/**
 * app.js - Aula de Música
 * Arquivo consolidado gerado automaticamente
 * Gerado em: 2026-09-28T00:30:36.355Z
 *
 * NÃO EDITE ESTE ARQUIVO DIRETAMENTE!
 * Edite os arquivos em js/classes/ e use: node scripts/sync-class.js --all
 */


// ============================================
// i18n (gerado de js/i18n/translations.json — FONTE ÚNICA; de pages.* só os linkLabel)
// ============================================
window.__I18N__ = {"pt":{"meta":{"title":"Aula de Música — Jogos para aprender ritmo, leitura de pauta e percepção musical","description":"Educação musical em jogos: ritmo, leitura de partitura, intervalos e acordes de ouvido e música de verdade lida na pauta, inclusive do seu MIDI. Níveis, ranking e turmas para escolas. No navegador.","ogImageAlt":"Aula de Música — jogos de ritmo, leitura de pauta e percepção musical","jsonldSiteDesc":"Educação musical em jogos: ritmo, leitura de pauta, intervalos e acordes de ouvido e música de verdade lida na partitura.","jsonldBrowserReq":"Requer navegador moderno com suporte a Web Audio API.","jsonldFeatures":["Jogo de ritmo com 30 níveis em 6 mundos","Leitura de pauta em esteira, claves de sol e fá","Modo infantil de leitura com cores","Intervalos e acordes de ouvido, por níveis","Música de verdade lida na partitura, no piano da tela ou num teclado MIDI","Importação do seu arquivo MIDI com cifras","Ranking e progresso por conta","Grupos para escolas e turmas, com painel do professor"]},"app":{"name":"Aula de Música","tagline":"Aprenda Música Jogando","loading":"Carregando…","updateAvailable":"Nova versão disponível","updateNow":"Atualizar","loadError":"Não foi possível carregar esta tela.","bootFailed":"Não foi possível carregar o app.","retry":"Tentar de novo"},"langSwitch":{"label":"Idioma"},"nav":{"games":"Jogos","about":"Sobre","menu":"Menu","rhythm":"Ritmo","staffReading":"Leitura","intervals":"Intervalos","chords":"Acordes","songs":"Música","news":"Novidades","home":"Início","levels":"Níveis","ranking":"Ranking","progress":"Meu progresso","profile":"Minha conta","help":"Ajuda","privacy":"Privacidade","terms":"Termos","contact":"Contato"},"menu":{"title":"Menu","close":"Fechar","switchTitle":"Trocar de jogo"},"promo":{"railLabel":"Recomendação","sister":{"eyebrow":"Projeto irmão","brand":"Ouvido Absoluto","body":"Conheça o nosso outro projeto, dedicado ao ouvido absoluto: mais jogos de percepção, ranking, medalhas e uma comunidade que treina todo dia.","cta":"Conhecer","hide":"Ocultar"}},"news":{"title":"Novidades","updated":"Última atualização: {date}","tagFeature":"Novidade","tagImprovement":"Melhoria","empty":"Sem novidades por enquanto.","error":"Não foi possível carregar as novidades.","cta":"Experimentar agora"},"legal":{"privacy":{"title":"Privacidade"},"terms":{"title":"Termos de uso"},"contact":{"title":"Contato","formTitle":"Escreva para nós","guestBody":"Para mandar uma mensagem, entre na sua conta. É para o e-mail dela que a resposta vai.","from":"A resposta vai para {email}","label":"Sua mensagem","placeholder":"Dúvida, erro na tela, sugestão… Se for erro, diga o aparelho e o que você estava fazendo.","counter":"{n} / {max}","send":"Enviar mensagem","sending":"Enviando…","sentTitle":"Mensagem enviada","sentBody":"Uma pessoa lê e responde em {email}. Pode demorar um pouco.","another":"Escrever outra","staticCta":"Escrever pelo app","staticNote":"O formulário fica dentro do app e pede que você entre na sua conta: é para o e-mail dela que a resposta vai.","errors":{"too_short":"Escreva um pouco mais (pelo menos {min} caracteres).","too_long":"A mensagem passou de {max} caracteres. Encurte um pouco.","bad_message":"Não foi possível ler essa mensagem. Tente de novo.","rate_limited":"Você já mandou várias mensagens nesta hora. Espere um pouco antes de mandar outra — o seu texto continua aqui.","csrf":"Não deu para enviar agora. Tente de novo — o seu texto continua aqui."}},"updated":"Atualizado em {date}","error":"Não foi possível carregar este texto agora. Ele também está publicado no site.","readOnSite":"Ler no site"},"hero":{"eyebrow":"Educação musical","titlePre":"Aprenda música","highlight":"jogando","titlePost":"","subtitle":"Ritmo, leitura de partitura, percepção musical e música de verdade, em jogos inteligentes com níveis e ranking.","cta":"Ver os jogos"},"games":{"sectionTitle":"Jogos Disponíveis","sectionSubtitle":"Escolha um jogo e comece a treinar suas habilidades musicais","play":"Jogar","learnMore":"Saiba mais","rhythm":{"name":"Ritmo","description":"Leia as figuras na pauta e toque no tempo certo. Precisão em milissegundos, seis mundos de níveis, modo livre e teclado MIDI."},"staffReading":{"name":"Leitura de Pauta","description":"Leia as notas que passam na pauta antes que sumam. Níveis por mundo, linha-guia para iniciantes, clave de fá no treino livre."},"intervals":{"name":"Intervalos","description":"Reconheça de ouvido a distância entre duas notas, de terças a oitavas, melódicos e harmônicos. Níveis e modo livre."},"chords":{"name":"Acordes","description":"Identifique acordes de ouvido: tríades maiores e menores, sétimas e nonas. Níveis e modo livre."},"songs":{"name":"Música de Verdade","description":"Toque uma música inteira lendo a partitura, no piano da tela ou num teclado MIDI. O modo estudo espera você. Ou carregue o seu MIDI e plante as cifras."},"kids":{"name":"Partitura para Crianças","description":"Cada nota tem uma cor e uma linha-guia mostra a tecla certa — para quem ainda não lê partitura."}},"about":{"title":"Sobre o Projeto","p1":"O <strong>Aula de Música</strong> é uma plataforma de educação musical gamificada, criada para tornar o aprendizado de música acessível e divertido para todos.","p2":"Desenvolvemos com inteligência artificial: isso nos deixa experimentar rápido e criar recursos com um nível de detalhe e feedback que você não encontra na maioria das ferramentas.","p3":"Começamos com o treinamento rítmico — a base de toda música — e hoje já temos leitura de pauta, percepção musical (intervalos e acordes) e a leitura de músicas reais, inclusive as que você mesmo carrega em MIDI. Cada jogo com níveis e modo livre, ranking por conta e grupos para escolas e turmas.","features":{"responsive":"Funciona em qualquer dispositivo","progressive":"Dificuldade progressiva","progress":"Acompanhe seu progresso","browser":"Direto no navegador, sem instalar"}},"footer":{"copyright":"© {year} Aula de Música. Todos os direitos reservados.","madeBy":"· Um projeto <a href=\"https://3wimusic.com/pt/\">3wi</a>"},"rhythm":{"level":{"mapTitle":"Trilha de níveis","mapOpen":"🗺️ Níveis","locked":"bloqueado","n":"Nível {n}","next":"Próximo nível →","unlocked":"✅ Nível concluído! Próximo desbloqueado.","passedAgain":"🎉 Mandou bem de novo!","allDone":"🏆 Você zerou a trilha! Parabéns!","tryAgain":"Quase! Tire {pass}% nos dois placares para liberar o próximo.","tryAgainHold":"O seu tempo está certo! Falta segurar: mantenha a tecla (ou o dedo) apertada até cada nota acabar, em vez de dar um toque rápido.","world1":"Mundo 1 · Pulso","world1Hint":"Semínima, mínima e semibreve — sinta o pulso.","world2":"Mundo 2 · Subdivisão","world2Hint":"Colcheias: dois toques por tempo.","world3":"Mundo 3 · Pontos","world3Hint":"Figuras pontuadas: o ponto aumenta a metade.","world4":"Mundo 4 · Silêncio","world4Hint":"O som que falta e o som que dura: pausas e ligadura.","world5":"Mundo 5 · Síncope","world5Hint":"O acento cai entre os tempos.","world6":"Mundo 6 · Grade fina","world6Hint":"Semicolcheia e fusa: mais divisões dentro do mesmo tempo.","progress":"Nível {id} de {total}","goal":"meta {pass}%","seeResult":"Ver resultado"},"title":"Jogo de Ritmo","freeTitle":"Ritmo Livre","toFreeMode":"⚙️ Modo livre","toRankedMode":"🏆 Voltar aos níveis","initError":"Erro ao inicializar jogo","audioUnavailable":"Sistema de áudio não disponível","back":"Voltar","menuStatus":"Ouça o ritmo e depois toque para avaliar sua precisão.","menuStatusShort":"Ouça, depois toque e avalie.","listen":"▶  Ouvir","grade":"🎯  Avaliar","another":"🔀  Outro ritmo","tempo":"Tempo: ","gradeDuration":" Avaliar duração das notas","listening":"🔊 Ouça com atenção…","getReady":"🎯 Prepare-se! Reproduza o ritmo no toque.","go":"VAI!","liveOnTime":"No tempo! 🎯","liveEarly":"Adiantou ⏪","liveLate":"Atrasou ⏩","liveTooEarly":"Muito adiantado ⏪","liveTooLate":"Muito atrasado ⏩","tendencyOk":"No tempo, ótimo! 🎯","tendencyEarly":"Você tende a ADIANTAR ~{ms}ms ⏪","tendencyLate":"Você tende a ATRASAR ~{ms}ms ⏩","durationLabel":"Duração: {pct}%","onsetTitle":"Início","durationTitle":"Duração","durationOk":"Duração certa! 🎯","durationShort":"Você SEGURA CURTO ~{ms}ms 🤏","durationLong":"Você SEGURA LONGO ~{ms}ms 🫳","howMeasured":"Como isso é medido?","extraPenalty":"Notas extras −{pct}%","restPenalty":"Tocou em pausa −{pct}%","timingAccuracy":"Precisão de tempo: {pct}%","missed":"perdida","note":"Nota {n}","noteDetail":"Detalhe por nota","legendOnTime":"no tempo","legendOff":"fora","legendMissing":"faltou","legendTarget":"fim ideal","retry":"🎯  Tentar de novo","backToMenu":"↩  Voltar ao menu","tutorial":{"open":"❓ Como jogar","prev":"◀ Anterior","next":"Próximo ▶","start":"🚀 Começar","skip":"Pular","scene":{"oneBeat":"segura 1 tempo","halfBeat":"segura meio tempo","quarter":"SEMÍNIMA","eighth":"COLCHEIA","listen":"👂 OUÇA","onsetOk":"INÍCIO ✓","durOk":"DURAÇÃO ✓"},"cards":[{"title":"Sua batida","body":"Música começa com uma batida: o seu coração."},{"title":"Batida vira nota","body":"Cada batida do coração vira uma nota na pauta."},{"title":"Longa ou curta","body":"Cada nota tem um tamanho: uma dura mais, a outra dura menos — as duas se seguram até acabar."},{"title":"Onde, é quando","body":"O lugar da nota na pauta mostra a hora dela tocar."},{"title":"Primeiro, ouça","body":"Uma linha passa em cada nota e toca pra você ouvir."},{"title":"Sua vez","body":"Toque o botão em cada nota e segure até ela acabar — quanto maior a nota, mais tempo segurando."},{"title":"Bora jogar!","body":"Você já sabe: leia, ouça e toque no tempo. Vai lá!"}]},"config":{"open":"⚙️ Ajustes","title":"Painel de controle","hint":"Escolha as figuras que entram no sorteio dos ritmos.","notes":"Notas","rests":"Pausas","ties":"Ligaduras","tiesHint":"Liga duas notas numa só, somando os tempos. Sustentação: a nota atravessa a barra de compasso. Síncope: o contratempo se prende ao tempo seguinte.","beat":"{n} tempo","beats":"{n} tempos","reset":"Restaurar padrão","close":"Fechar","needOneNote":"Pelo menos uma nota precisa ficar marcada.","timeSig":"Fórmula de compasso","measures":"Compassos","restLimit":"Pausas seguidas, no máximo","tieOff":"Sem ligadura","tieSustain":"Sustentação","tieSyncopation":"Síncope","tieBoth":"As duas","click":"Clique do metrônomo","clickHint":"A contagem antes de começar sempre toca todos os tempos. O “Ouvir” já segue o clique escolhido.","clickAll":"Em todos os tempos","clickOne":"Só no tempo 1","click24":"Nos tempos 2 e 4","clickNone":"Sem clique","measureRest":"Pausa de compasso","noFit":"Não cabe em {sig}","needOneFit":"Pelo menos uma nota que caiba em {sig} precisa ficar marcada.","autoOn":"Ligada para fechar o compasso de {sig} · toque para manter","autoAdded":"As notas marcadas não fecham um compasso de {sig}: {fig} fica ligada enquanto precisar.","drawnAsBarRest":"aparece como pausa de compasso","sustainOneBar":"Com 1 compasso não há barra para a sustentação atravessar."},"figures":{"whole":"Semibreve","dotted-half":"Mínima pontuada","half":"Mínima","dotted-quarter":"Semínima pontuada","quarter":"Semínima","dotted-eighth":"Colcheia pontuada","eighth":"Colcheia","sixteenth":"Semicolcheia","fusa":"Fusa","whole-rest":"Pausa de semibreve","half-rest":"Pausa de mínima","quarter-rest":"Pausa de semínima","dotted-eighth-rest":"Pausa de colcheia pontuada","eighth-rest":"Pausa de colcheia","sixteenth-rest":"Pausa de semicolcheia","fusa-rest":"Pausa de fusa"},"tap":{"label":"TOQUE","hintDesktop":"clique ou tecla ESPAÇO","hintMobile":"toque e segure aqui","hintHold":"segure até a nota acabar"},"trails":{"title":"Trilha","strip":"Trilha: {name} · Nível {n} de {m}","mapOpen":"Ver os níveis da trilha","training":"treino, sem meta","takes":"{done} de {takes} vezes","takesLeft":"Boa! Faltam {n} para liberar o próximo nível.","trainingDone":"Treino feito. O próximo nível está liberado.","cleared":"concluído","readOnly":"Nesta trilha as figuras e o compasso são de quem a montou. Para mexer nelas, “Levar para o meu painel” copia este exercício para o seu Ritmo Livre.","editCopy":"Levar para o meu painel","saveAs":"＋ Usar este exercício numa trilha","created":"Trilha criada. Monte os níveis aqui.","saved":"Guardado.","needAccount":"Para guardar uma trilha, entre na sua conta ou crie uma.","readOnlyTitle":"Exercício da trilha","editCopyConfirm":"Isto troca o SEU painel do Ritmo Livre pelo exercício deste nível e sai da trilha. Continuar?","takesLeftLast":"Boa! Faltam {n} para concluir.","trainingDoneLast":"Treino feito.","allDone":"🏆 Você concluiu a trilha!","toCover":"↩ Ver a trilha","whichTrail":"Em qual trilha?","newOne":"Nova trilha (este vira o nível 1)","asLevel":"{name} — vira o nível {n}","appended":"Guardado como nível {n} de {name}.","defaultName":"Trilha nova","defaultNameOf":"Trilha de {name}","testStrip":"Testando: {name} · Nível {n} de {m} · nada é gravado","toWorkshop":"← Voltar à oficina","testPassed":"Passou: a meta é {pass}%. Nada foi gravado.","testTraining":"Treino, sem meta. Nada foi gravado.","editInWorkshop":"Editar na oficina","sample":"Ver uma trilha de exemplo →","noInput":"Nenhum toque registrado: toque no botão no tempo das notas. Esta rodada não conta.","testFailed":"Com este placar o aluno não passaria (meta {pass}%). Nada foi gravado.","blank":"Nova trilha em branco →"},"ruler":{"measure":"Compasso {n}"},"settings":{"sound":"Som da nota","vary":"Melodia","pitch":"Notas na altura certa","ruler":"Régua de tempos","midi":"Teclado MIDI"},"midi":{"listening":"🎹 {device} conectado: toque o ritmo nele","nodevice":"🎹 Nenhum teclado MIDI encontrado: ligue-o pelo cabo USB (ou Bluetooth) e ele aparece aqui sozinho.","denied":"🎹 O navegador negou o acesso MIDI: permita no cadeado ao lado do endereço e depois desligue e ligue de novo o teclado MIDI no ⚙️."},"noInput":"Nenhum toque registrado","noInputDur":"Sem toques, sem duração"},"staffReading":{"title":"✏️ Treino Livre de Leitura","progress":"Nota {current} de {total}  ·  Acertos: {correct}","question":"Qual é esta nota?","correct":"✅ Isso! É {note}.","wrong":"❌ Era {note}.","youMarked":"✘ marcou {note}","noteN":"Nota {n}","scoreLine":"{correct} de {total} corretas","detailTitle":"Detalhe por nota","playAgain":"🔁  Jogar de novo","backToMenu":"↩  Voltar ao menu","answerWith":"Responder com: ","modeButtons":"🔢 Botões","modePiano":"🎹 Piano","modeMic":"🎙️ Microfone","modeMidi":"🎹 MIDI","hearNote":"🔊  Ouvir a nota","config":{"open":"⚙️ Opções","title":"Opções","guideTitle":"Linha-guia","guideAlways":"Sempre","guideError":"Só quando erra","guideOff":"Desligada","clefTitle":"Clave","clefTreble":"Sol","clefBass":"Fá","clefBoth":"As duas","realPiano":"Piano real","reset":"Restaurar padrão","close":"Fechar","keyTitle":"Tonalidade","keyAtLeastOne":"Deixe pelo menos uma tonalidade marcada"},"tutorial":{"open":"❓ Como jogar","prev":"◀ Anterior","next":"Próximo ▶","start":"🚀 Começar","skip":"Pular","cards":[{"title":"Grave e agudo","body":"No piano, a esquerda é grave e a direita é aguda. Quanto mais à direita, mais agudo o som."},{"title":"A pauta","body":"A pauta é a escada dos sons: quanto mais alta a nota, mais aguda — como andar para a direita no piano."},{"title":"Linha ou espaço","body":"Cada nota mora numa linha (faixa amarela) ou num espaço (faixa azul). Um degrau é sempre a tecla vizinha."},{"title":"A clave de Sol","body":"A clave de Sol abraça a 2ª linha e marca onde fica o Sol. Esse é o seu ponto de partida."},{"title":"Os vizinhos do Sol","body":"Achou o Sol, achou todos: cada degrau para cima ou para baixo é a próxima nota, sem pular nomes."},{"title":"Uma rodada","body":"No jogo aparece uma nota e você diz o nome (ou toca a tecla). É só contar a partir do Sol."},{"title":"Bora jogar!","body":"Você já sabe ler: ache o Sol e conte os vizinhos. Bora jogar!"}]},"toFlow":"🏃 Leitura em fluxo"},"readingFlow":{"title":"🎼 Leitura de Pauta","subtitle":"As notas vêm chegando da direita. Diga o nome da nota destacada antes que ela saia pela esquerda.","start":"▶ Começar","prompt":"Diga o nome da nota destacada","score":"Pontos","combo":"Sequência","best":"Recorde","progress":"Andamento","accuracy":"de precisão","playAgain":"🔁  Jogar de novo","backToMenu":"↩  Voltar ao menu","results":{"title":"Fim da rodada","scoreLine":"{hits} de {total} certas","maxCombo":"Maior sequência","newBest":"🎉 Novo recorde!","starRecord":"🌟 Novo recorde de estrelas!","levelStars":"Estrelas do nível","unlocked":"🔓 Próximo nível liberado!"},"level":"Nível","notesWord":"notas","locked":"Bloqueado — passe o nível anterior","worldLabel":"Mundo {n}","worlds":{"1":"Na pauta","2":"A pauta inteira"},"input":"Responder com","inputButtons":"Botões","inputPiano":"Piano","inputMic":"🎙️ Microfone","inputMidi":"🎹 MIDI","kids":"Kids","realPiano":"Som: piano de verdade","loadingPiano":"Baixando","stop":"Parar","nextLevel":"➡ Próximo nível","toFreeMode":"✏️ Treino livre (1 nota)","kidsLearned":"Você aprendeu {note}! 🎉","kidsGraduated":"Você está respondendo sem as cores! 🎓","kidsColorHint":"Cada nota tem a sua cor na pauta. Conforme você aprende, a cor sai dos botões.","kidsAllLearned":"Você já responde sem as cores neste nível! 🎉 Suba de nível para novas notas.","kidsReset":"🔄 Recomeçar cores","kidsResetConfirm":"Trazer as cores de volta para os botões? Isso apaga o progresso de aprendizado das notas.","wasNote":"Era {note}!","buttonsLocked":"A partir do nível 2 a resposta é no piano: ler a nota é achar a tecla.","octaveUp":"Nome certo! Era o {note} de cima.","octaveDown":"Nome certo! Era o {note} de baixo.","teach":{"got":"Entendi","octave":{"title":"🎹 Mesmo nome, outra altura","text":"Deste nível em diante a mesma nota aparece em duas alturas. Mesmo nome, mais agudo — e outra tecla."},"ledgerLow":{"title":"🎼 A pauta continua embaixo","text":"Quando a nota desce demais, ela ganha uma linhinha só pra ela. Esta primeira, logo abaixo da pauta, é o Dó central."},"ledgerHigh":{"title":"🎼 E continua em cima","text":"Do outro lado funciona igual: mais uma linhinha acima da pauta, e esse é o Lá agudo."}},"stopConfirm":"Parar mesmo?","unlockGoal":"Faça {acc}% para liberar o nível {level}","masteryTitle":"Álbum de notas"},"notes":{"C":"Dó","D":"Ré","E":"Mi","F":"Fá","G":"Sol","A":"Lá","B":"Si"},"micInput":{"activateHint":"Responda tocando no seu piano de verdade","activate":"🎙️ Ativar microfone","requesting":"Aguardando permissão…","listening":"Ouvindo… toque a nota no seu instrumento","denied":"Acesso ao microfone negado","deniedHelp":"Permita o microfone nas configurações do navegador, ou responda pelos botões.","unsupported":"Microfone indisponível neste ambiente","unsupportedHelp":"O navegador exige conexão segura (HTTPS) para usar o microfone.","error":"Não deu para acessar o microfone","useButtons":"Usar botões"},"midiInput":{"activateHint":"Responda tocando no seu teclado MIDI","activate":"🎹 Conectar teclado MIDI","requesting":"Aguardando permissão…","listening":"Conectado… toque a nota no seu teclado","nodevice":"Nenhum instrumento MIDI encontrado","nodeviceHelp":"Conecte seu teclado pelo cabo USB (ou Bluetooth) — ele aparece aqui sozinho.","denied":"Acesso MIDI negado","deniedHelp":"Permita o acesso MIDI nas configurações do navegador, ou responda pelos botões.","unsupported":"MIDI indisponível neste navegador","unsupportedHelp":"Este navegador não tem Web MIDI. Tente pelo Chrome ou Edge no computador.","error":"Não deu para acessar o MIDI","useButtons":"Usar botões"},"intervals":{"title":"🎵 Intervalos","progress":"Intervalo {current} de {total}  ·  Acertos: {correct}","mode":"Modo: ","modeIdentify":"🎧 Ouvir e identificar","modeBuild":"🎹 Construir no piano","identifyPrompt":"🎧 Ouça o intervalo. Que intervalo é?","buildPrompt":"🎹 Toque a {interval} acima de {root}.","buildPromptDown":"🎹 Toque a {interval} abaixo de {root}.","progressEndless":"Intervalo {current}  ·  Acertos: {correct}","freeTitle":"🎵 Intervalos — Treino livre","freeSubtitle":"Monte seu treino: escolha os intervalos e as opções.","toFreeMode":"⚙️ Modo livre","toRankedMode":"🏆 Níveis","settings":"⚙️ Configurar","pickIntervals":"Escolha os intervalos:","playLabel":"Tocar:","melodic":"Melódico","harmonicMode":"Harmônico","dir":"Direção:","dirUp":"↑ Cima","dirDown":"↓ Baixo","dirBoth":"↕ Ambas","length":"Tamanho:","endless":"∞ Sem fim","stop":"Parar","correct":"✅ Isso! {interval}.","wrong":"❌ Era {interval}.","repeat":"🔊  Repetir","hearBase":"🔊  Ouvir a base","buildHint":"Toque a tecla certa no piano acima. ","youPlayed":"✘ tocou {note}","youMarked":"✘ marcou {interval}","base":"(base {root})","scoreLine":"{correct} de {total} corretas","detailTitle":"Detalhe","playAgain":"🔁  Jogar de novo","backToMenu":"↩  Voltar ao menu","start":"▶ Começar","subtitle":"Escolha um nível e treine o ouvido.","hearExample":"🔊 Ouvir exemplo","exampleIs":"Assim soa: {interval}","level":"Nível","locked":"bloqueado","assist":"Ver teclas:","assistOn":"Sim","assistOff":"Não","harmonicTag":"harmônico","unlocked":"✅ Novo nível liberado!","nextLevel":"Próximo nível →","chooseLevel":"🎚️ Escolher nível","names":{"P1":"Uníssono","m2":"Segunda menor","M2":"Segunda maior","m3":"Terça menor","M3":"Terça maior","P4":"Quarta justa","TT":"Trítono","P5":"Quinta justa","m6":"Sexta menor","M6":"Sexta maior","m7":"Sétima menor","M7":"Sétima maior","P8":"Oitava justa"},"needPass":"Você precisa de {pass}% para liberar o próximo nível.","goal":"Meta: {pass}%","stopConfirm":"Parar mesmo?"},"chords":{"title":"🎸 Acordes","progress":"Acorde {current} de {total}  ·  Acertos: {correct}","identifyPrompt":"🎧 Ouça o acorde. Qual acorde é?","correct":"✅ Isso! {chord}.","wrong":"❌ Era {chord}.","repeat":"🔊  Repetir","youMarked":"✘ marcou {chord}","base":"(fund. {root})","scoreLine":"{correct} de {total} corretos","detailTitle":"Detalhe","playAgain":"🔁  Jogar de novo","backToMenu":"↩  Voltar ao menu","start":"▶ Começar","subtitle":"Escolha um nível e treine o ouvido.","hearExample":"🔊 Ouvir exemplo","exampleIs":"Assim soa: {chord}","level":"Nível","locked":"bloqueado","assist":"Ver teclas:","assistOn":"Sim","assistOff":"Não","style":"Tocar:","styleBlock":"Junto","styleArpeggio":"Arpejo","unlocked":"✅ Novo nível liberado!","nextLevel":"Próximo nível →","chooseLevel":"🎚️ Escolher nível","freeTitle":"🎸 Acordes — Treino livre","freeSubtitle":"Monte seu treino: escolha os acordes e as opções.","progressEndless":"Acorde {current}  ·  Acertos: {correct}","pickChords":"Escolha os acordes:","arpDir":"Arpejo:","dirUp":"↑ Cima","dirDown":"↓ Baixo","dirBoth":"↕ Ambas","length":"Tamanho:","endless":"∞ Sem fim","stop":"Parar","settings":"⚙️ Configurar","toFreeMode":"⚙️ Modo livre","toRankedMode":"🏆 Níveis","names":{"7":"Dominante 7","9":"Dominante 9","11":"Dominante 11","13":"Dominante 13","maj":"Maior","min":"Menor","dim":"Diminuto","aug":"Aumentado","sus2":"Sus2","sus4":"Sus4","maj7":"Maior 7","min7":"Menor 7","m7b5":"Meio-dim. (ø)","dim7":"Dim. 7 (°7)","maj9":"Maior 9","min9":"Menor 9"},"needPass":"Você precisa de {pass}% para liberar o próximo nível.","goal":"Meta: {pass}%","stopConfirm":"Parar mesmo?"},"common":{"close":"Fechar","cancel":"Cancelar"},"auth":{"signInTitle":"Entrar","signUpTitle":"Criar conta","forgotTitle":"Recuperar senha","resetTitle":"Redefinir senha","google":"Continuar com Google","or":"ou","emailButton":"Criar conta com e-mail","backToChoice":"Voltar","nameLabel":"Nome","namePlaceholder":"Como quer ser chamado","emailLabel":"Email","emailPlaceholder":"voce@exemplo.com","passwordLabel":"Senha","passwordPlaceholder":"Mínimo {min} caracteres","signInSubmit":"Entrar","signUpSubmit":"Criar conta","forgotSubmit":"Enviar instruções","resetSubmit":"Salvar nova senha","forgotIntro":"Enviaremos um link para redefinir sua senha.","resetIntro":"Escolha uma nova senha para sua conta.","newPasswordLabel":"Nova senha","newPasswordPlaceholder":"Mínimo {min} caracteres","toSignUp":"Não tem conta? Criar uma","toSignIn":"Já tem conta? Entrar","toForgot":"Esqueci a senha","backToSignIn":"Voltar ao login","loading":"Aguarde…","signInCta":"Entrar","accountTitle":"Conta","signOut":"Sair","deleteAccount":"Apagar conta","resendVerification":"Confirmar e-mail (reenviar link)","deleteConfirm":"Apagar sua conta e todo o progresso? Isso não pode ser desfeito.","guest":"Convidado","gate":{"rewardTitle":"Você está indo bem! 🎉","rewardSubtitle":"Crie sua conta para continuar e salvar seu progresso.","contextLine":"Você completou os {free} primeiros níveis — o nível {level} te espera.","lockedHint":"Crie sua conta para jogar este nível"},"linked":{"title":"Sua conta agora entra pelo Google","body":"Esse e-mail já tinha uma conta com senha, mas nunca tinha sido confirmado. Por segurança, a senha antiga foi desativada — seu progresso está intacto, na mesma conta. Daqui em diante, entre pelo Google. Se preferir voltar a usar senha, defina uma nova.","setPassword":"Definir nova senha","resetSent":"Enviamos ao seu e-mail o link para definir a nova senha.","ok":"Entendi"},"toasts":{"welcome":"Bem-vindo, {name}!","accountCreated":"Conta criada! Verifique seu email para confirmar.","resetSent":"Se o email existir, enviamos instruções.","emailVerified":"E-mail verificado! Sua conta está confirmada.","verifySent":"Link de confirmação reenviado. Veja sua caixa de entrada.","verifyRate":"Muitas tentativas por agora. Abra o link de novo em alguns minutos.","verifyFailed":"Link de verificação inválido ou expirado.","passwordReset":"Senha redefinida! Entre com a nova senha.","signedOut":"Você saiu da conta.","sessionExpired":"Sua sessão expirou. Entre novamente.","progressRestored":"Progresso da sua conta recuperado neste aparelho.","progressLinked":"Seu progresso foi vinculado à sua conta.","accountDeleted":"Sua conta foi apagada."},"errors":{"generic":"Algo deu errado. Tente de novo.","network":"Sem conexão com o servidor. Tente mais tarde.","invalid_email":"Email inválido.","short_password":"A senha precisa de ao menos {min} caracteres.","long_password":"A senha é muito longa. Use uma mais curta.","empty_password":"Digite sua senha.","reset_invalid":"Link de redefinição inválido ou expirado. Peça um novo.","email_taken":"Este email já tem conta. Tente entrar.","invalid_credentials":"Email ou senha incorretos.","no_account":"Não encontramos conta com esse e-mail.","rate_limited":"Muitas tentativas. Aguarde um instante.","disposable_email":"Use um email permanente.","social_account":"Esta conta entra pelo Google e não tem senha. Use o botão do Google ou defina uma senha nova.","social_account_noprov":"Esta conta entra pelo Google e não tem senha. Para entrar por e-mail, defina uma senha nova.","session_expired":"Sua sessão expirou. Entre novamente.","csrf":"Sessão de segurança expirada. Recarregue a página.","spam":"Não foi possível processar. Recarregue e tente de novo.","oauth_cancelled":"Login cancelado.","oauth_invalid_state":"Sua sessão de login expirou. Tente de novo.","oauth_account_exists":"Já existe uma conta com esse e-mail. Entre com e-mail e senha.","oauth_failed":"Não foi possível entrar com o provedor. Tente de novo.","actions":{"createAccount":"Criar conta","signIn":"Entrar","googleSignIn":"Entrar com Google","setPassword":"Definir nova senha"},"empty_name":"Escolha um nome — ele aparece no ranking.","bad_name":"Esse nome não pôde ser lido. Use letras e números.","not_logged":"Entre na sua conta para fazer isso.","bad_code":"Código não encontrado. Confira com quem organiza o grupo.","already_in_group":"Você já está num grupo. Saia dele para entrar em outro.","forbidden":"Você não tem permissão para isso.","empty_group_name":"Dê um nome ao grupo.","group_taken":"Já existe um grupo com esse nome.","no_group":"Você não está em nenhum grupo.","pending_exists":"Você já tem um pedido de grupo em análise.","owner_exists":"Você já organiza um grupo.","name_locked":"O nome não muda depois de o grupo ser liberado.","logo_missing":"Escolha uma imagem.","logo_too_big":"A imagem passa de 2 MB.","logo_bad_image":"O arquivo não é uma imagem PNG, JPG, GIF ou WebP.","logo_too_large_dims":"A imagem é grande demais (até 4000×4000).","logo_encode_failed":"Não deu para processar a imagem. Tente outra.","bad_decision":"Decisão inválida.","bad_status":"Este pedido já foi decidido.","bad_group":"Grupo inválido.","bad_country":"País inválido.","no_list":"Trilha não encontrada.","lists_max":"Você chegou ao máximo de trilhas por conta.","empty_list_name":"Dê um nome à trilha.","bad_levels":"Os níveis da trilha vieram inválidos.","bad_lid":"Os níveis da trilha vieram inválidos.","too_many_levels":"A trilha passou do máximo de níveis.","levels_too_big":"A trilha é grande demais.","bad_visibility":"Visibilidade inválida."},"prefs":{"diary":"Diário de jogo","on":"Registrando","off":"Desligado","help":"Guarda o que você joga — nível, tempo e precisão — para as suas estatísticas. Desligar para de registrar e apaga a fila que ainda não subiu deste aparelho; o que já está na sua conta continua lá. O seu melhor resultado de cada nível continua subindo e no ranking.","anon":"A contagem de visitas do site, descrita na Privacidade, não depende disto.","saveError":"Não deu para confirmar se salvou. Recarregue o app para ver como está."}},"pages":{"ritmo":{"linkLabel":"Jogo de Ritmo"},"leitura":{"linkLabel":"Leitura de Partitura"},"kids":{"linkLabel":"Partitura para Crianças"},"intervalos":{"linkLabel":"Intervalos"},"acordes":{"linkLabel":"Acordes"},"musicas":{"linkLabel":"Música de Verdade"},"ritmoGuia":{"linkLabel":"O que é ritmo"},"leituraGuia":{"linkLabel":"Como ler partitura"},"intervalosGuia":{"linkLabel":"O que são intervalos musicais"},"acordesGuia":{"linkLabel":"O que são acordes"},"escolas":{"linkLabel":"Para escolas e professores"},"toolVocal":{"linkLabel":"Teste vocal"},"midi":{"linkLabel":"Sua música com cifra"}},"ranking":{"title":"Ranking","subtitle":"Quem foi mais longe na trilha","gameLabel":"Jogo","tabOverall":"Geral","tabLevel":"Por nível","levelLabel":"Nível","levelOption":"{n}","loginPrompt":"Entre na sua conta para aparecer no ranking.","loginCta":"Entrar","loading":"Carregando…","error":"Não foi possível carregar o ranking.","empty":"Ninguém no ranking ainda. Jogue um nível para estrear.","notInLevel":"Você ainda não tem registro no nível {n}. Jogue este nível conectado para entrar aqui.","colPlayer":"Jogador","colLevel":"Nível","colAccuracy":"Precisão","colPlays":"Partidas","reached":"Nível {n}","you":"Você","guestPlayer":"Sem nome","scopeLabel":"Ver ranking por","colPosition":"Posição","emptyCta":"Jogar {game}","youAreHidden":"Você não aparece nesta lista porque desligou “Aparecer no ranking”.","schoolLink":"{group}: ver a página do grupo","youAreHiddenCta":"Ligar em Minha conta","whoLabel":"Ver o ranking de","whoAll":"Todos","groupEmpty":"Ninguém de {group} no ranking de {game} ainda. Jogue um nível para estrear.","ownerNote":"Você organiza este grupo e não aparece na lista.","showing":"{from}–{to} de {total}","pageNav":"Páginas do ranking","prev":"Página anterior","next":"Próxima página","pageN":"Página {n}","pageOf":"página {n} de {total}","goToMine":"Ir para a minha página"},"stats":{"title":"Meu progresso","subtitle":"O que a sua conta guarda de cada treino","error":"Não foi possível carregar o seu progresso.","retry":"Tentar de novo","emptyTitle":"Ainda não há nada por aqui.","emptyBody":"Jogue uma rodada conectado e volte: os dias, o tempo e a evolução aparecem aqui.","emptyBodyOff":"Com o diário de jogo desligado, só o seu melhor nível em cada jogo vai aparecer aqui. Ligue o registro e jogue uma rodada para ver dias, tempo e evolução.","emptyCta":"Jogar {game}","tileDays":"Dias de treino","tileStreak":"Sequência (dias)","tileStreakSub":"melhor: {n}","tileTime":"Tempo de treino","tileRounds":"Rodadas","tileRoundsSub":"{n} abandonadas","since":"desde {date}","timeHours":"{h}h {m}min","timeMinutes":"{m} min","diaryOff":"O diário de jogo está desligado, então dias, tempo, rodadas e evolução não são registrados. O seu melhor nível em cada jogo continua abaixo.","diaryOffCta":"Ligar o registro","beforeDiary":"As rodadas jogadas antes de o diário existir não aparecem aqui — só o nível mais alto de cada jogo.","chartTitle":"Evolução","chartCaption":"Precisão média por dia · {game}","chartEmpty":"Nenhuma rodada nos últimos {n} dias.","chartAvg":"média {p}%","chartAria":"{game}: rodadas em {days} de {n} dias, precisão média de {p}%.","windowGroup":"Período","windowLabel":"{n} dias","gameLabel":"Jogo","roundsOne":"1 rodada","roundsMany":"{n} rodadas","stripTitle":"Últimas 4 semanas","stripToday":"hoje","stripNone":"sem rodadas","tableTitle":"Por jogo","colGame":"Jogo","colLevel":"Nível","colAccuracy":"Precisão","colRounds":"Rodadas","colAbandons":"Abandonos","colTime":"Tempo","previewIntro":"Assim fica o seu progresso quando você tem conta. O gráfico e os cartões abaixo são um exemplo com {game}.","previewStamp":"Exemplo","previewCta":"Criar conta para guardar isto","previewAria":"Exemplo: a precisão em {game} subindo de {from}% para {to}% ao longo de {n} dias.","previewOutro":"Com uma conta, cada rodada entra nesta tela — e o seu progresso segue você em qualquer aparelho.","previewDeviceTitle":"Neste aparelho","previewDeviceNote":"Este é o seu progresso de verdade: o nível mais alto e a melhor precisão que este navegador guardou. Sem conta, ele some se você trocar de aparelho ou limpar o navegador."},"profile":{"title":"Minha conta","subtitle":"Os seus dados e os ajustes desta conta.","guestTitle":"Você ainda não está na sua conta","guestBody":"A conta guarda o seu progresso e o leva de um aparelho para outro. Entre para ver e ajustar os seus dados aqui.","guestSignUp":"Criar conta","guestSignIn":"Entrar","loadError":"Não foi possível carregar os seus dados agora.","retry":"Tentar de novo","noName":"(sem nome)","nameLabel":"Nome","namePublic":"É o nome que aparece no ranking.","edit":"Editar","save":"Salvar","nameSaved":"Nome atualizado.","verified":"E-mail confirmado","unverified":"E-mail não confirmado","roleAdmin":"Administrador","memberSince":"Conta criada em {date}.","avatarNote":"A foto vem da sua conta do Google. Sem Google, o avatar são as suas iniciais — não há envio de foto por aqui.","accessTitle":"Como você entra","accessPassword":"E-mail e senha","accessGoogle":"Google","accessNone":"Nenhuma forma de entrada registrada.","noPasswordNote":"Esta conta não tem senha: você entra pelo Google. Para também entrar por e-mail, crie uma senha — o link chega no seu e-mail.","setPassword":"Criar uma senha","languageLabel":"Idioma","languageNote":"O idioma acompanha o endereço do site: cada idioma tem o seu. Trocar aqui leva você para o endereço do idioma escolhido, com a mesma conta.","language":{"pt":"Português","en":"Inglês","es":"Espanhol"},"prefsTitle":"Ajustes","ranking":{"label":"Aparecer no ranking","on":"Nome e foto visíveis","off":"Fora da lista pública","help":"O ranking é uma página pública: com isto ligado, o seu nome e a sua foto aparecem lá para qualquer pessoa, ao lado do nível e da precisão.","scope":"Desligar tira você da lista e não apaga nada — o seu progresso e os seus resultados continuam seus."},"accountTitle":"Conta","reset":{"title":"Zerar progresso","sub":"{n} resultados guardados","subEmpty":"Não há resultado guardado","body":"Apaga os seus melhores resultados e os níveis liberados, neste aparelho e na sua conta — a trilha volta ao começo e a sua linha sai do ranking. O seu histórico de treino em “Meu progresso” continua, e as músicas sincronizadas também. Não tem volta.","count":"{n} resultados serão apagados.","confirm":"Zerar progresso","done":"Progresso zerado."},"group":{"title":"Grupo","intro":"Faz parte de uma escola ou turma? Digite o código que quem organiza passou.","codeLabel":"Código do grupo","codePlaceholder":"ABCD2345","join":"Entrar no grupo","members":"{n} pessoas","membersOne":"1 pessoa","viewPage":"Ver a página do grupo","note":"O ranking do grupo é público, e quem organiza acompanha o seu progresso nos jogos.","leave":"Sair do grupo","leaveSub":"Nada é apagado — só a sua linha sai da lista do grupo","leaveTitle":"Sair do grupo","leaveBody":"Sair de {name}? A sua linha sai do ranking do grupo. Nada é apagado — o seu progresso e os seus resultados continuam seus. Dá para entrar de novo com o código.","leaveConfirm":"Sair do grupo","left":"Você saiu do grupo.","joined":"Você entrou em {name}.","existing":"Grupos que já estão aqui:","admin":{"title":"Grupos (administração)","intro":"Os pedidos de quem organiza uma escola chegam na fila acima. Aqui você cria um grupo direto, sem pedido: o código é o convite, passe-o a quem organiza. Criar um grupo não põe você dentro dele.","nameLabel":"Nome do grupo","create":"Criar grupo","created":"Grupo “{name}” criado. Código: {code}","code":"código","none":"Nenhum grupo criado ainda."},"requestIntro":"Organiza uma escola ou turma? Peça a criação de um grupo: você recebe um código para os alunos e acompanha o progresso deles.","requestCta":"Pedir a criação de um grupo","owner":{"pending":"Em análise","pendingBody":"A administração revisa o pedido e você recebe um e-mail. O código de convite aparece aqui quando o grupo for liberado.","rejected":"Não liberado","rejectedBody":"Este pedido não foi liberado. Se quiser, peça de novo: o formulário vem preenchido com o pedido anterior.","paused":"Pausado","pausedBody":"O grupo está pausado pela administração: ninguém entra e a página não aparece.","live":"Liberado","decisionNote":"Nota da administração:","code":"Código de convite","link":"Link de convite","copy":"Copiar","copied":"Copiado!","share":"Passe o código ou o link a quem deve entrar. Cada pessoa entra com a própria conta e aparece, com nome e resultados, no ranking da página do grupo — que é pública. Você vê esse ranking sem estar nele.","edit":"Editar o pedido","editLive":"Editar a página","noTranslation":"A descrição ainda não foi traduzida: a página mostra o texto original nos três idiomas.","translating":"Traduzindo a descrição…","copyFailed":"Não deu para copiar aqui: o texto ficou selecionado, copie com o teclado."},"adminQueue":{"title":"Pedidos de grupo","none":"Nenhum pedido pendente.","by":"pedido por {email}","approve":"Liberar","reject":"Recusar","noteLabel":"Nota para a pessoa (opcional, vai no e-mail)","statusPending":"em análise","statusRejected":"recusado","statusPaused":"pausado","viewPreview":"Ver a página","decided":"Decidido: {name} — {status}.","noDescription":"(sem descrição)","note":"Observação:","statusLive":"liberado","previous":"Recusado antes, com a nota:","resume":"Retomar (voltar a ficar visível)","rejectTitle":"Recusar o pedido?","rejectBody":"Recusar “{name}”? A pessoa recebe um e-mail e o pedido fecha; ela pode pedir de novo."},"joinOther":"Entrar em outro grupo com um código","alsoMember":"Você também participa de {name}."},"trails":{"title":"Minhas trilhas","intro":"Uma trilha é uma sequência de exercícios do Ritmo, do seu jeito. Monte os níveis, mande o link e acompanhe a turma.","none":"Nenhuma trilha ainda.","create":"＋ Nova trilha","edit":"Editar","open":"Abrir","copyLink":"Copiar link"}},"songs":{"happyBirthday":{"title":"Parabéns pra Você"},"twinkle":{"title":"Brilha, Brilha, Estrelinha"},"odeToJoy":{"title":"Hino à Alegria"},"jingleBells":{"title":"Bate o Sino (Jingle Bells)"}},"song":{"title":"Música de Verdade","subtitle":"Leia a partitura enquanto ela passa e toque a música no seu instrumento.","start":"Tocar","listen":"Ouvir a música","listening":"Ouvindo…","stop":"Parar","prompt":"Toque as notas quando elas cruzarem a linha.","promptStudy":"A partitura espera você. Toque a nota destacada.","mode":"Modo","modeStudy":"Estudo","modeTempo":"No tempo","modeStudyHint":"No modo estudo a partitura para em cada nota e espera você tocar a certa. Não vale nota — serve para aprender a peça.","modeTempoHint":"No modo no tempo a partitura rola firme, com metrônomo, e o seu desempenho é medido: as notas certas e a precisão do ataque.","tempoLabel":"Andamento","densityLabel":"Espaçamento","density":{"tight":"Compacto","medium":"Médio","loose":"Folgado"},"input":"Responder com","inputPiano":"Piano","inputMic":"Microfone","inputMidi":"Teclado MIDI","micNoRhythm":"No microfone só as notas são medidas: a detecção de altura chega depois do ataque, e cronometrar isso seria inventar precisão.","measure":"Compasso","hits":"Notas","wasNote":"Era {note}!","results":{"notes":"Notas","notesHint":"{hits} de {total} alturas certas","rhythm":"Ritmo","rhythmNotMeasured":"não medido no microfone","missed":"Notas que passaram","extras":"Notas a mais","onTime":"no tempo","rushing":"adiantando {ms} ms","dragging":"atrasando {ms} ms","starRecord":"Novo recorde de estrelas!","again":"Tocar de novo","toStudy":"Ir para o estudo","toTempo":"Agora no tempo","studyDone":"Peça inteira!","studyLine":"{notes} notas · {wrong} tentativas erradas","studyNext":"Quando a peça estiver na mão, mude para o modo no tempo — lá a partitura rola sozinha e o seu ritmo é medido.","noStar":"Sem estrelas: a estrela precisa do ritmo medido, e o microfone não mede o instante do ataque. Toque no piano da tela ou num teclado MIDI para valer medalha.","freeNoRecord":"Esta é a sua música: a estrela vale para esta sessão. O recorde só existe nas músicas do catálogo.","pick":"Escolher outra música"},"skipNote":"Pular esta nota","interrupted":"A rodada foi interrompida porque a página ficou em segundo plano. Nada foi pontuado — comece de novo quando puder acompanhar.","import":{"title":"Sua própria música","lead":"Carregue um arquivo MIDI (.mid) e leia essa música na esteira. O arquivo não sai do seu aparelho.","choose":"Escolher arquivo .mid","demo":"Usar o exemplo","drop":"Solte o arquivo .mid aqui","reading":"Lendo o arquivo…","privacy":"A leitura acontece aqui no navegador: o arquivo não é enviado para nenhum servidor.","privacyAccount":"A leitura acontece aqui no navegador. Com a sua conta, o arquivo também fica guardado nela — é assim que ele aparece no seu outro aparelho.","track":"Faixa","trackN":"Faixa {n}","notesWord":"notas","drums":"percussão","summary":"{notes} notas · {measures} compassos · {ts} · {key} · clave de {clef}","clef":{"treble":"sol","bass":"fá"},"errTitle":"Não deu para transformar este arquivo em partitura","warn":{"polyphonyReduced":"Esta faixa tem mais de uma voz: você vai estudar a de cima (a melodia). {dropped} notas ficaram de fora.","mergedNotes":"Notas simultâneas iguais foram reunidas numa só.","keyInferred":"O arquivo não diz a tonalidade — escolhemos a que precisa de menos acidentes.","tempoChanges":"O arquivo muda de andamento {count} vez(es); aqui você lê num andamento só, o que escolher no controle.","timeChanges":"O arquivo muda de fórmula de compasso {count} vez(es); a partitura usa a primeira do começo ao fim.","drums":"Esta faixa é de percussão: os sons não têm altura definida para ler na pauta.","drumsFiltered":"Esta faixa tinha percussão misturada com a melodia: as {dropped} notas de percussão saíram (não têm altura para ler na pauta).","snapped":"{count} nota(s) não caíam exatamente na grade e foram encaixadas na figura mais próxima."},"err":{"notMidi":"Este arquivo não é um MIDI (.mid). Se você tem a música em PDF ou MP3, ela ainda não serve — precisamos do MIDI.","format2":"Este MIDI é do tipo 2 (padrões independentes), que não forma uma música contínua. Exporte como tipo 0 ou 1.","smpte":"Este MIDI marca o tempo em quadros de vídeo, não em tempos musicais — não dá para escrever a partitura dele.","badPpq":"O cabeçalho deste MIDI está corrompido (divisão de tempo inválida).","tooBig":"Arquivo grande demais ({kb} KB). O limite é {max} KB — um MIDI de partitura costuma ter poucos KB.","noTracks":"Este MIDI não tem nenhuma faixa com música dentro.","noSuchTrack":"Esta faixa não existe no arquivo.","emptyTrack":"A faixa escolhida não tem nenhuma nota. Tente outra faixa.","offGrid":"{percent}% das notas não caem em nenhuma figura: este arquivo parece uma gravação ao vivo, não uma partitura. Um MIDI exportado de um editor de partituras funciona.","tuplets":"Esta música tem quiálteras (tercinas), que ainda não sabemos escrever. Estamos trabalhando nisso.","tooManyNotes":"Música longa demais para o v1: {notes} notas (o limite é {max}).","tooManyMeasures":"Música longa demais para o v1: {measures} compassos (o limite é {max}).","internal":"Não conseguimos montar a partitura deste arquivo.","readFailed":"Não deu para ler o arquivo. Tente escolher de novo.","unknown":"Não deu para ler este arquivo MIDI.","badTimeSignature":"A fórmula de compasso deste arquivo ({beats}/{value}) não é válida.","demoFailed":"Não conseguimos carregar o exemplo agora. Se você estiver sem internet, escolha um arquivo do seu aparelho."},"back":"{file}","tap":"Toque para escolher o arquivo .mid"},"listenPartial":"O exemplo sonoro vai até o compasso {measure} — a peça é longa demais para tocar inteira.","harmony":{"open":"Cifras","title":"Cifras","lead":"Escolha um compasso e plante o acorde. As cifras passam junto com a melodia enquanto você toca.","grid":"Grade","grid_measure":"Compasso","grid_half":"Meio","grid_beat":"Tempo","pickup":"anacruse","at":"Compasso {measure} · {chord}","repeat":"Repetir","delete":"Apagar","clearAll":"Apagar todas","clearAllAsk":"Apagar as {n} cifras desta música?","confirmClear":"Apagar tudo","done":"Pronto","count":"{n} cifras nesta música","dropped":"{n} cifras ficaram fora desta faixa e foram descartadas.","summary":"{n} cifras plantadas","count_one":"1 cifra nesta música","summary_one":"1 cifra plantada","dropped_one":"1 cifra ficou fora desta faixa e foi descartada.","tooMany":"Esta música passou de {max} cifras — as excedentes não foram guardadas.","notSaved":"Não deu para guardar as cifras neste aparelho (memória do navegador cheia). Elas valem só para esta sessão."},"modePlay":"Acompanhar","modePlayHint":"No modo acompanhar a partitura rola no tempo, com metrônomo, e nada é medido: é para tocar a música — melodia, cifra ou as duas — do seu jeito.","playing":"Toque à vontade. Nada está sendo medido.","playDone":"Fim da peça.","shelf":{"addFile":"Importar um arquivo .mid","empty":"Nada guardado ainda. Importe um arquivo .mid e ele fica aqui.","untitled":"sem nome","noChords":"sem cifras","remove":"Apagar","removeAsk":"Apagar “{name}” deste aparelho?","removeAskChords":"Apagar “{name}” deste aparelho? As {n} cifras continuam guardadas: se você importar o mesmo arquivo de novo, elas voltam.","removeAskChords_one":"Apagar “{name}” deste aparelho? A cifra continua guardada: se você importar o mesmo arquivo de novo, ela volta.","full":"Suas músicas já são {max} — o limite deste aparelho. Esta você toca agora, mas para guardá-la apague uma da lista.","fullBytes":"Acabou o espaço para músicas neste aparelho. Esta você toca agora, mas para guardá-la apague uma da lista.","gone":"Esta música não está mais guardada neste aparelho.","kb":"{n} KB","mb":"{n} MB","chords":"{n} cifras","chords_one":"1 cifra"},"cloud":{"title":"Suas músicas na conta","status":"{n} de {max} músicas na sua conta","notSynced":"Ainda não sincronizado neste aparelho.","tooNew":"{n} não foram lidas (feitas numa versão mais nova do app)","tooNew_one":"1 não foi lida (feita numa versão mais nova do app)","inAccount":"Na conta:","forget":"Tirar da conta","forgetAsk":"Tirar “{name}” da sua conta? Ela continua neste aparelho, com as cifras.","syncNow":"Sincronizar agora","syncing":"Sincronizando…","guest":"Entre na sua conta para que suas músicas e cifras apareçam em qualquer aparelho.","login":"Entrar na minha conta","note":"As suas músicas e as suas cifras ficam guardadas na conta. No outro aparelho, entre e toque em Sincronizar: elas descem sozinhas.","sent":"{n} músicas enviadas","sent_one":"1 música enviada","got":"{n} cifras novas","got_one":"1 cifra nova","full":"{n} não couberam na conta (cabem {max})","full_one":"1 não coube na conta (cabem {max})","gotFiles":"{n} músicas baixadas para este aparelho","gotFiles_one":"1 música baixada para este aparelho","noRoom":"{n} não couberam neste aparelho","noRoom_one":"1 não coube neste aparelho","fileErr":"{n} arquivos não vieram — toque em Sincronizar de novo","fileErr_one":"1 arquivo não veio — toque em Sincronizar de novo","nothing":"Tudo já estava sincronizado.","err":"Não deu para falar com a sua conta agora. Suas músicas continuam guardadas neste aparelho."},"backup":{"export":"Baixar cópia (.json)","share":"Enviar cópia","import":"Restaurar de um arquivo","note":"O backup é um arquivo .json que fica com você: leve-o para outro aparelho e importe por aqui. Importar SOMA músicas e cifras — nunca apaga o que já está guardado.","empty":"Ainda não há nada para exportar.","noRoom":"{n} não couberam na estante (as cifras delas foram guardadas)","fixed":"{n} identificações recalculadas pelo arquivo","skipped":"{n} itens recusados","added":"{n} músicas novas","added_one":"1 música nova","updated":"{n} atualizadas","updated_one":"1 atualizada","chords":"{n} cifras novas","chords_one":"1 cifra nova","noShelf":"{n} músicas não puderam ser guardadas neste navegador (as cifras delas foram guardadas)","noShelf_one":"1 música não pôde ser guardada neste navegador (as cifras dela foram guardadas)","noRoom_one":"1 não coube na estante (as cifras dela foram guardadas)","fixed_one":"1 identificação recalculada pelo arquivo","rejected":"{n} cifras do backup foram recusadas por estarem corrompidas","rejected_one":"1 cifra do backup foi recusada por estar corrompida","skipped_one":"1 item recusado","nothing":"Nada de novo: este backup já estava todo aqui.","err":{"empty":"O arquivo está vazio.","notJson":"Este arquivo não é um .json válido.","notOurs":"Este .json não é um repertório do Aula de Música.","newerVersion":"Este backup foi feito numa versão mais nova do app (formato {version}). Atualize o app e tente de novo.","tooBig":"O arquivo passa de {mb} MB.","badSong":"Nenhuma música pôde ser lida deste backup.","songTooBig":"“{name}” é grande demais e foi recusada.","badVersion":"Este arquivo não diz em que formato foi feito — não dá para confiar nele."}},"pick":{"title":"Escolher música","lead":"Suas músicas e as do app. Toque numa para abrir.","open":"Escolher música","mine":"Suas músicas","app":"Do app","current":"aberta agora"}},"music":{"major":"maior","minor":"menor"},"help":{"dotAria":"Ajuda: {subject}","prev":"Anterior","next":"Próximo","gotIt":"Entendi","tabs":{"explain":"Explicação","video":"Vídeo","faq":"Perguntas"},"flow":{"howto":{"title":"Como funciona a esteira de notas","p1":{"title":"As notas andam sozinhas, da direita para a esquerda","body":"A nota de cor mais forte, com o círculo pontilhado em volta, é a sua vez: é essa que você tem que nomear. As outras estão só na fila, esperando."},"p2":{"title":"A faixa vermelha é o prazo","body":"Se a nota chegar na faixa vermelha pontilhada sem resposta, ela some e conta como erro. Não precisa correr: nos primeiros níveis a esteira anda devagar de propósito."}},"input":{"title":"Como responder: botão, piano ou o seu instrumento","p1":{"title":"Quatro jeitos de dizer qual é a nota","body":"Botões traz o nome da nota escrito. Piano pede a tecla certa. Microfone escuta o seu piano acústico pelo aparelho, e MIDI recebe o teclado ligado no computador — esses dois só aparecem quando o aparelho aceita."},"p2":{"title":"Por que os botões trancam","body":"Do nível 2 em diante a resposta é a tecla, não o nome: é isso que liga a pauta ao instrumento. Os botões continuam na lista, com cadeado, para você ver que eles não sumiram."}},"kids":{"title":"O modo Kids","p1":{"title":"Cada nota ganha uma cor","body":"No Kids a nota tem uma cor própria na pauta, e a mesma cor aparece no botão e na tecla. A criança acha pela cor antes de saber o nome — e a esteira anda mais devagar, com mais espaço entre as notas."},"p2":{"title":"A cor sai sozinha, por mérito","body":"Depois de alguns acertos seguidos, a cor daquela nota some do botão; na pauta ela fica. O quadro embaixo da tela mostra quais notas você já responde sem a cor. Ninguém precisa desligar nada: a muleta se desmancha sozinha."}},"exitLine":{"title":"A faixa vermelha pontilhada","p1":{"title":"É o prazo daquela nota, não o fim do jogo","body":"Cada nota tem até chegar na faixa vermelha para ser nomeada. Chegou sem resposta, ela some e conta como erro — mas a esteira continua, e a próxima já está a caminho. Errar uma não estraga a rodada."},"q1":{"q":"A nota sumiu e eu nem vi. O que aconteceu?","a":"Ela passou da faixa vermelha. Nos primeiros níveis isso quase não acontece, porque a esteira anda devagar; nos níveis altos ela acelera de propósito. Se estiver rápido demais, volte um nível — o nome da nota tem que sair sem pensar antes de a velocidade fazer sentido."}}},"intervals":{"howto":{"title":"O que é um intervalo","p1":{"title":"É a distância entre duas notas","body":"O jogo toca duas notas — uma depois da outra, ou as duas juntas. A distância entre elas é o que os músicos chamam de intervalo: notas vizinhas soam quase iguais, notas afastadas dão um salto que a gente escuta na hora."},"p2":{"title":"É treino de ouvido, não de vista","body":"Você não precisa ver nada para responder; o piano da tela só mostra depois quais foram as duas notas. Se não lembrar o som, aperte Repetir quantas vezes quiser — não custa ponto nenhum. O nível 1 tem só duas respostas possíveis."}},"assist":{"title":"“Ver teclas”: o que muda","p1":{"title":"É a pista visual, e ela é opcional","body":"Com “Ver teclas” em Sim, o piano da tela acende as notas enquanto o som toca: dá para conferir com os olhos o que o ouvido escutou. Ele vem desligado — toque em Sim para ligar. Em Não você responde só de ouvido, que é o objetivo do treino. Ligar ou desligar não muda o nível nem o placar: comece no Sim e desligue quando o som já estiver reconhecível."}},"mode":{"title":"Ouvir e identificar × Construir no piano","p1":{"title":"Duas formas de responder a mesma pergunta","body":"Em “Ouvir e identificar” o jogo toca o intervalo e você escolhe o nome dele. Em “Construir no piano” o jogo dá a primeira nota e o nome do intervalo, e você toca a segunda no teclado. O primeiro treina reconhecer; o segundo treina produzir — e é o segundo que você vai usar quando estiver tocando."}},"play":{"title":"Melódico × Harmônico","p1":{"title":"As duas notas em fila, ou as duas de uma vez","body":"Em Melódico as notas vêm uma depois da outra, como uma melodia — dá para acompanhar o caminho de uma até a outra. Em Harmônico as duas soam juntas, e aí você escuta o acorde formado por elas, não o percurso. Harmônico é bem mais difícil: é o mesmo intervalo, mas o ouvido tem que separar dois sons empilhados."}}},"chords":{"howto":{"title":"O que é um acorde","p1":{"title":"São três ou mais notas soando juntas","body":"Uma nota sozinha é uma nota. Três apertadas ao mesmo tempo formam um acorde — é o som do violão quando você bate todas as cordas de uma vez."},"p2":{"title":"Um atalho para começar","body":"Maior soa alegre, menor soa triste. Isso já resolve o nível 1 inteiro, que só tem essas duas respostas. É treino de ouvido: se não tiver certeza, aperte Repetir — o app toca de novo, sem custo nenhum."}},"play":{"title":"“Junto” × “Arpejo”","p1":{"title":"As mesmas notas, em duas formas de tocar","body":"Em Junto as notas soam todas no mesmo instante, como um violão batido: o acorde inteiro de uma vez. Em Arpejo elas vêm uma de cada vez, de baixo para cima, como um violão dedilhado — dá para escutar cada nota separada. O acorde é o mesmo; se estiver difícil ouvir por dentro, comece no Arpejo."}}},"song":{"mode":{"title":"Qual modo escolher?","p1":{"title":"Estudo — para aprender","body":"A partitura para em cada nota e espera você tocar a certa. Não vale nota: é treino. É por aqui que se começa uma peça nova."},"p2":{"title":"No tempo — para se testar","body":"A partitura rola firme, com metrônomo, e o app mede as notas certas e a precisão do ataque. Mude para cá quando a peça já estiver na mão."},"p3":{"title":"Acompanhar — para tocar por prazer","body":"A partitura rola no tempo e nada é medido: é para tocar a música — melodia, cifra, ou as duas — do seu jeito."}},"tempo":{"title":"O “Andamento”","p1":{"title":"A velocidade em que a partitura anda","body":"Arraste para a esquerda para ficar mais devagar, para a direita para ficar mais rápido. No modo Estudo ele governa o quanto a esteira caminha entre uma nota e outra; nos modos No tempo e Acompanhar é a velocidade real da música."},"q1":{"q":"Posso tocar bem mais devagar que o original?","a":"Pode, e deve. Estudar devagar e acelerar aos poucos é como se aprende uma peça — nada no app penaliza um andamento baixo."}},"input":{"title":"Por onde você toca","p1":{"title":"Piano da tela, microfone ou teclado MIDI","body":"Piano é o teclado desenhado na tela, que funciona em qualquer aparelho. Microfone escuta o seu piano acústico e reconhece a nota pelo som. Teclado MIDI recebe o instrumento ligado por cabo. As três respondem a mesma coisa — muda só por onde a nota entra; microfone e MIDI só aparecem quando o aparelho aceita."}},"chart":{"title":"As cifras","p1":{"title":"O nome do acorde escrito por cima da música","body":"Cifra é o nome do acorde — C, G7, Am — escrito acima da partitura, dizendo o que a mão da harmonia toca naquele trecho. Quem acompanha ao violão ou toca de ouvido lê a cifra, não a melodia inteira."},"p2":{"title":"Você planta as suas, e elas ficam","body":"Abra “Cifras” e escreva o acorde em cada ponto da música. Elas ficam guardadas naquele arquivo neste aparelho e aparecem toda vez que você abrir a peça. Algumas músicas do catálogo já vêm com cifra pronta — e o que você escrever por cima vale mais que a de fábrica, inclusive se você apagar todas."},"q1":{"q":"O app toca as cifras?","a":"Ainda não. Elas são escritas para VOCÊ tocar — no violão, na mão esquerda do piano, no instrumento que for. Para acompanhar sem ser cobrado nas notas, use o modo Acompanhar."}},"chartGrid":{"title":"Escrever cifra na grade","p1":{"title":"Por que a grade, e não a partitura rolando","body":"Escrever direto na esteira exigiria caçar o ponto certo numa tela que mostra pouco mais de um compasso de cada vez — numa música de trinta compassos, seriam vinte e cinco páginas de tateio. A grade mostra a música inteira de uma vez: você vê onde cada acorde entra."},"p2":{"title":"Compasso, meio compasso ou tempo","body":"Escolha de quanto em quanto você quer poder escrever. Compasso serve para a maioria das músicas populares, em que o acorde dura o compasso inteiro. Meio compasso e tempo dão pontos mais miúdos, para quando a harmonia anda mais rápido."}},"midi":{"title":"Trazer o seu arquivo MIDI","p1":{"title":"Qualquer .mid vira partitura na esteira","body":"Escolha um arquivo .mid do aparelho e o app o lê ali mesmo, no navegador: monta a partitura, escolhe a clave e a armadura e põe a melodia para rolar. O arquivo NÃO é enviado para servidor nenhum."},"p2":{"title":"Alguns arquivos são recusados — e isso é de propósito","body":"MIDI guarda quando cada nota soa, não como ela se escreve. Se o arquivo tiver notas que não caem na grade rítmica — tercinas, execução humana gravada ao vivo, rubato — o app diz o que não coube em vez de desenhar uma partitura torta. Recusa com explicação vale mais que uma página errada."},"q1":{"q":"Onde eu consigo arquivos .mid?","a":"Há acervos grandes de domínio público na internet, e a maioria dos editores de partitura (MuseScore, por exemplo) exporta .mid. Respeite o direito autoral do que você baixar."},"q2":{"q":"A peça que eu importei não grava recorde. Por quê?","a":"Porque não daria para comparar: cada pessoa traz um arquivo diferente, com notas e dificuldade diferentes. O placar aparece na tela, mas não entra no ranking."}},"lists":{"title":"A lista de músicas","p1":{"title":"O catálogo do app e os seus arquivos, na mesma lista","body":"Em cima ficam as músicas que já vêm com o app, todas de domínio público. Embaixo ficam os arquivos .mid que você trouxe. É uma lista só, nas duas portas do jogo: você troca de peça sem sair para lugar nenhum."}},"account":{"title":"Onde o seu arquivo fica","p1":{"title":"No aparelho, e só nele","body":"O .mid que você importa fica guardado neste navegador, neste aparelho. Ele não sobe para servidor nenhum, e por isso não segue a sua conta: entrar noutro celular não traz as suas músicas junto. Para levá-las, use o backup."},"q1":{"q":"Se eu limpar os dados do navegador, perco tudo?","a":"Perde. Faça a cópia em .json antes — ela guarda as suas cifras, ligadas a cada música. Os arquivos .mid ela não leva: guarde-os na mesma pasta da cópia e o seu repertório volta inteiro."}},"backup":{"title":"Backup do seu repertório","p1":{"title":"Um arquivo .json com as suas cifras","body":"Aperte “Enviar cópia” (ou “Baixar cópia (.json)”) e o app gera um arquivo com as cifras que você escreveu, ligadas a cada música. Guarde esse arquivo onde quiser — e-mail, nuvem, pen drive: é ele que atravessa a troca de aparelho ou a limpeza do navegador."},"p2":{"title":"“Restaurar de um arquivo” SOMA, nunca apaga","body":"Ao trazer um backup de volta, as cifras dele se juntam às que já estão aqui. Nada é apagado: se um ponto tem cifra nos dois lados, a que já estava no aparelho é a que fica. Importar duas vezes não faz mal nenhum."},"q1":{"q":"O backup guarda os arquivos .mid também?","a":"Não, só as cifras. Os arquivos .mid você já tem — guarde-os na mesma pasta da cópia e o seu repertório volta inteiro."}},"results":{"title":"O placar da música","p1":{"title":"Notas certas e precisão do ataque","body":"Notas diz quantas você tocou certo. Precisão diz o quanto você caiu junto com o tempo em cada uma. As duas só são medidas no modo No tempo — no Estudo a partitura espera por você, e no Acompanhar nada é medido."},"p2":{"title":"As estrelas são do seu melhor","body":"As estrelas guardam a sua melhor passada naquela música do catálogo, e não descem quando você tenta de novo e sai pior. Peça que você importou não guarda estrela: sem todo mundo tocando a mesma coisa, não haveria o que comparar."}}},"reading":{"howto":{"title":"Treino livre: uma nota de cada vez","p1":{"title":"Aqui nada corre","body":"Aparece UMA nota na pauta e ela espera. Você diz qual é, sem relógio e sem esteira. É o lugar de aprender o nome das notas com calma — e de voltar quando a leitura em fluxo começa a apertar."},"p2":{"title":"Não vale nota, e é por isso que serve","body":"O treino livre não conta ponto, não sobe nível e não entra no ranking. Ele existe para você errar à vontade: é onde se decora, não onde se prova."}},"guide":{"title":"A linha-guia (⚙️ Opções)","p1":{"title":"Uma linha da nota até a tecla certa","body":"A linha-guia liga a nota na pauta à tecla (ou ao botão) que responde por ela. Quem está começando ainda não tem esse caminho na cabeça — a linha o desenha até ele virar automático."},"p2":{"title":"Três ajustes, do mais ao menos ajuda","body":"Sempre mostra a linha em toda nota. Só quando erra faz a linha aparecer na correção, apontando onde era. Desligada tira a ajuda visual. Comece em Sempre e desça um degrau quando estiver acertando sem olhar."}},"clef":{"title":"A clave (⚙️ Opções)","p1":{"title":"Sol, fá ou as duas","body":"A clave diz que nota mora em cada linha. A de sol é a das notas agudas (mão direita do piano, violino, flauta); a de fá, das graves (mão esquerda, violoncelo, baixo). Em “As duas” a clave troca a cada nota — leia a clave antes da nota."}},"key":{"title":"A tonalidade (⚙️ Opções)","p1":{"title":"Os sinais logo depois da clave","body":"A armadura é o grupo de sustenidos ou bemóis escrito depois da clave, e vale para a peça inteira: com um sustenido, todo Fá é Fá♯, sem sinal na nota. Cada tonalidade maior tem a sua armadura, e a relativa menor usa a mesma: para treinar Lá menor, escolha Dó maior."},"p2":{"title":"Como o treino usa","body":"As notas sorteadas seguem a armadura. No piano, a resposta é a tecla certa (em geral a preta, quando a nota é alterada); nos botões aparecem também os nomes alterados, como Fá♯ — e “Fá” para um Fá♯ escrito conta erro. Marque quantas tonalidades quiser: a armadura é sorteada entre as marcadas a cada “Jogar de novo” (uma só marcada = sempre a mesma). Comece por uma ou duas alterações."}},"sound":{"title":"Piano real (⚙️ Opções)","p1":{"title":"Sons de piano de verdade","body":"Ligado, o app baixa gravações de um piano (cerca de 1,6 MB, uma vez só — fica guardado no aparelho) e toca a nota com esse som. Desligado, a nota sai num tom simples. Vale para todos os jogos."}}},"rhythm":{"howto":{"title":"Como jogar o Ritmo","p1":{"title":"A linha anda; você toca quando ela cruza a nota","body":"A partitura fica parada e uma linha atravessa a tela da esquerda para a direita, sempre na mesma velocidade. Cada vez que a linha cruza uma nota, é a hora de tocar. Onde a nota está na tela é QUANDO ela soa."},"p2":{"title":"No computador é a barra de espaço; no celular, o dedo no botão TOQUE","body":"No computador, aperte a barra de espaço. No celular, toque e segure no botão grande escrito TOQUE. Segure enquanto a nota durar e solte no fim — toda nota se segura até acabar, a curta só dura menos."},"p3":{"title":"Antes de começar, a contagem","body":"Toda rodada começa com a contagem do metrônomo para você pegar o andamento — quatro cliques, em 4/4. Não toque neles: eles são a contagem. A primeira nota vem logo depois do último clique."},"q1":{"q":"Toco no tempo certo, mas o app diz que errei.","a":"Olhe primeiro os DOIS placares. Se o Início está alto e a Duração baixa, o seu tempo está certo: o que falta é segurar cada nota até ela acabar, em vez de dar um toque rápido. Se os dois estiverem baixos, pode ser o som saindo atrasado — fone Bluetooth é o caso mais comum. O app tenta descontar esse atraso sozinho, mas nem todo aparelho informa o valor certo: experimente jogar no alto-falante ou com fone de fio."},"q2":{"q":"Preciso saber ler partitura para jogar?","a":"Não. Você não precisa saber o nome das figuras: basta ver onde as notas estão e tocar quando a linha cruzar cada uma. Os nomes você aprende depois, jogando."}},"tempo":{"title":"O “Tempo” (BPM)","p1":{"title":"É a velocidade da música","body":"BPM quer dizer batidas por minuto: quantas vezes o metrônomo clica em um minuto. Menos BPM, mais devagar e mais fácil de acertar. A margem de erro do app é a mesma em qualquer velocidade — então acelerar deixa o exercício mais difícil, e desacelerar é uma forma legítima de estudar."}},"results":{"title":"“Início” e “Duração”: o que os números dizem","p1":{"title":"Início é QUANDO você tocou","body":"Início mede o quanto você acertou o momento de cada nota — se o seu toque caiu junto com a linha ou um pouco antes/depois. É a nota mais importante do jogo: é ela que diz se você está no tempo."},"p2":{"title":"Duração é QUANTO você segurou","body":"Duração mede se você segurou a tecla o tempo que a figura pedia: soltar cedo demais numa nota longa, ou segurar demais numa curta, derruba esse número. Ele é mais exigente nas figuras curtas, porque elas duram menos — e por isso costuma ser o número mais baixo dos dois."},"q1":{"q":"Meu “Início” está alto e a “Duração” baixa. Está ruim?","a":"Não. Isso é o mais comum, e quer dizer que você está no tempo mas ainda não está controlando o tamanho das notas. Trabalhe soltando a tecla no fim da nota, em vez de logo depois de tocar."},"q2":{"q":"Passei de nível mesmo com um número baixo. Como?","a":"A aprovação do nível olha o conjunto, não um número isolado. Um deles baixo não reprova sozinho — mas ele é o que te mostra onde estudar da próxima vez."}},"trails":{"title":"O que é uma trilha","p1":{"title":"Uma sequência de exercícios, do seu jeito","body":"Uma trilha é uma lista de exercícios do Ritmo que você monta: cada nível é um exercício (figuras, compasso, andamento e, se quiser, uma nota para passar). A turma joga um por um, em ordem. Pode ter um nível só ou trinta."},"p2":{"title":"Monta na oficina, manda o link, acompanha","body":"Este botão leva o exercício que está na tela para uma trilha (nova, ou o próximo nível de uma que você já tem). Na oficina da trilha você ajusta cada nível, vê um exemplo do que a turma vai ver e testa. Depois é só copiar o link: quem abrir entra na conta e joga, e você vê quantos começaram e concluíram. Também dá para começar por “Minhas trilhas”, na sua conta."},"action":"Ver uma trilha de exemplo"},"pitch":{"title":"Notas na altura certa","p1":{"title":"Cada nota na linha em que soa","body":"Com “Melodia”, o app pode desenhar cada nota do ritmo na linha da pauta em que ela soa, como numa partitura de verdade: haste para baixo nas notas altas e linha suplementar no Dó grave. Desligado, todas ficam na linha do meio. A pontuação não muda: o jogo mede só o tempo."}},"sound":{"title":"Som da nota","p1":{"title":"A nota que você ouve","body":"É a nota que o modelo toca no “Ouvir” e que o botão toca quando você aperta. Escolha uma nota, ou “Melodia” para as notas do ritmo mudarem de altura, como uma pequena melodia que muda a cada ritmo. A pontuação não muda: o jogo mede só o tempo."}},"ruler":{"title":"Régua de tempos","p1":{"title":"Os números embaixo da pauta","body":"Marcam os tempos de cada compasso, para ajudar a contar enquanto você toca. Quando já contar sozinho, pode escondê-la. A pontuação é a mesma com ou sem ela."}},"midi":{"title":"Teclado MIDI","p1":{"title":"Tocar o ritmo no seu instrumento","body":"Ligue esta opção e toque o ritmo no seu teclado ou controlador MIDI ligado ao computador (cabo USB ou Bluetooth). Cada tecla que você aperta vale como um toque no botão, e segurar a tecla é segurar a nota. Qualquer tecla serve: o jogo mede só o tempo, não a altura. O som que você ouve é a nota que tocou; se o seu piano também soa por conta própria, abaixe o volume dele para não ouvir em dobro. Vale a tecla segurada: o pedal de sustain não conta como duração. Duas ou mais teclas tocadas juntas (acorde, oitava) contam como um toque só. No iPhone e no iPad esta opção não aparece: o navegador deles não tem MIDI."}}},"app":{"levelGate":{"title":"Por que os níveis estão trancados","p1":{"title":"Os níveis abrem em ordem","body":"Cada nível destranca o seguinte. Termine o nível 1 e o 2 abre sozinho, sem nada para configurar. O cadeado quer dizer “ainda não”, nunca “não pode”."},"p2":{"title":"Os três primeiros você joga sem conta","body":"Você joga os três primeiros níveis de cada trilha sem nada. Do quarto em diante o app pede uma conta — leva um minuto, e dá para entrar com o Google."},"p3":{"title":"A conta existe para o progresso não morar no navegador","body":"Sem conta, o seu avanço fica guardado só neste navegador: trocar de celular, ou limpar os dados, e ele some. Com conta, ele segue você — e o ranking passa a fazer sentido, porque há alguém do outro lado do placar."},"q1":{"q":"Vou perder o que já joguei sem conta?","a":"Não. Ao criar a conta, o progresso deste aparelho é adotado por ela. A única exceção é uma conta que já jogou aqui antes: essa mantém o progresso dela, que é o mais avançado dos dois."}},"freeMode":{"title":"Modo livre × trilha de níveis","p1":{"title":"Um treina o que você escolher; o outro tem começo, meio e fim","body":"A trilha de níveis vai do fácil ao difícil numa ordem pensada, guarda o seu melhor de cada nível e entra no ranking. O modo livre não tem ordem nem placar guardado: você escolhe o que quer treinar e repete à vontade. Use a trilha para avançar e o livre para insistir naquilo que ainda não saiu."}},"groups":{"title":"Grupos (escola ou turma)","p1":{"title":"O que é um grupo","body":"Um grupo representa uma escola ou uma turma dentro do app. Quem organiza — um professor ou a coordenação — pede o grupo aqui mesmo: um nome, uma descrição curta e, se quiser, uma logo. O pedido é liberado em pouco tempo e a confirmação chega por e-mail. Os alunos entram depois, cada um com a própria conta."},"p2":{"title":"Como entrar e o que aparece","body":"Liberado, o grupo ganha uma página própria, mais um código de convite e um link em \"Minha conta\". Quem organiza passa um dos dois aos alunos. Quem entra passa a ver, além do ranking geral, um só do grupo: o nível alcançado e a precisão de cada pessoa. Quem organiza vê esse ranking mesmo sem entrar no grupo — e, se quiser participar, entra com o código como os alunos."},"q1":{"q":"Sair do grupo apaga o meu progresso?","a":"Não. Sair só tira o seu nome do ranking do grupo. Todo o seu progresso continua igual."}}},"title":"Ajuda","subtitle":"Tudo o que o app explica, num lugar só.","sub":"Como jogar, dúvidas e primeiros passos","searchPlaceholder":"Buscar ajuda…","searchEmpty":"Nada encontrado para “{q}”. Tente outra palavra — ou role e procure pelo jogo.","hereTitle":"Ajuda desta tela","hereFrom":"Você veio de: {game}","firstTitle":"Primeiros passos","firstSub":"As dúvidas de quem está chegando agora.","byGameTitle":"Ajuda por jogo","byGameSub":"Toque num assunto para abrir a explicação.","guidesTitle":"Guias interativos","guidesSub":"Páginas do nosso site que explicam o assunto com som e movimento. Abrem numa aba nova — o app continua aqui.","topicsN":"{n} assuntos","topicsOne":"1 assunto","backToResult":"◀ Voltar ao resultado","groups":{"app":"O app"},"levelsLabel":"Níveis:","pageOf":"Página {n} de {total}"},"group":{"title":"Grupo","newTitle":"Pedir a criação de um grupo","form":{"intro":"Diga quem é a escola ou a turma. O que você escreve aqui aparece na página do grupo, que é pública; a observação é só para a administração.","nameLabel":"Nome da escola ou da turma","descLabel":"Descrição","descHint":"Até {max} caracteres. Escreva no seu idioma: a página traduz para os outros dois.","logoLabel":"Logo (opcional)","logoHint":"PNG, JPG, GIF ou WebP até 2 MB. A imagem é redimensionada para 256×256.","logoChoose":"Escolher imagem","logoRemove":"Tirar a logo","logoSending":"Enviando a logo…","logoSaved":"Logo atualizada.","logoAfter":"A logo pode ser enviada depois de criar o pedido.","noteLabel":"Observação para a administração (opcional)","noteHint":"Não aparece na página.","submit":"Enviar pedido","save":"Salvar","saved":"Alterações salvas.","countryLabel":"País (opcional)","countryNone":"Não mostrar","countryHint":"Se escolher, a bandeira e o nome do país aparecem na página do grupo."},"sent":{"title":"Pedido enviado","body":"A administração revisa o pedido e você recebe um e-mail. O código de convite aparece em “Minha conta” quando o grupo for liberado.","ok":"Entendi"},"guest":{"title":"Para pedir um grupo, entre na sua conta","body":"O grupo fica ligado à conta de quem o organiza."},"page":{"join":"Entrar neste grupo","joinLogin":"Entrar na conta para participar","joined":"Você está neste grupo","owner":"Você organiza este grupo","inOther":"Você já está em outro grupo. Saia dele em “Minha conta” para entrar neste.","joinNote":"Quem entra aparece no ranking do grupo, que é público, e quem organiza acompanha o seu progresso. Dá para sair quando quiser.","preview":"Prévia: este grupo ainda não está liberado. Só você e a administração veem esta página.","notFound":"Este grupo não existe ou não está disponível.","noDescription":"Sem descrição.","logoAlt":"Logo de {name}","joining":"Entrando…","askCode":"Para entrar, peça o código de convite a quem organiza o grupo e digite-o em “Minha conta”."},"ranking":{"title":"Ranking do grupo","adminNote":"Você vê como administração do site e não aparece na lista.","emptyViewer":"Ninguém de {group} no ranking de {game} ainda."},"news":{"badge":"Novo","country":"Agora dá para mostrar o país do grupo, com a bandeira, na página. Escolha em “Editar a página”.","ok":"Entendi"},"class":{"title":"Visão da turma","private":"🔒 Só quem organiza o grupo vê esta parte. Os alunos não.","cardIntro":"Veja em que nível cada aluno está, quem já tentou {n} vezes ou mais sem passar e, no Ritmo, o que falta: segurar as notas ou entrar no tempo.","cardCta":"Abrir a visão da turma","backPage":"Página do grupo","gameLabel":"Jogo","inGame":"No jogo: {game}","forbidden":"Só quem organiza este grupo pode ver a turma.","empty":"Ainda não há ninguém no grupo. Passe o código de convite para a turma.","noneStarted":"Ninguém da turma jogou {game} ainda.","statStudents":"alunos no grupo","statStudentOne":"aluno no grupo","statRounds":"rodadas","statTime":"tocando, somados","statMid":"nível do meio da turma","playing":"{n} de {total} já jogaram.","diaryOff":"{n} alunos estão com o diário de jogo desligado: o nível deles aparece; rodadas, tempo e tentativas não entram nas somas.","diaryOffOne":"1 aluno está com o diário de jogo desligado: o nível aparece; rodadas, tempo e tentativas não entram nas somas.","diaryOffStudent":"Diário de jogo desligado: tentativas e tempo deste aluno não são registrados.","whereTitle":"Onde cada aluno está","whereHint":"Cada bolinha é um aluno, no nível que está tentando passar agora.","histAria":"Alunos por nível: {parts}","histPart":"nível {level}: {n} alunos","legendAdvancing":"avançando","legendStuck":"{n} tentativas ou mais no mesmo nível","legendDone":"zerou a trilha","tapHint":"Toque num aluno para ver o detalhe.","pickLabel":"Ver aluno","pickNone":"Escolha um aluno","notStarted":"Ainda não jogaram: {names}.","levels":"Níveis","level":"Nível {n}","done":"Zerou a trilha","noName":"(sem nome)","best":"Melhor tentativa: {acc}%. O nível pede {pass}%.","bestNoPass":"Melhor tentativa: {acc}%.","bestSplit":"Melhor tentativa: início {onset}% · duração {duration}%. O nível pede {pass}% nos dois.","noBest":"Ainda sem placar neste nível.","tries":"{n} tentativas no nível {level}.","triesOne":"1 tentativa no nível {level}.","totals":"{rounds} rodadas · {time} em {game}.","min":"{m} min","hm":"{h} h {m}","today":"hoje","yesterday":"ontem","stuckTitle":"Quem precisa de uma mão","stuckHint":"{n} tentativas ou mais no nível atual sem passar. A barra é a melhor tentativa; o traço é o que o nível pede.","stuckNone":"Ninguém empacado agora.","stuckMore":"Ver os outros {n}","stuckMoreOne":"Ver mais 1","needs":"pede {pass}%","triesShort":"tentativas","accuracy":"Melhor","badge":{"hold":"Falta segurar","timing":"Entrar no tempo","generic":"Abaixo da meta"},"diag":{"hold":"Entra no tempo, mas solta as notas cedo: falta segurar cada nota até o fim.","timing":"Segura as notas, mas entra fora do tempo: o que falha é o começo de cada nota.","genericSplit":"Início e duração ainda abaixo dos {pass}% que o nível pede.","generic":"A melhor tentativa ainda está abaixo dos {pass}% que o nível pede."},"seriesTitle":"Rodadas por dia","seriesHint":"Últimos {n} dias, no seu fuso.","seriesAria":"Rodadas por dia: {parts}","seriesPart":"{day}: {n} rodadas, {players} alunos","seriesEmpty":"Nenhuma rodada registrada nos últimos {n} dias.","seriesOff":"Sem diário de jogo ligado na turma: não há rodadas para contar.","wallsTitle":"Onde a turma costuma travar","wallsHint":"Quantas tentativas, na mediana, cada nível pediu até passar (de quem passou com o diário ligado).","wallsAria":"Tentativas até passar, por nível: {parts}","wallsPart":"nível {level}: mediana de {median} tentativas ({n} alunos)","wallsTop":"O nível que mais pede tentativas: {level} (mediana de {median}, entre quem já passou).","wallsHere":"tem aluno neste nível agora","wallsEmpty":"Ainda não dá para medir: ninguém passou de um nível com o diário ligado.","tableSummary":"Todos os alunos ({n})","colName":"Aluno","colLevel":"Nível","colTries":"Tentativas","colRounds":"Rodadas","colTime":"Tempo","histPartOne":"nível {level}: 1 aluno","histStuck":"{n} empacados","noRecords":"Sem registro no diário de jogo neste jogo (jogou antes de o diário existir, ou nada chegou ainda).","world":"Mundo {n}","seriesPartOne":"{day}: {n} rodadas, 1 aluno","wallsPartOne":"nível {level}: {median} tentativas (1 aluno só)","wallsNow":"{n} parados nele agora","wallsOnlyHere":"nível {level}: ninguém mediu ainda, {n} parados nele agora"}},"trail":{"title":"Trilha","editTitle":"Editar trilha","by":"por {name}","bySchool":"por {name} · {school}","levels":"{n} níveis","levelsOne":"1 nível","guestIntro":"Esta trilha é para quem tem conta: o seu avanço fica guardado neste aparelho e quem a montou acompanha a turma. Entrar ou criar conta leva um minuto.","play":"Jogar","continueAt":"Continuar no nível {n}","progress":"{done} de {total} níveis concluídos","cleared":"concluído","current":"você está aqui","locked":"bloqueado","training":"treino","sameRhythm":"mesmo ritmo para todos","edit":"Editar a trilha","viewAsStudent":"Ver como aluno","link":"Link da trilha","stats":"{started} começaram · {finished} concluíram","statsNone":"Ninguém jogou ainda.","notFound":"Esta trilha não existe ou foi apagada.","cancel":"Cancelar","editor":{"name":"Nome da trilha","label":"Nome do nível (opcional)","labelPh":"Ex.: Pulso","pass":"Para passar","takes":"Vezes que precisa bater a meta","seed":"Mesmo ritmo para todos","dup":"Duplicar","del":"Apagar","add":"＋ Adicionar nível","delTrail":"Apagar trilha","delConfirm":"Apagar “{name}”? O link deixa de funcionar para todo mundo.","delLevelConfirm":"Apagar o nível {n}?","saving":"Guardando…","saved":"Guardado.","measures":"compassos","measureOne":"compasso","ties":"ligadura","deleted":"Trilha apagada.","auto":"ligada para fechar o compasso","namePh":"Ex.: 6º ano · semínimas","nameHint":"A turma vê este nome.","s1":"Monte os níveis","s1Lead":"Cada nível é um exercício. A turma joga um por um, em ordem.","s2":"Mande o link","s2Lead":"Quem abrir entra na conta (ou cria uma) e joga nível a nível.","s3":"Acompanhe","s3Lead":"Aqui aparece quantos começaram e quantos concluíram.","newHint":"Nasceu igual ao nível {n}. Mude uma coisa: uma figura a mais, o andamento, o compasso.","exTitle":"Exemplo do que a turma vai ver","otherEx":"🔀 Outro exemplo","otherSeed":"🎲 Sortear outro ritmo","figs":"⚙️ Figuras e compasso","panelTitle":"Figuras e compasso · nível {n}","resetLevel":"Restaurar padrão","tempo":"Andamento","passTraining":"Treino","passNote":"Treino: joga, vê o placar e segue para o próximo.","seedNote":"Ligado: o ritmo do exemplo acima é o que a turma inteira toca — sorteie até gostar. Desligado: cada rodada sorteia outro.","test":"▶ Testar este nível","addNote":"O nível novo nasce igual ao anterior.","diffNew":"novo: {x}","diffOut":"sai: {x}","diffTempo":"andamento {a} → {b}","diffSig":"compasso {a} → {b}","diffBars":"{n} compassos","diffTiesOn":"com ligadura","diffTiesOff":"sem ligadura","diffSame":"igual ao anterior","kicker":"Oficina da trilha"},"guestWhat":"Exercícios de ritmo: você lê o ritmo na partitura e o toca no tempo do metrônomo, nível a nível.","paused":"Esta trilha está pausada pela administração: quem abre o link não a vê.","playAgain":"Jogar de novo","asStudent":"Você está vendo como aluno","backToWorkshop":"← Voltar à oficina","deviceNote":"O seu avanço nesta trilha fica guardado neste aparelho."}},"en":{"meta":{"title":"Absolute Pitch Class — Music learning games: rhythm, note reading & ear training","description":"Music education in games: rhythm, sheet-music reading, intervals and chords by ear, and real music read on the staff, including your own MIDI. Levels, ranking and classes for schools. In your browser.","ogImageAlt":"Absolute Pitch Class — rhythm, staff-reading and ear-training games","jsonldSiteDesc":"Music education in games: rhythm, staff reading, intervals and chords by ear, and real music read from the score.","jsonldBrowserReq":"Requires a modern browser with Web Audio API support.","jsonldFeatures":["Rhythm game with 30 levels in 6 worlds","Scrolling staff reading, treble and bass clefs","Kids mode with color-coded notes","Interval and chord ear training by levels","Real music read from the score, on the on-screen piano or a MIDI keyboard","Import your own MIDI file with chord symbols","Ranking and progress tied to your account","Groups for schools and classes, with a teacher's view"]},"app":{"name":"Absolute Pitch Class","tagline":"Learn Music by Playing","loading":"Loading…","updateAvailable":"New version available","updateNow":"Update","loadError":"Couldn't load this screen.","bootFailed":"Couldn't load the app.","retry":"Try again"},"langSwitch":{"label":"Language"},"nav":{"games":"Games","about":"About","menu":"Menu","rhythm":"Rhythm","staffReading":"Reading","intervals":"Intervals","chords":"Chords","songs":"Music","news":"What's New","home":"Home","levels":"Levels","ranking":"Ranking","progress":"My progress","profile":"My account","help":"Help","privacy":"Privacy","terms":"Terms","contact":"Contact"},"menu":{"title":"Menu","close":"Close","switchTitle":"Switch game"},"promo":{"railLabel":"Recommendation","sister":{"eyebrow":"Sister project","brand":"Absolute Pitch Piano","body":"Meet our other project, dedicated to absolute pitch: more ear-training games, a ranking, badges and a community that practices every day.","cta":"Take a look","hide":"Hide"}},"news":{"title":"What's New","updated":"Last updated: {date}","tagFeature":"New","tagImprovement":"Improvement","empty":"Nothing new yet.","error":"Couldn't load the news.","cta":"Try it now"},"legal":{"privacy":{"title":"Privacy"},"terms":{"title":"Terms of use"},"contact":{"title":"Contact","formTitle":"Write to us","guestBody":"To send a message, sign in to your account. The reply goes to your account e-mail.","from":"The reply goes to {email}","label":"Your message","placeholder":"A question, a bug, a suggestion… If it is a bug, say which device and what you were doing.","counter":"{n} / {max}","send":"Send message","sending":"Sending…","sentTitle":"Message sent","sentBody":"A person reads it and replies to {email}. It may take a little while.","another":"Write another","staticCta":"Write through the app","staticNote":"The form is inside the app and asks you to sign in: the reply goes to your account e-mail.","errors":{"too_short":"Write a little more (at least {min} characters).","too_long":"The message is over {max} characters. Please shorten it.","bad_message":"This message could not be read. Please try again.","rate_limited":"You have already sent several messages this hour. Please wait a while before sending another — your text is still here.","csrf":"It could not be sent right now. Please try again — your text is still here."}},"updated":"Updated on {date}","error":"This text could not be loaded right now. It is also published on the site.","readOnSite":"Read it on the site"},"hero":{"eyebrow":"Music education","titlePre":"Learn music by","highlight":"playing","titlePost":"","subtitle":"Rhythm, sheet-music reading, ear training and real music, in smart games with levels and a ranking.","cta":"See the games"},"games":{"sectionTitle":"Available Games","sectionSubtitle":"Choose a game and start training your musical skills","play":"Play","learnMore":"Learn more","rhythm":{"name":"Rhythm","description":"Read the figures on the staff and play in time. Millisecond precision, six worlds of levels, free mode and MIDI keyboard."},"staffReading":{"name":"Staff Reading","description":"Read the notes flowing across the staff before they disappear. Levels by world, a guide line for beginners, bass clef in free practice."},"intervals":{"name":"Intervals","description":"Recognize by ear the distance between two notes, from thirds to octaves, melodic and harmonic. Levels and free mode."},"chords":{"name":"Chords","description":"Identify chords by ear: major and minor triads, sevenths and ninths. Levels and free mode."},"songs":{"name":"Real Music","description":"Play a whole piece by reading the score, on the on-screen piano or a MIDI keyboard. Practice mode waits for you. Or load your own MIDI and plant the chords."},"kids":{"name":"Sheet Music for Kids","description":"Every note has its own color and a guide line points to the right key — for children who don't read music yet."}},"about":{"title":"About the Project","p1":"<strong>Absolute Pitch Class</strong> is a gamified music education platform, created to make learning music accessible and fun for everyone.","p2":"We build with artificial intelligence: it lets us experiment fast and create features with a level of detail and feedback you won't find in most tools.","p3":"We started with rhythm training — the foundation of all music — and today we also have sight-reading, ear training (intervals and chords) and reading real music, including files you load yourself in MIDI. Every game with levels and a free mode, a ranking tied to your account, and groups for schools and classes.","features":{"responsive":"Works on any device","progressive":"Progressive difficulty","progress":"Track your progress","browser":"Right in your browser, no install"}},"footer":{"copyright":"© {year} Absolute Pitch Class. All rights reserved.","madeBy":"· A <a href=\"https://3wimusic.com/\">3wi</a> project"},"rhythm":{"level":{"mapTitle":"Level track","mapOpen":"🗺️ Levels","locked":"locked","n":"Level {n}","next":"Next level →","unlocked":"✅ Level cleared! Next one unlocked.","passedAgain":"🎉 Nailed it again!","allDone":"🏆 You finished the track! Congrats!","tryAgain":"Almost! Score {pass}% on both meters to unlock the next.","tryAgainHold":"Your timing is right! What is missing is the hold: keep the key (or your finger) down until each note ends, instead of tapping quickly.","world1":"World 1 · Pulse","world1Hint":"Quarter, half and whole notes — feel the pulse.","world2":"World 2 · Subdivision","world2Hint":"Eighth notes: two taps per beat.","world3":"World 3 · Dots","world3Hint":"Dotted figures: the dot adds half the value.","world4":"World 4 · Silence","world4Hint":"The sound that's missing and the sound that lasts: rests and ties.","world5":"World 5 · Syncopation","world5Hint":"The accent lands between the beats.","world6":"World 6 · Fine grid","world6Hint":"Sixteenths and thirty-seconds: more divisions inside the same beat.","progress":"Level {id} of {total}","goal":"goal {pass}%","seeResult":"See result"},"title":"Rhythm Game","freeTitle":"Free Rhythm","toFreeMode":"⚙️ Free mode","toRankedMode":"🏆 Back to levels","initError":"Failed to initialize game","audioUnavailable":"Audio system unavailable","back":"Back","menuStatus":"Listen to the rhythm, then play it to test your accuracy.","menuStatusShort":"Listen, then play and test it.","listen":"▶  Listen","grade":"🎯  Test","another":"🔀  Another rhythm","tempo":"Tempo: ","gradeDuration":" Grade note duration","listening":"🔊 Listen carefully…","getReady":"🎯 Get ready! Reproduce the rhythm by tapping.","go":"GO!","liveOnTime":"On time! 🎯","liveEarly":"Early ⏪","liveLate":"Late ⏩","liveTooEarly":"Too early ⏪","liveTooLate":"Too late ⏩","tendencyOk":"Right on time, great! 🎯","tendencyEarly":"You tend to RUSH ~{ms}ms ⏪","tendencyLate":"You tend to DRAG ~{ms}ms ⏩","durationLabel":"Duration: {pct}%","onsetTitle":"Start","durationTitle":"Duration","durationOk":"Right length! 🎯","durationShort":"You HOLD TOO SHORT ~{ms}ms 🤏","durationLong":"You HOLD TOO LONG ~{ms}ms 🫳","howMeasured":"How is this measured?","extraPenalty":"Extra notes −{pct}%","restPenalty":"Tapped on a rest −{pct}%","timingAccuracy":"Timing accuracy: {pct}%","missed":"missed","note":"Note {n}","noteDetail":"Per-note detail","legendOnTime":"on time","legendOff":"off","legendMissing":"missing","legendTarget":"ideal end","retry":"🎯  Try again","backToMenu":"↩  Back to menu","tutorial":{"open":"❓ How to play","prev":"◀ Back","next":"Next ▶","start":"🚀 Start","skip":"Skip","scene":{"oneBeat":"hold 1 beat","halfBeat":"hold half a beat","quarter":"QUARTER","eighth":"EIGHTH","listen":"👂 LISTEN","onsetOk":"START ✓","durOk":"DURATION ✓"},"cards":[{"title":"Your beat","body":"Music starts with a beat: your heart."},{"title":"Beat becomes a note","body":"Each heartbeat becomes a note on the staff."},{"title":"Long or short","body":"Each note has a size: one lasts longer, one lasts less — both are held until they end."},{"title":"Where is when","body":"A note's spot on the staff shows when it plays."},{"title":"First, listen","body":"A line passes each note and plays it for you."},{"title":"Your turn","body":"Tap the button on each note and hold until it ends — the bigger the note, the longer you hold."},{"title":"Let's play!","body":"You've got it: read, listen, and tap in time. Go!"}]},"config":{"open":"⚙️ Settings","title":"Control panel","hint":"Choose which figures can appear in the rhythms.","notes":"Notes","rests":"Rests","ties":"Ties","tiesHint":"Joins two notes into one, adding their beats together. Held note: it carries over the barline. Syncopation: an offbeat is held into the next beat.","beat":"{n} beat","beats":"{n} beats","reset":"Restore defaults","close":"Close","needOneNote":"Keep at least one note checked.","timeSig":"Time signature","measures":"Bars","restLimit":"Rests in a row, at most","tieOff":"No ties","tieSustain":"Held note","tieSyncopation":"Syncopation","tieBoth":"Both","click":"Metronome click","clickHint":"The count-in before you start always clicks every beat. “Listen” already follows the click you chose.","clickAll":"On every beat","clickOne":"Only on beat 1","click24":"On beats 2 and 4","clickNone":"No click","measureRest":"Whole-bar rest","noFit":"Doesn't fit in {sig}","needOneFit":"Keep at least one note that fits in {sig} checked.","autoOn":"Turned on to complete a bar of {sig} · tap to keep it","autoAdded":"Your checked notes can't complete a bar of {sig}: {fig} stays on while it's needed.","drawnAsBarRest":"shown as a whole-bar rest","sustainOneBar":"With 1 bar there is no barline for a held note to cross."},"figures":{"whole":"Whole note","dotted-half":"Dotted half note","half":"Half note","dotted-quarter":"Dotted quarter note","quarter":"Quarter note","dotted-eighth":"Dotted eighth note","eighth":"Eighth note","sixteenth":"Sixteenth note","fusa":"Thirty-second note","whole-rest":"Whole rest","half-rest":"Half rest","quarter-rest":"Quarter rest","dotted-eighth-rest":"Dotted eighth rest","eighth-rest":"Eighth rest","sixteenth-rest":"Sixteenth rest","fusa-rest":"Thirty-second rest"},"tap":{"label":"TAP","hintDesktop":"click or press SPACE","hintMobile":"touch and hold here","hintHold":"hold until the note ends"},"trails":{"title":"Trail","strip":"Trail: {name} · Level {n} of {m}","mapOpen":"See the trail levels","training":"practice, no target","takes":"{done} of {takes} times","takesLeft":"Nice! {n} more to unlock the next level.","trainingDone":"Practice done. The next level is unlocked.","cleared":"done","readOnly":"In this trail the figures and the time signature belong to whoever built it. To change them, “Take to my panel” copies this exercise to your Free Rhythm.","editCopy":"Take to my panel","saveAs":"＋ Use this exercise in a trail","created":"Trail created. Build the levels here.","saved":"Saved.","needAccount":"To save a trail, sign in or create an account.","readOnlyTitle":"Trail exercise","editCopyConfirm":"This replaces YOUR Free Rhythm panel with this level’s exercise and leaves the trail. Continue?","takesLeftLast":"Nice! {n} more to finish.","trainingDoneLast":"Practice done.","allDone":"🏆 You finished the trail!","toCover":"↩ See the trail","whichTrail":"Which trail?","newOne":"New trail (this becomes level 1)","asLevel":"{name} — becomes level {n}","appended":"Saved as level {n} of {name}.","defaultName":"New trail","defaultNameOf":"{name}’s trail","testStrip":"Testing: {name} · Level {n} of {m} · nothing is saved","toWorkshop":"← Back to the workshop","testPassed":"Passed: the goal is {pass}%. Nothing was saved.","testTraining":"Practice level, no goal. Nothing was saved.","editInWorkshop":"Edit in the workshop","sample":"See a sample trail →","noInput":"No taps registered: tap the button in time with the notes. This round doesn’t count.","testFailed":"With this score the student wouldn’t pass (goal {pass}%). Nothing was saved.","blank":"New blank trail →"},"ruler":{"measure":"Bar {n}"},"settings":{"sound":"Note sound","vary":"Melody","pitch":"Notes at their pitch","ruler":"Beat ruler","midi":"MIDI keyboard"},"midi":{"listening":"🎹 {device} connected: play the rhythm on it","nodevice":"🎹 No MIDI keyboard found: plug it in by USB cable (or Bluetooth) and it shows up here on its own.","denied":"🎹 The browser denied MIDI access: allow it in the padlock next to the address, then switch the MIDI keyboard off and on again in ⚙️."},"noInput":"No taps registered","noInputDur":"No taps, no duration"},"staffReading":{"title":"✏️ Free Reading Practice","progress":"Note {current} of {total}  ·  Correct: {correct}","question":"What note is this?","correct":"✅ That's it! It's {note}.","wrong":"❌ It was {note}.","youMarked":"✘ you marked {note}","noteN":"Note {n}","scoreLine":"{correct} of {total} correct","detailTitle":"Note breakdown","playAgain":"🔁  Play again","backToMenu":"↩  Back to menu","answerWith":"Answer with: ","modeButtons":"🔢 Buttons","modePiano":"🎹 Piano","modeMic":"🎙️ Microphone","modeMidi":"🎹 MIDI","hearNote":"🔊  Hear the note","config":{"open":"⚙️ Options","title":"Options","guideTitle":"Guide line","guideAlways":"Always","guideError":"Only on mistakes","guideOff":"Off","clefTitle":"Clef","clefTreble":"Treble","clefBass":"Bass","clefBoth":"Both","realPiano":"Real piano","reset":"Reset to default","close":"Close","keyTitle":"Key","keyAtLeastOne":"Keep at least one key selected"},"tutorial":{"open":"❓ How to play","prev":"◀ Back","next":"Next ▶","start":"🚀 Start","skip":"Skip","cards":[{"title":"Low and high","body":"On the piano, the left is low and the right is high. The further right, the higher the sound."},{"title":"The staff","body":"The staff is a ladder of sounds: the higher the note sits, the higher it sounds — like moving right on the piano."},{"title":"Line or space","body":"Each note sits on a line (yellow band) or in a space (blue band). One step is always the neighbouring key."},{"title":"The treble clef","body":"The treble clef curls around the 2nd line and marks where G lives. That is your starting point."},{"title":"G and its neighbours","body":"Find G and you find them all: each step up or down is the next note, skipping no names."},{"title":"One round","body":"A note appears and you name it (or play the key). Just count from G."},{"title":"Let's play!","body":"You can read now: find G and count the neighbours. Let's play!"}]},"toFlow":"🏃 Reading flow"},"readingFlow":{"title":"🎼 Staff Reading","subtitle":"Notes scroll in from the right. Name the highlighted note before it slides off the left.","start":"▶ Start","prompt":"Name the highlighted note","score":"Score","combo":"Streak","best":"Best","progress":"Progress","accuracy":"accuracy","playAgain":"🔁  Play again","backToMenu":"↩  Back to menu","results":{"title":"Round over","scoreLine":"{hits} of {total} correct","maxCombo":"Best streak","newBest":"🎉 New best!","starRecord":"🌟 New star record!","levelStars":"Level stars","unlocked":"🔓 Next level unlocked!"},"level":"Level","notesWord":"notes","locked":"Locked — clear the previous level","worldLabel":"World {n}","worlds":{"1":"On the staff","2":"The whole staff"},"input":"Answer with","inputButtons":"Buttons","inputPiano":"Piano","inputMic":"🎙️ Microphone","inputMidi":"🎹 MIDI","kids":"Kids","realPiano":"Sound: real piano","loadingPiano":"Loading","stop":"Stop","nextLevel":"➡ Next level","toFreeMode":"✏️ Free practice (1 note)","kidsLearned":"You learned {note}! 🎉","kidsGraduated":"You're answering without the colors! 🎓","kidsColorHint":"Every note has its own color on the staff. As you learn, the color leaves the buttons.","kidsAllLearned":"You already answer without colors at this level! 🎉 Level up for new notes.","kidsReset":"🔄 Reset colors","kidsResetConfirm":"Bring the colors back to the buttons? This erases your note-learning progress.","wasNote":"It was {note}!","buttonsLocked":"From level 2 on you answer on the piano: reading a note means finding its key.","octaveUp":"Right name! It was the {note} above.","octaveDown":"Right name! It was the {note} below.","teach":{"got":"Got it","octave":{"title":"🎹 Same name, different pitch","text":"From this level on the same note shows up at two pitches. Same name, higher up — and a different key."},"ledgerLow":{"title":"🎼 The staff keeps going below","text":"When a note drops too low, it gets a little line of its own. This first one, just under the staff, is middle C."},"ledgerHigh":{"title":"🎼 And it keeps going above","text":"The other end works the same way: one more little line above the staff, and that one is the high A."}},"stopConfirm":"Really stop?","unlockGoal":"Score {acc}% to unlock level {level}","masteryTitle":"Note album"},"notes":{"C":"C","D":"D","E":"E","F":"F","G":"G","A":"A","B":"B"},"micInput":{"activateHint":"Answer by playing your real piano","activate":"🎙️ Enable microphone","requesting":"Waiting for permission…","listening":"Listening… play the note on your instrument","denied":"Microphone access denied","deniedHelp":"Allow the microphone in your browser settings, or answer with the buttons.","unsupported":"Microphone unavailable in this environment","unsupportedHelp":"The browser requires a secure connection (HTTPS) to use the microphone.","error":"Could not access the microphone","useButtons":"Use buttons"},"midiInput":{"activateHint":"Answer by playing your MIDI keyboard","activate":"🎹 Connect MIDI keyboard","requesting":"Waiting for permission…","listening":"Connected… play the note on your keyboard","nodevice":"No MIDI instrument found","nodeviceHelp":"Connect your keyboard via USB (or Bluetooth) — it shows up here on its own.","denied":"MIDI access denied","deniedHelp":"Allow MIDI access in your browser settings, or answer with the buttons.","unsupported":"MIDI unavailable in this browser","unsupportedHelp":"This browser has no Web MIDI. Try Chrome or Edge on a computer.","error":"Could not access MIDI","useButtons":"Use buttons"},"intervals":{"title":"🎵 Intervals","progress":"Interval {current} of {total}  ·  Correct: {correct}","mode":"Mode: ","modeIdentify":"🎧 Listen and identify","modeBuild":"🎹 Build on the piano","identifyPrompt":"🎧 Listen to the interval. Which interval is it?","buildPrompt":"🎹 Play the {interval} above {root}.","buildPromptDown":"🎹 Play the {interval} below {root}.","progressEndless":"Interval {current}  ·  Correct: {correct}","freeTitle":"🎵 Intervals — Free practice","freeSubtitle":"Build your drill: pick the intervals and options.","toFreeMode":"⚙️ Free mode","toRankedMode":"🏆 Levels","settings":"⚙️ Settings","pickIntervals":"Pick the intervals:","playLabel":"Play:","melodic":"Melodic","harmonicMode":"Harmonic","dir":"Direction:","dirUp":"↑ Up","dirDown":"↓ Down","dirBoth":"↕ Both","length":"Length:","endless":"∞ Endless","stop":"Stop","correct":"✅ That's it! {interval}.","wrong":"❌ It was {interval}.","repeat":"🔊  Replay","hearBase":"🔊  Hear the root","buildHint":"Play the right key on the piano above. ","youPlayed":"✘ you played {note}","youMarked":"✘ you marked {interval}","base":"(root {root})","scoreLine":"{correct} of {total} correct","detailTitle":"Breakdown","playAgain":"🔁  Play again","backToMenu":"↩  Back to menu","start":"▶ Start","subtitle":"Pick a level and train your ear.","hearExample":"🔊 Hear an example","exampleIs":"This is how it sounds: {interval}","level":"Level","locked":"locked","assist":"Show keys:","assistOn":"Yes","assistOff":"No","harmonicTag":"harmonic","unlocked":"✅ New level unlocked!","nextLevel":"Next level →","chooseLevel":"🎚️ Choose level","names":{"P1":"Unison","m2":"Minor second","M2":"Major second","m3":"Minor third","M3":"Major third","P4":"Perfect fourth","TT":"Tritone","P5":"Perfect fifth","m6":"Minor sixth","M6":"Major sixth","m7":"Minor seventh","M7":"Major seventh","P8":"Perfect octave"},"needPass":"You need {pass}% to unlock the next level.","goal":"Goal: {pass}%","stopConfirm":"Stop for real?"},"chords":{"title":"🎸 Chords","progress":"Chord {current} of {total}  ·  Correct: {correct}","identifyPrompt":"🎧 Listen to the chord. Which chord is it?","correct":"✅ That's it! {chord}.","wrong":"❌ It was {chord}.","repeat":"🔊  Replay","youMarked":"✘ you marked {chord}","base":"(root {root})","scoreLine":"{correct} of {total} correct","detailTitle":"Breakdown","playAgain":"🔁  Play again","backToMenu":"↩  Back to menu","start":"▶ Start","subtitle":"Pick a level and train your ear.","hearExample":"🔊 Hear an example","exampleIs":"This is how it sounds: {chord}","level":"Level","locked":"locked","assist":"Show keys:","assistOn":"Yes","assistOff":"No","style":"Play:","styleBlock":"Block","styleArpeggio":"Arpeggio","unlocked":"✅ New level unlocked!","nextLevel":"Next level →","chooseLevel":"🎚️ Choose level","freeTitle":"🎸 Chords — Free practice","freeSubtitle":"Build your drill: pick the chords and options.","progressEndless":"Chord {current}  ·  Correct: {correct}","pickChords":"Pick the chords:","arpDir":"Arpeggio:","dirUp":"↑ Up","dirDown":"↓ Down","dirBoth":"↕ Both","length":"Length:","endless":"∞ Endless","stop":"Stop","settings":"⚙️ Settings","toFreeMode":"⚙️ Free mode","toRankedMode":"🏆 Levels","names":{"7":"Dominant 7","9":"Dominant 9","11":"Dominant 11","13":"Dominant 13","maj":"Major","min":"Minor","dim":"Diminished","aug":"Augmented","sus2":"Sus2","sus4":"Sus4","maj7":"Major 7","min7":"Minor 7","m7b5":"Half-dim. (ø)","dim7":"Dim. 7 (°7)","maj9":"Major 9","min9":"Minor 9"},"needPass":"You need {pass}% to unlock the next level.","goal":"Goal: {pass}%","stopConfirm":"Stop for real?"},"common":{"close":"Close","cancel":"Cancel"},"auth":{"signInTitle":"Sign in","signUpTitle":"Create account","forgotTitle":"Reset password","resetTitle":"Set a new password","google":"Continue with Google","or":"or","emailButton":"Sign up with email","backToChoice":"Back","nameLabel":"Name","namePlaceholder":"What should we call you","emailLabel":"Email","emailPlaceholder":"you@example.com","passwordLabel":"Password","passwordPlaceholder":"At least {min} characters","signInSubmit":"Sign in","signUpSubmit":"Create account","forgotSubmit":"Send instructions","resetSubmit":"Save new password","forgotIntro":"We'll email you a link to reset your password.","resetIntro":"Choose a new password for your account.","newPasswordLabel":"New password","newPasswordPlaceholder":"At least {min} characters","toSignUp":"No account? Create one","toSignIn":"Have an account? Sign in","toForgot":"Forgot password","backToSignIn":"Back to sign in","loading":"Please wait…","signInCta":"Sign in","accountTitle":"Account","signOut":"Sign out","deleteAccount":"Delete account","resendVerification":"Confirm email (resend link)","deleteConfirm":"Delete your account and all progress? This can't be undone.","guest":"Guest","gate":{"rewardTitle":"You're doing great! 🎉","rewardSubtitle":"Create your account to keep going and save your progress.","contextLine":"You've cleared the first {free} levels — level {level} is waiting.","lockedHint":"Create your account to play this level"},"linked":{"title":"Your account now signs in with Google","body":"This email already had a password account, but it had never been confirmed. For safety, the old password was disabled — your progress is intact, on the same account. From now on, sign in with Google. If you would rather use a password again, set a new one.","setPassword":"Set a new password","resetSent":"We sent the link to set your new password to your email.","ok":"Got it"},"toasts":{"welcome":"Welcome, {name}!","accountCreated":"Account created! Check your email to confirm.","resetSent":"If the email exists, we've sent instructions.","emailVerified":"Email verified! Your account is confirmed.","verifySent":"Confirmation link resent. Check your inbox.","verifyRate":"Too many attempts for now. Open the link again in a few minutes.","verifyFailed":"Verification link is invalid or expired.","passwordReset":"Password reset! Sign in with your new password.","signedOut":"You've signed out.","sessionExpired":"Your session expired. Please sign in again.","progressRestored":"Your account's progress was restored on this device.","progressLinked":"Your progress was linked to your account.","accountDeleted":"Your account was deleted."},"errors":{"generic":"Something went wrong. Try again.","network":"No connection to the server. Try again later.","invalid_email":"Invalid email.","short_password":"Password must be at least {min} characters.","long_password":"That password is too long. Please use a shorter one.","empty_password":"Enter your password.","reset_invalid":"Reset link is invalid or expired. Request a new one.","email_taken":"This email already has an account. Try signing in.","invalid_credentials":"Wrong email or password.","no_account":"We couldn't find an account with that email.","rate_limited":"Too many attempts. Please wait a moment.","disposable_email":"Use a permanent email.","social_account":"This account signs in with Google and has no password. Use the Google button or set a new password.","social_account_noprov":"This account signs in with Google and has no password. To sign in by email, set a new password.","session_expired":"Your session expired. Please sign in again.","csrf":"Security session expired. Reload the page.","spam":"Couldn't process. Reload and try again.","oauth_cancelled":"Sign-in canceled.","oauth_invalid_state":"Your sign-in session expired. Please try again.","oauth_account_exists":"An account with this email already exists. Sign in with email and password.","oauth_failed":"Couldn't sign in with the provider. Please try again.","actions":{"createAccount":"Create account","signIn":"Sign in","googleSignIn":"Sign in with Google","setPassword":"Set a new password"},"empty_name":"Pick a name — it shows on the leaderboard.","bad_name":"That name could not be read. Use letters and numbers.","not_logged":"Sign in to your account to do that.","bad_code":"Code not found. Check it with whoever runs the group.","already_in_group":"You are already in a group. Leave it to join another one.","forbidden":"You don't have permission for that.","empty_group_name":"Give the group a name.","group_taken":"A group with that name already exists.","no_group":"You are not in any group.","pending_exists":"You already have a group request under review.","owner_exists":"You already run a group.","name_locked":"The name cannot change after the group is approved.","logo_missing":"Choose an image.","logo_too_big":"The image is over 2 MB.","logo_bad_image":"The file is not a PNG, JPG, GIF or WebP image.","logo_too_large_dims":"The image is too large (up to 4000×4000).","logo_encode_failed":"Could not process the image. Try another one.","bad_decision":"Invalid decision.","bad_status":"This request has already been decided.","bad_group":"Invalid group.","bad_country":"Invalid country.","no_list":"Trail not found.","lists_max":"You reached the maximum number of trails per account.","empty_list_name":"Give the trail a name.","bad_levels":"The trail levels were invalid.","bad_lid":"The trail levels were invalid.","too_many_levels":"The trail exceeds the maximum number of levels.","levels_too_big":"The trail is too large.","bad_visibility":"Invalid visibility."},"prefs":{"diary":"Game diary","on":"Recording","off":"Off","help":"Keeps what you play — level, time and accuracy — for your own statistics. Turning it off stops the recording and deletes the queue that had not been sent from this device; what is already in your account stays. Your best result on each level keeps going up and into the ranking.","anon":"The site visit count, described in Privacy, does not depend on this.","saveError":"Could not confirm it was saved. Reload the app to see how it stands."}},"pages":{"ritmo":{"linkLabel":"Rhythm Game"},"leitura":{"linkLabel":"Sight Reading"},"kids":{"linkLabel":"Sheet Music for Kids"},"intervalos":{"linkLabel":"Intervals"},"acordes":{"linkLabel":"Chords"},"musicas":{"linkLabel":"Real Music"},"ritmoGuia":{"linkLabel":"What is rhythm"},"leituraGuia":{"linkLabel":"How to read sheet music"},"intervalosGuia":{"linkLabel":"What are musical intervals"},"acordesGuia":{"linkLabel":"What are chords in music"},"escolas":{"linkLabel":"For music schools and teachers"},"toolVocal":{"linkLabel":"Vocal range test"},"midi":{"linkLabel":"Your song with chords"}},"ranking":{"title":"Ranking","subtitle":"Who has gone furthest along the path","gameLabel":"Game","tabOverall":"Overall","tabLevel":"By level","levelLabel":"Level","levelOption":"{n}","loginPrompt":"Sign in to appear in the ranking.","loginCta":"Sign in","loading":"Loading…","error":"Could not load the ranking.","empty":"No one on the ranking yet. Play a level to be the first.","notInLevel":"You have no record on level {n} yet. Play this level while signed in to show up here.","colPlayer":"Player","colLevel":"Level","colAccuracy":"Accuracy","colPlays":"Plays","reached":"Level {n}","you":"You","guestPlayer":"Unnamed","scopeLabel":"View ranking by","colPosition":"Position","emptyCta":"Play {game}","youAreHidden":"You are not on this list because you turned off “Appear on the Ranking”.","schoolLink":"{group}: see the group page","youAreHiddenCta":"Turn it on in My account","whoLabel":"Show the ranking of","whoAll":"Everyone","groupEmpty":"Nobody from {group} on the {game} ranking yet. Play a level to be the first.","ownerNote":"You run this group and do not appear on the list.","showing":"{from}–{to} of {total}","pageNav":"Ranking pages","prev":"Previous page","next":"Next page","pageN":"Page {n}","pageOf":"page {n} of {total}","goToMine":"Go to my page"},"stats":{"title":"My progress","subtitle":"What your account keeps from every practice","error":"Could not load your progress.","retry":"Try again","emptyTitle":"Nothing here yet.","emptyBody":"Play a round while signed in and come back: your days, time and progress show up here.","emptyBodyOff":"With the game diary off, only your best level in each game will show up here. Turn recording on and play a round to see days, time and progress.","emptyCta":"Play {game}","tileDays":"Practice days","tileStreak":"Streak (days)","tileStreakSub":"best: {n}","tileTime":"Practice time","tileRounds":"Rounds","tileRoundsSub":"{n} abandoned","since":"since {date}","timeHours":"{h}h {m}min","timeMinutes":"{m} min","diaryOff":"Your game diary is off, so days, time, rounds and progress are not being recorded. Your best level in each game is still shown below.","diaryOffCta":"Turn recording on","beforeDiary":"Rounds played before the diary existed don't show up here — only the highest level of each game.","chartTitle":"Progress","chartCaption":"Average accuracy per day · {game}","chartEmpty":"No rounds in the last {n} days.","chartAvg":"average {p}%","chartAria":"{game}: rounds on {days} of the last {n} days, average accuracy {p}%.","windowGroup":"Period","windowLabel":"{n} days","gameLabel":"Game","roundsOne":"1 round","roundsMany":"{n} rounds","stripTitle":"Last 4 weeks","stripToday":"today","stripNone":"no rounds","tableTitle":"By game","colGame":"Game","colLevel":"Level","colAccuracy":"Accuracy","colRounds":"Rounds","colAbandons":"Abandoned","colTime":"Time","previewIntro":"This is how your progress looks once you have an account. The chart and cards below are an example with {game}.","previewStamp":"Example","previewCta":"Create an account to keep this","previewAria":"Example: accuracy in {game} rising from {from}% to {to}% over {n} days.","previewOutro":"With an account, every round lands on this screen — and your progress follows you to any device.","previewDeviceTitle":"On this device","previewDeviceNote":"This part is real: the highest level and the best accuracy this browser has kept. Without an account it is gone if you switch devices or clear the browser."},"profile":{"title":"My account","subtitle":"Your details and the settings for this account.","guestTitle":"You are not signed in yet","guestBody":"An account keeps your progress and carries it from one device to another. Sign in to see and adjust your details here.","guestSignUp":"Create account","guestSignIn":"Sign in","loadError":"We could not load your details right now.","retry":"Try again","noName":"(no name)","nameLabel":"Name","namePublic":"This is the name shown on the leaderboard.","edit":"Edit","save":"Save","nameSaved":"Name updated.","verified":"E-mail confirmed","unverified":"E-mail not confirmed","roleAdmin":"Administrator","memberSince":"Account created on {date}.","avatarNote":"The photo comes from your Google account. Without Google, your avatar is your initials — there is no photo upload here.","accessTitle":"How you sign in","accessPassword":"E-mail and password","accessGoogle":"Google","accessNone":"No sign-in method on record.","noPasswordNote":"This account has no password: you sign in with Google. To sign in by e-mail as well, create a password — the link arrives in your inbox.","setPassword":"Create a password","languageLabel":"Language","languageNote":"The language follows the site address: each language has its own. Switching here takes you to that language's address, with the same account.","language":{"pt":"Portuguese","en":"English","es":"Spanish"},"prefsTitle":"Settings","ranking":{"label":"Appear on the Ranking","on":"Name and photo visible","off":"Not on the public list","help":"The Ranking is a public page: with this on, your name and your photo appear there for anyone, next to your level and accuracy.","scope":"Turning it off takes you off the list and deletes nothing — your progress and your results stay yours."},"accountTitle":"Account","reset":{"title":"Reset progress","sub":"{n} results saved","subEmpty":"No results saved","body":"This deletes your best results and unlocked levels, on this device and in your account — the path goes back to the start and your row leaves the leaderboard. Your training history in “My progress” stays, and so do your synced songs. There is no undo.","count":"{n} results will be deleted.","confirm":"Reset progress","done":"Progress reset."},"group":{"title":"Group","intro":"Part of a school or class? Enter the code the organizer gave you.","codeLabel":"Group code","codePlaceholder":"ABCD2345","join":"Join the group","members":"{n} people","membersOne":"1 person","viewPage":"See the group page","note":"The group ranking is public, and the organizer follows your progress in the games.","leave":"Leave the group","leaveSub":"Nothing is deleted — only your row leaves the group list","leaveTitle":"Leave the group","leaveBody":"Leave {name}? Your row leaves the group ranking. Nothing is deleted — your progress and your results stay yours. You can join again with the code.","leaveConfirm":"Leave the group","left":"You left the group.","joined":"You joined {name}.","existing":"Groups already here:","admin":{"title":"Groups (admin)","intro":"Requests from people who run a school arrive in the queue above. Here you create a group directly, with no request: the code is the invitation, hand it to whoever runs the group. Creating a group does not put you in it.","nameLabel":"Group name","create":"Create group","created":"Group “{name}” created. Code: {code}","code":"code","none":"No group created yet."},"requestIntro":"Do you run a school or class? Ask for a group: you get a code for your students and follow their progress.","requestCta":"Request a group","owner":{"pending":"Under review","pendingBody":"The administration reviews the request and you get an email. The invitation code shows up here once the group is approved.","rejected":"Not approved","rejectedBody":"This request was not approved. If you like, ask again: the form comes filled with the previous request.","paused":"Paused","pausedBody":"The group is paused by the administration: nobody can join and the page is not shown.","live":"Approved","decisionNote":"Note from the administration:","code":"Invitation code","link":"Invitation link","copy":"Copy","copied":"Copied!","share":"Hand the code or the link to whoever should join. Each person joins with their own account and appears, with name and results, on the ranking on the group page — which is public. You see that ranking without being in it.","edit":"Edit the request","editLive":"Edit the page","noTranslation":"The description has not been translated yet: the page shows the original text in all three languages.","translating":"Translating the description…","copyFailed":"Could not copy here: the text is selected, copy it with the keyboard."},"adminQueue":{"title":"Group requests","none":"No pending requests.","by":"requested by {email}","approve":"Approve","reject":"Decline","noteLabel":"Note to the person (optional, goes in the email)","statusPending":"under review","statusRejected":"declined","statusPaused":"paused","viewPreview":"See the page","decided":"Decided: {name} — {status}.","noDescription":"(no description)","note":"Note:","statusLive":"approved","previous":"Declined before, with the note:","resume":"Resume (make it visible again)","rejectTitle":"Decline the request?","rejectBody":"Decline “{name}”? The person gets an email and the request closes; they can ask again."},"joinOther":"Join another group with a code","alsoMember":"You are also a member of {name}."},"trails":{"title":"My trails","intro":"A trail is a sequence of Rhythm exercises, your way. Build the levels, share the link and follow the class.","none":"No trails yet.","create":"＋ New trail","edit":"Edit","open":"Open","copyLink":"Copy link"}},"songs":{"happyBirthday":{"title":"Happy Birthday"},"twinkle":{"title":"Twinkle, Twinkle, Little Star"},"odeToJoy":{"title":"Ode to Joy"},"jingleBells":{"title":"Jingle Bells"}},"song":{"title":"Real Music","subtitle":"Read the score as it scrolls by and play the piece on your instrument.","start":"Play","listen":"Hear the piece","listening":"Listening…","stop":"Stop","prompt":"Play each note as it crosses the line.","promptStudy":"The score is waiting for you. Play the highlighted note.","mode":"Mode","modeStudy":"Practice","modeTempo":"In time","modeStudyHint":"In practice mode the score stops at every note and waits for you to play the right one. Nothing is scored — it is for learning the piece.","modeTempoHint":"In time mode the score scrolls steadily, with a metronome, and your playing is measured: the right notes and the accuracy of each attack.","tempoLabel":"Tempo","densityLabel":"Spacing","density":{"tight":"Tight","medium":"Medium","loose":"Wide"},"input":"Answer with","inputPiano":"Piano","inputMic":"Microphone","inputMidi":"MIDI keyboard","micNoRhythm":"On the microphone only the notes are measured: pitch detection lands after the attack, so timing it would be inventing precision.","measure":"Measure","hits":"Notes","wasNote":"It was {note}!","results":{"notes":"Notes","notesHint":"{hits} of {total} pitches right","rhythm":"Timing","rhythmNotMeasured":"not measured on the microphone","missed":"Notes missed","extras":"Extra notes","onTime":"on time","rushing":"rushing by {ms} ms","dragging":"dragging by {ms} ms","starRecord":"New star record!","again":"Play again","toStudy":"Go to practice","toTempo":"Now in time","studyDone":"Whole piece!","studyLine":"{notes} notes · {wrong} wrong attempts","studyNext":"Once the piece is under your fingers, switch to time mode — there the score scrolls on its own and your timing is measured.","noStar":"No stars: a star needs measured timing, and the microphone cannot measure the instant of the attack. Play on the on-screen piano or a MIDI keyboard to earn one.","freeNoRecord":"This is your own music: the star counts for this session. Records only exist for the songs in the catalogue.","pick":"Choose another song"},"skipNote":"Skip this note","interrupted":"The run was interrupted because the page went to the background. Nothing was scored — start again when you can follow along.","import":{"title":"Your own music","lead":"Load a MIDI file (.mid) and read that music on the staff. The file never leaves your device.","choose":"Choose a .mid file","demo":"Use the example","drop":"Drop the .mid file here","reading":"Reading the file…","privacy":"Everything happens here in your browser: the file is never uploaded to any server.","privacyAccount":"Reading happens here in your browser. With your account, the file is also kept in it — that is how it shows up on your other device.","track":"Track","trackN":"Track {n}","notesWord":"notes","drums":"drums","summary":"{notes} notes · {measures} bars · {ts} · {key} · {clef} clef","clef":{"treble":"treble","bass":"bass"},"errTitle":"This file could not be turned into a score","warn":{"polyphonyReduced":"This track has more than one voice: you will study the top one (the melody). {dropped} notes were left out.","mergedNotes":"Identical simultaneous notes were merged into one.","keyInferred":"The file does not state the key — we picked the one needing the fewest accidentals.","tempoChanges":"The file changes tempo {count} time(s); here you read at a single tempo, the one you set.","timeChanges":"The file changes time signature {count} time(s); the score uses the first one throughout.","drums":"This is a drum track: the sounds have no definite pitch to read on the staff.","drumsFiltered":"This track had drums mixed in with the melody: the {dropped} drum notes were left out (they have no pitch to read on the staff).","snapped":"{count} note(s) did not fall exactly on the grid and were snapped to the nearest note value."},"err":{"notMidi":"This is not a MIDI file (.mid). A PDF or MP3 will not work yet — we need the MIDI.","format2":"This is a type 2 MIDI (independent patterns), which is not one continuous piece. Export it as type 0 or 1.","smpte":"This MIDI counts time in video frames, not musical beats — a score cannot be written from it.","badPpq":"The header of this MIDI is corrupted (invalid time division).","tooBig":"File too large ({kb} KB). The limit is {max} KB — a score MIDI is usually a few KB.","noTracks":"This MIDI has no track with music in it.","noSuchTrack":"That track does not exist in the file.","emptyTrack":"The chosen track has no notes. Try another track.","offGrid":"{percent}% of the notes do not fit any note value: this file looks like a live recording, not a score. A MIDI exported from notation software works.","tuplets":"This music has tuplets (triplets), which we cannot write yet. We are working on it.","tooManyNotes":"Too long for v1: {notes} notes (the limit is {max}).","tooManyMeasures":"Too long for v1: {measures} bars (the limit is {max}).","internal":"We could not build a score from this file.","readFailed":"The file could not be read. Try choosing it again.","unknown":"This MIDI file could not be read.","badTimeSignature":"The time signature in this file ({beats}/{value}) is not valid.","demoFailed":"We could not load the example right now. If you are offline, choose a file from your device."},"back":"{file}","tap":"Tap to choose the .mid file"},"listenPartial":"The audio example runs to bar {measure} — the piece is too long to play in full.","harmony":{"open":"Chords","title":"Chord symbols","lead":"Pick a bar and plant the chord. The symbols scroll along with the melody while you play.","grid":"Grid","grid_measure":"Bar","grid_half":"Half","grid_beat":"Beat","pickup":"pickup","at":"Bar {measure} · {chord}","repeat":"Repeat","delete":"Delete","clearAll":"Clear all","clearAllAsk":"Delete all {n} chords in this song?","confirmClear":"Delete all","done":"Done","count":"{n} chords in this song","dropped":"{n} chords fell outside this track and were dropped.","summary":"{n} chords planted","count_one":"1 chord in this song","summary_one":"1 chord planted","dropped_one":"1 chord fell outside this track and was dropped.","tooMany":"This song went past {max} chords — the extra ones were not saved.","notSaved":"Couldn't save the chords on this device (browser storage is full). They will last only for this session."},"modePlay":"Play along","modePlayHint":"In play-along mode the score scrolls in time, with a metronome, and nothing is measured: it is for playing the song — melody, chords or both — your way.","playing":"Play freely. Nothing is being measured.","playDone":"End of the piece.","shelf":{"addFile":"Import a .mid file","empty":"Nothing saved yet. Import a .mid file and it stays here.","untitled":"untitled","noChords":"no chords","remove":"Delete","removeAsk":"Delete “{name}” from this device?","removeAskChords":"Delete “{name}” from this device? The {n} chords stay saved: import the same file again and they come back.","removeAskChords_one":"Delete “{name}” from this device? The chord stays saved: import the same file again and it comes back.","full":"You already have {max} songs — this device's limit. You can play this one now, but to save it delete one from the list.","fullBytes":"This device is out of room for songs. You can play this one now, but to save it delete one from the list.","gone":"This song is no longer saved on this device.","kb":"{n} KB","mb":"{n} MB","chords":"{n} chords","chords_one":"1 chord"},"cloud":{"title":"Your songs in your account","status":"{n} of {max} songs in your account","notSynced":"Not synced on this device yet.","tooNew":"{n} could not be read (made by a newer version of the app)","tooNew_one":"1 could not be read (made by a newer version of the app)","inAccount":"In your account:","forget":"Remove from account","forgetAsk":"Remove “{name}” from your account? It stays on this device, chords and all.","syncNow":"Sync now","syncing":"Syncing…","guest":"Sign in so your songs and chords show up on any device.","login":"Sign in","note":"Your songs and your chords are kept in your account. On the other device, sign in and tap Sync: they come down on their own.","sent":"{n} songs sent","sent_one":"1 song sent","got":"{n} new chords","got_one":"1 new chord","full":"{n} did not fit in your account ({max} fit)","full_one":"1 did not fit in your account ({max} fit)","gotFiles":"{n} songs downloaded to this device","gotFiles_one":"1 song downloaded to this device","noRoom":"{n} did not fit on this device","noRoom_one":"1 did not fit on this device","fileErr":"{n} files did not come through — tap Sync again","fileErr_one":"1 file did not come through — tap Sync again","nothing":"Everything was already in sync.","err":"Could not reach your account right now. Your songs are still saved on this device."},"backup":{"export":"Download a copy (.json)","share":"Send a copy","import":"Restore from a file","note":"The backup is a .json file that stays with you: take it to another device and import it here. Importing ADDS songs and chords — it never erases what is already saved.","empty":"Nothing to export yet.","noRoom":"{n} did not fit on the shelf (their chords were saved)","fixed":"{n} ids recomputed from the file","skipped":"{n} items rejected","added":"{n} new songs","added_one":"1 new song","updated":"{n} updated","updated_one":"1 updated","chords":"{n} new chords","chords_one":"1 new chord","noShelf":"{n} songs could not be saved in this browser (their chords were saved)","noShelf_one":"1 song could not be saved in this browser (its chords were saved)","noRoom_one":"1 did not fit on the shelf (its chords were saved)","fixed_one":"1 id recomputed from the file","rejected":"{n} chords in the backup were rejected as corrupted","rejected_one":"1 chord in the backup was rejected as corrupted","skipped_one":"1 item rejected","nothing":"Nothing new: this backup was already all here.","err":{"empty":"The file is empty.","notJson":"This file is not valid .json.","notOurs":"This .json is not an Absolute Pitch Class repertoire.","newerVersion":"This backup was made by a newer version of the app (format {version}). Update the app and try again.","tooBig":"The file is over {mb} MB.","badSong":"No song could be read from this backup.","songTooBig":"“{name}” is too large and was rejected.","badVersion":"This file does not say which format it was made in — it cannot be trusted."}},"pick":{"title":"Choose a song","lead":"Your songs and the app's. Tap one to open it.","open":"Choose a song","mine":"Your songs","app":"From the app","current":"currently open"}},"music":{"major":"major","minor":"minor"},"help":{"dotAria":"Help: {subject}","prev":"Previous","next":"Next","gotIt":"Got it","tabs":{"explain":"Explanation","video":"Video","faq":"Questions"},"flow":{"howto":{"title":"How the note conveyor works","p1":{"title":"The notes move on their own, from right to left","body":"The brightest note — the one with the dotted circle around it — is your turn: that is the one you have to name. The others are just in line, waiting."},"p2":{"title":"The red band is the deadline","body":"If the note reaches the dotted red band with no answer, it disappears and counts as a miss. No need to rush: in the first levels the conveyor moves slowly on purpose."}},"input":{"title":"How to answer: button, piano or your own instrument","p1":{"title":"Four ways to say which note it is","body":"Buttons show the note name written out. Piano asks for the right key. Microphone listens to your acoustic piano through the device, and MIDI takes the keyboard plugged into your computer — those two only show up when the device supports them."},"p2":{"title":"Why the buttons lock","body":"From level 2 on, the answer is the key, not the name: that is what connects the staff to the instrument. The buttons stay on the list, with a padlock, so you can see they did not disappear."}},"kids":{"title":"Kids mode","p1":{"title":"Every note gets a color","body":"In Kids mode each note has its own color on the staff, and the same color shows up on the button and on the key. The child finds it by color before knowing the name — and the conveyor moves more slowly, with more room between notes."},"p2":{"title":"The color leaves on its own, once it is earned","body":"After a few answers in a row, that note's color disappears from the button; on the staff it stays. The panel at the bottom of the screen shows which notes you can already answer without the color. Nobody has to switch anything off: the crutch dissolves by itself."}},"exitLine":{"title":"The dotted red band","p1":{"title":"It is that note's deadline, not the end of the game","body":"Each note has until it reaches the red band to be named. If it gets there with no answer, it disappears and counts as a miss — but the conveyor keeps going, and the next one is already on its way. Missing one does not spoil the round."},"q1":{"q":"The note vanished and I did not even see it. What happened?","a":"It went past the red band. In the first levels this barely happens, because the conveyor is slow; in the higher levels it speeds up on purpose. If it feels too fast, drop back a level — the note's name has to come without thinking before the speed makes any sense."}}},"intervals":{"howto":{"title":"What an interval is","p1":{"title":"It is the distance between two notes","body":"The game plays two notes — one after the other, or both together. The distance between them is what musicians call an interval: neighboring notes sound almost the same, notes far apart make a leap you hear right away."},"p2":{"title":"It is ear training, not eye training","body":"You do not need to see anything to answer; the piano on screen only shows afterwards which two notes they were. If you cannot recall the sound, press Replay as many times as you like — it costs no points. Level 1 has only two possible answers."}},"assist":{"title":"“Show keys”: what it changes","p1":{"title":"It is the visual hint, and it is optional","body":"With “Show keys” on Yes, the piano on screen lights up the notes while the sound plays: you can check with your eyes what your ear heard. It starts off — tap Yes to turn it on. On No you answer by ear alone, which is the point of the training. Turning it on or off changes neither the level nor the score: start on Yes and switch it off once the sound is recognizable."}},"mode":{"title":"Listen and identify × Build on the piano","p1":{"title":"Two ways of answering the same question","body":"In “Listen and identify” the game plays the interval and you pick its name. In “Build on the piano” the game gives you the first note and the name of the interval, and you play the second one on the keyboard. The first trains recognizing; the second trains producing — and the second is the one you will use when you are playing."}},"play":{"title":"Melodic × Harmonic","p1":{"title":"The two notes in a row, or both at once","body":"In Melodic the notes come one after the other, like a melody — you can follow the path from one to the other. In Harmonic they sound together, and then you hear the chord they make rather than the journey. Harmonic is a good deal harder: it is the same interval, but your ear has to pull apart two stacked sounds."}}},"chords":{"howto":{"title":"What a chord is","p1":{"title":"It is three or more notes sounding together","body":"A note on its own is a note. Three pressed at the same time make a chord — it is the sound of a guitar when you strum all the strings at once."},"p2":{"title":"A shortcut to get started","body":"Major sounds happy, minor sounds sad. That alone settles the whole of level 1, which has only those two answers. It is ear training: if you are not sure, press Replay — the app plays it again, at no cost."}},"play":{"title":"“Block” × “Arpeggio”","p1":{"title":"The same notes, played in two different ways","body":"In Block the notes all sound at the same instant, like a strummed guitar: the whole chord at once. In Arpeggio they come one at a time, from the bottom up, like a fingerpicked guitar — you can hear each note separately. The chord is the same; if it is hard to hear inside it, start with Arpeggio."}}},"song":{"mode":{"title":"Which mode should I pick?","p1":{"title":"Practice — to learn","body":"The score stops at every note and waits for you to play the right one. It does not count for a score: it is practice. This is where you start a new piece."},"p2":{"title":"In time — to test yourself","body":"The score scrolls steadily, with a metronome, and the app measures the right notes and the accuracy of your attack. Switch to this once the piece is under your fingers."},"p3":{"title":"Play along — for the pleasure of playing","body":"The score scrolls in time and nothing is measured: it is for playing the music — melody, chords, or both — your own way."}},"tempo":{"title":"The “Tempo”","p1":{"title":"The speed the score moves at","body":"Drag left to go slower, right to go faster. In Practice mode it governs how far the conveyor travels between one note and the next; in In time and Play along it is the real speed of the music."},"q1":{"q":"Can I play much slower than the original?","a":"You can, and you should. Practicing slowly and speeding up gradually is how a piece is learned — nothing in the app penalises a low tempo."}},"input":{"title":"How you play","p1":{"title":"On-screen piano, microphone or MIDI keyboard","body":"Piano is the keyboard drawn on screen, which works on any device. Microphone listens to your acoustic piano and recognizes the note from the sound. MIDI keyboard takes an instrument connected by cable. All three answer the same thing — only the way in changes; microphone and MIDI only show up when the device supports them."}},"chart":{"title":"The chords","p1":{"title":"The chord name written above the music","body":"A chord symbol is the name of the chord — C, G7, Am — written above the score, saying what the harmony hand plays over that stretch. People accompanying on guitar, or playing by ear, read the chords rather than the whole melody."},"p2":{"title":"You plant your own, and they stay","body":"Open “Chords” and write the chord at each point of the music. They are stored with that file on this device and show up every time you open the piece. Some catalogue songs already come with chords — and whatever you write over them wins, including if you delete them all."},"q1":{"q":"Does the app play the chords?","a":"Not yet. They are written for YOU to play — on guitar, in the piano's left hand, on whatever instrument. To accompany without being marked on the notes, use Play along mode."}},"chartGrid":{"title":"Writing chords on the grid","p1":{"title":"Why a grid, and not the scrolling score","body":"Writing straight onto the conveyor would mean hunting for the right spot on a screen that shows barely more than one bar at a time — on a thirty-bar song that is twenty-five screens of hunting. The grid shows the whole song at once: you can see where each chord comes in."},"p2":{"title":"Bar, half bar or beat","body":"Choose how finely you want to be able to write. Bar suits most popular songs, where the chord lasts the whole bar. Half bar and beat give you smaller slots, for when the harmony moves faster."}},"midi":{"title":"Bringing in your own MIDI file","p1":{"title":"Any .mid becomes a score on the conveyor","body":"Pick a .mid file from your device and the app reads it right there, in the browser: it builds the score, chooses the clef and key signature and sets the melody rolling. The file is NOT uploaded to any server."},"p2":{"title":"Some files are refused — and that is deliberate","body":"MIDI stores when each note sounds, not how it is written. If the file has notes that do not land on the rhythmic grid — triplets, a live human performance, rubato — the app tells you what did not fit instead of drawing a crooked score. A refusal with an explanation is worth more than a wrong page."},"q1":{"q":"Where do I get .mid files?","a":"There are large public-domain archives online, and most score editors (MuseScore, for one) export .mid. Respect the copyright of whatever you download."},"q2":{"q":"The piece I imported does not save a record. Why not?","a":"Because there would be nothing to compare: everyone brings a different file, with different notes and different difficulty. The score shows on screen, but it does not enter the ranking."}},"lists":{"title":"The song list","p1":{"title":"The app's catalogue and your files, in one list","body":"At the top are the songs that ship with the app, all public domain. Below are the .mid files you brought in. It is a single list, at both doors of the game: you switch pieces without going anywhere else."}},"account":{"title":"Where your file lives","p1":{"title":"On the device, and only there","body":"The .mid you import is stored in this browser, on this device. It is not uploaded anywhere, and so it does not follow your account: signing in on another phone will not bring your songs along. To take them with you, use the backup."},"q1":{"q":"If I clear my browser data, do I lose everything?","a":"You do. Make the .json copy first — it holds the chords you wrote, tied to each song. It does not carry the .mid files: keep those in the same folder as the copy and your whole repertoire comes back."}},"backup":{"title":"Backing up your repertoire","p1":{"title":"One .json file with your chords","body":"Press “Send a copy” (or “Download a copy (.json)”) and the app makes a file with the chords you wrote, tied to each song. Keep that file wherever you like — email, cloud, USB stick: it is what survives changing device or clearing the browser."},"p2":{"title":"“Restore from a file” ADDS, it never deletes","body":"When you bring a backup back in, its chords join the ones already here. Nothing is erased: if a slot has a chord on both sides, the one already on the device is the one that stays. Importing twice does no harm at all."},"q1":{"q":"Does the backup keep the .mid files too?","a":"No, only the chords. You already have the .mid files — keep them in the same folder as the copy and you can rebuild your whole library."}},"results":{"title":"The song's score","p1":{"title":"Right notes and attack accuracy","body":"Notes says how many you played correctly. Accuracy says how closely you landed with the beat on each one. Both are only measured in In time mode — in Practice the score waits for you, and in Play along nothing is measured."},"p2":{"title":"The stars keep your best","body":"The stars hold your best run on that catalogue song, and they do not go down when you try again and do worse. A piece you imported keeps no stars: without everyone playing the same thing, there would be nothing to compare."}}},"reading":{"howto":{"title":"Free practice: one note at a time","p1":{"title":"Nothing runs here","body":"ONE note appears on the staff and it waits. You say which one it is, with no clock and no conveyor. This is the place to learn the note names calmly — and to come back to when reading flow starts to get tight."},"p2":{"title":"It does not count, and that is the point","body":"Free practice scores no points, unlocks no levels and never enters the ranking. It exists so you can get things wrong freely: it is where you memorise, not where you prove anything."}},"guide":{"title":"The guide line (⚙️ Options)","p1":{"title":"A line from the note to the right key","body":"The guide line connects the note on the staff to the key (or button) that answers it. Someone starting out does not have that path in their head yet — the line draws it until it becomes automatic."},"p2":{"title":"Three settings, from most to least help","body":"Always shows the line on every note. Only on mistakes makes the line appear during the correction, pointing at where it was. Off removes the visual help. Start on Always and step down once you are getting it right without looking."}},"clef":{"title":"The clef (⚙️ Options)","p1":{"title":"Treble, bass or both","body":"The clef says which note lives on each line. The treble clef is for high notes (piano right hand, violin, flute); the bass clef, for low ones (left hand, cello, bass). With “Both” the clef changes on every note — read the clef before the note."}},"key":{"title":"The key (⚙️ Options)","p1":{"title":"The signs right after the clef","body":"The key signature is the group of sharps or flats written after the clef, and it holds for the whole piece: with one sharp, every F is F♯, with no sign on the note. Each major key has its own signature, and its relative minor shares it: to practice A minor, choose C major."},"p2":{"title":"How the practice uses it","body":"The notes follow the key signature. On the piano, the answer is the right key (usually the black one when the note is altered); the buttons also show the altered names, like F♯ — and “F” for a written F♯ counts as a mistake. Select as many keys as you like: the signature is drawn from the selected ones on every “Play again” (a single selection means always the same). Start with one or two accidentals."}},"sound":{"title":"Real piano (⚙️ Options)","p1":{"title":"Sounds from a real piano","body":"When on, the app downloads recordings of a piano (about 1.6 MB, once — it stays on the device) and plays the note with that sound. When off, the note plays as a simple tone. Applies to every game."}}},"rhythm":{"howto":{"title":"How to play Rhythm","p1":{"title":"The line moves; you play when it crosses a note","body":"The score stays still and a line travels across the screen from left to right, always at the same speed. Every time the line crosses a note, that is when to play. Where the note sits on screen is WHEN it sounds."},"p2":{"title":"On a computer it is the space bar; on a phone, your finger on TAP","body":"On a computer, press the space bar. On a phone, touch and hold the big button marked TAP. Hold it for as long as the note lasts and let go at the end — every note is held until it ends, a short one just ends sooner."},"p3":{"title":"The count-in comes first","body":"Every round starts with a metronome count-in so you can pick up the tempo — four clicks, in 4/4. Do not play along with them: they are the count-in. The first note comes right after the last click."},"q1":{"q":"I play in time but the app says I missed.","a":"Look at BOTH meters first. If Start is high and Duration is low, your timing is right: what is missing is holding each note until it ends instead of tapping quickly. If both are low, the sound may be coming out late — Bluetooth headphones are the usual culprit. The app tries to subtract that delay on its own, but not every device reports the right value: try playing on the speaker or with wired headphones."},"q2":{"q":"Do I need to read music to play?","a":"No. You do not need to know the names of the note values: just see where the notes are and play when the line crosses each one. The names come later, from playing."}},"tempo":{"title":"The “Tempo” (BPM)","p1":{"title":"It is the speed of the music","body":"BPM means beats per minute: how many times the metronome clicks in a minute. Fewer BPM, slower and easier to hit. The app's margin of error is the same at any speed — so speeding up makes the exercise harder, and slowing down is a perfectly legitimate way to practice."}},"results":{"title":"“Start” and “Duration”: what the numbers say","p1":{"title":"Start is WHEN you played","body":"Start measures how well you hit the moment of each note — whether your tap landed with the line or a little before or after. It is the most important number in the game: it is the one that tells you whether you are in time."},"p2":{"title":"Duration is HOW LONG you held","body":"Duration measures whether you held the key for as long as the note value asked: letting go too early on a long note, or holding on too long on a short one, pulls this number down. It is stricter on short note values, because they last less — which is why it is usually the lower of the two."},"q1":{"q":"My “Start” is high and my “Duration” is low. Is that bad?","a":"No. It is the most common pattern, and it means you are in time but not yet controlling the length of the notes. Work on releasing the key at the end of the note, rather than right after playing it."},"q2":{"q":"I passed the level even with a low number. How?","a":"Passing a level looks at the whole picture, not one number in isolation. One low number does not fail you on its own — but it is the one showing you what to practice next time."}},"trails":{"title":"What a trail is","p1":{"title":"A sequence of exercises, your way","body":"A trail is a list of Rhythm exercises you build: each level is one exercise (figures, time signature, tempo and, if you want, a score to pass). The class plays them one by one, in order. It can have one level or thirty."},"p2":{"title":"Build it in the workshop, share the link, follow up","body":"This button takes the exercise on screen into a trail (a new one, or the next level of one you already have). In the trail workshop you adjust each level, see an example of what the class will see and test it. Then copy the link: whoever opens it signs in and plays, and you see how many started and finished. You can also start from “My trails”, in your account."},"action":"See a sample trail"},"pitch":{"title":"Notes at their pitch","p1":{"title":"Each note on the line where it sounds","body":"With “Melody” on, the app can draw each note of the rhythm on the staff line where it sounds, like in real sheet music: stems down on the high notes and a ledger line for the low C. Off, every note sits on the middle line. Your score does not change: the game only measures timing."}},"sound":{"title":"Note sound","p1":{"title":"The note you hear","body":"It is the note the model plays in “Listen” and the note the button plays when you press it. Pick one note, or “Melody” to make the notes of the rhythm change pitch, like a short tune that changes with every rhythm. Your score does not change: the game only measures timing."}},"ruler":{"title":"Beat ruler","p1":{"title":"The numbers under the staff","body":"They mark the beats of each measure, to help you count while you play. Once you can count on your own, you can hide it. Your score is the same with or without it."}},"midi":{"title":"MIDI keyboard","p1":{"title":"Play the rhythm on your instrument","body":"Turn this on and play the rhythm on your MIDI keyboard or controller connected to the computer (USB cable or Bluetooth). Every key you press counts as a tap on the button, and holding the key is holding the note. Any key works: the game measures timing only, not pitch. The sound you hear is the note you played; if your piano also makes its own sound, turn its volume down so you do not hear it twice. What counts is the key being held: the sustain pedal does not count as duration. Two or more keys played together (a chord, an octave) count as a single tap. On iPhone and iPad this option does not appear: their browser has no MIDI."}}},"app":{"levelGate":{"title":"Why the levels are locked","p1":{"title":"The levels open in order","body":"Each level unlocks the next one. Finish level 1 and level 2 opens by itself, with nothing to set up. The padlock means “not yet”, never “not allowed”."},"p2":{"title":"The first three need no account","body":"You play the first three levels of every track with nothing at all. From the fourth on the app asks for an account — it takes a minute, and you can sign in with Google."},"p3":{"title":"The account exists so your progress does not live in the browser","body":"With no account, your progress is stored in this browser only: change phone, or clear your data, and it is gone. With an account it follows you — and the ranking starts to mean something, because there is somebody on the other side of the scoreboard."},"q1":{"q":"Will I lose what I played without an account?","a":"No. When you create the account, this device's progress is adopted by it. The one exception is an account that has already played here: that one keeps its own progress, which is the further along of the two."}},"freeMode":{"title":"Free mode × the level track","p1":{"title":"One trains whatever you choose; the other has a beginning, a middle and an end","body":"The level track runs from easy to hard in a considered order, keeps your best on each level and feeds the ranking. Free mode has no order and keeps no score: you choose what to practice and repeat as much as you like. Use the track to move forward and free mode to hammer at whatever is not coming out yet."}},"groups":{"title":"Groups (school or class)","p1":{"title":"What a group is","body":"A group stands for a school or a class inside the app. Whoever organizes it — a teacher or the school office — requests the group right here: a name, a short description and, if you like, a logo. The request is approved shortly and a confirmation arrives by e-mail. Students join later, each with their own account."},"p2":{"title":"Joining, and what you see","body":"Once approved, the group gets its own page, plus an invite code and a link under \"My account\". The organizer passes one of them to the students. Whoever joins sees, besides the overall ranking, one for the group alone: each person's level reached and accuracy. The organizer sees that ranking without joining the group — and can join with the code, like the students, to take part."},"q1":{"q":"Does leaving the group erase my progress?","a":"No. Leaving only takes your name off the group ranking. All of your progress stays as it is."}}},"title":"Help","subtitle":"Everything the app explains, in one place.","sub":"How to play, questions and first steps","searchPlaceholder":"Search help…","searchEmpty":"Nothing found for “{q}”. Try another word — or scroll and look for the game.","hereTitle":"Help for this screen","hereFrom":"You came from: {game}","firstTitle":"First steps","firstSub":"The questions people have when they arrive.","byGameTitle":"Help by game","byGameSub":"Tap a subject to open the explanation.","guidesTitle":"Interactive guides","guidesSub":"Pages on our site that explain the subject with sound and movement. They open in a new tab, so the app stays where it is.","topicsN":"{n} subjects","topicsOne":"1 subject","backToResult":"◀ Back to the result","groups":{"app":"The app"},"levelsLabel":"Levels:","pageOf":"Page {n} of {total}"},"group":{"title":"Group","newTitle":"Request a group","form":{"intro":"Tell us who the school or class is. What you write here appears on the group page, which is public; the note is for the administration only.","nameLabel":"Name of the school or class","descLabel":"Description","descHint":"Up to {max} characters. Write in your language: the page translates it into the other two.","logoLabel":"Logo (optional)","logoHint":"PNG, JPG, GIF or WebP up to 2 MB. The image is resized to 256×256.","logoChoose":"Choose image","logoRemove":"Remove the logo","logoSending":"Uploading the logo…","logoSaved":"Logo updated.","logoAfter":"The logo can be uploaded after the request is created.","noteLabel":"Note to the administration (optional)","noteHint":"Not shown on the page.","submit":"Send request","save":"Save","saved":"Changes saved.","countryLabel":"Country (optional)","countryNone":"Don't show","countryHint":"If you choose one, the flag and the country's name appear on the group page."},"sent":{"title":"Request sent","body":"The administration reviews the request and you get an email. The invitation code shows up in “My account” once the group is approved.","ok":"Got it"},"guest":{"title":"To request a group, sign in to your account","body":"The group is tied to the account of whoever runs it."},"page":{"join":"Join this group","joinLogin":"Sign in to join","joined":"You are in this group","owner":"You run this group","inOther":"You are already in another group. Leave it in “My account” to join this one.","joinNote":"Members appear on the group ranking, which is public, and the organizer follows their progress. You can leave whenever you want.","preview":"Preview: this group is not approved yet. Only you and the administration can see this page.","notFound":"This group does not exist or is not available.","noDescription":"No description.","logoAlt":"Logo of {name}","joining":"Joining…","askCode":"To join, ask whoever runs the group for the invitation code and type it in “My account”."},"ranking":{"title":"Group ranking","adminNote":"You are viewing as site administration and are not on the list.","emptyViewer":"No one from {group} on the {game} ranking yet."},"news":{"badge":"New","country":"You can now show the group's country, with its flag, on the page. Choose it in “Edit the page”.","ok":"Got it"},"class":{"title":"Class view","private":"🔒 Only the group organizer sees this part. Students don't.","cardIntro":"See which level each student is on, who has tried {n} times or more without passing and, in Rhythm, what is missing: holding the notes or coming in on time.","cardCta":"Open the class view","backPage":"Group page","gameLabel":"Game","inGame":"Game: {game}","forbidden":"Only the organizer of this group can see the class.","empty":"Nobody is in the group yet. Share the invitation code with the class.","noneStarted":"Nobody in the class has played {game} yet.","statStudents":"students in the group","statStudentOne":"student in the group","statRounds":"rounds","statTime":"playing, combined","statMid":"middle level of the class","playing":"{n} of {total} have played.","diaryOff":"{n} students have the game diary turned off: their level shows; rounds, time and attempts are not added up.","diaryOffOne":"1 student has the game diary turned off: the level shows; rounds, time and attempts are not added up.","diaryOffStudent":"Game diary turned off: this student's attempts and time are not recorded.","whereTitle":"Where each student is","whereHint":"Each dot is a student, on the level they are trying to pass now.","histAria":"Students per level: {parts}","histPart":"level {level}: {n} students","legendAdvancing":"moving on","legendStuck":"{n} attempts or more on the same level","legendDone":"finished the track","tapHint":"Tap a student to see the details.","pickLabel":"View student","pickNone":"Choose a student","notStarted":"Haven't played yet: {names}.","levels":"Levels","level":"Level {n}","done":"Finished the track","noName":"(no name)","best":"Best attempt: {acc}%. The level asks for {pass}%.","bestNoPass":"Best attempt: {acc}%.","bestSplit":"Best attempt: start {onset}% · duration {duration}%. The level asks for {pass}% on both.","noBest":"No score on this level yet.","tries":"{n} attempts on level {level}.","triesOne":"1 attempt on level {level}.","totals":"{rounds} rounds · {time} in {game}.","min":"{m} min","hm":"{h} h {m}","today":"today","yesterday":"yesterday","stuckTitle":"Who could use a hand","stuckHint":"{n} attempts or more on the current level without passing. The bar is the best attempt; the tick is what the level asks for.","stuckNone":"Nobody is stuck right now.","stuckMore":"See the other {n}","stuckMoreOne":"See 1 more","needs":"asks {pass}%","triesShort":"attempts","accuracy":"Best","badge":{"hold":"Needs to hold","timing":"Needs to start on time","generic":"Below the goal"},"diag":{"hold":"Plays on time but lets go of the notes early: needs to hold each note to the end.","timing":"Holds the notes but starts them off the beat: the start of each note is what fails.","genericSplit":"Timing and duration are still below the {pass}% the level asks for.","generic":"The best attempt is still below the {pass}% the level asks for."},"seriesTitle":"Rounds per day","seriesHint":"Last {n} days, in your time zone.","seriesAria":"Rounds per day: {parts}","seriesPart":"{day}: {n} rounds, {players} students","seriesEmpty":"No rounds recorded in the last {n} days.","seriesOff":"No game diary turned on in the class: there are no rounds to count.","wallsTitle":"Where the class usually gets stuck","wallsHint":"The median number of attempts each level took to pass (among those who passed with the diary on).","wallsAria":"Attempts to pass, per level: {parts}","wallsPart":"level {level}: median of {median} attempts ({n} students)","wallsTop":"The level that takes the most attempts: {level} (median of {median}, among those who passed).","wallsHere":"a student is on this level now","wallsEmpty":"Nothing to measure yet: nobody has passed a level with the diary on.","tableSummary":"All students ({n})","colName":"Student","colLevel":"Level","colTries":"Attempts","colRounds":"Rounds","colTime":"Time","histPartOne":"level {level}: 1 student","histStuck":"{n} stuck","noRecords":"No game diary records in this game (played before the diary existed, or nothing has arrived yet).","world":"World {n}","seriesPartOne":"{day}: {n} rounds, 1 student","wallsPartOne":"level {level}: {median} attempts (1 student only)","wallsNow":"{n} stuck on it now","wallsOnlyHere":"level {level}: not measured yet, {n} stuck on it now"}},"trail":{"title":"Trail","editTitle":"Edit trail","by":"by {name}","bySchool":"by {name} · {school}","levels":"{n} levels","levelsOne":"1 level","guestIntro":"This trail is for people with an account: your progress is kept on this device and its author follows the class. Signing in or creating an account takes a minute.","play":"Play","continueAt":"Continue at level {n}","progress":"{done} of {total} levels done","cleared":"done","current":"you are here","locked":"locked","training":"practice","sameRhythm":"same rhythm for everyone","edit":"Edit the trail","viewAsStudent":"View as a student","link":"Trail link","stats":"{started} started · {finished} finished","statsNone":"Nobody has played yet.","notFound":"This trail does not exist or was deleted.","cancel":"Cancel","editor":{"name":"Trail name","label":"Level name (optional)","labelPh":"E.g. Pulse","pass":"To pass","takes":"How many times to pass it","seed":"Same rhythm for everyone","dup":"Duplicate","del":"Delete","add":"＋ Add level","delTrail":"Delete trail","delConfirm":"Delete “{name}”? The link stops working for everyone.","delLevelConfirm":"Delete level {n}?","saving":"Saving…","saved":"Saved.","measures":"bars","measureOne":"bar","ties":"tie","deleted":"Trail deleted.","auto":"added to close the measure","namePh":"E.g. 6th grade · quarter notes","nameHint":"The class sees this name.","s1":"Build the levels","s1Lead":"Each level is one exercise. The class plays them one by one, in order.","s2":"Share the link","s2Lead":"Whoever opens it signs in (or creates an account) and plays level by level.","s3":"Follow up","s3Lead":"This shows how many started and how many finished.","newHint":"Starts as a copy of level {n}. Change one thing: one more figure, the tempo, the time signature.","exTitle":"Example of what the class will see","otherEx":"🔀 Another example","otherSeed":"🎲 Roll another rhythm","figs":"⚙️ Figures & time signature","panelTitle":"Figures & time signature · level {n}","resetLevel":"Restore defaults","tempo":"Tempo","passTraining":"No goal","passNote":"No goal: play, see the score and move on to the next.","seedNote":"On: the rhythm in the example above is the one the whole class plays — reroll until you like it. Off: every round draws another.","test":"▶ Try this level","addNote":"A new level starts as a copy of the previous one.","diffNew":"new: {x}","diffOut":"out: {x}","diffTempo":"tempo {a} → {b}","diffSig":"time signature {a} → {b}","diffBars":"{n} bars","diffTiesOn":"with ties","diffTiesOff":"no ties","diffSame":"same as the previous one","kicker":"Trail workshop"},"guestWhat":"Rhythm exercises: you read the rhythm on the staff and tap it in time with the metronome, level by level.","paused":"This trail is paused by the site administration: people opening the link cannot see it.","playAgain":"Play again","asStudent":"You are viewing as a student","backToWorkshop":"← Back to the workshop","deviceNote":"Your progress in this trail is kept on this device."}},"es":{"meta":{"title":"Oído Absoluto Class — Juegos para aprender ritmo, lectura de partitura y percepción musical","description":"Educación musical en juegos: ritmo, lectura de partituras, intervalos y acordes de oído y música de verdad leída en el pentagrama, incluido tu propio MIDI. Niveles, ranking y grupos para escuelas. En el navegador.","ogImageAlt":"Oído Absoluto Class — juegos de ritmo, lectura de partitura y percepción musical","jsonldSiteDesc":"Educación musical en juegos: ritmo, lectura de partituras, intervalos y acordes de oído y música de verdad leída en la partitura.","jsonldBrowserReq":"Requiere un navegador moderno compatible con Web Audio API.","jsonldFeatures":["Juego de ritmo con 30 niveles en 6 mundos","Lectura de partitura en cinta, claves de sol y de fa","Modo infantil con notas de colores","Intervalos y acordes de oído por niveles","Música de verdad leída en la partitura, en el piano de la pantalla o en un teclado MIDI","Importa tu propio archivo MIDI con cifrados","Ranking y progreso en tu cuenta","Grupos para escuelas y clases, con panel del profesor"]},"app":{"name":"Oído Absoluto Class","tagline":"Aprende Música Jugando","loading":"Cargando…","updateAvailable":"Nueva versión disponible","updateNow":"Actualizar","loadError":"No se pudo cargar esta pantalla.","bootFailed":"No se pudo cargar la app.","retry":"Intentar de nuevo"},"langSwitch":{"label":"Idioma"},"nav":{"games":"Juegos","about":"Acerca","menu":"Menú","rhythm":"Ritmo","staffReading":"Lectura","intervals":"Intervalos","chords":"Acordes","songs":"Música","news":"Novedades","home":"Inicio","levels":"Niveles","ranking":"Ranking","progress":"Mi progreso","profile":"Mi cuenta","help":"Ayuda","privacy":"Privacidad","terms":"Términos","contact":"Contacto"},"menu":{"title":"Menú","close":"Cerrar","switchTitle":"Cambiar de juego"},"promo":{"railLabel":"Recomendación","sister":{"eyebrow":"Proyecto hermano","brand":"Oído Absoluto Piano","body":"Conoce nuestro otro proyecto, dedicado al oído absoluto: más juegos de percepción, ranking, medallas y una comunidad que entrena todos los días.","cta":"Conocer","hide":"Ocultar"}},"news":{"title":"Novedades","updated":"Última actualización: {date}","tagFeature":"Novedad","tagImprovement":"Mejora","empty":"Nada nuevo por ahora.","error":"No se pudieron cargar las novedades.","cta":"Probar ahora"},"legal":{"privacy":{"title":"Privacidad"},"terms":{"title":"Términos de uso"},"contact":{"title":"Contacto","formTitle":"Escríbenos","guestBody":"Para enviar un mensaje, entra en tu cuenta. La respuesta va al correo de esa cuenta.","from":"La respuesta va a {email}","label":"Tu mensaje","placeholder":"Una duda, un error en pantalla, una sugerencia… Si es un error, di qué aparato y qué estabas haciendo.","counter":"{n} / {max}","send":"Enviar mensaje","sending":"Enviando…","sentTitle":"Mensaje enviado","sentBody":"Una persona lo lee y responde a {email}. Puede tardar un poco.","another":"Escribir otro","staticCta":"Escribir desde la app","staticNote":"El formulario está dentro de la app y te pide entrar en tu cuenta: la respuesta va al correo de esa cuenta.","errors":{"too_short":"Escribe un poco más (al menos {min} caracteres).","too_long":"El mensaje pasa de {max} caracteres. Acórtalo un poco.","bad_message":"No se pudo leer este mensaje. Inténtalo de nuevo.","rate_limited":"Ya enviaste varios mensajes en esta hora. Espera un poco antes de enviar otro: tu texto sigue aquí.","csrf":"No se pudo enviar ahora. Inténtalo de nuevo: tu texto sigue aquí."}},"updated":"Actualizado el {date}","error":"No se pudo cargar este texto ahora. También está publicado en el sitio.","readOnSite":"Leer en el sitio"},"hero":{"eyebrow":"Educación musical","titlePre":"Aprende música","highlight":"jugando","titlePost":"","subtitle":"Ritmo, lectura de partituras, percepción musical y música de verdad, en juegos inteligentes con niveles y ranking.","cta":"Ver los juegos"},"games":{"sectionTitle":"Juegos Disponibles","sectionSubtitle":"Elige un juego y empieza a entrenar tus habilidades musicales","play":"Jugar","learnMore":"Más información","rhythm":{"name":"Ritmo","description":"Lee las figuras en el pentagrama y toca a tiempo. Precisión en milisegundos, seis mundos de niveles, modo libre y teclado MIDI."},"staffReading":{"name":"Lectura de Partitura","description":"Lee las notas que pasan por el pentagrama antes de que desaparezcan. Niveles por mundo, línea guía para principiantes, clave de fa en el entrenamiento libre."},"intervals":{"name":"Intervalos","description":"Reconoce de oído la distancia entre dos notas, de terceras a octavas, melódicos y armónicos. Niveles y modo libre."},"chords":{"name":"Acordes","description":"Identifica acordes de oído: tríadas mayores y menores, séptimas y novenas. Niveles y modo libre."},"songs":{"name":"Música de Verdad","description":"Toca una pieza entera leyendo la partitura, en el piano de la pantalla o en un teclado MIDI. El modo estudio te espera. O carga tu propio MIDI y planta los cifrados."},"kids":{"name":"Partituras para Niños","description":"Cada nota tiene un color y una línea-guía señala la tecla correcta — para quienes aún no leen partituras."}},"about":{"title":"Sobre el Proyecto","p1":"<strong>Oído Absoluto Class</strong> es una plataforma de educación musical gamificada, creada para hacer el aprendizaje de música accesible y divertido para todos.","p2":"Desarrollamos con inteligencia artificial: eso nos permite experimentar rápido y crear recursos con un nivel de detalle y feedback que no encontrarás en la mayoría de las herramientas.","p3":"Empezamos con el entrenamiento rítmico — la base de toda música — y hoy ya tenemos lectura de partituras, percepción musical (intervalos y acordes) y la lectura de música real, incluida la que tú mismo cargas en MIDI. Cada juego con niveles y modo libre, ranking en tu cuenta y grupos para escuelas y clases.","features":{"responsive":"Funciona en cualquier dispositivo","progressive":"Dificultad progresiva","progress":"Sigue tu progreso","browser":"Directo en el navegador, sin instalar"}},"footer":{"copyright":"© {year} Oído Absoluto Class. Todos los derechos reservados.","madeBy":"· Un proyecto de <a href=\"https://3wimusic.com/es/\">3wi</a>"},"rhythm":{"level":{"mapTitle":"Ruta de niveles","mapOpen":"🗺️ Niveles","locked":"bloqueado","n":"Nivel {n}","next":"Siguiente nivel →","unlocked":"✅ ¡Nivel superado! Se desbloqueó el siguiente.","passedAgain":"🎉 ¡Muy bien otra vez!","allDone":"🏆 ¡Completaste la ruta! ¡Felicidades!","tryAgain":"¡Casi! Saca {pass}% en ambos marcadores para desbloquear el siguiente.","tryAgainHold":"¡Tu tiempo está bien! Falta mantener: deja la tecla (o el dedo) apretada hasta que cada nota acabe, en vez de dar un toque rápido.","world1":"Mundo 1 · Pulso","world1Hint":"Negra, blanca y redonda — siente el pulso.","world2":"Mundo 2 · Subdivisión","world2Hint":"Corcheas: dos toques por tiempo.","world3":"Mundo 3 · Puntillos","world3Hint":"Figuras con puntillo: el puntillo añade la mitad.","world4":"Mundo 4 · Silencio","world4Hint":"El sonido que falta y el que dura: silencios y ligaduras.","world5":"Mundo 5 · Síncopa","world5Hint":"El acento cae entre los tiempos.","world6":"Mundo 6 · Rejilla fina","world6Hint":"Semicorchea y fusa: más divisiones dentro del mismo tiempo.","progress":"Nivel {id} de {total}","goal":"meta {pass}%","seeResult":"Ver resultado"},"title":"Juego de Ritmo","freeTitle":"Ritmo Libre","toFreeMode":"⚙️ Modo libre","toRankedMode":"🏆 Volver a los niveles","initError":"Error al inicializar el juego","audioUnavailable":"Sistema de audio no disponible","back":"Volver","menuStatus":"Escucha el ritmo y luego tócalo para evaluar tu precisión.","menuStatusShort":"Escucha, luego toca y evalúa.","listen":"▶  Escuchar","grade":"🎯  Evaluar","another":"🔀  Otro ritmo","tempo":"Tempo: ","gradeDuration":" Evaluar la duración de las notas","listening":"🔊 Escucha con atención…","getReady":"🎯 ¡Prepárate! Reproduce el ritmo tocando.","go":"¡YA!","liveOnTime":"¡A tiempo! 🎯","liveEarly":"Adelantó ⏪","liveLate":"Atrasó ⏩","liveTooEarly":"Muy adelantado ⏪","liveTooLate":"Muy atrasado ⏩","tendencyOk":"¡A tiempo, genial! 🎯","tendencyEarly":"Tiendes a ADELANTAR ~{ms}ms ⏪","tendencyLate":"Tiendes a ATRASAR ~{ms}ms ⏩","durationLabel":"Duración: {pct}%","onsetTitle":"Inicio","durationTitle":"Duración","durationOk":"¡Duración justa! 🎯","durationShort":"SUELTAS PRONTO ~{ms}ms 🤏","durationLong":"SUELTAS TARDE ~{ms}ms 🫳","howMeasured":"¿Cómo se mide esto?","extraPenalty":"Notas extra −{pct}%","restPenalty":"Tocaste en un silencio −{pct}%","timingAccuracy":"Precisión de tiempo: {pct}%","missed":"perdida","note":"Nota {n}","noteDetail":"Detalle por nota","legendOnTime":"a tiempo","legendOff":"fuera","legendMissing":"faltó","legendTarget":"fin ideal","retry":"🎯  Intentar de nuevo","backToMenu":"↩  Volver al menú","tutorial":{"open":"❓ Cómo jugar","prev":"◀ Anterior","next":"Siguiente ▶","start":"🚀 Empezar","skip":"Saltar","scene":{"oneBeat":"mantén 1 tiempo","halfBeat":"mantén medio tiempo","quarter":"NEGRA","eighth":"CORCHEA","listen":"👂 ESCUCHA","onsetOk":"INICIO ✓","durOk":"DURACIÓN ✓"},"cards":[{"title":"Tu latido","body":"La música empieza con un latido: tu corazón."},{"title":"El latido es una nota","body":"Cada latido del corazón se vuelve una nota en el pentagrama."},{"title":"Larga o corta","body":"Cada nota tiene un tamaño: una dura más, la otra dura menos — las dos se mantienen hasta que acaban."},{"title":"Dónde es cuándo","body":"El lugar de la nota en el pentagrama muestra cuándo suena."},{"title":"Primero, escucha","body":"Una línea pasa por cada nota y la toca para ti."},{"title":"Tu turno","body":"Toca el botón en cada nota y mantén hasta que acabe — cuanto mayor la nota, más tiempo mantienes."},{"title":"¡A jugar!","body":"Ya lo sabes: lee, escucha y toca a tiempo. ¡Vamos!"}]},"config":{"open":"⚙️ Ajustes","title":"Panel de control","hint":"Elige las figuras que pueden aparecer en los ritmos.","notes":"Notas","rests":"Silencios","ties":"Ligaduras","tiesHint":"Une dos notas en una sola, sumando los tiempos. Nota sostenida: atraviesa la barra de compás. Síncopa: el contratiempo se une al tiempo siguiente.","beat":"{n} tiempo","beats":"{n} tiempos","reset":"Restaurar valores","close":"Cerrar","needOneNote":"Deja al menos una nota marcada.","timeSig":"Compás","measures":"Compases","restLimit":"Silencios seguidos, como máximo","tieOff":"Sin ligaduras","tieSustain":"Nota sostenida","tieSyncopation":"Síncopa","tieBoth":"Las dos","click":"Clic del metrónomo","clickHint":"La cuenta antes de empezar siempre suena en todos los tiempos. “Escuchar” ya sigue el clic elegido.","clickAll":"En todos los tiempos","clickOne":"Solo en el tiempo 1","click24":"En los tiempos 2 y 4","clickNone":"Sin clic","measureRest":"Silencio de compás","noFit":"No cabe en {sig}","needOneFit":"Deja marcada al menos una nota que quepa en {sig}.","autoOn":"Activada para completar el compás de {sig} · toca para mantenerla","autoAdded":"Las notas marcadas no completan un compás de {sig}: {fig} queda activada mientras haga falta.","drawnAsBarRest":"se muestra como silencio de compás","sustainOneBar":"Con 1 compás no hay barra que la nota sostenida pueda atravesar."},"figures":{"whole":"Redonda","dotted-half":"Blanca con puntillo","half":"Blanca","dotted-quarter":"Negra con puntillo","quarter":"Negra","dotted-eighth":"Corchea con puntillo","eighth":"Corchea","sixteenth":"Semicorchea","fusa":"Fusa","whole-rest":"Silencio de redonda","half-rest":"Silencio de blanca","quarter-rest":"Silencio de negra","dotted-eighth-rest":"Silencio de corchea con puntillo","eighth-rest":"Silencio de corchea","sixteenth-rest":"Silencio de semicorchea","fusa-rest":"Silencio de fusa"},"tap":{"label":"TOCA","hintDesktop":"clic o tecla ESPACIO","hintMobile":"toca y mantén aquí","hintHold":"mantén hasta que la nota acabe"},"trails":{"title":"Ruta","strip":"Ruta: {name} · Nivel {n} de {m}","mapOpen":"Ver los niveles de la ruta","training":"práctica, sin meta","takes":"{done} de {takes} veces","takesLeft":"¡Bien! Faltan {n} para desbloquear el siguiente nivel.","trainingDone":"Práctica hecha. El siguiente nivel está desbloqueado.","cleared":"completado","readOnly":"En esta ruta las figuras y el compás son de quien la armó. Para cambiarlas, “Llevar a mi panel” copia este ejercicio a tu Ritmo Libre.","editCopy":"Llevar a mi panel","saveAs":"＋ Usar este ejercicio en una ruta","created":"Ruta creada. Arma los niveles aquí.","saved":"Guardado.","needAccount":"Para guardar una ruta, entra en tu cuenta o crea una.","readOnlyTitle":"Ejercicio de la ruta","editCopyConfirm":"Esto reemplaza TU panel del Ritmo Libre por el ejercicio de este nivel y sale de la ruta. ¿Continuar?","takesLeftLast":"¡Bien! Faltan {n} para terminar.","trainingDoneLast":"Práctica hecha.","allDone":"🏆 ¡Completaste la ruta!","toCover":"↩ Ver la ruta","whichTrail":"¿En qué ruta?","newOne":"Nueva ruta (este pasa a ser el nivel 1)","asLevel":"{name} — pasa a ser el nivel {n}","appended":"Guardado como nivel {n} de {name}.","defaultName":"Ruta nueva","defaultNameOf":"Ruta de {name}","testStrip":"Probando: {name} · Nivel {n} de {m} · no se guarda nada","toWorkshop":"← Volver al taller","testPassed":"Aprobado: la meta es {pass}%. No se guardó nada.","testTraining":"Práctica, sin meta. No se guardó nada.","editInWorkshop":"Editar en el taller","sample":"Ver una ruta de ejemplo →","noInput":"Ningún toque registrado: toca el botón al tiempo de las notas. Esta ronda no cuenta.","testFailed":"Con este puntaje el alumno no aprobaría (meta {pass}%). No se guardó nada.","blank":"Nueva ruta en blanco →"},"ruler":{"measure":"Compás {n}"},"settings":{"sound":"Sonido de la nota","vary":"Melodía","pitch":"Notas en su altura","ruler":"Regla de tiempos","midi":"Teclado MIDI"},"midi":{"listening":"🎹 {device} conectado: toca el ritmo en él","nodevice":"🎹 No se encontró ningún teclado MIDI: conéctalo por cable USB (o Bluetooth) y aparece aquí solo.","denied":"🎹 El navegador negó el acceso MIDI: permítelo en el candado junto a la dirección y luego apaga y vuelve a encender el teclado MIDI en ⚙️."},"noInput":"Ningún toque registrado","noInputDur":"Sin toques, sin duración"},"staffReading":{"title":"✏️ Práctica Libre de Lectura","progress":"Nota {current} de {total}  ·  Aciertos: {correct}","question":"¿Qué nota es esta?","correct":"✅ ¡Eso es! Es {note}.","wrong":"❌ Era {note}.","youMarked":"✘ marcaste {note}","noteN":"Nota {n}","scoreLine":"{correct} de {total} correctas","detailTitle":"Detalle por nota","playAgain":"🔁  Jugar de nuevo","backToMenu":"↩  Volver al menú","answerWith":"Responder con: ","modeButtons":"🔢 Botones","modePiano":"🎹 Piano","modeMic":"🎙️ Micrófono","modeMidi":"🎹 MIDI","hearNote":"🔊  Escuchar la nota","config":{"open":"⚙️ Opciones","title":"Opciones","guideTitle":"Línea guía","guideAlways":"Siempre","guideError":"Solo al fallar","guideOff":"Desactivada","clefTitle":"Clave","clefTreble":"Sol","clefBass":"Fa","clefBoth":"Las dos","realPiano":"Piano real","reset":"Restaurar predeterminado","close":"Cerrar","keyTitle":"Tonalidad","keyAtLeastOne":"Deja al menos una tonalidad marcada"},"tutorial":{"open":"❓ Cómo jugar","prev":"◀ Anterior","next":"Siguiente ▶","start":"🚀 Empezar","skip":"Saltar","cards":[{"title":"Grave y agudo","body":"En el piano, la izquierda es grave y la derecha aguda. Cuanto más a la derecha, más agudo el sonido."},{"title":"El pentagrama","body":"El pentagrama es una escalera de sonidos: cuanto más alta la nota, más aguda — como ir a la derecha en el piano."},{"title":"Línea o espacio","body":"Cada nota está en una línea (franja amarilla) o en un espacio (franja azul). Un escalón es siempre la tecla vecina."},{"title":"La clave de Sol","body":"La clave de Sol rodea la 2ª línea y marca dónde está el Sol. Ese es tu punto de partida."},{"title":"Los vecinos del Sol","body":"Si encuentras el Sol, los encuentras a todos: cada escalón arriba o abajo es la nota siguiente, sin saltar nombres."},{"title":"Una ronda","body":"Aparece una nota y dices su nombre (o tocas la tecla). Solo cuenta desde el Sol."},{"title":"¡A jugar!","body":"Ya sabes leer: encuentra el Sol y cuenta los vecinos. ¡A jugar!"}]},"toFlow":"🏃 Lectura en flujo"},"readingFlow":{"title":"🎼 Lectura de Partitura","subtitle":"Las notas llegan desde la derecha. Di el nombre de la nota resaltada antes de que salga por la izquierda.","start":"▶ Empezar","prompt":"Di el nombre de la nota resaltada","score":"Puntos","combo":"Racha","best":"Récord","progress":"Progreso","accuracy":"de precisión","playAgain":"🔁  Jugar de nuevo","backToMenu":"↩  Volver al menú","results":{"title":"Fin de la ronda","scoreLine":"{hits} de {total} correctas","maxCombo":"Mejor racha","newBest":"🎉 ¡Nuevo récord!","starRecord":"🌟 ¡Nuevo récord de estrellas!","levelStars":"Estrellas del nivel","unlocked":"🔓 ¡Nivel siguiente desbloqueado!"},"level":"Nivel","notesWord":"notas","locked":"Bloqueado — supera el nivel anterior","worldLabel":"Mundo {n}","worlds":{"1":"En el pentagrama","2":"El pentagrama entero"},"input":"Responder con","inputButtons":"Botones","inputPiano":"Piano","inputMic":"🎙️ Micrófono","inputMidi":"🎹 MIDI","kids":"Kids","realPiano":"Sonido: piano real","loadingPiano":"Cargando","stop":"Parar","nextLevel":"➡ Nivel siguiente","toFreeMode":"✏️ Práctica libre (1 nota)","kidsLearned":"¡Aprendiste {note}! 🎉","kidsGraduated":"¡Estás respondiendo sin los colores! 🎓","kidsColorHint":"Cada nota tiene su color en el pentagrama. A medida que aprendes, el color sale de los botones.","kidsAllLearned":"¡Ya respondes sin colores en este nivel! 🎉 Sube de nivel para nuevas notas.","kidsReset":"🔄 Reiniciar colores","kidsResetConfirm":"¿Traer los colores de vuelta a los botones? Esto borra tu progreso de aprendizaje de las notas.","wasNote":"¡Era {note}!","buttonsLocked":"A partir del nivel 2 respondes en el piano: leer la nota es encontrar la tecla.","octaveUp":"¡Nombre correcto! Era el {note} de arriba.","octaveDown":"¡Nombre correcto! Era el {note} de abajo.","teach":{"got":"Entendido","octave":{"title":"🎹 Mismo nombre, otra altura","text":"Desde este nivel la misma nota aparece en dos alturas. Mismo nombre, más agudo — y otra tecla."},"ledgerLow":{"title":"🎼 El pentagrama sigue abajo","text":"Cuando la nota baja demasiado, gana una rayita solo para ella. Esta primera, justo debajo del pentagrama, es el Do central."},"ledgerHigh":{"title":"🎼 Y sigue arriba","text":"Del otro lado funciona igual: una rayita más encima del pentagrama, y esa es el La agudo."}},"stopConfirm":"¿Parar de verdad?","unlockGoal":"Logra {acc}% para desbloquear el nivel {level}","masteryTitle":"Álbum de notas"},"notes":{"C":"Do","D":"Re","E":"Mi","F":"Fa","G":"Sol","A":"La","B":"Si"},"micInput":{"activateHint":"Responde tocando en tu piano de verdad","activate":"🎙️ Activar micrófono","requesting":"Esperando permiso…","listening":"Escuchando… toca la nota en tu instrumento","denied":"Acceso al micrófono denegado","deniedHelp":"Permite el micrófono en la configuración del navegador, o responde con los botones.","unsupported":"Micrófono no disponible en este entorno","unsupportedHelp":"El navegador exige una conexión segura (HTTPS) para usar el micrófono.","error":"No se pudo acceder al micrófono","useButtons":"Usar botones"},"midiInput":{"activateHint":"Responde tocando en tu teclado MIDI","activate":"🎹 Conectar teclado MIDI","requesting":"Esperando permiso…","listening":"Conectado… toca la nota en tu teclado","nodevice":"No se encontró ningún instrumento MIDI","nodeviceHelp":"Conecta tu teclado por cable USB (o Bluetooth) — aparecerá aquí solo.","denied":"Acceso MIDI denegado","deniedHelp":"Permite el acceso MIDI en la configuración del navegador, o responde con los botones.","unsupported":"MIDI no disponible en este navegador","unsupportedHelp":"Este navegador no tiene Web MIDI. Prueba con Chrome o Edge en la computadora.","error":"No se pudo acceder al MIDI","useButtons":"Usar botones"},"intervals":{"title":"🎵 Intervalos","progress":"Intervalo {current} de {total}  ·  Aciertos: {correct}","mode":"Modo: ","modeIdentify":"🎧 Escuchar e identificar","modeBuild":"🎹 Construir en el piano","identifyPrompt":"🎧 Escucha el intervalo. ¿Qué intervalo es?","buildPrompt":"🎹 Toca la {interval} encima de {root}.","buildPromptDown":"🎹 Toca la {interval} debajo de {root}.","progressEndless":"Intervalo {current}  ·  Aciertos: {correct}","freeTitle":"🎵 Intervalos — Práctica libre","freeSubtitle":"Arma tu práctica: elige los intervalos y las opciones.","toFreeMode":"⚙️ Modo libre","toRankedMode":"🏆 Niveles","settings":"⚙️ Configurar","pickIntervals":"Elige los intervalos:","playLabel":"Tocar:","melodic":"Melódico","harmonicMode":"Armónico","dir":"Dirección:","dirUp":"↑ Arriba","dirDown":"↓ Abajo","dirBoth":"↕ Ambas","length":"Tamaño:","endless":"∞ Sin fin","stop":"Parar","correct":"✅ ¡Eso es! {interval}.","wrong":"❌ Era {interval}.","repeat":"🔊  Repetir","hearBase":"🔊  Escuchar la base","buildHint":"Toca la tecla correcta en el piano de arriba. ","youPlayed":"✘ tocaste {note}","youMarked":"✘ marcaste {interval}","base":"(base {root})","scoreLine":"{correct} de {total} correctas","detailTitle":"Detalle","playAgain":"🔁  Jugar de nuevo","backToMenu":"↩  Volver al menú","start":"▶ Empezar","subtitle":"Elige un nivel y entrena el oído.","hearExample":"🔊 Oír un ejemplo","exampleIs":"Así suena: {interval}","level":"Nivel","locked":"bloqueado","assist":"Ver teclas:","assistOn":"Sí","assistOff":"No","harmonicTag":"armónico","unlocked":"✅ ¡Nuevo nivel desbloqueado!","nextLevel":"Siguiente nivel →","chooseLevel":"🎚️ Elegir nivel","names":{"P1":"Unísono","m2":"Segunda menor","M2":"Segunda mayor","m3":"Tercera menor","M3":"Tercera mayor","P4":"Cuarta justa","TT":"Tritono","P5":"Quinta justa","m6":"Sexta menor","M6":"Sexta mayor","m7":"Séptima menor","M7":"Séptima mayor","P8":"Octava justa"},"needPass":"Necesitas {pass}% para desbloquear el siguiente nivel.","goal":"Meta: {pass}%","stopConfirm":"¿Parar de verdad?"},"chords":{"title":"🎸 Acordes","progress":"Acorde {current} de {total}  ·  Aciertos: {correct}","identifyPrompt":"🎧 Escucha el acorde. ¿Qué acorde es?","correct":"✅ ¡Eso es! {chord}.","wrong":"❌ Era {chord}.","repeat":"🔊  Repetir","youMarked":"✘ marcaste {chord}","base":"(fund. {root})","scoreLine":"{correct} de {total} correctos","detailTitle":"Detalle","playAgain":"🔁  Jugar de nuevo","backToMenu":"↩  Volver al menú","start":"▶ Empezar","subtitle":"Elige un nivel y entrena el oído.","hearExample":"🔊 Oír un ejemplo","exampleIs":"Así suena: {chord}","level":"Nivel","locked":"bloqueado","assist":"Ver teclas:","assistOn":"Sí","assistOff":"No","style":"Tocar:","styleBlock":"En bloque","styleArpeggio":"Arpegio","unlocked":"✅ ¡Nuevo nivel desbloqueado!","nextLevel":"Siguiente nivel →","chooseLevel":"🎚️ Elegir nivel","freeTitle":"🎸 Acordes — Práctica libre","freeSubtitle":"Arma tu práctica: elige los acordes y las opciones.","progressEndless":"Acorde {current}  ·  Aciertos: {correct}","pickChords":"Elige los acordes:","arpDir":"Arpegio:","dirUp":"↑ Arriba","dirDown":"↓ Abajo","dirBoth":"↕ Ambas","length":"Tamaño:","endless":"∞ Sin fin","stop":"Parar","settings":"⚙️ Configurar","toFreeMode":"⚙️ Modo libre","toRankedMode":"🏆 Niveles","names":{"7":"Dominante 7","9":"Dominante 9","11":"Dominante 11","13":"Dominante 13","maj":"Mayor","min":"Menor","dim":"Disminuido","aug":"Aumentado","sus2":"Sus2","sus4":"Sus4","maj7":"Mayor 7","min7":"Menor 7","m7b5":"Semidism. (ø)","dim7":"Dism. 7 (°7)","maj9":"Mayor 9","min9":"Menor 9"},"needPass":"Necesitas {pass}% para desbloquear el siguiente nivel.","goal":"Meta: {pass}%","stopConfirm":"¿Parar de verdad?"},"common":{"close":"Cerrar","cancel":"Cancelar"},"auth":{"signInTitle":"Entrar","signUpTitle":"Crear cuenta","forgotTitle":"Recuperar contraseña","resetTitle":"Establecer nueva contraseña","google":"Continuar con Google","or":"o","emailButton":"Crear cuenta con correo","backToChoice":"Volver","nameLabel":"Nombre","namePlaceholder":"¿Cómo quieres que te llamemos?","emailLabel":"Correo","emailPlaceholder":"tu@ejemplo.com","passwordLabel":"Contraseña","passwordPlaceholder":"Mínimo {min} caracteres","signInSubmit":"Entrar","signUpSubmit":"Crear cuenta","forgotSubmit":"Enviar instrucciones","resetSubmit":"Guardar nueva contraseña","forgotIntro":"Te enviaremos un enlace para restablecer tu contraseña.","resetIntro":"Elige una nueva contraseña para tu cuenta.","newPasswordLabel":"Nueva contraseña","newPasswordPlaceholder":"Mínimo {min} caracteres","toSignUp":"¿No tienes cuenta? Crea una","toSignIn":"¿Ya tienes cuenta? Entra","toForgot":"Olvidé mi contraseña","backToSignIn":"Volver al inicio de sesión","loading":"Espera…","signInCta":"Entrar","accountTitle":"Cuenta","signOut":"Salir","deleteAccount":"Eliminar cuenta","resendVerification":"Confirmar correo (reenviar enlace)","deleteConfirm":"¿Eliminar tu cuenta y todo el progreso? Esto no se puede deshacer.","guest":"Invitado","gate":{"rewardTitle":"¡Vas muy bien! 🎉","rewardSubtitle":"Crea tu cuenta para continuar y guardar tu progreso.","contextLine":"Completaste los primeros {free} niveles — el nivel {level} te espera.","lockedHint":"Crea tu cuenta para jugar este nivel"},"linked":{"title":"Tu cuenta ahora entra con Google","body":"Ese correo ya tenía una cuenta con contraseña, pero nunca había sido confirmado. Por seguridad, la contraseña anterior fue desactivada — tu progreso está intacto, en la misma cuenta. De ahora en adelante, entra con Google. Si prefieres volver a usar contraseña, define una nueva.","setPassword":"Definir nueva contraseña","resetSent":"Enviamos a tu correo el enlace para definir la nueva contraseña.","ok":"Entendido"},"toasts":{"welcome":"¡Bienvenido, {name}!","accountCreated":"¡Cuenta creada! Revisa tu correo para confirmar.","resetSent":"Si el correo existe, enviamos instrucciones.","emailVerified":"¡Correo verificado! Tu cuenta está confirmada.","verifySent":"Enlace de confirmación reenviado. Revisa tu bandeja de entrada.","verifyRate":"Demasiados intentos por ahora. Abre el enlace de nuevo en unos minutos.","verifyFailed":"El enlace de verificación es inválido o expiró.","passwordReset":"¡Contraseña restablecida! Entra con la nueva.","signedOut":"Has salido de la cuenta.","sessionExpired":"Tu sesión expiró. Entra de nuevo.","progressRestored":"Progreso de tu cuenta recuperado en este dispositivo.","progressLinked":"Tu progreso se vinculó a tu cuenta.","accountDeleted":"Tu cuenta fue eliminada."},"errors":{"generic":"Algo salió mal. Inténtalo de nuevo.","network":"Sin conexión con el servidor. Inténtalo más tarde.","invalid_email":"Correo inválido.","short_password":"La contraseña necesita al menos {min} caracteres.","long_password":"La contraseña es demasiado larga. Usa una más corta.","empty_password":"Escribe tu contraseña.","reset_invalid":"El enlace de restablecimiento es inválido o expiró. Pide uno nuevo.","email_taken":"Este correo ya tiene cuenta. Intenta entrar.","invalid_credentials":"Correo o contraseña incorrectos.","no_account":"No encontramos una cuenta con ese correo.","rate_limited":"Demasiados intentos. Espera un momento.","disposable_email":"Usa un correo permanente.","social_account":"Esta cuenta entra con Google y no tiene contraseña. Usa el botón de Google o define una contraseña nueva.","social_account_noprov":"Esta cuenta entra con Google y no tiene contraseña. Para entrar por correo, define una contraseña nueva.","session_expired":"Tu sesión expiró. Entra de nuevo.","csrf":"Sesión de seguridad expirada. Recarga la página.","spam":"No se pudo procesar. Recarga e inténtalo de nuevo.","oauth_cancelled":"Inicio de sesión cancelado.","oauth_invalid_state":"Tu sesión de inicio expiró. Inténtalo de nuevo.","oauth_account_exists":"Ya existe una cuenta con ese correo. Entra con correo y contraseña.","oauth_failed":"No se pudo iniciar sesión con el proveedor. Inténtalo de nuevo.","actions":{"createAccount":"Crear cuenta","signIn":"Entrar","googleSignIn":"Entrar con Google","setPassword":"Definir nueva contraseña"},"empty_name":"Elige un nombre — aparece en el ranking.","bad_name":"Ese nombre no se pudo leer. Usa letras y números.","not_logged":"Entra en tu cuenta para hacer eso.","bad_code":"Código no encontrado. Confírmalo con quien organiza el grupo.","already_in_group":"Ya estás en un grupo. Sal de él para entrar en otro.","forbidden":"No tienes permiso para eso.","empty_group_name":"Ponle un nombre al grupo.","group_taken":"Ya existe un grupo con ese nombre.","no_group":"No estás en ningún grupo.","pending_exists":"Ya tienes un pedido de grupo en revisión.","owner_exists":"Ya organizas un grupo.","name_locked":"El nombre no cambia después de que el grupo sea aprobado.","logo_missing":"Elige una imagen.","logo_too_big":"La imagen supera los 2 MB.","logo_bad_image":"El archivo no es una imagen PNG, JPG, GIF o WebP.","logo_too_large_dims":"La imagen es demasiado grande (hasta 4000×4000).","logo_encode_failed":"No se pudo procesar la imagen. Prueba con otra.","bad_decision":"Decisión inválida.","bad_status":"Este pedido ya fue decidido.","bad_group":"Grupo inválido.","bad_country":"País no válido.","no_list":"Ruta no encontrada.","lists_max":"Llegaste al máximo de rutas por cuenta.","empty_list_name":"Ponle un nombre a la ruta.","bad_levels":"Los niveles de la ruta llegaron inválidos.","bad_lid":"Los niveles de la ruta llegaron inválidos.","too_many_levels":"La ruta pasó el máximo de niveles.","levels_too_big":"La ruta es demasiado grande.","bad_visibility":"Visibilidad inválida."},"prefs":{"diary":"Diario de juego","on":"Registrando","off":"Apagado","help":"Guarda lo que juegas — nivel, tiempo y precisión — para tus estadísticas. Apagarlo detiene el registro y borra de este aparato la cola que aún no había subido; lo que ya está en tu cuenta se queda. Tu mejor resultado de cada nivel sigue subiendo y al ranking.","anon":"El recuento de visitas del sitio, descrito en Privacidad, no depende de esto.","saveError":"No se pudo confirmar si se guardó. Recarga la app para ver cómo está."}},"pages":{"ritmo":{"linkLabel":"Juego de Ritmo"},"leitura":{"linkLabel":"Lectura de Partituras"},"kids":{"linkLabel":"Partituras para Niños"},"intervalos":{"linkLabel":"Intervalos"},"acordes":{"linkLabel":"Acordes"},"musicas":{"linkLabel":"Música de Verdad"},"ritmoGuia":{"linkLabel":"Qué es el ritmo"},"leituraGuia":{"linkLabel":"Cómo leer partituras"},"intervalosGuia":{"linkLabel":"Qué son los intervalos musicales"},"acordesGuia":{"linkLabel":"Qué son los acordes"},"escolas":{"linkLabel":"Para escuelas de música y profesores"},"toolVocal":{"linkLabel":"Test de voz"},"midi":{"linkLabel":"Tu música con cifrado"}},"ranking":{"title":"Ranking","subtitle":"Quién llegó más lejos en el camino","gameLabel":"Juego","tabOverall":"General","tabLevel":"Por nivel","levelLabel":"Nivel","levelOption":"{n}","loginPrompt":"Entra en tu cuenta para aparecer en el ranking.","loginCta":"Entrar","loading":"Cargando…","error":"No se pudo cargar el ranking.","empty":"Nadie en el ranking todavía. Juega un nivel y sé el primero.","notInLevel":"Todavía no tienes registro en el nivel {n}. Juega este nivel con la sesión iniciada para aparecer aquí.","colPlayer":"Jugador","colLevel":"Nivel","colAccuracy":"Precisión","colPlays":"Partidas","reached":"Nivel {n}","you":"Tú","guestPlayer":"Sin nombre","scopeLabel":"Ver ranking por","colPosition":"Posición","emptyCta":"Jugar {game}","youAreHidden":"No apareces en esta lista porque apagaste “Aparecer en el ranking”.","schoolLink":"{group}: ver la página del grupo","youAreHiddenCta":"Activarlo en Mi cuenta","whoLabel":"Ver el ranking de","whoAll":"Todos","groupEmpty":"Nadie de {group} en el ranking de {game} todavía. Juega un nivel para estrenarlo.","ownerNote":"Tú organizas este grupo y no apareces en la lista.","showing":"{from}–{to} de {total}","pageNav":"Páginas del ranking","prev":"Página anterior","next":"Página siguiente","pageN":"Página {n}","pageOf":"página {n} de {total}","goToMine":"Ir a mi página"},"stats":{"title":"Mi progreso","subtitle":"Lo que tu cuenta guarda de cada práctica","error":"No se pudo cargar tu progreso.","retry":"Intentar de nuevo","emptyTitle":"Todavía no hay nada por aquí.","emptyBody":"Juega una ronda conectado y vuelve: los días, el tiempo y la evolución aparecen aquí.","emptyBodyOff":"Con el diario de juego apagado, aquí solo aparecerá tu mejor nivel en cada juego. Enciende el registro y juega una ronda para ver días, tiempo y evolución.","emptyCta":"Jugar {game}","tileDays":"Días de práctica","tileStreak":"Racha (días)","tileStreakSub":"mejor: {n}","tileTime":"Tiempo de práctica","tileRounds":"Rondas","tileRoundsSub":"{n} abandonadas","since":"desde {date}","timeHours":"{h}h {m}min","timeMinutes":"{m} min","diaryOff":"El diario de juego está apagado, así que días, tiempo, rondas y evolución no se registran. Tu mejor nivel en cada juego sigue abajo.","diaryOffCta":"Encender el registro","beforeDiary":"Las rondas jugadas antes de que existiera el diario no aparecen aquí — solo el nivel más alto de cada juego.","chartTitle":"Evolución","chartCaption":"Precisión media por día · {game}","chartEmpty":"Ninguna ronda en los últimos {n} días.","chartAvg":"media {p}%","chartAria":"{game}: rondas en {days} de los últimos {n} días, precisión media de {p}%.","windowGroup":"Período","windowLabel":"{n} días","gameLabel":"Juego","roundsOne":"1 ronda","roundsMany":"{n} rondas","stripTitle":"Últimas 4 semanas","stripToday":"hoy","stripNone":"sin rondas","tableTitle":"Por juego","colGame":"Juego","colLevel":"Nivel","colAccuracy":"Precisión","colRounds":"Rondas","colAbandons":"Abandonos","colTime":"Tiempo","previewIntro":"Así se ve tu progreso cuando tienes cuenta. El gráfico y las tarjetas de abajo son un ejemplo con {game}.","previewStamp":"Ejemplo","previewCta":"Crear una cuenta para guardar esto","previewAria":"Ejemplo: la precisión en {game} que sube de {from}% a {to}% a lo largo de {n} días.","previewOutro":"Con una cuenta, cada ronda entra en esta pantalla — y tu progreso te sigue a cualquier dispositivo.","previewDeviceTitle":"En este dispositivo","previewDeviceNote":"Esta parte es real: el nivel más alto y la mejor precisión que este navegador guardó. Sin cuenta desaparece si cambias de dispositivo o limpias el navegador."},"profile":{"title":"Mi cuenta","subtitle":"Tus datos y los ajustes de esta cuenta.","guestTitle":"Todavía no entraste en tu cuenta","guestBody":"La cuenta guarda tu progreso y lo lleva de un aparato a otro. Entra para ver y ajustar tus datos aquí.","guestSignUp":"Crear cuenta","guestSignIn":"Entrar","loadError":"No pudimos cargar tus datos ahora.","retry":"Intentar de nuevo","noName":"(sin nombre)","nameLabel":"Nombre","namePublic":"Es el nombre que aparece en el ranking.","edit":"Editar","save":"Guardar","nameSaved":"Nombre actualizado.","verified":"Correo confirmado","unverified":"Correo sin confirmar","roleAdmin":"Administrador","memberSince":"Cuenta creada el {date}.","avatarNote":"La foto viene de tu cuenta de Google. Sin Google, el avatar son tus iniciales — aquí no se sube ninguna foto.","accessTitle":"Cómo entras","accessPassword":"Correo y contraseña","accessGoogle":"Google","accessNone":"No hay forma de entrada registrada.","noPasswordNote":"Esta cuenta no tiene contraseña: entras con Google. Para entrar también por correo, crea una contraseña — el enlace llega a tu correo.","setPassword":"Crear una contraseña","languageLabel":"Idioma","languageNote":"El idioma acompaña la dirección del sitio: cada idioma tiene la suya. Cambiar aquí te lleva a la dirección de ese idioma, con la misma cuenta.","language":{"pt":"Portugués","en":"Inglés","es":"Español"},"prefsTitle":"Ajustes","ranking":{"label":"Aparecer en el ranking","on":"Nombre y foto visibles","off":"Fuera de la lista pública","help":"El ranking es una página pública: con esto activado, tu nombre y tu foto aparecen allí para cualquiera, junto al nivel y la precisión.","scope":"Apagarlo te saca de la lista y no borra nada — tu progreso y tus resultados siguen siendo tuyos."},"accountTitle":"Cuenta","reset":{"title":"Borrar el progreso","sub":"{n} resultados guardados","subEmpty":"No hay resultados guardados","body":"Borra tus mejores resultados y los niveles desbloqueados, en este aparato y en tu cuenta — el recorrido vuelve al principio y tu línea sale del ranking. Tu historial de práctica en “Mi progreso” se mantiene, y las canciones sincronizadas también. No tiene vuelta atrás.","count":"Se borrarán {n} resultados.","confirm":"Borrar el progreso","done":"Progreso borrado."},"group":{"title":"Grupo","intro":"¿Formas parte de una escuela o clase? Escribe el código que te dio quien la organiza.","codeLabel":"Código del grupo","codePlaceholder":"ABCD2345","join":"Entrar al grupo","members":"{n} personas","membersOne":"1 persona","viewPage":"Ver la página del grupo","note":"El ranking del grupo es público, y quien lo organiza sigue tu progreso en los juegos.","leave":"Salir del grupo","leaveSub":"No se borra nada — solo tu fila sale de la lista del grupo","leaveTitle":"Salir del grupo","leaveBody":"¿Salir de {name}? Tu fila sale del ranking del grupo. No se borra nada — tu progreso y tus resultados siguen siendo tuyos. Puedes volver a entrar con el código.","leaveConfirm":"Salir del grupo","left":"Saliste del grupo.","joined":"Entraste en {name}.","existing":"Grupos que ya están aquí:","admin":{"title":"Grupos (administración)","intro":"Los pedidos de quien organiza una escuela llegan a la fila de arriba. Aquí creas un grupo directo, sin pedido: el código es la invitación, entrégalo a quien organiza. Crear un grupo no te pone dentro de él.","nameLabel":"Nombre del grupo","create":"Crear grupo","created":"Grupo “{name}” creado. Código: {code}","code":"código","none":"Ningún grupo creado todavía."},"requestIntro":"¿Organizas una escuela o clase? Pide la creación de un grupo: recibes un código para tus alumnos y sigues su progreso.","requestCta":"Pedir la creación de un grupo","owner":{"pending":"En revisión","pendingBody":"La administración revisa el pedido y recibes un correo. El código de invitación aparece aquí cuando el grupo sea aprobado.","rejected":"No aprobado","rejectedBody":"Este pedido no fue aprobado. Si quieres, vuelve a pedir: el formulario viene relleno con el pedido anterior.","paused":"Pausado","pausedBody":"El grupo está pausado por la administración: nadie entra y la página no se muestra.","live":"Aprobado","decisionNote":"Nota de la administración:","code":"Código de invitación","link":"Enlace de invitación","copy":"Copiar","copied":"¡Copiado!","share":"Entrega el código o el enlace a quien deba entrar. Cada persona entra con su propia cuenta y aparece, con nombre y resultados, en el ranking de la página del grupo — que es pública. Tú ves ese ranking sin estar en él.","edit":"Editar el pedido","editLive":"Editar la página","noTranslation":"La descripción todavía no fue traducida: la página muestra el texto original en los tres idiomas.","translating":"Traduciendo la descripción…","copyFailed":"No se pudo copiar aquí: el texto quedó seleccionado, cópialo con el teclado."},"adminQueue":{"title":"Pedidos de grupo","none":"Ningún pedido pendiente.","by":"pedido por {email}","approve":"Aprobar","reject":"Rechazar","noteLabel":"Nota para la persona (opcional, va en el correo)","statusPending":"en revisión","statusRejected":"rechazado","statusPaused":"pausado","viewPreview":"Ver la página","decided":"Decidido: {name} — {status}.","noDescription":"(sin descripción)","note":"Observación:","statusLive":"aprobado","previous":"Rechazado antes, con la nota:","resume":"Reanudar (volver a hacerlo visible)","rejectTitle":"¿Rechazar el pedido?","rejectBody":"¿Rechazar “{name}”? La persona recibe un correo y el pedido se cierra; puede volver a pedir."},"joinOther":"Entrar en otro grupo con un código","alsoMember":"También participas en {name}."},"trails":{"title":"Mis rutas","intro":"Una ruta es una secuencia de ejercicios de Ritmo, a tu manera. Arma los niveles, envía el enlace y sigue a la clase.","none":"Ninguna ruta todavía.","create":"＋ Nueva ruta","edit":"Editar","open":"Abrir","copyLink":"Copiar enlace"}},"songs":{"happyBirthday":{"title":"Feliz Cumpleaños"},"twinkle":{"title":"Estrellita, ¿Dónde Estás?"},"odeToJoy":{"title":"Himno a la Alegría"},"jingleBells":{"title":"Cascabel (Jingle Bells)"}},"song":{"title":"Música de Verdad","subtitle":"Lee la partitura mientras pasa y toca la pieza en tu instrumento.","start":"Tocar","listen":"Escuchar la pieza","listening":"Escuchando…","stop":"Parar","prompt":"Toca cada nota cuando cruce la línea.","promptStudy":"La partitura te espera. Toca la nota destacada.","mode":"Modo","modeStudy":"Estudio","modeTempo":"A tempo","modeStudyHint":"En el modo estudio la partitura se detiene en cada nota y espera a que toques la correcta. No puntúa — sirve para aprender la pieza.","modeTempoHint":"En el modo a tempo la partitura avanza sin parar, con metrónomo, y se mide tu ejecución: las notas correctas y la precisión del ataque.","tempoLabel":"Tempo","densityLabel":"Espaciado","density":{"tight":"Compacto","medium":"Medio","loose":"Amplio"},"input":"Responder con","inputPiano":"Piano","inputMic":"Micrófono","inputMidi":"Teclado MIDI","micNoRhythm":"Con el micrófono solo se miden las notas: la detección de altura llega después del ataque, y cronometrar eso sería inventar precisión.","measure":"Compás","hits":"Notas","wasNote":"¡Era {note}!","results":{"notes":"Notas","notesHint":"{hits} de {total} alturas correctas","rhythm":"Ritmo","rhythmNotMeasured":"no medido con el micrófono","missed":"Notas que pasaron","extras":"Notas de más","onTime":"a tempo","rushing":"adelantando {ms} ms","dragging":"atrasando {ms} ms","starRecord":"¡Nuevo récord de estrellas!","again":"Tocar de nuevo","toStudy":"Ir al estudio","toTempo":"Ahora a tempo","studyDone":"¡Pieza completa!","studyLine":"{notes} notas · {wrong} intentos fallidos","studyNext":"Cuando tengas la pieza en los dedos, cambia al modo a tempo — allí la partitura avanza sola y se mide tu ritmo.","noStar":"Sin estrellas: la estrella necesita el ritmo medido, y el micrófono no mide el instante del ataque. Toca en el piano de la pantalla o en un teclado MIDI para conseguirla.","freeNoRecord":"Esta es tu propia música: la estrella vale para esta sesión. El récord solo existe en las canciones del catálogo.","pick":"Elegir otra canción"},"skipNote":"Saltar esta nota","interrupted":"La ronda se interrumpió porque la página pasó a segundo plano. No se puntuó nada — empieza de nuevo cuando puedas seguirla.","import":{"title":"Tu propia música","lead":"Carga un archivo MIDI (.mid) y lee esa música en el pentagrama. El archivo no sale de tu aparato.","choose":"Elegir archivo .mid","demo":"Usar el ejemplo","drop":"Suelta aquí el archivo .mid","reading":"Leyendo el archivo…","privacy":"Todo ocurre aquí en tu navegador: el archivo no se envía a ningún servidor.","privacyAccount":"La lectura ocurre aquí en tu navegador. Con tu cuenta, el archivo también queda guardado en ella — así es como aparece en tu otro aparato.","track":"Pista","trackN":"Pista {n}","notesWord":"notas","drums":"percusión","summary":"{notes} notas · {measures} compases · {ts} · {key} · clave de {clef}","clef":{"treble":"sol","bass":"fa"},"errTitle":"No se pudo convertir este archivo en partitura","warn":{"polyphonyReduced":"Esta pista tiene más de una voz: vas a estudiar la de arriba (la melodía). {dropped} notas quedaron fuera.","mergedNotes":"Notas simultáneas iguales se unieron en una sola.","keyInferred":"El archivo no indica la tonalidad — elegimos la que necesita menos alteraciones.","tempoChanges":"El archivo cambia de tempo {count} vez(ces); aquí lees a un solo tempo, el que elijas.","timeChanges":"El archivo cambia de compás {count} vez(ces); la partitura usa el primero de principio a fin.","drums":"Esta pista es de percusión: los sonidos no tienen altura definida para leer en el pentagrama.","drumsFiltered":"Esta pista tenía percusión mezclada con la melodía: las {dropped} notas de percusión quedaron fuera (no tienen altura para leer en el pentagrama).","snapped":"{count} nota(s) no caían exactamente en la rejilla y se ajustaron a la figura más cercana."},"err":{"notMidi":"Este archivo no es un MIDI (.mid). Un PDF o un MP3 todavía no sirven — necesitamos el MIDI.","format2":"Este MIDI es de tipo 2 (patrones independientes) y no forma una pieza continua. Expórtalo como tipo 0 o 1.","smpte":"Este MIDI mide el tiempo en cuadros de video, no en tiempos musicales — no se puede escribir su partitura.","badPpq":"El encabezado de este MIDI está dañado (división de tiempo inválida).","tooBig":"Archivo demasiado grande ({kb} KB). El límite es {max} KB — un MIDI de partitura pesa pocos KB.","noTracks":"Este MIDI no tiene ninguna pista con música.","noSuchTrack":"Esa pista no existe en el archivo.","emptyTrack":"La pista elegida no tiene notas. Prueba con otra.","offGrid":"{percent}% de las notas no caen en ninguna figura: este archivo parece una grabación en vivo, no una partitura. Un MIDI exportado de un editor de partituras sí funciona.","tuplets":"Esta música tiene tresillos, que todavía no sabemos escribir. Estamos trabajando en ello.","tooManyNotes":"Demasiado larga para el v1: {notes} notas (el límite es {max}).","tooManyMeasures":"Demasiado larga para el v1: {measures} compases (el límite es {max}).","internal":"No pudimos armar la partitura de este archivo.","readFailed":"No se pudo leer el archivo. Inténtalo de nuevo.","unknown":"No se pudo leer este archivo MIDI.","badTimeSignature":"El compás de este archivo ({beats}/{value}) no es válido.","demoFailed":"No pudimos cargar el ejemplo ahora. Si estás sin conexión, elige un archivo de tu aparato."},"back":"{file}","tap":"Toca para elegir el archivo .mid"},"listenPartial":"El ejemplo sonoro llega hasta el compás {measure} — la pieza es demasiado larga para tocarla entera.","harmony":{"open":"Cifrados","title":"Cifrados","lead":"Elige un compás y planta el acorde. Los cifrados pasan junto a la melodía mientras tocas.","grid":"Rejilla","grid_measure":"Compás","grid_half":"Mitad","grid_beat":"Tiempo","pickup":"anacrusa","at":"Compás {measure} · {chord}","repeat":"Repetir","delete":"Borrar","clearAll":"Borrar todos","clearAllAsk":"¿Borrar los {n} acordes de esta música?","confirmClear":"Borrar todo","done":"Listo","count":"{n} acordes en esta música","dropped":"{n} acordes quedaron fuera de esta pista y se descartaron.","summary":"{n} acordes plantados","count_one":"1 acorde en esta música","summary_one":"1 acorde plantado","dropped_one":"1 acorde quedó fuera de esta pista y se descartó.","tooMany":"Esta música superó los {max} acordes — los excedentes no se guardaron.","notSaved":"No se pudieron guardar los cifrados en este aparato (memoria del navegador llena). Valen solo para esta sesión."},"modePlay":"Acompañar","modePlayHint":"En el modo acompañar la partitura avanza a tempo, con metrónomo, y no se mide nada: es para tocar la música — melodía, cifrados o ambos — a tu manera.","playing":"Toca a tu gusto. No se está midiendo nada.","playDone":"Fin de la pieza.","shelf":{"addFile":"Importar un archivo .mid","empty":"Todavía no hay nada guardado. Importa un archivo .mid y se queda aquí.","untitled":"sin nombre","noChords":"sin cifrados","remove":"Borrar","removeAsk":"¿Borrar “{name}” de este aparato?","removeAskChords":"¿Borrar “{name}” de este aparato? Los {n} cifrados siguen guardados: si importas el mismo archivo otra vez, vuelven.","removeAskChords_one":"¿Borrar “{name}” de este aparato? El cifrado sigue guardado: si importas el mismo archivo otra vez, vuelve.","full":"Ya tienes {max} canciones — el límite de este aparato. Esta la puedes tocar ahora, pero para guardarla borra una de la lista.","fullBytes":"Se acabó el espacio para canciones en este aparato. Esta la puedes tocar ahora, pero para guardarla borra una de la lista.","gone":"Esta canción ya no está guardada en este aparato.","kb":"{n} KB","mb":"{n} MB","chords":"{n} cifrados","chords_one":"1 cifrado"},"cloud":{"title":"Tus canciones en tu cuenta","status":"{n} de {max} canciones en tu cuenta","notSynced":"Aún no sincronizado en este aparato.","tooNew":"{n} no se pudieron leer (hechas en una versión más nueva de la app)","tooNew_one":"1 no se pudo leer (hecha en una versión más nueva de la app)","inAccount":"En tu cuenta:","forget":"Quitar de la cuenta","forgetAsk":"¿Quitar “{name}” de tu cuenta? Sigue en este aparato, con sus cifrados.","syncNow":"Sincronizar ahora","syncing":"Sincronizando…","guest":"Entra en tu cuenta para que tus canciones y cifrados aparezcan en cualquier aparato.","login":"Entrar en mi cuenta","note":"Tus canciones y tus cifrados quedan guardados en tu cuenta. En el otro aparato, entra y toca Sincronizar: bajan solos.","sent":"{n} canciones enviadas","sent_one":"1 canción enviada","got":"{n} cifrados nuevos","got_one":"1 cifrado nuevo","full":"{n} no cupieron en tu cuenta (caben {max})","full_one":"1 no cupo en tu cuenta (caben {max})","gotFiles":"{n} canciones descargadas a este aparato","gotFiles_one":"1 canción descargada a este aparato","noRoom":"{n} no cupieron en este aparato","noRoom_one":"1 no cupo en este aparato","fileErr":"{n} archivos no llegaron — toca Sincronizar otra vez","fileErr_one":"1 archivo no llegó — toca Sincronizar otra vez","nothing":"Todo ya estaba sincronizado.","err":"No se pudo contactar con tu cuenta ahora. Tus canciones siguen guardadas en este aparato."},"backup":{"export":"Descargar una copia (.json)","share":"Enviar una copia","import":"Restaurar desde un archivo","note":"La copia es un archivo .json que se queda contigo: llévalo a otro aparato e impórtalo aquí. Importar SUMA canciones y cifrados — nunca borra lo que ya está guardado.","empty":"Todavía no hay nada que exportar.","noRoom":"{n} no cupieron en la estantería (sus cifrados sí se guardaron)","fixed":"{n} identificaciones recalculadas por el archivo","skipped":"{n} elementos rechazados","added":"{n} canciones nuevas","added_one":"1 canción nueva","updated":"{n} actualizadas","updated_one":"1 actualizada","chords":"{n} cifrados nuevos","chords_one":"1 cifrado nuevo","noShelf":"{n} canciones no se pudieron guardar en este navegador (sus cifrados sí se guardaron)","noShelf_one":"1 canción no se pudo guardar en este navegador (sus cifrados sí se guardaron)","noRoom_one":"1 no cupo en la estantería (sus cifrados sí se guardaron)","fixed_one":"1 identificación recalculada por el archivo","rejected":"{n} cifrados de la copia fueron rechazados por estar dañados","rejected_one":"1 cifrado de la copia fue rechazado por estar dañado","skipped_one":"1 elemento rechazado","nothing":"Nada nuevo: esta copia ya estaba entera aquí.","err":{"empty":"El archivo está vacío.","notJson":"Este archivo no es un .json válido.","notOurs":"Este .json no es un repertorio de Oído Absoluto Class.","newerVersion":"Esta copia se hizo con una versión más nueva de la app (formato {version}). Actualiza la app e inténtalo de nuevo.","tooBig":"El archivo supera los {mb} MB.","badSong":"No se pudo leer ninguna canción de esta copia.","songTooBig":"“{name}” es demasiado grande y fue rechazada.","badVersion":"Este archivo no dice en qué formato se hizo — no se puede confiar en él."}},"pick":{"title":"Elegir canción","lead":"Tus canciones y las de la app. Elige una para abrirla.","open":"Elegir canción","mine":"Tus canciones","app":"De la app","current":"abierta ahora"}},"music":{"major":"mayor","minor":"menor"},"help":{"dotAria":"Ayuda: {subject}","prev":"Anterior","next":"Siguiente","gotIt":"Entendido","tabs":{"explain":"Explicación","video":"Vídeo","faq":"Preguntas"},"flow":{"howto":{"title":"Cómo funciona la cinta de notas","p1":{"title":"Las notas avanzan solas, de derecha a izquierda","body":"La nota de color más fuerte, con el círculo punteado alrededor, es tu turno: esa es la que tienes que nombrar. Las demás están solo en la fila, esperando."},"p2":{"title":"La franja roja es el plazo","body":"Si la nota llega a la franja roja punteada sin respuesta, desaparece y cuenta como error. No hace falta correr: en los primeros niveles la cinta avanza despacio a propósito."}},"input":{"title":"Cómo responder: botón, piano o tu propio instrumento","p1":{"title":"Cuatro maneras de decir cuál es la nota","body":"Botones muestra el nombre de la nota escrito. Piano pide la tecla correcta. Micrófono escucha tu piano acústico por el aparato, y MIDI recibe el teclado conectado al ordenador — esos dos solo aparecen cuando el aparato lo permite."},"p2":{"title":"Por qué se bloquean los botones","body":"Del nivel 2 en adelante la respuesta es la tecla, no el nombre: eso es lo que une el pentagrama al instrumento. Los botones siguen en la lista, con candado, para que veas que no desaparecieron."}},"kids":{"title":"El modo Kids","p1":{"title":"Cada nota tiene su color","body":"En Kids la nota tiene un color propio en el pentagrama, y el mismo color aparece en el botón y en la tecla. El niño la encuentra por el color antes de saber el nombre — y la cinta avanza más despacio, con más espacio entre las notas."},"p2":{"title":"El color se va solo, por mérito","body":"Después de algunos aciertos seguidos, el color de esa nota desaparece del botón; en el pentagrama se queda. El cuadro de abajo muestra qué notas ya respondes sin el color. Nadie tiene que apagar nada: la muleta se deshace sola."}},"exitLine":{"title":"La franja roja punteada","p1":{"title":"Es el plazo de esa nota, no el final del juego","body":"Cada nota tiene hasta llegar a la franja roja para ser nombrada. Si llega sin respuesta, desaparece y cuenta como error — pero la cinta sigue, y la siguiente ya viene en camino. Fallar una no arruina la ronda."},"q1":{"q":"La nota desapareció y ni la vi. ¿Qué pasó?","a":"Pasó de la franja roja. En los primeros niveles esto casi no ocurre, porque la cinta va despacio; en los niveles altos acelera a propósito. Si va demasiado rápido, baja un nivel — el nombre de la nota tiene que salir sin pensar antes de que la velocidad tenga sentido."}}},"intervals":{"howto":{"title":"Qué es un intervalo","p1":{"title":"Es la distancia entre dos notas","body":"El juego toca dos notas — una después de la otra, o las dos juntas. La distancia entre ellas es lo que los músicos llaman intervalo: las notas vecinas suenan casi iguales, las notas alejadas dan un salto que se oye enseguida."},"p2":{"title":"Es entrenamiento de oído, no de vista","body":"No necesitas ver nada para responder; el piano de la pantalla solo muestra después cuáles fueron las dos notas. Si no recuerdas el sonido, pulsa Repetir tantas veces como quieras — no cuesta ningún punto. El nivel 1 tiene solo dos respuestas posibles."}},"assist":{"title":"“Ver teclas”: qué cambia","p1":{"title":"Es la pista visual, y es opcional","body":"Con “Ver teclas” en Sí, el piano de la pantalla enciende las notas mientras suena: puedes comprobar con los ojos lo que oyó el oído. Viene apagado — toca Sí para encenderlo. En No respondes solo de oído, que es el objetivo del entrenamiento. Activarlo o desactivarlo no cambia el nivel ni la puntuación: empieza en Sí y apágalo cuando el sonido ya sea reconocible."}},"mode":{"title":"Escuchar e identificar × Construir en el piano","p1":{"title":"Dos formas de responder a la misma pregunta","body":"En “Escuchar e identificar” el juego toca el intervalo y tú eliges su nombre. En “Construir en el piano” el juego da la primera nota y el nombre del intervalo, y tú tocas la segunda en el teclado. El primero entrena reconocer; el segundo entrena producir — y es el segundo el que vas a usar cuando estés tocando."}},"play":{"title":"Melódico × Armónico","p1":{"title":"Las dos notas en fila, o las dos a la vez","body":"En Melódico las notas vienen una después de la otra, como una melodía — puedes seguir el camino de una a la otra. En Armónico suenan juntas, y entonces oyes el acorde que forman, no el recorrido. Armónico es bastante más difícil: es el mismo intervalo, pero el oído tiene que separar dos sonidos apilados."}}},"chords":{"howto":{"title":"Qué es un acorde","p1":{"title":"Son tres o más notas sonando juntas","body":"Una nota sola es una nota. Tres pulsadas al mismo tiempo forman un acorde — es el sonido de la guitarra cuando rasgueas todas las cuerdas de una vez."},"p2":{"title":"Un atajo para empezar","body":"Mayor suena alegre, menor suena triste. Eso ya resuelve el nivel 1 entero, que solo tiene esas dos respuestas. Es entrenamiento de oído: si no estás seguro, pulsa Repetir — la app lo toca de nuevo, sin coste ninguno."}},"play":{"title":"“En bloque” × “Arpegio”","p1":{"title":"Las mismas notas, en dos formas de tocar","body":"Con En bloque las notas suenan todas en el mismo instante, como una guitarra rasgueada: el acorde entero de una vez. En Arpegio vienen una a una, de abajo hacia arriba, como una guitarra punteada — se puede oír cada nota por separado. El acorde es el mismo; si cuesta oír por dentro, empieza por el Arpegio."}}},"song":{"mode":{"title":"¿Qué modo elegir?","p1":{"title":"Estudio — para aprender","body":"La partitura se para en cada nota y espera a que toques la correcta. No cuenta para la puntuación: es entrenamiento. Es por aquí por donde se empieza una pieza nueva."},"p2":{"title":"A tempo — para ponerte a prueba","body":"La partitura avanza firme, con metrónomo, y la app mide las notas correctas y la precisión del ataque. Cambia aquí cuando la pieza ya la tengas en la mano."},"p3":{"title":"Acompañar — para tocar por placer","body":"La partitura avanza a tempo y no se mide nada: es para tocar la música — melodía, cifrado, o las dos — a tu manera."}},"tempo":{"title":"El “Tempo”","p1":{"title":"La velocidad a la que avanza la partitura","body":"Arrastra a la izquierda para ir más despacio, a la derecha para ir más rápido. En modo Estudio gobierna cuánto camina la cinta entre una nota y otra; en A tempo y Acompañar es la velocidad real de la música."},"q1":{"q":"¿Puedo tocar mucho más despacio que el original?","a":"Puedes, y debes. Estudiar despacio e ir acelerando poco a poco es como se aprende una pieza — nada en la app penaliza un tempo bajo."}},"input":{"title":"Por dónde tocas","p1":{"title":"Piano de pantalla, micrófono o teclado MIDI","body":"Piano es el teclado dibujado en la pantalla, que funciona en cualquier aparato. Micrófono escucha tu piano acústico y reconoce la nota por el sonido. Teclado MIDI recibe el instrumento conectado por cable. Los tres responden lo mismo — solo cambia por dónde entra la nota; micrófono y MIDI solo aparecen cuando el aparato lo permite."}},"chart":{"title":"Los cifrados","p1":{"title":"El nombre del acorde escrito encima de la música","body":"El cifrado es el nombre del acorde — C, G7, Am — escrito sobre la partitura, diciendo qué toca la mano de la armonía en ese tramo. Quien acompaña a la guitarra o toca de oído lee el cifrado, no la melodía entera."},"p2":{"title":"Tú plantas los tuyos, y se quedan","body":"Abre “Cifrados” y escribe el acorde en cada punto de la música. Se guardan con ese archivo en este aparato y aparecen cada vez que abres la pieza. Algunas canciones del catálogo ya vienen con cifrado — y lo que tú escribas por encima vale más que el de fábrica, incluso si los borras todos."},"q1":{"q":"¿La app toca los cifrados?","a":"Todavía no. Están escritos para que los toques TÚ — en la guitarra, en la mano izquierda del piano, en el instrumento que sea. Para acompañar sin que te evalúen las notas, usa el modo Acompañar."}},"chartGrid":{"title":"Escribir cifrado en la cuadrícula","p1":{"title":"Por qué la cuadrícula, y no la partitura rodando","body":"Escribir directamente en la cinta obligaría a cazar el punto exacto en una pantalla que muestra poco más de un compás cada vez — en una canción de treinta compases serían veinticinco páginas de tanteo. La cuadrícula muestra la canción entera de una vez: ves dónde entra cada acorde."},"p2":{"title":"Compás, mitad o tiempo","body":"Elige cada cuánto quieres poder escribir. Compás sirve para la mayoría de las canciones populares, en las que el acorde dura el compás entero. Mitad y Tiempo dan puntos más menudos, para cuando la armonía se mueve más rápido."}},"midi":{"title":"Traer tu archivo MIDI","p1":{"title":"Cualquier .mid se convierte en partitura en la cinta","body":"Elige un archivo .mid del aparato y la app lo lee allí mismo, en el navegador: monta la partitura, elige la clave y la armadura y pone la melodía a rodar. El archivo NO se envía a ningún servidor."},"p2":{"title":"Algunos archivos se rechazan — y es a propósito","body":"MIDI guarda cuándo suena cada nota, no cómo se escribe. Si el archivo tiene notas que no caen en la rejilla rítmica — tresillos, una interpretación humana grabada en directo, rubato — la app dice qué no cupo en vez de dibujar una partitura torcida. Un rechazo con explicación vale más que una página equivocada."},"q1":{"q":"¿Dónde consigo archivos .mid?","a":"Hay grandes archivos de dominio público en internet, y la mayoría de los editores de partitura (MuseScore, por ejemplo) exporta .mid. Respeta los derechos de autor de lo que descargues."},"q2":{"q":"La pieza que importé no guarda récord. ¿Por qué?","a":"Porque no habría con qué compararla: cada persona trae un archivo distinto, con notas y dificultad distintas. La puntuación aparece en pantalla, pero no entra en la clasificación."}},"lists":{"title":"La lista de canciones","p1":{"title":"El catálogo de la app y tus archivos, en la misma lista","body":"Arriba están las canciones que vienen con la app, todas de dominio público. Abajo están los archivos .mid que has traído. Es una sola lista, en las dos puertas del juego: cambias de pieza sin salir a ningún sitio."}},"account":{"title":"Dónde queda tu archivo","p1":{"title":"En el aparato, y solo ahí","body":"El .mid que importas se guarda en este navegador, en este aparato. No sube a ningún servidor, y por eso no sigue a tu cuenta: entrar en otro móvil no trae tus canciones contigo. Para llevártelas, usa la copia de seguridad."},"q1":{"q":"Si borro los datos del navegador, ¿lo pierdo todo?","a":"Lo pierdes. Haz antes la copia en .json — guarda los cifrados que escribiste, ligados a cada canción. Los archivos .mid no van en ella: guárdalos en la misma carpeta que la copia y tu repertorio vuelve entero."}},"backup":{"title":"Copia de seguridad de tu repertorio","p1":{"title":"Un archivo .json con tus cifrados","body":"Pulsa “Enviar una copia” (o “Descargar una copia (.json)”) y la app genera un archivo con los cifrados que escribiste, ligados a cada canción. Guarda ese archivo donde quieras — correo, nube, memoria USB: es lo que sobrevive al cambio de aparato o al borrado del navegador."},"p2":{"title":"“Restaurar desde un archivo” SUMA, nunca borra","body":"Al traer una copia de vuelta, sus cifrados se juntan con los que ya están aquí. No se borra nada: si un punto tiene cifrado en los dos lados, se queda el que ya estaba en el aparato. Importar dos veces no hace ningún daño."},"q1":{"q":"¿La copia guarda también los archivos .mid?","a":"No, solo los cifrados. Los archivos .mid ya los tienes — guárdalos en la misma carpeta que la copia y podrás recuperar tu repertorio entero."}},"results":{"title":"La puntuación de la canción","p1":{"title":"Notas correctas y precisión del ataque","body":"Notas dice cuántas tocaste bien. Precisión dice hasta qué punto caíste junto al tiempo en cada una. Las dos solo se miden en el modo A tempo — en Estudio la partitura te espera, y en Acompañar no se mide nada."},"p2":{"title":"Las estrellas guardan tu mejor marca","body":"Las estrellas guardan tu mejor pasada en esa canción del catálogo, y no bajan cuando lo intentas otra vez y sale peor. Una pieza que importaste no guarda estrellas: sin que todo el mundo toque lo mismo, no habría con qué comparar."}}},"reading":{"howto":{"title":"Entrenamiento libre: una nota cada vez","p1":{"title":"Aquí no corre nada","body":"Aparece UNA nota en el pentagrama y espera. Tú dices cuál es, sin reloj y sin cinta. Es el lugar para aprender el nombre de las notas con calma — y al que volver cuando la lectura en flujo empieza a apretar."},"p2":{"title":"No cuenta para nada, y por eso sirve","body":"El entrenamiento libre no da puntos, no sube de nivel y no entra en la clasificación. Existe para que falles a gusto: es donde se memoriza, no donde se demuestra."}},"guide":{"title":"La línea guía (⚙️ Opciones)","p1":{"title":"Una línea de la nota hasta la tecla correcta","body":"La línea guía une la nota del pentagrama con la tecla (o el botón) que la responde. Quien empieza todavía no tiene ese camino en la cabeza — la línea lo dibuja hasta que se vuelve automático."},"p2":{"title":"Tres ajustes, de más a menos ayuda","body":"Siempre muestra la línea en todas las notas. Solo al fallar hace que la línea aparezca en la corrección, señalando dónde estaba. Desactivada quita la ayuda visual. Empieza en Siempre y baja un escalón cuando estés acertando sin mirar."}},"clef":{"title":"La clave (⚙️ Opciones)","p1":{"title":"Sol, fa o las dos","body":"La clave dice qué nota vive en cada línea. La de sol es la de las notas agudas (mano derecha del piano, violín, flauta); la de fa, la de las graves (mano izquierda, violonchelo, bajo). Con “Las dos” la clave cambia en cada nota: lee la clave antes que la nota."}},"key":{"title":"La tonalidad (⚙️ Opciones)","p1":{"title":"Los signos justo después de la clave","body":"La armadura es el grupo de sostenidos o bemoles escrito después de la clave, y vale para toda la pieza: con un sostenido, todo Fa es Fa♯, sin signo en la nota. Cada tonalidad mayor tiene su armadura, y la relativa menor usa la misma: para entrenar La menor, elige Do mayor."},"p2":{"title":"Cómo lo usa el entrenamiento","body":"Las notas sorteadas siguen la armadura. En el piano, la respuesta es la tecla correcta (en general la negra, cuando la nota está alterada); en los botones aparecen también los nombres alterados, como Fa♯, y “Fa” para un Fa♯ escrito cuenta como error. Marca tantas tonalidades como quieras: la armadura se sortea entre las marcadas en cada “Jugar de nuevo” (una sola marcada = siempre la misma). Empieza con una o dos alteraciones."}},"sound":{"title":"Piano real (⚙️ Opciones)","p1":{"title":"Sonidos de un piano de verdad","body":"Activado, la app descarga grabaciones de un piano (unos 1,6 MB, una sola vez; queda guardado en el dispositivo) y toca la nota con ese sonido. Desactivado, la nota suena como un tono simple. Vale para todos los juegos."}}},"rhythm":{"howto":{"title":"Cómo jugar al Ritmo","p1":{"title":"La línea avanza; tú tocas cuando cruza una nota","body":"La partitura se queda quieta y una línea atraviesa la pantalla de izquierda a derecha, siempre a la misma velocidad. Cada vez que la línea cruza una nota, es el momento de tocar. Dónde está la nota en la pantalla es CUÁNDO suena."},"p2":{"title":"En el ordenador es la barra espaciadora; en el móvil, el dedo en TOCA","body":"En el ordenador, pulsa la barra espaciadora. En el móvil, toca y mantén el botón grande que dice TOCA. Mantenlo mientras dure la nota y suéltalo al final — toda nota se mantiene hasta que acaba, la corta solo dura menos."},"p3":{"title":"Antes de empezar, la cuenta","body":"Cada ronda empieza con la cuenta del metrónomo para que cojas el tempo: cuatro clics, en 4/4. No toques con ellos: son la cuenta de entrada. La primera nota viene justo después del último clic."},"q1":{"q":"Toco a tiempo, pero la app dice que fallé.","a":"Mira primero los DOS marcadores. Si el Inicio está alto y la Duración baja, tu tiempo está bien: lo que falta es mantener cada nota hasta que acabe, en vez de dar un toque rápido. Si ambos están bajos, puede que el sonido salga con retraso — los auriculares Bluetooth son el caso más común. La app intenta descontar ese retraso sola, pero no todo aparato informa el valor correcto: prueba a jugar con el altavoz o con auriculares de cable."},"q2":{"q":"¿Necesito saber leer partitura para jugar?","a":"No. No hace falta saber el nombre de las figuras: basta con ver dónde están las notas y tocar cuando la línea cruce cada una. Los nombres los aprendes después, jugando."}},"tempo":{"title":"El “Tempo” (BPM)","p1":{"title":"Es la velocidad de la música","body":"BPM quiere decir tiempos por minuto: cuántas veces hace clic el metrónomo en un minuto. Menos BPM, más despacio y más fácil de acertar. El margen de error de la app es el mismo a cualquier velocidad — así que acelerar hace el ejercicio más difícil, y ralentizar es una forma perfectamente legítima de estudiar."}},"results":{"title":"“Inicio” y “Duración”: qué dicen los números","p1":{"title":"Inicio es CUÁNDO tocaste","body":"Inicio mide hasta qué punto acertaste el momento de cada nota — si tu toque cayó junto con la línea o un poco antes o después. Es el número más importante del juego: es el que dice si estás a tiempo."},"p2":{"title":"Duración es CUÁNTO mantuviste","body":"Duración mide si mantuviste la tecla el tiempo que pedía la figura: soltar demasiado pronto en una nota larga, o mantener de más en una corta, baja este número. Es más exigente en las figuras cortas, porque duran menos — y por eso suele ser el más bajo de los dos."},"q1":{"q":"Mi “Inicio” está alto y la “Duración” baja. ¿Está mal?","a":"No. Es lo más común, y quiere decir que estás a tiempo pero todavía no controlas el largo de las notas. Trabaja soltando la tecla al final de la nota, en vez de justo después de tocarla."},"q2":{"q":"Pasé de nivel aun con un número bajo. ¿Cómo?","a":"La aprobación del nivel mira el conjunto, no un número aislado. Uno bajo no suspende por sí solo — pero es el que te muestra qué estudiar la próxima vez."}},"trails":{"title":"Qué es una ruta","p1":{"title":"Una secuencia de ejercicios, a tu manera","body":"Una ruta es una lista de ejercicios de Ritmo que armas tú: cada nivel es un ejercicio (figuras, compás, tempo y, si quieres, una nota para pasar). La clase los juega uno a uno, en orden. Puede tener un solo nivel o treinta."},"p2":{"title":"Ármala en el taller, envía el enlace, haz seguimiento","body":"Este botón lleva el ejercicio que está en pantalla a una ruta (nueva, o el siguiente nivel de una que ya tienes). En el taller de la ruta ajustas cada nivel, ves un ejemplo de lo que verá la clase y lo pruebas. Luego copias el enlace: quien lo abra entra en su cuenta y juega, y tú ves cuántos empezaron y terminaron. También puedes empezar por “Mis rutas”, en tu cuenta."},"action":"Ver una ruta de ejemplo"},"pitch":{"title":"Notas en su altura","p1":{"title":"Cada nota en la línea donde suena","body":"Con “Melodía”, la app puede dibujar cada nota del ritmo en la línea del pentagrama donde suena, como en una partitura de verdad: plica hacia abajo en las notas agudas y línea adicional en el Do grave. Apagado, todas quedan en la línea del medio. La puntuación no cambia: el juego mide solo el tiempo."}},"sound":{"title":"Sonido de la nota","p1":{"title":"La nota que escuchas","body":"Es la nota que toca el modelo en “Escuchar” y la que toca el botón cuando lo presionas. Elige una nota, o “Melodía” para que las notas del ritmo cambien de altura, como una pequeña melodía que cambia en cada ritmo. La puntuación no cambia: el juego mide solo el tiempo."}},"ruler":{"title":"Regla de tiempos","p1":{"title":"Los números debajo del pentagrama","body":"Marcan los tiempos de cada compás, para ayudarte a contar mientras tocas. Cuando ya cuentes solo, puedes ocultarla. La puntuación es la misma con o sin ella."}},"midi":{"title":"Teclado MIDI","p1":{"title":"Tocar el ritmo en tu instrumento","body":"Activa esta opción y toca el ritmo en tu teclado o controlador MIDI conectado a la computadora (cable USB o Bluetooth). Cada tecla que presionas cuenta como un toque en el botón, y mantener la tecla es mantener la nota. Sirve cualquier tecla: el juego mide solo el tiempo, no la altura. El sonido que escuchas es la nota que tocaste; si tu piano también suena por su cuenta, bájale el volumen para no oírlo doble. Lo que cuenta es la tecla mantenida: el pedal de sustain no cuenta como duración. Dos o más teclas tocadas juntas (acorde, octava) cuentan como un solo toque. En iPhone y iPad esta opción no aparece: su navegador no tiene MIDI."}}},"app":{"levelGate":{"title":"Por qué están bloqueados los niveles","p1":{"title":"Los niveles se abren en orden","body":"Cada nivel desbloquea el siguiente. Termina el nivel 1 y el 2 se abre solo, sin nada que configurar. El candado quiere decir “todavía no”, nunca “no puedes”."},"p2":{"title":"Los tres primeros los juegas sin cuenta","body":"Juegas los tres primeros niveles de cada recorrido sin nada. Del cuarto en adelante la app pide una cuenta — lleva un minuto, y puedes entrar con Google."},"p3":{"title":"La cuenta existe para que tu progreso no viva en el navegador","body":"Sin cuenta, tu avance se guarda solo en este navegador: cambias de móvil, o borras los datos, y desaparece. Con cuenta te sigue — y la clasificación empieza a tener sentido, porque hay alguien al otro lado del marcador."},"q1":{"q":"¿Voy a perder lo que ya jugué sin cuenta?","a":"No. Al crear la cuenta, el progreso de este aparato lo adopta ella. La única excepción es una cuenta que ya jugó aquí antes: esa mantiene su propio progreso, que es el más avanzado de los dos."}},"freeMode":{"title":"Modo libre × recorrido de niveles","p1":{"title":"Uno entrena lo que tú elijas; el otro tiene principio, medio y fin","body":"El recorrido de niveles va de fácil a difícil en un orden pensado, guarda tu mejor marca de cada nivel y entra en la clasificación. El modo libre no tiene orden ni marca guardada: eliges qué entrenar y repites a gusto. Usa el recorrido para avanzar y el libre para insistir en lo que todavía no sale."}},"groups":{"title":"Grupos (escuela o clase)","p1":{"title":"Qué es un grupo","body":"Un grupo representa una escuela o una clase dentro de la app. Quien organiza — un profesor o la coordinación — pide el grupo aquí mismo: un nombre, una descripción corta y, si quiere, un logo. El pedido se libera en poco tiempo y la confirmación llega por correo. Los alumnos entran después, cada uno con su cuenta."},"p2":{"title":"Cómo se entra y qué se ve","body":"Una vez liberado, el grupo tiene su propia página, más un código de invitación y un enlace en \"Mi cuenta\". Quien organiza pasa uno de los dos a los alumnos. Quien entra ve, además del ranking general, uno solo del grupo: el nivel alcanzado y la precisión de cada persona. Quien organiza ve ese ranking sin entrar en el grupo — y, si quiere participar, entra con el código como los alumnos."},"q1":{"q":"¿Salir del grupo borra mi progreso?","a":"No. Salir solo quita tu nombre del ranking del grupo. Todo tu progreso se mantiene igual."}}},"title":"Ayuda","subtitle":"Todo lo que la app explica, en un solo sitio.","sub":"Cómo jugar, dudas y primeros pasos","searchPlaceholder":"Buscar ayuda…","searchEmpty":"No se encontró nada para “{q}”. Prueba otra palabra — o baja y busca por el juego.","hereTitle":"Ayuda de esta pantalla","hereFrom":"Vienes de: {game}","firstTitle":"Primeros pasos","firstSub":"Las dudas de quien acaba de llegar.","byGameTitle":"Ayuda por juego","byGameSub":"Toca un asunto para abrir la explicación.","guidesTitle":"Guías interactivas","guidesSub":"Páginas de nuestro sitio que explican el tema con sonido y movimiento. Se abren en una pestaña nueva y la app se queda aquí.","topicsN":"{n} asuntos","topicsOne":"1 asunto","backToResult":"◀ Volver al resultado","groups":{"app":"La app"},"levelsLabel":"Niveles:","pageOf":"Página {n} de {total}"},"group":{"title":"Grupo","newTitle":"Pedir la creación de un grupo","form":{"intro":"Cuenta quién es la escuela o la clase. Lo que escribes aquí aparece en la página del grupo, que es pública; la observación es solo para la administración.","nameLabel":"Nombre de la escuela o de la clase","descLabel":"Descripción","descHint":"Hasta {max} caracteres. Escribe en tu idioma: la página lo traduce a los otros dos.","logoLabel":"Logo (opcional)","logoHint":"PNG, JPG, GIF o WebP hasta 2 MB. La imagen se redimensiona a 256×256.","logoChoose":"Elegir imagen","logoRemove":"Quitar el logo","logoSending":"Enviando el logo…","logoSaved":"Logo actualizado.","logoAfter":"El logo se puede enviar después de crear el pedido.","noteLabel":"Observación para la administración (opcional)","noteHint":"No aparece en la página.","submit":"Enviar pedido","save":"Guardar","saved":"Cambios guardados.","countryLabel":"País (opcional)","countryNone":"No mostrar","countryHint":"Si eliges uno, la bandera y el nombre del país aparecen en la página del grupo."},"sent":{"title":"Pedido enviado","body":"La administración revisa el pedido y recibes un correo. El código de invitación aparece en “Mi cuenta” cuando el grupo sea aprobado.","ok":"Entendido"},"guest":{"title":"Para pedir un grupo, entra en tu cuenta","body":"El grupo queda ligado a la cuenta de quien lo organiza."},"page":{"join":"Entrar a este grupo","joinLogin":"Entrar en la cuenta para participar","joined":"Estás en este grupo","owner":"Tú organizas este grupo","inOther":"Ya estás en otro grupo. Sal de él en “Mi cuenta” para entrar a este.","joinNote":"Quien entra aparece en el ranking del grupo, que es público, y quien lo organiza sigue su progreso. Puedes salir cuando quieras.","preview":"Vista previa: este grupo todavía no está aprobado. Solo tú y la administración ven esta página.","notFound":"Este grupo no existe o no está disponible.","noDescription":"Sin descripción.","logoAlt":"Logo de {name}","joining":"Entrando…","askCode":"Para entrar, pide el código de invitación a quien organiza el grupo y escríbelo en “Mi cuenta”."},"ranking":{"title":"Ranking del grupo","adminNote":"Estás viendo como administración del sitio y no apareces en la lista.","emptyViewer":"Nadie de {group} en el ranking de {game} todavía."},"news":{"badge":"Nuevo","country":"Ahora puedes mostrar el país del grupo, con su bandera, en la página. Elígelo en “Editar la página”.","ok":"Entendido"},"class":{"title":"Vista de la clase","private":"🔒 Solo quien organiza el grupo ve esta parte. Los alumnos no.","cardIntro":"Mira en qué nivel está cada alumno, quién ya lo intentó {n} veces o más sin pasar y, en Ritmo, qué le falta: sostener las notas o entrar a tiempo.","cardCta":"Abrir la vista de la clase","backPage":"Página del grupo","gameLabel":"Juego","inGame":"Juego: {game}","forbidden":"Solo quien organiza este grupo puede ver la clase.","empty":"Todavía no hay nadie en el grupo. Comparte el código de invitación con la clase.","noneStarted":"Nadie de la clase ha jugado {game} todavía.","statStudents":"alumnos en el grupo","statStudentOne":"alumno en el grupo","statRounds":"rondas","statTime":"tocando, sumados","statMid":"nivel del medio de la clase","playing":"{n} de {total} ya jugaron.","diaryOff":"{n} alumnos tienen el diario de juego apagado: su nivel aparece; rondas, tiempo e intentos no entran en las sumas.","diaryOffOne":"1 alumno tiene el diario de juego apagado: el nivel aparece; rondas, tiempo e intentos no entran en las sumas.","diaryOffStudent":"Diario de juego apagado: los intentos y el tiempo de este alumno no se registran.","whereTitle":"Dónde está cada alumno","whereHint":"Cada punto es un alumno, en el nivel que está intentando pasar ahora.","histAria":"Alumnos por nivel: {parts}","histPart":"nivel {level}: {n} alumnos","legendAdvancing":"avanzando","legendStuck":"{n} intentos o más en el mismo nivel","legendDone":"terminó el recorrido","tapHint":"Toca un alumno para ver el detalle.","pickLabel":"Ver alumno","pickNone":"Elige un alumno","notStarted":"Todavía no jugaron: {names}.","levels":"Niveles","level":"Nivel {n}","done":"Terminó el recorrido","noName":"(sin nombre)","best":"Mejor intento: {acc}%. El nivel pide {pass}%.","bestNoPass":"Mejor intento: {acc}%.","bestSplit":"Mejor intento: inicio {onset}% · duración {duration}%. El nivel pide {pass}% en los dos.","noBest":"Todavía sin puntuación en este nivel.","tries":"{n} intentos en el nivel {level}.","triesOne":"1 intento en el nivel {level}.","totals":"{rounds} rondas · {time} en {game}.","min":"{m} min","hm":"{h} h {m}","today":"hoy","yesterday":"ayer","stuckTitle":"Quién necesita una mano","stuckHint":"{n} intentos o más en el nivel actual sin pasar. La barra es el mejor intento; la marca es lo que pide el nivel.","stuckNone":"Nadie está atascado ahora.","stuckMore":"Ver los otros {n}","stuckMoreOne":"Ver 1 más","needs":"pide {pass}%","triesShort":"intentos","accuracy":"Mejor","badge":{"hold":"Falta sostener","timing":"Entrar a tiempo","generic":"Bajo la meta"},"diag":{"hold":"Entra a tiempo, pero suelta las notas antes: falta sostener cada nota hasta el final.","timing":"Sostiene las notas, pero entra fuera de tiempo: lo que falla es el comienzo de cada nota.","genericSplit":"Inicio y duración todavía por debajo del {pass}% que pide el nivel.","generic":"El mejor intento todavía está por debajo del {pass}% que pide el nivel."},"seriesTitle":"Rondas por día","seriesHint":"Últimos {n} días, en tu zona horaria.","seriesAria":"Rondas por día: {parts}","seriesPart":"{day}: {n} rondas, {players} alumnos","seriesEmpty":"Ninguna ronda registrada en los últimos {n} días.","seriesOff":"Sin diario de juego encendido en la clase: no hay rondas que contar.","wallsTitle":"Dónde suele trabarse la clase","wallsHint":"Cuántos intentos, en la mediana, pidió cada nivel hasta pasar (de quien pasó con el diario encendido).","wallsAria":"Intentos hasta pasar, por nivel: {parts}","wallsPart":"nivel {level}: mediana de {median} intentos ({n} alumnos)","wallsTop":"El nivel que más intentos pide: {level} (mediana de {median}, entre quienes ya pasaron).","wallsHere":"hay un alumno en este nivel ahora","wallsEmpty":"Todavía no se puede medir: nadie pasó un nivel con el diario encendido.","tableSummary":"Todos los alumnos ({n})","colName":"Alumno","colLevel":"Nivel","colTries":"Intentos","colRounds":"Rondas","colTime":"Tiempo","histPartOne":"nivel {level}: 1 alumno","histStuck":"{n} atascados","noRecords":"Sin registro en el diario de juego en este juego (jugó antes de que existiera el diario, o todavía no llegó nada).","world":"Mundo {n}","seriesPartOne":"{day}: {n} rondas, 1 alumno","wallsPartOne":"nivel {level}: {median} intentos (1 alumno solo)","wallsNow":"{n} parados en él ahora","wallsOnlyHere":"nivel {level}: todavía sin medir, {n} parados en él ahora"}},"trail":{"title":"Ruta","editTitle":"Editar ruta","by":"por {name}","bySchool":"por {name} · {school}","levels":"{n} niveles","levelsOne":"1 nivel","guestIntro":"Esta ruta es para quien tiene cuenta: tu avance queda guardado en este dispositivo y quien la armó sigue al grupo. Entrar o crear una cuenta toma un minuto.","play":"Jugar","continueAt":"Continuar en el nivel {n}","progress":"{done} de {total} niveles completados","cleared":"completado","current":"estás aquí","locked":"bloqueado","training":"práctica","sameRhythm":"mismo ritmo para todos","edit":"Editar la ruta","viewAsStudent":"Ver como alumno","link":"Enlace de la ruta","stats":"{started} empezaron · {finished} terminaron","statsNone":"Nadie ha jugado todavía.","notFound":"Esta ruta no existe o fue borrada.","cancel":"Cancelar","editor":{"name":"Nombre de la ruta","label":"Nombre del nivel (opcional)","labelPh":"Ej.: Pulso","pass":"Para pasar","takes":"Veces que hay que lograr la meta","seed":"Mismo ritmo para todos","dup":"Duplicar","del":"Borrar","add":"＋ Añadir nivel","delTrail":"Borrar ruta","delConfirm":"¿Borrar “{name}”? El enlace deja de funcionar para todos.","delLevelConfirm":"¿Borrar el nivel {n}?","saving":"Guardando…","saved":"Guardado.","measures":"compases","measureOne":"compás","ties":"ligadura","deleted":"Ruta borrada.","auto":"añadida para cerrar el compás","namePh":"Ej.: 6.º curso · negras","nameHint":"La clase ve este nombre.","s1":"Arma los niveles","s1Lead":"Cada nivel es un ejercicio. La clase los juega uno a uno, en orden.","s2":"Envía el enlace","s2Lead":"Quien lo abra entra en su cuenta (o crea una) y juega nivel a nivel.","s3":"Haz seguimiento","s3Lead":"Aquí aparece cuántos empezaron y cuántos terminaron.","newHint":"Empieza como copia del nivel {n}. Cambia una cosa: una figura más, el tempo, el compás.","exTitle":"Ejemplo de lo que verá la clase","otherEx":"🔀 Otro ejemplo","otherSeed":"🎲 Sortear otro ritmo","figs":"⚙️ Figuras y compás","panelTitle":"Figuras y compás · nivel {n}","resetLevel":"Restaurar valores","tempo":"Tempo","passTraining":"Sin meta","passNote":"Sin meta: juega, ve la puntuación y sigue al siguiente.","seedNote":"Activado: el ritmo del ejemplo de arriba es el que toca toda la clase — sortea hasta que te guste. Desactivado: cada ronda sortea otro.","test":"▶ Probar este nivel","addNote":"El nivel nuevo empieza como copia del anterior.","diffNew":"nuevo: {x}","diffOut":"sale: {x}","diffTempo":"tempo {a} → {b}","diffSig":"compás {a} → {b}","diffBars":"{n} compases","diffTiesOn":"con ligadura","diffTiesOff":"sin ligadura","diffSame":"igual al anterior","kicker":"Taller de la ruta"},"guestWhat":"Ejercicios de ritmo: lees el ritmo en la partitura y lo tocas al tiempo del metrónomo, nivel a nivel.","paused":"Esta ruta está pausada por la administración: quien abre el enlace no la ve.","playAgain":"Jugar de nuevo","asStudent":"Estás viendo como alumno","backToWorkshop":"← Volver al taller","deviceNote":"Tu avance en esta ruta queda guardado en este dispositivo."}}};

// ============================================
// core/EventBus.js
// ============================================
/**
 * EventBus - Sistema de eventos pub/sub
 * Permite comunicação desacoplada entre componentes
 */
class EventBus {
    constructor() {
        if (EventBus.instance) {
            return EventBus.instance;
        }
        this.listeners = new Map();
        EventBus.instance = this;
    }

    /**
     * Registra um listener para um evento
     * @param {string} event - Nome do evento
     * @param {Function} callback - Função a ser chamada
     * @returns {Function} - Função para remover o listener
     */
    on(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(callback);

        // Retorna função para remover o listener
        return () => this.off(event, callback);
    }

    /**
     * Registra um listener que será chamado apenas uma vez
     * @param {string} event - Nome do evento
     * @param {Function} callback - Função a ser chamada
     */
    once(event, callback) {
        const wrapper = (...args) => {
            this.off(event, wrapper);
            callback(...args);
        };
        this.on(event, wrapper);
    }

    /**
     * Remove um listener específico
     * @param {string} event - Nome do evento
     * @param {Function} callback - Função a ser removida
     */
    off(event, callback) {
        if (this.listeners.has(event)) {
            this.listeners.get(event).delete(callback);
        }
    }

    /**
     * Emite um evento para todos os listeners
     * @param {string} event - Nome do evento
     * @param {...any} args - Argumentos a serem passados
     */
    emit(event, ...args) {
        if (this.listeners.has(event)) {
            this.listeners.get(event).forEach(callback => {
                try {
                    callback(...args);
                } catch (error) {
                    console.error(`EventBus: Erro no handler de '${event}':`, error);
                }
            });
        }
    }

    /**
     * Remove todos os listeners de um evento ou todos os eventos
     * @param {string} [event] - Nome do evento (opcional)
     */
    clear(event = null) {
        if (event) {
            this.listeners.delete(event);
        } else {
            this.listeners.clear();
        }
    }

    /**
     * Verifica se um evento tem listeners
     * @param {string} event - Nome do evento
     * @returns {boolean}
     */
    hasListeners(event) {
        return this.listeners.has(event) && this.listeners.get(event).size > 0;
    }
}

// Singleton global
window.eventBus = new EventBus();



// ============================================
// core/Beacon.js
// ============================================
/**
 * Beacon — emissor de sinais do funil DENTRO do app (Fase 1b). Ver docs/FUNNEL-PLANO.md.
 *
 * A landing/SEO usa o `js/beacon.js` standalone; o emissor do app vive aqui, no bundle.
 * Mesmo endpoint e mesma convenção de wire.
 *
 * 🔴 Desde 09/ago o `/app/` TAMBÉM carrega o `js/beacon.js` — não pelo emissor (o standalone
 *    se cala dentro do /app/), e sim porque a resolução da ORIGEM (`r=`) mora lá e tem que ter
 *    UMA implementação só. Duas cópias da mesma regra já divergiram neste projeto e o gate
 *    passou verde por meses. Se o arquivo não carregar, `r=` some e o parser cai no referer
 *    do log — degrada, não quebra.
 *
 * 🔴 CONVENÇÃO (não quebrar): `p=` são famílias RESERVADAS (landing/game/round/gate/action).
 *    Ação discreta = `p=action&a=<nome>`. NUNCA inventar um `p=` novo — o sessionizer trata
 *    desconhecido como landing e contamina o funil.
 *
 * Fase 1b emite só `p=game` (game-start): 1× por jogo por page-load, no 1º áudio REAL.
 * Dispara para anônimo E logado (`auth=0|1` per-hit) — quem filtra é a análise.
 *
 * Fase 3b acrescenta `p=round` (fecho de rodada) — ver roundOpen/roundClose no fim da classe.
 *
 * LGPD-leve: sem cookie, sem localStorage, sem PII. Best-effort: NUNCA quebra o gameplay.
 */
class Beacon {
    static GIF = '/img/px.gif';

    /** Rotas que SÃO jogo (Main.GAMES + as avulsas "-livre"). home/news ficam de fora.
     *  🔴 Jogo NOVO tem que entrar aqui também — senão ele simplesmente não existe no
     *  funil (foi o que aconteceu com `songs` enquanto era rota avulsa). */
    static GAME_ROUTES = new Set([
        'rhythm', 'staffReading', 'intervals', 'chords', 'songs',
        'rhythmFree', 'intervalsFree', 'chordsFree', 'staffReadingFree', 'songsFree'
    ]);

    /** Jogo da rota atual (setado pelo afterEach do router). null = não é jogo. */
    static currentGame = null;

    /** Dedup: 1 beacon de game-start por jogo por page-load. */
    static _gameStartFired = new Set();
    /**
     * 🔴 Som na TELA INICIAL não é jogar. Desde 13/set Intervalos e Acordes mostram o
     * piano (tocável) e um "Ouvir exemplo" antes do Começar — e o AudioManager chama
     * `gameStart()` em TODO som. Sem esta trava, tocar uma tecla na vitrine contaria como
     * "começou o jogo" e a série de `p=game` desses dois jogos deixaria de ser comparável
     * com a de antes (quando o 1º som só existia dentro da rodada). O jogo liga a trava
     * ao mostrar a tela inicial e desliga ao abrir a rodada; `setRoute` zera (jogo novo,
     * trava nova).
     */
    static gameStartPaused = false;
    static pauseGameStart(on) { Beacon.gameStartPaused = !!on; }

    static _lang() {
        try { return window.language?.currentLanguage || 'pt'; } catch (e) { return 'pt'; }
    }

    static _auth() {
        try { return window.authState?.isLoggedIn ? 1 : 0; } catch (e) { return 0; }
    }

    /**
     * Dispara o pixel. Best-effort: qualquer erro é engolido.
     * `unload` = a página está indo embora; `new Image()` costuma ser cancelado aí, então
     * usa fetch com keepalive (que sobrevive ao unload e, ao contrário do sendBeacon,
     * continua sendo GET — o formato do log e os dois parsers seguem intactos).
     */
    static fire(params, unload) {
        try {
            const q = ['b=1'];
            for (const k in params) {
                if (Object.prototype.hasOwnProperty.call(params, k) && params[k] != null) {
                    q.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
                }
            }
            if (params?.r == null) {
                const org = window.AmBeacon?.origin?.();
                if (org) q.push('r=' + encodeURIComponent(org));
            }
            q.push('t=' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7));
            const url = Beacon.GIF + '?' + q.join('&');
            if (unload && typeof fetch === 'function') {
                fetch(url, { method: 'GET', keepalive: true, mode: 'no-cors', credentials: 'omit' })
                    .catch(() => { /* best-effort */ });
                return;
            }
            new Image().src = url;
        } catch (e) { /* nunca quebra a página */ }
    }

    /** Teto de telas por page-load: sem ele, um loop de rota vira flood no log. */
    /** Rotas que só redirecionam — não são tela, não entram no mapa de navegação. */
    static ROUTE_ALIASES = new Set(['readingFlowLegacy']);

    static SCREEN_CAP = 40;
    static _screenCount = 0;
    static _lastScreen = null;
    static _humanReady = false;    // o portão humano já abriu nesta página?
    static _gateArmed = false;
    static _pendingScreen = null;  // rota do boot, à espera do portão

    /**
     * Chamado pelo router a cada troca de rota. Guarda o jogo atual (ou null) e emite o
     * `screen_view` — o mapa de para onde a pessoa vai DENTRO do app.
     *
     * 🔴 POR QUE ISTO EXISTE (05/set): até aqui, dentro do `/app/` só existia quem fazia
     *    BARULHO. O `p=game` só dispara no 1º ÁUDIO REAL (AudioManager), e o `/app/` não emite
     *    `landing` de propósito. Resultado: entrar no app, abrir o ⊞, escolher um jogo e ficar
     *    na tela inicial dele emitia ZERO — e no painel isso é indistinguível de "ninguém
     *    entrou". Foi exatamente o que o Bernardo viu ao testar em 05/set.
     *
     * 🔴 É `p=action`, não uma família nova: `landing` marcaria "tocou a landing" em quem nunca
     *    passou por ela. Quem dá a semântica de app é a AÇÃO (`a=screen_view`), e é o ETL que
     *    a traduz em `entered_app` — ao contrário do `a=sat_*`, que NÃO é app.
     *
     * 🔴 Rota REPETIDA seguida não emite: o router chama isto em toda navegação, inclusive
     *    quando o hash muda para o mesmo lugar (recarga, voltar do drawer). Sem o dedup, um
     *    jogo que reescreve a própria rota vira uma linha por quadro.
     */
    static setRoute(name) {
        try {
            Beacon.currentGame = Beacon.GAME_ROUTES.has(name) ? name : null;
            Beacon.gameStartPaused = false;
        } catch (e) { Beacon.currentGame = null; }
        try {
            const scr = typeof name === 'string' ? name : '';
            // Faixa fechada: o `scr` vai para a URL do beacon e de lá para o log. Rota que não
            // casa não vira "?" silencioso — simplesmente não se emite (o ETL não teria o que
            // fazer com ela, e inventar um balde aqui seria uma segunda tabela de rotas).
            if (!/^[A-Za-z][A-Za-z0-9-]{0,23}$/.test(scr)) return;
            // 🔴 Rota que só REDIRECIONA não é tela: o alias `#/leitura-fluxo` fazia sair
            //    `readingFlowLegacy` E `staffReading` na mesma navegação, e o stub entrava no
            //    mapa TELAS DO APP como se fosse destino. O `setRoute` roda ANTES do handler,
            //    então o painel não tem como distinguir depois — a lista mora aqui.
            if (Beacon.ROUTE_ALIASES.has(scr)) return;
            // 🔴 PORTÃO HUMANO (auditoria de 05/set). A 1ª versão disto emitia no
            //    `DOMContentLoaded`, sem aba visível e sem gesto — e era o ÚNICO beacon do
            //    projeto assim: o `js/beacon.js` recusa emitir com a aba escondida ("aba em
            //    background = provável prerender/bot") e ainda exige gesto OU 1,5 s de dwell.
            //    Medido no log de 14 dias: 20 identidades baixaram o bundle sem nunca disparar
            //    beacon, entre elas o `GoogleOther` (que o filtro de UA NÃO pega) e três faixas
            //    de Google Cloud com UA de Chrome puro. Contra uma base de 27 humanos, isso
            //    empurrava o humano/dia de 2,8 para 4,0 — inflação de ~40% lida como
            //    crescimento, no dia do deploy.
            //    A PRIMEIRA rota (a do boot) espera o portão; da segunda em diante a navegação
            //    JÁ É o gesto, e o portão se abre com ela.
            if (!Beacon._humanReady) { Beacon._holdScreen(scr); return; }
            Beacon._emitScreen(scr);
        } catch (e) { /* nunca quebra a navegação */ }
    }

    /** Segura a rota do boot até haver prova de gente, e arma o portão uma única vez. */
    static _holdScreen(scr) {
        // 🔴 Guarda só a ÚLTIMA rota pendente: quem navega três vezes antes de o portão abrir
        //    interessa pelo lugar onde parou, e o dedup a jusante cuidaria do resto de todo jeito.
        Beacon._pendingScreen = scr;
        Beacon._armGate();
    }

    /**
     * Arma o PORTÃO HUMANO — uma vez por page-load, para todos os emissores que dependem
     * dele. Ao abrir, descarrega o que estava esperando: a rota do boot e as ações discretas.
     *
     * 🔴 UM PORTÃO SÓ. Emissor novo que precise de prova de gente entra AQUI (fila +
     *    descarga), nunca com um segundo relógio. O tripwire do CLAUDE.md ("mesmo portão ⇒
     *    mesma faixa") nasceu porque o `screen_view` estreou sem portão nenhum: medido no log
     *    de 14 dias, empurrava o humano/dia de 2,8 para 4,0, com o `GoogleOther` entrando
     *    como humano CERTO — a única faixa que se herda por identidade.
     */
    static _armGate() {
        if (Beacon._gateArmed) return;
        Beacon._gateArmed = true;
        const EVT = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
        const abrir = () => {
            if (Beacon._humanReady) return;
            if (document.visibilityState !== 'visible') return;   // prerender não passa
            Beacon._humanReady = true;
            EVT.forEach((e) => window.removeEventListener(e, abrir, true));
            const pend = Beacon._pendingScreen;
            Beacon._pendingScreen = null;
            if (pend) Beacon._emitScreen(pend);
            // Ações discretas que chegaram antes da prova de gente. FIFO: a ordem em que
            // aconteceram é a única informação que a fila carrega.
            const acts = Beacon._pendingActions;
            Beacon._pendingActions = [];
            acts.forEach((x) => Beacon._emitAction(x.name, x.extra));
        };
        try {
            EVT.forEach((e) => window.addEventListener(e, abrir, { capture: true, passive: true }));
            // dwell de 1,5 s visível, o MESMO critério do js/beacon.js — não inventar um segundo.
            // 🔴 E o dwell só COMEÇA com a aba visível, como lá. Antes o timer era armado na
            //    hora: numa aba aberta em segundo plano (link do meio, "abrir em nova aba") ele
            //    disparava escondido, o `abrir` devolvia e o caminho do dwell MORRIA — daí em
            //    diante só um gesto abria o portão. O standalone espera o `visibilitychange`
            //    para armar; dizer "mesmo portão" e ter um que desiste era a divergência.
            if (document.visibilityState === 'visible') setTimeout(abrir, 1500);
            else document.addEventListener('visibilitychange', function onVis() {
                if (document.visibilityState !== 'visible') return;
                document.removeEventListener('visibilitychange', onVis);
                setTimeout(abrir, 1500);
            });
        } catch (e) { /* best-effort */ }
    }

    /** O disparo em si, depois do portão. Dedup de rota repetida + teto por page-load. */
    static _emitScreen(scr) {
        if (scr === Beacon._lastScreen) return;
        Beacon._lastScreen = scr;
        if (Beacon._screenCount >= Beacon.SCREEN_CAP) return;
        Beacon._screenCount++;
        // 🔴 `over=1` na ÚLTIMA que cabe, como o roundClose já faz: sem isso a sessão MAIS
        //    navegada da série sai como a que parou de navegar.
        const over = Beacon._screenCount === Beacon.SCREEN_CAP ? 1 : null;
        Beacon.fire({ p: 'action', a: 'screen_view', scr: scr,
                      auth: Beacon._auth(), over: over, lang: Beacon._lang() });
    }

    // ───────────────────── Ação discreta dentro do app (p=action) ─────────────────────

    /** Teto por page-load — vale para a fila do portão e para o que efetivamente sai. */
    static ACTION_CAP = 12;
    static _actionCount = 0;
    static _actionSeen = new Set();
    static _pendingActions = [];

    /**
     * Ação discreta dentro do app: `p=action&a=<nome>`. Hoje a prévia de "Meu progresso"
     * (`stats_preview` e `stats_cta`) e a vitrine do PromoRail (`promo_view|click|hide`,
     * 15/set), mas o emissor é GERAL — é por ele que ação nova entra, para não nascer um
     * segundo portão humano.
     *
     * 🔴 MESMO PORTÃO do `screen_view`, logo MESMA FAIXA no ETL (`provavel`).
     * 🔴 POR QUE NÃO BASTA O `screen_view`: ele já diz "abriu #/progresso com auth=0". O que
     *    ele NÃO diz é QUAL amostra foi desenhada (`g=`) e se a tabela trazia progresso real
     *    do aparelho (`dev=`) — que é a variável em teste. Sem isso, medir a prévia em 30
     *    dias seria comparar cliques com um denominador que não sabe o que foi mostrado.
     * 🔴 Dedup por (ação + jogo) e teto por page-load: "esta sessão viu a prévia" é binário,
     *    e contar ida e volta não muda decisão nenhuma — vira flood num log de 2 pessoas/dia.
     * 🔴 O dedup marca ANTES do portão de propósito: a 2ª chamada de uma ação que já está na
     *    FILA não pode enfileirar de novo. Fila cheia (12) marca e descarta — com ~10 ações
     *    possíveis no app inteiro, o caso não existe, e segurar memória por ele custaria mais.
     */
    static action(name, extra = {}) {
        try {
            const a = String(name == null ? '' : name);
            // Faixa fechada: o nome vai para a URL e de lá para o access.log. Fora dela não se
            // emite — o ETL contaria como lixo, e um balde aqui seria uma 2ª tabela de ações.
            if (!/^[a-z][a-z0-9_]{0,23}$/.test(a)) return;
            const g = extra && extra.g != null ? String(extra.g) : '';
            if (g && !/^[a-z][a-z0-9]{0,23}$/.test(g)) return;
            // 🔴 TODO extra válido ENTRA na chave de dedup (ação + extras, em ordem fixa).
            //    Nasceu com `g` e `dev` à mão: `dev` diz se a tabela da prévia trouxe progresso
            //    real do aparelho — fora da chave, o convidado que abrisse a prévia vazio
            //    (dev=0), jogasse e voltasse no MESMO page-load (dev=1) ficava registrado como
            //    dev=0 para sempre, na direção que SUBESTIMA a hipótese. Com a vitrine (15/set)
            //    a mesma peça vive em placements diferentes (`pl=`) — chave só por `g` fundiria
            //    "viu nas Novidades" com "viu no Ranking". Genérico: só o que SAI no beacon
            //    (valor dentro da faixa) conta para a chave; extra descartado não separa nada.
            const key = a + '|' + Beacon._extraKey(extra);
            if (Beacon._actionSeen.has(key)) return;
            Beacon._actionSeen.add(key);
            if (!Beacon._humanReady) {
                if (Beacon._pendingActions.length < Beacon.ACTION_CAP) Beacon._pendingActions.push({ name: a, extra: extra });
                Beacon._armGate();
                return;
            }
            Beacon._emitAction(a, extra);
        } catch (e) { /* best-effort */ }
    }

    /** Faixa fechada do VALOR de um extra: tudo aqui vira URL e a URL vira linha de log.
     *  Emissor nosso, mas a régua é a mesma que o ETL aplica do outro lado. */
    static EXTRA_RE = /^[A-Za-z0-9_-]{1,24}$/;

    /** Os extras que vão SAIR no beacon (chave própria, valor na faixa), em ordem fixa. */
    static _extraKey(extra) {
        const parts = [];
        Object.keys(extra || {}).sort().forEach(k => {
            const v = extra[k];
            if (v == null || !Beacon.EXTRA_RE.test(String(v))) return;
            parts.push(k + '=' + v);
        });
        return parts.join('&');
    }

    /** O disparo em si, depois do portão. */
    static _emitAction(name, extra) {
        if (Beacon._actionCount >= Beacon.ACTION_CAP) return;
        Beacon._actionCount++;
        const p = { p: 'action', a: name, auth: Beacon._auth(), lang: Beacon._lang() };
        for (const k in (extra || {})) {
            if (!Object.prototype.hasOwnProperty.call(extra, k)) continue;
            const v = extra[k];
            if (v == null) continue;
            if (!Beacon.EXTRA_RE.test(String(v))) continue;
            p[k] = v;
        }
        Beacon.fire(p);
    }

    /** Trava de segurança: teto de beacons de gate por page-load (evita flood em loop). */
    static _gateCount = 0;
    static GATE_CAP = 20;

    /**
     * Gate de conta (nível 4+): mede quem encosta no muro e o que faz.
     *   o=shown  → o portão apareceu (anônimo tentou nível acima da fronteira)
     *   o=auth   → autenticou depois do gate. NÃO distingue signup de login: do cliente
     *              isso não é confiável (o modal abre em 'signup' mas a pessoa pode trocar).
     *              Quem separa é o triangulate, cruzando com users.created_at.
     *   o=cancel → fechou o modal sem logar (parede mole: segue nos níveis livres)
     * 'shown' sem desfecho na sessão = fechou a aba com o portão na cara (abandono duro).
     */
    static gate(outcome, gameId, levelNum) {
        try {
            // 🔴 O cap conta SÓ os 'shown' (o evento que pode repetir em loop). Desfecho
            // (auth/cancel) é raro e valioso — se ele consumisse/respeitasse o cap, um
            // usuário que abrisse o portão muitas vezes e ENTÃO se cadastrasse teria a
            // conversão descartada em silêncio, justo o número que mais importa.
            if (outcome === 'shown') {
                if (Beacon._gateCount >= Beacon.GATE_CAP) return;
                Beacon._gateCount++;
            }
            Beacon.fire({
                p: 'gate', o: outcome,
                g: gameId || '?',            // '?' = jogo ausente (convenção; NUNCA 'none')
                lvl: levelNum != null ? levelNum : null,
                auth: Beacon._auth(), lang: Beacon._lang()
            });
        } catch (e) { /* best-effort */ }
    }

    static _authFailSeen = new Set();

    /**
     * Recusa no formulário de conta. Existe por um buraco específico: o cliente barra
     * senha curta / e-mail malformado ANTES de postar, então essas tentativas nunca
     * chegam no servidor e o log de auth dele não as vê. Foi o que deixou um cadastro
     * frustrado (13/ago/2026) sem explicação possível.
     *
     * `o` é o CÓDIGO do erro (short_password, invalid_credentials…), nunca o e-mail —
     * beacon vai por URL e a URL vai pro access.log, que não é lugar de dado pessoal.
     * Quem precisa do e-mail é o log do servidor, que é privado.
     */
    static authFail(mode, code) {
        try {
            // 🔴 Teto por CAUSA, não por volume. Um teto contado engoliria o motivo que
            // interessa: 12 recusas de 'network' (backend fora do ar, botão reclicável)
            // estouravam a conta e o 'short_password' seguinte sumia em silêncio — o
            // mesmo erro que o cap do `gate` evita ao não deixar 'shown' comer o desfecho.
            // A análise usa "quais motivos apareceram", não "quantas vezes" → 1 por par.
            const key = (mode || '?') + ':' + (code || 'generic');
            if (Beacon._authFailSeen.has(key)) return;
            Beacon._authFailSeen.add(key);
            Beacon.fire({ p: 'auth', m: mode || '?', o: code || 'generic',
                          auth: Beacon._auth(), lang: Beacon._lang() });
        } catch (e) { /* best-effort */ }
    }

    /**
     * Game-start: 1º áudio real dentro de uma rota de jogo.
     * Chamado do AudioManager (play/playNote) — os 2 únicos pontos por onde os jogos tocam.
     */
    static gameStart() {
        try {
            const g = Beacon.currentGame;
            if (!g || Beacon.gameStartPaused || Beacon._gameStartFired.has(g)) return;
            Beacon._gameStartFired.add(g);
            Beacon.fire({ p: 'game', g: g, auth: Beacon._auth(), lang: Beacon._lang() });
        } catch (e) { /* best-effort */ }
    }

    // ───────────────────────── Rodadas (Fase 3b) ─────────────────────────
    //
    // Pergunta da fase: quem entrou, CONTINUOU jogando? Com o Service Worker servindo
    // tudo de cache, depois do load o servidor não vê mais nada — jogar não gera request.
    //
    // 🔴 ANON-ONLY de propósito: de quem está logado o servidor já sabe (save_score grava
    //    `plays` por nível). Beacon aqui só duplicaria dado e volume. A checagem é no
    //    FECHO (não na abertura): quem loga no meio da rodada já não é mais anônimo.
    // 🔴 O placar ENTROU em 13/set, e isto era uma decisão escrita ("sem placar/precisão:
    //    o que responde a pergunta é o ORDINAL"). Estava certa para a pergunta da Fase 3b
    //    ("quem entrou, continuou jogando?"). A pergunta mudou — é "por que PAROU?" — e aí
    //    o ordinal não basta: um visitante fez 27 rodadas no nível 1 do Ritmo e foi embora,
    //    e não dava pra distinguir "tocou no tempo e não segurou" de "mal tocou". As duas
    //    deixam o MESMO rastro (`o=done`, `lvl=1`).
    // 🔴 Só `oi`/`du` (início/duração), só de quem MANDA (hoje o Ritmo — é o único jogo com
    //    dois placares). Inteiro 0-100 — fora da faixa é OMITIDO, nunca corrigido (valor
    //    clampado esconderia emissor com defeito atrás de um número plausível). Tudo vira URL
    //    e a URL vira linha de access.log. Campo ausente é AUSENTE, nunca zero — zero é uma
    //    nota legítima e o ETL precisa distinguir "não mandou" de "tirou 0".

    /** Teto de beacons de rodada por page-load. Ver roundClose para o que acontece ao estourar. */
    static ROUND_CAP = 40;

    /** Ordinal da rodada POR JOGO neste page-load (o cap, esse, é global). */
    static _roundCount = {};
    static _roundSent = 0;        // quantos beacons de rodada já saíram (mede o cap)
    static _roundCapped = false;  // marcador de estouro já enviado → silêncio daqui pra frente
    /** Rodada em curso: { g, lvl }. null = nenhuma aberta. */
    static _openRound = null;

    /**
     * Abre uma rodada. `levelNum` vai 1-BASED (numeração do AuthGate e do servidor) ou
     * null onde não há trilha (sandbox, modo livre, quiz de 1 nota).
     *
     * O jogo é CAPTURADO aqui, não lido no fecho: o `quit` sai de dentro do destroy() da
     * tela, e depender de `currentGame` nessa hora amarraria a atribuição à ordem em que o
     * Router destrói a tela antiga e roda o afterEach — trocar essa ordem faria o beacon
     * mentir em silêncio.
     *
     * Abrir com outra rodada aberta FECHA a anterior como 'quit': é o caso real de trocar
     * de nível / reiniciar no meio, que é abandono tanto quanto sair da rota.
     *
     * `isEngaged` (opcional) = função que diz se a pessoa realmente jogou esta rodada. O
     * quiz passa `() => this.history.length > 0` porque apresenta a pergunta 1 sozinho ao
     * entrar na rota. É a MESMA evidência que o fecho usa — passada aqui, e não repetida
     * em cada jogo, pra que os dois caminhos (fecho e saída de página) nunca divirjam.
     */
    static roundOpen(levelNum, isEngaged, extra = null) {
        try {
            if (Beacon._openRound) Beacon.roundClose('quit');
            const g = Beacon.currentGame;
            Beacon._openRound = g
                ? { g: g, lvl: levelNum != null ? levelNum : null, engaged: isEngaged || null }
                : null;
            // DIÁRIO (user_events): o irmão LOGADO deste emissor anota o instante de abertura
            // (session_time / level_abandoned no fecho). Gancho único: jogo novo entra de graça.
            // `extra` (17/set) = o que a rodada carrega além do nível — hoje `{list}` da trilha do
            // professor. Só vai ao diário (logado); o GIF anônimo não o lê.
            if (Beacon._openRound) { try { window.eventTracker?.roundOpened(g, Beacon._openRound.lvl, extra); } catch (e2) {} }
        } catch (e) { Beacon._openRound = null; }
    }

    /**
     * Descarta a rodada aberta SEM emitir e SEM gastar ordinal: ela nunca começou de
     * verdade. Existe porque o quiz apresenta a pergunta 1 sozinho ao entrar na rota —
     * quem entra e sai sem responder nada não "abandonou uma rodada", e contar isso como
     * rodada inflaria justamente o número que esta fase quer medir.
     *
     * Descartar é obrigatório (não dá pra simplesmente não fechar): rodada aberta
     * sobrevive à troca de tela, e a próxima abertura a fecharia como 'quit'.
     */
    static roundCancel() {
        try { Beacon._openRound = null; } catch (e) { /* best-effort */ }
        // O tracker (diário) também esquece: senão a rodada órfã vira `duration_s` de uma
        // peça tocada horas depois no modo Acompanhar (que não abre rodada). Auditoria 06/set.
        try { window.eventTracker?.roundOpened(null); } catch (e) { /* best-effort */ }
    }

    /**
     * Fecha a rodada aberta. `outcome`: 'done' (terminou) | 'quit' (largou no meio).
     * Idempotente: sem rodada aberta não faz nada — por isso o destroy() pode chamar
     * sempre, sem saber se a rodada já tinha acabado.
     *
     * Cap: capar joga fora justamente as sessões mais engajadas, então o estouro não é
     * silencioso — o beacon nº ROUND_CAP+1 sai marcado com `over=1` e leva o `n` real.
     * A análise distingue "parou de jogar" de "passou do teto" (sem ele, as duas coisas
     * chegam como a mesma ausência de dados).
     */
    /**
     * @param {string} outcome 'done' | 'quit'
     * @param {{onset?:number, duration?:number}} [scores] placares do take (só o Ritmo
     *        tem os dois). Fora de 0-100 ou não-numérico = omitido, nunca corrigido.
     */
    static roundClose(outcome, scores) {
        try {
            const r = Beacon._openRound;
            if (!r) return;
            Beacon._openRound = null;

            // O ordinal conta TODA rodada fechada, inclusive as não emitidas (logado /
            // acima do cap): `n` tem de ser a enésima rodada de verdade, não a enésima
            // reportada — senão quem loga no meio reinicia a contagem e infla o começo.
            const n = (Beacon._roundCount[r.g] = (Beacon._roundCount[r.g] || 0) + 1);

            // DIÁRIO (user_events): ANTES do `anon-only` abaixo, de propósito — o tracker é
            // justamente o lado LOGADO. Ele emite session_time e, no quit, level_abandoned.
            try { window.eventTracker?.roundClosed(r.g, r.lvl, outcome === 'quit' ? 'quit' : 'done'); } catch (e2) {}

            if (Beacon._auth()) return;        // anon-only (ver cabeçalho da seção)
            if (Beacon._roundCapped) return;   // já avisou que estourou; silêncio

            const over = Beacon._roundSent >= Beacon.ROUND_CAP;
            Beacon._roundSent++;
            if (over) Beacon._roundCapped = true;

            // Nota 0-100 inteira, ou null (= parâmetro não sai). NÃO clampa: valor fora
            // da faixa é emissor com defeito, e mandá-lo corrigido esconderia o defeito
            // atrás de um número plausível.
            const nota = (v) => (typeof v === 'number' && isFinite(v) && v >= 0 && v <= 100)
                ? Math.round(v) : null;

            Beacon.fire({
                p: 'round', g: r.g, lvl: r.lvl, n: n,
                o: outcome === 'quit' ? 'quit' : 'done',
                oi: scores ? nota(scores.onset) : null,
                du: scores ? nota(scores.duration) : null,
                over: over ? 1 : null,
                auth: 0, lang: Beacon._lang()
            });
        } catch (e) { /* best-effort */ }
    }

    /**
     * Página indo embora com rodada em curso (fechar aba/app — o abandono mais comum no
     * mobile, e o único que não passa por destroy() nenhum).
     *
     * 🔴 Emite MAS NÃO FECHA a rodada, de propósito: `pagehide` também dispara quando a
     *    página vai pro bfcache, e daí a pessoa pode voltar e TERMINAR a rodada. Fechar
     *    aqui gastaria o ordinal e faria o fim legítimo sumir. Como o `n` enviado é o
     *    mesmo que o fecho normal usaria, o par (jogo, n) casa: se vier um `done` depois,
     *    a análise sabe que a pessoa voltou; se não vier, foi abandono de verdade.
     * `u=1` marca a origem — é abandono por SAÍDA, não o "largou" explícito do jogo.
     */
    static _unloadFlush() {
        try {
            const r = Beacon._openRound;
            if (!r) return;
            // Mesma regra do fecho: rodada em que a pessoa não jogou nada não é rodada.
            // Sem isto, quem só abre a rota do quiz (que apresenta a pergunta 1 sozinho)
            // e fecha a aba entraria como rodada abandonada — inflando o número da fase.
            if (r.engaged && !r.engaged()) return;
            if (Beacon._auth()) return;                     // anon-only, igual ao fecho
            if (Beacon._roundCapped) return;
            Beacon.fire({
                p: 'round', g: r.g, lvl: r.lvl,
                n: (Beacon._roundCount[r.g] || 0) + 1,      // o n que o fecho normal usaria
                o: 'quit', u: 1, auth: 0, lang: Beacon._lang()
            }, true);                                        // transporte que sobrevive ao unload
        } catch (e) { /* best-effort */ }
    }
}

// Abandono por saída de página. Só `pagehide` — `visibilitychange` dispararia ao trocar de
// app no celular, e voltar depois é normal: viraria "largou" de quem não largou.
try {
    window.addEventListener('pagehide', () => Beacon._unloadFlush());
} catch (e) { /* best-effort */ }

window.Beacon = Beacon;



// ============================================
// core/StorageScope.js
// ============================================
/**
 * StorageScope — namespacing de chaves de localStorage por DONO.
 *
 * Adaptado de capsula/StorageScope.js (referência read-only), sem a migração legada
 * dele (lá havia chaves globais antigas atribuíveis por userId interno; aqui o projeto
 * só teve chaves de guest até agora). Ver docs/auth/AUTH-STATUS-E-PLANO.md (Fase 1).
 *
 * PROBLEMA QUE RESOLVE: progresso/ranking vazando entre contas no MESMO navegador
 * (família, sala de aula, device compartilhado). Cada dono passa a ter a SUA chave
 * física: `${baseKey}::u<id>` (logado) | `${baseKey}::guest` (convidado).
 *
 * 🔴 REGRA CRÍTICA: a chave é resolvida SEMPRE na hora do get/set. NUNCA cachear no
 * construtor — currentUserId() é null durante o boot e só popula depois do auth.
 *
 * A "vacina" cross-user foi instalada ANTES de existir multi-conta (retrofit depois é
 * caro — é o bug nº1 do capsula). Desde a Fase 3/4 o login existe e currentUserId()
 * devolve o id real, então as chaves de quem está logado caem em ::u<id> de verdade.
 */
class StorageScope {
    /**
     * Chaves-base de PROGRESSO/RANKING que precisam de dono. FONTE ÚNICA.
     * Preferências de device (rf_input_mode, rf_kids, bpm, idioma…) ficam GLOBAIS.
     */
    // 🔴 FONTE ÚNICA das chaves de PROGRESSO/POSIÇÃO por dono — TEM de bater com as
    // constantes reais dos jogos (senão clearGuestScope/import operam no vazio → vaza
    // pro próximo convidado e some no cadastro). Preferências de device (bpm, kids,
    // answer_mode, assist, tutorial flags, free_*) NÃO entram aqui — ficam globais.
    static PROGRESS_BASE_KEYS = [
        'rhythm_level_progress_v1',   // LevelConfig.PROGRESS_KEY  ({current, highestUnlocked})
        'rhythm_level_best_v1',       // LevelConfig.BEST_KEY (melhor take por nível + fila do ranking)
        'reading_flow_unlocked_v1',   // ReadingFlowGame.UNLOCKED_KEY (nível liberado)
        'reading_flow_level_v1',      // ReadingFlowGame.LEVEL_KEY (último nível escolhido)
        'reading_flow_stars_v1',      // ReadingFlowGame.STARS_KEY ({levelIdx: estrelas})
        'reading_flow_best_v1',       // ReadingFlowGame.BEST_KEY (melhor take por nível + fila do ranking)
        'rf_kids_mastery',            // ReadingFlowGame.MASTERY_KEY (desmame por nota, por usuário)
        'interval_unlocked_v1',       // IntervalGame.UNLOCKED_KEY
        'interval_level_v1',          // IntervalGame.LEVEL_KEY
        'interval_best_v1',           // IntervalGame.BEST_KEY (melhor take por nível + fila do ranking)
        'chord_unlocked_v1',          // ChordGame.UNLOCKED_KEY
        'chord_level_v1',             // ChordGame.LEVEL_KEY
        'chord_best_v1',              // ChordGame.BEST_KEY (melhor take por nível + fila do ranking)
        'song_stars_v1'               // SongReadingGame.STARS_KEY ({songId: estrelas})
        // 🔴 Chave de progresso de jogo NOVO entra aqui; a do sandbox (`*_free_*`) NÃO —
        // aquilo é preferência de aparelho. Chave de progresso fora desta lista não é
        // adotada no cadastro e ainda vaza para o próximo convidado, sem erro nenhum.
    ];

    /**
     * Estratégias por chave-base. PONTO DE EXTENSÃO (flexível/versionado): quando o dado
     * de avanço/posição/performance de um jogo AMADURECE (campos novos, nova versão de
     * chave `_vN`), o jogo registra aqui uma função `(guestRaw, destRaw) => rawFinal`,
     * sem tocar no laço de import. Sem estratégia, adota-se o valor cru.
     *
     * Ela é chamada em DOIS regimes, e o 2º argumento diz qual:
     *  - `destRaw === null` → ADOÇÃO: a conta não tem a chave. É o caso comum (quem jogou
     *    de convidado e depois criou conta); a função só TRANSFORMA o valor do guest.
     *  - `destRaw` string   → MERGE: a conta já tem a chave e estamos na READOÇÃO (a
     *    sessão morreu no meio da rodada). SÓ acontece aí. A função tem de ser MONÓTONA
     *    — o resultado nunca pode ser pior que `destRaw` — porque é a única situação em
     *    que o ::guest toca dado que já é da conta. Fora da readoção, a conta vence
     *    sempre (anti cross-user; ver importGuestProgress).
     * Quem implementa a régua monótona hoje é `LevelProgress.mergeBags`, registrada por
     * `LevelProgress.register()` — a MESMA linha que põe o jogo no ranking.
     */
    static MERGE_STRATEGIES = {};

    /** Registra (ou substitui) a estratégia de adoção de uma chave-base/versão. */
    static registerMergeStrategy(baseKey, fn) {
        if (typeof fn === 'function') StorageScope.MERGE_STRATEGIES[baseKey] = fn;
    }

    /**
     * userId atual: AuthState (fonte primária) → UserManager.getUserId() → null (guest).
     * O fallback via getUserId() cobre o caso de `id` falsy (0/ausente) com email
     * presente — sem ele, um usuário logado escreveria no escopo ::guest (compartilhado).
     */
    static currentUserId() {
        try {
            return window.authState?.userId
                ?? window.userManager?.getUserId?.()
                ?? null;
        } catch (e) {
            return null;
        }
    }

    static scopeSuffix() {
        const id = StorageScope.currentUserId();
        return id ? `::u${id}` : '::guest';
    }

    /** Compõe a chave namespaced. Ex: key('reading_flow_best_v1') → '…::guest'. */
    static key(baseKey) {
        return `${baseKey}${StorageScope.scopeSuffix()}`;
    }

    /**
     * Limpa o escopo ::guest no SUCESSO DE LOGIN — pra um guest velho não vazar
     * progresso pro próximo guest do navegador. Chamar dentro de setUser() (cobre
     * login local, OAuth e signup de uma vez) — chamado em UserManager.setUser.
     */
    static clearGuestScope(baseKeys = StorageScope.PROGRESS_BASE_KEYS) {
        if (typeof window === 'undefined' || !window.localStorage) return;
        baseKeys.forEach(k => {
            try { window.localStorage.removeItem(`${k}::guest`); } catch (e) {}
        });
    }

    /**
     * Apaga as chaves de PROGRESSO do escopo CORRENTE (o ::u<id> de quem está logado).
     * É a metade local do "Zerar progresso" da tela de conta — a outra metade é o
     * `reset_progress` no servidor, que roda ANTES (ver UserManager.resetProgress: com a
     * ordem trocada, uma falha de rede apagaria o aparelho e o servidor devolveria tudo no
     * login seguinte).
     *
     * 🔴 A MARCA DE ADOÇÃO (`IMPORT_FLAG`) FICA. Ela diz "esta conta já apareceu neste
     * aparelho", e é o que impede o progresso de um convidado — que pode ser OUTRA pessoa —
     * de ser adotado. Limpá-la aqui transformaria "zerar o meu progresso" numa porta de
     * entrada para o progresso alheio no próximo login.
     * 🔴 Só o que está em `PROGRESS_BASE_KEYS`: preferência de aparelho (andamento, modo
     * infantil, ajuda vista, cifras) não é progresso e não se perde num "zerar".
     *
     * @returns {number} quantas chaves saíram (0 = não havia nada guardado aqui).
     */
    static clearProgress(baseKeys = StorageScope.PROGRESS_BASE_KEYS) {
        if (typeof window === 'undefined' || !window.localStorage) return 0;
        let n = 0;
        baseKeys.forEach(base => {
            try {
                const k = StorageScope.key(base);
                if (window.localStorage.getItem(k) !== null) { window.localStorage.removeItem(k); n++; }
            } catch (e) { /* uma chave presa não impede as outras */ }
        });
        return n;
    }

    /**
     * Promove o progresso do escopo ::guest para o da CONTA logada — SÓ na PRIMEIRA
     * vez que aquela conta aparece neste device.
     *
     * 🔴 ANTI CROSS-USER (lição Theo×Ana do capsula, §A1): num device compartilhado
     * (família, sala de aula), o progresso de um convidado — que pode ser OUTRA pessoa
     * — nunca pode contaminar uma conta existente. "Dado sem dono não é seu."
     *
     * Efeito prático: quem joga de convidado e DEPOIS cria conta leva o avanço junto
     * (conta virgem neste device → adota); uma conta que já jogou aqui nunca herda o
     * guest, nem quando um jogo NOVO estreia com uma chave que ela ainda não tem.
     *
     * Chamar DENTRO de setUser() ANTES de clearGuestScope() (o authState já aponta pro
     * novo usuário → StorageScope.key(base) resolve pro `::u<id>`). Uma estratégia
     * registrada (MERGE_STRATEGIES) pode TRANSFORMAR o valor do guest ao adotar (ex.:
     * migrar shape antigo) e, SÓ na readoção, fundi-lo monotonicamente no da conta.
     *
     * @returns {number} quantas chaves a READOÇÃO gravou — fundidas E adotadas; 0 na
     *   adoção normal. Quem chama usa isto para reaplicar o desbloqueio derivado (ver
     *   LevelProgress.reapplyUnlocks). 🔴 Contar só as FUNDIDAS deixava de fora a conta
     *   que é veterana por outra chave e cai no ramo de adoção — auditoria de 06/set.
     */
    static IMPORT_FLAG = 'storageScope_imported';   // + ::u<id> — 1 adoção por conta/device
    /**
     * + ::u<id> — autoriza UMA readoção do ::guest por esta conta, apesar do IMPORT_FLAG.
     * Gravada pelo UserManager.handleSessionExpired ANTES do logout: a sessão que morre
     * no meio de uma rodada manda o take em curso para ::guest, e sem isto ele nunca
     * voltaria para a conta (a adoção é one-shot por device). Consumida na 1ª adoção.
     * 🔴 O anti cross-user depende de a JANELA ser curta, e ela tem DUAS travas, ambas
     * postas em 06/set depois de a auditoria medir o furo: o `handleSessionExpired` só
     * grava a marca se houver RODADA ABERTA, e aqui ela só vale dentro do
     * `READOPT_TTL_MS`. Sem as duas, a marca era gravada até na expiração do BOOT e valia
     * para sempre — bastava outra pessoa jogar de convidado no aparelho entre uma coisa e
     * outra para o progresso dela entrar na conta e subir ao ranking sob o nome dela.
     * A frase antiga aqui ("o device não trocou de mão no meio de uma rodada") era
     * verdadeira sobre a rodada e FALSA sobre a janela, que não estava limitada a ela.
     * 🔴 Chave que a conta já tem NUNCA é sobrescrita — mas, desde 06/set, ela pode ser
     * FUNDIDA se tiver estratégia registrada (MERGE_STRATEGIES), e o merge é monótono.
     * Antes disso a readoção era não-destrutiva POR CHAVE, e como `*_best_v1` existe na
     * conta depois de qualquer partida, o take da rodada que morreu se perdia mesmo assim.
     */
    static READOPT_FLAG = 'storageScope_readopt';

    /**
     * Prazo da marca. 🔴 EXISTE PORQUE A MARCA SEM PRAZO É UM FURO CROSS-USER, e o merge
     * de 06/set o abriu: até então a readoção era não-destrutiva por chave e não conseguia
     * tocar o bag de melhores, então a marca eterna era contida POR ACIDENTE.
     * O cenário medido na auditoria: a sessão de 14 d de uma conta expira NO BOOT (o
     * `validateSessionInBackground` também chama `handleSessionExpired`), a marca fica
     * gravada para sempre, outra pessoa joga de convidado no mesmo aparelho a semana
     * inteira, e o próximo login daquela conta adotaria o progresso do estranho — e o
     * publicaria no ranking sob o nome dela.
     * A marca cobre UMA coisa: "a rodada que estava no ar termina e grava em ::guest".
     * Isso acontece em minutos. 30 min é folga generosa para isso e curta para o resto.
     */
    static READOPT_TTL_MS = 30 * 60 * 1000;

    /** Grava a marca. Quem chama decide SE deve (ver UserManager.handleSessionExpired:
     *  só com rodada aberta). O valor é o instante — e ele É LIDO, ver `_readoptValid`. */
    static markReadopt(uid) {
        if (typeof window === 'undefined' || !window.localStorage || uid == null) return;
        try { window.localStorage.setItem(`${StorageScope.READOPT_FLAG}::u${uid}`, new Date().toISOString()); } catch (e) {}
    }

    /** Marca presente E dentro do prazo? Valor ilegível ou fora do prazo NÃO autoriza. */
    static _readoptValid(raw) {
        if (!raw) return false;
        const t = Date.parse(raw);
        if (!Number.isFinite(t)) return false;              // marca corrompida: não autoriza
        const idade = Date.now() - t;
        return idade >= 0 && idade <= StorageScope.READOPT_TTL_MS;
    }

    static importGuestProgress(baseKeys = StorageScope.PROGRESS_BASE_KEYS) {
        if (typeof window === 'undefined' || !window.localStorage) return 0;
        const uid = StorageScope.currentUserId();
        if (uid == null) return 0; // só faz sentido logado
        const ls = window.localStorage;

        // 🔴 ADOÇÃO É POR CONTA, NÃO POR CHAVE (27/jul). O guard "a conta já tem esta
        // chave" protegia só chaves que a conta JÁ conhecia — quando um jogo estreia no
        // ranking, a chave nova não existe em conta nenhuma do parque, e toda conta
        // veterana adotaria o progresso de convidado de um ESTRANHO no device
        // compartilhado (e o backfill publicaria no ranking sob o nome dela).
        // Regra agora: quem já tem QUALQUER progresso próprio aqui é veterano neste
        // device e não adota nada — nem hoje, nem quando o próximo jogo estrear.
        const flagKey = `${StorageScope.IMPORT_FLAG}::u${uid}`;
        const readoptKey = `${StorageScope.READOPT_FLAG}::u${uid}`;
        let readopt = false;
        try {
            // Readoção autorizada (sessão morreu no meio de uma rodada — ver READOPT_FLAG):
            // consome a marca e pula o portão de veterano UMA vez. 🔴 A marca é consumida
            // mesmo VENCIDA — ela é one-shot por desenho, e deixar lixo vencido no storage
            // só adiaria o mesmo risco para o próximo login.
            const marca = ls.getItem(readoptKey);
            if (marca !== null) {
                ls.removeItem(readoptKey);
                readopt = StorageScope._readoptValid(marca);
            }
            if (!readopt) {
                if (ls.getItem(flagKey)) return 0;                     // já adotou (ou já foi barrado) aqui
                const veteran = baseKeys.some(k => ls.getItem(StorageScope.key(k)) !== null);
                if (veteran) { ls.setItem(flagKey, new Date().toISOString()); return 0; }
            }
        } catch (e) { return 0; }  // sem storage confiável: não adota (o lado seguro)

        // 🔴 Conta chaves ESCRITAS NA READOÇÃO — fundidas E adotadas. Contar só as fundidas
        // era o defeito nº 2 da auditoria: quem tinha `*_level_progress` (só de escolher um
        // nível) mas nenhum `*_best_v1` é VETERANA e mesmo assim cai no ramo de ADOÇÃO, e o
        // `reapplyUnlocks` do chamador não disparava — o nível reconquistado ficava trancado
        // até o login seguinte, que é exatamente o buraco que ele existe para fechar.
        let touched = 0;
        baseKeys.forEach(base => {
            try {
                const guestRaw = ls.getItem(`${base}::guest`);
                if (guestRaw === null) return;               // guest não tem esse dado
                const destKey = StorageScope.key(base);      // ::u<id> (já logado)
                const destRaw = ls.getItem(destKey);
                const strategy = StorageScope.MERGE_STRATEGIES[base];
                if (destRaw !== null) {
                    // 🔴 A conta JÁ TEM esta chave. Nada aqui SOBRESCREVE: a chave só é
                    // tocada se tiver estratégia registrada, e a estratégia é um merge
                    // MONÓTONO (o resultado é ≥ o que a conta tinha). Sem estratégia —
                    // desbloqueio, posição, estrelas — a conta vence, como antes: não há
                    // régua para fundir esses, e inventar uma seria decidir no escuro.
                    //
                    // 🔴 QUEM PROTEGE O ANTI CROSS-USER É O PORTÃO LÁ EM CIMA, não este
                    // `!readopt`. Provado por mutação (06/set): tirar o `!readopt` daqui
                    // NÃO abre o merge para um login qualquer, porque sem a marca o portão
                    // já devolveu — veterana sai em `return 0`, e quem não é veterana não
                    // tem chave nenhuma, então `destRaw` é null e este ramo nem roda. O
                    // `!readopt` fica como cinto de segunda camada (custa nada e o dia em
                    // que alguém mexer no portão ele é a única coisa de pé), mas não se
                    // deve confiar nele como se fosse a trava — a trava é o portão.
                    if (!readopt || !strategy) return;
                    const val = strategy(guestRaw, destRaw);
                    if (val != null && val !== destRaw) { ls.setItem(destKey, val); if (readopt) touched++; }
                    return;
                }
                const val = strategy ? strategy(guestRaw, null) : guestRaw;
                if (val != null) { ls.setItem(destKey, val); if (readopt) touched++; }
            } catch (e) {
                // Quota estourada no meio da readoção: o `clearGuestScope` do chamador vem
                // logo depois e a marca já foi consumida, então o take se perde SEM segunda
                // chance. Não dá para desfazer daqui (o take pode estar meio gravado), mas
                // não pode ser mudo — dívida escrita, não silêncio.
                try { console.warn('StorageScope: falha ao gravar', base, '— take do ::guest pode ter se perdido', e); } catch (e2) {}
            }
        });

        // Marca a conta como já servida NESTE device: a 1ª adoção é a única.
        try { ls.setItem(flagKey, new Date().toISOString()); } catch (e) {}
        // Quantas chaves a READOÇÃO gravou (fundidas + adotadas); 0 na adoção normal. Quem
        // chama usa isto para reaplicar o desbloqueio derivado — ver LevelProgress.reapplyUnlocks.
        return touched;
    }

    /**
     * Migração one-shot das chaves legadas SEM sufixo → ::guest.
     *
     * Este projeto JÁ TEM jogadores em prod com as chaves antigas sem sufixo. Ao ligar
     * o namespacing, o jogo passaria a ler `${base}::guest` (vazio) → progresso/recorde
     * "sumiriam". Esta migração PRESERVA esses dados movendo-os pro escopo ::guest.
     *
     * Pura preservação (nunca descarta): copia só se o destino ::guest ainda não existe,
     * depois remove a chave crua. Idempotente via flag. Roda em contexto guest (não há
     * login ainda) — seguro porque é o mesmo device/pessoa, não há outro dono.
     */
    static migrateLegacyToGuest() {
        const FLAG = 'storageScope_guest_migrated_v1';
        if (typeof window === 'undefined' || !window.localStorage) return;
        const ls = window.localStorage;
        try {
            if (ls.getItem(FLAG)) return;
        } catch (e) {
            return;
        }
        StorageScope.PROGRESS_BASE_KEYS.forEach(base => {
            try {
                const legacy = ls.getItem(base);
                if (legacy === null) return;
                const guestKey = `${base}::guest`;
                if (ls.getItem(guestKey) === null) {
                    ls.setItem(guestKey, legacy);
                }
                ls.removeItem(base);
            } catch (e) { /* quota/serialização — segue, não há perda além do legado */ }
        });
        try { ls.setItem(FLAG, new Date().toISOString()); } catch (e) {}
    }
}

// Disponibiliza globalmente + roda a migração legada→::guest uma vez no parse do bundle
// (antes de qualquer jogo construir e ler progresso). Idempotente.
window.StorageScope = StorageScope;
StorageScope.migrateLegacyToGuest();



// ============================================
// core/AuthState.js
// ============================================
/**
 * AuthState — single source of truth do estado de autenticação (cliente).
 *
 * Port do capsula/AuthState.js (referência read-only), sem os logs e a ponte EventBus
 * do original. Imutável por fora (getters retornam cópia congelada); mutação só via
 * setState(). Observer pattern p/ a UI reagir a login/logout. Ver docs/auth §1.1.
 *
 * Fase 2 (camada de identidade desconectada): existe como fundação, SEM rede. Sem login
 * ainda → fica sempre em 'guest'. É a fonte que o StorageScope lê (window.authState.userId)
 * pra resolver o escopo das chaves de progresso.
 */
class AuthState {
    constructor() {
        this._user = null;
        this._userType = 'guest';       // guest | logged | subscriber | admin
        this._isAuthenticated = false;
        this._observers = [];
        this._timestamp = Date.now();
    }

    // === Getters públicos (imutáveis) ===
    get user() { return this._user ? Object.freeze({ ...this._user }) : null; }
    get userType() { return this._userType; }
    get isAuthenticated() { return this._isAuthenticated; }
    get isLoggedIn() { return this._isAuthenticated; }
    get isGuest() { return this._userType === 'guest'; }
    get isAdmin() { return this._userType === 'admin'; }
    get userName() { return this._user?.name || 'Anônimo'; }
    get userEmail() { return this._user?.email || null; }
    get userId() { return this._user?.id || null; }
    get timestamp() { return this._timestamp; }

    // === Mutação controlada ===
    setState(user, userType = 'guest') {
        if (user && typeof user !== 'object') throw new Error('User must be an object or null');
        if (!['guest', 'logged', 'subscriber', 'admin'].includes(userType)) {
            throw new Error('Invalid userType');
        }
        const prev = this._snapshot();
        this._user = user;
        this._userType = userType;
        this._isAuthenticated = !!(user && userType !== 'guest');
        this._timestamp = Date.now();
        const curr = this._snapshot();
        if (JSON.stringify(prev) !== JSON.stringify(curr)) this._notify(curr, prev);
    }

    login(user, userType = 'logged') {
        if (!user || !user.name || !user.email) throw new Error('User needs name and email');
        this.setState(user, userType);
    }

    logout() { this.setState(null, 'guest'); }

    updateUser(userData) {
        if (!this._isAuthenticated) throw new Error('Not authenticated');
        this.setState({ ...this._user, ...userData }, this._userType);
    }

    // === Observer ===
    subscribe(callback) {
        if (typeof callback !== 'function') throw new Error('callback must be a function');
        this._observers.push(callback);
        return () => {
            const i = this._observers.indexOf(callback);
            if (i > -1) this._observers.splice(i, 1);
        };
    }

    _notify(curr, prev) {
        this._observers.forEach(cb => {
            try { cb(curr, prev); } catch (e) { console.error('AuthState observer error:', e); }
        });
    }

    _snapshot() {
        return {
            user: this.user,
            userType: this._userType,
            isAuthenticated: this._isAuthenticated,
            timestamp: this._timestamp
        };
    }

    // === Serialização (com expiração = AuthRepository.MAX_AGE, 14 d = sessão do servidor) ===
    toJSON() {
        return { user: this._user, userType: this._userType, timestamp: this._timestamp, version: '1.0' };
    }

    fromJSON(data) {
        if (!data || typeof data !== 'object') { this.setState(null, 'guest'); return; }
        if (data.version && data.version !== '1.0') { this.setState(null, 'guest'); return; }
        // 🔴 UMA verdade sobre o TTL: a do AuthRepository. Havia um 24 h duplicado aqui, e
        // subir o do repositório para 14 d não mudava nada — este cortava antes.
        const maxAge = (window.AuthRepository && window.AuthRepository.MAX_AGE) || (14 * 24 * 60 * 60 * 1000);
        if (data.timestamp && (Date.now() - data.timestamp > maxAge)) { this.setState(null, 'guest'); return; }
        try { this.setState(data.user, data.userType || 'guest'); }
        catch (e) { this.setState(null, 'guest'); }
    }
}

// Disponibiliza a CLASSE globalmente (a instância vive em window.authState, criada pelo
// UserManager). UserManager faz `new window.AuthState()`.
window.AuthState = AuthState;



// ============================================
// core/AuthRepository.js
// ============================================
/**
 * AuthRepository — persistência do estado de auth em localStorage (cliente).
 *
 * Port do capsula/AuthRepository.js (referência read-only), SEM a camada de migração
 * "legacy" do original (projeto novo, sem dado legado de auth). Valida estrutura e
 * expiração (14 dias = sessão do servidor). Ver docs/auth §1.2.
 *
 * Chave própria `auth_state` (NÃO passa por StorageScope — é o estado do dono, não dado
 * scopado por dono). Fase 2: existe, mas como não há login, nunca chega a salvar nada.
 */
class AuthRepository {
    /** Fonte ÚNICA do TTL local (AuthState.fromJSON lê daqui). 14 d = cookie de sessão. */
    static MAX_AGE = 14 * 24 * 60 * 60 * 1000;

    constructor() {
        this.storageKey = 'auth_state';
        // 🔴 14 dias = a MESMA vida da sessão do servidor (auth-helpers.php, cookie 1209600 s).
        // Era 24 h: a pessoa voltava em 2 dias, o local tinha expirado, o boot caía em
        // `guest` SEM perguntar ao servidor — e o progresso passava a ser lido de ::guest
        // com a sessão ainda viva lá. "Servidor esqueceu e o cliente ainda mostra logado"
        // é o outro sentido, e quem cobre é o validateSessionInBackground do boot.
        this.maxAge = AuthRepository.MAX_AGE; // 14 dias (1209600000 ms)
        this.version = '1.0';
    }

    /** @param {AuthState} authState */
    save(authState) {
        try {
            window.localStorage.setItem(this.storageKey, JSON.stringify({
                ...authState.toJSON(),
                savedAt: Date.now(),
                version: this.version
            }));
            return true;
        } catch (e) {
            console.error('AuthRepository.save:', e);
            return false;
        }
    }

    /** @returns {Object|null} dados válidos ou null */
    load() {
        try {
            const stored = window.localStorage.getItem(this.storageKey);
            if (!stored) return null;

            let data;
            try { data = JSON.parse(stored); }
            catch (e) { window.localStorage.removeItem(this.storageKey); return null; }

            if (!this._isValid(data)) { window.localStorage.removeItem(this.storageKey); return null; }
            if (this._isExpired(data)) { window.localStorage.removeItem(this.storageKey); return null; }
            return data;
        } catch (e) {
            console.error('AuthRepository.load:', e);
            return null;
        }
    }

    clear() {
        try { window.localStorage.removeItem(this.storageKey); return true; }
        catch (e) { return false; }
    }

    _isValid(data) {
        return data && typeof data === 'object'
            && 'user' in data && 'userType' in data && 'timestamp' in data && 'version' in data;
    }

    _isExpired(data) {
        if (!data.timestamp) return true;
        return (Date.now() - data.timestamp) > this.maxAge;
    }
}

// Disponibiliza a CLASSE globalmente (UserManager faz `new window.AuthRepository()`).
window.AuthRepository = AuthRepository;



// ============================================
// core/UserManager.js
// ============================================
/**
 * UserManager — camada de IDENTIDADE do cliente (orquestra AuthState + AuthRepository).
 *
 * Versão ENXUTA do capsula/UserManager.js (~1008 linhas): só identidade. Cortados
 * GlobalStats/Game*StatsManager, EmailHealth, PWAInstall e todo o sync de stats/servidor
 * (acoplado ao handler.php/schema do capsula). Ver docs/auth §1.3.
 *
 * 🔴 Fase 2: existe como singleton global (window.userManager) + expõe window.authState,
 * que o StorageScope lê pra resolver o escopo. Sem login → 'guest' → tudo em ::guest.
 *
 * 🔴 Fase 4 (bastidor): ganchos de servidor LIGADOS na API same-origin `/api/`
 * (auth-backend; path-based em todo ambiente — ver docs/auth/FASE-3-4-SETUP.md).
 * Tolerante a backend ausente: se /api/ devolver não-JSON (em prod o catch-all da
 * SPA responde o shell até a Fase 3 subir) ou falhar → no-op, segue estado local
 * (offline-first). O retorno do OAuth (?login=social / ?auth_error=) é consumido
 * no boot e a query é limpa da URL. SEM UI ainda — eventos p/ o header ficam
 * dormentes até a fase de UI.
 */
class UserManager {
    constructor() {
        this.authState = new window.AuthState();
        this.repository = new window.AuthRepository();
        this._csrfToken = null;   // cacheado; buscado sob demanda em _getCsrf()
        this._pendingAuthError = null; // código de erro OAuth do boot, drenado por takeAuthNotice()

        this.restoreSession();
        this._setupStateSync();
        this._consumeOAuthReturn();
    }

    // === Boot ===
    restoreSession() {
        const saved = this.repository.load();
        if (saved) {
            this.authState.fromJSON(saved);
            // §A2/§A3: validar sessão e reconciliar role com o servidor em BACKGROUND,
            // não-bloqueante.
            this.validateSessionInBackground();
        } else {
            this.authState.setState(null, 'guest');
        }
        // §A6 FECHADO (06/set/2026) pelo lado mais barato: o TTL local do AuthRepository
        // passou de 24 h para os MESMOS 14 dias da sessão do servidor — o estado local
        // existe sempre que a sessão existe, então não há mais "voltei em 2 dias e sou
        // visitante" sem o servidor ter esquecido ninguém. O caso inverso (servidor
        // esqueceu, cliente ainda mostra logado) é coberto pelo validateSessionInBackground
        // acima — COM UMA RESSALVA, aceita de propósito: ele pula se `navigator.onLine` é
        // false e mantém o estado local se o backend não responder (não-JSON/500). Nesses
        // casos o app mostra "logado" por até 14 d sem confirmação. O que a pessoa vê é o
        // PRÓPRIO progresso local (::u<id>), e o servidor recusa qualquer escrita sem
        // sessão (401 → handleSessionExpired assim que a rede voltar). O header pinta o
        // avatar antes da resposta (era o BUG-SESSION-EXPIRY do capsula; a janela só
        // ficou mais longa). O retorno de OAuth segue em _consumeOAuthReturn.
    }

    // === Login / Logout ===
    setUser(userData, type = 'logged') {
        // 🔴 TROCOU DE CONTA ⇒ preferência volta ao padrão. Hoje o invariante se segurava por
        // propriedade dos CHAMADORES (login/check_session/save_prefs trazem `prefs`, e o
        // `_absorbPrefs` roda antes daqui) — não pela fronteira. Um caminho novo alimentado
        // por resposta sem `prefs` faria a conta B herdar a decisão de privacidade da A em
        // silêncio, e o `track()` de B apagaria a fila de B por causa da preferência de A.
        // Auditoria de 07/set. Só quando o id MUDA: reidratar a mesma conta não pode zerar
        // o que o `_absorbPrefs` acabou de trazer.
        try {
            const antes = this.getUserId();
            const agora = userData && userData.id != null ? userData.id : null;
            if (antes != null && agora != null && String(antes) !== String(agora)) {
                this._prefs = Object.assign({}, UserManager.PREF_DEFAULTS);
            }
        } catch (e) {}
        this.authState.setState(userData, type);

        // §A1: ao virar não-guest, (1) IMPORTAR o progresso do ::guest pra conta
        // (promoção one-shot, merge monotônico — quem jogou de convidado não perde o
        // avanço ao logar) e SÓ ENTÃO (2) limpar o ::guest pra não vazar pro próximo.
        // Ordem importa: import lê ::guest antes de clearGuestScope apagá-lo. Centralizado
        // AQUI cobre login local, OAuth e signup. Fonte única de chaves = PROGRESS_BASE_KEYS.
        if (type !== 'guest' && window.StorageScope) {
            try {
                // > 0 = houve READOÇÃO com merge (a sessão tinha morrido no meio de uma
                // rodada e o take caiu no ::guest). O take volta pelo merge, mas o
                // DESBLOQUEIO é derivado e quem o aplica é o restoreFromServer — que sai
                // cedo quando o servidor devolve zero linhas daquele jogo (níveis 1-3 são
                // livres: dá para ter bag local e nada no servidor). Sem esta linha, o
                // nível reconquistado ficava trancado até o login seguinte.
                if (window.StorageScope.importGuestProgress() > 0) {
                    window.LevelProgress?.reapplyUnlocks?.();
                }
                window.StorageScope.clearGuestScope();
            } catch (e) {}
        }

        this.repository.save(this.authState);
        this.notifyStateChange();
    }

    logout() {
        this.authState.logout();
        this.repository.clear();
        // 🔴 Preferência é DA CONTA: sair tem de zerá-la para o padrão. Sem isto, a conta B
        // que logasse depois da conta A neste device herdaria o "diário desligado" dela até
        // o check_session responder — e nesse meio-tempo a decisão de privacidade de uma
        // pessoa estaria valendo para outra. É o mesmo princípio do StorageScope.
        this._prefs = Object.assign({}, UserManager.PREF_DEFAULTS);
        this.notifyStateChange();
    }

    /**
     * O servidor disse "sessão morta" (401 em apiGet/_doPost, ou check_session com
     * `session_expired`). Derruba o estado local e avisa a UI (AppHeader mostra toast).
     * 🔴 DEDUP: se já é convidado, não repete — um boot com 3 requisições em voo (my_scores,
     * songs_list, save_score) devolvia 3 × 401 e daria 3 toasts iguais.
     */
    handleSessionExpired(message = 'Sua sessão expirou. Faça login novamente.') {
        if (!this.isLoggedIn()) return;
        // 🔴 A morte da sessão pode chegar NO MEIO DE UMA RODADA: depois do logout o
        // StorageScope resolve para ::guest e o take em curso é gravado lá. No relogin, a
        // adoção guest→conta é one-shot por device e NÃO rodaria de novo — o resultado
        // ficaria em ::guest até o clearGuestScope apagá-lo. A marca abaixo autoriza UMA
        // readoção (não-destrutiva, como sempre) para esta conta. Antes de 06/set o 401
        // era mudo e o take ficava em ::u<id>; isto preserva o que dava para preservar.
        // 🔴 SÓ COM RODADA ABERTA. `handleSessionExpired` não roda apenas no meio de uma
        // partida: o `validateSessionInBackground` o chama no BOOT, quando a sessão de 14 d
        // já venceu no servidor. Marcando ali, a autorização ficava gravada num aparelho em
        // que ninguém está jogando — e, com o merge de 06/set, o próximo login daquela conta
        // adotaria o que QUALQUER convidado tivesse jogado nesse meio-tempo (medido na
        // auditoria: o progresso de outra pessoa subindo ao ranking sob o nome da conta).
        // `roundElapsed()` é o sinal público do EventTracker: número = rodada no ar (é ela
        // que vai gravar em ::guest depois do logout), null = não há take a resgatar.
        // A 2ª trava é o prazo da marca, em StorageScope.READOPT_TTL_MS.
        try {
            const rodadaAberta = window.eventTracker?.roundElapsed?.() != null;
            if (rodadaAberta) window.StorageScope?.markReadopt?.(this.getUserId());
        } catch (e) {}
        this.logout();
        if (typeof document !== 'undefined') {
            document.dispatchEvent(new CustomEvent('sessionExpired', { detail: { message } }));
        }
    }

    /**
     * 🔴 401 NÃO É `null`. Até 06/set/2026 `apiGet`/`_doPost` devolviam null/`network` para
     * QUALQUER `!res.ok` — "sua sessão morreu" era indistinguível de "a internet caiu", e o
     * progresso parava de subir em silêncio até o próximo reload (o único lugar que
     * validava sessão era o boot). Aqui: sessão morta derruba o estado local na hora e
     * devolve um código que o chamador consegue distinguir. `check_session` NÃO passa por
     * aqui (responde 200 com success:false de propósito; validateSessionInBackground trata).
     * @returns {object|null} o payload de sessão expirada, ou null se não é esse caso
     */
    _sessionDeath(res, data) {
        const dead = (res && res.status === 401) || (data && data.error_type === 'session_expired');
        if (!dead) return null;
        this.handleSessionExpired();
        return { success: false, error_code: 'session_expired' };
    }

    // === Getters / estado ===
    isLoggedIn() { return this.authState.isAuthenticated; }
    isGuest() { return this.authState.isGuest; }
    isAdmin() { return this.authState.isAdmin; }
    getUser() { return this.authState.user; }
    get user() { return this.authState.user; }
    getUserId() { const u = this.getUser(); return u?.id || u?.email || null; }
    getUserName() { return this.authState.userName; }
    getUserEmail() { return this.authState.userEmail; }
    getUserType() { return this.authState.userType; }

    // Matriz simples de permissão (expandir conforme features do ritmo)
    canAccess(feature) {
        switch (feature) {
            case 'basic_games': return true;
            case 'ranking':     return this.isLoggedIn();
            case 'admin_panel': return this.isAdmin();
            default:            return false;
        }
    }

    // === Eventos p/ a UI (header, seletor de níveis) ===
    notifyStateChange() {
        if (typeof document === 'undefined') return;
        document.dispatchEvent(new CustomEvent('userStateChanged', {
            detail: {
                user: this.getUser(),
                userType: this.getUserType(),
                isLoggedIn: this.isLoggedIn()
            }
        }));
    }

    _setupStateSync() {
        // auto-save sempre que o estado muda
        this.authState.subscribe(() => this.repository.save(this.authState));
    }

    // === Ganchos de servidor (Fase 4 — API same-origin /api/) ===

    /**
     * check_session no backend. Devolve o JSON ou NULL = "backend indisponível"
     * (rede caída, ou /api/ servindo o shell da SPA em prod até a Fase 3 subir) —
     * caso em que o chamador NÃO mexe no estado local (offline-first).
     */
    async _fetchCheckSession() {
        try {
            if (typeof fetch !== 'function' || typeof location === 'undefined') return null;
            const res = await fetch('/api/?action=check_session', { credentials: 'same-origin' });
            if (!res.ok) return null;
            const ct = res.headers.get('content-type') || '';
            if (ct.indexOf('json') === -1) return null; // catch-all da SPA → não é a API
            const data = await res.json();
            // Aviso de conta pendente (`notice`, ex.: 'password_cleared' gravado na sessão
            // pelo oauth_callback). Disparado no PRÓXIMO tick: quem chamou ainda vai fazer
            // setUser() com este mesmo `data`, então o ouvinte já encontra o usuário certo
            // (e-mail certo para "definir nova senha"). Vem da sessão, nunca da URL.
            if (data && data.success && data.notice && typeof document !== 'undefined') {
                const code = String(data.notice);
                setTimeout(() => document.dispatchEvent(new CustomEvent('authNotice', { detail: { code } })), 0);
            }
            return this._absorbPrefs(data);
        } catch (e) {
            return null;
        }
    }

    /**
     * §A2: restaura a UI na hora (offline-first) e SE o servidor disser "expirou", faz
     * logout. Pula se offline/guest. §A3: reconcilia userType autoritativo de carona.
     */
    async validateSessionInBackground() {
        if (typeof navigator !== 'undefined' && !navigator.onLine) return;
        if (!this.isLoggedIn()) return;
        const data = await this._fetchCheckSession();
        if (!data) return; // backend indisponível → mantém estado local
        if (data.success) {
            this.setUser(data.user, data.userType || 'logged');
        } else {
            this.handleSessionExpired();
        }
    }

    /** §A3: pegar o userType autoritativo do servidor e atualizar o estado local. */
    async syncUserTypeFromServer() {
        if (!this.isLoggedIn()) return;
        const data = await this._fetchCheckSession();
        if (data && data.success && data.userType && data.userType !== this.getUserType()) {
            this.setUser(data.user || this.getUser(), data.userType);
        }
    }

    // === Auth por formulário (Etapa A — e-mail/senha + social redirect) ===================
    //
    // Os métodos públicos devolvem um resultado NEUTRO de i18n: { success:true, ... } ou
    // { success:false, code } — `code` é uma chave estável (auth.errors.<code>) que a UI
    // localiza. O UserManager NÃO faz i18n. Sucesso de login/registro-com-sessão chama
    // setUser() (que importa o guest e higieniza o ::guest).

    _validEmail(email) {
        return typeof email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    }

    /** Token CSRF (double-submit). Cacheado; devolve null se o backend não responder. */
    async _getCsrf() {
        if (this._csrfToken) return this._csrfToken;
        try {
            if (typeof fetch !== 'function') return null;
            const res = await fetch('/api/?action=get_csrf_token', { credentials: 'same-origin' });
            if (!res.ok) return null;
            const ct = res.headers.get('content-type') || '';
            if (ct.indexOf('json') === -1) return null;
            const data = await res.json();
            if (data && data.success && data.token) { this._csrfToken = data.token; return data.token; }
            return null;
        } catch (e) { return null; }
    }

    /**
     * POST urlencoded p/ a API same-origin. Injeta csrf_token quando pedido. Tolerante a
     * backend ausente (não-JSON = shell da SPA / rede caída → { success:false, error_code:'network' }).
     * Se um POST com CSRF falhar por token inválido/expirado, refaz uma vez com token novo.
     */
    async _postForm(action, fields = {}, { csrf = false, keepalive = false } = {}) {
        let data = await this._doPost(action, fields, csrf, keepalive);
        const stale = data && (data.error_code === 'TOKEN_MISSING'
            || data.error_code === 'SESSION_EXPIRED' || data.error_code === 'CSRF_INVALID');
        if (csrf && stale) {
            this._csrfToken = null;                // força refetch
            data = await this._doPost(action, fields, csrf, keepalive);
        }
        return data;
    }

    /** `keepalive` = a página está indo embora (EventTracker no pagehide/hidden): o fetch
     *  sobrevive ao unload. Limite do navegador: ~64 KB em voo por origem. */
    async _doPost(action, fields, csrf, keepalive = false) {
        try {
            if (typeof fetch !== 'function') return { success: false, error_code: 'network' };
            const body = new URLSearchParams();
            if (csrf) {
                const token = await this._getCsrf();
                if (token) body.set('csrf_token', token);
            }
            Object.entries(fields).forEach(([k, v]) => body.set(k, v == null ? '' : String(v)));
            const res = await fetch('/api/?action=' + encodeURIComponent(action), {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body.toString(),
                keepalive: !!keepalive
            });
            // 🔴 401 ANTES do content-type: um 401 em HTML (página de erro do Apache, o
            // catch-all da SPA) é morte de sessão, não rede — classificá-lo como 'network'
            // era o mesmo silêncio que esta função veio matar. Igual ao apiGet.
            if (res.status === 401) return this._sessionDeath(res, null);
            const ct = res.headers.get('content-type') || '';
            if (ct.indexOf('json') === -1) return { success: false, error_code: 'network' };
            const data = await res.json();
            return this._sessionDeath(res, data) || this._absorbPrefs(data);
        } catch (e) { return { success: false, error_code: 'network' }; }
    }

    /** Traduz a resposta de erro do backend numa `code` estável p/ a UI localizar. */
    _errorResult(data) {
        if (!data) return { success: false, code: 'network' };
        if (data.error_type === 'social_account_exists') {
            return { success: false, code: 'social_account', provider: data.provider || null };
        }
        if (data.error_type === 'session_expired') return { success: false, code: 'session_expired' };
        const ec = data.error_code;
        if (ec === 'TOKEN_MISSING' || ec === 'SESSION_EXPIRED' || ec === 'CSRF_INVALID') {
            this._csrfToken = null;
            return { success: false, code: 'csrf' };
        }
        if (ec === 'network') return { success: false, code: 'network' };
        // error_code de negócio já vem no vocabulário do front (invalid_email, email_taken,
        // invalid_credentials, rate_limited, disposable_email, short_password, spam).
        if (ec) return { success: false, code: ec };
        return { success: false, code: 'generic' };
    }

    // === Reuso público p/ repositórios (RankingRepository, futuros) ==============
    // A ponte HTTP (CSRF+retry, tolerância a backend ausente/rede) vive aqui; repos de
    // dados apoiam-se nela em vez de reimplementar fetch. Devolvem o JSON cru (ou null/
    // {error_code:'network'} quando o backend não responde) — o repo interpreta.

    /**
     * GET same-origin na API. JSON, ou null (rede caída / catch-all da SPA = não-JSON /
     * erro de servidor). 🔴 Exceção: 401 devolve `{success:false, error_code:'session_expired'}`
     * e derruba a sessão local (ver _sessionDeath) — nunca `null`.
     */
    async apiGet(action, params = {}) {
        try {
            if (typeof fetch !== 'function') return null;
            const qs = new URLSearchParams({ action, ...params }).toString();
            const res = await fetch('/api/?' + qs, { credentials: 'same-origin' });
            if (res.status === 401) return this._sessionDeath(res, null);
            if (!res.ok) return null;
            const ct = res.headers.get('content-type') || '';
            if (ct.indexOf('json') === -1) return null;
            const data = await res.json();
            return this._sessionDeath(res, data) || this._absorbPrefs(data);
        } catch (e) { return null; }
    }

    /** POST same-origin na API (CSRF opcional + retry de token stale). Alias de _postForm. */
    async apiPost(action, fields = {}, opts = {}) { return this._postForm(action, fields, opts); }

    // === Preferências da conta (users.data) ===================================
    /**
     * 🔴 PADRÕES IGUAIS AOS DO SERVIDOR (`USER_PREFS` em auth-backend/php/auth-helpers.php).
     * Espelho inevitável (PHP não compartilha objeto com o browser) e guardado por teste,
     * que importa os dois lados. O padrão é o que vale ANTES de a 1ª resposta chegar — e
     * é por isso que ele tem de bater: divergir aqui faria a 1ª rodada da página gravar (ou
     * deixar de gravar) contra a vontade da pessoa, até o `check_session` responder.
     * 🔴 O servidor é a AUTORIDADE: ele recusa `track_events` quando desligado. Este cache
     * existe para não gastar rede e para a tela saber o que desenhar, não como trava.
     */
    static PREF_DEFAULTS = { analytics_enabled: 1, ranking_visible: 1, rhythm_tone: '', rhythm_ruler: '', rhythm_pitch: '' };

    /** Cacheia `prefs` de qualquer resposta que as traga (login, check_session, save_prefs)
     *  e devolve o próprio `data` — é usado como passagem no ponto de retorno. */
    _absorbPrefs(data) {
        try {
            if (data && data.prefs && typeof data.prefs === 'object') {
                this._prefs = Object.assign({}, UserManager.PREF_DEFAULTS, data.prefs);
            }
        } catch (e) {}
        return data;
    }

    /** Valor atual de uma preferência (padrão enquanto o servidor não respondeu). */
    getPref(name) {
        const bag = this._prefs || UserManager.PREF_DEFAULTS;
        return Object.prototype.hasOwnProperty.call(bag, name) ? bag[name] : UserManager.PREF_DEFAULTS[name];
    }

    /**
     * Grava UMA preferência. Otimista na tela? Não: só atualiza o cache com o que o
     * SERVIDOR devolveu (`_absorbPrefs` no caminho de volta), porque uma preferência que
     * a tela mostra ligada e o servidor tem desligada é pior que um instante de espera.
     * @returns {{success:boolean, prefs?:object, error_code?:string}}
     */
    async savePref(name, value) {
        if (!this.isLoggedIn()) return { success: false, error_code: 'not_logged' };
        const fields = {};
        // Liga/desliga vai como 1/0; ajuste de escolha (som da nota do Ritmo) vai como TEXTO,
        // e o servidor confere contra a lista dele (`USER_PREFS[k].values`).
        fields[name] = typeof value === 'string' ? value : (value ? 1 : 0);
        const uid = this.getUserId();
        const res = await this.apiPost('save_prefs', fields, { csrf: true });
        // 🔴 Trocou de conta enquanto o pedido estava em voo: a resposta é da conta ANTERIOR e
        //    não pode virar o cache da atual (inclui as preferências de PRIVACIDADE). Auditoria 18/set.
        //    🔴 Sessão MORTA não é troca de conta: o `_sessionDeath` já fez logout (uid → null) e
        //    avisou; devolver `account_changed` aí fazia o chamador mostrar um 2º toast por cima
        //    do "Sessão expirada" (auditoria 18/set). A resposta dela passa como veio.
        if (res && res.error_code === 'session_expired') return res;
        if (String(this.getUserId()) !== String(uid)) return { success: false, error_code: 'account_changed' };
        // 🔴 Absorve AQUI também, e não só no transporte: quem grava a preferência é quem
        // tem de deixar o cache coerente. Depender do `_doPost` fazia o método funcionar por
        // efeito colateral de outra camada — e qualquer chamada por outro caminho (teste,
        // ou um transporte novo amanhã) deixaria a tela mostrando o valor velho.
        // `_absorbPrefs` só age quando a resposta traz `prefs`, então recusa não pinta nada.
        return this._absorbPrefs(res) || { success: false, error_code: 'network' };
    }

    async loginWithPassword({ email, password } = {}) {
        if (!this._validEmail(email)) return { success: false, code: 'invalid_email' };
        if (!password) return { success: false, code: 'empty_password' };
        const data = await this._postForm('login', { email: email.trim(), password, extra_field: '' }, { csrf: true });
        if (data && data.success) {
            this.setUser(data.user, data.userType || 'logged');
            return { success: true, user: this.getUser() };
        }
        return this._errorResult(data);
    }

    async registerAccount({ name, email, password } = {}) {
        if (!this._validEmail(email)) return { success: false, code: 'invalid_email' };
        if (!password || password.length < UserManager.MIN_PASSWORD) return { success: false, code: 'short_password' };
        const data = await this._postForm('register',
            { name: (name || '').trim(), email: email.trim(), password, extra_field: '' }, { csrf: true });
        if (data && data.success) return { success: true, verificationRequired: !!data.verification_required };
        return this._errorResult(data);
    }

    async requestPasswordReset(email) {
        if (!this._validEmail(email)) return { success: false, code: 'invalid_email' };
        const data = await this._postForm('forgot_password', { email: email.trim() });
        if (data && data.success) return { success: true };  // resposta neutra do backend
        return this._errorResult(data);
    }

    /**
     * Reenvia o link de confirmação de e-mail (resposta neutra do backend). Só faz
     * sentido para conta local com `email_verified = 0` — é o AppHeader que decide
     * mostrar o botão; aqui é só a chamada.
     */
    async resendVerification(email) {
        if (!this._validEmail(email)) return { success: false, code: 'invalid_email' };
        const data = await this._postForm('resend_verification', { email: email.trim() });
        if (data && data.success) return { success: true };
        return this._errorResult(data);
    }

    /**
     * Redefine a senha a partir do token do e-mail (fluxo "esqueci a senha").
     * Sem CSRF: a autorização é o próprio token de reset. O backend, no sucesso, também
     * marca email_verified=1. Não abre sessão → a UI manda pro login com a nova senha.
     */
    async resetPassword(token, password) {
        if (!token) return { success: false, code: 'generic' };
        if (!password || password.length < UserManager.MIN_PASSWORD) return { success: false, code: 'short_password' };
        const data = await this._postForm('reset_password', { token, password });
        if (data && data.success) return { success: true };
        // reset_password devolve 'message' (token inválido/expirado) sem error_code → mapeia.
        if (data && !data.error_code && !data.error_type) return { success: false, code: 'reset_invalid' };
        return this._errorResult(data);
    }

    /** Logout do USUÁRIO (UI): encerra a sessão no servidor e depois o estado local. */
    async logoutServer() {
        try { await this._postForm('logout', {}); } catch (e) { /* segue: local sempre limpa */ }
        this.logout();
    }

    /** Apaga a conta no servidor (CSRF + sessão) e faz logout local. */
    async deleteAccount() {
        const data = await this._postForm('delete_account', {}, { csrf: true });
        if (data && data.success) {
            // 🔴 A FILA DO DIÁRIO SAI DO APARELHO JUNTO. O servidor cascateia `user_events`,
            // mas `event_queue_v1::u<id>` fica em localStorage — e como a conta não volta a
            // logar, o `dropQueue()` (que só roda em `track`/`flush`, no escopo corrente)
            // NUNCA mais rodaria: jogo, nível, precisão e horários dela ficariam para sempre
            // num navegador que pode ser de família ou de escola. Auditoria de 07/set.
            // ANTES do logout, que é quando o escopo ainda resolve para ::u<id>.
            // 🔴 Só aqui, nunca no logout comum: 401 e logout MANTÊM a fila de propósito
            // (o tripwire do diário é explícito), porque relogar continua de onde parou.
            try { window.eventTracker?.dropQueue(); } catch (e) {}
            this.logout();
            return { success: true };
        }
        return this._errorResult(data);
    }

    // === "Minha conta" (#/perfil) — ler e gravar o próprio cadastro ==============

    /**
     * O cadastro que a tela de perfil desenha (`my_profile`, GET com sessão): nome,
     * e-mail, avatar, papel, data de criação, COMO a pessoa entra (senha × provedores) e
     * quantos placares existem. Uma ida, tudo pronto — o molde é o `my_stats`.
     * @returns {Promise<object|null>} o bloco `profile`, ou null (rede caída / sessão morta).
     */
    async fetchProfile() {
        const data = await this.apiGet('my_profile');
        return (data && data.success && data.profile) ? data.profile : null;
    }

    /**
     * Grava o nome. PATCH: manda só o que muda (o servidor conta o que não conhece em
     * `dropped` e não recusa).
     *
     * 🔴 CORTA ANTES DE POSTAR, com o MESMO teto do servidor (`MAX_NAME_LEN`) — mas a
     * verdade que fica na tela é o `name` que VOLTA: cortar aqui e pintar o digitado faria
     * o header mostrar um nome que o ranking não tem. E a recusa de nome vazio é do
     * servidor (`empty_name`), não daqui: validação que nunca posta é buraco cego no log,
     * a lição de 13/ago.
     *
     * @returns {{success:boolean, name?:string, code?:string}}
     */
    async updateProfile({ name } = {}) {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const fields = {};
        if (typeof name === 'string') fields.name = name.trim().slice(0, UserManager.MAX_NAME);
        const data = await this._postForm('update_profile', fields, { csrf: true });
        if (data && data.success) {
            // O estado local passa a ser o do servidor — o header (avatar/iniciais) e o
            // ranking mostram a mesma coisa. `setUser` com o MESMO id não zera preferência
            // nem re-importa o ::guest (o IMPORT_FLAG é one-shot por conta/aparelho).
            if (data.changed && typeof data.name === 'string') {
                const u = Object.assign({}, this.getUser() || {}, { name: data.name });
                this.setUser(u, this.getUserType() || 'logged');
            }
            return { success: true, name: data.name, changed: !!data.changed };
        }
        return this._errorResult(data);
    }

    /**
     * Zera o progresso: apaga os placares NO SERVIDOR e, só depois, as chaves de progresso
     * DESTE aparelho para esta conta.
     *
     * 🔴 A ORDEM É A DEFESA. Limpar o aparelho primeiro e falhar no servidor apagaria o
     * trabalho da pessoa e o devolveria inteiro no próximo login (o `restoreFromServer`
     * funde o que está lá) — "zerei e voltou" é pior que "não zerou".
     * 🔴 O diário (`user_events`) e o repertório (`user_songs`) NÃO entram: apagar tudo é
     * `deleteAccount`, e é isso que a política publicada promete.
     */
    async resetProgress() {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const data = await this._postForm('reset_progress', {}, { csrf: true });
        if (!data || !data.success) return this._errorResult(data);
        let local = 0;
        try { local = window.StorageScope?.clearProgress?.() || 0; } catch (e) {}
        return { success: true, deleted: data.deleted || 0, local };
    }

    /**
     * Contato (#/contato): manda a mensagem ao dono. Só logado — o servidor recusa sem
     * sessão de qualquer jeito; a checagem aqui só evita a ida à rede.
     * 🔴 NÃO valida o tamanho antes de postar: recusa no cliente não deixa linha em log
     * nenhum (a lição de 13/ago). O servidor devolve `too_short`/`too_long` e a tela traduz.
     * O `maxlength` do campo é só o teto do DEDO, não uma recusa.
     */
    async sendContact(message) {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const data = await this._postForm('contact_send', { message: String(message == null ? '' : message) }, { csrf: true });
        if (data && data.success) return { success: true, id: data.id || null };
        return this._errorResult(data);
    }

    // === Grupos (escola/turma) — docs/GRUPOS-PLANO.md =========================
    // O grupo vive no payload do `user` (`group_id`/`group_name`, vindos de login e
    // check_session); entrar/sair atualiza esse payload pelo setUser (MESMO id: não zera
    // preferência nem re-importa o ::guest) e o `userStateChanged` avisa quem desenha.

    /** O grupo da conta logada: `{id, name}` ou null. Convidado: null. */
    getGroup() {
        const u = this.isLoggedIn() ? this.getUser() : null;
        if (!u || u.group_id == null) return null;
        return { id: Number(u.group_id), name: u.group_name || '' };
    }

    _applyGroup(g) {
        const u = Object.assign({}, this.getUser() || {}, {
            group_id: g ? Number(g.id) : null, group_name: g ? String(g.name || '') : null
        });
        this.setUser(u, this.getUserType() || 'logged');
    }

    /** Entrar num grupo pelo CÓDIGO de convite. @returns {{success:boolean, group?:object, code?:string}} */
    async joinGroup(code) {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const data = await this._postForm('join_group', { code: String(code == null ? '' : code).trim() }, { csrf: true });
        if (data && data.success && data.group) {
            this._applyGroup(data.group);
            return { success: true, group: data.group };
        }
        return this._errorResult(data);
    }

    /** Sair do grupo. Nada é apagado (é vínculo, não dado). Idempotente. */
    async leaveGroup() {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const data = await this._postForm('leave_group', {}, { csrf: true });
        if (data && data.success) {
            this._applyGroup(null);
            return { success: true, left: !!data.left };
        }
        return this._errorResult(data);
    }

    /** Grupos existentes (nome + quantos; o código só vem para admin). null = rede/sessão. */
    async listGroups(q = '') {
        if (!this.isLoggedIn()) return null;
        const data = await this.apiGet('list_groups', q ? { q } : {});
        if (!(data && data.success && Array.isArray(data.groups))) return null;
        // A FILA de pedidos vem junto só para admin (`requests`); a lista continua sendo o array,
        // com a fila pendurada nele para não mudar a forma que as telas já leem.
        const out = data.groups.slice();
        if (Array.isArray(data.requests)) out.requests = data.requests;
        return out;
    }

    /** Criar grupo — SÓ ADMIN (o portão devolve 403 `forbidden` para os outros). */
    async createGroup(name) {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const data = await this._postForm('create_group', { name: String(name == null ? '' : name) }, { csrf: true });
        if (data && data.success && data.group) return { success: true, group: data.group };
        return this._errorResult(data);
    }

    // === Autonomia de grupos (15/set; docs/GRUPOS-AUTONOMIA-PLANO.md) ==========
    // O grupo que a conta ORGANIZA vive no payload do `user` (`owns_group`: id, name, status,
    // is_active, live), vindo de login/check_session — o #/ranking decide o seletor por ele e
    // o #/perfil pinta o estado. O bloco COMPLETO (código, descrição, logo) vem do my_profile
    // (`owned_group`) e das respostas de escrita.

    /** O grupo que a conta organiza: `{id, name, status, is_active, live}` ou null. */
    getOwnedGroup() {
        const u = this.isLoggedIn() ? this.getUser() : null;
        if (!u || !u.owns_group || u.owns_group.id == null) return null;
        const g = u.owns_group;
        return { id: Number(g.id), name: String(g.name || ''), status: String(g.status || ''),
                 is_active: Number(g.is_active) || 0, live: !!g.live };
    }

    _applyOwnedGroup(g) {
        const u = Object.assign({}, this.getUser() || {}, {
            owns_group: g ? { id: Number(g.id), name: String(g.name || ''), status: String(g.status || ''),
                              is_active: Number(g.is_active) || 0, live: !!g.live } : null
        });
        this.setUser(u, this.getUserType() || 'logged');
    }

    /**
     * PEDIR a criação de um grupo (nome, descrição, observação). A recusa é do servidor
     * (`empty_group_name`, `pending_exists`, `owner_exists`, `group_taken`, `rate_limited`).
     * Sucesso atualiza o payload (`owns_group`) e devolve o bloco do dono.
     */
    async requestGroup({ name = '', description = '', note = '', country = '' } = {}) {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const data = await this._postForm('request_group', { name: String(name == null ? '' : name),
            description: String(description == null ? '' : description), note: String(note == null ? '' : note),
            country: String(country == null ? '' : country) }, { csrf: true });
        if (data && data.success && data.group) { this._applyOwnedGroup(data.group); return { success: true, group: data.group }; }
        return this._errorResult(data);
    }

    /** Editar o próprio grupo/pedido (PATCH: só as chaves passadas vão). */
    async updateGroup(groupId, fields = {}) {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const body = { group_id: String(groupId) };
        ['name', 'description', 'note', 'country'].forEach(k => { if (fields[k] != null) body[k] = String(fields[k]); });
        const data = await this._postForm('update_group', body, { csrf: true });
        if (data && data.success && data.group) {
            const mine = this.getOwnedGroup();
            if (mine && mine.id === Number(data.group.id)) this._applyOwnedGroup(data.group);
            return { success: true, group: data.group, changed: data.changed || [] };
        }
        return this._errorResult(data);
    }

    /**
     * Enviar (ou tirar, com `remove`) a LOGO — multipart. O servidor re-codifica a imagem; o
     * que volta é o bloco do dono com `has_logo`/`logo_v` (o `v` troca a URL da imagem).
     */
    async uploadGroupLogo(groupId, file, { remove = false } = {}) {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const data = await this._postMultipart('group_logo_put', { group_id: String(groupId), ...(remove ? { remove: '1' } : {}) },
            remove ? null : { field: 'logo', file });
        if (data && data.success && data.group) {
            const mine = this.getOwnedGroup();
            if (mine && mine.id === Number(data.group.id)) this._applyOwnedGroup(data.group);
            return { success: true, group: data.group };
        }
        return this._errorResult(data);
    }

    /** ADMIN: liberar/recusar um pedido (`decision` = 'approve' | 'reject'). */
    async decideGroup(groupId, decision, note = '') {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const data = await this._postForm('decide_group', { group_id: String(groupId), decision: String(decision), note: String(note == null ? '' : note) }, { csrf: true });
        if (data && data.success && data.group) return { success: true, group: data.group };
        return this._errorResult(data);
    }

    /**
     * A PÁGINA do grupo (pública). Convidado também chama: `apiGet` funciona sem sessão.
     * @returns {{success:boolean, group?:object, preview?:boolean, code?:string}}
     */
    async fetchGroupPage(groupId, lang = '') {
        const params = { id: String(groupId) };
        if (lang) params.lang = lang;
        // Não é o `apiGet`: ele devolve null em qualquer status ≠ 2xx, e aqui o 404 do
        // servidor TEM corpo (`no_group`) — "não existe" e "rede caída" são frases diferentes.
        try {
            if (typeof fetch !== 'function') return { success: false, code: 'network' };
            const res = await fetch('/api/?' + new URLSearchParams({ action: 'group_page', ...params }).toString(), { credentials: 'same-origin' });
            const ct = res.headers.get('content-type') || '';
            if (ct.indexOf('json') === -1) return { success: false, code: 'network' };
            const data = await res.json();
            if (data && data.success && data.group) return { success: true, group: data.group, preview: !!data.preview };
            if (data && data.error_code) return { success: false, code: data.error_code };
            return { success: false, code: 'network' };
        } catch (e) { return { success: false, code: 'network' }; }
    }

    // === Trilhas do professor (docs/LISTAS-PLANO.md, fase 1a, 17/set) ==========
    /**
     * A trilha pelo CÓDIGO do link. Convidado também chama (a capa é pública; os níveis só vêm
     * com sessão). Como o `fetchGroupPage`, não é o `apiGet`: o 404 TEM corpo (`no_list`) e
     * "não existe" e "rede caída" são frases diferentes.
     * @returns {{success:true, list:object, logged:boolean, can_edit:boolean, stats?:object}|{success:false, code:string}}
     */
    async fetchList(code) {
        try {
            if (typeof fetch !== 'function') return { success: false, code: 'network' };
            const res = await fetch('/api/?' + new URLSearchParams({ action: 'list_get', code: String(code || '') }).toString(), { credentials: 'same-origin' });
            const ct = res.headers.get('content-type') || '';
            if (ct.indexOf('json') === -1) return { success: false, code: 'network' };
            const data = await res.json();
            if (data && data.success && data.list) return { success: true, list: data.list, logged: !!data.logged, can_edit: !!data.can_edit, stats: data.stats || null };
            if (data && data.error_code) return { success: false, code: data.error_code };
            return { success: false, code: 'network' };
        } catch (e) { return { success: false, code: 'network' }; }
    }

    /**
     * Criar (`code` vazio) ou editar a trilha. `levels` = o array já serializado
     * (RhythmTrails.serializeLevels). A recusa é do SERVIDOR (`empty_list_name`, `lists_max`,
     * `bad_levels`, `too_many_levels`, `levels_too_big`, `forbidden`, `no_list`, `rate_limited`).
     */
    async saveList({ code = '', name = '', levels = [], visibility = '' } = {}) {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const fields = { code: String(code || ''), name: String(name == null ? '' : name), levels: JSON.stringify(levels) };
        if (visibility) fields.visibility = String(visibility);
        const data = await this._postForm('list_put', fields, { csrf: true });
        if (data && data.success && data.list) return { success: true, list: data.list, created: !!data.created, rev_up: !!data.rev_up, dropped: Number(data.dropped) || 0 };
        return this._errorResult(data);
    }

    /** As trilhas DA CONTA, com o retorno de cada uma (`stats`). null = rede/sessão. */
    async myLists() {
        if (!this.isLoggedIn()) return null;
        const data = await this.apiGet('my_lists');
        if (!(data && data.success && Array.isArray(data.lists))) return null;
        const out = data.lists.slice();
        out.max = Number(data.max) || 0;
        return out;
    }

    /** Apagar a PRÓPRIA trilha (o link morre para todo mundo — quem chama já confirmou). */
    async deleteList(code) {
        if (!this.isLoggedIn()) return { success: false, code: 'not_logged' };
        const data = await this._postForm('list_delete', { code: String(code || '') }, { csrf: true });
        if (data && data.success) return { success: true };
        return this._errorResult(data);
    }

    /**
     * A VISÃO DA TURMA de um grupo (só dono ou admin; docs/VISAO-DA-TURMA-PLANO.md). `game`
     * vazio = o servidor escolhe o de mais atividade; `tz` = offset do navegador (+HH:MM).
     * Não é o `apiGet` puro: 403/404 têm corpo e são frases diferentes de "rede caída".
     * 🔴 401 derruba a sessão como em todo lugar (`_sessionDeath`), nunca vira null.
     * @returns {Promise<{success:true, data:object}|{success:false, code:string}>}
     */
    async fetchClassView(groupId, { game = '', tz = '' } = {}) {
        try {
            if (typeof fetch !== 'function') return { success: false, code: 'network' };
            const params = { action: 'group_class_view', group_id: String(groupId) };
            if (game) params.game = game;
            if (tz) params.tz = tz;
            const res = await fetch('/api/?' + new URLSearchParams(params).toString(), { credentials: 'same-origin' });
            if (res.status === 401) { this._sessionDeath(res, null); return { success: false, code: 'session_expired' }; }
            const ct = res.headers.get('content-type') || '';
            if (ct.indexOf('json') === -1) return { success: false, code: 'network' };
            const data = await res.json();
            if (data && data.success && Array.isArray(data.students)) return { success: true, data };
            if (data && data.error_code) return { success: false, code: data.error_code };
            return { success: false, code: 'network' };
        } catch (e) { return { success: false, code: 'network' }; }
    }

    /** URL da logo de um grupo (o `v` faz o cache de 1 dia trocar na hora em que a logo muda). */
    static groupLogoUrl(groupId, v = '') {
        return '/api/?action=group_logo&id=' + encodeURIComponent(String(groupId)) + (v ? '&v=' + encodeURIComponent(String(v)) : '');
    }

    /** POST multipart same-origin (CSRF injetado). Só a logo usa; o resto é urlencoded. */
    async _postMultipart(action, fields = {}, file = null) {
        let data = await this._doMultipart(action, fields, file);
        // O MESMO retry de token velho do `_postForm` (auditoria M9): sair e entrar na mesma aba
        // deixava a 1ª troca de logo recusada com "recarregue a página".
        const stale = data && (data.error_code === 'TOKEN_MISSING' || data.error_code === 'SESSION_EXPIRED' || data.error_code === 'CSRF_INVALID');
        if (stale) { this._csrfToken = null; data = await this._doMultipart(action, fields, file); }
        return data;
    }

    async _doMultipart(action, fields, file) {
        try {
            if (typeof fetch !== 'function' || typeof FormData === 'undefined') return { success: false, error_code: 'network' };
            const fd = new FormData();
            const token = await this._getCsrf();
            if (token) fd.set('csrf_token', token);
            Object.entries(fields).forEach(([k, v]) => fd.set(k, v == null ? '' : String(v)));
            if (file && file.file) fd.set(file.field || 'file', file.file, file.file.name || 'upload');
            const res = await fetch('/api/?action=' + encodeURIComponent(action), { method: 'POST', credentials: 'same-origin', body: fd });
            if (res.status === 401) return this._sessionDeath(res, null);
            const ct = res.headers.get('content-type') || '';
            if (ct.indexOf('json') === -1) return { success: false, error_code: 'network' };
            const data = await res.json();
            return this._sessionDeath(res, data) || this._absorbPrefs(data);
        } catch (e) { return { success: false, error_code: 'network' }; }
    }

    /**
     * Login social: navegação top-level pro backend (oauth_start). O retorno cai em
     * _consumeOAuthReturn() no boot.
     *
     * 🔴 `from` = PATH do APP (ex.: /app/), NUNCA a rota do hash: o backend devolve pra
     * `{base}{from}?login=social`, e o app (SPA hash-router) vive em /app/. Mandar a
     * rota do hash (`/ritmo`) fazia o backend devolver pra landing estática `/ritmo/`,
     * que não carrega o bundle → o ?login=social nunca era consumido (bug 09/jul).
     */
    startOAuth(provider = 'google') {
        if (typeof location === 'undefined') return;
        const path = location.pathname || '/app/';
        const from = path.indexOf('/app/') !== -1 ? path : '/app/';
        const params = new URLSearchParams({ action: 'oauth_start', provider });
        UserManager.saveReturnRoute();
        params.set('from', from);
        const lang = (typeof window !== 'undefined' && window.language && window.language.currentLanguage) || '';
        if (lang) params.set('lang', lang);
        location.href = '/api/?' + params.toString();
    }

    /**
     * 🔴 GUARDA A ROTA ANTES DE SAIR PARA O GOOGLE.
     *
     * O login social é uma navegação de página inteira, e o hash NUNCA chega ao servidor
     * (o browser não o envia): o `from` leva só o PATH, então a volta caía sempre em
     * `/app/` sem rota — quem entrava na conta de dentro de "Música de verdade" voltava
     * para a tela inicial e perdia o lugar. O `AuthGate` já resolvia isso, mas SÓ quando
     * era o portão do nível 4 que abria o modal; entrar por vontade própria (pelo ☰ ou
     * pelo botão da estante) não guardava nada.
     *
     * `sessionStorage` porque a intenção morre com a aba; TTL curto pelo mesmo motivo do
     * intent do gate — voltar do Google sem logar e logar meia hora depois não pode
     * teleportar ninguém.
     */
    static ROUTE_KEY = 'auth_return_route';
    /** Rota NOSSA: path de letras/dígitos/`/`/`_`/`-`, query opcional de `k=v&k=v` no mesmo alfabeto. */
    static ROUTE_RE = /^#\/[a-zA-Z0-9/_-]*(\?[a-zA-Z0-9_-]+=[a-zA-Z0-9_-]*(&[a-zA-Z0-9_-]+=[a-zA-Z0-9_-]*)*)?$/;
    static ROUTE_TTL_MS = 10 * 60 * 1000;

    static saveReturnRoute(hash) {
        try {
            const h = (hash != null ? hash : (location.hash || ''));
            // 🔴 Só rota NOSSA entra. O valor volta a ser escrito em `location.hash` na
            // outra ponta, e aceitar texto livre daqui seria abrir uma porta para
            // qualquer coisa que consiga escrever no sessionStorage desta origem.
            // Aceita QUERY simples (`#/grupo/7?join=ABCD2345`): o link de convite tem de sobreviver
            // à ida ao Google. O alfabeto continua fechado (nada de `<`, `"`, espaço, `javascript:`).
            if (!UserManager.ROUTE_RE.test(h)) { sessionStorage.removeItem(UserManager.ROUTE_KEY); return; }
            sessionStorage.setItem(UserManager.ROUTE_KEY, JSON.stringify({ hash: h, at: Date.now() }));
        } catch (e) { /* modo privado: sem memória de rota, cai na home como antes */ }
    }

    /** Consome a rota guardada. `''` = não há (ou expirou). */
    static takeReturnRoute() {
        try {
            const raw = sessionStorage.getItem(UserManager.ROUTE_KEY);
            sessionStorage.removeItem(UserManager.ROUTE_KEY);
            if (!raw) return '';
            const o = JSON.parse(raw);
            if (!o || !o.hash || !o.at || (Date.now() - o.at) > UserManager.ROUTE_TTL_MS) return '';
            return UserManager.ROUTE_RE.test(o.hash) ? o.hash : '';
        } catch (e) { return ''; }
    }

    /**
     * Retorno do OAuth (Fase 4): o callback do backend abre a sessão PHP e redireciona
     * pro app com ?login=social (sucesso) ou ?auth_error=<código>. Aqui a query é
     * consumida e LIMPA da URL (preservando o hash da rota); no sucesso, check_session
     * traz o usuário e setUser() assume (higienizando ::guest via clearGuestScope).
     * Erros são GUARDADOS em _pendingAuthError (o boot roda antes de notifications/
     * authModal existirem) e drenados depois por takeAuthNotice() → toast localizado
     * no Main._handleEmailNotices. Também dispara 'authError' (compat p/ ouvintes futuros).
     */
    _consumeOAuthReturn() {
        if (typeof location === 'undefined' || typeof history === 'undefined') return;
        try {
            const params = new URLSearchParams(location.search);
            const isSocialReturn = params.get('login') === 'social';
            const authError = params.get('auth_error');
            if (!isSocialReturn && !authError) return;

            params.delete('login');
            params.delete('auth_error');
            params.delete('linked'); // legado (05/set, algumas horas): o aviso hoje vem do check_session
            const qs = params.toString();
            // 🔴 A rota volta ANTES do check_session, e por replaceState: assim a tela já
            // nasce no lugar certo, sem um pisca-pisca pela home e sem uma entrada extra
            // no histórico (o Voltar tem de sair do app, não desfazer o login).
            // Se o `AuthGate` tiver um intent (portão do nível 4), ele navega DEPOIS, no
            // `userStateChanged`, e vence — é o destino mais específico dos dois.
            const rota = UserManager.takeReturnRoute();
            const destino = (isSocialReturn && rota) ? rota : location.hash;
            history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + destino);

            if (authError) {
                this._pendingAuthError = authError; // drenado por takeAuthNotice() → toast localizado
                document.dispatchEvent(new CustomEvent('authError', { detail: { code: authError } }));
                return;
            }
            this._fetchCheckSession().then((data) => {
                if (data && data.success) this.setUser(data.user, data.userType || 'logged');
            });
        } catch (e) {}
    }

    /**
     * Consome os marcadores de e-mail na query do boot do /app/ e os LIMPA da URL
     * (preservando hash + demais params), devolvendo {verified, resetToken} pra a UI agir:
     *   ?verified=1|0   ← retorno do link de verificação (case verify_email do handler)
     *   ?reset_token=…  ← link de "esqueci a senha" → abre o AuthModal no modo reset
     *   authError       ← código de erro OAuth já consumido da URL no boot (_pendingAuthError)
     * (O aviso de senha apagada NÃO passa por aqui: vem do check_session → evento 'authNotice'.)
     * Chamado pelo Main.init (quando notifications/authModal já existem) — não abre UI aqui
     * pra não acoplar core→componentes nem depender da ordem de parse do bundle.
     */
    takeAuthNotice() {
        const out = { verified: null, resetToken: null, authError: null };
        // Erro OAuth guardado no boot (a URL já foi limpa por _consumeOAuthReturn).
        if (this._pendingAuthError) { out.authError = this._pendingAuthError; this._pendingAuthError = null; }
        if (typeof location === 'undefined' || typeof history === 'undefined') return out;
        try {
            const params = new URLSearchParams(location.search);
            if (!params.has('verified') && !params.has('reset_token')) return out;
            if (params.has('verified'))    out.verified = params.get('verified');
            if (params.has('reset_token')) out.resetToken = params.get('reset_token');
            params.delete('verified');
            params.delete('reset_token');
            const qs = params.toString();
            history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
        } catch (e) {}
        return out;
    }
}

// 🔴 TAMANHO MÍNIMO DE SENHA — FONTE ÚNICA do cliente (o espelho do servidor é
// MIN_PASSWORD_LEN em auth-backend/php/handler.php; mexer num sem o outro deixa a
// recusa acontecendo do lado errado). O texto que o usuário lê NÃO repete o número:
// as 3 strings de i18n interpolam {min} a partir daqui.
// 6 (e não 8) porque a conta aqui guarda progresso de jogo de música — não há segredo
// a proteger, e o piso de 8 barrava cadastro ANTES de sair requisição alguma
// (o `registerAccount` recusa local → o servidor nem vê, e o log de acesso fica MUDO).
UserManager.MIN_PASSWORD = 6;

// 🔴 TETO DO NOME — espelho de `MAX_NAME_LEN` no handler.php (guardado por `profile-test`,
// que importa os dois lados). Aqui ele CORTA antes de postar; lá ele corta de novo, porque
// o servidor não confia no cliente. Divergir faz a tela prometer um nome que o banco não
// guarda (cliente maior) ou cortar o que o servidor aceitaria (cliente menor).
UserManager.MAX_NAME = 60;
// Faixa da mensagem de contato — espelho de CONTACT_MIN_LEN/CONTACT_MAX_LEN no handler.php
// (o contact-test lê os dois). Aqui só servem ao contador e ao `maxlength`; quem recusa é o servidor.
UserManager.CONTACT_MIN = 10;
UserManager.CONTACT_MAX = 4000;

// Singleton global + expõe a instância de AuthState que o StorageScope lê (window.authState).
// Auto-instancia no parse (antes de Main.init), igual aos demais singletons de core.
window.UserManager = UserManager;
window.userManager = new UserManager();
window.authState = window.userManager.authState;



// ============================================
// core/EventTracker.js
// ============================================
/**
 * EventTracker — o DIÁRIO da conta, lado cliente (pacote C, 06/set/2026).
 * Ver docs/EVENTOS-PLANO.md. Singleton `window.eventTracker`.
 *
 * Em português comum: o servidor só guardava o MELHOR resultado de cada nível. Ele não
 * sabia quando a pessoa jogou, quantas vezes tentou, quanto tempo ficou nem se desistiu.
 * Isto aqui anota cada coisa que acontece (uma linha, nunca editada) e manda em lotes
 * para `track_events`, que grava em `user_events`. Estatística, medalha e painel do
 * professor são leituras desse diário.
 *
 * 🔴 SÓ LOGADO gera evento (D2): `track()` é no-op para convidado. O funil anônimo
 *    continua sendo o `Beacon` (px.gif) — este é o irmão LOGADO, não uma mudança do funil.
 * 🔴 OS JOGOS NÃO MUDAM (D6): os ganchos moram nos pontos únicos que todo jogo já cruza —
 *    `LevelProgress.recordBest()` → level_result; `Beacon.roundOpen/roundClose()` →
 *    session_time e level_abandoned. Jogo novo entra em Main.GAMES e ganha o diário de
 *    graça. A única linha dentro de um jogo é o `song_played` no fim de peça do
 *    SongReadingGame (o único jogo fora do LevelProgress; a identidade da peça só existe lá).
 * 🔴 `EVENTS` é a MESMA tabela de `auth-backend/php/events-schema.php`, conferida por
 *    IMPORTAÇÃO no `event-tracker-test` (não por espelho manual). Evento novo = as duas.
 * 🔴 Fila em localStorage ESCOPADA POR CONTA via `StorageScope.key()` (`::u<id>`), e
 *    FORA de `PROGRESS_BASE_KEYS`: fila de convidado não existe e adoção guest→conta não
 *    faz sentido para evento. Teto 500 (FIFO). Todo setItem em try/catch (quota).
 * 🔴 401 mantém a fila: a morte de sessão já é do UserManager (handleSessionExpired); ao
 *    relogar na mesma conta a fila dela segue de onde parou.
 * 🔴 `game_id` NÃO tem tabela própria: sai de `Main.GAMES` (rota `/ritmo` → 'ritmo', o
 *    MESMO id de rank-config.php). Rota "-livre" (`rhythmFree`) resolve para o jogo-mãe
 *    com `free:1`. Espelho aqui divergiria no próximo jogo.
 * 🔴 Tempo de rodada = Date.now() entre roundOpen e roundClose. Não é tempo MUSICAL (o
 *    relógio único de áudio é do RhythmEngine); é duração de sessão, e `setTimeout` do
 *    flush idem. Nunca timer de página: aba em segundo plano não conta (D-plano §5).
 */
class EventTracker {
    /** Whitelist: nome → chaves do payload ('?' = opcional). = events-schema.php. */
    static EVENTS = {
        // `list`/`lid`/`rev` = trilha do professor (docs/LISTAS-PLANO.md): o lid é a identidade
        // do nível, `level` leva só a posição na hora. Emitidos pelo modo `list` do RhythmGame.
        level_result:    ['game_id', 'level', 'accuracy', 'passed', '?best_ms', '?duration_s', '?onset', '?duration', '?list', '?lid', '?rev'],
        level_abandoned: ['game_id', '?level', 'elapsed_s', '?free', '?list'],
        song_played:     ['song_id', 'mode', '?duration_s', 'own'],
        session_time:    ['game_id', 'seconds', '?free', '?list']
    };

    static QUEUE_KEY = 'event_queue_v1';   // + StorageScope (::u<id>)
    static MAX_QUEUE = 500;                // FIFO: acima disto o mais velho cai
    static BATCH = 50;                     // = EVENTS_MAX_BATCH do handler
    static FLUSH_N = 20;                   // lote cheio → manda já
    static FLUSH_MS = 30000;               // senão, em até 30 s
    /**
     * Códigos em que o lote é VENENO e se descarta (senão a fila trava atrás dele para
     * sempre). Lista FECHADA e curta de propósito: `bad_batch` é a única recusa definitiva
     * que o servidor emite para um lote. TUDO O MAIS MANTÉM a fila — rede, 401, balde, CSRF
     * e também `server_error` (500), `unknown_action` (404) e `gate_misconfigured`: são
     * exatamente o que acontece quando o front sobe antes do backend ou a migração 003
     * não foi aplicada, e nessa janela apagar a fila destruiria horas de diário de todo
     * mundo, em silêncio (auditoria 06/set: a 1ª versão tinha a polaridade INVERTIDA —
     * lista de "fica" e descarte por padrão). O teto 500 FIFO é o que torna "manter" seguro.
     */
    static DROP_ON = new Set(['bad_batch']);
    /** Teto do servidor para segundos de rodada (`int:0..86400` no events-schema.php): o
     *  cliente CLAMPA em vez de deixar o evento ser rejeitado em silêncio. */
    static MAX_SECONDS = 86400;

    constructor() {
        this._timer = null;
        this._inflight = false;
        this._round = null;     // { g, lvl, at, hidden } — rodada aberta pelo gancho do Beacon
        this._hiddenAt = null;  // instante em que a aba foi escondida (desconto do tempo de rodada)
        this._bind();
        // Sessão RESTAURADA no boot (restoreSession não dispara userStateChanged): a fila que
        // sobrou de ontem sai em 30 s, sem depender de um track novo nem do backend responder.
        if (this._loggedIn()) this._arm();
    }

    // ---------- dependências em runtime (todas opcionais: nunca lança) ----------
    _um() { try { return window.userManager || null; } catch (e) { return null; } }
    _loggedIn() { try { return !!(this._um() && this._um().isLoggedIn()); } catch (e) { return false; } }
    /**
     * GATE DE LGPD (`users.data` → `analytics_enabled`, pacote B item 4). Desligado, o
     * diário para de anotar e a fila que existia é DESCARTADA — manter a fila faria o
     * "não registre" virar "registre depois", que é pior que não ter o interruptor.
     * 🔴 Isto NÃO é a trava: a trava é o servidor, que recusa `track_events` quando a
     *    preferência está desligada. Aqui é economia de rede e coerência de tela — uma aba
     *    com bundle velho continua sendo barrada do outro lado.
     * 🔴 Ausente/desconhecida vale LIGADO, o mesmo padrão do servidor: divergir faria a
     *    janela entre o boot e o `check_session` gravar (ou perder) contra a vontade.
     */
    _analyticsOn() {
        try {
            const um = this._um();
            if (!um || typeof um.getPref !== 'function') return true;
            return !!um.getPref('analytics_enabled');
        } catch (e) { return true; }
    }
    _key() {
        try { return window.StorageScope ? window.StorageScope.key(EventTracker.QUEUE_KEY) : EventTracker.QUEUE_KEY + '::guest'; }
        catch (e) { return EventTracker.QUEUE_KEY + '::guest'; }
    }
    _ls() { try { return window.localStorage || null; } catch (e) { return null; } }

    // ---------- fila ----------
    /** `key` opcional: quem atravessa um `await` PASSA a chave capturada antes (ver flush). */
    _read(key = null) {
        try {
            const raw = this._ls() && this._ls().getItem(key || this._key());
            const arr = raw ? JSON.parse(raw) : null;
            return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
    }
    _write(arr, key = null) {
        try { if (this._ls()) this._ls().setItem(key || this._key(), JSON.stringify(arr)); } catch (e) { /* quota: evento perdido, app segue */ }
    }
    /** Quantos eventos esperam envio (da conta atual). */
    pending() { return this._read().length; }

    /**
     * Apaga a fila da conta atual. Usado pelo gate de LGPD: quem desliga o diário não pode
     * ficar com eventos guardados no aparelho esperando um religamento — "não registre"
     * tem de valer também para o que já estava a caminho.
     */
    dropQueue() {
        try { if (this._ls()) this._ls().removeItem(this._key()); } catch (e) {}
    }

    static uuid() {
        try { if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID(); } catch (e) {}
        // v4 manual (ambiente sem randomUUID): mesmo formato que o servidor valida.
        let s = '';
        for (let i = 0; i < 32; i++) s += Math.floor(Math.random() * 16).toString(16);
        return s.slice(0, 8) + '-' + s.slice(8, 12) + '-4' + s.slice(13, 16) + '-' +
               (8 + Math.floor(Math.random() * 4)).toString(16) + s.slice(17, 20) + '-' + s.slice(20, 32);
    }

    /**
     * Anota um evento. No-op se convidado, nome fora da whitelist ou payload sem as
     * chaves obrigatórias. Só as chaves da whitelist entram (o resto some aqui, não
     * viaja). Devolve o item enfileirado ou null.
     */
    track(name, payload = {}) {
        try {
            if (!this._loggedIn()) return null;
            // Gate de LGPD: desligado, não anota — e limpa o que já estava na fila.
            if (!this._analyticsOn()) { this.dropQueue(); return null; }
            const spec = EventTracker.EVENTS[name];
            if (!spec) return null;
            const clean = {};
            for (const k of spec) {
                const key = k[0] === '?' ? k.slice(1) : k;
                const v = payload ? payload[key] : undefined;
                if (v === undefined || v === null) { if (k[0] !== '?') return null; continue; }
                clean[key] = v;
            }
            const item = { uuid: EventTracker.uuid(), name, ts: Date.now(), payload: clean };
            const q = this._read();
            // 1º evento da conta nesta página: pré-busca o token CSRF, para o flush do
            // `pagehide` (keepalive) não depender de um GET que o unload cancela.
            if (!q.length) { try { const um = this._um(); if (um && !um._csrfToken && typeof um._getCsrf === 'function') um._getCsrf(); } catch (e) {} }
            q.push(item);
            while (q.length > EventTracker.MAX_QUEUE) q.shift();
            this._write(q);
            if (q.length >= EventTracker.FLUSH_N) this.flush();
            else this._arm();
            return item;
        } catch (e) { return null; }
    }

    _arm() {
        if (this._timer) return;
        try { this._timer = setTimeout(() => { this._timer = null; this.flush(); }, EventTracker.FLUSH_MS); } catch (e) {}
    }

    /**
     * Manda até BATCH eventos. `keepalive` = a página está indo embora (hidden/pagehide).
     * Sucesso remove os enviados (por uuid — o que entrou na fila durante o voo fica).
     * Falha transitória (rede, 401, balde, CSRF, resposta sem código) MANTÉM e rearma o
     * timer; lote veneno (recusa definitiva COM código, ex.: bad_batch) é descartado,
     * senão a fila travaria para sempre atrás dele.
     * 🔴 A chave da fila é capturada ANTES do `await`: se a sessão morrer durante o voo
     *    (um 401 paralelo), `_key()` já resolve para `::guest` na volta — e o pós-voo
     *    escreveria uma fila-lixo de convidado e deixaria os enviados na da conta
     *    (achado do event-tracker-test).
     */
    async flush({ keepalive = false } = {}) {
        if (this._inflight) return null;
        if (!this._loggedIn()) return null;
        // Desligado: nada a mandar, e a fila não pode ficar esperando um religamento.
        if (!this._analyticsOn()) { this.dropQueue(); return null; }
        const key = this._key();
        const q = this._read(key);
        if (!q.length) return null;
        const um = this._um();
        if (!um || typeof um.apiPost !== 'function') return null;
        // No unload, sem token em cache o `_getCsrf` (GET sem keepalive) é cancelado e o POST
        // nunca sai — e ainda gasta 2 fichas do balde. Não tenta: a fila fica para a próxima.
        if (keepalive && !um._csrfToken) return null;
        const batch = q.slice(0, EventTracker.BATCH);
        this._inflight = true;
        let res = null;
        try {
            res = await um.apiPost('track_events', { events: JSON.stringify(batch) }, { csrf: true, keepalive });
        } catch (e) { res = { success: false, error_code: 'network' }; }
        this._inflight = false;
        const drop = !!(res && res.success) ||
            !!(res && res.success === false && EventTracker.DROP_ON.has(res.error_code));
        // `rejected`/`dropped_keys` são o ÚNICO sinal de emissor quebrado (o servidor aceita o
        // lote e joga o evento fora): não pode morrer aqui em silêncio.
        // 🔴 O servidor RECUSOU por preferência: ele é a autoridade, então a aba se corrige
        //    sozinha em vez de gravar e bater a cada 30 s pelo resto da vida da página. É o
        //    conserto barato do caso "duas abas" e do "boot offline": a aba com `_prefs`
        //    velha descobre pela resposta que a conta desligou o diário. Auditoria de 07/set.
        if (res && res.success && res.analytics_disabled) {
            try {
                const um = this._um();
                if (um && typeof um._absorbPrefs === 'function') um._absorbPrefs({ prefs: { analytics_enabled: 0 } });
            } catch (e) {}
            this.dropQueue();
            return res;   // não passa pelo aviso de "emissor quebrado" abaixo: não é isso
        }
        if (res && res.success && ((res.rejected | 0) > 0 || (res.dropped_keys | 0) > 0)) {
            try { console.warn('[EventTracker] servidor rejeitou', res.rejected | 0, 'evento(s) e descartou', res.dropped_keys | 0, 'chave(s) do lote — emissor fora do events-schema.php'); } catch (e) {}
        }
        if (drop) {
            const sent = new Set(batch.map(e => e.uuid));
            this._write(this._read(key).filter(e => !sent.has(e.uuid)), key);
        }
        if (this._read(key).length && this._loggedIn()) this._arm();
        return res;
    }

    // ---------- ganchos (chamados pelo Beacon e pelo LevelProgress) ----------
    /**
     * `game_id` do servidor a partir do NOME DE ROTA do Beacon ('rhythm', 'rhythmFree'…):
     * lê Main.GAMES (rota '/ritmo' ↔ name 'rhythm'). Devolve { id, free } ou null.
     */
    static gameFor(routeName) {
        try {
            if (!routeName) return null;
            const free = /Free$/.test(routeName);
            const base = free ? routeName.replace(/Free$/, '') : routeName;
            const games = (window.main && window.main.constructor && window.main.constructor.GAMES) ||
                          (window.Main && window.Main.GAMES) || null;
            if (!games) return null;
            for (const route in games) {
                if (Object.prototype.hasOwnProperty.call(games, route) && games[route] && games[route].name === base) {
                    return { id: route.replace(/^\//, ''), free: free ? 1 : 0 };
                }
            }
            return null;
        } catch (e) { return null; }
    }

    /** Beacon.roundOpen → guarda o instante. Rodada já aberta é substituída (o Beacon fecha a
     *  anterior como quit antes). `routeName` null = descarta (Beacon.roundCancel). */
    roundOpened(routeName, level, extra = null) {
        try {
            // `extra` = o que a rodada carrega além do nível (hoje só `list`, a trilha do professor):
            // entra em session_time e level_abandoned. Só chaves da whitelist sobrevivem ao track().
            const list = extra && typeof extra.list === 'string' && extra.list ? extra.list : null;
            this._round = routeName ? { g: routeName, lvl: level != null ? level : null, at: Date.now(), hidden: 0, list } : null;
            // Aberta com a aba já escondida: o desconto começa agora.
            if (this._round && this._hiddenAt != null) this._hiddenAt = Date.now();
        } catch (e) { this._round = null; }
    }

    /**
     * Segundos de rodada VISÍVEIS: parede menos o tempo com a aba escondida (tela apagada,
     * app trocado, sono) — mesma régua do `sat_*`. Clampado no teto do servidor. Sem o
     * desconto, bloquear o celular no meio de uma peça e voltar 3 h depois somava 10.800 s
     * de "tempo de rodada" (auditoria 06/set). null sem rodada aberta.
     */
    _elapsed() {
        const r = this._round;
        if (!r) return null;
        const hiddenNow = this._hiddenAt != null ? Math.max(0, Date.now() - this._hiddenAt) : 0;
        const secs = Math.round((Date.now() - r.at - r.hidden - hiddenNow) / 1000);
        return Math.min(EventTracker.MAX_SECONDS, Math.max(0, secs));
    }

    /** Segundos visíveis desde o roundOpen, ou null. Lido pelo song_played antes do fecho. */
    roundElapsed() { return this._elapsed(); }

    /** Beacon.roundClose → session_time (sempre) e level_abandoned (quit). */
    roundClosed(routeName, level, outcome) {
        try {
            const r = this._round;
            if (!r) return;
            const secs = this._elapsed();
            this._round = null;
            if (!this._loggedIn()) return;
            const game = EventTracker.gameFor(routeName || r.g);
            if (!game) return;
            this.track('session_time', { game_id: game.id, seconds: secs, free: game.free, list: r.list || null });
            if (outcome === 'quit') {
                this.track('level_abandoned', { game_id: game.id, level: level != null ? level : r.lvl, elapsed_s: secs, free: game.free, list: r.list || null });
            }
        } catch (e) { /* diário nunca quebra o jogo */ }
    }

    // ---------- ciclo de vida da página ----------
    _bind() {
        try {
            if (typeof document === 'undefined' || !document.addEventListener) return;
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'hidden') {
                    if (this._hiddenAt == null) this._hiddenAt = Date.now();
                    this.flush({ keepalive: true });
                } else {
                    // Voltou: o intervalo escondido vai para o desconto da rodada aberta.
                    if (this._hiddenAt != null && this._round) this._round.hidden += Math.max(0, Date.now() - this._hiddenAt);
                    this._hiddenAt = null;
                }
            });
            // Login (ou sessão restaurada): a fila DESTA conta pode ter sobrado de antes.
            document.addEventListener('userStateChanged', (e) => {
                if (e && e.detail && e.detail.isLoggedIn) this._arm();
            });
        } catch (e) {}
        try { window.addEventListener('pagehide', () => this.flush({ keepalive: true })); } catch (e) {}
    }
}

window.EventTracker = EventTracker;
window.eventTracker = new EventTracker();



// ============================================
// core/AuthGate.js
// ============================================
/**
 * AuthGate — portão de conta nos níveis das trilhas ranqueadas.
 *
 * Regra de produto: os {FREE_LEVELS} primeiros níveis de CADA trilha são livres pra
 * anônimo; entrar em nível acima exige conta (parede MOLE: cancelar = segue nos livres).
 * A fronteira mora SÓ AQUI — os jogos nunca hardcodam o número, só perguntam allow().
 * Espelha o gate do capsula (LevelBasedGame.requireLogin + enforceLoginProtection),
 * por composição: o jogo chama, o gate decide e abre o AuthModal com contexto de
 * recompensa (Google 1-toque em destaque — o AuthModal já põe o social no topo).
 *
 * API (níveis sempre 1-BASED humanos — trilhas 0-indexed convertem idx+1):
 *   allow(levelNum, ctx, resume) → true se liberado; false = bloqueou E abriu o gate.
 *       ctx = { gameId, route } (route = hash da trilha, ex.: '#/ritmo' — usado na
 *       retomada pós-OAuth, que perde o hash no redirect). resume() é re-invocado
 *       após login in-page (e-mail/senha) pra entrar no nível pretendido.
 *   clampForGuest(levelNum) → min(levelNum, FREE_LEVELS) se guest (defesa: logout com
 *       nível corrente alto / storage adulterado — espelho do enforceLoginProtection).
 *   takeIntentFor(gameId) → o jogo consome a intenção no init (só se logado, gameId
 *       bate e não expirou o TTL) e re-entra no nível pretendido.
 *
 * Pós-OAuth (redirect do Google perde o hash → boot cai em /app/ sem rota): o próprio
 * gate resolve, sem tocar no Main — o listener de 'userStateChanged' detecta o login
 * do boot SEM pendência in-page e navega pro route salvo no intent; o jogo monta e
 * consome via takeIntentFor. TTL de 10 min: intent órfão (voltou do Google sem logar,
 * OAuth com erro) não teleporta o jogador dias depois dentro da mesma aba.
 *
 * Retomada in-page: ouve 'userStateChanged' (document) — NÃO authState.subscribe —
 * porque o UserManager só dispara o evento DEPOIS do importGuestProgress (§A1);
 * o observer direto do authState acorda cedo demais, com o escopo da conta ainda
 * vazio, e a retomada cairia num nível "trancado". Modal fechado sem login
 * ('auth-modal-closed', disparado pelo AuthModal) descarta a pendência (senão um
 * login futuro pelo header teleportaria o jogador de nível).
 */
class AuthGate {
    // Fonte ÚNICA da fronteira (1-based): níveis 1..FREE_LEVELS livres, acima = conta.
    static FREE_LEVELS = 3;

    static INTENT_KEY = 'auth_gate_intent'; // sessionStorage — sobrevive ao redirect OAuth
    static INTENT_TTL_MS = 10 * 60 * 1000;  // intent órfão expira (não teleportar depois)

    constructor() {
        if (AuthGate.instance) return AuthGate.instance;
        this._pending = null;   // { resume } do gate aberto (retomada in-page)
        this._gateCtx = null;   // funil: gate EM ABERTO nesta página (p/ atribuir o desfecho)
        if (typeof document !== 'undefined') {
            document.addEventListener('userStateChanged', (e) => {
                if (!e.detail || !e.detail.isLoggedIn) return;
                // Funil: converteu depois do gate. No fluxo SOCIAL (Google) o redirect do
                // OAuth trocou de page-load e levou o _gateCtx (só memória) — sem isto,
                // TODA conversão por Google sairia como 'shown' sem desfecho, ou seja,
                // seria lida como abandono duro. O intent do sessionStorage atravessa o
                // redirect e já valida shape + TTL de 10 min (não atribui gate antigo).
                if (!this._gateCtx) {
                    const it = this._peekIntent();
                    if (it) this._gateCtx = { gameId: it.gameId || '', levelNum: it.levelNum };
                }
                this._closeGateBeacon('auth');
                if (this._pending) {
                    // Retomada IN-PAGE (e-mail/senha na mesma sessão): re-executa a ação.
                    const fn = this._pending.resume;
                    this._pending = null;
                    this._clearIntent();
                    try { fn(); } catch (err) { console.error('AuthGate resume error:', err); }
                    return;
                }
                // Boot PÓS-OAUTH (sem pendência in-page): o redirect do Google perdeu o
                // hash → navega pra rota do intent; o init do jogo consome (takeIntentFor).
                const it = this._peekIntent();
                if (it && it.route && window.location.hash !== it.route) {
                    window.location.hash = it.route;
                }
            });
            document.addEventListener('auth-modal-closed', () => {
                // Fechou sem logar → abandona pendência E intenção salva (mesmo sem
                // pendência: trocar de rota com o gate aberto zera o _pending, mas o
                // fechar-sem-logar ainda precisa descartar o intent do sessionStorage).
                if (window.userManager && window.userManager.isGuest()) {
                    this._pending = null;
                    this._clearIntent();
                    this._closeGateBeacon('cancel');  // funil: desistiu do portão
                }
            });
            // Erro no OAuth (?auth_error consumido pelo UserManager no boot) → a ida ao
            // Google fracassou; descarta a intenção pra um login futuro não teleportar.
            document.addEventListener('authError', () => this._clearIntent());
        }
        if (typeof window !== 'undefined') {
            // Troca de rota com gate aberto (ex.: Back do browser): a screen morre, mas o
            // closure de resume referencia o jogo MORTO → descarta a pendência in-page.
            // O intent do sessionStorage FICA: se o login vier depois, o fluxo de boot
            // (navega pro route + init consome) retoma do jeito certo, em instância viva.
            // + funil: sair da rota com o portão aberto é ABANDONO honesto. Sem limpar o
            // _gateCtx, um login futuro pelo header (minutos depois, noutra tela) seria
            // atribuído como conversão daquele gate abandonado. O desfecho legítimo pós-
            // OAuth não se perde: é reconstruído pelo intent no userStateChanged.
            window.addEventListener('hashchange', () => { this._pending = null; this._gateCtx = null; });
        }
        AuthGate.instance = this;
    }

    /** Bloqueado = anônimo tentando nível acima da fronteira. */
    isBlocked(levelNum) {
        return levelNum > AuthGate.FREE_LEVELS &&
            !!(window.userManager && window.userManager.isGuest());
    }

    /**
     * Porta única dos jogos: true = pode entrar; false = gate aberto (o jogo dá
     * return e NÃO muta nada — a retomada re-executa resume() após o login).
     */
    allow(levelNum, ctx = {}, resume = null) {
        if (!this.isBlocked(levelNum)) return true;
        this._pending = resume ? { resume } : null;
        this._saveIntent({ route: ctx.route || '', gameId: ctx.gameId || '', levelNum });
        if (window.authModal) {
            window.authModal.open('signup', { gate: { gameId: ctx.gameId || '', levelNum } });
            // Funil: o portão apareceu DE FATO (só aqui — sem modal não houve portão).
            // _gateCtx marca que há um gate EM ABERTO nesta página, pra que só o desfecho
            // DELE seja atribuído (login pelo header, sem gate, não conta como conversão).
            // Só emite em ABERTURA NOVA: re-clique no nível trancado com o gate já aberto
            // não repete o beacon (senão o cap estoura e engole o desfecho).
            if (!this._gateCtx) {
                this._gateCtx = { gameId: ctx.gameId || '', levelNum };
                window.Beacon?.gate('shown', ctx.gameId || '', levelNum);
            }
        }
        return false;
    }

    /** Funil: fecha o gate aberto com um desfecho (1× por abertura). Best-effort. */
    _closeGateBeacon(outcome) {
        try {
            const c = this._gateCtx;
            if (!c) return;
            this._gateCtx = null;
            window.Beacon?.gate(outcome, c.gameId, c.levelNum);
        } catch (e) { /* nunca atrapalha o fluxo de auth */ }
    }

    /** Defesa no boot/round dos jogos: guest nunca fica num nível acima da fronteira. */
    clampForGuest(levelNum) {
        return this.isBlocked(levelNum) ? AuthGate.FREE_LEVELS : levelNum;
    }

    // ---------- intenção pendente (retomada pós-redirect OAuth) ----------

    _saveIntent(intent) {
        try {
            window.sessionStorage.setItem(AuthGate.INTENT_KEY,
                JSON.stringify({ ...intent, ts: Date.now() }));
        } catch (e) { /* sem sessionStorage → sem retomada pós-redirect, gate segue */ }
    }

    _clearIntent() {
        try { window.sessionStorage.removeItem(AuthGate.INTENT_KEY); } catch (e) {}
    }

    /** Lê a intenção SEM consumir; valida shape e TTL (expirada → limpa e null). */
    _peekIntent() {
        try {
            const raw = window.sessionStorage.getItem(AuthGate.INTENT_KEY);
            if (!raw) return null;
            const i = JSON.parse(raw);
            if (!i || !i.levelNum) { this._clearIntent(); return null; }
            if (i.ts && (Date.now() - i.ts > AuthGate.INTENT_TTL_MS)) { this._clearIntent(); return null; }
            return i;
        } catch (e) { this._clearIntent(); return null; }
    }

    /**
     * Consumo pelo JOGO (no init): devolve e LIMPA a intenção se for deste jogo e o
     * usuário já estiver logado (boot pós-OAuth). Guest/na dele → null, intent fica
     * (pode estar a caminho do login) até expirar o TTL.
     */
    takeIntentFor(gameId) {
        const i = this._peekIntent();
        if (!i || i.gameId !== gameId) return null;
        if (window.userManager && window.userManager.isGuest()) return null;
        this._clearIntent();
        return i;
    }
}

// Classe + singleton global (mesmo padrão de userManager/notifications).
window.AuthGate = AuthGate;
window.authGate = new AuthGate();



// ============================================
// core/LevelProgress.js
// ============================================
/**
 * LevelProgress — "melhor take por nível + fila de sincronização", REUTILIZÁVEL.
 *
 * Nasceu dentro do LevelConfig (só do Ritmo) e virou classe quando a Leitura precisou
 * do MESMO mecanismo. Cada jogo ranqueado registra UMA instância; ela é a ficha do jogo
 * no ranking: identidade (`gameId`/`nameKey`/`route`), os níveis e os melhores takes.
 *
 * POR QUE EXISTE O MAPA LOCAL: o servidor só conhece o que foi jogado COM a conta
 * conectada — os níveis 1-3 são livres (AuthGate.FREE_LEVELS), então quem loga depois
 * sumiria do leaderboard justamente nos primeiros. Aqui guarda-se o melhor take
 * LOCALMENTE (convidado incluso) marcando o que ainda não subiu;
 * RankingRepository.syncPending() esvazia a fila no login.
 *
 * 🔴 NÍVEL É 1-BASED, na numeração do SERVIDOR (`scores.level` ≥ 1, mesma do AuthGate).
 * Jogo com índice 0-based (ReadingFlowGame.levelIdx) converte NA BORDA, ao registrar.
 *
 * 🔴 O REGISTRO É A FONTE ÚNICA de "quais jogos têm ranking" — a RankingScreen monta o
 * seletor a partir dele e o backfill percorre ele. Jogo novo = uma chamada `register`
 * no rodapé do arquivo do jogo; nada mais precisa saber que ele existe.
 *
 * ⚠️ NÃO é histórico: guarda 1 registro por nível (o melhor), então `plays` no servidor
 * conta 1 pelo backfill, não as N tentativas de convidado.
 */
class LevelProgress {
    /** gameId → instância, em ordem de registro (= ordem no seletor da tela). */
    static registry = new Map();

    /** Registra (ou substitui) a ficha de um jogo ranqueado. Retorna a instância. */
    static register(cfg) {
        const inst = new LevelProgress(cfg);
        LevelProgress.registry.set(inst.gameId, inst);
        // 🔴 A chave de melhores deste jogo passa a saber se FUNDIR (e não só adotar) o
        // que estiver no ::guest. Só o caminho de READOÇÃO do StorageScope usa isto; a
        // adoção normal continua chamando a estratégia com destRaw=null (= adota cru).
        // Registrar AQUI e não numa lista à parte é o que faz jogo novo herdar a regra
        // pela mesma linha que já o põe no ranking — lista paralela divergiria no próximo.
        try { window.StorageScope?.registerMergeStrategy?.(inst.storageKey, LevelProgress.mergeBags); } catch (e) {}
        return inst;
    }

    /**
     * Funde o bag de melhores do ::guest no bag da CONTA. String → string (é o contrato
     * de MERGE_STRATEGIES do StorageScope, que guarda valor cru de localStorage).
     *
     * POR QUE EXISTE: a sessão que morre no meio de uma rodada derruba o login, e o take
     * que termina depois disso é gravado em `::guest`. A readoção (READOPT_FLAG) traz o
     * ::guest de volta, mas era NÃO-DESTRUTIVA POR CHAVE — e `*_best_v1` existe na conta
     * depois de qualquer partida, então a chave era pulada e o take se perdia. Era a
     * dívida escrita na auditoria de 06/set (§6.1 do mapa de plataforma).
     *
     * 🔴 MESMA RÉGUA do `recordBest` e do UPSERT do servidor: fica a MAIOR precisão e,
     * no empate, o melhor timing; `passed` é OU (sticky, nunca volta a false). Nenhum
     * nível é apagado e nenhum recua em `acc` ou em `passed`.
     * 🔴 Monótono NA RÉGUA (acc → desempate por ms), não campo a campo: quando a precisão
     * do ::guest é MAIOR, o `ms` que fica é o dela, e ele pode ser pior que o da conta.
     * Isso não é desvio — é o que `recordBest` e o UPSERT do PHP já fazem (`best_ms` segue
     * o take vencedor, não o menor de todos). Dizer "≥ em tudo" era comentário mentindo.
     * 🔴 Nível tocado sai `synced:false`: o servidor não conhece esse take (foi jogado
     * deslogado), então ele TEM de entrar na fila do `pendingBests`.
     * 🔴 `seq` sempre incrementa no que muda: um `save_score` em voo com o `seq` antigo
     * não pode marcar como sincronizado o registro NOVO (é a razão de o `seq` existir).
     * 🔴 Registro sem `acc` finito conta como INEXISTENTE dos dois lados (mesmo critério
     * do `restoreFromServer`): lixo não vence take bom nem vira buraco negro.
     *
     * @param {string}      guestRaw  valor cru de `<base>::guest`
     * @param {string|null} destRaw   valor cru de `<base>::u<id>`; null = adoção pura
     * @returns {string} o valor a gravar (o próprio `destRaw` quando nada muda)
     */
    static mergeBags(guestRaw, destRaw = null) {
        // Adoção pura (a conta não tem a chave): o laço do StorageScope só grava o cru.
        if (destRaw == null) return guestRaw;
        const parse = (raw) => {
            try {
                const o = raw ? JSON.parse(raw) : null;
                return (o && typeof o === 'object' && !Array.isArray(o)) ? o : null;
            } catch (e) { return null; }
        };
        const guest = parse(guestRaw);
        const dest = parse(destRaw);
        // Guest ilegível: não há o que fundir. Conta ilegível: idem — sobrescrever aqui
        // seria destrutivo, e é o único caso em que a régua monótona não sabe decidir.
        if (!guest || !dest) return destRaw;
        const ok = (r) => (r && typeof r === 'object' && Number.isFinite(r.acc)) ? r : null;
        // Número tolerante: aceita `12` e `"12"`, recusa null/''/NaN/objeto. `Number(null)`
        // é 0 e finito, então a checagem de tipo vem ANTES da conversão (é a mesma
        // armadilha do `accuracy` nulo no restoreFromServer).
        const num = (v) => {
            if (typeof v === 'number') return Number.isFinite(v) ? v : null;
            if (typeof v === 'string' && v.trim() !== '' && Number.isFinite(Number(v))) return Number(v);
            return null;
        };
        // 🔴 Só chaves que SÃO nível. `pendingBests`/`_runApplyUnlock` iteram `levels()`, então
        // uma chave estranha vinda do ::guest seria inerte — mas incharia o bag para sempre e,
        // pior, marcaria `touched` a cada login, disparando `reapplyUnlocks` à toa.
        const ehNivel = (k) => /^[0-9]+$/.test(k);
        let touched = false;

        Object.keys(guest).forEach((lvl) => {
            if (!ehNivel(lvl)) return;
            const g = ok(guest[lvl]);
            if (!g) return;
            const raw = dest[lvl];                 // pode existir e estar corrompido
            const d = ok(raw);
            if (!d) {
                // Nível que o ::guest tem e a conta não tem (ou tem corrompido: sem `acc`
                // finito não há take comparável). Entra o do guest, pendente de envio — mas
                // 🔴 `seq` e `passed` do lado da conta são PRESERVADOS quando existem: eles
                // são campos independentes do `acc` e podem estar íntegros. Sem isto o `seq`
                // DECRESCIA (9 → 2) e um `passed:true` virava false — os dois contra a regra
                // monótona que esta função promete (auditoria de 06/set).
                const rawSeq = raw && typeof raw === 'object' ? num(raw.seq) : null;
                dest[lvl] = {
                    acc: g.acc, ms: num(g.ms),
                    passed: !!(g.passed || (raw && typeof raw === 'object' && raw.passed)),
                    at: num(g.at) || Date.now(),
                    seq: (rawSeq != null ? rawSeq : (num(g.seq) || 0)) + 1,
                    metrics: g.metrics != null ? g.metrics
                             : (raw && typeof raw === 'object' && raw.metrics != null ? raw.metrics : null),
                    synced: false
                };
                touched = true;
                return;
            }
            const dMs = num(d.ms);
            const gMs = num(g.ms);
            const better = g.acc > d.acc || (g.acc === d.acc && gMs != null && (dMs == null || gMs < dMs));
            const acc = Math.max(d.acc, g.acc);
            const ms = better ? gMs : dMs;
            const passed = !!(d.passed || g.passed);
            if (acc === d.acc && ms === dMs && passed === !!d.passed) return;  // conta já é ≥: intacta
            dest[lvl] = {
                acc, ms, passed,
                at: better ? (num(g.at) || num(d.at) || Date.now()) : (num(d.at) || Date.now()),
                seq: (Number.isFinite(d.seq) ? d.seq : 0) + 1,
                metrics: better ? (g.metrics != null ? g.metrics : d.metrics) : (d.metrics != null ? d.metrics : g.metrics),
                synced: false
            };
            touched = true;
        });

        if (!touched) return destRaw;
        try { return JSON.stringify(dest); } catch (e) { return destRaw; }
    }

    /**
     * Reaplica o desbloqueio derivado dos bags LOCAIS, em todo jogo registrado.
     *
     * Existe por causa de um buraco estreito do merge acima: quem passa de nível na
     * rodada em que a sessão morre recupera o TAKE, mas o desbloqueio é derivado e quem
     * o aplica é o `restoreFromServer` — que sai cedo quando o servidor devolve ZERO
     * linhas para aquele jogo (níveis 1-3 são livres: dá para ter bag local e nada no
     * servidor). Sem isto, o nível conquistado ficava trancado até o login seguinte.
     * Idempotente e só ACRESCENTA: `_runApplyUnlock` entrega os níveis aprovados e cada
     * jogo grava no formato dele.
     */
    static reapplyUnlocks() {
        LevelProgress.all().forEach((prog) => {
            try { prog._runApplyUnlock(prog.getBests()); } catch (e) { /* nunca derruba o login */ }
        });
    }

    static get(gameId) { return LevelProgress.registry.get(gameId) || null; }

    /** Todos os jogos ranqueados, na ordem de registro. */
    static all() { return Array.from(LevelProgress.registry.values()); }

    /**
     * @param {string} gameId    id do jogo no servidor (tem de estar em rankGames() do PHP)
     * @param {string} storageKey chave-base do mapa de melhores (versionada; entra no StorageScope)
     * @param {string} nameKey   chave i18n do nome do jogo (ex.: 'games.rhythm.name')
     * @param {string} route     rota do jogo (ex.: '#/ritmo') — CTA da tela vazia
     * @param {function} levels  () => níveis em ordem ASCENDENTE (1-based, numeração do servidor)
     * @param {function} [currentLevel] () => nível onde o jogador está (default do seletor)
     * @param {function} [applyUnlock] (níveisAprovados1Based[]) => o jogo grava o PRÓPRIO
     *   desbloqueio. Opcional. 🔴 Existe porque NÃO há formato único: Leitura/Intervalos/
     *   Acordes guardam um inteiro 0-based (`*_unlocked_v1`) e o Ritmo um JSON
     *   `{current, highestUnlocked}` com ids. Quem sabe o formato é o jogo; o LevelProgress
     *   só entrega o dado. Jogo novo com outro formato entra sem tocar aqui.
     * @param {function} [levelInfo] (nível 1-based) => `{ world, pass }` — o MUNDO do nível
     *   (número, ou null onde o jogo não tem mundos) e o LIMIAR de aprovação (0-100). Opcional.
     *   Quem lê é a visão da turma (docs/VISAO-DA-TURMA-PLANO.md): agrupar por mundo e dizer
     *   "pede 82%". 🔴 O limiar mora no jogo (RHYTHM_LEVELS.pass, LEVELS[i].pass, UNLOCK_ACC);
     *   aqui só se pergunta — uma tabela à parte divergiria no primeiro ajuste de trilha.
     * @param {function} [worldName] (mundo) => `{ key, params }` — o rótulo i18n do mundo.
     */
    constructor({ gameId, storageKey, nameKey, route, levels, currentLevel = null, applyUnlock = null,
                  levelInfo = null, worldName = null } = {}) {
        this.gameId = gameId;
        this.storageKey = storageKey;
        this.nameKey = nameKey;
        this.route = route;
        this._levels = levels;
        this._currentLevel = currentLevel;
        this._applyUnlock = applyUnlock;
        this._levelInfo = levelInfo;
        this._worldName = worldName;
    }

    /**
     * `{ world, pass }` de um nível: mundo (número ou null) e limiar (0-100 ou null). Nunca
     * lança; jogo que não declara devolve os dois null (a tela cai no "sem mundos").
     */
    levelInfo(level) {
        try {
            const i = this._levelInfo ? this._levelInfo(level) : null;
            const world = i && Number.isFinite(i.world) ? i.world : null;
            const pass = i && Number.isFinite(i.pass) ? i.pass : null;
            return { world, pass };
        } catch (e) { return { world: null, pass: null }; }
    }

    /** O rótulo do mundo como `{ key, params }` (i18n), ou null quando o jogo não diz. */
    worldName(world) {
        try {
            const w = this._worldName ? this._worldName(world) : null;
            return w && typeof w.key === 'string' ? { key: w.key, params: w.params || {} } : null;
        } catch (e) { return null; }
    }

    /** Níveis do jogo (ascendente). Tolerante: catálogo indisponível → lista vazia. */
    levels() {
        try {
            const l = this._levels ? this._levels() : null;
            return Array.isArray(l) ? l : [];
        } catch (e) { return []; }
    }

    has(level) { return this.levels().indexOf(level) !== -1; }

    /** Nível "você está aqui" (default do seletor por nível); cai no 1º se não souber. */
    currentLevel() {
        const all = this.levels();
        if (!all.length) return null;
        try {
            const v = this._currentLevel ? this._currentLevel() : null;
            return this.has(v) ? v : all[0];
        } catch (e) { return all[0]; }
    }

    // ---------- melhor take por nível ----------

    /** { "<level>": { acc, ms, passed, at, metrics, synced } }. Tolerante a ausência/lixo. */
    getBests() {
        try {
            const raw = window.localStorage && window.localStorage.getItem(window.StorageScope.key(this.storageKey));
            const map = raw ? JSON.parse(raw) : null;
            return (map && typeof map === 'object' && !Array.isArray(map)) ? map : {};
        } catch (e) { return {}; }
    }

    _saveBests(map) {
        try {
            if (window.localStorage) window.localStorage.setItem(window.StorageScope.key(this.storageKey), JSON.stringify(map));
        } catch (e) { /* sem persistência: o take corrente ainda sobe se estiver logado */ }
    }

    /**
     * Registra um take. Merge MONÓTONO, espelho do UPSERT do servidor: fica a MAIOR
     * precisão e, no empate, o melhor timing; `passed` é sticky. Todo take marca
     * `synced:false` — take novo é informação não enviada, mesmo que não melhore o
     * recorde (o servidor faz o merge monótono dele também, então reenviar é seguro).
     */
    recordBest(level, { accuracy, bestMs = null, passed = false, metrics = null } = {}) {
        if (!this.has(level) || !Number.isFinite(accuracy)) return null;
        const map = this.getBests();
        const cur = map[String(level)] || null;
        const acc = Math.round(accuracy * 100) / 100;
        const ms = Number.isFinite(bestMs) ? Math.round(bestMs) : null;
        const better = !cur || acc > cur.acc ||
            (acc === cur.acc && ms != null && (cur.ms == null || ms < cur.ms));
        const rec = {
            acc: cur ? Math.max(cur.acc, acc) : acc,
            ms: better ? ms : cur.ms,
            passed: !!((cur && cur.passed) || passed),
            at: Date.now(),
            // `seq` identifica ESTA versão do registro para o markBestSynced. Contador, e
            // não `at`: dois takes no mesmo milissegundo teriam o mesmo relógio, e um
            // discriminador que empata não discrimina nada.
            seq: (cur && Number.isFinite(cur.seq) ? cur.seq : 0) + 1,
            metrics: better ? metrics : (cur ? cur.metrics : metrics),
            synced: false
        };
        map[String(level)] = rec;
        this._saveBests(map);
        // DIÁRIO (user_events): todo take de todo jogo ranqueado passa AQUI — é o gancho
        // único do `level_result`, vitória E derrota (D6/D7 de docs/EVENTOS-PLANO.md). O
        // evento leva o take DESTA rodada (acc/ms), não o recorde fundido. No-op p/ convidado.
        try {
            // `best_ms` clampado no teto do servidor (600 000, o mesmo do save_score): Intervalos/
            // Acordes medem reação por relógio de parede, e uma pergunta respondida depois do
            // almoço fazia o `level_result` INTEIRO ser rejeitado em silêncio (auditoria 06/set).
            // Ataque e duração DESTA tentativa (17/set): saem de `metrics.detail` do take, que só
            // o Ritmo preenche — os outros jogos mandam sem os dois (opcionais). É o par que a
            // visão da turma lê hoje do PLACAR (melhor tentativa): no diário vira tendência
            // tentativa a tentativa. Fora de 0-100 é OMITIDO, nunca clampado (o servidor
            // rejeitaria o evento inteiro; clampar esconderia emissor com defeito).
            const det = metrics && metrics.detail;
            const pct = (v) => (Number.isFinite(v) && v >= 0 && v <= 100) ? v : null;
            window.eventTracker?.track('level_result', {
                game_id: this.gameId, level, accuracy: acc, passed: passed ? 1 : 0,
                best_ms: ms != null ? Math.min(ms, 600000) : null,
                onset: pct(det ? det.onset : null), duration: pct(det ? det.duration : null)
            });
        } catch (e) { /* diário nunca quebra o jogo */ }
        return rec;
    }

    /**
     * Marca o nível como já enviado ao servidor (chamado no sucesso do save_score).
     *
     * 🔴 `seq` = versão do registro que REALMENTE subiu. Sem ela, um take melhor
     * terminado enquanto o request estava em voo era marcado como sincronizado sem nunca
     * ter sido enviado — a melhora sumia em silêncio até a pessoa rejogar aquele nível.
     * Sem `seq` (registro anterior a esta versão) marca o corrente, como antes.
     */
    markBestSynced(level, seq = null) {
        const map = this.getBests();
        const rec = map[String(level)];
        if (!rec || rec.synced === true) return;
        if (seq != null && rec.seq !== seq) return;   // o registro mudou: o que subiu já é velho
        rec.synced = true;
        this._saveBests(map);
    }

    /**
     * Fila do backfill: registros ainda não enviados, em ordem ASCENDENTE de nível —
     * o servidor exige registro no nível anterior acima de RANK_TRUST_LEVEL (anti
     * salto-impossível), então a ordem não é cosmética.
     *
     * Registro corrompido é DESCARTADO da fila, não enviado: subir lixo devolve
     * `bad_accuracy`, que interrompe a fila daquele jogo — um único registro podre
     * congelaria todos os níveis seguintes para sempre, a cada login.
     */
    pendingBests() {
        const map = this.getBests();
        return this.levels()
            .map(id => ({ id, rec: map[String(id)] }))
            .filter(x => x.rec && typeof x.rec === 'object' && Number.isFinite(x.rec.acc) && x.rec.synced !== true)
            .map(x => Object.assign({ id: x.id }, x.rec));
    }

    /**
     * DEVOLUÇÃO: traz de volta o progresso DA CONTA que o servidor guarda (`my_scores`) e
     * o funde no mapa local. É o par que faltava do `pendingBests` — sem ele o progresso
     * só subia, e logar noutro device/browser/origem começava do zero.
     *
     * 🔴 MERGE MONÓTONO NOS DOIS SENTIDOS, mesma régua do `recordBest` e do UPSERT do PHP:
     * - servidor melhor (ou igual) ⇒ adota e marca `synced` (não há o que subir);
     * - local melhor ⇒ PRESERVA o local e deixa pendente, pra `syncPending` empurrar depois;
     * - `passed` é OU dos dois (sticky, nunca volta a false);
     * - nível que só existe local fica intacto e pendente.
     * Nada aqui apaga take: a devolução só pode ACRESCENTAR.
     *
     * Depois do merge, delega o desbloqueio ao jogo (`applyUnlock`) com os níveis
     * aprovados — o formato é de quem registrou, não daqui.
     *
     * @param {Array} rows linhas do servidor: { level, accuracy, best_ms, passed }
     * @returns {number} quantos níveis foram acrescentados/melhorados pelo servidor
     */
    restoreFromServer(rows) {
        if (!Array.isArray(rows) || !rows.length) return 0;
        const map = this.getBests();
        let changed = 0;
        rows.forEach((r) => {
            if (!r || typeof r !== 'object') return;
            const level = Number(r.level);
            // 🔴 `accuracy` nula tem de ser DESCARTADA, não convertida: `Number(null)` é 0
            // e finito, então a coluna nullable do servidor viraria um take de 0% —
            // pior que não ter registro nenhum.
            const acc = r.accuracy == null ? NaN : Number(r.accuracy);
            if (!Number.isFinite(level) || !Number.isFinite(acc) || !this.has(level)) return;
            const ms = Number.isFinite(Number(r.best_ms)) && r.best_ms !== null ? Math.round(Number(r.best_ms)) : null;
            const passed = !!(r.passed === 1 || r.passed === true || r.passed === '1');
            // Registro local corrompido conta como INEXISTENTE. Sem isto ele vira buraco
            // negro: toda comparação com NaN é false ⇒ o servidor nunca sobrescreve, e o
            // `pendingBests` já o descarta ⇒ aquele nível não sobe nem desce, para sempre.
            const raw = map[String(level)];
            const cur = (raw && typeof raw === 'object' && Number.isFinite(raw.acc)) ? raw : null;
            const srvBetter = !cur || acc > cur.acc ||
                (acc === cur.acc && ms != null && (cur.ms == null || ms < cur.ms));
            if (srvBetter) {
                map[String(level)] = {
                    acc, ms,
                    passed: !!(passed || (cur && cur.passed)),
                    at: (cur && cur.at) || Date.now(),
                    seq: (cur && Number.isFinite(cur.seq) ? cur.seq : 0) + 1,
                    // A bag de métricas do servidor não volta (o endpoint não a devolve):
                    // preserva a local se houver. Ela só alimenta a tela de ranking.
                    metrics: cur ? cur.metrics : null,
                    synced: true
                };
                changed++;
            } else {
                // Local é melhor ou igual: `passed` ainda pode chegar do servidor, e o
                // registro segue pendente se ainda não subiu (o servidor tem versão pior).
                if (passed && !cur.passed) { cur.passed = true; changed++; }
                // 🔴 `synced` só quando NÃO HÁ MAIS NADA A SUBIR — ou seja, quando o
                // servidor é pelo menos tão bom. `ms` MENOR é melhor: `ms <= cur.ms`.
                // Marcar aqui com o local melhor congelaria o desempate de timing no
                // servidor para sempre (o `pendingBests` nunca mais entrega o registro, e
                // o leaderboard por nível ordena justamente por best_ms).
                const srvTiming = cur.ms == null || (ms != null && ms <= cur.ms);
                if (acc === cur.acc && srvTiming) cur.synced = true;
            }
        });
        this._saveBests(map);
        this._runApplyUnlock(map);
        return changed;
    }

    /** Níveis aprovados (1-based) → o jogo grava o desbloqueio no formato dele. Nunca lança:
     *  falha aqui não pode derrubar o login. */
    _runApplyUnlock(map) {
        if (typeof this._applyUnlock !== 'function') return;
        try {
            const passed = this.levels().filter((id) => {
                const rec = map[String(id)];
                return !!(rec && rec.passed === true);
            });
            this._applyUnlock(passed);
        } catch (e) { /* desbloqueio é derivado: o mapa de takes já está salvo */ }
    }
}

// Disponibiliza globalmente (padrão dos demais de core).
window.LevelProgress = LevelProgress;



// ============================================
// core/RankingRepository.js
// ============================================
/**
 * RankingRepository — cliente do placar/ranking (Fase 5). Fala com os endpoints
 * `save_score` e `leaderboard` do auth-backend, reusando a ponte HTTP do UserManager
 * (CSRF+retry, tolerância a backend ausente). NÃO reimplementa fetch nem faz i18n.
 *
 * 🔴 CRESCIMENTO: o placar é uma bag ABERTA e VERSIONADA. `saveScore` recebe um objeto
 * `metrics` livre (com `v`) que o servidor grava como veio — figuras/compassos/métricas
 * novas entram sem tocar isto nem o schema. Ver docs/RANKING-PLANO.md.
 *
 * Fire-and-forget por natureza: falha de rede NUNCA trava o jogo (o chamador ignora o
 * rejeitado). Convidado não grava (retorna {success:false, code:'not_logged'}); entra no
 * ranking naturalmente na 1ª partida após logar.
 */
class RankingRepository {
    /** Envia o resultado de um nível. @returns {success, best?} | {success:false, code} */
    async saveScore({ gameId, level, accuracy, bestMs = null, passed = false, metrics = null } = {}) {
        const um = window.userManager;
        if (!um || !um.isLoggedIn()) return { success: false, code: 'not_logged' };
        const fields = {
            game_id: gameId,
            level,
            accuracy,
            best_ms: bestMs == null ? '' : bestMs,
            passed: passed ? 1 : 0,
            metrics: metrics ? JSON.stringify(metrics) : ''
        };
        const data = await um.apiPost('save_score', fields, { csrf: true });
        if (data && data.success) return { success: true, best: data.best };
        return { success: false, code: (data && (data.error_code || data.error_type)) || 'network' };
    }

    /**
     * Os campos de PÁGINA da resposta (18/set). Servidor velho não manda nada disso: aí é
     * página única (`hasMore` falso, `total` = o que veio) — a tela funciona como antes.
     * `me` = a linha de quem pediu quando ela está FORA da página (posição absoluta).
     */
    static _page(data, offset) {
        const rows = data.rows || [];
        return {
            total: Number.isFinite(data.total) ? data.total : offset + rows.length,
            offset: Number.isFinite(data.offset) ? data.offset : offset,
            hasMore: data.has_more === 1 || data.has_more === true,
            me: (data.me && typeof data.me === 'object') ? data.me : null,
            meRank: Number.isFinite(data.me_rank) ? data.me_rank : null
        };
    }

    /**
     * Lê o leaderboard. scope 'overall' (geral do jogo: nível↓, precisão↓) ou 'level'
     * (um nível: precisão↓). @returns {success, rows, scope} | {success:false, rows:[], code}
     */
    async leaderboard({ gameId, scope = 'overall', level = null, limit = 20, offset = 0 } = {}) {
        const um = window.userManager;
        const params = { game_id: gameId, scope, limit };
        if (offset > 0) params.offset = offset;
        if (scope === 'level' && level != null) params.level = level;
        const data = um ? await um.apiGet('leaderboard', params) : null;
        // `me_hidden` só vem quando há sessão: é a preferência de QUEM PEDIU (ranking_visible).
        // Sem ele a tela teria de adivinhar por que a pessoa não está na lista — e "não me
        // achei" também acontece com quem nunca jogou logado ou ficou fora do top 20.
        if (data && data.success) return Object.assign(RankingRepository._page(data, offset),
            { success: true, rows: data.rows || [], scope: data.scope || scope, meHidden: data.me_hidden === 1 });
        return { success: false, rows: [], code: (data && data.error_code) || 'network' };
    }

    /**
     * O ranking DE UM GRUPO (escola/turma): `group_leaderboard`, público desde 17/set. A mesma
     * forma do `leaderboard`, mais `group` ({id, name, members}). `no_group` = a conta não
     * está em grupo nenhum (a tela volta para "Todos").
     */
    async groupLeaderboard({ gameId, scope = 'overall', level = null, limit = 20, groupId = null, offset = 0 } = {}) {
        const um = window.userManager;
        // Público desde 17/set: sem conta, vale com o `group_id` (a página do grupo sempre manda).
        if (!um || (!um.isLoggedIn() && groupId == null)) return { success: false, rows: [], code: 'not_logged' };
        const params = { game_id: gameId, scope, limit };
        if (offset > 0) params.offset = offset;
        // `group_id` explícito: é como o DONO (não-membro) pede o ranking do grupo que organiza.
        if (groupId != null) params.group_id = groupId;
        if (scope === 'level' && level != null) params.level = level;
        const data = await um.apiGet('group_leaderboard', params);
        if (data && data.success) return Object.assign(RankingRepository._page(data, offset),
            { success: true, rows: data.rows || [], scope: data.scope || scope, meHidden: data.me_hidden === 1, group: data.group || null });
        return { success: false, rows: [], code: (data && data.error_code) || 'network' };
    }

    /**
     * Códigos de falha LOCAIS a um jogo/nível: o pedido chegou e o servidor recusou
     * AQUELE dado. Não dizem nada sobre a rede nem sobre a sessão, então o backfill
     * segue para o próximo jogo em vez de abortar tudo. Qualquer outro código (rede,
     * rate-limit, sessão, desconhecido) PARA a passada inteira — default conservador:
     * na dúvida, tentar de novo no próximo login sai mais barato que insistir agora.
     */
    static LOCAL_FAIL_CODES = new Set([
        'bad_jump', 'bad_level', 'bad_accuracy', 'bad_ms', 'bad_metrics', 'metrics_too_big', 'bad_game'
    ]);

    /**
     * BACKFILL: sobe os melhores takes LOCAIS que ainda não foram enviados — tipicamente
     * os níveis livres (1-3) jogados como convidado ANTES de existir conta, que de outro
     * modo nunca entrariam no leaderboard por nível (o servidor só vê o que foi jogado
     * logado). Fonte da fila: TODOS os jogos registrados em LevelProgress — jogo novo
     * entra no backfill só por se registrar, sem tocar aqui.
     *
     * 🔴 ORDEM ASCENDENTE E SEQUENCIAL DENTRO DE CADA JOGO: acima de RANK_TRUST_LEVEL o
     * servidor exige registro no nível anterior DO MESMO game_id (anti salto-impossível)
     * — em paralelo, ou de trás pra frente, o backfill se auto-rejeitaria com `bad_jump`.
     * Entre jogos não há ordem: as trilhas são independentes no servidor.
     *
     * Na falha, o que sobrou continua marcado como pendente e tenta de novo no próximo
     * login/boot logado (ver LOCAL_FAIL_CODES p/ parar o jogo × parar tudo). Nunca lança.
     */
    /**
     * DEVOLUÇÃO: puxa o progresso da PRÓPRIA conta (`my_scores`) e o funde nos mapas
     * locais. Par do `syncPending` — sem ele o progresso só subia, e logar noutro
     * device/browser/origem (inclusive o lab, que é outra origem) começava do zero,
     * apesar do gate prometer o contrário ao exigir conta no nível 4.
     *
     * 🔴 UMA requisição para TODOS os jogos: o agrupamento é por `gameId` registrado no
     * LevelProgress, então trilha nova entra sozinha e o custo não cresce com o nº de
     * jogos. O merge (monótono, nunca destrutivo) mora no LevelProgress.
     *
     * Não devolve progresso de CONVIDADO: o servidor só conhece o que foi jogado com a
     * conta, então a trava anti cross-user do StorageScope não é contornada por aqui.
     * Fire-and-forget: falha de rede nunca trava login nem jogo.
     */
    async restoreMine() {
        const um = window.userManager;
        if (!um || !um.isLoggedIn() || !window.LevelProgress) return { restored: 0 };
        if (this._restoring) return { restored: 0 };   // login + boot podem disparar juntos
        // Uma restauração por conta POR PAGE LOAD: o boot dispara duas vezes (o
        // 'userStateChanged' da sessão restaurada e o setTimeout de 2s), e a 1ª quase
        // sempre já terminou — o flag `_restoring` sozinho não deduplica nada. Sem isto
        // são 2 requisições por load, queimando o rate limit à toa.
        const owner = window.StorageScope ? window.StorageScope.currentUserId() : null;
        if (owner != null && this._restoredFor === owner) return { restored: 0 };
        this._restoring = true;
        let restored = 0;
        try {
            const data = await um.apiGet('my_scores', {});
            // 🔴 O ESCOPO DE STORAGE É RESOLVIDO NA HORA DE ESCREVER, não aqui: se a conta
            // mudou enquanto o request estava em voo (logout, ou outra pessoa logando no
            // mesmo browser), gravar agora jogaria o progresso de A em ::guest ou em
            // ::u<B> — e o ::guest é adotado pela próxima conta virgem deste device.
            // Na dúvida, descartar: a devolução tenta de novo no próximo login/boot.
            const still = window.StorageScope ? window.StorageScope.currentUserId() : null;
            // 🔴 O servidor diz DE QUEM são as linhas (`user_id`, desde 06/set — o endpoint
            // aceita `?user_id=` para o admin ler outra conta). Progresso que não é do dono
            // local NÃO entra no LevelProgress dele: a defesa fica ao lado do dado, não em
            // quem chama. Resposta antiga sem `user_id` continua aceita.
            const foreign = data && data.user_id != null && Number(data.user_id) !== Number(owner);
            if (!foreign && still === owner && um.isLoggedIn() && data && data.success && Array.isArray(data.rows)) {
                const byGame = new Map();
                data.rows.forEach((r) => {
                    if (!r || !r.game_id) return;
                    if (!byGame.has(r.game_id)) byGame.set(r.game_id, []);
                    byGame.get(r.game_id).push(r);
                });
                for (const prog of window.LevelProgress.all()) {
                    restored += prog.restoreFromServer(byGame.get(prog.gameId) || []);
                }
                this._restoredFor = owner;   // só marca o que de fato chegou e foi gravado
            }
        } catch (e) { /* tenta de novo no próximo login/boot */
        } finally {
            // 🔴 `finally`: qualquer saída (dono trocado, resposta ruim, exceção) TEM de
            // soltar o flag — travado em true, a devolução morreria pelo resto do page load.
            this._restoring = false;
        }
        return { restored };
    }

    async syncPending() {
        const um = window.userManager;
        if (!um || !um.isLoggedIn() || !window.LevelProgress) return { sent: 0 };
        if (this._syncing) return { sent: 0 };   // login + boot podem disparar juntos
        this._syncing = true;
        let sent = 0;
        try {
            for (const prog of window.LevelProgress.all()) {
                let halt = false;
                for (const b of prog.pendingBests()) {
                    // metrics é a bag versionada: sem `v` inteiro o servidor recusa (bad_metrics)
                    // — registro antigo/corrompido sobe sem bag em vez de derrubar a fila inteira.
                    const metrics = (b.metrics && Number.isInteger(b.metrics.v)) ? b.metrics : null;
                    const res = await this.saveScore({
                        gameId: prog.gameId, level: b.id, accuracy: b.acc, bestMs: b.ms, passed: b.passed, metrics
                    });
                    if (!res || !res.success) {
                        halt = !RankingRepository.LOCAL_FAIL_CODES.has(res && res.code);
                        break;   // o resto DESTE jogo depende do nível anterior: não adianta insistir
                    }
                    prog.markBestSynced(b.id, b.seq);   // versão do take que subiu, não a corrente
                    sent++;
                }
                if (halt) break;
            }
        } catch (e) { /* fila é acessória: tenta de novo no próximo login */ }
        this._syncing = false;
        return { sent };
    }
}

// Singleton global (padrão dos demais de core).
window.RankingRepository = RankingRepository;
window.rankingRepository = new RankingRepository();

// DESCE e depois SOBE, ao LOGAR. 'userStateChanged' (não authState.subscribe) porque
// dispara DEPOIS do import guest→conta — antes dele o mapa local ainda está no escopo
// ::guest e o backfill subiria dados que a conta não adotou. Mesmo evento do AuthGate.
//
// 🔴 A ORDEM IMPORTA: restaurar ANTES de empurrar. O merge marca como sincronizado tudo
// que o servidor já tem igual ou melhor, então a fila que sobe depois carrega só o que
// é de fato novo — e o que é local e MELHOR continua pendente e sobe na sequência.
// A devolução avisa a UI ('progressRestored') pra tela aberta se redesenhar: sem isso o
// jogador veria o nível velho até navegar.
function rankingSyncBoth() {
    return window.rankingRepository.restoreMine()
        .then((r) => {
            if (r && r.restored > 0 && typeof document !== 'undefined') {
                document.dispatchEvent(new CustomEvent('progressRestored', { detail: { levels: r.restored } }));
            }
        })
        .catch(() => {})
        .then(() => window.rankingRepository.syncPending())
        .catch(() => {});
}

if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') {
    document.addEventListener('userStateChanged', (e) => {
        if (e && e.detail && e.detail.isLoggedIn) rankingSyncBoth();
    });
    // E uma vez no BOOT: quem já tinha sessão salva não dispara 'userStateChanged'
    // (restoreSession só reidrata o estado) — sem isto, o que falhou por rede numa
    // sessão anterior só subiria no próximo login. Adiado pro fim do boot: o
    // userManager pode não existir ainda quando este arquivo roda no bundle.
    setTimeout(() => { rankingSyncBoth(); }, 2000);
}



// ============================================
// core/DomManager.js
// ============================================
/**
 * DomManager - Gerenciador de elementos DOM
 * Singleton para criação e cache de elementos
 */
class DomManager {
    constructor(rootId = 'app') {
        if (DomManager.instance) {
            return DomManager.instance;
        }

        this.rootId = rootId;
        this.elements = new Map();
        this.screenInstances = new Map();

        DomManager.instance = this;
    }

    /**
     * Obtém ou cria um elemento
     * @param {string} id - ID do elemento
     * @param {string} tagName - Tag HTML (default: 'div')
     * @param {HTMLElement} parent - Elemento pai (default: body)
     * @param {Object} config - Configurações adicionais
     * @returns {HTMLElement}
     */
    getOrCreate(id, tagName = 'div', parent = null, config = {}) {
        // Verifica cache
        if (this.elements.has(id)) {
            const cached = this.elements.get(id);
            if (document.body.contains(cached)) {
                return cached;
            }
            // Elemento não está mais no DOM, remove do cache
            this.elements.delete(id);
        }

        // Procura elemento existente
        let element = document.getElementById(id);

        if (!element) {
            // Cria novo elemento
            element = document.createElement(tagName);
            element.id = id;

            // Aplica classes
            if (config.className) {
                element.className = config.className;
            }

            // Aplica atributos
            if (config.attributes) {
                Object.entries(config.attributes).forEach(([key, value]) => {
                    element.setAttribute(key, value);
                });
            }

            // Aplica estilos inline
            if (config.styles) {
                Object.assign(element.style, config.styles);
            }

            // Adiciona ao parent
            const parentElement = parent || document.body;
            parentElement.appendChild(element);
        }

        // Adiciona ao cache
        this.elements.set(id, element);

        return element;
    }

    /**
     * Remove um elemento do DOM e do cache
     * @param {string} id - ID do elemento
     */
    remove(id) {
        const element = this.elements.get(id);
        if (element && element.parentNode) {
            element.parentNode.removeChild(element);
        }
        this.elements.delete(id);
    }

    /**
     * Limpa o conteúdo de um elemento
     * @param {string} id - ID do elemento
     */
    clear(id) {
        const element = this.elements.get(id) || document.getElementById(id);
        if (element) {
            element.innerHTML = '';
        }
    }

    /**
     * Cria elemento sem adicionar ao DOM
     * @param {string} tagName - Tag HTML
     * @param {Object} config - Configurações
     * @returns {HTMLElement}
     */
    create(tagName, config = {}) {
        const element = document.createElement(tagName);

        if (config.id) {
            element.id = config.id;
        }

        if (config.className) {
            element.className = config.className;
        }

        if (config.innerHTML) {
            element.innerHTML = config.innerHTML;
        }

        if (config.textContent) {
            element.textContent = config.textContent;
        }

        if (config.attributes) {
            Object.entries(config.attributes).forEach(([key, value]) => {
                element.setAttribute(key, value);
            });
        }

        if (config.styles) {
            Object.assign(element.style, config.styles);
        }

        if (config.events) {
            Object.entries(config.events).forEach(([event, handler]) => {
                element.addEventListener(event, handler);
            });
        }

        return element;
    }

    /**
     * Registra uma instância de screen
     * @param {string} screenId - ID da screen
     * @param {Object} instance - Instância da screen
     */
    registerScreen(screenId, instance) {
        this.screenInstances.set(screenId, instance);
    }

    /**
     * Obtém uma instância de screen
     * @param {string} screenId - ID da screen
     * @returns {Object|null}
     */
    getScreen(screenId) {
        return this.screenInstances.get(screenId) || null;
    }

    /**
     * Remove uma instância de screen
     * @param {string} screenId - ID da screen
     */
    unregisterScreen(screenId) {
        this.screenInstances.delete(screenId);
    }

    /**
     * Obtém o elemento root da aplicação
     * @returns {HTMLElement}
     */
    getRoot() {
        return this.getOrCreate(this.rootId, 'div', document.body, {
            className: 'app-root'
        });
    }
}

// Singleton global
window.domManager = new DomManager();



// ============================================
// core/Language.js
// ============================================
/**
 * Language - Sistema de internacionalização
 * Gerencia traduções e idioma atual.
 *
 * 🔴 FONTE ÚNICA DE TRADUÇÕES: js/i18n/translations.json
 *    - No app (runtime): sync-class.js embute o JSON no topo do bundle como
 *      window.__I18N__ — por isso getTranslations() apenas o devolve (sem fetch,
 *      boot síncrono). __I18N__ é definido ANTES desta classe rodar.
 *    - Na landing (SEO): build-landing.js lê o MESMO JSON para gerar /, /en/, /es/.
 *    Editar SEMPRE em translations.json, nunca strings soltas aqui.
 */
class Language {
    constructor() {
        if (Language.instance) {
            return Language.instance;
        }

        this.currentLanguage = this.detectLanguage();
        this.translations = this.getTranslations();
        this.languages = [
            { value: 'pt', text: 'Português', flag: '🇧🇷' },
            { value: 'en', text: 'English', flag: '🇺🇸' },
            { value: 'es', text: 'Español', flag: '🇪🇸' }
        ];

        Language.instance = this;
    }

    /**
     * Detecta o idioma do usuário
     * @returns {string}
     */
    detectLanguage() {
        const supported = ['pt', 'en', 'es'];

        // 0. HOSTNAME (MAIOR prioridade — Stage 2: idioma por domínio). Espelha o
        //    projeto principal: cada domínio é um idioma. Cobre www. e lab. (endsWith).
        //    aulademusica.com.br → pt · absolutepitchclass.com → en · oidoabsolutoclass.com → es.
        const hostLang = this.languageFromHost(
            (typeof location !== 'undefined' && location.hostname) || ''
        );
        if (hostLang) {
            return hostLang;
        }

        // 1. <html lang> da página. A landing estática é gerada por idioma com
        //    <html lang="pt-BR|en|es">; o app herda esse idioma da página em que o
        //    usuário entrou, sem precisar de toggle. 'pt-BR' → 'pt'.
        const htmlLang = ((typeof document !== 'undefined' && document.documentElement.lang) || '')
            .slice(0, 2).toLowerCase();
        if (supported.includes(htmlLang)) {
            return htmlLang;
        }

        // 2. Tenta localStorage
        const saved = localStorage.getItem('language');
        if (saved && supported.includes(saved)) {
            return saved;
        }

        // 3. Tenta navigator.language
        const browserLang = navigator.language?.substring(0, 2);
        if (browserLang && supported.includes(browserLang)) {
            return browserLang;
        }

        // 4. Default: português
        return 'pt';
    }

    /**
     * Mapeia um hostname para idioma (Stage 2: idioma por domínio).
     * Casa o domínio exato OU subdomínios (www., lab.) via sufixo.
     * @param {string} hostname
     * @returns {string|null} 'pt'|'en'|'es' ou null se não reconhecido
     */
    languageFromHost(hostname) {
        const host = String(hostname).toLowerCase();
        const map = {
            'aulademusica.com.br': 'pt',
            'absolutepitchclass.com': 'en',
            'oidoabsolutoclass.com': 'es'
        };
        for (const domain in map) {
            if (host === domain || host.endsWith('.' + domain)) {
                return map[domain];
            }
        }
        return null;
    }

    /**
     * Define o idioma atual
     * @param {string} lang - Código do idioma (pt, en, es)
     */
    setLanguage(lang) {
        if (['pt', 'en', 'es'].includes(lang)) {
            this.currentLanguage = lang;
            localStorage.setItem('language', lang);
            window.eventBus?.emit('language:changed', lang);
        }
    }

    /**
     * Obtém uma tradução por chave
     * @param {string} key - Chave aninhada (ex: 'games.rhythm.name')
     * @param {Object} params - Parâmetros para substituição
     * @returns {string}
     */
    get(key, params = {}) {
        const keys = key.split('.');
        let value = this.translations[this.currentLanguage];

        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k];
            } else {
                // Fallback para português
                value = this.translations.pt;
                for (const fallbackKey of keys) {
                    if (value && typeof value === 'object' && fallbackKey in value) {
                        value = value[fallbackKey];
                    } else {
                        console.warn(`Language: Chave não encontrada: ${key}`);
                        return key;
                    }
                }
                break;
            }
        }

        if (typeof value !== 'string') {
            return key;
        }

        // Substitui parâmetros {param}
        return value.replace(/\{(\w+)\}/g, (match, paramName) => {
            return params[paramName] !== undefined ? params[paramName] : match;
        });
    }

    /**
     * Atalho para get()
     */
    t(key, params = {}) {
        return this.get(key, params);
    }

    /**
     * Retorna o dicionário de traduções.
     * Fonte única embutida pelo build (sync-class.js) a partir de
     * js/i18n/translations.json como window.__I18N__.
     * @returns {Object}
     */
    getTranslations() {
        return (typeof window !== 'undefined' && window.__I18N__) ? window.__I18N__ : {};
    }
}

// Singleton global
window.language = new Language();



// ============================================
// core/Router.js
// ============================================
/**
 * Router - Sistema de navegação SPA
 * Gerencia rotas baseadas em hash
 */
class Router {
    constructor() {
        if (Router.instance) {
            return Router.instance;
        }

        this.routes = new Map();
        this.currentRoute = null;
        this.currentScreen = null;
        this.currentPath = null;     // rota no ar, como string ('/intervalos')
        this.previousPath = null;    // de onde se veio — lido pela Central de Ajuda
        this.beforeHooks = [];
        this.afterHooks = [];
        /**
         * 🔴 Selo da navegação corrente. `handleRoute` é ASSÍNCRONA e pode ficar esperando
         * (hooks, e sobretudo um `init()` que busca dado na rede). Sem este selo, a
         * navegação que resolve TARDE sobrescreve `currentScreen` e a tela que ela criou
         * fica viva e fora do alcance de qualquer `destroy()` futuro. Ver handleRoute.
         */
        this._navSeq = 0;

        // Escuta mudanças de hash
        window.addEventListener('hashchange', () => this.handleRoute());

        Router.instance = this;
    }

    /**
     * Registra uma rota
     * @param {string} path - Caminho da rota (ex: '/ritmo')
     * @param {Object} config - Configuração da rota
     */
    register(path, config) {
        this.routes.set(path, {
            path,
            ...config
        });
    }

    /**
     * Registra múltiplas rotas
     * @param {Object} routes - Objeto com rotas
     */
    registerAll(routes) {
        Object.entries(routes).forEach(([path, config]) => {
            this.register(path, config);
        });
    }

    /**
     * Adiciona hook antes da navegação
     * @param {Function} hook - Função (from, to) => boolean
     */
    beforeEach(hook) {
        this.beforeHooks.push(hook);
    }

    /**
     * Adiciona hook após a navegação
     * @param {Function} hook - Função (from, to) => void
     */
    afterEach(hook) {
        this.afterHooks.push(hook);
    }

    /**
     * Navega para uma rota
     * @param {string} path - Caminho da rota
     * @param {Object} params - Parâmetros opcionais
     */
    navigate(path, params = {}) {
        // Normaliza o path
        if (!path.startsWith('/')) {
            path = '/' + path;
        }

        // Monta query string se houver params
        let hash = path;
        if (Object.keys(params).length > 0) {
            const query = new URLSearchParams(params).toString();
            hash = `${path}?${query}`;
        }

        window.location.hash = hash;
    }

    /**
     * Navega para a rota anterior
     */
    back() {
        window.history.back();
    }

    /**
     * Processa a rota atual
     */
    async handleRoute() {
        const hash = window.location.hash.slice(1) || '/';
        const [path, queryString] = hash.split('?');
        const query = queryString ? Object.fromEntries(new URLSearchParams(queryString)) : {};

        // Ignora hashes que são âncoras de scroll (não começam com /)
        if (hash && !hash.startsWith('/')) {
            // É uma âncora (ex: #games), não uma rota SPA
            return;
        }

        // Encontra a rota
        const route = this.findRoute(path);

        if (!route) {
            console.warn(`Router: Rota não encontrada: ${path}`);
            // Fallback para home
            if (path !== '/') {
                this.navigate('/');
            }
            return;
        }

        const from = this.currentRoute;
        // Path-params (`/turma/:id` → {id}) e query (`?aba=x`) chegam JUNTOS ao handler;
        // a query vence no conflito de nome. Antes o `routeParams` capturado pelo
        // findRoute ficava preso em `currentRoute` e nenhum handler o recebia.
        const params = { ...(route.routeParams || {}), ...query };
        const to = { ...route, params };

        /**
         * 🔴 TRAVA DE REENTRÂNCIA. Daqui em diante há `await`, e o usuário pode trocar de
         * rota no meio — um clique impaciente enquanto uma tela carrega. Sem esta trava, a
         * navegação lenta terminava DEPOIS da rápida e sobrescrevia `currentScreen`: os
         * dois jogos ficavam vivos ao mesmo tempo (rAF, áudio agendado, teclado em
         * `document`) e o `destroy()` seguinte só alcançava o fantasma. Medido pela
         * auditoria: URL em `#/ritmo`, `currentScreen` = a tela do outro jogo, 8 notas
         * agendadas que ninguém mata, e o `_killAudio()` do fantasma calando o metrônomo
         * do jogo que estava tocando de verdade.
         *
         * Ficou latente por muito tempo porque todo `init()` era síncrono na prática. O
         * jogo de música real é o primeiro que ESPERA A REDE (busca a partitura) — ele não
         * criou o defeito, só o tornou alcançável. Qualquer tela futura que carregue dado
         * cai no mesmo buraco, então a trava mora aqui e não no jogo.
         */
        const seq = ++this._navSeq;
        /** Esta navegação ainda é a atual? (false = o usuário já foi para outro lugar) */
        const atual = () => seq === this._navSeq;

        // Executa hooks before
        for (const hook of this.beforeHooks) {
            const canProceed = await hook(from, to);
            if (canProceed === false) {
                return;
            }
            if (!atual()) return;
        }

        // Cleanup da screen anterior
        if (this.currentScreen && typeof this.currentScreen.destroy === 'function') {
            this.currentScreen.destroy();
        }

        // 🔴 De onde a pessoa VEIO — dois campos, aditivos, escritos no único ponto em
        // que a troca de rota é definitiva (depois da trava de reentrância, senão uma
        // navegação abortada deixaria a origem errada). A Central de Ajuda (#/ajuda) lê
        // isto para abrir com os assuntos da tela anterior: quem pede ajuda no meio do
        // jogo quase sempre quer o assunto DAQUELA tela, não um índice.
        this.previousPath = this.currentPath || null;
        this.currentPath = path;

        this.currentRoute = to;

        // Funil: o jogo da tela tem de trocar EXATAMENTE aqui — depois do destroy() acima
        // (que fecha a rodada abandonada com o jogo VELHO, o certo) e ANTES do handler
        // abaixo (o quiz de 1 nota abre rodada dentro do próprio init(), e no afterEach
        // seria tarde: a rodada nasceria atribuída ao jogo anterior, ou perdida no
        // page-load direto). Best-effort, nunca quebra a navegação.
        window.Beacon?.setRoute(to?.name);

        // Executa o handler da rota
        if (route.handler) {
            let screen = null;
            try {
                screen = await route.handler(params);
            } catch (error) {
                console.error('Router: Erro ao executar handler:', error);
            }
            if (!atual()) {
                // O usuário saiu enquanto esta tela nascia. Ela é ÓRFÃ: não pode assumir o
                // lugar da atual (sobrescrever `currentScreen` a tornaria imortal), e
                // precisa ser desmontada aqui — é o único ponto do app que ainda tem uma
                // referência para ela.
                if (screen && typeof screen.destroy === 'function') {
                    try { screen.destroy(); } catch (e) { console.warn('Router: falha ao desmontar tela órfã:', e); }
                }
                return;
            }
            this.currentScreen = screen;
        }
        if (!atual()) return;

        // Emite evento
        window.eventBus?.emit('route:changed', { from, to });

        // Executa hooks after
        for (const hook of this.afterHooks) {
            await hook(from, to);
            if (!atual()) return;
        }
    }

    /**
     * Encontra uma rota pelo path
     * @param {string} path - Caminho
     * @returns {Object|null}
     */
    findRoute(path) {
        // Busca exata
        if (this.routes.has(path)) {
            return this.routes.get(path);
        }

        // Busca com parâmetros dinâmicos (ex: /user/:id). O path é ESCAPADO antes de
        // virar regex: um `.` ou `+` numa rota futura seria metacaractere (`/a.b` casaria
        // `/aXb`). O `:` não é especial, então `:param` continua casando depois do escape.
        for (const [routePath, config] of this.routes) {
            const escaped = routePath.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const pattern = escaped.replace(/:\w+/g, '([^/]+)');
            const regex = new RegExp(`^${pattern}$`);
            const match = path.match(regex);

            if (match) {
                // Extrai parâmetros
                const paramNames = (routePath.match(/:(\w+)/g) || []).map(p => p.slice(1));
                const params = {};
                paramNames.forEach((name, index) => {
                    params[name] = match[index + 1];
                });

                return { ...config, routeParams: params };
            }
        }

        return null;
    }

    /**
     * Obtém o path atual
     * @returns {string}
     */
    getCurrentPath() {
        const hash = window.location.hash.slice(1) || '/';
        return hash.split('?')[0];
    }

    /**
     * Obtém os parâmetros da URL atual
     * @returns {Object}
     */
    getCurrentParams() {
        const hash = window.location.hash.slice(1) || '/';
        const [, queryString] = hash.split('?');
        return queryString ? Object.fromEntries(new URLSearchParams(queryString)) : {};
    }

    /**
     * Verifica se uma rota está ativa
     * @param {string} path - Caminho
     * @returns {boolean}
     */
    isActive(path) {
        return this.getCurrentPath() === path;
    }

    /**
     * Inicializa o router
     */
    init() {
        // Processa a rota inicial
        this.handleRoute();
    }
}

// Singleton global
window.router = new Router();



// ============================================
// core/HelpRegistry.js
// ============================================
/**
 * HelpRegistry — a TABELA ÚNICA da ajuda contextual.
 *
 * Dado PURO, sem DOM: é o que permite ao teste carregá-la em Node do mesmo jeito
 * que o levels-test já faz com o catálogo de níveis. Quem desenha é o HelpDot
 * (o "?") e o HelpSheet (a folha); aqui só mora a VERDADE sobre quais tópicos
 * existem, de que grupo são e quantas páginas/perguntas cada um tem.
 *
 * 🔴 `pages` (e `faq`) moram AQUI, não no translations.json, por dois motivos
 * medidos: Language.get() devolve a CHAVE CRUA quando o valor não é string (então
 * array não passa por t()), e o i18n-test trata array como FOLHA, comparando só
 * comprimento — um `body` faltando em espanhol dentro de um array passaria verde.
 * Com o número na tabela, `i18nKeys()` DERIVA exatamente as chaves exigidas e o
 * help-test cobra as três traduções, uma a uma.
 *
 * 🔴 Tabela única, nunca espelho: o teste IMPORTA esta classe e pergunta `ids()`.
 * Espelho de tabela não é redundância — é uma segunda verdade esperando divergir
 * (auditoria de 08/ago, CLAUDE.md).
 *
 * Persistência ("já vi este ?"): chave `help_seen_v1`, FORA do StorageScope —
 * ajuda é preferência de APARELHO, não progresso. Dentro de PROGRESS_BASE_KEYS a
 * regra de adoção guest→conta apagaria (mesma razão do `song_harmony_v1`).
 */
class HelpRegistry {

    /** Grupos (a Central da fase 2 varre por aqui; a fase 1 só classifica). */
    static GROUPS = ['rhythm', 'staffReading', 'intervals', 'chords', 'songs', 'app'];

    /** Default de todo tópico — campo ausente na tabela cai aqui, para a tabela
     *  não virar parede de `null` e `get()` devolver sempre a forma completa. */
    static DEFAULTS = {
        group: 'app',
        icon: '❓',
        pages: 1,        // 🔴 nº de páginas da Explicação — a verdade mora aqui
        faq: 0,          // 0 → a aba Perguntas não existe (fase 2)
        art: null,       // fase 3: id em HelpSheet.ART
        video: null,     // fase 4: { src, cues }
        action: null,    // opcional: { route } — rótulo em help.<id>.action
        firstRun: false  // fase 3: este tópico oferece o Primeiro Ensaio
    };

    /**
     * FASE 1 — os 3 jogos que hoje não têm ajuda nenhuma (Leitura em Fluxo,
     * Intervalos, Acordes) + o "qual modo escolher?" do jogo de música.
     * Os outros 19 tópicos do plano entram na fase 2.
     */
    static HELP = {
        // ---- staffReading: Leitura em Fluxo (#/leitura) — headline, órfão até aqui
        'flow.howto':       { group: 'staffReading', icon: '🎼', pages: 2 },
        'flow.input':       { group: 'staffReading', icon: '🎹', pages: 2 },
        'flow.kids':        { group: 'staffReading', icon: '🧸', pages: 2 },

        // ---- intervals (#/intervalos) — órfão até aqui
        'intervals.howto':  { group: 'intervals', icon: '🎧', pages: 2 },
        'intervals.assist': { group: 'intervals', icon: '👀', pages: 1 },
        'intervals.mode':   { group: 'intervals', icon: '🎹', pages: 1 },

        // ---- chords (#/acordes) — órfão até aqui
        'chords.howto':     { group: 'chords', icon: '🎸', pages: 2 },
        'chords.play':      { group: 'chords', icon: '🎵', pages: 1 },
        // "Ver teclas" é a MESMA dúvida nos dois jogos: um corpo, duas âncoras.
        // 🔴 O alias declara o PRÓPRIO grupo: sem isto ele herdaria 'intervals' e a
        // Central listaria a mesma linha duas vezes em Intervalos e nenhuma em Acordes.
        'chords.assist':    { alias: 'intervals.assist', group: 'chords' },

        // ---- staffReading: os dois jogos de leitura (fase 2)
        'flow.exitLine':    { group: 'staffReading', icon: '🚩', pages: 1, faq: 1 },
        'reading.howto':    { group: 'staffReading', icon: '🔍', pages: 2 },
        'reading.guide':    { group: 'staffReading', icon: '📏', pages: 2 },
        // Os ajustes do treino livre no ⚙️ (27/set): uma linha por ajuste, a explicação aqui.
        'reading.clef':     { group: 'staffReading', icon: '🎼', pages: 1 },
        'reading.key':      { group: 'staffReading', icon: '♯', pages: 2 },
        'reading.sound':    { group: 'staffReading', icon: '🎹', pages: 1 },

        // ---- intervals (fase 2)
        'intervals.play':   { group: 'intervals', icon: '🎼', pages: 1 },

        // ---- rhythm (#/ritmo) — tinha tutorial animado, nunca teve "?" (fase 2)
        'rhythm.howto':     { group: 'rhythm', icon: '🥁', pages: 3, faq: 2 },
        'rhythm.tempo':     { group: 'rhythm', icon: '⏱️', pages: 1 },
        // Os ajustes do JOGADOR no ⚙️ (18/set): uma linha por ajuste, a explicação aqui.
        'rhythm.sound':     { group: 'rhythm', icon: '🎵', pages: 1 },
        'rhythm.ruler':     { group: 'rhythm', icon: '📏', pages: 1 },
        // "Notas na altura certa" (19/set): linha FILHA da "Melodia" no ⚙️ — só existe com ela escolhida.
        'rhythm.pitch':     { group: 'rhythm', icon: '🎼', pages: 1 },
        // O teclado MIDI como botão (19/set): a linha só existe onde há Web MIDI (não no iOS).
        'rhythm.midi':      { group: 'rhythm', icon: '🎹', pages: 1 },
        // aposenta o <details> "Como isso é medido?" da tela de resultado
        'rhythm.results':   { group: 'rhythm', icon: '📊', pages: 2, faq: 2 },
        // A trilha do PROFESSOR (oficina, 18/set): o "?" ao lado de "＋ Usar este exercício numa
        // trilha" no Ritmo Livre — o botão pressupõe o conceito, o "?" o entrega.
        // A ação (22/set) leva à TRILHA EXEMPLO — `route` é FUNÇÃO porque o código mora em
        // `RhythmTrails.SAMPLE_CODE` (dado, por ambiente); vazio ⇒ null ⇒ o botão não nasce.
        'rhythm.trails':    { group: 'rhythm', icon: '📋', pages: 2, action: { route: () => (window.RhythmTrails && window.RhythmTrails.sampleRoute) ? window.RhythmTrails.sampleRoute() : null } },

        // ---- songs (#/musicas) — song.mode veio na fase 1
        'song.mode':        { group: 'songs', icon: '🎚️', pages: 3 },
        'song.tempo':       { group: 'songs', icon: '⏱️', pages: 1, faq: 1 },
        'song.input':       { group: 'songs', icon: '🎹', pages: 1 },
        'song.chart':       { group: 'songs', icon: '🎸', pages: 2, faq: 1 },
        'song.chartGrid':   { group: 'songs', icon: '📐', pages: 2 },
        'song.midi':        { group: 'songs', icon: '📥', pages: 2, faq: 2 },
        'song.lists':       { group: 'songs', icon: '📚', pages: 1 },
        'song.account':     { group: 'songs', icon: '📱', pages: 1, faq: 1 },
        'song.backup':      { group: 'songs', icon: '💾', pages: 2, faq: 1 },
        'song.results':     { group: 'songs', icon: '⭐', pages: 2 },


        // ---- app: o que não é de jogo nenhum
        // 🔴 3 páginas, e a p1 responde a pergunta que a TELA levanta: com o gate em
        // 3 níveis livres, quem chega novo vê os cadeados 2 e 3 — que são de
        // PROGRESSO, não de conta. Responder sobre o nível 4 quando a pessoa pergunta
        // sobre o 2 é pior que não responder: confirma que ela não entendeu.
        'app.levelGate':    { group: 'app', icon: '🔓', pages: 3, faq: 1 },
        'app.freeMode':     { group: 'app', icon: '⚙️', pages: 1 },
        // Grupos (escola/turma): o "?" mora em #/grupo/novo (convidado e logado). A rota NÃO
        // entra em ROUTE_TOPICS (aquela lista é jogos × 2, por régua do help-test [Q]); a
        // varredura do [P] visita #/grupo/novo à parte.
        'app.groups':       { group: 'app', icon: '🏫', pages: 2, faq: 1 }
    };

    // ---------- leitura da tabela ----------

    /** Definição RESOLVIDA (segue `alias`, aplica DEFAULTS). null se não existe.
     *  `id` = o id pedido (a âncora); `sourceId` = de onde veio o corpo/i18n. */
    /**
     * Tópico atrás de uma CORTINA (18/set): `rhythm.trails` só existe para o público quando a trilha do
     * professor estiver ligada (`RhythmTrails.ENABLED`). Escondido = `get()` null, fora de `ids()`,
     * `byGroup()` e `forRoute()` — mas as chaves i18n continuam exigidas (`allI18nKeys` varre a TABELA),
     * senão o help-test [B] as acusaria de órfãs e o lançamento nasceria sem texto.
     */
    static hidden(topicId) {
        if (topicId !== 'rhythm.trails') return false;
        return !(typeof window !== 'undefined' && window.RhythmTrails && window.RhythmTrails.ENABLED);
    }

    static get(topicId, _vistos) {
        const raw = HelpRegistry.HELP[topicId];
        if (!raw || HelpRegistry.hidden(topicId)) return null;
        if (raw.alias) {
            // 🔴 Trava de ciclo. `a → b → a` (ou um alias para si mesmo) daria
            // RangeError DENTRO do construtor do HelpDot — ou seja, derrubaria a
            // montagem da TELA DO JOGO, não só a ajuda. Uma linha para uma tabela
            // que qualquer sessão futura pode editar.
            const vistos = _vistos || new Set();
            if (vistos.has(topicId)) return null;
            vistos.add(topicId);
            const target = HelpRegistry.get(raw.alias, vistos);
            if (!target) return null;
            // Corpo e i18n vêm do alvo; grupo e ícone o alias pode ter os seus (é a
            // MESMA dúvida, mas ela mora nas duas prateleiras da Central).
            return Object.assign({}, target, {
                id: topicId,
                sourceId: target.sourceId,
                group: raw.group || target.group,
                icon: raw.icon || target.icon
            });
        }
        return Object.assign({}, HelpRegistry.DEFAULTS, raw, { id: topicId, sourceId: topicId });
    }

    /** Todos os ids de âncora, na ordem da tabela (aliases inclusos; os atrás da cortina não). */
    static ids() { return Object.keys(HelpRegistry.HELP).filter(id => !HelpRegistry.hidden(id)); }

    /** Ids de um grupo, na ordem da tabela. */
    static byGroup(group) {
        return HelpRegistry.ids().filter((id) => {
            const d = HelpRegistry.get(id);
            return d && d.group === group;
        });
    }

    /**
     * 🔴 DERIVA toda chave i18n que o tópico exige — o teste não lista nada.
     * Alias devolve as chaves do ALVO (o corpo é o mesmo); senão a asserção [A]
     * exigiria chave inexistente e a [B] acusaria órfã.
     */
    static i18nKeys(topicId) {
        const d = HelpRegistry.get(topicId);
        if (!d) return [];
        const base = 'help.' + d.sourceId;
        const keys = [base + '.title'];
        for (let i = 1; i <= d.pages; i++) keys.push(base + '.p' + i + '.title', base + '.p' + i + '.body');
        for (let i = 1; i <= d.faq; i++) keys.push(base + '.q' + i + '.q', base + '.q' + i + '.a');
        if (d.action) keys.push(base + '.action');
        return keys;
    }

    /** Toda chave i18n de todos os tópicos, sem repetir (aliases coalescem). */
    static allI18nKeys() {
        const out = [];
        // a TABELA inteira, cortina inclusa: o texto do tópico escondido tem de existir nos 3 idiomas
        Object.keys(HelpRegistry.HELP).forEach((id) => {
            HelpRegistry._i18nKeysRaw(id).forEach((k) => { if (!out.includes(k)) out.push(k); });
        });
        return out;
    }

    /** `i18nKeys` sem a cortina (para `allI18nKeys`). */
    static _i18nKeysRaw(topicId) {
        const raw = HelpRegistry.HELP[topicId];
        if (!raw) return [];
        if (raw.alias) return HelpRegistry._i18nKeysRaw(raw.alias);
        const d = Object.assign({}, HelpRegistry.DEFAULTS, raw);
        const base = 'help.' + topicId;
        const keys = [base + '.title'];
        for (let i = 1; i <= d.pages; i++) keys.push(base + '.p' + i + '.title', base + '.p' + i + '.body');
        for (let i = 1; i <= d.faq; i++) keys.push(base + '.q' + i + '.q', base + '.q' + i + '.a');
        if (d.action) keys.push(base + '.action');
        return keys;
    }

    // ---------- "já vi este ?" (pulse só na 1ª visita) ----------

    /**
     * Tópicos de "Primeiros passos" da Central — a dúvida de quem CHEGOU AGORA e
     * ainda não reconhece o nome de nenhum jogo. É ordem editorial, não um grupo
     * novo: eles continuam morando nos seus grupos.
     */
    // 🔴 COMO SE JOGA primeiro. A ordem anterior abria a prateleira de quem chegou
    // perdido com administração de conta (o cadeado) e taxonomia interna (trilha ×
    // livre) — para o público 60+ isso confirma o medo de que o app é complicado.
    // `app.freeMode` saiu: é dúvida de quem JÁ jogou, não de primeiro passo.
    static FIRST_STEPS = ['rhythm.howto', 'flow.howto', 'intervals.howto', 'app.levelGate'];

    /** Ordem em que os grupos aparecem na Central (jogo primeiro, app por último). */
    static GROUP_ORDER = ['rhythm', 'staffReading', 'intervals', 'chords', 'songs', 'app'];

    /**
     * Tópicos da tela em que a pessoa estava — a Central abre com eles no topo.
     * Rota (com ou sem '#') → ids. Quem abre a ajuda no meio do jogo quase sempre
     * quer o assunto DAQUELA tela, não um índice.
     *
     * 🔴 Esta lista é uma SEGUNDA VERDADE sobre "o que tem nesta tela", e ela já
     * divergiu antes do deploy: dizia `rhythm.calibrate` em `/ritmo` (onde não há
     * botão de calibrar) e NÃO dizia em `/ritmo-livre` (onde há). Como derivá-la das
     * âncoras exigiria um registro vivo de HelpDots montados — mais maquinaria do
     * que a fase 2 comporta —, ela fica escrita, mas GUARDADA: o `help-test [Q]`
     * monta cada rota no shell real e exige que todo id listado tenha "?" naquela
     * tela ou esteja na lista curta de exceções. Espelho de tabela sem guarda é uma
     * segunda verdade esperando divergir; com guarda, é só uma lista.
     *
     * 🔴 `/musicas` e `/musicas-livre` são a MESMA rota em duas telas (o seletor e o
     * tocador): a lista traz o que serve às duas, começando pelo seletor, que é onde
     * a rota entra.
     */
    static ROUTE_TOPICS = {
        '/ritmo':          ['rhythm.howto', 'rhythm.tempo', 'rhythm.results'],
        '/ritmo-livre':    ['rhythm.howto', 'rhythm.tempo', 'app.freeMode', 'rhythm.trails'],
        '/leitura':        ['flow.howto', 'flow.input', 'flow.kids', 'flow.exitLine'],
        '/leitura-livre':  ['reading.howto', 'reading.guide', 'app.freeMode'],
        '/intervalos':     ['intervals.howto', 'intervals.assist', 'intervals.mode'],
        '/intervalos-livre': ['intervals.howto', 'intervals.play', 'app.freeMode'],
        '/acordes':        ['chords.howto', 'chords.assist', 'chords.play'],
        '/acordes-livre':  ['chords.howto', 'chords.play', 'app.freeMode'],
        '/musicas':        ['song.lists', 'song.mode', 'song.chart', 'song.tempo'],
        '/musicas-livre':  ['song.midi', 'song.lists', 'song.account', 'song.backup']
    };

    /** Os ids de uma rota (aceita '#/x' ou '/x'); [] se a rota não tem tópicos. */
    static forRoute(route) {
        const clean = String(route || '').replace(/^#/, '').split('?')[0];
        return (HelpRegistry.ROUTE_TOPICS[clean] || []).filter(id => !!HelpRegistry.get(id));
    }

    // ---------- páginas SATÉLITE (fora do app) ----------

    /**
     * As páginas satélite — a matéria explicada fora do app, com brinquedos
     * (`docs/SATELITE-RITMO-PLANO.md` e `docs/SATELITE-LEITURA-PLANO.md`).
     *
     * 🔴 Elas aparecem SÓ aqui, dentro do app. Decisão do Bernardo: na tela dos
     * jogos a pessoa está *fazendo*, e link para fora é vazamento, não conversão.
     * A Central é o único lugar onde ela já está confusa com um conceito — ali a
     * página ajuda em vez de atrapalhar. O funil aponta satélite → app; este é o
     * único fio no sentido contrário, e ele nasce de uma dúvida, não de um banner.
     *
     * 🔴 Isto é um ESPELHO do `SATELLITE_PAGES` do `scripts/build-landing.js` — o
     * app não lê o build. Espelho de tabela é uma segunda verdade esperando
     * divergir, e slug divergente aqui vira 404 servido como 200 pelo catch-all da
     * SPA (o pior tipo de erro: com cara de sucesso). Por isso o `help-test [S]`
     * IMPORTA as duas tabelas e exige que os 6 slugs sejam idênticos.
     *
     * `linkLabel` NÃO mora aqui: é `pages.<key>.linkLabel` no translations.json,
     * onde a landing e o `make-og` já o leem — uma verdade só, nos 3 idiomas.
     */
    static GUIDES = [
        { key: 'ritmoGuia', icon: '🥁',
          slugs: { pt: 'o-que-e-ritmo-na-musica',
                   en: 'what-is-rhythm-in-music',
                   es: 'que-es-el-ritmo-en-la-musica' } },
        { key: 'leituraGuia', icon: '🎼',
          slugs: { pt: 'como-ler-partitura',
                   en: 'how-to-read-sheet-music',
                   es: 'como-leer-partituras' } },
        { key: 'intervalosGuia', icon: '🎹',
          slugs: { pt: 'o-que-sao-intervalos-musicais',
                   en: 'what-are-musical-intervals',
                   es: 'que-son-los-intervalos-musicales' } },
        { key: 'acordesGuia', icon: '🎸',
          slugs: { pt: 'o-que-sao-acordes',
                   en: 'what-are-chords-in-music',
                   es: 'que-son-los-acordes' } }
    ];

    /** Slug da guia no idioma pedido; null se a chave não existe. Função PURA —
     *  quem sabe em que AMBIENTE está (prod × ritmo.local) é a tela, não a tabela. */
    static guideSlug(key, lang) {
        const g = HelpRegistry.GUIDES.find(x => x.key === key);
        if (!g) return null;
        return g.slugs[lang] || g.slugs.pt;
    }

    static SEEN_KEY = 'help_seen_v1';   // 🔴 FORA do StorageScope (preferência de aparelho)

    static _seenMap() {
        try {
            const raw = (window.localStorage || localStorage).getItem(HelpRegistry.SEEN_KEY);
            const o = raw ? JSON.parse(raw) : null;
            return (o && typeof o === 'object') ? o : {};
        } catch (_) { return {}; }
    }

    /** Já viu este tópico neste aparelho? (alias conta junto com o alvo: o corpo
     *  é o mesmo, e piscar duas vezes o mesmo texto é ruído.) */
    static seen(topicId) {
        const d = HelpRegistry.get(topicId);
        return !!(d && HelpRegistry._seenMap()[d.sourceId]);
    }

    static markSeen(topicId) {
        const d = HelpRegistry.get(topicId);
        if (!d) return;
        const m = HelpRegistry._seenMap();
        if (m[d.sourceId]) return;
        m[d.sourceId] = 1;
        try { (window.localStorage || localStorage).setItem(HelpRegistry.SEEN_KEY, JSON.stringify(m)); } catch (_) {}
    }
}

window.HelpRegistry = HelpRegistry;



// ============================================
// core/SongStore.js
// ============================================
/**
 * SongStore — a ESTANTE: o `.mid` do aluno guardado NESTE aparelho (Etapa 8).
 *
 * Plano: docs/ESTANTE-PLANO.md. Até aqui, as CIFRAS voltavam (chave `song_harmony_v1`,
 * indexada pelo hash do conteúdo do arquivo) mas o ARQUIVO não: ele ficava no Downloads
 * do aparelho e tinha de ser apontado no seletor do sistema toda sessão. Para uma peça é
 * um toque a mais; para um repertório de dezenas, é o que impede o repertório de existir.
 *
 * ─── 🔴 O ARQUIVO CONTINUA NÃO SAINDO DO APARELHO ────────────────────────────────────
 *
 * Guardar localmente é o que esta classe acrescenta. Subir para servidor continua fora —
 * é o que a tela promete em três idiomas. O `.json` de backup (§3 do plano) é um arquivo
 * que a PESSOA move entre aparelhos dela, com o dedo dela; nada aqui fala com a rede.
 *
 * ─── Por que IndexedDB e não localStorage ────────────────────────────────────────────
 *
 * `localStorage` é texto: um `.mid` viraria base64 (+33%) dentro de uma cota de 5 MB
 * COMPARTILHADA com o progresso dos outros quatro jogos. O sintoma de estourá-la não
 * apareceria aqui — apareceria como "o Ritmo parou de gravar o nível". IndexedDB guarda
 * `ArrayBuffer` cru, com cota própria e ordens de grandeza maior.
 *
 * ─── 🔴 DUAS OBJECT STORES, e não é preciosismo ──────────────────────────────────────
 *
 * IndexedDB só sabe devolver o registro INTEIRO. Com uma store só, desenhar a lista de 60
 * linhas traria dezenas de MB para a memória de um celular só para escrever nomes na tela.
 * `songs` guarda metadados (~200 bytes/peça, é o que a lista lê); `blobs` guarda os bytes,
 * lidos só quando a peça é aberta.
 *
 * ─── 🔴 NÃO TOCA `song_harmony_v1` ───────────────────────────────────────────────────
 *
 * A chave das cifras é do `SongReadingGame`, que a tem em produção. Se esta classe também
 * a lesse, existiriam DUAS verdades sobre onde a cifra mora — a armadilha que este projeto
 * já pagou três vezes. `packRepertoire`/`unpackRepertoire`/`mergeChords` são PUROS e
 * recebem o mapa de cifras como argumento; quem lê e grava o localStorage é o jogo.
 */
class SongStore {
    static DB_NAME = 'aulademusica';
    static DB_VERSION = 1;
    static META = 'songs';
    static BLOBS = 'blobs';

    /**
     * Tetos da estante. 🔴 O de arquivos é MENOR que `SongReadingGame.HARMONY_MAX_FILES`
     * de propósito: se fosse igual ou maior, o despejo LRU do `song_harmony_v1` apagaria
     * as cifras de uma peça que ESTÁ na estante — a pessoa veria a música na lista, abriria,
     * e ela estaria pelada. Guardado por `library-test [K]`.
     */
    static MAX_FILES = 60;
    /** `MidiFile.MAX_BYTES` já limita cada arquivo a 512 KB; um .mid de partitura tem
     *  5–40 KB. 16 MB é folga larga com um teto que existe de verdade. */
    static MAX_BYTES_TOTAL = 16 * 1024 * 1024;

    /** Backup (§3 do plano). */
    static FORMAT = 'aulademusica.repertoire';
    static FORMAT_VERSION = 1;
    static MAX_JSON_BYTES = 64 * 1024 * 1024;

    constructor() {
        this._db = null;
        this._opening = null;
        /** `null` = ainda não se sabe · `true`/`false` = medido. Ver `open()`. */
        this.available = null;
    }

    // ---------- abertura ----------

    /**
     * Abre (uma vez) o banco. 🔴 NUNCA estoura: aba privada, armazenamento bloqueado ou
     * cota zerada devolvem `null` e `available === false`. Falha da estante não pode
     * impedir de TOCAR — é a lição da auditoria de 24/ago, em que uma cifra corrompida
     * derrubava a importação inteira.
     * @returns {Promise<IDBDatabase|null>}
     */
    open() {
        if (this._db) return Promise.resolve(this._db);
        if (this._opening) return this._opening;
        this._opening = new Promise((resolve) => {
            let req;
            try {
                if (!window.indexedDB) throw new Error('sem indexedDB');
                req = window.indexedDB.open(SongStore.DB_NAME, SongStore.DB_VERSION);
            } catch (e) { this.available = false; return resolve(null); }

            // Alguns browsers travam o `open` (outra aba segurando um upgrade) sem nunca
            // chamar erro nem sucesso. A tela não pode ficar pendurada nisso.
            // 🔴 O timeout LIBERA `_opening`: sem isso, um `open` pendurado uma vez matava a
            // estante pelo RESTO DA SESSÃO — a Promise já resolvida com `null` ficava em
            // cache e toda chamada seguinte devolvia `null`, mesmo com o banco de volta.
            const timer = setTimeout(() => {
                this.available = false;
                this._opening = null;
                resolve(null);
            }, 4000);
            const done = (db) => { clearTimeout(timer); this.available = !!db; this._db = db; resolve(db); };

            req.onupgradeneeded = () => {
                const db = req.result;
                if (!db.objectStoreNames.contains(SongStore.META)) {
                    db.createObjectStore(SongStore.META, { keyPath: 'id' });
                }
                if (!db.objectStoreNames.contains(SongStore.BLOBS)) {
                    db.createObjectStore(SongStore.BLOBS, { keyPath: 'id' });
                }
            };
            req.onsuccess = () => {
                const db = req.result;
                // Fechar aqui é o que deixa outra aba fazer upgrade em vez de travar.
                db.onversionchange = () => {
                    try { db.close(); } catch (e) {}
                    // `available` volta a "não se sabe": enquanto o banco está fechado, dizer
                    // `true` mente para quem decide a porta "Minhas músicas" por ela.
                    this._db = null; this._opening = null; this.available = null;
                };
                done(db);
            };
            req.onerror = () => done(null);
            req.onblocked = () => done(null);
        });
        return this._opening;
    }

    /** Uma transação envolvida em Promise. Resolve `fb` se o banco não existe. */
    async _tx(stores, mode, fn, fb) {
        const db = await this.open();
        if (!db) return fb;
        return new Promise((resolve) => {
            let tx;
            try { tx = db.transaction(stores, mode); } catch (e) { return resolve(fb); }
            let out = fb;
            tx.oncomplete = () => resolve(out);
            tx.onerror = () => resolve(fb);
            tx.onabort = () => resolve(fb);
            try { fn(tx, (v) => { out = v; }); } catch (e) { try { tx.abort(); } catch (e2) {} resolve(fb); }
        });
    }

    // ---------- leitura ----------

    /**
     * Metadados de tudo que está guardado, do aberto mais recentemente para o mais antigo.
     * 🔴 NÃO traz os bytes (ver o cabeçalho): é a lista de uma tela, não um carregamento.
     * @returns {Promise<Array>} [{id, name, size, addedAt, lastOpenedAt, trackIndex}]
     */
    async list() {
        const rows = await this._tx([SongStore.META], 'readonly', (tx, set) => {
            const req = tx.objectStore(SongStore.META).getAll();
            req.onsuccess = () => set(req.result || []);
        }, []);
        return rows.sort((a, b) => (b.lastOpenedAt || b.addedAt || 0) - (a.lastOpenedAt || a.addedAt || 0));
    }

    /** Quantas peças estão guardadas (sem tocar nos bytes). */
    async count() {
        return this._tx([SongStore.META], 'readonly', (tx, set) => {
            const req = tx.objectStore(SongStore.META).count();
            req.onsuccess = () => set(req.result || 0);
        }, 0);
    }

    /** `{count, bytes}` — o que os dois tetos vigiam. */
    async stats() {
        const rows = await this.list();
        return { count: rows.length, bytes: rows.reduce((s, r) => s + (r.size || 0), 0) };
    }

    /**
     * A peça inteira: metadados + bytes.
     * @returns {Promise<{id,name,size,addedAt,lastOpenedAt,trackIndex,bytes:ArrayBuffer}|null>}
     */
    async get(id) {
        if (!id) return null;
        // 🔴 NUNCA reatribuir `tx.oncomplete` aqui: é ele que o `_tx` usa para resolver a
        // Promise. Os pedidos de uma mesma transação completam na ORDEM em que foram
        // emitidos, então `m.result` já está pronto quando o `b.onsuccess` roda.
        return this._tx([SongStore.META, SongStore.BLOBS], 'readonly', (tx, set) => {
            const m = tx.objectStore(SongStore.META).get(id);
            const b = tx.objectStore(SongStore.BLOBS).get(id);
            b.onsuccess = () => {
                if (!m.result || !b.result) return;
                set(Object.assign({}, m.result, { bytes: SongStore._toBuffer(b.result.bytes) }));
            };
        }, null);
    }

    // ---------- escrita ----------

    /**
     * Guarda (ou atualiza) uma peça.
     *
     * 🔴 CHEIO NÃO DESPEJA NADA. O despejo LRU faz sentido no `song_harmony_v1`, onde ele
     * protege a cota dos OUTROS jogos. Aqui despejar significaria apagar o arquivo que a
     * pessoa cifrou à mão, sem ela pedir. Cheio devolve `{ok:false, reason:'full'}` — a
     * peça toca do mesmo jeito e a tela explica que apagar uma da estante resolve.
     *
     * @returns {Promise<{ok:boolean, reason?:string}>}
     */
    async put({ id, name, bytes, trackIndex }) {
        if (!id || !bytes) return { ok: false, reason: 'invalid' };
        const buf = SongStore._toBuffer(bytes);
        const size = buf.byteLength;
        const db = await this.open();
        if (!db) return { ok: false, reason: 'unavailable' };

        const rows = await this.list();
        const antiga = rows.find(r => r.id === id);
        if (!antiga) {
            const totalBytes = rows.reduce((s, r) => s + (r.size || 0), 0);
            if (rows.length >= SongStore.MAX_FILES) return { ok: false, reason: 'full' };
            // 🔴 Motivo SEPARADO do teto de arquivos: são dois limites diferentes e a tela
            // diz um número. Com o mesmo `'full'`, recusar por BYTES fazia o aviso dizer
            // "suas músicas já são 60" para quem tinha 20 — a tela mentindo sobre o próprio
            // limite. Raro (exige .mid gigante), mas mentira barata de evitar.
            if (totalBytes + size > SongStore.MAX_BYTES_TOTAL) return { ok: false, reason: 'fullBytes' };
        }

        const agora = Date.now();
        const meta = {
            id,
            name: name || (antiga && antiga.name) || '',
            size,
            addedAt: (antiga && antiga.addedAt) || agora,
            lastOpenedAt: agora,
            trackIndex: (trackIndex == null
                ? (antiga ? SongStore._trackIndex(antiga.trackIndex) : null)
                : SongStore._trackIndex(trackIndex))
        };
        // 🔴 `set(true)` só vira o valor da Promise se a transação COMPLETAR: erro, abort
        // e cota estourada caem no `fb` (`false`). É assim que a cota vira uma frase na
        // tela em vez de uma gravação que a pessoa acha que aconteceu.
        const gravou = await this._tx([SongStore.META, SongStore.BLOBS], 'readwrite', (tx, set) => {
            const stMeta = tx.objectStore(SongStore.META);
            // 🔴 O teto foi lido de uma `list()` FORA desta transação; duas gravações
            // concorrentes passavam as duas. Reconfere DENTRO — é o que sustenta a
            // desigualdade 60 < 64, e ela é o que impede a cifra de uma peça guardada de
            // ser despejada debaixo dela.
            if (!antiga) {
                const c = stMeta.count();
                c.onsuccess = () => {
                    if (c.result >= SongStore.MAX_FILES) { try { tx.abort(); } catch (e) {} return; }
                    stMeta.put(meta);
                    tx.objectStore(SongStore.BLOBS).put({ id, bytes: buf });
                    set(true);
                };
                return;
            }
            // 🔴 Peça que JÁ está guardada não reescreve os bytes: o `id` é o hash do
            // conteúdo, então "já existe" implica bytes idênticos. Reescrever até 512 KB
            // só para carimbar `lastOpenedAt` era o preço de cada toque na estante.
            stMeta.put(meta);
            set(true);
        }, false);
        return gravou ? { ok: true } : { ok: false, reason: antiga ? 'quota' : 'full' };
    }

    async remove(id) {
        return this._tx([SongStore.META, SongStore.BLOBS], 'readwrite', (tx, set) => {
            tx.objectStore(SongStore.META).delete(id);
            tx.objectStore(SongStore.BLOBS).delete(id);
            set(true);
        }, false);
    }

    async clear() {
        return this._tx([SongStore.META, SongStore.BLOBS], 'readwrite', (tx, set) => {
            tx.objectStore(SongStore.META).clear();
            tx.objectStore(SongStore.BLOBS).clear();
            set(true);
        }, false);
    }

    // ---------- base64 ----------

    /**
     * 🔴 Em PEDAÇOS: `String.fromCharCode(...bytes)` com 512 KB de uma vez estoura o limite
     * de argumentos do JS e derruba a exportação com um erro que não fala do problema.
     */
    static toBase64(bytes) {
        const b = new Uint8Array(SongStore._toBuffer(bytes));
        let s = '';
        for (let i = 0; i < b.length; i += 8192) {
            s += String.fromCharCode.apply(null, b.subarray(i, i + 8192));
        }
        return btoa(s);
    }

    /** @returns {Uint8Array|null} `null` se não for base64 válido. */
    static fromBase64(str) {
        if (typeof str !== 'string') return null;
        let bin;
        try { bin = atob(str); } catch (e) { return null; }
        const out = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
        return out;
    }

    /** Inteiro ≥ 0, ou `null` (= "sem preferência, use a heurística"). */
    static _trackIndex(v) {
        return (typeof v === 'number' && isFinite(v) && v >= 0 && v === Math.trunc(v)) ? v : null;
    }

    static _toBuffer(x) {
        if (x instanceof ArrayBuffer) return x;
        if (ArrayBuffer.isView(x)) return x.buffer.slice(x.byteOffset, x.byteOffset + x.byteLength);
        return new Uint8Array(x || []).buffer;
    }

    /**
     * O aparelho sabe ENTREGAR um arquivo a outro app (AirDrop, WhatsApp, Arquivos)?
     *
     * 🔴 Por que isto existe: no celular, "Exportar" baixava o `.json` para a pasta de
     * downloads DO MESMO APARELHO — o arquivo sumia dentro do app Arquivos e a pessoa
     * ainda tinha de achá-lo e compartilhar na mão. Três passos para uma intenção só.
     * Com `navigator.share` o repertório sai do aparelho de verdade, em um toque.
     *
     * A sonda constrói um `File` de brincadeira porque `canShare` **exige o payload**:
     * `navigator.share` existir não implica saber compartilhar ARQUIVO (o desktop
     * tipicamente compartilha só texto/URL). Quem responde `false` cai no download, que
     * continua sendo a resposta certa no computador.
     */
    static canShareFiles() {
        try {
            if (typeof navigator === 'undefined' || !navigator.canShare || !navigator.share) return false;
            if (typeof File === 'undefined') return false;
            const sonda = new File([new Blob(['{}'], { type: 'application/json' })],
                                   'probe.json', { type: 'application/json' });
            return !!navigator.canShare({ files: [sonda] });
        } catch (e) { return false; }
    }

    // ---------- backup: empacotar / desempacotar / fundir ----------

    /**
     * Repertório → objeto pronto para `JSON.stringify`. PURO: recebe as peças (com bytes)
     * e o mapa de cifras — não lê estante nem localStorage.
     * @param {Array} songs [{id, name, addedAt, trackIndex, bytes}]
     * @param {Object} harmonyStore o valor de `song_harmony_v1` (id → {name, updatedAt, chords})
     */
    static packRepertoire(songs, harmonyStore = {}) {
        return {
            format: SongStore.FORMAT,
            version: SongStore.FORMAT_VERSION,
            exportedAt: new Date().toISOString(),
            songs: (Array.isArray(songs) ? songs : []).filter(s => s && s.id && s.bytes).map(s => {
                const h = (harmonyStore && harmonyStore[s.id]) || {};
                return {
                    id: s.id,
                    name: s.name || '',
                    addedAt: s.addedAt || 0,
                    trackIndex: (s.trackIndex == null ? null : s.trackIndex),
                    midi: SongStore.toBase64(s.bytes),
                    // 🔴 Sempre presente, mesmo vazio: peça sem cifra tem de aparecer no
                    // arquivo (senão "exportei 12, voltaram 9" e ninguém sabe por quê).
                    chords: Array.isArray(h.chords) ? h.chords : [],
                    updatedAt: h.updatedAt || 0
                };
            })
        };
    }

    /**
     * Texto do `.json` → peças utilizáveis. PURO. Toda recusa é `{code, params}` — quem
     * escreve frase é a tela (regra do importador de MIDI).
     *
     * 🔴 O `id` é RECALCULADO a partir dos bytes; o declarado no arquivo é só uma pista.
     * É a mesma regra do `symbol` da cifra: identidade derivada não se aceita de fora. Sem
     * isto, um `.json` editado à mão órfã as cifras de uma peça em silêncio.
     *
     * @param {string} text
     * @param {function(ArrayBuffer):string} hashFn `SongReadingGame.hashBytes` — a ÚNICA
     *        implementação do hash do projeto, passada de fora para não virar a segunda.
     * @param {number} [maxBytesPerFile] `MidiFile.MAX_BYTES`
     * @returns {{songs:Array, errors:Array, fixedIds:number}}
     */
    static unpackRepertoire(text, hashFn, maxBytesPerFile) {
        if (typeof text !== 'string' || !text.length) return { songs: [], errors: [{ code: 'empty' }], fixedIds: 0 };
        if (text.length > SongStore.MAX_JSON_BYTES) {
            return { songs: [], errors: [{ code: 'tooBig', params: { mb: Math.round(SongStore.MAX_JSON_BYTES / 1048576) } }], fixedIds: 0 };
        }
        let data;
        try { data = JSON.parse(text); } catch (e) { return { songs: [], errors: [{ code: 'notJson' }], fixedIds: 0 }; }
        if (!data || data.format !== SongStore.FORMAT) {
            return { songs: [], errors: [{ code: 'notOurs' }], fixedIds: 0 };
        }
        // 🔴 `version` tem de ser NÚMERO: `null`, `'1'`, `[]` e `0.5` passavam pela
        // comparação por coerção, e um `.json` SEM o campo caía em `newerVersion` com
        // `params` vazio — a tela imprimia literalmente "(formato {version})" nos 3 idiomas.
        if (typeof data.version !== 'number' || !isFinite(data.version)
            || data.version !== Math.trunc(data.version) || data.version < 1) {
            return { songs: [], errors: [{ code: 'badVersion' }], fixedIds: 0 };
        }
        if (data.version > SongStore.FORMAT_VERSION) {
            return { songs: [], errors: [{ code: 'newerVersion', params: { version: data.version } }], fixedIds: 0 };
        }
        const songs = [], errors = [];
        let fixedIds = 0;
        (Array.isArray(data.songs) ? data.songs : []).forEach((s, i) => {
            const bytes = s && SongStore.fromBase64(s.midi);
            if (!bytes || !bytes.length) { errors.push({ code: 'badSong', params: { n: i + 1 } }); return; }
            if (maxBytesPerFile && bytes.length > maxBytesPerFile) {
                errors.push({ code: 'songTooBig', params: { name: (s.name || '') } });
                return;
            }
            const buf = SongStore._toBuffer(bytes);
            const id = hashFn(buf);
            if (s.id !== id) fixedIds++;
            songs.push({
                id, name: s.name || '', addedAt: s.addedAt || 0,
                // 🔴 A faixa vem de fora e é usada para CONSTRUIR a partitura: lixo aqui
                // fazia a peça falhar inteira ao abrir da estante. Como o `id`, ela não se
                // aceita crua — só inteiro ≥ 0 sobrevive; o resto vira "sem preferência".
                trackIndex: SongStore._trackIndex(s.trackIndex),
                bytes: buf,
                chords: Array.isArray(s.chords) ? s.chords : [],
                updatedAt: s.updatedAt || 0
            });
        });
        return { songs, errors, fixedIds };
    }

    /**
     * Funde cifras por UNIÃO DE BEAT. PURO.
     *
     * 🔴 IMPORTAR NUNCA APAGA UMA CIFRA. Beat que só existe de um lado entra; beat nos dois
     * lados fica com o do registro mais NOVO. Apagar não se propaga, e essa é a direção
     * segura: o erro possível é ficar com uma cifra a mais — o outro seria perder uma tarde
     * de trabalho manual, que foi exatamente o defeito nº 1 da auditoria de 24/ago.
     *
     * @returns {{chords:Array, added:number, replaced:number}}
     */
    static mergeChords(local, incoming, incomingIsNewer, isValid) {
        // 🔴 `Array.isArray` nas DUAS pontas. `(local || []).forEach` estourava um
        // `TypeError` quando o registro do disco vinha com `chords` que não é array — e
        // `_mergeRepertoire` não tem `catch`: a pessoa escolhia o `.json` e NADA acontecia
        // na tela, para sempre (o dado ruim está gravado). É a mesma fronteira do defeito
        // que derrubava a importação inteira por uma cifra corrompida. A guarda é DESTA
        // função: é ela que recebe dado do disco.
        const arr = (x) => (Array.isArray(x) ? x : []);
        // 🔴 `Math.round(beat*960)`: 960 divisões por semínima cobrem toda a grade do
        // projeto (até a fusa, e o tempo pontuado de 6/8) com 8× de folga, e absorvem o
        // ruído de ponto flutuante de propósito.
        const key = (b) => Math.round(b * 960);
        // 🔴 `typeof b === 'number'` NÃO é redundante: `isFinite(null)`, `isFinite(true)` e
        // `isFinite('')` são `true`, e `null` cai na chave 0 — uma entrada de lixo vinda
        // mais nova despejava a cifra do PRIMEIRO TEMPO da peça.
        const beatOk = (c) => !!c && typeof c.beat === 'number' && isFinite(c.beat) && c.beat >= 0;
        // 🔴 A lei da cifra é do `Score` (`Score.isValidChord`), passada de fora como o
        // `hashFn`: esta classe é pura e não pode ter uma segunda lei — seria a mais
        // frouxa das duas, e é ela que grava no disco.
        const valida = (c) => beatOk(c) && (typeof isValid === 'function' ? isValid(c) : true);

        const out = new Map();
        arr(local).forEach(c => { if (beatOk(c)) out.set(key(c.beat), c); });
        let added = 0, replaced = 0, rejected = 0;
        arr(incoming).forEach(c => {
            // 🔴 Cifra que chega INVÁLIDA nunca desloca a válida que está aqui. Sem isto,
            // ela vencia por ser mais nova, o `setChord` a recusava ao carregar, ela não
            // entrava em `_harmonyOutOfRange` (só as fora-de-faixa entram) e o save
            // seguinte a apagava de vez: a cifra boa da pessoa evaporava, e a tela ainda
            // dizia "1 atualizadas · 0 cifras novas".
            if (!valida(c)) { rejected++; return; }
            const k = key(c.beat);
            if (!out.has(k)) { out.set(k, c); added++; }
            else if (incomingIsNewer) { out.set(k, c); replaced++; }
        });
        return {
            chords: [...out.values()].sort((a, b) => a.beat - b.beat),
            added, replaced, rejected
        };
    }
}

// Singleton: o banco é recurso global (uma conexão por aba), como o audioManager.
window.SongStore = SongStore;
window.songStore = new SongStore();



// ============================================
// core/SongSync.js
// ============================================
/**
 * SongSync — o repertório segue a CONTA (Etapa 9, docs/SINCRONIA-PLANO.md).
 *
 * Irmã do `RankingRepository`: fala com `songs_list` / `song_put` / `song_forget`
 * reusando a ponte HTTP do `UserManager` (CSRF + retry). NÃO faz i18n, NÃO toca DOM.
 *
 * ─── 🔴 A FUSÃO NÃO MORA AQUI ─────────────────────────────────────────────────────
 *
 * Quem funde cifra por beat é `SongStore.mergeChords`, que já existe, é pura e é
 * testada — a mesma que o backup `.json` usa. Esta classe BAIXA, entrega para ela
 * fundir, e SOBE o resultado. O servidor é last-write-wins por carimbo. Se um dia
 * aparecer lógica de fusão aqui dentro, existem duas verdades sobre o que é fundir
 * cifra, e a que grava no disco vai ser a errada.
 *
 * ─── 🔴 MANUAL, NÃO AUTOMÁTICO (decisão de 26/ago) ────────────────────────────────
 *
 * Sincronia automática erra CALADO: ou subiu o que não devia, ou não subiu e a pessoa
 * jura que subiu. Enquanto o serviço é novo, o botão deixa todo efeito visível.
 *
 * ─── 🔴 APAGAR NÃO É SINCRONIZADO ─────────────────────────────────────────────────
 *
 * União automática + apagar propagado = RESSURREIÇÃO: apaga no celular, o notebook
 * mantém pela união e re-sobe, e a música volta para sempre. Apagar no aparelho NUNCA
 * toca na conta; tirar da conta é `forget()`, uma ação própria. Ver §2 do plano.
 */
class SongSync {
    /** Versão da bag de cifras. O servidor exige o campo e não olha o resto. */
    static BAG_VERSION = 1;

    /** Há conta logada? (convidado não sincroniza — a estante local segue inteira.) */
    available() {
        const um = window.userManager;
        return !!(um && um.isLoggedIn());
    }

    /** @returns {{success:true, rows:Array, max:number}|{success:false, code:string}} */
    async list() {
        if (!this.available()) return { success: false, code: 'not_logged' };
        const data = await window.userManager.apiGet('songs_list', {});
        if (data && data.success) {
            return { success: true, rows: Array.isArray(data.rows) ? data.rows : [], max: data.max || 0 };
        }
        return { success: false, code: (data && (data.error_code || data.error_type)) || 'network' };
    }

    /**
     * Sobe UMA música (metadados + cifras). A bag vai versionada e o servidor não a abre.
     * @returns {{success:true, count:number, max:number}|{success:false, code:string}}
     */
    async put({ id, name = '', trackIndex = null, chords = [], updatedAt = 0, midi = null } = {}) {
        if (!this.available()) return { success: false, code: 'not_logged' };
        const fields = {
            song_id: id,
            name: name || '',
            track_index: (trackIndex == null ? '' : trackIndex),
            // 🔴 Os bytes são OPCIONAIS e o campo AUSENTE significa "não tenho para mandar",
            // nunca "apague o que você guardou" — o servidor só faz `has_file` SUBIR. É o
            // caminho comum: o aparelho remanda o .mid uma vez, e as sincronias seguintes
            // levam só a cifra, que é o que muda.
            midi: midi || '',
            // 🔴 Bag SEMPRE presente, mesmo vazia — peça sem cifra tem de existir na conta
            // (senão "sincronizei 3, voltaram 2" e ninguém sabe por quê). Mesma regra do
            // `packRepertoire`, e pelo mesmo motivo.
            chords: JSON.stringify({ v: SongSync.BAG_VERSION, items: Array.isArray(chords) ? chords : [] }),
            updated_at: updatedAt || 0
        };
        const data = await window.userManager.apiPost('song_put', fields, { csrf: true });
        if (data && data.success) return { success: true, count: data.count, max: data.max, stored: !!data.stored };
        return { success: false, code: (data && (data.error_code || data.error_type)) || 'network',
                 max: data && data.max };
    }

    /**
     * BAIXA os bytes de UMA música da conta.
     *
     * 🔴 Vem como base64 dentro do JSON, não como download. Ver `song_file` no handler: o
     * arquivo de terceiro nunca chega a existir como documento no browser — só o app o
     * decodifica, de propósito.
     * @returns {{success:true, bytes:Uint8Array}|{success:false, code:string}}
     */
    async file(id) {
        if (!this.available()) return { success: false, code: 'not_logged' };
        const data = await window.userManager.apiGet('song_file', { song_id: id });
        if (!data || !data.success) {
            return { success: false, code: (data && (data.error_code || data.error_type)) || 'network' };
        }
        const bytes = window.SongStore.fromBase64(data.midi || '');
        // 🔴 base64 quebrado devolve `null` e NÃO pode virar peça vazia: `SongStore.put`
        // aceitaria um arquivo de 0 byte com o id de um .mid legítimo, e a estante passaria
        // a ter uma música que abre pelada — com o id certo, o que impede a boa de voltar.
        if (!bytes || !bytes.length) return { success: false, code: 'bad_file' };
        return { success: true, bytes };
    }

    /** Tira da CONTA (não toca no aparelho). */
    async forget(id) {
        if (!this.available()) return { success: false, code: 'not_logged' };
        const data = await window.userManager.apiPost('song_forget', { song_id: id }, { csrf: true });
        if (data && data.success) return { success: true, removed: data.removed, count: data.count };
        return { success: false, code: (data && (data.error_code || data.error_type)) || 'network' };
    }

    /**
     * Itens de cifra de uma linha do servidor — ou `null` quando esta versão do app NÃO
     * SABE LER a bag.
     *
     * 🔴 `null` e `[]` são coisas DIFERENTES, e confundi-las apaga trabalho. A bag é opaca
     * de propósito, então um app velho PODE receber `v:2` de um app novo. A primeira versão
     * disto devolvia `[]` "para a peça só não ganhar cifra" — mas o chamador não ficava
     * quieto: ele adotava o carimbo remoto, mantinha as cifras velhas dele e as re-subia
     * com aquele carimbo. O servidor é last-write-wins e aceitava. Resultado medido pela
     * auditoria: 40 cifras feitas no celular substituídas por 6 do notebook desatualizado.
     * `null` obriga o chamador a NÃO ENCOSTAR naquela linha — nem fundir, nem carimbar,
     * nem subir.
     */
    static itemsOf(row) {
        const c = row && row.chords;
        if (!c || typeof c !== 'object') return [];      // linha sem cifra: legítimo, vazio
        if (c.v !== SongSync.BAG_VERSION) return null;   // não sei ler: não encosto
        return Array.isArray(c.items) ? c.items : [];
    }
}

// 🔴 A CLASSE também vai para `window`, não só a instância. `class` no topo de um script
// clássico é binding léxico global, NÃO propriedade de `window` — sem esta linha,
// `window.SongSync.itemsOf(...)` é `TypeError` em toda sincronia que traga alguma linha do
// servidor, e o `catch` do chamador transforma isso em "não deu para falar com a sua
// conta", com o servidor tendo respondido 200. Todas as irmãs (`Score`, `SongStore`,
// `SongShelf`) fazem as duas linhas; esta ficou só com a instância e passou no gate porque
// o teste devolvia `rows: []`.
window.SongSync = SongSync;
window.songSync = new SongSync();



// ============================================
// managers/TimerManager.js
// ============================================
/**
 * TimerManager - Gerenciador de timers
 * Centraliza controle de setTimeout/setInterval com tracking
 */
class TimerManager {
    constructor() {
        if (TimerManager.instance) {
            return TimerManager.instance;
        }

        this.timeouts = new Map();
        this.intervals = new Map();
        this.idCounter = 0;

        TimerManager.instance = this;
    }

    /**
     * Cria um timeout rastreado
     * @param {Function} callback - Função a executar
     * @param {number} delay - Delay em ms
     * @param {string} description - Descrição para debug
     * @returns {number} - ID do timeout
     */
    setTimeout(callback, delay, description = '') {
        const id = ++this.idCounter;
        const timeoutId = window.setTimeout(() => {
            this.timeouts.delete(id);
            callback();
        }, delay);

        this.timeouts.set(id, {
            timeoutId,
            description,
            createdAt: Date.now(),
            delay
        });

        return id;
    }

    /**
     * Cancela um timeout
     * @param {number} id - ID retornado por setTimeout
     */
    clearTimeout(id) {
        const timer = this.timeouts.get(id);
        if (timer) {
            window.clearTimeout(timer.timeoutId);
            this.timeouts.delete(id);
        }
    }

    /**
     * Cria um interval rastreado
     * @param {Function} callback - Função a executar
     * @param {number} interval - Intervalo em ms
     * @param {string} description - Descrição para debug
     * @returns {number} - ID do interval
     */
    setInterval(callback, interval, description = '') {
        const id = ++this.idCounter;
        const intervalId = window.setInterval(callback, interval);

        this.intervals.set(id, {
            intervalId,
            description,
            createdAt: Date.now(),
            interval
        });

        return id;
    }

    /**
     * Cancela um interval
     * @param {number} id - ID retornado por setInterval
     */
    clearInterval(id) {
        const timer = this.intervals.get(id);
        if (timer) {
            window.clearInterval(timer.intervalId);
            this.intervals.delete(id);
        }
    }

    /**
     * Cancela todos os timers
     */
    clearAll() {
        // Cancela timeouts
        for (const [id, timer] of this.timeouts) {
            window.clearTimeout(timer.timeoutId);
        }
        this.timeouts.clear();

        // Cancela intervals
        for (const [id, timer] of this.intervals) {
            window.clearInterval(timer.intervalId);
        }
        this.intervals.clear();
    }

    /**
     * Retorna informações sobre timers ativos
     * @returns {Object}
     */
    getStatus() {
        return {
            timeouts: this.timeouts.size,
            intervals: this.intervals.size,
            details: {
                timeouts: Array.from(this.timeouts.entries()).map(([id, t]) => ({
                    id,
                    description: t.description,
                    age: Date.now() - t.createdAt
                })),
                intervals: Array.from(this.intervals.entries()).map(([id, t]) => ({
                    id,
                    description: t.description,
                    age: Date.now() - t.createdAt
                }))
            }
        };
    }

    /**
     * Cria uma Promise que resolve após delay
     * @param {number} ms - Tempo em milissegundos
     * @returns {Promise}
     */
    sleep(ms) {
        return new Promise(resolve => this.setTimeout(resolve, ms, 'sleep'));
    }

    /**
     * Executa callback com precisão usando requestAnimationFrame
     * @param {Function} callback - Função a executar
     * @param {number} targetTime - Timestamp alvo (performance.now())
     * @returns {number} - ID do frame request
     */
    scheduleAtTime(callback, targetTime) {
        const check = () => {
            if (performance.now() >= targetTime) {
                callback();
            } else {
                requestAnimationFrame(check);
            }
        };
        return requestAnimationFrame(check);
    }
}

// Singleton global
window.timerManager = new TimerManager();



// ============================================
// managers/AudioManager.js
// ============================================
/**
 * AudioManager - Gerenciador de áudio usando Web Audio API
 * Reproduz sons para o jogo de ritmo
 */
class AudioManager {
    constructor() {
        if (AudioManager.instance) {
            return AudioManager.instance;
        }

        this.volume = 0.7;
        this.initialized = false;
        this.sounds = new Map();

        // Até quando (relógio do contexto) o app estará emitindo som. O MicPitchInput
        // consulta isOutputBusy() por frame pra não "ouvir" o próprio alto-falante
        // (feedback de acerto/erro viraria detecção fantasma). Atualizado por
        // playSynth/playBuffer/playNote via _markOutputBusy().
        this.outputBusyUntil = 0;

        // Piano realista: banco cromático C3–C6 (um sample por nota, sem esticar).
        // Preferência GLOBAL persistida; quando OFF (default) cai no B4 esticado de
        // sempre. 'bankState' evita carregamentos concorrentes.
        this.pianoRealistic = false;
        try { this.pianoRealistic = localStorage.getItem('audio_piano_realistic') === '1'; } catch (e) {}
        this.bankState = 'idle'; // 'idle' | 'loading' | 'ready'
        this._bankPromise = null; // load em andamento, compartilhado por chamadas concorrentes

        // Cria AudioContext imediatamente (como projeto principal)
        // Pode ficar suspenso até user gesture, mas não dá erro
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        try {
            this.context = new AudioContext();
            this.gainNode = this.context.createGain();
            this.gainNode.gain.value = this.volume;
            this.gainNode.connect(this.context.destination);
        } catch (e) {
            console.error('AudioManager: Web Audio API não suportada:', e.message);
            this.context = null;
            AudioManager.instance = this;
            return;
        }

        // Carrega sons síncronos (synth) imediatamente
        this.loadDefaultSounds();
        this.initialized = true;

        // 🔴 Auto-resume defensivo (sintoma "app morto"): o AudioContext nasce
        // 'suspended' (sem gesto) e o iOS pode deixá-lo 'interrupted' ao relançar a
        // PWA do home screen / voltar do background. Como o relógio do jogo é
        // context.currentTime, um contexto parado CONGELA os loops de rAF → o app
        // não responde até dar reload (que recria o contexto). Estes listeners
        // persistentes religam o contexto em QUALQUER gesto e ao voltar ao
        // foreground, recuperando sem reload. São idempotentes (resume em contexto
        // já 'running' é no-op).
        this._armAutoResume();

        // Escolha persistida = ON → carrega o banco em background (o Service Worker
        // cacheia os mp3, então na volta isso é instantâneo/offline). Sem UI de
        // progresso aqui: até terminar, playNote usa o fallback B4 esticado.
        if (this.pianoRealistic) this.loadPianoBank().catch(() => {});

        AudioManager.instance = this;
    }

    /**
     * Notas do banco de piano realista (C3..C6), nomes com BEMOL como os arquivos.
     * @returns {string[]}
     */
    static pianoBankNotes() {
        const names = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];
        const out = [];
        for (let o = 3; o <= 5; o++) for (const n of names) out.push(n + o);
        out.push('C6');
        return out;
    }

    /**
     * Normaliza nota científica para a grafia do banco (BEMOL). sciFromMidi emite
     * sustenido (C#4); os arquivos são bemol (Db4). Natural/bemol passam direto.
     * @param {string} note ex.: 'C#4', 'Db4', 'G4'
     * @returns {string}
     */
    _normalizeNote(note) {
        if (typeof note !== 'string') return note;
        const m = note.match(/^([A-G])(#|b)?(-?\d)$/);
        if (!m) return note;
        const [, letter, acc, oct] = m;
        if (acc === '#') {
            const map = { 'C#': 'Db', 'D#': 'Eb', 'F#': 'Gb', 'G#': 'Ab', 'A#': 'Bb' };
            return (map[letter + '#'] || (letter + '#')) + oct;
        }
        return note;
    }

    /** Liga/desliga o piano realista e persiste a escolha (global). */
    setPianoRealistic(on) {
        this.pianoRealistic = !!on;
        try { localStorage.setItem('audio_piano_realistic', on ? '1' : '0'); } catch (e) {}
    }

    isPianoRealistic() { return this.pianoRealistic; }
    isPianoBankReady() { return this.bankState === 'ready'; }

    /**
     * Carrega o banco cromático de piano (C3–C6) sob demanda. Espelha o
     * loadInstrumentBuffers do projeto principal: fetch + retry com backoff +
     * progresso. Idempotente: se já 'ready' resolve na hora; se 'loading' ignora.
     * @param {function} [progressCb] ({loaded,total,progress}) a cada nota
     * @returns {Promise<boolean>} true quando o banco está utilizável
     */
    async loadPianoBank(progressCb = null) {
        if (!this.context) return false;
        const notes = AudioManager.pianoBankNotes();
        const total = notes.length;
        if (this.bankState === 'ready') {
            if (progressCb) progressCb({ loaded: total, total, progress: 100 });
            return true;
        }
        // Carregamento em andamento → junta-se a ele (resultado compartilhado), pra
        // quem chama concorrente não declarar "pronto" antes da hora.
        if (this.bankState === 'loading' && this._bankPromise) return this._bankPromise;
        this.bankState = 'loading';

        let loaded = 0;
        if (progressCb) progressCb({ loaded: 0, total, progress: 0 });

        const loadOne = async (note) => {
            const key = 'piano-' + note;
            if (!this.sounds.has(key)) {
                let attempts = 0;
                while (attempts < 3) {
                    try {
                        attempts++;
                        const res = await fetch('/audio/piano/' + note + '.mp3');
                        if (!res.ok) throw new Error('HTTP ' + res.status);
                        const buf = await this.context.decodeAudioData(await res.arrayBuffer());
                        this.sounds.set(key, { type: 'buffer', buffer: buf });
                        break;
                    } catch (err) {
                        if (attempts >= 3) {
                            console.warn(`AudioManager: falha ao carregar piano ${note}:`, err.message);
                            break;
                        }
                        await new Promise(r => setTimeout(r, 400 * attempts));
                    }
                }
            }
            loaded++;
            if (progressCb) progressCb({ loaded, total, progress: Math.round((loaded / total) * 100) });
        };

        this._bankPromise = Promise.all(notes.map(loadOne)).then(() => {
            this.bankState = 'ready';
            return true;
        });
        return this._bankPromise;
    }

    /**
     * Religa o AudioContext em interações do usuário e ao voltar ao foreground.
     * Não usa { once } de propósito: o iOS pode interromper o contexto várias
     * vezes na vida da página (ligações, troca de app, lock) — queremos recuperar
     * de cada uma.
     */
    _armAutoResume() {
        const resume = () => this.resumeContext();
        ['pointerdown', 'touchend', 'keydown'].forEach(evt =>
            document.addEventListener(evt, resume, { passive: true })
        );
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) this.resumeContext();
        });
    }

    /**
     * O app está (ou ainda vai estar) emitindo som?
     * O microfone ouve o alto-falante: sem este gate, o feedback sonoro do próprio
     * jogo viraria "nota detectada". Margem de 250ms após o fim programado cobre
     * release do envelope + reverberação do ambiente.
     * @returns {boolean}
     */
    isOutputBusy() {
        return this.context ? this.context.currentTime < this.outputBusyUntil : false;
    }

    /** Registra que haverá som até endTime (relógio do contexto) + margem. */
    _markOutputBusy(endTime) {
        this.outputBusyUntil = Math.max(this.outputBusyUntil, endTime + 0.25);
    }

    /**
     * Relógio mestre do jogo: tempo atual do AudioContext (segundos)
     * TUDO (metrônomo, demo, lead-in, grade de avaliação, inputs) deve
     * derivar deste relógio. performance.now()/setTimeout NÃO são confiáveis
     * para ritmo (derivam e tremem). Ver "A Tale of Two Clocks" (Chris Wilson).
     * @returns {number} currentTime em segundos
     */
    now() {
        return this.context ? this.context.currentTime : 0;
    }

    /**
     * Latência de saída do dispositivo (segundos).
     * O usuário ouve o som ~outputLatency DEPOIS do tempo agendado.
     * Usado para compensar a comparação input vs grade.
     * @returns {number}
     */
    getOutputLatency() {
        if (!this.context) return 0;
        // outputLatency é o valor real (Chrome/FF); baseLatency é o mínimo do device
        const out = this.context.outputLatency;
        if (typeof out === 'number' && out > 0) return out;
        return this.context.baseLatency || 0;
    }

    /**
     * Resume o AudioContext se estiver suspenso
     * Deve ser chamado após interação do usuário
     */
    resumeContext() {
        // 'interrupted' é estado do Safari/iOS (áudio interrompido pelo SO);
        // tratá-lo junto de 'suspended' é o que recupera a PWA relançada/voltando
        // do background sem precisar de reload. Retorna a Promise p/ quem quiser
        // aguardar o contexto religar antes de agendar áudio.
        if (this.context && this.context.state !== 'running' && this.context.state !== 'closed') {
            return this.context.resume().catch(e => {
                console.error('AudioManager: Falha ao resumir AudioContext:', e.message);
            });
        }
        return Promise.resolve();
    }

    /**
     * Carrega sons padrão (síncrono para synth, assíncrono para MP3)
     */
    loadDefaultSounds() {
        // Cria sons sintetizados (não requer arquivos externos) - SÍNCRONO
        this.createSynthSound('tick', 800, 0.05, 'sine');      // Som agudo curto
        this.createSynthSound('tock', 400, 0.08, 'sine');      // Som grave curto
        this.createSynthSound('accent', 1000, 0.1, 'triangle'); // Acentuado
        this.createSynthSound('tap', 600, 0.03, 'square');     // Feedback de toque
        this.createSynthSound('correct', 880, 0.15, 'sine');   // Acerto
        this.createSynthSound('wrong', 220, 0.2, 'sawtooth'); // Erro

        // Carrega sample de piano B4 em background (assíncrono)
        this.loadSound('piano-B4', '/audio/piano/B4.mp3').catch(err => {
            console.warn('AudioManager: Erro ao carregar piano B4:', err);
        });
    }

    /**
     * Cria um som sintetizado
     * @param {string} name - Nome do som
     * @param {number} frequency - Frequência em Hz
     * @param {number} duration - Duração em segundos
     * @param {string} type - Tipo de onda (sine, square, triangle, sawtooth)
     */
    createSynthSound(name, frequency, duration, type = 'sine') {
        this.sounds.set(name, {
            type: 'synth',
            frequency,
            duration,
            waveType: type
        });
    }

    /**
     * Carrega um arquivo de áudio
     * @param {string} name - Nome para referência
     * @param {string} url - URL do arquivo
     */
    async loadSound(name, url) {
        if (!this.context) {
            console.warn('AudioManager: Contexto não inicializado');
            return;
        }

        try {
            const response = await fetch(url);
            const arrayBuffer = await response.arrayBuffer();
            const audioBuffer = await this.context.decodeAudioData(arrayBuffer);

            this.sounds.set(name, {
                type: 'buffer',
                buffer: audioBuffer
            });
        } catch (error) {
            console.error(`AudioManager: Erro ao carregar '${name}':`, error);
        }
    }

    /**
     * Reproduz um som
     * @param {string} name - Nome do som
     * @param {Object} options - Opções de reprodução
     * @returns {Object} - Objeto com método stop()
     */
    play(name, options = {}) {
        if (!this.initialized || !this.context) {
            console.warn('AudioManager: Não inicializado');
            return { stop: () => {} };
        }

        const sound = this.sounds.get(name);
        if (!sound) {
            console.warn(`AudioManager: Som '${name}' não encontrado`);
            return { stop: () => {} };
        }

        // Resume context automaticamente (crítico para user gesture)
        this.resumeContext();
        window.Beacon?.gameStart();  // funil: 1º áudio real da rota de jogo (dedup interno)

        if (sound.type === 'synth') {
            return this.playSynth(sound, options);
        } else if (sound.type === 'buffer') {
            return this.playBuffer(sound, options);
        }

        return { stop: () => {} };
    }

    /**
     * Reproduz som sintetizado
     * @param {Object} sound - Configuração do som
     * @param {Object} options - Opções
     * @returns {Object}
     */
    playSynth(sound, options = {}) {
        const oscillator = this.context.createOscillator();
        const gainNode = this.context.createGain();

        oscillator.type = sound.waveType;
        oscillator.frequency.value = options.frequency || sound.frequency;

        const duration = options.duration || sound.duration;
        const volume = options.volume !== undefined ? options.volume : 1;

        // Envelope ADSR simplificado.
        // options.when permite AGENDAR o som no futuro (relógio de áudio),
        // essencial para metrônomo/demo sem jitter. Default = agora.
        const now = (options.when !== undefined && options.when > this.context.currentTime)
            ? options.when
            : this.context.currentTime;
        gainNode.gain.setValueAtTime(0, now);
        gainNode.gain.linearRampToValueAtTime(volume * this.volume, now + 0.01); // Attack
        gainNode.gain.linearRampToValueAtTime(volume * this.volume * 0.7, now + 0.02); // Decay
        gainNode.gain.linearRampToValueAtTime(0, now + duration); // Release

        oscillator.connect(gainNode);
        gainNode.connect(this.gainNode);

        oscillator.start(now);
        oscillator.stop(now + duration + 0.1);
        this._markOutputBusy(now + duration + 0.1);

        return {
            stop: () => {
                try {
                    oscillator.stop();
                } catch (e) {
                    // Já parou
                }
            }
        };
    }

    /**
     * Reproduz buffer de áudio
     * @param {Object} sound - Configuração do som
     * @param {Object} options - Opções
     * @returns {Object}
     */
    playBuffer(sound, options = {}) {
        const source = this.context.createBufferSource();
        const gainNode = this.context.createGain();

        source.buffer = sound.buffer;

        const volume = options.volume !== undefined ? options.volume : 1;
        gainNode.gain.value = volume * this.volume;

        source.connect(gainNode);
        gainNode.connect(this.gainNode);

        source.start(0);
        this._markOutputBusy(this.context.currentTime + sound.buffer.duration);

        return {
            stop: () => {
                try {
                    source.stop();
                } catch (e) {
                    // Já parou
                }
            }
        };
    }

    /**
     * Reproduz sequência de sons (para padrões rítmicos)
     * @param {Array} pattern - Array de {time: ms, sound: string, options: {}}
     * @param {number} bpm - Batidas por minuto
     * @returns {Object} - Objeto com método stop()
     */
    playPattern(pattern, bpm = 120) {
        if (!this.initialized) {
            console.warn('AudioManager: Não inicializado');
            return { stop: () => {} };
        }

        const beatDuration = 60000 / bpm; // ms por batida
        const timeouts = [];
        const startTime = performance.now();

        pattern.forEach(({ beat, sound, options = {} }) => {
            const delay = beat * beatDuration;
            const timeoutId = window.setTimeout(() => {
                this.play(sound, options);
            }, delay);
            timeouts.push(timeoutId);
        });

        return {
            stop: () => {
                timeouts.forEach(id => window.clearTimeout(id));
            },
            getDuration: () => {
                const lastBeat = Math.max(...pattern.map(p => p.beat));
                return (lastBeat + 1) * beatDuration;
            }
        };
    }

    /**
     * Define o volume geral
     * @param {number} value - Volume de 0 a 1
     */
    setVolume(value) {
        this.volume = Math.max(0, Math.min(1, value));
        if (this.gainNode) {
            this.gainNode.gain.value = this.volume;
        }
    }

    /**
     * Obtém o volume atual
     * @returns {number}
     */
    getVolume() {
        return this.volume;
    }

    /**
     * Verifica se está inicializado e pronto para uso
     * @returns {boolean}
     */
    isReady() {
        return this.initialized && this.context !== null;
    }

    /**
     * Converte nota musical para frequência
     * @param {string} note - Nota no formato "C4", "Db4", "B4", etc.
     * @returns {number} - Frequência em Hz
     */
    getFrequency(note) {
        const noteNames = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];
        const match = note.match(/^([A-G]b?)(-?\d)$/);
        if (!match) return 440; // Fallback A4

        const [_, noteName, octave] = match;
        const semitoneOffset = noteNames.indexOf(noteName) - noteNames.indexOf('A');
        const octaveOffset = (parseInt(octave) - 4) * 12;
        const totalSemitones = semitoneOffset + octaveOffset;

        return 440 * Math.pow(2, totalSemitones / 12);
    }

    /**
     * Reproduz uma nota musical com duração específica
     * Usa sample de piano B4 (arquivo MP3 carregado)
     * @param {string} note - Nota no formato "C4", "B4", etc.
     * @param {number} duration - Duração em segundos
     * @param {Object} options - Opções adicionais
     * @returns {Object} - Objeto com método stop()
     */
    playNote(note, duration, options = {}) {
        if (!this.initialized || !this.context) {
            console.warn('AudioManager: Não inicializado');
            return { stop: () => {} };
        }

        // Resume context automaticamente (crítico para user gesture)
        this.resumeContext();
        window.Beacon?.gameStart();  // funil: 1º áudio real da rota de jogo (dedup interno)

        // Nota desejada (científica): options.note tem prioridade; senão o 1º arg.
        const targetNote = options.note || note;
        const norm = targetNote ? this._normalizeNote(targetNote) : null;

        // 1) Piano realista LIGADO e sample da nota já carregado → toca o sample
        //    REAL daquela nota (sem esticar): timbre consistente, ideal p/ ouvido.
        let buffer = null;
        let rate = 1;
        if (this.pianoRealistic && norm) {
            const real = this.sounds.get('piano-' + norm);
            if (real && real.type === 'buffer') buffer = real.buffer;
        }

        // 2) Fallback (OFF, banco ainda carregando, ou nota fora do range): B4
        //    esticado — comportamento histórico, intacto.
        if (!buffer) {
            const b4 = this.sounds.get('piano-B4');
            if (!b4 || b4.type !== 'buffer') {
                console.warn(`AudioManager: Sample 'piano-B4' não carregado`);
                return { stop: () => {} };
            }
            buffer = b4.buffer;
            if (options.playbackRate) {
                rate = options.playbackRate;
            } else if (norm) {
                rate = this.getFrequency(norm) / this.getFrequency('B4');
            }
        }

        const source = this.context.createBufferSource();
        const gainNode = this.context.createGain();

        source.buffer = buffer;
        if (rate !== 1) source.playbackRate.value = rate;

        const volume = (options.volume !== undefined ? options.volume : 1) * this.volume;
        // options.when permite AGENDAR a nota no futuro (relógio de áudio). Default = agora.
        const now = (options.when !== undefined && options.when > this.context.currentTime)
            ? options.when
            : this.context.currentTime;

        // Envelope de volume para controlar duração
        const sustainEnd = Math.max(now + 0.02, now + duration - 0.1);
        gainNode.gain.setValueAtTime(0, now);
        gainNode.gain.linearRampToValueAtTime(volume, now + 0.01); // Attack rápido
        gainNode.gain.setValueAtTime(volume, sustainEnd); // Sustain
        gainNode.gain.linearRampToValueAtTime(0, now + duration); // Release

        source.connect(gainNode);
        gainNode.connect(this.gainNode);

        source.start(now);
        source.stop(now + duration + 0.1);
        this._markOutputBusy(now + duration + 0.1);

        return {
            stop: () => {
                try {
                    source.stop();
                } catch (e) {
                    // Já parou
                }
            }
        };
    }
}

// Singleton global
window.audioManager = new AudioManager();



// ============================================
// managers/MetronomeManager.js
// ============================================
/**
 * MetronomeManager - Metrônomo com LOOKAHEAD SCHEDULER (relógio de áudio)
 *
 * Substitui o antigo setInterval-que-toca-na-hora (derivava e tremia).
 * Padrão "A Tale of Two Clocks" (Chris Wilson):
 *   - Um timer JS de baixa frequência (lookahead) só AGENDA eventos de áudio
 *     ~100ms à frente, em tempos exatos do AudioContext.currentTime.
 *   - O áudio dispara com precisão de sample, imune ao jitter do JS.
 *
 * Tudo no jogo (demo, lead-in, grade de avaliação, inputs) ancora no MESMO
 * relógio: transportStartTime (segundos) + beatDuration. Use beatTime(i)
 * para saber o tempo absoluto de qualquer beat global.
 */
class MetronomeManager {
    constructor() {
        this.isPlaying = false;
        this.bpm = 120;
        this.beatsPerMeasure = 4;

        // Relógio mestre (segundos, base AudioContext)
        this.transportStartTime = 0;
        this.beatDuration = 0.5;       // segundos por beat
        this.totalBeats = Infinity;    // quantos beats agendar (Infinity = contínuo)

        // Scheduler
        this.nextBeatIndex = 0;        // próximo beat (global, 0-based) a agendar
        this.lookaheadId = null;       // setInterval do scheduler
        this.LOOKAHEAD_MS = 25;        // frequência do scheduler
        this.SCHEDULE_AHEAD = 0.12;    // janela de agendamento à frente (s)
        // Handles dos ticks JÁ agendados no grafo de áudio (start no futuro).
        // stop() os mata — senão, ao parar, os ticks da janela de lookahead seguem soando.
        this.scheduledSources = [];

        // Callback opcional por beat (disparado no AGENDAMENTO, não no áudio).
        // Para visuais sincronizados ao áudio use beatTime()+requestAnimationFrame.
        this.onBeatCallback = null;

        // Padrão de clique (personalizado do Ritmo). Vale só a partir de `leadInBeats`:
        // a contagem de entrada é SEMPRE inteira, senão a pessoa não sabe quando começa.
        this.click = 'all';
        this.leadInBeats = 0;
    }

    /**
     * Este tempo SOA? Pura (testável sem áudio).
     *   'all' todos · 'one' só o 1 · '24' só 2 e 4 (existe só em 4/4; noutra fórmula
     *   vira 'one') · 'none' nenhum. Antes de `leadInBeats`, sempre soa (contagem).
     * @param {string} click
     * @param {number} beatInMeasure - 1-based
     * @param {number} beatsPerMeasure
     * @param {number} globalBeat
     * @param {number} leadInBeats
     */
    static clickAudible(click, beatInMeasure, beatsPerMeasure, globalBeat = 0, leadInBeats = 0) {
        if (globalBeat < leadInBeats) return true;
        switch (click) {
            case 'none': return false;
            case 'one': return beatInMeasure === 1;
            case '24': return beatsPerMeasure === 4 ? (beatInMeasure === 2 || beatInMeasure === 4)
                                                    : beatInMeasure === 1;
            default: return true;
        }
    }

    /**
     * Inicia o metrônomo a partir de um tempo de áudio absoluto.
     * @param {number} bpm
     * @param {number} beatsPerMeasure
     * @param {number} startTime - tempo de áudio (s) do beat 0. Default: agora + 0.1
     * @param {number} totalBeats - quantos beats tocar (Infinity = contínuo)
     * @param {{click?: string, leadInBeats?: number}} opts - padrão de clique depois da
     *        contagem (default: todos os tempos, como sempre foi)
     */
    start(bpm = 120, beatsPerMeasure = 4, startTime = null, totalBeats = Infinity, opts = {}) {
        this.stop();

        this.bpm = bpm;
        this.beatsPerMeasure = beatsPerMeasure;
        this.click = opts.click || 'all';
        this.leadInBeats = Number.isFinite(opts.leadInBeats) ? opts.leadInBeats : 0;
        this.beatDuration = 60 / bpm;
        this.totalBeats = totalBeats;

        const ctxNow = window.audioManager.now();
        this.transportStartTime = (startTime !== null && startTime > ctxNow)
            ? startTime
            : ctxNow + 0.1;

        this.nextBeatIndex = 0;
        this.isPlaying = true;

        // Dispara o scheduler imediatamente e em loop
        this.scheduler();
        this.lookaheadId = window.setInterval(() => this.scheduler(), this.LOOKAHEAD_MS);
    }

    /**
     * Tempo de áudio absoluto (s) de um beat global (0-based).
     * @param {number} globalBeat
     * @returns {number}
     */
    beatTime(globalBeat) {
        return this.transportStartTime + globalBeat * this.beatDuration;
    }

    /**
     * Loop do scheduler: agenda todos os beats dentro da janela de lookahead.
     */
    scheduler() {
        if (!this.isPlaying) return;
        const ctxNow = window.audioManager.now();

        while (
            this.nextBeatIndex < this.totalBeats &&
            this.beatTime(this.nextBeatIndex) < ctxNow + this.SCHEDULE_AHEAD
        ) {
            this.scheduleBeat(this.nextBeatIndex, this.beatTime(this.nextBeatIndex));
            this.nextBeatIndex++;
        }

        // Acabaram os beats finitos → para o scheduler (o áudio já está agendado)
        if (this.nextBeatIndex >= this.totalBeats) {
            this.stopScheduler();
        }
    }

    /**
     * Agenda o clique de um beat no tempo exato do áudio.
     * @param {number} globalBeat
     * @param {number} when - tempo de áudio (s)
     */
    scheduleBeat(globalBeat, when) {
        const beatInMeasure = (globalBeat % this.beatsPerMeasure) + 1; // 1-based
        const isAccent = beatInMeasure === 1;

        // Clique mudo NÃO agenda som (nada a matar no stop), mas o callback segue: a contagem
        // na bola e quem mais escutar o pulso dependem dele.
        if (MetronomeManager.clickAudible(this.click, beatInMeasure, this.beatsPerMeasure, globalBeat, this.leadInBeats)) {
            const handle = window.audioManager.play(isAccent ? 'accent' : 'tick', {
                volume: isAccent ? 1.0 : 0.55,
                when
            });
            this.scheduledSources.push(handle);
        }

        if (this.onBeatCallback) {
            this.onBeatCallback(beatInMeasure, globalBeat, when);
        }
    }

    /**
     * Define callback por beat (no agendamento). Para visual preciso prefira
     * ler beatTime() num requestAnimationFrame.
     * @param {Function|null} callback - (beatInMeasure, globalBeat, when) => void
     */
    setOnBeat(callback) {
        this.onBeatCallback = callback;
    }

    /**
     * Para apenas o loop do scheduler (áudio já agendado continua tocando).
     */
    stopScheduler() {
        if (this.lookaheadId) {
            window.clearInterval(this.lookaheadId);
            this.lookaheadId = null;
        }
    }

    /**
     * Para o metrônomo por completo.
     */
    stop() {
        this.stopScheduler();
        // Mata os ticks já agendados no grafo (não tocados ainda) — senão seguem soando
        // após o stop (vazamento de áudio ao apertar "Parar").
        this.scheduledSources.forEach(s => { try { s.stop(); } catch (e) { /* já tocou */ } });
        this.scheduledSources = [];
        this.isPlaying = false;
        this.nextBeatIndex = 0;
        this.onBeatCallback = null;
        this.click = 'all';
        this.leadInBeats = 0;
    }

    /**
     * @returns {boolean}
     */
    playing() {
        return this.isPlaying;
    }
}

// Singleton global
window.MetronomeManager = MetronomeManager;
window.metronomeManager = new MetronomeManager();



// ============================================
// managers/MidiInputManager.js
// ============================================
/**
 * MidiInputManager - acesso ÚNICO à Web MIDI API, compartilhado por todos os jogos.
 *
 * Só o RECURSO (permissão + lista de dispositivos + roteamento de mensagens) mora
 * aqui; quem traduz isso em "nota respondida" é o MidiPitchInput, do mesmo jeito
 * que o MicPitchInput faz com o microfone. Um jogo NUNCA chama requestMIDIAccess
 * direto — pediria a permissão de novo a cada troca de tela.
 *
 * 🔴 O construtor é INERTE: `requestMIDIAccess` só roda em `start()`, que tem de
 * partir de um gesto do usuário (clique em "conectar"), nunca do load da página —
 * o Chrome exibe prompt de permissão.
 *
 * Assinantes recebem eventos normalizados:
 *   { type: 'noteon'|'noteoff', midi, velocity (0..1), channel }
 * Só Note On/Off passam; CC, pitch bend, clock e sysex são ignorados nesta fase.
 *
 * Hot-plug: `onstatechange` reata os listeners e avisa os assinantes de devices —
 * plugar o teclado com o jogo aberto funciona sem recarregar.
 */
class MidiInputManager {
    /** Web MIDI disponível? (Chrome/Edge/Firefox/Safari recentes; ausente no iOS) */
    static isSupported() {
        return !!(typeof navigator !== 'undefined' && navigator.requestMIDIAccess);
    }

    constructor() {
        this.state = 'idle'; // idle|requesting|ready|denied|unsupported|error
        this.access = null;
        this.devices = [];        // MIDIInput[] conectados
        this._subs = new Set();   // (evento) => void
        this._deviceSubs = new Set(); // (devices) => void
        this._starting = null;    // promise em voo (chamadas simultâneas não duplicam o prompt)
        this._onMessage = this._handleMessage.bind(this);
        this._onStateChange = this._handleStateChange.bind(this);
    }

    /**
     * Pede a permissão e liga os listeners. Idempotente: chamadas seguintes
     * devolvem o mesmo resultado sem novo prompt.
     * @returns {Promise<boolean>} true se o acesso está pronto
     */
    start() {
        if (this.state === 'ready') return Promise.resolve(true);
        if (this._starting) return this._starting;
        if (!MidiInputManager.isSupported()) {
            this.state = 'unsupported';
            return Promise.resolve(false);
        }

        this.state = 'requesting';
        this._starting = navigator.requestMIDIAccess({ sysex: false }).then((access) => {
            this.access = access;
            access.onstatechange = this._onStateChange;
            this._refreshDevices();
            this.state = 'ready';
            this._starting = null;
            return true;
        }).catch((err) => {
            const denied = err && (err.name === 'SecurityError' || err.name === 'NotAllowedError');
            this.state = denied ? 'denied' : 'error';
            this._starting = null;
            return false;
        });
        return this._starting;
    }

    /** Há pelo menos um teclado/controlador plugado? */
    hasDevice() { return this.devices.length > 0; }

    /** Nome do 1º dispositivo (para a UI); null se não há nenhum. */
    getDeviceName() { return this.devices.length ? (this.devices[0].name || 'MIDI') : null; }

    /** Assina eventos de nota. Devolve a função de cancelamento. */
    subscribe(fn) {
        this._subs.add(fn);
        return () => this._subs.delete(fn);
    }

    /** Assina conexão/desconexão de dispositivos. Devolve a função de cancelamento. */
    onDevicesChanged(fn) {
        this._deviceSubs.add(fn);
        return () => this._deviceSubs.delete(fn);
    }

    // ---------- interno ----------

    /** Relista as entradas e (re)liga o handler em cada uma — cobre hot-plug. */
    _refreshDevices() {
        if (!this.access) return;
        this.devices = Array.from(this.access.inputs.values());
        this.devices.forEach((input) => { input.onmidimessage = this._onMessage; });
    }

    _handleStateChange() {
        const before = this.devices.length;
        this._refreshDevices();
        if (this.devices.length !== before || !before) {
            this._deviceSubs.forEach((fn) => { try { fn(this.devices); } catch (e) {} });
        }
    }

    /**
     * Traduz a mensagem crua em evento normalizado. Note On com velocity 0 é o
     * Note Off que a maioria dos teclados manda (running status) — cai no mesmo ramo.
     */
    _handleMessage(msg) {
        const d = msg.data;
        if (!d || d.length < 3) return;
        const cmd = d[0] & 0xf0;
        if (cmd !== 0x90 && cmd !== 0x80) return; // ignora CC, pitch bend, clock…
        const midi = d[1];
        const velocity = d[2];
        const type = (cmd === 0x90 && velocity > 0) ? 'noteon' : 'noteoff';
        const ev = { type, midi, velocity: velocity / 127, channel: d[0] & 0x0f };
        this._subs.forEach((fn) => { try { fn(ev); } catch (e) {} });
    }
}

// Singleton global (inerte até start(): nenhum prompt de permissão no load)
window.MidiInputManager = MidiInputManager;
window.midiInputManager = new MidiInputManager();



// ============================================
// music/MusicStaff.js
// ============================================
/**
 * MusicStaff - Pentagrama Base
 *
 * Responsabilidade ÚNICA:
 * - Criar SVG container
 * - Desenhar 5 linhas horizontais
 * - Calcular coordenadas Y para qualquer posição
 *
 * Posições (de baixo para cima):
 *   -2 = Dó abaixo do pentagrama (linha suplementar inferior)
 *   -1 = Ré
 *    0 = Mi (linha 1 - primeira linha do pentagrama)
 *    1 = Fá
 *    2 = Sol (linha 2)
 *    3 = Lá
 *    4 = Si (linha 3 - meio do pentagrama)
 *    5 = Dó
 *    6 = Ré (linha 4)
 *    7 = Mi
 *    8 = Fá (linha 5 - última linha do pentagrama)
 *    9 = Sol
 *   10 = Lá (linha suplementar superior)
 */
class MusicStaff {
    constructor(container, options = {}) {
        this.container = container;

        // Configuração
        this.config = {
            width: options.width || container.clientWidth || 800, // 800px para acomodar 2 compassos (320px cada) + clave (80px)
            height: options.height || 200, // Aumentado de 120 para 200 (espaço para régua de debug)
            lineSpacing: options.lineSpacing || 10,
            marginLeft: options.marginLeft || 20,
            marginRight: options.marginRight || 20,
            marginTop: options.marginTop || 40,
            lineColor: options.lineColor || '#000000',
            lineWidth: options.lineWidth || 1
        };

        // SVG element
        this.svg = null;

        // Coordenadas Y das 5 linhas (calculadas)
        // Linha 1 (Mi) = índice 0, Linha 5 (Fá) = índice 4
        this.linePositions = [];

        this.init();
    }

    /**
     * Inicializa o SVG e calcula coordenadas
     */
    init() {
        this.createSVG();
        this.calculateLinePositions();
    }

    /**
     * Cria elemento SVG
     */
    createSVG() {
        this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.svg.setAttribute('width', this.config.width);
        this.svg.setAttribute('height', this.config.height);
        this.svg.setAttribute('viewBox', `0 0 ${this.config.width} ${this.config.height}`);
        this.svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        this.svg.style.display = 'block';
        this.svg.style.backgroundColor = '#ffffff';
        // RESPONSIVO (mobile): nunca transbordar o container. config.width já é medido
        // do container, então 100% ≈ 1:1 (notas em tamanho cheio, sem distorção); o
        // maxWidth:100% garante que rounding/reflow nunca cause scroll horizontal ("samba").
        this.svg.style.width = '100%';
        this.svg.style.maxWidth = '100%';
        this.svg.style.height = 'auto';
        this.container.appendChild(this.svg);
    }

    /**
     * Calcula posição Y de cada linha do pentagrama
     * Linhas são numeradas de baixo para cima (1-5)
     * Mas desenhamos de cima para baixo no SVG
     */
    calculateLinePositions() {
        // Linha 5 (Fá) fica no topo, Linha 1 (Mi) fica embaixo
        for (let i = 0; i < 5; i++) {
            // i=0 é a linha 5 (topo), i=4 é a linha 1 (base)
            this.linePositions[i] = this.config.marginTop + (i * this.config.lineSpacing);
        }
    }

    /**
     * Retorna coordenada Y para uma posição musical
     * @param {number} position - Posição na pauta (0=Mi linha 1, 4=Si linha 3, 8=Fá linha 5)
     * @returns {number} Coordenada Y no SVG
     */
    getY(position) {
        // Posição 0 = linha 1 (Mi) = linePositions[4] (base)
        // Posição 8 = linha 5 (Fá) = linePositions[0] (topo)
        // Cada posição = meio espaçamento
        const baseY = this.linePositions[4]; // Y da linha 1
        return baseY - (position * this.config.lineSpacing / 2);
    }

    /**
     * Retorna coordenada Y de uma linha específica (1-5)
     * @param {number} lineNum - Número da linha (1-5)
     * @returns {number} Coordenada Y no SVG
     */
    getLineY(lineNum) {
        // Linha 1 = índice 4, Linha 5 = índice 0
        return this.linePositions[5 - lineNum];
    }

    /**
     * Desenha as 5 linhas do pentagrama
     * @returns {MusicStaff} this (chainable)
     */
    drawLines() {
        const x1 = this.config.marginLeft;
        const x2 = this.config.width - this.config.marginRight;

        for (let i = 0; i < 5; i++) {
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line.setAttribute('x1', x1);
            line.setAttribute('y1', this.linePositions[i]);
            line.setAttribute('x2', x2);
            line.setAttribute('y2', this.linePositions[i]);
            line.setAttribute('stroke', this.config.lineColor);
            line.setAttribute('stroke-width', this.config.lineWidth);
            this.svg.appendChild(line);
        }

        return this;
    }

    /**
     * Meia-largura da linha suplementar — FONTE ÚNICA (os dois jogos de leitura usam).
     *
     * 🔴 Tem de ser maior que a meia-largura REAL da cabeça (elipse INCLINADA), senão o
     * tracinho fica escondido embaixo da nota e ela "boia" sem referência. A projeção
     * horizontal da elipse girada é `rx·cos θ + ry·sin θ` — no Kids (cabeça gorda) isso
     * passa de 11px e engolia o tracinho de 10px. Sobra de 0,35 espaço de cada lado =
     * convenção de gravura.
     * @param {number} lineSpacing - espaçamento entre linhas da pauta
     * @param {number} rx - raio horizontal da cabeça (0 = sem cabeça conhecida)
     * @param {number} ry - raio vertical da cabeça
     * @param {number} angleDeg - inclinação da cabeça em graus
     * @returns {number} meia-largura em px
     */
    static ledgerHalfWidth(lineSpacing, rx = 0, ry = 0, angleDeg = -18) {
        const a = Math.abs(angleDeg) * Math.PI / 180;
        const headHalf = rx * Math.cos(a) + ry * Math.sin(a);
        return Math.max(lineSpacing * 0.8, headHalf + lineSpacing * 0.35);
    }

    /**
     * Desenha linha suplementar em uma posição
     * @param {number} x - Posição X
     * @param {number} position - Posição musical (-2, -4, 10, 12, etc)
     * @param {number} [halfWidth] - meia-largura (ver MusicStaff.ledgerHalfWidth). Quem
     *        conhece o tamanho da cabeça DEVE passar; sem isso, cai no mínimo da pauta.
     * @returns {MusicStaff} this (chainable)
     */
    drawLedgerLine(x, position, halfWidth = null) {
        // Só desenha se posição está fora do pentagrama
        if (position >= 0 && position <= 8) return this;

        const y = this.getY(position);
        if (halfWidth == null) halfWidth = MusicStaff.ledgerHalfWidth(this.config.lineSpacing);

        const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttribute('x1', x - halfWidth);
        line.setAttribute('y1', y);
        line.setAttribute('x2', x + halfWidth);
        line.setAttribute('y2', y);
        line.setAttribute('stroke', this.config.lineColor);
        line.setAttribute('stroke-width', this.config.lineWidth);
        this.svg.appendChild(line);

        return this;
    }

    /**
     * Retorna área útil para desenho (após margem esquerda)
     * @returns {Object} { startX, endX, width }
     */
    getDrawArea() {
        const startX = this.config.marginLeft;
        const endX = this.config.width - this.config.marginRight;
        return {
            startX,
            endX,
            width: endX - startX
        };
    }

    /**
     * Limpa o SVG
     * @returns {MusicStaff} this (chainable)
     */
    clear() {
        while (this.svg.firstChild) {
            this.svg.removeChild(this.svg.firstChild);
        }
        return this;
    }

    /**
     * Destrói o componente
     */
    destroy() {
        if (this.svg) {
            this.svg.remove();
            this.svg = null;
        }
    }
}

// Disponibiliza globalmente
window.MusicStaff = MusicStaff;



// ============================================
// music/PitchUtil.js
// ============================================
/**
 * PitchUtil - Conhecimento PURO de altura musical (sem DOM, sem áudio).
 *
 * Fundação reutilizável para qualquer jogo que lide com notas (leitura de pauta,
 * intervalos, acordes, melodia). Centraliza o que antes estava espalhado
 * (AudioManager.getFrequency, NOTE_TABLE do gerador) numa única fonte testável.
 *
 * Convenções:
 *  - "sci" = notação científica de altura: "C4", "F#5", "Bb3" (Dó central = C4, MIDI 60).
 *  - "midi" = número MIDI inteiro (C4 = 60).
 *  - Acidentes: usamos sustenido (#) como forma canônica das teclas pretas.
 *
 * Separação de responsabilidades: PitchUtil cuida de ALTURA pura. O mapeamento
 * posição-na-pauta → nota (que depende da CLAVE) fica no domínio da pauta/gerador.
 */
class PitchUtil {
    // Letras naturais em ordem e seus offsets de semitom dentro da oitava (C=0).
    static LETTERS = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
    static SEMITONE = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
    static SOLFEGE = { C: 'Dó', D: 'Ré', E: 'Mi', F: 'Fá', G: 'Sol', A: 'Lá', B: 'Si' };
    // Escala cromática canônica (sustenidos). Índice = semitom dentro da oitava.
    static CHROMATIC = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

    /**
     * Converte notação científica em número MIDI. Aceita # e b.
     * @param {string} sci - ex: "C4", "F#5", "Bb3"
     * @returns {number|null}
     */
    static midiFromSci(sci) {
        const m = String(sci).match(/^([A-G])([#b]?)(-?\d+)$/);
        if (!m) return null;
        const [, letter, acc, octStr] = m;
        let semitone = PitchUtil.SEMITONE[letter];
        if (acc === '#') semitone += 1;
        else if (acc === 'b') semitone -= 1;
        const octave = parseInt(octStr, 10);
        return (octave + 1) * 12 + semitone;
    }

    /**
     * Converte número MIDI em notação científica (forma com sustenido).
     * @param {number} midi
     * @returns {string}
     */
    static sciFromMidi(midi) {
        const octave = Math.floor(midi / 12) - 1;
        const name = PitchUtil.CHROMATIC[((midi % 12) + 12) % 12];
        return `${name}${octave}`;
    }

    /** É uma tecla preta (nota com sustenido)? @param {number} midi */
    static isBlack(midi) {
        return PitchUtil.CHROMATIC[((midi % 12) + 12) % 12].includes('#');
    }

    /** Letra natural base da nota (sem acidente). @param {number} midi */
    static letterOf(midi) {
        return PitchUtil.CHROMATIC[((midi % 12) + 12) % 12][0];
    }

    /** Oitava da nota. @param {number} midi */
    static octaveOf(midi) {
        return Math.floor(midi / 12) - 1;
    }

    /** Solfejo (PT) da letra base. @param {number} midi */
    static solfegeOf(midi) {
        return PitchUtil.SOLFEGE[PitchUtil.letterOf(midi)];
    }

    /**
     * Frequência em Hz (temperamento igual, A4 = 440). Aceita midi ou sci.
     * @param {number|string} note
     * @returns {number}
     */
    static frequency(note) {
        const midi = typeof note === 'number' ? note : PitchUtil.midiFromSci(note);
        return 440 * Math.pow(2, (midi - 69) / 12);
    }

    /**
     * Inverso de frequency(): Hz → MIDI mais próximo (temperamento igual, A4 = 440).
     * Retorna também o desvio em cents — útil para calibração/depuração da entrada
     * por microfone (pianos acústicos raramente estão exatamente em 440).
     * @param {number} freq - frequência em Hz (> 0)
     * @returns {{midi:number, cents:number}|null}
     */
    static midiFromFrequency(freq) {
        if (!(freq > 0) || !isFinite(freq)) return null;
        const exact = 69 + 12 * Math.log2(freq / 440);
        const midi = Math.round(exact);
        return { midi, cents: Math.round((exact - midi) * 100) };
    }

    /**
     * Objeto descritivo completo de uma nota — o "contrato" que componentes de UI
     * (ex: PianoKeyboard) emitem ao serem tocados.
     * @param {number} midi
     * @returns {{midi:number, sci:string, letter:string, solfege:string, octave:number,
     *            isBlack:boolean, accidental:string, frequency:number}}
     */
    static info(midi) {
        const chroma = PitchUtil.CHROMATIC[((midi % 12) + 12) % 12];
        return {
            midi,
            sci: PitchUtil.sciFromMidi(midi),
            letter: chroma[0],
            accidental: chroma.length > 1 ? '#' : '',
            solfege: PitchUtil.SOLFEGE[chroma[0]],
            octave: PitchUtil.octaveOf(midi),
            isBlack: chroma.includes('#'),
            frequency: PitchUtil.frequency(midi)
        };
    }

    /**
     * Enumera TODAS as notas cromáticas no intervalo [minSci, maxSci] inclusive.
     * Útil para montar um teclado de piano de qualquer extensão.
     * @param {string} minSci
     * @param {string} maxSci
     * @returns {Array<Object>} lista de PitchUtil.info()
     */
    static range(minSci, maxSci) {
        const lo = PitchUtil.midiFromSci(minSci);
        const hi = PitchUtil.midiFromSci(maxSci);
        const out = [];
        for (let m = lo; m <= hi; m++) out.push(PitchUtil.info(m));
        return out;
    }
}

// Disponibiliza globalmente
window.PitchUtil = PitchUtil;



// ============================================
// music/Interval.js
// ============================================
/**
 * Interval - Representação robusta de um intervalo musical.
 *
 * Fundação reutilizável (como PitchUtil para altura). Um intervalo é a distância
 * entre duas alturas, descrita por:
 *   - semitones: tamanho cromático (3ª menor = 3, 3ª maior = 4).
 *   - number:    número diatônico (3 = terça, 5 = quinta…).
 *   - quality:   'minor' | 'major' | 'perfect' | 'augmented' | 'diminished'.
 *   - namePt:    nome em português ("Terça maior").
 *   - short:     abreviação ("3M").
 *
 * Catálogo cobre todos os intervalos simples (dentro da oitava). O jogo HABILITA
 * um subconjunto (hoje só 3ª maior/menor); adicionar novos é só habilitar o code.
 *
 * Separação: Interval cuida da TEORIA do intervalo; aplicar a uma nota concreta
 * delega o cálculo de MIDI (que vem de PitchUtil no consumo).
 */
class Interval {
    constructor(def) {
        this.code = def.code;
        this.semitones = def.semitones;
        this.number = def.number;
        this.quality = def.quality;
        this.namePt = def.namePt;
        this.short = def.short;
    }

    /** Aplica o intervalo a um MIDI, ascendente. */
    applyUp(midi) { return midi + this.semitones; }
    /** Aplica o intervalo a um MIDI, descendente. */
    applyDown(midi) { return midi - this.semitones; }
    /** Aplica conforme a direção ('up' | 'down'). */
    apply(midi, direction = 'up') {
        return direction === 'down' ? this.applyDown(midi) : this.applyUp(midi);
    }

    // ---------- fábrica / catálogo ----------

    static fromCode(code) {
        const def = Interval.CATALOG[code];
        return def ? new Interval(def) : null;
    }

    /** Lista de Interval a partir de uma lista de codes (ignora inválidos). */
    static all(codes) {
        return codes.map(c => Interval.fromCode(c)).filter(Boolean);
    }

    /**
     * Identifica um intervalo pelo nº de semitons. Se `allowedCodes` for dado,
     * busca só nesse conjunto (resolve ambiguidades enarmônicas — ex.: 6 semitons).
     * @param {number} semitones
     * @param {string[]|null} allowedCodes
     * @returns {Interval|null}
     */
    static fromSemitones(semitones, allowedCodes = null) {
        const pool = allowedCodes || Object.keys(Interval.CATALOG);
        for (const code of pool) {
            const def = Interval.CATALOG[code];
            if (def && def.semitones === semitones) return new Interval(def);
        }
        return null;
    }
}

// Catálogo de intervalos simples (uma oitava). `code` repetido no objeto p/ a fábrica.
Interval.CATALOG = {
    P1:  { code: 'P1',  semitones: 0,  number: 1, quality: 'perfect',    namePt: 'Uníssono',      short: '1J' },
    m2:  { code: 'm2',  semitones: 1,  number: 2, quality: 'minor',      namePt: 'Segunda menor', short: '2m' },
    M2:  { code: 'M2',  semitones: 2,  number: 2, quality: 'major',      namePt: 'Segunda maior', short: '2M' },
    m3:  { code: 'm3',  semitones: 3,  number: 3, quality: 'minor',      namePt: 'Terça menor',   short: '3m' },
    M3:  { code: 'M3',  semitones: 4,  number: 3, quality: 'major',      namePt: 'Terça maior',   short: '3M' },
    P4:  { code: 'P4',  semitones: 5,  number: 4, quality: 'perfect',    namePt: 'Quarta justa',  short: '4J' },
    TT:  { code: 'TT',  semitones: 6,  number: 4, quality: 'augmented',  namePt: 'Trítono',       short: 'TT' },
    P5:  { code: 'P5',  semitones: 7,  number: 5, quality: 'perfect',    namePt: 'Quinta justa',  short: '5J' },
    m6:  { code: 'm6',  semitones: 8,  number: 6, quality: 'minor',      namePt: 'Sexta menor',   short: '6m' },
    M6:  { code: 'M6',  semitones: 9,  number: 6, quality: 'major',      namePt: 'Sexta maior',   short: '6M' },
    m7:  { code: 'm7',  semitones: 10, number: 7, quality: 'minor',      namePt: 'Sétima menor',  short: '7m' },
    M7:  { code: 'M7',  semitones: 11, number: 7, quality: 'major',      namePt: 'Sétima maior',  short: '7M' },
    P8:  { code: 'P8',  semitones: 12, number: 8, quality: 'perfect',    namePt: 'Oitava justa',  short: '8J' }
};

// Disponibiliza globalmente
window.Interval = Interval;



// ============================================
// music/Chord.js
// ============================================
/**
 * Chord - Representação robusta de um acorde musical.
 *
 * Fundação reutilizável (como Interval para a distância entre 2 alturas, mas aqui
 * para 3+ alturas soando juntas). Um acorde é descrito por:
 *   - code:      identificador estável ('maj', 'min', 'maj7', '13'…) — usado no jogo.
 *   - intervals: offsets em semitons a partir da fundamental ([0,4,7] = tríade maior).
 *   - quality:   família ('triad' | 'seventh' | 'extension') — só p/ agrupar/descrever.
 *   - symbol:    cifra curta ('M', 'm', 'maj7', '7', 'ø', '°7'…).
 *
 * Catálogo cobre tríades → 7ªs → extensões (9/11/13). O jogo HABILITA um subconjunto
 * por nível (começa maior/menor); adicionar acorde é só mais uma linha no catálogo.
 *
 * Voicings das extensões (11/13) são compactos de propósito (omitem graus que
 * embolam o reconhecimento auditivo — ex.: 13 = fund/3/7/9/13, sem 5 e 11), seguindo
 * a prática de cifra. Identificação no jogo é por `code` (ouvido), não por análise.
 *
 * Separação: Chord cuida da TEORIA; aplicar a uma fundamental concreta devolve os
 * MIDIs (o cálculo de frequência/letra vem de PitchUtil no consumo).
 */
class Chord {
    constructor(def) {
        this.code = def.code;
        this.intervals = def.intervals;
        this.quality = def.quality;
        this.symbol = def.symbol;
    }

    /** Nº de notas do acorde (tamanho do voicing). */
    get size() { return this.intervals.length; }

    /** Offset (em semitons) da nota mais aguda — usado p/ clampar a fundamental ao range. */
    get topOffset() { return this.intervals[this.intervals.length - 1]; }

    /** Aplica o acorde a uma fundamental MIDI → array de MIDIs (graves→agudos). */
    apply(rootMidi) {
        return this.intervals.map(semi => rootMidi + semi);
    }

    // ---------- fábrica / catálogo ----------

    static fromCode(code) {
        const def = Chord.CATALOG[code];
        return def ? new Chord(def) : null;
    }

    /** Lista de Chord a partir de uma lista de codes (ignora inválidos). */
    static all(codes) {
        return codes.map(c => Chord.fromCode(c)).filter(Boolean);
    }

    // ---------- cifra (o que se IMPRIME acima da pauta) ----------

    /**
     * Cifra por extenso: 'C', 'Am7', 'F♯m7(♭5)'.
     *
     * 🔴 NÃO usa `symbol`. Aquele campo é o RÓTULO DO BOTÃO do jogo de Acordes ('M', 'ø',
     * '°') — resposta de exercício de ouvido, e um jogo que está no ar e é ranqueado.
     * Cifra de partitura é outra convenção: o acorde maior não escreve sufixo nenhum
     * ("C", nunca "CM"). São duas tabelas porque são duas coisas; fundi-las mudaria os
     * botões do jogo de Acordes sem ninguém pedir.
     *
     * A grafia é NEUTRA de idioma de propósito: cifra é letra nos três domínios. Se um dia
     * PT quiser 'C7M' no lugar de 'Cmaj7', troca-se esta tabela e nada migra — a cifra é
     * DERIVADA (ver Score.annotate), nunca guardada.
     *
     * @param {string} rootLabel - fundamental já soletrada ('C', 'B♭', 'F♯')
     * @param {string} code - chave do CATALOG
     * @returns {string|null} null se o code não existe
     */
    static chartSymbol(rootLabel, code) {
        // 🔴 `hasOwnProperty`, como o `isValidCode` irmão. Com acesso cru, um `code` vindo
        // de JSON com o nome de um membro do protótipo ('toString', 'constructor') devolvia
        // a FUNÇÃO como sufixo — e a esteira desenhava "Cfunction toString() { [native code] }".
        const suffix = Object.prototype.hasOwnProperty.call(Chord.CHART_SUFFIX, code)
            ? Chord.CHART_SUFFIX[code] : null;
        return (suffix == null) ? null : rootLabel + suffix;
    }

    /** O code existe no catálogo? (portão do `Score.validate` e do editor de cifras) */
    static isValidCode(code) {
        return Object.prototype.hasOwnProperty.call(Chord.CATALOG, code);
    }
}

// Catálogo de acordes. `code` repetido no objeto p/ a fábrica.
// intervals = offsets em semitons a partir da fundamental.
Chord.CATALOG = {
    // ---- Tríades ----
    maj:   { code: 'maj',   quality: 'triad',     symbol: 'M',    intervals: [0, 4, 7] },
    min:   { code: 'min',   quality: 'triad',     symbol: 'm',    intervals: [0, 3, 7] },
    dim:   { code: 'dim',   quality: 'triad',     symbol: '°',    intervals: [0, 3, 6] },
    aug:   { code: 'aug',   quality: 'triad',     symbol: '+',    intervals: [0, 4, 8] },
    sus2:  { code: 'sus2',  quality: 'triad',     symbol: 'sus2', intervals: [0, 2, 7] },
    sus4:  { code: 'sus4',  quality: 'triad',     symbol: 'sus4', intervals: [0, 5, 7] },

    // ---- Sétimas ----
    maj7:  { code: 'maj7',  quality: 'seventh',   symbol: 'maj7', intervals: [0, 4, 7, 11] },
    '7':   { code: '7',     quality: 'seventh',   symbol: '7',    intervals: [0, 4, 7, 10] },
    min7:  { code: 'min7',  quality: 'seventh',   symbol: 'm7',   intervals: [0, 3, 7, 10] },
    m7b5:  { code: 'm7b5',  quality: 'seventh',   symbol: 'ø',    intervals: [0, 3, 6, 10] },
    dim7:  { code: 'dim7',  quality: 'seventh',   symbol: '°7',   intervals: [0, 3, 6, 9] },

    // ---- Extensões (voicings compactos de cifra) ----
    maj9:  { code: 'maj9',  quality: 'extension', symbol: 'maj9', intervals: [0, 4, 7, 11, 14] },
    '9':   { code: '9',     quality: 'extension', symbol: '9',    intervals: [0, 4, 7, 10, 14] },
    min9:  { code: 'min9',  quality: 'extension', symbol: 'm9',   intervals: [0, 3, 7, 10, 14] },
    '11':  { code: '11',    quality: 'extension', symbol: '11',   intervals: [0, 7, 10, 14, 17] },        // omite 3ª (clássico)
    '13':  { code: '13',    quality: 'extension', symbol: '13',   intervals: [0, 4, 10, 14, 21] }         // fund/3/7/9/13 (sem 5 e 11)
};

/**
 * Sufixo de CIFRA por code (ver `Chord.chartSymbol`). Cobre o catálogo inteiro: um code
 * sem entrada aqui não é cifrável, e o editor não o oferece.
 */
Chord.CHART_SUFFIX = {
    maj:  '',      min:  'm',     dim:  '°',      aug:  '+',
    sus2: 'sus2',  sus4: 'sus4',
    maj7: 'maj7',  '7':  '7',     min7: 'm7',     m7b5: 'm7(♭5)',  dim7: '°7',
    maj9: 'maj9',  '9':  '9',     min9: 'm9',     '11': '11',      '13': '13'
};

/**
 * Ordem em que o seletor de cifra mostra as qualidades: as que aparecem em qualquer
 * música popular primeiro, as extensões no fim. É a ordem da TELA, não do catálogo —
 * o catálogo é ordenado por família (tríade → 7ª → extensão), que é o que o jogo de
 * Acordes precisa para montar níveis.
 */
Chord.CHART_CODES = [
    'maj', 'min', '7', 'min7', 'maj7', 'm7b5', 'dim', 'dim7', 'aug', 'sus4', 'sus2',
    '9', 'min9', 'maj9', '11', '13'
];

// Disponibiliza globalmente
window.Chord = Chord;



// ============================================
// music/RhythmPattern.js
// ============================================
/**
 * RhythmPattern - Estrutura de dados imutável de um padrão rítmico
 *
 * Responsabilidade ÚNICA:
 * - Armazenar notas/pausas de um padrão
 * - Calcular duração total
 * - Fornecer beats esperados para scoring
 */
class RhythmPattern {
    constructor(notes, config) {
        this.notes = notes;  // Array de {type, duration, beat, visualType}
        this.config = config; // {bpm, timeSignature, measures}
    }

    /**
     * Duração total do padrão em milissegundos
     * @returns {number}
     */
    getDuration() {
        const beatDuration = 60000 / this.config.bpm; // ms por beat
        const totalBeats = this.config.measures * this.config.timeSignature.beats;
        return totalBeats * beatDuration;
    }

    /**
     * Retorna nota em índice específico
     * @param {number} index
     * @returns {Object}
     */
    getNote(index) {
        return this.notes[index];
    }

    /**
     * Retorna beats esperados com timestamps
     * @returns {Array}
     */
    getExpectedBeats() {
        const beatDuration = 60000 / this.config.bpm;
        const beats = [];

        this.notes.forEach(note => {
            if (note.type === 'note') {
                beats.push({
                    beat: note.beat,
                    timestamp: note.beat * beatDuration,
                    duration: note.duration * beatDuration,
                    visualType: note.visualType
                });
            }
        });

        return beats;
    }

    /**
     * Serializa para JSON
     * @returns {Object}
     */
    toJSON() {
        return {
            notes: this.notes,
            config: this.config
        };
    }
}

// Disponibiliza globalmente
window.RhythmPattern = RhythmPattern;



// ============================================
// music/Notation.js
// ============================================
/**
 * Notation - conhecimento PURO de escrita musical (sem DOM, sem áudio, sem estado).
 *
 * É a peça que traduz "altura + armadura" em "o que se escreve na pauta". Existe porque
 * o MIDI — a fonte do jogo de música real — **não tem** nada disso:
 *
 *   🔴 MIDI não tem clave.       → `inferClef` decide pelo âmbito.
 *   🔴 MIDI não tem enarmonia.   → o byte 66 é Fá♯ E Sol♭; `spell` decide pela ARMADURA.
 *   🔴 MIDI não tem figura.      → tem duração em ticks; `figureOf` mapeia p/ semínima & cia.
 *
 * Irmã de PitchUtil (que é altura pura: midi↔sci↔freq). A divisão: PitchUtil sabe QUE SOM é,
 * Notation sabe COMO SE ESCREVE. Ver docs/MUSICA-REAL-PLANO.md §2.
 *
 * 🔴 UNIDADE DE TEMPO: tudo aqui (e no Score) é em SEMÍNIMAS ("beats" = quarter notes),
 * a mesma unidade do PPQ do MIDI. Fórmula de compasso vira nº de semínimas por compasso
 * via `quartersPerMeasure` — 3/4 → 3, 6/8 → 3. Nunca misturar com "pulso percebido".
 */
class Notation {
    /** Letras em ordem diatônica a partir de Dó (índice = grau). */
    static LETTERS = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];

    /** Classe de altura (semitons acima de Dó) de cada letra NATURAL. */
    static NATURAL_PC = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };

    /**
     * O TEMPO da fórmula, em semínimas — 1 no compasso simples, 1,5 no composto.
     *
     * 🔴 Não confundir com `quartersPerMeasure`: 6/8 tem 3 semínimas por compasso e DOIS
     * tempos, de 1,5 cada. É a distinção que faz o compasso composto parecer composto —
     * o beam agrupa por aqui, e o editor de cifras planta por aqui. Uma regra só: se as
     * duas discordarem, a página se contradiz (colcheias agrupadas de três com a cifra
     * caindo de semínima em semínima).
     *
     * @param {{beats:number, noteValue:number}} ts
     * @returns {number} semínimas por tempo
     */
    static metricBeat(ts) {
        if (!ts) return 1;
        const composto = ts.noteValue >= 8 && ts.beats % 3 === 0 && ts.beats > 3;
        return composto ? 1.5 : 1;
    }

    /** Ordem em que sustenidos e bemóis entram na armadura (círculo de quintas). */
    static SHARP_ORDER = ['F', 'C', 'G', 'D', 'A', 'E', 'B'];
    static FLAT_ORDER  = ['B', 'E', 'A', 'D', 'G', 'C', 'F'];

    /**
     * Âncora de cada clave = passo diatônico absoluto da POSIÇÃO 0 da pauta (1ª linha).
     * Clave de sol: 1ª linha = Mi4. Clave de fá: 1ª linha = Sol2.
     * (passo diatônico absoluto = oitava·7 + grau da letra — ver `diatonicStep`.)
     */
    static CLEF_ANCHOR = { treble: 30, bass: 18 };

    /**
     * Figuras por duração em semínimas. Fonte única compartilhada com RHYTHM_FIGURES
     * (mesmos `visualType` do RhythmRenderer) — é o que deixa o desenho reusar as
     * primitivas do jogo de ritmo sem tradução.
     */
    static FIGURES = [
        { duration: 4,     note: 'whole',          rest: 'whole-rest' },
        // 🔴 As pausas pontuadas NÃO são luxo: sem a de mínima pontuada, um compasso inteiro
        // de silêncio é inexprimível em 3/4 (a peça de estreia!), e sem a de semínima
        // pontuada, em 6/8. Ligadura de pausas não existe — ou há figura, ou não se escreve.
        { duration: 3,     note: 'dotted-half',    rest: 'dotted-half-rest' },
        { duration: 2,     note: 'half',           rest: 'half-rest' },
        { duration: 1.5,   note: 'dotted-quarter', rest: 'dotted-quarter-rest' },
        { duration: 1,     note: 'quarter',        rest: 'quarter-rest' },
        { duration: 0.75,  note: 'dotted-eighth',  rest: 'dotted-eighth-rest' },
        { duration: 0.5,   note: 'eighth',         rest: 'eighth-rest' },
        { duration: 0.25,  note: 'sixteenth',      rest: 'sixteenth-rest' },
        { duration: 0.125, note: 'fusa',           rest: 'fusa-rest' }
    ];

    static EPS = 1e-6;

    // ---------- armadura ----------

    /**
     * Alterações que a ARMADURA impõe a cada letra.
     * @param {number} sharps - +N sustenidos, −N bemóis (−7..7)
     * @returns {Object} letra → −1 (bemol) | 0 | +1 (sustenido)
     */
    static keyAccidentals(sharps) {
        const acc = { C: 0, D: 0, E: 0, F: 0, G: 0, A: 0, B: 0 };
        const n = Math.max(-7, Math.min(7, sharps | 0));
        if (n > 0) for (let i = 0; i < n; i++) acc[Notation.SHARP_ORDER[i]] = 1;
        else for (let i = 0; i < -n; i++) acc[Notation.FLAT_ORDER[i]] = -1;
        return acc;
    }

    // ---------- soletração (a decisão que o MIDI não carrega) ----------

    /**
     * Decide COMO ESCREVER uma altura MIDI dentro de uma armadura.
     *
     * Três degraus, nesta ordem — e a ordem É a regra:
     *
     *   1. Está na escala da armadura? → letra da escala. O acidente já está na armadura,
     *      não se reescreve.
     *   2. 🔴 Existe letra NATURAL com essa altura? → use-a, com bequadro. É o degrau que
     *      separa gravura de aritmética: em Mi♭ maior, o Mi natural tem de sair "Mi♮", não
     *      "Fá♭". Pular este passo produz Fá♭/Dó♭/Mi♯/Si♯ o tempo todo — tecnicamente a
     *      mesma altura, e ilegível para quem está aprendendo a ler.
     *   3. Sobrou o cromatismo sem letra natural (as 5 teclas pretas: alturas 1, 3, 6, 8,
     *      10) → o sinal segue a armadura: tonalidade de sustenidos sobe por sustenido,
     *      de bemóis desce por bemol.
     *
     * @param {number} midi - 0..127
     * @param {number} sharps - armadura (−7..7)
     * @returns {{letter:string, alter:number, octave:number, midi:number}}
     */
    static spell(midi, sharps = 0) {
        const pc = ((midi % 12) + 12) % 12;
        const keyAcc = Notation.keyAccidentals(sharps);

        // 1) A altura está na escala? → letra da escala, alteração da armadura.
        let letter = null, alter = 0;
        for (const L of Notation.LETTERS) {
            const lp = ((Notation.NATURAL_PC[L] + keyAcc[L]) % 12 + 12) % 12;
            if (lp === pc) { letter = L; alter = keyAcc[L]; break; }
        }

        // 2) Tem letra natural? → bequadro. (Ver o porquê no cabeçalho: evita Fá♭/Si♯.)
        if (letter === null) {
            for (const L of Notation.LETTERS) {
                if (Notation.NATURAL_PC[L] === pc) { letter = L; alter = 0; break; }
            }
        }

        // 3) Tecla preta fora da escala: vence a escrita mais PERTO da tonalidade no
        //    círculo de quintas (ver `_chromaticSpelling`).
        if (letter === null) {
            const c = Notation._chromaticSpelling(pc, sharps);
            letter = c.letter; alter = c.alter;
        }

        // 🔴 Oitava vem da LETRA, não do midi: Si♯3 e Dó4 são o mesmo byte (60) e oitavas
        // diferentes. `(midi − alter − pcNatural) / 12 − 1` acerta os dois.
        const octave = Math.round((midi - alter - Notation.NATURAL_PC[letter]) / 12) - 1;
        return { letter, alter, octave, midi };
    }

    /** Posição de cada letra natural no círculo de quintas (Fá = −1, Dó = 0, Sol = 1…). */
    static FIFTHS_OF_LETTER = { F: -1, C: 0, G: 1, D: 2, A: 3, E: 4, B: 5 };

    /**
     * Escrita de uma das 5 teclas pretas FORA da escala.
     *
     * 🔴 Não basta "a armadura tem sustenidos, então use sustenido". Essa regra produz
     * **Lá♯ e Ré♯ em Dó maior**, onde qualquer editor escreve **Si♭ e Mi♭** — e Sol♭ em Fá
     * maior, onde se escreve Fá♯. A escolha certa é a escrita mais PRÓXIMA da tonalidade
     * no círculo de quintas: Si♭ está a 2 quintas de Dó, Lá♯ está a 10.
     *
     * O centro é `sharps + 2` (o miolo do arco diatônico da tonalidade, que ocupa as
     * quintas de `sharps−1` a `sharps+5`). No empate vence o BEMOL: em Dó maior, ♭6 (Lá♭)
     * é muito mais corrente que ♯5 (Sol♯).
     *
     * @param {number} pc - classe de altura 0..11 (uma das teclas pretas)
     * @param {number} sharps - armadura
     * @returns {{letter:string, alter:number}}
     */
    static _chromaticSpelling(pc, sharps) {
        const centro = sharps + 2;
        let melhor = null;
        // Duas candidatas: a letra abaixo com sustenido e a letra acima com bemol.
        [[1, ((pc - 1) % 12 + 12) % 12], [-1, ((pc + 1) % 12 + 12) % 12]].forEach(([alter, natPc]) => {
            const L = Notation.LETTERS.find(x => Notation.NATURAL_PC[x] === natPc);
            if (!L) return;
            const quintas = Notation.FIFTHS_OF_LETTER[L] + alter * 7;
            const dist = Math.abs(quintas - centro);
            // `<=` com o bemol avaliado por ÚLTIMO ⇒ o empate fica com o bemol.
            if (!melhor || dist <= melhor.dist) melhor = { letter: L, alter, dist };
        });
        return melhor || { letter: 'C', alter: 0 };
    }

    /** Passo diatônico ABSOLUTO (ignora acidentes): Dó4 = 28, Mi4 = 30, Sol2 = 18. */
    static diatonicStep(letter, octave) {
        return octave * 7 + Notation.LETTERS.indexOf(letter);
    }

    /**
     * Posição na pauta (o eixo do MusicStaff: 0 = 1ª linha, 4 = linha do meio, 8 = 5ª linha).
     * Acidente NÃO move a nota — Fá e Fá♯ ocupam a mesma linha. Por isso deriva do passo
     * diatônico, nunca do midi cru.
     * @param {number} midi
     * @param {string} clef - 'treble' | 'bass'
     * @param {number} sharps
     * @returns {number} posição (pode ser negativa ou > 8 → linhas suplementares)
     */
    static positionOf(midi, clef = 'treble', sharps = 0) {
        const s = Notation.spell(midi, sharps);
        const anchor = Notation.CLEF_ANCHOR[clef] != null
            ? Notation.CLEF_ANCHOR[clef] : Notation.CLEF_ANCHOR.treble;
        return Notation.diatonicStep(s.letter, s.octave) - anchor;
    }

    /**
     * Qual acidente IMPRIMIR antes da nota, dado o que a armadura já diz e o que já
     * apareceu no compasso. Devolve null quando nada precisa ser escrito.
     *
     * `measureState` é o mapa "letra+oitava → alteração vigente" DENTRO do compasso
     * (acidente vale até a barra). Quem chama é responsável por zerá-lo a cada compasso
     * e por registrar o retorno — assim a mesma nota repetida não recebe dois sinais.
     *
     * @param {{letter:string, alter:number, octave:number}} spelled
     * @param {number} sharps
     * @param {Object} [measureState] - mutável; chave `letter+octave`
     * @returns {'sharp'|'flat'|'natural'|null}
     */
    static accidentalToPrint(spelled, sharps = 0, measureState = null) {
        const keyAlter = Notation.keyAccidentals(sharps)[spelled.letter];
        const key = spelled.letter + spelled.octave;
        const vigente = (measureState && key in measureState) ? measureState[key] : keyAlter;
        if (spelled.alter === vigente) return null;
        if (measureState) measureState[key] = spelled.alter;
        if (spelled.alter === 0) return 'natural';
        return spelled.alter > 0 ? 'sharp' : 'flat';
    }

    // ---------- clave (o MIDI não tem — inferimos) ----------

    /**
     * Escolhe a clave pelo âmbito. Mediana é usada de propósito no lugar da média: uma
     * nota grave isolada não deve arrastar a peça inteira p/ a clave de fá.
     * Empate/vazio → clave de sol (é o que o aluno iniciante lê).
     * @param {Array<number>} midis
     * @returns {'treble'|'bass'}
     */
    static inferClef(midis) {
        const xs = (midis || []).filter(m => typeof m === 'number').slice().sort((a, b) => a - b);
        if (!xs.length) return 'treble';
        const mid = xs.length % 2 ? xs[(xs.length - 1) / 2]
                                  : (xs[xs.length / 2 - 1] + xs[xs.length / 2]) / 2;
        return mid < 60 ? 'bass' : 'treble'; // 60 = Dó central
    }

    // ---------- figuras ----------

    /**
     * Duração (em semínimas) → figura desenhável.
     * @param {number} duration
     * @param {boolean} isRest
     * @returns {{visualType:string, dots:number}|null} null = não é representável por UMA
     *          figura (precisa de ligadura ou quiáltera — decisão de quem monta o Score)
     */
    static figureOf(duration, isRest = false) {
        const f = Notation.FIGURES.find(x => Math.abs(x.duration - duration) < Notation.EPS);
        if (!f) return null;
        const visualType = isRest ? f.rest : f.note;
        if (!visualType) return null; // ex.: pausa de mínima pontuada não está no catálogo
        return { visualType, dots: /^dotted-/.test(visualType) ? 1 : 0 };
    }

    /** Figura → duração em semínimas (inverso de figureOf). null se desconhecida. */
    static durationOf(visualType) {
        // 🔴 A guarda não é paranoia: entradas do catálogo têm `rest: null`, então um
        // `visualType` nulo (o que `Score.annotate` grava quando NÃO existe figura) casaria
        // com a primeira delas e devolveria "mínima pontuada" em vez de erro.
        if (!visualType) return null;
        const f = Notation.FIGURES.find(x => x.note === visualType || x.rest === visualType);
        return f ? f.duration : null;
    }

    /**
     * Semínimas por compasso de uma fórmula. 3/4 → 3 · 6/8 → 3 · 4/4 → 4.
     * @param {{beats:number, noteValue:number}} timeSignature
     */
    static quartersPerMeasure(timeSignature) {
        const ts = timeSignature || { beats: 4, noteValue: 4 };
        return ts.beats * 4 / ts.noteValue;
    }

    /**
     * Direção da haste pela posição na pauta. Convenção de gravura: da linha do meio
     * (posição 4) para cima, haste desce; abaixo dela, sobe.
     * @param {number} position
     * @returns {boolean} true = haste p/ cima
     */
    static stemUp(position) {
        return position < 4;
    }
}

// Disponibiliza globalmente
if (typeof window !== 'undefined') window.Notation = Notation;



// ============================================
// music/Key.js
// ============================================
/**
 * Key - TONALIDADE (armadura + tônica + modo). Conhecimento puro, sem DOM e sem áudio.
 *
 * Irmã de `Notation`, e a divisão entre as duas é a de sempre neste projeto:
 *
 *   Notation  → "que sinal se imprime nesta nota" (armadura como lista de alterações)
 *   Key       → "que TONALIDADE é esta" (Mi♭ maior × Dó menor, tônica, relativa, nome)
 *   PitchUtil → "que som é este" (midi ↔ sci ↔ frequência)
 *
 * Existe porque o importador de MIDI precisa DECIDIR a tonalidade — o arquivo muitas
 * vezes não traz a meta de armadura, e sem ela toda tecla preta vira sustenido avulso
 * (legível para o computador, ilegível para quem está aprendendo). E porque tonalidade
 * é vocabulário que os jogos vão pedir de novo: escala, campo harmônico, cifra.
 *
 * 🔴 A armadura é a MESMA para a tonalidade maior e a sua relativa menor (Mi♭ maior e
 * Dó menor têm 3 bemóis). O que muda é a tônica — e é por isso que `{sharps, minor}` é
 * o par mínimo que descreve uma tonalidade, nunca só o número.
 *
 * 🔴 Nome de nota NÃO se escreve aqui: PT/EN/ES chamam a mesma nota de Dó/C/Do. Esta
 * classe devolve a tônica SOLETRADA (letra + alteração) e quem tem tela compõe o nome
 * com `PitchUtil.SOLFEGE` e as chaves `music.major`/`music.minor`.
 */
class Key {

    /** Do lado dos bemóis (−7) ao dos sustenidos (+7): tônica maior e relativa menor. */
    static CIRCLE = [
        { sharps: -7, major: ['C', -1], minor: ['A', -1] },   // Dó♭ maior · Lá♭ menor
        { sharps: -6, major: ['G', -1], minor: ['E', -1] },
        { sharps: -5, major: ['D', -1], minor: ['B', -1] },
        { sharps: -4, major: ['A', -1], minor: ['F',  0] },
        { sharps: -3, major: ['E', -1], minor: ['C',  0] },   // Mi♭ maior · Dó menor
        { sharps: -2, major: ['B', -1], minor: ['G',  0] },
        { sharps: -1, major: ['F',  0], minor: ['D',  0] },
        { sharps:  0, major: ['C',  0], minor: ['A',  0] },   // Dó maior · Lá menor
        { sharps:  1, major: ['G',  0], minor: ['E',  0] },
        { sharps:  2, major: ['D',  0], minor: ['B',  0] },
        { sharps:  3, major: ['A',  0], minor: ['F',  1] },
        { sharps:  4, major: ['E',  0], minor: ['C',  1] },
        { sharps:  5, major: ['B',  0], minor: ['G',  1] },
        { sharps:  6, major: ['F',  1], minor: ['D',  1] },
        { sharps:  7, major: ['C',  1], minor: ['A',  1] }    // Dó♯ maior · Lá♯ menor
    ];

    /** Grau (em semitons a partir da tônica) das notas da escala maior e da menor natural. */
    static MAJOR_SCALE = [0, 2, 4, 5, 7, 9, 11];
    static MINOR_SCALE = [0, 2, 3, 5, 7, 8, 10];

    /**
     * @param {number} sharps −7..7 (negativo = bemóis)
     * @param {boolean} [minor]
     * @returns {{sharps:number, minor:boolean, tonic:{letter:string, alter:number},
     *            tonicPc:number, accidentals:number}|null}
     */
    static of(sharps, minor = false) {
        const entry = Key.CIRCLE.find(k => k.sharps === sharps);
        if (!entry) return null;
        const [letter, alter] = minor ? entry.minor : entry.major;
        return {
            sharps, minor: !!minor,
            tonic: { letter, alter },
            tonicPc: ((window.Notation.NATURAL_PC[letter] + alter) % 12 + 12) % 12,
            accidentals: Math.abs(sharps)
        };
    }

    /** Tonalidade a partir da tônica escrita (ex.: 'B',−1,false → 2 bemóis). null se não existe. */
    static fromTonic(letter, alter = 0, minor = false) {
        const entry = Key.CIRCLE.find(k => {
            const [l, a] = minor ? k.minor : k.major;
            return l === letter && a === alter;
        });
        return entry ? Key.of(entry.sharps, minor) : null;
    }

    /** A relativa (maior ↔ menor): MESMA armadura, outra tônica. */
    static relative(key) {
        return key ? Key.of(key.sharps, !key.minor) : null;
    }

    /** Alturas MIDI da escala da tonalidade, numa oitava (para exercícios futuros). */
    static scalePcs(key) {
        const steps = key.minor ? Key.MINOR_SCALE : Key.MAJOR_SCALE;
        return steps.map(s => (key.tonicPc + s) % 12);
    }

    /** A nota pertence à escala da tonalidade? */
    static contains(key, midi) {
        return Key.scalePcs(key).indexOf(((midi % 12) + 12) % 12) >= 0;
    }

    /**
     * Rótulo curto e NEUTRO de idioma: 'E♭', 'F♯'. O modo ("maior"/"menor") vem da tela,
     * das chaves `music.major`/`music.minor` — traduzir aqui furaria o piso trilíngue.
     */
    static tonicLabel(key, useSolfege = false) {
        if (!key) return '';
        const base = useSolfege ? window.PitchUtil.SOLFEGE[key.tonic.letter] : key.tonic.letter;
        return base + (key.tonic.alter > 0 ? '♯' : key.tonic.alter < 0 ? '♭' : '');
    }

    /**
     * 🔴 Deduz a tonalidade de um punhado de alturas — o caminho normal do importador,
     * porque a maioria dos `.mid` não traz a meta de armadura.
     *
     * Duas perguntas, nesta ordem:
     *   1. QUAL ARMADURA? a que exige menos acidente escrito. É objetivo e é o que um
     *      copista faria: a escrita que suja menos a página é a certa.
     *   2. MAIOR OU MENOR? a armadura não distingue (são a mesma!), então decide a
     *      TÔNICA: quem termina e quem mais aparece. Empate → maior.
     *
     * A resposta erra em música modal e em peça que muda de tom no meio — e errar aqui
     * custa acidente a mais na página, não nota errada: a ALTURA nunca muda, só a escrita.
     *
     * @param {Array<number>} midis - na ordem em que soam (o fim pesa na decisão do modo)
     * @returns {{sharps:number, minor:boolean}}
     */
    static infer(midis) {
        const N = window.Notation;
        const notes = (midis || []).filter(m => typeof m === 'number');
        if (!notes.length) return { sharps: 0, minor: false };

        let sharps = 0, bestCost = Infinity;
        for (let s = -7; s <= 7; s++) {
            let cost = 0;
            notes.forEach(m => { if (N.accidentalToPrint(N.spell(m, s), s, null)) cost++; });
            // Empate → armadura mais simples (Dó ganha de Fá♯ com o mesmo custo).
            if (cost < bestCost || (cost === bestCost && Math.abs(s) < Math.abs(sharps))) {
                bestCost = cost; sharps = s;
            }
        }

        // Modo: pesa a tônica maior contra a da relativa menor. A última nota vale muito
        // (a peça costuma pousar na tônica), a primeira vale, e a frequência desempata.
        const major = Key.of(sharps, false), minor = Key.of(sharps, true);
        const pcs = notes.map(m => ((m % 12) + 12) % 12);
        const count = (pc) => pcs.filter(p => p === pc).length / pcs.length;
        const bonus = (pc) => (pcs[pcs.length - 1] === pc ? 0.5 : 0) + (pcs[0] === pc ? 0.2 : 0);
        const scoreMajor = count(major.tonicPc) + bonus(major.tonicPc);
        const scoreMinor = count(minor.tonicPc) + bonus(minor.tonicPc);
        return { sharps, minor: scoreMinor > scoreMajor };
    }
}

// Disponibiliza globalmente
if (typeof window !== 'undefined') window.Key = Key;



// ============================================
// music/Score.js
// ============================================
/**
 * Score - modelo PURO de uma partitura (sem DOM, sem áudio, sem MIDI).
 *
 * É a peça central do jogo de música real: TUDO que se desenha, toca ou avalia lê daqui.
 * Duas fontes produzem um Score e ele não sabe distinguir uma da outra — é justamente esse
 * o ponto:
 *
 *     songs/*.json  ──┐
 *                     ├──→  Score  ──→  ScoreRenderer · SongReadingGame · AudioManager
 *     arquivo .mid  ──┘        (MidiFile → ScoreBuilder, Etapa 4)
 *
 * 🔴 Se `Score` algum dia precisar de um `if` sobre a ORIGEM do dado, o importador falhou.
 *
 * 🔴 UNIDADE DE TEMPO = SEMÍNIMA ("beat" = quarter note), igual ao PPQ do MIDI. Tick e PPQ
 * morrem dentro do parser; nada fora dele vê tick. Fórmula de compasso vira nº de semínimas
 * por compasso (3/4 → 3 · 6/8 → 3) via Notation.quartersPerMeasure.
 *
 * 🔴 O JSON guarda só o ESSENCIAL de cada nota — `{beat, duration, midi}`. Posição na pauta,
 * figura, soletração e acidente são DERIVADOS (`annotate()`) a partir de clave + armadura,
 * porque é exatamente isso que o importador de MIDI vai ter de derivar também. Guardar o
 * derivado no arquivo criaria duas verdades que podem divergir.
 *
 * 🔴 LIGADURA = "nó-âncora", o mesmo modelo do motor de ritmo (ver RHYTHM-ENGINE.md): UM
 * item em `notes` com a duração SOMADA + `tie[]` descrevendo as cabeças. 1 onset, N cabeças.
 * NUNCA dois nós irmãos — a continuação viraria um ataque para quem lê onset.
 *
 * Plano: docs/MUSICA-REAL-PLANO.md
 */
class Score {
    static EPS = 1e-6;

    /**
     * @param {Object} data - ver `songs/parabens.json` para o formato canônico
     */
    constructor(data = {}) {
        /** Chave de i18n do título (preferida) e/ou título literal de fallback. */
        this.titleKey = data.titleKey || null;
        this.title = data.title || '';
        /** 'curated' (catálogo do site) | 'imported' (arquivo do aluno) */
        this.source = data.source || 'curated';
        /** Crédito/domínio público — o catálogo curado só aceita PD (ver plano §8). */
        this.credit = data.credit || null;

        /** Armadura: {sharps: −7..7, minor: bool}. MIDI meta 0x59 cai aqui. */
        this.keySignature = Object.assign({ sharps: 0, minor: false }, data.keySignature || {});

        /** Fórmulas de compasso ao longo da peça: [{beat, beats, noteValue}], ordenadas. */
        this.timeSignatures = (data.timeSignatures && data.timeSignatures.length)
            ? data.timeSignatures.slice().sort((a, b) => a.beat - b.beat)
            : [{ beat: 0, beats: 4, noteValue: 4 }];

        /** Andamento ao longo da peça: [{beat, bpm}] (bpm = semínimas por minuto). */
        this.tempoMap = (data.tempoMap && data.tempoMap.length)
            ? data.tempoMap.slice().sort((a, b) => a.beat - b.beat)
            : [{ beat: 0, bpm: 90 }];

        /**
         * Anacruse: semínimas ANTES do primeiro compasso completo. As barras caem em
         * `pickupBeats + k·quartersPorCompasso`. Sem isto, o Parabéns (que começa em
         * levada de duas colcheias) teria barra no lugar errado a peça inteira.
         */
        this.pickupBeats = data.pickupBeats || 0;

        /**
         * Pautas. v1 = UMA (melodia). Grande pauta (2 mãos) é a Etapa 5 do plano — o
         * array já existe para não precisar mudar o formato dos arquivos depois.
         * Cada pauta: {clef, voices: [{notes: [...]}]}
         */
        this.staves = (data.staves || []).map(st => ({
            clef: st.clef || null, // null = inferir do âmbito (MIDI não traz clave)
            voices: (st.voices || []).map(v => ({
                notes: (v.notes || []).map(n => ({
                    type: n.type === 'rest' ? 'rest' : 'note',
                    beat: n.beat,
                    duration: n.duration,
                    midi: n.type === 'rest' ? null : n.midi,
                    tie: n.tie ? n.tie.map(s => ({ beat: s.beat, duration: s.duration })) : null
                }))
            }))
        }));

        /**
         * 🔴 CIFRAS (Etapa 7) — faixa do MODELO, nunca desenho solto. Um overlay pintado
         * por cima sumiria no redesenho da janela, na troca de andamento e no replay;
         * aqui a cifra é dado, e por isso sobrevive aos três.
         *
         * Guarda o ESSENCIAL — `{beat, root:{letter,alter}, code}` —, exatamente como a
         * nota guarda `{beat, duration, midi}`. O que se IMPRIME (`symbol`: "Am7") é
         * DERIVADO em `annotate()`, junto com a soletração e a figura das notas. Guardar
         * o texto criaria duas verdades que podem divergir.
         */
        this.harmony = [];
        (data.harmony || [])
            .map(h => ({
                beat: h.beat,
                root: {
                    letter: h.root ? h.root.letter : null,
                    alter: (h.root && h.root.alter) ? h.root.alter : 0
                },
                code: h.code
            }))
            .sort((a, b) => a.beat - b.beat)
            // 🔴 ORDENADA **E ÚNICA** — é o que todo leitor assume (`chordAt` para na
            // última ≤ beat, o desenho imprime uma por X). Ordenar sem deduplicar deixava
            // duas cifras no mesmo beat desenhadas uma sobre a outra; a última ganha, como
            // no `setChord`.
            .forEach(h => {
                const ult = this.harmony[this.harmony.length - 1];
                if (ult && Math.abs(ult.beat - h.beat) < Score.EPS) this.harmony[this.harmony.length - 1] = h;
                else this.harmony.push(h);
            });

        this.annotate();
    }

    /** Letras válidas de fundamental. Fonte única do `setChord` e do `validate`. */
    static LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

    /** Fundamental soletrada para a cifra: 'C', 'B♭', 'F♯'. Neutro de idioma (ver Chord). */
    static rootLabel(root) {
        if (!root || !root.letter) return '';
        return root.letter + (root.alter > 0 ? '♯' : root.alter < 0 ? '♭' : '');
    }

    /** @param {Object} obj @returns {Score} */
    static fromJSON(obj) {
        return new Score(typeof obj === 'string' ? JSON.parse(obj) : obj);
    }

    // ---------- derivação ----------

    /**
     * Preenche o que é DERIVADO de clave + armadura: clave inferida (quando ausente),
     * posição na pauta, figura/pontos, soletração e acidente a imprimir.
     *
     * O acidente é calculado com memória POR COMPASSO (um acidente vale até a barra) —
     * por isso a varredura precisa saber onde caem as barras, e não pode ser feita
     * nota a nota isoladamente.
     */
    annotate() {
        this._annotateHarmony();
        const N = window.Notation || (typeof Notation !== 'undefined' ? Notation : null);
        if (!N) return; // ambiente sem Notation carregada (não deve acontecer no bundle)
        const sharps = this.keySignature.sharps || 0;
        // Compassos calculados UMA vez e percorridos com ponteiro: `measureIndexAt` varre
        // a peça inteira a cada chamada, e um arquivo importado tem milhares de notas.
        const ms = this.measures();

        this.staves.forEach(st => {
            if (!st.clef) {
                const midis = [];
                st.voices.forEach(v => v.notes.forEach(n => { if (n.midi != null) midis.push(n.midi); }));
                st.clef = N.inferClef(midis);
            }

            st.voices.forEach(voice => {
                // Estado de acidentes do compasso corrente (zera em cada barra).
                let mPtr = 0;
                let measureIdx = -1;
                let state = {};

                voice.notes.forEach(n => {
                    while (mPtr + 1 < ms.length && n.beat >= ms[mPtr].endBeat - Score.EPS) mPtr++;
                    const mi = ms.length ? ms[mPtr].index : -1;
                    if (mi !== measureIdx) { measureIdx = mi; state = {}; }

                    if (n.type === 'rest') {
                        n.position = 4; // pausa mora na linha do meio (o desenho ajusta por figura)
                        n.spelled = null;
                        n.accidental = null;
                        const f = N.figureOf(n.duration, true);
                        n.visualType = f ? f.visualType : null;
                        n.tieSegments = null;
                        return;
                    }

                    n.spelled = N.spell(n.midi, sharps);
                    // 🔴 Clave desconhecida cairia em `undefined` e a posição viraria NaN —
                    // a nota some do desenho SEM erro nenhum. Aqui degrada p/ clave de sol;
                    // quem denuncia é o validate(), que recusa a clave inválida.
                    const anchor = (st.clef in N.CLEF_ANCHOR) ? N.CLEF_ANCHOR[st.clef] : N.CLEF_ANCHOR.treble;
                    n.position = N.diatonicStep(n.spelled.letter, n.spelled.octave) - anchor;
                    n.accidental = N.accidentalToPrint(n.spelled, sharps, state);
                    n.stemUp = N.stemUp(n.position);

                    if (n.tie && n.tie.length) {
                        // Cada segmento vira uma CABEÇA; a nota (onset) mantém a soma.
                        n.tieSegments = n.tie.map((s, k) => {
                            const f = N.figureOf(s.duration, false);
                            return {
                                beat: s.beat, duration: s.duration,
                                visualType: f ? f.visualType : null,
                                tiePrev: k > 0
                            };
                        });
                        n.visualType = n.tieSegments[0].visualType;
                    } else {
                        const f = N.figureOf(n.duration, false);
                        n.visualType = f ? f.visualType : null;
                        n.tieSegments = null;
                    }
                });
            });
        });
        return this;
    }

    /**
     * Deriva a cifra impressa de cada entrada da harmonia. Separado de `annotate()` porque
     * não depende de clave, armadura nem de onde caem as barras — e porque assim continua
     * funcionando num ambiente sem `Notation` (o `annotate` desiste ali em cima).
     */
    _annotateHarmony() {
        const C = window.Chord || (typeof Chord !== 'undefined' ? Chord : null);
        this.harmony.forEach(h => {
            h.symbol = C ? C.chartSymbol(Score.rootLabel(h.root), h.code) : null;
        });
    }

    // ---------- cifras ----------

    /**
     * Planta (ou substitui) a cifra num beat. Mantém a faixa ORDENADA — todo leitor
     * depende disso, do desenho ao `chordAt`.
     * @param {number} beat
     * @param {{root:{letter:string, alter:number}, code:string}} def
     * @returns {Object|null} a entrada plantada, ou null se o acorde não existe
     */
    /**
     * A LEI DA CIFRA, num lugar só: `{beat, root:{letter, alter}, code}` é aceitável?
     *
     * 🔴 Estática e pública de propósito. Ela nasceu dentro do `setChord` e o `SongStore`
     * (backup, Etapa 8) precisava exatamente dela para não deixar uma cifra corrompida
     * vinda de um `.json` DESLOCAR uma cifra boa que estava no aparelho. Reescrevê-la lá
     * criaria a segunda lei que este projeto já pagou três vezes — e a mais frouxa das
     * duas seria justamente a que grava no disco. Uma lei, dois leitores.
     *
     * 🔴 `typeof beat === 'number'` NÃO é redundante com `isFinite`: `isFinite(null)`,
     * `isFinite(true)` e `isFinite('')` são todos `true`, e `null` mapeia para o beat 0 —
     * era assim que uma entrada de lixo despejava a cifra do primeiro tempo.
     */
    static isValidChordDef(def) {
        const C = window.Chord || (typeof Chord !== 'undefined' ? Chord : null);
        if (!def || !C || !C.isValidCode(def.code)) return false;
        if (typeof def.beat === 'number' && !(isFinite(def.beat) && def.beat >= 0)) return false;
        const r = def.root;
        if (!r || Score.LETTERS.indexOf(r.letter) < 0) return false;
        const alter = r.alter || 0;
        if (!isFinite(alter) || alter !== Math.trunc(alter) || Math.abs(alter) > 1) return false;
        return true;
    }

    /** A mesma lei, exigindo também que o `beat` esteja lá e seja um número de verdade. */
    static isValidChord(h) {
        return !!h && typeof h.beat === 'number' && isFinite(h.beat) && h.beat >= 0
            && Score.isValidChordDef(h);
    }

    setChord(beat, def) {
        // 🔴 A MESMA lei do `validate()`, aplicada na porta de entrada. Sem isto o
        // `setChord` era sistematicamente mais permissivo que o `validate`: aceitava
        // `root` ausente (e estourava um TypeError em cima do dado do localStorage),
        // letra 'H' e `alter: 0.5` (que imprimia "C♯" e ainda assim passava na validação,
        // porque ela só olhava a FAIXA). Uma API que põe o modelo num estado que o próprio
        // modelo reprova é uma segunda lei.
        if (!(typeof beat === 'number' && isFinite(beat)) || beat < 0) return null;
        if (!Score.isValidChordDef(def)) return null;
        const C = window.Chord || (typeof Chord !== 'undefined' ? Chord : null);

        const entry = {
            beat,
            root: { letter: def.root.letter, alter: def.root.alter || 0 },
            code: def.code
        };
        entry.symbol = C.chartSymbol(Score.rootLabel(entry.root), entry.code);

        const i = this.harmony.findIndex(h => Math.abs(h.beat - beat) < Score.EPS);
        if (i >= 0) this.harmony[i] = entry;
        else {
            const at = this.harmony.findIndex(h => h.beat > beat);
            if (at < 0) this.harmony.push(entry); else this.harmony.splice(at, 0, entry);
        }
        return entry;
    }

    /** Apaga a cifra de um beat. @returns {boolean} true se havia uma. */
    removeChord(beat) {
        const i = this.harmony.findIndex(h => Math.abs(h.beat - beat) < Score.EPS);
        if (i < 0) return false;
        this.harmony.splice(i, 1);
        return true;
    }

    /**
     * A cifra que está SOANDO num beat — a última plantada em `beat` ou antes dele.
     *
     * 🔴 Não é "a mais próxima": um acorde vale até o próximo aparecer. Confundir os dois
     * faria a cifra do compasso seguinte acender antes da hora, na metade de cada compasso.
     */
    chordAt(beat) {
        let cur = null;
        for (const h of this.harmony) {
            if (h.beat <= beat + Score.EPS) cur = h; else break;
        }
        return cur;
    }

    /** Cifras cujo beat cai em [fromBeat, toBeat) — o que a janela do desenho precisa. */
    harmonyBetween(fromBeat, toBeat) {
        return this.harmony.filter(
            h => h.beat >= fromBeat - Score.EPS && h.beat < toBeat - Score.EPS);
    }

    // ---------- consultas de tempo ----------

    /** Fórmula vigente num beat. */
    timeSignatureAt(beat) {
        let ts = this.timeSignatures[0];
        for (const t of this.timeSignatures) { if (t.beat <= beat + Score.EPS) ts = t; else break; }
        return ts;
    }

    /** Andamento vigente num beat (semínimas por minuto). */
    bpmAt(beat) {
        let t = this.tempoMap[0];
        for (const x of this.tempoMap) { if (x.beat <= beat + Score.EPS) t = x; else break; }
        return t.bpm;
    }

    /** Última posição temporal escrita (fim da última nota/pausa). */
    get totalBeats() {
        let end = 0;
        this.staves.forEach(st => st.voices.forEach(v => v.notes.forEach(n => {
            end = Math.max(end, n.beat + n.duration);
        })));
        return end;
    }

    /**
     * Compassos da peça, do início ao fim escrito.
     * O índice 0 é a ANACRUSE quando ela existe (compasso incompleto, de propósito).
     * @returns {Array<{index:number, startBeat:number, endBeat:number, quarters:number, pickup:boolean}>}
     */
    measures() {
        const N = window.Notation || Notation;
        const out = [];
        const end = this.totalBeats;
        let beat = 0;
        let idx = 0;

        if (this.pickupBeats > Score.EPS) {
            out.push({ index: idx++, startBeat: 0, endBeat: this.pickupBeats,
                       quarters: this.pickupBeats, pickup: true });
            beat = this.pickupBeats;
        }
        // Guarda: fórmula degenerada (0 semínimas) travaria o laço.
        let guard = 0;
        while (beat < end - Score.EPS && guard++ < 10000) {
            const q = N.quartersPerMeasure(this.timeSignatureAt(beat));
            if (!(q > 0)) break;
            out.push({ index: idx++, startBeat: beat, endBeat: beat + q, quarters: q, pickup: false });
            beat += q;
        }
        return out;
    }

    /** Índice do compasso que contém `beat` (−1 se antes do início). */
    measureIndexAt(beat) {
        const ms = this.measures();
        if (!(beat >= -Score.EPS)) return -1; // negativo ou NaN: fora da peça
        for (const m of ms) {
            if (beat >= m.startBeat - Score.EPS && beat < m.endBeat - Score.EPS) return m.index;
        }
        return ms.length ? ms[ms.length - 1].index : -1;
    }

    /** Beats onde cai cada barra de compasso (sem a barra inicial). */
    barlineBeats() {
        return this.measures().map(m => m.endBeat);
    }

    /**
     * Converte beat → segundos respeitando o mapa de andamento (constante por trecho).
     * Puro; quem toca aplica isso sobre `audioContext.currentTime`.
     * @param {number} beat
     * @param {number} [bpmOverride] - o aluno manda no tempo de estudo; quando dado,
     *        ignora o mapa (o andamento do arquivo vira só o default do slider).
     */
    beatToSeconds(beat, bpmOverride = null) {
        if (bpmOverride) return beat * 60 / bpmOverride;
        let sec = 0, cursor = 0;
        for (let i = 0; i < this.tempoMap.length; i++) {
            // 🔴 `Math.max(cursor, …)` fazia o trecho ANTES da 1ª entrada custar zero
            // segundo — e discordava do bpmAt(), que extrapola para trás. Nem todo SMF põe
            // o andamento no tick 0, então isto apareceria já no 1º arquivo importado.
            const from = (i === 0) ? cursor : Math.max(cursor, this.tempoMap[i].beat);
            const to = (i + 1 < this.tempoMap.length) ? Math.min(beat, this.tempoMap[i + 1].beat) : beat;
            if (to > from) sec += (to - from) * 60 / this.tempoMap[i].bpm;
            cursor = to;
            if (cursor >= beat) break;
        }
        return sec;
    }

    // ---------- consultas de conteúdo ----------

    /** Notas de uma voz (default: 1ª pauta, 1ª voz — o caso monofônico do v1). */
    notes(staffIndex = 0, voiceIndex = 0) {
        const st = this.staves[staffIndex];
        if (!st || !st.voices[voiceIndex]) return [];
        return st.voices[voiceIndex].notes;
    }

    /** Notas cujo SOM cai (mesmo que parcialmente) na janela [fromBeat, toBeat). */
    notesBetween(fromBeat, toBeat, staffIndex = 0, voiceIndex = 0) {
        return this.notes(staffIndex, voiceIndex).filter(
            n => n.beat < toBeat - Score.EPS && n.beat + n.duration > fromBeat + Score.EPS);
    }

    /** Âmbito escrito da peça (define a extensão do piano de resposta). */
    midiRange() {
        let min = Infinity, max = -Infinity;
        this.staves.forEach(st => st.voices.forEach(v => v.notes.forEach(n => {
            if (n.midi == null) return;
            min = Math.min(min, n.midi); max = Math.max(max, n.midi);
        })));
        return (min === Infinity) ? null : { min, max };
    }

    // ---------- validação ----------

    /** Nome amigável de um compasso nas mensagens de erro. */
    _measureName(m) {
        if (m.pickup) return 'anacruse';
        return `compasso ${this.pickupBeats > Score.EPS ? m.index : m.index + 1}`;
    }

    /**
     * Confere as invariantes que fazem a partitura ser desenhável e tocável.
     * É o mesmo portão que o importador de MIDI vai atravessar na Etapa 4 — por isso
     * as mensagens são legíveis por humano, não códigos.
     *
     * 🔴 A regra do compasso NÃO é "a soma dos eventos bate": é **ladrilho + barra**.
     *
     *   (a) a voz LADRILHA o tempo — do beat 0 até o fim, sem buraco e sem sobreposição;
     *   (b) toda barra cai num limite de evento OU numa emenda de ligadura;
     *   (c) a peça termina exatamente numa barra.
     *
     * As três juntas são estritamente mais fortes que "somar por compasso" e não têm as
     * três fugas que a versão por soma tinha: ligadura INTERNA desligava a checagem do
     * compasso inteiro; ligadura podia cortar a barra no meio de uma cabeça; e buraco no
     * começo de um compasso se compensava com notas até a barra. Silêncio tem de ser
     * ESCRITO (pausa) — é isso que (a) exige, e é o que o importador de MIDI terá de
     * fazer com as lacunas do arquivo.
     *
     * @returns {{ok:boolean, errors:Array<string>}}
     */
    validate() {
        const N = window.Notation || Notation;
        const errors = [];
        const E = Score.EPS;
        const num = (v) => typeof v === 'number' && isFinite(v);
        // Número legível por HUMANO nas mensagens. Sem isto, uma tercina despeja
        // "0.3333333333333333" na cara de quem só quer saber que o arquivo não serve.
        const fmt = (v) => (typeof v === 'number' && isFinite(v))
            ? String(Math.round(v * 10000) / 10000) : String(v);
        const ms = this.measures(); // calculado UMA vez (ver annotate)

        // ---------- cabeçalho ----------
        const sharps = this.keySignature ? this.keySignature.sharps : 0;
        if (!num(sharps) || sharps < -7 || sharps > 7 || sharps !== Math.trunc(sharps)) {
            errors.push(`armadura inválida (${sharps}) — tem de ser um inteiro de −7 a 7`);
        }

        const VALORES = [1, 2, 4, 8, 16, 32];
        this.timeSignatures.forEach((ts, i) => {
            if (!num(ts.beats) || ts.beats <= 0 || ts.beats !== Math.trunc(ts.beats)) {
                errors.push(`fórmula de compasso ${i + 1}: numerador inválido (${ts.beats})`);
            }
            if (VALORES.indexOf(ts.noteValue) < 0) {
                errors.push(`fórmula de compasso ${i + 1}: denominador inválido (${ts.noteValue})`);
            }
            // Trocar de fórmula no meio de um compasso não é notável.
            if (i > 0 && !ms.some(m => Math.abs(m.startBeat - ts.beat) < E)) {
                errors.push(`fórmula de compasso ${i + 1}: a troca (beat ${ts.beat}) não cai numa barra`);
            }
        });
        if (this.timeSignatures.length && Math.abs(this.timeSignatures[0].beat) > E) {
            errors.push('a primeira fórmula de compasso tem de começar no beat 0');
        }

        this.tempoMap.forEach((t, i) => {
            if (!num(t.bpm) || t.bpm <= 0) errors.push(`andamento ${i + 1}: bpm inválido (${t.bpm})`);
        });

        const q0 = this.timeSignatures.length ? N.quartersPerMeasure(this.timeSignatures[0]) : 4;
        if (!num(this.pickupBeats) || this.pickupBeats < 0) {
            errors.push(`anacruse inválida (${this.pickupBeats})`);
        } else if (this.pickupBeats >= q0 - E && this.pickupBeats > E) {
            errors.push(`anacruse de ${this.pickupBeats} semínimas não cabe: um compasso tem ${q0}`);
        }

        if (!this.staves.length) errors.push('partitura sem nenhuma pauta');

        this.staves.forEach((st, si) => {
            if (!st.voices.length) errors.push(`pauta ${si + 1}: sem nenhuma voz`);
            // 🔴 Clave desconhecida daria posição NaN (nota invisível, sem erro nenhum).
            if (!(st.clef in N.CLEF_ANCHOR)) {
                errors.push(`pauta ${si + 1}: clave desconhecida ("${st.clef}") — só sol e fá`);
            }

            st.voices.forEach((voice, vi) => {
                const tag = `pauta ${si + 1}, voz ${vi + 1}`;
                const ns = voice.notes;
                if (!ns.length) return;

                ns.forEach((n, i) => {
                    const where = `${tag}, evento ${i + 1} (beat ${fmt(n.beat)})`;
                    if (!num(n.beat) || n.beat < 0) errors.push(`${where}: beat inválido`);
                    if (!num(n.duration) || n.duration <= 0) errors.push(`${where}: duração precisa ser > 0`);
                    if (n.type === 'note' && (!num(n.midi) || n.midi < 0 || n.midi > 127)) {
                        errors.push(`${where}: altura MIDI inválida (${n.midi})`);
                    }
                    // Ordem temporal + monofonia (v1): nada se sobrepõe dentro de uma voz.
                    if (i > 0) {
                        const p = ns[i - 1];
                        if (n.beat < p.beat - E) errors.push(`${where}: fora de ordem temporal`);
                        else if (n.beat < p.beat + p.duration - E) {
                            errors.push(`${where}: sobrepõe o evento anterior — uma voz é monofônica`);
                        }
                    }
                    // Toda duração precisa virar figura (ou ligadura de figuras).
                    if (n.tie && n.tie.length) {
                        if (n.tie.length < 2) {
                            errors.push(`${where}: ligadura de um segmento só — precisa de ≥2 cabeças`);
                        }
                        const sum = n.tie.reduce((a, s) => a + s.duration, 0);
                        if (Math.abs(sum - n.duration) > E) {
                            errors.push(`${where}: ligadura soma ${sum}, mas a nota dura ${n.duration}`);
                        }
                        if (Math.abs(n.tie[0].beat - n.beat) > E) {
                            errors.push(`${where}: 1º segmento da ligadura não começa no beat da nota`);
                        }
                        n.tie.forEach((s, k) => {
                            if (!num(s.duration) || s.duration <= 0) {
                                errors.push(`${where}: segmento ${k + 1} da ligadura tem duração inválida (${s.duration})`);
                            } else if (!N.figureOf(s.duration, n.type === 'rest')) {
                                errors.push(`${where}: segmento ${k + 1} da ligadura (${s.duration}) não tem figura`);
                            }
                            if (k > 0) {
                                const prev = n.tie[k - 1];
                                if (Math.abs(prev.beat + prev.duration - s.beat) > E) {
                                    errors.push(`${where}: segmentos da ligadura não são contíguos`);
                                }
                            }
                        });
                    } else if (!N.figureOf(n.duration, n.type === 'rest')) {
                        errors.push(`${where}: duração ${fmt(n.duration)}`
                            + ' não é uma figura — quantize, ligue, ou é quiáltera (fora do escopo)');
                    }
                });

                // (a) LADRILHO: começa no 0 e não tem buraco. Silêncio se escreve com pausa.
                if (Math.abs(ns[0].beat) > E) {
                    errors.push(`${tag}: começa no beat ${fmt(ns[0].beat)} — o silêncio inicial tem de ser uma pausa escrita`);
                }
                for (let i = 0; i + 1 < ns.length; i++) {
                    const fim = ns[i].beat + ns[i].duration;
                    if (ns[i + 1].beat > fim + E) {
                        const m = ms.find(x => fim >= x.startBeat - E && fim < x.endBeat - E);
                        errors.push(`${tag}: buraco de ${fmt(ns[i + 1].beat - fim)} semínimas no beat ${fmt(fim)}`
                            + (m ? ` (${this._measureName(m)}) — falta uma pausa` : ' — falta uma pausa'));
                    }
                }
            });
        });

        // ---------- cifras ----------
        // Inerte quando não há harmonia — que é o caso de toda peça do catálogo hoje.
        if (this.harmony.length) {
            const C = window.Chord || (typeof Chord !== 'undefined' ? Chord : null);
            const fimPeca = this.totalBeats;
            const LETRAS = Score.LETTERS;
            this.harmony.forEach((h, i) => {
                const where = `cifra ${i + 1} (beat ${fmt(h.beat)})`;
                if (!num(h.beat) || h.beat < 0) errors.push(`${where}: beat inválido`);
                // Cifra depois do fim é cifra que ninguém vai ver — sintoma de faixa
                // trocada por baixo dela (ver SongReadingGame), não de erro de digitação.
                else if (h.beat >= fimPeca - E && fimPeca > E) {
                    errors.push(`${where}: cai depois do fim da peça (beat ${fmt(fimPeca)})`);
                }
                if (!C || !C.isValidCode(h.code)) {
                    errors.push(`${where}: acorde desconhecido ("${h.code}")`);
                }
                if (!h.root || LETRAS.indexOf(h.root.letter) < 0) {
                    errors.push(`${where}: fundamental inválida ("${h.root && h.root.letter}")`);
                }
                // 🔴 INTEIRO de −1 a 1, não só "na faixa": `alter: 0.5` passava e imprimia
                // "C♯" (o `rootLabel` só testa > 0). Lei escrita ≠ lei aplicada.
                const alt = h.root && h.root.alter;
                if (!num(alt) || alt !== Math.trunc(alt) || Math.abs(alt) > 1) {
                    errors.push(`${where}: alteração da fundamental fora de ♭/♮/♯`);
                }
                // Ordenação E unicidade numa checagem só: a faixa é lida em ordem por
                // `chordAt` e pelo desenho, e duas no mesmo beat imprimiriam uma sobre a outra.
                if (i > 0) {
                    const d = h.beat - this.harmony[i - 1].beat;
                    if (d < -E) errors.push(`${where}: fora de ordem`);
                    else if (Math.abs(d) < E) errors.push(`${where}: duas cifras no mesmo beat`);
                }
            });
        }

        // (b) toda barra INTERIOR cai num limite de evento ou numa emenda de ligadura.
        // (c) a peça termina exatamente numa barra.
        const fim = this.totalBeats;
        const pontos = [];
        this.staves.forEach(st => st.voices.forEach(v => v.notes.forEach(n => {
            pontos.push(n.beat);
            if (n.tie) n.tie.forEach(s => pontos.push(s.beat));
            pontos.push(n.beat + n.duration);
        })));
        ms.forEach(m => {
            if (m.endBeat > fim - E) return; // a barra final é tratada por (c)
            if (!pontos.some(p => Math.abs(p - m.endBeat) < E)) {
                errors.push(`${this._measureName(m)}: a barra (beat ${fmt(m.endBeat)}) cai no MEIO de uma nota`
                    + ' — atravessar a barra exige ligadura');
            }
        });
        if (ms.length && fim > E) {
            const ultimo = ms[ms.length - 1];
            if (Math.abs(fim - ultimo.endBeat) > E) {
                errors.push(`a peça termina no beat ${fmt(fim)}, no meio do ${this._measureName(ultimo)}`
                    + ` (a barra cairia em ${fmt(ultimo.endBeat)})`);
            }
        }

        return { ok: errors.length === 0, errors };
    }
}

// Disponibiliza globalmente
if (typeof window !== 'undefined') window.Score = Score;



// ============================================
// music/MidiFile.js
// ============================================
/**
 * MidiFile - parser PURO de Standard MIDI File (bytes → eventos). Sem DOM, sem áudio.
 *
 * Etapa 4 do jogo de música real (docs/MUSICA-REAL-PLANO.md): o aluno carrega um `.mid`
 * e ele vira lição de leitura. Este arquivo faz SÓ a primeira metade — ler os bytes.
 * Quem decide figura, clave, enarmonia e compasso é o `ScoreBuilder`.
 *
 * 🔴 TICK E PPQ MORREM AQUI. Tudo que sai daqui está em SEMÍNIMAS (beats, float), a
 * mesma unidade do `Score`. Nada fora deste arquivo vê tick — é o que deixa o Score
 * curado (escrito à mão) e o importado serem o MESMO tipo de coisa.
 *
 * 🔴 O ARQUIVO NUNCA SAI DO DEVICE. Isto roda no browser do aluno, sem upload nenhum.
 *
 * 🔴 ERRO É CÓDIGO, NÃO FRASE. Esta classe é pura e o app é trilíngue: recusa vem como
 * `{code, params}` (`MidiFile.Fail`), e quem tem tela traduz. A `message` em português
 * existe só para log e teste.
 *
 * O que o formato dá (e o que ele NÃO dá) está em docs/MUSICA-REAL-PLANO.md §2 — em
 * resumo: altura e tempo sim; clave, enarmonia e figura não.
 */
class MidiFile {

    /** Teto de sanidade: um `.mid` de partitura tem alguns KB; 512 KB já é exagero. */
    static MAX_BYTES = 512 * 1024;

    /** Teto de eventos lidos, para que um arquivo corrompido não trave a aba. */
    static MAX_EVENTS = 200000;

    /**
     * Recusa legível. `code` é chave de i18n (`song.import.err.<code>`), `params` são os
     * valores a interpolar. Nunca montar frase aqui — a tela é que sabe o idioma.
     */
    static Fail = class MidiFileError extends Error {
        constructor(code, params = {}, ptMessage = '') {
            super(ptMessage || code);
            this.name = 'MidiFileError';
            this.code = code;
            this.params = params;
        }
    };

    /**
     * @param {ArrayBuffer|Uint8Array} buffer - bytes do arquivo
     * @returns {{format:number, ppq:number, trackCount:number,
     *            tempoMap:Array<{beat:number,bpm:number}>,
     *            timeSignatures:Array<{beat:number,beats:number,noteValue:number}>,
     *            keySignature:{sharps:number,minor:boolean},
     *            endBeat:number,
     *            tracks:Array<{index:number,name:string,instrument:string,
     *                          channels:Array<number>,
     *                          events:Array<Object>}>}}
     */
    static parse(buffer) {
        const bytes = (buffer instanceof Uint8Array) ? buffer : new Uint8Array(buffer);
        if (bytes.length > MidiFile.MAX_BYTES) {
            throw new MidiFile.Fail('tooBig',
                { kb: Math.round(bytes.length / 1024), max: MidiFile.MAX_BYTES / 1024 },
                `arquivo grande demais (${Math.round(bytes.length / 1024)} KB)`);
        }
        if (bytes.length < 14 || MidiFile._str(bytes, 0, 4) !== 'MThd') {
            throw new MidiFile.Fail('notMidi', {}, 'não é um arquivo MIDI (falta o cabeçalho MThd)');
        }

        const headerLen = MidiFile._u32(bytes, 4);
        const format = MidiFile._u16(bytes, 8);
        const trackCount = MidiFile._u16(bytes, 10);
        const division = MidiFile._u16(bytes, 12);

        // Formato 2 = padrões independentes, sem linha do tempo comum: não é uma peça.
        if (format === 2) {
            throw new MidiFile.Fail('format2', {}, 'MIDI formato 2 (padrões independentes) não vira partitura');
        }
        // 🔴 Divisão SMPTE (bit 15 ligado) conta em quadros de vídeo, não em semínimas —
        // não existe "beat" nela sem o andamento, e o arquivo vira gravação, não partitura.
        // É raríssimo em arquivo de música; recusar é mais honesto que adivinhar.
        if (division & 0x8000) {
            throw new MidiFile.Fail('smpte', {}, 'arquivo em divisão SMPTE (quadros de vídeo), não em semínimas');
        }
        const ppq = division;
        if (!(ppq > 0)) {
            throw new MidiFile.Fail('badPpq', {}, 'divisão de tempo inválida no cabeçalho');
        }

        const tracks = [];
        const tempoMap = [];
        const timeSignatures = [];
        const keySignatures = [];
        let endBeat = 0;
        let budget = MidiFile.MAX_EVENTS;

        let pos = 8 + headerLen; // o cabeçalho declara o próprio tamanho (6, mas não confie)
        while (pos + 8 <= bytes.length && tracks.length < 256) {
            const id = MidiFile._str(bytes, pos, 4);
            const len = MidiFile._u32(bytes, pos + 4);
            pos += 8;
            const end = Math.min(pos + len, bytes.length);
            // Pedaço desconhecido entre trilhas é legal no formato: pula em silêncio.
            if (id !== 'MTrk') { pos = end; continue; }

            const track = {
                index: tracks.length, name: '', instrument: '',
                channels: [], events: []
            };
            const r = MidiFile._readTrack(bytes, pos, end, ppq, track, budget);
            budget = r.budget;
            tempoMap.push(...r.tempos);
            timeSignatures.push(...r.timeSigs);
            keySignatures.push(...r.keySigs);
            endBeat = Math.max(endBeat, r.endBeat);
            tracks.push(track);
            pos = end;
        }

        if (!tracks.length) {
            throw new MidiFile.Fail('noTracks', {}, 'arquivo sem nenhuma trilha (MTrk)');
        }

        return {
            format, ppq, trackCount: trackCount || tracks.length,
            // Metas de andamento/fórmula/armadura valem para a PEÇA INTEIRA, mesmo quando
            // vêm numa trilha só (é o que o formato 1 faz). Por isso são içadas para cá.
            tempoMap: MidiFile._dedupe(tempoMap, 'bpm'),
            timeSignatures: MidiFile._dedupe(timeSignatures, 'beats', 'noteValue'),
            // Ordena por BEAT: o array vem concatenado na ordem em que as TRILHAS
            // aparecem, então a armadura do meio da peça (numa trilha lida antes) vencia
            // a do começo. Vale a primeira no TEMPO — a peça só tem uma armadura no v1.
            keySignature: keySignatures.length
                ? (() => { const k = keySignatures.slice().sort((a, b) => a.beat - b.beat)[0];
                           return { sharps: k.sharps, minor: k.minor }; })()
                : null,
            endBeat,
            tracks
        };
    }

    // ---------- leitura de uma trilha ----------

    static _readTrack(bytes, pos, end, ppq, track, budget) {
        const tempos = [], timeSigs = [], keySigs = [];
        let tick = 0;
        let running = 0;   // status corrente (running status: o byte pode ser omitido)
        let endBeat = 0;

        while (pos < end && budget > 0) {
            const dt = MidiFile._varint(bytes, pos);
            pos = dt.pos;
            tick += dt.value;
            if (pos >= end) break;

            let status = bytes[pos];
            if (status & 0x80) { pos++; if (status < 0xF0) running = status; }
            else { status = running; }   // running status: reusa o último status de canal
            if (!status) break;          // lixo antes de qualquer status: para a trilha

            const beat = tick / ppq;

            if (status === 0xFF) {                       // meta-evento
                const type = bytes[pos++];
                const l = MidiFile._varint(bytes, pos); pos = l.pos;
                const data = bytes.subarray(pos, pos + l.value);
                pos += l.value;
                budget--;

                if (type === 0x51 && data.length >= 3) {          // andamento (µs/semínima)
                    const us = (data[0] << 16) | (data[1] << 8) | data[2];
                    if (us > 0) tempos.push({ beat, bpm: 60000000 / us });
                } else if (type === 0x58 && data.length >= 2) {   // fórmula de compasso
                    timeSigs.push({ beat, beats: data[0], noteValue: Math.pow(2, data[1]) });
                } else if (type === 0x59 && data.length >= 2) {   // armadura
                    // O byte é com sinal: 0xFF = 1 bemol.
                    const sharps = (data[0] << 24) >> 24;
                    keySigs.push({ beat, sharps, minor: data[1] === 1 });
                } else if (type === 0x03 && !track.name) {
                    track.name = MidiFile._text(data);
                } else if (type === 0x04 && !track.instrument) {
                    track.instrument = MidiFile._text(data);
                } else if (type === 0x2F) {                       // fim da trilha
                    break;
                }
                continue;
            }

            if (status === 0xF0 || status === 0xF7) {    // sysex: pula pelo tamanho declarado
                const l = MidiFile._varint(bytes, pos); pos = l.pos + l.value;
                continue;
            }

            // 🔴 Status de SISTEMA (0xF1-0xFE) não tem canal e tem tamanho próprio. Caíam
            // no `else` de 2 bytes lá embaixo, e um único 0xF8 (MIDI clock, ZERO bytes de
            // dado) dessincronizava a trilha: medido, o arquivo `60@0 · 62@1` virava
            // `60@0 · 80@8,79` — uma nota que não existe em lugar nenhum, sem aviso.
            if (status >= 0xF1) {
                pos += (status === 0xF2) ? 2 : (status === 0xF1 || status === 0xF3) ? 1 : 0;
                continue;
            }

            const kind = status & 0xF0;
            const channel = status & 0x0F;
            budget--;

            if (kind === 0x90 || kind === 0x80) {
                const midi = bytes[pos++], vel = bytes[pos++];
                // 🔴 Note On com velocity 0 É note off. Metade dos arquivos do mundo usa
                // essa forma (ela é o que permite o running status durar a peça inteira);
                // tratá-la como ataque produziria notas de duração zero e nota repetida.
                const on = (kind === 0x90 && vel > 0);
                track.events.push({ beat, type: on ? 'noteOn' : 'noteOff', midi, velocity: vel, channel });
                if (track.channels.indexOf(channel) < 0) track.channels.push(channel);
                endBeat = Math.max(endBeat, beat);
            } else if (kind === 0xC0 || kind === 0xD0) {
                pos += 1;                                 // program change / aftertouch de canal
            } else {
                pos += 2;                                 // demais eventos de canal: 2 dados
            }
        }

        return { tempos, timeSigs, keySigs, endBeat, budget };
    }

    // ---------- utilidades de bytes ----------

    static _u16(b, i) { return (b[i] << 8) | b[i + 1]; }
    static _u32(b, i) { return ((b[i] << 24) | (b[i + 1] << 16) | (b[i + 2] << 8) | b[i + 3]) >>> 0; }
    static _str(b, i, n) {
        let s = '';
        for (let k = 0; k < n; k++) s += String.fromCharCode(b[i + k]);
        return s;
    }

    /**
     * Texto de meta-evento. O padrão SMF é anterior ao Unicode e não declara codificação,
     * mas MuseScore, Sibelius, Finale e Logic gravam UTF-8 hoje — lido como Latin-1,
     * "Violão Solo" virava "ViolÃ£o Solo" no seletor de faixa de um app em português e
     * espanhol. Tenta UTF-8 estrito e só cai para Latin-1 quando ele recusa.
     */
    static _text(data) {
        let s = null;
        try {
            if (typeof TextDecoder !== 'undefined') {
                s = new TextDecoder('utf-8', { fatal: true }).decode(data);
            }
        } catch (e) { s = null; }
        if (s == null) {
            s = '';
            for (let i = 0; i < data.length; i++) s += String.fromCharCode(data[i]);
        }
        return s.replace(/[\x00-\x1f]/g, '').trim();
    }

    /** Inteiro de tamanho variável (7 bits por byte, o 8º diz "tem mais"). */
    static _varint(b, i) {
        let value = 0, n = 0;
        while (i < b.length && n < 4) {
            const byte = b[i++]; n++;
            value = (value << 7) | (byte & 0x7f);
            if (!(byte & 0x80)) break;
        }
        return { value, pos: i };
    }

    /**
     * Ordena por beat e descarta repetição sem mudança — arquivos de sequenciador
     * costumam reescrever o mesmo andamento em toda barra, e cada entrada dessas vira
     * um trecho a mais no `beatToSeconds`.
     */
    static _dedupe(list, ...fields) {
        const out = [];
        list.sort((a, b) => a.beat - b.beat).forEach(item => {
            const prev = out[out.length - 1];
            if (prev && fields.every(f => Math.abs(prev[f] - item[f]) < 1e-9)) return;
            if (prev && Math.abs(prev.beat - item.beat) < 1e-9) { out[out.length - 1] = item; return; }
            out.push(item);
        });
        return out;
    }
}

// Disponibiliza globalmente
if (typeof window !== 'undefined') window.MidiFile = MidiFile;



// ============================================
// music/ScoreBuilder.js
// ============================================
/**
 * ScoreBuilder - eventos de MIDI → `Score` desenhável. Puro (sem DOM, sem áudio).
 *
 * É a segunda metade do importador (a primeira é `MidiFile`, que só lê bytes). Aqui
 * moram as DECISÕES que o formato MIDI não tem como dar (docs/MUSICA-REAL-PLANO.md §2):
 *
 *   🔴 figura rítmica → sai da QUANTIZAÇÃO (grade de 1/16, com 1/32 como segunda tentativa)
 *   🔴 clave         → `Notation.inferClef` (pelo âmbito) — o formato não tem clave
 *   🔴 enarmonia     → `Notation.spell` pela ARMADURA (que também pode faltar: `Key.infer`)
 *   🔴 anacruse      → deduzida do RESTO do comprimento da peça
 *
 * 🔴 A PARTITURA É A VERDADE, O MIDI É A FONTE (§3 do plano). O que não cabe na grade
 * dentro da tolerância NÃO vira pauta torta: o arquivo é RECUSADO com diagnóstico. Um
 * `.mid` de gravação ao vivo não é partitura, e fingir que é produziria um jogo que
 * cobra do aluno um ritmo que ninguém escreveu.
 *
 * 🔴 Reduz para UMA VOZ (a melodia = a linha de cima). Grande pauta e acorde são a
 * Etapa 5. A redução é declarada no `report`, nunca silenciosa.
 *
 * 🔴 Erro e aviso são CÓDIGO + params (a tela é que traduz — o app é trilíngue).
 * Recusa é exceção `MidiFile.Fail`; ressalva é linha em `report.warnings`.
 */
class ScoreBuilder {

    /** Grades tentadas, em ordem. 1/16 resolve a esmagadora maioria; 1/32 salva quem
     *  escreveu fusas. Mais fino que isso não é partitura de estudo, é gravação. */
    static GRIDS = [0.25, 0.125];

    /**
     * Desvio tolerado até a grade, como fração dela (0,15 × 1/16 ≈ 9 ms a 96 bpm).
     * 🔴 O número é APERTADO de propósito: um arquivo exportado de editor de partitura
     * erra 2 ou 3 ticks (arredondamento), e um humano tocando erra dezenas de vezes mais.
     * Com a tolerância larga (0,35) a TERCINA passava — 1/3 caía em 3/8 e a peça saía
     * com um ritmo pontuado que ninguém escreveu. Quiáltera é recusa, não arredondamento.
     */
    static TOL_RATIO = 0.15;

    /** Acima desta fração de notas fora da grade, o arquivo é gravação ao vivo. */
    static OFFGRID_RATIO = 0.05;

    /** Tetos de sanidade (o plano §5, Etapa 4). Acima disso, mensagem clara — sem travar. */
    static MAX_NOTES = 3000;      // depois da redução: é o que o aluno vai LER
    static MAX_RAW_NOTES = 20000; // antes: só para não travar a aba com arquivo absurdo
    static MAX_MEASURES = 300;

    /** Canal 10 (índice 9) é percussão no General MIDI: som sem altura, não é leitura. */
    static DRUM_CHANNEL = 9;

    /**
     * Ataques dentro desta janela (em semínimas) são UM ataque só. 0,06 ≈ 37 ms a 96 bpm:
     * cobre o espalhamento de acorde rolado e a apojatura que os editores exportam, e fica
     * abaixo do menor passo de grade (1/32 = 0,125), então nunca engole duas notas reais.
     */
    static ONSET_WINDOW = 0.06;

    static EPS = 1e-6;

    // =====================================================================
    // 1. Leitura das trilhas (o que a tela mostra ANTES de escolher)
    // =====================================================================

    /**
     * Retrato de cada trilha, para a tela de importação escolher qual estudar.
     * @param {Object} midi - saída de `MidiFile.parse`
     */
    static analyze(midi) {
        const tracks = midi.tracks.map(t => {
            const notes = ScoreBuilder._pairNotes(t);
            const midis = notes.map(n => n.midi);
            const drums = t.channels.length > 0
                && t.channels.every(c => c === ScoreBuilder.DRUM_CHANNEL);
            return {
                index: t.index,
                name: t.name || t.instrument || '',
                noteCount: notes.length,
                range: midis.length ? { min: Math.min(...midis), max: Math.max(...midis) } : null,
                median: ScoreBuilder._median(midis),
                polyphony: ScoreBuilder._polyphonyRatio(notes),
                drums,
                channels: t.channels.slice()
            };
        });

        return {
            tracks,
            suggestedTrack: ScoreBuilder._suggestTrack(tracks),
            bpm: midi.tempoMap.length ? midi.tempoMap[0].bpm : 90,
            timeSignature: midi.timeSignatures.length
                ? midi.timeSignatures[0] : { beat: 0, beats: 4, noteValue: 4 },
            keySignature: midi.keySignature,
            tempoChanges: Math.max(0, midi.tempoMap.length - 1),
            timeChanges: Math.max(0, midi.timeSignatures.length - 1)
        };
    }

    /**
     * Qual trilha é "a melodia". Heurística, e por isso a tela deixa trocar: mais notas
     * conta, ser aguda conta, e ser polifônica DESCONTA (acompanhamento costuma ser bloco
     * de acordes). Percussão nunca é sugerida — não tem altura para ler.
     */
    static _suggestTrack(tracks) {
        let best = -1, bestScore = -Infinity;
        tracks.forEach(t => {
            if (t.drums || t.noteCount < 2) return;
            const score = Math.min(t.noteCount, 400) / 400
                + (1 - t.polyphony) * 0.8
                + ((t.median || 60) - 48) / 48 * 0.4;
            if (score > bestScore) { bestScore = score; best = t.index; }
        });
        if (best < 0) { // só percussão / trilhas vazias: devolve a que tiver notas
            const any = tracks.find(t => t.noteCount > 0);
            best = any ? any.index : 0;
        }
        return best;
    }

    /**
     * Pareia Note On/Off de uma trilha → notas com duração, em SEMÍNIMAS.
     * Pilha por (canal, altura): a mesma nota pode reentrar antes de sair (pedal, legato
     * de sequenciador) e parear com o Off errado encurtaria a nota errada.
     */
    static _pairNotes(track) {
        const open = new Map();
        const out = [];
        track.events.forEach(ev => {
            if (ev.type !== 'noteOn' && ev.type !== 'noteOff') return;
            const key = ev.channel * 128 + ev.midi;
            if (ev.type === 'noteOn') {
                if (!open.has(key)) open.set(key, []);
                open.get(key).push(ev);
            } else {
                const stack = open.get(key);
                if (!stack || !stack.length) return; // Off órfão: arquivo sujo, ignora
                const on = stack.shift();
                if (ev.beat > on.beat + ScoreBuilder.EPS) {
                    out.push({ beat: on.beat, duration: ev.beat - on.beat, midi: on.midi,
                               velocity: on.velocity, channel: on.channel });
                }
            }
        });
        // Notas sem Off (trilha truncada): valem até o fim conhecido, nunca somem caladas.
        open.forEach(stack => stack.forEach(on => {
            out.push({ beat: on.beat, duration: 1, midi: on.midi,
                       velocity: on.velocity, channel: on.channel });
        }));
        return out.sort((a, b) => a.beat - b.beat || b.midi - a.midi);
    }

    /**
     * 🔴 REGRA ÚNICA de quem fica quando dois ataques disputam o MESMO instante.
     *
     * Duas situações musicais diferentes chegam aqui e pedem respostas opostas:
     *   - **acorde/arpejo**: as notas duram o mesmo → fica a DE CIMA (é a melodia);
     *   - **apojatura**: uma dura uma fração da outra → fica a LONGA (a curta é ornamento,
     *     e ornamento não tem figura na grade — escrevê-lo no lugar da nota principal é
     *     trocar a melodia pelo enfeite).
     *
     * Por isso a regra não é "a mais aguda" nem "a mais longa", e sim: se uma é ornamento
     * da outra (dura menos da metade), vence a longa; senão, vence a aguda.
     *
     * @returns {Object} o vencedor (um dos dois argumentos, por identidade)
     */
    static _winner(a, b) {
        const ornament = (x, y) => x.duration < y.duration * 0.5;
        if (ornament(a, b)) return b;
        if (ornament(b, a)) return a;
        return a.midi > b.midi ? a : b;
    }

    /** Fração de notas que soam junto com outra (0 = melodia pura, 1 = bloco de acordes). */
    static _polyphonyRatio(notes) {
        if (notes.length < 2) return 0;
        let overlapped = 0;
        for (let i = 0; i < notes.length; i++) {
            const a = notes[i];
            for (let j = i + 1; j < notes.length && notes[j].beat < a.beat + a.duration - ScoreBuilder.EPS; j++) {
                overlapped++; break;
            }
        }
        return overlapped / notes.length;
    }

    static _median(xs) {
        if (!xs || !xs.length) return null;
        const s = xs.slice().sort((a, b) => a - b);
        return s.length % 2 ? s[(s.length - 1) / 2] : (s[s.length / 2 - 1] + s[s.length / 2]) / 2;
    }

    // =====================================================================
    // 2. Construção do Score
    // =====================================================================

    /**
     * @param {Object} midi - saída de `MidiFile.parse`
     * @param {Object} [opts] - {trackIndex, title, grid}
     * @returns {{score:Score, report:Object}}
     * @throws {MidiFile.Fail} arquivo que não vira partitura (código + params p/ a tela)
     */
    static build(midi, opts = {}) {
        const Fail = window.MidiFile.Fail;
        const warnings = [];
        const analysis = ScoreBuilder.analyze(midi);
        const trackIndex = (opts.trackIndex != null) ? opts.trackIndex : analysis.suggestedTrack;
        const track = midi.tracks[trackIndex];
        if (!track) throw new Fail('noSuchTrack', { index: trackIndex }, `trilha ${trackIndex} não existe`);

        const info = analysis.tracks[trackIndex];
        if (info.drums) warnings.push({ code: 'drums', params: {} });

        let raw = ScoreBuilder._pairNotes(track);
        if (!raw.length) throw new Fail('emptyTrack', {}, 'a trilha escolhida não tem nenhuma nota');

        // 🔴 PERCUSSÃO MISTURADA na mesma trilha (o caso do formato 0, que é o `.mid` mais
        // comum da internet: tudo numa trilha só). O `info.drums` acima só é verdadeiro
        // quando a trilha INTEIRA é do canal 10 — então, misturada, ela passava batida, e
        // como triângulo e prato são "notas agudas", a linha de cima virava a percussão:
        // uma lição de leitura com oito batidas de triângulo. Som sem altura não se lê na
        // pauta, então ele sai antes de qualquer outra decisão.
        const pitched = raw.filter(n => n.channel !== ScoreBuilder.DRUM_CHANNEL);
        if (pitched.length && pitched.length < raw.length) {
            warnings.push({ code: 'drumsFiltered', params: { dropped: raw.length - pitched.length } });
            raw = pitched;
        }
        // 🔴 O teto vale para a MELODIA, não para o arquivo. Contado no cru, um piano a
        // cinco vozes com 3.500 notas era recusado mesmo tendo 400 na linha de cima — que
        // é exatamente o caso que o v1 diz saber tratar. O cru só tem um teto de sanidade,
        // contra travar a aba.
        if (raw.length > ScoreBuilder.MAX_RAW_NOTES) {
            throw new Fail('tooManyNotes',
                { notes: raw.length, max: ScoreBuilder.MAX_RAW_NOTES },
                `${raw.length} notas (o teto é ${ScoreBuilder.MAX_RAW_NOTES})`);
        }

        // ---- redução a uma voz: a linha de cima ----
        const reduced = ScoreBuilder._topVoice(raw);
        if (reduced.dropped > 0) {
            warnings.push({ code: 'polyphonyReduced', params: { dropped: reduced.dropped } });
        }
        let notes = reduced.notes;
        if (notes.length > ScoreBuilder.MAX_NOTES) {
            throw new Fail('tooManyNotes',
                { notes: notes.length, max: ScoreBuilder.MAX_NOTES },
                `${notes.length} notas na melodia (o teto é ${ScoreBuilder.MAX_NOTES})`);
        }

        // ---- grade: tenta 1/16 e, se não couber, 1/32 ----
        const forced = opts.grid ? [opts.grid] : ScoreBuilder.GRIDS;
        let fit = null;
        for (const grid of forced) {
            const f = ScoreBuilder._quantize(notes, grid);
            if (!fit || f.offGrid.length < fit.offGrid.length) fit = f;
            if (f.offGrid.length === 0
                || f.offGrid.length / notes.length <= ScoreBuilder.OFFGRID_RATIO) { fit = f; break; }
        }
        const offRatio = fit.offGrid.length / notes.length;
        if (fit.offGrid.length > 3 && offRatio > ScoreBuilder.OFFGRID_RATIO) {
            // Diagnóstico específico vale mais que um genérico: quem tem tercina no
            // arquivo precisa saber que é a TERCINA, não que "tocou torto".
            if (ScoreBuilder._looksLikeTuplet(fit.offGrid)) {
                throw new Fail('tuplets', { percent: Math.round(offRatio * 100) },
                    'a peça tem quiálteras (tercinas) — fora do escopo do importador');
            }
            // 🔴 A recusa É a feature (§3 do plano). Um MIDI tocado ao vivo tem ataque em
            // 431 ticks de uma grade de 480: não existe figura para isso, e "arredondar
            // assim mesmo" produziria uma partitura que ninguém escreveu e que o placar
            // depois cobraria do aluno.
            throw new Fail('offGrid', {
                percent: Math.round(offRatio * 100),
                first: fit.offGrid[0].beat.toFixed(2)
            }, `${Math.round(offRatio * 100)}% das notas fora da grade — parece gravação ao vivo`);
        }
        notes = fit.notes;
        if (fit.merged > 0) warnings.push({ code: 'mergedNotes', params: { merged: fit.merged } });
        // Poucas notas fora da grade não derrubam o arquivo (seria severo demais), mas
        // TAMBÉM não podem sair caladas: elas foram movidas, e o aluno lê um ritmo que o
        // arquivo não tem exatamente. Até 3 notas passavam em silêncio.
        if (fit.offGrid.length > 0) {
            warnings.push({ code: 'snapped', params: { count: fit.offGrid.length } });
        }

        // ---- métrica ----
        const ts = analysis.timeSignature;
        const q = window.Notation.quartersPerMeasure(ts);
        if (!(q > 0)) throw new Fail('badTimeSignature', { beats: ts.beats, value: ts.noteValue },
                                     `fórmula de compasso inválida (${ts.beats}/${ts.noteValue})`);
        if (analysis.timeChanges > 0) {
            // Fórmula que muda no meio é notável, mas cada troca precisa cair numa barra —
            // e o v1 desenha a peça inteira com a fórmula inicial. Declarar > adivinhar.
            warnings.push({ code: 'timeChanges', params: { count: analysis.timeChanges } });
        }
        if (analysis.tempoChanges > 0) {
            warnings.push({ code: 'tempoChanges', params: { count: analysis.tempoChanges } });
        }

        const lastEnd = notes.reduce((m, n) => Math.max(m, n.beat + n.duration), 0);
        const pickupBeats = ScoreBuilder._pickPickup(notes, lastEnd, q);

        const endPadded = ScoreBuilder._ceilToBar(lastEnd, pickupBeats, q);
        const measureCount = Math.ceil((endPadded - pickupBeats) / q) + (pickupBeats ? 1 : 0);
        if (measureCount > ScoreBuilder.MAX_MEASURES) {
            throw new Fail('tooManyMeasures',
                { measures: measureCount, max: ScoreBuilder.MAX_MEASURES },
                `${measureCount} compassos (o teto é ${ScoreBuilder.MAX_MEASURES})`);
        }

        // ---- ladrilho: nota, pausa nos vãos, barra respeitada ----
        const bars = ScoreBuilder._barlines(pickupBeats, q, endPadded);
        // Tempo em semínimas: 1 nos compassos simples, 1,5 nos compostos (6/8, 9/8, 12/8),
        // onde a hierarquia métrica é ternária. É o que a grafia usa para cortar e ligar.
        // 🔴 FONTE ÚNICA (`Notation.metricBeat`) — a MESMA que o beam do ScoreRenderer e a
        // grade do editor de cifras leem. Esta era a terceira cópia da regra escrita à mão;
        // as três concordavam byte a byte, e era exatamente esse o perigo: no dia em que a
        // regra mudar (6/4 é o candidato óbvio), o importador cortaria a ligadura e escreveria
        // a pausa por uma métrica, e a página desenharia por outra.
        const beatUnit = window.Notation.metricBeat(ts);
        const events = [];
        let cursor = 0;
        let tiedAcross = 0;
        notes.forEach(n => {
            if (n.beat > cursor + ScoreBuilder.EPS) ScoreBuilder._pushRests(events, cursor, n.beat, bars, beatUnit);
            const segs = ScoreBuilder._split(n.beat, n.beat + n.duration, bars, beatUnit);
            events.push({
                type: 'note', beat: n.beat, duration: n.duration, midi: n.midi,
                tie: segs.length > 1 ? segs : null
            });
            if (segs.length > 1) tiedAcross++;
            cursor = n.beat + n.duration;
        });
        if (endPadded > cursor + ScoreBuilder.EPS) ScoreBuilder._pushRests(events, cursor, endPadded, bars, beatUnit);

        // ---- tonalidade: a do arquivo, ou deduzida (ver Key.infer) ----
        const key = midi.keySignature
            ? { sharps: midi.keySignature.sharps, minor: !!midi.keySignature.minor }
            : window.Key.infer(notes.map(n => n.midi));
        if (!midi.keySignature) warnings.push({ code: 'keyInferred', params: { sharps: key.sharps } });

        const data = {
            title: opts.title || track.name || '',
            source: 'imported',
            keySignature: key,
            timeSignatures: [{ beat: 0, beats: ts.beats, noteValue: ts.noteValue }],
            tempoMap: (midi.tempoMap.length ? midi.tempoMap : [{ beat: 0, bpm: 90 }])
                .map(t => ({ beat: t.beat, bpm: Math.round(t.bpm * 100) / 100 })),
            pickupBeats,
            staves: [{ clef: null, voices: [{ notes: events }] }] // clef null = inferida no annotate
        };

        const score = new window.Score(data);
        const v = score.validate();
        if (!v.ok) {
            // Chegar aqui é BUG NOSSO, não arquivo ruim: o ladrilho acima existe justamente
            // para satisfazer o `validate`. Falha alto, com a lista, em vez de entregar uma
            // partitura que o desenho e o placar vão interpretar cada um do seu jeito.
            throw new Fail('internal', { detail: v.errors.slice(0, 3).join(' · ') },
                           'partitura montada não passou na validação:\n  ' + v.errors.slice(0, 8).join('\n  '));
        }

        return {
            score,
            report: {
                trackIndex,
                trackName: info.name,
                notes: notes.length,
                measures: measureCount,
                bpm: Math.round(analysis.bpm),
                timeSignature: { beats: ts.beats, noteValue: ts.noteValue },
                keySignature: key,
                clef: score.staves[0].clef,
                range: score.midiRange(),
                grid: fit.grid,
                pickupBeats,
                tiedAcross,
                quantized: fit.moved,
                warnings
            }
        };
    }

    /** Conveniência: bytes → {score, report}. */
    static fromBytes(buffer, opts = {}) {
        return ScoreBuilder.build(window.MidiFile.parse(buffer), opts);
    }

    // =====================================================================
    // 3. Peças da construção
    // =====================================================================

    /**
     * Reduz polifonia à LINHA DE CIMA. Um ataque só entra se for pelo menos tão agudo
     * quanto o que já está soando — é isso que faz o acompanhamento POR BAIXO de uma nota
     * longa da melodia desaparecer em vez de virar nota nova. E a nota que fica é cortada
     * na entrada da seguinte (uma voz é monofônica; o `Score.validate` cobra isso).
     */
    static _topVoice(raw) {
        const E = ScoreBuilder.EPS;
        const byOnset = [];
        raw.forEach(n => {
            const g = byOnset[byOnset.length - 1];
            // Ataques praticamente juntos são UM ataque só (acorde, arpejo curto,
            // apojatura). A janela era 0,02 — menor que o espalhamento com que os editores
            // exportam acorde rolado (30-50 ms ≈ 0,05 batida), então o acorde escapava
            // do grupo e a nota de cima acabava descartada mais adiante, na quantização.
            if (g && Math.abs(g.beat - n.beat) < ScoreBuilder.ONSET_WINDOW) {
                if (ScoreBuilder._winner(n, g) === n) { g.midi = n.midi; g.duration = n.duration; }
                g.dropped++;
                return;
            }
            byOnset.push({ beat: n.beat, duration: n.duration, midi: n.midi, dropped: 0 });
        });

        const out = [];
        let dropped = 0;
        byOnset.forEach(n => {
            dropped += n.dropped;
            const prev = out[out.length - 1];
            if (prev && n.beat < prev.beat + prev.duration - E && n.midi < prev.midi) {
                dropped++; return;      // soa por baixo da melodia: é acompanhamento
            }
            if (prev && n.beat < prev.beat + prev.duration - E) {
                prev.duration = n.beat - prev.beat;   // legato/sobreposição: corta na entrada
            }
            out.push({ beat: n.beat, duration: n.duration, midi: n.midi });
        });
        return { notes: out.filter(n => n.duration > E), dropped };
    }

    /**
     * Encaixa na grade. Devolve as notas movidas e a LISTA das que não couberam — quem
     * decide recusar é o `build` (a política mora num lugar só).
     */
    static _quantize(notes, grid) {
        const tol = grid * ScoreBuilder.TOL_RATIO;
        const snap = (b) => Math.round(b / grid) * grid;
        const offGrid = [];
        let moved = 0, merged = 0;
        const out = [];

        notes.forEach(n => {
            const b = snap(n.beat);
            if (Math.abs(n.beat - b) > tol) offGrid.push({ beat: n.beat, midi: n.midi });
            if (Math.abs(n.beat - b) > ScoreBuilder.EPS) moved++;
            // Duração: nunca zero — nota curtíssima (staccato) vira a menor figura da grade.
            let d = Math.max(grid, snap(n.duration));
            const prev = out[out.length - 1];
            if (prev && Math.abs(prev.beat - b) < ScoreBuilder.EPS) {
                // 🔴 Duas notas caíram no mesmo ponto da grade. Ficar com "a primeira"
                // APAGAVA a melodia: uma apojatura (0,06 batida) antes da nota principal
                // é o que todo editor exporta para acciaccatura, e a nota real virava
                // 1,75 batida de pausa. Quem fica é decidido pela mesma regra do
                // `_topVoice` — e a duração é a do vencedor, não a do que chegou antes.
                merged++;
                if (ScoreBuilder._winner(n, prev) === n) { prev.midi = n.midi; prev.duration = d; }
                else prev.duration = Math.max(prev.duration, d);
                return;
            }
            if (prev && prev.beat + prev.duration > b + ScoreBuilder.EPS) {
                prev.duration = b - prev.beat;   // a quantização criou sobreposição: apara
                if (prev.duration <= ScoreBuilder.EPS) { out.pop(); merged++; }
            }
            out.push({ beat: b, duration: d, midi: n.midi });
        });

        return { notes: out, grid, offGrid, moved, merged };
    }

    /**
     * Onde cai a primeira barra. O formato MIDI não diz — e errar isso desalinha a peça
     * INTEIRA, da primeira à última página.
     *
     * A hipótese vem do RESTO do comprimento (25 semínimas em 3/4 = 8 compassos + 1 tempo
     * de entrada), mas 🔴 não pode ser aceita de olhos fechados: basta a última nota estar
     * cortada, ou haver lixo no fim, para o resto virar um número qualquer. Em um `.mid`
     * real de teste isso deu anacruse de 0,75 e a peça saiu com LIGADURA EM 173 DAS 183
     * NOTAS — a assinatura visível de barra no lugar errado.
     *
     * O desempate é o próprio sintoma: vence a leitura em que menos notas atravessam a
     * barra (e, no empate, aquela em que mais ataques CAEM na barra). Música respeita a
     * barra; ruído de arredondamento, não.
     */
    static _pickPickup(notes, lastEnd, q) {
        const E = ScoreBuilder.EPS;
        const rest = lastEnd % q;
        const cands = [0];
        if (rest > E && q - rest > E) cands.push(rest);
        if (cands.length === 1) return 0;

        let best = 0, bestScore = null;
        cands.forEach(p => {
            let crossings = 0, onBar = 0;
            notes.forEach(n => {
                const from = (n.beat - p) / q, to = (n.beat + n.duration - p) / q;
                if (Math.abs(from - Math.round(from)) < 1e-9) onBar++;
                if (Math.floor(to - 1e-9) > Math.floor(from + 1e-9)) crossings++;
            });
            const score = { crossings, onBar };
            if (!bestScore || crossings < bestScore.crossings
                || (crossings === bestScore.crossings && onBar > bestScore.onBar)) {
                bestScore = score; best = p;
            }
        });
        return best;
    }

    /**
     * Os desvios são de QUIÁLTERA (divisão em 3) e não de execução humana? A assinatura
     * é clara: ataque em múltiplo de 1/3 (ou 1/6) de semínima, que nenhuma grade binária
     * alcança. Serve só para escolher a MENSAGEM — a recusa já está decidida.
     */
    static _looksLikeTuplet(offGrid) {
        if (!offGrid.length) return false;
        // 🔴 A janela é ESTREITA (0,02) e a maioria exigida é ALTA (70%) porque a divisão
        // em 3 é densa: com 0,05 de folga, um terço da reta numérica "parece tercina" e a
        // gravação ao vivo saía diagnosticada como quiáltera.
        const third = offGrid.filter(o => {
            const f = Math.abs(o.beat * 3 - Math.round(o.beat * 3));
            const s = Math.abs(o.beat * 6 - Math.round(o.beat * 6));
            return f < 0.02 || s < 0.02;
        }).length;
        return third / offGrid.length >= 0.7;
    }

    /** Beats das barras, da 1ª até o fim (inclui o fim). */
    static _barlines(pickupBeats, q, endBeat) {
        const bars = [];
        let b = pickupBeats > ScoreBuilder.EPS ? pickupBeats : q;
        if (pickupBeats > ScoreBuilder.EPS) bars.push(pickupBeats);
        for (; b < endBeat - ScoreBuilder.EPS; b += q) {
            if (b > ScoreBuilder.EPS && bars[bars.length - 1] !== b) bars.push(b);
        }
        bars.push(endBeat);
        return bars.filter((v, i, a) => i === 0 || v > a[i - 1] + ScoreBuilder.EPS);
    }

    static _ceilToBar(beat, pickupBeats, q) {
        if (beat <= pickupBeats + ScoreBuilder.EPS) return pickupBeats > 0 ? pickupBeats : q;
        const k = Math.ceil((beat - pickupBeats) / q - ScoreBuilder.EPS);
        return pickupBeats + k * q;
    }

    /** Início do compasso que contém `beat`. */
    static _barStart(beat, bars) {
        let start = 0;
        for (const b of bars) { if (b <= beat + ScoreBuilder.EPS) start = b; else break; }
        return start;
    }

    /**
     * Um trecho [from, to) → segmentos que (a) nunca cruzam barra e (b) cada um é uma
     * FIGURA. É daqui que sai a ligadura sobre a barra — o mesmo "nó-âncora" do motor de
     * ritmo: um evento só, com `tie[]` descrevendo as cabeças.
     */
    static _split(from, to, bars, beatUnit = 1) {
        const segs = [];
        let cur = from;
        while (cur < to - ScoreBuilder.EPS) {
            const bar = bars.find(b => b > cur + ScoreBuilder.EPS);
            const stop = Math.min(to, bar != null ? bar : to);
            ScoreBuilder._figures(ScoreBuilder._barStart(cur, bars), cur, stop, beatUnit)
                .forEach(s => segs.push(s));
            cur = stop;
        }
        return segs;
    }

    /**
     * Decompõe [from, to) DENTRO de um compasso em figuras desenháveis.
     *
     * 🔴 A regra NÃO é "a maior figura cujo tamanho divide o offset" — esse critério
     * (`off % d`) parece métrica e não é: em off 1,5 com d 0,75 a conta dá 2 e a figura
     * "cai certo", então uma SEMÍNIMA sincopada saía escrita como colcheia pontuada ligada
     * a semicolcheia, e uma MÍNIMA nos tempos 2-3 de uma valsa saía como duas semínimas
     * ligadas — coisa que nenhum editor de partitura faz. Numa melodia sincopada trivial
     * isso produzia 6 ligaduras em 8 notas.
     *
     * A regra correta tem dois degraus, nesta ordem:
     *   1. **Se o trecho inteiro já é uma figura, escreve UMA cabeça** (desde que comece
     *      num tempo ou não passe de um tempo — o que impede escrever uma nota longuíssima
     *      pendurada em qualquer contratempo).
     *   2. Senão, corta na fronteira métrica MAIS GROSSA que cai dentro do trecho e repete
     *      dos dois lados. É a hierarquia do compasso (compasso → tempo → meio tempo…),
     *      a mesma que decide agrupamento de barra de ligação.
     *
     * `beatUnit` é o tempo em semínimas: 1 nos compassos simples, 1,5 nos compostos (6/8),
     * onde a hierarquia é ternária e cortar de semínima em semínima seria errado.
     */
    static _figures(barStart, from, to, beatUnit = 1, depth = 0) {
        const E = ScoreBuilder.EPS;
        const N = window.Notation;
        const span = to - from;
        if (span <= E) return [];

        const off = from - barStart;
        const onBeat = Math.abs(off / beatUnit - Math.round(off / beatUnit)) < 1e-6;
        if (N.figureOf(span) && (onBeat || span <= beatUnit + E)) {
            return [{ beat: from, duration: span }];
        }

        if (depth < 12) {
            for (const level of ScoreBuilder._levels(beatUnit)) {
                const cut = barStart + (Math.floor((off + E) / level) + 1) * level;
                if (cut > from + E && cut < to - E) {
                    return ScoreBuilder._figures(barStart, from, cut, beatUnit, depth + 1)
                        .concat(ScoreBuilder._figures(barStart, cut, to, beatUnit, depth + 1));
                }
            }
        }

        // Sem fronteira métrica dentro do trecho (ou fundo demais): maior figura que couber.
        const segs = [];
        let cur = from, guard = 0;
        while (cur < to - E && guard++ < 64) {
            const DUR = N.FIGURES.map(f => f.duration);
            const pick = DUR.find(d => d <= to - cur + E) || DUR[DUR.length - 1];
            segs.push({ beat: cur, duration: pick });
            cur += pick;
        }
        return segs;
    }

    /** Fronteiras da hierarquia métrica, da mais grossa para a mais fina. */
    static _levels(beatUnit) {
        return [beatUnit * 4, beatUnit * 2, beatUnit, beatUnit / 2, beatUnit / 4, beatUnit / 8]
            .filter(l => l >= 0.125 - ScoreBuilder.EPS);
    }

    /** Escreve o silêncio de [from,to) como PAUSAS (o `Score.validate` exige ladrilho). */
    static _pushRests(events, from, to, bars, beatUnit = 1) {
        // Pausa não se liga: cada figura é um evento próprio.
        ScoreBuilder._split(from, to, bars, beatUnit).forEach(s => {
            events.push({ type: 'rest', beat: s.beat, duration: s.duration, midi: null, tie: null });
        });
    }

}

// Disponibiliza globalmente
if (typeof window !== 'undefined') window.ScoreBuilder = ScoreBuilder;



// ============================================
// games/ExerciseConfig.js
// ============================================
/**
 * ExerciseConfig - Configuração do exercício de ritmo + catálogo de figuras
 *
 * RHYTHM_FIGURES é a FONTE ÚNICA do catálogo de figuras rítmicas:
 * gerador (allowedNotes), painel de controle (RhythmConfigPanel) e persistência
 * (localStorage) derivam todos daqui. Adicionar uma figura nova = 1 linha no
 * CATALOG (id = visualType que o RhythmRenderer sabe desenhar).
 */

const EXERCISE_CONFIG = {
    timeSignature: {
        beats: 4,
        noteValue: 4
    },
    measures: 2,
    bpm: 60,  // P5 — tempo lento por padrão (1 batida/segundo) para o primeiro contato.
              // O jogo permite ajustar 40–120 em runtime (RhythmGame.currentBpm).
    // Preenchido por RHYTHM_FIGURES.apply() (seleção salva ou defaults do catálogo).
    allowedNotes: [],
    consecutiveRestLimit: 2,  // Máximo de 2 pausas consecutivas
    // Ligadura (tie): quando true, o gerador pode fundir duas figuras contíguas que
    // cruzam a barra de compasso num "nó-âncora" (RhythmTies.apply() sincroniza daqui).
    tiesEnabled: false,
    // FREQUÊNCIA da ligadura (0-1): chance de fundir cada par ELEGÍVEL. O sandbox usa
    // sempre o default; a trilha sobrescreve por nível (LevelConfig.apply), porque um
    // mundo de síncope com metade dos padrões sem síncope não ensina síncope.
    tieProb: 0.5,
    // QUAIS lições de ligadura o nível quer: ['sustain'] (atravessa a barra) e/ou
    // ['syncopation'] (fraco preso ao forte). null = as duas, comportamento do sandbox.
    tieKinds: null,
    // Clique do metrônomo DEPOIS da contagem: 'all' | 'one' (só no 1) | '24' (só em 4/4) |
    // 'none'. A contagem de entrada é sempre inteira (MetronomeManager.clickAudible).
    click: 'all'
};

/**
 * RHYTHM_SANDBOX — o PRESET do exercício livre: um objeto serializável e versionado que
 * diz tudo o que o personalizado sorteia e como soa.
 *
 *   { v:1, timeSig:{beats,noteValue}, measures, restLimit, bpm,
 *     figures:[ids], ties:bool, tieKinds:null|['sustain']|['syncopation'], click }
 *
 * - `getPreset()` compõe: a FORMA mora em `STORAGE_KEY`; figuras e ligadura continuam nas
 *   chaves irmãs (`rhythm_figures_v1`/`rhythm_ties_v1`). Todas por APARELHO, fora do
 *   `StorageScope` (é preferência; em PROGRESS_BASE_KEYS a adoção guest→conta apagaria).
 * - `applyPreset(p)` normaliza, grava as três chaves e escreve em EXERCISE_CONFIG.
 * - `apply()` escreve o preset salvo OU o padrão em EXERCISE_CONFIG, sem gravar nada.
 * - Campo ausente ou inválido = padrão, nunca erro. O degrau seguinte ("lista de
 *   exercícios" do professor) é guardar ESTE objeto com nome — nada do painel pode
 *   escrever em EXERCISE_CONFIG por fora dele.
 *
 * 🔴 EXERCISE_CONFIG é UM objeto global para as duas rotas, e o vazamento tem DOIS
 * sentidos. Nível → livre: medido 16/set, nível 18 → #/ritmo-livre sorteava 4 compassos
 * (por isso `apply()` escreve a forma INTEIRA). Livre → nível: com fórmula e clique aqui,
 * quem sai do 3/4 entraria na trilha em 3/4 — por isso `RhythmLevels.apply` escreve 4/4
 * e clique inteiro explicitamente. Parâmetro novo de um lado entra nos dois.
 *
 * 🔴 O andamento do livre tem chave PRÓPRIA (dentro da forma). `rhythm_bpm` é gravada pela
 * trilha a cada nível, e o preset "mentiria" depois de uma partida ranqueada.
 */
const RHYTHM_SANDBOX = {
    STORAGE_KEY: 'rhythm_sandbox_v1',
    VERSION: 1,

    // Opções que o painel oferece (e que o normalizador aceita). 2/2, 6/8 e 12/8 FORA de
    // propósito nesta rodada: exigem vigamento e grafia de pausa que o gerador não tem.
    TIME_SIGS: Object.freeze([2, 3, 4]),        // numerador; a unidade é sempre a semínima
    MEASURES: Object.freeze([1, 2, 4]),
    REST_LIMITS: Object.freeze([1, 2, 3]),
    CLICKS: Object.freeze(['all', 'one', '24', 'none']),
    TIE_KINDS: Object.freeze(['sustain', 'syncopation']),

    DEFAULTS: Object.freeze({
        beats: EXERCISE_CONFIG.timeSignature.beats,
        noteValue: EXERCISE_CONFIG.timeSignature.noteValue,
        measures: EXERCISE_CONFIG.measures,
        consecutiveRestLimit: EXERCISE_CONFIG.consecutiveRestLimit,
        bpm: EXERCISE_CONFIG.bpm,
        tieKinds: null,
        click: 'all'
    }),

    // Andamento aceito (espelha RhythmGame.MIN_BPM/MAX_BPM; fora da faixa = padrão).
    BPM_MIN: 40,
    BPM_MAX: 120,

    /** O preset padrão ("Restaurar padrão"). */
    defaultPreset() {
        const d = this.DEFAULTS;
        return {
            v: this.VERSION,
            timeSig: { beats: d.beats, noteValue: d.noteValue },
            measures: d.measures,
            restLimit: d.consecutiveRestLimit,
            bpm: d.bpm,
            figures: window.RhythmFigures ? window.RhythmFigures.defaults() : [],
            ties: false,
            tieKinds: d.tieKinds,
            click: d.click
        };
    },

    /** A forma salva (objeto cru, possivelmente incompleto) ou {}. */
    _readForm() {
        if (this._memo) return this._memo.form;
        try {
            const raw = window.localStorage && window.localStorage.getItem(this.STORAGE_KEY);
            const o = raw ? JSON.parse(raw) : null;
            return (o && typeof o === 'object' && !Array.isArray(o)) ? o : {};
        } catch (e) { return {}; }
    },

    // Último preset aplicado, em memória, SÓ quando o aparelho não gravou (cota cheia, modo
    // privado): sem ele o `apply()` do prepareRound seguinte relia o storage e o painel dizia
    // 3/4 com o ritmo saindo em 4/4 (auditoria 16/set).
    _memo: null,

    /** Preset corrente: o salvo, completado e validado campo a campo pelo padrão. */
    getPreset() {
        const f = this._readForm();
        const m = this._memo;
        return this.normalize({
            v: f.v,
            timeSig: f.timeSig,
            measures: f.measures,
            restLimit: f.restLimit,
            bpm: f.bpm,
            figures: m ? m.figures : (window.RhythmFigures ? window.RhythmFigures.getEnabled() : []),
            ties: m ? m.ties : (window.RhythmTies ? window.RhythmTies.isEnabled() : false),
            tieKinds: f.tieKinds,
            click: f.click
        });
    },

    /** A duração que uma figura ocupa NESTA fórmula (pausa de compasso = o compasso). */
    figureDuration(id, beats) {
        const f = window.RhythmFigures && window.RhythmFigures.byId(id);
        if (!f) return null;
        return f.id === 'whole-rest' ? beats : f.duration;
    },

    /** A figura cabe num compasso desta fórmula? (a pausa de compasso sempre cabe) */
    fits(id, beats) {
        const d = this.figureDuration(id, beats);
        return d != null && d <= beats + 1e-9;
    },

    /**
     * Estas figuras FECHAM um compasso desta fórmula a partir de TODA posição que elas
     * mesmas alcançam? (grade de fusa, 1/8 de tempo). Não basta uma nota caber: 3/4 só com
     * a mínima chega ao tempo 3 e fica sem nada que feche — o gerador caía no preenchimento
     * e punha semínima em 100% das rodadas (auditoria 16/set). Pausas contam: fechar com
     * pausa é escolha da pessoa. Limite de pausas e grafia ficam de fora (o gerador tenta
     * de novo antes de sujar).
     */
    closes(ids, beats) {
        const size = Math.round(beats * 8);
        const units = [...new Set(ids.map(id => this.figureDuration(id, beats))
            .filter(d => d != null && d <= beats + 1e-9)
            .map(d => Math.round(d * 8)).filter(u => u > 0))];
        const fecha = new Array(size + 1).fill(false);
        fecha[size] = true;
        for (let pos = size - 1; pos >= 0; pos--) fecha[pos] = units.some(u => pos + u <= size && fecha[pos + u]);
        const visto = new Set([0]), fila = [0];
        while (fila.length) {
            const pos = fila.shift();
            if (!fecha[pos]) return false;
            units.forEach(u => { const q = pos + u; if (q < size && !visto.has(q)) { visto.add(q); fila.push(q); } });
        }
        return true;
    },

    /** O clique que SOA nesta fórmula: '2 e 4' só existe em 4/4 (fora dele, 'só no 1'). */
    effectiveClick(n) {
        return (n.click === '24' && n.timeSig.beats !== 4) ? 'one' : n.click;
    },

    /**
     * Completa e valida um preset. Nunca lança: campo inválido vira o padrão.
     * Regras que não são só "valor na lista":
     * - andamento no passo do controle (5 em 5, 40-120): o jogo arredonda, e o preset não
     *   pode dizer 63 com o jogo tocando 65;
     * - `click:'24'` fica GRAVADO em qualquer fórmula (voltar ao 4/4 o devolve); quem toca
     *   é `effectiveClick`;
     * - a seleção precisa de uma nota sonora que CAIBA e de figuras que FECHEM o compasso
     *   (`closes`). Falta → liga, EM MEMÓRIA, a menor figura da escada que resolve
     *   (semínima, colcheia…) e a lista em `autoFigures`. Ela não é gravada: voltar a uma
     *   fórmula que não precisa dela devolve a seleção da pessoa intacta.
     */
    normalize(p, opts = {}) {
        const d = this.DEFAULTS;
        p = (p && typeof p === 'object') ? p : {};
        const pick = (v, list, def) => list.includes(v) ? v : def;

        const beats = pick(p.timeSig && p.timeSig.beats, this.TIME_SIGS, d.beats);
        const bpmN = Number(p.bpm);
        // 🔴 O passo de 5 é do SLIDER, não do formato: o nível de uma trilha (`opts.level`) aceita
        // BPM inteiro — a trilha oficial tem 63/66/69 e arredondar de 5 em 5 a adulterava.
        const step = opts.level ? 1 : 5;
        const bpm = (Number.isFinite(bpmN) && bpmN >= this.BPM_MIN && bpmN <= this.BPM_MAX)
            ? Math.max(this.BPM_MIN, Math.min(this.BPM_MAX, Math.round(bpmN / step) * step)) : d.bpm;

        let tieKinds = null;
        if (Array.isArray(p.tieKinds)) {
            const k = this.TIE_KINDS.filter(x => p.tieKinds.includes(x));
            // as duas = null (é o que o gerador entende por "as duas", e o que a trilha grava)
            tieKinds = (k.length === 1) ? k : null;
        }

        const click = pick(p.click, this.CLICKS, d.click);

        const F = window.RhythmFigures;
        let figures = Array.isArray(p.figures) && F ? p.figures.filter(id => F.byId(id)) : [];
        figures = figures.filter((id, i) => figures.indexOf(id) === i);
        if (F && !figures.some(id => F.byId(id).kind === 'note')) figures = F.defaults();
        const autoFigures = [];
        if (F) {
            const liga = (id) => { if (!figures.includes(id)) { figures.push(id); autoFigures.push(id); } };
            if (!figures.some(id => F.byId(id).kind === 'note' && this.fits(id, beats))) liga('quarter');
            // UMA figura só, a maior da escada que resolve (a fusa fecha qualquer compasso)
            if (!this.closes(figures, beats)) {
                liga(['quarter', 'eighth', 'sixteenth', 'fusa']
                    .find(id => !figures.includes(id) && this.closes([...figures, id], beats)) || 'fusa');
            }
        }

        const out = {
            v: this.VERSION,
            timeSig: { beats, noteValue: 4 },
            measures: pick(p.measures, this.MEASURES, d.measures),
            restLimit: pick(p.restLimit, this.REST_LIMITS, d.consecutiveRestLimit),
            bpm,
            figures,
            ties: p.ties === true,
            tieKinds,
            click
        };
        // Dose da ligadura: só a trilha carrega (o sandbox usa o DEFAULT_PROB do RhythmTies e o
        // campo nem existe no preset gravado — `applyPreset` não o persiste).
        const tp = Number(p.tieProb);
        if (opts.level || Number.isFinite(tp)) out.tieProb = (Number.isFinite(tp) && tp >= 0 && tp <= 1) ? tp : (window.RhythmTies ? window.RhythmTies.DEFAULT_PROB : 0.5);
        Object.defineProperty(out, 'autoFigures', { value: autoFigures, enumerable: false });
        return out;
    },

    /**
     * A FOTO do painel: o preset EFETIVO do personalizado (com a figura que o jogo ligou para
     * fechar o compasso — marcada como tal só em memória) mais a dose de ligadura. É o que a
     * "trilha do professor" guarda como nível (docs/LISTAS-PLANO.md); a foto fiel grava a
     * figura ligada, e o `closes` só recusa JSON importado (1b).
     */
    snapshot() {
        const n = this.getPreset();
        return {
            v: n.v, timeSig: { beats: n.timeSig.beats, noteValue: 4 }, measures: n.measures, restLimit: n.restLimit,
            bpm: n.bpm, figures: n.figures.slice(), ties: n.ties, tieKinds: n.tieKinds ? n.tieKinds.slice() : null,
            click: n.click, tieProb: window.RhythmTies ? window.RhythmTies.DEFAULT_PROB : 0.5
        };
    },

    /**
     * Escreve o preset de um NÍVEL DE TRILHA em EXERCISE_CONFIG sem gravar NADA no aparelho
     * (`applyPreset` grava as três chaves; isto é o preset ativo do modo `list`, que nunca
     * pode virar o preset da pessoa). Devolve o preset normalizado (régua de nível: BPM inteiro).
     */
    writeLevel(p) {
        const n = this.normalize(p, { level: true });
        this._write(n);
        return n;
    },

    /** O que se GRAVA da seleção: sem as figuras ligadas só para fechar o compasso. */
    storedFigures(n) {
        return n.figures.filter(id => !(n.autoFigures || []).includes(id));
    },

    /** Grava o preset (as três chaves) e o aplica. Devolve o preset normalizado. */
    applyPreset(p) {
        const n = this.normalize(p);
        const form = { v: n.v, timeSig: n.timeSig, measures: n.measures, restLimit: n.restLimit,
                       bpm: n.bpm, tieKinds: n.tieKinds, click: n.click };
        const figures = this.storedFigures(n);
        this._memo = null;
        let gravou = false;
        try {
            if (window.localStorage) {
                window.localStorage.setItem(this.STORAGE_KEY, JSON.stringify(form));
                gravou = true;
            }
        } catch (e) { /* sem persistência: vale o que está em memória (_memo) */ }
        if (window.RhythmFigures) window.RhythmFigures.setEnabled(figures);
        if (window.RhythmTies) window.RhythmTies.setEnabled(n.ties);
        // RhythmFigures/RhythmTies engolem a própria falha: confere lendo de volta.
        const leu = gravou && window.RhythmFigures && window.RhythmTies
            && JSON.stringify(window.RhythmFigures.getEnabled()) === JSON.stringify(figures)
            && window.RhythmTies.isEnabled() === n.ties;
        if (!leu) this._memo = { form, figures, ties: n.ties };
        this._write(n);
        return n;
    },

    /** Só o andamento (o controle de tempo grava sem passar pelo painel). */
    setBpm(bpm) {
        const p = this.getPreset();
        p.figures = this.storedFigures(p);
        p.bpm = bpm;
        return this.applyPreset(p);
    },

    /** Escreve o preset salvo OU o padrão em EXERCISE_CONFIG (não grava nada). */
    apply() {
        this._write(this.getPreset());
    },

    // ---------- o painel ⚙️ como DADO (seções declarativas), sem jogo ----------

    /** "4 tempos" / "1 tempo" / "½ tempo" / "1½ tempos" (i18n). `t(key, params)`. */
    beatsLabel(duration, t) {
        const FRAC = { 0.125: '⅛', 0.25: '¼', 0.5: '½', 0.75: '¾', 1.5: '1½' };
        const n = FRAC[duration] || String(duration);
        return t(duration <= 1 ? 'rhythm.config.beat' : 'rhythm.config.beats', { n });
    },

    /**
     * As SEÇÕES do `RhythmConfigPanel` a partir de um preset NORMALIZADO — a única
     * descrição do painel, usada pelo jogo (o preset da pessoa, ou o do nível em modo
     * `list`, apagado) e pela OFICINA da trilha (o preset de cada nível, 18/set). Figuras
     * vêm do catálogo; forma, ligadura e clique das listas daqui. Seção nova = mais um
     * descriptor aqui + um campo no preset.
     *
     * 🔴 Figura que NÃO CABE na fórmula (semibreve em 3/4) fica APAGADA com o porquê no
     * sublabel e MANTÉM a marca — desmarcar em silêncio quebraria a única promessa do modo
     * livre (a seleção), e voltar ao 4/4 a devolve. O sorteio já a exclui por construção.
     * `t(key, params)` é a tradução; `readOnly` apaga tudo (o nível é do autor).
     */
    sections(p, { t, readOnly = false } = {}) {
        const S = this;
        const beats = p.timeSig.beats;
        const sig = `${beats}/4`;
        const autoFigs = Array.isArray(p.autoFigures) ? p.autoFigures : [];
        const item = (f) => {
            const fits = S.fits(f.id, beats);
            // ligada SÓ para fechar o compasso (em memória, não gravada): marcada, e um toque
            // a ADOTA (senão sumiria ao marcar outra figura que também fecha o compasso)
            const auto = autoFigs.includes(f.id);
            const dur = S.figureDuration(f.id, beats);
            let sublabel = S.beatsLabel(dur, t);
            if (!fits) sublabel = t('rhythm.config.noFit', { sig });
            else if (auto) sublabel = t('rhythm.config.autoOn', { sig });
            // pausa que enche o compasso (a de mínima em 2/4) é DESENHADA como pausa de compasso
            else if (f.kind === 'rest' && f.id !== 'whole-rest' && Math.abs(dur - beats) < 1e-9) {
                sublabel = sublabel + ' · ' + t('rhythm.config.drawnAsBarRest');
            }
            return {
                id: f.id,
                icon: window.RhythmRenderer ? window.RhythmRenderer.figureIcon(f.id) : null,
                // a pausa de semibreve É a pausa de compasso — dura o que a fórmula disser
                label: f.id === 'whole-rest' ? t('rhythm.config.measureRest') : t('rhythm.figures.' + f.id),
                sublabel,
                checked: p.figures.includes(f.id),
                auto: auto && !readOnly,
                disabled: readOnly || !fits
            };
        };
        const ro = (items) => readOnly ? items.map(it => ({ ...it, disabled: true })) : items;
        // Tabelas de LITERAIS inteiros (nunca 'prefixo.' + valor): o teste de i18n acha a
        // chave no fonte.
        const TIE_LABEL = {
            off: 'rhythm.config.tieOff', sustain: 'rhythm.config.tieSustain',
            syncopation: 'rhythm.config.tieSyncopation', both: 'rhythm.config.tieBoth'
        };
        const CLICK_LABEL = {
            all: 'rhythm.config.clickAll', one: 'rhythm.config.clickOne',
            '24': 'rhythm.config.click24', none: 'rhythm.config.clickNone'
        };
        const tieNow = !p.ties ? 'off' : (p.tieKinds ? p.tieKinds[0] : 'both');
        // Com 1 compasso não há barra interna: a sustentação não tem o que atravessar.
        const semBarra = p.measures === 1;
        // '2 e 4' fica gravado fora do 4/4, mas o que SOA (e o que a tela marca) é 'só no 1'
        const clickNow = S.effectiveClick(p);
        const F = window.RhythmFigures;
        return [
            {
                id: 'timeSig',
                title: t('rhythm.config.timeSig'),
                single: true, inline: true,
                items: ro(S.TIME_SIGS.map(b => ({ id: String(b), label: `${b}/4`, checked: b === beats })))
            },
            {
                id: 'measures',
                title: t('rhythm.config.measures'),
                single: true, inline: true,
                items: ro(S.MEASURES.map(m => ({ id: String(m), label: String(m), checked: m === p.measures })))
            },
            {
                id: 'notes',
                title: t('rhythm.config.notes'),
                // Somente leitura: a instrução "escolha as figuras" com tudo apagado parecia quebrado.
                hint: readOnly ? t('rhythm.trails.readOnly') : t('rhythm.config.hint'),
                items: F.CATALOG.filter(f => f.kind === 'note').map(item)
            },
            {
                id: 'rests',
                title: t('rhythm.config.rests'),
                items: F.CATALOG.filter(f => f.kind === 'rest').map(item)
            },
            {
                id: 'restLimit',
                title: t('rhythm.config.restLimit'),
                single: true, inline: true,
                items: ro(S.REST_LIMITS.map(n => ({ id: String(n), label: String(n), checked: n === p.restLimit })))
            },
            {
                // Ligadura = relação entre figuras (não é item do catálogo). UMA escolha só:
                // desligada, ou qual das duas lições (a trilha ensina cada uma num mundo).
                id: 'ties',
                title: t('rhythm.config.ties'),
                hint: t('rhythm.config.tiesHint') + (semBarra ? ' ' + t('rhythm.config.sustainOneBar') : ''),
                single: true, inline: true,
                items: ro(['off', 'sustain', 'syncopation', 'both'].map(k => ({
                    id: k, label: t(TIE_LABEL[k]), checked: k === tieNow,
                    disabled: semBarra && k === 'sustain'
                })))
            },
            {
                id: 'click',
                title: t('rhythm.config.click'),
                hint: t('rhythm.config.clickHint'),
                single: true, inline: true,
                // "2 e 4" só existe em 4/4 (o preset já o rebaixa para "só no 1" noutra fórmula)
                items: ro(S.CLICKS.filter(c => c !== '24' || beats === 4).map(c => ({
                    id: c, label: t(CLICK_LABEL[c]), checked: c === clickNow
                })))
            }
        ];
    },

    /**
     * A regra "pelo menos UMA nota sonora que CAIBA na fórmula" (pausas livres), para o
     * `canToggle` do painel. Devolve true ou a frase de recusa.
     */
    canToggle(cur, sectionId, itemId, next, enabledBySection, t) {
        if (sectionId !== 'notes' || next) return true;
        const beats = cur.timeSig.beats;
        const sobram = (enabledBySection.notes || []).filter(id => id !== itemId && this.fits(id, beats));
        if (sobram.length) return true;
        return beats === 4 ? t('rhythm.config.needOneNote') : t('rhythm.config.needOneFit', { sig: `${beats}/4` });
    },

    /**
     * Seleção do painel → preset CRU (a normalizar por quem grava: `applyPreset` no jogo,
     * `normalize(…, {level:true})` na oficina). `cur` = o preset normalizado de antes (traz
     * `autoFigures`: as figuras ligadas só para fechar o compasso NÃO viram escolha — a não
     * ser a que a pessoa acabou de ADOTAR com um toque, `meta.adopted`).
     */
    presetFromSelection(cur, enabledBySection, meta = null) {
        const um = (id) => { const v = (enabledBySection[id] || [])[0]; return v === undefined ? undefined : v; };
        const num = (id, def) => { const v = Number(um(id)); return Number.isFinite(v) ? v : def; };
        const tie = um('ties') || (cur.ties ? (cur.tieKinds ? cur.tieKinds[0] : 'both') : 'off');
        // '2 e 4' gravado aparece como 'só no 1' fora do 4/4; mexer noutra seção não o apaga
        let click = um('click') || cur.click;
        if (cur.click === '24' && click === this.effectiveClick(cur)) click = '24';
        const adotada = meta && meta.adopted;
        const autoFigs = Array.isArray(cur.autoFigures) ? cur.autoFigures : [];
        const figures = [...(enabledBySection.notes || []), ...(enabledBySection.rests || [])]
            .filter(id => id === adotada || !autoFigs.includes(id));
        return {
            ...cur,
            timeSig: { beats: num('timeSig', cur.timeSig.beats), noteValue: 4 },
            measures: num('measures', cur.measures),
            restLimit: num('restLimit', cur.restLimit),
            figures,
            ties: tie !== 'off',
            tieKinds: (tie === 'sustain' || tie === 'syncopation') ? [tie] : null,
            click
        };
    },

    /** A ÚNICA escrita do sandbox em EXERCISE_CONFIG — a forma inteira, sempre. */
    _write(n) {
        const F = window.RhythmFigures;
        if (F) {
            EXERCISE_CONFIG.allowedNotes = F.CATALOG
                .filter(f => n.figures.includes(f.id))
                .map(f => ({ type: f.id, duration: f.duration, weight: f.weight }));
        }
        EXERCISE_CONFIG.timeSignature = { beats: n.timeSig.beats, noteValue: n.timeSig.noteValue };
        EXERCISE_CONFIG.measures = n.measures;
        EXERCISE_CONFIG.consecutiveRestLimit = n.restLimit;
        EXERCISE_CONFIG.bpm = n.bpm;
        EXERCISE_CONFIG.tiesEnabled = !!n.ties;
        EXERCISE_CONFIG.tieProb = Number.isFinite(n.tieProb) ? n.tieProb : (window.RhythmTies ? window.RhythmTies.DEFAULT_PROB : 0.5);
        EXERCISE_CONFIG.tieKinds = n.tieKinds ? n.tieKinds.slice() : null;
        EXERCISE_CONFIG.click = this.effectiveClick(n);
    }
};

const RHYTHM_FIGURES = {
    STORAGE_KEY: 'rhythm_figures_v1',

    // id = visualType (RhythmRenderer.drawNote/drawRest; figureIcon desenha o ícone).
    // duration em tempos de 4/4. weight só pesa entre as figuras HABILITADAS
    // (o gerador normaliza a soma). enabledByDefault espelha o exercício original.
    CATALOG: [
        { id: 'whole',          kind: 'note', duration: 4,   weight: 0.15, enabledByDefault: false },
        { id: 'dotted-half',    kind: 'note', duration: 3,   weight: 0.20, enabledByDefault: false },
        { id: 'half',           kind: 'note', duration: 2,   weight: 0.30, enabledByDefault: true },
        { id: 'dotted-quarter', kind: 'note', duration: 1.5, weight: 0.25, enabledByDefault: false },
        { id: 'quarter',        kind: 'note', duration: 1,     weight: 0.50, enabledByDefault: true },
        { id: 'dotted-eighth',  kind: 'note', duration: 0.75,  weight: 0.18, enabledByDefault: false },
        { id: 'eighth',         kind: 'note', duration: 0.5,   weight: 0.40, enabledByDefault: false },
        { id: 'sixteenth',      kind: 'note', duration: 0.25,  weight: 0.25, enabledByDefault: false },
        { id: 'fusa',           kind: 'note', duration: 0.125, weight: 0.12, enabledByDefault: false },
        { id: 'whole-rest',     kind: 'rest', duration: 4,     weight: 0.08, enabledByDefault: false },
        { id: 'half-rest',      kind: 'rest', duration: 2,     weight: 0.12, enabledByDefault: false },
        { id: 'quarter-rest',   kind: 'rest', duration: 1,     weight: 0.20, enabledByDefault: true },
        { id: 'dotted-eighth-rest', kind: 'rest', duration: 0.75, weight: 0.07, enabledByDefault: false },
        { id: 'eighth-rest',    kind: 'rest', duration: 0.5,   weight: 0.15, enabledByDefault: false },
        { id: 'sixteenth-rest', kind: 'rest', duration: 0.25,  weight: 0.10, enabledByDefault: false },
        { id: 'fusa-rest',      kind: 'rest', duration: 0.125, weight: 0.06, enabledByDefault: false }
    ],

    byId(id) {
        return this.CATALOG.find(f => f.id === id) || null;
    },

    defaults() {
        return this.CATALOG.filter(f => f.enabledByDefault).map(f => f.id);
    },

    /**
     * Seleção habilitada: a salva (se válida) ou os defaults.
     * Regra do jogo: pelo menos UMA figura sonora (kind 'note') — senão não há
     * o que tocar/avaliar. Seleção inválida/corrompida → defaults.
     */
    getEnabled() {
        try {
            const raw = window.localStorage && window.localStorage.getItem(this.STORAGE_KEY);
            if (raw) {
                const ids = JSON.parse(raw).filter(id => this.byId(id));
                if (ids.some(id => this.byId(id).kind === 'note')) return ids;
            }
        } catch (e) { /* localStorage indisponível/corrompido → defaults */ }
        return this.defaults();
    },

    /** Persiste a seleção e a aplica em EXERCISE_CONFIG.allowedNotes. */
    setEnabled(ids) {
        try {
            if (window.localStorage) window.localStorage.setItem(this.STORAGE_KEY, JSON.stringify(ids));
        } catch (e) { /* sem persistência, mas aplica em memória */ }
        this.apply();
    },

    /** Reconstrói allowedNotes ({type,duration,weight}) a partir da seleção. */
    apply() {
        const enabled = this.getEnabled();
        EXERCISE_CONFIG.allowedNotes = this.CATALOG
            .filter(f => enabled.includes(f.id))
            .map(f => ({ type: f.id, duration: f.duration, weight: f.weight }));
    }
};

RHYTHM_FIGURES.apply();

/**
 * RHYTHM_TIES — liga/desliga ligaduras (síncope que cruza a barra de compasso).
 * NÃO é figura do catálogo (é uma RELAÇÃO entre figuras): fica fora de
 * RHYTHM_FIGURES p/ não envenenar fillFigure/figureIcon/allowedNotes. Persiste em
 * localStorage e espelha em EXERCISE_CONFIG.tiesEnabled (lido pelo gerador).
 */
const RHYTHM_TIES = {
    STORAGE_KEY: 'rhythm_ties_v1',

    // Frequência do sandbox. apply() a REPÕE em EXERCISE_CONFIG p/ que voltar da
    // trilha (onde o nível manda) não deixe o modo livre com a dose de um nível.
    DEFAULT_PROB: 0.5,

    isEnabled() {
        try { return window.localStorage && window.localStorage.getItem(this.STORAGE_KEY) === '1'; }
        catch (e) { return false; }
    },

    setEnabled(on) {
        try {
            if (window.localStorage) window.localStorage.setItem(this.STORAGE_KEY, on ? '1' : '0');
        } catch (e) { /* sem persistência, mas aplica em memória */ }
        EXERCISE_CONFIG.tiesEnabled = !!on;
        // Repõe o par inteiro: mexer só no liga/desliga deixava a DOSE e a LIÇÃO do último
        // nível jogado penduradas no config global. Hoje ninguém gera padrão sem passar por
        // prepareRound (que re-sincroniza), mas o dia em que alguém gerar, herda o nível.
        EXERCISE_CONFIG.tieProb = this.DEFAULT_PROB;
        EXERCISE_CONFIG.tieKinds = null;
    },

    apply() {
        EXERCISE_CONFIG.tiesEnabled = this.isEnabled();
        EXERCISE_CONFIG.tieProb = this.DEFAULT_PROB;
        EXERCISE_CONFIG.tieKinds = null;          // sandbox = as duas lições
    }
};

RHYTHM_TIES.apply();

// Disponibiliza globalmente
window.EXERCISE_CONFIG = EXERCISE_CONFIG;
window.RhythmSandbox = RHYTHM_SANDBOX;
window.RhythmFigures = RHYTHM_FIGURES;
window.RhythmTies = RHYTHM_TIES;



// ============================================
// games/RhythmPrefs.js
// ============================================
/**
 * RhythmPrefs — os AJUSTES DO JOGADOR no Ritmo (18/set): som da nota, régua de tempos e, desde
 * 19/set, o teclado MIDI como botão. Valem nos três modos (níveis, livre, trilha) e moram no ⚙️.
 *
 * 🔴 SÓ O QUE NÃO MUDA A DIFICULDADE. O ranking compara pessoas: ajuste que facilita
 *    (desligar o metrônomo, esconder notas) não entra aqui.
 *
 * Onde fica guardado:
 *  - no APARELHO (`rhythm_prefs_v1`), sempre — fora do `StorageScope`: é gosto, não progresso
 *    (mesma régua de `help_seen_v1` e `stats_view_v1`);
 *  - na CONTA, com login (`users.data`: `rhythm_tone`/`rhythm_ruler`/`rhythm_pitch`, whitelist em
 *    `auth-helpers.php`), para seguir a pessoa em outro aparelho.
 *
 * Quem vence na leitura: a escolha feita NESTA página → a da conta → a do aparelho → o padrão.
 * 🔴 '' na conta = "nunca escolheu": cai para o aparelho. É por isso que o padrão do
 *    servidor é '' e não 'B' — senão o convidado que escolheu Ré voltava a Si ao criar conta.
 * 🔴 A gravação na conta ESPERA o último clique (`SAVE_DELAY_MS`): passar por 7 notas não pode
 *    gastar o balde do `save_prefs` (30/10min por conta). O aparelho grava na hora.
 * 🔴 Gravação na conta que FALHA (rede, 401, balde) deixa a escolha PENDENTE no aparelho:
 *    `_pend[ajuste][uid] = valor` — o VALOR de CADA conta, não um ponteiro para o valor do
 *    aparelho (esse muda com o convidado ou com outra conta, e a 1ª versão subia a escolha
 *    de um convidado para a conta de A no relogin — auditoria 18/set). A pendência vence o valor
 *    velho da conta e é reenviada no próximo `flush()`; a de uma conta nunca apaga a de outra.
 *    Offline em dois aparelhos: vence o último que reconecta (decisão consciente — é gosto).
 */
class RhythmPrefs {
    static KEY = 'rhythm_prefs_v1';
    static TONES = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
    static VARY = 'var';
    static DEFAULTS = { tone: 'B', ruler: 'on', pitch: 'off', midi: 'off' };
    static FIELDS = {
        tone:  { pref: 'rhythm_tone',  values: ['C', 'D', 'E', 'F', 'G', 'A', 'B', 'var'] },
        ruler: { pref: 'rhythm_ruler', values: ['on', 'off'] },
        // "Notas na altura certa" (19/set): com a "Melodia", desenhar cada nota na linha em que
        // ela SOA (hoje tudo sai na linha do meio). Só faz sentido com `tone === 'var'` — a
        // linha do ⚙️ só aparece aí — e vai para a CONTA como o som: é gosto que segue a pessoa.
        pitch: { pref: 'rhythm_pitch', values: ['on', 'off'] },
        // 🔴 `pref: null` = SÓ no aparelho, nunca na conta: o teclado MIDI está plugado NESTE
        //    computador, e o celular da mesma pessoa nem tem Web MIDI. Subir para `users.data`
        //    seria uma chave a mais na whitelist do PHP para um valor que só vale aqui.
        midi:  { pref: null,           values: ['on', 'off'] }
    };
    static OCTAVE = 4;            // Si 4 era a nota fixa até 18/set; as outras ficam na mesma oitava
    static SAVE_DELAY_MS = 800;

    static _mem = { uid: null, values: {} };
    static _timers = {};

    static _valid(name, v) {
        const f = RhythmPrefs.FIELDS[name];
        return !!f && f.values.includes(v);
    }

    static _um() {
        const um = window.userManager;
        return (um && typeof um.isLoggedIn === 'function' && um.isLoggedIn()) ? um : null;
    }

    static _uid() {
        const um = RhythmPrefs._um();
        try { return um ? String(um.getUserId()) : 'guest'; } catch (e) { return 'guest'; }
    }

    static _local() {
        try {
            const o = JSON.parse(localStorage.getItem(RhythmPrefs.KEY));
            return (o && typeof o === 'object') ? o : {};
        } catch (e) { return {}; }
    }

    static _write(o) {
        try { localStorage.setItem(RhythmPrefs.KEY, JSON.stringify(o)); } catch (e) { /* sem storage: vale só nesta página */ }
    }

    /** O valor que ESTA conta escolheu e a conta ainda não confirmou (ou null). */
    static _pending(name, uid, local) {
        const m = local._pend && local._pend[name];
        const v = (m && typeof m === 'object') ? m[uid] : undefined;
        return RhythmPrefs._valid(name, v) ? v : null;
    }

    /** Valor atual de um ajuste ('tone' | 'ruler' | 'pitch' | 'midi'). Nunca lança; sempre devolve um valor válido. */
    static get(name) {
        const mem = RhythmPrefs._mem, uid = RhythmPrefs._uid();
        if (mem.uid === uid && RhythmPrefs._valid(name, mem.values[name])) return mem.values[name];
        const local = RhythmPrefs._local();
        const pend = (uid !== 'guest' && RhythmPrefs.FIELDS[name].pref) ? RhythmPrefs._pending(name, uid, local) : null;
        if (pend) return pend;
        const um = RhythmPrefs._um();
        if (um && RhythmPrefs.FIELDS[name].pref && typeof um.getPref === 'function') {
            const conta = um.getPref(RhythmPrefs.FIELDS[name].pref);
            if (RhythmPrefs._valid(name, conta)) return conta;
        }
        if (RhythmPrefs._valid(name, local[name])) return local[name];
        return RhythmPrefs.DEFAULTS[name];
    }

    /** Grava um ajuste: vale na hora (página + aparelho) e sobe para a conta depois do último clique. */
    static set(name, value) {
        if (!RhythmPrefs._valid(name, value)) return false;
        const uid = RhythmPrefs._uid();
        if (RhythmPrefs._mem.uid !== uid) RhythmPrefs._mem = { uid, values: {} };
        RhythmPrefs._mem.values[name] = value;
        const o = RhythmPrefs._local();
        o[name] = value;
        const um = RhythmPrefs._um();
        const conta = !!RhythmPrefs.FIELDS[name].pref && uid !== 'guest' && um && typeof um.savePref === 'function';
        if (conta) {
            const m = (o._pend && typeof o._pend[name] === 'object' && o._pend[name]) || {};
            o._pend = Object.assign({}, o._pend, { [name]: Object.assign({}, m, { [uid]: value }) });
        }
        RhythmPrefs._write(o);
        if (conta) RhythmPrefs._send(name, value, uid, um);
        return true;
    }

    /** Sobe para a conta depois do último clique; só a CONFIRMAÇÃO do servidor tira a pendência. */
    static _send(name, value, uid, um) {
        clearTimeout(RhythmPrefs._timers[name]);
        RhythmPrefs._timers[name] = setTimeout(() => {
            // Trocou de conta durante a espera: não grava a escolha de uma na outra.
            if (RhythmPrefs._uid() !== uid) return;
            Promise.resolve(um.savePref(RhythmPrefs.FIELDS[name].pref, value)).then((res) => {
                if (!res || !res.success) return;   // fica pendente: o próximo flush() tenta de novo
                // Só tira a pendência se ela ainda for ESTE valor (uma escolha mais nova continua pendente).
                const o = RhythmPrefs._local();
                const m = o._pend && o._pend[name];
                if (m && typeof m === 'object' && m[uid] === value) { delete m[uid]; RhythmPrefs._write(o); }
            }).catch(() => {});
        }, RhythmPrefs.SAVE_DELAY_MS);
    }

    /** Reenvia o que ficou pendente DESTA conta (chamado ao abrir o jogo). */
    static flush() {
        const um = RhythmPrefs._um(), uid = RhythmPrefs._uid();
        if (!um || uid === 'guest' || typeof um.savePref !== 'function') return;
        const local = RhythmPrefs._local();
        Object.keys(RhythmPrefs.FIELDS).forEach(name => {
            if (!RhythmPrefs.FIELDS[name].pref) return;   // ajuste só de aparelho: nada a subir
            const v = RhythmPrefs._pending(name, uid, local);
            if (v) RhythmPrefs._send(name, v, uid, um);
        });
    }

    /** Volta tudo ao padrão (o "Restaurar padrão" do ⚙️). */
    static reset() {
        // Só o que MUDOU: restaurar o que já está no padrão não gasta pedido nem vira escolha explícita.
        Object.keys(RhythmPrefs.DEFAULTS).forEach(k => { if (RhythmPrefs.get(k) !== RhythmPrefs.DEFAULTS[k]) RhythmPrefs.set(k, RhythmPrefs.DEFAULTS[k]); });
    }

    /**
     * A nota fixa que soa ('D4'…). Com "melodia" (`var`) não há nota única — ver `melody`.
     */
    static pickNote(tone) {
        const t = RhythmPrefs._valid('tone', tone) && tone !== RhythmPrefs.VARY ? tone : RhythmPrefs.DEFAULTS.tone;
        return t + RhythmPrefs.OCTAVE;
    }

    /** Pentatônica de Dó (sem semitom: nenhuma nota "briga" com outra), de Dó 4 a Ré 5. */
    static MELODY_SCALE = ['C4', 'D4', 'E4', 'G4', 'A4', 'C5', 'D5'];

    /**
     * "Melodia": UMA nota por nota do ritmo (18/set, pedido dele — cada toque soa diferente).
     * Não é sorteio solto: sete notas quaisquer em sequência soam como barulho. Anda por
     * PASSOS curtos na pentatônica (vizinha ou pular uma, nunca parada), REBATE nas pontas da
     * escala em vez de travar nelas (travar repetia a nota), começa numa nota do acorde de Dó
     * e TERMINA em Dó — soa como frase. Só a última pode repetir a anterior (Dó antes do Dó). Sorteada no preparo do ritmo, fora do
     * tempo musical, então `Math.random` é legítimo (e injetável para teste).
     */
    static melody(count, rand = Math.random) {
        const S = RhythmPrefs.MELODY_SCALE, max = S.length - 1;
        if (count <= 0) return [];
        const passos = [-2, -1, -1, 1, 1, 2];
        let i = [0, 2, 3][Math.floor(rand() * 3) % 3];     // começa em Dó, Mi ou Sol
        const out = [S[i]];
        for (let k = 1; k < count; k++) {
            let j = i + passos[Math.floor(rand() * passos.length) % passos.length];
            if (j < 0 || j > max) j = i - (j - i);          // rebate na ponta (não trava nela)
            i = Math.max(0, Math.min(max, j));
            out.push(S[i]);
        }
        // Fecha em Dó — o mais perto da PENÚLTIMA nota (a que soa antes dele). Decidir pelo passo
        // sorteado e descartado dava saltos de até 5 graus no fim (o teste mediu).
        if (count > 1) { const pen = S.indexOf(out[count - 2]); out[count - 1] = pen >= 3 ? 'C5' : 'C4'; }
        return out;
    }

    /**
     * Posição na PAUTA de cada nota da melodia (o eixo do `MusicStaff`: 0 = 1ª linha, 4 = linha
     * do meio, 8 = 5ª linha; Dó 4 = −2, na 1ª linha suplementar). É o que o `RhythmRenderer`
     * recebe em `pitches` quando o ajuste "Notas na altura certa" está ligado. Pela MESMA régua
     * da partitura de verdade (`Notation.positionOf`), nunca uma tabela própria: a pentatônica é
     * só de naturais, então a soletração é a da armadura de Dó.
     * @param {string[]} melody - ['C4', 'E4', …]
     * @returns {number[]}
     */
    static positions(melody) {
        const N = window.Notation, PU = window.PitchUtil;
        if (!Array.isArray(melody) || !N || !PU) return [];
        return melody.map(sci => N.positionOf(PU.midiFromSci(sci)));
    }
}

window.RhythmPrefs = RhythmPrefs;



// ============================================
// games/LevelConfig.js
// ============================================
/**
 * LevelConfig - Trilha de níveis do jogo de ritmo (FONTE ÚNICA dos níveis)
 *
 * Espelha o padrão de RHYTHM_FIGURES: um array declarativo (CATALOG) + um objeto
 * com helpers + global em window. Cada nível "liga" um subconjunto do catálogo de
 * figuras e sobrescreve os parâmetros do exercício (bpm/measures/restLimit/ties)
 * ANTES de prepareRound() — NÃO duplica lógica de geração/scoring, só configura.
 *
 * O MODO de jogo (trilha × sandbox) é da ROTA, não daqui: ranqueado (#/ritmo) usa
 * esta trilha; o sandbox (#/ritmo-livre) usa RHYTHM_FIGURES/RHYTHM_TIES. Cada
 * RhythmGame recebe o modo na construção (this.mode) — ver RHYTHM-DOIS-JOGOS.
 *
 * O nível aplica figuras DIRETO em EXERCISE_CONFIG.allowedNotes (mapeando os ids via
 * RHYTHM_FIGURES.byId) SEM tocar a seleção salva do sandbox (STORAGE_KEY das figuras).
 * prepareRound() re-sincroniza EXERCISE_CONFIG conforme o modo corrente (idempotente).
 *
 * Currículo: Mundos 1-6, tudo em 4/4 (compassos compostos = fase tardia). Limiar de
 * aprovação sobe 75% → 84% ao longo da trilha.
 *
 * Os mundos 1-3 escalam por FIGURA (que figura entra no sorteio). Nos mundos 4-5 o
 * eixo muda — mesmas figuras, o que varia é ONDE o som cai: pausa na divisão,
 * sustentação sobre a barra, síncope. O mundo 6 volta à figura, agora pela GRADE
 * (quantas divisões cabem num tempo). Ver docs/RITMO-TRILHA-RODADA2.md §4.
 */
const RHYTHM_LEVELS = {
    PROGRESS_KEY: 'rhythm_level_progress_v1',

    // Cada nível: { id, world, figures:[catalogId], ties?, tieProb?, bpm, measures, restLimit, pass }
    // - figures = ids do RHYTHM_FIGURES.CATALOG (mapeados p/ {type,duration,weight}).
    // - pass = limiar (0-100) que onsetScore E durationScore precisam bater p/ liberar o próximo.
    // - ties = liga ligadura (sustentação/síncope) no gerador, sem persistir no toggle do sandbox.
    // - tieProb = dose da ligadura (0-1, chance por par elegível). Ausente → 0.5 (histórico).
    CATALOG: [
        // ---------- MUNDO 1 — Pulso (semínima/mínima/semibreve + pausas, 4/4) ----------
        { id: 1,  world: 1, figures: ['quarter'], bpm: 60, measures: 2, restLimit: 1, pass: 75 },
        { id: 2,  world: 1, figures: ['quarter', 'quarter-rest'], bpm: 60, measures: 2, restLimit: 1, pass: 75 },
        { id: 3,  world: 1, figures: ['half', 'quarter', 'half-rest', 'quarter-rest'], bpm: 63, measures: 2, restLimit: 2, pass: 78 },
        { id: 4,  world: 1, figures: ['whole', 'half', 'quarter', 'quarter-rest'], bpm: 63, measures: 2, restLimit: 2, pass: 78 },
        { id: 5,  world: 1, figures: ['whole', 'dotted-half', 'half', 'quarter', 'whole-rest', 'half-rest', 'quarter-rest'], bpm: 66, measures: 2, restLimit: 2, pass: 80 },

        // ---------- MUNDO 2 — Subdivisão (colcheia + beam, 4/4) ----------
        { id: 6,  world: 2, figures: ['quarter', 'eighth', 'quarter-rest'], bpm: 60, measures: 2, restLimit: 2, pass: 78 },
        { id: 7,  world: 2, figures: ['half', 'quarter', 'eighth', 'quarter-rest', 'eighth-rest'], bpm: 63, measures: 2, restLimit: 2, pass: 80 },
        { id: 8,  world: 2, figures: ['quarter', 'eighth', 'quarter-rest', 'eighth-rest'], bpm: 66, measures: 2, restLimit: 2, pass: 80 },
        { id: 9,  world: 2, figures: ['half', 'quarter', 'eighth', 'half-rest', 'quarter-rest', 'eighth-rest'], bpm: 69, measures: 2, restLimit: 2, pass: 82 },
        { id: 10, world: 2, figures: ['half', 'quarter', 'eighth', 'quarter-rest', 'eighth-rest'], ties: true, bpm: 66, measures: 2, restLimit: 2, pass: 82 },

        // ---------- MUNDO 3 — Pontos (figuras pontuadas, 4/4) ----------
        { id: 11, world: 3, figures: ['dotted-half', 'half', 'quarter', 'quarter-rest'], bpm: 63, measures: 2, restLimit: 2, pass: 80 },
        { id: 12, world: 3, figures: ['dotted-quarter', 'quarter', 'eighth', 'quarter-rest'], bpm: 63, measures: 2, restLimit: 2, pass: 82 },
        { id: 13, world: 3, figures: ['dotted-quarter', 'quarter', 'eighth', 'eighth-rest', 'quarter-rest'], bpm: 66, measures: 2, restLimit: 2, pass: 82 },
        { id: 14, world: 3, figures: ['dotted-eighth', 'sixteenth', 'quarter', 'quarter-rest'], bpm: 66, measures: 2, restLimit: 2, pass: 82 },
        { id: 15, world: 3, figures: ['dotted-half', 'dotted-quarter', 'dotted-eighth', 'half', 'quarter', 'eighth', 'sixteenth', 'half-rest', 'quarter-rest', 'eighth-rest'], bpm: 69, measures: 2, restLimit: 2, pass: 84 },

        // ---------- MUNDO 4 — Silêncio (pausa na divisão + ligadura de sustentação, 4/4) ----------
        // Nenhuma figura NOVA: o que muda é ONDE o som falta e por quanto ele dura.
        // O 16 isola a ligadura sozinha — sem colcheia no sorteio, o ramo `syncopation`
        // do gerador não tem como disparar, então só sobra o `crossBar` (sustentação).
        //
        // 🔴 FRASES DE 4 COMPASSOS a partir do 18, e não por gosto: a sustentação exige
        // que a nota termine EXATAMENTE numa barra, e em 2 compassos existe UMA barra
        // interna no padrão inteiro. Medido: 2 compassos entregam a lição em ~18% das
        // rodadas mesmo com a dose no máximo; 4 compassos (3 barras) levam a 51-70%.
        // Não era possível ensinar sustentação no formato curto — não é calibragem, é
        // aritmética. De quebra é o eixo do Bellson (frases longas), que estava pronto
        // no renderer e nenhum nível usava.
        { id: 16, world: 4, figures: ['whole', 'half', 'quarter', 'quarter-rest'], ties: true, tieKinds: ['sustain'], tieProb: 1.0, bpm: 63, measures: 2, restLimit: 1, pass: 80 },
        { id: 17, world: 4, figures: ['quarter', 'eighth', 'quarter-rest', 'eighth-rest'], bpm: 63, measures: 2, restLimit: 2, pass: 80 },
        { id: 18, world: 4, figures: ['whole', 'half', 'quarter', 'eighth', 'quarter-rest', 'eighth-rest'], ties: true, tieKinds: ['sustain'], tieProb: 1.0, bpm: 66, measures: 4, restLimit: 2, pass: 82 },
        { id: 19, world: 4, figures: ['half', 'quarter', 'eighth', 'whole-rest', 'half-rest', 'quarter-rest', 'eighth-rest'], bpm: 66, measures: 4, restLimit: 3, pass: 82 },
        { id: 20, world: 4, figures: ['whole', 'half', 'quarter', 'whole-rest', 'half-rest', 'quarter-rest'], ties: true, tieKinds: ['sustain'], tieProb: 1.0, bpm: 66, measures: 4, restLimit: 3, pass: 84 },

        // ---------- MUNDO 5 — Síncope (contratempo, 4/4) ----------
        // Aqui a ligadura muda de papel: no mundo 4 ela SUSTENTA (cruza a barra), aqui
        // ela SINCOPA (colcheia fraca presa ao tempo seguinte). Mesmo motor, dose alta —
        // um mundo de síncope com metade dos padrões sem síncope seria um mundo morno.
        // O 25 é o único que junta as duas lições no mesmo padrão, que é o papel de um boss.
        //
        // 🔴 FRASE DE 4 COMPASSOS NO MUNDO INTEIRO. Até 11/ago o mundo 5 estava em 2 e o
        // mundo 4 já tinha ido a 4 — a trilha ziguezagueava (2,2,4,4,4 | 2,2,2,2,4), o que
        // o Bernardo estranhou jogando. Comprimento de frase é eixo de dificuldade e só
        // CRESCE. O "ambiente seguro" do 21 (o nível que apresenta a síncope) vem do
        // conjunto minúsculo de figuras dele, não do comprimento.
        { id: 21, world: 5, figures: ['quarter', 'eighth', 'quarter-rest'], ties: true, tieKinds: ['syncopation'], tieProb: 0.85, bpm: 60, measures: 4, restLimit: 1, pass: 80 },
        { id: 22, world: 5, figures: ['quarter', 'eighth', 'quarter-rest', 'eighth-rest'], ties: true, tieKinds: ['syncopation'], tieProb: 0.85, bpm: 63, measures: 4, restLimit: 2, pass: 82 },
        { id: 23, world: 5, figures: ['eighth', 'quarter', 'quarter-rest', 'eighth-rest'], ties: true, tieKinds: ['syncopation'], tieProb: 0.9, bpm: 63, measures: 4, restLimit: 2, pass: 82 },
        { id: 24, world: 5, figures: ['half', 'quarter', 'eighth', 'quarter-rest', 'eighth-rest'], ties: true, tieKinds: ['syncopation'], tieProb: 0.9, bpm: 66, measures: 4, restLimit: 2, pass: 84 },
        { id: 25, world: 5, figures: ['whole', 'half', 'quarter', 'eighth', 'quarter-rest', 'eighth-rest'], ties: true, tieKinds: ['syncopation', 'sustain'], tieProb: 1.0, bpm: 66, measures: 4, restLimit: 2, pass: 84 },

        // ---------- MUNDO 6 — Grade fina (semicolcheia, pontuada curta e fusa, 4/4) ----------
        // As 4 figuras que estavam 100% construídas (desenho com vigamento múltiplo, áudio,
        // ícone do painel) e que NENHUM nível usava: sixteenth-rest, dotted-eighth-rest,
        // fusa e fusa-rest. Aqui a dificuldade volta a ser a GRADE — quantas divisões cabem
        // num tempo — depois de dois mundos em que ela era o LUGAR do som.
        //
        // 🔴 O 29 RECUA o andamento de propósito. A fusa a 60 BPM dura 125 ms; a 66 já são
        // 114. Andamento aqui não é degrau, é o que torna a figura legível — e a margem do
        // scorer é em ms FIXOS, então acelerar não compensa nada, só encurta a figura.
        //
        // 🔴 O LIMIAR ENTRA EM 80 e sobe até 84. O plano pedia 84 no 28 e um respiro (82) no
        // 29, que apresenta a fusa — mas dentro de um mundo o limiar não pode recuar (o mapa
        // e o teste tratam isso como escada). O respiro veio na PORTA do mundo: 80 no 26.
        //
        // 🔴 CADA PAUSA VEM COM A SUA DOBRADA quando isso não suja a lição (eighth-rest no 27
        // por causa da sixteenth-rest; a corrente inteira no 30). Sem a pausa maior no nível,
        // o gerador se RECUSA a sortear o par — ver a grafia em RhythmPatternGenerator.
        { id: 26, world: 6, figures: ['sixteenth', 'eighth', 'quarter', 'quarter-rest'], bpm: 63, measures: 4, restLimit: 2, pass: 80 },
        { id: 27, world: 6, figures: ['sixteenth', 'eighth', 'quarter', 'quarter-rest', 'eighth-rest', 'sixteenth-rest'], bpm: 63, measures: 4, restLimit: 2, pass: 82 },
        { id: 28, world: 6, figures: ['dotted-eighth', 'sixteenth', 'quarter', 'quarter-rest', 'eighth-rest', 'dotted-eighth-rest'], bpm: 66, measures: 4, restLimit: 2, pass: 82 },
        { id: 29, world: 6, figures: ['fusa', 'sixteenth', 'eighth', 'quarter', 'quarter-rest', 'fusa-rest'], bpm: 60, measures: 4, restLimit: 2, pass: 82 },
        { id: 30, world: 6, figures: ['fusa', 'sixteenth', 'dotted-eighth', 'eighth', 'quarter', 'half', 'quarter-rest', 'eighth-rest', 'sixteenth-rest', 'fusa-rest'], bpm: 66, measures: 4, restLimit: 2, pass: 84 }
    ],

    byId(id) {
        return this.CATALOG.find(l => l.id === id) || null;
    },

    /** Ids de mundos na ordem (ex.: [1,2,3]). */
    worlds() {
        const seen = [];
        this.CATALOG.forEach(l => { if (!seen.includes(l.world)) seen.push(l.world); });
        return seen;
    },

    firstId() { return this.CATALOG[0].id; },
    lastId() { return this.CATALOG[this.CATALOG.length - 1].id; },

    /** Próximo nível na sequência do catálogo (ou null no fim). */
    nextId(id) {
        const i = this.CATALOG.findIndex(l => l.id === id);
        return (i >= 0 && i < this.CATALOG.length - 1) ? this.CATALOG[i + 1].id : null;
    },

    // ---------- progresso (persistência) ----------

    /** { current, highestUnlocked }. Defaults: começa no nível 1, só ele liberado. */
    getProgress() {
        const first = this.firstId();
        try {
            const raw = window.localStorage && window.localStorage.getItem(window.StorageScope.key(this.PROGRESS_KEY));
            if (raw) {
                const p = JSON.parse(raw);
                const current = this.byId(p.current) ? p.current : first;
                const highestUnlocked = this.byId(p.highestUnlocked) ? p.highestUnlocked : first;
                return { current, highestUnlocked };
            }
        } catch (e) { /* localStorage indisponível/corrompido → defaults */ }
        return { current: first, highestUnlocked: first };
    },

    _saveProgress(p) {
        try {
            if (window.localStorage) window.localStorage.setItem(window.StorageScope.key(this.PROGRESS_KEY), JSON.stringify(p));
        } catch (e) { /* sem persistência, segue em memória */ }
    },

    /** Um nível está liberado se seu índice ≤ índice do maior desbloqueado. */
    isUnlocked(id) {
        const hi = this.getProgress().highestUnlocked;
        const iHi = this.CATALOG.findIndex(l => l.id === hi);
        const iId = this.CATALOG.findIndex(l => l.id === id);
        return iId >= 0 && iId <= iHi;
    },

    isCleared(id) {
        // "Concluído" = já liberou um nível posterior a este (índice < maior desbloqueado).
        const hi = this.getProgress().highestUnlocked;
        const iHi = this.CATALOG.findIndex(l => l.id === hi);
        const iId = this.CATALOG.findIndex(l => l.id === id);
        return iId >= 0 && iId < iHi;
    },

    /** Define o nível corrente (só se liberado). Retorna o id efetivo. */
    setCurrent(id) {
        const p = this.getProgress();
        if (this.isUnlocked(id)) { p.current = id; this._saveProgress(p); }
        return p.current;
    },

    getCurrent() { return this.getProgress().current; },

    /**
     * Registra o resultado de um take avaliado no nível `id`. Se ambos os placares
     * ≥ pass, desbloqueia o PRÓXIMO nível (se houver). Retorna:
     *   { passed, newlyUnlocked, nextId }  — newlyUnlocked = true só na 1ª vez.
     */
    recordResult(id, onsetScore, durationScore) {
        const level = this.byId(id);
        if (!level) return { passed: false, newlyUnlocked: false, nextId: null };
        // 🔴 ARREDONDA, como a TELA. O card imprime `Math.round` nos dois placares e o
        // `_maybeSaveScore` manda ao ranking `min(round, round)` — o portão era o único dos
        // três consumidores no float. Resultado medido: onset 74,6 / duração 90 pintava
        // "Início 75% · Duração 90%" com "Quase! Tire 75% nos dois placares" embaixo, e o
        // nível não abria. É a mesma queixa que abriu esta frente ("acertei e deu erro"),
        // só que na fronteira. O efeito é ≤0,5 pp, sempre a FAVOR de quem lê a tela.
        const passed = Math.round(onsetScore) >= level.pass && Math.round(durationScore) >= level.pass;
        const next = this.nextId(id);
        let newlyUnlocked = false;
        if (passed && next != null) {
            const p = this.getProgress();
            const iHi = this.CATALOG.findIndex(l => l.id === p.highestUnlocked);
            const iNext = this.CATALOG.findIndex(l => l.id === next);
            if (iNext > iHi) { p.highestUnlocked = next; this._saveProgress(p); newlyUnlocked = true; }
        }
        return { passed, newlyUnlocked, nextId: next };
    },

    // ---------- melhor take por nível (fila de sincronização do ranking) ----------
    //
    // A MÁQUINA saiu daqui e virou `LevelProgress` (core) quando a Leitura passou a
    // precisar da mesma coisa — o Ritmo é só o primeiro inquilino, registrado no rodapé
    // deste arquivo. Mesma chave física de sempre (`rhythm_level_best_v1`): zero
    // migração, os recordes já gravados continuam valendo. Estes 4 métodos ficam como
    // FACHADA porque `RhythmLevels.recordBest(...)` é o vocabulário que o RhythmGame
    // (e os testes) já falam — a fachada é barata e a troca não vaza pro jogo.

    BEST_KEY: 'rhythm_level_best_v1',

    /** Instância compartilhada (registrada no rodapé). null só se o core não carregou. */
    progress() { return window.LevelProgress ? window.LevelProgress.get('ritmo') : null; },

    getBests() { const p = this.progress(); return p ? p.getBests() : {}; },
    recordBest(id, take) { const p = this.progress(); return p ? p.recordBest(id, take) : null; },
    markBestSynced(id, seq = null) { const p = this.progress(); if (p) p.markBestSynced(id, seq); },
    pendingBests() { const p = this.progress(); return p ? p.pendingBests() : []; },

    // ---------- aplicação em EXERCISE_CONFIG ----------

    /**
     * Sobrescreve EXERCISE_CONFIG com a config do nível `id`: allowedNotes (figuras
     * do nível mapeadas via RHYTHM_FIGURES.byId), measures/restLimit/ties/bpm, e 4/4 com
     * clique inteiro (a trilha é toda em 4/4; ver o vazamento inverso no RhythmSandbox).
     * NÃO toca a seleção salva do sandbox. Retorna o nível aplicado (ou null).
     */
    apply(id) {
        const level = this.byId(id);
        if (!level || !window.EXERCISE_CONFIG || !window.RhythmFigures) return null;
        const cfg = window.EXERCISE_CONFIG;
        cfg.allowedNotes = level.figures
            .map(fid => window.RhythmFigures.byId(fid))
            .filter(Boolean)
            .map(f => ({ type: f.id, duration: f.duration, weight: f.weight }));
        cfg.measures = level.measures;
        cfg.consecutiveRestLimit = level.restLimit;
        cfg.tiesEnabled = !!level.ties;
        cfg.tieProb = (typeof level.tieProb === 'number')
            ? level.tieProb
            : (window.RhythmTies ? window.RhythmTies.DEFAULT_PROB : 0.5);
        cfg.tieKinds = Array.isArray(level.tieKinds) ? level.tieKinds.slice() : null;
        cfg.bpm = level.bpm;
        // 🔴 Fórmula e clique ESCRITOS, não herdados: o personalizado grava 2/4, 3/4 e clique
        // mudo neste mesmo objeto global, e sem estas duas linhas quem sai do 3/4 do livre
        // entra na trilha em 3/4 (o vazamento no sentido inverso ao do RhythmSandbox).
        cfg.timeSignature = { beats: 4, noteValue: 4 };
        cfg.click = 'all';
        return level;
    },

    /** Aplica o nível corrente (atalho usado pelo jogo no modo trilha). */
    applyCurrent() { return this.apply(this.getCurrent()); }
};

// Disponibiliza globalmente
window.RhythmLevels = RHYTHM_LEVELS;

// Ficha do Ritmo no ranking (FONTE ÚNICA: a RankingScreen e o backfill leem daqui).
// `levels` deriva do CATALOG → a trilha cresce de 15 a 100 níveis sem tocar nada disto.
if (window.LevelProgress) {
    window.LevelProgress.register({
        gameId: 'ritmo',
        storageKey: RHYTHM_LEVELS.BEST_KEY,
        nameKey: 'games.rhythm.name',
        route: '#/ritmo',
        levels: () => RHYTHM_LEVELS.CATALOG.map(l => l.id),
        currentLevel: () => RHYTHM_LEVELS.getCurrent(),
        levelInfo: (id) => { const l = RHYTHM_LEVELS.byId(id); return l ? { world: l.world, pass: l.pass } : null; },
        // Tabela de LITERAIS, nunca `'rhythm.level.world' + w` (regra das chaves montadas; auditoria 17/set).
        worldName: (w) => ({ key: ({ 1: 'rhythm.level.world1', 2: 'rhythm.level.world2', 3: 'rhythm.level.world3', 4: 'rhythm.level.world4', 5: 'rhythm.level.world5', 6: 'rhythm.level.world6' })[w] || '' }),
        // Devolução de progresso (login noutro device/browser): chega a lista de níveis
        // APROVADOS e aqui ela vira o formato DESTE jogo — `{current, highestUnlocked}`
        // com ids do CATALOG, não um inteiro. Libera o PRÓXIMO do maior aprovado (mesma
        // regra do `recordResult`) e só SOBE: nunca rebaixa quem está à frente localmente.
        applyUnlock: (passed) => {
            if (!Array.isArray(passed) || !passed.length) return;
            const idx = (id) => RHYTHM_LEVELS.CATALOG.findIndex(l => l.id === id);
            const topPassed = passed.reduce((a, b) => (idx(b) > idx(a) ? b : a), passed[0]);
            const next = RHYTHM_LEVELS.nextId(topPassed);
            const target = next != null ? next : topPassed;   // aprovou o último: fica nele
            const p = RHYTHM_LEVELS.getProgress();
            if (idx(target) > idx(p.highestUnlocked)) {
                p.highestUnlocked = target;
                RHYTHM_LEVELS._saveProgress(p);
            }
        }
    });
} else if (typeof console !== 'undefined') {
    // Falha de ORDEM no loadOrder do sync-class. Sem este aviso o ranking morre em
    // silêncio (recordBest passa a devolver null e nada mais acontece).
    console.warn('[LevelConfig] LevelProgress ausente — Ritmo fora do ranking. Conferir loadOrder.');
}



// ============================================
// games/RhythmTrails.js
// ============================================
/**
 * RhythmTrails — a TRILHA DO PROFESSOR no cliente (docs/LISTAS-PLANO.md, fase 1a, 17/set/2026).
 * Dado puro, sem DOM: normaliza a lista que veio do servidor, guarda o progresso da pessoa
 * POR CONTA no aparelho e decide o que está liberado. O jogo (RhythmGame, modo `list`), a
 * capa (#/trilha/:code, TrailScreen) e o editor leem daqui — um lugar só.
 *
 * Em português comum: uma trilha é uma sequência de exercícios do Ritmo Livre, do tamanho que
 * quem a montou quis (1 ou 100 níveis). Cada nível é a foto do painel ⚙️ mais uma nota de
 * corte opcional. Isto aqui é a régua que diz "este nível está liberado?", "bateu a meta?",
 * "qual é o próximo?".
 *
 * 🔴 IDENTIDADE DO NÍVEL É O `lid`, NUNCA A POSIÇÃO: o professor insere um nível no meio e
 *    todo progresso continua apontando para o exercício certo. A posição é só o que a tela mostra.
 * 🔴 O PROGRESSO FICA POR CONTA (`StorageScope.key` → `::u<id>`) e FORA de `PROGRESS_BASE_KEYS`:
 *    convidado nunca joga trilha (a capa pede conta), então não há adoção guest→conta a tratar,
 *    e "Zerar progresso" não toca aqui. Subir ao servidor e seguir a conta = fase 2.
 * 🔴 NADA daqui escreve no preset do personalizado nem em `rhythm_bpm`: o preset do nível é
 *    escrito em EXERCISE_CONFIG por `RhythmSandbox.writeLevel` (só memória).
 * 🔴 `seed` + `gen`: com semente, todos tocam o MESMO padrão — mas só enquanto o gerador for o
 *    mesmo (`RhythmPatternGenerator.GEN`). Versão diferente ⇒ a semente é IGNORADA (sorteio
 *    normal), nunca um padrão torto de um gerador que mudou.
 * 🔴 Nível SEM `pass` é TREINO: joga, vê o placar, e conta como feito na 1ª rodada. Com `pass`,
 *    "feito" = `min(Início, Duração) ≥ pass` (arredondado como a TELA, a régua do `recordResult`
 *    da trilha oficial), `takes` vezes.
 * 🔴 MODO TESTE (`list.test`, oficina 18/set): quem MONTOU a trilha abre um nível para ver o que o
 *    aluno verá. Cadeado nenhum (o dono não tem de concluir o 3 para ver o 7), e NADA se grava —
 *    nem progresso no aparelho, nem `level_result` no diário (senão o professor entrava no "N
 *    começaram" da própria trilha). Só `RhythmFreeScreen.prepare` liga a bandeira, e só com `can_edit`.
 */
const RHYTHM_TRAILS = {
    /**
     * 🔴 A CORTINA (18/set): `false` esconde a trilha do PÚBLICO — o botão "＋ Usar este exercício numa
     * trilha" (e o seu "?") no Ritmo Livre, o cartão "Minhas trilhas" em #/perfil e o tópico na Central de
     * ajuda. Tudo o mais fica no bundle e funciona por LINK (`#/trilha/CÓDIGO`, `?lista=`) — só não há
     * como chegar lá sem um código, e não existe código antes do `deploy-api.sh` (migração 014). Decisão
     * dele: subir atualizações menores do app com a trilha nos bastidores, até auditar. Os testes ligam
     * a bandeira (`window.RhythmTrails.ENABLED = true`); virar `true` aqui é o lançamento.
     * 🔴 ABERTA NO LOCAL em 22/set (decisão dele: soltar devagar, sem convocação; ele espia antes).
     *    Enquanto ele decide, NADA MAIS sobe por `--live` — o deploy sobe a pasta, não a mudança.
     */
    ENABLED: true,
    /**
     * A TRILHA EXEMPLO (22/set): uma trilha pronta, de uma conta de professor, para quem abre a
     * ferramenta entender o formato em dois minutos — sem manifesto. É DADO, não código: vive no banco
     * (local: `Profa. Quinta`, do simulador; prod: recriar no dia do deploy com o MESMO código, que é
     * escolhido à mão dentro do alfabeto do servidor — sem 0/O/1/I). Código vazio = nenhum link aparece
     * (o "?" do Ritmo Livre, a capa do Ritmo Livre e "Minhas trilhas" leem `sampleRoute()`).
     */
    SAMPLE_CODE: 'EXEMPLARYTHM',
    /** Por idioma (os rótulos de nível são texto do autor e não se traduzem); ausente = cai no SAMPLE_CODE. */
    SAMPLE_CODES: { pt: 'EXEMPLARYTHM', en: 'EXAMPLERHYTM', es: 'EJEMPLRYTHMS' },
    sampleRoute() {
        const lang = (window.language && window.language.currentLanguage) || 'pt';
        const c = String(this.SAMPLE_CODES[lang] || this.SAMPLE_CODE || '');
        return this.CODE_RE.test(c) ? '#/trilha/' + c : null;
    },
    PROGRESS_KEY: 'rhythm_lists_progress_v1',   // + StorageScope (::u<id>)
    VERSION: 1,
    MAX_LEVELS: 120,        // espelho de LISTS_MAX_LEVELS (lists.php) — o teste lê os dois
    NAME_MAX: 80,           // espelho de LISTS_NAME_MAX
    LABEL_MAX: 40,          // espelho de LISTS_LABEL_MAX
    TAKES_MAX: 20,          // espelho de LISTS_TAKES_MAX
    CODE_RE: /^[A-Z2-9]{12}$/,   // espelho de LISTS_CODE_LEN + alfabeto

    /**
     * Cria uma trilha EM BRANCO (1 nível, só semínimas — o começo da trilha exemplo) com nome padrão e
     * devolve a resposta do servidor. Quem chama navega para a oficina. Um lugar só para as duas portas
     * (#/perfil "＋ Nova trilha" e o link no Ritmo Livre, 22/set) — a recusa é do servidor e vira frase.
     */
    async createBlank(um, t) {
        const S = window.RhythmSandbox;
        if (!um || !um.saveList || !S) return { success: false, code: 'generic' };
        const level = this.normalizeLevel({ preset: S.normalize(Object.assign(S.defaultPreset(), { figures: ['quarter'] }), { level: true }) }, []);
        return um.saveList({ code: '', name: this.defaultName(um.getUser && um.getUser(), t), levels: this.serializeLevels([level]) });
    },

    /** Identidade nova de nível: curta, minúscula, única dentro da lista (o servidor exige a forma). */
    newLid(taken = []) {
        const abc = 'abcdefghijklmnopqrstuvwxyz0123456789';
        for (let t = 0; t < 50; t++) {
            let s = '';
            for (let i = 0; i < 6; i++) s += abc[Math.floor(Math.random() * abc.length)];
            if (!taken.includes(s)) return s;
        }
        return 'l' + Date.now().toString(36).slice(-7);
    },

    /** Semente nova para "mesmo ritmo para todos" (inteiro 31 bits, como o servidor aceita). */
    newSeed() {
        try {
            if (window.crypto && window.crypto.getRandomValues) {
                const a = new Uint32Array(1); window.crypto.getRandomValues(a); return a[0] & 0x7fffffff;
            }
        } catch (e) { /* cai no Math.random */ }
        return Math.floor(Math.random() * 0x7fffffff);
    },

    /**
     * Um nível normalizado: `{ lid, preset, pass, takes, label, seed, gen }`. O preset passa pelo
     * ÚNICO normalizador (`RhythmSandbox.normalize`, régua de nível) — campo inválido = padrão.
     * `pass` null = treino; `takes` 1..TAKES_MAX; `label` texto do autor (não se traduz).
     */
    normalizeLevel(raw, taken = []) {
        raw = (raw && typeof raw === 'object') ? raw : {};
        const S = window.RhythmSandbox;
        const lid = (typeof raw.lid === 'string' && /^[a-z0-9]{4,12}$/.test(raw.lid) && !taken.includes(raw.lid)) ? raw.lid : this.newLid(taken);
        const preset = S ? S.normalize(raw.preset, { level: true }) : (raw.preset || {});
        const passN = Number(raw.pass);
        const pass = (raw.pass != null && Number.isFinite(passN) && passN >= 0 && passN <= 100) ? Math.round(passN) : null;
        const takesN = Number(raw.takes);
        const takes = (Number.isFinite(takesN) && takesN >= 1) ? Math.min(this.TAKES_MAX, Math.round(takesN)) : 1;
        const label = (typeof raw.label === 'string') ? raw.label.replace(/[\x00-\x1F\x7F]/g, ' ').trim().slice(0, this.LABEL_MAX) : '';
        const seedN = Number(raw.seed);
        const seed = (raw.seed != null && Number.isFinite(seedN) && seedN >= 0) ? Math.floor(seedN) : null;
        const genN = Number(raw.gen);
        const gen = (seed != null && Number.isFinite(genN) && genN >= 1) ? Math.floor(genN) : null;
        return { lid, preset, pass, takes, label, seed: gen ? seed : null, gen };
    },

    /** A lista inteira normalizada (o que o servidor devolveu em `list`), ou null se não tem níveis. */
    normalizeList(raw) {
        if (!raw || typeof raw !== 'object' || !Array.isArray(raw.levels) || !raw.levels.length) return null;
        const levels = [];
        raw.levels.slice(0, this.MAX_LEVELS).forEach(l => { levels.push(this.normalizeLevel(l, levels.map(x => x.lid))); });
        return {
            code: String(raw.code || ''),
            name: String(raw.name || ''),
            rev: Math.max(1, Number(raw.rev) || 1),
            levels,
            author: raw.author && typeof raw.author === 'object' ? { name: String(raw.author.name || '') } : null,
            group: raw.group && typeof raw.group === 'object' ? { id: Number(raw.group.id) || 0, name: String(raw.group.name || '') } : null
        };
    },

    /** O que se MANDA ao servidor (`list_put`): só os campos do formato, sem lixo de normalização. */
    serializeLevels(levels) {
        return levels.map(l => {
            const p = l.preset || {};
            const o = { lid: l.lid, preset: {
                timeSig: { beats: p.timeSig ? p.timeSig.beats : 4, noteValue: 4 }, measures: p.measures, restLimit: p.restLimit,
                bpm: p.bpm, figures: (p.figures || []).slice(), ties: !!p.ties, tieKinds: p.tieKinds ? p.tieKinds.slice() : null,
                click: p.click
            } };
            if (Number.isFinite(p.tieProb)) o.preset.tieProb = p.tieProb;
            if (l.pass != null) o.pass = l.pass;
            if (l.takes > 1) o.takes = l.takes;
            if (l.label) o.label = l.label;
            if (l.seed != null && l.gen) { o.seed = l.seed; o.gen = l.gen; }
            return o;
        });
    },

    /**
     * O nome com que a trilha NASCE (a oficina o edita no campo do topo; o modal de nome saiu em
     * 18/set): "Trilha de ⟨primeiro nome⟩", ou "Trilha nova" sem nome. `t(key, params)`.
     */
    defaultName(user, t) {
        const raw = user && typeof user.name === 'string' ? user.name.trim() : '';
        const first = raw.split(/\s+/)[0] || '';
        return (first ? t('rhythm.trails.defaultNameOf', { name: first }) : t('rhythm.trails.defaultName')).slice(0, this.NAME_MAX);
    },

    /** Nível a partir da FOTO do painel (`RhythmSandbox.snapshot()`), com identidade nova. */
    levelFromSnapshot(snapshot, taken = [], extra = {}) {
        return this.normalizeLevel({ lid: this.newLid(taken), preset: snapshot, ...extra }, taken);
    },

    // ---------- semente ----------

    /** mulberry32: pequeno, determinístico, suficiente para sorteio de figura. */
    rng(seed) {
        let a = (Number(seed) >>> 0) || 1;
        return function () {
            a = (a + 0x6D2B79F5) >>> 0;
            let t = a;
            t = Math.imul(t ^ (t >>> 15), t | 1);
            t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
            return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
        };
    },

    /** A fonte de aleatório para ESTE nível: semeada se há `seed` e o `gen` é o do gerador de hoje; senão null (sorteio). */
    rngFor(level) {
        const G = window.RhythmPatternGenerator;
        if (!level || level.seed == null || !G || level.gen !== G.GEN) return null;
        return this.rng(level.seed);
    },

    // ---------- progresso (por conta, no aparelho) ----------

    _key() {
        try { return window.StorageScope ? window.StorageScope.key(this.PROGRESS_KEY) : this.PROGRESS_KEY + '::guest'; }
        catch (e) { return this.PROGRESS_KEY + '::guest'; }
    },
    _readAll() {
        try {
            const raw = window.localStorage && window.localStorage.getItem(this._key());
            const o = raw ? JSON.parse(raw) : null;
            return (o && typeof o === 'object' && !Array.isArray(o)) ? o : {};
        } catch (e) { return {}; }
    },
    _writeAll(all) {
        try { if (window.localStorage) window.localStorage.setItem(this._key(), JSON.stringify(all)); } catch (e) { /* sem persistência: vale a memória */ }
    },

    /** `{ at: lid|null, done: { [lid]: vezes feitas } }` desta trilha, para a conta corrente. */
    progressOf(code) {
        const p = this._readAll()[code];
        const done = (p && p.done && typeof p.done === 'object') ? p.done : {};
        return { at: p && typeof p.at === 'string' ? p.at : null, done };
    },
    _saveProgress(code, p) {
        const all = this._readAll();
        all[code] = { at: p.at, done: p.done };
        this._writeAll(all);
    },

    indexOf(list, lid) { return list.levels.findIndex(l => l.lid === lid); },
    byLid(list, lid) { return list.levels.find(l => l.lid === lid) || null; },

    /** Quantas vezes o nível foi FEITO (bateu a meta, ou jogado, se treino). */
    doneCount(list, lid) { return Number(this.progressOf(list.code).done[lid]) || 0; },
    /** Concluído = feito `takes` vezes. */
    isCleared(list, lid) {
        const l = this.byLid(list, lid);
        return !!l && this.doneCount(list, lid) >= l.takes;
    },
    /** Liberado = todos os anteriores concluídos (o 1º sempre). No modo TESTE, todos. */
    isUnlocked(list, lid) {
        const i = this.indexOf(list, lid);
        if (i < 0) return false;
        if (list.test) return true;
        for (let k = 0; k < i; k++) if (!this.isCleared(list, list.levels[k].lid)) return false;
        return true;
    },
    /** O nível "de agora": o guardado, se liberado; senão o 1º não concluído; senão o último. */
    currentLid(list) {
        if (list.test && list._testAt && this.byLid(list, list._testAt)) return list._testAt;
        const p = this.progressOf(list.code);
        if (p.at && this.byLid(list, p.at) && this.isUnlocked(list, p.at)) return p.at;
        const first = list.levels.find(l => !this.isCleared(list, l.lid));
        return (first || list.levels[list.levels.length - 1]).lid;
    },
    /** Marca o nível corrente (só se liberado). Devolve o lid efetivo. */
    setCurrent(list, lid) {
        const eff = this.isUnlocked(list, lid) ? lid : this.currentLid(list);
        if (list.test) { list._testAt = eff; return eff; }     // teste: só em memória
        const p = this.progressOf(list.code);
        p.at = eff;
        this._saveProgress(list.code, p);
        return eff;
    },
    nextLid(list, lid) {
        const i = this.indexOf(list, lid);
        return (i >= 0 && i < list.levels.length - 1) ? list.levels[i + 1].lid : null;
    },

    /**
     * Registra uma rodada avaliada. Devolve
     *   { training, passed, counted, done, takes, cleared, newlyUnlocked, nextLid }
     * `passed` = bateu a meta (treino: sempre true); `counted` = esta rodada somou;
     * `newlyUnlocked` = o PRÓXIMO acabou de abrir (1ª vez).
     * 🔴 Arredonda como a TELA (`Math.round`), a régua do `recordResult` da trilha oficial.
     */
    recordResult(list, lid, onsetScore, durationScore, { bestMs = null, noInput = false } = {}) {
        const l = this.byLid(list, lid);
        if (!l) return { training: false, passed: false, counted: false, done: 0, takes: 1, cleared: false, newlyUnlocked: false, nextLid: null };
        const training = l.pass == null;
        // 🔴 Sem NENHUM toque a rodada não conta — nem o treino (auditoria 22/set: quem não tocou passava de nível).
        const passed = !noInput && (training || (Math.round(onsetScore) >= l.pass && Math.round(durationScore) >= l.pass));
        // TESTE do dono: o veredito sai igual, mas nada se grava (nem diário, nem progresso).
        if (list.test) {
            // sem `nextLid`: o teste é de UM nível (o "próximo" avançaria o `_testAt` e a barra "← trilha",
            // congelada no init, voltaria a outro nível que não o botão do resultado)
            return { training, passed, counted: false, done: passed ? 1 : 0, takes: l.takes, cleared: passed, newlyUnlocked: false, nextLid: null, test: true, noInput };
        }
        // DIÁRIO (user_events): a rodada da trilha vai por gancho PRÓPRIO — nunca pelo recordBest da
        // oficial (o bag do ranqueado fica intocado). Mesmo desenho do LevelProgress: quem registra
        // a rodada é quem a anota. `list`+`lid`+`rev` = identidade; `level` = a POSIÇÃO na hora.
        // No-op para convidado (o tracker é só de logado). Nunca quebra o jogo.
        try {
            const onset = Math.round(onsetScore), duration = Math.round(durationScore);
            const pct = (v) => (Number.isFinite(v) && v >= 0 && v <= 100) ? v : null;
            const game = (window.EventTracker && window.EventTracker.gameFor('rhythm')) || { id: 'ritmo' };
            window.eventTracker?.track('level_result', {
                game_id: game.id, level: this.indexOf(list, lid) + 1, accuracy: Math.min(onset, duration), passed: passed ? 1 : 0,
                best_ms: bestMs != null ? Math.min(bestMs, 600000) : null,
                onset: pct(onsetScore), duration: pct(durationScore),
                list: list.code, lid, rev: list.rev
            });
        } catch (e) { /* diário nunca quebra o jogo */ }
        const p = this.progressOf(list.code);
        const wasCleared = (Number(p.done[lid]) || 0) >= l.takes;
        let counted = false;
        if (passed) { p.done[lid] = (Number(p.done[lid]) || 0) + 1; counted = true; }
        p.at = lid;
        this._saveProgress(list.code, p);
        const done = Number(p.done[lid]) || 0;
        const cleared = done >= l.takes;
        const next = this.nextLid(list, lid);
        return { training, passed, counted, done, takes: l.takes, cleared, noInput,
                 newlyUnlocked: cleared && !wasCleared && next != null, nextLid: cleared ? next : null };
    }
};

window.RhythmTrails = RHYTHM_TRAILS;



// ============================================
// games/RhythmPatternGenerator.js
// ============================================
/**
 * RhythmPatternGenerator - Gera padrões rítmicos aleatórios válidos
 *
 * Responsabilidade ÚNICA:
 * - Gerar sequência de notas/pausas respeitando configuração
 * - Validar que padrão preenche compassos corretamente (4 beats cada)
 * - Respeitar pesos (weights) e limites de pausas consecutivas
 *
 * Funciona com QUALQUER seleção do catálogo (RHYTHM_FIGURES), inclusive
 * durações fracionárias (colcheia 0.5, semínima pontuada 1.5): o sorteio só
 * considera figuras que CABEM no restante do compasso; se nenhuma habilitada
 * couber, preenche com a maior figura padrão que caiba (greedy — como toda
 * duração do catálogo é múltipla de 0.5, o compasso sempre fecha exato).
 */
class RhythmPatternGenerator {
    /**
     * VERSÃO DO SORTEIO. A trilha do professor grava `seed` + `gen` no nível (docs/LISTAS-PLANO.md):
     * com a mesma semente e a mesma versão, todos os alunos tocam o MESMO padrão. 🔴 Mudou a
     * ordem/quantidade de sorteios aqui (uma chamada a mais ao `rng`, um ramo novo que consome
     * aleatório)? SUBA este número — senão a semente antiga passa a produzir OUTRO padrão em
     * silêncio, e o jogo (RhythmTrails.rngFor) ignora a semente quando o `gen` não bate.
     */
    static GEN = 1;

    /** @param {Function} [rng] fonte de aleatório 0..1 (padrão Math.random; a trilha injeta a semeada) */
    constructor(config, rng = null) {
        this.config = config; // EXERCISE_CONFIG
        this.EPS = 1e-9;      // tolerância p/ comparações com durações fracionárias
        this._rand = typeof rng === 'function' ? rng : Math.random;
    }

    /**
     * Gera um padrão rítmico aleatório
     * Gera compasso por compasso para garantir exatidão musical
     * @returns {RhythmPattern}
     */
    generate() {
        // 🔴 PADRÃO SÓ DE PAUSAS SE SORTEIA DE NOVO. O `_ensureSoundingNote` converte a 1ª
        // pausa em nota PELA DURAÇÃO dela — com 1 compasso e a pausa de compasso marcada, isso
        // punha semibreve/mínima pontuada que ninguém escolheu em ~14% das rodadas (auditoria
        // 16/set). Ele fica como último recurso, depois de TENTATIVAS sorteios.
        const TENTATIVAS = 30;
        let notes = null;
        for (let t = 0; t < TENTATIVAS; t++) {
            notes = this._generateNotes();
            if (notes.some(n => n.type === 'note')) break;
        }

        this._ensureSoundingNote(notes);
        this._consolidateRests(notes);
        if (this.config.tiesEnabled) this._applyTies(notes);
        return new window.RhythmPattern(notes, this.config);
    }

    /** Sorteia as figuras do padrão inteiro (sem a garantia de nota sonora nem a grafia final). */
    _generateNotes() {
        const beatsPerMeasure = this.config.timeSignature.beats;
        const notes = [];
        let totalBeat = 0;

        // Gera cada compasso separadamente. O contador de pausas consecutivas
        // ATRAVESSA a fronteira de compasso (senão 2 pausas no fim de um + 2 no
        // início do outro = 4 seguidas, burlando o limite).
        //
        // 🔴 COMPASSO SUJO SE SORTEIA DE NOVO. Uma escolha legal no começo pode deixar o resto
        // do compasso sem opção de grafia certa, e o sorteio então aceita a pausa mal escrita
        // ou cai na escada do preenchimento (figura fora da seleção). Em compasso curto (2/4)
        // isso passava de 60% com seleções pequenas — e já existia em 4/4. Tentar o compasso
        // de novo, com o contador de pausas restaurado, é barato; o sujo fica como último recurso.
        const restState = { run: 0 };
        for (let measure = 0; measure < this.config.measures; measure++) {
            const run0 = restState.run;
            let measureNotes = null;
            for (let t = 0; t < 12; t++) {
                restState.run = run0;
                const sujo = { v: false };
                measureNotes = this.generateMeasure(measure, totalBeat, restState, notes, sujo);
                if (!sujo.v) break;
            }
            notes.push(...measureNotes);
            totalBeat += beatsPerMeasure;
        }
        return notes;
    }

    // ------------------------------------------------------------------
    // GRAFIA DAS PAUSAS
    //
    // Regra de notação (não é gosto): duas pausas IGUAIS e contíguas, alinhadas à
    // divisão métrica, escrevem-se como UMA pausa do dobro. Em 4/4: duas semínimas
    // nos tempos 1-2 ou 3-4 viram uma mínima; nos tempos 2-3 NÃO (atravessariam a
    // metade do compasso, que é justamente o que a grafia tem de mostrar).
    //
    // O sorteio é figura a figura e não sabia disso: 4 a 47% das rodadas saíam com
    // um par mal escrito, em TODOS os níveis (não é regressão dos mundos novos).
    //
    // 🔴 Nem todo nível tem a pausa maior no seu conjunto de figuras (o nível 4 gera
    // o par de semínimas e não conhece a pausa de mínima). Consolidar assim mesmo
    // faria surgir na pauta um símbolo que o nível não ensinou. Por isso são DOIS
    // caminhos, e os dois valem: quando a pausa maior está no nível, funde-se aqui;
    // quando não está, o sorteio se recusa a criar o par (ver generateMeasure).
    //
    // 🔴 E A REGRA TEM DUAS DIREÇÕES — a segunda custou uma auditoria para aparecer.
    // Juntar o que está partido é metade; a outra metade é NÃO ESCREVER uma pausa
    // sozinha em cima da divisão. Uma pausa de semínima começando em X,5 esconde o
    // tempo seguinte tanto quanto duas de colcheia escondem a metade do compasso —
    // e o primeiro corte deste conserto a deixava passar em 42-91% das rodadas,
    // porque só olhava PARES. Daí `_restStartOk`, aplicada no sorteio.
    //
    // 🔴 ESTAS REGRAS SÃO DIÁDICAS: valem em 4/4 e 2/4, onde toda duração é metade
    // da anterior. Em 3/4 (personalizado, 16/set) elas dão a grafia certa nos casos
    // simples — semínimas nos tempos 1-2 fundem, nos 2-3 não; pausa de mínima no tempo 2
    // é recusada — e o que a hierarquia diádica NÃO alcança é o compasso mudo: mínima +
    // semínima não é par. Daí `_mergeSilentMeasure` (ver abaixo), casos à mão no
    // levels-test. Em 6/8 a hierarquia é outra (3+3) — REVISAR ANTES de 6/8.
    //
    // 🔴 PAUSA DE COMPASSO segue a FÓRMULA: `whole-rest` é "este compasso é mudo" em
    // qualquer fórmula (convenção universal), então vale 3 tempos em 3/4 e 2 em 2/4.
    // O catálogo guarda 4 (4/4); `_allowed()` devolve a duração efetiva.
    // ------------------------------------------------------------------

    /** allowedNotes com a duração EFETIVA nesta fórmula (a pausa de compasso = o compasso). */
    _allowed() {
        const beats = this.config.timeSignature.beats;
        return (this.config.allowedNotes || []).map(n =>
            n.type === 'whole-rest' ? { type: n.type, duration: beats, weight: n.weight } : n);
    }

    /**
     * Esta pausa pode COMEÇAR aqui? Regra: uma pausa de duração d se escreve num
     * múltiplo de d dentro do compasso — senão ela atravessa uma divisão mais forte
     * do que a que a abriu, e o olho perde o tempo. (Pausa de semínima nos tempos
     * 1,2,3,4 sim; começando em 1,5 não — ali são duas de colcheia.)
     * Pausa PONTUADA não é diádica: exige-se apenas que caiba DENTRO de um tempo.
     */
    _restStartOk(beat, duration) {
        const beats = this.config.timeSignature.beats;
        const ini = beat % beats;
        // pausa de compasso: começa na barra e só (3 tempos em 3/4 não é diádica nem pontuada)
        if (Math.abs(duration - beats) < this.EPS) return ini < this.EPS || Math.abs(ini - beats) < this.EPS;
        const log = Math.log2(duration);
        if (Math.abs(log - Math.round(log)) < 1e-9) {           // diádica (…4, 2, 1, ½, ¼)
            const r = ini % duration;
            return r < this.EPS || Math.abs(r - duration) < this.EPS;
        }
        // pontuada (0,75): tem de caber dentro de UM tempo, sem atravessá-lo
        return Math.floor(ini + this.EPS) === Math.floor(ini + duration - this.EPS);
    }

    /** A pausa do catálogo do NÍVEL com esta duração ('half-rest'…), ou null. */
    _restFormFor(duration) {
        const f = this._allowed().find(n =>
            n.type.includes('rest') && Math.abs(n.duration - duration) < this.EPS);
        return f ? f.type : null;
    }

    /** Este par de pausas deveria ser UMA pausa do dobro? (regra pura, sem catálogo) */
    _restPairMerges(a, b) {
        if (!a || !b || a.type !== 'rest' || b.type !== 'rest') return false;
        if (Math.abs(a.duration - b.duration) > this.EPS) return false;
        if (Math.abs((a.beat + a.duration) - b.beat) > this.EPS) return false;   // contíguas
        const beatsPerMeasure = this.config.timeSignature.beats;
        const soma = a.duration * 2;
        if (soma > beatsPerMeasure + this.EPS) return false;   // não há pausa maior que o compasso
        // O par só se escreve junto se COMEÇAR num múltiplo da própria soma dentro do
        // compasso — é isso que impede a pausa de mascarar a divisão métrica.
        // 🔴 E TERMINAR DENTRO DO COMPASSO. Em 4/4 e 2/4 isso é aritmética (o compasso é
        // múltiplo de toda soma diádica); em 3/4 não: as semínimas no tempo 3 e no 1 do
        // compasso seguinte começam num múltiplo de 2 e virariam uma mínima ATRAVESSANDO a
        // barra — pausa não se liga. Medido no levels-test antes deste corte.
        const ini = a.beat % beatsPerMeasure;
        if (ini + soma > beatsPerMeasure + this.EPS) return false;
        const resto = ini % soma;
        return resto < this.EPS || Math.abs(resto - soma) < this.EPS;
    }

    /**
     * Funde os pares mal escritos, enquanto houver — o nó novo pode formar par com o
     * vizinho (4 pausas de semínima → 2 de mínima → 1 de semibreve). Só funde quando a
     * pausa maior existe no nível; o resto é impedido lá no sorteio.
     * @param {Array} notes
     */
    _consolidateRests(notes) {
        let fundiu = true;
        while (fundiu) {
            fundiu = false;
            for (let i = 0; i < notes.length - 1; i++) {
                if (!this._restPairMerges(notes[i], notes[i + 1])) continue;
                const forma = this._restFormFor(notes[i].duration * 2);
                if (!forma) continue;                 // sem a pausa maior no nível: fica como está
                notes[i].duration *= 2;
                notes[i].visualType = forma;
                notes.splice(i + 1, 1);
                fundiu = true;
                break;
            }
            if (!fundiu) fundiu = this._mergeSilentMeasure(notes, true);
        }
    }

    /**
     * Compasso INTEIRAMENTE mudo escrito com mais de uma pausa. Em 4/4 e 2/4 a fusão par a
     * par já chega lá; em 3/4 não (mínima + semínima não é par) — e a notação manda uma
     * pausa de compasso só. Com `merge` funde (se a pausa de compasso está no conjunto) e
     * devolve true; sem `merge` só diz se existe (é o "órfão" do `_wouldStrandRest`).
     */
    _mergeSilentMeasure(notes, merge) {
        const beats = this.config.timeSignature.beats;
        const forma = merge ? this._restFormFor(beats) : null;
        if (merge && !forma) return false;
        for (let i = 0; i < notes.length; i++) {
            const ini = notes[i].beat % beats;
            if (notes[i].type !== 'rest' || !(ini < this.EPS || Math.abs(ini - beats) < this.EPS)) continue;
            let j = i, soma = 0;
            while (j < notes.length && notes[j].type === 'rest' && soma < beats - this.EPS) {
                soma += notes[j].duration; j++;
            }
            if (j - i < 2 || Math.abs(soma - beats) > this.EPS) continue;
            if (!merge) return true;
            notes[i].duration = beats;
            notes[i].visualType = forma;
            notes.splice(i + 1, j - i - 1);
            return true;
        }
        return false;
    }

    /**
     * O caminho 2: esta pausa candidata deixaria o padrão com um par que a notação
     * manda juntar e que este nível não sabe escrever? Simula a consolidação sobre
     * uma cópia — o que sobrar consolidável depois dela é, por definição, órfão.
     * @param {Array} anteriores  notas já geradas (padrão inteiro, não só o compasso)
     * @param {Object} entry      figura sorteada
     * @param {number} beat       beat absoluto onde ela cairia
     */
    _wouldStrandRest(anteriores, entry, beat) {
        const sim = anteriores.map(n => ({ type: n.type, duration: n.duration, beat: n.beat, visualType: n.visualType }));
        sim.push({ type: 'rest', duration: entry.duration, beat, visualType: entry.type });
        this._consolidateRests(sim);
        for (let i = 0; i < sim.length - 1; i++) {
            if (this._restPairMerges(sim[i], sim[i + 1])) return true;
        }
        return this._mergeSilentMeasure(sim, false);
    }

    /**
     * Ligadura (fatia 2 — cruza a barra OU síncope dentro do compasso).
     *
     * Funde, com probabilidade TIE_PROB, duas notas CONTÍGUAS em que a 1ª termina
     * exatamente sobre um TEMPO (beat inteiro) e a 2ª começa ali, num único
     * "nó-âncora": `duration` vira a SOMA (1 onset, duração somada — scorer/áudio
     * não mudam) e `tie` guarda os segmentos só p/ o desenho (cabeças + arco). O
     * RhythmRenderer.expandTies reexpõe os segmentos p/ o beam agrupar normalmente.
     *
     * Dois contextos elegíveis (ambos com o ponto da ligadura SOBRE o tempo, que é
     * onde a ligadura mostra a pulsação):
     * - CRUZA A BARRA: 1ª nota termina numa barra de compasso e ambas são ≥ 1 tempo
     *   (sustentação longa atravessando o compasso).
     * - SÍNCOPE: 1ª nota é uma colcheia FORA do tempo (começa em X,5) e termina no
     *   tempo seguinte → a colcheia fraca se prende ao tempo forte (síncope clássica).
     * @param {Array} notes
     */
    _applyTies(notes) {
        const beatsPerMeasure = this.config.timeSignature.beats;
        // Dose da ligadura: vem do NÍVEL (trilha) ou do default do sandbox. Fora de
        // [0,1] ou ausente → 0.5, que é o valor histórico (nível 10 não muda).
        const p = this.config.tieProb;
        const TIE_PROB = (typeof p === 'number' && p >= 0 && p <= 1) ? p : 0.5;
        // Lições de ligadura permitidas neste nível. null/ausente = as duas (histórico).
        const kk = this.config.tieKinds;
        const kinds = (Array.isArray(kk) && kk.length) ? kk : null;
        const isBeat = (x) => Math.abs(x - Math.round(x)) < this.EPS;        // sobre um tempo inteiro
        const onBarline = (x) => isBeat(x) && Math.round(x) % beatsPerMeasure === 0;
        const offBeat = (x) => Math.abs((x % 1) - 0.5) < this.EPS;            // começa em X,5

        // 🔴 DUAS PASSADAS, sustentação PRIMEIRO — e a ordem não é detalhe.
        // Uma nota já ligada não pode ser ligada de novo. A síncope é MUITO mais comum
        // (qualquer colcheia fora do tempo serve) do que a sustentação (a nota tem de
        // terminar exatamente na barra, e as duas serem ≥ 1 tempo — em 2 compassos há
        // UMA oportunidade no padrão inteiro). Numa passada só, a lição comum consome as
        // notas vizinhas da barra e a lição escassa nunca acontece. Servir primeiro a
        // oportunidade rara é o que faz um nível conseguir ensinar as duas coisas.
        const passada = (querCross) => {
            for (let i = 0; i < notes.length - 1; i++) {
                const a = notes[i], b = notes[i + 1];
                if (a.type !== 'note' || b.type !== 'note' || a.tie || b.tie) continue;
                const aEnd = a.beat + a.duration;
                if (!isBeat(aEnd) || Math.abs(aEnd - b.beat) > this.EPS) continue;  // contígua, no tempo

                const crossBar = onBarline(aEnd) && a.duration >= 1 - this.EPS && b.duration >= 1 - this.EPS;
                const syncopation = offBeat(a.beat) && Math.abs(a.duration - 0.5) < this.EPS;
                if (crossBar !== querCross) continue;          // cada passada cuida do seu ramo
                if (!crossBar && !syncopation) continue;
                // 🔴 QUAL das duas lições este nível quer. Os dois ramos usam o mesmo campo
                // `ties` mas ensinam coisas OPOSTAS — sustentação (o som atravessa a barra) e
                // síncope (o fraco se prende ao forte). Deixado ao acaso, quem decide é o
                // conjunto de figuras: basta haver colcheia para a síncope dominar, e um mundo
                // de sustentação passa a ensinar síncope sem ninguém ter mudado nada. Agora o
                // nível DECLARA (`tieKinds`); ausente = as duas, que é o comportamento antigo.
                const kind = crossBar ? 'sustain' : 'syncopation';
                if (kinds && !kinds.includes(kind)) continue;
                if (this._rand() > TIE_PROB) continue;

                a.tieKind = kind;            // etiqueta a lição que ESTE nó ensina (lida pelos testes)
                a.tie = [
                    { beat: a.beat, duration: a.duration, visualType: a.visualType },
                    { beat: b.beat, duration: b.duration, visualType: b.visualType }
                ];
                a.duration += b.duration;   // âncora carrega a soma → 1 onset p/ scorer/áudio
                notes.splice(i + 1, 1);     // remove a continuação do array (vira segmento visual)
            }
        };
        passada(true);      // sustentação (escassa) escolhe antes
        passada(false);     // síncope preenche o que sobrou
    }

    /**
     * Regra do jogo: o padrão precisa de ao menos UMA nota sonora (senão não há
     * o que tocar/avaliar). Com pausas longas habilitadas (ex.: pausa de
     * semibreve), o sorteio pode sair só de pausas — converte a primeira em nota.
     * @param {Array} notes
     */
    _ensureSoundingNote(notes) {
        if (notes.some(n => n.type === 'note')) return;
        const first = notes[0];
        first.type = 'note';
        first.visualType = this.getDurationVisualType(first.duration);
    }

    /**
     * Gera um compasso completo (quantos tempos a fórmula disser)
     * @param {number} measureNumber - Número do compasso (0, 1, ...)
     * @param {number} startBeat - Beat de início absoluto
     * @param {Object} restState - contador de pausas consecutivas (atravessa a barra)
     * @param {Array} anteriores - notas dos compassos já gerados (grafia das pausas)
     * @param {{v:boolean}|null} sujo - marcado se o compasso precisou sacrificar a grafia ou
     *        sair da seleção (o chamador tenta de novo)
     * @returns {Array}
     */
    generateMeasure(measureNumber, startBeat, restState = { run: 0 }, anteriores = [], sujo = null) {
        const beatsPerMeasure = this.config.timeSignature.beats; // 4
        const notes = [];
        let currentBeat = 0; // Beat relativo dentro do compasso (0-4)

        while (currentBeat < beatsPerMeasure - this.EPS) {
            const remaining = beatsPerMeasure - currentBeat;

            // 1. Candidatas = habilitadas que CABEM no restante do compasso
            let pool = this._allowed().filter(n => n.duration <= remaining + this.EPS);

            // 2. Limita pausas consecutivas (estourou → só figuras sonoras)
            if (restState.run >= this.config.consecutiveRestLimit) {
                pool = pool.filter(n => !n.type.includes('rest'));
            }

            // 2b. GRAFIA, as duas direções: a pausa não pode COMEÇAR em cima da divisão
            //     (`_restStartOk`), nem formar um par que a notação manda juntar e que
            //     este nível não sabe escrever (`_wouldStrandRest`). O par que ELE sabe
            //     escrever passa e é fundido depois, em _consolidateRests.
            const jaGeradas = anteriores.concat(notes);
            const beatAbs = startBeat + currentBeat;
            const grafiaOk = (n) => !n.type.includes('rest') ||
                (this._restStartOk(beatAbs, n.duration) && !this._wouldStrandRest(jaGeradas, n, beatAbs));
            const limpo = pool.filter(grafiaOk);

            // 3. Sorteio ponderado.
            //
            // 🔴 A ORDEM DE RECUO IMPORTA, e o primeiro corte errou nela: caía direto no
            //    `fillFigure`, que ignora `allowedNotes` — no sandbox isso punha na pauta
            //    uma figura que o usuário tinha DESLIGADO (medido: 42% das rodadas com
            //    `half`+`quarter-rest`). Trocar "pausa mal escrita" por "figura que o aluno
            //    desligou" é piorar: a seleção de figuras é a única promessa do modo livre.
            //    Agora: grafia certa → senão a seleção do usuário mesmo que a grafia sofra
            //    → e só em último caso o preenchimento, que fecha o compasso.
            const entry = limpo.length ? this.weightedPick(limpo)
                        : pool.length  ? this.weightedPick(pool)
                        : this.fillFigure(remaining);
            // sujo = grafia sacrificada, ou preenchimento com figura FORA da seleção
            if (sujo && !limpo.length && (pool.length ||
                !(this.config.allowedNotes || []).some(n => n.type === entry.type))) sujo.v = true;

            const isRest = entry.type.includes('rest');
            restState.run = isRest ? restState.run + 1 : 0;

            notes.push({
                type: isRest ? 'rest' : 'note',
                duration: entry.duration,
                beat: startBeat + currentBeat,
                visualType: entry.type
            });
            currentBeat += entry.duration;
        }

        return notes;
    }

    /**
     * Maior figura padrão (sonora) que cabe na duração restante.
     * A menor figura do catálogo (fusa, 0.125) divide toda duração possível do
     * sorteio → o greedy sempre fecha o compasso exato, mesmo após uma fusa.
     * @param {number} remaining
     * @returns {Object}
     */
    fillFigure(remaining) {
        // Preferir a maior figura SONORA do próprio nível/seleção que caiba: o preenchimento
        // é o último recurso, e nele já se perdeu o sorteio — não há por que perder também a
        // seleção de figuras. Só quando nenhuma cabe (ex.: nível sem colcheia que sobrou meio
        // tempo) é que se recorre à escada padrão, que é o que GARANTE fechar o compasso.
        const own = (this.config.allowedNotes || [])
            .filter(n => !n.type.includes('rest') && n.duration <= remaining + this.EPS)
            .sort((a, b) => b.duration - a.duration)[0];
        if (own) return { type: own.type, duration: own.duration };
        const FILL = [4, 3, 2, 1.5, 1, 0.75, 0.5, 0.25, 0.125];
        const duration = FILL.find(d => d <= remaining + this.EPS) || 0.125;
        return { type: this.getDurationVisualType(duration), duration };
    }

    /**
     * Seleção aleatória com peso (weighted random) sobre um conjunto
     * @param {Array} pool
     * @returns {Object}
     */
    weightedPick(pool) {
        const totalWeight = pool.reduce((sum, n) => sum + n.weight, 0);
        let random = this._rand() * totalWeight;

        for (const note of pool) {
            random -= note.weight;
            if (random <= 0) return note;
        }

        return pool[0];
    }

    /**
     * Mapeia duração para tipo visual
     * @param {number} duration
     * @returns {string}
     */
    getDurationVisualType(duration) {
        if (duration === 4) return 'whole';
        if (duration === 3) return 'dotted-half';
        if (duration === 2) return 'half';
        if (duration === 1.5) return 'dotted-quarter';
        if (duration === 1) return 'quarter';
        if (duration === 0.75) return 'dotted-eighth';
        if (duration === 0.5) return 'eighth';
        if (duration === 0.25) return 'sixteenth';
        if (duration === 0.125) return 'fusa';

        // Fallback: usa semínimas
        return 'quarter';
    }

    /**
     * Valida que padrão preenche compassos corretamente
     * @param {Array} notes
     * @returns {boolean}
     */
    validatePattern(notes) {
        const total = notes.reduce((sum, n) => sum + n.duration, 0);
        const expected = this.config.measures * this.config.timeSignature.beats;
        return Math.abs(total - expected) < 0.001;
    }
}

// Disponibiliza globalmente
window.RhythmPatternGenerator = RhythmPatternGenerator;



// ============================================
// components/rhythm/RhythmRenderer.js
// ============================================
/**
 * RhythmRenderer - Desenha padrões rítmicos no pentagrama SVG
 *
 * Responsabilidade ÚNICA:
 * - Renderizar notas e pausas no pentagrama
 * - Calcular posições X das notas
 * - Usar funções de desenho SVG (copiadas de test-elements.html)
 */
class RhythmRenderer {
    constructor(musicStaff) {
        this.staff = musicStaff;
        this.elements = [];

        // V3 — NOTAÇÃO PROPORCIONAL AO TEMPO.
        // Toda coordenada X (notas, pausas, barras, régua de debug e playhead)
        // deriva de getBeatX(beat). Não existe mais "optical spacing": posição = tempo.
        //
        // MOBILE (abordagem B — responsivo legível): a escala horizontal (pxPerBeat)
        // NÃO é mais fixa. `_computeLayout()` a calcula a cada render p/ preencher a
        // largura disponível do SVG, com teto `maxPxPerBeat` (no desktop largo → 80/beat
        // = compasso 320px, IDÊNTICO à V3). Em telas estreitas encolhe p/ caber inteiro,
        // sem cortar. Tudo continua derivando de getBeatX → sincronia V3 intacta.
        this.LAYOUT = {
            // Tempos por compasso. NÃO é constante: `_computeLayout` o relê de
            // `pattern.config.timeSignature.beats` a cada render (o personalizado tem 2/4 e
            // 3/4). Barras, régua, sistemas e a pausa de compasso derivam daqui.
            beatsPerMeasure: 4,
            maxPxPerBeat: 80,     // teto da escala (desktop: 320px/compasso, igual à V3)
            // Espaço horizontal p/ clave + fórmula de compasso (antes era um "+80" fixo
            // em getBeatX). Clave e fórmula são posicionadas como fração de clefSpace
            // (0.25 e 0.75) → no desktop (80) reproduz exatamente a V3; no mobile encolhe.
            clefSpace: 80,
            // Respiro à esquerda: afasta a 1ª nota (beat 0) da fórmula de compasso.
            // Aplicado DENTRO de getBeatX → notas, playhead e régua deslocam juntos
            // (a sincronia continua verdadeira por construção). NUNCA insetar só as notas.
            leftInset: 22,
            // Recuo COSMÉTICO da barra de compasso interior (só o desenho da barra; NÃO
            // entra em getBeatX). 🔴 getBeatX é ESTRITAMENTE LINEAR → o playhead anda a
            // velocidade constante ("tempo é tempo"), sem nenhuma aceleração. A barra
            // interior cairia no MESMO X do downbeat (mesmo instante) → recua um pouco para
            // a esquerda, no espaço proporcional que a última nota já tem. Em notação por
            // tempo, subdivisões curtas (semicolcheia/fusa) no fim do compasso ficam justas:
            // é o limite honesto da proporcional (só mais px/tempo — Opção B — afrouxaria).
            barlineInset: 11
        };

        // Escala horizontal corrente (px por tempo). Recalculada em _computeLayout().
        // Default = teto, p/ getBeatX funcionar antes do 1º render (ex.: createPlayhead).
        this.pxPerBeat = this.LAYOUT.maxPxPerBeat;

        // MULTI-SYSTEM (quebra de linha como partitura real). _computeLayout decide
        // quantos compassos cabem por linha NO PISO DE LEGIBILIDADE e só quebra quando
        // NÃO cabe tudo numa linha (desktop 2 compassos segue em 1 linha, igual à V3).
        // Cada sistema é uma cópia vertical do slot da pauta (yOffset = sys·systemHeight).
        // 🔴 getBeatX continua ESTRITAMENTE LINEAR DENTRO de cada sistema → o playhead anda
        // a velocidade constante por linha e faz "carriage return" na quebra (evento
        // esperado, o olho faz igual). UMA escala global p/ todas as linhas → MESMA
        // velocidade em toda linha ("tempo é tempo"); a última linha pode ficar mais curta.
        // W_MIN = largura mínima legível de uma figura → piso pxPerBeat = W_MIN / menorFigura.
        this.W_MIN = 14;
        // Piso de px/tempo exigido pela RÉGUA (um rótulo a cada meio tempo: "1", "1.5"…).
        // 🔴 CALIBRADO PARA NÃO MEXER EM QUEM JÁ ESTÁ NO AR: com 26, os níveis de 2 compassos
        // passavam a quebrar em duas linhas num celular de 340px — mudança gratuita em nível
        // de produção. Com 22 eles ficam como estão (24,7px/tempo ali) e o nível 20, que
        // pedia 14, quebra. Abaixo de ~20px/tempo a régua é ilegível de qualquer jeito.
        this.MIN_PX_RULER = 28;
        this._mps = 0;            // compassos por sistema (0 = ainda não computado)
        this._beatsPerSystem = 0; // _mps · beatsPerMeasure
        this._systems = 1;        // nº de linhas
        this._systemHeight = 0;   // altura vertical de cada slot de sistema (px)
        // Reservar a banda de respostas (faixa onde os toques do usuário aparecem)? No MENU
        // (idle) não há toques → false encolhe o slot ao essencial (pauta+régua), cortando o
        // vazio entre/abaixo dos sistemas. Na PRÁTICA/AVALIAÇÃO o dono liga (true) p/ caber as
        // linhas de resposta. Default true = seguro (quem não setar, reserva).
        this.reserveResponseBand = true;

        // ALTURA DAS NOTAS (19/set — ajuste "Notas na altura certa", só com a "Melodia"): posição
        // na pauta de cada nota SONORA do padrão, na ordem (`RhythmPrefs.positions`; 4 = linha do
        // meio, −2 = Dó 4 na 1ª suplementar). null = tudo na linha do meio, como sempre foi — e
        // esse caminho fica INTOCADO (haste p/ cima, barra horizontal). Com alturas, só Y muda:
        // X continua vindo de getBeatX e o placar não sabe que isto existe.
        this.pitches = null;
        // Respiro EXTRA abaixo da pauta quando há alturas. O que desce abaixo da pauta NÃO é a
        // bandeirola (ela nasce na ponta da haste e cresce RUMO à cabeça — `drawFlags`): é (a) a
        // BARRA de um grupo com haste p/ baixo que contém Sol 4/Lá 4 (Lá 4→Dó 5: empate, a última
        // decide, desce; barra em +25 px abaixo da última linha; Sol 4→Ré 5 dá +30) e (b) o ARCO
        // por baixo de uma ligadura em Dó 4 (+24 num tempo, +35 com duas mínimas). O tique da
        // régua começa em +20. Com 16 ele começa em +36. (Auditoria 19/set: a 1ª versão dizia
        // "bandeirola a 32 px" e o mutante do pad só caía por asserção-espelho.)
        // Régua, rótulo e banda de respostas descem juntos; sem alturas, zero (nada muda de lugar).
        this.PITCH_PAD = 16;

        // Constantes de desenho (copiadas de test-elements.html)
        this.STAFF = {
            lineSpacing: 10,
            lineWidth: 1,
            totalHeight: 40
        };

        this.NOTEHEAD = {
            rx: 6.5,
            ry: 4.5,
            angle: -18,
            strokeWidth: 1.8
        };

        this.STEM = {
            height: this.STAFF.lineSpacing * 3.5,  // 35px
            width: 1.2,
            offsetX: this.NOTEHEAD.rx - 0.5
        };

        // Tamanho NOMINAL da cabeça (e o offset da haste que dele deriva). `_computeLayout`
        // reescreve this.NOTEHEAD.rx/ry a cada render conforme o espaço disponível; sem esta
        // cópia, cada render encolheria em cima do render anterior até sumir.
        this._headBase = { rx: this.NOTEHEAD.rx, ry: this.NOTEHEAD.ry };

        // LINHAS DE RESPOSTA DO USUÁRIO — a "realidade nua" de cada toque.
        // Cada resposta é UM segmento horizontal numa fileira própria, ABAIXO da régua:
        //   x1 = getBeatX(beatDoAperto)   (pode ser NEGATIVO = antes da régua)
        //   x2 = getBeatX(beatDoSoltar)   (clampado na barra final do exercício)
        // Fileiras empilhadas (rowStep) com cores cíclicas → cada toque é independente,
        // dá pra ver atraso na 1ª e adianto na 2ª lado a lado. Toda coordenada vem de
        // getBeatX → mesma régua das notas (sincronia verdadeira por construção).
        this.RESPONSE = {
            baseGap: 80,    // px abaixo de getY(0) onde começa a 1ª fileira (após o rótulo do compasso)
            rowStepMax: 9,  // espaçamento vertical IDEAL entre fileiras
            rowStepMin: 5,  // espaçamento MÍNIMO (muitos toques → comprime, mas continua legível)
            strokeWidth: 4,
            onsetDotR: 2.6,
            palette: ['#2563eb', '#db2777', '#059669', '#d97706', '#7c3aed',
                      '#0891b2', '#dc2626', '#65a30d', '#c026d3', '#0d9488'],
            // Anatomia da resposta (tela de resultado): DOIS canais independentes —
            // sólido = houve som (dedo pressionado) · pontilhado = faltou (silêncio que
            // devia ter som); cor = certo/errado.
            correctColor: '#10b981', // verde  — no tempo (sobrepôs a janela ideal)
            wrongColor:   '#ef4444', // vermelho — som FORA do lugar (adiantou/segurou demais/extra)
            missColor:    '#9ca3af', // cinza  — FALTOU (atrasou/soltou cedo/nota perdida)
            dash:         '2,3',     // pontilhado do "faltou"
            targetColor:  '#6b7280', // cinza escuro — "linha de chegada" (fim ideal da nota)
            tickHalf:     3.5        // meia-altura do tique-alvo (px)
        };
        this._activeResponse = null; // segmento sendo desenhado ao vivo (dedo pressionado)
        this._totalBeats = 0;        // fim do exercício — clamp da ponta direita das respostas
        this._responseRows = 10;     // capacidade de fileiras (ajustada por render() ao nº de notas)
    }

    /**
     * Renderiza padrão completo no pentagrama
     * @param {RhythmPattern} pattern
     */
    render(pattern) {
        this.clear();

        // 0. Calcula escala (pxPerBeat) E quebra em sistemas (multi-system "só quando não
        //    cabe"). DEVE vir antes de qualquer getBeatX (todo X/Y de beat deriva daqui).
        this._computeLayout(pattern);
        // 0b. Cresce o SVG p/ caber N sistemas empilhados (1 sistema = altura V3 original).
        this._applySvgHeight();

        // 1. Calcula posição da última barra via getBeatX (fonte única de X)
        const totalBeats = pattern.config.measures * this.LAYOUT.beatsPerMeasure;
        this._totalBeats = totalBeats; // clamp das linhas de resposta (nada passa do fim)
        // Capacidade de fileiras de resposta: nº de notas + folga p/ toques extras
        // (duplos/fantasma — justo o que se quer enxergar no debug). _responseRowY usa
        // isso p/ comprimir o espaçamento e GARANTIR que tudo cabe dentro do SVG (o
        // #staff-container é overflow:hidden — nada pode vazar e sumir, ainda mais no celular).
        const noteCount = pattern.notes.filter(n => n.type === 'note').length;
        this._responseRows = Math.max(10, noteCount + 6);
        // Banda de respostas POR SISTEMA: capacidade = notas naquele sistema + folga; e um
        // contador de fileiras livre por sistema (reset a cada render). _responseRowY usa
        // isso p/ empilhar cada toque na linha do seu beat sem colidir entre sistemas.
        this._sysCapacity = new Array(this._systems).fill(0);
        pattern.notes.forEach(n => {
            if (n.type === 'note') this._sysCapacity[this._systemOf(n.beat)]++;
        });
        this._sysCapacity = this._sysCapacity.map(c => Math.max(6, c + 4));
        this._sysRowNext = new Array(this._systems).fill(0);

        // 2. Desenha pentagrama (uma linha por sistema, estendida até a barra final dela)
        this.drawStaffLines(pattern);

        // 3+4. Clave de sol + fórmula de compasso (repetidas no início de CADA sistema,
        //      como partitura real). Loop por sistema dentro de cada método.
        this.drawClef();
        this.drawTimeSignature(pattern.config.timeSignature);

        // 5. EXPANDE ligaduras em "unidades visuais": uma cabeça por segmento. Assim o beam
        //    enxerga as colcheias ligadas como notas reais e as agrupa naturalmente (a síncope
        //    de colcheia recebe beam, não bandeirola solta). O modelo de dados (nó-âncora com
        //    duração SOMADA) fica intacto → scorer/áudio/onsets não mudam. `tiePrev` marca o
        //    segmento que recebe arco de ligadura vindo do anterior.
        const visual = RhythmRenderer.expandTies(pattern.notes);
        const positions = visual.map(v => this.getBeatX(v.beat));

        // 5b. Grupos de barra de ligação (colcheias do MESMO tempo) — decididos ANTES de
        //     desenhar: colcheia agrupada NÃO recebe bandeirola. Roda sobre as unidades visuais.
        const beamGroups = RhythmRenderer.computeBeamGroups(visual);
        const beamed = new Set(beamGroups.flat());

        // 6. Desenha cada unidade visual, deslocada p/ o sistema do seu beat (yOffset).
        //    ALTURA: sem `pitches`, toda nota na linha do meio (posição 4 = Si) com haste p/ cima,
        //    como sempre. Com `pitches`, a k-ésima nota SONORA vai para a posição dela: linha
        //    suplementar se sair da pauta, haste p/ baixo da linha do meio para cima, e nas
        //    beamadas a haste é da barra (`drawBeamPitched`), que a estica até a reta inclinada.
        const posOf = this._positionsFor(visual);
        const upOf = this._stemDirections(visual, posOf, beamGroups);
        visual.forEach((v, i) => {
            const x = positions[i];
            const yOff = this._yOffset(v.beat);
            const pos = v.type === 'note' ? posOf[i] : 4;
            const y = this.staff.getY(pos) + yOff; // sem alturas: Si (linha 3 = meio do pentagrama)

            if (v.type === 'note') {
                if (this.pitches) this._drawLedgers(x, pos, yOff);
                this.drawNote(x, y, v.visualType, {
                    noFlag: beamed.has(i), up: upOf[i],
                    noStem: !!this.pitches && beamed.has(i),
                    onLine: pos % 2 === 0,
                    stemLen: this._stemLen(y - yOff)
                });
            } else {
                // A pausa de COMPASSO INTEIRO é a única figura centralizada da notação: ela
                // não marca um instante, marca "este compasso é mudo". Desenhada no beat 0
                // do compasso ela cola na última nota do compasso ANTERIOR e parece pertencer
                // a ele (visto ao vivo no nível 20). O deslocamento é só de DESENHO — não
                // passa por getBeatX, que segue estritamente linear.
                // Em qualquer fórmula: compasso mudo é a pausa de COMPASSO (o glifo da
                // semibreve), inclusive a pausa de mínima que ocupa o compasso de 2/4.
                const bpm = this.LAYOUT.beatsPerMeasure;
                const compassoMudo = Math.abs(v.duration - bpm) < 1e-9 && Math.abs(v.beat % bpm) < 1e-9;
                this.drawRest(compassoMudo ? x + (bpm / 2) * this.pxPerBeat : x, y,
                              compassoMudo ? 'whole-rest' : v.visualType, yOff);
            }
        });

        // 6b. Barras de ligação (depois das hastes, p/ cobrir a junção). Um grupo de beam
        //     nunca cruza compasso (é dentro de 1 tempo) → todo o grupo no mesmo sistema.
        beamGroups.forEach(group => {
            const yOff = this._yOffset(visual[group[0]].beat);
            if (!this.pitches) { this.drawBeam(group, positions, visual, yOff); return; }
            this.drawBeamPitched(group, positions, visual,
                group.map(i => this.staff.getY(posOf[i]) + yOff), upOf[group[0]]);
        });

        // 6c. Arcos de ligadura entre cada segmento `tiePrev` e o anterior.
        //
        // 🔴 QUANDO A LIGADURA CAI NA QUEBRA DE LINHA, ela vira DOIS MEIOS-ARCOS — um
        // saindo da nota até a margem do sistema, outro entrando da margem até a nota
        // do sistema seguinte. É o que a gravura de verdade faz, e aqui não é estética:
        // o modelo é nó-âncora (1 ataque, N cabeças), então SEM arco o aluno lê duas
        // notas soltas, toca dois ataques, e o scorer — que espera um — o pune por ter
        // lido corretamente o que estava na tela. Desenho e cobrança têm de concordar.
        // (Antes o arco era simplesmente descartado; inofensivo enquanto só um nível
        // usava ligadura em 2 compassos, insustentável com `measures: 4` no celular.)
        const area = this.staff.getDrawArea();
        visual.forEach((v, i) => {
            if (!v.tiePrev || i === 0) return;
            // Os dois segmentos são a MESMA nota (1 onset) → mesma posição; só o sistema muda.
            const yA = this.staff.getY(posOf[i - 1]) + this._yOffset(visual[i - 1].beat);
            const yB = this.staff.getY(posOf[i]) + this._yOffset(v.beat);
            // O arco vai do lado OPOSTO à haste (`below === up`): sem alturas a haste sobe
            // sempre e o arco fica embaixo, como era; com haste p/ baixo ele vai por cima.
            // Hastes MISTAS (a 2ª cabeça caiu num grupo de barra que decidiu o contrário —
            // acontece: Dó 5 ligado a um Dó 5 beamado com Sol 4): a cabeça acima da linha do
            // meio leva o arco por cima, abaixo dela por baixo (regra de gravura).
            const below = (upOf[i - 1] === upOf[i]) ? upOf[i] : posOf[i] < 4;
            if (Math.abs(yA - yB) < 0.5) {
                this.drawTie(positions[i - 1], positions[i], yB, below);
            } else {
                // Ponta que sobra em cada lado: um respiro até a margem, nunca colada nela.
                const tail = Math.min(this.STAFF.lineSpacing * 2.2, this.pxPerBeat * 0.6);
                this.drawTie(positions[i - 1], Math.min(area.endX, positions[i - 1] + tail), yA,
                             below, null, { openEnd: true });
                this.drawTie(Math.max(area.startX, positions[i] - tail), positions[i], yB,
                             below, null, { openStart: true });
            }
        });

        // 7. Desenha barras de compasso (recuo cosmético considera as cabeças visuais)
        this.drawBarlines(pattern, visual);

        // 8. Régua de tempos. Nasceu como ferramenta de avaliação e ficou: os números
        //    ajudam a contar. Desde 18/set o JOGADOR pode escondê-la (⚙️ → `RhythmPrefs`);
        //    só o DESENHO sai — o espaçamento mínimo dela (`MIN_PX_RULER`) continua valendo,
        //    para a pauta não mudar de forma ao ligar/desligar.
        if (this.showRuler !== false) this.drawDebugRuler(pattern);
    }

    /**
     * Ajusta a altura do SVG (e do viewBox) p/ acomodar os N sistemas empilhados.
     * Com 1 sistema → altura original (V3, sem mudança). Largura/viewBox-X intactos:
     * width:100% + height:auto preservam a proporção, então o conteúdo cresce p/ baixo
     * e o #staff-container (height:auto) acompanha (scroll vertical natural no mobile).
     */
    _applySvgHeight() {
        const svg = this.staff.svg;
        if (!svg) return;
        const baseW = this.staff.config.width;
        const h = Math.max(1, this._systems) * this._systemHeight;
        svg.setAttribute('height', h);
        svg.setAttribute('viewBox', `0 0 ${baseW} ${h}`);
    }

    /**
     * Calcula posições X para cada nota — V3: PROPORCIONAL AO TEMPO.
     * A cabeça da nota que começa no beat b fica exatamente em getBeatX(b).
     * Isso torna a sincronia com o playhead verdadeira por construção:
     * positions[i] === getBeatX(notes[i].beat) para toda nota.
     * @param {RhythmPattern} pattern
     * @returns {Array<number>}
     */
    /** Respiro extra abaixo da pauta (régua, rótulo e banda descem juntos) — só com alturas. */
    _padBelow() {
        return this.pitches ? this.PITCH_PAD : 0;
    }

    /**
     * Posição na pauta de cada unidade visual. Pausa e nota sem altura = 4 (linha do meio).
     * A k-ésima unidade que NÃO é continuação de ligadura é a k-ésima nota SONORA do padrão —
     * os N segmentos de uma ligadura são a mesma nota (1 onset) e herdam a mesma altura.
     * Valor fora da lista ou não numérico cai na linha do meio (com a haste pela regra: p/ baixo —
     * inalcançável pelo jogo, que manda null quando a melodia e o padrão divergem).
     */
    _positionsFor(visual) {
        const P = this.pitches;
        let k = -1;
        return visual.map(v => {
            if (v.type !== 'note') return 4;
            if (!v.tiePrev) k++;
            const p = P ? P[k] : null;
            return (typeof p === 'number' && isFinite(p)) ? p : 4;
        });
    }

    /**
     * Direção da haste de cada unidade (true = p/ cima). Sem alturas: sempre p/ cima (o
     * caminho histórico). Com alturas, a regra da gravura (a mesma de `Notation.stemUp`: da
     * linha do meio para cima, haste desce) — e por GRUPO de barra, decidida pela nota mais
     * distante da linha do meio (empate: a última, como no `ScoreRenderer`), porque um beam
     * não pode ter hastes para os dois lados.
     */
    _stemDirections(visual, posOf, beamGroups) {
        if (!this.pitches) return visual.map(() => true);
        const up = visual.map((v, i) => posOf[i] < 4);
        beamGroups.forEach(g => {
            const far = g.reduce((a, i) => Math.abs(posOf[i] - 4) >= Math.abs(posOf[a] - 4) ? i : a, g[0]);
            g.forEach(i => { up[i] = posOf[far] < 4; });
        });
        return up;
    }

    /**
     * Comprimento da haste: o nominal, ou até a linha do meio quando a cabeça está mais longe
     * que isso (convenção de gravura para nota em linha suplementar — sem isso a haste fica
     * solta no ar). A pentatônica de hoje (−2…6) nunca passa de 30 px do meio, então o ramo
     * só vale para escala futura. Na linha do meio dá o nominal: o caminho sem alturas não muda.
     * @param {number} yLocal - Y da cabeça SEM o deslocamento do sistema
     */
    _stemLen(yLocal) {
        return Math.max(this.STEM.height, Math.abs(this.staff.getY(4) - yLocal));
    }

    /** Linhas suplementares de uma cabeça fora da pauta (só com alturas). */
    _drawLedgers(x, position, yOff = 0) {
        if (position >= 0 && position <= 8) return;
        const svg = this.staff.svg;
        const nh = this.NOTEHEAD, ls = this.staff.config.lineSpacing;
        const MS = this.staff.constructor;
        const half = (MS && typeof MS.ledgerHalfWidth === 'function')
            ? MS.ledgerHalfWidth(ls, nh.rx, nh.ry, nh.angle) : ls * 0.8;
        const line = (p) => {
            const y = this.staff.getY(p) + yOff;
            const el = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            el.setAttribute('x1', x - half); el.setAttribute('y1', y);
            el.setAttribute('x2', x + half); el.setAttribute('y2', y);
            el.setAttribute('stroke', '#000');
            el.setAttribute('stroke-width', this.STAFF.lineWidth);
            el.setAttribute('data-ledger', p);
            svg.appendChild(el);
            this.elements.push(el);
        };
        if (position < 0) for (let p = -2; p >= position; p -= 2) line(p);
        else for (let p = 10; p <= position; p += 2) line(p);
    }

    calculateNotePositions(pattern) {
        return pattern.notes.map(note => this.getBeatX(note.beat));
    }

    /**
     * Nº de compassos no sistema `s` (o último pode ter menos que _mps).
     */
    _measuresInSystem(s, measures) {
        return Math.max(0, Math.min(this._mps, measures - s * this._mps));
    }

    /**
     * X da borda direita do sistema `s` (fim do último compasso da linha). Calculado
     * direto (sem getBeatPos, que rolaria p/ o próximo sistema na fronteira exata).
     */
    _systemRightX(s, measures) {
        const drawArea = this.staff.getDrawArea();
        const originX = drawArea.startX + this.LAYOUT.clefSpace + this.LAYOUT.leftInset;
        const localBeats = this._measuresInSystem(s, measures) * this.LAYOUT.beatsPerMeasure;
        return originX + localBeats * this.pxPerBeat;
    }

    /** Desenha as 5 linhas de UMA pauta (x1→x2), deslocada verticalmente por `yOff`. */
    _drawStaffRow(x1, x2, yOff) {
        const svg = this.staff.svg;
        for (let i = 0; i < 5; i++) {
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            const y = this.staff.linePositions[i] + yOff;
            line.setAttribute('x1', x1);
            line.setAttribute('y1', y);
            line.setAttribute('x2', x2);
            line.setAttribute('y2', y);
            line.setAttribute('stroke', this.staff.config.lineColor);
            line.setAttribute('stroke-width', this.staff.config.lineWidth);
            svg.appendChild(line);
            this.elements.push(line);
        }
    }

    /**
     * Desenha as linhas do pentagrama.
     * - `drawStaffLines(endX)` — LEGADO (StaffReadingRenderer reusa a primitiva): UMA pauta
     *   da margem esquerda até endX. Mantido p/ não quebrar o contrato compartilhado.
     * - `drawStaffLines(pattern)` — multi-system: uma pauta por sistema, até a barra final
     *   daquele sistema (a última linha pode ser mais curta = borda irregular).
     * @param {RhythmPattern|number} patternOrEndX
     */
    drawStaffLines(patternOrEndX) {
        const x1 = this.staff.config.marginLeft;
        if (typeof patternOrEndX === 'number') {
            this._drawStaffRow(x1, patternOrEndX + 5, 0); // legado: 1 pauta até endX
            return;
        }
        const measures = patternOrEndX.config.measures;
        for (let s = 0; s < this._systems; s++) {
            const x2 = this._systemRightX(s, measures) + 5; // +5px além da última barra
            this._drawStaffRow(x1, x2, s * this._systemHeight);
        }
    }

    /**
     * Desenha a clave no início de CADA sistema (como partitura real).
     * @param {'treble'|'bass'} clef - sol (default; o ritmo só usa esta) ou fá.
     *   Fatores da de fá = os do ScoreRenderer (5.6/7.2 do tamanho, base em getY(6)+0.15),
     *   para a clave sair IDÊNTICA nos jogos — o aluno vê um app só.
     */
    drawClef(clef = 'treble') {
        const svg = this.staff.svg;
        const drawArea = this.staff.getDrawArea();
        const isBass = clef === 'bass';
        // Tamanho/posição em fração de clefSpace → escala com a largura no mobile.
        // Desktop (clefSpace 80): 80*0.9=72px e startX+20 → idêntico à V3.
        const fontSize = this.LAYOUT.clefSpace * 0.9 * (isBass ? 5.6 / 7.2 : 1);

        for (let s = 0; s < this._systems; s++) {
            // Sol: a espiral abraça a 2ª linha (G4). Fá: os dois pontos cercam a 4ª (F3).
            const lineY = this.staff.getY(isBass ? 6 : 4) + s * this._systemHeight;
            const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            text.setAttribute('x', drawArea.startX + this.LAYOUT.clefSpace * 0.25);
            text.setAttribute('y', lineY + this.STAFF.lineSpacing * (isBass ? 0.15 : 1.2));
            text.setAttribute('font-size', fontSize);
            text.setAttribute('font-family', 'Bravura, Times New Roman, Georgia, serif');
            text.setAttribute('fill', '#000');
            text.textContent = isBass ? '𝄢' : '𝄞';
            svg.appendChild(text);
            this.elements.push(text);
        }
    }

    /**
     * Desenha fórmula de compasso
     * @param {Object} timeSignature - {beats, noteValue}
     */
    drawTimeSignature(timeSignature) {
        const svg = this.staff.svg;
        const drawArea = this.staff.getDrawArea();
        const x = drawArea.startX + this.LAYOUT.clefSpace * 0.75; // Após a clave (desktop: startX+60)
        const fontSize = this.STAFF.lineSpacing * 2;

        const mkNum = (xx, yy, txt) => {
            const t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            t.setAttribute('x', xx);
            t.setAttribute('y', yy);
            t.setAttribute('font-size', fontSize);
            t.setAttribute('font-weight', 'bold');
            t.setAttribute('font-family', 'Times New Roman, serif');
            t.setAttribute('text-anchor', 'middle');
            t.setAttribute('fill', '#000');
            t.textContent = txt;
            svg.appendChild(t);
            this.elements.push(t);
        };

        // Fórmula repetida no início de cada sistema (clareza p/ o aluno).
        for (let s = 0; s < this._systems; s++) {
            const centerY = this.staff.getY(4) + s * this._systemHeight; // Si (linha 3)
            mkNum(x, centerY - this.STAFF.lineSpacing * 0.8, timeSignature.beats.toString());
            mkNum(x, centerY + this.STAFF.lineSpacing * 2.2, timeSignature.noteValue.toString());
        }
    }

    /**
     * Grupos de barra de ligação (beam) — notação tradicional (Gould, "Behind Bars"):
     * o beam torna o TEMPO visível, então só liga colcheias que pertencem ao MESMO
     * tempo (floor do beat absoluto igual → nunca cruza tempo nem barra de compasso),
     * contíguas (sem lacuna) e sonoras (pausa/outra figura quebra o grupo). Grupo
     * precisa de ≥2 notas; colcheia sozinha no tempo fica com bandeirola (flag).
     * Puro (sem DOM) — coberto em logic-tests.
     * @param {Array} notes - [{type, duration, beat, visualType}] ordenadas por beat
     * @returns {Array<Array<number>>} grupos de índices em `notes`
     */
    static computeBeamGroups(notes) {
        const EPS = 1e-6;
        const groups = [];
        let current = [];
        const close = () => { if (current.length >= 2) groups.push(current); current = []; };

        notes.forEach((n, i) => {
            // Beamável = nota sonora de subdivisão (colcheia 0.5, semicolcheia 0.25,
            // fusa 0.125). Semínima+ não recebe beam; pausa/figura longa quebra o grupo.
            const eligible = n.type === 'note' && n.duration < 0.5 + EPS;
            if (!eligible) { close(); return; }
            const prev = current.length ? notes[current[current.length - 1]] : null;
            const sameBeat = prev && Math.floor(prev.beat + EPS) === Math.floor(n.beat + EPS);
            const contiguous = prev && Math.abs(prev.beat + prev.duration - n.beat) < EPS;
            if (prev && sameBeat && contiguous) current.push(i);
            else { close(); current = [i]; }
        });
        close();
        return groups;
    }

    /**
     * Nº de barras (beams) de uma figura beamável: colcheia 1, semicolcheia 2, fusa 3.
     * = log2(0.5 / duração) + 1. Puro — coberto em logic-tests.
     * @param {number} duration
     * @returns {number}
     */
    static beamLevel(duration) {
        return Math.round(Math.log2(0.5 / duration)) + 1;
    }

    /**
     * Desenha as barras de ligação de um grupo (gravura tradicional, Gould):
     * - Barra PRIMÁRIA (nível 1): retângulo plano cobrindo o grupo inteiro.
     * - Barras SECUNDÁRIAS (níveis 2..max): cobrem só runs contíguas de notas com
     *   beamLevel ≥ L; uma nota isolada nesse nível recebe um STUB (meia barra
     *   apontando para o interior do tempo). Empilhadas para baixo (beamGap).
     * Retângulos planos preenchidos (anti-fresta), assentados no TOPO das hastes.
     * @param {Array<number>} group - índices das notas do grupo
     * @param {Array<number>} positions - X das cabeças (calculateNotePositions)
     * @param {Array} notes - padrão (para a duração de cada nota)
     */
    drawBeam(group, positions, notes, yOff = 0) {
        const svg = this.staff.svg;
        const y = this.staff.getY(4) + yOff; // cabeças na linha do meio do sistema do grupo
        const yTip = y - this.STEM.height;
        const thickness = this.STAFF.lineSpacing * 0.5;
        const beamGap = this.STAFF.lineSpacing * 0.62; // separação entre barras
        const stub = this.STAFF.lineSpacing * 0.9;     // largura da meia-barra
        const half = this.STEM.width / 2;
        const stemX = (gi) => positions[group[gi]] + this.STEM.offsetX;
        const levelOf = (gi) => RhythmRenderer.beamLevel(notes[group[gi]].duration);

        const rect = (xL, xR, yTop) => {
            const r = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            r.setAttribute('x', xL);
            r.setAttribute('y', yTop);
            r.setAttribute('width', xR - xL);
            r.setAttribute('height', thickness);
            r.setAttribute('fill', '#000');
            svg.appendChild(r);
            this.elements.push(r);
        };

        // Nível 1 — barra primária cobre o grupo inteiro
        rect(stemX(0) - half, stemX(group.length - 1) + half, yTip);

        // Níveis 2..max — runs maximais de notas com beamLevel ≥ L
        const maxLevel = Math.max(...group.map((_, gi) => levelOf(gi)));
        for (let L = 2; L <= maxLevel; L++) {
            const yTop = yTip + (L - 1) * beamGap;
            let k = 0;
            while (k < group.length) {
                if (levelOf(k) < L) { k++; continue; }
                let j = k;
                while (j + 1 < group.length && levelOf(j + 1) >= L) j++;
                if (j > k) {
                    rect(stemX(k) - half, stemX(j) + half, yTop); // run ≥2 → barra cheia
                } else if (k > 0) {
                    rect(stemX(k) - stub, stemX(k) + half, yTop); // isolada interna → stub p/ esquerda
                } else {
                    rect(stemX(k) - half, stemX(k) + stub, yTop); // isolada na borda → stub p/ direita
                }
                k = j + 1;
            }
        }
    }

    /**
     * Desenha uma nota
     * @param {number} x
     * @param {number} y
     * @param {string} type - 'quarter', 'half', etc
     * @param {Object} opts - { noFlag: true } = colcheia em grupo de beam (sem bandeirola)
     *        { up: false } = haste p/ BAIXO (nota acima da linha do meio, com alturas); default p/ cima.
     *        { noStem: true } = quem desenha a haste é a barra inclinada (`drawBeamPitched`).
     *        { stemLen } = comprimento da haste (default STEM.height).
     *        { onLine: false } = cabeça num ESPAÇO: o ponto de aumento fica na altura da cabeça
     *        (na linha ele sobe meio espaço, senão encosta na linha e some). Default: linha.
     */
    drawNote(x, y, type, opts = {}) {
        const svg = this.staff.svg;
        const up = opts.up !== false;
        const len = opts.stemLen == null ? null : opts.stemLen;
        const stem = () => { if (!opts.noStem) this.drawStem(svg, x, y, up, len); };
        const flags = (n) => this.drawFlags(svg, x, y, n, up, len);
        const dot = () => this.drawAugmentationDot(svg, x, y, opts.onLine === false ? 0 : null);

        if (type === 'whole') {
            // Semibreve: cabeça vazia larga, SEM haste
            this.drawNoteheadWhole(svg, x, y);
        } else if (type === 'dotted-half') {
            // Mínima pontuada: cabeça vazia + haste + ponto de aumento
            this.drawNoteheadEmpty(svg, x, y);
            stem();
            dot();
        } else if (type === 'half') {
            // Mínima: cabeça vazia + haste
            this.drawNoteheadEmpty(svg, x, y);
            stem();
        } else if (type === 'dotted-quarter') {
            // Semínima pontuada: cabeça preenchida + haste + ponto de aumento
            this.drawNoteheadFilled(svg, x, y);
            stem();
            dot();
        } else if (type === 'dotted-eighth') {
            // Colcheia pontuada (0,75): cabeça preenchida + haste + 1 bandeirola +
            // ponto de aumento. Não recebe beam (duração ≥ 0,5) → sempre com flag.
            this.drawNoteheadFilled(svg, x, y);
            stem();
            flags(1);
            dot();
        } else if (type === 'eighth') {
            // Colcheia: cabeça preenchida + haste; bandeirola SÓ se isolada no
            // tempo — em grupo, o beam (drawBeam) substitui a bandeirola.
            this.drawNoteheadFilled(svg, x, y);
            stem();
            if (!opts.noFlag) flags(1);
        } else if (type === 'sixteenth') {
            // Semicolcheia: cabeça preenchida + haste + flag DUPLA se isolada
            // (em grupo, o beam duplo substitui as bandeirolas).
            this.drawNoteheadFilled(svg, x, y);
            stem();
            if (!opts.noFlag) flags(2);
        } else if (type === 'fusa') {
            // Fusa: cabeça preenchida + haste + flag TRIPLA se isolada
            // (em grupo, o beam triplo substitui as bandeirolas).
            this.drawNoteheadFilled(svg, x, y);
            stem();
            if (!opts.noFlag) flags(3);
        } else {
            // Fallback ('quarter' e tipos desconhecidos): semínima
            this.drawNoteheadFilled(svg, x, y);
            stem();
        }
    }

    /**
     * Barra de ligação COM ALTURAS (ajuste "Notas na altura certa"). A receita de gravura do
     * `ScoreRenderer._drawBeamGroup`, com as primitivas daqui: reta pelas pontas ideais das
     * hastes das notas extremas, inclinação LIMITADA (íngreme fica agressiva), deslocada até
     * nenhuma haste ficar mais curta que o mínimo; cada haste esticada até a reta; barras como
     * paralelogramos (acompanham a inclinação sem deformar a espessura); as secundárias
     * empilham em direção às CABEÇAS. Desenha as HASTES também — o `drawNote` as pula nas
     * notas beamadas deste caminho. Sem `pitches` o caminho é o `drawBeam` de sempre, intocado
     * (com todas as alturas iguais esta receita dá inclinação zero: o mesmo desenho).
     * @param {Array<number>} group - índices em `notes`
     * @param {Array<number>} positions - X das cabeças
     * @param {Array} notes - unidades visuais (duração → nº de barras)
     * @param {Array<number>} ys - Y da cabeça de cada nota do grupo (já com o yOffset do sistema)
     * @param {boolean} up - direção das hastes do grupo
     */
    drawBeamPitched(group, positions, notes, ys, up) {
        if (group.length < 2) return;
        const svg = this.staff.svg;
        const s = this.STAFF.lineSpacing;
        const dir = up ? -1 : 1;                 // p/ onde a haste cresce
        const MIN_STEM = s * 2.5;
        const IDEAL_STEM = this.STEM.height;
        const MAX_SLOPE = 0.22;                  // ~1 espaço a cada 4,5 de avanço
        const xs = group.map(i => positions[i] + (up ? this.STEM.offsetX : -this.STEM.offsetX));

        const x1 = xs[0], x2 = xs[xs.length - 1];
        let yA = ys[0] + dir * IDEAL_STEM;
        const yB = ys[ys.length - 1] + dir * IDEAL_STEM;
        let slope = (x2 - x1) ? (yB - yA) / (x2 - x1) : 0;
        slope = Math.max(-MAX_SLOPE, Math.min(MAX_SLOPE, slope));
        const lineY = (x) => yA + slope * (x - x1);

        // Empurra a reta até TODA haste ter pelo menos MIN_STEM.
        let shift = 0;
        xs.forEach((x, k) => {
            const need = ys[k] + dir * MIN_STEM;          // ponta mínima aceitável
            const have = lineY(x);
            const curta = up ? (have - need) : (need - have); // >0 = a reta deixa a haste curta
            if (curta > 0) shift = up ? Math.max(shift, curta) : Math.min(shift, -curta);
        });
        if (up && shift > 0) yA -= shift; else if (!up && shift < 0) yA -= shift;
        const yAt = (x) => yA + slope * (x - x1);

        // Hastes até a barra.
        group.forEach((i, k) => this.drawStem(svg, positions[i], ys[k], up, Math.abs(yAt(xs[k]) - ys[k])));

        // Barras: a primária cobre o grupo; as secundárias, só as runs daquele nível.
        const thickness = s * 0.5;
        const gap = s * 0.75;                    // 0,5 de barra + 0,25 de ar (barra inclinada)
        const stub = s * 0.9;
        const half = this.STEM.width / 2;
        const levelOf = (k) => RhythmRenderer.beamLevel(notes[group[k]].duration);
        const bar = (xL, xR, level) => {
            const off = -dir * (level - 1) * gap;
            const yl = yAt(xL) + off, yr = yAt(xR) + off;
            const poly = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
            poly.setAttribute('points', `${xL},${yl} ${xR},${yr} ${xR},${yr + thickness} ${xL},${yl + thickness}`);
            poly.setAttribute('fill', '#000');
            poly.setAttribute('data-beam', String(level));
            svg.appendChild(poly);
            this.elements.push(poly);
        };
        bar(x1 - half, x2 + half, 1);
        const maxLevel = Math.max(...group.map((_, k) => levelOf(k)));
        for (let L = 2; L <= maxLevel; L++) {
            let k = 0;
            while (k < group.length) {
                if (levelOf(k) < L) { k++; continue; }
                let j = k;
                while (j + 1 < group.length && levelOf(j + 1) >= L) j++;
                if (j > k) bar(xs[k] - half, xs[j] + half, L);       // run ≥2 → barra cheia
                else if (k > 0) bar(xs[k] - stub, xs[k] + half, L);   // isolada interna → stub p/ esquerda
                else bar(xs[k] - half, xs[k] + stub, L);              // isolada na borda → stub p/ direita
                k = j + 1;
            }
        }
    }

    /**
     * Expande nós-âncora de ligadura em "unidades visuais": uma por segmento (cabeça
     * a desenhar), preservando a ordem temporal. Notas/pausas normais passam direto.
     * `tiePrev:true` = o segmento recebe arco de ligadura vindo da unidade anterior
     * (sempre o segmento imediatamente anterior, pois os segmentos de uma ligadura
     * saem CONTÍGUOS na lista). Puro (sem DOM) → testável; o modelo de dados (nó com
     * duração SOMADA) NÃO muda, então scorer/áudio/onsets ficam intactos.
     * @param {Array} notes - [{type, beat, duration, visualType, tie?}]
     * @returns {Array} unidades visuais [{type, beat, duration, visualType, tiePrev}]
     */
    static expandTies(notes) {
        const out = [];
        notes.forEach(n => {
            if (n.type === 'note' && n.tie) {
                n.tie.forEach((seg, k) => out.push({
                    type: 'note', beat: seg.beat, duration: seg.duration,
                    visualType: seg.visualType, tiePrev: k > 0
                }));
            } else {
                out.push({ type: n.type, beat: n.beat, duration: n.duration,
                           visualType: n.visualType, tiePrev: false });
            }
        });
        return out;
    }

    /**
     * Arco de ligadura (tie) entre duas cabeças. Curva quadrática das bordas internas.
     * @param {number} x1 - centro X da 1ª cabeça
     * @param {number} x2 - centro X da 2ª cabeça
     * @param {number} y  - centro Y das cabeças (mesma linha)
     * @param {boolean} [below=true] - arco POR BAIXO das cabeças. 🔴 O jogo de ritmo escreve
     *        tudo com haste p/ cima, então embaixo está sempre livre; numa partitura com
     *        alturas, nota acima da linha do meio tem haste p/ BAIXO e o arco embaixo cai em
     *        cima da haste. Quem sabe a direção da haste passa `false` e o arco vai por cima.
     * @param {number} [maxBelly] - profundidade máxima da barriga (default: 1,8 espaço).
     * @param {Object} [ends] - `{openStart, openEnd}`: ponta que NÃO encosta em cabeça
     *        (meio-arco de quebra de linha) — não recua o raio da cabeça daquele lado.
     */
    drawTie(x1, x2, y, below = true, maxBelly = null, ends = null) {
        const svg = this.staff.svg;
        const s = this.STAFF.lineSpacing;
        const sgn = below ? 1 : -1;
        const xa = x1 + ((ends && ends.openStart) ? 0 : this.NOTEHEAD.rx);
        const xb = x2 - ((ends && ends.openEnd) ? 0 : this.NOTEHEAD.rx);
        const yStart = y + sgn * (this.NOTEHEAD.ry + 2.5);
        // Barriga PROPORCIONAL ao vão: com profundidade fixa, uma ligadura de 4 semínimas
        // (≈230px) tinha 7px de curva — 1:32, que o olho lê como um traço reto, não como
        // ligadura. Cresce com o vão até um teto, e o piso mantém as curtas iguais às de antes.
        const belly = Math.min(maxBelly == null ? s * 1.8 : maxBelly,
                               Math.max(s * 0.7, Math.abs(xb - xa) * 0.06));
        const yBelly = yStart + sgn * belly;
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', `M ${xa} ${yStart} Q ${(xa + xb) / 2} ${yBelly}, ${xb} ${yStart}`);
        path.setAttribute('data-tie', below ? 'below' : 'above');   // marca: o teste acha o arco (a pausa também é path com Q)
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke', '#000');
        path.setAttribute('stroke-width', 1.6);
        path.setAttribute('stroke-linecap', 'round');
        svg.appendChild(path);
        this.elements.push(path);
    }

    /**
     * Desenha uma pausa
     * @param {number} x
     * @param {number} y
     * @param {string} type - 'quarter-rest', etc
     */
    drawRest(x, y, type, yOff = 0) {
        const svg = this.staff.svg;

        if (type === 'whole-rest') {
            // Pausa de semibreve: retângulo PENDURADO sob a linha 4 (getY(6))
            this.drawWholeRest(svg, x, this.staff.getY(6) + yOff);
        } else if (type === 'half-rest') {
            // Pausa de mínima: retângulo APOIADO na linha do meio (getY(4))
            this.drawHalfRest(svg, x, this.staff.getY(4) + yOff);
        } else if (type === 'dotted-eighth-rest') {
            // Pausa de colcheia pontuada: pausa de colcheia + ponto de aumento à direita.
            this.drawEighthRest(svg, x, y);
            const s = this.STAFF.lineSpacing;
            const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            dot.setAttribute('cx', x + 0.85 * s);
            dot.setAttribute('cy', y - 0.1 * s);
            dot.setAttribute('r', 2.1);
            dot.setAttribute('fill', '#000');
            svg.appendChild(dot);
            this.elements.push(dot);
        } else if (type === 'eighth-rest') {
            this.drawEighthRest(svg, x, y);
        } else if (type === 'sixteenth-rest') {
            this.drawFlagRest(svg, x, y, 2);
        } else if (type === 'fusa-rest') {
            this.drawFlagRest(svg, x, y, 3);
        } else {
            // 'quarter-rest' e fallback
            this.drawQuarterRest(svg, x, y);
        }
    }

    /**
     * Desenha cabeça de nota preenchida (semínima)
     */
    drawNoteheadFilled(svg, cx, cy) {
        const ellipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
        ellipse.setAttribute('cx', cx);
        ellipse.setAttribute('cy', cy);
        ellipse.setAttribute('rx', this.NOTEHEAD.rx);
        ellipse.setAttribute('ry', this.NOTEHEAD.ry);
        ellipse.setAttribute('fill', '#000');
        ellipse.setAttribute('transform', `rotate(${this.NOTEHEAD.angle}, ${cx}, ${cy})`);
        svg.appendChild(ellipse);
        this.elements.push(ellipse);
        return ellipse;
    }

    /**
     * Desenha cabeça de nota vazia (mínima)
     */
    drawNoteheadEmpty(svg, cx, cy) {
        const ellipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
        ellipse.setAttribute('cx', cx);
        ellipse.setAttribute('cy', cy);
        ellipse.setAttribute('rx', this.NOTEHEAD.rx);
        ellipse.setAttribute('ry', this.NOTEHEAD.ry);
        ellipse.setAttribute('fill', '#fff');
        ellipse.setAttribute('stroke', '#000');
        ellipse.setAttribute('stroke-width', this.NOTEHEAD.strokeWidth);
        ellipse.setAttribute('transform', `rotate(${this.NOTEHEAD.angle}, ${cx}, ${cy})`);
        svg.appendChild(ellipse);
        this.elements.push(ellipse);
        return ellipse;
    }

    /**
     * Ícone SVG avulso de uma figura (painel de controle etc.) — desenha com as
     * MESMAS primitivas da partitura (sem depender de fonte musical instalada).
     * @param {string} figureId - visualType ('quarter', 'half-rest', ...)
     * @returns {SVGElement}
     */
    static figureIcon(figureId) {
        const NS = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(NS, 'svg');
        svg.setAttribute('viewBox', '0 0 40 56');
        svg.setAttribute('width', '26');
        svg.setAttribute('height', '36');
        svg.style.cssText = 'display:block;overflow:visible;';

        // instância mínima só com as constantes de desenho (primitivas não usam mais nada)
        const r = Object.create(RhythmRenderer.prototype);
        r.STAFF = { lineSpacing: 10, lineWidth: 1, totalHeight: 40 };
        r.NOTEHEAD = { rx: 6.5, ry: 4.5, angle: -18, strokeWidth: 1.8 };
        r.STEM = { height: 35, width: 1.2, offsetX: 6 };
        r.elements = [];

        const x = 16;
        if (figureId.includes('rest')) {
            // linha de referência: mostra a pausa "pendurada" (semibreve) ou "apoiada" (mínima)
            const refY = 22;
            r.staff = { svg, getY: () => refY };
            if (figureId === 'whole-rest' || figureId === 'half-rest') {
                const line = document.createElementNS(NS, 'line');
                line.setAttribute('x1', x - 11); line.setAttribute('x2', x + 11);
                line.setAttribute('y1', refY); line.setAttribute('y2', refY);
                line.setAttribute('stroke', '#cbd5e1'); line.setAttribute('stroke-width', 1);
                svg.appendChild(line);
            }
            r.drawRest(x, 26, figureId);
        } else {
            r.staff = { svg, getY: () => 44 };
            r.drawNote(x, 44, figureId);
        }
        return svg;
    }

    /**
     * Desenha cabeça de semibreve (vazia, mais larga, sem inclinação)
     */
    drawNoteheadWhole(svg, cx, cy) {
        const ellipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
        ellipse.setAttribute('cx', cx);
        ellipse.setAttribute('cy', cy);
        ellipse.setAttribute('rx', this.NOTEHEAD.rx * 1.35);
        ellipse.setAttribute('ry', this.NOTEHEAD.ry);
        ellipse.setAttribute('fill', '#fff');
        ellipse.setAttribute('stroke', '#000');
        ellipse.setAttribute('stroke-width', this.NOTEHEAD.strokeWidth * 1.3);
        svg.appendChild(ellipse);
        this.elements.push(ellipse);
        return ellipse;
    }

    /**
     * Desenha ponto de aumento (à direita da cabeça, no espaço acima da linha —
     * a nota do jogo senta na linha do meio, então o ponto sobe meio espaço).
     * @param {number} [dy] - deslocamento vertical do ponto. Default (null) = meio espaço
     *        acima, o caso do jogo de ritmo (nota sempre na linha do meio). Numa partitura
     *        com alturas, o ponto vai no ESPAÇO: quem está numa linha sobe meio espaço,
     *        quem já está num espaço fica onde está (dy = 0). Quem sabe a posição passa.
     */
    drawAugmentationDot(svg, noteheadCx, noteheadCy, dy = null) {
        const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        dot.setAttribute('cx', noteheadCx + this.NOTEHEAD.rx + 4.5);
        dot.setAttribute('cy', noteheadCy + (dy == null ? -this.STAFF.lineSpacing * 0.5 : dy));
        dot.setAttribute('r', 2.1);
        dot.setAttribute('fill', '#000');
        svg.appendChild(dot);
        this.elements.push(dot);
        return dot;
    }

    /**
     * Desenha N bandeirolas a partir do topo da haste (haste p/ cima).
     * 1 = colcheia, 2 = semicolcheia, 3 = fusa.
     * - 1 bandeirola: gota tradicional (longa), inalterada.
     * - 2+ bandeirolas: barras curvas mais curtas e EMPILHADAS com ar entre elas
     *   (cada subdivisão = +1 barra; gravura tradicional). Barras compridas se
     *   fundiriam num borrão — por isso as múltiplas são encurtadas.
     * @param {number} count - nº de bandeirolas
     * @param {boolean} [up=true] - direção da HASTE. O jogo de ritmo escreve tudo na linha
     *        do meio com haste p/ cima; numa partitura com alturas, nota acima da linha do
     *        meio tem haste p/ baixo e a bandeirola espelha VERTICALMENTE — mas continua
     *        **à direita da haste** (convenção de gravura), por isso só o sinal de Y muda.
     * @param {number} [stemLen] - comprimento da haste (default: STEM.height). Nota com
     *        beam tem haste esticada até a barra; a bandeirola nasce na ponta real.
     */
    drawFlags(svg, noteheadCx, noteheadCy, count = 1, up = true, stemLen = null) {
        const sgn = up ? 1 : -1;                       // +1 desce a partir da ponta, −1 sobe
        const len = stemLen == null ? this.STEM.height : stemLen;
        const sx = noteheadCx + (up ? this.STEM.offsetX : -this.STEM.offsetX);
        const sy0 = noteheadCy - sgn * len;            // ponta da haste
        const s = this.STAFF.lineSpacing;
        const dy = (k) => sy0 + sgn * k;               // desloca a partir da ponta

        if (count <= 1) {
            // Colcheia: gota longa tradicional
            this._appendFlag(svg, `
                M ${sx} ${sy0}
                C ${sx + 0.9*s} ${dy(0.55*s)}, ${sx + 0.95*s} ${dy(1.4*s)}, ${sx + 0.45*s} ${dy(2.2*s)}
                C ${sx + 0.75*s} ${dy(1.4*s)}, ${sx + 0.5*s} ${dy(0.9*s)}, ${sx} ${dy(0.7*s)}
                Z`);
            return;
        }

        // 2+ bandeirolas: barras curvas curtas, separadas por ar
        const flagGap = s * 0.82; // passo vertical entre barras
        for (let k = 0; k < count; k++) {
            const base = k * flagGap;
            this._appendFlag(svg, `
                M ${sx} ${dy(base)}
                C ${sx + 1.05*s} ${dy(base + 0.42*s)}, ${sx + 1.0*s} ${dy(base + 1.05*s)}, ${sx + 0.42*s} ${dy(base + 1.45*s)}
                C ${sx + 0.7*s} ${dy(base + 1.0*s)}, ${sx + 0.6*s} ${dy(base + 0.68*s)}, ${sx} ${dy(base + 0.5*s)}
                Z`);
        }
    }

    /** Anexa um <path> de bandeirola (preenchido) ao SVG. */
    _appendFlag(svg, d) {
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', d.replace(/\s+/g, ' ').trim());
        path.setAttribute('fill', '#000');
        path.setAttribute('stroke', '#000');
        path.setAttribute('stroke-width', 0.6);
        svg.appendChild(path);
        this.elements.push(path);
    }

    /**
     * Desenha haste da nota
     * @param {number} [len] - comprimento (default STEM.height). Nota dentro de um grupo
     *        de beam precisa esticar/encurtar até a barra — quem calcula a barra passa.
     */
    drawStem(svg, noteheadCx, noteheadCy, up = true, len = null) {
        const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        const L = len == null ? this.STEM.height : len;

        const x = up ? noteheadCx + this.STEM.offsetX : noteheadCx - this.STEM.offsetX;
        const yEnd = up ? noteheadCy - L : noteheadCy + L;

        line.setAttribute('x1', x);
        line.setAttribute('y1', noteheadCy);
        line.setAttribute('x2', x);
        line.setAttribute('y2', yEnd);
        line.setAttribute('stroke', '#000');
        line.setAttribute('stroke-width', this.STEM.width);
        svg.appendChild(line);
        this.elements.push(line);
        return line;
    }

    /**
     * Desenha pausa de mínima (retângulo em cima da linha 3)
     */
    drawHalfRest(svg, x, line3Y) {
        const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        const width = this.STAFF.lineSpacing * 1.2;
        const height = this.STAFF.lineSpacing * 0.5;

        rect.setAttribute('x', x - width/2);
        rect.setAttribute('y', line3Y - height);
        rect.setAttribute('width', width);
        rect.setAttribute('height', height);
        rect.setAttribute('fill', '#000');
        svg.appendChild(rect);
        this.elements.push(rect);
    }

    /**
     * Desenha pausa de semibreve (retângulo pendurado SOB a linha 4)
     */
    drawWholeRest(svg, x, line4Y) {
        const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        const width = this.STAFF.lineSpacing * 1.2;
        const height = this.STAFF.lineSpacing * 0.5;

        rect.setAttribute('x', x - width/2);
        rect.setAttribute('y', line4Y);
        rect.setAttribute('width', width);
        rect.setAttribute('height', height);
        rect.setAttribute('fill', '#000');
        svg.appendChild(rect);
        this.elements.push(rect);
    }

    /** Pausa de colcheia = 1 gancho (wrapper de drawFlagRest). */
    drawEighthRest(svg, x, centerY) {
        this.drawFlagRest(svg, x, centerY, 1);
    }

    /**
     * Desenha pausa com N ganchos sobre um traço inclinado (gravura tradicional):
     * 1 = colcheia, 2 = semicolcheia, 3 = fusa. Cada gancho adicional desce ao longo
     * do traço, que se alonga para acomodá-los.
     * @param {number} count - nº de ganchos
     */
    drawFlagRest(svg, x, centerY, count = 1) {
        const s = this.STAFF.lineSpacing;
        const dy = 0.55 * s;   // descida vertical por gancho
        const dx = 0.12 * s;   // deslocamento horizontal (acompanha o traço inclinado)

        // traço inclinado, alongado conforme o nº de ganchos
        const topX = x + 0.5*s, topY = centerY - 0.6*s;
        const botX = x - 0.1*s - (count - 1) * dx;
        const botY = centerY + (1.1 + (count - 1) * 0.55) * s;
        const stroke = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        stroke.setAttribute('d', `M ${topX} ${topY} L ${botX} ${botY}`);
        stroke.setAttribute('fill', 'none');
        stroke.setAttribute('stroke', '#000');
        stroke.setAttribute('stroke-width', 1.6);
        stroke.setAttribute('stroke-linecap', 'round');
        svg.appendChild(stroke);
        this.elements.push(stroke);

        // ganchos (curva + pingo), escalonados para baixo ao longo do traço
        for (let k = 0; k < count; k++) {
            const hx = topX - k * dx;
            const hy = topY + k * dy;
            const hook = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            hook.setAttribute('d', `M ${hx} ${hy} Q ${hx - 0.45*s} ${hy + 0.7*s}, ${hx - 0.95*s} ${hy + 0.25*s}`);
            hook.setAttribute('fill', 'none');
            hook.setAttribute('stroke', '#000');
            hook.setAttribute('stroke-width', 1.6);
            hook.setAttribute('stroke-linecap', 'round');
            svg.appendChild(hook);
            this.elements.push(hook);

            const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            dot.setAttribute('cx', hx - 0.95*s);
            dot.setAttribute('cy', hy + 0.25*s);
            dot.setAttribute('r', 0.26*s);
            dot.setAttribute('fill', '#000');
            svg.appendChild(dot);
            this.elements.push(dot);
        }
    }

    /**
     * Desenha pausa de semínima (símbolo complexo)
     */
    drawQuarterRest(svg, x, centerY) {
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        const s = this.STAFF.lineSpacing;

        const d = `
            M ${x} ${centerY - s}
            L ${x - 0.3*s} ${centerY - 0.6*s}
            Q ${x + 0.2*s} ${centerY - 0.3*s}, ${x} ${centerY}
            Q ${x - 0.3*s} ${centerY + 0.3*s}, ${x + 0.1*s} ${centerY + 0.7*s}
            Q ${x + 0.3*s} ${centerY + 0.9*s}, ${x + 0.2*s} ${centerY + 1.2*s}
            L ${x} ${centerY + 0.8*s}
        `.replace(/\s+/g, ' ').trim();

        path.setAttribute('d', d);
        path.setAttribute('fill', '#000');
        path.setAttribute('stroke', '#000');
        path.setAttribute('stroke-width', 1.5);
        svg.appendChild(path);
        this.elements.push(path);
    }

    /**
     * Desenha barras de compasso — V3: posição derivada de getBeatX.
     * A barra ao final do compasso m fica em getBeatX(m * beatsPerMeasure),
     * o mesmo X que o playhead atinge ao cruzar a fronteira → sincronia garantida.
     * @param {RhythmPattern} pattern
     */
    drawBarlines(pattern, visual = null) {
        const svg = this.staff.svg;
        const beatsPerMeasure = this.LAYOUT.beatsPerMeasure;
        const measures = pattern.config.measures;
        // Cabeças visíveis (segmentos de ligadura expandidos) p/ o recuo cosmético.
        const heads = visual || pattern.notes;

        // Uma barra ao final de cada compasso; a última (do exercício) é dupla.
        // RECUO COSMÉTICO da barra INTERIOR: cairia no mesmo X do downbeat (mesmo instante)
        // → recua p/ o vazio à esquerda. É só o DESENHO — NÃO toca getBeatX/notas/playhead
        // (lineares; "tempo é tempo"). Limitado à METADE do vão até a última nota (e 40% de
        // 1 tempo no mobile) → nunca cruza a nota anterior.
        // BARRA DE FIM DE SISTEMA (multi-system): o downbeat seguinte está na PRÓXIMA linha,
        // então não há colisão no canto direito → barra no X exato da borda do sistema, SEM
        // inset (carriage return). A última de todas é dupla.
        for (let s = 0; s < this._systems; s++) {
            const yOff = s * this._systemHeight;
            const staffTopY = this.staff.getY(8) + yOff;    // linha 5 (topo)
            const staffBottomY = this.staff.getY(0) + yOff; // linha 1 (base)
            const measuresHere = this._measuresInSystem(s, measures);

            for (let localM = 1; localM <= measuresHere; localM++) {
                const globalM = s * this._mps + localM;
                const isFinal = (globalM === measures);
                const isSystemEnd = (localM === measuresHere);
                const boundary = globalM * beatsPerMeasure;

                if (isSystemEnd) {
                    // Borda direita do sistema (sem inset). getBeatX rolaria p/ a próxima linha.
                    this.drawBarline(svg, this._systemRightX(s, measures), staffTopY, staffBottomY, isFinal);
                    continue;
                }
                // Barra interior: recuo cosmético até a última cabeça do compasso.
                let lastOnset = boundary - 1;
                heads.forEach(n => {
                    if (n.beat < boundary - 1e-9 && n.beat > lastOnset) lastOnset = n.beat;
                });
                const gapToLast = (boundary - lastOnset) * this.pxPerBeat;
                const inset = Math.min(this.LAYOUT.barlineInset, this.pxPerBeat * 0.4, gapToLast * 0.5);
                this.drawBarline(svg, this.getBeatX(boundary) - inset, staffTopY, staffBottomY, false);
            }
        }
    }

    /**
     * Desenha uma barra de compasso vertical
     * @param {SVGElement} svg
     * @param {number} x - Posição X
     * @param {number} y1 - Topo
     * @param {number} y2 - Fundo
     * @param {boolean} double - Barra dupla?
     */
    drawBarline(svg, x, y1, y2, double = false) {
        if (double) {
            // Barra dupla: duas linhas finas
            const line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line1.setAttribute('x1', x - 3);
            line1.setAttribute('y1', y1);
            line1.setAttribute('x2', x - 3);
            line1.setAttribute('y2', y2);
            line1.setAttribute('stroke', '#000');
            line1.setAttribute('stroke-width', 1.5);
            svg.appendChild(line1);
            this.elements.push(line1);

            const line2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line2.setAttribute('x1', x);
            line2.setAttribute('y1', y1);
            line2.setAttribute('x2', x);
            line2.setAttribute('y2', y2);
            line2.setAttribute('stroke', '#000');
            line2.setAttribute('stroke-width', 2.5);
            svg.appendChild(line2);
            this.elements.push(line2);
        } else {
            // Barra simples
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line.setAttribute('x1', x);
            line.setAttribute('y1', y1);
            line.setAttribute('x2', x);
            line.setAttribute('y2', y2);
            line.setAttribute('stroke', '#000');
            line.setAttribute('stroke-width', 1.5);
            svg.appendChild(line);
            this.elements.push(line);
        }
    }

    /**
     * Desenha régua numerada de debug embaixo dos compassos.
     * V3: TODO X vem de getBeatX(beat) — os ticks coincidem com notas e playhead
     * por construção (mesma função de mapeamento). Ferramenta de avaliação do dono.
     * TEMPORÁRIO - para ajuste fino de simetria.
     * @param {RhythmPattern} pattern
     */
    drawDebugRuler(pattern) {
        const svg = this.staff.svg;
        const beatsPerMeasure = this.LAYOUT.beatsPerMeasure;
        const measures = (pattern && pattern.config) ? pattern.config.measures : 2;
        const drawArea = this.staff.getDrawArea();
        const originX = drawArea.startX + this.LAYOUT.clefSpace + this.LAYOUT.leftInset;
        // X SEMPRE local ao sistema (originX + beatLocal·pxPerBeat) → evita o roll-over de
        // getBeatPos nas fronteiras e mantém a régua colada nas notas/playhead daquela linha.
        const localX = (beatInSystem) => originX + beatInSystem * this.pxPerBeat;

        for (let s = 0; s < this._systems; s++) {
            const yOff = s * this._systemHeight;
            const rulerY = this.staff.getY(0) + 30 + this._padBelow() + yOff; // 30px abaixo da última linha (+ respiro com alturas)
            const measuresHere = this._measuresInSystem(s, measures);

            for (let localM = 0; localM < measuresHere; localM++) {
                const globalMeasure = s * this._mps + localM;
                const measureBaseBeat = localM * beatsPerMeasure; // local ao sistema
                const measureStartX = localX(measureBaseBeat);
                const measureEndX = localX(measureBaseBeat + beatsPerMeasure);

                // Linha horizontal da régua (início→fim do compasso)
                const rulerLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
                rulerLine.setAttribute('x1', measureStartX);
                rulerLine.setAttribute('y1', rulerY);
                rulerLine.setAttribute('x2', measureEndX);
                rulerLine.setAttribute('y2', rulerY);
                rulerLine.setAttribute('stroke', '#333');
                rulerLine.setAttribute('stroke-width', 1.5);
                rulerLine.setAttribute('stroke-dasharray', '3,3');
                rulerLine.setAttribute('data-ruler', '');   // marca: quem esconde/testa a régua acha só ela
                svg.appendChild(rulerLine);
                this.elements.push(rulerLine);

                // Ticks em cada meio-beat: 1, 1.5, 2, ... beatsPerMeasure
                for (let subdivision = 0; subdivision < beatsPerMeasure * 2; subdivision++) {
                    const localBeat = subdivision / 2;                  // 0, 0.5, 1, ...
                    const beatValue = localBeat + 1;                    // rótulo 1-indexado
                    const beatX = localX(measureBaseBeat + localBeat);
                    const isWholeBeat = (subdivision % 2 === 0);

                    const tick = document.createElementNS('http://www.w3.org/2000/svg', 'line');
                    tick.setAttribute('x1', beatX);
                    tick.setAttribute('y1', rulerY - (isWholeBeat ? 10 : 6));
                    tick.setAttribute('x2', beatX);
                    tick.setAttribute('y2', rulerY + (isWholeBeat ? 10 : 6));
                    tick.setAttribute('stroke', isWholeBeat ? '#000' : '#666');
                    tick.setAttribute('stroke-width', isWholeBeat ? 2 : 1);
                    tick.setAttribute('data-ruler', '');
                    svg.appendChild(tick);
                    this.elements.push(tick);

                    const label = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                    label.setAttribute('x', beatX);
                    label.setAttribute('y', rulerY + 20);
                    label.setAttribute('font-size', isWholeBeat ? 13 : 10);
                    label.setAttribute('font-weight', isWholeBeat ? 'bold' : 'normal');
                    label.setAttribute('font-family', 'Arial, sans-serif');
                    label.setAttribute('text-anchor', 'middle');
                    label.setAttribute('fill', isWholeBeat ? '#000' : '#666');
                    label.textContent = beatValue.toString();
                    label.setAttribute('data-ruler', '');
                    svg.appendChild(label);
                    this.elements.push(label);
                }

                // Label do compasso (número GLOBAL, centralizado)
                const measureLabel = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                measureLabel.setAttribute('x', localX(measureBaseBeat + beatsPerMeasure / 2));
                measureLabel.setAttribute('y', rulerY + 40);
                measureLabel.setAttribute('font-size', 11);
                measureLabel.setAttribute('font-weight', 'bold');
                measureLabel.setAttribute('font-family', 'Arial, sans-serif');
                measureLabel.setAttribute('text-anchor', 'middle');
                measureLabel.setAttribute('fill', '#333');
                // i18n (era "Compasso N" nos 3 idiomas — auditoria 18/set); sem Language, o PT
                const lt = window.language && typeof window.language.t === 'function' ? window.language.t('rhythm.ruler.measure', { n: globalMeasure + 1 }) : '';
                measureLabel.textContent = (lt && lt !== 'rhythm.ruler.measure') ? lt : `Compasso ${globalMeasure + 1}`;
                measureLabel.setAttribute('data-ruler', '');
                svg.appendChild(measureLabel);
                this.elements.push(measureLabel);
            }

            // Tooltip interativo por sistema (cobre só a largura desta linha)
            const sysEndX = localX(measuresHere * beatsPerMeasure);
            this.addRulerTooltip(svg, originX, rulerY, sysEndX - originX);
        }
    }

    /**
     * Adiciona tooltip interativo na régua
     * Mostra valor X exato ao passar mouse
     */
    addRulerTooltip(svg, startX, rulerY, totalWidth) {
        // Área invisível para capturar mouse (largura = a do sistema desta linha)
        const hitArea = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        hitArea.setAttribute('x', startX);
        hitArea.setAttribute('y', rulerY - 15);
        hitArea.setAttribute('width', totalWidth);
        hitArea.setAttribute('height', 60);
        hitArea.setAttribute('fill', 'transparent');
        hitArea.style.cursor = 'crosshair';
        svg.appendChild(hitArea);
        this.elements.push(hitArea);

        // Tooltip (inicialmente escondido)
        const tooltip = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        tooltip.setAttribute('y', rulerY - 20);
        tooltip.setAttribute('font-size', 11);
        tooltip.setAttribute('font-weight', 'bold');
        tooltip.setAttribute('font-family', 'monospace');
        tooltip.setAttribute('fill', 'red');
        tooltip.setAttribute('visibility', 'hidden');
        svg.appendChild(tooltip);
        this.elements.push(tooltip);

        // Linha vertical indicadora
        const pointer = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        pointer.setAttribute('y1', rulerY - 15);
        pointer.setAttribute('y2', rulerY + 15);
        pointer.setAttribute('stroke', 'red');
        pointer.setAttribute('stroke-width', 1);
        pointer.setAttribute('stroke-dasharray', '2,2');
        pointer.setAttribute('visibility', 'hidden');
        svg.appendChild(pointer);
        this.elements.push(pointer);

        // Event listeners
        hitArea.addEventListener('mousemove', (e) => {
            const rect = svg.getBoundingClientRect();
            const mouseX = e.clientX - rect.left;

            tooltip.setAttribute('x', mouseX + 10);
            tooltip.setAttribute('visibility', 'visible');
            tooltip.textContent = `X: ${Math.round(mouseX)}px`;

            pointer.setAttribute('x1', mouseX);
            pointer.setAttribute('x2', mouseX);
            pointer.setAttribute('visibility', 'visible');
        });

        hitArea.addEventListener('mouseleave', () => {
            tooltip.setAttribute('visibility', 'hidden');
            pointer.setAttribute('visibility', 'hidden');
        });
    }

    /**
     * Calcula a escala horizontal (pxPerBeat) p/ o padrão caber na largura do SVG
     * (abordagem B — responsivo legível). Preenche a largura disponível, com teto
     * `maxPxPerBeat` (no desktop largo → 80/beat = compasso 320px, idêntico à V3).
     * Chamado no topo de render(), ANTES de qualquer getBeatX.
     *
     * Largura disponível p/ as notas = área de desenho − (clave/fórmula + respiro).
     * Em telas estreitas o resultado é < teto → tudo encolhe junto e a pauta nunca
     * transborda/corta. Como pxPerBeat alimenta getBeatX (fonte única de X), notas,
     * barras, régua e playhead continuam em sincronia perfeita.
     * @param {RhythmPattern} pattern
     */
    _computeLayout(pattern) {
        // 🔴 A fórmula vem do PADRÃO, nunca de global: o mesmo renderer desenha a trilha (4/4)
        // e o personalizado (2/4, 3/4) — um valor guardado de um render vazaria no seguinte.
        const ts = pattern && pattern.config && pattern.config.timeSignature;
        this.LAYOUT.beatsPerMeasure = (ts && ts.beats > 0) ? ts.beats : 4;
        const beatsPerMeasure = this.LAYOUT.beatsPerMeasure;
        const measures = (pattern && pattern.config) ? pattern.config.measures : 1;
        const totalBeats = measures * beatsPerMeasure;
        const drawArea = this.staff.getDrawArea();
        const available = (drawArea.endX - drawArea.startX) - this.LAYOUT.clefSpace - this.LAYOUT.leftInset;

        // Piso de legibilidade: a MENOR figura do padrão (em tempos) precisa de ≥ W_MIN px.
        //   floorPx = W_MIN / dMin  → garante glifo legível E respiro natural na barra
        //   (vão antes da barra = (4−últimoOnset)·pxPerBeat ≥ dMin·floorPx = W_MIN, de graça).
        // Capado ao teto desktop p/ nunca ampliar além da escala V3 (tamanho consistente).
        let dMin = 1;
        if (pattern && Array.isArray(pattern.notes)) {
            for (const n of pattern.notes) {
                if (n && n.duration > 0 && n.duration < dMin) dMin = n.duration;
            }
        }
        // 🔴 O TETO CEDE PARA A FIGURA CURTA. Antes o piso era capado pelo teto do desktop
        // (`Math.min(maxPxPerBeat, …)`) — para a fusa o piso exigiria 112 px/tempo, o cap o
        // cortava em 80 e a proteção se desligava EM SILÊNCIO. Nenhuma figura chegava lá
        // (semicolcheia pede 56) até o mundo 6 estrear a fusa; auditoria de 11/ago mediu 10-12%
        // das cabeças SE SOBREPONDO, no desktop inclusive. Quando a menor figura pede mais que
        // a escala V3, "tamanho consistente" já é impossível — o que se preserva é a leitura:
        // o padrão ocupa mais px e quebra em mais sistemas.
        const need = this.W_MIN / dMin;
        const denso = need > this.LAYOUT.maxPxPerBeat;
        const teto = denso ? Infinity : this.LAYOUT.maxPxPerBeat;
        // 🔴 A RÉGUA TAMBÉM OCUPA ESPAÇO, e o piso acima não sabia disso: ele deriva só da
        // menor NOTA. O nível 20 é o único da trilha cuja figura mais curta é um tempo
        // inteiro (semínima) — piso 14px/tempo, e os 4 compassos couberam numa linha só no
        // celular. A régua imprime um número a cada MEIO tempo, então sobrava 7px por
        // número: "11.52.53.54.51…". Os vizinhos (19, 21) têm colcheia, piso 28, quebram em
        // duas linhas e ficam legíveis — por isso só o 20 aparecia torto.
        const floorPx = Math.max(this.MIN_PX_RULER,
            denso ? need : Math.min(this.LAYOUT.maxPxPerBeat, need));

        // "Só quando não cabe": se tudo entra numa linha ≥ piso, mantém o comportamento V3
        // (1 sistema, escala = preenche a largura, capada). Senão, quebra em N linhas.
        const fitsOneLine = (totalBeats <= 0) || (available / totalBeats >= floorPx) || measures <= 1;
        let mps;
        if (fitsOneLine) {
            mps = measures;
            const fill = totalBeats > 0 ? available / totalBeats : this.LAYOUT.maxPxPerBeat;
            this.pxPerBeat = Math.max(4, Math.min(teto, fill));
        } else {
            // compassos que cabem por linha NO piso; ≥1. UMA escala global preenche a linha
            // cheia (última pode ficar curta = borda direita irregular, mesma velocidade).
            mps = Math.max(1, Math.floor(available / (beatsPerMeasure * floorPx)));
            const fill = available / (mps * beatsPerMeasure);
            this.pxPerBeat = Math.max(4, Math.min(teto, fill));
        }

        // 🔴 CABEÇA DE NOTA ESCALÁVEL — a tela estreita não negocia. Mesmo com o teto cedendo,
        // um compasso de fusas pede 448px e o celular tem ~258px úteis: a figura fica com 8px
        // de espaço para uma cabeça de 13px, e elas se sobrepõem (auditoria 11/ago). Quando a
        // menor figura não tem o seu W_MIN, a CABEÇA encolhe na mesma proporção — piso em 55%,
        // abaixo disso não é mais nota, é ponto. Nada disso toca getBeatX: posição = tempo.
        // A régua é a LARGURA DA CABEÇA (2·rx), não o W_MIN: o que não pode é uma cabeça
        // invadir a seguinte. 0,92 deixa um fio de respiro entre elas.
        const vao = this.pxPerBeat * dMin;                       // px disponíveis por figura
        const k = Math.max(0.45, Math.min(1, 0.92 * vao / (2 * this._headBase.rx)));
        this.NOTEHEAD.rx = this._headBase.rx * k;
        this.NOTEHEAD.ry = this._headBase.ry * k;
        this.STEM.offsetX = this.NOTEHEAD.rx - 0.5;

        this._mps = mps;
        this._beatsPerSystem = mps * beatsPerMeasure;
        this._systems = Math.max(1, Math.ceil(measures / mps));
        // Altura vertical de cada sistema. 1 sistema → slot cheio V3 (sem regressão).
        // Multi-system → adaptativa: cada linha tem MENOS notas, então a banda de respostas
        // reservada encolhe (antes era o slot cheio replicado → gordura entre/abaixo das
        // pautas). Corta o vazio sem espremer a pauta nem a banda além do legível.
        this._systemHeight = this._computeSystemHeight(pattern);
    }

    /**
     * Altura de cada sistema (slot vertical). Em 1 sistema, mantém config.height (V3).
     * Em multi-system, dimensiona ao conteúdo real: pauta + régua/rótulo (baseGap) +
     * banda de respostas suficiente p/ a MAIOR capacidade entre os sistemas (notas+folga),
     * comprimida ao passo mínimo legível. Nunca cresce além do slot V3 (só encolhe).
     */
    _computeSystemHeight(pattern) {
        // Início da banda (= fim de pauta+régua+rótulo do compasso), relativo ao slot.
        const bandStart = this.staff.getY(0) + this.RESPONSE.baseGap + this._padBelow();

        // Menu (idle): sem reservar banda → slot = só pauta+régua+rótulo + folga mínima.
        // Vale p/ 1 OU N sistemas: corta o vazio entre/abaixo das pautas no menu.
        if (!this.reserveResponseBand) {
            return Math.ceil(bandStart + 8);
        }

        // 1 sistema com banda → altura V3 original (sem regressão). Com alturas, o respiro entra
        // na altura também — senão ele era descontado da BANDA (fileiras colapsavam mais cedo).
        if (this._systems <= 1) return this.staff.config.height + this._padBelow();

        const counts = new Array(this._systems).fill(0);
        if (pattern && Array.isArray(pattern.notes) && this._beatsPerSystem > 0) {
            pattern.notes.forEach(n => {
                if (n.type !== 'note') return;
                const sys = Math.max(0, Math.min(this._systems - 1,
                    Math.floor((n.beat + 1e-9) / this._beatsPerSystem)));
                counts[sys]++;
            });
        }
        // folga +2 p/ toques extras (duplo/fantasma); piso 6 fileiras. Passo MÍNIMO (a banda
        // só precisa caber o caso comprimido — toques esparsos respiram naturalmente).
        const maxRows = Math.max(6, ...counts.map(c => c + 2));
        const band = maxRows * this.RESPONSE.rowStepMin;
        const bottomPad = 10;
        return Math.min(this.staff.config.height, Math.ceil(bandStart + band + bottomPad));
    }

    /** Índice do sistema (linha) que contém o beat. Clampado a [0, systems-1]. */
    _systemOf(beat) {
        if (this._systems <= 1 || this._beatsPerSystem <= 0) return 0;
        const s = Math.floor((beat + 1e-9) / this._beatsPerSystem);
        return Math.max(0, Math.min(this._systems - 1, s));
    }

    /** Deslocamento vertical (px) do sistema que contém o beat. */
    _yOffset(beat) {
        return this._systemOf(beat) * this._systemHeight;
    }

    /**
     * Posição completa de um beat: { x (local ao sistema), yOffset, sys }.
     * ★ Fonte única de coordenada (V3 multi-system). X é LINEAR dentro do sistema.
     */
    getBeatPos(beat) {
        const sys = this._systemOf(beat);
        const drawArea = this.staff.getDrawArea();
        const originX = drawArea.startX + this.LAYOUT.clefSpace + this.LAYOUT.leftInset;
        const localBeat = beat - sys * this._beatsPerSystem;
        return { x: originX + localBeat * this.pxPerBeat, yOffset: sys * this._systemHeight, sys };
    }

    /**
     * Converte um beat global (0..measures*beats) em coordenada X.
     * ★ FONTE ÚNICA DE VERDADE DE X (V3). Notas, pausas, barras de compasso,
     * régua de debug e playhead derivam TODOS daqui → posição = tempo.
     *
     * Grade LINEAR proporcional ao tempo: a escala `this.pxPerBeat` é definida por
     * _computeLayout() a cada render (responsiva — abordagem B). O clefSpace reserva
     * espaço p/ clave + fórmula e o leftInset dá respiro à 1ª nota; ambos aplicados
     * aqui dentro → notas/playhead/régua deslocam juntos e a sincronia permanece verdadeira.
     * @param {number} beat
     * @returns {number}
     */
    getBeatX(beat) {
        // 🔴 ESTRITAMENTE LINEAR DENTRO do sistema: X = origem + beatLocal·pxPerBeat.
        // Posição = tempo em todo ponto → o playhead anda a velocidade constante por linha
        // ("tempo é tempo"), sem nenhuma aceleração, e passa exatamente sobre cada nota
        // quando ela soa. A quebra de linha é "carriage return" (getBeatPos resolve o
        // sistema). NUNCA inserir termo não-linear aqui (goteira/respiro por compasso).
        return this.getBeatPos(beat).x;
    }

    /**
     * Cria o playhead (linha vertical que varre a partitura no tempo).
     * Chamar APÓS render() (render limpa o SVG). P2.
     */
    createPlayhead() {
        const svg = this.staff.svg;
        // Y é definido em movePlayhead (depende do sistema do beat); aqui só posiciona no
        // 1º sistema p/ não ficar sem coordenada antes do 1º move.
        const topY = this.staff.getY(8) - 18;
        const bottomY = this.staff.getY(0) + 18;

        const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttribute('y1', topY);
        line.setAttribute('y2', bottomY);
        line.setAttribute('stroke', '#10b981');
        line.setAttribute('stroke-width', 2.5);
        line.setAttribute('opacity', '0.85');
        line.setAttribute('visibility', 'hidden');
        line.style.pointerEvents = 'none';
        svg.appendChild(line);
        this.playhead = line;
        return line;
    }

    /**
     * Move o playhead para um beat. Cor opcional (estado da fase).
     * @param {number} beat
     * @param {string} color
     */
    movePlayhead(beat, color = '#10b981') {
        if (!this.playhead) return;
        // getBeatPos resolve o sistema → X local + yOffset. Na fronteira de sistema o beat
        // exato já rola p/ a linha de baixo (carriage return): o playhead "salta" pro início
        // da próxima linha no instante do downbeat — exatamente sobre o 1º evento dela.
        const pos = this.getBeatPos(beat);
        this.playhead.setAttribute('x1', pos.x);
        this.playhead.setAttribute('x2', pos.x);
        this.playhead.setAttribute('y1', this.staff.getY(8) - 18 + pos.yOffset);
        this.playhead.setAttribute('y2', this.staff.getY(0) + 18 + pos.yOffset);
        this.playhead.setAttribute('stroke', color);
        this.playhead.setAttribute('visibility', 'visible');
    }

    /** Esconde o playhead */
    hidePlayhead() {
        if (this.playhead) this.playhead.setAttribute('visibility', 'hidden');
    }

    /**
     * Marca visualmente o resultado de uma nota (feedback ao vivo / pós-take).
     * Bolinha acima da partitura, na posição do beat. P1/P2.
     * @param {number} beat
     * @param {string} color
     */
    addHitMarker(beat, color) {
        const svg = this.staff.svg;
        const pos = this.getBeatPos(beat);
        const x = pos.x;
        const y = this.staff.getY(8) - 26 + pos.yOffset;

        const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        dot.setAttribute('cx', x);
        dot.setAttribute('cy', y);
        dot.setAttribute('r', 5);
        dot.setAttribute('fill', color);
        dot.style.pointerEvents = 'none';
        svg.appendChild(dot);
        this.elements.push(dot);
        return dot;
    }

    // ---------- LINHAS DE RESPOSTA DO USUÁRIO ----------

    /** X local ao sistema `sys` (sem roll-over de getBeatPos nas fronteiras). */
    _localX(beat, sys) {
        const drawArea = this.staff.getDrawArea();
        const originX = drawArea.startX + this.LAYOUT.clefSpace + this.LAYOUT.leftInset;
        return originX + (beat - sys * this._beatsPerSystem) * this.pxPerBeat;
    }

    /** Beat (global) do fim do sistema `sys` — borda direita da linha (último pode ser curto). */
    _systemEndBeat(sys) {
        const measures = Math.round(this._totalBeats / this.LAYOUT.beatsPerMeasure);
        return sys * this._beatsPerSystem + this._measuresInSystem(sys, measures) * this.LAYOUT.beatsPerMeasure;
    }

    /**
     * Y da fileira `rowInSystem` na banda de respostas do sistema `sys` (abaixo da régua
     * DAQUELE sistema). Espaçamento ADAPTATIVO: comprime entre rowStepMax/rowStepMin p/
     * caber na banda [baseGap .. fundo do slot]. Capacidade = notas do sistema + folga →
     * cada toque empilha na linha do seu beat, sem colidir entre sistemas.
     */
    _responseRowY(rowInSystem, sys = 0) {
        const sh = this._systemHeight;
        const top = this.staff.getY(0) + this.RESPONSE.baseGap + this._padBelow() + sys * sh;
        // Fundo da banda = base do PRÓPRIO slot (não config.height). Com altura adaptativa
        // (sh < config.height no multi-system) isso mantém a banda dentro do sistema, sem
        // vazar pro de baixo. Em 1 sistema sh == config.height → idêntico ao V3.
        const bottom = (sys + 1) * sh - 6;
        const capacity = Math.max(1, (this._sysCapacity && this._sysCapacity[sys]) || this._responseRows);
        const step = Math.max(
            this.RESPONSE.rowStepMin,
            Math.min(this.RESPONSE.rowStepMax, (bottom - top) / capacity)
        );
        const i = Math.min(rowInSystem, capacity - 1);
        return Math.min(top + i * step, bottom);
    }

    /** Cria um segmento de linha de resposta (sólido) em (x,y) com cor; sem onset dot. */
    _newResponseLineEl(x, y, color) {
        const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttribute('x1', x);
        line.setAttribute('y1', y);
        line.setAttribute('x2', x);
        line.setAttribute('y2', y);
        line.setAttribute('stroke', color);
        line.setAttribute('stroke-width', this.RESPONSE.strokeWidth);
        line.setAttribute('stroke-linecap', 'round');
        line.style.pointerEvents = 'none';
        this.staff.svg.appendChild(line);
        this.elements.push(line);
        return line;
    }

    /**
     * Começa a desenhar a resposta `index` no beat do APERTO (pode ser negativo →
     * à esquerda do início da régua, p/ toque adiantado à 1ª nota). Cai na banda do
     * sistema do beat; cria o segmento (largura zero + bolinha de onset) e o deixa "ativo".
     * @param {number} index  - ordem do toque (define a COR)
     * @param {number} startBeat - beat do aperto (startRelativeMs / beatDurMs)
     * @returns {SVGLineElement}
     */
    startResponseLine(index, startBeat) {
        const sys = this._systemOf(startBeat);
        const rowInSys = (this._sysRowNext && this._sysRowNext[sys] !== undefined) ? this._sysRowNext[sys]++ : index;
        const y = this._responseRowY(rowInSys, sys);
        const x = this._localX(startBeat, sys);
        const color = this.RESPONSE.palette[index % this.RESPONSE.palette.length];

        const line = this._newResponseLineEl(x, y, color);

        // bolinha no onset: marca claramente o MOMENTO do aperto (independe da duração)
        const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        dot.setAttribute('cx', x);
        dot.setAttribute('cy', y);
        dot.setAttribute('r', this.RESPONSE.onsetDotR);
        dot.setAttribute('fill', color);
        dot.style.pointerEvents = 'none';
        this.staff.svg.appendChild(dot);
        this.elements.push(dot);

        this._activeResponse = { line, startX: x, color, index, sys, rowInSys };
        return line;
    }

    /**
     * Estende a ponta direita da resposta ativa até `beat` (clampado no fim do exercício;
     * nunca recua à esquerda do onset). Se o toque CRUZA a quebra de linha, fecha o
     * segmento na borda direita do sistema atual e ABRE um novo na linha seguinte (como
     * uma ligadura): o "raio-x" continua coerente em cada sistema. Chamado a cada frame.
     * @param {number} beat
     */
    extendResponseLine(beat) {
        if (!this._activeResponse) return;
        const target = Math.min(beat, this._totalBeats);
        let a = this._activeResponse;
        // avança por sistemas enquanto o alvo estiver numa linha posterior
        let guard = 0;
        while (this._systemOf(target) > a.sys && guard++ < this._systems) {
            const rightX = this._localX(this._systemEndBeat(a.sys), a.sys);
            a.line.setAttribute('x2', Math.max(rightX, a.startX));
            const nextSys = a.sys + 1;
            const rowInSys = (this._sysRowNext && this._sysRowNext[nextSys] !== undefined) ? this._sysRowNext[nextSys]++ : a.rowInSys;
            const y = this._responseRowY(rowInSys, nextSys);
            const leftX = this._localX(nextSys * this._beatsPerSystem, nextSys); // origem da próxima linha
            const line = this._newResponseLineEl(leftX, y, a.color);
            this._activeResponse = { line, startX: leftX, color: a.color, index: a.index, sys: nextSys, rowInSys };
            a = this._activeResponse;
        }
        const x2 = Math.max(this._localX(target, a.sys), a.startX);
        a.line.setAttribute('x2', x2);
    }

    /** Congela a resposta ativa no beat do SOLTAR e encerra o segmento. */
    endResponseLine(beat) {
        if (!this._activeResponse) return;
        this.extendResponseLine(beat);
        this._activeResponse = null;
    }

    /**
     * Desenha de uma vez TODAS as respostas a partir dos inputs crus (aperto→soltar).
     * Usado na tela de RESULTADO p/ o usuário analisar o take inteiro. Não pareia
     * nem julga: é a realidade dos toques, na ordem em que aconteceram.
     * @param {Array<{startRelative:number,endRelative:number}>} inputs
     * @param {number} beatDurMs - duração de 1 beat em ms (converte ms → beat)
     */
    drawResponseLines(inputs, beatDurMs) {
        if (!inputs || !beatDurMs) return;
        inputs.forEach((inp, i) => {
            this.startResponseLine(i, inp.startRelative / beatDurMs);
            this.endResponseLine(inp.endRelative / beatDurMs);
        });
    }

    // ---------- ANATOMIA DA RESPOSTA (tela de resultado) ----------

    /**
     * Desenha UM segmento de resposta numa fileira, em beats, classificado por `kind`:
     *   'correct' (verde sólido) · 'wrong' (vermelho sólido) · 'miss' (cinza pontilhado).
     * X deriva de getBeatX (mesma régua das notas). A esquerda pode ser negativa (antes
     * da régua = toque adiantado); a direita é clampada na barra final do exercício.
     * Multi-system: X é LOCAL ao sistema `sys` (banda da fileira). A direita é clampada
     * no fim do exercício E no fim do sistema (cauda que cruzaria a quebra de linha não é
     * desenhada — camada cosmética, rara; o treino em ms continua intacto). A esquerda
     * pode ser negativa (toque adiantado, desenhado à esquerda da origem da linha).
     * @param {number} rowY
     * @param {number} x1Beat
     * @param {number} x2Beat
     * @param {string} kind
     * @param {number} sys
     */
    _drawResponseSegment(rowY, x1Beat, x2Beat, kind, sys = 0) {
        const rightCap = Math.min(x2Beat, this._totalBeats, this._systemEndBeat(sys));
        const xa = this._localX(x1Beat, sys);
        const xb = this._localX(rightCap, sys);
        if (xb - xa < 0.5) return; // segmento sem largura visível

        const isMiss = (kind === 'miss');
        const color = kind === 'correct' ? this.RESPONSE.correctColor
                    : kind === 'wrong'   ? this.RESPONSE.wrongColor
                                         : this.RESPONSE.missColor;

        const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttribute('x1', xa);
        line.setAttribute('y1', rowY);
        line.setAttribute('x2', xb);
        line.setAttribute('y2', rowY);
        line.setAttribute('stroke', color);
        // "faltou" é fantasma: mais fino, pontilhado e meio translúcido (silêncio que
        // devia ter som). Som real (correct/wrong) é sólido, cheio, ponta arredondada.
        line.setAttribute('stroke-width', isMiss ? this.RESPONSE.strokeWidth - 1 : this.RESPONSE.strokeWidth);
        line.setAttribute('stroke-linecap', isMiss ? 'butt' : 'round');
        if (isMiss) {
            line.setAttribute('stroke-dasharray', this.RESPONSE.dash);
            line.setAttribute('opacity', '0.75');
        }
        line.style.pointerEvents = 'none';
        this.staff.svg.appendChild(line);
        this.elements.push(line);
    }

    /**
     * Quebra a linha do tempo de UMA nota em segmentos {correct|wrong|miss} a partir do
     * toque real [Sa,Se] vs a janela ideal [B,E] (tudo em beats). Classifica cada
     * sub-intervalo por presença de SOM × pertencer à NOTA IDEAL — robusto a qualquer
     * configuração (adiantado, atrasado, curto, longo, ou tudo junto). Funde vizinhos
     * de mesmo tipo p/ o pontilhado fluir contínuo.
     * @returns {Array<{x1:number,x2:number,kind:string}>}
     */
    _buildResponseSegments(Sa, Se, B, E) {
        const pts = [...new Set([Sa, Se, B, E])].sort((a, b) => a - b);
        const raw = [];
        for (let k = 0; k < pts.length - 1; k++) {
            const p = pts[k], q = pts[k + 1];
            if (q - p < 1e-9) continue;
            const mid = (p + q) / 2;
            const sound = (mid >= Sa && mid < Se);
            const ideal = (mid >= B && mid < E);
            let kind = null;
            if (sound && ideal) kind = 'correct';
            else if (sound && !ideal) kind = 'wrong'; // som fora do lugar
            else if (!sound && ideal) kind = 'miss';  // faltou (silêncio na nota)
            // !sound && !ideal → silêncio fora da nota: nada a desenhar
            if (kind) raw.push({ x1: p, x2: q, kind });
        }
        // funde segmentos adjacentes de mesmo tipo
        const merged = [];
        for (const s of raw) {
            const last = merged[merged.length - 1];
            if (last && last.kind === s.kind && Math.abs(last.x2 - s.x1) < 1e-9) last.x2 = s.x2;
            else merged.push({ ...s });
        }
        return merged;
    }

    /**
     * Desenha a ANATOMIA de um take inteiro a partir do resultado do scorer (uma fileira
     * por NOTA, na ordem da partitura) + os toques extras (som sem nota) ao final.
     * Reusa o pareamento que o scorer já fez (nada de matching novo aqui).
     * @param {Array} results - scorer.evaluate().results (cada {expected, actual|null, status})
     * @param {Array} extras  - scorer.evaluate().extras (toques sem nota)
     * @param {number} beatDurMs
     * @param {Object} opts - { onsetTolMs, durDeadMs } tolerâncias p/ "snap" (take bom = limpo)
     */
    drawScoredResponses(results, extras, beatDurMs, opts = {}) {
        if (!beatDurMs) return;
        const onsetTol = (opts.onsetTolMs ?? 45) / beatDurMs; // em beats
        const durDead = (opts.durDeadMs ?? 0) / beatDurMs;
        // Fileiras POR SISTEMA: cada nota cai na banda do sistema do seu beat B.
        const rowBySys = {};
        const rowFor = (sys) => { const r = rowBySys[sys] || 0; rowBySys[sys] = r + 1; return r; };

        for (const r of (results || [])) {
            if (!r || !r.expected) continue;
            const B = r.expected.startTime / beatDurMs;
            const E = (r.expected.startTime + r.expected.duration) / beatDurMs;
            const sys = this._systemOf(B);
            const rowY = this._responseRowY(rowFor(sys), sys);

            if (r.status === 'missed' || !r.actual) {
                // nota perdida: janela ideal inteira pontilhada (a ausência fica visível)
                this._drawResponseSegment(rowY, B, E, 'miss', sys);
                this._drawTargetTick(rowY, E, sys); // linha de chegada (mostra onde devia ir)
                continue;
            }

            let Sa = r.actual.startRelative / beatDurMs;
            const endMs = (r.actual.endRelative != null)
                ? r.actual.endRelative
                : r.actual.startRelative + r.actual.duration;
            let Se = endMs / beatDurMs;
            // snap de tolerância: dentro da janela perfeita/dead-zone, alinha à ideal
            // → um bom take vira verde limpo, sem lasquinhas vermelhas/pontilhadas.
            if (Math.abs(Sa - B) <= onsetTol) Sa = B;
            if (durDead > 0 && Math.abs(Se - E) <= durDead) Se = E;

            const segs = this._buildResponseSegments(Sa, Se, B, E);
            for (const s of segs) this._drawResponseSegment(rowY, s.x1, s.x2, s.kind, sys);
            this._drawTargetTick(rowY, E, sys); // linha de chegada no fim ideal da nota
            // bolinha no onset real, na cor do 1º segmento (marca o instante do aperto)
            const first = segs.length ? segs[0] : null;
            if (first) this._drawResponseDot(rowY, Sa, first.kind, sys);
        }

        // toques extras (som sem nota) → fileiras vermelhas inteiras (banda do beat do toque)
        for (const ex of (extras || [])) {
            const Sa = ex.startRelative / beatDurMs;
            const endMs = (ex.endRelative != null) ? ex.endRelative : ex.startRelative + ex.duration;
            const Se = endMs / beatDurMs;
            const sys = this._systemOf(Sa);
            const rowY = this._responseRowY(rowFor(sys), sys);
            this._drawResponseSegment(rowY, Sa, Se, 'wrong', sys);
            this._drawResponseDot(rowY, Sa, 'wrong', sys);
        }
    }

    /**
     * "Linha de chegada": tique vertical curto no FIM IDEAL da nota (E). Vira o ponto
     * de pivô — pontilhado ANTES dele = soltou cedo; vermelho DEPOIS = segurou demais;
     * verde encostando = no ponto. Cinza escuro p/ ler como referência, não como erro.
     */
    _drawTargetTick(rowY, beatE, sys = 0) {
        const x = this._localX(Math.min(beatE, this._totalBeats, this._systemEndBeat(sys)), sys);
        const h = this.RESPONSE.tickHalf;
        const tick = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        tick.setAttribute('x1', x);
        tick.setAttribute('y1', rowY - h);
        tick.setAttribute('x2', x);
        tick.setAttribute('y2', rowY + h);
        tick.setAttribute('stroke', this.RESPONSE.targetColor);
        tick.setAttribute('stroke-width', 1.5);
        tick.style.pointerEvents = 'none';
        this.staff.svg.appendChild(tick);
        this.elements.push(tick);
    }

    /** Bolinha de onset na fileira, na cor do tipo do 1º segmento. */
    _drawResponseDot(rowY, beat, kind, sys = 0) {
        const color = kind === 'correct' ? this.RESPONSE.correctColor
                    : kind === 'wrong'   ? this.RESPONSE.wrongColor
                                         : this.RESPONSE.missColor;
        const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        dot.setAttribute('cx', this._localX(beat, sys));
        dot.setAttribute('cy', rowY);
        dot.setAttribute('r', this.RESPONSE.onsetDotR);
        dot.setAttribute('fill', color);
        dot.style.pointerEvents = 'none';
        this.staff.svg.appendChild(dot);
        this.elements.push(dot);
    }

    /**
     * Limpa renderização anterior
     */
    clear() {
        this.staff.clear();
        this.elements = [];
        this.playhead = null; // SVG foi esvaziado; será recriado após render
        this._activeResponse = null; // SVG esvaziado → nenhum segmento ativo
    }
}

// Disponibiliza globalmente
window.RhythmRenderer = RhythmRenderer;



// ============================================
// components/rhythm/RhythmInputDetector.js
// ============================================
/**
 * RhythmInputDetector - Captura INÍCIO + DURAÇÃO no RELÓGIO DE ÁUDIO
 *
 * Mudança crítica (P0): os timestamps NÃO usam mais performance.now().
 * Usam audioManager.now() (AudioContext.currentTime), a MESMA base do
 * metrônomo/demo/grade. Assim input e grade compartilham origem e relógio.
 *
 * startRelative/endRelative/duration são em MILISSEGUNDOS, relativos ao
 * início da janela de gravação (originTime), já compensados pela latência
 * de saída (o usuário toca no som que OUVE, atrasado ~outputLatency).
 */
class RhythmInputDetector {
    constructor() {
        this.recording = false;
        this.originTime = 0;       // tempo de áudio (s) do beat 0 da gravação
        this.latencyOffset = 0;    // s — compensação (outputLatency do navegador)
        this.currentNote = null;
        this.inputs = [];
        this.onLiveTap = null;     // callback (startRelativeMs) => void p/ feedback ao vivo
    }

    /**
     * Inicia gravação ancorada no relógio de áudio.
     * @param {number} originTime - tempo de áudio (s) do beat 0 da gravação
     * @param {number} latencyOffset - s a subtrair (latência de saída do navegador)
     */
    start(originTime, latencyOffset = 0) {
        this.recording = true;
        this.originTime = originTime;
        this.latencyOffset = latencyOffset;
        this.currentNote = null;
        this.inputs = [];
    }

    /** Converte tempo de áudio absoluto (s) → ms relativos à gravação, compensados */
    toRelativeMs(audioTime) {
        return (audioTime - this.originTime - this.latencyOffset) * 1000;
    }

    /**
     * Início da nota (pressionar)
     */
    onTapDown() {
        if (!this.recording) return;
        if (this.currentNote) return; // já segurando

        const t = window.audioManager.now();
        const startRelative = this.toRelativeMs(t);
        this.currentNote = {
            startAudio: t,
            startRelative
        };

        window.eventBus.emit('rhythm:tap-down', { startRelative });
        if (this.onLiveTap) this.onLiveTap(startRelative);
    }

    /**
     * Fim da nota (soltar)
     */
    onTapUp() {
        if (!this.recording) return;
        if (!this.currentNote) return;

        const t = window.audioManager.now();
        this.currentNote.endAudio = t;
        this.currentNote.endRelative = this.toRelativeMs(t);
        // duração: latência cancela (diferença de dois tempos do mesmo relógio)
        this.currentNote.duration = (t - this.currentNote.startAudio) * 1000;

        this.inputs.push({ ...this.currentNote });
        this.currentNote = null;

        window.eventBus.emit('rhythm:tap-up', {});
    }

    /**
     * Para gravação e retorna inputs
     *
     * 🔴 Finaliza a nota AINDA SEGURADA *antes* de zerar `recording`. No touch a
     * última nota costuma estar com o dedo pressionado quando a captura fecha
     * (o `pointerup` ainda não veio, e `tapButton.disable()` não chama o release).
     * Se zerássemos `recording` primeiro, o `onTapUp` aqui bateria no próprio
     * guard `if (!this.recording) return` e a nota seria DESCARTADA → reaparecia
     * a "última nota perdida" só no touch. O onset já foi capturado no onTapDown
     * (dentro da janela); só faltava medir a duração até aqui. Regressão coberta
     * em logic-tests (detector segurado no stop) e integration-test (take touch).
     * @returns {Array}
     */
    stop() {
        if (this.currentNote) {
            this.onTapUp();
        }
        this.recording = false;
        return this.inputs;
    }

    clear() {
        this.inputs = [];
        this.currentNote = null;
    }
}

// Disponibiliza globalmente
window.RhythmInputDetector = RhythmInputDetector;



// ============================================
// components/rhythm/RhythmScorer.js
// ============================================
/**
 * RhythmScorer - Scoring de PRECISAO CONTINUO (0-100%)
 *
 * Responsabilidades:
 * - Proximity matching: pareia inputs com notas esperadas mais proximas
 * - Timing accuracy: precisao de inicio (formula linear)
 * - Duration accuracy: formula proporcional (% desvio da duracao esperada)
 * - Rest violation detection: penaliza tocar durante pausas
 * - Extra notes: identifica e penaliza inputs nao pareados
 */
class RhythmScorer {
    constructor(options = {}) {
        this.EXTRA_NOTE_PENALTY = 5;       // -5% por nota extra
        this.REST_VIOLATION_PENALTY = 10;  // -10% por violacao de pausa

        // P4 — calibragem amigável ao iniciante:
        // Janela "perfeita": dentro de ±PERFECT_WINDOW_MS conta como 100% (não exige
        // precisão sobre-humana). Fora dela, decaimento linear.
        this.PERFECT_WINDOW_MS = options.perfectWindowMs ?? 45;
        this.TIMING_DECAY_PER_MS = options.timingDecayPerMs ?? 0.25; // 0% a ~445ms

        // Duração (segurar a tecla) é SECUNDÁRIA. Por padrão graduamos só o ATAQUE
        // (onset) — é o que importa pra quem está começando. Ative gradeDuration
        // para ponderar a duração (peso DURATION_WEIGHT).
        this.gradeDuration = options.gradeDuration ?? false;
        this.DURATION_WEIGHT = options.durationWeight ?? 0.25;

        // Janela "perfeita" da DURAÇÃO (ms ABSOLUTOS, como o ataque — não % da batida,
        // que escalava mal: 15% de uma mínima = 300ms). Dentro dela = 100%; fora, decai
        // pela cobertura real (igual ao gráfico). Fixada em 45ms (simétrica ao ataque) p/
        // o iniciante de hoje (semínima/mínima). É a MESMA janela usada pelo desenho (snap
        // do verde) → número e gráfico contam a mesma história. É PARÂMETRO de propósito:
        // um futuro "modo competição" / tempos quebrados passa outro valor (ou margem
        // híbrida piso-ms × fração-da-batida) sem mexer aqui. Ranking de precisão usará
        // erro médio em ms (contínuo), não esta janela.
        this.DURATION_PERFECT_MS = options.durationPerfectMs ?? 45;
    }

    /**
     * Avalia inputs do usuario vs padrao esperado
     * @param {RhythmPattern} pattern
     * @param {Array} userInputs
     * @returns {Object}
     */
    evaluate(pattern, userInputs) {
        const beatDuration = 60000 / pattern.config.bpm;
        const expectedNotes = this.calculateExpectedNotes(pattern);
        const restWindows = this.calculateRestWindows(pattern);

        // 1. Alinhamento ótimo (preserva ordem temporal) — ver alignInputsToNotes
        const { aligned, extras } = this.alignInputsToNotes(expectedNotes, userInputs, beatDuration);

        // 2. Score cada nota NA ORDEM DA PARTITURA (pareada ou perdida)
        const results = [];
        for (const { expected, actual } of aligned) {
            if (!actual) {
                results.push({
                    expected,
                    actual: null,
                    timingAccuracy: 0,
                    durationAccuracy: 0,
                    noteAccuracy: 0,
                    status: 'missed'
                });
                continue;
            }

            // P1 — preserva o SINAL: negativo = adiantou, positivo = atrasou.
            // Esse sinal é a dica de coaching nº1 ("você está correndo").
            const signedDelta = actual.startRelative - expected.startTime;
            const timingDelta = Math.abs(signedDelta);
            const timingAccuracy = this.calculateTimingAccuracy(timingDelta);
            const durationAccuracy = this.calculateDurationAccuracy(actual.duration, expected.duration);

            // P4 — onset primário; duração só pondera se gradeDuration estiver ligado
            const noteAccuracy = this.gradeDuration
                ? timingAccuracy * (1 - this.DURATION_WEIGHT) + durationAccuracy * this.DURATION_WEIGHT
                : timingAccuracy;

            results.push({
                expected,
                actual,
                signedDelta,
                timingDelta,
                rushing: signedDelta < 0,
                timingAccuracy,
                durationAccuracy,
                noteAccuracy,
                status: this.getStatus(timingDelta, Math.abs(actual.duration - expected.duration))
            });
        }

        // 4. Detectar violacoes de pausa nos extras
        const restViolations = [];
        const pureExtras = [];
        for (const input of extras) {
            const violation = this.checkRestViolation(input, restWindows);
            if (violation) {
                restViolations.push({ input, rest: violation });
            } else {
                pureExtras.push(input);
            }
        }

        // 5. Score final
        const noteCount = expectedNotes.length;
        const baseScore = noteCount > 0
            ? results.reduce((sum, r) => sum + r.noteAccuracy, 0) / noteCount
            : 0;

        const extraPenalty = pureExtras.length * this.EXTRA_NOTE_PENALTY;
        const restPenalty = restViolations.length * this.REST_VIOLATION_PENALTY;
        const score = Math.max(0, baseScore - extraPenalty - restPenalty);

        const matchedResults = results.filter(r => r.status !== 'missed');
        const avgTiming = matchedResults.length > 0
            ? matchedResults.reduce((s, r) => s + r.timingAccuracy, 0) / matchedResults.length
            : 0;
        const avgDuration = matchedResults.length > 0
            ? matchedResults.reduce((s, r) => s + r.durationAccuracy, 0) / matchedResults.length
            : 0;

        // P1 — tendência geral: média do delta COM sinal (negativo=adiantando)
        const avgSignedDelta = matchedResults.length > 0
            ? matchedResults.reduce((s, r) => s + r.signedDelta, 0) / matchedResults.length
            : 0;

        // P8 — DOIS placares CO-IGUAIS: Início (ataque) × Duração.
        // Decisão 1 (denominador): ambos dividem por TODAS as notas esperadas
        // (a missed já entra em `results` com timing/duration = 0), então são
        // diretamente comparáveis — "100% de duração" é impossível se você
        // perdeu metade das notas.
        // Decisão 2 (penalidades): nota extra / tocar em pausa é erro de
        // COLOCAÇÃO no tempo → desconta só no Início; Duração fica "pura".
        const onsetBase = noteCount > 0
            ? results.reduce((s, r) => s + r.timingAccuracy, 0) / noteCount
            : 0;
        const durationBase = noteCount > 0
            ? results.reduce((s, r) => s + r.durationAccuracy, 0) / noteCount
            : 0;
        const onsetScore = Math.max(0, onsetBase - extraPenalty - restPenalty);
        const durationScore = durationBase;

        // Decisão 3 (tendência de duração): média do desvio COM sinal nas notas
        // pareadas. <0 = segurou CURTO (soltou cedo); >0 = segurou LONGO.
        const avgSignedDurationDelta = matchedResults.length > 0
            ? matchedResults.reduce((s, r) => s + (r.actual.duration - r.expected.duration), 0) / matchedResults.length
            : 0;

        return {
            results,
            extras: pureExtras,
            restViolations,
            score,
            totalNotes: noteCount,
            avgTimingAccuracy: avgTiming,
            avgDurationAccuracy: avgDuration,
            avgSignedDelta,          // ms; <0 adiantando, >0 atrasando
            onsetScore,              // P8 — placar de ATAQUE (0-100), inclui penalidades
            durationScore,           // P8 — placar de DURAÇÃO (0-100), puro
            avgSignedDurationDelta,  // ms; <0 segurou curto, >0 segurou longo
            gradeDuration: this.gradeDuration,
            extraPenalty,
            restPenalty,
            beatDuration
        };
    }

    /**
     * Alinha inputs ↔ notas esperadas de forma ÓTIMA e PRESERVANDO A ORDEM.
     *
     * Antes era guloso ("mais próximo livre" por nota): quando os últimos toques
     * caíam adiantados/juntos, uma nota podia roubar o toque da seguinte, e a
     * última sobrava sem par dentro da tolerância → marcava PERDIDA mesmo o
     * usuário tendo tocado, e ainda gerava um "extra" fantasma.
     *
     * Agora é um alinhamento de sequências (Needleman–Wunsch). Como inputs e
     * notas já estão ordenados no tempo, o DP minimiza o desvio total mantendo a
     * ordem — pareamento global ótimo, sem cruzar notas.
     *
     * Objetivo LEXICOGRÁFICO: (1º) MAXIMIZAR o nº de casamentos, (2º) entre as
     * soluções com mais casamentos, minimizar o desvio total. Casar é só
     * permitido se |Δ| ≤ threshold (= 1 batida). Pular nota (missed) ou toque
     * (extra) não tem custo — assim nunca trocamos um casamento por um "perdida".
     * (Casar uma nota a 1 batida vira % baixa, mas "tocou"; é melhor feedback que
     * "perdida".) O lexicográfico vem de uma RECOMPENSA fixa por casamento que
     * domina qualquer soma de desvios: cada match subtrai REWARD (≫ Σ|Δ| possível)
     * e soma |Δ|, então mais matches sempre ganha e o |Δ| só desempata.
     *
     * @param {Array} expectedNotes - notas esperadas (qualquer ordem)
     * @param {Array} userInputs - inputs do usuário (qualquer ordem)
     * @param {number} beatDuration - duracao de 1 beat em ms
     * @returns {Object} { aligned, extras } — `aligned` em ordem temporal, cada
     *   item { expected, actual|null } (actual null = nota perdida)
     */
    alignInputsToNotes(expectedNotes, userInputs, beatDuration) {
        const threshold = beatDuration;     // distância máxima p/ casar (1 batida)
        const REWARD = 1e7;                 // ≫ Σ|Δ| possível → casamentos dominam o desvio

        const E = [...expectedNotes].sort((a, b) => a.startTime - b.startTime);
        const I = [...userInputs].sort((a, b) => a.startRelative - b.startRelative);
        const n = E.length, m = I.length;

        // dp[i][j] = custo mínimo alinhando as i primeiras notas com os j primeiros inputs.
        // bt[i][j] = operação escolhida: 0=casar, 1=pular nota (miss), 2=pular input (extra).
        // Pular não custa nada; casar dá -REWARD+|Δ| → o DP maximiza casamentos e usa |Δ| de desempate.
        const dp = Array.from({ length: n + 1 }, () => new Float64Array(m + 1));
        const bt = Array.from({ length: n + 1 }, () => new Int8Array(m + 1));
        for (let i = 1; i <= n; i++) { dp[i][0] = 0; bt[i][0] = 1; }
        for (let j = 1; j <= m; j++) { dp[0][j] = 0; bt[0][j] = 2; }

        for (let i = 1; i <= n; i++) {
            for (let j = 1; j <= m; j++) {
                const delta = Math.abs(I[j - 1].startRelative - E[i - 1].startTime);
                const matchCost = delta <= threshold ? dp[i - 1][j - 1] + delta - REWARD : Infinity;
                const missCost = dp[i - 1][j];   // nota i sem par (sem custo)
                const extraCost = dp[i][j - 1];  // input j sem par (sem custo)
                let best = matchCost, op = 0;
                if (missCost < best) { best = missCost; op = 1; }
                if (extraCost < best) { best = extraCost; op = 2; }
                dp[i][j] = best; bt[i][j] = op;
            }
        }

        // Backtrack reconstruindo o alinhamento (do fim ao começo).
        const aligned = [];
        const extras = [];
        let i = n, j = m;
        while (i > 0 || j > 0) {
            const op = bt[i][j];
            if (op === 0)      { aligned.push({ expected: E[i - 1], actual: I[j - 1] }); i--; j--; }
            else if (op === 1) { aligned.push({ expected: E[i - 1], actual: null });     i--; }
            else               { extras.push(I[j - 1]);                                   j--; }
        }
        aligned.reverse(); // volta à ordem temporal
        extras.reverse();

        return { aligned, extras };
    }

    /**
     * Precisao de timing com JANELA PERFEITA + decaimento linear (P4).
     * Dentro de ±PERFECT_WINDOW_MS = 100%. Fora, decai TIMING_DECAY_PER_MS por ms.
     * Ex (janela 45, decay 0.25): 0-45ms=100%, 145ms=75%, 245ms=50%, 445ms=0%.
     */
    calculateTimingAccuracy(deltaMs) {
        if (deltaMs <= this.PERFECT_WINDOW_MS) return 100;
        return Math.max(0, 100 - (deltaMs - this.PERFECT_WINDOW_MS) * this.TIMING_DECAY_PER_MS);
    }

    /**
     * Precisao de duracao (proporcional ao esperado) — JUSTA (×1, sem dobrar o castigo).
     * A nota = quanto da duração você cobriu: 0% off=100%, 10% off=90%, 25% off=75%,
     * 100% off=0%. Assim o NÚMERO bate com o gráfico de resposta (verde = fração coberta),
     * em vez do antigo ×2 que esmagava (16% off virava 67% em vez de 84%).
     */
    calculateDurationAccuracy(userDuration, expectedDuration) {
        if (expectedDuration <= 0) return 100;
        const devMs = Math.abs(userDuration - expectedDuration);
        if (devMs <= this.DURATION_PERFECT_MS) return 100; // perto o bastante = perfeito
        const percentDeviation = devMs / expectedDuration;
        return Math.max(0, 100 - (percentDeviation * 100));
    }

    /**
     * Calcula janelas de pausa do padrao
     * @param {RhythmPattern} pattern
     * @returns {Array} [{startTime, endTime, beat, duration}]
     */
    calculateRestWindows(pattern) {
        const beatDuration = 60000 / pattern.config.bpm;
        const rests = [];

        for (const note of pattern.notes) {
            if (note.type === 'rest') {
                const startTime = note.beat * beatDuration;
                const duration = note.duration * beatDuration;
                rests.push({
                    startTime,
                    endTime: startTime + duration,
                    beat: note.beat,
                    duration
                });
            }
        }

        return rests;
    }

    /**
     * Verifica se um input cai dentro de uma janela de pausa
     * @param {Object} input
     * @param {Array} restWindows
     * @returns {Object|null} a rest window violada, ou null
     */
    checkRestViolation(input, restWindows) {
        for (const rest of restWindows) {
            if (input.startRelative >= rest.startTime && input.startRelative < rest.endTime) {
                return rest;
            }
        }
        return null;
    }

    /**
     * Status qualitativo da nota
     */
    getStatus(timingDelta, durationDelta) {
        if (timingDelta < 50 && durationDelta < 50) return 'excellent';
        if (timingDelta < 100 && durationDelta < 100) return 'good';
        if (timingDelta < 200 && durationDelta < 200) return 'ok';
        return 'poor';
    }

    /**
     * Calcula notas esperadas com timestamps
     * @param {RhythmPattern} pattern
     * @returns {Array}
     */
    calculateExpectedNotes(pattern) {
        const beatDuration = 60000 / pattern.config.bpm;
        const notes = [];

        for (const note of pattern.notes) {
            if (note.type === 'note') {
                notes.push({
                    beat: note.beat,
                    startTime: note.beat * beatDuration,
                    duration: note.duration * beatDuration,
                    visualType: note.visualType
                });
            }
        }

        return notes;
    }
}

// Disponibiliza globalmente
window.RhythmScorer = RhythmScorer;



// ============================================
// components/rhythm/RhythmTapButton.js
// ============================================
/**
 * RhythmTapButton - Botão grande de toque com PRESS/RELEASE
 *
 * P6 — robustez de input:
 *  - Pointer Events (unifica mouse/touch/caneta) + setPointerCapture:
 *    segurar e arrastar para fora do círculo NÃO solta a nota (matava o
 *    antigo bug do mouseleave virar release falso).
 *  - Tecla ESPAÇO no desktop (mais precisa que o mouse), com guarda de repeat.
 *  - Rótulo + dica, TRILÍNGUES (`rhythm.tap.*`); a dica muda com o aparelho.
 */
class RhythmTapButton {
    constructor(container) {
        this.container = container;
        this.button = null;
        this.labelEl = null;   // rótulo TOQUE + dica
        this.countEl = null;   // número da contagem de entrada (centro da bola)
        this.ringEl = null;    // anel que encolhe a cada batida
        this.enabled = false;
        this.onPressCallback = null;
        this.onReleaseCallback = null;
        this.isPressed = false;
        this.playSound = false;
        this.note = 'B4';        // a nota que o toque soa — o jogo troca pelo ajuste do jogador (RhythmPrefs)
        this.noteFor = null;     // opcional: () => nota do toque AGORA (a "melodia" muda a cada nota)
        this.currentSound = null;
        this.activePointerId = null;

        // handlers ligados (para add/removeEventListener)
        this._onKeyDown = (e) => this.handleKeyDown(e);
        this._onKeyUp = (e) => this.handleKeyUp(e);
    }

    /**
     * Renderiza botão no container
     */
    render() {
        // Bola RESPONSIVA e mais compacta (era 280px fixo — grande demais, sobretudo
        // no celular). overflow:hidden CONTÉM o anel/ripple da contagem dentro da bola
        // → nada vaza p/ fora (sem barra de rolagem lateral) e a bola NÃO muda de
        // tamanho a cada batida (sem "pulos").
        const mobile = (window.innerWidth || 1024) < 560;
        this._size = mobile ? 156 : 192;       // ~20% menor que antes — mais elegante; alvo de toque ainda folgado
        const labelFont = mobile ? '1.6rem' : '2rem';

        this.button = window.domManager.create('button', {
            className: 'rhythm-tap-button',
            styles: {
                width: this._size + 'px',
                height: this._size + 'px',
                fontSize: labelFont,
                fontWeight: 'bold',
                borderRadius: '50%',
                border: 'none',
                background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                color: '#fff',
                cursor: 'pointer',
                touchAction: 'none',
                userSelect: 'none',
                webkitUserSelect: 'none',          // iOS: bloqueia seleção/magnifier no long-press
                webkitTouchCallout: 'none',        // iOS: bloqueia menu callout (copiar/definir)
                webkitTapHighlightColor: 'transparent', // remove flash cinza do toque
                transition: 'transform 0.08s, background 0.08s',
                boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                margin: mobile ? '1.2rem auto' : '2rem auto',
                position: 'relative',          // âncora p/ o número/anel da contagem (absolutos)
                overflow: 'hidden',            // CONTÉM o ripple da batida (não vaza → sem scroll lateral)
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: '1.1'
            }
        });
        // Rótulo normal (TOQUE + dica) + camada da contagem (número central) + anel
        // (ripple) que cresce DE DENTRO a cada batida — contido pelo overflow:hidden.
        // A contagem de entrada vive DENTRO da bola (some o <div> separado que empilhava
        // o número acima — pior no celular). Sem escalar a bola → sem "pulos".
        // 🔴 Este texto ERA fixo em português e saía em PT nos 3 domínios — e é a
        // ÚNICA instrução do app que diz qual botão apertar. Violava o tripwire de
        // i18n em silêncio, porque nada testa string que não passa por _t().
        // A dica muda com o aparelho: no celular não há "clique" nem barra de espaço.
        const t = (k) => {
            const v = window.language ? window.language.t('rhythm.tap.' + k) : null;
            return (v && v !== 'rhythm.tap.' + k) ? v : '';
        };
        const dica = (mobile ? t('hintMobile') : t('hintDesktop'));
        this.button.innerHTML = `
            <span class="rtb-label" style="display:flex;flex-direction:column;align-items:center;line-height:1.1;transition:opacity 0.12s;">${t('label')}
                <span style="font-size:0.85rem;font-weight:500;opacity:0.85;margin-top:0.5rem;">
                    ${dica}<br>${t('hintHold')}
                </span>
            </span>
            <span class="rtb-count" style="position:absolute;inset:0;display:none;align-items:center;justify-content:center;font-weight:800;color:#fff;pointer-events:none;text-shadow:0 2px 8px rgba(0,0,0,0.25);"></span>
            <span class="rtb-ring" style="position:absolute;inset:0;border-radius:50%;border:4px solid rgba(255,255,255,0.8);pointer-events:none;opacity:0;"></span>`;
        this.labelEl = this.button.querySelector('.rtb-label');
        this.countEl = this.button.querySelector('.rtb-count');
        this.ringEl = this.button.querySelector('.rtb-ring');

        // Pointer events (mouse + touch + caneta), com captura
        this.button.addEventListener('pointerdown', (e) => {
            e.preventDefault();
            if (this.activePointerId !== null) return;
            this.activePointerId = e.pointerId;
            try { this.button.setPointerCapture(e.pointerId); } catch (_) {}
            this.handlePress();
        });
        this.button.addEventListener('pointerup', (e) => {
            if (e.pointerId !== this.activePointerId) return;
            this.releasePointer(e.pointerId);
            this.handleRelease();
        });
        this.button.addEventListener('pointercancel', (e) => {
            if (e.pointerId !== this.activePointerId) return;
            this.releasePointer(e.pointerId);
            this.handleRelease();
        });
        // Android/desktop: o long-press dispara o evento `contextmenu` (menu
        // copiar/compartilhar/baixar) por um caminho separado do -webkit-touch-callout
        // do iOS. Cancelar aqui é o que falta pra segurar a nota sem o menu pular.
        this.button.addEventListener('contextmenu', (e) => e.preventDefault());

        this.container.appendChild(this.button);
    }

    releasePointer(pointerId) {
        try { this.button.releasePointerCapture(pointerId); } catch (_) {}
        this.activePointerId = null;
    }

    handleKeyDown(e) {
        if (e.code !== 'Space' && e.key !== ' ') return;
        if (e.repeat) return; // ignora auto-repeat do teclado
        e.preventDefault();
        this.handlePress();
    }

    handleKeyUp(e) {
        if (e.code !== 'Space' && e.key !== ' ') return;
        e.preventDefault();
        this.handleRelease();
    }

    /**
     * Início do toque.
     * @param {string} [note] nota a soar SÓ neste toque (o teclado MIDI manda a que a pessoa
     *   tocou); sem ela vale o ajuste do jogador (`noteFor`/`note`).
     */
    handlePress(note) {
        if (!this.enabled || this.isPressed) return;

        this.isPressed = true;
        this.button.style.transform = 'scale(0.92)';
        this.button.style.background = 'linear-gradient(135deg, #8b5cf6, #ec4899)';

        if (this.playSound) {
            const nota = note || (typeof this.noteFor === 'function' && this.noteFor()) || this.note || 'B4';
            this.currentSound = window.audioManager.playNote(nota, 5);
        }
        if (this.onPressCallback) this.onPressCallback();
    }

    /**
     * Fim do toque
     */
    handleRelease() {
        if (!this.enabled || !this.isPressed) return;

        this.isPressed = false;
        this.button.style.transform = 'scale(1)';
        this.button.style.background = 'linear-gradient(135deg, #6366f1, #8b5cf6)';

        if (this.currentSound) {
            this.currentSound.stop();
            this.currentSound = null;
        }
        if (this.onReleaseCallback) this.onReleaseCallback();
    }

    /**
     * Habilita botão (e o atalho de teclado)
     * @param {Object} options
     * @param {boolean} options.playSound
     */
    enable(options = {}) {
        this.enabled = true;
        this.playSound = options.playSound || false;
        document.addEventListener('keydown', this._onKeyDown);
        document.addEventListener('keyup', this._onKeyUp);
    }

    /**
     * Desabilita botão (e remove o atalho de teclado)
     */
    disable() {
        this.enabled = false;
        this.isPressed = false;
        this.playSound = false;
        // 🔴 Reset de pointer: se um pointerup/pointercancel se perdeu (iOS
        // interrompe, ou o container é limpo antes do release), activePointerId
        // ficaria travado e o `if (activePointerId !== null) return` engoliria o
        // PRIMEIRO toque do próximo take. disable() é o teardown limpo entre takes.
        if (this.activePointerId !== null) this.releasePointer(this.activePointerId);
        document.removeEventListener('keydown', this._onKeyDown);
        document.removeEventListener('keyup', this._onKeyUp);
        if (this.currentSound) {
            this.currentSound.stop();
            this.currentSound = null;
        }
        if (this.button) {
            this.button.style.transform = 'scale(1)';
            this.button.style.background = 'linear-gradient(135deg, #6366f1, #8b5cf6)';
        }
    }

    setOnPress(callback) { this.onPressCallback = callback; }
    setOnRelease(callback) { this.onReleaseCallback = callback; }

    /**
     * Mostra o valor da contagem de entrada NO CENTRO da bola e dá um pulso (a bola
     * "respira" a cada batida) + anel que encolhe ao redor. Chamar só na VIRADA do
     * número (o RhythmGame guarda o último valor) — senão o pulso reinicia todo frame.
     * @param {string|number} value  número (1·2·3·4) ou texto ("Vai!")
     * @param {Object} [opts]
     * @param {boolean} [opts.accent]  batida 1 → pulso/fonte maiores
     */
    showCount(value, opts = {}) {
        if (!this.countEl) return;
        const accent = !!opts.accent;
        if (this.labelEl) this.labelEl.style.opacity = '0';
        this.countEl.style.display = 'flex';
        this.countEl.textContent = value;
        // Fonte proporcional ao tamanho da bola ( funciona p/ "1·2·3·4" ou "Vai!").
        const size = this._size || 240;
        const text = String(value);
        const base = text.length > 1 ? 0.22 : 0.34;   // texto longo ("Vai!") menor
        this.countEl.style.fontSize = Math.round(size * (accent ? base * 1.12 : base)) + 'px';

        // SEM escalar a bola (era a causa do "pulo" + barra de rolagem). O feedback de
        // batida é: (1) pop suave do NÚMERO e (2) um ripple que cresce DE DENTRO da bola,
        // contido pelo overflow:hidden — nada vaza, layout não muda.
        if (this.button.animate) {
            this.countEl.animate(
                [{ opacity: 0, transform: 'scale(0.86)' }, { opacity: 1, transform: 'scale(1)' }],
                { duration: 170, easing: 'ease-out' }
            );
            this.ringEl.animate(
                [{ opacity: accent ? 0.8 : 0.55, transform: 'scale(0.25)' }, { opacity: 0, transform: 'scale(1)' }],
                { duration: 460, easing: 'ease-out' }
            );
        }
    }

    /** Some a contagem e devolve o rótulo TOQUE (volta ao modo de toque). */
    clearCount() {
        if (!this.countEl) return;
        this.countEl.style.display = 'none';
        this.countEl.textContent = '';
        if (this.labelEl) this.labelEl.style.opacity = '1';
    }

    /**
     * Destrói componente
     */
    destroy() {
        document.removeEventListener('keydown', this._onKeyDown);
        document.removeEventListener('keyup', this._onKeyUp);
        if (this.button) this.button.remove();
    }
}

// Disponibiliza globalmente
window.RhythmTapButton = RhythmTapButton;



// ============================================
// components/rhythm/RhythmMidiInput.js
// ============================================
/**
 * RhythmMidiInput — o teclado/controlador MIDI como BOTÃO DE TOQUE do Ritmo (19/set).
 *
 * O Ritmo mede só INÍCIO e DURAÇÃO, e um instrumento MIDI entrega exatamente isso: Note On é
 * apertar, Note Off é soltar. Esta classe traduz as mensagens (via `MidiPitchInput`, o mesmo
 * consumidor dos jogos de leitura, sobre o `midiInputManager` único do app) em
 * `onPress(info)` / `onRelease()` — o par que o `RhythmTapButton` já dispara para o dedo e
 * para a barra de espaço. O jogo NÃO ganha um 2º caminho de entrada: o adaptador chama
 * `handlePress/handleRelease` do botão, e dali tudo é igual (detector, linha-resposta, som,
 * e a guarda "botão desabilitado" fora da janela de captura vale de graça).
 *
 * 🔴 UM TOQUE = UM GRUPO DE TECLAS (auditoria 19/set). A nota do Ritmo é UMA por vez, mas o
 *   pianista toca o ritmo em ACORDES e OITAVAS: três Note On em 5 ms são UM toque, não três
 *   (com "última tecla vence" puro cada tecla soltava e apertava de novo — dois toques de 2 ms
 *   viravam "extras" e derrubavam os dois placares, sem aviso).
 *   - Note On dentro de `CHORD_MS` do último onset ENTRA no grupo, sem novo onset.
 *   - Note On fora da janela com o grupo ainda segurado = LEGATO (o normal ao piano): solta o
 *     grupo e aperta — dois onsets, como a pessoa tocou.
 *   - O toque só SOLTA quando a ÚLTIMA tecla do grupo sobe; Note Off de tecla que não está no
 *     grupo é ignorado (soltar a tecla velha do legato não pode encerrar a nota nova).
 *   - Tecla que JÁ está no grupo não re-dispara (teclado em layer manda a mesma nota em dois
 *     canais; uma tecla física não desce duas vezes sem subir).
 *   - Perder o teclado (cabo puxado, `nodevice`) com tecla segurada SOLTA — senão o botão ficava
 *     preso "apertado" até o fim do take.
 * 🔴 Qualquer tecla ou pad vale (0–127): o `MidiPitchInput` sozinho corta fora de A0–C8, e pad
 *   de bateria manda nota grave. O jogo mede tempo, não altura.
 * 🔴 Quem usa chama `destroy()` ao sair (senão o handler segue vivo num jogo que saiu da tela).
 */
class RhythmMidiInput {
    /** Teclas que descem dentro desta janela (ms) são o MESMO toque (acorde/oitava). */
    static CHORD_MS = 30;

    /** Web MIDI neste navegador? (ausente no iOS — aí a linha do ⚙️ nem aparece) */
    static isSupported() {
        return !!(window.MidiPitchInput && window.MidiPitchInput.isSupported());
    }

    constructor(opts = {}) {
        this.onPress = opts.onPress || null;      // (info: PitchUtil.info) — o grupo desceu (1ª tecla)
        this.onRelease = opts.onRelease || null;  // () — a última tecla do grupo subiu
        this.onState = opts.onState || null;      // (state) — 'listening'|'nodevice'|'denied'|'error'|'requesting'
        // Relógio em ms, injetável (o teste controla a janela do acorde). O de áudio é o mesmo
        // que carimba o onset; fora do harness nunca falta.
        this._now = opts.now || (() => (window.audioManager && window.audioManager.now ? window.audioManager.now() * 1000 : performance.now()));
        this._keys = new Set();    // teclas do grupo que está "segurando o botão"
        this._onsetAt = -Infinity; // ms do último onset (janela do acorde)
        this._input = null;        // MidiPitchInput
    }

    get state() { return this._input ? this._input.state : 'idle'; }

    /** Nome do teclado ativo (para a linha de status); null se não há nenhum. */
    getDeviceName() { return this._input ? this._input.getDeviceName() : null; }

    /**
     * Pede o acesso e começa a ouvir. Partir de um gesto na 1ª vez (o clique no ⚙️); nas
     * seguintes a permissão já está guardada pelo navegador e não há prompt.
     * @returns {Promise<boolean>}
     */
    start() {
        if (!this._input) {
            this._input = new window.MidiPitchInput({
                minMidi: 0, maxMidi: 127,
                onKeyPress: (info) => this._down(info),
                onNoteOff: (info) => this._up(info),
                onStateChange: (s) => {
                    if (s !== 'listening') this._drop();   // teclado sumiu com tecla segurada: solta
                    if (this.onState) this.onState(s);
                }
            });
        }
        return this._input.start();
    }

    /** Público de fato para os testes (que injetam eventos sem hardware). */
    _down(info) {
        const midi = info.midi;
        if (this._keys.has(midi)) return;                       // duplicata (layer/eco)
        const t = this._now();
        if (this._keys.size && t - this._onsetAt <= RhythmMidiInput.CHORD_MS) {
            this._keys.add(midi);                               // acorde: entra no toque que já desceu
            return;
        }
        if (this._keys.size) { this._keys.clear(); if (this.onRelease) this.onRelease(); }   // legato: solta o grupo anterior
        this._keys.add(midi);
        this._onsetAt = t;
        if (this.onPress) this.onPress(info);
    }

    _up(info) {
        if (!this._keys.delete(info.midi)) return;   // tecla fora do grupo: nada
        if (this._keys.size) return;                 // acorde: só a última tecla solta
        if (this.onRelease) this.onRelease();
    }

    /** Solta o que estiver segurado (teclado perdido, desligar, destroy). */
    _drop() {
        if (!this._keys.size) return;
        this._keys.clear();
        if (this.onRelease) this.onRelease();
    }

    destroy() {
        this.onState = null;   // ANTES do destroy do input: o 'idle' que ele emite não pode pintar "aguardando…"
        this._drop();
        if (this._input) { this._input.destroy(); this._input = null; }
        this.onPress = null;
        this.onRelease = null;
    }
}

window.RhythmMidiInput = RhythmMidiInput;



// ============================================
// components/rhythm/RhythmConfigPanel.js
// ============================================
/**
 * RhythmConfigPanel - Painel de controle do jogo de ritmo (gaveta lateral)
 *
 * Gaveta que desliza da ESQUERDA, sobre um backdrop; responsiva (no celular
 * ocupa ~88vw, no desktop 340px) e rolável. Fecha por ✕, backdrop, Esc.
 *
 * GENÉRICO E MODULAR: o painel não conhece "figuras" — recebe SEÇÕES
 * declarativas (toggle-list) e emite onChange com a seleção por seção.
 * Futuras seções (ex.: fórmulas de compasso, BPMs múltiplos) = mais um
 * descriptor no array `sections`, sem mexer nesta classe.
 *
 * sections: [{ id, title, hint?, single?, items: [{ id, glyph?, label, sublabel?, checked, disabled? }] }]
 *   single:true  → escolha ÚNICA (rádio): exatamente um item marcado por seção.
 *                  (default: checkbox/multi-seleção, comportamento histórico.)
 *   inline:true  → as opções viram uma fileira de botões (chips) que quebra linha, em vez
 *                  de uma linha por opção: 3-4 escolhas curtas ("2/4 · 3/4 · 4/4") não pagam
 *                  57 px de rolagem cada. Com `single` é rádio (uma marcada); SEM `single` é
 *                  multi-seleção (27/set: as 15 tonalidades da Leitura, marque quantas
 *                  quiser) e passa pelo `canToggle` como a lista. Alvo continua com 44 px de ALTURA.
 *   collapsible:true → (com inline) a seção nasce FECHADA numa linha: [título] [resumo do que está
 *                  marcado…] [▾] [?]; tocar abre as chips (`section.open`). É o orçamento de espaço
 *                  do painel (27/set): 15 tonalidades custam 5 linhas, e quem só quer Dó maior não
 *                  paga por elas. O dono pode passar `open:true` para nascer aberta.
 *   auto:true    → (checkbox) item marcado pelo DONO, não pela pessoa (ex.: a semínima ligada
 *                  para fechar o compasso). Tocar nele não desmarca: ADOTA — continua marcado e
 *                  o onChange recebe `{adopted: id}` como 2º argumento.
 *   disabled:true → item APAGADO e intocável, mas o `checked` dele é preservado e continua
 *                  em getEnabled() (ex.: a semibreve "não cabe em 3/4" — o dono põe o porquê
 *                  no sublabel; voltar ao 4/4 devolve a figura sem ninguém remarcar).
 *   kind:'select' → AJUSTE EM UMA LINHA: [título ........ <select>] [?]. Sem cabeçalho nem dica
 *                  (a explicação mora no "?"). Muitas opções num espaço de uma linha.
 *   kind:'switch' → AJUSTE EM UMA LINHA: [título ........ ☐] [?]. Um item só (ligado/desligado).
 *                  As duas formas são o molde para os ajustes que vierem: descrever, não desenhar.
 *   sub:true      → (com kind) linha FILHA do ajuste de cima: recuada e presa a ele por um fio à
 *                  esquerda (o submenu do projeto principal). Quem decide se ela EXISTE é o dono,
 *                  ao montar as seções (ex.: "Notas na altura certa" só embaixo de "Melodia") —
 *                  o painel não esconde nada, só desenha.
 *   help:'topico' → "?" (HelpDot → modal pequeno da HelpRegistry) ao lado do título. Vale para
 *                  toda seção; nas de uma linha, substitui a `hint`.
 * onChange(enabledBySection, meta?) — após cada toggle válido ({sectionId: [ids…]}); meta = {adopted}
 * canToggle(sectionId, itemId, next, enabledBySection) — true | string (aviso,
 *           bloqueia o toggle; é aqui que o dono aplica regras como "pelo menos
 *           uma figura sonora marcada")
 * onReset() — botão "restaurar padrão"; se devolver sections novas, re-renderiza
 */
class RhythmConfigPanel {
    constructor(opts = {}) {
        this.title = opts.title || '';
        this.sections = opts.sections || [];
        this.onChange = opts.onChange || null;
        this.canToggle = opts.canToggle || null;
        this.onReset = opts.onReset || null;
        this.labels = opts.labels || {}; // { reset, close }

        this.overlay = null;
        this.drawer = null;
        this.bodyEl = null;
        this._warnEl = null;
        this._warnTimer = null;
        this._open = false;
        // Esc com o modal do "?" aberto por cima fecha SÓ o modal (o NotificationManager cuida
        // dele); a gaveta fica — senão quem lia a ajuda do ajuste perdia o painel junto.
        this._onKey = (e) => {
            if (e.key !== 'Escape') return;
            if (document.querySelector('[data-notification-modal]')) return;
            this.close();
        };
    }

    /** Seleção corrente: { sectionId: [itemIds marcados] } */
    getEnabled() {
        const out = {};
        this.sections.forEach(s => { out[s.id] = s.items.filter(i => i.checked).map(i => i.id); });
        return out;
    }

    /** Troca as seções (ex.: após reset) e re-renderiza se o painel existir. */
    setSections(sections) {
        this.sections = sections || [];
        if (this.bodyEl) this._renderBody();
    }

    open() {
        if (this._open) return;
        this._open = true;
        // Foco: quem abriu (o ⚙️) recebe o foco de volta no close(); ao abrir, o foco vai para
        // o ✕ — sem isso eram 18 Tabs pela página escurecida até entrar na gaveta (medido 27/set).
        this._opener = document.activeElement;
        if (!this.overlay) this._build();
        this._renderBody();
        document.body.appendChild(this.overlay);
        document.addEventListener('keydown', this._onKey);
        if (this._closeBtn) this._closeBtn.focus({ preventScroll: true });
        // 2 frames: garante a transição a partir do estado fechado recém-anexado
        // 🔴 Fechado ou DESTRUÍDO antes dos 2 quadros (sair da tela logo depois de abrir o ⚙️):
        // overlay já é null. Sob carga os quadros atrasam — foi assim que o gate o achou.
        requestAnimationFrame(() => requestAnimationFrame(() => {
            if (!this._open || !this.overlay) return;
            this.overlay.style.opacity = '1';
            this.drawer.style.transform = 'translateX(0)';
        }));
    }

    close() {
        if (!this._open || !this.overlay) return;
        this._open = false;
        document.removeEventListener('keydown', this._onKey);
        this.overlay.style.opacity = '0';
        this.drawer.style.transform = 'translateX(-100%)';
        setTimeout(() => { if (!this._open && this.overlay) this.overlay.remove(); }, 260);
        const back = this._opener;
        this._opener = null;
        if (back && back.focus && document.contains(back)) back.focus({ preventScroll: true });
    }

    destroy() {
        document.removeEventListener('keydown', this._onKey);
        clearTimeout(this._warnTimer);
        if (this.overlay) this.overlay.remove();
        this.overlay = this.drawer = this.bodyEl = this._warnEl = this._closeBtn = this._opener = null;
        this._open = false;
    }

    // ---------- construção ----------

    _build() {
        this.overlay = document.createElement('div');
        this.overlay.style.cssText = 'position:fixed;inset:0;z-index:1000;background:rgba(15,23,42,0.45);'
            + 'opacity:0;transition:opacity 0.25s;backdrop-filter:blur(2px);';
        this.overlay.addEventListener('click', (e) => { if (e.target === this.overlay) this.close(); });

        this.drawer = document.createElement('div');
        this.drawer.style.cssText = 'position:absolute;left:0;top:0;bottom:0;'
            + 'width:min(340px,88vw);background:#fff;box-shadow:6px 0 30px rgba(0,0,0,0.25);'
            + 'transform:translateX(-100%);transition:transform 0.25s ease;'
            + 'display:flex;flex-direction:column;';

        // header
        const header = document.createElement('div');
        header.style.cssText = 'display:flex;align-items:center;justify-content:space-between;'
            + 'padding:1rem 1.1rem;border-bottom:1px solid #eee;flex:0 0 auto;';
        const h = document.createElement('h2');
        h.textContent = this.title;
        h.style.cssText = 'margin:0;font-size:1.15rem;';
        const closeBtn = document.createElement('button');
        closeBtn.textContent = '✕';
        closeBtn.setAttribute('aria-label', this.labels.close || 'Close');
        closeBtn.style.cssText = 'background:none;border:none;font-size:1.2rem;color:#64748b;min-width:44px;min-height:44px;'
            + 'cursor:pointer;padding:0.3rem 0.5rem;';
        closeBtn.addEventListener('click', () => this.close());
        this._closeBtn = closeBtn;
        header.appendChild(h);
        header.appendChild(closeBtn);

        // corpo rolável (seções)
        this.bodyEl = document.createElement('div');
        this.bodyEl.style.cssText = 'flex:1 1 auto;overflow-y:auto;padding:0.8rem 1.1rem;'
            + '-webkit-overflow-scrolling:touch;';

        // aviso (regras violadas, ex.: desmarcar a última nota)
        this._warnEl = document.createElement('div');
        // role=status: "a semínima foi ligada" e as recusas do canToggle chegam ao leitor de tela
        this._warnEl.setAttribute('role', 'status');
        this._warnEl.setAttribute('aria-live', 'polite');
        this._warnEl.style.cssText = 'flex:0 0 auto;padding:0 1.1rem;color:#ef4444;'
            + 'font-size:0.85rem;min-height:1.4rem;transition:opacity 0.2s;opacity:0;';

        // rodapé (restaurar padrão)
        const footer = document.createElement('div');
        footer.style.cssText = 'flex:0 0 auto;padding:0.7rem 1.1rem 1rem;border-top:1px solid #eee;'
            + 'text-align:center;';
        const resetBtn = document.createElement('button');
        resetBtn.textContent = this.labels.reset || 'Reset';
        // min-height 44: piso de alvo do projeto (media 37 px — auditoria 27/set)
        resetBtn.style.cssText = 'background:#f1f5f9;border:1px solid #e2e8f0;border-radius:10px;'
            + 'padding:0.55rem 1.2rem;min-height:44px;color:#475569;font-size:0.9rem;cursor:pointer;';
        resetBtn.addEventListener('click', () => {
            if (!this.onReset) return;
            const fresh = this.onReset();
            if (fresh) this.setSections(fresh);
        });
        footer.appendChild(resetBtn);

        this.drawer.appendChild(header);
        this.drawer.appendChild(this.bodyEl);
        this.drawer.appendChild(this._warnEl);
        this.drawer.appendChild(footer);
        this.overlay.appendChild(this.drawer);
    }

    _renderBody() {
        // 🔴 Redesenhar destrói o input focado: quem navega por TECLADO (setas no grupo de
        // rádio) perdia o foco a cada troca e a 2ª seta não fazia nada. Devolve o foco ao
        // input com a mesma identidade (seção + item) depois de redesenhar.
        // 🔴 NUNCA a um <select>: `focus()` num select dentro do `change` (gesto da pessoa)
        // abre o picker do iPhone de novo — "escolhi a nota e o modal não fechou" (19/set).
        const ativo = document.activeElement;
        const foco = (ativo && ativo.tagName !== 'SELECT' && this.bodyEl.contains(ativo) && ativo.dataset && ativo.dataset.section)
            ? { s: ativo.dataset.section, i: ativo.dataset.item } : null;
        // o botão que abre/fecha uma seção `collapsible` também é recriado — devolve o foco a ele
        const toggle = (ativo && this.bodyEl.contains(ativo) && ativo.dataset && ativo.dataset.collapse) || null;
        this._fillBody();
        if (foco) {
            const alvo = [...this.bodyEl.querySelectorAll('input[data-section]')]
                .find(el => el.dataset.section === foco.s && el.dataset.item === foco.i);
            if (alvo) alvo.focus({ preventScroll: true });
        } else if (toggle) {
            const alvo = this.bodyEl.querySelector(`[data-collapse="${toggle}"]`);
            if (alvo) alvo.focus({ preventScroll: true });
        }
    }

    _fillBody() {
        this.bodyEl.innerHTML = '';
        let antes = null;
        this.sections.forEach(section => {
            if (section.kind === 'select' || section.kind === 'switch') {
                const row = this._buildSettingRow(section);
                // a 1ª linha de ajuste depois de seções de lista ganha um respiro com fio
                if (antes && antes !== 'row') row.style.cssText += 'margin-top:0.8rem;border-top:1px solid #eee;padding-top:0.6rem;';
                this.bodyEl.appendChild(row);
                antes = 'row';
                return;
            }
            if (section.inline && section.collapsible) {
                const row = this._buildCollapsibleRow(section);
                if (antes && antes !== 'row') row.style.cssText += 'margin-top:0.8rem;border-top:1px solid #eee;padding-top:0.6rem;';
                this.bodyEl.appendChild(row);
                if (section.open) this.bodyEl.appendChild(this._buildChipRow(section));
                antes = 'row';
                return;
            }
            antes = 'list';
            const st = document.createElement('h3');
            st.textContent = section.title;
            st.style.cssText = 'margin:0.8rem 0 0.2rem;font-size:0.8rem;letter-spacing:0.06em;'
                + 'text-transform:uppercase;color:#94a3b8;';
            if (section.help && window.HelpDot) {
                // "?" colado ao título: o h3 vira uma linha flex (o "?" tem alvo de 44 px)
                st.style.cssText += 'display:flex;align-items:center;justify-content:space-between;';
                st.appendChild(new window.HelpDot(section.help).el);
            }
            this.bodyEl.appendChild(st);

            if (section.hint) {
                const hint = document.createElement('p');
                hint.textContent = section.hint;
                hint.style.cssText = 'margin:0 0 0.4rem;font-size:0.82rem;color:#94a3b8;line-height:1.35;';
                this.bodyEl.appendChild(hint);
            }

            if (section.inline) {
                this.bodyEl.appendChild(this._buildChipRow(section));
                return;
            }
            section.items.forEach(item => this.bodyEl.appendChild(this._buildRow(section, item)));
        });
    }

    /** A fileira de chips de uma seção `inline` (rádio com `single`, checkbox sem). */
    _buildChipRow(section) {
        const wrap = document.createElement('div');
        wrap.dataset.chipRow = section.id;
        wrap.setAttribute('role', section.single ? 'radiogroup' : 'group');
        wrap.setAttribute('aria-label', section.title);
        wrap.style.cssText = 'display:flex;flex-wrap:wrap;gap:0.4rem;padding:0.25rem 0 0.35rem;';
        section.items.forEach(item => wrap.appendChild(this._buildChip(section, item)));
        return wrap;
    }

    /**
     * Linha FECHADA de uma seção `collapsible`: [título] [resumo do marcado…] [▾] [?].
     * O botão ocupa a linha inteira (alvo de 44 px); o resumo corta com reticências.
     */
    _buildCollapsibleRow(section) {
        const row = document.createElement('div');
        row.dataset.settingRow = section.id;
        row.style.cssText = 'display:flex;align-items:center;gap:0.5rem;min-height:44px;padding:0.15rem 0;';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.collapse = section.id;
        btn.setAttribute('aria-expanded', section.open ? 'true' : 'false');
        btn.style.cssText = 'flex:1 1 auto;min-width:0;display:flex;align-items:center;gap:0.5rem;min-height:44px;'
            + 'background:none;border:none;padding:0;text-align:left;cursor:pointer;color:#334155;font:inherit;';
        const name = document.createElement('span');
        name.textContent = section.title;
        name.style.cssText = 'flex:0 0 auto;font-size:0.95rem;font-weight:600;';
        const summary = document.createElement('span');
        summary.dataset.collapseSummary = section.id;
        summary.textContent = section.items.filter(i => i.checked).map(i => i.label).join(' · ');
        summary.style.cssText = 'flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'
            + 'font-size:0.9rem;color:#64748b;text-align:right;';
        const chevron = document.createElement('span');
        chevron.textContent = section.open ? '▴' : '▾';
        chevron.setAttribute('aria-hidden', 'true');
        chevron.style.cssText = 'flex:0 0 auto;color:#94a3b8;font-size:0.9rem;';
        btn.appendChild(name); btn.appendChild(summary); btn.appendChild(chevron);
        btn.addEventListener('click', () => { section.open = !section.open; this._renderBody(); });
        row.appendChild(btn);
        if (section.help && window.HelpDot) row.appendChild(new window.HelpDot(section.help).el);
        return row;
    }

    /**
     * Ajuste em UMA linha (`kind: 'select' | 'switch'`): nome à esquerda, controle à direita,
     * "?" no fim. O controle leva `data-section` (e o select, `data-item` do valor atual).
     */
    _buildSettingRow(section) {
        const row = document.createElement('div');
        row.dataset.settingRow = section.id;
        row.style.cssText = 'display:flex;align-items:center;gap:0.5rem;min-height:44px;padding:0.15rem 0;';
        const id = 'cfg-' + section.id + '-' + Math.random().toString(36).slice(2, 7);

        const name = document.createElement('label');
        name.htmlFor = id;
        name.textContent = section.title;
        // nowrap: a 320 px "Linha-guia" quebrava em duas linhas (medido 27/set); o select cede (flex 0 1)
        name.style.cssText = 'flex:1 1 auto;min-width:0;white-space:nowrap;font-size:0.95rem;font-weight:600;color:#334155;cursor:pointer;';
        if (section.sub) {
            // Filha: recuo + fio à esquerda; o alvo continua com 44 px de altura e o "?" no fim.
            row.dataset.settingSub = '1';
            row.style.cssText += 'margin-left:0.9rem;padding-left:0.7rem;border-left:2px solid #c7d2fe;';
            name.style.fontWeight = '500';
        }
        row.appendChild(name);

        const fire = () => { if (this.onChange) this.onChange(this.getEnabled()); };
        let ctl;
        if (section.kind === 'select') {
            ctl = document.createElement('select');
            // 16 px: abaixo disso o Safari do iPhone dá zoom na página ao tocar no select
            // 50%: com 55% o título "Tonalidade" (81 px) encostava no select a 375 px (auditoria 27/set)
            ctl.style.cssText = 'flex:0 1 auto;min-width:0;min-height:44px;max-width:50%;font-size:16px;padding:0 0.6rem;'
                + 'border:1.5px solid #e2e8f0;border-radius:10px;background:#fff;color:#1e293b;cursor:pointer;';
            section.items.forEach(item => {
                const o = document.createElement('option');
                o.value = item.id; o.textContent = item.label; o.selected = !!item.checked;
                if (item.disabled) o.disabled = true;
                ctl.appendChild(o);
            });
            const atual = section.items.find(i => i.checked);
            if (atual) ctl.dataset.item = atual.id;
            ctl.addEventListener('change', () => {
                const verdict = this.canToggle ? this.canToggle(section.id, ctl.value, true, this.getEnabled()) : true;
                if (verdict !== true) {
                    ctl.value = ctl.dataset.item || '';
                    this._warn(typeof verdict === 'string' ? verdict : '');
                    return;
                }
                section.items.forEach(it => { it.checked = (it.id === ctl.value); });
                ctl.dataset.item = ctl.value;
                fire();
            });
        } else {
            const item = section.items[0] || { id: 'on', checked: false };
            ctl = document.createElement('input');
            ctl.type = 'checkbox';
            ctl.checked = !!item.checked;
            ctl.dataset.item = item.id;
            ctl.style.cssText = 'width:22px;height:22px;margin:11px;accent-color:#6366f1;cursor:pointer;flex:0 0 auto;';
            ctl.addEventListener('change', () => { item.checked = ctl.checked; fire(); });
        }
        ctl.id = id;
        ctl.dataset.section = section.id;
        ctl.setAttribute('aria-label', section.title);
        row.appendChild(ctl);

        if (section.help && window.HelpDot) row.appendChild(new window.HelpDot(section.help).el);
        return row;
    }

    /** Linha de item: [checkbox] [glifo] [nome + duração]. A linha toda é o alvo de toque. */
    _buildRow(section, item) {
        const row = document.createElement('label');
        row.style.cssText = 'display:flex;align-items:center;gap:0.65rem;padding:0.4rem 0.45rem;'
            + 'min-height:44px;border-radius:10px;cursor:pointer;user-select:none;'
            + '-webkit-tap-highlight-color:transparent;';
        row.addEventListener('mouseenter', () => { row.style.background = '#f8fafc'; });
        row.addEventListener('mouseleave', () => { row.style.background = 'none'; });

        const cb = document.createElement('input');
        cb.type = section.single ? 'radio' : 'checkbox';
        if (section.single) cb.name = 'cfg-radio-' + section.id;
        cb.checked = !!item.checked;
        cb.style.cssText = 'width:19px;height:19px;accent-color:#6366f1;cursor:pointer;flex:0 0 auto;';
        cb.dataset.section = section.id;
        cb.dataset.item = item.id;
        if (item.auto) cb.dataset.auto = '1';
        if (item.disabled) {
            cb.disabled = true;
            row.style.opacity = '0.45';
            row.style.cursor = 'default';
            row.setAttribute('aria-disabled', 'true');
        }
        cb.addEventListener('change', () => {
            if (section.single) {
                // rádio: marca este, desmarca os demais da seção (sem canToggle).
                section.items.forEach(it => { it.checked = (it === item); });
                this._renderBody();
                if (this.onChange) this.onChange(this.getEnabled());
                return;
            }
            if (item.auto) {
                // adotar: o toque confirma a figura que o dono ligou, nunca a desmarca
                cb.checked = true;
                item.checked = true;
                item.auto = false;
                delete cb.dataset.auto;
                if (this.onChange) this.onChange(this.getEnabled(), { adopted: item.id });
                return;
            }
            const next = cb.checked;
            const verdict = this.canToggle ? this.canToggle(section.id, item.id, next, this.getEnabled()) : true;
            if (verdict !== true) {
                cb.checked = !next; // reverte
                this._warn(typeof verdict === 'string' ? verdict : '');
                return;
            }
            item.checked = next;
            if (this.onChange) this.onChange(this.getEnabled());
        });

        // ícone: SVG fornecido pelo dono (desenhado pelas primitivas reais da
        // partitura — não depende de fonte musical); fallback = glifo de texto
        const glyph = document.createElement('span');
        glyph.style.cssText = 'width:2.1rem;display:flex;justify-content:center;align-items:center;'
            + 'flex:0 0 auto;color:#1e293b;';
        if (item.icon) {
            glyph.appendChild(item.icon);
        } else {
            glyph.textContent = item.glyph || '';
            glyph.style.fontSize = '1.5rem';
        }

        const txt = document.createElement('span');
        txt.style.cssText = 'display:flex;flex-direction:column;line-height:1.25;';
        const name = document.createElement('span');
        name.textContent = item.label;
        name.style.cssText = 'font-size:0.95rem;font-weight:600;color:#334155;';
        txt.appendChild(name);
        if (item.sublabel) {
            const sub = document.createElement('span');
            sub.textContent = item.sublabel;
            sub.style.cssText = 'font-size:0.78rem;color:#94a3b8;';
            txt.appendChild(sub);
        }

        row.appendChild(cb);
        row.appendChild(glyph);
        row.appendChild(txt);
        return row;
    }

    /** Opção em forma de botão (seção `inline`): rádio com `single`, checkbox sem. O input
     *  nativo continua lá (teclado, leitor de tela, `change`), só invisível. */
    _buildChip(section, item) {
        const chip = document.createElement('label');
        const on = !!item.checked;
        chip.style.cssText = 'position:relative;display:inline-flex;align-items:center;justify-content:center;'
            + 'min-height:44px;min-width:44px;box-sizing:border-box;padding:0 0.85rem;border-radius:10px;cursor:pointer;user-select:none;'
            + 'font-size:0.9rem;font-weight:600;-webkit-tap-highlight-color:transparent;'
            + (on ? 'background:#eef2ff;border:1.5px solid #6366f1;color:#3730a3;'
                  : 'background:#fff;border:1.5px solid #e2e8f0;color:#475569;');
        const cb = document.createElement('input');
        cb.type = section.single ? 'radio' : 'checkbox';
        if (section.single) cb.name = 'cfg-radio-' + section.id;
        cb.checked = on;
        cb.dataset.section = section.id;
        cb.dataset.item = item.id;
        if (item.disabled) {
            cb.disabled = true;
            chip.style.opacity = '0.45';
            chip.style.cursor = 'default';
            chip.setAttribute('aria-disabled', 'true');
        }
        cb.style.cssText = 'position:absolute;opacity:0;width:1px;height:1px;margin:0;pointer-events:none;';
        // anel só no foco de TECLADO (:focus-visible): no toque ele ficava preso no chip
        cb.addEventListener('focus', () => {
            let kb = true;
            try { kb = cb.matches(':focus-visible'); } catch (e) { /* sem suporte: mantém o anel */ }
            if (kb) chip.style.boxShadow = '0 0 0 3px rgba(99,102,241,0.35)';
        });
        cb.addEventListener('blur', () => { chip.style.boxShadow = 'none'; });
        cb.addEventListener('change', () => {
            if (section.single) {
                section.items.forEach(it => { it.checked = (it === item); });
                this._renderBody();
                if (this.onChange) this.onChange(this.getEnabled());
                return;
            }
            // multi: mesma regra da lista — o dono pode recusar ("pelo menos uma marcada")
            const next = cb.checked;
            const verdict = this.canToggle ? this.canToggle(section.id, item.id, next, this.getEnabled()) : true;
            if (verdict !== true) {
                cb.checked = !next;
                this._warn(typeof verdict === 'string' ? verdict : '');
                return;
            }
            item.checked = next;
            this._renderBody();
            if (this.onChange) this.onChange(this.getEnabled());
        });
        const txt = document.createElement('span');
        txt.textContent = item.label;
        chip.appendChild(cb);
        chip.appendChild(txt);
        return chip;
    }

    /** Aviso no rodapé (o dono usa quando a MUDANÇA dele alterou outra seção). */
    warn(msg) { this._warn(msg); }

    _warn(msg) {
        if (!this._warnEl) return;
        this._warnEl.textContent = msg;
        this._warnEl.style.opacity = '1';
        clearTimeout(this._warnTimer);
        this._warnTimer = setTimeout(() => { if (this._warnEl) this._warnEl.style.opacity = '0'; }, 2600);
    }
}

// Disponibiliza globalmente
window.RhythmConfigPanel = RhythmConfigPanel;



// ============================================
// components/rhythm/RhythmLevelMap.js
// ============================================
/**
 * RhythmLevelMap - Mapa de níveis do jogo de ritmo (overlay de seleção)
 *
 * Grade de níveis agrupados por MUNDO, com cadeado nos bloqueados, ✓ nos concluídos
 * e destaque no corrente. Lê o estado de RHYTHM_LEVELS (progresso) e devolve a
 * escolha via callback — NÃO contém regra de progressão (isso é do LevelConfig).
 *
 * EXCLUSIVO do jogo RANQUEADO (#/ritmo). O modo (trilha × sandbox) virou ROTA —
 * não há mais seletor de modo aqui (o sandbox é #/ritmo-livre, link no menu).
 *
 * opts:
 *   title                       — título do cabeçalho
 *   labels: { locked, close }
 *   worldName(world)            — nome do mundo (i18n) → string
 *   worldHint(world)            — descrição curta do mundo → string (opcional)
 *   levelName(level)            — rótulo do nível (ex.: "Nível 3") → string
 *   onSelect(id)                — clicou num nível liberado
 */
class RhythmLevelMap {
    constructor(opts = {}) {
        this.title = opts.title || '';
        this.labels = opts.labels || {};
        this.worldName = opts.worldName || ((w) => 'Mundo ' + w);
        this.worldHint = opts.worldHint || (() => '');
        this.levelName = opts.levelName || ((l) => 'Nível ' + l.id);
        this.onSelect = opts.onSelect || null;

        this.overlay = null;
        this.drawer = null;
        this.bodyEl = null;
        this._open = false;
        this._onKey = (e) => { if (e.key === 'Escape') this.close(); };
    }

    open() {
        if (this._open) return;
        this._open = true;
        if (!this.overlay) this._build();
        this._renderBody();
        document.body.appendChild(this.overlay);
        document.addEventListener('keydown', this._onKey);
        requestAnimationFrame(() => requestAnimationFrame(() => {
            this.overlay.style.opacity = '1';
            this.drawer.style.transform = 'translateX(0)';
        }));
    }

    close() {
        if (!this._open || !this.overlay) return;
        this._open = false;
        document.removeEventListener('keydown', this._onKey);
        this.overlay.style.opacity = '0';
        this.drawer.style.transform = 'translateX(-100%)';
        setTimeout(() => { if (!this._open && this.overlay) this.overlay.remove(); }, 260);
    }

    destroy() {
        document.removeEventListener('keydown', this._onKey);
        if (this.overlay) this.overlay.remove();
        this.overlay = this.drawer = this.bodyEl = null;
        this._open = false;
    }

    // ---------- construção ----------

    _build() {
        this.overlay = document.createElement('div');
        this.overlay.style.cssText = 'position:fixed;inset:0;z-index:1000;background:rgba(15,23,42,0.45);'
            + 'opacity:0;transition:opacity 0.25s;backdrop-filter:blur(2px);';
        this.overlay.addEventListener('click', (e) => { if (e.target === this.overlay) this.close(); });

        this.drawer = document.createElement('div');
        this.drawer.style.cssText = 'position:absolute;left:0;top:0;bottom:0;'
            + 'width:min(380px,92vw);background:#fff;box-shadow:6px 0 30px rgba(0,0,0,0.25);'
            + 'transform:translateX(-100%);transition:transform 0.25s ease;'
            + 'display:flex;flex-direction:column;';

        const header = document.createElement('div');
        header.style.cssText = 'display:flex;align-items:center;justify-content:space-between;'
            + 'padding:1rem 1.1rem;border-bottom:1px solid #eee;flex:0 0 auto;';
        const h = document.createElement('h2');
        h.textContent = this.title;
        h.style.cssText = 'margin:0;font-size:1.15rem;';
        const closeBtn = document.createElement('button');
        closeBtn.textContent = '✕';
        closeBtn.setAttribute('aria-label', this.labels.close || 'Close');
        closeBtn.style.cssText = 'background:none;border:none;font-size:1.2rem;color:#64748b;'
            + 'cursor:pointer;padding:0.3rem 0.5rem;';
        closeBtn.addEventListener('click', () => this.close());
        header.appendChild(h);
        header.appendChild(closeBtn);

        this.bodyEl = document.createElement('div');
        this.bodyEl.style.cssText = 'flex:1 1 auto;overflow-y:auto;padding:0.8rem 1.1rem 1.2rem;'
            + '-webkit-overflow-scrolling:touch;';

        this.drawer.appendChild(header);
        this.drawer.appendChild(this.bodyEl);
        this.overlay.appendChild(this.drawer);
    }

    _renderBody() {
        const L = window.RhythmLevels;
        this.bodyEl.innerHTML = '';

        L.worlds().forEach(world => {
            const wt = document.createElement('h3');
            wt.textContent = this.worldName(world);
            wt.style.cssText = 'margin:1rem 0 0.1rem;font-size:0.8rem;letter-spacing:0.06em;'
                + 'text-transform:uppercase;color:#94a3b8;';
            this.bodyEl.appendChild(wt);

            const hint = this.worldHint(world);
            if (hint) {
                const hp = document.createElement('p');
                hp.textContent = hint;
                hp.style.cssText = 'margin:0 0 0.5rem;font-size:0.82rem;color:#94a3b8;line-height:1.35;';
                this.bodyEl.appendChild(hp);
            }

            const grid = document.createElement('div');
            grid.style.cssText = 'display:grid;grid-template-columns:repeat(5,1fr);gap:0.5rem;margin-bottom:0.3rem;';
            L.CATALOG.filter(l => l.world === world).forEach(level => {
                grid.appendChild(this._buildLevelButton(level));
            });
            this.bodyEl.appendChild(grid);
        });
    }

    _buildLevelButton(level) {
        const L = window.RhythmLevels;
        const unlocked = L.isUnlocked(level.id);
        const cleared = L.isCleared(level.id);
        const isCurrent = L.getCurrent() === level.id;

        const b = document.createElement('button');
        b.style.cssText = 'aspect-ratio:1;border-radius:12px;font-size:1.05rem;font-weight:700;'
            + 'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:0.1rem;'
            + 'border:2px solid transparent;transition:all 0.15s;';

        if (!unlocked) {
            b.disabled = true;
            b.style.cssText += 'background:#f1f5f9;color:#cbd5e1;cursor:not-allowed;';
            b.innerHTML = '<span style="font-size:1.1rem;">🔒</span>';
            b.setAttribute('aria-label', `${this.levelName(level)} — ${this.labels.locked || 'locked'}`);
            return b;
        }

        b.style.cursor = 'pointer';
        if (isCurrent) {
            b.style.cssText += 'background:#6366f1;color:#fff;border-color:#4f46e5;';
        } else if (cleared) {
            b.style.cssText += 'background:#ecfdf5;color:#059669;border-color:#a7f3d0;';
        } else {
            b.style.cssText += 'background:#eef2ff;color:#4f46e5;';
        }

        const num = document.createElement('span');
        num.textContent = level.id;
        b.appendChild(num);
        if (cleared && !isCurrent) {
            const chk = document.createElement('span');
            chk.textContent = '✓';
            chk.style.cssText = 'font-size:0.75rem;line-height:1;';
            b.appendChild(chk);
        }

        b.setAttribute('aria-label', this.levelName(level) + (cleared ? ' ✓' : ''));
        b.addEventListener('click', () => {
            if (this.onSelect) this.onSelect(level.id);
            this.close();
        });
        return b;
    }
}

// Disponibiliza globalmente
window.RhythmLevelMap = RhythmLevelMap;



// ============================================
// components/staff/KeySignatureRenderer.js
// ============================================
/**
 * KeySignatureRenderer — desenha UMA pauta estática com clave e ARMADURA. Só isso.
 *
 * É a pauta do jogo de Escalas (6º jogo, docs/ESCALAS-PLANO.md §3): mostra a armadura da
 * tonalidade-MÃE da escala e a tônica como semibreve. Nasceu no quiz "Tonalidades"
 * (docs/TONALIDADES-PLANO.md §5-B, histórico) e mantém o nome porque descreve o que faz.
 * A pauta não rola, não tem fórmula de compasso, não tem ritmo e não tem música: o
 * conteúdo da imagem é a armadura, e mais nada.
 *
 * COMPÕE, não duplica (o molde é o StaffReadingRenderer):
 *   - MusicStaff    → o eixo de altura (`getY(position)`) e o SVG `width:100%`;
 *   - RhythmRenderer → as primitivas de gravura já provadas (linhas da pauta, cabeça de
 *     semibreve, `clear()`). Nenhum `<line>` de pentagrama nasce aqui.
 *
 * O que esta classe NÃO faz:
 *   - não sorteia nada (isso é o `ScaleGenerator`), não sabe o que é resposta certa;
 *   - não desenha notas de melodia, hastes, pausas, barras nem fórmula de compasso;
 *   - não toca áudio, não lê i18n, não escreve texto de enunciado;
 *   - não guarda estado de jogo — `render()` é idempotente e recomeça do zero.
 *
 * 🔴 A REGRA DE POSIÇÃO DA ARMADURA É COPIADA, NÃO REINVENTADA.
 * Cada sustenido/bemol tem um lugar convencional na pauta (o 4º sustenido, Ré, sobe; o
 * Lá desce uma oitava; na clave de fá tudo desce 2 posições). Isso é convenção de gravura:
 * erra fácil, e o erro é visível para qualquer músico. A regra já está provada em
 * `ScoreRenderer._drawKeySignature` — o mapa `trebleOct`, `Notation.SHARP_ORDER/FLAT_ORDER`,
 * `Notation.CLEF_ANCHOR` e o avanço pela largura REAL do glifo (`getBBox`, nunca um passo
 * fixo) — e foi copiada daqui literalmente, linha por linha.
 *
 * 🔴 O QUE **NÃO** FOI COPIADO, E POR QUÊ (as duas divergências são MEDIDAS, não gosto):
 *   1. o TAMANHO do sinal — ver `ACC_SPACES`;
 *   2. o DESLOCAMENTO VERTICAL do glifo — ver `LEGACY_DY_SPACES` e `_accDy`.
 * As duas viraram constante nomeada: reverter para o desenho do `ScoreRenderer` é trocar
 * dois números. A posição na pauta (que linha, que espaço) é IDÊNTICA nos dois arquivos —
 * é ela que não pode divergir.
 *
 * 🔴 POR QUE EXISTEM DUAS CÓPIAS. Lá o desenho vive dentro de um `Score` rolante: camada
 * fixa + recorte, fórmula de compasso depois da armadura, e um orçamento de prefixo em
 * FRAÇÃO da tela (30%) porque a música precisa caber ao lado. Aqui a pauta é estática e a
 * armadura é o conteúdo — o orçamento é a pauta INTEIRA, não há fórmula, não há recorte e
 * não há `Score` (o jogo tem um número, `sharps`, não uma partitura). Fundir as duas
 * exigiria que o `ScoreRenderer` aceitasse host, escala e ausência de peça — e ele está em
 * produção nos jogos que leem partitura. O que não pode divergir é a REGRA: mexeu numa
 * posição, mexe nas duas, e a suíte do jogo deve comparar posição a posição.
 *
 * 🔴 `sharps === 0` NÃO é caso de erro: Dó maior (e Lá menor) é resposta legítima e precisa
 * de desenho — pauta + clave e mais nada. Devolver cedo sem desenhar a pauta deixaria a
 * pergunta "Dó maior?" sem imagem nenhuma.
 *
 * 🔴 A armadura CABE ou ENCOLHE, nunca sobrepõe. Sete sinais num visor de 320px não podem
 * encostar na clave nem vazar da pauta. Cada peça é DESENHADA, MEDIDA com `getBBox()` e a
 * seguinte começa depois dela (por isso nunca encosta na clave, em largura nenhuma); se
 * mesmo assim o conjunto passar da borda direita, a segunda passada reduz a escala de
 * clave + sinais e redesenha. É o mesmo remédio do `ScoreRenderer.renderFixed`.
 *
 * 🔴 DOIS JEITOS DE USAR, e o segundo é o que está em produção (treino livre da Leitura):
 *   - `render(sharps, {clef})` — a pauta INTEIRA é desta classe (o quiz de armaduras);
 *   - `drawSignature(x0, sharps, clef)` — SÓ os sinais, numa pauta que o DONO já desenhou
 *     (linhas + clave + nota do `StaffReadingRenderer`). Não apaga o SVG, só os sinais da
 *     chamada anterior. A regra de posição é a MESMA função (`_drawAccidentals`) — é o que
 *     evita uma terceira cópia da convenção de gravura.
 *   Quem compõe passa `onRepaint` no construtor: quando a Bravura chega, em vez de `render()`
 *   (que esvazia o SVG e apagaria a nota) o dono redesenha a cena completa.
 *
 * 🔴 A BRAVURA É LAZY. No primeiro quadro a fonte pode não ter chegado, e aí `getBBox()`
 * mede o glifo da fonte de FALLBACK — a armadura sai com o espaçamento errado (ou o
 * primeiro sinal encostado na clave) e fica assim para sempre, porque nada redesenha.
 * O construtor assina `document.fonts.ready` e repinta a última pergunta quando a fonte
 * chega. Mesmo comportamento (e mesma pilha de fallback) do `ScoreRenderer`.
 */
class KeySignatureRenderer {
    static NS = 'http://www.w3.org/2000/svg';

    /** Glifos. Os mesmos caracteres do ScoreRenderer — a Bravura os cobre; o fallback também. */
    static GLYPH = { sharp: '♯', flat: '♭' };

    /** 🔴 Pilha de fontes idêntica à do ScoreRenderer/RhythmRenderer: o aluno vê UM app só. */
    static FONT = 'Bravura, Times New Roman, Georgia, serif';

    /** Piso do encolhimento. Abaixo disto a clave deixa de ser reconhecível — e uma clave
     *  ilegível transforma a pergunta "que tom é este?" em adivinhação. */
    static MIN_SCALE = 0.55;

    /** Máximo de acidentes que uma armadura pode ter (o círculo de quintas acaba em 7). */
    static MAX_ACC = 7;

    /**
     * OITAVA de referência de cada sinal na clave de sol (o 4º sustenido, Ré, sobe; o Lá
     * desce). Na clave de fá tudo desce 2 posições. É a tabela do `ScoreRenderer`,
     * ESTÁTICA para o teste IMPORTAR em vez de copiar (regra da casa: espelho de tabela
     * diverge em silêncio). Mexeu aqui, mexe no `ScoreRenderer._drawKeySignature`.
     */
    static TREBLE_OCTAVE = {
        sharp: { F: 5, C: 5, G: 5, D: 5, A: 4, E: 5, B: 4 },
        flat:  { B: 4, E: 5, A: 4, D: 5, G: 4, C: 5, F: 4 }
    };

    /**
     * Tamanho do sinal, em ESPAÇOS DE PAUTA (font-size = ACC_SPACES · lineSpacing).
     *
     * 🔴 4,0 é a proporção da própria fonte, não um chute: numa fonte SMuFL o em vale UM
     * pentagrama (4 espaços), então `font-size = 4·lineSpacing` faz 1 espaço da fonte valer
     * 1 espaço da pauta e o sinal sai do tamanho de livro. MEDIDO na Bravura: a 24px o ♯
     * tem 16,75px de tinta — 2,79 espaços da fonte, que é a altura canônica; com a pauta a
     * 10px de espaço, esses mesmos 16,75px viram 1,7 espaço, ou seja **60% do tamanho certo**.
     *
     * 🔴 DIVERGE do `ScoreRenderer` de propósito (lá é `s·2,4`), e o motivo é o contexto:
     * numa partitura rolante o sinal é um adereço da nota e encolhê-lo compra espaço para a
     * MÚSICA; aqui a armadura é o ENUNCIADO INTEIRO — é ela que a pessoa tem de contar e
     * reconhecer num celular. Constante única: voltar ao tamanho do score é trocar este 4,0
     * por 2,4, e nada mais.
     */
    static ACC_SPACES = 4.0;

    /** Folga horizontal entre sinais (em espaços de pauta), somada à largura REAL do glifo. */
    static ACC_GAP = 0.25;

    /** Folga entre a clave e o primeiro sinal (em espaços de pauta). */
    static CLEF_GAP = 0.6;

    /**
     * Deslocamento vertical LEGADO, usado só enquanto a Bravura não chegou.
     *
     * 🔴 Este `+0,35` é o número do `ScoreRenderer`, e MEDIR mostrou o que ele é: um acerto
     * para a fonte de FALLBACK, não para a Bravura. Na Bravura o ♯ tem tinta simétrica em
     * torno da linha de base (medido: centro a −0,02px de 24) — a origem do glifo JÁ é a
     * posição na pauta, então o certo é `dy = 0`; somar 0,35 espaço joga os sete sinais um
     * terço de espaço para BAIXO, e um sinal que devia estar NA LINHA passa a parecer que
     * está no espaço — que é exatamente a informação que o jogo pede para ler. No Times New
     * Roman o ♯ é assimétrico (tinta de −17,2 a +2,5 a 24px) e aí o 0,35 aproxima. Por isso
     * o offset é escolhido pela fonte que de fato renderizou, e não fixo.
     */
    static LEGACY_DY_SPACES = 0.35;

    /**
     * @param {MusicStaff} musicStaff - pauta já montada num container (o SVG é dela)
     * @param {Object} [options]
     * @param {number} [options.padLeft=4] - respiro entre a margem da pauta e a clave
     */
    constructor(musicStaff, options = {}) {
        this.staff = musicStaff;
        /** Primitivas de gravura — reuso, não duplicação. */
        this.rr = new window.RhythmRenderer(musicStaff);

        /** 🔴 Nós SVG criados por ESTA classe. Sem esta lista, cada pergunta empilharia um
         *  jogo de glifos sobre o anterior; o defeito só aparece depois de ~10 rodadas
         *  (armadura "borrada" e memória crescendo), que é tarde demais para achar. */
        this.elements = [];

        /** Última pergunta desenhada — o repintar da fonte precisa dela. */
        this._last = null;
        /** Escala aplicada no último desenho (1 = coube inteiro; < 1 = encolheu). */
        this.scale = 1;
        /** X logo depois do último sinal da armadura (útil a quem quiser pôr algo à direita). */
        this.signatureEndX = null;

        this.LAYOUT = {
            padLeft: options.padLeft != null ? options.padLeft : 4
        };

        /** Quem COMPÕE (ver o cabeçalho): redesenha a cena inteira quando a fonte chega. */
        this.onRepaint = typeof options.onRepaint === 'function' ? options.onRepaint : null;
        /** Já houve um `drawSignature`? (o repinte da fonte só faz sentido depois de desenhar) */
        this._sigDrawn = false;

        // Bravura lazy: ver o 🔴 do cabeçalho.
        if (typeof document !== 'undefined' && document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => {
                if (!this._last && !this._sigDrawn) return;
                this._repaint();
            }).catch(() => { /* navegador sem Font Loading API: fica o desenho do fallback */ });
        }
    }

    /**
     * Repinte pela chegada da fonte. Dono que compõe redesenha a cena dele; senão a
     * última pergunta do `render()`.
     * @private
     */
    _repaint() {
        if (this.onRepaint) { this.onRepaint(); return; }
        if (this._last) this.render(this._last.sharps, this._last.options);
    }

    // ================= API pública =================

    /**
     * Desenha pauta + clave + armadura (+ tônica opcional). Idempotente: limpa antes.
     *
     * @param {number} sharps - −7..7. Positivo = sustenidos, negativo = bemóis,
     *        0 = pauta e clave apenas (Dó maior / Lá menor).
     * @param {Object} [options]
     * @param {string} [options.clef='treble'] - 'treble' | 'bass'
     * @param {number|null} [options.tonicPos=null] - posição da tônica no eixo do MusicStaff
     *        (0 = 1ª linha / Mi4 na clave de sol). Desenhada como semibreve SEM HASTE depois
     *        da armadura — cabeça sem haste porque ela não tem duração: é o nome do tom, não
     *        uma nota para tocar.
     * @returns {KeySignatureRenderer} this (encadeável)
     */
    render(sharps, options = {}) {
        const n = Number.isFinite(sharps) ? Math.trunc(sharps) : 0;
        const clamped = Math.max(-KeySignatureRenderer.MAX_ACC,
                                 Math.min(KeySignatureRenderer.MAX_ACC, n));
        this._draw(clamped, options, null);
        this._armarRepinte();
        // 🔴 DEPOIS do desenho, nunca antes: `_draw` começa por `clear()`, e o `clear()`
        // apaga a memória do repintar (ver lá). Marcado antes, o repintar da fonte acharia
        // `null` e a armadura ficaria para sempre com a métrica do fallback.
        this._last = { sharps: clamped, options };
        return this;
    }

    /**
     * SÓ a armadura, a partir de `x0`, numa pauta que o dono já desenhou (linhas + clave).
     * Composição, não cópia: a mesma `_drawAccidentals` do `render()`, logo a MESMA regra
     * de posição. Não toca no resto do SVG — apaga só os sinais da chamada anterior.
     *
     * @param {number} x0 - onde o 1º sinal começa (o dono mede a clave dele)
     * @param {number} sharps - −7..7; 0 desenha nada e devolve `x0`
     * @param {'treble'|'bass'} [clef='treble']
     * @param {number} [scale=1] - escala dos sinais (1 = tamanho de livro, `ACC_SPACES`)
     * @returns {number} X logo depois do último sinal (= x0 quando não há armadura)
     */
    drawSignature(x0, sharps, clef = 'treble', scale = 1) {
        this.clearSignature();
        const n = Number.isFinite(sharps) ? Math.trunc(sharps) : 0;
        const clamped = Math.max(-KeySignatureRenderer.MAX_ACC,
                                 Math.min(KeySignatureRenderer.MAX_ACC, n));
        const s = this.staff.config.lineSpacing || this.rr.STAFF.lineSpacing;
        const x = this._drawAccidentals(x0, clamped, clef === 'bass' ? 'bass' : 'treble', s, scale);
        this.signatureEndX = x;
        this._sigDrawn = true;
        this._armarRepinte();
        return x;
    }

    /** Apaga SÓ os sinais desta classe (o SVG do dono fica). Par do `drawSignature`. */
    clearSignature() {
        this.elements.forEach(el => { if (el && el.parentNode) el.parentNode.removeChild(el); });
        this.elements = [];
        this.signatureEndX = null;
        return this;
    }

    /**
     * Apaga o desenho. 🔴 Zera TAMBÉM a lista de elementos: um array que só cresce é
     * vazamento igual ao do DOM, e nós já removidos ficariam retidos por ele.
     *
     * 🔴 E esquece a última pergunta: sem isso, a chegada da Bravura repinta uma armadura
     * numa tela que o jogo já limpou (a fonte chega quando quer — inclusive depois de a
     * pessoa ter respondido e a tela ter virado outra).
     * @returns {KeySignatureRenderer} this (encadeável)
     */
    clear() {
        // Remoção explícita ANTES do clear do renderer: se um dia o RhythmRenderer parar de
        // esvaziar o SVG inteiro, esta classe continua sem vazar um nó sequer.
        this.elements.forEach(el => { if (el && el.parentNode) el.parentNode.removeChild(el); });
        this.elements = [];
        this.rr.clear();          // esvazia o SVG (staff.clear()) e a lista do RhythmRenderer
        this.signatureEndX = null;
        this._last = null;
        return this;
    }

    // ================= desenho =================

    /**
     * Uma passada de desenho.
     * @param {number} sharps
     * @param {Object} options
     * @param {number|null} k - escala de clave+sinais. `null` = 1ª passada (mede e, se não
     *        couber, chama a si mesma UMA vez com a escala calculada).
     * @private
     */
    _draw(sharps, options, k) {
        this.clear();

        const clef = options.clef === 'bass' ? 'bass' : 'treble';
        const tonicPos = options.tonicPos != null ? options.tonicPos : null;
        const area = this.staff.getDrawArea();
        // 🔴 O tamanho dos glifos deriva do PENTAGRAMA (lineSpacing), nunca da largura da
        // tela: clave e acidente são proporção de pauta. Amarrá-los ao orçamento horizontal
        // faria a mesma armadura ter tamanhos diferentes conforme o visor.
        const s = this.staff.config.lineSpacing || this.rr.STAFF.lineSpacing;
        const escala = k == null ? 1 : k;

        // 1. Pauta — primitiva do RhythmRenderer (caminho legado de UMA pauta, o mesmo que
        //    o StaffReadingRenderer usa; ele soma +5 internamente, daí o −5 aqui).
        this.rr.drawStaffLines(area.endX - 5);

        // 2. Clave. Fatores copiados do ScoreRenderer (que por sua vez os tirou do
        //    RhythmRenderer) para a clave sair IDÊNTICA à dos outros jogos.
        //    Sol: a espiral abraça a 2ª linha. Fá: os dois pontos cercam a 4ª linha.
        const isBass = clef === 'bass';
        const clefEl = this._text({
            x: area.startX + this.LAYOUT.padLeft,
            y: (isBass ? this.staff.getY(6) : this.staff.getY(4)) + s * (isBass ? 0.15 : 1.2),
            'font-size': s * (isBass ? 5.6 : 7.2) * escala
        }, isBass ? '𝄢' : '𝄞');

        // 3. Armadura, começando DEPOIS da clave MEDIDA — nunca numa fração da tela.
        const x0 = this._rightEdge(clefEl, area.startX + s * 4 * escala)
                 + s * KeySignatureRenderer.CLEF_GAP;
        let x = this._drawAccidentals(x0, sharps, clef, s, escala);
        this.signatureEndX = x;

        // 4. Tônica (opcional).
        let direita = x;
        if (tonicPos != null) {
            direita = this._drawTonic(x + s * 1.6, tonicPos);
        }

        // 5. Coube? 🔴 Two-pass porque só dá para saber depois de MEDIR — a largura de um
        //    glifo depende da fonte que de fato carregou. Se estourou a borda direita da
        //    pauta, encolhe clave + sinais e redesenha UMA vez. Nunca deixa sobrepor.
        //    MEDIDO (7 sinais, lineSpacing 10): com a Bravura cabe inteiro em escala 1 até
        //    uma pauta de ~190px e, encolhendo, até ~105px; com o FALLBACK (o ♭ do Times é
        //    2× mais largo) a segunda passada é que salva os 6 e 7 bemóis num visor de
        //    320px (k 0,95 e 0,83). Abaixo de ~105px o piso de legibilidade vence e a
        //    armadura passa da margem — não há layout do app nessa faixa (320px de visor
        //    dão ~298px de pauta), e truncar sinal seria mentir sobre a resposta.
        const teto = area.endX - s * 0.4;
        if (k == null && direita > teto) {
            const preciso = direita - area.startX;
            const disponivel = teto - area.startX;
            if (preciso > 0 && disponivel > 0) {
                const novo = Math.max(KeySignatureRenderer.MIN_SCALE, disponivel / preciso);
                if (novo < 1) return this._draw(sharps, options, novo);
            }
        }
        this.scale = escala;
    }

    /**
     * Os N sinais, em ordem e nas posições convencionais.
     *
     * 🔴 CÓPIA LITERAL da regra de `ScoreRenderer._drawKeySignature` (ver o cabeçalho).
     * O mapa diz a OITAVA de referência de cada letra na clave de sol; na clave de fá tudo
     * desce uma terça (2 posições), que é a mesma regra dos editores de partitura.
     *
     * @returns {number} X logo depois do último sinal (igual a x0 quando não há armadura)
     * @private
     */
    _drawAccidentals(x0, sharps, clef, s, k) {
        if (!sharps) return x0;   // 🔴 Dó maior desenha pauta + clave e para aqui.

        const N = window.Notation;
        const order = sharps > 0 ? N.SHARP_ORDER : N.FLAT_ORDER;
        const n = Math.min(KeySignatureRenderer.MAX_ACC, Math.abs(sharps));
        const trebleOct = KeySignatureRenderer.TREBLE_OCTAVE[sharps > 0 ? 'sharp' : 'flat'];
        const fonte = s * KeySignatureRenderer.ACC_SPACES * k;
        const step = s * 0.62 * k;
        const gap = s * KeySignatureRenderer.ACC_GAP * k;
        const dy = this._accDy(s * k, fonte);
        const glifo = sharps > 0
            ? KeySignatureRenderer.GLYPH.sharp : KeySignatureRenderer.GLYPH.flat;

        let x = x0;
        for (let i = 0; i < n; i++) {
            const L = order[i];
            let pos = N.diatonicStep(L, trebleOct[L]) - N.CLEF_ANCHOR.treble;
            if (clef === 'bass') pos -= 2;
            const el = this._text({ x, y: this.staff.getY(pos) + dy, 'font-size': fonte }, glifo);
            // 🔴 Avança pela largura REAL do sinal — o ♭ é bem mais estreito que o ♯, e um
            // passo fixo deixaria a armadura de bemóis rala e a de sustenidos apertada.
            x = Math.max(x + step, this._rightEdge(el, x + step) + gap);
        }
        return x;
    }

    /**
     * Cabeça de semibreve (sem haste) na posição da tônica, com as linhas suplementares
     * que ela exigir. Primitivas do RhythmRenderer + a meia-largura ÚNICA do MusicStaff
     * (a mesma que os dois jogos de leitura usam) — senão o tracinho some embaixo da cabeça.
     * @returns {number} borda direita da cabeça
     * @private
     */
    _drawTonic(cx, position) {
        const nh = this.rr.NOTEHEAD;
        const half = window.MusicStaff.ledgerHalfWidth(
            this.staff.config.lineSpacing, nh.rx * 1.35, nh.ry, 0);
        // 🔴 `drawLedgerLine` (do MusicStaff) escreve no SVG sem registrar o nó em lista
        // nenhuma — quem chama é que tem de recolher, senão a linha suplementar escapa do
        // `clear()` explícito. Ela é sempre anexada no FIM, então basta marcar onde o DOM
        // estava antes. A cabeça vem pelo RhythmRenderer, que registra sozinho.
        const antesDom = this.staff.svg.childNodes.length;
        if (position < 0) {
            for (let p = -2; p >= position; p -= 2) this.staff.drawLedgerLine(cx, p, half);
        } else if (position > 8) {
            for (let p = 10; p <= position; p += 2) this.staff.drawLedgerLine(cx, p, half);
        }
        for (let i = antesDom; i < this.staff.svg.childNodes.length; i++) {
            this.elements.push(this.staff.svg.childNodes[i]);
        }
        const antesRr = this.rr.elements.length;
        this.rr.drawNoteheadWhole(this.staff.svg, cx, this.staff.getY(position));
        this.rr.elements.slice(antesRr).forEach(el => this.elements.push(el));
        return cx + nh.rx * 1.35;
    }

    // ================= util =================

    /**
     * Deslocamento vertical do glifo do acidente, em px.
     *
     * 🔴 A PERGUNTA NÃO É "quanto descer", É "QUAL FONTE DESENHOU". Numa fonte SMuFL (Bravura)
     * a origem do ♯/♭ É a posição na pauta ⇒ deslocamento ZERO. Numa fonte de texto o sinal
     * é uma letra qualquer, assentada na linha de base ⇒ precisa descer. Como a Bravura é
     * lazy, os dois casos acontecem NA MESMA SESSÃO, e um número fixo erra num dos dois.
     *
     * A sonda é o ♯ (e só ele, mesmo quando se desenham bemóis): ele é o glifo cuja tinta é
     * simétrica em torno da origem numa fonte SMuFL e claramente assimétrica numa fonte de
     * texto — ou seja, a assimetria identifica a FONTE, não o sinal. O ♭ é assimétrico nas
     * duas (o cabo sobe), então centrar a tinta dele seria errado; por isso a sonda não
     * mede o glifo que vai ser desenhado.
     *
     * Sem `measureText`/`actualBoundingBox*` (navegador antigo, jsdom) cai no legado — o
     * mesmo desenho que o `ScoreRenderer` já faz hoje em produção.
     * @private
     */
    /**
     * 🔴 A PROMESSA DO CABEÇALHO NÃO SE CUMPRIA. O construtor assinava `document.fonts.ready`,
     * mas quando ele roda o shell do `/app/` ainda não pediu glifo Bravura nenhum ⇒ a
     * promessa JÁ ESTÁ resolvida, o `.then` dispara no microtask seguinte com `_last === null`
     * e volta. Só DEPOIS o `_draw` insere o primeiro `<text font-family=Bravura>` e o
     * navegador vai buscar a fonte (945 KB). Quando ela chega, os `x` dos sinais continuam
     * calculados sobre a clave ESTREITA do fallback — medido pela auditoria de código com a
     * fonte atrasada 3s: a clave terminava em 57,9 e o 1º sustenido começava em 41,2, ou
     * seja, EM CIMA da clave, e ficava assim.
     * Agora o pedido é feito DEPOIS de desenhar, que é quando a fonte de fato importa, e o
     * repinte usa a última pergunta. Uma vez por render, sem laço.
     */
    _armarRepinte() {
        // 🔴 Teto: UM repinte por instância. A fonte chega uma vez; se `load` resolvesse com
        // a Bravura em erro, `check()` seguiria falso e repintar→rearmar→load giraria sem fim.
        if (this._repintou || this._repinteArmado || typeof document === 'undefined' || !document.fonts) return;
        try { if (document.fonts.check('40px Bravura')) return; } catch (e) { return; }
        this._repinteArmado = true;
        const solta = () => { this._repinteArmado = false; };
        try {
            document.fonts.load('40px Bravura').then(() => {
                solta();
                this._repintou = true;
                this._repaint();
            }).catch(solta);
        } catch (e) { solta(); }
    }

    _accDy(s, fontSize) {
        const legado = s * KeySignatureRenderer.LEGACY_DY_SPACES;
        try {
            if (!this._probeCtx) {
                if (typeof document === 'undefined' || !document.createElement) return legado;
                const cv = document.createElement('canvas');
                if (!cv.getContext) return legado;
                this._probeCtx = cv.getContext('2d');
            }
            const ctx = this._probeCtx;
            if (!ctx) return legado;
            ctx.font = fontSize + 'px ' + KeySignatureRenderer.FONT;
            const m = ctx.measureText(KeySignatureRenderer.GLYPH.sharp);
            const asc = m.actualBoundingBoxAscent, desc = m.actualBoundingBoxDescent;
            if (!isFinite(asc) || !isFinite(desc) || asc + desc <= 0) return legado;
            // Simétrico (≤ 15% do corpo de diferença) ⇒ fonte musical ⇒ a origem já está no
            // lugar certo. Assimétrico ⇒ fonte de texto ⇒ vale o acerto legado.
            return Math.abs(asc - desc) <= (asc + desc) * 0.15 ? 0 : legado;
        } catch (e) {
            return legado;
        }
    }

    /**
     * Cria um `<text>` com a pilha de fontes da casa e o registra para o `clear()`.
     * @private
     */
    _text(attrs, conteudo) {
        const el = document.createElementNS(KeySignatureRenderer.NS, 'text');
        for (const k in attrs) el.setAttribute(k, attrs[k]);
        el.setAttribute('font-family', KeySignatureRenderer.FONT);
        el.setAttribute('fill', '#000');
        el.textContent = conteudo;
        this.staff.svg.appendChild(el);
        this.elements.push(el);
        return el;
    }

    /**
     * Borda direita REAL de um elemento de texto. `getBBox` é a única forma honesta de saber
     * quanto um glifo ocupa (a largura depende da fonte que de fato carregou), e cai no
     * fallback quando o navegador não sabe medir (SVG fora do documento, jsdom…).
     * Copiado de `ScoreRenderer._rightEdge` pelo mesmo motivo do resto.
     * @private
     */
    _rightEdge(el, fallback) {
        try {
            const b = el.getBBox();
            if (b && b.width > 0) return b.x + b.width;
        } catch (e) { /* sem layout disponível */ }
        return fallback;
    }
}

// 🔴 Sem esta linha a classe SOME do bundle sem erro nenhum: o `sync-class.js` concatena os
// arquivos e quem procura `window.KeySignatureRenderer` recebe `undefined` — falha MUDA.
window.KeySignatureRenderer = KeySignatureRenderer;



// ============================================
// components/staff/StaffReadingRenderer.js
// ============================================
/**
 * StaffReadingRenderer - Desenha UMA nota no pentagrama (leitura de pauta)
 *
 * Protótipo do 2º card de treinamento. Reaproveita ao máximo o que já existe:
 *  - MusicStaff: eixo de altura (getY(position)) + linhas suplementares.
 *  - RhythmRenderer: primitivas de desenho (clave, cabeça de nota, haste, linhas
 *    da pauta). Em vez de duplicar SVG, instanciamos um RhythmRenderer e usamos
 *    seus métodos de gravura.
 *  - KeySignatureRenderer: a ARMADURA (tonalidade do treino livre), composta pelo
 *    `drawSignature()` — a regra de posição de cada ♯/♭ mora lá, e só lá.
 *
 * Responsabilidade ÚNICA: renderizar a nota da pergunta atual e recolorir para
 * feedback (verde = acerto, vermelho = erro). NÃO conhece pontuação nem fluxo.
 *
 * 🔴 Com `sharps = 0` a geometria é a HISTÓRICA, pixel por pixel: a nota se centra no
 * espaço depois de `clefSpace`. Com armadura, a nota se centra no que SOBRA depois do
 * último sinal — a armadura empurra a nota, nunca a cobre.
 *
 * 🔴 A Bravura é lazy (ver KeySignatureRenderer): a largura dos sinais é MEDIDA, e no
 * primeiro quadro pode ser a da fonte de fallback. Quando a fonte chega, o
 * KeySignatureRenderer chama `onRepaint` e ESTA classe redesenha a cena inteira (pauta,
 * clave, armadura, nota, cor do feedback) — o `render()` dele apagaria a nota.
 */
class StaffReadingRenderer {
    constructor(musicStaff) {
        this.staff = musicStaff;
        // Reuso das primitivas de gravura do jogo de ritmo (clave, notehead, haste).
        this.rr = new window.RhythmRenderer(musicStaff);
        // Armadura: composta, não copiada. Sem a classe no bundle o treino segue sem armadura.
        this.ks = window.KeySignatureRenderer
            ? new window.KeySignatureRenderer(musicStaff, { onRepaint: () => this._repaint() })
            : null;
        this.noteX = null;
        this.noteEls = []; // elementos SVG da nota atual (p/ recolorir no feedback)
        this.sharps = 0;
        this._last = null;   // última cena (repinte da fonte)
        this._color = null;  // cor do feedback aplicada por cima da última cena
        /** Dono avisado depois de um repinte pela fonte (a nota pode ter mudado de X). */
        this.onRepaint = null;
    }

    /**
     * Renderiza a pauta com a clave pedida, a armadura e UMA nota na posição dada.
     * A geometria (Y, suplementares, haste) é por POSIÇÃO e não sabe de clave nem de
     * armadura — só o glifo e o X mudam; quem traduz posição em nome é o
     * StaffReadingGenerator.
     * @param {number} position - posição musical (0 = linha 1 … 8 = linha 5)
     * @param {'treble'|'bass'} [clef='treble']
     * @param {number} [sharps=0] - armadura: +N sustenidos, −N bemóis (0 = nenhuma)
     */
    render(position, clef = 'treble', sharps = 0) {
        this.rr.clear(); // limpa SVG + lista de elementos
        if (this.ks) this.ks.clearSignature(); // o SVG já foi esvaziado; zera a lista dele
        this.clef = clef;
        this.sharps = Number.isFinite(sharps) ? Math.trunc(sharps) : 0;
        this._last = { position, clef, sharps: this.sharps };
        this._color = null;

        const drawArea = this.staff.getDrawArea();
        const endX = drawArea.endX - 5;

        // Pauta + clave (reuso direto das primitivas do RhythmRenderer)
        this.rr.drawStaffLines(endX);
        this.rr.drawClef(clef);
        const clefEl = this.rr.elements[this.rr.elements.length - 1];

        // Armadura: começa depois da clave MEDIDA (a largura do glifo depende da fonte que
        // carregou), nunca numa fração fixa; o fallback é o "após a clave" do RhythmRenderer.
        let afterClef = drawArea.startX + this.rr.LAYOUT.clefSpace;
        if (this.ks && this.sharps) {
            const s = this.staff.config.lineSpacing || this.rr.STAFF.lineSpacing;
            const clefRight = this._rightEdge(clefEl, drawArea.startX + this.rr.LAYOUT.clefSpace * 0.75);
            const x0 = clefRight + s * window.KeySignatureRenderer.CLEF_GAP;
            const end = this.ks.drawSignature(x0, this.sharps, clef);
            afterClef = Math.max(afterClef, end + s * 1.2);
        }

        // X da nota: centralizada na área que sobra (depois da clave — ou da armadura)
        const x = afterClef + (endX - afterClef) / 2;
        this.noteX = x;

        const y = this.staff.getY(position);

        // Linhas suplementares se a nota cair fora do pentagrama (Dó central etc.)
        this._drawLedgers(x, position);

        // Cabeça + haste de semínima. Hastes p/ baixo da linha do meio (Si) p/ cima.
        const before = this.rr.elements.length;
        this.rr.drawNoteheadFilled(this.staff.svg, x, y);
        this.rr.drawStem(this.staff.svg, x, y, position < 4);
        this.noteEls = this.rr.elements.slice(before);
    }

    /**
     * Desenha as linhas suplementares necessárias entre a pauta e a nota.
     * Posições pares fora de 0..8 são "em cima da linha"; passamos cada uma à
     * MusicStaff (que ignora posições dentro do pentagrama). A meia-largura vem do
     * tamanho REAL da cabeça (senão o tracinho some embaixo dela).
     */
    _drawLedgers(x, position) {
        const nh = this.rr.NOTEHEAD;
        const half = window.MusicStaff.ledgerHalfWidth(
            this.staff.config.lineSpacing, nh.rx, nh.ry, nh.angle);
        if (position < 0) {
            for (let p = -2; p >= position; p -= 2) this.staff.drawLedgerLine(x, p, half);
        } else if (position > 8) {
            for (let p = 10; p <= position; p += 2) this.staff.drawLedgerLine(x, p, half);
        }
    }

    /**
     * Recolore a nota atual (feedback). Aceita qualquer cor CSS.
     * @param {string} color
     */
    colorNote(color) {
        this._color = color;
        this.noteEls.forEach(el => {
            if (el.getAttribute('fill') && el.getAttribute('fill') !== 'none') {
                el.setAttribute('fill', color);
            }
            if (el.getAttribute('stroke')) {
                el.setAttribute('stroke', color);
            }
        });
    }

    /** Repinte pela chegada da Bravura: a MESMA cena, com a cor do feedback que estava. */
    _repaint() {
        if (!this._last) return;
        const color = this._color;
        this.render(this._last.position, this._last.clef, this._last.sharps);
        if (color) this.colorNote(color);
        if (this.onRepaint) this.onRepaint();
    }

    /** Borda direita REAL de um `<text>` (a clave); fallback quando não há layout. */
    _rightEdge(el, fallback) {
        try {
            const b = el && el.getBBox ? el.getBBox() : null;
            if (b && b.width > 0) return b.x + b.width;
        } catch (e) { /* SVG fora do documento, jsdom… */ }
        return fallback;
    }

    clear() {
        this.rr.clear();
        if (this.ks) this.ks.clearSignature();
        this.noteEls = [];
        this._last = null;
        this._color = null;
    }
}

// Disponibiliza globalmente
window.StaffReadingRenderer = StaffReadingRenderer;



// ============================================
// components/score/ScoreRenderer.js
// ============================================
/**
 * ScoreRenderer - desenha um `Score` numa ESTEIRA (janela rolante D→E).
 *
 * COMPÕE o RhythmRenderer em vez de estender: cabeça, haste, bandeirola, ponto, pausa,
 * clave, barra e arco de ligadura já existem lá, gravados. O precedente é o
 * StaffReadingRenderer, que faz exatamente isto. O que este arquivo acrescenta é o que
 * o jogo de ritmo nunca precisou:
 *
 *   1. ALTURA — cada cabeça no seu Y (o ritmo escreve tudo na linha do meio);
 *   2. HASTE PARA BAIXO — acima da linha do meio a haste desce (o ritmo é sempre p/ cima);
 *   3. BEAM INCLINADO — a barra segue a subida/descida das notas (a do ritmo é horizontal);
 *   4. ACIDENTE, ARMADURA e LINHA SUPLEMENTAR por nota.
 *
 * 🔴 LEI DE X — ESTRITAMENTE LINEAR, a mesma do getBeatX:
 *
 *        x(beat) = beat · pxPerBeat        (dentro do grupo rolante)
 *        rolagem = translate(readX − agora · pxPerBeat, 0)
 *
 * Ou seja, na tela a nota do beat B aparece em `readX + (B − agora)·pxPerBeat`. Nada de
 * respiro por compasso: **qualquer pixel sem tempo obriga a música a acelerar para
 * atravessá-lo** (é o mesmo triângulo impossível documentado no RHYTHM-ENGINE.md).
 *
 * 🔴 ROLAGEM = UM TRANSFORM, não redesenho. Redesenhar 60×/s a partitura inteira queimaria
 * bateria e faria o SVG piscar; aqui o conteúdo é materializado UMA vez por janela e só o
 * `transform` do grupo muda por quadro. Quem manda no relógio é o jogo (AudioContext).
 *
 * 🔴 JANELA (materialização parcial): só os compassos por perto viram nós SVG
 * (`ensureWindow`). Uma peça importada de 300 compassos daria ~96.000px e milhares de nós —
 * inaceitável no celular. O corte é SEMPRE em barra de compasso, por dois motivos: um grupo
 * de beam nunca cruza a barra (então nunca é partido ao meio) e o X é absoluto no grupo,
 * então rematerializar não desloca nada — a emenda é invisível.
 *
 * Etapa 2 de docs/MUSICA-REAL-PLANO.md.
 */
class ScoreRenderer {
    static NS = 'http://www.w3.org/2000/svg';

    /** Fração máxima da pauta que clave + armadura + fórmula podem ocupar. */
    static PREFIX_MAX_FRAC = 0.30;
    /** Piso do encolhimento do prefixo (abaixo disto a clave deixa de ser reconhecível). */
    static PREFIX_MIN_SCALE = 0.55;

    /** Glifos de acidente (mesma fonte da clave). */
    static ACCIDENTAL_GLYPH = { sharp: '♯', flat: '♭', natural: '♮' };

    /** Cifra na esteira: tinta escura (é leitura, não estado). O indicador do acorde
     *  CORRENTE é índigo, a mesma cor que a linha de leitura já usa para dizer "agora". */
    static HARMONY_COLOR = '#0f172a';
    static HARMONY_NOW_COLOR = '#6366f1';

    /**
     * Quantos espaços de pauta a cifra se afasta da CABEÇA MAIS ALTA da peça.
     *
     * 🔴 4,6 e não 2,0 porque a tinta alta NÃO é só a cabeça. A premissa "nota acima da
     * linha do meio tem haste para baixo" é falsa dentro deste próprio arquivo: em grupo
     * de beam, `dirOf` dá a direção pela nota mais DISTANTE da linha do meio — então uma
     * colcheia aguda seguida de uma bem grave ganha haste para CIMA, e a ponta sobe 3,5
     * espaços (IDEAL_STEM) acima da cabeça, com o polígono do beam junto. Medido: com A5
     * seguida de B3, a haste (y 68→33) e o beam (y 32,9→47,3) atravessavam o texto da
     * cifra (y 34→51). Salto largo dentro de um grupo beamado é banal em melodia
     * importada — a primeira cifra do compasso saía rabiscada.
     *
     * A banda é calculada em `harmonyBandY`, que roda ANTES de `dirOf` existir, então a
     * folga é constante e conservadora em vez de consultar o grupo.
     */
    static HARMONY_CLEAR = 4.6;

    constructor(musicStaff, options = {}) {
        this.staff = musicStaff;
        /** Primitivas de gravura — reuso, não duplicação. */
        this.rr = new window.RhythmRenderer(musicStaff);
        this.score = null;

        const width = this.staff.config.width;
        this.LAYOUT = {
            // Escala horizontal. Mais px por semínima = partitura mais folgada e mais
            // lenta de atravessar. Teto p/ não esticar demais no desktop; piso p/ a
            // colcheia não colar no celular.
            // 🔴 `densityMul` multiplica ANTES do piso de `_applyMinScale`, nunca depois:
            // aplicado depois, "compacto" empurraria as cabeças uma por cima da outra. Assim
            // o compacto aperta só até o ponto em que a peça ainda cabe legível, e para.
            pxPerBeat: (options.pxPerBeat || Math.max(38, Math.min(92, width / 8)))
                       * (options.densityMul || 1),
            // Respiro antes da clave. O RESTO do prefixo (clave + armadura + fórmula) NÃO
            // é orçado por fração de tela: é MEDIDO peça a peça em renderFixed. Ver lá.
            padLeft: options.padLeft != null ? options.padLeft : 4,
            // Folga entre a linha de leitura e o começo do prefixo. 🔴 Tem de ser ≥ o alcance
            // do acidente à esquerda da cabeça (~17px), senão o ♯/♭ da nota que está EM CIMA
            // da linha de leitura é aparado pelo recorte — justo a informação que decide a
            // resposta, cortada no instante em que se lê.
            readGap: options.readGap != null ? options.readGap : 20,
            // Quantos compassos materializar de cada lado da janela visível.
            windowPad: options.windowPad || 2,
            // 🔴 Recuo COSMÉTICO da barra de compasso interior. A barra cai no MESMO instante
            // do tempo forte, logo no MESMO X da cabeça — e a linha atravessa a nota (medido:
            // 5 de 5 barras a 0,0px da cabeça). Recua só o `<line>`, para o vazio à esquerda.
            // NÃO toca `x(beat)`: notas, linha de leitura e rolagem continuam lineares. É a
            // mesma solução do motor de ritmo (RHYTHM-ENGINE.md, `barlineInset`).
            barlineInset: options.barlineInset != null ? options.barlineInset : 11
        };

        /** Camadas: a fixa não rola; a rolante carrega a música. */
        this.gFixed = null;
        this.gScroll = null;
        this.gClip = null;
        this.readLine = null;

        this._nowBeat = 0;
        this._window = null;   // {fromBeat, toBeat} materializado
        // 🔴 CHAVE = o `beat` do NÓ-ÂNCORA, lido do próprio Score, nunca recalculado.
        // É float, e float só é chave confiável enquanto ninguém faz conta com ele: quem
        // pinta uma nota tem de passar o MESMO `n.beat` que leu do modelo (0.5+0.5 não é
        // garantidamente o 1 do arquivo). Contrato firmado na Etapa 3, que é quem estreou
        // o uso; a auditoria 2 o havia deixado em aberto.
        this._noteEls = new Map(); // beat → [elementos] (o jogo recolore por aqui)
        // Marcas PERSISTENTES de cor (acerto/erro/próxima). Ver `markNote`.
        this._marks = new Map();   // beat → cor
        this._prefixEnd = this.staff.getDrawArea().startX + 60; // medido em renderFixed

        this._buildLayers();

        // A Bravura é lazy: se o prefixo for medido ANTES de ela chegar, a medida é a da
        // fonte de fallback e a armadura pode encostar na clave por um instante. Remede
        // quando a fonte estiver pronta (barato: só a camada fixa + um transform).
        if (typeof document !== 'undefined' && document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => {
                if (!this.score) return;
                this.renderFixed();
                this.scrollTo(this._nowBeat);
            }).catch(() => {});
        }
    }

    // ================= camadas =================

    _el(tag, attrs = {}, parent = null) {
        const e = document.createElementNS(ScoreRenderer.NS, tag);
        for (const k in attrs) e.setAttribute(k, attrs[k]);
        (parent || this.staff.svg).appendChild(e);
        return e;
    }

    _buildLayers() {
        const svg = this.staff.svg;
        const w = this.staff.config.width;
        const h = this.staff.config.height;

        // Recorte: a música só existe à direita do prefixo. Sem isto, a nota que sai pela
        // esquerda passaria POR CIMA da clave.
        const clipId = 'score-clip-' + Math.random().toString(36).slice(2, 8);
        const defs = this._el('defs');
        const cp = this._el('clipPath', { id: clipId }, defs);
        // Guardado: a borda do recorte só é conhecida depois de MEDIR o prefixo (renderFixed).
        this._clipRect = this._el('rect', { x: this._prefixEnd, y: 0,
            width: Math.max(0, w - this._prefixEnd), height: h }, cp);

        this.gClip = this._el('g', { 'clip-path': `url(#${clipId})` });
        this.gScroll = this._el('g', { class: 'score-scroll' }, this.gClip);
        this.gFixed = this._el('g', { class: 'score-fixed' });
    }

    /**
     * Executa `fn` com as primitivas apontando para outro host SVG.
     *
     * Necessário porque RhythmRenderer.drawRest / MusicStaff.drawLedgerLine escrevem em
     * `staff.svg` direto (não recebem o host por parâmetro, ao contrário das primitivas de
     * cabeça/haste). Trocar o alvo por um instante é bem mais barato — e menos arriscado —
     * do que reescrever essas primitivas ou duplicá-las aqui.
     */
    _withHost(hostEl, fn) {
        const real = this.staff.svg;
        this.staff.svg = hostEl;
        try { fn(); } finally { this.staff.svg = real; }
    }

    // ================= X: a lei linear =================

    /**
     * Borda direita REAL de um elemento de texto. `getBBox` é a única forma honesta de
     * saber quanto um glifo ocupa (a largura depende da fonte que de fato carregou), e
     * cai no fallback se o navegador não souber medir (SVG fora do documento, jsdom…).
     */
    _rightEdge(el, fallback) {
        try {
            const b = el.getBBox();
            if (b && b.width > 0) return b.x + b.width;
        } catch (e) { /* sem layout disponível */ }
        return fallback;
    }

    /** X de um beat DENTRO do grupo rolante. Fonte única — tudo deriva daqui. */
    x(beat) {
        return beat * this.LAYOUT.pxPerBeat;
    }

    /** X de tela da linha de leitura (onde o "agora" acontece). */
    get readX() {
        return this._prefixEnd + this.LAYOUT.readGap;
    }

    /** Quantas semínimas cabem à direita da linha de leitura (o que dá p/ enxergar). */
    get visibleBeats() {
        const right = this.staff.config.width - this.staff.config.marginRight;
        return Math.max(1, (right - this.readX) / this.LAYOUT.pxPerBeat);
    }

    // ================= API =================

    setScore(score) {
        this.score = score;
        this._window = null;
        this._nowBeat = 0;
        this._marks = new Map();   // partitura nova não herda o feedback da anterior
        this._measuresCache = score ? score.measures() : [];

        // 🔴 Desenhar partitura inválida é pior que não desenhar: duração sem figura vira
        // semínima em silêncio (o desenho MENTE sobre o ritmo). Não recusamos — o dono da
        // tela decide — mas nunca passa calado.
        if (score) {
            const v = score.validate();
            if (!v.ok) console.warn('ScoreRenderer: partitura inválida — o desenho pode mentir.\n  '
                + v.errors.slice(0, 8).join('\n  '));
        }

        // Cabeça mais ALTA da peça — de onde a faixa de cifras se afasta (harmonyBandY).
        // Calculado uma vez: `notes()` varre a voz inteira e isto é lido por janela.
        this._maxPos = 8;
        if (score) {
            score.notes().forEach(n => {
                if (n.type === 'note' && Number.isFinite(n.position)) {
                    this._maxPos = Math.max(this._maxPos, n.position);
                }
            });
        }

        this._applyMinScale();
        this.renderFixed();
        this.scrollTo(0);
        return this;
    }

    /**
     * 🔴 Piso de escala DERIVADO DA PEÇA, não um número fixo.
     *
     * A lei de X é linear (`x = beat·pxPerBeat`), então **não dá para "abrir espaço" para uma
     * nota apertada** — mexer no espaçamento local quebraria a sincronia. A única alavanca
     * honesta é a escala global. O piso antigo (38 px/semínima) foi dimensionado pensando em
     * colcheia (19px entre cabeças); com semicolcheia dá 9,5px e **as cabeças se sobrepõem
     * 3,5px**, sem nem contar acidente. Aqui o piso sai da MENOR distância entre eventos que
     * a peça realmente tem, mais o alcance do acidente quando ele existe.
     *
     * Consequência aceita: em tela estreita, uma peça de semicolcheias mostra MENOS tempo.
     * Ver menos, legível, é melhor que ver mais, ilegível — ainda mais num jogo em que a
     * altura lida é a resposta.
     */
    _applyMinScale() {
        if (!this.score) return;
        const ns = this.score.notes();
        if (ns.length < 2) return;
        const rx = this.rr.NOTEHEAD.rx;
        const AR = 2.5;                 // ar mínimo entre cabeças vizinhas
        const ACID = rx + 10.5;         // quanto o acidente avança à esquerda da cabeça
        let need = 0;
        for (let i = 0; i + 1 < ns.length; i++) {
            const d = ns[i + 1].beat - ns[i].beat;
            if (!(d > Score.EPS)) continue;
            const largura = rx * 2 + AR + (ns[i + 1].accidental ? ACID : 0);
            need = Math.max(need, largura / d);
        }
        // Teto de sanidade: peça com fusas não pode explodir a escala a ponto de caber
        // meia figura na tela — aí o limite honesto é a própria tela, e some tempo visível.
        this.LAYOUT.pxPerBeat = Math.min(Math.max(this.LAYOUT.pxPerBeat, need), 400);
    }

    /**
     * Move a esteira. É a ÚNICA coisa que roda por quadro — um atributo, sem redesenho.
     * @param {number} beat - posição do "agora" em semínimas
     */
    scrollTo(beat) {
        // Guarda: um NaN vindo do relógio do jogo produziria `translate(NaN,0)` — o grupo
        // rolante SOME e o Chrome só reclama no console. Melhor congelar no último válido.
        if (!isFinite(beat)) return this;
        this._nowBeat = beat;
        if (this.gScroll) {
            this.gScroll.setAttribute('transform', `translate(${this.readX - this.x(beat)}, 0)`);
        }
        this.ensureWindow(beat);
        // A cifra corrente anda com a esteira. Aqui, e não no jogo: quem rola já disse
        // tudo o que era preciso, e um consumidor novo não tem como esquecer.
        this.showNowChord(beat);
        return this;
    }

    /**
     * Materializa a fatia de compassos em volta de `beat`, se a janela andou.
     * Corta SEMPRE em barra de compasso (ver cabeçalho).
     */
    ensureWindow(beat) {
        if (!this.score) return;
        // Cache: `measures()` aloca a grade inteira e varre todas as notas (via totalBeats).
        // Chamado por scrollTo, isto rodava 60×/s só para descobrir que nada mudou — numa
        // peça de 300 compassos, 18.000 objetos e 162.000 visitas a notas por segundo.
        const ms = this._measuresCache && this._measuresCache.length
            ? this._measuresCache : (this._measuresCache = this.score.measures());
        if (!ms.length) return;

        const pad = this.LAYOUT.windowPad;
        const firstIdx = ms.findIndex(m => beat < m.endBeat - Score.EPS);
        const start = Math.max(0, (firstIdx < 0 ? ms.length - 1 : firstIdx) - pad);
        // Último compasso VISÍVEL (findIndex devolve o 1º invisível → −1), + folga.
        const visEnd = beat + this.visibleBeats;
        let lastIdx = ms.findIndex(m => m.startBeat > visEnd + Score.EPS);
        lastIdx = (lastIdx < 0) ? ms.length - 1 : Math.max(start, lastIdx - 1);
        const end = Math.min(ms.length - 1, lastIdx + pad);

        const from = ms[start].startBeat;
        const to = ms[end].endBeat;
        if (this._window && Math.abs(this._window.fromBeat - from) < Score.EPS
                         && Math.abs(this._window.toBeat - to) < Score.EPS) return;

        // 🔴 Marcar DEPOIS de desenhar. Marcando antes, uma exceção no meio do desenho deixa
        // a janela registrada como pronta com conteúdo pela metade — e ela nunca mais é
        // refeita, porque a comparação seguinte dá igual.
        this.renderWindow(from, to);
        this._window = { fromBeat: from, toBeat: to };
    }

    // ================= desenho: camada fixa =================

    /**
     * Pauta, clave, armadura, fórmula e linha de leitura. Não rolam.
     *
     * 🔴 O prefixo é MEDIDO, não orçado. A versão anterior punha a armadura numa fração da
     * largura da tela (`prefix * 0.52`) enquanto a clave era dimensionada pelo pentagrama —
     * duas réguas independentes, então em certas larguras o primeiro bemol caía EM CIMA da
     * clave (medido: clave até x=66,6, bemol de 61,9 a 67,4). Aqui cada peça é desenhada,
     * medida com `getBBox()` e a seguinte começa depois dela. Não há largura de tela em que
     * colida, e a armadura de 7 sustenidos empurra a música em vez de invadir a clave.
     */
    renderFixed(escala = null) {
        while (this.gFixed.firstChild) this.gFixed.removeChild(this.gFixed.firstChild);
        if (!this.score) return;

        const st = this.score.staves[0] || { clef: 'treble' };
        const area = this.staff.getDrawArea();
        const s = this.rr.STAFF.lineSpacing;
        // 🔴 O prefixo é medido em px ABSOLUTOS (clave é proporção de pauta), mas a pauta
        // encolhe com a tela. Em 320px com armadura de 7 sustenidos ele comia 58% da largura
        // — sobrava meio compasso de 4/4 de música visível. Se passar do teto, encolhe clave
        // e armadura e redesenha. Two-pass porque só dá para saber depois de MEDIR.
        const TETO = (area.endX - area.startX) * ScoreRenderer.PREFIX_MAX_FRAC;
        const k = escala == null ? 1 : escala;

        // 5 linhas, de ponta a ponta (a pauta é o palco; quem anda é a música).
        for (let i = 0; i < 5; i++) {
            this._el('line', {
                x1: area.startX, y1: this.staff.linePositions[i],
                x2: area.endX,   y2: this.staff.linePositions[i],
                stroke: this.staff.config.lineColor, 'stroke-width': this.staff.config.lineWidth
            }, this.gFixed);
        }

        // Clave (glifo Bravura). 🔴 O tamanho deriva do PENTAGRAMA (lineSpacing), nunca do
        // orçamento horizontal: clave é proporção de pauta, e amarrá-la ao `prefix` faria a
        // mesma partitura ter clave de tamanhos diferentes conforme a largura da tela. Os
        // fatores são os do RhythmRenderer (7.2 × lineSpacing, base em getY(4)+1.2) para a
        // clave sair IDÊNTICA à dos outros jogos — o aluno vê um app só.
        const isBass = st.clef === 'bass';
        const clef = this._el('text', {
            x: area.startX + this.LAYOUT.padLeft,
            // Sol: a espiral abraça a 2ª linha. Fá: os dois pontos cercam a 4ª linha.
            y: (isBass ? this.staff.getY(6) : this.staff.getY(4)) + s * (isBass ? 0.15 : 1.2),
            'font-size': s * (isBass ? 5.6 : 7.2) * k,
            'font-family': 'Bravura, Times New Roman, Georgia, serif',
            fill: '#000'
        }, this.gFixed);
        clef.textContent = isBass ? '𝄢' : '𝄞';

        // Armadura: começa DEPOIS da clave medida, nunca numa fração da tela.
        const kx = this._drawKeySignature(this._rightEdge(clef, area.startX + s * 4 * k) + s * 0.5, st.clef, k);

        // Fórmula de compasso (âncora no meio dos dois algarismos).
        const ts = this.score.timeSignatureAt(0);
        const tx = kx + s * 1.1;
        let tRight = tx;
        [[ts.beats, -s * 0.8], [ts.noteValue, s * 2.2]].forEach(([txt, dy]) => {
            const el = this._el('text', {
                x: tx, y: this.staff.getY(4) + dy, 'font-size': s * 2, 'font-weight': 'bold',
                'font-family': 'Times New Roman, serif', 'text-anchor': 'middle', fill: '#000'
            }, this.gFixed);
            el.textContent = String(txt);
            tRight = Math.max(tRight, this._rightEdge(el, tx + s));
        });

        // Segunda passada: se o prefixo estourou o teto, encolhe e redesenha uma vez só.
        const largura = (tRight + s * 0.6) - area.startX;
        if (escala == null && largura > TETO && largura > 0) {
            return this.renderFixed(Math.max(ScoreRenderer.PREFIX_MIN_SCALE, TETO / largura));
        }

        // Fim do prefixo: daqui pra direita é território da música. O recorte acompanha —
        // sem isso a nota que sai pela esquerda passaria por cima da fórmula.
        this._prefixEnd = tRight + s * 0.6;
        if (this._clipRect) {
            this._clipRect.setAttribute('x', this._prefixEnd);
            this._clipRect.setAttribute('width', Math.max(0, this.staff.config.width - this._prefixEnd));
        }

        // Linha de leitura: o "agora". Vai um pouco além da pauta p/ ser vista de relance.
        this.readLine = this._el('line', {
            x1: this.readX, y1: this.staff.getY(8) - s * 2.2,
            x2: this.readX, y2: this.staff.getY(0) + s * 2.2,
            stroke: '#6366f1', 'stroke-width': 2, 'stroke-linecap': 'round', opacity: 0.9
        }, this.gFixed);

        // "Cifra agora" — ver `showNowChord`. Nasce vazia; só peça COM harmonia a preenche.
        this.nowChordEl = null;
        this._nowChordKey = null;
        this._nowChordRange = null;
        if (this.score.harmony.length) {
            this.nowChordEl = this._el('text', {
                x: area.startX + this.LAYOUT.padLeft, y: this.harmonyBandY(),
                'font-size': s * 1.5, 'font-weight': '800',
                'font-family': 'system-ui, sans-serif', fill: ScoreRenderer.HARMONY_NOW_COLOR
            }, this.gFixed);
            this.showNowChord(this._nowBeat);
        }
    }

    // ================= cifras (Etapa 7) =================

    /**
     * Y da linha de base da cifra — ACIMA de toda a tinta da música.
     *
     * 🔴 Não é uma constante. Acima da pauta a peça pode ter linhas suplementares (cabeça
     * em `position` 12, 14…) e o acidente que vem com elas; um número fixo funcionaria no
     * Parabéns e cruzaria a cabeça de qualquer peça que sobe. Haste e beam NÃO entram na
     * conta porque nota acima da linha do meio tem haste para BAIXO — a tinta alta é a
     * cabeça, e é dela que a cifra se afasta.
     */
    harmonyBandY() {
        const s = this.rr.STAFF.lineSpacing;
        const topo = this.staff.getY(8);
        const alta = this.staff.getY(Math.max(8, this._maxPos || 8));
        return Math.min(topo - s * 3.0, alta - s * ScoreRenderer.HARMONY_CLEAR);
    }

    /** A peça tem cifra? (fonte única — a geometria só muda quando tem) */
    hasHarmony() {
        return !!(this.score && this.score.harmony && this.score.harmony.length);
    }

    /**
     * Mostra qual acorde está SOANDO agora, parado na margem esquerda.
     *
     * 🔴 Existe porque X é linear: o símbolo rolante cruza a linha de leitura no beat dele
     * e SAI pela esquerda. Uma cifra que dura quatro tempos já saiu da tela enquanto você
     * ainda a está tocando — você veria a cifra passar e não saberia em que acorde está.
     * Não é uma segunda verdade: lê a MESMA faixa do `Score` que o símbolo rolante.
     *
     * 🔴 Só toca o DOM quando o acorde MUDA. É chamado por quadro, e reescrever
     * `textContent` 60×/s é a mesma queima de layout que o `_markNext` e o `_hudKey` do
     * jogo já aprenderam a evitar.
     */
    showNowChord(beat) {
        if (!this.nowChordEl || !this.score) return;
        // 🔴 Enquanto o beat continuar DENTRO do trecho do acorde corrente não há o que
        // decidir — e é esse o caso em 99% dos quadros. Sem esta guarda, `chordAt` varreria
        // a faixa inteira 60×/s (numa peça longa, dezenas de milhares de comparações por
        // segundo para descobrir que nada mudou). Mesma economia do `_measuresCache`.
        const r = this._nowChordRange;
        if (r && beat >= r.from && beat < r.to) return;

        const H = this.score.harmony;
        const h = this.score.chordAt(beat);
        const i = h ? H.indexOf(h) : -1;
        // 🔴 ANTES da primeira cifra o trecho vai até ela, NÃO até o infinito. Com Infinity
        // aqui, a peça que começa sem acorde nunca mais reavaliava: o indicador ficava vazio
        // a música inteira, porque o quadro seguinte achava que já sabia a resposta.
        const prox = (i < 0)
            ? (H.length ? H[0].beat : Infinity)
            : (i + 1 < H.length ? H[i + 1].beat : Infinity);
        this._nowChordRange = { from: h ? h.beat : -Infinity, to: prox };

        const txt = h ? (h.symbol || '') : '';
        if (txt === this._nowChordKey) return;
        this._nowChordKey = txt;
        this.nowChordEl.textContent = txt;
    }

    /** Desenha as cifras de [from, to) no grupo rolante. Mesmo X linear das notas. */
    _drawHarmony(fromBeat, toBeat) {
        if (!this.hasHarmony()) return;
        const s = this.rr.STAFF.lineSpacing;
        const y = this.harmonyBandY();
        const ppb = this.LAYOUT.pxPerBeat;
        const H = this.score.harmony;
        const visiveis = this.score.harmonyBetween(fromBeat, toBeat);

        visiveis.forEach(h => {
            if (!h.symbol) return;
            const attrs = {
                x: this.x(h.beat), y,
                'font-size': s * 1.4, 'font-weight': '700',
                'font-family': 'system-ui, sans-serif', fill: ScoreRenderer.HARMONY_COLOR
            };
            // 🔴 A cifra NÃO pode empurrar a vizinha: X é a lei linear e não há para onde
            // mover. Então ela CABE — encolhe e, no limite, comprime o traçado. Sem isto,
            // medido em 400px (41 px/semínima) com a grade "Tempo": "F♯m7(♭5)" mede 63,8 px
            // e 7 de 8 pares se sobrepunham, saindo `F#m7(♭5F#m7(♭5F#m7(♭5…` — a superfície
            // inteira da feature ilegível justamente onde ela é mais usada.
            const i = H.indexOf(h);
            const prox = (i >= 0 && i + 1 < H.length) ? H[i + 1].beat : Infinity;
            const espaco = (prox - h.beat) * ppb - 3;
            if (isFinite(espaco) && espaco > 0) {
                // Estimativa sem `getBBox` (isto roda por janela, e medir força layout):
                // ~0,62 em da largura média destes glifos. Erra para o lado seguro.
                const largura = h.symbol.length * s * 1.4 * 0.62;
                if (largura > espaco) {
                    const fonte = Math.max(s * 0.95, s * 1.4 * (espaco / largura));
                    attrs['font-size'] = fonte;
                    const aindaFalta = h.symbol.length * fonte * 0.62;
                    if (aindaFalta > espaco) {
                        attrs.textLength = Math.max(8, espaco);
                        attrs.lengthAdjust = 'spacingAndGlyphs';
                    }
                }
            }
            this._el('text', attrs, this.gScroll).textContent = h.symbol;
        });
    }

    /**
     * Rematerializa a janela corrente. O editor de cifras chama depois de plantar/apagar:
     * `renderWindow` só roda quando a janela ANDA, e uma cifra nova não move janela nenhuma.
     * É um toque de dedo, não um quadro — redesenhar a janela inteira é barato aqui.
     */
    refresh() {
        if (!this.score) return this;
        // A PRIMEIRA cifra (e o apagar da última) mudam a camada FIXA: é ela que hospeda a
        // "cifra agora". Sem isto, plantar a primeira cifra da peça não acenderia o
        // indicador até a próxima troca de tela.
        // 🔴 ANTES da guarda de janela: numa peça em que `ensureWindow` nunca rodou, sair
        // aqui deixaria o indicador apagado para sempre.
        if (this.hasHarmony() !== !!this.nowChordEl) {
            this.renderFixed();
            this.gScroll.setAttribute('transform', `translate(${this.readX - this.x(this._nowBeat)}, 0)`);
        }
        this._nowChordRange = null;   // a faixa mudou: o trecho em cache não vale mais
        if (this._window) this.renderWindow(this._window.fromBeat, this._window.toBeat);
        this.showNowChord(this._nowBeat);
        return this;
    }

    /**
     * Desenha a armadura. Posições convencionais: os sustenidos/bemóis não caem em
     * qualquer oitava — cada um tem seu lugar, e ele MUDA conforme a clave.
     * @returns {number} X logo depois do último sinal
     */
    _drawKeySignature(x0, clef, k = 1) {
        const sharps = (this.score.keySignature && this.score.keySignature.sharps) || 0;
        if (!sharps) return x0;
        const s = this.rr.STAFF.lineSpacing;
        const N = window.Notation;
        const order = sharps > 0 ? N.SHARP_ORDER : N.FLAT_ORDER;
        const n = Math.min(7, Math.abs(sharps));
        // Oitava de referência de cada sinal na clave de sol (convenção de gravura);
        // na clave de fá tudo desce uma terça (2 posições) — mesma regra dos editores.
        const trebleOct = sharps > 0
            ? { F: 5, C: 5, G: 5, D: 5, A: 4, E: 5, B: 4 }
            : { B: 4, E: 5, A: 4, D: 5, G: 4, C: 5, F: 4 };
        const step = s * 0.62 * k;

        let x = x0;
        for (let i = 0; i < n; i++) {
            const L = order[i];
            let pos = N.diatonicStep(L, trebleOct[L]) - N.CLEF_ANCHOR.treble;
            if (clef === 'bass') pos -= 2;
            const el = this._el('text', {
                x, y: this.staff.getY(pos) + s * 0.35, 'font-size': s * 2.4 * k,
                'font-family': 'Bravura, Times New Roman, serif', fill: '#000'
            }, this.gFixed);
            el.textContent = sharps > 0
                ? ScoreRenderer.ACCIDENTAL_GLYPH.sharp : ScoreRenderer.ACCIDENTAL_GLYPH.flat;
            // Avança pela largura REAL do sinal (o ♭ é mais estreito que o ♯).
            x = Math.max(x + step, this._rightEdge(el, x + step) + s * 0.12 * k);
        }
        return x;
    }

    // ================= desenho: camada rolante =================

    /** (Re)materializa notas, pausas, barras e números de compasso de [from, to). */
    renderWindow(fromBeat, toBeat) {
        while (this.gScroll.firstChild) this.gScroll.removeChild(this.gScroll.firstChild);
        this.rr.elements = [];
        this._noteEls = new Map();
        if (!this.score) return;

        const st = this.score.staves[0];
        if (!st) return;

        // Unidades VISUAIS: a ligadura vira N cabeças (o modelo de dados segue com 1 onset).
        // Calculadas ANTES das barras (que precisam saber onde estão as cabeças p/ recuar),
        // mas as barras são DESENHADAS primeiro — assim ficam atrás das notas.
        const visual = this._visualUnits(st.voices[0] ? st.voices[0].notes : [], fromBeat, toBeat);
        this._drawBarlines(fromBeat, toBeat, visual);
        const groups = this._beamGroups(visual);
        const beamed = new Set(groups.flat());

        // Direção de haste por GRUPO (um beam não pode ter hastes p/ os dois lados).
        const dirOf = new Map();
        groups.forEach(g => {
            // A nota mais distante da linha do meio decide. `>=` (não `>`) para que o EMPATE
            // fique com a ÚLTIMA — é a convenção, e com `>` um grupo {pos 2, pos 6} saía com
            // as duas hastes p/ cima e a segunda no comprimento mínimo.
            const far = g.reduce((a, i) =>
                Math.abs(visual[i].position - 4) >= Math.abs(visual[a].position - 4) ? i : a, g[0]);
            g.forEach(i => dirOf.set(i, visual[far].position < 4));
        });

        visual.forEach((v, i) => {
            const x = this.x(v.beat);
            if (v.type === 'rest') { this._drawRest(x, v); return; }
            const up = dirOf.has(i) ? dirOf.get(i) : v.stemUp;
            this._drawNote(x, v, { up, noStemFlag: beamed.has(i) });
        });

        groups.forEach(g => this._drawBeamGroup(g, visual, dirOf.get(g[0])));

        // Cifras: acima de tudo, no mesmo X linear das notas (Etapa 7).
        this._drawHarmony(fromBeat, toBeat);

        // 🔴 Reaplica o feedback do jogo. `renderWindow` ZERA o grupo rolante e redesenha
        // tudo em preto — e ela roda toda vez que a janela anda, no meio da rodada. Sem
        // isto, uma nota pintada de verde volta ao preto sozinha assim que o compasso
        // seguinte é materializado: o aluno vê o próprio acerto ser apagado.
        this._marks.forEach((cor, beat) => this.colorNoteAt(beat, cor));

        // Arcos de ligadura entre cabeças contíguas do mesmo nó-âncora.
        visual.forEach((v, i) => {
            if (!v.tiePrev || i === 0) return;
            const y = this.staff.getY(v.position);
            // 🔴 O arco vai do lado OPOSTO à haste. O padrão do RhythmRenderer é "por baixo"
            // porque lá a haste sobe sempre; aqui, nota acima da linha do meio tem haste p/
            // baixo e o arco por baixo cai EM CIMA dela (medido: a ponta do arco dentro da
            // haste). `dirOf` manda quando a cabeça está num grupo de beam.
            // `below === up`: haste p/ CIMA deixa o lado de baixo livre → arco embaixo.
            const up = dirOf.has(i) ? dirOf.get(i) : v.stemUp;
            this._withHost(this.gScroll,
                () => this.rr.drawTie(this.x(visual[i - 1].beat), this.x(v.beat), y, up));
        });
    }

    /** Nº de barras de uma figura. Vem do TIPO, não da duração: a colcheia pontuada tem
     *  1 barra, mas `log2(0.5/0.75)` não é inteiro e a conta genérica devolve 0. */
    static BEAM_LEVEL = { eighth: 1, 'dotted-eighth': 1, sixteenth: 2, fusa: 3 };

    /**
     * Grupos de barra de ligação — versão que conhece a PARTITURA.
     *
     * 🔴 Não usa `RhythmRenderer.computeBeamGroups`: aquela agrupa por `Math.floor(beat)`,
     * isto é, por semínima, o que só funciona no mundo do jogo de ritmo (4/4, sem anacruse
     * fracionária). Numa partitura de verdade isso produz três erros:
     *
     *   • **6/8 sai beamado como 3/4** — três grupos de 2 em vez de dois de 3. O beam é
     *     justamente o que faz o compasso composto PARECER composto; errar isso é escrever
     *     a métrica errada.
     *   • **o beam atravessa a barra** quando a barra não cai em semínima inteira (anacruse
     *     de colcheia, 7/8) — e aí a janela ainda parte o grupo e a nota órfã ganha
     *     bandeirola.
     *   • **colcheia pontuada + semicolcheia não beama** (`duration < 0.5` exclui 0,75) — o
     *     ritmo pontuado mais comum da música tonal sai com duas bandeirolas soltas.
     *
     * Aqui a unidade de agrupamento vem da FÓRMULA (composto → tempo pontuado de 1,5
     * semínima; simples → 1 semínima) e nenhum grupo cruza barra nem unidade.
     */
    _beamGroups(visual) {
        const E = Score.EPS;
        const groups = [];
        let cur = [];
        const fecha = () => { if (cur.length >= 2) groups.push(cur); cur = []; };
        // Unidade de tempo p/ agrupar, por compasso (a fórmula pode mudar no meio da peça).
        // 🔴 Fonte ÚNICA do tempo métrico (`Notation.metricBeat`): o editor de cifras planta
        // pela mesma régua. Duas cópias divergem, e aí o 6/8 sai beamado de três com a cifra
        // caindo de semínima em semínima.
        const unidade = (beat) => window.Notation.metricBeat(this.score.timeSignatureAt(beat));
        // Início da unidade que contém `beat`, ancorado na BARRA (não no zero absoluto —
        // senão a anacruse desloca todas as unidades da peça).
        const ms = this._measuresCache && this._measuresCache.length
            ? this._measuresCache : this.score.measures();
        const ancora = (beat) => {
            const m = ms.find(x => beat >= x.startBeat - E && beat < x.endBeat - E);
            const base = m ? m.startBeat : 0;
            const u = unidade(beat);
            return { base: base + Math.floor((beat - base) / u + E) * u, u, fim: m ? m.endBeat : Infinity };
        };

        visual.forEach((v, i) => {
            const nivel = ScoreRenderer.BEAM_LEVEL[v.visualType];
            if (v.type !== 'note' || !nivel) { fecha(); return; }
            const a = ancora(v.beat);
            const prev = cur.length ? visual[cur[cur.length - 1]] : null;
            if (prev) {
                const pa = ancora(prev.beat);
                const mesmaUnidade = Math.abs(pa.base - a.base) < E;
                const contiguo = Math.abs(prev.beat + prev.duration - v.beat) < E;
                // Nenhum grupo cruza barra (a âncora já muda de base) nem deixa buraco.
                if (mesmaUnidade && contiguo) { cur.push(i); return; }
                fecha();
            }
            cur = [i];
        });
        fecha();
        return groups;
    }

    /**
     * Expande os nós-âncora de ligadura em cabeças e recorta a janela.
     * 🔴 Não usa `RhythmRenderer.expandTies`: aquela é do jogo de ritmo e descarta altura
     * (os objetos que ela devolve não têm midi/position). Aqui a altura é o assunto.
     */
    _visualUnits(notes, fromBeat, toBeat) {
        const out = [];
        const dentro = (b) => b >= fromBeat - Score.EPS && b < toBeat - Score.EPS;
        notes.forEach(n => {
            if (n.type === 'note' && n.tieSegments && n.tieSegments.length) {
                n.tieSegments.forEach(seg => {
                    if (!dentro(seg.beat)) return;
                    out.push({
                        type: 'note', beat: seg.beat, duration: seg.duration,
                        visualType: seg.visualType, tiePrev: seg.tiePrev,
                        midi: n.midi, position: n.position, accidental: seg.tiePrev ? null : n.accidental,
                        stemUp: n.stemUp, onsetBeat: n.beat
                    });
                });
                return;
            }
            if (!dentro(n.beat)) return;
            out.push({
                type: n.type, beat: n.beat, duration: n.duration, visualType: n.visualType,
                tiePrev: false, midi: n.midi, position: n.position,
                accidental: n.accidental, stemUp: n.stemUp, onsetBeat: n.beat
            });
        });
        return out;
    }

    /**
     * Barras de compasso + número do compasso.
     *
     * 🔴 A barra INTERIOR recua (`barlineInset`). Ela marca o mesmo instante do tempo forte,
     * então cai no mesmo X da cabeça e a risca atravessa a nota. O recuo é **só do desenho**:
     * `x(beat)` continua intocado, e com ele a linha de leitura, a rolagem e a sincronia.
     *
     * O recuo é limitado por três coisas, e vence a MENOR:
     *   • o valor de conforto (`barlineInset`) — mais que isso a barra descola do tempo;
     *   • metade do vão até a cabeça ANTERIOR — nunca invade a nota que vem antes;
     *   • 40% de uma semínima — em subdivisão curta, o espaço simplesmente não existe.
     * Quando o tempo forte tem ACIDENTE, o recuo cresce o suficiente para passar à esquerda
     * dele (o ♯/♭ avança ~17px), ainda respeitando os limites acima.
     *
     * A barra FINAL fica no X exato: não há nota depois dela para atropelar.
     */
    _drawBarlines(fromBeat, toBeat, visual = []) {
        const ms = this._measuresCache && this._measuresCache.length
            ? this._measuresCache : this.score.measures();
        const s = this.rr.STAFF.lineSpacing;
        const rx = this.rr.NOTEHEAD.rx;
        const ppb = this.LAYOUT.pxPerBeat;
        const yTop = this.staff.getY(8);
        const yBot = this.staff.getY(0);
        const last = ms.length ? ms[ms.length - 1].endBeat : 0;

        ms.forEach(m => {
            if (m.endBeat < fromBeat - Score.EPS || m.endBeat > toBeat + Score.EPS) return;
            const final = Math.abs(m.endBeat - last) < Score.EPS;
            let x = this.x(m.endBeat);

            if (!final) {
                // Cabeça anterior mais próxima da barra (limita o recuo).
                let anterior = m.endBeat - 1;
                visual.forEach(v => {
                    if (v.beat < m.endBeat - Score.EPS && v.beat > anterior) anterior = v.beat;
                });
                const vao = (m.endBeat - anterior) * ppb;
                // O tempo forte tem acidente? Então a barra precisa passar à esquerda dele.
                const forte = visual.find(v => Math.abs(v.beat - m.endBeat) < Score.EPS);
                const desejado = (forte && forte.accidental)
                    ? Math.max(this.LAYOUT.barlineInset, rx + 12.5) : this.LAYOUT.barlineInset;
                x -= Math.max(0, Math.min(desejado, ppb * 0.4, vao * 0.5));
            }

            this._el('line', {
                x1: x, y1: yTop, x2: x, y2: yBot,
                stroke: '#000', 'stroke-width': final ? 1.2 : 1
            }, this.gScroll);
            if (final) {
                // Barra final: fina + grossa, como manda a gravura.
                this._el('rect', { x: x + 3, y: yTop, width: 3.4, height: yBot - yTop, fill: '#000' }, this.gScroll);
            }
            // Número do compasso, alinhado à BARRA (não ao tempo forte): com o recuo, preso à
            // nota ele ficava à direita da própria barra que numera.
            const prox = ms[m.index + 1];
            if (prox && !prox.pickup) {
                const num = this.score.pickupBeats > Score.EPS ? prox.index : prox.index + 1;
                // 🔴 Com cifra, o número CEDE o lugar e sobe. A convenção de gravura é a
                // cifra colada na pauta (ela se lê junto com a música) e a referência de
                // compasso acima dela. Sem cifra, nada se move — é o que mantém a foto de
                // OG do jogo (calibrada em pixels) e o catálogo idênticos ao que já são.
                const yNum = this.hasHarmony() ? this.harmonyBandY() - s * 1.8 : yTop - s * 1.4;
                this._el('text', {
                    x: x + 3, y: yNum, 'font-size': s * 0.95,
                    'font-family': 'system-ui, sans-serif', fill: '#94a3b8'
                }, this.gScroll).textContent = String(num);
            }
        });
    }

    /** Uma cabeça com tudo que vem junto: suplementares, acidente, haste, bandeirola, ponto. */
    _drawNote(x, v, opts = {}) {
        const y = this.staff.getY(v.position);
        const up = opts.up !== undefined ? opts.up : v.stemUp;
        // 🔴 Capturamos pelos FILHOS do grupo, não por `rr.elements`: acidente (this._el) e
        // linha suplementar (MusicStaff) não empilham lá, então o feedback do jogo recoloria
        // menos da metade da nota. Contar filhos pega tudo, venha de onde vier.
        const before = this.gScroll.childNodes.length;

        this._withHost(this.gScroll, () => {
            this._drawLedgers(x, v.position);
            if (v.accidental) this._drawAccidental(x, y, v.accidental);

            // Sem figura = partitura que o validate já reprovou. Desenhar semínima calada
            // faria o DESENHO MENTIR sobre o ritmo; o aviso sai no setScore.
            const t = v.visualType || 'quarter';
            if (t === 'whole') {
                this.rr.drawNoteheadWhole(this.gScroll, x, y);
            } else if (t === 'half' || t === 'dotted-half') {
                this.rr.drawNoteheadEmpty(this.gScroll, x, y);
            } else {
                this.rr.drawNoteheadFilled(this.gScroll, x, y);
            }

            if (t !== 'whole' && !opts.noStemFlag) {
                // Convenção de gravura: nota em linha suplementar tem a haste ESTICADA até a
                // linha central. Com comprimento fixo, um Sol6 fica com uma hastezinha solta
                // no ar, sem ligação visual com a pauta que dá sentido à altura dele.
                const alvo = this.staff.getY(4);
                const len = Math.max(this.rr.STEM.height, Math.abs(alvo - y));
                this.rr.drawStem(this.gScroll, x, y, up, len);
                const flags = ScoreRenderer.BEAM_LEVEL[t] || 0;
                if (flags) this.rr.drawFlags(this.gScroll, x, y, flags, up, len);
            }

            // 🔴 O ponto mora no ESPAÇO: nota em cima de linha (posição PAR) sobe meio
            // espaço; nota que já está num espaço fica onde está. Sem isso o ponto
            // encosta na linha e some.
            if (/^dotted-/.test(t)) {
                const emLinha = (v.position % 2 === 0);
                this.rr.drawAugmentationDot(this.gScroll, x, y, emLinha ? -this.rr.STAFF.lineSpacing * 0.5 : 0);
            }
        });

        // 🔴 ACUMULA, não sobrescreve. Um nó-âncora de ligadura desenha N cabeças com a
        // MESMA chave (o beat do onset). Sobrescrevendo, só a ÚLTIMA cabeça ficava
        // registrada — e o feedback do jogo pintava de verde a continuação, do outro lado
        // da barra, deixando preta a cabeça que o aluno acabou de tocar. Ele leria isso
        // como "acertei uma nota que ainda não toquei". Acumulando, a nota inteira (que é
        // UMA nota, com N cabeças) acende junto, que é o que ela é.
        const chave = v.onsetBeat != null ? v.onsetBeat : v.beat;
        const novos = Array.prototype.slice.call(this.gScroll.childNodes, before);
        const antigos = this._noteEls.get(chave);
        this._noteEls.set(chave, antigos ? antigos.concat(novos) : novos);
    }

    _drawRest(x, v) {
        const t = v.visualType || 'quarter-rest';
        // Pausa pontuada = pausa base + ponto. O RhythmRenderer só conhece a de colcheia
        // pontuada; as de mínima e semínima pontuadas (compasso vazio em 3/4 e em 6/8) são
        // montadas aqui pela mesma receita.
        const BASE = { 'dotted-half-rest': 'half-rest', 'dotted-quarter-rest': 'quarter-rest' };
        this._withHost(this.gScroll, () => {
            this.rr.drawRest(x, this.staff.getY(4), BASE[t] || t, 0);
            if (BASE[t]) {
                const s = this.rr.STAFF.lineSpacing;
                // A pausa de mínima fica APOIADA na linha do meio; a de semínima, centrada.
                const yDot = this.staff.getY(t === 'dotted-half-rest' ? 5 : 4) - s * 0.5;
                this._el('circle', { cx: x + s * 1.1, cy: yDot, r: 2.1, fill: '#000' }, this.gScroll);
            }
        });
    }

    _drawLedgers(x, position) {
        const nh = this.rr.NOTEHEAD;
        const half = window.MusicStaff.ledgerHalfWidth(
            this.staff.config.lineSpacing, nh.rx, nh.ry, nh.angle);
        if (position < 0) for (let p = -2; p >= position; p -= 2) this.staff.drawLedgerLine(x, p, half);
        else if (position > 8) for (let p = 10; p <= position; p += 2) this.staff.drawLedgerLine(x, p, half);
    }

    _drawAccidental(x, y, kind) {
        const s = this.rr.STAFF.lineSpacing;
        this._el('text', {
            x: x - this.rr.NOTEHEAD.rx - s * 0.75, y: y + s * 0.36, 'font-size': s * 2.4,
            'font-family': 'Bravura, Times New Roman, serif', 'text-anchor': 'middle', fill: '#000'
        }, this.gScroll).textContent = ScoreRenderer.ACCIDENTAL_GLYPH[kind] || '';
    }

    /**
     * Barra de ligação INCLINADA (o RhythmRenderer.drawBeam é horizontal na linha do meio;
     * numa partitura com alturas ela tem de acompanhar o desenho melódico).
     *
     * Receita de gravura: reta pelas pontas das hastes das notas extremas, inclinação
     * LIMITADA (uma barra muito íngreme fica agressiva), e depois deslocada até nenhuma
     * haste ficar mais curta que o mínimo. Cada haste é então esticada até a reta.
     */
    _drawBeamGroup(group, visual, up) {
        if (group.length < 2) return;
        const s = this.rr.STAFF.lineSpacing;
        const dir = up ? -1 : 1;                 // p/ onde a haste cresce
        const MIN_STEM = s * 2.5;
        const IDEAL_STEM = this.rr.STEM.height;
        const MAX_SLOPE = 0.22;                  // ~1 espaço a cada 4,5 de avanço

        const xs = group.map(i => this.x(visual[i].beat) + (up ? this.rr.STEM.offsetX : -this.rr.STEM.offsetX));
        const ys = group.map(i => this.staff.getY(visual[i].position));

        // Reta tentativa pelas pontas ideais das notas extremas.
        const x1 = xs[0], x2 = xs[xs.length - 1];
        let yA = ys[0] + dir * IDEAL_STEM;
        let yB = ys[ys.length - 1] + dir * IDEAL_STEM;
        let slope = (x2 - x1) ? (yB - yA) / (x2 - x1) : 0;
        slope = Math.max(-MAX_SLOPE, Math.min(MAX_SLOPE, slope));

        const lineY = (x) => yA + slope * (x - x1);

        // Empurra a reta até TODA haste ter pelo menos MIN_STEM.
        let shift = 0;
        xs.forEach((x, k) => {
            const need = ys[k] + dir * MIN_STEM;         // ponta mínima aceitável
            const have = lineY(x);
            const falta = up ? (have - need) : (need - have); // >0 = sobra, <0 = curta
            if (falta > 0) shift = up ? Math.max(shift, falta) : Math.min(shift, -falta);
        });
        if (up && shift > 0) yA -= shift; else if (!up && shift < 0) yA -= shift;

        const yAt = (x) => yA + slope * (x - x1);

        // Hastes até a barra. Cada haste entra na lista da SUA nota, senão o feedback do
        // jogo recolore a cabeça e deixa a haste preta.
        this._withHost(this.gScroll, () => {
            group.forEach((i, k) => {
                const len = Math.abs(yAt(xs[k]) - ys[k]);
                const el = this.rr.drawStem(this.gScroll, this.x(visual[i].beat), ys[k], up, len);
                const chave = visual[i].onsetBeat != null ? visual[i].onsetBeat : visual[i].beat;
                const lista = this._noteEls.get(chave);
                if (lista) lista.push(el);
            });
        });

        // Barras: a primária cobre o grupo; as secundárias, só as runs daquele nível.
        const thickness = s * 0.5;
        // 🔴 0,75 espaço entre topos = 0,5 de barra + 0,25 de ar (medida de gravura). O
        // jogo de ritmo usa 0,62, que deixa 1,2px de branco — aceitável em barra HORIZONTAL,
        // mas com barra inclinada o antisserrilhado fecha essa fresta e o beam duplo vira
        // um borrão só. Aqui a barra é inclinada, então vale a medida certa.
        const gap = s * 0.75;
        const half = this.rr.STEM.width / 2;
        const levelOf = (k) => ScoreRenderer.BEAM_LEVEL[visual[group[k]].visualType] || 1;
        const bar = (xL, xR, level) => {
            // 🔴 As barras SECUNDÁRIAS empilham na direção das CABEÇAS, não para fora: a
            // primária mora na ponta da haste e as de baixo nível voltam em direção à
            // nota. Empilhar para fora afasta a semicolcheia da própria cabeça e o grupo
            // deixa de se ler como um bloco. Por isso `-dir`, não `dir`.
            const off = -dir * (level - 1) * gap;
            const yl = yAt(xL) + off, yr = yAt(xR) + off;
            // Paralelogramo: acompanha a inclinação sem deformar a espessura.
            this._el('polygon', {
                points: `${xL},${yl} ${xR},${yr} ${xR},${yr + thickness} ${xL},${yl + thickness}`,
                fill: '#000'
            }, this.gScroll);
        };

        bar(x1 - half, x2 + half, 1);
        const maxLevel = Math.max(...group.map((_, k) => levelOf(k)));
        for (let L = 2; L <= maxLevel; L++) {
            let k = 0;
            while (k < group.length) {
                if (levelOf(k) < L) { k++; continue; }
                let j = k;
                while (j + 1 < group.length && levelOf(j + 1) >= L) j++;
                const stub = s * 0.9;
                if (j > k) bar(xs[k] - half, xs[j] + half, L);
                else if (k > 0) bar(xs[k] - stub, xs[k] + half, L);
                else bar(xs[k] - half, xs[k] + stub, L);
                k = j + 1;
            }
        }
    }

    // ================= utilidades para o jogo (Etapa 3) =================

    /** Recolore uma nota inteira (feedback de acerto/erro): cabeça, haste, acidente, beam. */
    colorNoteAt(beat, color) {
        const els = this._noteEls.get(beat);
        if (!els) return false;
        els.forEach(el => {
            const fill = el.getAttribute('fill');
            // 🔴 Cabeça VAZIA (mínima/semibreve) tem fill branco: pintá-la de cor a deixa
            // sólida, e ela passa a se ler como semínima. Numa partitura a figura é
            // informação; o feedback não pode reescrevê-la. Nessas, só o contorno muda.
            if (fill && fill !== 'none' && fill.toLowerCase() !== '#fff' && fill.toLowerCase() !== '#ffffff') {
                el.setAttribute('fill', color);
            }
            if (el.getAttribute('stroke')) el.setAttribute('stroke', color);
        });
        return true;
    }

    /**
     * Pinta uma nota e MANTÉM a cor através das rolagens de janela.
     *
     * É a API que o jogo usa; `colorNoteAt` sozinha pinta só o que está materializado
     * AGORA e perde a cor na próxima rematerialização (ver renderWindow).
     *
     * @param {number} beat - o `beat` do nó-âncora LIDO DO SCORE (ver `_noteEls`)
     * @param {string|null} color - cor, ou null para esquecer a marca (volta ao preto)
     */
    markNote(beat, color) {
        if (color) this._marks.set(beat, color);
        else this._marks.delete(beat);
        return this.colorNoteAt(beat, color || '#000');
    }

    /** Esquece todas as marcas e devolve a partitura ao preto (nova rodada). */
    clearMarks() {
        const beats = Array.from(this._marks.keys());
        this._marks.clear();
        beats.forEach(b => this.colorNoteAt(b, '#000'));
    }

    clear() {
        [this.gScroll, this.gFixed].forEach(g => { while (g && g.firstChild) g.removeChild(g.firstChild); });
        this.rr.elements = [];
        this._noteEls = new Map();
        this._marks = new Map();
        this._window = null;
        this.nowChordEl = null;
        this._nowChordKey = null;
        this._nowChordRange = null;
        this._maxPos = 8;
        // 🔴 Zerar a partitura também: a promessa de `document.fonts.ready` sobrevive ao
        // clear e só desiste com `!this.score` — sem isto, a fonte chegando depois da troca
        // de tela REDESENHA a partitura num SVG que já devia estar morto.
        this.score = null;
        this._measuresCache = [];
    }

    /**
     * Desmonta de vez. Necessário porque o construtor cria camadas (`defs`, `clipPath`, 3
     * grupos) direto no SVG do MusicStaff e nunca as remove: um renderer novo sobre o mesmo
     * staff (uma troca de tela, um resize que reaproveite a pauta) EMPILHA camadas e deixa a
     * partitura anterior visível por baixo.
     */
    destroy() {
        this.clear();
        [this.gClip, this.gFixed].forEach(g => { if (g && g.parentNode) g.parentNode.removeChild(g); });
        if (this._clipRect && this._clipRect.parentNode) {
            const defs = this._clipRect.parentNode.parentNode; // rect → clipPath → defs
            if (defs && defs.parentNode) defs.parentNode.removeChild(defs);
        }
        this.gClip = this.gScroll = this.gFixed = this._clipRect = this.readLine = null;
        this.staff = null;
        this.rr = null;
    }
}

// Disponibiliza globalmente
if (typeof window !== 'undefined') window.ScoreRenderer = ScoreRenderer;



// ============================================
// components/score/HarmonyEditor.js
// ============================================
/**
 * HarmonyEditor — plantar, editar e apagar as CIFRAS de uma partitura (Etapa 7).
 *
 * MIDI não tem cifra, e é isso que falta para tocar a própria música lendo a melodia e
 * fazendo a harmonia junto. Aqui a pessoa escolhe em que compassos (ou meios compassos,
 * ou tempos) cada acorde entra.
 *
 * ─── DOM PURO: este arquivo NÃO desenha no SVG ───────────────────────────────────────
 *
 * Ele muda o `Score` e pede ao `ScoreRenderer` que redesenhe (`refresh`) ou role
 * (`scrollTo`). A cifra aparece na pauta porque está no MODELO, não porque o editor a
 * pintou — é a invariante da Etapa 7 e é o que faz a cifra sobreviver ao redesenho da
 * janela, à troca de andamento e ao replay. Consequência prática: nada aqui pode ficar
 * pendurado num nó SVG que a próxima janela vai remover.
 *
 * ─── 🔴 A SUPERFÍCIE É A GRADE DO CHART, NÃO A ESTEIRA ───────────────────────────────
 *
 * Medido em 360 px: a esteira mostra 5 semínimas — 1,25 compasso. Plantar cifra numa peça
 * de 32 compassos por ali seriam 25 páginas de tateio. A grade (compassos em caixas, o
 * acorde dentro) é a forma que a cifra já tem no mundo, cabe inteira numa tela rolável e
 * deixa tocar direto no compasso 17. A pauta fica em cima como REFERÊNCIA: ela segue a
 * célula selecionada para você conferir o que a melodia faz ali.
 *
 * ─── Dois toques, sempre ─────────────────────────────────────────────────────────────
 *
 *   tocar na célula → tocar na fundamental (só seleciona) → tocar na qualidade (planta)
 *
 * A qualidade é o COMMIT, e é ela que avança a seleção para a célula seguinte — é o que
 * faz `C F G C F G` ser rápido no dedo. Os chips de qualidade mostram a cifra INTEIRA com
 * a fundamental escolhida ("A", "Am", "Am7"…): você vê o que vai plantar antes de plantar,
 * e nenhuma palavra precisa ser traduzida.
 *
 * Plano: docs/CIFRAS-PLANO.md
 */
class HarmonyEditor {
    /** Grades de plantio. `per(m)` = quantas células o compasso `m` ganha. */
    static UNITS = ['measure', 'half', 'beat'];

    /**
     * Orçamento de largura por célula ao decidir as COLUNAS. 🔴 Não é a largura final: a
     * caixa do compasso ainda desconta `gap`, `padding` e `border`, então o alvo real fica
     * em ~68 px num celular de 360. É o número de onde as colunas saem, não uma promessa.
     */
    static MIN_CELL = 76;

    /** Altura mínima da célula: o alvo de toque de verdade (a largura já sobra). */
    static CELL_H = 44;

    /** Fundamentais. A grafia das cinco pretas depende do botão ♯/♭ (ver `_roots`). */
    static WHITE = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
    static BLACK_SHARP = [['C', 1], ['D', 1], ['F', 1], ['G', 1], ['A', 1]];
    static BLACK_FLAT  = [['D', -1], ['E', -1], ['G', -1], ['A', -1], ['B', -1]];

    /**
     * As qualidades que aparecem SEMPRE. As outras oito ficam atrás do "⋯".
     *
     * 🔴 Não é enfeite: com as 16 na tela, o painel comia 330 px de um celular de 780 —
     * e ele é grudado embaixo (ver `_paintPanel`), então esses pixels saem da GRADE, que
     * é por onde se navega a música. Estas oito cobrem quase todo chart de música popular,
     * e o meio-diminuto entra porque é vocabulário de jazz, não exceção.
     */
    static COMMON_CODES = ['maj', 'min', '7', 'min7', 'maj7', 'm7b5', 'dim', 'sus4'];

    static COLOR = { sel: '#6366f1', ink: '#0f172a', muted: '#94a3b8', line: '#e2e8f0' };

    /**
     * @param {Object} opts
     * @param {Score} opts.score
     * @param {ScoreRenderer} opts.renderer - só `scrollTo` e `refresh` são usados
     * @param {HTMLElement} opts.host - onde a grade e o painel são montados
     * @param {Function} opts.t - tradutor (k, params) => string
     * @param {Function} [opts.onChange] - chamado depois de toda mudança (o jogo persiste)
     * @param {Function} [opts.onDone] - "Pronto"
     */
    constructor(opts = {}) {
        this.score = opts.score;
        this.renderer = opts.renderer || null;
        this.host = opts.host;
        this._t = opts.t || ((k) => k);
        this.onChange = opts.onChange || (() => {});
        this.onDone = opts.onDone || (() => {});

        this.unit = 'measure';
        this.selected = 0;              // índice em `this._slots`
        /** Última cifra plantada — o que o botão "repetir" repete. */
        this.last = null;
        /** Fundamental em foco no painel (não planta sozinha; ver cabeçalho). */
        this.root = null;
        /** As 16 qualidades ou só as 8 comuns (ver COMMON_CODES). */
        this.showAll = false;
        /** A lista foi aberta PELA PESSOA ou automaticamente (cifra rara na célula)? */
        this._showAllManual = false;
        // Grafia default das teclas pretas: a da armadura. Peça em Fá maior mostra B♭, não
        // A♯ — mas o botão ♯/♭ existe porque cifra fora do tom é normal e a armadura não
        // decide sozinha.
        this.useFlats = ((this.score && this.score.keySignature
                          && this.score.keySignature.sharps) || 0) < 0;

        this._slots = [];
        this._els = {};
        this._destroyed = false;
    }

    // ---------- grade ----------

    /**
     * As células, na ordem da peça.
     *
     * 🔴 A grade "Tempo" usa `Notation.metricBeat` — o tempo MÉTRICO, não a semínima. Em
     * 6/8 o tempo é pontuado (1,5 semínima) e o compasso tem DOIS, não três. É a mesma
     * régua com que o beam agrupa as colcheias; duas cópias divergiriam e a página se
     * contradiria.
     */
    _buildSlots() {
        const N = window.Notation;
        const out = [];
        this.score.measures().forEach(m => {
            let n = 1;
            if (this.unit === 'half') n = 2;
            else if (this.unit === 'beat') {
                const u = N.metricBeat(this.score.timeSignatureAt(m.startBeat));
                n = Math.max(1, Math.round(m.quarters / u));
            }
            const step = m.quarters / n;
            for (let k = 0; k < n; k++) {
                out.push({ beat: m.startBeat + k * step, measure: m, sub: k, subs: n });
            }
        });
        this._slots = out;
        if (this.selected >= out.length) this.selected = Math.max(0, out.length - 1);
        return out;
    }

    /** Nº do compasso como o aluno o conta (a anacruse é o "0"). */
    _measureNumber(m) {
        return this.score.pickupBeats > window.Score.EPS ? m.index : m.index + 1;
    }

    /**
     * Colunas por linha. 🔴 Segue a GRADE, para o alvo nunca encolher: com 4 colunas fixas,
     * a grade "Tempo" daria células de 19 px num celular. Aqui o compasso inteiro é que
     * ocupa uma coluna, então quem divide as colunas é o nº de células do compasso.
     */
    _cols() {
        const w = (this.host && this.host.clientWidth) || 340;
        const subs = this._slots.length
            ? Math.max(...this._slots.map(s => s.subs)) : 1;
        const cabem = Math.floor(w / (HarmonyEditor.MIN_CELL * subs));
        return Math.max(1, Math.min(8, cabem));
    }

    // ---------- fundamentais ----------

    /** As 12, na ordem em que aparecem: 7 brancas numa fileira, 5 pretas na outra. */
    _roots(black) {
        if (!black) return HarmonyEditor.WHITE.map(l => ({ letter: l, alter: 0 }));
        const src = this.useFlats ? HarmonyEditor.BLACK_FLAT : HarmonyEditor.BLACK_SHARP;
        return src.map(([l, a]) => ({ letter: l, alter: a }));
    }

    _sameRoot(a, b) {
        return !!a && !!b && a.letter === b.letter && (a.alter | 0) === (b.alter | 0);
    }

    /** A fundamental que o painel usa agora: a em foco → a da célula → Dó. */
    _activeRoot() {
        if (this.root) return this.root;
        const h = this._chordAtSelected();
        if (h) return h.root;
        return { letter: 'C', alter: 0 };
    }

    _chordAtSelected() {
        const s = this._slots[this.selected];
        if (!s) return null;
        return this.score.harmony.find(
            h => Math.abs(h.beat - s.beat) < window.Score.EPS) || null;
    }

    // ---------- ações ----------

    select(i, { scroll = true } = {}) {
        if (i < 0 || i >= this._slots.length) return;
        this.selected = i;
        this.root = null;                 // a célula nova manda: o painel volta a segui-la
        // A pauta acompanha a seleção — é a referência do que a melodia faz naquele ponto.
        if (scroll && this.renderer) this.renderer.scrollTo(this._slots[i].beat);
        this._paintGrid();
        this._paintPanel();
        // Com a grade rolando na própria caixa, o avanço automático precisa trazer a
        // célula nova para o campo de visão — senão ele "some" para fora do quadro.
        if (scroll) this._revealSelected();
    }

    /** Planta a cifra na célula selecionada e ANDA. É o commit. */
    plant(code) {
        const s = this._slots[this.selected];
        if (!s) return;
        const root = this._activeRoot();
        if (!this.score.setChord(s.beat, { root, code })) return;
        this.last = { root, code };
        this._changed();
        // Avança. Na última célula fica onde está — não há para onde ir, e voltar ao
        // começo faria a próxima cifra cair no compasso 1 sem ninguém pedir.
        if (this.selected + 1 < this._slots.length) this.select(this.selected + 1);
        else { this._paintGrid(); this._paintPanel(); }
    }

    /** Traz a célula selecionada para dentro da caixa rolante da grade. */
    _revealSelected() {
        const g = this._els.grid;
        if (!g) return;
        const cell = g.querySelector(`[data-slot="${this.selected}"]`);
        // `block:'nearest'` move o mínimo necessário — não sacode a página quando a célula
        // já está visível, que é o caso comum.
        if (cell && cell.scrollIntoView) {
            try { cell.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) { /* jsdom */ }
        }
    }

    /** Repete a última cifra usada (um toque). */
    repeatLast() {
        if (!this.last) return;
        this.root = this.last.root;
        this.plant(this.last.code);
    }

    remove() {
        const s = this._slots[this.selected];
        if (!s || !this.score.removeChord(s.beat)) return;
        this._changed();
        this._paintGrid();
        this._paintPanel();
    }

    clearAll() {
        const n = this.score.harmony.length;
        if (!n) return;
        const ask = () => {
            this.score.harmony.length = 0;
            // 🔴 `clearedAll` chega ao `_saveHarmony`: só aqui as cifras guardadas FORA da
            // faixa corrente também vão embora. A pessoa pediu para limpar a música, não a faixa.
            this._changed({ clearedAll: true });
            this._paintGrid();
            this._paintPanel();
        };
        if (!window.notifications) return ask();
        const body = document.createElement('p');
        body.textContent = this._t('song.harmony.clearAllAsk', { n });
        body.style.cssText = 'text-align:center;color:#475569;line-height:1.5;';
        window.notifications.modal({
            title: this._t('song.harmony.clearAll'),
            node: body,
            actions: [
                { label: this._t('song.harmony.confirmClear'), style: 'primary', onClick: ask },
                { label: this._t('common.cancel'), style: 'neutral' }
            ],
            dismissible: true
        });
    }

    setUnit(unit) {
        if (HarmonyEditor.UNITS.indexOf(unit) < 0 || unit === this.unit) return;
        // Guarda o beat em foco para não perder o lugar quando a grade muda de resolução.
        const beat = this._slots[this.selected] ? this._slots[this.selected].beat : 0;
        this.unit = unit;
        this._buildSlots();
        let i = this._slots.findIndex(s => s.beat >= beat - window.Score.EPS);
        this.selected = i < 0 ? Math.max(0, this._slots.length - 1) : i;
        this.render();
    }

    /**
     * 🔴 Uma mudança de cifra NÃO move a janela da esteira, então `renderWindow` não roda
     * sozinha: sem o `refresh`, a cifra plantada só apareceria na pauta quando o compasso
     * saísse e voltasse. É também aqui que a persistência é pedida ao dono da tela — o
     * editor não conhece localStorage nem o arquivo de onde a peça veio.
     */
    _changed(info) {
        if (this.renderer) this.renderer.refresh();
        this.onChange(info || {});
    }

    // ---------- desenho ----------

    render() {
        if (this._destroyed || !this.host) return;
        this._buildSlots();
        this.host.innerHTML = '';

        const wrap = document.createElement('div');
        wrap.style.cssText = 'display:flex;flex-direction:column;gap:0.7rem;';

        wrap.appendChild(this._buildUnitRow());
        this._els.grid = document.createElement('div');
        wrap.appendChild(this._els.grid);
        this._els.panel = document.createElement('div');
        wrap.appendChild(this._els.panel);

        this.host.appendChild(wrap);
        this._paintGrid();
        this._paintPanel();
        if (this.renderer && this._slots[this.selected]) {
            this.renderer.scrollTo(this._slots[this.selected].beat);
        }
    }

    _chip(label, on, onClick, extra = '') {
        const b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        b.style.cssText = `min-width:0;min-height:44px;padding:0.5rem 0.3rem;border-radius:10px;
            border:2px solid ${on ? HarmonyEditor.COLOR.sel : HarmonyEditor.COLOR.line};
            background:${on ? HarmonyEditor.COLOR.sel : '#fff'};color:${on ? '#fff' : '#334155'};
            font-weight:700;font-size:0.95rem;cursor:pointer;line-height:1;${extra}`;
        b.addEventListener('click', onClick);
        return b;
    }

    _buildUnitRow() {
        const row = document.createElement('div');
        row.style.cssText = 'display:flex;gap:0.4rem;align-items:center;justify-content:center;flex-wrap:wrap;';
        const lab = document.createElement('span');
        lab.textContent = this._t('song.harmony.grid') + ':';
        lab.style.color = '#64748b';
        row.appendChild(lab);
        const seg = document.createElement('div');
        seg.style.cssText = 'display:inline-flex;border:2px solid #e2e8f0;border-radius:999px;overflow:hidden;';
        HarmonyEditor.UNITS.forEach(u => {
            const b = document.createElement('button');
            b.type = 'button';
            b.dataset.unit = u;
            b.textContent = this._t('song.harmony.grid_' + u);
            const on = u === this.unit;
            b.style.cssText = `padding:0.5rem 0.85rem;min-height:44px;border:none;cursor:pointer;font-weight:700;
                font-size:0.85rem;background:${on ? HarmonyEditor.COLOR.sel : 'transparent'};
                color:${on ? '#fff' : '#475569'};`;
            b.addEventListener('click', () => this.setUnit(u));
            seg.appendChild(b);
        });
        row.appendChild(seg);
        return row;
    }

    _paintGrid() {
        const g = this._els.grid;
        if (!g) return;
        g.innerHTML = '';
        // 🔴 A GRADE ROLA DENTRO DA PRÓPRIA CAIXA, e é isto que mantém o painel de acordes
        // sempre visível. A primeira tentativa foi `position:sticky` no painel; ela falhava
        // por DOIS motivos independentes, os dois medidos: (a) o `style.cssText` logo abaixo
        // apagava as propriedades; (b) `.song-game` tem `overflow-x:hidden`, o que computa
        // `overflow-y:auto` e cria um scrollport que não rola — e sticky dentro de scrollport
        // que não rola é inerte. Limitar a altura da grade resolve sem depender de nenhum
        // dos dois: numa peça de 32 compassos a tela inteira do editor continua cabendo.
        g.style.cssText = `display:grid;grid-template-columns:repeat(${this._cols()},1fr);
            gap:6px;align-items:stretch;max-height:42vh;overflow-y:auto;
            -webkit-overflow-scrolling:touch;padding:2px;`;

        // Uma caixa por COMPASSO; dentro dela, as células da grade escolhida.
        let i = 0;
        while (i < this._slots.length) {
            const first = this._slots[i];
            const box = document.createElement('div');
            box.style.cssText = `border:1px solid ${HarmonyEditor.COLOR.line};border-radius:10px;
                padding:3px;background:#fff;display:flex;flex-direction:column;gap:2px;min-width:0;`;

            const num = document.createElement('div');
            num.textContent = first.measure.pickup
                ? this._t('song.harmony.pickup') : String(this._measureNumber(first.measure));
            num.style.cssText = `font-size:0.68rem;color:${HarmonyEditor.COLOR.muted};
                padding-left:3px;line-height:1;`;
            box.appendChild(num);

            const subs = document.createElement('div');
            subs.style.cssText = `display:grid;grid-template-columns:repeat(${first.subs},1fr);gap:2px;`;
            for (let k = 0; k < first.subs && i < this._slots.length; k++, i++) {
                const slot = this._slots[i];
                const idx = i;
                const h = this.score.harmony.find(
                    x => Math.abs(x.beat - slot.beat) < window.Score.EPS);
                const on = idx === this.selected;
                const cell = document.createElement('button');
                cell.type = 'button';
                cell.dataset.beat = String(slot.beat);
                cell.dataset.slot = String(idx);
                cell.textContent = h ? h.symbol : '+';
                cell.style.cssText = `min-height:${HarmonyEditor.CELL_H}px;border-radius:7px;cursor:pointer;min-width:0;
                    border:2px solid ${on ? HarmonyEditor.COLOR.sel : 'transparent'};
                    background:${on ? '#eef2ff' : '#f8fafc'};
                    color:${h ? HarmonyEditor.COLOR.ink : HarmonyEditor.COLOR.muted};
                    font-weight:${h ? '800' : '400'};font-size:${h ? '0.95rem' : '1.1rem'};
                    padding:0.2rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`;
                cell.addEventListener('click', () => this.select(idx));
                subs.appendChild(cell);
            }
            box.appendChild(subs);
            g.appendChild(box);
        }
    }

    _paintPanel() {
        const p = this._els.panel;
        if (!p) return;
        p.innerHTML = '';
        // 🔴 Padding HORIZONTAL curto de propósito. Em 360 px as 7 fundamentais precisam de
        // 7×44 px + 6 vãos = 326 px, e cada 1 rem de padring lateral tira 16 px delas — com
        // 0,7 rem o alvo caía para 39 px. O respiro vertical fica; o lateral é da grade.
        p.style.cssText = `border:1px solid ${HarmonyEditor.COLOR.line};border-radius:12px;
            padding:0.7rem 0.3rem;background:#f8fafc;display:flex;flex-direction:column;gap:0.5rem;`;

        const slot = this._slots[this.selected];
        const atual = this._chordAtSelected();
        const root = this._activeRoot();

        // Onde estou + o que há aqui.
        const head = document.createElement('div');
        head.style.cssText = 'text-align:center;color:#475569;font-size:0.85rem;';
        head.textContent = slot
            ? this._t('song.harmony.at', {
                measure: slot.measure.pickup ? this._t('song.harmony.pickup')
                                             : this._measureNumber(slot.measure),
                chord: atual ? atual.symbol : '—'
              })
            : '';
        p.appendChild(head);

        // Fundamentais: brancas numa fileira, pretas na outra, e o botão que vira a grafia.
        // 🔴 GRADE, não `flex-wrap`. Com wrap, medido em 390 px, as 7 brancas não cabiam por
        // ~8 px e o Si caía sozinho numa segunda linha — o seletor perdia a cara de teclado
        // e ganhava uma fileira de um botão só. Em grade elas dividem a largura disponível e
        // sempre cabem numa linha, em qualquer tela.
        [false, true].forEach(black => {
            const row = document.createElement('div');
            row.style.cssText = `display:grid;
                grid-template-columns:repeat(${black ? 6 : 7},minmax(0,1fr));gap:3px;`;
            this._roots(black).forEach(r => {
                const b = this._chip(window.Score.rootLabel(r), this._sameRoot(r, root),
                    () => { this.root = r; this._paintPanel(); });
                // Endereço estável da fundamental, irmão do `data-code` das qualidades: o
                // rótulo é NEUTRO de idioma ("C", "B♭"), mas casar por texto tropeçaria na
                // grafia enarmônica, que o botão ♯/♭ troca em tempo de execução.
                b.dataset.root = window.Score.rootLabel(r);
                row.appendChild(b);
            });
            if (black) {
                row.appendChild(this._chip(this.useFlats ? '♯' : '♭', false, () => {
                    this.useFlats = !this.useFlats;
                    // A fundamental em foco acompanha a grafia se for uma tecla preta.
                    if (this.root && this.root.alter) {
                        const i = this._roots(true).findIndex(x =>
                            ((window.Notation.NATURAL_PC[x.letter] + x.alter) % 12 + 12) % 12 ===
                            ((window.Notation.NATURAL_PC[this.root.letter] + this.root.alter) % 12 + 12) % 12);
                        if (i >= 0) this.root = this._roots(true)[i];
                    }
                    this._paintPanel();
                }, 'font-size:1.05rem;'));
            }
            p.appendChild(row);
        });

        // Qualidades: cada chip mostra a CIFRA INTEIRA que será plantada. Nada a traduzir,
        // e você vê o resultado antes de commitar.
        const quals = document.createElement('div');
        // Mesma razão da fileira de fundamentais, e as colunas seguem a largura: 4 no
        // celular (16 acordes = 4 linhas cheias), 8 no desktop (2 linhas). Com wrap sobrava
        // sempre uma última linha de um chip só.
        const qc = Math.max(3, Math.min(8, Math.floor(((this.host && this.host.clientWidth) || 340) / 76)));
        quals.style.cssText = `display:grid;grid-template-columns:repeat(${qc},minmax(0,1fr));
            gap:3px;margin-top:0.2rem;`;
        const lista = this.showAll ? window.Chord.CHART_CODES : HarmonyEditor.COMMON_CODES;
        lista.forEach(code => {
            const label = window.Chord.chartSymbol(window.Score.rootLabel(root), code);
            const on = !!atual && atual.code === code && this._sameRoot(atual.root, root);
            const b = this._chip(label, on, () => this.plant(code), 'font-size:0.9rem;');
            b.dataset.code = code;
            quals.appendChild(b);
        });
        // A cifra plantada pode ser uma das escondidas: nesse caso a lista abre sozinha,
        // senão reabrir a célula não mostraria o acorde que está lá. 🔴 E FECHA sozinha ao
        // sair dessa célula — aberta para sempre, ela devolve 8 chips de altura roubados da
        // grade, que é a razão inteira de existir a lista curta.
        const raro = !!atual && HarmonyEditor.COMMON_CODES.indexOf(atual.code) < 0;
        if (!this.showAll && raro) { this.showAll = true; return this._paintPanel(); }
        if (this.showAll && !this._showAllManual && !raro) { this.showAll = false; return this._paintPanel(); }

        const mais = this._chip(this.showAll ? '−' : '⋯', false, () => {
            this.showAll = !this.showAll;
            this._showAllManual = this.showAll;
            this._paintPanel();
        }, 'font-size:1rem;');
        mais.dataset.act = 'more';
        quals.appendChild(mais);
        p.appendChild(quals);

        // Ações.
        const acts = document.createElement('div');
        acts.style.cssText = 'display:flex;gap:6px;justify-content:center;flex-wrap:wrap;margin-top:0.2rem;';
        const btn = (label, bg, onClick, id, disabled) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.textContent = label;
            if (id) b.dataset.act = id;
            b.disabled = !!disabled;
            b.style.cssText = `min-height:44px;padding:0.5rem 0.9rem;border:none;border-radius:10px;
                background:${bg};color:#fff;font-weight:700;font-size:0.9rem;
                cursor:${disabled ? 'default' : 'pointer'};opacity:${disabled ? 0.45 : 1};`;
            if (!disabled) b.addEventListener('click', onClick);
            return b;
        };
        acts.appendChild(btn('⟳ ' + this._t('song.harmony.repeat'), '#6366f1',
            () => this.repeatLast(), 'repeat', !this.last));
        acts.appendChild(btn('🗑 ' + this._t('song.harmony.delete'), '#ef4444',
            () => this.remove(), 'delete', !atual));
        acts.appendChild(btn(this._t('song.harmony.clearAll'), '#94a3b8',
            () => this.clearAll(), 'clearAll', !this.score.harmony.length));
        acts.appendChild(btn('✓ ' + this._t('song.harmony.done'), '#10b981',
            () => this.onDone(), 'done'));
        p.appendChild(acts);

        const count = document.createElement('div');
        count.dataset.role = 'count';
        count.style.cssText = `text-align:center;color:${HarmonyEditor.COLOR.muted};font-size:0.78rem;`;
        const n = this.score.harmony.length;
        count.textContent = this._t(n === 1 ? 'song.harmony.count_one' : 'song.harmony.count', { n });
        p.appendChild(count);
    }

    destroy() {
        this._destroyed = true;
        // Nada de listeners globais nem de nós SVG: os botões morrem com o host. O que
        // importa é soltar as referências — um editor vivo segurando um renderer destruído
        // é a mesma classe de bug que a promessa de `fonts.ready` já causou aqui.
        if (this.host) this.host.innerHTML = '';
        this.host = null;
        this.renderer = null;
        this.score = null;
        this._slots = [];
        this._els = {};
    }
}

// Disponibiliza globalmente
if (typeof window !== 'undefined') window.HarmonyEditor = HarmonyEditor;



// ============================================
// components/score/SongShelf.js
// ============================================
/**
 * SongShelf — a tela "Minhas músicas" (Etapa 8, docs/ESTANTE-PLANO.md).
 *
 * Lista o que está guardado no aparelho (`SongStore`) e abre a peça já cifrada em um
 * toque. Irmã do `HarmonyEditor` em tudo o que importa:
 *
 *   • **DOM PURO.** Não fala com o `Score`, nem com o renderer, nem com o localStorage.
 *     Recebe a lista pronta e devolve intenções por callback — quem tem estado é o jogo.
 *   • **Tela dentro do jogo**, não rota nova: `Main.GAMES`, `Beacon.GAME_ROUTES`, tabela
 *     de slugs, OG e ranking não sabem que ela existe.
 *   • `destroy()` solta tudo.
 *
 * 🔴 A LINHA INTEIRA É O BOTÃO DE ABRIR. O 🗑 é um botão de dentro, com `stopPropagation`
 * e alvo próprio: numa lista em que a linha toda navega, um ícone de apagar sem separação
 * de alvo é um toque distraído que apaga trabalho manual.
 */
class SongShelf {
    /** Alvo de toque mínimo do projeto. A linha vai bem acima disso (duas linhas de texto). */
    static MIN_TAP = 44;

    /**
     * @param {Object} o
     * @param {HTMLElement} o.host       onde desenhar
     * @param {function} o.t             tradutor (k, params) → string
     * @param {Array} o.songs            [{id, name, size, addedAt, lastOpenedAt, chords}]
     * @param {Array} o.catalog          peças do app [{id:'catalog:x', name, stars, chords}]
     * @param {string} o.currentId       id da peça aberta atrás desta tela (marca a linha)
     * @param {Object} o.back            {label, onBack} — saída para a peça aberta, no TOPO
     * @param {function} o.onOpen        (id) → abrir a peça
     * @param {function} o.onRemove      (song) → apagar (o jogo é quem confirma)
     * @param {function} o.onImportFile  → seletor de .mid
     * @param {function} o.onExport      → baixar o repertório
     * @param {function} o.onImportBackup→ ler um .json de repertório
     * @param {boolean}  o.canShare      o aparelho entrega arquivo a outro app? (rótulo)
     * @param {Object}   o.account       {loggedIn, count, max, busy, syncedAt} — estado da conta
     * @param {function} o.onSync        → sincronizar o repertório com a conta
     * @param {function} o.onLogin       → abrir o login
     * @param {function} o.onForget      (id, name) → tirar UMA música da conta
     */
    constructor(o = {}) {
        this.host = o.host;
        this.t = o.t || ((k) => k);
        this.songs = o.songs || [];
        /**
         * 🔴 As peças DO APP entram na mesma lista. Antes o catálogo morava numa rota e a
         * estante na outra: o ladrilho do ⊞ levava sempre à peça de demonstração e o
         * repertório da pessoa ficava atrás de um botão chamado "Importar MIDI".
         */
        this.catalog = o.catalog || [];
        this.currentId = o.currentId || null;
        this.back = o.back || null;
        this.onOpen = o.onOpen || (() => {});
        this.onRemove = o.onRemove || (() => {});
        this.onImportFile = o.onImportFile || (() => {});
        this.onExport = o.onExport || (() => {});
        this.onImportBackup = o.onImportBackup || (() => {});
        this.canShare = !!o.canShare;
        this.account = o.account || null;
        this.onSync = o.onSync || (() => {});
        this.onLogin = o.onLogin || (() => {});
        this.onForget = o.onForget || (() => {});
        /** Recado de uma operação (relatório do backup, estante cheia). `{text, tone}`. */
        this.notice = o.notice || null;
        this.el = null;
        this._destroyed = false;
    }

    /** "24 KB" · "1,2 MB" — o tamanho do arquivo, no idioma da pessoa. */
    _size(bytes) {
        const n = bytes || 0;
        if (n >= 1048576) return this.t('song.shelf.mb', { n: (n / 1048576).toFixed(1) });
        return this.t('song.shelf.kb', { n: Math.max(1, Math.round(n / 1024)) });
    }

    /** Data curta, pelo locale ativo (o `<html lang>` já é o do domínio). */
    _date(ts) {
        if (!ts) return '';
        try {
            return new Date(ts).toLocaleDateString(document.documentElement.lang || undefined,
                                                   { day: 'numeric', month: 'short' });
        } catch (e) { return ''; }
    }

    render() {
        if (this._destroyed || !this.host) return;
        // 🔴 A estante mora num nó PRÓPRIO dentro do host, e nunca limpa o host inteiro.
        // O host dela é o container da PAUTA (a lista ocupa o lugar da partitura enquanto
        // se escolhe a peça) — com `host.innerHTML = ''` no `destroy`, abrir uma música da
        // estante montava a pauta e o fechamento da estante, logo em seguida, a APAGAVA:
        // partitura carregada, tela vazia, nenhum erro no console. Pego pelo `harmony-test`.
        if (this.el) this.el.remove();

        const wrap = document.createElement('div');
        this.el = wrap;
        wrap.dataset.shelf = '1';
        wrap.style.cssText = 'max-width:520px;margin:0 auto;text-align:left;';

        // 🔴 A SAÍDA PARA A PEÇA ABERTA vem ANTES de tudo. Ela era o último elemento da
        // tela — depois das 60 linhas, do bloco de backup e da linha de privacidade — e é a
        // ação mais provável de quem entrou aqui sem querer no meio do estudo.
        if (this.back && this.back.label) {
            const volta = document.createElement('button');
            volta.type = 'button';
            volta.dataset.pickBack = '1';
            volta.textContent = '↩ ' + this.t('song.import.back', { file: this.back.label });
            volta.style.cssText = `display:block;width:100%;box-sizing:border-box;min-height:${SongShelf.MIN_TAP}px;
                padding:0.6rem 1rem;margin:0 0 0.6rem;border:1px solid #a7f3d0;border-radius:12px;cursor:pointer;
                background:#ecfdf5;color:#047857;font-weight:700;font-size:0.92rem;text-align:left;
                overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`;
            volta.addEventListener('click', () => (this.back.onBack || (() => {}))());
            wrap.appendChild(volta);
        }

        // Importar é o maior alvo: numa estante cheia, trazer a peça nova é o gesto mais
        // comum e não pode ficar depois de 60 linhas.
        //
        // 🔴 Mas com a estante VAZIA ele desce. Esta lista virou a PORTA de `#/musicas` (o
        // catálogo passou de uma peça), e quem chega pela primeira vez não tem `.mid`
        // nenhum para importar: no celular, o botão + a caixa de conta + "nada guardado
        // ainda" empurravam as músicas do app para baixo da dobra — a tela inteira era
        // sobre um arquivo que a pessoa não tem, e o que ela veio ver ficava escondido.
        const novo = document.createElement('button');
        novo.type = 'button';
        novo.dataset.shelfImport = '1';
        novo.textContent = '📂 ' + this.t('song.shelf.addFile');
        novo.style.cssText = `display:block;width:100%;box-sizing:border-box;min-height:52px;
            padding:0.85rem 1rem;margin:0 0 0.9rem;border:none;border-radius:12px;cursor:pointer;
            background:linear-gradient(135deg,#6366f1,#8b5cf6);color:#fff;font-weight:700;
            font-size:1rem;box-shadow:0 4px 12px rgba(0,0,0,0.15);`;
        novo.addEventListener('click', () => this.onImportFile());
        if (this.songs.length) wrap.appendChild(novo);

        if (this.notice && this.notice.text) {
            const n = document.createElement('div');
            const erro = this.notice.tone === 'error';
            n.dataset.shelfNotice = '1';
            n.textContent = this.notice.text;
            n.style.cssText = `margin:0 0 0.8rem;padding:0.6rem 0.8rem;border-radius:10px;font-size:0.85rem;
                line-height:1.45;background:${erro ? '#fef2f2' : '#f0fdfa'};
                border:1px solid ${erro ? '#fecaca' : '#99f6e4'};color:${erro ? '#b91c1c' : '#0f766e'};`;
            wrap.appendChild(n);
        }

        const conta = this._accountBar();

        const secaoApp = () => {
            if (!this.catalog.length) return;
            wrap.appendChild(this._sectionLabel(this.t('song.pick.app')));
            const doApp = document.createElement('div');
            doApp.style.cssText = 'display:flex;flex-direction:column;gap:0.5rem;';
            this.catalog.forEach(c => doApp.appendChild(this._catalogRow(c)));
            wrap.appendChild(doApp);
        };

        // 🔴 A ORDEM DEPENDE DE TER REPERTÓRIO, e é a mesma regra nas duas pontas: primeiro
        // o que a pessoa veio buscar. Com estante, são as músicas DELA (o catálogo fecha a
        // lista — é demonstração, não repertório de ninguém). Sem estante, as do app são a
        // única coisa que existe na tela, e tudo que fala de arquivo vai para baixo delas.
        if (!this.songs.length) {
            secaoApp();
            novo.style.marginTop = '1.1rem';   // não pode colar na última linha do catálogo
            wrap.appendChild(novo);
            const p = document.createElement('p');
            p.textContent = this.t('song.shelf.empty');
            p.style.cssText = 'color:#94a3b8;font-size:0.9rem;line-height:1.5;margin:0.6rem 0;';
            wrap.appendChild(p);
            if (conta) wrap.appendChild(conta);
        } else {
            if (conta) wrap.appendChild(conta);
            wrap.appendChild(this._sectionLabel(this.t('song.pick.mine')));
            const lista = document.createElement('div');
            lista.style.cssText = 'display:flex;flex-direction:column;gap:0.5rem;';
            this.songs.forEach(s => lista.appendChild(this._row(s)));
            wrap.appendChild(lista);
            secaoApp();
        }

        wrap.appendChild(this._backupBar());
        this.host.appendChild(wrap);
        return wrap;
    }

    /** Rótulo de seção — o que separa "as suas" do "do app" sem virar mais um botão. */
    _sectionLabel(texto) {
        const h = document.createElement('div');
        h.dataset.pickSection = '1';
        h.textContent = texto;
        h.style.cssText = `margin:0.9rem 0 0.35rem;font-size:0.72rem;font-weight:800;color:#94a3b8;
            text-transform:uppercase;letter-spacing:0.06em;`;
        return h;
    }

    /** A marca de "é esta que está aberta atrás desta tela". */
    _currentTag() {
        const tag = document.createElement('span');
        tag.dataset.pickCurrent = '1';
        tag.textContent = '▶ ' + this.t('song.pick.current');
        tag.style.cssText = `margin-left:0.4rem;font-size:0.7rem;font-weight:700;color:#4f46e5;
            background:#eef2ff;border-radius:999px;padding:0.1rem 0.45rem;white-space:nowrap;`;
        return tag;
    }

    /**
     * Linha do CATÁLOGO. Sem 🗑 — não é da pessoa, não se apaga; e com as estrelas, que só
     * existem aqui (peça importada não tem recorde: ninguém mais leu a mesma coisa).
     */
    _catalogRow(c) {
        const row = document.createElement('div');
        row.dataset.pickRow = c.id;
        const aberta = this.currentId && this.currentId === c.id;
        row.style.cssText = `display:flex;align-items:stretch;background:#fff;border-radius:12px;
            overflow:hidden;border:1px solid ${aberta ? '#c7d2fe' : '#e2e8f0'};`;

        const abrir = document.createElement('button');
        abrir.type = 'button';
        abrir.dataset.pickOpen = c.id;
        abrir.style.cssText = `flex:1;min-width:0;min-height:${SongShelf.MIN_TAP}px;text-align:left;
            background:none;border:none;cursor:pointer;padding:0.6rem 0.85rem;font:inherit;`;

        const nome = document.createElement('div');
        nome.style.cssText = `font-weight:700;color:#334155;font-size:0.95rem;line-height:1.3;
            display:flex;align-items:center;gap:0.1rem;overflow:hidden;`;
        const txt = document.createElement('span');
        txt.textContent = c.name || '';
        txt.style.cssText = 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
        nome.appendChild(txt);
        if (aberta) nome.appendChild(this._currentTag());
        abrir.appendChild(nome);

        const meta = document.createElement('div');
        const n = c.chords || 0;
        const partes = [];
        if (c.stars) partes.push('★'.repeat(c.stars) + '☆'.repeat(Math.max(0, 3 - c.stars)));
        if (n) partes.push('🎸 ' + this.t(n === 1 ? 'song.shelf.chords_one' : 'song.shelf.chords', { n }));
        meta.textContent = partes.join(' · ');
        // 🔴 Sempre uma segunda linha: sem estrela nem cifra, a linha do catálogo saía com
        // 46 px contra 57–64 px das do aluno — uma caixa branca com uma linha de texto, e é
        // ela SOZINHA que se vê numa conta nova. `☆☆☆` diz o que ainda não foi conquistado.
        if (!partes.length) partes.push('☆☆☆');
        meta.textContent = partes.join(' · ');
        meta.style.cssText = `color:#94a3b8;font-size:0.78rem;line-height:1.35;margin-top:0.15rem;
            overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`;
        abrir.appendChild(meta);

        abrir.addEventListener('click', () => this.onOpen(c.id));
        row.appendChild(abrir);
        return row;
    }

    _row(s) {
        const row = document.createElement('div');
        row.dataset.shelfRow = s.id;
        const aberta = this.currentId && this.currentId === s.id;
        row.style.cssText = `display:flex;align-items:stretch;gap:0.4rem;background:#fff;
            border:1px solid ${aberta ? '#c7d2fe' : '#e2e8f0'};border-radius:12px;overflow:hidden;`;

        const abrir = document.createElement('button');
        abrir.type = 'button';
        abrir.dataset.shelfOpen = s.id;
        abrir.style.cssText = `flex:1;min-width:0;min-height:${SongShelf.MIN_TAP}px;text-align:left;
            background:none;border:none;cursor:pointer;padding:0.6rem 0.2rem 0.6rem 0.85rem;font:inherit;`;

        const nome = document.createElement('div');
        nome.style.cssText = `font-weight:700;color:#334155;font-size:0.95rem;line-height:1.3;
            display:flex;align-items:center;gap:0.1rem;overflow:hidden;`;
        const txt = document.createElement('span');
        txt.textContent = s.name || this.t('song.shelf.untitled');
        txt.style.cssText = 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
        nome.appendChild(txt);
        if (aberta) nome.appendChild(this._currentTag());
        abrir.appendChild(nome);

        const meta = document.createElement('div');
        const n = s.chords || 0;
        // Chave PRÓPRIA e curta: `song.harmony.count` diz "{n} cifras nesta música", que
        // numa linha que já nomeia a música vira "prelude.mid · 12 cifras nesta música".
        const cifras = n === 0 ? this.t('song.shelf.noChords')
            : '🎸 ' + this.t(n === 1 ? 'song.shelf.chords_one' : 'song.shelf.chords', { n });
        meta.textContent = [cifras, this._size(s.size), this._date(s.lastOpenedAt || s.addedAt)]
            .filter(Boolean).join(' · ');
        // 🔴 `line-height` fixo: o emoji 🎸 estica a caixa de linha, e sem isto a lista
        // balançava entre 57 px (sem cifra) e 64 px (com) — visível com 20 músicas.
        meta.style.cssText = `color:${n ? '#0d9488' : '#94a3b8'};font-size:0.78rem;line-height:1.35;
            margin-top:0.15rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`;
        abrir.appendChild(meta);

        abrir.addEventListener('click', () => this.onOpen(s.id));
        row.appendChild(abrir);

        const apagar = document.createElement('button');
        apagar.type = 'button';
        apagar.dataset.shelfRemove = s.id;
        apagar.setAttribute('aria-label', this.t('song.shelf.remove'));
        apagar.title = this.t('song.shelf.remove');
        apagar.textContent = '🗑';
        apagar.style.cssText = `flex:0 0 ${SongShelf.MIN_TAP}px;min-width:${SongShelf.MIN_TAP}px;
            min-height:${SongShelf.MIN_TAP}px;background:none;border:none;border-left:1px solid #f1f5f9;
            cursor:pointer;font-size:1.05rem;color:#94a3b8;`;
        apagar.addEventListener('click', (e) => { e.stopPropagation(); this.onRemove(s); });
        row.appendChild(apagar);

        return row;
    }

    /**
     * A CONTA, no topo — a coisa que a pessoa procura primeiro (Etapa 9).
     *
     * 🔴 Duas coisas com nomes que não se confundem: aqui é "sua conta" (trocar de
     * aparelho); lá embaixo é "arquivo" (backup de verdade, e a única saída de quem não
     * tem conta). O defeito da versão anterior era um botão só, chamado "Exportar",
     * tentando ser as duas.
     */
    _accountBar() {
        const a = this.account;
        if (!a) return null;
        const box = document.createElement('div');
        box.dataset.accountBar = '1';
        box.style.cssText = `margin:0 0 0.9rem;padding:0.7rem 0.85rem;border-radius:12px;
            background:#f0f9ff;border:1px solid #bae6fd;`;

        if (!a.loggedIn) {
            // Convidado: NADA sobe, e a tela diz isso sem prometer o que não faz.
            const p = document.createElement('p');
            p.textContent = this.t('song.cloud.guest');
            p.style.cssText = 'margin:0 0 0.55rem;font-size:0.85rem;line-height:1.45;color:#075985;';
            box.appendChild(p);
            const b = document.createElement('button');
            b.type = 'button';
            b.dataset.cloudLogin = '1';
            b.textContent = this.t('song.cloud.login');
            b.style.cssText = `min-height:${SongShelf.MIN_TAP}px;padding:0.5rem 1rem;border-radius:10px;
                border:none;background:#0284c7;color:#fff;font-weight:700;font-size:0.9rem;cursor:pointer;`;
            b.addEventListener('click', () => this.onLogin());
            box.appendChild(b);
            return box;
        }

        const titulo = document.createElement('p');
        titulo.textContent = this.t('song.cloud.title');
        titulo.style.cssText = 'margin:0 0 0.2rem;font-size:0.9rem;font-weight:700;color:#075985;';
        box.appendChild(titulo);

        const estado = document.createElement('p');
        estado.dataset.cloudStatus = '1';
        estado.textContent = a.synced
            ? this.t('song.cloud.status', { n: a.count || 0, max: a.max || 0 })
            : this.t('song.cloud.notSynced');
        estado.style.cssText = 'margin:0 0 0.55rem;font-size:0.82rem;line-height:1.45;color:#0369a1;';
        box.appendChild(estado);

        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.cloudSync = '1';
        b.disabled = !!a.busy;
        b.textContent = a.busy ? this.t('song.cloud.syncing') : '↻ ' + this.t('song.cloud.syncNow');
        b.style.cssText = `min-height:${SongShelf.MIN_TAP}px;padding:0.5rem 1rem;border-radius:10px;
            border:none;background:${a.busy ? '#94a3b8' : '#0284c7'};color:#fff;font-weight:700;
            font-size:0.9rem;cursor:${a.busy ? 'default' : 'pointer'};`;
        b.addEventListener('click', () => { if (!a.busy) this.onSync(); });
        box.appendChild(b);

        // 🔴 A SAÍDA DO TETO. Sem isto, a conta enche em N e não há controle nenhum, em
        // lugar nenhum do app, que tire uma música de lá: quem pegar os lugares primeiro
        // fica com eles para sempre, e a peça cifrada de hoje recebe "não coube" toda vez.
        // O endpoint existia desde o primeiro dia; o botão é que não.
        if (Array.isArray(a.songs) && a.songs.length) {
            const rot = document.createElement('p');
            rot.textContent = this.t('song.cloud.inAccount');
            rot.style.cssText = 'margin:0.7rem 0 0.3rem;font-size:0.78rem;font-weight:700;color:#0369a1;';
            box.appendChild(rot);
            a.songs.forEach(sg => {
                const linha = document.createElement('div');
                linha.dataset.cloudRow = sg.id;
                linha.style.cssText = `display:flex;align-items:center;gap:0.5rem;padding:0.2rem 0;`;
                const nome = document.createElement('span');
                nome.textContent = sg.name || this.t('song.shelf.untitled');
                nome.style.cssText = 'flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:0.82rem;color:#075985;';
                linha.appendChild(nome);
                const x = document.createElement('button');
                x.type = 'button';
                x.dataset.cloudForget = sg.id;
                x.textContent = '✕';
                x.title = this.t('song.cloud.forget');
                x.setAttribute('aria-label', this.t('song.cloud.forget'));
                x.style.cssText = `min-width:${SongShelf.MIN_TAP}px;min-height:${SongShelf.MIN_TAP}px;
                    border:none;background:none;color:#0369a1;font-size:0.95rem;cursor:pointer;`;
                x.addEventListener('click', (e) => { e.stopPropagation(); this.onForget(sg.id, sg.name || ''); });
                linha.appendChild(x);
                box.appendChild(linha);
            });
        }

        // A nota diz o que a sincronia FAZ. Enquanto só a cifra viajava, ela precisava
        // avisar que o arquivo não — porque o outro aparelho mostrava o nome e não abria a
        // música, que foi exatamente o defeito relatado. Agora o arquivo vai junto e a
        // frase pode prometer o que a seção se chama.
        const nota = document.createElement('p');
        nota.textContent = this.t('song.cloud.note');
        nota.style.cssText = 'margin:0.55rem 0 0;font-size:0.76rem;line-height:1.45;color:#0891b2;';
        box.appendChild(nota);
        return box;
    }

    /**
     * Backup (§3 do plano). 🔴 O "importar repertório" também mora na tela de IMPORTAÇÃO,
     * não só aqui: num celular novo a estante está vazia, e restaurar seria impossível se
     * a única porta fosse a tela que só aparece com estante cheia.
     */
    _backupBar() {
        const box = document.createElement('div');
        box.style.cssText = 'margin-top:1.1rem;padding-top:0.9rem;border-top:1px solid #e2e8f0;';

        const linha = document.createElement('div');
        linha.style.cssText = 'display:flex;gap:0.5rem;flex-wrap:wrap;';
        const mk = (label, data, fn) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.dataset[data] = '1';
            b.textContent = label;
            b.style.cssText = `flex:1 1 140px;min-height:${SongShelf.MIN_TAP}px;padding:0.55rem 0.8rem;
                border:1px solid #cbd5e1;border-radius:10px;background:#f8fafc;color:#475569;
                font-weight:600;font-size:0.88rem;cursor:pointer;`;
            b.addEventListener('click', fn);
            return b;
        };
        // 🔴 O rótulo é uma PROMESSA. "Exportar" descrevia o mecanismo e não dizia para onde
        // — daí a estranheza de clicar e o arquivo aparecer no próprio aparelho. Agora cada
        // rótulo diz o que vai acontecer de fato naquele aparelho.
        linha.appendChild(mk(
            this.canShare ? '📤 ' + this.t('song.backup.share') : '⬇ ' + this.t('song.backup.export'),
            'backupExport', () => this.onExport()));
        linha.appendChild(mk('⬆ ' + this.t('song.backup.import'), 'backupImport', () => this.onImportBackup()));
        // Um "?" para a DUPLA: a dúvida é "o que este arquivo leva, e importar apaga
        // o que já tenho?" — pergunta do grupo, não de cada botão.
        if (window.HelpDot) linha.appendChild(new window.HelpDot('song.backup').el);
        box.appendChild(linha);

        const nota = document.createElement('p');
        nota.textContent = this.t('song.backup.note');
        nota.style.cssText = 'color:#94a3b8;font-size:0.76rem;line-height:1.45;margin:0.6rem 0 0;';
        box.appendChild(nota);
        return box;
    }

    destroy() {
        this._destroyed = true;
        // Só o próprio nó — ver `render()`. Quem limpa o host é quem o emprestou.
        if (this.el) this.el.remove();
        this.el = null;
        this.host = null;
        this.songs = [];
        this.catalog = [];
    }
}

// Disponibiliza globalmente
window.SongShelf = SongShelf;



// ============================================
// components/NoteFx.js
// ============================================
/**
 * NoteFx — vocabulário de feedback NÃO-CROMÁTICO para o modo Kids.
 *
 * 🔴 POR QUE ESTA CLASSE EXISTE: no Kids, COR = IDENTIDADE DA NOTA (paleta Boomwhacker,
 * a mesma na cabeça da nota e na tecla do piano). Logo, feedback de acerto/erro NÃO PODE
 * ser cor: verde e vermelho JÁ SÃO Fá e Dó, e repintar a nota/tecla apaga justamente o
 * que a criança está aprendendo. Aqui o sinal vive em OUTROS canais — movimento (♪
 * voando), forma (anel pontilhado) e brilho (halo na PRÓPRIA cor do objeto).
 *
 * Vocabulário único nas duas superfícies (pauta e piano), de propósito:
 *    ♪ subindo      = acertou
 *    anel pontilhado = não foi (forma neutra, sem matiz)
 *    halo na cor    = "é este aqui" (brilho realça sem trocar a cor)
 *    ♪ descendo     = costura pauta→tecla no momento didático ("a nota está ali ⇒ toca aqui")
 *
 * Todos os efeitos são EFÊMEROS: criam elementos numa camada de fx, animam com WAAPI e
 * se removem sozinhos no fim. `clear(layer)` é a rede de segurança ao parar/trocar de tela.
 *
 * Acessibilidade: `reduced()` honra prefers-reduced-motion — o feedback continua
 * existindo (nunca some), mas degrada para opacidade/pose estática, sem deslocamento.
 *
 * 🔴 REGRA DO EIXO Y (pauta): nenhum efeito pode deslocar a NOTA verticalmente — a altura
 * é o que se está aprendendo a ler; mover a nota em Y comunicaria outra altura. Tremor é
 * sempre em X. As partículas sobem, mas são objetos à parte, não a nota.
 */
class NoteFx {
    static SVG_NS = 'http://www.w3.org/2000/svg';
    static GLYPHS = ['♪', '♫', '♬', '♪', '♩'];
    static NEUTRAL = '#334155';   // grafite do anel pontilhado (fora da paleta Boomwhacker)

    /** prefers-reduced-motion ativo? (checado a cada uso: o usuário pode mudar em tempo real) */
    static reduced() {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    /**
     * Cria/garante uma camada <g> de efeitos.
     * `before` (opcional) = nó do pai antes do qual a camada fica — usado no piano p/
     * pôr o HALO ABAIXO das teclas pretas: por cima delas, o brilho vira uma mancha
     * translúcida em vez de brilho. Sem `before`, a camada vai pro topo da pilha.
     */
    static layer(parentSvg, cls = 'note-fx', before = null) {
        if (!parentSvg) return null;
        let g = parentSvg.querySelector(`:scope > g.${cls}`);
        if (!g) {
            g = document.createElementNS(NoteFx.SVG_NS, 'g');
            g.setAttribute('class', cls);
            g.style.pointerEvents = 'none';
        }
        if (before && before.parentNode === parentSvg) parentSvg.insertBefore(g, before);
        else parentSvg.appendChild(g); // reanexar = manter no topo da pilha
        return g;
    }

    /** Remove tudo de uma camada (parar o jogo, trocar de tela, resize). */
    static clear(layer) {
        if (!layer) return;
        while (layer.firstChild) layer.removeChild(layer.firstChild);
    }

    /** Anima e auto-remove. Elemento some mesmo se a animação não for suportada. */
    static _run(el, frames, opts) {
        const done = () => { if (el && el.parentNode) el.parentNode.removeChild(el); };
        if (!el.animate) { setTimeout(done, opts.duration || 600); return; }
        const anim = el.animate(frames, opts);
        anim.onfinish = done;
        anim.oncancel = done;
    }

    /** Base de um elemento SVG de efeito: sem eventos, transform-box p/ escalar no centro. */
    static _el(layer, tag) {
        const el = document.createElementNS(NoteFx.SVG_NS, tag);
        el.style.pointerEvents = 'none';
        el.style.transformBox = 'fill-box';
        el.style.transformOrigin = 'center';
        layer.appendChild(el);
        return el;
    }

    // ---------- ACERTO: ♪ voando ----------

    /**
     * ♪ ♫ ♬ subindo a partir de (x,y), na cor do objeto que acertou.
     * `ceil` limita a subida (não invadir a esteira acima nem sair do viewBox).
     */
    static flyNotes(layer, x, y, color, opts = {}) {
        if (!layer) return;
        const reduced = NoteFx.reduced();
        const count = reduced ? 3 : (opts.count || 5);
        const rise = opts.rise || 46;
        const ceil = typeof opts.ceil === 'number' ? opts.ceil : 4; // y mínimo permitido
        for (let i = 0; i < count; i++) {
            const t = NoteFx._el(layer, 'text');
            t.setAttribute('x', x);
            t.setAttribute('y', y);
            t.setAttribute('text-anchor', 'middle');
            t.setAttribute('font-size', 13 + (i % 3) * 4);
            t.setAttribute('font-weight', '700');
            t.setAttribute('font-family', "'Times New Roman', serif");
            // a 4ª partícula é grafite: garante contraste sobre QUALQUER cor de fundo
            t.setAttribute('fill', i % 4 === 3 ? NoteFx.NEUTRAL : color);
            t.textContent = NoteFx.GLYPHS[i % NoteFx.GLYPHS.length];

            const ox = (i - (count - 1) / 2) * 11;
            const oy = -Math.max(0, Math.min(rise + (i % 3) * 14, y - ceil));
            if (reduced) {
                t.setAttribute('transform', `translate(${ox},${oy * 0.5})`);
                NoteFx._run(t, [{ opacity: 0 }, { opacity: 1, offset: 0.3 },
                    { opacity: 1, offset: 0.7 }, { opacity: 0 }], { duration: 700 });
            } else {
                NoteFx._run(t, [
                    { transform: 'translate(0px,0px) scale(.5)', opacity: 0 },
                    { transform: `translate(${ox * 0.5}px,${oy * 0.45}px) scale(1)`, opacity: 1, offset: 0.35 },
                    { transform: `translate(${ox}px,${oy}px) scale(1)`, opacity: 0 }
                ], { duration: 900 + i * 60, easing: 'cubic-bezier(.25,.6,.35,1)' });
            }
        }
    }

    // ---------- ERRO: anel pontilhado (forma pura, zero matiz) ----------

    /** Anel pontilhado grafite pulsando 1× em volta de (x,y). Não preenche nada. */
    static dottedRing(layer, x, y, r = 17) {
        if (!layer) return;
        const c = NoteFx._el(layer, 'circle');
        c.setAttribute('cx', x); c.setAttribute('cy', y); c.setAttribute('r', r);
        c.setAttribute('fill', 'none');
        c.setAttribute('stroke', NoteFx.NEUTRAL);
        c.setAttribute('stroke-width', '2.5');
        c.setAttribute('stroke-dasharray', '5 5');
        if (NoteFx.reduced()) {
            NoteFx._run(c, [{ opacity: 0 }, { opacity: 0.95, offset: 0.25 },
                { opacity: 0.95, offset: 0.75 }, { opacity: 0 }], { duration: 800 });
        } else {
            NoteFx._run(c, [
                { transform: 'scale(.6)', opacity: 0 },
                { transform: 'scale(1)', opacity: 0.95, offset: 0.3 },
                { transform: 'scale(1.18)', opacity: 0.85, offset: 0.7 },
                { transform: 'scale(1.3)', opacity: 0 }
            ], { duration: 800, easing: 'ease-out' });
        }
    }

    // ---------- "É ESTE": halo na PRÓPRIA cor (camada DOM sobre o teclado) ----------
    //
    // 🔴 POR QUE DOM E NÃO SVG: dentro do <svg> do teclado o halo é CORTADO (a borda da
    // tecla coincide com o limite do viewBox) e some sob as teclas pretas — sobra um
    // contorninho na faixa de baixo, sem graça. Numa camada DOM por cima nada corta: o
    // brilho envolve a tecla inteira e VAZA para fora do teclado, que é o efeito bonito.
    // `box` = { left, top, w, h } em px, relativo ao host.

    /** Halo em volta de uma tecla, na cor DELA. `pulses` 1 = acerto; 2-3 = "é este aqui". */
    static haloBox(host, box, color, pulses = 1) {
        if (!host) return;
        const d = document.createElement('div');
        // o contorno BRANCO por dentro é o que separa o brilho da tecla (mesma cor),
        // sem introduzir matiz nova — branco não é nota nenhuma.
        d.style.cssText = `position:absolute;left:${box.left}px;top:${box.top}px;` +
            `width:${box.w}px;height:${box.h}px;border:3px solid ${color};border-radius:7px;` +
            `box-sizing:border-box;pointer-events:none;will-change:transform,opacity;` +
            `box-shadow:0 0 16px 4px ${color}, inset 0 0 0 2px rgba(255,255,255,.85);`;
        host.appendChild(d);
        if (NoteFx.reduced()) {
            NoteFx._run(d, [{ opacity: 0 }, { opacity: 1, offset: 0.2 },
                { opacity: 1, offset: 0.8 }, { opacity: 0 }], { duration: 500 + pulses * 300 });
            return;
        }
        const frames = [];
        for (let i = 0; i < pulses; i++) {
            frames.push({ transform: 'scale(1)', opacity: 0.25 });
            frames.push({ transform: 'scale(1.06)', opacity: 1 });
            frames.push({ transform: 'scale(1)', opacity: 0.25 });
        }
        frames.push({ transform: 'scale(1.1)', opacity: 0 });
        NoteFx._run(d, frames, { duration: 420 * pulses + 180, easing: 'ease-in-out' });
    }

    /** Erro: mesma caixa, contorno pontilhado grafite. Forma pura, zero matiz. */
    static dottedBoxEl(host, box) {
        if (!host) return;
        const d = document.createElement('div');
        d.style.cssText = `position:absolute;left:${box.left}px;top:${box.top}px;` +
            `width:${box.w}px;height:${box.h}px;border:3px dashed ${NoteFx.NEUTRAL};` +
            `border-radius:7px;box-sizing:border-box;pointer-events:none;will-change:transform,opacity;`;
        host.appendChild(d);
        NoteFx._run(d, NoteFx.reduced()
            ? [{ opacity: 0 }, { opacity: 1, offset: 0.25 }, { opacity: 1, offset: 0.8 }, { opacity: 0 }]
            : [{ transform: 'scale(.94)', opacity: 0 }, { transform: 'scale(1)', opacity: 1, offset: 0.3 },
               { transform: 'scale(1.05)', opacity: 0.9, offset: 0.7 }, { transform: 'scale(1.08)', opacity: 0 }],
            { duration: 760, easing: 'ease-out' });
    }

    // ---------- costura pauta → tecla ----------

    /** ♪ que DESCE (vinda da pauta) e pousa sobre a tecla certa. Ensina a relação. */
    static landNote(layer, x, fromY, toY, color) {
        if (!layer) return 0;
        const t = NoteFx._el(layer, 'text');
        t.setAttribute('x', x);
        t.setAttribute('y', fromY);
        t.setAttribute('text-anchor', 'middle');
        t.setAttribute('font-size', '22');
        t.setAttribute('font-weight', '700');
        t.setAttribute('font-family', "'Times New Roman', serif");
        t.setAttribute('fill', color);
        t.textContent = '♪';
        const d = toY - fromY;
        if (NoteFx.reduced()) {
            t.setAttribute('transform', `translate(0,${d})`);
            NoteFx._run(t, [{ opacity: 0 }, { opacity: 1, offset: 0.25 },
                { opacity: 1, offset: 0.8 }, { opacity: 0 }], { duration: 900 });
            return 300;
        }
        NoteFx._run(t, [
            { transform: 'translate(0px,0px)', opacity: 0 },
            { transform: `translate(0px,${d * 0.2}px)`, opacity: 1, offset: 0.18 },
            { transform: `translate(0px,${d}px)`, opacity: 1, offset: 0.62 },
            { transform: `translate(0px,${d * 0.86}px)`, opacity: 1, offset: 0.78 },
            { transform: `translate(0px,${d}px)`, opacity: 0 }
        ], { duration: 1050, easing: 'cubic-bezier(.3,.1,.3,1)' });
        return 650; // quando o halo deve entrar (a ♪ já pousou)
    }

    // ---------- tremor ----------

    /** Tremor horizontal curto. 🔴 SEMPRE em X: mexer em Y mentiria sobre a altura. */
    static shakeX(el, amp = 4) {
        if (!el || !el.animate) return;
        if (NoteFx.reduced()) {
            el.animate([{ opacity: 1 }, { opacity: 0.5, offset: 0.4 }, { opacity: 1 }], { duration: 400 });
            return;
        }
        el.animate([
            { transform: 'translateX(0)' }, { transform: `translateX(${-amp}px)` },
            { transform: `translateX(${amp}px)` }, { transform: `translateX(${-amp / 2}px)` },
            { transform: 'translateX(0)' }
        ], { duration: 240, easing: 'ease-out' });
    }

    // ---------- superfícies DOM (botões de resposta) ----------

    /** Halo num elemento DOM (botão), na cor dele. Mesma gramática do halo do piano. */
    static haloEl(el, color, pulses = 1) {
        if (!el || !el.animate) return;
        const glow = NoteFx.rgba(color, 0.75);
        if (NoteFx.reduced()) {
            el.animate([{ boxShadow: `0 0 0 0 ${glow}` }, { boxShadow: `0 0 0 6px ${glow}` },
                { boxShadow: `0 0 0 0 ${NoteFx.rgba(color, 0)}` }], { duration: 500 + pulses * 250 });
            return;
        }
        const frames = [];
        for (let i = 0; i < pulses; i++) {
            frames.push({ boxShadow: `0 0 0 0 ${glow}` });
            frames.push({ boxShadow: `0 0 0 9px ${NoteFx.rgba(color, 0.35)}` });
        }
        frames.push({ boxShadow: `0 0 0 14px ${NoteFx.rgba(color, 0)}` });
        el.animate(frames, { duration: 420 * pulses + 180, easing: 'ease-out' });
    }

    /** Anel pontilhado num elemento DOM: overlay temporário (não mexe no fundo do botão). */
    static dottedEl(el) {
        if (!el) return;
        const prevPos = el.style.position;
        if (!prevPos || prevPos === 'static') el.style.position = 'relative';
        const ov = document.createElement('span');
        ov.style.cssText = 'position:absolute;inset:-4px;border:3px dashed ' + NoteFx.NEUTRAL +
            ';border-radius:inherit;pointer-events:none;';
        el.appendChild(ov);
        NoteFx._run(ov, NoteFx.reduced()
            ? [{ opacity: 0 }, { opacity: 1, offset: 0.25 }, { opacity: 1, offset: 0.8 }, { opacity: 0 }]
            : [{ transform: 'scale(.94)', opacity: 0 }, { transform: 'scale(1)', opacity: 1, offset: 0.3 },
               { transform: 'scale(1.06)', opacity: 0.9, offset: 0.7 }, { transform: 'scale(1.1)', opacity: 0 }],
            { duration: 760, easing: 'ease-out' });
    }

    /** '#rrggbb' → 'rgba(r,g,b,a)' (box-shadow precisa de alfa p/ o halo respirar). */
    static rgba(hex, alpha) {
        const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
        if (!m) return `rgba(100,116,139,${alpha})`;
        return `rgba(${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)},${alpha})`;
    }
}

// Disponibiliza globalmente
window.NoteFx = NoteFx;



// ============================================
// components/LevelPill.js
// ============================================
/**
 * LevelPill - o botão de UM nível na fileira da trilha (1, 2, 3…).
 *
 * Existe para a trilha se ler como TRILHA, não como cerca: o número aparece sempre —
 * trancado é o mesmo número apagado, com borda tracejada — e embaixo vai o melhor
 * resultado da pessoa naquele nível (verde quando bateu a meta, âmbar quando não).
 *
 * 🔴 Sem emoji de cadeado, de propósito: `🔒` é dourado numa paleta que não tem
 * dourado, muda de desenho a cada sistema operacional e esconde o número — nove
 * cadeados em fila é a primeira coisa que o jogador novo via em Acordes.
 *
 * Só DESENHA: não sabe de nível, de gate de conta nem de storage. Quem chama decide
 * `locked`/`active`/`best` e pendura o clique. Um lugar só para os jogos com trilha
 * (hoje Intervalos e Acordes; Leitura e Ritmo ainda desenham o deles).
 */
class LevelPill {
    /**
     * @param {object} o
     * @param {number}  o.n       número do nível (1-based, o que a pessoa lê)
     * @param {boolean} o.locked  ainda não liberado (desabilitado, apagado, tracejado)
     * @param {boolean} o.active  é o nível selecionado
     * @param {object}  [o.best]  melhor take: { acc, passed } (o formato do LevelProgress)
     * @param {string}  [o.title] tooltip
     * @returns {HTMLButtonElement}
     */
    static make({ n, locked, active, best = null, title = '' }) {
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.nivel = String(n);   // endereço do picker para as medições do teste
        b.disabled = !!locked;
        if (title) b.title = title;
        if (locked) b.dataset.locked = '1';

        // 44×44: o alvo de dedo do projeto. Coluna: número em cima, resultado embaixo.
        const border = active ? '2px solid #6366f1' : (locked ? '2px dashed #e2e8f0' : '2px solid #e2e8f0');
        const bg = active ? 'linear-gradient(135deg,#6366f1,#8b5cf6)' : (locked ? '#f8fafc' : '#fff');
        const color = active ? '#fff' : (locked ? '#cbd5e1' : '#334155');
        b.style.cssText = `width:44px;height:44px;padding:0;border-radius:10px;cursor:${locked ? 'not-allowed' : 'pointer'};
            display:inline-flex;flex-direction:column;align-items:center;justify-content:center;line-height:1;
            border:${border};background:${bg};color:${color};`;

        const num = document.createElement('span');
        num.textContent = String(n);
        num.style.cssText = 'font-weight:800;font-size:1rem;';
        b.appendChild(num);

        // O melhor % só aparece onde HOUVE take — nível nunca jogado fica só com o número.
        const acc = best && Number.isFinite(best.acc) ? Math.round(best.acc) : null;
        if (acc !== null) {
            const sub = document.createElement('span');
            sub.dataset.best = String(acc);
            sub.textContent = acc + '%';
            const tone = best.passed ? '#059669' : '#d97706';
            sub.style.cssText = `font-size:0.6rem;font-weight:700;margin-top:2px;color:${active ? 'rgba(255,255,255,0.9)' : tone};`;
            b.appendChild(sub);
        }
        return b;
    }
}

window.LevelPill = LevelPill;



// ============================================
// components/piano/PianoKeyboard.js
// ============================================
/**
 * PianoKeyboard - Teclado de piano SVG, reutilizável e desacoplado.
 *
 * Componente de UI puro de entrada: desenha teclas brancas/pretas de qualquer
 * extensão, captura toques (pointer/mouse/touch), toca o som e EMITE a nota via
 * callback `onKeyPress(info, ev)` — onde `info` é o contrato de PitchUtil.info().
 * NÃO sabe nada de "pergunta/resposta": quem usa decide o que fazer com a nota.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * 🔴 CONTRATO DE ENTRADA (documentado AQUI, a fonte mais antiga; as irmãs
 *    KeyboardInput · MicPitchInput · MidiPitchInput apontam para cá)
 *
 *      onKeyPress(info, ev)
 *
 *   `info` — QUAL nota (PitchUtil.info): midi, sci, letter, octave, frequency…
 *            É a carteira de identidade da altura. Pode ser guardada e reusada
 *            (este componente guarda uma por tecla desde o render).
 *
 *   `ev`   — O ACONTECIMENTO. Objeto NOVO a cada toque, descartável:
 *              { at, timed, source, velocity }
 *            • `at`       instante no RELÓGIO DE ÁUDIO (audioManager.now(), s).
 *                         null se não há AudioContext.
 *            • `timed`    o instante serve para MEDIR RITMO? true nas superfícies
 *                         que reagem ao gesto físico (esta, teclado do PC, MIDI);
 *                         false no microfone, que detecta a altura ~50–120 ms
 *                         depois do ataque — mais que a janela perfeita de ±45 ms
 *                         do RhythmScorer. Quem pontua ritmo pergunta por `timed`,
 *                         nunca pelo nome da fonte.
 *            • `source`   'piano' | 'keyboard' | 'mic' | 'midi' (diagnóstico/UI).
 *            • `velocity` 0..1 — real no MIDI, 1 onde não há dinâmica.
 *
 * 🔴 Por que o instante vem SEPARADO e não carimbado dentro de `info`: `info` é
 *    identidade e sobrevive (ver `this.keys`); `ev` é acontecimento e morre no
 *    mesmo instante em que nasce. Carimbar hora numa identidade guardada produz,
 *    mais cedo ou mais tarde, um horário velho lido como novo.
 *
 * 🔴 Quem só declara `onKeyPress(info)` NÃO precisa mudar nada — o JavaScript
 *    descarta o argumento extra. Foi assim que os 4 jogos anteriores atravessaram
 *    esta mudança sem uma linha alterada.
 *
 * Ponto de extensão previsto (ainda NÃO implementado): `onKeyRelease(info, ev)`
 * para pontuar DURAÇÃO. Fora do v1 do jogo de música real de propósito.
 * ─────────────────────────────────────────────────────────────────────────────
 *
 * Robusto p/ crescimento: extensão configurável (minSci/maxSci), rótulos
 * (solfejo/letra/nenhum), API de feedback visual (flashKey/flashByLetter) e
 * habilitar/desabilitar. Serve para leitura de pauta hoje e intervalos/acordes/
 * melodia amanhã.
 *
 * Convenções de input espelham o RhythmTapButton (Pointer Events + captura).
 */
class PianoKeyboard {
    constructor(container, options = {}) {
        this.container = container;
        this.opts = {
            minSci: options.minSci || 'C4',
            maxSci: options.maxSci || 'B4',
            labelType: options.labelType || 'solfege', // 'solfege' | 'letter' | 'none'
            // labelFn(info) → texto do rótulo. Override opcional p/ rótulos localizados
            // (i18n: EN letras, PT 'Dó', ES 'Do'). Quando ausente, usa labelType.
            labelFn: typeof options.labelFn === 'function' ? options.labelFn : null,
            playSound: options.playSound !== false,
            onKeyPress: options.onKeyPress || null,
            // 2 fileiras EMPILHADAS (grave embaixo, agudo em cima). Sem isto, teclado de 2
            // oitavas em tela de 360px dá ~26px por branca (pretas ~16px) — e num jogo em
            // que a oitava vale nota, o dedo que escorrega pra vizinha conta ERRO, ou seja,
            // a tela suja a métrica. Quem decide ligar é o jogo, não o componente.
            rows: options.rows === 2 ? 2 : 1
        };

        // Geometria (coordenadas do viewBox; o SVG escala p/ a largura do container)
        this.GEO = {
            whiteW: 46,
            whiteH: 150,
            blackWRatio: 0.62,
            blackHRatio: 0.62
        };

        this.svg = null;
        this.enabled = true;
        this.keys = new Map();           // midi → { el, info, baseFill }
        this._flashTimers = new Map();   // midi → timeoutId
        this._fxTimers = [];             // timeouts da camada de fx (Kids) — limpos no destroy
        this._fxHostEl = null;           // camada DOM de fx (halo/pontilhado) por cima do teclado
        this._activePointers = new Map(); // pointerId → midi
        this._holds = new Map();         // midi → cor (destaque persistente, ex: nota-raiz)
    }

    // ---------- receita do PIANO DE RESPOSTA (estáticos, sem instância) ----------
    //
    // Como se monta um teclado para RESPONDER a uma pauta. Nasceu dentro da Leitura em
    // esteira; mudou de casa quando o jogo de música real precisou exatamente da mesma
    // receita. Ficar em dois lugares seria garantir que um dia divergissem — e a
    // divergência apareceria como "no jogo X a tecla `a` é outra nota".
    // 🔴 São ESTÁTICOS de propósito: não dependem de instância nenhuma, então o jogo os
    // consulta ANTES de existir um teclado (para dimensionar a tela, por exemplo).

    /** A partir de quantas brancas vale partir o teclado em duas fileiras. */
    static ROWS_MIN_WHITES = 12;
    /** Largura de viewport (px) abaixo da qual o aperto acontece. */
    static ROWS_MAX_WIDTH = 560;

    // Teclado do PC → BRANCAS, uma fileira POR OITAVA (7 graus cada):
    //   a s d f g h j  = Dó Ré Mi Fá Sol Lá Si da oitava mais grave em tela
    //   q w e r t y u  = as MESMAS letras uma oitava acima (q fica logo acima de a)
    // 🔴 Duas fileiras, e não uma esticada, por dois motivos. (1) Alcance: a fileira de
    // casa só tem 10 posições confiáveis — a 11ª e a 12ª cairiam em teclas MORTAS no
    // ABNT2 (`~` chega como e.key === 'Dead') ou fora da fileira no US (`\`), e o
    // jogador bateria numa tecla muda. (2) Metáfora: "mesmo dedo, fileira de cima = uma
    // oitava acima". Só letras ⇒ vale em qualquer layout, sem e.code.
    // `k` é ALIAS do Dó de cima (mesma tecla do KeyboardInput.DEFAULT_MAP).
    static KEYBOARD_ROWS = [
        ['a', 's', 'd', 'f', 'g', 'h', 'j'],
        [['q', 'k'], 'w', 'e', 'r', 't', 'y', 'u']
    ];

    /**
     * Extensão de um teclado de resposta que cobre [loMidi, hiMidi]: do **Dó igual ou
     * abaixo da nota mais grave** até a mais aguda, nunca menos que uma oitava cheia.
     *
     * 🔴 Não é o âmbito exato do conteúdo, de propósito. Um teclado com só as notas em
     * jogo entregaria a resposta por ELIMINAÇÃO (três teclas = impossível errar) e mataria
     * justamente o que se está treinando. Começar no Dó dá o ponto de orientação que todo
     * iniciante usa no teclado; o teto acompanha para que a tecla certa exista.
     *
     * @returns {{minSci:string, maxSci:string}}
     */
    static responseRange(loMidi, hiMidi) {
        const PU = window.PitchUtil;
        const lo = Number.isFinite(loMidi) ? loMidi : 64;
        const hi = Number.isFinite(hiMidi) ? Math.max(hiMidi, lo) : lo + 5;
        const baseC = lo - (((lo % 12) + 12) % 12);   // Dó igual ou abaixo da mais grave
        return { minSci: PU.sciFromMidi(baseC), maxSci: PU.sciFromMidi(Math.max(hi, baseC + 11)) };
    }

    /**
     * Quantas FILEIRAS o teclado usa. Único lugar que decide isto.
     *
     * 🔴 Em tela estreita, dois oitavas em fileira única dá ~26px por branca (pretas
     * ~16px). Num jogo em que a oitava vale nota, o dedo que escorrega pra vizinha conta
     * ERRO — a tela passaria a sujar a métrica. Com 2 fileiras, a branca volta pra ~44px.
     * No desktop segue fileira única: lá o espaço sobra e o teclado inteiro à vista é mais
     * legível que partido.
     */
    static rowsFor(minSci, maxSci, viewportWidth = null) {
        const whites = window.PitchUtil.range(minSci, maxSci).filter(n => !n.isBlack).length;
        const w = viewportWidth != null ? viewportWidth : (window.innerWidth || 1024);
        return (w < PianoKeyboard.ROWS_MAX_WIDTH && whites >= PianoKeyboard.ROWS_MIN_WHITES) ? 2 : 1;
    }

    /**
     * Mapa tecla-do-PC → nota científica para uma extensão.
     *
     * 🔴 Ancorado NO TECLADO EM TELA (que sempre começa num DÓ — ver `responseRange`), não
     * no conteúdo sorteado: `a` = a tecla mais grave em tela = SEMPRE Dó, a convenção do
     * projeto principal. Ancorar no conteúdo fazia `a` valer Mi4 num jogo cujo âmbito
     * começa em Mi — o jogador digitava Dó Ré Mi e ouvia Mi Fá Sol. As teclas "chamariz"
     * (as que o teclado mostra além do âmbito) também ganham atalho: paridade com o mouse,
     * e o erro pelo teclado passa a ser possível — do contrário o atalho entregaria a
     * resposta. Branca excedente às fileiras fica só no mouse/toque.
     */
    static keyMapFor(minSci, maxSci) {
        const whites = window.PitchUtil.range(minSci, maxSci).filter(n => !n.isBlack);
        const map = {};
        whites.forEach((info, i) => {
            const row = PianoKeyboard.KEYBOARD_ROWS[Math.floor(i / 7)];
            const slot = row && row[i % 7];
            if (!slot) return;
            (Array.isArray(slot) ? slot : [slot]).forEach((ch) => { map[ch] = info.sci; });
        });
        return map;
    }

    // ---------- render ----------

    /**
     * Divide as brancas em fileiras. 🔴 O corte é SEMPRE num Dó, por dois motivos: é o
     * ponto de orientação que o iniciante usa no teclado, e nenhuma tecla preta atravessa
     * a emenda (entre Si e Dó não existe preta) — a fileira de baixo termina inteira.
     * Sem um Dó interno onde cortar, devolve fileira única: melhor um teclado apertado
     * que um partido no lugar errado.
     */
    _rowGroups(whites) {
        if (this.opts.rows !== 2 || whites.length < 4) return [whites];
        // 🔴 O corte vai no PRIMEIRO Dó interno, e fica assim de propósito. Tentei cortar
        // pelo Dó mais próximo do meio para equilibrar as fileiras; MEDIDO em 3 oitavas
        // (22 brancas, container de 360px): 14+8 dá branca de 25,7px contra 24,0px do corte
        // no primeiro Dó. 1,7px — nada perto dos 44px de alvo — e o preço era desalinhar o
        // `keyMapFor`, que fatia o teclado do PC de 7 em 7 brancas assumindo que a emenda
        // visual cai no 7º: as duas fileiras de letras cairiam na mesma fileira DESENHADA e
        // a de cima ficaria muda. Teclado largo demais para duas fileiras se resolve
        // ESTREITANDO A FAIXA (é o que o jogo de Intervalos faz no modo descendente), não
        // remendando onde a emenda cai.
        const cut = whites.findIndex((n, i) => i > 0 && n.letter === 'C');
        if (cut <= 0) return [whites];
        return [whites.slice(0, cut), whites.slice(cut)];
    }

    render() {
        const notes = window.PitchUtil.range(this.opts.minSci, this.opts.maxSci);
        const whites = notes.filter(n => !n.isBlack);
        const { whiteW, whiteH, blackWRatio, blackHRatio } = this.GEO;
        const blackW = whiteW * blackWRatio;
        const blackH = whiteH * blackHRatio;

        const groups = this._rowGroups(whites);
        const rowGap = groups.length > 1 ? 10 : 0;
        // Largura = a da fileira MAIS LARGA (as duas escalam juntas, então a tecla tem o
        // mesmo tamanho nas duas — fileira curta fica com sobra à direita, não com tecla
        // maior, que faria a mesma nota mudar de tamanho conforme o nível).
        const totalW = Math.max.apply(null, groups.map(g => g.length)) * whiteW;
        const totalH = groups.length * whiteH + (groups.length - 1) * rowGap;

        this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.svg.setAttribute('viewBox', `0 0 ${totalW} ${totalH}`);
        this.svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        this.svg.style.display = 'block';
        this.svg.style.margin = '0 auto';
        this.svg.style.width = '100%';
        this.svg.style.maxWidth = totalW + 'px'; // não estoura o tamanho natural no desktop
        this.svg.style.height = 'auto';
        this.svg.style.touchAction = 'none';
        this.svg.style.userSelect = 'none';

        const maxMidi = window.PitchUtil.midiFromSci(this.opts.maxSci);

        groups.forEach((group, gi) => {
            // Grave EMBAIXO, agudo em cima — igual à pauta, onde o agudo sobe. Invertido
            // (grave em cima) o teclado leria ao contrário da notação que ele responde.
            const yTop = (groups.length - 1 - gi) * (whiteH + rowGap);

            // 1) brancas (fundo)
            group.forEach((info, i) => {
                const x = i * whiteW;
                this._key(info, x, yTop, whiteW, whiteH, '#ffffff', '#cbd5e1');
                this._label(info, x + whiteW / 2, yTop + whiteH - 10, '#374151');
            });

            // 2) pretas (sobrepostas na fronteira direita da branca, quando existe um
            //    sustenido logo acima dela, dentro da extensão E dentro desta fileira)
            group.forEach((info, i) => {
                const blackMidi = info.midi + 1;
                if (!window.PitchUtil.isBlack(blackMidi) || blackMidi > maxMidi) return;
                // Preta órfã pendurada na emenda entre fileiras. Só vale com 2 fileiras:
                // em fileira única este é o fim do teclado e o desenho de sempre continua.
                if (groups.length > 1 && i === group.length - 1) return;
                const bInfo = window.PitchUtil.info(blackMidi);
                const cx = (i + 1) * whiteW; // fronteira entre esta branca e a próxima
                this._key(bInfo, cx - blackW / 2, yTop, blackW, blackH, '#1f2937', '#0f172a');
            });
        });

        // Região VISÍVEL da tecla, em coordenadas do viewBox: onde a ♪ do "era esta"
        // pousa (ela vive DENTRO do SVG, que corta nas bordas e esconde sob as pretas).
        // O halo/pontilhado não usam isto — moram na camada DOM, sem corte.
        // 🔴 Ancorado no `y` DA TECLA, não no topo do SVG: com 2 fileiras a de baixo
        // começa em y>0 e a ♪ pousaria no vazio entre as fileiras.
        this.keys.forEach((k) => {
            const b = k.box;
            k.fxBox = k.info.isBlack
                ? { x: b.x + 2, y: b.y + 2, w: b.w - 4, h: b.h - 4, rx: 3 }
                : { x: b.x + 3, y: b.y + blackH + 4, w: b.w - 6, h: b.h - blackH - 8, rx: 4 };
        });

        this.container.appendChild(this.svg);
    }

    /** Cria uma tecla (rect) clicável e registra em this.keys. */
    _key(info, x, y, w, h, fill, stroke) {
        const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        rect.setAttribute('x', x);
        rect.setAttribute('y', y);
        rect.setAttribute('width', w);
        rect.setAttribute('height', h);
        rect.setAttribute('rx', 4);
        rect.setAttribute('fill', fill);
        rect.setAttribute('stroke', stroke);
        rect.setAttribute('stroke-width', 1.2);
        rect.style.cursor = 'pointer';

        rect.addEventListener('pointerdown', (e) => this._onDown(e, info, rect));
        rect.addEventListener('pointerup', (e) => this._onUp(e));
        rect.addEventListener('pointercancel', (e) => this._onUp(e));
        rect.addEventListener('pointerleave', (e) => this._onUp(e));

        this.svg.appendChild(rect);
        // box guardado p/ a camada de fx (halo/pontilhado desenham SOBRE a tecla)
        this.keys.set(info.midi, { el: rect, info, baseFill: fill, box: { x, y, w, h, rx: 4 } });
        return rect;
    }

    _label(info, cx, cy, color) {
        if (this.opts.labelType === 'none' && !this.opts.labelFn) return;
        const txt = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        txt.setAttribute('x', cx);
        txt.setAttribute('y', cy);
        txt.setAttribute('text-anchor', 'middle');
        txt.setAttribute('font-size', 12);
        txt.setAttribute('font-family', 'Arial, sans-serif');
        txt.setAttribute('fill', color);
        txt.style.pointerEvents = 'none';
        txt.textContent = this.opts.labelFn
            ? this.opts.labelFn(info)
            : (this.opts.labelType === 'letter' ? info.letter : info.solfege);
        this.svg.appendChild(txt);
    }

    // ---------- input ----------

    _onDown(e, info, rect) {
        e.preventDefault();
        if (!this.enabled) return;
        // 🔴 O instante é lido AQUI, antes de capturar o ponteiro e de tocar o som:
        // `play('tick')` monta nós de áudio e o relógio anda no meio disso. Num jogo
        // com janela perfeita de ±45 ms, essa sobra é grande demais para se dar de
        // presente. (Ver CONTRATO DE ENTRADA no cabeçalho.)
        const ev = { at: window.audioManager ? window.audioManager.now() : null,
                     timed: true, source: 'piano', velocity: 1 };
        try { rect.setPointerCapture(e.pointerId); } catch (_) {}
        this._activePointers.set(e.pointerId, info.midi);

        // depressão visual
        rect.setAttribute('fill', info.isBlack ? '#4f46e5' : '#c7d2fe');

        if (this.opts.playSound && window.audioManager) {
            window.audioManager.resumeContext();
            window.audioManager.play('tick', { frequency: info.frequency, duration: 0.6, volume: 0.85 });
        }
        if (this.opts.onKeyPress) this.opts.onKeyPress(info, ev);
    }

    _onUp(e) {
        const midi = this._activePointers.get(e.pointerId);
        if (midi === undefined) return;
        this._activePointers.delete(e.pointerId);
        const k = this.keys.get(midi);
        // só restaura se não estiver no meio de um flash de feedback
        if (k && !this._flashTimers.has(midi)) k.el.setAttribute('fill', this._restFill(midi));
    }

    /** Cor de repouso da tecla: destaque persistente (hold) se houver, senão a base. */
    _restFill(midi) {
        const k = this.keys.get(midi);
        return this._holds.get(midi) || (k ? k.baseFill : '#ffffff');
    }

    // ---------- feedback visual ----------

    /** Pisca uma tecla numa cor por `ms` e depois volta ao repouso (hold ou base). */
    flashKey(midi, color, ms = 700) {
        const k = this.keys.get(midi);
        if (!k) return;
        if (this._flashTimers.has(midi)) clearTimeout(this._flashTimers.get(midi));
        k.el.setAttribute('fill', color);
        const id = setTimeout(() => {
            k.el.setAttribute('fill', this._restFill(midi));
            this._flashTimers.delete(midi);
        }, ms);
        this._flashTimers.set(midi, id);
    }

    /** Pisca a(s) tecla(s) branca(s) com a letra dada (ex: feedback por nome). */
    flashByLetter(letter, color, ms = 700) {
        this.keys.forEach(({ info }, midi) => {
            if (!info.isBlack && info.letter === letter) this.flashKey(midi, color, ms);
        });
    }

    /**
     * Pinta a cor de REPOUSO das teclas brancas por letra (skin Kids: associa
     * cor↔nota, igual às cabeças na pauta). Reescreve `baseFill` → flashes de
     * feedback e holds continuam funcionando por cima e voltam à cor pintada.
     * `colorMap`: { C:'#..', D:'#..', … }. Letras ausentes ficam intactas; passar
     * `null` (ou mapa vazio) restaura todas as brancas ao branco original.
     */
    paintByLetter(colorMap) {
        this.keys.forEach((k, midi) => {
            if (k.info.isBlack) return;
            const c = (colorMap && colorMap[k.info.letter]) || '#ffffff';
            k.baseFill = c;
            if (!this._flashTimers.has(midi) && !this._holds.has(midi)) k.el.setAttribute('fill', c);
        });
    }

    // ---------- feedback POR CAMADA (modo Kids) ----------
    //
    // 🔴 `flashKey` REPINTA o `fill` da tecla — inutilizável no Kids, onde o fill da tecla
    // É a identidade da nota (paintByLetter pinta a paleta Boomwhacker). Estes métodos
    // desenham NUMA CAMADA POR CIMA (NoteFx) e nunca tocam na cor da tecla: brilho, forma
    // e movimento como sinal. Fora do Kids, siga usando flashKey — lá não há colisão.

    /** Camada de efeitos no TOPO (♪ voando/descendo passam por cima de tudo). */
    _fx() {
        return window.NoteFx ? window.NoteFx.layer(this.svg) : null;
    }

    /** Camada DOM POR CIMA do teclado (halo e pontilhado). 🔴 Dentro do SVG o halo é
     *  cortado pelo limite do viewBox e some sob as teclas pretas; aqui ele envolve a
     *  tecla inteira, passa por cima das pretas e o brilho vaza pra fora do teclado. */
    _fxHost() {
        if (!this.svg) return null;
        if (!this._fxHostEl || !this._fxHostEl.isConnected) {
            const host = document.createElement('div');
            host.className = 'pk-fx';
            host.style.cssText = 'position:absolute;inset:0;pointer-events:none;overflow:visible;';
            const cs = window.getComputedStyle(this.container).position;
            if (cs === 'static') this.container.style.position = 'relative';
            this.container.appendChild(host);
            this._fxHostEl = host;
        }
        return this._fxHostEl;
    }

    /** Retângulo da tecla em px, relativo ao host (o SVG escala: só o DOM sabe o tamanho real). */
    _keyBoxPx(midi) {
        const k = this.keys.get(midi);
        const host = this._fxHost();
        if (!k || !host) return null;
        const r = k.el.getBoundingClientRect();
        const h = host.getBoundingClientRect();
        return { left: r.left - h.left, top: r.top - h.top, w: r.width, h: r.height };
    }

    /** Primeira tecla BRANCA de uma letra (o Kids responde por nome, não por oitava). */
    _whiteMidi(letter) {
        let found = null;
        this.keys.forEach(({ info }, midi) => {
            if (found === null && !info.isBlack && info.letter === letter) found = midi;
        });
        return found;
    }

    /** Acerto: halo na PRÓPRIA cor da tecla (identidade preservada, brilho = sinal). */
    fxHit(midi) {
        const k = this.keys.get(midi);
        if (!k || !window.NoteFx) return;
        const box = this._keyBoxPx(midi);
        if (box) window.NoteFx.haloBox(this._fxHost(), box, this._restFill(midi), 1);
    }

    /** Erro: anel pontilhado neutro + tremor horizontal da tecla. Zero matiz, zero repintura. */
    fxMiss(midi) {
        const k = this.keys.get(midi);
        if (!k || !window.NoteFx) return;
        const box = this._keyBoxPx(midi);
        if (box) window.NoteFx.dottedBoxEl(this._fxHost(), box);
        window.NoteFx.shakeX(k.el, 3);
    }

    /** Versões por LETRA (o Kids responde por nome da nota, sem oitava). */
    fxHitLetter(letter) {
        const midi = this._whiteMidi(letter);
        if (midi !== null) this.fxHit(midi);
    }

    fxMissLetter(letter) {
        const midi = this._whiteMidi(letter);
        if (midi !== null) this.fxMiss(midi);
    }

    /** Irmã por LETRA. ⚠️ `_whiteMidi` devolve a tecla mais GRAVE daquela letra: onde a
     *  letra se repete (teclado de 2 oitavas) isto aponta a oitava errada — use `fxTeach`
     *  com o midi exato sempre que ele for conhecido. */
    fxTeachLetter(letter) {
        const midi = this._whiteMidi(letter);
        if (midi !== null) this.fxTeach(midi);
    }

    /** "Era esta": a ♪ desce (como se viesse da pauta), pousa na tecla e ela acende.
     *  É o único efeito que ENSINA a relação pauta↔teclado ("a nota está ali ⇒ toca aqui"). */
    fxTeach(midi) {
        const k = midi === null || midi === undefined ? null : this.keys.get(midi);
        if (!k || !window.NoteFx) return;
        const layer = this._fx();
        const color = this._restFill(midi);
        const cx = k.fxBox.x + k.fxBox.w / 2;
        const landY = k.fxBox.y + k.fxBox.h * 0.45; // pousa na faixa visível da tecla
        const delay = window.NoteFx.landNote(layer, cx, 6, landY, color);
        const id = setTimeout(() => {
            const box = this._keyBoxPx(midi);
            if (this.svg && box) window.NoteFx.haloBox(this._fxHost(), box, this._restFill(midi), 2);
        }, delay);
        this._fxTimers.push(id);
    }

    /** Limpa a camada de fx (parar/trocar de rodada). Não mexe em cores. */
    clearFx() {
        this._fxTimers.forEach(id => clearTimeout(id));
        this._fxTimers = [];
        if (window.NoteFx && this.svg) window.NoteFx.clear(this._fx());
        if (this._fxHostEl) { while (this._fxHostEl.firstChild) this._fxHostEl.removeChild(this._fxHostEl.firstChild); }
    }

    /** Destaque PERSISTENTE de uma tecla (ex: nota-raiz), até releaseHolds(). */
    hold(midi, color) {
        this._holds.set(midi, color);
        const k = this.keys.get(midi);
        if (k && !this._flashTimers.has(midi)) k.el.setAttribute('fill', color);
    }

    /** Remove todos os destaques persistentes e volta as teclas ao repouso. */
    releaseHolds() {
        this._holds.clear();
        this.keys.forEach((k, midi) => {
            if (!this._flashTimers.has(midi)) k.el.setAttribute('fill', k.baseFill);
        });
    }

    /** Restaura todas as teclas ao repouso (respeita holds); cancela flashes. */
    clearFeedback() {
        this._flashTimers.forEach(id => clearTimeout(id));
        this._flashTimers.clear();
        this.keys.forEach((k, midi) => k.el.setAttribute('fill', this._restFill(midi)));
    }

    // ---------- estado ----------

    setEnabled(enabled) {
        this.enabled = enabled;
        if (this.svg) {
            this.svg.style.opacity = enabled ? '1' : '0.55';
            this.svg.style.pointerEvents = enabled ? 'auto' : 'none';
        }
    }

    destroy() {
        this._flashTimers.forEach(id => clearTimeout(id));
        this._flashTimers.clear();
        this._fxTimers.forEach(id => clearTimeout(id));
        this._fxTimers = [];
        this._activePointers.clear();
        this.keys.clear();
        if (this._fxHostEl) { this._fxHostEl.remove(); this._fxHostEl = null; }
        if (this.svg) { this.svg.remove(); this.svg = null; }
    }
}

// Disponibiliza globalmente
window.PianoKeyboard = PianoKeyboard;



// ============================================
// components/piano/KeyboardInput.js
// ============================================
/**
 * KeyboardInput - entrada de notas pelo TECLADO FÍSICO do computador.
 *
 * Espelha o teclado virtual (PianoKeyboard): traduz teclas do PC em notas e emite
 * o MESMO `onKeyPress(info, ev)` — o CONTRATO DE ENTRADA está documentado por
 * inteiro no cabeçalho do PianoKeyboard. Assim qualquer jogo que já usa o piano
 * como resposta ganha o teclado de graça (mesmo callback `answer(info.letter,
 * info)`), e o feedback visual reaproveita o `flashKey` do piano passado em `piano`.
 *
 * Layout = MESMAS letras do projeto principal (capsula KeyboardManager): fileira
 * branca A S D F G H J (K) + pretas W E T Y U → C4…C5.
 *
 *   A   S   D   F   G   H   J   K        (brancas: C  D  E  F  G  A  B  C5)
 *     W  E      T   Y   U                (pretas:  C# D#    F# G# A#)
 *
 * 🔴 Ciclo de vida: chama `enable()`/`disable()` — `disable()` REMOVE os listeners
 * de document. Quem usa DEVE chamar `destroy()` ao trocar de jogo/parar (senão o
 * teclado continua respondendo no jogo errado). Nunca interfere em <input>/<textarea>.
 */
class KeyboardInput {
    // tecla (lowercase) → nota científica. Igual ao capsula (C4–C5).
    static DEFAULT_MAP = {
        a: 'C4', w: 'Db4', s: 'D4', e: 'Eb4', d: 'E4', f: 'F4',
        t: 'Gb4', g: 'G4', y: 'Ab4', h: 'A4', u: 'Bb4', j: 'B4', k: 'C5'
    };

    constructor(options = {}) {
        this.onKeyPress = options.onKeyPress || null;
        this.piano = options.piano || null;        // PianoKeyboard p/ espelhar o flash (opcional)
        this.playSound = options.playSound !== false;
        this.keyMap = options.keyMap || KeyboardInput.DEFAULT_MAP;

        this.enabled = false;
        this._active = new Set();                  // teclas seguradas (evita auto-repeat)
        this._down = this._onKeyDown.bind(this);
        this._up = this._onKeyUp.bind(this);
        // 🔴 Alt-tab com a tecla PRESSIONADA entrega o `keyup` para a outra janela: a tecla
        // fica eternamente "segurada" em `_active` e emudece — o jogador aperta e nada sai.
        // Curava-se sozinho na Leitura (cada rodada refaz o KeyboardInput), mas no jogo de
        // música real a entrada é montada UMA vez por peça, então a tecla morre no meio e
        // as notas somem do placar. Perder o foco solta tudo: nenhuma tecla continua
        // pressionada numa janela que não está mais recebendo eventos.
        this._blur = () => this._active.clear();
    }

    enable() {
        if (this.enabled) return;
        this.enabled = true;
        this._active.clear();
        document.addEventListener('keydown', this._down);
        document.addEventListener('keyup', this._up);
        window.addEventListener('blur', this._blur);
        document.addEventListener('visibilitychange', this._blur);
    }

    disable() {
        if (!this.enabled) return;
        this.enabled = false;
        this._active.clear();
        document.removeEventListener('keydown', this._down);
        document.removeEventListener('keyup', this._up);
        window.removeEventListener('blur', this._blur);
        document.removeEventListener('visibilitychange', this._blur);
    }

    setEnabled(on) { on ? this.enable() : this.disable(); }

    /** Monta o info (contrato PitchUtil.info) a partir da tecla, ou null se não mapeada. */
    _infoFor(key) {
        const sci = this.keyMap[key];
        if (!sci) return null;
        const PU = window.PitchUtil;
        if (!PU) return null;
        return PU.info(PU.midiFromSci(sci));
    }

    _onKeyDown(e) {
        if (!this.enabled) return;
        // NUNCA interferir em campos de formulário (login/cadastro futuros).
        const tgt = e.target;
        if (tgt && (tgt.tagName === 'INPUT' || tgt.tagName === 'TEXTAREA' || tgt.isContentEditable)) return;
        if (e.repeat || e.ctrlKey || e.altKey || e.metaKey || !e.key) return;

        const key = e.key.toLowerCase();
        const info = this._infoFor(key);
        if (!info) return;                 // tecla não mapeada → deixa passar
        e.preventDefault();
        if (this._active.has(key)) return; // já segurando
        this._active.add(key);

        // Instante ANTES do som (o `play` abaixo monta nós de áudio e o relógio anda).
        const ev = { at: window.audioManager ? window.audioManager.now() : null,
                     timed: true, source: 'keyboard', velocity: 1 };

        // som + "afundar" a tecla no piano virtual (o answer() do jogo sobrescreve o
        // flash logo em seguida com verde/vermelho, então isto é só o toque inicial)
        if (this.playSound && window.audioManager) {
            window.audioManager.resumeContext();
            window.audioManager.play('tick', { frequency: info.frequency, duration: 0.6, volume: 0.85 });
        }
        if (this.piano && typeof this.piano.flashKey === 'function') {
            this.piano.flashKey(info.midi, info.isBlack ? '#4f46e5' : '#c7d2fe', 140);
        }

        if (this.onKeyPress) this.onKeyPress(info, ev);
    }

    _onKeyUp(e) {
        if (!this.enabled || !e.key) return;
        const key = e.key.toLowerCase();
        if (this.keyMap[key]) this._active.delete(key);
    }

    destroy() {
        this.disable();
        this.piano = null;
        this.onKeyPress = null;
    }
}

// Disponibiliza globalmente
window.KeyboardInput = KeyboardInput;



// ============================================
// components/piano/MicPitchInput.js
// ============================================
/**
 * MicPitchInput - entrada de notas por PIANO ACÚSTICO (ou qualquer instrumento
 * monofônico) via MICROFONE, com detecção de pitch em tempo real.
 *
 * Espelha KeyboardInput/PianoKeyboard: detecta a nota tocada e emite a MESMA
 * `onKeyPress(info)` — onde `info` é o contrato de PitchUtil.info(). Qualquer jogo
 * que já responde a `answer(info.letter, info)` ganha o piano acústico de graça.
 * (A futura entrada MIDI será um irmão deste componente com o mesmo contrato.)
 *
 * Cadeia: getUserMedia → MediaStreamAudioSourceNode no AudioContext ÚNICO do
 * audioManager (NUNCA criar um segundo contexto) → AnalyserNode → loop rAF com
 * getFloatTimeDomainData → autocorrelação normalizada (MPM/NSDF) → freq → midi →
 * PitchUtil.info(midi) → onKeyPress(info).
 *
 * Anti-eco: cada frame consulta audioManager.isOutputBusy() — enquanto o próprio
 * app emite som (feedback de acerto/erro), a detecção é descartada, senão o mic
 * "ouviria" o alto-falante e responderia sozinho.
 *
 * Onset (1 evento por nota, sem spam no sustain): máquina de estados
 * SILENT → CANDIDATE (midi estável por N frames) → HELD. Emite ao estabilizar
 * nota nova (legato) ou em re-ataque da mesma nota (salto de RMS).
 *
 * 🔴 getUserMedia exige SECURE CONTEXT (HTTPS ou localhost) — http://ritmo.local
 * NÃO serve; usar http://localhost ou o lab com SSL. `isSupported()` detecta.
 * 🔴 Ciclo de vida: quem usa DEVE chamar `destroy()` ao trocar de jogo/parar
 * (senão o mic fica aberto e o indicador de gravação do browser aceso).
 */
class MicPitchInput {
    /** Estados expostos via onStateChange. */
    static STATES = ['idle', 'requesting', 'listening', 'denied', 'unsupported', 'error'];

    /** Mic disponível? (exige secure context: HTTPS ou localhost) */
    static isSupported() {
        return !!(window.isSecureContext && navigator.mediaDevices &&
                  navigator.mediaDevices.getUserMedia && window.AudioContext);
    }

    constructor(options = {}) {
        this.onKeyPress = options.onKeyPress || null;
        this.onStateChange = options.onStateChange || null; // (state) — p/ UI de status
        this.onFrame = options.onFrame || null;             // ({rms,freq,midi,cents,clarity,muted}) — p/ medidor
        this.piano = options.piano || null;                 // PianoKeyboard p/ espelhar o flash (opcional)

        // Range plausível de piano (A0..C8). A comparação dos jogos é por LETRA
        // (oitava-agnóstica), então aceitar o range inteiro é seguro e permite
        // tocar a nota em qualquer região do instrumento.
        this.minMidi = options.minMidi ?? 21;
        this.maxMidi = options.maxMidi ?? 108;

        // Thresholds calibráveis (test-mic-pitch.html tem sliders p/ ajuste fino).
        this.clarityThreshold = options.clarityThreshold ?? 0.9; // NSDF: quão "periódico" p/ valer como nota
        this.rmsGate = options.rmsGate ?? 0.01;                  // piso de volume (corta ruído de fundo)
        this.stableFrames = options.stableFrames ?? 3;           // frames com o MESMO midi p/ emitir
        this.quietFrames = options.quietFrames ?? 5;             // frames sem pitch p/ voltar a SILENT
        this.reattackRatio = options.reattackRatio ?? 2.5;       // salto de RMS = mesma nota tocada de novo

        this.fftSize = options.fftSize ?? 4096; // ~93ms @44.1kHz; alcança A0 (τ≈1604 < 2048)

        this.enabled = true;      // gate de EMISSÃO (setEnabled) — o stream continua vivo
        this.state = 'idle';
        this._stream = null;
        this._source = null;
        this._analyser = null;
        this._buf = null;
        this._raf = 0;
        this._destroyed = false;

        this._resetFsm();
    }

    _resetFsm() {
        this._held = null;          // midi da nota "segurada" (já emitida)
        this._candidate = null;     // midi aguardando estabilizar
        this._candidateCount = 0;
        this._quietCount = 0;
        this._minRmsHeld = Infinity; // menor RMS desde a última emissão (detecta re-ataque)
    }

    _setState(state) {
        if (this.state === state) return;
        this.state = state;
        if (this.onStateChange) this.onStateChange(state);
    }

    /**
     * Pede permissão e começa a ouvir. Chamar SEMPRE a partir de gesto do usuário
     * (clique em "ativar microfone" / "Começar") — nunca no load da página.
     * @returns {Promise<boolean>} true se está ouvindo
     */
    async start() {
        if (this._destroyed) return false;
        if (this._stream) { this._setState('listening'); return true; }
        if (!MicPitchInput.isSupported()) { this._setState('unsupported'); return false; }

        this._setState('requesting');
        let stream;
        try {
            // Processamentos de voz DESLIGADOS: são feitos p/ fala e mutilam
            // harmônicos/dinâmica de instrumento (o AGC ainda mascara o re-ataque).
            stream = await navigator.mediaDevices.getUserMedia({
                audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false }
            });
        } catch (err) {
            const denied = err && (err.name === 'NotAllowedError' || err.name === 'SecurityError' ||
                                   err.name === 'PermissionDeniedError');
            this._setState(denied ? 'denied' : 'error');
            return false;
        }
        if (this._destroyed) { stream.getTracks().forEach(t => t.stop()); return false; }

        const am = window.audioManager;
        await am.resumeContext();
        this._stream = stream;
        this._source = am.context.createMediaStreamSource(stream);
        this._analyser = am.context.createAnalyser();
        this._analyser.fftSize = this.fftSize;
        this._source.connect(this._analyser); // analyser NÃO conecta ao destination (sem eco)
        this._buf = new Float32Array(this._analyser.fftSize);

        this._resetFsm();
        const loop = () => {
            if (!this._analyser) return;
            this._analyser.getFloatTimeDomainData(this._buf);
            // sampleRate lido a CADA frame: o iOS pode trocá-lo ao ativar o mic
            this._feedFrame(this._buf, am.context.sampleRate);
            this._raf = requestAnimationFrame(loop);
        };
        this._raf = requestAnimationFrame(loop);
        this._setState('listening');
        return true;
    }

    /** Para de ouvir e solta o microfone (apaga o indicador de gravação do browser). */
    stop() {
        if (this._raf) { cancelAnimationFrame(this._raf); this._raf = 0; }
        if (this._source) { try { this._source.disconnect(); } catch (e) {} this._source = null; }
        this._analyser = null;
        if (this._stream) {
            this._stream.getTracks().forEach(t => { try { t.stop(); } catch (e) {} });
            this._stream = null;
        }
        this._resetFsm();
        if (this.state === 'listening' || this.state === 'requesting') this._setState('idle');
    }

    /**
     * Gate de emissão SEM soltar o stream (pausas entre perguntas): evita pedir
     * permissão de novo e mantém o medidor vivo; só não emite onKeyPress.
     */
    setEnabled(on) { this.enabled = !!on; }

    destroy() {
        this._destroyed = true;
        this.stop();
        this.piano = null;
        this.onKeyPress = null;
        this.onStateChange = null;
        this.onFrame = null;
    }

    /**
     * Detecção de pitch por MPM (McLeod Pitch Method) sobre a NSDF.
     * PURA (sem DOM/mic) — testável com Float32Array sintético.
     * @param {Float32Array} buf - domínio do tempo
     * @param {number} sampleRate
     * @returns {{freq:number|null, clarity:number, rms:number}}
     */
    _detectPitch(buf, sampleRate) {
        const n = buf.length;
        let sumSq = 0;
        for (let i = 0; i < n; i++) sumSq += buf[i] * buf[i];
        const rms = Math.sqrt(sumSq / n);
        if (rms < this.rmsGate) return { freq: null, clarity: 0, rms };

        const PU = window.PitchUtil;
        const tauMin = Math.max(2, Math.floor(sampleRate / PU.frequency(this.maxMidi)));
        const tauMax = Math.min(n >> 1, Math.ceil(sampleRate / PU.frequency(this.minMidi)));
        if (tauMin >= tauMax) return { freq: null, clarity: 0, rms };

        // NSDF: nsdf[τ] = 2·Σ x[i]x[i+τ] / Σ (x[i]² + x[i+τ]²) ∈ [-1, 1]
        const nsdf = new Float32Array(tauMax + 1);
        for (let tau = tauMin; tau <= tauMax; tau++) {
            let acf = 0, m = 0;
            for (let i = 0, len = n - tau; i < len; i++) {
                const a = buf[i], b = buf[i + tau];
                acf += a * b;
                m += a * a + b * b;
            }
            nsdf[tau] = m > 0 ? (2 * acf) / m : 0;
        }

        // Peak-picking MPM: só depois do 1º mergulho abaixo de zero (descarta o
        // lóbulo de lag-zero); um máximo por região positiva; escolhe o PRIMEIRO
        // pico ≥ k·maxPico (k=0.9) — é isto que evita cair no subharmônico.
        const peaks = [];
        let tau = tauMin;
        while (tau <= tauMax && nsdf[tau] > 0) tau++;   // pula o lóbulo inicial
        while (tau <= tauMax) {
            while (tau <= tauMax && nsdf[tau] <= 0) tau++;
            let bestTau = -1, bestVal = -Infinity;
            while (tau <= tauMax && nsdf[tau] > 0) {
                if (nsdf[tau] > bestVal) { bestVal = nsdf[tau]; bestTau = tau; }
                tau++;
            }
            if (bestTau > 0) peaks.push({ tau: bestTau, val: bestVal });
        }
        if (!peaks.length) return { freq: null, clarity: 0, rms };

        const maxVal = Math.max(...peaks.map(p => p.val));
        const chosen = peaks.find(p => p.val >= 0.9 * maxVal);
        const clarity = chosen.val;
        if (clarity < this.clarityThreshold) return { freq: null, clarity, rms };

        // Interpolação parabólica em τ (precisão sub-amostra)
        let t = chosen.tau;
        if (t > tauMin && t < tauMax) {
            const y0 = nsdf[t - 1], y1 = nsdf[t], y2 = nsdf[t + 1];
            const denom = y0 - 2 * y1 + y2;
            if (denom !== 0) t += 0.5 * (y0 - y2) / denom;
        }
        return { freq: sampleRate / t, clarity, rms };
    }

    /**
     * Alimenta UM frame na máquina de estados de onset. Usado pelo loop rAF E
     * pelos testes (que injetam buffers sintéticos sem mic).
     * @param {Float32Array} buf
     * @param {number} sampleRate
     */
    _feedFrame(buf, sampleRate) {
        // App emitindo som → o mic ouviria o alto-falante: descarta o frame.
        const muted = !!(window.audioManager && window.audioManager.isOutputBusy());
        if (muted) {
            this._candidate = null;
            this._candidateCount = 0;
            if (this.onFrame) this.onFrame({ rms: 0, freq: null, midi: null, cents: 0, clarity: 0, muted: true });
            return;
        }

        const PU = window.PitchUtil;
        const det = this._detectPitch(buf, sampleRate);
        let midi = null, cents = 0;
        if (det.freq !== null) {
            const m = PU.midiFromFrequency(det.freq);
            if (m && m.midi >= this.minMidi && m.midi <= this.maxMidi) { midi = m.midi; cents = m.cents; }
        }
        if (this.onFrame) {
            this.onFrame({ rms: det.rms, freq: det.freq, midi, cents, clarity: det.clarity, muted: false });
        }

        if (midi === null) {
            // frame sem nota: candidato cai na hora; HELD só solta após quietFrames
            this._candidate = null;
            this._candidateCount = 0;
            if (++this._quietCount >= this.quietFrames) {
                this._held = null;
                this._minRmsHeld = Infinity;
            }
            return;
        }
        this._quietCount = 0;

        if (midi === this._held) {
            // sustain da nota já emitida; salto de RMS = re-ataque (tocou de novo)
            if (det.rms > this.reattackRatio * this._minRmsHeld) {
                this._emit(midi);
                this._minRmsHeld = det.rms;
            } else {
                this._minRmsHeld = Math.min(this._minRmsHeld, det.rms);
            }
            this._candidate = null;
            this._candidateCount = 0;
            return;
        }

        // nota diferente da segurada: precisa estabilizar (anti-glitch de transição)
        if (midi === this._candidate) {
            this._candidateCount++;
        } else {
            this._candidate = midi;
            this._candidateCount = 1;
        }
        if (this._candidateCount >= this.stableFrames) {
            this._emit(midi);
            this._minRmsHeld = det.rms;
            this._candidate = null;
            this._candidateCount = 0;
        }
    }

    /**
     * Emite a nota no CONTRATO DE ENTRADA (documentado no PianoKeyboard).
     *
     * 🔴 `timed: false` — ÚNICA fonte que declara isso, e o motivo é físico, não um
     * defeito a consertar. O instante que chega aqui é o do FRAME em que a altura
     * ficou provada, não o do ataque:
     *
     *   • o analisador olha uma janela de `fftSize` amostras (4096 ≈ 93 ms @44,1k);
     *   • e só emite depois de `stableFrames` frames concordando (3 × ~16,7 ms).
     *
     * Somando, o carimbo chega tipicamente 50–120 ms DEPOIS do dedo — mais que a
     * janela perfeita de ±45 ms do RhythmScorer, e variável com a nota, o cômodo e o
     * device. Não é compensável por uma constante honesta. Por isso o microfone
     * responde ALTURA muito bem e não serve para pontuar RITMO; quem pontua ritmo
     * pergunta por `ev.timed` e trata este caso, em vez de fingir precisão.
     */
    _emit(midi) {
        this._held = midi;
        if (!this.enabled) return;
        const info = window.PitchUtil.info(midi);
        const ev = { at: window.audioManager ? window.audioManager.now() : null,
                     timed: false, source: 'mic', velocity: 1 };
        if (this.piano && typeof this.piano.flashKey === 'function') {
            this.piano.flashKey(info.midi, info.isBlack ? '#4f46e5' : '#c7d2fe', 140);
        }
        if (this.onKeyPress) this.onKeyPress(info, ev);
    }
}

// Disponibiliza globalmente
window.MicPitchInput = MicPitchInput;



// ============================================
// components/piano/MidiPitchInput.js
// ============================================
/**
 * MidiPitchInput - entrada de notas por INSTRUMENTO MIDI (teclado, controlador).
 *
 * Irmão do MicPitchInput, com o MESMO contrato: emite `onKeyPress(info)`, onde
 * `info` é o de PitchUtil.info(). Qualquer jogo que já responde a
 * `answer(info.letter, info)` ganha o teclado MIDI de graça — a única diferença
 * é a fonte do evento (mensagem MIDI em vez de detecção de pitch no microfone).
 *
 * O que o mic tem e aqui NÃO é preciso: autocorrelação, threshold de clareza,
 * gate de RMS, anti-eco (isOutputBusy) e máquina de onset — a mensagem MIDI JÁ é
 * o onset, exato e sem latência. Por isso esta classe é curta: ela só filtra
 * Note On, converte para info e repassa.
 *
 * O que aqui existe e o mic NÃO tem: `onNoteOff` e notas SIMULTÂNEAS (o mic é
 * monofônico). Os jogos de leitura usam só o Note On; Ritmo e Acordes vão usar o
 * resto sobre esta mesma base.
 *
 * O recurso (permissão + dispositivos) mora no `midiInputManager` singleton — um
 * requestMIDIAccess para o app inteiro. Esta classe é o consumidor por jogo.
 *
 * 🔴 Web MIDI não existe no iOS e exige secure context — `isSupported()` detecta e
 * o modo simplesmente não aparece no seletor (mesmo padrão do mic em HTTP).
 * 🔴 Ciclo de vida: quem usa DEVE chamar `destroy()` ao trocar de jogo/parar
 * (senão o handler segue vivo respondendo a um jogo que saiu da tela).
 */
class MidiPitchInput {
    /** Estados expostos via onStateChange. 'nodevice' = acesso OK, nada plugado. */
    static STATES = ['idle', 'requesting', 'listening', 'nodevice', 'denied', 'unsupported', 'error'];

    /** MIDI disponível neste browser? */
    static isSupported() {
        return !!(window.MidiInputManager && window.MidiInputManager.isSupported());
    }

    constructor(options = {}) {
        this.onKeyPress = options.onKeyPress || null;
        this.onStateChange = options.onStateChange || null; // (state) — p/ UI de status
        this.onFrame = options.onFrame || null;             // ({rms,midi,…}) — p/ medidor, igual ao mic
        this.onNoteOff = options.onNoteOff || null;         // (info) — não usado nos jogos de leitura
        this.piano = options.piano || null;                 // PianoKeyboard p/ espelhar o flash (opcional)

        // Range plausível de piano (A0..C8): fora dele, ignora (pads de bateria de
        // controlador costumam mandar notas graves fora da escala musical).
        this.minMidi = options.minMidi ?? 21;
        this.maxMidi = options.maxMidi ?? 108;
        this.minVelocity = options.minVelocity ?? 0; // 0..1 — corta toque acidental, se preciso

        this.enabled = true;  // gate de EMISSÃO (setEnabled) — a assinatura continua viva
        this.state = 'idle';
        this._held = new Set();   // midis segurados (polifonia)
        this._unsub = null;
        this._unsubDevices = null;
        this._destroyed = false;
    }

    _setState(state) {
        if (this.state === state) return;
        this.state = state;
        if (this.onStateChange) this.onStateChange(state);
    }

    /**
     * Pede o acesso MIDI e começa a ouvir. Chamar SEMPRE a partir de gesto do
     * usuário (clique em "conectar teclado" / "Começar") — o browser abre prompt.
     * @returns {Promise<boolean>} true se está pronto (mesmo sem device plugado)
     */
    async start() {
        if (this._destroyed) return false;
        if (!MidiPitchInput.isSupported()) { this._setState('unsupported'); return false; }

        const mgr = window.midiInputManager;
        this._setState('requesting');
        const ok = await mgr.start();
        if (this._destroyed) return false;
        if (!ok) { this._setState(mgr.state === 'denied' ? 'denied' : 'error'); return false; }

        if (!this._unsub) this._unsub = mgr.subscribe((ev) => this._onEvent(ev));
        // hot-plug: plugar/desplugar o teclado com o jogo aberto troca o estado sozinho
        if (!this._unsubDevices) this._unsubDevices = mgr.onDevicesChanged(() => this._syncDeviceState());
        this._syncDeviceState();
        return true;
    }

    /** 'listening' (há teclado) × 'nodevice' (acesso concedido, nada plugado). */
    _syncDeviceState() {
        if (this._destroyed || !this._unsub) return;
        this._setState(window.midiInputManager.hasDevice() ? 'listening' : 'nodevice');
    }

    /** Nome do dispositivo ativo (p/ a UI); null se não há nenhum. */
    getDeviceName() {
        return window.midiInputManager ? window.midiInputManager.getDeviceName() : null;
    }

    /** Solta a assinatura (o acesso MIDI do app segue vivo, sem novo prompt depois). */
    stop() {
        if (this._unsub) { this._unsub(); this._unsub = null; }
        if (this._unsubDevices) { this._unsubDevices(); this._unsubDevices = null; }
        this._held.clear();
        if (this.state === 'listening' || this.state === 'nodevice' || this.state === 'requesting') {
            this._setState('idle');
        }
    }

    /**
     * Gate de emissão SEM soltar a assinatura (pausas entre perguntas): mantém o
     * medidor vivo e o estado das teclas coerente; só não emite onKeyPress.
     */
    setEnabled(on) { this.enabled = !!on; }

    destroy() {
        this._destroyed = true;
        this.stop();
        this.piano = null;
        this.onKeyPress = null;
        this.onStateChange = null;
        this.onFrame = null;
        this.onNoteOff = null;
    }

    /**
     * Trata UM evento normalizado do manager. Público de fato para os testes, que
     * injetam eventos sem hardware.
     * @param {{type:string, midi:number, velocity:number}} ev
     */
    _onEvent(ev) {
        if (this._destroyed || !ev) return;
        if (ev.midi < this.minMidi || ev.midi > this.maxMidi) return;

        if (ev.type === 'noteoff') {
            this._held.delete(ev.midi);
            this._frame();
            if (this.onNoteOff && this.enabled) this.onNoteOff(window.PitchUtil.info(ev.midi));
            return;
        }
        if (ev.velocity < this.minVelocity) return;

        this._held.add(ev.midi);
        // 🔴 EMITE ANTES de alimentar o medidor. `_frame` dispara `onFrame`, que escreve no
        // DOM (MicStatusPanel), e o carimbo de tempo do `_emit` é lido DEPOIS — era a única
        // das 4 fontes que trabalhava antes de olhar o relógio. Medido: até 2,67 ms de
        // atraso com o painel na tela. Dentro da janela de ±45 ms, mas é erro de graça.
        this._emit(ev.midi, ev.velocity);
        this._frame(ev.velocity);
    }

    /**
     * Alimenta o painel de status no MESMO formato do mic (o MicStatusPanel é
     * compartilhado): `rms` vira a velocity, e a nota ao vivo é a última segurada.
     */
    _frame(velocity) {
        if (!this.onFrame) return;
        const last = this._held.size ? Array.from(this._held).pop() : null;
        this.onFrame({
            rms: last === null ? 0 : (velocity ?? 0.6),
            freq: last === null ? null : window.PitchUtil.frequency(last),
            midi: last, cents: 0, clarity: 1, muted: false
        });
    }

    /**
     * Emite a nota no CONTRATO DE ENTRADA (documentado no PianoKeyboard).
     *
     * 🔴 `timed: true` — é a fonte mais precisa das quatro: a mensagem MIDI JÁ é o
     * onset (sem análise, sem estabilização) e o handler roda na hora. O refino
     * possível seria converter o `event.timeStamp` da Web MIDI (domínio do
     * performance.now) para o relógio de áudio; o ganho fica na casa de poucos ms,
     * bem dentro da janela de ±45 ms, e a conversão tem deriva própria. Não vale.
     */
    _emit(midi, velocity) {
        if (!this.enabled) return;
        const info = window.PitchUtil.info(midi);
        const ev = { at: window.audioManager ? window.audioManager.now() : null,
                     timed: true, source: 'midi',
                     velocity: (typeof velocity === 'number') ? velocity : 1 };
        if (this.piano && typeof this.piano.flashKey === 'function') {
            this.piano.flashKey(info.midi, info.isBlack ? '#4f46e5' : '#c7d2fe', 140);
        }
        if (this.onKeyPress) this.onKeyPress(info, ev);
    }
}

// Disponibiliza globalmente
window.MidiPitchInput = MidiPitchInput;



// ============================================
// components/piano/MicStatusPanel.js
// ============================================
/**
 * MicStatusPanel - UI de status de entrada por INSTRUMENTO (microfone ou MIDI).
 *
 * Bloco COMPARTILHADO pelos dois jogos de leitura (StaffReadingGame e
 * ReadingFlowGame) e pelas DUAS entradas de instrumento: bolinha de estado +
 * nota detectada ao vivo + medidor de nível + botões (ativar / voltar pros
 * botões). O MIDI reusa o painel inteiro trocando só os textos (namespace
 * `midiInput.*`) e a escala do medidor (velocity 0..1 em vez de RMS).
 *
 * Não sabe nada de áudio nem de MIDI: é alimentado de fora via setState(state)
 * (do onStateChange do Mic/MidiPitchInput) e frame(f) (do onFrame). flash(info,
 * ok) pinta a nota detectada de verde/vermelho no feedback da resposta — o
 * análogo do flashKey do PianoKeyboard.
 *
 * i18n por injeção: `t(sufixo)` → tradução de `micInput.` ou `midiInput.` (o jogo
 * passa seu _t já com o namespace certo).
 */
class MicStatusPanel {
    static DOT_COLORS = {
        idle: '#94a3b8', requesting: '#f59e0b', listening: '#10b981',
        nodevice: '#f59e0b',  // acesso concedido, nenhum instrumento plugado (só MIDI)
        denied: '#ef4444', unsupported: '#ef4444', error: '#ef4444'
    };

    /** Estados que degradam com texto de ajuda + saída 1-clique pros botões. */
    static HELP_STATES = { denied: 'deniedHelp', unsupported: 'unsupportedHelp', error: 'unsupportedHelp', nodevice: 'nodeviceHelp' };

    constructor(container, opts = {}) {
        this.container = container;
        this.t = opts.t || ((k) => k);
        this.noteLabel = opts.noteLabel || ((info) => info.letter); // rótulo localizado
        this.onActivate = opts.onActivate || null;
        this.onFallback = opts.onFallback || null;
        // RMS do mic é minúsculo (~0.1 no forte) → ×800. Velocity MIDI já é 0..1 → ×100.
        this.meterScale = opts.meterScale ?? 800;

        this.state = 'idle';
        this.el = null;
        this._dot = null;
        this._statusTxt = null;
        this._noteEl = null;
        this._meterFill = null;
        this._btnRow = null;
        this._flashTimer = null;
        this._flashing = false;
    }

    render() {
        const el = document.createElement('div');
        el.className = 'mic-status-panel';
        el.style.cssText = 'display:inline-block;min-width:240px;max-width:340px;padding:0.7rem 1.1rem;'
            + 'background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;text-align:center;';

        const row = document.createElement('div');
        row.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:0.45rem;font-size:0.85rem;color:#64748b;';
        this._dot = document.createElement('span');
        this._dot.style.cssText = 'width:9px;height:9px;border-radius:50%;display:inline-block;background:#94a3b8;flex:none;';
        this._statusTxt = document.createElement('span');
        row.appendChild(this._dot);
        row.appendChild(this._statusTxt);
        el.appendChild(row);

        // nota detectada (grande) — ao vivo em cinza; verde/vermelho no feedback
        this._noteEl = document.createElement('div');
        this._noteEl.style.cssText = 'font-size:1.9rem;font-weight:800;min-height:2.5rem;color:#94a3b8;'
            + 'display:flex;align-items:center;justify-content:center;';
        this._noteEl.textContent = '—';
        el.appendChild(this._noteEl);

        // medidor de nível
        const meter = document.createElement('div');
        meter.style.cssText = 'height:6px;border-radius:3px;background:#e2e8f0;overflow:hidden;margin:0.2rem 0 0.4rem;';
        this._meterFill = document.createElement('div');
        this._meterFill.style.cssText = 'height:100%;width:0;background:#10b981;transition:width 60ms linear;';
        meter.appendChild(this._meterFill);
        el.appendChild(meter);

        this._btnRow = document.createElement('div');
        el.appendChild(this._btnRow);

        this.container.appendChild(el);
        this.el = el;
        this.setState(this.state);
        return el;
    }

    _button(label, bg, onClick) {
        const b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        b.style.cssText = 'padding:0.45rem 0.9rem;font-size:0.9rem;font-weight:bold;color:#fff;border:none;'
            + `border-radius:8px;cursor:pointer;margin:0.15rem 0.25rem;background:${bg};`;
        b.addEventListener('click', onClick);
        return b;
    }

    /**
     * Atualiza estado visual (idle/requesting/listening/nodevice/denied/unsupported/error).
     * @param {string} state
     * @param {string} [detail] - sufixo do texto (o MIDI passa o nome do dispositivo)
     */
    setState(state, detail) {
        this.state = state;
        if (!this.el) return;
        this._dot.style.background = MicStatusPanel.DOT_COLORS[state] || '#94a3b8';
        this._dot.style.animation = state === 'listening' ? 'mic-pulse 1.6s ease-in-out infinite' : '';
        this._ensurePulseKeyframes();
        this._statusTxt.textContent = this.t(state === 'idle' ? 'activateHint' : state)
            + (detail ? ' · ' + detail : '');

        this._btnRow.innerHTML = '';
        if (state === 'idle' || state === 'error') {
            if (this.onActivate) this._btnRow.appendChild(
                this._button(this.t('activate'), 'linear-gradient(135deg,#6366f1,#8b5cf6)', () => this.onActivate()));
        }
        const helpKey = MicStatusPanel.HELP_STATES[state];
        if (helpKey) {
            const help = document.createElement('p');
            help.style.cssText = 'font-size:0.8rem;color:#94a3b8;margin:0 0 0.3rem;';
            help.textContent = this.t(helpKey);
            this._btnRow.appendChild(help);
            if (this.onFallback) this._btnRow.appendChild(
                this._button(this.t('useButtons'), '#64748b', () => this.onFallback()));
        }
    }

    /** Frame do detector: medidor + nota ao vivo (quando não está em flash de feedback). */
    frame(f) {
        if (!this.el) return;
        this._meterFill.style.width = Math.min(100, (f.rms || 0) * this.meterScale) + '%';
        if (this._flashing) return;
        if (f.midi != null) {
            this._noteEl.textContent = this.noteLabel(window.PitchUtil.info(f.midi));
            this._noteEl.style.color = '#475569';
        } else {
            this._noteEl.textContent = '—';
            this._noteEl.style.color = '#94a3b8';
        }
    }

    /** Feedback da resposta: nota tocada em verde (acertou) ou vermelho (errou). */
    flash(info, ok, ms = 1100) {
        if (!this.el) return;
        clearTimeout(this._flashTimer);
        this._flashing = true;
        this._noteEl.textContent = this.noteLabel(info);
        this._noteEl.style.color = ok ? '#10b981' : '#ef4444';
        this._flashTimer = setTimeout(() => { this._flashing = false; }, ms);
    }

    /** Injeta (1x) os keyframes do pulso da bolinha "ouvindo". */
    _ensurePulseKeyframes() {
        if (document.getElementById('mic-pulse-style')) return;
        const s = document.createElement('style');
        s.id = 'mic-pulse-style';
        s.textContent = '@keyframes mic-pulse { 0%,100% { opacity:1; } 50% { opacity:0.35; } }';
        document.head.appendChild(s);
    }

    destroy() {
        clearTimeout(this._flashTimer);
        if (this.el) { this.el.remove(); this.el = null; }
        this.onActivate = null;
        this.onFallback = null;
    }
}

// Disponibiliza globalmente
window.MicStatusPanel = MicStatusPanel;



// ============================================
// components/piano/NoteInputRecorder.js
// ============================================
/**
 * NoteInputRecorder - grava ALTURA + INSTANTE no relógio de áudio.
 *
 * Irmão do `RhythmInputDetector`, e a divisão entre os dois é de propósito:
 *
 *   RhythmInputDetector — jogo de ritmo. UMA superfície (a bola), sem altura, com
 *                         início E duração. Monofônico por construção:
 *                         `if (this.currentNote) return` no onTapDown.
 *   NoteInputRecorder   — jogo de música real. QUALQUER superfície do contrato de
 *                         entrada (piano, teclado do PC, MIDI, microfone), com
 *                         altura, só o início.
 *
 * 🔴 Por que não reusar o RhythmInputDetector: aquele guard monofônico. Tocando
 * melodia num teclado, ligar a nota seguinte antes de soltar a anterior (legato —
 * o jeito CERTO de tocar) faria o ataque da segunda ser DESCARTADO em silêncio. Aqui
 * cada ataque é um registro independente; não há estado de "nota aberta" para
 * colidir. É também o motivo de este arquivo ser tão curto: sem duração no v1, não
 * há pareamento On/Off para administrar.
 *
 * 🔴 UM RELÓGIO SÓ: os instantes vêm do `ev.at` do contrato de entrada, que é
 * `audioManager.now()` (AudioContext.currentTime) carimbado na própria fonte. Nunca
 * performance.now(), nunca Date.now(). Ver PianoKeyboard (CONTRATO DE ENTRADA).
 *
 * 🔴 LATÊNCIA: `startRelative` já desconta `latencyOffset` — o aluno toca junto com o
 * que ele VÊ e OUVE, ambos atrasados pela saída de áudio do device. Mesma conta do
 * RhythmInputDetector.toRelativeMs, pelo mesmo motivo.
 *
 * A saída é o formato que o `RhythmScorer` já consome (`startRelative` em ms), então
 * o alinhamento ótimo dele (Needleman–Wunsch) serve sem tradução.
 *
 * Etapa 3 de docs/MUSICA-REAL-PLANO.md.
 */
class NoteInputRecorder {
    constructor() {
        this.recording = false;
        this.originTime = 0;      // tempo de áudio (s) do beat 0 da peça
        this.latencyOffset = 0;   // s a subtrair (saída do device + calibração)
        this.inputs = [];
        /** callback (entrada) => void — feedback ao vivo, sem esperar o fim. */
        this.onRecord = null;
    }

    /**
     * Abre a captura ancorada no relógio de áudio.
     *
     * Chamar um PRÉ-ROLL antes do beat 0 (o Ritmo usa meia batida): quem ataca a
     * primeira nota adiantado tem o toque gravado com `startRelative` NEGATIVO —
     * que o scorer sabe ler — em vez de cair num vão morto e virar "não tocou".
     *
     * @param {number} originTime - tempo de áudio (s) correspondente ao beat 0
     * @param {number} [latencyOffset] - s a descontar
     */
    start(originTime, latencyOffset = 0) {
        this.recording = true;
        this.originTime = originTime;
        this.latencyOffset = latencyOffset;
        this.inputs = [];
    }

    /** Tempo de áudio absoluto (s) → ms relativos ao beat 0, já compensados. */
    toRelativeMs(at) {
        return (at - this.originTime - this.latencyOffset) * 1000;
    }

    /**
     * Grava um ataque. Recebe os DOIS objetos do contrato de entrada, exatamente
     * como a fonte os entregou — nada de desmontar e remontar pelo caminho.
     *
     * @param {Object} info - PitchUtil.info (QUAL nota)
     * @param {Object} [ev] - {at, timed, source, velocity} (O ACONTECIMENTO)
     * @returns {Object|null} a entrada gravada, ou null se a captura está fechada
     */
    record(info, ev) {
        if (!this.recording || !info) return null;
        // Fonte sem carimbo (contrato antigo, ou AudioContext ausente): lê o relógio
        // aqui. Pior que o carimbo da fonte — perdeu-se o caminho até este ponto —
        // mas infinitamente melhor que descartar a nota do aluno.
        const at = (ev && typeof ev.at === 'number')
            ? ev.at
            : (window.audioManager ? window.audioManager.now() : 0);

        const entry = {
            startRelative: this.toRelativeMs(at),  // ms — o que o RhythmScorer lê
            at,
            midi: info.midi,
            sci: info.sci,
            letter: info.letter,
            // 🔴 Viaja com a nota: o microfone detecta a altura ~50–120 ms depois do
            // ataque (ver MicPitchInput._emit). Quem for pontuar RITMO precisa saber
            // que este instante não é medida — e precisa saber POR NOTA, porque a
            // pessoa pode trocar de superfície no meio da peça.
            //
            // 🔴 O default é FALSO: só é cronometrável quem DECLARA `timed: true`. A versão
            // anterior presumia o contrário (`!(ev && ev.timed === false)`), e o default
            // estava do lado errado — uma fonte que não diz nada passava a ser pontuada
            // como se fosse precisa. Isso não é hipotético: existe uma cópia congelada do
            // microfone no bundle do teste vocal (js/tools/teste-vocal.js, gerado antes
            // deste contrato) que emite sem `ev`. Na dúvida sobre QUANDO a nota aconteceu,
            // a resposta honesta é "não sei", nunca "no tempo certo".
            timed: !!(ev && ev.timed === true),
            source: (ev && ev.source) || null
        };
        this.inputs.push(entry);
        if (this.onRecord) this.onRecord(entry);
        return entry;
    }

    /**
     * Fecha a captura e devolve os ataques em ORDEM TEMPORAL.
     *
     * A ordenação não é zelo excessivo: o alinhamento do RhythmScorer pressupõe as
     * duas sequências ordenadas, e o microfone pode emitir fora de ordem (uma nota
     * confirma depois de outra que atacou mais tarde mas estabilizou antes).
     */
    stop() {
        this.recording = false;
        this.inputs.sort((a, b) => a.startRelative - b.startRelative);
        return this.inputs;
    }

    /**
     * Todos os ataques são de superfície que mede tempo? (false ⇒ não pontuar ritmo)
     *
     * 🔴 Take VAZIO devolve `false`, não `true`. `[].every(...)` é `true` por definição, e
     * isso fazia quem não tocou nada no microfone receber um "Ritmo 0%" — exatamente o
     * número que a decisão de projeto promete nunca exibir para o mic. Sem nenhuma nota
     * não há nada medido, então não há o que afirmar sobre ritmo.
     */
    allTimed() {
        return this.inputs.length > 0 && this.inputs.every(i => i.timed);
    }

    clear() {
        this.inputs = [];
    }
}

// Disponibiliza globalmente
if (typeof window !== 'undefined') window.NoteInputRecorder = NoteInputRecorder;



// ============================================
// games/StaffReadingGenerator.js
// ============================================
/**
 * StaffReadingGenerator - Sorteia notas para o jogo de leitura de pauta.
 *
 * Análogo ao RhythmPatternGenerator, mas trivial: escolhe uma posição musical
 * dentro de um intervalo e devolve os dados da nota (posição na pauta, letra,
 * solfejo e altura científica para tocar o som).
 *
 * Mapa de posições (clave de sol) — igual ao documentado em MusicStaff:
 *   -2 Dó central (linha supl.)  …  0 Mi(linha1) … 8 Fá(linha5) … 10 Lá(supl.)
 *
 * Clave de fá: a MESMA geometria (posição → Y não muda), outra tabela de nomes
 * (`NOTE_TABLE_BASS`). Dó central = pos -2 na de sol e pos 10 na de fá — o mesmo `C4`.
 *   `clef`: 'treble' (default, comportamento histórico) · 'bass' · 'both' (sorteia a
 *   clave a cada nota). Na de fá o range é `bassRange` (default Dó3–Dó4 = 3..10: a
 *   região de mão esquerda que todo método ensina primeiro, e o piso do banco do piano
 *   realista, C3). 🔴 `minPos/maxPos` são SEMPRE da clave de sol — em 'bass' são ignorados.
 *
 * Tonalidade (treino livre, 27/set): `sharps` (−7..7, default 0) é a ARMADURA. A posição
 * sorteada é a mesma; o que muda é a SOLETRAÇÃO: em Sol maior a linha do Fá é Fá♯. Cada
 * nota sai com `alter` (−1/0/+1 pela `Notation.keyAccidentals`), `midi`, `pc` (classe de
 * altura), `id` (nome soletrado, 'F#'/'Bb'/'C') e `sci` já alterada ('F#4'). Com 0 os
 * campos históricos (`letter`, `solfege`, `sci`) são IDÊNTICOS aos de antes — a esteira
 * (`ReadingFlowGame`) não sabe de armadura e não muda.
 * 🔴 O que se lê é a LETRA + a armadura; a resposta é da ALTURA (o piano) ou do nome
 * soletrado (os botões) — quem decide é o jogo (`StaffReadingGame.answer`), não aqui.
 */
class StaffReadingGenerator {
    // Tabela posição → { letter, solfege, sci }. Cobre Dó central .. Lá agudo.
    static NOTE_TABLE = {
        '-2': { letter: 'C', solfege: 'Dó',  sci: 'C4' }, // Dó central
        '-1': { letter: 'D', solfege: 'Ré',  sci: 'D4' },
        '0':  { letter: 'E', solfege: 'Mi',  sci: 'E4' },
        '1':  { letter: 'F', solfege: 'Fá',  sci: 'F4' },
        '2':  { letter: 'G', solfege: 'Sol', sci: 'G4' },
        '3':  { letter: 'A', solfege: 'Lá',  sci: 'A4' },
        '4':  { letter: 'B', solfege: 'Si',  sci: 'B4' },
        '5':  { letter: 'C', solfege: 'Dó',  sci: 'C5' },
        '6':  { letter: 'D', solfege: 'Ré',  sci: 'D5' },
        '7':  { letter: 'E', solfege: 'Mi',  sci: 'E5' },
        '8':  { letter: 'F', solfege: 'Fá',  sci: 'F5' },
        '9':  { letter: 'G', solfege: 'Sol', sci: 'G5' },
        '10': { letter: 'A', solfege: 'Lá',  sci: 'A5' }
    };

    // Clave de fá: mesma posição, outro nome. Sol2 na linha 1 … Lá3 na linha 5.
    static NOTE_TABLE_BASS = {
        '-2': { letter: 'E', solfege: 'Mi',  sci: 'E2' },
        '-1': { letter: 'F', solfege: 'Fá',  sci: 'F2' },
        '0':  { letter: 'G', solfege: 'Sol', sci: 'G2' },
        '1':  { letter: 'A', solfege: 'Lá',  sci: 'A2' },
        '2':  { letter: 'B', solfege: 'Si',  sci: 'B2' },
        '3':  { letter: 'C', solfege: 'Dó',  sci: 'C3' },
        '4':  { letter: 'D', solfege: 'Ré',  sci: 'D3' },
        '5':  { letter: 'E', solfege: 'Mi',  sci: 'E3' },
        '6':  { letter: 'F', solfege: 'Fá',  sci: 'F3' },
        '7':  { letter: 'G', solfege: 'Sol', sci: 'G3' },
        '8':  { letter: 'A', solfege: 'Lá',  sci: 'A3' },
        '9':  { letter: 'B', solfege: 'Si',  sci: 'B3' },
        '10': { letter: 'C', solfege: 'Dó',  sci: 'C4' } // Dó central (supl. acima)
    };

    static TABLES = { treble: StaffReadingGenerator.NOTE_TABLE, bass: StaffReadingGenerator.NOTE_TABLE_BASS };
    static CLEFS = ['treble', 'bass', 'both'];
    static DEFAULT_BASS_RANGE = [3, 10]; // Dó3–Dó4
    static MAX_SHARPS = 7;               // o círculo de quintas acaba em 7 (Dó♯ maior / Dó♭ maior)

    // Distância máxima (em graus) do sorteio em relação à nota anterior, por `motion`.
    // 🔴 `free` é o comportamento HISTÓRICO (salto livre) e segue sendo o default: nenhum
    // nível que não pedir `motion` muda de dificuldade.
    static MOTION_SPAN = { step: 1, mixed: 3 };

    /**
     * @param {Object} config - { minPos, maxPos, avoidRepeat, motion, clef, bassRange }
     *   Default: 0..9 (Mi4..Sol5) — tudo dentro/colado na pauta, sem linhas
     *   suplementares → "bem simples" para o protótipo inicial.
     *   `motion`: 'step' (±1 grau) · 'mixed' (±1..3) · 'free' (qualquer, default).
     *   `clef`: 'treble' (default) · 'bass' · 'both'. `bassRange`: [min,max] na de fá.
     */
    constructor(config = {}) {
        this.minPos = Number.isInteger(config.minPos) ? config.minPos : 0;
        this.maxPos = Number.isInteger(config.maxPos) ? config.maxPos : 9;
        this.avoidRepeat = config.avoidRepeat !== false;
        this.motion = StaffReadingGenerator.MOTION_SPAN[config.motion] ? config.motion : 'free';
        this.clef = StaffReadingGenerator.CLEFS.includes(config.clef) ? config.clef : 'treble';
        const br = Array.isArray(config.bassRange) && config.bassRange.length === 2
            && config.bassRange.every(Number.isInteger) ? config.bassRange : StaffReadingGenerator.DEFAULT_BASS_RANGE;
        this.bassRange = [Math.min(br[0], br[1]), Math.max(br[0], br[1])];
        this.sharps = StaffReadingGenerator.clampSharps(config.sharps);
        this.last = null;
        this.lastClef = null;
    }

    /** Armadura válida: inteiro em −7..7; qualquer outra coisa é Dó maior (0). */
    static clampSharps(v) {
        const n = Number.isInteger(v) ? v : 0;
        return Math.max(-StaffReadingGenerator.MAX_SHARPS, Math.min(StaffReadingGenerator.MAX_SHARPS, n));
    }

    /** Sufixo do nome soletrado: 'F' + '#' = 'F#'; 'B' + 'b' = 'Bb'. */
    static accSuffix(alter) {
        return alter > 0 ? '#' : alter < 0 ? 'b' : '';
    }

    /**
     * Uma nota da tabela LIDA numa armadura: soletração + altura de verdade.
     * `sci`/`midi` já carregam a alteração ('F#4' = 66); `pc` é a classe de altura 0..11
     * (é por ela que a tecla do piano responde); `id` é o nome soletrado ('F#').
     * @param {{letter:string, solfege:string, sci:string}} data - entrada de NOTE_TABLE*
     * @param {number} sharps
     */
    static inKey(data, sharps) {
        const n = StaffReadingGenerator.clampSharps(sharps);
        const alter = n ? window.Notation.keyAccidentals(n)[data.letter] : 0;
        const midi = window.PitchUtil.midiFromSci(data.sci) + alter;
        const acc = StaffReadingGenerator.accSuffix(alter);
        return {
            ...data,
            alter, midi,
            pc: ((midi % 12) + 12) % 12,
            id: data.letter + acc,
            sci: data.letter + acc + data.sci.slice(1),
            sharps: n
        };
    }

    /**
     * As 7 notas da escala da armadura, em ordem de letra (Dó..Si), cada uma com a
     * alteração que a armadura impõe: é a lista de RESPOSTAS possíveis do treino.
     * @returns {Array<{letter:string, alter:number, id:string, pc:number}>}
     */
    static keyNotes(sharps) {
        const n = StaffReadingGenerator.clampSharps(sharps);
        const acc = n ? window.Notation.keyAccidentals(n) : null;
        return window.Notation.LETTERS.map(letter => {
            const alter = acc ? acc[letter] : 0;
            const pc = ((window.Notation.NATURAL_PC[letter] + alter) % 12 + 12) % 12;
            return { letter, alter, id: letter + StaffReadingGenerator.accSuffix(alter), pc };
        });
    }

    /** Range de posições da clave pedida (sol: minPos/maxPos · fá: bassRange). */
    rangeFor(clef) {
        return clef === 'bass' ? this.bassRange : [this.minPos, this.maxPos];
    }

    /** Clave da PRÓXIMA nota: fixa, ou moeda em 'both'. */
    _pickClef() {
        if (this.clef !== 'both') return this.clef;
        return Math.random() < 0.5 ? 'treble' : 'bass';
    }

    /**
     * Sorteia uma nota dentro do intervalo configurado.
     *
     * Com `motion` de passo/salto o sorteio é RELATIVO à anterior: ler por grau conjunto é
     * a habilidade que o iniciante realmente usa (a leitura real anda por segundas), e o
     * salto livre desde o nível 1 vira loteria de reconhecimento isolado. A primeira nota
     * de cada rodada não tem anterior ⇒ sorteio livre.
     *
     * Em 'both' a clave troca por moeda e a nota depois de uma troca sai livre (grau
     * conjunto entre claves não é leitura, é aritmética).
     *
     * @returns {{position:number, clef:string, letter:string, solfege:string, sci:string,
     *            alter:number, midi:number, pc:number, id:string, sharps:number}}
     */
    generate() {
        const clef = this._pickClef();
        const [minPos, maxPos] = this.rangeFor(clef);
        const span = maxPos - minPos + 1;
        const reach = StaffReadingGenerator.MOTION_SPAN[this.motion];
        const sameClef = this.lastClef === null || this.lastClef === clef;
        let pos;
        if (reach && this.last !== null && sameClef && span > 1) {
            // Candidatas dentro do alcance E dentro do range, tirando a repetição.
            // 🔴 Montar a lista em vez de sortear-e-tentar: perto da borda (última nota no
            // extremo) metade dos candidatos cai fora, e um laço de rejeição pode girar
            // muito ou, com `avoidRepeat`, nunca sair. A lista nunca fica vazia porque
            // span > 1 garante ao menos um vizinho válido.
            const cands = [];
            for (let p = this.last - reach; p <= this.last + reach; p++) {
                if (p < minPos || p > maxPos) continue;
                if (this.avoidRepeat && p === this.last) continue;
                cands.push(p);
            }
            pos = cands[Math.floor(Math.random() * cands.length)];
        } else {
            // Repetição só conta na MESMA clave: a mesma posição noutra clave é outra nota.
            const avoid = this.avoidRepeat && span > 1 && sameClef;
            do {
                pos = minPos + Math.floor(Math.random() * span);
            } while (avoid && pos === this.last);
        }
        this.last = pos;
        this.lastClef = clef;

        const data = StaffReadingGenerator.TABLES[clef][String(pos)];
        return { position: pos, clef, ...StaffReadingGenerator.inKey(data, this.sharps) };
    }

    /** Lista de letras únicas possíveis (união das claves em jogo; para validar botões). */
    possibleLetters() {
        const set = new Set();
        const clefs = this.clef === 'both' ? ['treble', 'bass'] : [this.clef];
        clefs.forEach((clef) => {
            const [lo, hi] = this.rangeFor(clef);
            for (let p = lo; p <= hi; p++) {
                const d = StaffReadingGenerator.TABLES[clef][String(p)];
                if (d) set.add(d.letter);
            }
        });
        return [...set];
    }
}

// Disponibiliza globalmente
window.StaffReadingGenerator = StaffReadingGenerator;



// ============================================
// games/IntervalGenerator.js
// ============================================
/**
 * IntervalGenerator - Sorteia perguntas do jogo de intervalos.
 *
 * Análogo aos geradores dos outros jogos. Escolhe uma NOTA RAIZ dentro de uma
 * faixa e um INTERVALO habilitado; devolve raiz + alvo (em MIDI) já calculados.
 *
 * Robusto p/ crescimento: a lista de intervalos habilitados, a faixa de raízes
 * e a direção são todas configuráveis. Hoje começa só com 3ª maior e menor.
 */
class IntervalGenerator {
    /**
     * @param {Object} config
     *   intervals  : codes habilitados (default ['M3','m3'])
     *   minRootSci : raiz mínima (default 'C4')
     *   maxRootSci : raiz máxima (default 'G4' — garante alvo ≤ B4 p/ 3ª no piano 1 oitava)
     *   direction  : 'up' (default) | 'down' | 'both' (sorteia a cada pergunta)
     *   avoidRepeat: evita repetir o MESMO par (raiz+intervalo) seguido
     */
    constructor(config = {}) {
        this.codes = config.intervals && config.intervals.length ? config.intervals : ['M3', 'm3'];
        this.minRoot = window.PitchUtil.midiFromSci(config.minRootSci || 'C4');
        this.maxRoot = window.PitchUtil.midiFromSci(config.maxRootSci || 'G4');
        this.direction = config.direction || 'up';
        this.avoidRepeat = config.avoidRepeat !== false;
        this._lastKey = null;
    }

    /** Direção efetiva desta pergunta ('both' → sorteia up/down). */
    _resolveDirection() {
        if (this.direction === 'both') return Math.random() < 0.5 ? 'up' : 'down';
        return this.direction === 'down' ? 'down' : 'up';
    }

    /** Intervalos habilitados como objetos Interval, ordenados por semitons. */
    enabledIntervals() {
        return window.Interval.all(this.codes).sort((a, b) => a.semitones - b.semitones);
    }

    /**
     * @returns {{interval:Interval, rootMidi:number, targetMidi:number, direction:string}}
     */
    generate() {
        const span = this.maxRoot - this.minRoot + 1;
        let interval, rootMidi, key;
        do {
            const code = this.codes[Math.floor(Math.random() * this.codes.length)];
            interval = window.Interval.fromCode(code);
            rootMidi = this.minRoot + Math.floor(Math.random() * span);
            key = `${code}@${rootMidi}`;
        } while (this.avoidRepeat && key === this._lastKey && (span > 1 || this.codes.length > 1));
        this._lastKey = key;

        const direction = this._resolveDirection();
        const targetMidi = interval.apply(rootMidi, direction);
        return { interval, rootMidi, targetMidi, direction };
    }
}

// Disponibiliza globalmente
window.IntervalGenerator = IntervalGenerator;



// ============================================
// games/ChordGenerator.js
// ============================================
/**
 * ChordGenerator - Sorteia perguntas do jogo de acordes.
 *
 * Análogo ao IntervalGenerator: escolhe uma FUNDAMENTAL dentro de uma faixa e um
 * ACORDE habilitado; devolve fundamental + notas (MIDIs) já calculadas.
 *
 * Clamp automático ao range do piano: cada acorde tem um `topOffset` (semitons da
 * nota mais aguda). A faixa efetiva de fundamentais é INTERSECTADA com o teto do
 * piano (`maxTopMidi`) por acorde, garantindo que a nota mais aguda nunca passe do
 * teclado — assim os níveis podem pedir 13ªs sem estourar o range. Por isso o sorteio
 * escolhe o acorde PRIMEIRO e só então a fundamental (que depende do topOffset dele).
 */
class ChordGenerator {
    /**
     * @param {Object} config
     *   chords     : codes habilitados (default ['maj','min'])
     *   minRootSci : fundamental mínima (default 'C4')
     *   maxRootSci : fundamental máxima (default 'G4')
     *   maxTopMidi : teto absoluto da nota mais aguda (default C6 = 84) — clamp ao piano
     *   avoidRepeat: evita repetir o MESMO par (fundamental+acorde) seguido
     */
    constructor(config = {}) {
        this.codes = config.chords && config.chords.length ? config.chords : ['maj', 'min'];
        this.minRoot = window.PitchUtil.midiFromSci(config.minRootSci || 'C4');
        this.maxRoot = window.PitchUtil.midiFromSci(config.maxRootSci || 'G4');
        this.maxTopMidi = config.maxTopMidi != null ? config.maxTopMidi : window.PitchUtil.midiFromSci('C6');
        this.avoidRepeat = config.avoidRepeat !== false;
        this._lastKey = null;
    }

    /** Acordes habilitados como objetos Chord, ordenados por nº de notas e tamanho. */
    enabledChords() {
        return window.Chord.all(this.codes)
            .sort((a, b) => (a.size - b.size) || (a.topOffset - b.topOffset));
    }

    /**
     * @returns {{chord:Chord, rootMidi:number, notes:number[]}}
     */
    generate() {
        let chord, rootMidi, key;
        do {
            const code = this.codes[Math.floor(Math.random() * this.codes.length)];
            chord = window.Chord.fromCode(code);
            // teto de fundamental p/ este acorde caber no piano (nota aguda ≤ maxTopMidi)
            const hiRoot = Math.min(this.maxRoot, this.maxTopMidi - chord.topOffset);
            const loRoot = Math.min(this.minRoot, hiRoot);
            const span = hiRoot - loRoot + 1;
            rootMidi = loRoot + Math.floor(Math.random() * span);
            key = `${code}@${rootMidi}`;
        } while (this.avoidRepeat && key === this._lastKey && this.codes.length > 1);
        this._lastKey = key;

        return { chord, rootMidi, notes: chord.apply(rootMidi) };
    }
}

// Disponibiliza globalmente
window.ChordGenerator = ChordGenerator;



// ============================================
// games/RhythmGame.js
// ============================================
/**
 * RhythmGame - Jogo de Ritmo (relógio único / AudioContext)
 *
 * REESCRITA P0–P8:
 *  - P0: metrônomo, demo, lead-in, grade e inputs derivam de UM relógio
 *        (AudioContext.currentTime). Sem setInterval/setTimeout/performance.now
 *        para tempo musical. Vide MetronomeManager (lookahead scheduler).
 *  - P1: feedback adiantado/atrasado (ao vivo + no resultado).
 *  - P2: playhead varrendo a partitura, sincronizado ao áudio.
 *  - P3: fluxo Ouvir → Avaliar (não é exame de tentativa única). O "Praticar" (tocar junto
 *    sem nota) saiu em 18/set: o Avaliar já faz isso E devolve o resultado.
 *  - P4: scoring com janela de tolerância; duração é opcional.
 *  - P5: tempo lento por padrão + alternância Lento/Normal.
 *  - P6: input robusto no RhythmTapButton (pointer capture + Espaço).
 *  - P7: compensação da latência de saída que o NAVEGADOR informa (`outputLatency`, inclui o
 *    fone Bluetooth). A calibração manual por toques SAIU em 18/set: misturava o atraso do
 *    aparelho com o hábito da pessoa e errava ~29 ms por construção (o 1º toque é reflexo).
 *
 * Estados: idle(menu) → demo | countdown→recording→evaluating→results
 */
class RhythmGame {
    /**
     * @param {{mode?: 'ranked'|'free'|'list', list?: object}} opts
     *   mode='ranked' (default) → trilha de níveis (#/ritmo, headline).
     *   mode='free'             → sandbox de figuras (#/ritmo-livre).
     *   mode='list'             → TRILHA DO PROFESSOR (#/ritmo-livre?lista=CÓDIGO), `opts.list` =
     *                             a lista normalizada por RhythmTrails (docs/LISTAS-PLANO.md).
     *                             Hoje `free` significava "sandbox da pessoa" E "sem trilha"; a
     *                             lista precisa do segundo e NÃO pode ter o primeiro — daí o 3º modo.
     */
    constructor(opts = {}) {
        this.mode = opts.mode === 'free' ? 'free' : (opts.mode === 'list' ? 'list' : 'ranked');
        this.trail = (this.mode === 'list' && opts.list && Array.isArray(opts.list.levels) && opts.list.levels.length) ? opts.list : null;
        if (this.mode === 'list' && !this.trail) throw new Error('RhythmGame: modo list exige a lista normalizada');
        this.state = 'idle';

        this.container = null;
        this.musicStaff = null;
        this.renderer = null;
        this.inputDetector = null;
        this.scorer = null;
        this.tapButton = null;
        this.midiInput = null;   // RhythmMidiInput, só com o ajuste "Teclado MIDI" ligado (_syncMidi)

        this.staffContainer = null;
        this.controlsContainer = null;
        this.statusEl = null;
        this.countdownEl = null;
        this._lastCountValue = null; // guarda da contagem na bola (pulsa só na virada)
        this.resultsContainer = null;

        this.currentPattern = null;
        // A nota que o modelo e o botão soam — ajuste do JOGADOR (RhythmPrefs, ⚙️). Sorteada
        // a cada ritmo novo quando o ajuste é "variar".
        this._note = 'B4';
        // "Melodia": uma nota por nota do ritmo (índice = ordem das notas SONORAS), ou null.
        this._melody = null;

        // P5 — tempo: seletor contínuo (slider) 40–120 BPM, passo 5.
        // Substitui os toggles Lento/Normal. Fonte de verdade é currentBpm;
        // pattern.config.bpm é sincronizado. Persistido em localStorage.
        this.MIN_BPM = 40;
        this.MAX_BPM = 120;
        this.BPM_STEP = 5;
        // 🔴 Andamento por MODO: o livre lê o do PRESET (chave própria, `RhythmSandbox`), a
        // trilha lê `rhythm_bpm`. As duas já dividiram a mesma chave, e entrar num nível
        // sobrescrevia o andamento do personalizado. Padrão do SANDBOX, nunca o
        // EXERCISE_CONFIG vivo (ele carrega o bpm do último nível jogado).
        // Trilha do professor: o andamento é o do NÍVEL (inteiro; ver _clampBpm).
        const savedBpm = this.trail
            ? this._trailLevel().preset.bpm
            : (this.mode === 'free' && window.RhythmSandbox)
                ? window.RhythmSandbox.getPreset().bpm
                : parseInt(localStorage.getItem('rhythm_bpm'), 10);
        const defaultBpm = (window.RhythmSandbox && window.RhythmSandbox.DEFAULTS.bpm) || 60;
        this.currentBpm = this._clampBpm(Number.isFinite(savedBpm) ? savedBpm : defaultBpm);

        // refs do controle de tempo (atualizados ao vivo sem re-renderizar a pauta)
        this._tempoSlider = null;
        this._tempoReadout = null;

        // P7 — compensação de latência (s). Default = latência de saída do device.
        // = outputLatency do navegador (init).
        this.latencyOffset = 0;

        // Pré-roll de captura no take avaliado: abre o input MEIA BATIDA antes do
        // beat 0 (origem inalterada) p/ não descartar um toque ADIANTADO na 1ª nota
        // — senão ela cairia num dead zone e viraria "perdida". Proporcional ao beat:
        // ½ batida = 500ms a 60 BPM, 250ms a 120 — sempre longe do clique da contagem
        // (1 batida atrás) e dentro da tolerância de casamento (1 batida) do scorer.
        this.INPUT_PREROLL_BEATS = 0.5;

        // animação
        this.rafId = null;
        // handles das notas-modelo (B4) agendadas no futuro; _killScheduledAudio() as mata
        // ao parar (senão a demonstração segue soando após "Parar" — vazamento de áudio).
        this.scheduledNotes = [];
        this.activeExpectedMs = null; // notas esperadas (ms) do take ativo, p/ feedback ao vivo
    }

    async init(container) {
        this.container = container;

        if (!window.audioManager || !window.audioManager.isReady()) {
            this.container.innerHTML = `
                <div style="padding:2rem;text-align:center;">
                    <h2>${this._t('rhythm.initError')}</h2>
                    <p>${this._t('rhythm.audioUnavailable')}</p>
                    <button onclick="window.location.hash='/'" style="margin-top:1rem;padding:0.5rem 1rem;">${this._t('rhythm.back')}</button>
                </div>`;
            return;
        }

        // Latência: a que o NAVEGADOR informa (Chrome/Firefox; Safari desde 18.4).
        // 🔴 A calibração manual saiu (18/set) e o valor que ela deixou gravado é IGNORADO e
        //    apagado: sem o botão, quem calibrou com um fone que nem usa mais ficaria preso
        //    àquele número para sempre, sem ter como desfazer.
        try { localStorage.removeItem('rhythm_latency_offset'); } catch (e) {}
        this.latencyOffset = window.audioManager.getOutputLatency();
        // Ajuste do jogador que a conta não confirmou (rede caiu na última escolha): reenviar.
        if (window.RhythmPrefs) window.RhythmPrefs.flush();

        this.setupUI();
        this.setupComponents();
        // Teclado MIDI como botão (ajuste de aparelho): liga se a pessoa deixou ligado. A
        // permissão já foi dada no 1º clique do ⚙️, então aqui não há prompt.
        this._syncMidi();

        // No modo trilha (ranked), o nível dita o tempo inicial (a dificuldade é
        // controlada). O sandbox (livre) mantém o BPM salvo do usuário.
        if (this._levelsMode() && window.RhythmLevels) {
            this._enforceGate();
            const lvl = window.RhythmLevels.byId(window.RhythmLevels.getCurrent());
            if (lvl) this.currentBpm = this._clampBpm(lvl.bpm);
        }

        this.prepareRound();

        // Retomada pós-OAuth (AuthGate): intent salvo antes do redirect do Google →
        // entra direto no nível pretendido (gate passa; desbloqueio-por-progresso manda).
        if (this._levelsMode() && window.authGate) {
            const it = window.authGate.takeIntentFor('rhythm');
            if (it) this._enterLevel(it.levelNum);
        }

        // Tutorial: auto-abre 1x por device, SÓ no ranqueado (porta de entrada);
        // no personalizado fica só o botão "?" do menu. showTutorial() trata vazio.
        // 🔴 Mesma política do `_maybeTeach` da Leitura: com outro modal em tela (aviso
        // de conta, login retomado pelo AuthGate) o tutorial NÃO abre e NÃO marca como
        // visto — senão o `modal()` derrubava o outro e a lição sumia para sempre.
        if (this._levelsMode() && !localStorage.getItem('rhythm_tutorial_seen')
            && !(window.notifications && window.notifications.isModalOpen())) {
            this.showTutorial();
            localStorage.setItem('rhythm_tutorial_seen', '1');
        }
    }

    setupUI() {
        // Mobile: padding menor (mais largura útil p/ a pauta) e overflow contido
        // (defesa contra "samba" — nada transborda a viewport horizontalmente).
        const mobile = (window.innerWidth || 1024) < 560;
        const pad = mobile ? '0.75rem' : '1.5rem';
        // Modo trilha: dispensa o h1 "Jogo de Ritmo" (redundante com o chip "Ritmo" do
        // header). No lugar, uma faixa compacta de progresso (Nível X de N + rail),
        // clicável p/ abrir o mapa — preenchida por _renderLevelStrip(). O modo livre
        // mantém o h1 (o header não distingue "Livre").
        // Modo `list`: a faixa da TRILHA (nome · nível N de M · rótulo), montada por textContent
        // em _renderTrailStrip — nome e rótulo são texto do autor, nunca HTML.
        const topHtml = this._levelsMode()
            ? `<div id="rhythm-level-strip" style="text-align:center;margin-bottom:0.6rem;"></div>`
            : this._listMode()
                ? `<div id="rhythm-trail-strip" style="text-align:center;margin-bottom:0.6rem;"></div>`
                : `<h1 class="game-h1" style="text-align:center;margin-bottom:0.5rem;">🥁 ${this._t('rhythm.freeTitle')}</h1>`;
        this.container.innerHTML = `
            <div class="rhythm-game" style="max-width:900px;margin:0 auto;padding:${pad};overflow-x:hidden;">
                ${topHtml}
                <div class="game-intro" style="display:flex;align-items:center;justify-content:center;gap:0.1rem;margin-bottom:0.5rem;">
                    <p id="rhythm-status" style="text-align:center;color:#555;min-height:1.5rem;margin:0;"></p>
                </div>
                <div id="staff-container" style="margin:1rem auto;max-width:100%;overflow:hidden;"></div>
                <div id="countdown-display" style="text-align:center;font-weight:bold;color:#6366f1;display:flex;align-items:center;justify-content:center;"></div>
                <div id="controls-container" style="text-align:center;margin:1rem;"></div>
                <div id="rhythm-midi-status" role="status" aria-live="polite" style="display:none;text-align:center;font-size:0.85rem;color:#475569;margin:-0.4rem 1rem 0.8rem;"></div>
                <div id="results-container" style="display:none;"></div>
            </div>`;

        // "?" de estreia na linha do status — FORA do <p>, que _setStatus reescreve
        // por textContent. 🔴 Nunca no h1: `.game-h1` some abaixo de 560px, e na
        // trilha ele nem existe (o topo é a faixa de progresso).
        if (window.HelpDot) {
            window.HelpDot.attach(this.container.querySelector('.game-intro'), 'rhythm.howto');
        }

        this.staffContainer = this.container.querySelector('#staff-container');
        this.statusEl = this.container.querySelector('#rhythm-status');
        this.countdownEl = this.container.querySelector('#countdown-display');
        this.controlsContainer = this.container.querySelector('#controls-container');
        this.resultsContainer = this.container.querySelector('#results-container');
    }

    setupComponents() {
        this._buildStaff();
        this.inputDetector = new window.RhythmInputDetector();
        this.scorer = new window.RhythmScorer();

        this.tapButton = new window.RhythmTapButton(this.controlsContainer);
        this.tapButton.note = this._note;   // o ajuste do jogador (RhythmPrefs); _pickNote o renova a cada ritmo
        // Callbacks de instância (persistem entre re-renders do botão).
        // O release ENCERRA a linha-resposta ao vivo logo após o detector medir o
        // soltar (onTapUp empilha o input com endRelative → _finishResponseLine o lê).
        this.tapButton.setOnPress(() => this.inputDetector.onTapDown());
        this.tapButton.setOnRelease(() => { this.inputDetector.onTapUp(); this._finishResponseLine(); });
        // O teclado MIDI (RhythmMidiInput) entra por ESTES mesmos dois caminhos — ver _startMidi.

        // Relayout em rotação/resize (largura muda → recalcula escala da pauta).
        // Só re-renderiza no menu (idle); durante um take, ignora (raro e disruptivo).
        this._onResize = () => {
            if (this.state !== 'idle') return;
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => {
                if (this.state === 'idle') this._buildStaff(true);
            }, 150);
        };
        window.addEventListener('resize', this._onResize);
    }

    /**
     * Config responsiva do pentagrama a partir da largura ATUAL do container.
     * Mobile (estreito): margens/clave menores → mais largura p/ as notas (abordagem B).
     * Desktop (largo): valores da V3 → escala bate no teto (80px/beat) e fica idêntico.
     */
    _responsiveStaffConfig() {
        const measured = this.staffContainer ? this.staffContainer.clientWidth : 0;
        const w = Math.max(280, Math.floor(measured || window.innerWidth || 800));
        const mobile = w < 560;
        return {
            mobile,
            staff: {
                // height 250 (era 200): abre espaço VERTICAL abaixo da régua p/ as
                // fileiras de linhas-resposta do usuário. Cresce só pra baixo (viewBox
                // mais alto, width:100%/height:auto → notas no mesmo tamanho, sem mexer
                // no X). Sem isso as respostas cairiam fora do SVG (overflow:hidden corta).
                width: w, height: 250, lineSpacing: 10,
                marginLeft: mobile ? 14 : 60,
                marginRight: mobile ? 12 : 40,
                marginTop: 40
            },
            // clefSpace/leftInset menores no mobile = mais espaço p/ as notas respirarem
            layout: { clefSpace: mobile ? 48 : 80, leftInset: mobile ? 10 : 22 }
        };
    }

    /**
     * (Re)cria o pentagrama com a largura corrente. `reRender` re-desenha o padrão
     * atual (usado no resize). O RhythmRenderer é stateless (só LAYOUT/pxPerBeat),
     * então recriá-lo não perde nada; o playhead é recriado por _renderPattern().
     */
    _buildStaff(reRender = false) {
        const cfg = this._responsiveStaffConfig();
        if (this.musicStaff) this.musicStaff.destroy();
        this.musicStaff = new window.MusicStaff(this.staffContainer, cfg.staff);
        this.renderer = new window.RhythmRenderer(this.musicStaff);
        Object.assign(this.renderer.LAYOUT, cfg.layout);
        if (reRender && this.currentPattern) this._renderPattern();
    }

    // ---------- helpers ----------

    get beatsPerMeasure() {
        return this.currentPattern
            ? this.currentPattern.config.timeSignature.beats
            : 4;
    }

    /**
     * Contagem de entrada, em tempos: UM compasso — e o de 2 tempos conta dois (dois cliques
     * não dão o andamento). 4/4 → 4 · 3/4 → 3 (a contagem de valsa) · 2/4 → 4.
     * A contagem é SEMPRE inteira; o padrão de clique só vale depois dela.
     */
    static leadInBeats(beats) {
        return beats >= 3 ? beats : beats * Math.ceil(4 / beats);
    }

    /** Opções do metrônomo para este padrão (clique do preset; a trilha é sempre 'all'). */
    _metroOpts(leadInBeats) {
        const click = (this.currentPattern && this.currentPattern.config.click) || 'all';
        return { click, leadInBeats };
    }

    _beatDurSec() {
        return 60 / this.currentBpm;
    }

    _setStatus(text) {
        if (this.statusEl) this.statusEl.textContent = text || '';
    }

    /** i18n: atalho para window.language.t (fallback à chave se o Language não existir). */
    _t(key, params = {}) {
        return window.language ? window.language.t(key, params) : key;
    }

    _makeButton(label, bg, onClick, opts = {}) {
        const btn = window.domManager.create('button', {
            textContent: label,
            styles: {
                padding: opts.small ? '0.5rem 1rem' : '0.85rem 1.8rem',
                fontSize: opts.small ? '0.95rem' : '1.15rem',
                background: bg,
                color: '#fff',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
                fontWeight: 'bold',
                margin: '0.4rem',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                transition: 'transform 0.08s'
            }
        });
        btn.addEventListener('click', onClick);
        return btn;
    }

    // ---------- tutorial (cards de introdução) ----------

    /** Lê o array de cards do idioma atual (com fallback p/ pt). _t só devolve
     *  strings, então a lista vem direto do dicionário embutido (window.__I18N__). */
    _tutorialCards() {
        const dict = window.language.getTranslations();
        const lang = window.language.currentLanguage;
        const node = (dict && dict[lang] && dict[lang].rhythm && dict[lang].rhythm.tutorial)
            || (dict && dict.pt && dict.pt.rhythm && dict.pt.rhythm.tutorial);
        return (node && Array.isArray(node.cards)) ? node.cards : [];
    }

    /**
     * Overlay com os cards de introdução (1 de cada vez, navegação ◀ ▶ + pontinhos).
     * Auto-abre na 1ª visita (flag no localStorage) e fica disponível no botão "?".
     * Cards podem ter uma CENA animada (SVG + áudio) — ver this._tutorialScenes().
     * Transições de UI são CSS/rAF; o áudio das cenas roda no relógio de áudio e é
     * sempre encerrado (.stop()) ao trocar de card / fechar — nada vaza.
     */
    showTutorial() {
        const cards = this._tutorialCards();
        if (!cards.length) return;

        // Tema (roteiro v3.1) — história coesa em 7 quadros. Cenas escuras (corpo)
        // viram claras (página de música) a partir do Q3. Ordem do roteiro.
        const scenes = [
            (s) => this._sceneQ1(s),
            (s) => this._sceneQ2(s),
            (s) => this._sceneQ3(s),
            (s) => this._sceneQ4(s),
            (s) => this._sceneQ5(s),
            (s) => this._sceneQ6(s),
            (s) => this._sceneQ7(s)
        ];
        let idx = 0;
        let sceneStop = null; // cleanup da cena ativa (cancela rAF + mata áudio)

        const stopScene = () => { if (sceneStop) { sceneStop(); sceneStop = null; } };

        const overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;inset:0;z-index:1000;background:rgba(15,23,42,0.7);'
            + 'display:flex;align-items:center;justify-content:center;padding:1rem;'
            + 'opacity:0;transition:opacity 0.2s;backdrop-filter:blur(3px);';

        const modal = document.createElement('div');
        modal.style.cssText = 'background:#fff;border-radius:18px;max-width:430px;width:100%;'
            + 'padding:1.4rem;box-shadow:0 20px 60px rgba(0,0,0,0.35);text-align:center;';

        // Card escuro: palco GRANDE no topo, título + legenda curtos embaixo (mobile-first).
        const card = document.createElement('div');
        card.style.cssText = 'border-radius:14px;padding:0.9rem 0.9rem 1.2rem;color:#fff;'
            + 'background:linear-gradient(160deg,#1a1b26,#101119);'
            + 'transition:opacity 0.18s ease, transform 0.18s ease;';
        // palco da animação (SVG escuro, ocupa a maior parte do card)
        const stage = document.createElement('div');
        stage.style.cssText = 'margin:0 0 0.7rem;';
        const cardTitle = document.createElement('h2');
        cardTitle.style.cssText = 'margin:0 0 0.3rem;font-size:1.3rem;font-weight:800;';
        const cardBody = document.createElement('p');
        cardBody.style.cssText = 'margin:0;font-size:0.98rem;line-height:1.4;color:#c7c9d6;';
        card.appendChild(stage);
        card.appendChild(cardTitle);
        card.appendChild(cardBody);

        const dots = document.createElement('div');
        dots.style.cssText = 'display:flex;gap:0.4rem;justify-content:center;margin:1rem 0 0.6rem;';

        const nav = document.createElement('div');
        nav.style.cssText = 'display:flex;justify-content:space-between;align-items:center;gap:0.5rem;';
        const prevBtn = this._makeButton(this._t('rhythm.tutorial.prev'), '#94a3b8', () => go(idx - 1), { small: true });
        const nextBtn = this._makeButton('', 'linear-gradient(135deg,#10b981,#059669)',
            () => { if (idx >= cards.length - 1) close(); else go(idx + 1); });
        prevBtn.style.margin = '0';
        nextBtn.style.margin = '0';
        nav.appendChild(prevBtn);
        nav.appendChild(nextBtn);

        const skip = document.createElement('button');
        skip.textContent = this._t('rhythm.tutorial.skip');
        skip.style.cssText = 'background:none;border:none;color:#94a3b8;cursor:pointer;'
            + 'margin-top:0.7rem;font-size:0.9rem;';
        skip.addEventListener('click', close);

        const render = () => {
            const c = cards[idx];
            cardTitle.textContent = c.title;
            cardBody.innerHTML = c.body;
            prevBtn.style.visibility = idx === 0 ? 'hidden' : 'visible';
            nextBtn.textContent = (idx >= cards.length - 1)
                ? this._t('rhythm.tutorial.start') : this._t('rhythm.tutorial.next');
            dots.innerHTML = '';
            cards.forEach((_, i) => {
                const d = document.createElement('span');
                d.style.cssText = 'width:8px;height:8px;border-radius:50%;display:inline-block;'
                    + 'transition:background 0.2s;background:' + (i === idx ? '#FF5A6E' : '#3a3b46') + ';';
                dots.appendChild(d);
            });

            // monta a cena animada deste card (SVG escuro, viewBox 360x150)
            stopScene();
            stage.innerHTML = '';
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 360 150');
            svg.setAttribute('width', '100%');
            svg.style.cssText = 'display:block;border-radius:10px;background:#12131A;';
            stage.appendChild(svg);
            sceneStop = (scenes[idx] ? scenes[idx](svg) : null) || null;
        };

        function go(n) {
            if (n < 0 || n >= cards.length) return;
            stopScene(); // corta áudio/rAF do card que está saindo
            const dir = n > idx ? 18 : -18;
            card.style.opacity = '0';
            card.style.transform = 'translateX(' + dir + 'px)';
            setTimeout(() => {
                idx = n;
                render();
                card.style.opacity = '1';
                card.style.transform = 'translateX(0)';
            }, 160);
        }

        function close() {
            stopScene();
            overlay.style.opacity = '0';
            setTimeout(() => overlay.remove(), 200);
        }

        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

        modal.appendChild(card);
        modal.appendChild(dots);
        modal.appendChild(nav);
        modal.appendChild(skip);
        overlay.appendChild(modal);
        document.body.appendChild(overlay);
        render();
        requestAnimationFrame(() => { overlay.style.opacity = '1'; });
    }

    // ===== Toolkit de cena (compartilhado pelas 7 cenas do tutorial) =====

    /** cria + anexa um elemento SVG. */
    _svg(parent, tag, attrs) {
        const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
        for (const k in attrs) el.setAttribute(k, attrs[k]);
        parent.appendChild(el);
        return el;
    }

    /** cria um <text> com conteúdo (equivalente ao txt() do protótipo). */
    _txt(parent, attrs, content) {
        const t = this._svg(parent, 'text', attrs);
        t.textContent = content;
        return t;
    }

    /** "flash": aplica atributos, reverte após ms. Guarda o timeout em bag p/ limpar. */
    _tutFlash(el, on, off, ms, bag) {
        for (const k in on) el.setAttribute(k, on[k]);
        const id = setTimeout(() => { for (const k in off) el.setAttribute(k, off[k]); }, ms);
        if (bag) bag.push(id);
    }

    /**
     * Motor de loop de cena: agenda os toques (schedule) no relógio de áudio, roda
     * onFrame(t,pass) por rAF e dispara onTap(i,t,pass) ao cruzar cada toque; ao
     * fim do ciclo, recomeça. Devolve stop() que cancela o rAF e MATA o áudio
     * agendado à frente (contrato anti-vazamento). t em segundos dentro do ciclo.
     */
    _tutLoop(opts) {
        const cycleSec = opts.cycleSec;
        const schedule = opts.schedule || [];
        const onFrame = opts.onFrame, onTap = opts.onTap;
        let alive = true, raf = null, handles = [], t0 = 0, pass = 0, lit = [];
        const startPass = () => {
            if (!alive) return;
            window.audioManager.resumeContext();
            t0 = window.audioManager.now() + 0.15;
            handles = schedule.map((s) =>
                window.audioManager.playNote('B4', s.dur || 0.18, { when: t0 + s.at, volume: s.volume != null ? s.volume : 0.6 }));
            lit = schedule.map(() => false);
            frame();
        };
        const frame = () => {
            if (!alive) return;
            const raw = window.audioManager.now() - t0;
            const t = Math.max(0, Math.min(cycleSec, raw));
            if (onTap) schedule.forEach((s, i) => { if (!lit[i] && raw >= s.at) { lit[i] = true; onTap(i, t, pass); } });
            if (onFrame) onFrame(t, pass);
            if (raw < cycleSec) { raf = requestAnimationFrame(frame); }
            else { pass++; startPass(); }
        };
        startPass();
        return () => {
            alive = false;
            if (raf) cancelAnimationFrame(raf);
            handles.forEach((h) => { if (h && h.stop) h.stop(); });
        };
    }

    // ===== Primitivas de gravura (mesmo desenho do RhythmRenderer) =====

    /** constante de geometria da cabeça/haste (NH do protótipo). */
    _NH() { return { rx: 6.5, ry: 4.5, angle: -18, stemH: 26, stemOff: 5.5, stemW: 1.4 }; }

    _notehead(parent, x, y, color) {
        const NH = this._NH();
        return this._svg(parent, 'ellipse', { cx: x, cy: y, rx: NH.rx, ry: NH.ry, fill: color, transform: `rotate(${NH.angle} ${x} ${y})` });
    }
    _stem(parent, x, y, color) {
        const NH = this._NH();
        return this._svg(parent, 'line', { x1: x + NH.stemOff, y1: y - 1, x2: x + NH.stemOff, y2: y - NH.stemH, stroke: color, 'stroke-width': NH.stemW });
    }
    _eighthFlag(parent, x, y, color, s) {
        const NH = this._NH();
        s = s || 8;
        const sx = x + NH.stemOff, sy = y - NH.stemH;
        const d = `M ${sx} ${sy} C ${sx + 0.9 * s} ${sy + 0.55 * s}, ${sx + 0.95 * s} ${sy + 1.4 * s}, ${sx + 0.45 * s} ${sy + 2.2 * s}`
            + ` C ${sx + 0.75 * s} ${sy + 1.4 * s}, ${sx + 0.5 * s} ${sy + 0.9 * s}, ${sx} ${sy + 0.7 * s} Z`;
        return this._svg(parent, 'path', { d, fill: color, stroke: color, 'stroke-width': 0.5 });
    }
    _drawQuarter(parent, x, y, color) {
        const h = this._notehead(parent, x, y, color);
        this._stem(parent, x, y, color);
        return h;
    }
    _drawEighthPair(parent, xa, xb, y, color) {
        const NH = this._NH();
        const h1 = this._notehead(parent, xa, y, color);
        const h2 = this._notehead(parent, xb, y, color);
        this._stem(parent, xa, y, color); this._stem(parent, xb, y, color);
        this._svg(parent, 'line', { x1: xa + NH.stemOff - 0.7, y1: y - NH.stemH + 1.5, x2: xb + NH.stemOff + 0.7, y2: y - NH.stemH + 1.5, stroke: color, 'stroke-width': 4 });
        return [h1, h2];
    }

    /** Palco CLARO "cara do jogo" (pentagrama + clave + 4/4 + régua + playhead verde). */
    _staffStage(svg, o) {
        o = o || {};
        const compact = !!o.compact;
        const top = compact ? 24 : 34, ls = 9;
        const mid = top + 2 * ls;
        const rulerY = compact ? 96 : 108, numY = compact ? 110 : 126;
        this._svg(svg, 'rect', { x: 0, y: 0, width: 360, height: 150, fill: '#ffffff' });
        for (let i = 0; i < 5; i++)
            this._svg(svg, 'line', { x1: 14, y1: top + i * ls, x2: 346, y2: top + i * ls, stroke: '#333', 'stroke-width': 1 });
        this._txt(svg, { x: 18, y: mid + ls * 1.2, 'font-size': 40, 'font-family': 'Bravura, Times New Roman, Georgia, serif', fill: '#000' }, '𝄞');
        this._txt(svg, { x: 64, y: mid - ls * 0.8 + 7, 'font-size': 18, 'font-weight': 'bold', 'font-family': 'Times New Roman, serif', 'text-anchor': 'middle', fill: '#000' }, '4');
        this._txt(svg, { x: 64, y: mid + ls * 2.2 - 1, 'font-size': 18, 'font-weight': 'bold', 'font-family': 'Times New Roman, serif', 'text-anchor': 'middle', fill: '#000' }, '4');
        const padL = 96, padR = 26, beats = 4;
        const xOf = (b) => padL + (b / beats) * (360 - padL - padR);
        this._svg(svg, 'line', { x1: xOf(0), y1: rulerY, x2: xOf(beats), y2: rulerY, stroke: '#94a3b8', 'stroke-width': 1.5, 'stroke-dasharray': '3,3' });
        const nums = [];
        for (let b = 0; b <= beats; b++) {
            this._svg(svg, 'line', { x1: xOf(b), y1: rulerY - 5, x2: xOf(b), y2: rulerY + 5, stroke: '#333', 'stroke-width': b === beats ? 2 : 1.5 });
            if (b < beats) nums.push(this._txt(svg, { x: xOf(b), y: numY, 'text-anchor': 'middle', 'font-size': 11, 'font-family': 'Arial, sans-serif', fill: '#475569', 'font-weight': 'bold' }, b + 1));
        }
        const noteBeats = [0, 0.5, 2, 3];
        // 🔴 VALOR de cada figura, em tempos — declarado AO LADO de quem a desenha abaixo
        // (par de colcheias + 2 semínimas). NÃO se deduz do intervalo até a próxima nota:
        // entre a 2ª colcheia (0,5) e a 1ª semínima (2) há 1,5 tempo de ESPAÇO, e quem
        // deduzir daí acha que aquela colcheia vale 1,5 tempo.
        const noteVals = [0.5, 0.5, 1, 1];
        const heads = [], guides = [];
        if (!o.noNotes) {
            noteBeats.forEach((b) => guides.push(this._svg(svg, 'line', { x1: xOf(b), y1: mid + 4, x2: xOf(b), y2: rulerY - 2, stroke: '#10b981', 'stroke-width': 1.2, 'stroke-dasharray': '2,3', opacity: 0 })));
            const pair = this._drawEighthPair(svg, xOf(0), xOf(0.5), mid, '#000');
            heads.push(pair[0], pair[1]);
            heads.push(this._drawQuarter(svg, xOf(2), mid, '#000'));
            heads.push(this._drawQuarter(svg, xOf(3), mid, '#000'));
        }
        const ph = this._svg(svg, 'line', { x1: xOf(0), y1: top - 10, x2: xOf(0), y2: rulerY + 5, stroke: '#10b981', 'stroke-width': 2.5, 'stroke-linecap': 'round', opacity: 0 });
        return { xOf, beats, noteBeats, noteVals, heads, guides, ph, mid, top, ls, rulerY, nums };
    }

    /** Botão "TOQUE" claro (retângulo) + ripple. lit=true → rosa aceso. */
    _lightButton(svg, lit) {
        const x = 130, y = 126, w = 100, h = 18, cx = x + w / 2, cy = y + h / 2;
        const g = this._svg(svg, 'g', {});
        const ripple = this._svg(g, 'circle', { cx, cy, r: 12, fill: 'none', stroke: '#FF5A6E', 'stroke-width': 2, opacity: 0 });
        const btn = this._svg(g, 'rect', { x, y, width: w, height: h, rx: 9, fill: lit ? '#FF5A6E' : '#e2e8f0' });
        const label = this._txt(g, { x: cx, y: cy + 4, 'text-anchor': 'middle', 'font-size': 11, 'font-weight': 'bold', 'font-family': 'Arial, sans-serif', fill: lit ? '#fff' : '#94a3b8' }, this._t('rhythm.tap.label'));
        return { g, btn, ripple, label, cx, cy, x, y, w, h };
    }

    _heartPath(parent, tx, ty, scale, color) {
        const g = this._svg(parent, 'g', {});
        this._svg(g, 'path', { d: 'M0,-16 C-3,-30 -22,-32 -28,-18 C-34,-4 -12,10 0,22 C12,10 34,-4 28,-18 C22,-32 3,-30 0,-16 Z', fill: color || '#FF5A6E' });
        const set = (s) => g.setAttribute('transform', `translate(${tx},${ty}) scale(${(scale * s).toFixed(3)})`);
        set(1);
        return { g, set };
    }
    _heartbeatScale(t) {
        if (t < 0.12) return 1 + (t / 0.12) * 0.18;
        if (t < 0.26) return 1.18 - ((t - 0.12) / 0.14) * 0.18;
        if (t < 0.31) return 1 + ((t - 0.26) / 0.05) * 0.07;
        if (t < 0.36) return 1.07 - ((t - 0.31) / 0.05) * 0.07;
        return 1;
    }
    /** traçado de ECG: um pico por batida; devolve {d, beatsX} */
    _ecgPath(x0, x1, baseY, peakDrop) {
        const beatsX = [0, 1, 2, 3].map((k) => x0 + 26 + k * ((x1 - x0 - 52) / 3));
        let d = `M ${x0} ${baseY}`;
        beatsX.forEach((bx) => {
            d += ` L ${bx - 12} ${baseY} L ${bx - 9} ${baseY - 5} L ${bx - 6} ${baseY}`
               + ` L ${bx - 3} ${baseY} L ${bx} ${baseY - peakDrop} L ${bx + 3} ${baseY + peakDrop * 0.55} L ${bx + 6} ${baseY}`;
        });
        d += ` L ${x1} ${baseY}`;
        return { d, beatsX };
    }

    // ===== As 7 cenas (roteiro v3.1) =====

    /** Q1 — coração + ECG puro (sem números, sem acento: pulso é do corpo, não métrica). */
    _sceneQ1(svg) {
        const heart = this._heartPath(svg, 60, 66, 0.9);
        this._txt(svg, { x: 60, y: 126, 'text-anchor': 'middle', 'font-size': 11, 'font-family': 'Arial, sans-serif', fill: '#6b6c7a' }, '♥ ~70 bpm');
        const x0 = 110, x1 = 340, baseY = 72;
        const ecg = this._ecgPath(x0, x1, baseY, 30);
        const clip = this._svg(svg, 'clipPath', { id: 'q1clip' });
        const clipRect = this._svg(clip, 'rect', { x: x0, y: 0, width: 0, height: 150 });
        this._svg(svg, 'path', { d: ecg.d, fill: 'none', stroke: '#2a2b36', 'stroke-width': 2 });
        this._svg(svg, 'path', { d: ecg.d, fill: 'none', stroke: '#FF5A6E', 'stroke-width': 2.5, 'stroke-linecap': 'round', 'clip-path': 'url(#q1clip)' });
        const edge = this._svg(svg, 'circle', { cx: x0, cy: baseY, r: 3.5, fill: '#fff', opacity: 0.9 });
        const cycle = 3.6, reveal = 3.4, span = x1 - x0;
        const beatAt = ecg.beatsX.map((bx) => (bx - x0) / span * reveal);
        let lastBeat = -9;
        return this._tutLoop({
            cycleSec: cycle,
            schedule: beatAt.map((at) => ({ at, volume: 0.42, dur: 0.2 })),
            onTap: (i, t) => { lastBeat = t; },
            onFrame: (t) => {
                const w = Math.min(1, t / reveal) * span;
                clipRect.setAttribute('width', w.toFixed(1));
                edge.setAttribute('cx', (x0 + w).toFixed(1));
                edge.setAttribute('opacity', t < reveal ? 0.9 : 0);
                heart.set(this._heartbeatScale(Math.max(0, t - lastBeat)));
            }
        });
    }

    /** Q2 — ECG sobre o pentagrama: cada pico cristaliza numa semínima; contagem 1·2·3·4. */
    _sceneQ2(svg) {
        const heart = this._heartPath(svg, 38, 26, 0.42);
        const top = 46, ls = 9, mid = top + 2 * ls; // pentagrama y=46..82
        for (let i = 0; i < 5; i++)
            this._svg(svg, 'line', { x1: 70, y1: top + i * ls, x2: 344, y2: top + i * ls, stroke: '#4a4b58', 'stroke-width': 1, opacity: 0.7 });
        const x0 = 74, x1 = 340, baseY = mid;
        const ecg = this._ecgPath(x0, x1, baseY, 22);
        const clip = this._svg(svg, 'clipPath', { id: 'q2clip' });
        const clipRect = this._svg(clip, 'rect', { x: x0, y: 0, width: 0, height: 150 });
        this._svg(svg, 'path', { d: ecg.d, fill: 'none', stroke: '#23242f', 'stroke-width': 1.6 });
        this._svg(svg, 'path', { d: ecg.d, fill: 'none', stroke: '#FF5A6E', 'stroke-width': 2, 'stroke-linecap': 'round', 'clip-path': 'url(#q2clip)', opacity: 0.85 });
        const edge = this._svg(svg, 'circle', { cx: x0, cy: baseY, r: 3, fill: '#fff', opacity: 0.9 });
        const groups = ecg.beatsX.map((bx) => {
            const g = this._svg(svg, 'g', { opacity: 0, transform: `translate(${bx + 14},${mid}) scale(0)` });
            this._notehead(g, 0, 0, '#e8eaf2'); this._stem(g, 0, 0, '#e8eaf2');
            return g;
        });
        const nums = ecg.beatsX.map((bx, k) =>
            this._txt(svg, { x: bx + 14, y: 118, 'text-anchor': 'middle', 'font-size': k === 0 ? 18 : 14, 'font-family': 'Arial, sans-serif', 'font-weight': 'bold', fill: k === 0 ? '#FF5A6E' : '#8b8c9a', opacity: 0 }, k + 1));
        const cycle = 3.6, reveal = 3.4, span = x1 - x0;
        const beatAt = ecg.beatsX.map((bx) => (bx - x0) / span * reveal);
        let lastBeat = -9;
        return this._tutLoop({
            cycleSec: cycle,
            schedule: beatAt.map((at, k) => ({ at, volume: k === 0 ? 0.6 : 0.45, dur: 0.25 })),
            onTap: (i, t) => { lastBeat = t; },
            onFrame: (t) => {
                const w = Math.min(1, t / reveal) * span;
                clipRect.setAttribute('width', w.toFixed(1));
                edge.setAttribute('cx', (x0 + w).toFixed(1));
                edge.setAttribute('opacity', t < reveal ? 0.9 : 0);
                heart.set(this._heartbeatScale(Math.max(0, t - lastBeat)));
                groups.forEach((g, k) => {
                    const age = t - beatAt[k];
                    if (age < 0) { g.setAttribute('opacity', 0); nums[k].setAttribute('opacity', 0); return; }
                    const pop = age < 0.18 ? (age / 0.18) * 1.15 : (age < 0.3 ? 1.15 - ((age - 0.18) / 0.12) * 0.15 : 1);
                    g.setAttribute('transform', `translate(${ecg.beatsX[k] + 14},${mid}) scale(${pop.toFixed(2)})`);
                    g.setAttribute('opacity', 1);
                    nums[k].setAttribute('opacity', Math.min(1, age / 0.25).toFixed(2));
                });
            }
        });
    }

    /** Q3 — figuras reais no pentagrama claro + barras de duração. "Amanhecer" de 0.5s. */
    _sceneQ3(svg) {
        this._svg(svg, 'rect', { x: 0, y: 0, width: 360, height: 150, fill: '#ffffff' });
        const top = 32, ls = 9, mid = top + 2 * ls;
        for (let i = 0; i < 5; i++)
            this._svg(svg, 'line', { x1: 20, y1: top + i * ls, x2: 340, y2: top + i * ls, stroke: '#333', 'stroke-width': 1 });
        const gQ = this._svg(svg, 'g', { transform: `translate(110,${mid}) scale(1.4)` });
        const hQ = this._notehead(gQ, 0, 0, '#000'); this._stem(gQ, 0, 0, '#000');
        const gE = this._svg(svg, 'g', { transform: `translate(248,${mid}) scale(1.4)` });
        const hE = this._notehead(gE, 0, 0, '#000'); this._stem(gE, 0, 0, '#000'); this._eighthFlag(gE, 0, 0, '#000', 8);
        this._txt(svg, { x: 110, y: 86, 'text-anchor': 'middle', 'font-size': 11, 'font-family': 'Arial, sans-serif', fill: '#475569', 'font-weight': 'bold' }, this._t('rhythm.tutorial.scene.quarter'));
        this._txt(svg, { x: 248, y: 86, 'text-anchor': 'middle', 'font-size': 11, 'font-family': 'Arial, sans-serif', fill: '#475569', 'font-weight': 'bold' }, this._t('rhythm.tutorial.scene.eighth'));
        const yT = 98, hT = 14, lX = 50, lW = 120, sX = 218, sW = 60;
        this._svg(svg, 'rect', { x: lX, y: yT, width: lW, height: hT, rx: 7, fill: '#e2e8f0' });
        this._svg(svg, 'rect', { x: sX, y: yT, width: sW, height: hT, rx: 7, fill: '#e2e8f0' });
        const lFill = this._svg(svg, 'rect', { x: lX, y: yT, width: 0, height: hT, rx: 7, fill: '#3b82f6' });
        const sFill = this._svg(svg, 'rect', { x: sX, y: yT, width: 0, height: hT, rx: 7, fill: '#f59e0b' });
        this._txt(svg, { x: lX + lW / 2, y: yT + 30, 'text-anchor': 'middle', 'font-size': 12, 'font-family': 'Arial, sans-serif', fill: '#475569' }, this._t('rhythm.tutorial.scene.oneBeat'));
        this._txt(svg, { x: sX + sW / 2, y: yT + 30, 'text-anchor': 'middle', 'font-size': 12, 'font-family': 'Arial, sans-serif', fill: '#475569' }, this._t('rhythm.tutorial.scene.halfBeat'));
        const dawn = this._svg(svg, 'rect', { x: 0, y: 0, width: 360, height: 150, fill: '#12131A', opacity: 1, 'pointer-events': 'none' });
        const bag = [];
        const beatDur = 0.6, cycle = beatDur * 4;
        const stop = this._tutLoop({
            cycleSec: cycle,
            schedule: [{ at: 0, volume: 0.8, dur: 0.55 }, { at: beatDur * 2, volume: 0.7, dur: 0.26 }],
            onTap: (i) => {
                this._tutFlash(i === 0 ? hQ : hE, { fill: i === 0 ? '#3b82f6' : '#f59e0b' }, { fill: '#000' }, i === 0 ? 550 : 280, bag);
            },
            onFrame: (t, pass) => {
                const elapsed = pass * cycle + t; // tempo absoluto desde a entrada na cena
                dawn.setAttribute('opacity', Math.max(0, 1 - elapsed / 0.5).toFixed(2));
                const pL = Math.max(0, Math.min(1, t / beatDur));
                lFill.setAttribute('width', (lW * (t < beatDur * 1.7 ? pL : 0)).toFixed(1));
                const ts = t - beatDur * 2;
                const pS = Math.max(0, Math.min(1, ts / (beatDur * 0.5)));
                sFill.setAttribute('width', (sW * (ts >= 0 && ts < beatDur * 1.5 ? pS : 0)).toFixed(1));
            }
        });
        return () => { stop(); bag.forEach(clearTimeout); };
    }

    /** Q4 — "Onde, é quando": posição = instante. Faixinha de duração sob cada nota. */
    _sceneQ4(svg) {
        const NH = this._NH();
        const st = this._staffStage(svg, { noNotes: true });
        const gPair = this._svg(svg, 'g', {});
        this._drawEighthPair(gPair, st.xOf(0), st.xOf(0.5), st.mid, '#000');
        const gQ3 = this._svg(svg, 'g', {}); const h3 = this._drawQuarter(gQ3, st.xOf(2), st.mid, '#000');
        const gQ4 = this._svg(svg, 'g', {}); const h4 = this._drawQuarter(gQ4, st.xOf(3), st.mid, '#000');
        const pairHeads = gPair.querySelectorAll('ellipse');
        const heads = [pairHeads[0], pairHeads[1], h3, h4];
        const groups = [gPair, gQ3, gQ4];
        const guides = st.noteBeats.map((b) => this._svg(svg, 'line', { x1: st.xOf(b), y1: st.mid + 5, x2: st.xOf(b), y2: st.rulerY - 2, stroke: '#10b981', 'stroke-width': 1.2, 'stroke-dasharray': '2,3', opacity: 0 }));
        // faixinha de ocupação no tempo, logo acima da régua (cores do Q3: colcheia laranja, semínima azul)
        const sliceY = st.rulerY - 11, sliceH = 6;
        const slices = [
            { x0: st.xOf(0), x1: st.xOf(0.5), color: '#f59e0b' },
            { x0: st.xOf(0.5), x1: st.xOf(1), color: '#f59e0b' },
            { x0: st.xOf(2), x1: st.xOf(3), color: '#3b82f6' },
            { x0: st.xOf(3), x1: st.xOf(4), color: '#3b82f6' }
        ];
        const sliceRects = slices.map((s) => this._svg(svg, 'rect', { x: s.x0 + 1, y: sliceY, width: 0, height: sliceH, rx: 3, fill: s.color, opacity: 0.9 }));
        const bag = [];
        // fase 1 (0–0.6s): encaixe; fase 2 (0.7–1.2s): faixas de duração preenchem; fase 3 (1.2s+): soa
        const beatDur = 0.6, playAt = 1.2, cycle = playAt + beatDur * 4 + 0.2;
        const durs = [0.25, 0.25, 0.5, 0.5];
        const schedule = st.noteBeats.map((b, i) => ({ at: playAt + b * beatDur, volume: b === 0 ? 0.8 : 0.6, dur: durs[i] }));
        const stop = this._tutLoop({
            cycleSec: cycle,
            schedule,
            onTap: (i) => this._tutFlash(heads[i], { fill: '#f59e0b', rx: 8, ry: 5.8 }, { fill: '#000', rx: NH.rx, ry: NH.ry }, 200, bag),
            onFrame: (t) => {
                groups.forEach((g, i) => {
                    const d = Math.max(0, Math.min(1, (t - i * 0.15) / 0.4));
                    const ease = 1 - Math.pow(1 - d, 2);
                    g.setAttribute('transform', `translate(0,${(-30 * (1 - ease)).toFixed(1)})`);
                    g.setAttribute('opacity', d.toFixed(2));
                });
                const gp = (t > 0.7 && t < 1.2) ? Math.sin((t - 0.7) / 0.5 * Math.PI) : 0;
                guides.forEach((gd) => gd.setAttribute('opacity', (0.8 * gp).toFixed(2)));
                const fillP = Math.max(0, Math.min(1, (t - 0.7) / 0.5));
                slices.forEach((s, i) => sliceRects[i].setAttribute('width', ((s.x1 - s.x0 - 2) * fillP).toFixed(1)));
            }
        });
        return () => { stop(); bag.forEach(clearTimeout); };
    }

    /** Q5 — primeiro, ouça: playhead varre e cada nota cruzada soa; botão TOQUE apagado. */
    _sceneQ5(svg) {
        const NH = this._NH();
        const bag = [];
        const st = this._staffStage(svg, { compact: true });
        st.ph.setAttribute('opacity', 1);
        const chip = this._svg(svg, 'g', {});
        this._svg(chip, 'rect', { x: 14, y: 4, width: 84, height: 20, rx: 10, fill: '#fff', stroke: '#FF5A6E', 'stroke-width': 1.5 });
        this._txt(chip, { x: 56, y: 18, 'text-anchor': 'middle', 'font-size': 11, 'font-weight': 'bold', 'font-family': 'Arial, sans-serif', fill: '#FF5A6E' }, this._t('rhythm.tutorial.scene.listen'));
        this._lightButton(svg, false);
        const beatDur = 0.6, cycle = beatDur * 4;
        const durs = [0.25, 0.25, 0.5, 0.5];
        const stop = this._tutLoop({
            cycleSec: cycle,
            schedule: st.noteBeats.map((b, i) => ({ at: b * beatDur, volume: b === 0 ? 0.85 : 0.6, dur: durs[i] })),
            onTap: (i) => this._tutFlash(st.heads[i], { fill: '#f59e0b', rx: 8, ry: 5.8 }, { fill: '#000', rx: NH.rx, ry: NH.ry }, 180, bag),
            onFrame: (t) => {
                const x = st.xOf(t / beatDur);
                st.ph.setAttribute('x1', x); st.ph.setAttribute('x2', x);
                const ph = (t % beatDur) / beatDur;
                const s = 1 + 0.06 * Math.max(0, 1 - ph / 0.3);
                chip.setAttribute('transform', `translate(${(56 * (1 - s)).toFixed(1)},${(14 * (1 - s)).toFixed(1)}) scale(${s.toFixed(3)})`);
            }
        });
        return () => { stop(); bag.forEach(clearTimeout); };
    }

    /** Q6 — sua vez: contagem de entrada 1·2·3·4 → compasso com playhead, dedo segura/solta. */
    _sceneQ6(svg) {
        const NH = this._NH();
        const bag = [];
        const st = this._staffStage(svg, { compact: true });
        const btn = this._lightButton(svg, true);
        const finger = this._txt(svg, { x: btn.cx, y: btn.cy + 5, 'text-anchor': 'middle', 'font-size': 16, opacity: 0 }, '👆');
        // 🔴 ~90% de CADA figura (colcheia 0,30s · semínima 0,60s a beatDur 0,6): a cena
        // ensina "segure até ela acabar", que é o texto do card. Com 0,18 na colcheia (60%)
        // a animação mostrava a nota curta sendo SOLTA cedo — o modelo mental que trava a
        // pessoa no nível 1 — e o texto logo acima prometia o contrário.
        const holdsDur = [0.27, 0.27, 0.55, 0.55];
        const fills = st.noteBeats.map((b) => this._svg(svg, 'rect', { x: st.xOf(b) - 9, y: st.rulerY - 14, width: 0, height: 4, rx: 2, fill: '#3b82f6' }));
        // chips de feedback (canto sup. direito)
        const chipIni = this._svg(svg, 'g', { opacity: 0 });
        this._svg(chipIni, 'rect', { x: 252, y: 4, width: 94, height: 18, rx: 9, fill: '#dcfce7', stroke: '#16a34a' });
        this._txt(chipIni, { x: 299, y: 17, 'text-anchor': 'middle', 'font-size': 10, 'font-weight': 'bold', 'font-family': 'Arial, sans-serif', fill: '#16a34a' }, this._t('rhythm.tutorial.scene.onsetOk'));
        const chipDur = this._svg(svg, 'g', { opacity: 0 });
        this._svg(chipDur, 'rect', { x: 252, y: 26, width: 94, height: 18, rx: 9, fill: '#dbeafe', stroke: '#3b82f6' });
        this._txt(chipDur, { x: 299, y: 39, 'text-anchor': 'middle', 'font-size': 10, 'font-weight': 'bold', 'font-family': 'Arial, sans-serif', fill: '#3b82f6' }, this._t('rhythm.tutorial.scene.durOk'));
        const countIn = 4 * 0.6, beatDur = 0.6, cycle = countIn + beatDur * 4 + 0.3;
        const schedule = [];
        for (let k = 0; k < 4; k++) schedule.push({ at: k * 0.6, volume: k === 0 ? 0.5 : 0.32, dur: 0.1, kind: 'count', k });
        st.noteBeats.forEach((b, i) => schedule.push({ at: countIn + b * beatDur, volume: b === 0 ? 0.85 : 0.6, dur: holdsDur[i], kind: 'note', i }));
        const stop = this._tutLoop({
            cycleSec: cycle,
            schedule,
            onTap: (k) => {
                const s = schedule[k];
                if (s.kind === 'count') {
                    this._tutFlash(st.nums[s.k], { fill: '#FF5A6E', 'font-size': 15 }, { fill: '#475569', 'font-size': 11 }, 220, bag);
                } else {
                    this._tutFlash(st.heads[s.i], { fill: '#16a34a', rx: 8, ry: 5.8 }, { fill: '#000', rx: NH.rx, ry: NH.ry }, 220, bag);
                    this._tutFlash(chipIni, { opacity: 1 }, { opacity: 0 }, 380, bag);
                    // Limiar PROPORCIONAL, não absoluto: com `> 0.3` fixo a colcheia (que
                    // vale 0,30s) jamais acendia o selo, por construção — a cena afirmava
                    // "nota curta não precisa de duração".
                    // Sem `|| 1`: se `noteVals` sumir, isto explode em vez de silenciosamente
                    // dar "1 tempo" a todas as figuras — que é EXATAMENTE a 1ª versão
                    // defeituosa deste conserto (a colcheia perdia o selo sem ninguém ver).
                    const valor = st.noteVals[s.i] * beatDur;
                    if (holdsDur[s.i] >= valor * 0.8) this._tutFlash(chipDur, { opacity: 1 }, { opacity: 0 }, 700, bag);
                }
            },
            onFrame: (t) => {
                const inPlay = t >= countIn;
                st.ph.setAttribute('opacity', inPlay ? 1 : 0);
                if (inPlay) {
                    const x = st.xOf(Math.min((t - countIn) / beatDur, 4));
                    st.ph.setAttribute('x1', x); st.ph.setAttribute('x2', x);
                }
                let pressing = false;
                st.noteBeats.forEach((b, i) => {
                    const lt = t - countIn - b * beatDur;
                    const p = Math.max(0, Math.min(1, lt / holdsDur[i]));
                    fills[i].setAttribute('width', (18 * (lt >= 0 && lt < holdsDur[i] + 0.5 ? p : 0)).toFixed(1));
                    if (lt >= 0 && lt < holdsDur[i]) pressing = true;
                });
                btn.btn.setAttribute('fill', pressing ? '#e0455a' : '#FF5A6E');
                btn.btn.setAttribute('y', pressing ? btn.y + 1.5 : btn.y);
                finger.setAttribute('opacity', pressing ? 1 : 0);
            }
        });
        return () => { stop(); bag.forEach(clearTimeout); };
    }

    /** Q7 — bora jogar: recap + coração de volta no topo + confete na batida 1. */
    _sceneQ7(svg) {
        const NH = this._NH();
        const bag = [];
        const st = this._staffStage(svg, { compact: true });
        st.ph.setAttribute('opacity', 1);
        const heart = this._heartPath(svg, 340, 12, 0.32);
        const btn = this._lightButton(svg, true);
        const cols = ['#FF5A6E', '#FFC857', '#3b82f6', '#16a34a'];
        const confetti = [];
        for (let i = 0; i < 6; i++) confetti.push(this._svg(svg, 'circle', { cx: btn.cx, cy: btn.cy, r: 3, fill: cols[i % 4], opacity: 0 }));
        const beatDur = 0.55, cycle = beatDur * 4;
        const durs = [0.22, 0.22, 0.45, 0.45];
        let lastBeat0 = -9;
        const stop = this._tutLoop({
            cycleSec: cycle,
            schedule: st.noteBeats.map((b, i) => ({ at: b * beatDur, volume: b === 0 ? 0.9 : 0.6, dur: durs[i] })),
            onTap: (i, t) => {
                this._tutFlash(st.heads[i], { fill: '#16a34a', rx: 8, ry: 5.8 }, { fill: '#000', rx: NH.rx, ry: NH.ry }, 160, bag);
                if (st.noteBeats[i] === 0) lastBeat0 = t;
            },
            onFrame: (t) => {
                const x = st.xOf(t / beatDur);
                st.ph.setAttribute('x1', x); st.ph.setAttribute('x2', x);
                heart.set(this._heartbeatScale((t % beatDur) / beatDur * 0.857));
                const bs = 1 + 0.06 * Math.max(0, 1 - (t % beatDur) / 0.2);
                btn.g.setAttribute('transform', `translate(${(btn.cx * (1 - bs)).toFixed(1)},${(btn.cy * (1 - bs)).toFixed(1)}) scale(${bs.toFixed(3)})`);
                const age = t - lastBeat0;
                confetti.forEach((c, i) => {
                    if (age >= 0 && age < 0.6) {
                        const ang = (i / confetti.length) * Math.PI - Math.PI / 2;
                        c.setAttribute('cx', (btn.cx + Math.cos(ang) * age * 90).toFixed(1));
                        c.setAttribute('cy', (btn.cy - age * 70 + age * age * 55).toFixed(1));
                        c.setAttribute('opacity', (1 - age / 0.6).toFixed(2));
                    } else c.setAttribute('opacity', 0);
                });
            }
        });
        return () => { stop(); bag.forEach(clearTimeout); };
    }

    _renderPattern() {
        // Só reserva a banda de respostas quando ela vai ser USADA: durante os toques ao
        // vivo (prática/avaliação) e na tela de RESULTADO, onde `drawScoredResponses`
        // pinta uma fileira por nota. No menu/demo o slot encolhe ao essencial
        // (pauta+régua) → sem gordura.
        // Centralizado aqui p/ ser robusto a _buildStaff (resize recria o renderer).
        //
        // 🔴 'results' faltava aqui. `showResults` desligava a banda e desenhava a anatomia
        // dentro dela mesmo assim: sobravam ~2px para N fileiras, então TODAS empilhavam na
        // mesma altura e a legenda ("no tempo / fora / faltou") explicava um desenho que não
        // existia. Defeito antigo, valia para a trilha inteira.
        this.renderer.reserveResponseBand =
            (this.state === 'countdown'
             || this.state === 'recording' || this.state === 'results');
        this.renderer.showRuler = this._playerPref('ruler') !== 'off';
        this.renderer.pitches = this._pitchPositions();
        this.renderer.render(this.currentPattern);
        this.renderer.createPlayhead();
    }

    // ---------- ajustes do JOGADOR (som da nota, régua) — RhythmPrefs ----------

    /** Valor de um ajuste do jogador; sem `RhythmPrefs` carregado (harness antigo), o padrão histórico. */
    _playerPref(name) {
        const P = window.RhythmPrefs;
        if (P) return P.get(name);
        return name === 'tone' ? 'B' : (name === 'ruler' ? 'on' : 'off');
    }

    /**
     * Posição na pauta de cada nota SONORA do ritmo — só com "Melodia" E o ajuste "Notas na
     * altura certa" ligado; senão null (o renderer desenha tudo na linha do meio, como sempre).
     * Uma posição por nota da melodia, na mesma ordem (`this._melody[i]` ↔ k-ésima nota sonora).
     */
    _pitchPositions() {
        const P = window.RhythmPrefs;
        if (!P || !this._melody || this._playerPref('pitch') !== 'on') return null;
        const pos = P.positions(this._melody);
        return pos.length === this._melody.length ? pos : null;
    }

    /**
     * Prepara o som do ritmo: nota fixa, ou — na "melodia" — uma nota por nota do ritmo,
     * sorteada AGORA (antes de tocar). O botão roxo pergunta a nota a cada toque (`noteFor`).
     */
    _pickNote() {
        const P = window.RhythmPrefs;
        const tone = P ? P.get('tone') : 'B';
        const sonoras = this.currentPattern ? this.currentPattern.notes.filter(n => n.type === 'note').length : 0;
        this._melody = (P && tone === P.VARY && sonoras) ? P.melody(sonoras) : null;
        this._note = this._melody ? this._melody[0] : (P ? P.pickNote(tone) : 'B4');
        if (this.tapButton) {
            this.tapButton.note = this._note;
            this.tapButton.noteFor = () => this._noteForTap();
        }
    }

    /**
     * A nota do toque AGORA: na melodia, a da nota do ritmo mais perto deste instante (é o
     * toque que o placar vai casar com ela); fora da gravação, a 1ª. Nota fixa: ela mesma.
     */
    _noteForTap() {
        if (!this._melody) return this._note;
        const exp = this.activeExpectedMs, det = this.inputDetector;
        if (!exp || !exp.length || !det || this.state !== 'recording') return this._melody[0];
        const rel = (window.audioManager.now() - det.originTime - (det.latencyOffset || 0)) * 1000;
        let best = 0;
        exp.forEach((e, k) => { if (Math.abs(e.ms - rel) < Math.abs(exp[best].ms - rel)) best = k; });
        return this._melody[best] || this._note;
    }

    /**
     * Seções do ⚙️ que são do JOGADOR (valem nos três modos e não mudam a dificuldade).
     * O id começa com `_` para nunca colidir com as seções do preset do personalizado.
     * Rótulos das notas por TABELA de literais: chave montada em runtime ('notes.' + n) é
     * invisível para quem extrai as chaves do fonte.
     */
    _playerSections() {
        const P = window.RhythmPrefs;
        if (!P) return [];
        const NOTE_KEYS = { C: 'notes.C', D: 'notes.D', E: 'notes.E', F: 'notes.F', G: 'notes.G', A: 'notes.A', B: 'notes.B' };
        const tone = P.get('tone');
        // Uma LINHA por ajuste (kind select/switch) e a explicação no "?" — o painel vai
        // crescer, e cada ajuste novo tem de caber assim (18/set, pedido dele).
        const secs = [
            {
                id: '_tone', kind: 'select', title: this._t('rhythm.settings.sound'), help: 'rhythm.sound',
                items: P.TONES.map(n => ({ id: n, label: this._t(NOTE_KEYS[n]), checked: tone === n }))
                    .concat([{ id: P.VARY, label: this._t('rhythm.settings.vary'), checked: tone === P.VARY }])
            }
        ];
        // "Notas na altura certa": linha FILHA do som, que só EXISTE com a "Melodia" escolhida
        // (com nota fixa não há altura a desenhar — um interruptor sem efeito é clique morto).
        // Trocar o select remonta as seções (`_applyPlayerSelection`), e a linha aparece/some.
        if (tone === P.VARY) {
            secs.push({
                id: '_pitch', kind: 'switch', sub: true, title: this._t('rhythm.settings.pitch'), help: 'rhythm.pitch',
                items: [{ id: 'on', label: this._t('rhythm.settings.pitch'), checked: P.get('pitch') === 'on' }]
            });
        }
        secs.push({
            id: '_ruler', kind: 'switch', title: this._t('rhythm.settings.ruler'), help: 'rhythm.ruler',
            items: [{ id: 'on', label: this._t('rhythm.settings.ruler'), checked: P.get('ruler') === 'on' }]
        });
        // Teclado MIDI como botão: só onde há Web MIDI (no iOS a linha nem aparece — um
        // interruptor que nunca liga é clique morto). Ajuste de APARELHO (pref: null).
        if (this._midiAvailable()) {
            secs.push({
                id: '_midi', kind: 'switch', title: this._t('rhythm.settings.midi'), help: 'rhythm.midi',
                items: [{ id: 'on', label: this._t('rhythm.settings.midi'), checked: P.get('midi') === 'on' }]
            });
        }
        return secs;
    }

    /**
     * Grava o que mudou nas seções do jogador. Devolve true se ALGO mudou (aí a mudança era
     * do jogador, não do preset). Som novo toca uma vez, para a pessoa ouvir o que escolheu;
     * NÃO sorteia outro ritmo (trocar o som não é trocar o exercício).
     */
    _applyPlayerSelection(sel) {
        const P = window.RhythmPrefs;
        if (!P) return false;
        let mudou = false;
        const tone = (sel._tone || [])[0];
        const ruler = sel._ruler ? (sel._ruler.includes('on') ? 'on' : 'off') : null;
        if (tone && tone !== P.get('tone')) {
            const eraMelodia = P.get('tone') === P.VARY;
            P.set('tone', tone);
            this._pickNote();
            try { window.audioManager.resumeContext(); window.audioManager.playNote(this._note, 0.35, { volume: 0.6 }); } catch (e) {}
            // A melodia mudou (ou deixou de existir): com "Notas na altura certa" o desenho segue.
            if (this.state === 'idle' && this.currentPattern) this._renderPattern();
            // A linha filha "Notas na altura certa" existe só com a "Melodia": remonta as seções
            // SÓ quando a troca entra ou sai dela. Remontar em toda troca destruía o <select> no
            // meio do `change` e o foco devolvido reabria o picker do iPhone a cada nota (19/set).
            if (eraMelodia !== (tone === P.VARY) && this.configPanel && this._panelSectionsFn) this.configPanel.setSections(this._panelSectionsFn());
            mudou = true;
        }
        if (ruler && ruler !== P.get('ruler')) {
            P.set('ruler', ruler);
            if (this.state === 'idle' && this.currentPattern) this._renderPattern();
            mudou = true;
        }
        const pitch = sel._pitch ? (sel._pitch.includes('on') ? 'on' : 'off') : null;
        if (pitch && pitch !== P.get('pitch')) {
            P.set('pitch', pitch);
            if (this.state === 'idle' && this.currentPattern) this._renderPattern();
            mudou = true;
        }
        // O clique na caixa é o GESTO que o navegador exige para o prompt de permissão MIDI.
        const midi = sel._midi ? (sel._midi.includes('on') ? 'on' : 'off') : null;
        if (midi && midi !== P.get('midi')) {
            P.set('midi', midi);
            this._syncMidi();
            mudou = true;
        }
        return mudou;
    }

    // ---------- teclado MIDI como botão (RhythmMidiInput) ----------

    /** Há Web MIDI aqui? Sem ele o ajuste não existe (nem no ⚙️, nem no status). */
    _midiAvailable() {
        return !!(window.RhythmMidiInput && window.RhythmMidiInput.isSupported());
    }

    /** Liga ou desliga o adaptador conforme o ajuste do jogador. Idempotente. */
    _syncMidi() {
        const on = this._midiAvailable() && this._playerPref('midi') === 'on';
        if (on && !this.midiInput) this._startMidi();
        else if (!on && this.midiInput) this._stopMidi();
    }

    /**
     * O teclado dirige o BOTÃO, não o detector: `handlePress/handleRelease` são os mesmos
     * caminhos do dedo e da barra de espaço (detector, linha-resposta, som e a guarda de
     * "fora da janela de captura" vêm de graça). Tecla nova com o botão já apertado (pelo
     * dedo ou por outra tecla) = solta e aperta: um onset novo, como a pessoa tocou.
     * O som é a nota QUE A PESSOA TOCOU, não o ajuste "Som da nota": num piano digital com
     * som próprio ela ouviria Si por cima do Dó que tocou. Fora de `MIDI_SOUND_RANGE` (pad de
     * bateria em Dó 2, tecla extrema) o sample esticado vira um baque ou silêncio — aí soa o
     * ajuste do jogador, como o dedo.
     */
    static MIDI_SOUND_RANGE = [48, 84];   // C3–C6, a faixa do banco de piano

    _startMidi() {
        if (this.midiInput) return;
        this.midiInput = new window.RhythmMidiInput({
            onPress: (info) => {
                if (!this.tapButton) return;
                if (this.tapButton.isPressed) this.tapButton.handleRelease();
                const [lo, hi] = RhythmGame.MIDI_SOUND_RANGE;
                const nota = (info.midi >= lo && info.midi <= hi) ? info.sci : undefined;   // playNote normaliza o '#'
                this.tapButton.handlePress(nota);
            },
            onRelease: () => { if (this.tapButton) this.tapButton.handleRelease(); },
            onState: () => this._renderMidiStatus()
        });
        this.midiInput.start();
        this._renderMidiStatus();
    }

    _stopMidi() {
        if (this.midiInput) { this.midiInput.destroy(); this.midiInput = null; }
        this._renderMidiStatus();
    }

    /**
     * A linha de status embaixo dos controles — vale em TODOS os estados (o botão roxo só
     * existe durante o take, e é no menu que a pessoa confere se o teclado foi visto).
     * Some quando o ajuste está desligado.
     */
    _renderMidiStatus() {
        const el = this.container && this.container.querySelector('#rhythm-midi-status');
        if (!el) return;
        const m = this.midiInput;
        if (!m) { el.textContent = ''; el.style.display = 'none'; delete el.dataset.midiState; return; }
        const s = m.state;
        let txt;
        // Frases PRÓPRIAS do Ritmo para "sem teclado" e "negado": as dos jogos de leitura mandam
        // "responder pelos botões", e o "negado" aqui precisa dizer o caminho de volta (o
        // navegador não pergunta de novo: é liberar no cadeado E religar no ⚙️).
        if (s === 'listening') txt = this._t('rhythm.midi.listening', { device: m.getDeviceName() || 'MIDI' });
        else if (s === 'nodevice') txt = this._t('rhythm.midi.nodevice');
        else if (s === 'denied') txt = this._t('rhythm.midi.denied');
        else if (s === 'requesting' || s === 'idle') txt = '🎹 ' + this._t('midiInput.requesting');
        else txt = '🎹 ' + this._t('midiInput.error');
        el.textContent = txt;
        el.dataset.midiState = s;
        el.style.display = '';
    }

    /** Tudo o que o ⚙️ mostra: nos níveis, só o do jogador; no personalizado, o preset + o do jogador. */
    _panelSections() {
        return this._levelsMode() ? this._playerSections() : this._figureSections().concat(this._playerSections());
    }

    /** notas esperadas (onset em ms) do padrão, para feedback ao vivo */
    _expectedOnsetsMs() {
        const beatDurMs = this._beatDurSec() * 1000;
        return this.currentPattern.notes
            .filter(n => n.type === 'note')
            .map(n => ({ beat: n.beat, ms: n.beat * beatDurMs }));
    }

    _cancelRaf() {
        if (this.rafId) { cancelAnimationFrame(this.rafId); this.rafId = null; }
    }

    // ---------- linhas-resposta do usuário (visualização) ----------

    /** Converte ms (relativos ao beat 0 da gravação) → beat. */
    _msToBeat(ms) {
        return ms / (this._beatDurSec() * 1000);
    }

    /**
     * Início de um toque: abre uma nova linha-resposta na próxima fileira, no beat
     * do aperto (negativo se foi antes do exercício começar). Chamado pelo onLiveTap.
     */
    _beginResponseLine(startRelMs) {
        if (!this.renderer) return;
        this.renderer.startResponseLine(this._responseIndex || 0, this._msToBeat(startRelMs));
        this._responseIndex = (this._responseIndex || 0) + 1;
    }

    /** Fim de um toque: congela a linha-resposta ativa no beat do soltar. */
    _finishResponseLine() {
        if (!this.renderer || !this.renderer._activeResponse) return;
        const last = this.inputDetector.inputs[this.inputDetector.inputs.length - 1];
        if (!last) return;
        this.renderer.endResponseLine(this._msToBeat(last.endRelative));
    }

    // ---------- FASE: menu (idle) ----------

    /**
     * Volta ao menu. `keep: true` MANTÉM o ritmo (e a melodia) que está na tela — é o fim do
     * "Ouvir". 🔴 Sem isso o "Ouvir" terminava sorteando OUTRO ritmo: a pessoa ouvia um e era
     * avaliada em outro (em prod até 18/set; achado pela auditoria). Só "Outro ritmo", as
     * mudanças do preset e o início sorteiam.
     */
    prepareRound({ keep = false } = {}) {
        const manter = keep && !!this.currentPattern;
        this.state = 'idle';
        this._cancelRaf();
        this.resultsContainer.style.display = 'none';
        this.resultsContainer.innerHTML = '';
        this._clearCountdownUI();
        this.controlsContainer.innerHTML = '';

        // Sincroniza EXERCISE_CONFIG conforme o modo (trilha aplica o nível corrente;
        // sandbox restaura a seleção livre de figuras/ligaduras). Idempotente.
        this._syncConfigForMode();

        // novo padrão. Trilha com SEMENTE: todos tocam o MESMO padrão (RhythmTrails.rngFor
        // ignora a semente se o gerador mudou de versão — nunca padrão torto). Sem semente, sorteio.
        if (!manter) {
            const rng = this.trail ? window.RhythmTrails.rngFor(this._trailLevel()) : null;
            const generator = new window.RhythmPatternGenerator(window.EXERCISE_CONFIG, rng);
            this.currentPattern = generator.generate();
            this._pickNote();
        }
        this.currentPattern.config = { ...this.currentPattern.config, bpm: this.currentBpm };

        this._renderPattern();
        // Mobile: subtítulo curto (o h1 fica escondido por CSS; espaço pra pauta subir).
        const mobile = (window.innerWidth || 1024) < 560;
        this._setStatus(this._t(mobile ? 'rhythm.menuStatusShort' : 'rhythm.menuStatus'));

        // re-cria o botão de toque (escondido) para os modos que precisam
        this.controlsContainer.appendChild(this._buildMenu());
        // faixa de progresso no topo (trilha) — reflete o nível corrente a cada round
        this._renderLevelStrip();
        this._renderTrailStrip();
    }

    /**
     * Menu inicial — RAMIFICA pelo modo (this.mode), que é da rota (§ doc dois-jogos):
     *  - ranked (#/ritmo): Ouvir · Avaliar · tempo · ⚙️ Ajustes (do jogador) · "?" ·
     *    link → Modo livre. SEM "Outro ritmo" (o nível controla o sorteio).
     *  - free (#/ritmo-livre): Ouvir · Avaliar · Outro · tempo · ⚙️ Ajustes (figuras + jogador) ·
     *    "?" · link → 🏆 Níveis.
     */
    _buildMenu() {
        const ranked = this._levelsMode();
        // Trilha do professor: como o livre (Ouvir · Avaliar), MENOS "Outro ritmo"
        // quando o nível tem semente (o padrão é o mesmo para todo mundo), MENOS o link
        // cruzado (a barra "← ⟨trilha⟩" já leva de volta), e o ⚙️ abre SOMENTE LEITURA.
        const trail = this._listMode();
        const seeded = trail && this._trailLevel().seed != null;
        const wrap = document.createElement('div');
        // (A posição na trilha vive na faixa do topo — _renderLevelStrip — não aqui.)

        // linha principal de ações
        const row = document.createElement('div');
        row.appendChild(this._makeButton(this._t('rhythm.listen'), 'linear-gradient(135deg,#0ea5e9,#2563eb)', () => this.playDemo()));
        row.appendChild(this._makeButton(this._t('rhythm.grade'), 'linear-gradient(135deg,#10b981,#059669)', () => this.startGradedTake()));
        if (!ranked && !seeded) {
            // "Outro ritmo" (sorteia outro padrão) — no ranked o nível controla o sorteio.
            row.appendChild(this._makeButton(this._t('rhythm.another'), 'linear-gradient(135deg,#64748b,#475569)', () => this.prepareRound(), { small: true }));
        }
        wrap.appendChild(row);
        // linha de opções
        const opts = document.createElement('div');
        opts.style.marginTop = '0.75rem';
        opts.style.fontSize = '0.9rem';
        opts.style.color = '#555';

        // tempo — seletor contínuo (slider + −/+ + nome italiano), ao vivo. Em ambos os
        // modos (no ranked o nível dita o BPM inicial, mas dá pra desacelerar p/ estudar).
        opts.appendChild(this._buildTempoControl());

        // P8 — sem toggle: Início e Duração agora são DOIS placares co-iguais,
        // sempre exibidos. (Futuro: deixar o usuário escolher quais medir.)

        // ⚙️ Ajustes (gaveta lateral), nos TRÊS modos desde 18/set. Níveis: só os ajustes do
        // jogador (som da nota, régua). Personalizado: as figuras do sorteio + os do jogador.
        // Trilha: o nível do autor, somente leitura.
        opts.appendChild(this._makeButton(this._t('rhythm.config.open'), '#64748b', () => this.openConfigPanel(), { small: true }));

        // tutorial ("? Como jogar")
        const tut = this._makeButton(this._t('rhythm.tutorial.open'), '#94a3b8', () => this.showTutorial(), { small: true });
        tut.style.marginLeft = '0.6rem';
        opts.appendChild(tut);

        wrap.appendChild(opts);
        // Personalizado: a porta da TRILHA DO PROFESSOR ("Usar este exercício numa trilha"), logo abaixo
        // do ⚙️ que produz o exercício — atrás da cortina `RhythmTrails.ENABLED` até o lançamento.
        if (this.mode === 'free' && window.RhythmTrails && window.RhythmTrails.ENABLED) wrap.appendChild(this._buildSaveTrailRow());

        // link cruzado entre os dois jogos (navega pela ROTA — o modo é da rota).
        if (!trail) wrap.appendChild(this._buildCrossLink(ranked));
        return wrap;
    }

    // ---------- trilha do professor (modo `list`; docs/LISTAS-PLANO.md) ----------

    /** Modo trilha do professor — fixado na construção pela rota (`?lista=`). */
    _listMode() { return this.mode === 'list'; }

    /** O nível corrente da trilha (RhythmTrails decide: o guardado se liberado, senão o 1º aberto). */
    _trailLevel() {
        const T = window.RhythmTrails;
        return T.byLid(this.trail, T.currentLid(this.trail)) || this.trail.levels[0];
    }

    /** Posição (1-based) do nível corrente — o que a tela mostra; a identidade é o `lid`. */
    _trailPos() { return window.RhythmTrails.indexOf(this.trail, this._trailLevel().lid) + 1; }

    /** "Nível N · rótulo" (texto; quem imprime escolhe textContent ou escapa). */
    _trailLevelName(level = this._trailLevel()) {
        const n = window.RhythmTrails.indexOf(this.trail, level.lid) + 1;
        return this._t('rhythm.level.n', { n }) + (level.label ? ' · ' + level.label : '');
    }

    _esc(str) {
        return String(str == null ? '' : str).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    /** Entra num nível da trilha (só se liberado): andamento do nível + ritmo novo. Sem gate de conta: a capa já pediu. */
    _enterTrailLevel(lid) {
        const T = window.RhythmTrails;
        const eff = T.setCurrent(this.trail, lid);
        const level = T.byLid(this.trail, eff);
        if (level) this.currentBpm = this._clampBpm(level.preset.bpm);
        if (this.state === 'idle') this.prepareRound();
    }

    /** A saída da trilha: a CAPA para o aluno; a OFICINA (no nível) para o dono testando. */
    _goToCover() {
        const code = encodeURIComponent(this.trail.code);
        if (this.trail.test) { window.location.hash = '#/trilha/' + code + '?edit=1&lid=' + encodeURIComponent(this._trailLevel().lid); return; }
        window.location.hash = '#/trilha/' + code;
    }
    /** O rótulo dessa saída (o mesmo nos dois lugares — resultado e modal). */
    /** Rodada sem NENHUM toque (toda nota perdida e nenhum extra): não se elogia nem se conta. */
    _noInput(results) {
        return !!results && Array.isArray(results.results) && results.results.length > 0
            && results.results.every(r => r && r.status === 'missed') && !(results.extras && results.extras.length);
    }

    _coverLabel() { return this._t(this.trail && this.trail.test ? 'rhythm.trails.toWorkshop' : 'rhythm.trails.toCover'); }

    /** As frases de "faltam N" e "treino feito" no ÚLTIMO nível não podem prometer um próximo. */
    _trailHasNext() { return window.RhythmTrails.nextLid(this.trail, this._trailLevel().lid) != null; }

    _goNextTrailLevel(lid) {
        this.resultsContainer.style.display = 'none';
        this.state = 'idle';
        this._enterTrailLevel(lid);
    }

    /**
     * A faixa do topo no modo `list`: "Trilha: ⟨nome⟩ · Nível N de M" + rótulo do nível, tudo por
     * textContent (nome e rótulo são do autor). Clicável → o mapa da trilha.
     */
    _renderTrailStrip() {
        if (!this.container || !this.trail) return;
        const strip = this.container.querySelector('#rhythm-trail-strip');
        if (!strip) return;
        const level = this._trailLevel();
        strip.textContent = '';
        strip.style.display = '';
        const pill = document.createElement('span');
        pill.className = 'rhythm-trail-pill';
        pill.style.cssText = 'display:inline-flex;align-items:center;gap:0.55rem;flex-wrap:wrap;justify-content:center;max-width:100%;'
            + 'padding:0.35rem 0.8rem;border-radius:999px;background:#f8fafc;border:1px solid #eef2ff;';
        const name = document.createElement('span');
        name.style.cssText = 'font-size:0.82rem;font-weight:700;color:#4f46e5;';
        name.textContent = this._t(this.trail.test ? 'rhythm.trails.testStrip' : 'rhythm.trails.strip', { name: this.trail.name, n: this._trailPos(), m: this.trail.levels.length });
        pill.appendChild(name);
        if (level.label) {
            const lab = document.createElement('span');
            lab.style.cssText = 'font-size:0.78rem;color:#64748b;';
            lab.textContent = level.label;
            pill.appendChild(lab);
        }
        const map = document.createElement('span');
        map.setAttribute('aria-hidden', 'true');
        map.style.cssText = 'font-size:0.82rem;opacity:0.85;';
        map.textContent = '🗺️';
        pill.appendChild(map);
        strip.appendChild(pill);
        strip.style.cursor = 'pointer';
        strip.setAttribute('role', 'button');
        strip.setAttribute('tabindex', '0');
        strip.setAttribute('aria-label', this._t('rhythm.trails.mapOpen'));
        strip.onclick = () => this._openTrailMap();
        strip.onkeydown = (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this._openTrailMap(); } };
    }

    /** O mapa da trilha: um botão por nível (concluído ✓ · atual · liberado · 🔒), no modal do NotificationManager. */
    _openTrailMap() {
        if (!window.notifications || !this.trail || this.state !== 'idle') return;
        const T = window.RhythmTrails;
        const cur = this._trailLevel().lid;
        const node = document.createElement('div');
        node.className = 'rhythm-trail-map';
        node.style.cssText = 'display:flex;flex-direction:column;gap:0.35rem;max-height:60vh;overflow-y:auto;';
        this.trail.levels.forEach((l, i) => {
            const unlocked = T.isUnlocked(this.trail, l.lid);
            const cleared = T.isCleared(this.trail, l.lid);
            const b = document.createElement('button');
            b.type = 'button';
            b.dataset.lid = l.lid;
            b.disabled = !unlocked;
            b.style.cssText = `display:flex;align-items:center;gap:0.6rem;min-height:44px;padding:0.4rem 0.7rem;border-radius:10px;`
                + `border:1.5px solid ${l.lid === cur ? '#6366f1' : '#e2e8f0'};background:${l.lid === cur ? '#eef2ff' : '#fff'};`
                + `text-align:left;cursor:${unlocked ? 'pointer' : 'default'};opacity:${unlocked ? 1 : 0.5};font:inherit;color:#334155;`;
            const num = document.createElement('span');
            num.style.cssText = 'font-weight:800;color:#4f46e5;min-width:2.2rem;';
            num.textContent = String(i + 1);
            const txt = document.createElement('span');
            txt.style.cssText = 'flex:1;display:flex;flex-direction:column;line-height:1.25;';
            const t1 = document.createElement('span');
            t1.style.cssText = 'font-weight:600;';
            t1.textContent = l.label || this._t('rhythm.level.n', { n: i + 1 });
            const t2 = document.createElement('span');
            t2.style.cssText = 'font-size:0.78rem;color:#94a3b8;';
            t2.textContent = (l.pass != null ? this._t('rhythm.level.goal', { pass: l.pass }) : this._t('rhythm.trails.training'))
                + (l.takes > 1 ? ' · ' + this._t('rhythm.trails.takes', { done: Math.min(T.doneCount(this.trail, l.lid), l.takes), takes: l.takes }) : '');
            txt.appendChild(t1); txt.appendChild(t2);
            const st = document.createElement('span');
            st.style.cssText = 'font-size:0.9rem;';
            st.textContent = cleared ? '✓' : (unlocked ? '' : '🔒');
            st.setAttribute('aria-label', cleared ? this._t('rhythm.trails.cleared') : (unlocked ? '' : this._t('rhythm.level.locked')));
            b.appendChild(num); b.appendChild(txt); b.appendChild(st);
            if (unlocked) b.addEventListener('click', () => { window.notifications.closeModal(); this._enterTrailLevel(l.lid); });
            node.appendChild(b);
        });
        window.notifications.modal({
            title: this.trail.name, node, dismissible: true,
            actions: [{ label: this._t('rhythm.config.close'), style: 'neutral' }]
        });
    }

    /**
     * O ⚙️ no modo `list`: o MESMO painel, com tudo apagado (o nível é do autor), e o rodapé vira
     * "Editar uma cópia" — grava o nível no preset da PESSOA (é ela que pediu) e abre o personalizado.
     */
    _openReadOnlyPanel() {
        // O nível é do AUTOR (somente leitura); o som e a régua são do JOGADOR e valem aqui
        // também (auditoria 18/set: a trilha era o único modo sem eles).
        const sections = () => this._figureSections(this._trailLevel().preset, true).concat(this._playerSections());
        const test = !!this.trail.test;
        this._panelSectionsFn = sections;   // quem remonta o painel (troca de som) usa ESTA receita
        if (!this.configPanel) {
            this.configPanel = new window.RhythmConfigPanel({
                title: this._t('rhythm.trails.readOnlyTitle'),
                labels: { reset: this._t(test ? 'rhythm.trails.editInWorkshop' : 'rhythm.trails.editCopy'), close: this._t('rhythm.config.close') },
                sections: sections(),
                canToggle: (sectionId) => String(sectionId).charAt(0) === '_',
                onChange: (sel) => { this._applyPlayerSelection(sel); },
                onReset: () => {
                    // O dono testando edita NA OFICINA — "Levar para o meu painel" é ferramenta do aluno.
                    if (test) { this.configPanel.close(); this._goToCover(); return null; }
                    // 🔴 É a ÚNICA gravação intencional do modo `list` — e é destrutiva (substitui o
                    // painel da pessoa) e tira o aluno da trilha. Auditoria 17/set: sem confirmação, um
                    // toque por curiosidade apagava o preset e sumia com a tarefa. Pergunta antes.
                    this.configPanel.close();
                    if (!window.notifications) return null;
                    window.notifications.modal({
                        title: this._t('rhythm.trails.editCopy'),
                        html: `<p style="text-align:center;margin:0;color:#475569;">${this._esc(this._t('rhythm.trails.editCopyConfirm'))}</p>`,
                        actions: [
                            { label: this._t('rhythm.trails.editCopy'), style: 'primary', onClick: () => {
                                window.RhythmSandbox.applyPreset(this._trailLevel().preset);
                                window.location.hash = '#/ritmo-livre';
                            } },
                            { label: this._t('rhythm.config.close'), style: 'neutral' }
                        ]
                    });
                    return null;
                }
            });
        } else {
            this.configPanel.setSections(sections());
        }
        this.configPanel.open();
    }

    /**
     * A porta da TRILHA no personalizado (oficina, 18/set): "＋ Usar este exercício numa trilha"
     * + o "?" que diz o que é uma trilha. A foto do painel vira o nível 1 de uma trilha NOVA ou o
     * nível N+1 de uma que já existe — a pessoa escolhe numa folha, só quando há escolha.
     */
    _buildSaveTrailRow() {
        const wrap = document.createElement('div');
        wrap.className = 'rhythm-trail-save';
        wrap.style.cssText = 'margin-top:0.9rem;display:flex;flex-wrap:nowrap;gap:0.1rem;justify-content:center;align-items:center;';
        const btn = this._makeButton(this._t('rhythm.trails.saveAs'), 'linear-gradient(135deg,#0f766e,#0d9488)', () => this._saveAsTrail(), { small: true });
        btn.style.minHeight = '44px';   // alvo de dedo (auditoria 18/set: era o único botão do fluxo abaixo de 44)
        btn.dataset.act = 'savetrail';
        wrap.appendChild(btn);
        if (window.HelpDot) wrap.appendChild(new window.HelpDot('rhythm.trails').el);
        // A trilha EXEMPLO (22/set): a porta mais barata para entender o formato — sem ela o botão
        // pressupõe um conceito que a pessoa nunca viu. Só existe com código (`RhythmTrails.sampleRoute`).
        // E a porta para uma trilha EM BRANCO (22/set, pergunta dele: "e se eu quero uma trilha nova sem usar
        // este exercício?") — o botão de cima é só para "ESTE exercício vira um nível".
        const rota = window.RhythmTrails.sampleRoute && window.RhythmTrails.sampleRoute();
        const outer = document.createElement('div');
        outer.className = 'rhythm-trail-save-wrap';
        outer.appendChild(wrap);
        const row = document.createElement('div');
        row.style.cssText = 'display:flex;justify-content:center;flex-wrap:wrap;gap:0 0.4rem;';
        const linkCss = 'display:inline-flex;align-items:center;justify-content:center;min-height:44px;margin-top:0.2rem;padding:0 0.6rem;color:#0f766e;font-weight:600;text-decoration:none;font-size:0.9rem;';
        const blank = document.createElement('a');
        blank.href = '#';
        blank.dataset.act = 'trailblank';
        blank.textContent = this._t('rhythm.trails.blank');
        blank.style.cssText = linkCss;
        blank.addEventListener('click', (e) => { e.preventDefault(); this._createBlankTrail(); });
        row.appendChild(blank);
        if (rota) {
            const a = document.createElement('a');
            a.href = rota;
            a.dataset.act = 'trailsample';
            a.textContent = this._t('rhythm.trails.sample');
            a.style.cssText = linkCss;
            row.appendChild(a);
        }
        outer.appendChild(row);
        return outer;
    }

    /** Trilha em branco a partir do Ritmo Livre: a mesma receita do perfil (RhythmTrails.createBlank) e a oficina. */
    async _createBlankTrail() {
        if (this._trailBusy) return;
        const um = window.userManager;
        if (!um || !um.isLoggedIn()) {
            if (window.authModal) window.authModal.open('signup', { reason: this._t('rhythm.trails.needAccount') });
            return;
        }
        this._trailBusy = true;
        const r = await window.RhythmTrails.createBlank(um, (k, v) => this._t(k, v));
        this._trailBusy = false;
        if (r && r.success && r.list) { window.location.hash = '#/trilha/' + encodeURIComponent(r.list.code) + '?edit=1'; return; }
        if (window.notifications) window.notifications.toast(this._t('auth.errors.' + ((r && r.code) || 'generic')), { type: 'error', duration: 3000 });
    }

    /**
     * Guarda a FOTO do painel (`RhythmSandbox.snapshot`: o preset EFETIVO, com a figura ligada para
     * fechar o compasso) como nível. Convidado: trilha é de cadastrado — abre a porta de conta.
     * Sem trilha na conta: cria uma (nome padrão, editável na oficina) e abre a oficina. Com
     * trilhas: a folha "Em qual trilha?" — nova, ou o nível N+1 de uma existente (o exercício de
     * hoje entra numa trilha que a turma já usa). A recusa é do SERVIDOR e vira frase.
     */
    async _saveAsTrail() {
        if (this.state !== 'idle' || this._trailBusy) return;   // toque duplo criava DUAS trilhas (auditoria 18/set)
        const um = window.userManager;
        if (!um || !um.isLoggedIn()) {
            if (window.notifications) window.notifications.toast(this._t('rhythm.trails.needAccount'), { type: 'info', duration: 3200 });
            if (window.authModal) window.authModal.open('signup', { reason: this._t('rhythm.trails.needAccount') });
            return;
        }
        this._trailBusy = true;
        try {
            const snap = window.RhythmSandbox.snapshot();
            const lists = um.myLists ? await um.myLists() : null;
            if (!Array.isArray(lists) || !lists.length) { await this._createTrailWith(snap); return; }
            this._askWhichTrail(lists, snap);
        } finally { this._trailBusy = false; }
    }

    /** Trilha NOVA com a foto como nível 1; o nome nasce padrão e se edita na oficina. */
    async _createTrailWith(snap) {
        const um = window.userManager, T = window.RhythmTrails;
        const r = await um.saveList({ code: '', name: T.defaultName(um.getUser && um.getUser(), (k, v) => this._t(k, v)), levels: T.serializeLevels([T.levelFromSnapshot(snap, [])]) });
        if (!r || !r.success) { this._trailFail(r); return; }
        if (window.notifications) window.notifications.toast(this._t('rhythm.trails.created'), { type: 'success', duration: 1800 });
        window.location.hash = '#/trilha/' + encodeURIComponent(r.list.code) + '?edit=1';
    }

    /** A foto vira o ÚLTIMO nível de uma trilha existente (a lista inteira sobe, como sempre). */
    async _appendTrailLevel(code, snap) {
        const um = window.userManager, T = window.RhythmTrails;
        const got = await um.fetchList(code);
        const list = got && got.success && got.can_edit ? T.normalizeList(got.list) : null;
        if (!list) { this._trailFail(got); return; }
        const level = T.levelFromSnapshot(snap, list.levels.map(l => l.lid));
        const r = await um.saveList({ code: list.code, name: list.name, levels: T.serializeLevels([...list.levels, level]) });
        if (!r || !r.success) { this._trailFail(r); return; }
        if (window.notifications) window.notifications.toast(this._t('rhythm.trails.appended', { n: list.levels.length + 1, name: list.name }), { type: 'success', duration: 2200 });
        window.location.hash = '#/trilha/' + encodeURIComponent(list.code) + '?edit=1&lid=' + encodeURIComponent(level.lid);
    }

    _trailFail(r) {
        const code = (r && r.code) || 'generic';
        if (window.notifications) window.notifications.toast(this._t('auth.errors.' + code), { type: 'error', duration: 3200 });
    }

    /** "Em qual trilha?": nova, ou cada trilha da conta como "⟨nome⟩ — vira o nível N+1" (nome do autor: textContent). */
    _askWhichTrail(lists, snap) {
        if (!window.notifications) { this._createTrailWith(snap); return; }
        const node = document.createElement('div');
        node.style.cssText = 'display:flex;flex-direction:column;gap:0.4rem;';
        const mk = (label, primary, onClick, act) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.dataset.act = act;
            b.textContent = label;
            b.style.cssText = 'min-height:44px;padding:0.55rem 0.9rem;border-radius:10px;border:1px solid #e2e8f0;text-align:left;font:inherit;font-weight:600;cursor:pointer;'
                + (primary ? 'background:linear-gradient(135deg,#6366f1,#4f46e5);color:#fff;border-color:transparent;' : 'background:#f1f5f9;color:#334155;');
            b.addEventListener('click', () => { window.notifications.closeModal(); onClick(); });
            return b;
        };
        node.appendChild(mk(this._t('rhythm.trails.newOne'), true, () => this._createTrailWith(snap), 'trailnew'));
        lists.forEach(l => {
            const n = (Number(l.n_levels) || 0) + 1;
            const b = mk(this._t('rhythm.trails.asLevel', { name: String(l.name || ''), n }), false, () => this._appendTrailLevel(String(l.code), snap), 'trailappend');
            b.dataset.code = String(l.code || '');
            node.appendChild(b);
        });
        window.notifications.modal({
            title: this._t('rhythm.trails.whichTrail'), node, dismissible: true,
            actions: [{ label: this._t('rhythm.config.close'), style: 'neutral' }]
        });
    }

    /** Link p/ o jogo irmão: ranked → "⚙️ Modo livre"; free → "🏆 Níveis".
        Chip/pílula secundária (.rhythm-crosslink) — não mais um link sublinhado cru. */
    _buildCrossLink(ranked) {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'margin-top:1.2rem;text-align:center;';
        const link = document.createElement('button');
        link.type = 'button';
        link.className = 'rhythm-crosslink';
        link.textContent = this._t(ranked ? 'rhythm.toFreeMode' : 'rhythm.toRankedMode');
        link.addEventListener('click', () => {
            window.location.hash = ranked ? '#/ritmo-livre' : '#/ritmo';
        });
        wrap.appendChild(link);
        // "Trilha × livre" é a dúvida que o chip levanta: ele oferece a troca sem
        // dizer o que muda. Mesmo tópico nos 4 jogos que têm o par.
        if (window.HelpDot) window.HelpDot.attach(wrap, 'app.freeMode');
        return wrap;
    }

    /** monta o seletor de tempo: [−] slider [+] + "72 BPM · Andante" (atualiza ao vivo). */
    _buildTempoControl() {
        const tempoLabel = document.createElement('span');
        tempoLabel.textContent = this._t('rhythm.tempo');

        const dec = this._makeButton('−', '#94a3b8',
            () => this._applyTempo(this.currentBpm - this.BPM_STEP), { small: true });
        const inc = this._makeButton('+', '#94a3b8',
            () => this._applyTempo(this.currentBpm + this.BPM_STEP), { small: true });

        const slider = document.createElement('input');
        slider.type = 'range';
        slider.min = this.MIN_BPM;
        slider.max = this.MAX_BPM;
        slider.step = this.BPM_STEP;
        slider.value = this.currentBpm;
        slider.setAttribute('aria-label', 'BPM');
        slider.style.verticalAlign = 'middle';
        slider.style.margin = '0 0.5rem';
        slider.style.width = '160px';
        slider.style.maxWidth = '40vw';
        slider.style.cursor = 'pointer';
        slider.addEventListener('input', () => this._applyTempo(parseInt(slider.value, 10)));

        const readout = document.createElement('span');
        readout.style.fontWeight = 'bold';
        readout.style.minWidth = '11ch';
        readout.style.display = 'inline-block';

        this._tempoSlider = slider;
        this._tempoReadout = readout;

        const wrap = document.createElement('span');
        wrap.appendChild(tempoLabel);
        if (window.HelpDot) wrap.appendChild(new window.HelpDot('rhythm.tempo').el);
        wrap.appendChild(dec);
        wrap.appendChild(slider);
        wrap.appendChild(inc);
        wrap.appendChild(readout);

        this._refreshTempoUI();
        return wrap;
    }

    _clampBpm(bpm) {
        // Na trilha do professor o andamento do NÍVEL é inteiro (63, 66…): o passo de 5 é do
        // slider, e arredondar de 5 em 5 adulterava o nível ao entrar (o slider segue de 5 em 5).
        const snapped = this._listMode() ? Math.round(bpm) : Math.round(bpm / this.BPM_STEP) * this.BPM_STEP;
        return Math.max(this.MIN_BPM, Math.min(this.MAX_BPM, snapped));
    }

    /**
     * Aplica um novo tempo SEM gerar ritmo novo nem re-renderizar a pauta.
     * (A posição das notas vem de getBeatX(beat), proporcional ao beat — o BPM
     * só muda a velocidade de reprodução via _beatDurSec, não o desenho.)
     */
    _applyTempo(bpm) {
        if (this.state !== 'idle') return;
        const clamped = this._clampBpm(bpm);
        if (clamped === this.currentBpm) { this._refreshTempoUI(); return; }
        this.currentBpm = clamped;
        if (this.currentPattern) {
            this.currentPattern.config = { ...this.currentPattern.config, bpm: clamped };
        }
        // 🔴 Modo `list`: o andamento vive só em `currentBpm` — `setBpm` gravaria o BPM alheio no
        // preset do aluno, e `rhythm_bpm` é da trilha oficial.
        if (this._listMode()) { /* nada persiste */ }
        else if (!this._levelsMode() && window.RhythmSandbox) window.RhythmSandbox.setBpm(clamped);
        else localStorage.setItem('rhythm_bpm', String(clamped));
        this._refreshTempoUI();
    }

    /** sincroniza slider + leitura "BPM · nome" com currentBpm. */
    _refreshTempoUI() {
        if (this._tempoSlider) this._tempoSlider.value = this.currentBpm;
        if (this._tempoReadout) {
            this._tempoReadout.textContent = `${this.currentBpm} BPM · ${this._tempoName(this.currentBpm)}`;
        }
    }

    /** nome italiano do andamento (vocabulário musical universal, não traduzido). */
    _tempoName(bpm) {
        if (bpm < 66) return 'Largo';
        if (bpm < 76) return 'Adagio';
        if (bpm < 108) return 'Andante';
        if (bpm < 120) return 'Moderato';
        return 'Allegro';
    }

    // ---------- trilha de níveis (modo levels) ----------

    /** Modo trilha (ranqueado) — fixado na construção pela rota/Screen. */
    _levelsMode() {
        return this.mode === 'ranked';
    }

    /** Sincroniza EXERCISE_CONFIG p/ o modo corrente (trilha = nível; livre = sandbox). */
    _syncConfigForMode() {
        if (this._levelsMode()) {
            this._enforceGate();
            window.RhythmLevels.applyCurrent();
        } else if (this._listMode()) {
            // O PRESET ATIVO da trilha do professor: escrito em EXERCISE_CONFIG a cada rodada, em
            // MEMÓRIA — nunca `applyPreset` (que grava as três chaves do aluno). Sem isto a
            // lista morria no primeiro "Outro ritmo" (o `apply()` abaixo repunha o preset da pessoa).
            window.RhythmSandbox.writeLevel(this._trailLevel().preset);
        } else {
            // O preset INTEIRO (forma, figuras, ligadura, clique) — o nível jogado antes não
            // vaza. Uma escrita só: RhythmTies.apply() depois dele apagaria o tipo de ligadura.
            window.RhythmSandbox.apply();
        }
    }

    /** Contexto deste jogo pro AuthGate (route = retomada pós-OAuth, que perde o hash). */
    _gateCtx() { return { gameId: 'rhythm', route: '#/ritmo' }; }

    /**
     * Defesa (espelho do enforceLoginProtection do capsula): guest nunca FICA num nível
     * acima da fronteira do gate (logout com nível alto / storage adulterado) — o clamp
     * volta pro último livre. O desbloqueio-por-progresso é outra camada (não muda aqui).
     */
    _enforceGate() {
        if (!window.authGate || !window.RhythmLevels) return;
        const L = window.RhythmLevels;
        const cur = L.getCurrent();
        const eff = window.authGate.clampForGuest(cur);
        if (eff !== cur) L.setCurrent(eff);
        // Storage inconsistente (ex.: current=7 com highestUnlocked=1): setCurrent
        // RECUSA nível "não desbloqueado" e o clamp acima vira no-op → cai pro maior
        // desbloqueado (nesse cenário sempre ≤ fronteira; senão o clamp acima pegou).
        if (window.authGate.isBlocked(L.getCurrent())) L.setCurrent(L.getProgress().highestUnlocked);
    }

    /**
     * "Ir pro Nível X" a partir do resultado (página E modal usam este caminho único).
     * Gate ANTES de mexer na UI: se o anônimo cancelar o modal de conta, a página de
     * resultado continua intacta embaixo; o login retoma a sequência completa.
     */
    _goNextLevel(nextId) {
        const seq = () => { this.resultsContainer.style.display = 'none'; this.state = 'idle'; this._enterLevel(nextId); };
        if (window.authGate && !window.authGate.allow(nextId, this._gateCtx(), seq)) return;
        seq();
    }

    /** Entra num nível (seleção do mapa): fixa o tempo do nível e sorteia um ritmo novo. */
    _enterLevel(id) {
        // Gate de conta (nível 4+ anônimo): abre o modal e NÃO muta nada; o login
        // in-page retoma re-chamando _enterLevel(id) — este mesmo caminho.
        if (window.authGate && !window.authGate.allow(id, this._gateCtx(), () => this._enterLevel(id))) return;
        const eff = window.RhythmLevels.setCurrent(id);
        const lvl = window.RhythmLevels.byId(eff);
        if (lvl) {
            this.currentBpm = this._clampBpm(lvl.bpm);
            localStorage.setItem('rhythm_bpm', String(this.currentBpm));
        }
        if (this.state === 'idle') this.prepareRound();
    }

    /** Nomes i18n de um mundo (título + dica curta). */
    _worldName(world) { return this._t('rhythm.level.world' + world); }
    _worldHint(world) { return this._t('rhythm.level.world' + world + 'Hint'); }
    _levelName(level) { return this._t('rhythm.level.n', { n: level.id }); }

    openLevelMap() {
        if (this.state !== 'idle') return;
        this.levelMap = new window.RhythmLevelMap({
            title: this._t('rhythm.level.mapTitle'),
            labels: {
                locked: this._t('rhythm.level.locked'),
                close: this._t('rhythm.config.close')
            },
            worldName: (w) => this._worldName(w),
            worldHint: (w) => this._worldHint(w),
            levelName: (l) => this._levelName(l),
            onSelect: (id) => this._enterLevel(id)
        });
        this.levelMap.open();
    }

    // ---------- painel de controle (figuras do sorteio) ----------

    /** "4 tempos" / "1 tempo" / "½ tempo" (i18n) — a régua mora no RhythmSandbox. */
    _beatsLabel(duration) { return window.RhythmSandbox.beatsLabel(duration, (k, v) => this._t(k, v)); }

    /**
     * Seções do painel = o PRESET desenhado (`RhythmSandbox.sections`, a ÚNICA descrição do
     * painel — a oficina da trilha monta o mesmo painel de lá, 18/set). Aqui: o preset do
     * personalizado, ou o do NÍVEL no modo `list` (do autor, tudo apagado — lê-se, não se mexe).
     */
    _figureSections(presetArg = null, readOnly = false) {
        const S = window.RhythmSandbox;
        return S.sections(presetArg || S.getPreset(), { t: (k, v) => this._t(k, v), readOnly });
    }

    openConfigPanel() {
        if (this.state !== 'idle') return;
        if (this._listMode()) { this._openReadOnlyPanel(); return; }
        const ranked = this._levelsMode();
        this._panelSectionsFn = () => this._panelSections();
        if (!this.configPanel) {
            this.configPanel = new window.RhythmConfigPanel({
                title: this._t('rhythm.config.title'),
                labels: { reset: this._t('rhythm.config.reset'), close: this._t('rhythm.config.close') },
                sections: this._panelSections(),
                // regra do jogo: pelo menos UMA nota sonora que CAIBA na fórmula (pausas livres).
                // As seções do jogador (`_…`) não têm regra.
                canToggle: (sectionId, itemId, next, enabledBySection) => {
                    if (String(sectionId).charAt(0) === '_') return true;
                    const S = window.RhythmSandbox;
                    return S.canToggle(S.getPreset(), sectionId, itemId, next, enabledBySection, (k, v) => this._t(k, v));
                },
                onChange: (enabledBySection, meta) => {
                    // A mudança foi do jogador (som/régua)? Então o preset NÃO é regravado
                    // nem um ritmo novo é sorteado.
                    if (this._applyPlayerSelection(enabledBySection) || ranked) return;
                    const preset = {};
                    Object.keys(enabledBySection).forEach(k => { if (k.charAt(0) !== '_') preset[k] = enabledBySection[k]; });
                    this._applyFigureSelection(preset, meta);
                },
                onReset: () => {
                    if (window.RhythmPrefs) window.RhythmPrefs.reset();
                    this._pickNote();
                    this._syncMidi();   // "Restaurar padrão" desliga o teclado MIDI também
                    if (!ranked) {
                        const n = window.RhythmSandbox.applyPreset(window.RhythmSandbox.defaultPreset());
                        this.currentBpm = this._clampBpm(n.bpm);
                        if (this.state === 'idle') this.prepareRound();
                    } else if (this.state === 'idle' && this.currentPattern) {
                        this._renderPattern();
                    }
                    return this._panelSections();
                }
            });
        } else {
            this.configPanel.setSections(this._panelSections());
        }
        this.configPanel.open();
    }

    /**
     * Painel → preset → EXERCISE_CONFIG, e um ritmo novo com ele (ao vivo). O painel NUNCA
     * escreve em EXERCISE_CONFIG por fora do preset (é o objeto que a "lista de exercícios"
     * vai guardar).
     */
    _applyFigureSelection(enabledBySection, meta = null) {
        const S = window.RhythmSandbox;
        const cur = S.getPreset();
        // seleção → preset cru (a regra da figura ligada/adotada mora no RhythmSandbox) → grava
        const n = S.applyPreset(S.presetFromSelection(cur, enabledBySection, meta));
        // Fórmula e nº de compassos mudam o que cabe, o que precisa ser ligado e o que se pode
        // escolher: o painel se redesenha e DIZ o que ligou por conta própria.
        const novos = n.autoFigures.filter(id => !cur.autoFigures.includes(id));
        if (this.configPanel && (n.timeSig.beats !== cur.timeSig.beats || n.measures !== cur.measures
            || n.autoFigures.join() !== cur.autoFigures.join())) {
            this.configPanel.setSections(this._panelSections());
            if (novos.length) {
                const figs = novos.map(id => this._t('rhythm.figures.' + id).toLocaleLowerCase()).join(', ');
                this.configPanel.warn(this._t('rhythm.config.autoAdded', { sig: `${n.timeSig.beats}/4`, fig: figs }));
            }
        }
        if (this.state === 'idle') this.prepareRound();
    }

    // ---------- FASE: Ouvir (demo) ----------

    async playDemo() {
        if (this.state !== 'idle') return;
        this.state = 'demo';
        window.audioManager.resumeContext();
        this.controlsContainer.innerHTML = '';
        this._setStatus(this._t('rhythm.listening'));
        this._renderPattern();

        const beatDur = this._beatDurSec();
        const patternBeats = this.currentPattern.config.measures * this.beatsPerMeasure;
        const t0 = window.audioManager.now() + 0.3;

        // "Ouvir" soa como o exercício vai soar: o padrão de clique vale desde o 1º tempo
        // (não há contagem na demonstração).
        window.metronomeManager.start(this.currentBpm, this.beatsPerMeasure, t0, patternBeats + 1, this._metroOpts(0));
        this._scheduleModelNotes(t0, beatDur);

        await this._sweep(t0, patternBeats, '#0ea5e9');

        window.metronomeManager.stop();
        this.renderer.hidePlayhead();
        this.prepareRound({ keep: true });   // o MESMO ritmo que acabou de tocar
    }

    /** agenda as notas-modelo (na nota do ajuste do jogador; Si 4 por padrão) nos tempos exatos do áudio */
    _scheduleModelNotes(t0, beatDur) {
        // passes são sequenciais (await) → o lote anterior já tocou; só rastreamos o atual
        this.scheduledNotes = [];
        let k = 0;
        for (const note of this.currentPattern.notes) {
            if (note.type !== 'note') continue;
            const when = t0 + note.beat * beatDur;
            const durSec = note.duration * beatDur;
            const alt = (this._melody && this._melody[k++]) || this._note || 'B4';
            const handle = window.audioManager.playNote(alt, durSec, { when });
            this.scheduledNotes.push(handle);
        }
    }

    /** mata as notas-modelo já agendadas no futuro (corta o áudio na hora ao parar). */
    _killScheduledAudio() {
        this.scheduledNotes.forEach(h => { try { h.stop(); } catch (e) { /* já tocou */ } });
        this.scheduledNotes = [];
    }

    /** anima o playhead de beat 0 até `beats`, ancorado em t0 (s). Resolve no fim. */
    _sweep(t0, beats, color) {
        return new Promise((resolve) => {
            const loop = () => {
                const elapsed = (window.audioManager.now() - t0) / this._beatDurSec();
                if (elapsed >= beats) { resolve(); return; }
                if (elapsed >= 0) this.renderer.movePlayhead(Math.min(elapsed, beats), color);
                this.rafId = requestAnimationFrame(loop);
            };
            this.rafId = requestAnimationFrame(loop);
        });
    }

    // ---------- FASE: Avaliar (take com nota) ----------

    async startGradedTake() {
        if (this.state !== 'idle') return;
        this.state = 'countdown';
        window.audioManager.resumeContext();

        // Funil (Fase 3b): o take avaliado É a rodada do Ritmo (ouvir não é).
        // Nível já vem 1-BASED do RhythmLevels; null no sandbox. Best-effort.
        if (window.Beacon) {
            // Guarda no RhythmLevels como no resto do arquivo: o argumento é avaliado FORA
            // do try/catch do Beacon, e medição não pode derrubar o take.
            const lvl = (this._levelsMode() && window.RhythmLevels) ? window.RhythmLevels.getCurrent()
                : (this.trail ? this._trailPos() : null);
            // Trilha do professor: a rodada carrega o código da lista (só o diário o lê).
            // No TESTE do dono nada se mede (nem session_time/level_abandoned): a rodada não abre.
            if (!(this.trail && this.trail.test)) window.Beacon.roundOpen(lvl, undefined, this.trail ? { list: this.trail.code } : null);
        }

        this.controlsContainer.innerHTML = '';
        // Restaura a faixa do topo (o retry vem do resultado, que a havia escondido) —
        // mantém o nível visível durante o take.
        const strip = this.container && (this.container.querySelector('#rhythm-level-strip') || this.container.querySelector('#rhythm-trail-strip'));
        if (strip) strip.style.display = '';
        this.tapButton.render();
        this.tapButton.disable();
        this._renderPattern();
        this._setStatus(this._t('rhythm.getReady'));

        const beatDur = this._beatDurSec();
        const beats = this.beatsPerMeasure;
        const recordBeats = this.currentPattern.config.measures * beats;
        const leadInBeats = RhythmGame.leadInBeats(beats);

        const t0 = window.audioManager.now() + 0.35;
        window.metronomeManager.start(this.currentBpm, beats, t0, leadInBeats + recordBeats, this._metroOpts(leadInBeats));
        const recStartTime = t0 + leadInBeats * beatDur;
        // abre a captura um pré-roll (½ batida) ANTES do beat 0
        const captureOpenBeats = leadInBeats - this.INPUT_PREROLL_BEATS;

        this.activeExpectedMs = this._expectedOnsetsMs();
        this._responseIndex = 0; // zera as fileiras de resposta deste take
        this.inputDetector.onLiveTap = (relMs) => { this._liveFeedback(relMs); this._beginResponseLine(relMs); };

        await new Promise((resolve) => {
            let capturing = false;
            let recording = false;
            const loop = () => {
                const elapsed = (window.audioManager.now() - t0) / beatDur;

                if (elapsed < 0) {
                    this.rafId = requestAnimationFrame(loop); return;
                }

                // Estende a linha-resposta ativa até o beat ATUAL (= o mesmo que move o
                // playhead). Durante o pré-roll/lead-in o beat é negativo → o clamp do
                // renderer segura no onset até o tempo alcançá-lo. No-op se nada pressionado.
                this.renderer.extendResponseLine(elapsed - leadInBeats);

                // Pré-roll: abre o detector + habilita o toque meia batida antes do
                // beat 0 (origem = recStartTime, inalterada). Assim um toque adiantado
                // na 1ª nota é capturado (delta negativo) em vez de cair no dead zone.
                if (!capturing && elapsed >= captureOpenBeats) {
                    capturing = true;
                    this.inputDetector.start(recStartTime, this.latencyOffset);
                    this.tapButton.enable({ playSound: true });
                }

                if (elapsed < leadInBeats) {
                    this._showCountdown(Math.floor(elapsed) % beats + 1);
                    this.renderer.hidePlayhead();
                } else if (elapsed < leadInBeats + recordBeats) {
                    if (!recording) {
                        recording = true;
                        this.state = 'recording';
                        this._showCountdown(this._t('rhythm.go'), '#10b981');
                    }
                    this.renderer.movePlayhead(elapsed - leadInBeats, '#10b981');
                } else {
                    resolve(); return;
                }
                this.rafId = requestAnimationFrame(loop);
            };
            this.rafId = requestAnimationFrame(loop);
        });

        this.tapButton.disable();
        this.inputDetector.onLiveTap = null;
        const inputs = this.inputDetector.stop();
        this._lastInputs = inputs; // guarda p/ redesenhar as respostas na tela de resultado
        window.metronomeManager.stop();
        this.renderer.hidePlayhead();
        this._clearCountdownUI();

        this.state = 'evaluating';
        this.evaluate(inputs);
    }

    // ---------- feedback / countdown ----------

    /**
     * Contagem de entrada DENTRO da bola (RhythmTapButton): some o <div> separado que
     * empilhava o número acima da bola (espaço vertical desperdiçado, pior no mobile)
     * e o olho já fica onde vai tocar. Chamado a CADA frame do loop → só pulsa quando o
     * valor VIRA (_lastCountValue), senão a animação reiniciaria 60×/s. Fallback no
     * #countdown-display se o botão ainda não existir.
     */
    _showCountdown(value, color) {
        const isAccent = value === 1;
        if (this.tapButton && this.tapButton.button) {
            if (value !== this._lastCountValue) {
                this._lastCountValue = value;
                this.tapButton.showCount(value, { accent: isAccent });
            }
            if (this.countdownEl) this.countdownEl.textContent = '';
            return;
        }
        if (!this.countdownEl) return;
        this.countdownEl.textContent = value;
        this.countdownEl.style.fontSize = isAccent ? '4.5rem' : '3.5rem';
        this.countdownEl.style.color = color || (isAccent ? '#ec4899' : '#6366f1');
    }

    /** Limpa a contagem (bola + div legado) e zera a guarda de virada. */
    _clearCountdownUI() {
        this._lastCountValue = null;
        if (this.countdownEl) this.countdownEl.textContent = '';
        if (this.tapButton) this.tapButton.clearCount();
    }

    /** feedback ao vivo: marca no tempo / adiantado / atrasado */
    _liveFeedback(relMs) {
        if (!this.activeExpectedMs || !this.activeExpectedMs.length) return;
        let best = Infinity, beat = null;
        for (const e of this.activeExpectedMs) {
            const d = relMs - e.ms;
            if (Math.abs(d) < Math.abs(best)) { best = d; beat = e.beat; }
        }
        const absd = Math.abs(best);
        const perfect = this.scorer.PERFECT_WINDOW_MS;
        let color, msg;
        if (absd <= perfect) { color = '#10b981'; msg = this._t('rhythm.liveOnTime'); }
        else if (absd <= 150) { color = '#f59e0b'; msg = best < 0 ? this._t('rhythm.liveEarly') : this._t('rhythm.liveLate'); }
        else { color = '#ef4444'; msg = best < 0 ? this._t('rhythm.liveTooEarly') : this._t('rhythm.liveTooLate'); }

        if (beat !== null) this.renderer.addHitMarker(beat, color);
        this._setStatus(msg);
    }

    // ---------- avaliação / resultados ----------

    evaluate(userInputs) {
        this.state = 'results';
        const results = this.scorer.evaluate(this.currentPattern, userInputs);
        this._debugDump(userInputs, results);
        this.showResults(results);
    }

    /**
     * Dump de diagnóstico (toques capturados × notas esperadas × pareamento),
     * gated por localStorage.rhythm_debug==='1'. Para depurar no CELULAR casos
     * tipo "última nota perdida no touch" sem precisar de devtools acoplado:
     * ativar com `localStorage.rhythm_debug='1'` no console (ou via um bookmarklet)
     * e ler o console do dispositivo. No-op em produção (flag desligada).
     */
    _debugDump(userInputs, results) {
        try { if (localStorage.getItem('rhythm_debug') !== '1') return; } catch (e) { return; }
        const beatDurMs = this._beatDurSec() * 1000;
        console.log('[rhythm_debug] BPM', this.currentBpm, '| beatDur(ms)', beatDurMs.toFixed(1),
            '| latencyOffset(ms)', (this.latencyOffset * 1000).toFixed(1));
        console.log('[rhythm_debug] toques capturados:', userInputs.map(i => ({
            onsetMs: Math.round(i.startRelative), durMs: Math.round(i.duration)
        })));
        console.log('[rhythm_debug] notas × pareamento:', results.results.map((r, n) => ({
            nota: n + 1, beat: r.expected && r.expected.beat,
            esperadoMs: r.expected && Math.round(r.expected.startTime),
            status: r.status,
            tocadoMs: r.actual ? Math.round(r.actual.startRelative) : null,
            deltaMs: r.actual ? Math.round(r.signedDelta) : null
        })));
        if (results.extras && results.extras.length) {
            console.log('[rhythm_debug] extras (não pareados):',
                results.extras.map(i => Math.round(i.startRelative) + 'ms'));
        }
    }

    /**
     * Grava o resultado do nível no ranking (Fase 5). Fire-and-forget: qualquer falha é
     * engolida (o jogo nunca depende disto). accuracy headline = min(início, duração) — o
     * gate exige os dois, o menor é o gargalo honesto (casa com o backend). `metrics` é a
     * bag versionada (v + snapshot do EXERCISE_CONFIG + detalhe) que CRESCE sem migração.
     *
     * DOIS PASSOS: (1) registra SEMPRE no mapa local (RhythmLevels.recordBest), inclusive
     * de convidado — os níveis livres eram jogados sem conta e sumiam do ranking por nível;
     * (2) envia agora se houver sessão. O que não subiu fica na fila e sobe no login
     * (RankingRepository.syncPending).
     */
    _maybeSaveScore(levelId, results) {
        try {
            if (!this._levelsMode() || levelId == null) return;

            const onset = Math.round(results.onsetScore);
            const duration = Math.round(results.durationScore);
            const accuracy = Math.min(onset, duration);
            const passed = !!(this._levelOutcome && this._levelOutcome.passed);
            const bestMs = Number.isFinite(results.avgSignedDelta) ? Math.round(Math.abs(results.avgSignedDelta)) : null;

            const cfg = window.EXERCISE_CONFIG || {};
            const ts = cfg.timeSignature;
            // 🔴 `bpm` = tempo REALMENTE tocado (this.currentBpm), não o nominal do nível:
            // o modo trilha tem slider de tempo, e quem desacelera acerta mais fácil. Gravar
            // o nominal escondia isso — e a precisão é o desempate do ranking. `bpmLevel`
            // fica ao lado para dar de comparar (a bag é aberta: campo novo sem migração).
            const metrics = {
                v: 1,
                config: {
                    bpm: this.currentBpm,
                    bpmLevel: cfg.bpm,
                    measures: cfg.measures,
                    timeSig: ts ? `${ts.beats}/${ts.noteValue}` : '4/4',
                    ties: !!cfg.tiesEnabled,
                    // Dose e LIÇÃO da ligadura: sem elas, dois níveis que só diferem nisso
                    // chegam ao servidor idênticos — e a lição é o que o mundo 4 e o 5
                    // têm de diferente. A bag é aberta e versionada; acrescentar é barato.
                    tieProb: cfg.tiesEnabled ? cfg.tieProb : null,
                    tieKinds: cfg.tiesEnabled && cfg.tieKinds ? cfg.tieKinds : null,
                    click: cfg.click || 'all',
                    figures: Array.isArray(cfg.allowedNotes) ? cfg.allowedNotes.map(n => n.type) : []
                },
                detail: { onset, duration }
            };

            const rec = window.RhythmLevels.recordBest
                ? window.RhythmLevels.recordBest(levelId, { accuracy, bestMs, passed, metrics })
                : null;

            const um = window.userManager;
            if (!um || !um.isLoggedIn() || !window.rankingRepository) return;

            window.rankingRepository
                .saveScore({ gameId: 'ritmo', level: levelId, accuracy, bestMs, passed, metrics })
                // `rec.seq` amarra a marcação AO TAKE QUE SUBIU: terminar outra rodada com o
                // request em voo não pode marcar como enviado um take que nunca subiu.
                .then(res => { if (res && res.success) window.RhythmLevels.markBestSynced(levelId, rec && rec.seq); })
                .catch(() => {});
        } catch (e) { /* placar é acessório: nunca propaga p/ o jogo */ }
    }

    showResults(results) {
        // Funil (Fase 3b): rodada CONCLUÍDA, antes de qualquer render.
        // 🔴 Com os DOIS placares: de anônimo o `level_result` do diário não existe, e sem
        // eles "tocou no tempo e não segurou" é indistinguível de "mal tocou" no funil.
        // Só o Ritmo manda (é o único jogo com início × duração); ver Beacon.roundClose.
        if (window.Beacon) window.Beacon.roundClose('done', {
            onset: results ? results.onsetScore : null,
            duration: results ? results.durationScore : null
        });
        this._setStatus('');
        this._clearCountdownUI();
        this.controlsContainer.innerHTML = '';
        this.resultsContainer.style.display = 'block';
        // A faixa do topo é redundante aqui — o painel completo (card) já abre o resultado.
        const strip = this.container && (this.container.querySelector('#rhythm-level-strip') || this.container.querySelector('#rhythm-trail-strip'));
        if (strip) strip.style.display = 'none';

        // Gate da trilha: no modo níveis, registra o resultado e (se passou) libera o
        // próximo. Chamado UMA vez aqui (recordResult muta o progresso). null no sandbox.
        const levelId = this._levelsMode() ? window.RhythmLevels.getCurrent() : null;
        this._levelOutcome = levelId != null
            ? window.RhythmLevels.recordResult(levelId, results.onsetScore, results.durationScore)
            : null;
        // Trilha do professor: a régua mora no RhythmTrails — NUNCA no recordResult/recordBest da
        // oficial (o bag do ranqueado fica intocado) — e a rodada vai ao diário por gancho PRÓPRIO.
        if (this.trail) this._levelOutcome = this._recordTrailResult(results);

        // Placar/ranking (Fase 5): grava o resultado no servidor se logado. Fire-and-forget
        // — nunca bloqueia nem afeta o resultado local. Convidado é ignorado (entra no
        // ranking na 1ª partida após logar). Só no modo trilha.
        this._maybeSaveScore(levelId, results);

        // marca cada nota na partitura
        this._renderPattern();
        this.renderer.hidePlayhead();
        results.results.forEach(r => {
            if (!r.expected) return;
            const color = r.status === 'missed' ? '#ef4444' : this.getColorForAccuracy(r.noteAccuracy);
            this.renderer.addHitMarker(r.expected.beat, color);
        });

        // Anatomia da resposta: uma fileira por nota, pintada como CERTO (verde) /
        // FORA (vermelho sólido) / FALTOU (cinza pontilhado), reusando o pareamento que
        // o scorer já fez. _renderPattern() limpou o SVG, então repintamos aqui.
        this.renderer.drawScoredResponses(results.results, results.extras, results.beatDuration, {
            onsetTolMs: this.scorer.PERFECT_WINDOW_MS,
            durDeadMs: this.scorer.DURATION_PERFECT_MS
        });

        // tendência de INÍCIO (adiantando/atrasando) — dead-zone = janela perfeita
        const onsetAvg = Math.round(results.avgSignedDelta);
        // 🔴 ZERO toques não é "no tempo, ótimo": a média de um conjunto vazio é 0 e caía na faixa perfeita
        //    (auditoria de usabilidade 22/set: 8 notas perdidas, INÍCIO 0% e "🎯" embaixo).
        const noInput = this._noInput(results);
        let onsetTrend = this._t(noInput ? 'rhythm.noInput' : 'rhythm.tendencyOk');
        if (!noInput && Math.abs(onsetAvg) > this.scorer.PERFECT_WINDOW_MS) {
            onsetTrend = onsetAvg < 0
                ? this._t('rhythm.tendencyEarly', { ms: Math.abs(onsetAvg) })
                : this._t('rhythm.tendencyLate', { ms: onsetAvg });
        }

        // tendência de DURAÇÃO (segurou curto/longo). Dead-zone do TEXTO = 15% da
        // batida (só afeta a frase de coaching, não o placar).
        const durAvg = Math.round(results.avgSignedDurationDelta);
        // mesma janela do scorer/gráfico (60ms): setinha 🎯, coaching e snap do verde
        // concordam → 🎯 aparece exatamente quando a duração marca 100% e o gráfico fica cheio.
        const durDead = this.scorer.DURATION_PERFECT_MS;
        let durTrend = this._t(noInput ? 'rhythm.noInputDur' : 'rhythm.durationOk');
        if (!noInput && Math.abs(durAvg) > durDead) {
            durTrend = durAvg < 0
                ? this._t('rhythm.durationShort', { ms: Math.abs(durAvg) })
                : this._t('rhythm.durationLong', { ms: durAvg });
        }

        const penalties = [];
        if (results.extraPenalty > 0) penalties.push(this._t('rhythm.extraPenalty', { pct: results.extraPenalty }));
        if (results.restPenalty > 0) penalties.push(this._t('rhythm.restPenalty', { pct: results.restPenalty }));
        const penaltyHtml = penalties.length
            ? `<p style="color:#ef4444;font-size:0.9rem;margin:0.6rem 0 0;text-align:center;">${penalties.join(' · ')}</p>` : '';

        // Limiar do nível (trilha): amarra o "Quase!" aos números — cada placar mostra
        // "meta X%" (✓ verde quando bate). null no sandbox (sem gate).
        let pass = null;
        if (this._levelsMode() && window.RhythmLevels) {
            const lv = window.RhythmLevels.byId(window.RhythmLevels.getCurrent());
            if (lv) pass = lv.pass;
        }
        if (this.trail) pass = this._trailLevel().pass;   // null = nível de treino (sem meta)

        // P8 — dois placares CO-IGUAIS lado a lado: Início (ataque) × Duração.
        const card = (title, value, trend, key) => {
            let goalHtml = '';
            if (pass != null) {
                const met = value >= pass;
                goalHtml = `<p style="font-size:0.72rem;font-weight:700;margin:0.35rem 0 0;color:${met ? '#10b981' : '#94a3b8'};">${met ? '✓ ' : ''}${this._t('rhythm.level.goal', { pass })}</p>`;
            }
            return `
            <div style="flex:1;min-width:140px;text-align:center;padding:1.1rem 0.6rem;background:#f9fafb;border-radius:12px;">
                <p style="font-size:0.78rem;letter-spacing:0.05em;text-transform:uppercase;color:#888;margin:0 0 0.2rem;">${title}</p>
                <p data-rhythm-score="${key}" style="font-size:3rem;font-weight:bold;margin:0;color:${this.getColorForAccuracy(value)};">${value.toFixed(0)}%</p>
                <p style="font-size:0.9rem;color:#555;margin:0.3rem 0 0;">${trend}</p>
                ${goalHtml}
            </div>`;
        };

        const onsetTitle = this._t('rhythm.onsetTitle');
        const durationTitle = this._t('rhythm.durationTitle');

        const scoreHtml = `
            <div style="display:flex;gap:0.8rem;flex-wrap:wrap;">
                ${card(onsetTitle, results.onsetScore, onsetTrend, 'onset')}
                ${card(durationTitle, results.durationScore, durTrend, 'duration')}
            </div>
            ${penaltyHtml}
            <div id="rhythm-measured" style="text-align:center;margin:0.9rem auto 1.4rem;"></div>`;
        // 🔴 O <details> "Como isso é medido?" MORREU aqui. Ele era a única ajuda sob
        // demanda do app inteiro e o público-alvo não abre um triângulo recolhido
        // sozinho — vira o tópico `rhythm.results`, com o mesmo texto em duas páginas
        // e mais duas perguntas. Um "?" no lugar de um <summary> escondido.

        // Detalhe por nota: agora DUAS colunas (Início % · Duração %).
        const cell = (arrow, pct) => `
            <div style="display:flex;gap:0.35rem;align-items:center;justify-content:flex-end;flex:1;">
                <span style="color:#888;font-size:0.78rem;min-width:64px;text-align:right;">${arrow}</span>
                <span style="font-weight:bold;min-width:42px;text-align:right;color:${this.getColorForAccuracy(pct)};">${pct.toFixed(0)}%</span>
            </div>`;

        const rows = results.results.map((r, i) => {
            const missed = r.status === 'missed';
            let cells;
            if (missed) {
                cells = `<span style="color:#ef4444;flex:1;text-align:right;">${this._t('rhythm.missed')}</span>`;
            } else {
                const d = Math.round(r.signedDelta);
                const onsetArrow = Math.abs(d) <= this.scorer.PERFECT_WINDOW_MS
                    ? '🎯' : (d < 0 ? `⏪${Math.abs(d)}ms` : `⏩${d}ms`);
                const dd = Math.round(r.actual.duration - r.expected.duration);
                const durArrow = Math.abs(dd) <= durDead
                    ? '🎯' : (dd < 0 ? `🤏${Math.abs(dd)}ms` : `🫳${dd}ms`);
                cells = `${cell(onsetArrow, r.timingAccuracy)}${cell(durArrow, r.durationAccuracy)}`;
            }
            return `
                <div style="display:flex;justify-content:space-between;align-items:center;gap:0.6rem;padding:0.5rem 0.25rem;border-bottom:1px solid #eee;${missed ? 'opacity:0.6;' : ''}">
                    <span style="font-weight:500;min-width:54px;">${this._t('rhythm.note', { n: i + 1 })}</span>
                    ${cells}
                </div>`;
        }).join('');

        // Legenda da anatomia da resposta (explica as cores/pontilhado desenhados na
        // pauta acima). Fica logo no topo do resultado, adjacente ao desenho.
        const R = this.renderer.RESPONSE;
        const legendItem = (color, dashed, label) => `
            <span style="display:inline-flex;align-items:center;gap:0.4rem;font-size:0.82rem;color:#555;">
                <span style="display:inline-block;width:24px;height:0;border-top:3px ${dashed ? 'dotted' : 'solid'} ${color};"></span>${label}
            </span>`;
        // item especial: tique vertical da "linha de chegada" (fim ideal)
        const legendTick = (color, label) => `
            <span style="display:inline-flex;align-items:center;gap:0.4rem;font-size:0.82rem;color:#555;">
                <span style="display:inline-block;width:0;height:13px;border-left:2px solid ${color};"></span>${label}
            </span>`;
        const legendHtml = `
            <div style="display:flex;gap:1.1rem;justify-content:center;flex-wrap:wrap;margin:0 0 1rem;">
                ${legendItem(R.correctColor, false, this._t('rhythm.legendOnTime'))}
                ${legendItem(R.wrongColor, false, this._t('rhythm.legendOff'))}
                ${legendItem(R.missColor, true, this._t('rhythm.legendMissing'))}
                ${legendTick(R.targetColor, this._t('rhythm.legendTarget'))}
            </div>`;

        // Banner da trilha: desbloqueou / passou de novo / faltou pouco (gate por nível).
        const levelBannerHtml = this._levelBannerHtml(results);

        // Ações em cima (próprias), detalhe por nota embaixo (notas 1..N juntas).
        // 🔴 O container dos botões tem id próprio: querySelector('div:last-child')
        // pegava o 1º "último filho" da árvore = o <div> interno da Nota 1, grudando
        // os botões nela. Selecionar por id evita isso de vez.
        this.resultsContainer.innerHTML = `
            ${this._levelProgressHtml()}
            ${levelBannerHtml}
            ${legendHtml}
            ${scoreHtml}
            <div id="rhythm-result-actions" style="text-align:center;margin-bottom:1.5rem;"></div>
            <div style="max-width:480px;margin:0 auto 1.5rem;background:#fff;border-radius:8px;padding:1rem;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
                <h3 style="margin-bottom:0.5rem;text-align:center;font-size:1rem;">${this._t('rhythm.noteDetail')}</h3>
                <div style="display:flex;justify-content:space-between;gap:0.6rem;font-size:0.72rem;text-transform:uppercase;letter-spacing:0.04em;color:#aaa;padding:0 0.25rem 0.3rem;">
                    <span style="min-width:54px;"></span>
                    <span style="flex:1;text-align:right;">${onsetTitle}</span>
                    <span style="flex:1;text-align:right;">${durationTitle}</span>
                </div>
                ${rows}
            </div>`;

        // No lugar do <details> aposentado: um "?" que abre `rhythm.results` — a mesma
        // explicação, em duas páginas, mais duas perguntas ("Início alto e Duração
        // baixa, está ruim?"). Rótulo ao lado para o "?" não ficar solto no branco.
        const medido = this.resultsContainer.querySelector('#rhythm-measured');
        if (medido && window.HelpDot) {
            const lab = document.createElement('span');
            lab.textContent = this._t('rhythm.howMeasured');
            lab.style.cssText = 'color:#6366f1;font-size:0.92rem;';
            medido.appendChild(lab);
            window.HelpDot.attach(medido, 'rhythm.results');
        }

        const btnRow = this.resultsContainer.querySelector('#rhythm-result-actions');
        const out = this._levelOutcome;
        // Trilha: PASSOU e há próximo nível → botão de avançar em PRIMEIRO (ação
        // principal). 🔴 Condição é `passed`, NÃO `newlyUnlocked`: quando se repassa um
        // nível já vencido, newlyUnlocked=false e o botão sumia → "não levava a lugar
        // nenhum". Se passou, o próximo já está liberado (agora ou antes).
        if (out && out.passed && out.nextId != null) {
            btnRow.appendChild(this._makeButton(this._t('rhythm.level.next'), 'linear-gradient(135deg,#6366f1,#4f46e5)',
                () => this.trail ? this._goNextTrailLevel(out.nextId) : this._goNextLevel(out.nextId)));
        }
        // 'results' é estado terminal; sai dele (→ idle) antes de reentrar, senão o
        // guard `if (state !== 'idle') return` em startGradedTake() barra o retry.
        btnRow.appendChild(this._makeButton(this._t('rhythm.retry'), 'linear-gradient(135deg,#10b981,#059669)', () => { this.resultsContainer.style.display = 'none'; this.state = 'idle'; this.startGradedTake(); }));
        // Na trilha não há "menu" para voltar (só voltava à tela inicial do MESMO nível — auditoria 22/set).
        if (!this.trail) btnRow.appendChild(this._makeButton(this._t('rhythm.backToMenu'), 'linear-gradient(135deg,#64748b,#475569)', () => this.prepareRound()));
        if (this.trail) {
            // A saída da trilha (capa: progresso, próximos níveis). Por ÚLTIMO: é o que sai do jogo.
            const cover = this._makeButton(this._coverLabel(), 'linear-gradient(135deg,#0f766e,#0d9488)', () => this._goToCover());
            cover.dataset.role = 'back';
            btnRow.appendChild(cover);
        }

        // Modal de fim de nível (trilha): comemora e PUXA pro próximo — a página de
        // resultado fica embaixo (o modal é o "momento"; "Ver resultado" revela o detalhe).
        this._showLevelModal(results);
    }

    /**
     * Modal de fim de nível (modo trilha) por cima do resultado, via NotificationManager.
     * Passou → "Ir pro Nível X →" como ação principal; quase → "Tentar de novo"; trilha
     * zerada → celebra. "Ver resultado" só fecha, revelando a página detalhada embaixo.
     * No-op no sandbox ou se o outcome/notifications não existirem.
     */
    /**
     * VEREDITO da reprovação, em UM lugar só (modal + faixa leem daqui).
     *
     * 🔴 "Quase! Tire 75% nos dois placares" diz a REGRA e não diz o que a PESSOA fez.
     * Quando o Início passa e só a Duração reprova, o diagnóstico é exato e é outro:
     * a pessoa está no tempo e não está segurando. Medido em prod — 3 dos 6 jogadores
     * reais travaram no nível 1 com Início 85-95 e Duração 21/21/59, e um visitante
     * anônimo fechou este mesmo modal 27 vezes seguidas sem nunca sair do nível 1.
     * Sem esta linha, a única informação que ele recebia era o limiar que não bateu.
     *
     * Não é um modal NOVO de propósito: `modal()` derruba o aberto na 1ª linha, e um
     * segundo overlay apagaria o resultado. O aviso entra no card que já abre sozinho.
     * @returns {string} texto do veredito de reprovação
     */
    _failVerdict(results) {
        // Autossuficiente de propósito: o levels-test o chama com um `this` mínimo ({_t}).
        const lvl = window.RhythmLevels ? window.RhythmLevels.byId(window.RhythmLevels.getCurrent()) : null;
        const pass = (this.trail ? this._trailLevel().pass : (lvl ? lvl.pass : 0)) || 0;
        // Só quando o ataque BATE o limiar e a duração NÃO: aí a frase é verdade.
        // Os dois baixos = a pessoa está fora do tempo também, e a dica seria mentira.
        // 🔴 Compara o que a TELA IMPRIME (`Math.round`, ver o scoreLine do modal), não o
        // float: com onset 74,6 o card mostrava "Início 75%" logo acima de "Tire 75% nos dois",
        // e a pessoa lia a contradição. O `recordResult` segue no float de propósito — lá o
        // número é o portão de desbloqueio, e arredondar mudaria a progressão.
        return (results && Math.round(results.onsetScore) >= pass && Math.round(results.durationScore) < pass)
            ? this._t('rhythm.level.tryAgainHold')
            : this._t('rhythm.level.tryAgain', { pass });
    }

    /** A meta do nível corrente: trilha oficial ou do professor (null = treino, sem meta). */
    _currentPass() {
        if (this.trail) return this._trailLevel().pass;
        const lvl = window.RhythmLevels ? window.RhythmLevels.byId(window.RhythmLevels.getCurrent()) : null;
        return lvl ? lvl.pass : 0;
    }

    /**
     * Registra a rodada na TRILHA DO PROFESSOR. Quem anota no diário é o `RhythmTrails.recordResult`
     * (como o `LevelProgress.recordBest` anota a oficial): "os jogos não mudam" — este arquivo não
     * cita o tracker. Devolve o outcome na forma que botões, modal e faixa já leem (`passed`,
     * `newlyUnlocked`, `nextId`) mais os campos da trilha (`training`, `takes`, `done`, `cleared`).
     */
    _recordTrailResult(results) {
        const T = window.RhythmTrails;
        const level = this._trailLevel();
        const ms = Number.isFinite(results.avgSignedDelta) ? Math.round(Math.abs(results.avgSignedDelta)) : null;
        const out = T.recordResult(this.trail, level.lid, results.onsetScore, results.durationScore, { bestMs: ms, noInput: this._noInput(results) });
        return { ...out, nextId: out.nextLid };
    }

    _showLevelModal(results) {
        if (!(this._levelsMode() || this.trail) || !window.notifications) return;
        const out = this._levelOutcome;
        if (!out) return;
        if (out.training) return;    // nível de treino: sem veredito — a página já mostra o placar
        const lvl = this.trail ? null : window.RhythmLevels.byId(window.RhythmLevels.getCurrent());
        const onset = Math.round(results.onsetScore);
        const dur = Math.round(results.durationScore);
        // A classe é a ÂNCORA do "?" deste modal (ver o bloco `dotInCard` abaixo):
        // o número é exatamente o que a pessoa não entende quando ele aparece.
        const scoreLine = `<div class="rhythm-modal-score" style="font-size:1rem;color:#475569;margin-top:0.6rem;display:flex;align-items:center;justify-content:center;gap:0.15rem;flex-wrap:wrap;">
            ${this._t('rhythm.onsetTitle')} <b style="color:${this.getColorForAccuracy(results.onsetScore)};">${onset}%</b>
            &nbsp;·&nbsp;
            ${this._t('rhythm.durationTitle')} <b style="color:${this.getColorForAccuracy(results.durationScore)};">${dur}%</b>
        </div>`;

        // ação que só fecha o modal e revela a página de resultado (closeOnClick padrão)
        const seeResult = { label: this._t('rhythm.level.seeResult'), style: 'neutral' };
        const goNext = {
            label: this._t('rhythm.level.next'), style: 'primary',
            onClick: () => this.trail ? this._goNextTrailLevel(out.nextId) : this._goNextLevel(out.nextId)
        };
        const retry = {
            label: this._t('rhythm.retry'), style: 'success',
            onClick: () => { this.resultsContainer.style.display = 'none'; this.state = 'idle'; this.startGradedTake(); }
        };

        let verdict, actions;
        if (out.noInput) {
            // sem toque: nada conta (nem treino) — a frase diz o que fazer, não "Quase!"
            verdict = this._t('rhythm.trails.noInput'); actions = [retry, seeResult];
        } else if (out.test && !out.passed) {
            // TESTE do dono reprovado: não há "próximo" a liberar — fala do ALUNO (auditoria 22/set)
            verdict = this._t('rhythm.trails.testFailed', { pass: this._trailLevel().pass });
            actions = [retry, { label: this._coverLabel(), style: 'primary', onClick: () => this._goToCover() }, seeResult];
        } else if (out.test && out.passed) {
            // TESTE do dono: passou, e nada foi gravado — nunca "de novo"/"liberado" (auditoria 18/set)
            verdict = this._t(out.training ? 'rhythm.trails.testTraining' : 'rhythm.trails.testPassed', { pass: this._trailLevel().pass });
            actions = [{ label: this._coverLabel(), style: 'primary', onClick: () => this._goToCover() }, retry, seeResult];
        } else if (out.passed && out.takes > 1 && !out.cleared) {
            // "faça N vezes": bateu a meta, ainda falta repetir — o próximo continua fechado
            verdict = this._t(this.trail && !this._trailHasNext() ? 'rhythm.trails.takesLeftLast' : 'rhythm.trails.takesLeft', { n: out.takes - out.done });
            actions = [retry, seeResult];
        } else if (out.passed && out.nextId != null) {
            verdict = out.newlyUnlocked ? this._t('rhythm.level.unlocked') : this._t('rhythm.level.passedAgain');
            actions = [goNext, seeResult];
        } else if (out.passed) {
            // último nível: zerou a trilha. Na do professor, a saída é a CAPA (sem ela o fim era um beco).
            verdict = this._t(this.trail ? 'rhythm.trails.allDone' : 'rhythm.level.allDone');
            actions = this.trail
                ? [{ label: this._coverLabel(), style: 'primary', onClick: () => this._goToCover() }, retry, seeResult]
                : [retry, seeResult];
        } else {
            verdict = this._failVerdict(results);
            actions = [retry, seeResult];
        }

        const body = `<div style="text-align:center;">
            <p style="font-size:1.1rem;color:#0f172a;margin:0;font-weight:600;line-height:1.4;">${verdict}</p>
            ${scoreLine}
        </div>`;
        window.notifications.modal({
            title: this.trail ? this._trailLevelName() : (lvl ? this._levelName(lvl) : ''),
            html: body,
            actions,
            dismissible: true
        });
        // 🔴 O "?" DENTRO do modal de resultado. Ele NÃO abre um segundo overlay:
        // `modal()` derruba o aberto na primeira linha, e a folha por cima apagaria
        // o resultado que a pessoa acabou de conquistar. `dotInCard` troca a página
        // do MESMO card e o "◀ Voltar ao resultado" devolve os nós originais.
        // 🔴 Pelo atributo do NotificationManager, NUNCA por [role="dialog"]: o drawer
        // do AppHeader também é dialog e mora no DOM mesmo fechado — a busca genérica
        // podia devolver o drawer e pendurar o "?" em lugar nenhum.
        const linha = document.querySelector('[data-notification-modal] .rhythm-modal-score');
        const card = linha && linha.closest('[data-notification-modal]');
        if (card && linha && window.HelpSheet) {
            window.HelpSheet.dotInCard('rhythm.results', linha, card);
        }
    }

    /**
     * Banner de resultado da trilha (modo níveis): "✅ nível desbloqueado" na 1ª vez,
     * "🎉 mandou bem" se repassou, "quase lá" se faltou bater o limiar. '' no sandbox.
     */
    _levelBannerHtml(results) {
        const out = this._levelOutcome;
        if (!out) return '';
        let bg, color, text;
        const last = this.trail && !this._trailHasNext();
        if (out.noInput) {
            bg = '#fff7ed'; color = '#c2410c'; text = this._t('rhythm.trails.noInput');
        } else if (out.test && !out.passed) {
            bg = '#fff7ed'; color = '#c2410c'; text = this._t('rhythm.trails.testFailed', { pass: this._trailLevel().pass });
        } else if (out.test && out.passed) {
            bg = '#ecfeff'; color = '#0e7490'; text = this._t(out.training ? 'rhythm.trails.testTraining' : 'rhythm.trails.testPassed', { pass: this._trailLevel().pass });
        } else if (out.training) {
            bg = '#f8fafc'; color = '#475569'; text = this._t(last ? 'rhythm.trails.trainingDoneLast' : 'rhythm.trails.trainingDone');
        } else if (out.passed && out.takes > 1 && !out.cleared) {
            bg = '#eef2ff'; color = '#4f46e5'; text = this._t(last ? 'rhythm.trails.takesLeftLast' : 'rhythm.trails.takesLeft', { n: out.takes - out.done });
        } else if (out.newlyUnlocked) {
            bg = '#ecfdf5'; color = '#059669'; text = this._t('rhythm.level.unlocked');
        } else if (out.passed) {
            bg = '#eef2ff'; color = '#4f46e5'; text = out.nextId == null
                ? this._t(this.trail ? 'rhythm.trails.allDone' : 'rhythm.level.allDone') : this._t('rhythm.level.passedAgain');
        } else {
            // Mesma fonte do modal (`_failVerdict`): dois textos para o mesmo veredito
            // divergiriam na primeira correção, e a faixa é o que fica na tela depois
            // que o card é fechado.
            bg = '#fef2f2'; color = '#dc2626'; text = this._failVerdict(results);
        }
        // A identidade do nível (Nível X · Mundo) agora vive no _levelProgressHtml()
        // logo acima; aqui o banner é só o VEREDITO (desbloqueou / quase / zerou).
        return `<div style="max-width:480px;margin:0 auto 1rem;padding:0.8rem 1rem;border-radius:12px;
            background:${bg};color:${color};text-align:center;font-weight:600;font-size:1rem;">${text}</div>`;
    }

    /**
     * Painel "você está aqui" da trilha (modo níveis): identidade do nível corrente
     * (Nível X de N) + nome do mundo + um "rail" gráfico dos níveis DO MUNDO CORRENTE
     * — concluído (✓ verde) · atual (indigo destacado, com número) · liberado
     * (contorno) · bloqueado (cinza). Substitui o rótulo minúsculo antigo: mostra a
     * EVOLUÇÃO de relance, não só o número. '' no sandbox.
     *   compact=true → versão de uma linha p/ o menu (visível durante o jogo).
     */
    _levelProgressHtml(compact = false) {
        if (this.trail) return this._trailProgressHtml();
        if (!this._levelsMode() || !window.RhythmLevels) return '';
        const L = window.RhythmLevels;
        const cur = L.byId(L.getCurrent());
        if (!cur) return '';
        const total = L.CATALOG.length;

        // diâmetros por estado (px), menores na versão compacta
        const D = compact ? { cur: 20, clr: 13, unl: 11, lck: 8 } : { cur: 26, clr: 16, unl: 14, lck: 10 };
        const pip = (l) => {
            const isCur = l.id === cur.id;
            let style, inner = '';
            if (isCur) {
                style = `width:${D.cur}px;height:${D.cur}px;background:#4f46e5;color:#fff;`
                    + `font-size:${compact ? 0.62 : 0.8}rem;font-weight:800;box-shadow:0 0 0 4px rgba(79,70,229,0.18);`;
                inner = l.id;
            } else if (L.isCleared(l.id)) {
                style = `width:${D.clr}px;height:${D.clr}px;background:#10b981;color:#fff;font-size:${compact ? 0.5 : 0.6}rem;`;
                inner = '✓';
            } else if (L.isUnlocked(l.id)) {
                style = `width:${D.unl}px;height:${D.unl}px;background:#fff;border:2px solid #c7d2fe;`;
            } else {
                style = `width:${D.lck}px;height:${D.lck}px;background:#e2e8f0;`;
            }
            return `<span style="display:inline-flex;align-items:center;justify-content:center;border-radius:50%;flex:0 0 auto;${style}">${inner}</span>`;
        };
        // 🔴 O RAIL MOSTRA SÓ O MUNDO CORRENTE — largura CONSTANTE, não a trilha inteira.
        // Com 15 níveis a faixa media exatamente a largura disponível no celular (318px);
        // com 25 media 478 e era CORTADA pelo overflow-x:hidden — do nível 17 em diante o
        // próprio pip do "você está aqui" caía fora da tela. Um pip por nível não escala
        // (a trilha vai a 50), e nenhuma quebra/rolagem resolve sem esconder justamente o
        // que a faixa existe para mostrar. Cinco pips cabem em qualquer trilha futura.
        const rail = L.CATALOG.filter(l => l.world === cur.world).map(pip).join('');

        // Zoom macro: uma barrinha por MUNDO (concluído / atual / futuro). Devolve o senso
        // de jornada que os 25 pontinhos indiferenciados davam mal, e escala igual.
        const worldBar = L.worlds().map(w => {
            const niveis = L.CATALOG.filter(l => l.world === w);
            const feito = niveis.every(l => L.isCleared(l.id));
            const bg = w === cur.world ? '#4f46e5' : (feito ? '#10b981' : '#e2e8f0');
            return `<span style="flex:1 1 0;height:${compact ? 3 : 4}px;border-radius:2px;background:${bg};"></span>`;
        }).join('');

        const progressText = this._t('rhythm.level.progress', { id: cur.id, total });
        if (compact) {
            // Pílula compacta p/ o topo do jogo (faixa clicável → mapa). O 🗺️ no fim
            // sinaliza que dá pra tocar e ver a trilha inteira.
            return `<span style="display:inline-flex;align-items:center;gap:0.55rem;flex-wrap:wrap;justify-content:center;max-width:100%;
                padding:0.35rem 0.8rem;border-radius:999px;background:#f8fafc;border:1px solid #eef2ff;">
                <span style="font-size:0.82rem;font-weight:700;color:#4f46e5;">${progressText}</span>
                <span style="display:inline-flex;align-items:center;gap:0.4rem;flex-wrap:wrap;justify-content:center;">${rail}</span>
                <span aria-hidden="true" style="font-size:0.82rem;opacity:0.85;">🗺️</span>
            </span>`;
        }
        return `
            <div style="max-width:480px;margin:0 auto 1rem;padding:1rem;background:#f8fafc;border-radius:14px;border:1px solid #eef2ff;">
                <div style="text-align:center;font-size:1.3rem;font-weight:800;color:#4f46e5;line-height:1;margin-bottom:0.25rem;">${progressText}</div>
                <div style="text-align:center;font-size:0.72rem;letter-spacing:0.05em;text-transform:uppercase;color:#94a3b8;font-weight:700;margin-bottom:0.85rem;">${this._worldName(cur.world)}</div>
                <div style="display:flex;align-items:center;justify-content:center;gap:0.55rem;flex-wrap:wrap;margin-bottom:0.85rem;">${rail}</div>
                <div style="display:flex;align-items:center;gap:0.28rem;max-width:280px;margin:0 auto;">${worldBar}</div>
            </div>`;
    }

    /**
     * O painel "você está aqui" da TRILHA DO PROFESSOR (página de resultado): nome, posição e
     * rótulo (ESCAPADOS — são do autor) + um rail de até 9 pips em volta do nível corrente
     * (uma trilha pode ter 120: pip por nível não escala; ver o rail da oficial).
     */
    _trailProgressHtml() {
        const T = window.RhythmTrails;
        const level = this._trailLevel();
        const idx = T.indexOf(this.trail, level.lid);
        const total = this.trail.levels.length;
        const from = Math.max(0, Math.min(idx - 4, total - 9));
        const slice = this.trail.levels.slice(from, from + 9);
        const pip = (l) => {
            let style, inner = '';
            if (l.lid === level.lid) {
                style = 'width:26px;height:26px;background:#4f46e5;color:#fff;font-size:0.8rem;font-weight:800;box-shadow:0 0 0 4px rgba(79,70,229,0.18);';
                inner = String(T.indexOf(this.trail, l.lid) + 1);
            } else if (T.isCleared(this.trail, l.lid)) {
                style = 'width:16px;height:16px;background:#10b981;color:#fff;font-size:0.6rem;'; inner = '✓';
            } else if (T.isUnlocked(this.trail, l.lid)) {
                style = 'width:14px;height:14px;background:#fff;border:2px solid #c7d2fe;';
            } else {
                style = 'width:10px;height:10px;background:#e2e8f0;';
            }
            return `<span style="display:inline-flex;align-items:center;justify-content:center;border-radius:50%;flex:0 0 auto;${style}">${inner}</span>`;
        };
        const dots = (on) => on ? `<span style="color:#94a3b8;font-size:0.8rem;">…</span>` : '';
        return `
            <div class="rhythm-trail-progress" style="max-width:480px;margin:0 auto 1rem;padding:1rem;background:#f8fafc;border-radius:14px;border:1px solid #eef2ff;">
                <div style="text-align:center;font-size:0.72rem;letter-spacing:0.05em;text-transform:uppercase;color:#94a3b8;font-weight:700;margin-bottom:0.25rem;">${this._esc(this._trailPrefixName())}</div>
                <div style="text-align:center;font-size:1.3rem;font-weight:800;color:#4f46e5;line-height:1;margin-bottom:0.25rem;">${this._esc(this._t('rhythm.level.progress', { id: idx + 1, total }))}</div>
                ${level.label ? `<div style="text-align:center;font-size:0.85rem;color:#64748b;margin-bottom:0.6rem;">${this._esc(level.label)}</div>` : ''}
                <div style="display:flex;align-items:center;justify-content:center;gap:0.55rem;flex-wrap:wrap;">${dots(from > 0)}${slice.map(pip).join('')}${dots(from + 9 < total)}</div>
            </div>`;
    }

    /** "Trilha: ⟨nome⟩" (texto). */
    _trailPrefixName() { return this._t('rhythm.trails.title') + ': ' + this.trail.name; }

    /**
     * (Re)desenha a faixa de progresso no TOPO do jogo (modo trilha) — herdou o espaço
     * do antigo h1 "Jogo de Ritmo". Toda a pílula é clicável e abre o mapa de níveis
     * (substitui o botão "🗺️ Níveis" do menu). Some no sandbox. Chamar sempre que o
     * nível/menu muda (prepareRound, _enterLevel via prepareRound).
     */
    _renderLevelStrip() {
        if (!this.container) return;
        const strip = this.container.querySelector('#rhythm-level-strip');
        if (!strip) return;                       // sandbox (não existe a faixa)
        const art = this._levelProgressHtml(true);
        strip.innerHTML = art;
        strip.style.display = '';                 // desfaz o hide feito em showResults
        if (!art) return;
        strip.style.cursor = 'pointer';
        strip.setAttribute('role', 'button');
        strip.setAttribute('tabindex', '0');
        strip.setAttribute('aria-label', this._t('rhythm.level.mapOpen'));
        // onclick/onkeydown (não addEventListener): idempotente entre re-renders.
        strip.onclick = () => this.openLevelMap();
        strip.onkeydown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.openLevelMap(); }
        };
    }

    getColorForAccuracy(accuracy) {
        if (accuracy >= 90) return '#10b981';
        if (accuracy >= 75) return '#f59e0b';
        if (accuracy >= 55) return '#f97316';
        return '#ef4444';
    }

    destroy() {
        this._cancelRaf();
        this._killScheduledAudio();
        // Funil (Fase 3b): saiu no meio do take = abandono. No-op se já fechou. DEPOIS de
        // cortar o áudio agendado — primeiro o jogo para, só então a medição.
        if (window.Beacon) window.Beacon.roundClose('quit');
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        clearTimeout(this._resizeTimer);
        if (window.metronomeManager) window.metronomeManager.stop();
        if (this.configPanel) { this.configPanel.destroy(); this.configPanel = null; }
        this._stopMidi();   // solta a assinatura MIDI (senão o teclado seguia apertando um botão que saiu da tela)
        if (this.tapButton) this.tapButton.destroy();
        if (this.musicStaff) this.musicStaff.destroy();
        if (this.container) this.container.innerHTML = '';
    }
}

// Disponibiliza globalmente
window.RhythmGame = RhythmGame;



// ============================================
// games/BaseQuizGame.js
// ============================================
/**
 * BaseQuizGame - Base dos jogos de "pergunta-resposta" (quiz).
 *
 * Extrai a máquina de estados e a UI compartilhadas entre os jogos que seguem o
 * formato pergunta → feedback → resultado (hoje: Leitura de Pauta e Intervalos).
 * O Jogo de Ritmo NÃO herda daqui — ele tem um relógio de áudio próprio e não é
 * um quiz; misturá-los seria forçar a barra.
 *
 * Estados: idle → question → feedback → results
 *
 * O que a base entrega de graça:
 *   - estado do placar (totalQuestions/questionIndex/correctCount/history/answered);
 *   - fluxo startRound → nextQuestion → showResults;
 *   - toggle de modo de resposta (persistido) e área de resultado;
 *   - helpers _t / _noteName / _setStatus / _makeButton / _colorForScore.
 *
 * O que a SUBCLASSE deve implementar (ganchos):
 *   - _generateAndPresent()      → sorteia a pergunta e a apresenta na tela;
 *   - _buildAnswerArea()         → (re)constrói a área de resposta do modo atual;
 *   - _setAnswersEnabled(bool)   → liga/desliga a entrada de resposta;
 *   - _resultRow(h, i)           → HTML de uma linha do detalhamento de resultado;
 *   - _afterModeRebuild()        → o que fazer após trocar de modo (re-apresentar);
 *   - _cleanupForResults()       → limpeza específica ao entrar em results.
 *   E definir no construtor (via opts): ns, modeStorageKey, defaultMode,
 *   modeLabelKey, modes. Opcionais: _beforeModeRebuild(), _prepareRoundUI().
 *
 * É AQUI que um futuro sistema de níveis/stats/persistência deve plugar: uma
 * única costura (startRound/showResults) serve os dois jogos de quiz e os próximos.
 */
class BaseQuizGame {
    /**
     * @param {object} opts
     * @param {string} opts.ns            namespace i18n ('staffReading' | 'intervals')
     * @param {string} opts.modeStorageKey chave do localStorage p/ o modo de resposta
     * @param {string} opts.defaultMode   modo padrão quando não há nada salvo
     * @param {string} opts.modeLabelKey  chave i18n do rótulo "Responder com:"
     * @param {Array<[string,string]>} opts.modes  pares [mode, chaveI18nDoRotulo]
     * @param {number} [opts.totalQuestions=10]
     * @param {number} [opts.resultsMaxWidth=460]  largura do card de detalhamento
     * @param {string} [opts.btnFont='1.1rem']     fonte dos botões grandes
     */
    constructor(opts = {}) {
        this.ns = opts.ns;
        this.modeStorageKey = opts.modeStorageKey;
        this.modeLabelKey = opts.modeLabelKey;
        this.modes = opts.modes || [];
        this.totalQuestions = opts.totalQuestions || 10;
        this.resultsMaxWidth = opts.resultsMaxWidth || 460;
        this._btnFont = opts.btnFont || '1.1rem';

        this.state = 'idle';
        this.container = null;
        this.statusEl = null;
        this.progressEl = null;
        this.modeEl = null;
        this.answersEl = null;
        this.extraEl = null;
        this.resultsContainer = null;
        this.piano = null;

        this.questionIndex = 0;
        this.correctCount = 0;
        this.answered = false;
        this.history = [];

        // modo de resposta (persistido); subclasses definem os modos possíveis
        this.answerMode = localStorage.getItem(this.modeStorageKey) || opts.defaultMode;

        this._advanceTimer = null;
    }

    // 🔴 Relógio do jogo, escalável SÓ pelo teste. Os quizzes esperam ~1-2 s entre a resposta e a
    // pergunta seguinte (feedback que a pessoa lê); `interval-test` e `chord-test` jogam ~6 rodadas
    // inteiras cada e pagavam 82 s por suíte só nessa espera (medido 16/set). O harness põe
    // `BaseQuizGame.TIME_SCALE = 0.05` depois de carregar o bundle; em produção nada o toca e vale 1.
    // A régua entra APENAS nos atrasos de fluxo (`_ms`), nunca no áudio: o som do feedback continua
    // no tempo real (a duração da nota é do AudioManager, não deste relógio).
    static TIME_SCALE = 1;
    _ms(ms) { return Math.max(0, Math.round(ms * BaseQuizGame.TIME_SCALE)); }

    // ---------- fluxo (concreto, compartilhado) ----------

    startRound() {
        this._clearTimers();
        // Funil (Fase 3b): recomeçar com rodada em curso é abandono — mas vale a MESMA
        // regra do destroy (sem resposta nenhuma, descarta). Tem de vir ANTES do reset
        // de history, que é a evidência de que a pessoa jogou.
        this._beaconEndRound('quit');
        this.state = 'idle';
        this.questionIndex = 0;
        this.correctCount = 0;
        this.history = [];
        this.resultsContainer.style.display = 'none';
        this.resultsContainer.innerHTML = '';
        this._prepareRoundUI();
        this._buildModeToggle();
        this._buildAnswerArea();
        // Funil (Fase 3b): abre a rodada. O 2º argumento é a evidência de que a pessoa
        // jogou — o quiz apresenta a pergunta 1 sozinho, então rodada sem resposta
        // nenhuma não conta (nem no fecho, nem na saída de página).
        // Best-effort — o Beacon engole os próprios erros.
        if (window.Beacon) window.Beacon.roundOpen(this._beaconLevel(), () => this.history.length > 0);
        this.nextQuestion();
    }

    nextQuestion() {
        if (this.questionIndex >= this.totalQuestions) {
            this.showResults();
            return;
        }
        this.state = 'question';
        this.answered = false;
        this.questionIndex++;
        // tamanho "sem fim" (totalQuestions = Infinity) usa um progresso sem total.
        const progressKey = isFinite(this.totalQuestions) ? '.progress' : '.progressEndless';
        this.progressEl.textContent = this._t(this.ns + progressKey, {
            current: this.questionIndex, total: this.totalQuestions, correct: this.correctCount
        });
        this._generateAndPresent();
    }

    showResults() {
        this._clearTimers();
        this.state = 'results';
        // Funil (Fase 3b): rodada CONCLUÍDA. Antes do render — evento de medição não
        // pode depender de nenhuma linha de DOM abaixo dar certo. (No modo "sem fim",
        // encerrar sem ter respondido nada cai na mesma regra e é descartado.)
        this._beaconEndRound('done');
        this._setStatus('');
        this.progressEl.textContent = '';
        this.modeEl.innerHTML = '';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';
        this._cleanupForResults();
        this.resultsContainer.style.display = 'block';

        // "sem fim": o total efetivo é o que foi de fato respondido.
        const total = isFinite(this.totalQuestions) ? this.totalQuestions : (this.history.length || 1);
        const pct = Math.round((this.correctCount / total) * 100);
        const color = this._colorForScore(pct);
        const rows = this.history.map((h, i) => this._resultRow(h, i)).join('');

        this.resultsContainer.innerHTML = `
            <div style="text-align:center;padding:1.5rem;background:#f9fafb;border-radius:12px;margin-bottom:1.5rem;">
                <p style="font-size:4rem;font-weight:bold;margin:0.3rem 0;color:${color};">${pct}%</p>
                <p style="font-size:1.1rem;color:#444;">${this._t(this.ns + '.scoreLine', { correct: this.correctCount, total: total })}</p>
            </div>
            <div style="max-width:${this.resultsMaxWidth}px;margin:0 auto 1.5rem;background:#fff;border-radius:8px;padding:1rem;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
                <h3 style="margin-bottom:0.5rem;text-align:center;font-size:1rem;">${this._t(this.ns + '.detailTitle')}</h3>
                ${rows}
            </div>`;

        // 🔴 A linha de ações é CRIADA aqui, nunca procurada por seletor. Ela já foi um
        // `<div>` vazio no fim do template achado por `querySelector('div:last-child')` —
        // que é DESCENDENTE, não filho: o primeiro `div` que é `:last-child` em ordem de
        // documento é a ÚLTIMA LINHA DO DETALHAMENTO, e era lá dentro que os botões
        // caíam. Medido a 390px: "Jogar de novo" saía 100×118px, rótulo quebrado em 4
        // linhas, dentro de um `space-between` com borda no meio. Valia para os três
        // jogos que herdam esta base.
        const btnRow = document.createElement('div');
        // sem `gap`: os botões já trazem margem própria do _makeButton.
        btnRow.style.cssText = 'display:flex;flex-wrap:wrap;justify-content:center;align-items:stretch;text-align:center;';
        this.resultsContainer.appendChild(btnRow);
        btnRow.appendChild(this._makeButton(this._t(this.ns + '.playAgain'), 'linear-gradient(135deg,#10b981,#059669)', () => this.startRound()));
        // `data-role="back"` porque este é o ÚNICO botão que SAI do jogo: a subclasse o
        // reposiciona por último (appendChild move o nó), para ele não ficar no meio dos
        // botões que continuam o treino. Sem a marca, a ordem dependeria de contar índices.
        const backBtn = this._makeButton(this._t(this.ns + '.backToMenu'), 'linear-gradient(135deg,#64748b,#475569)', () => window.router.navigate('/'));
        backBtn.dataset.role = 'back';
        btnRow.appendChild(backBtn);

        // gancho de pós-resultado (ex.: níveis): a subclasse pode injetar banner/botões.
        this._afterResults(this.resultsContainer, btnRow, pct);
    }

    // ---------- modo de resposta (concreto, compartilhado) ----------

    _buildModeToggle() {
        this.modeEl.innerHTML = '';
        const label = document.createElement('span');
        label.textContent = this._t(this.modeLabelKey);
        this.modeEl.appendChild(label);
        this.modes.forEach(([mode, labelKey]) => {
            this.modeEl.appendChild(this._makeButton(
                this._t(labelKey),
                this.answerMode === mode ? '#059669' : '#cbd5e1',
                () => this._setAnswerMode(mode),
                { small: true }
            ));
        });
    }

    _setAnswerMode(mode) {
        if (this.answerMode === mode || this.state === 'results') return;
        this.answerMode = mode;
        localStorage.setItem(this.modeStorageKey, mode);
        this._beforeModeRebuild();
        this._buildModeToggle();
        this._buildAnswerArea();
        this._afterModeRebuild();
    }

    // ---------- helpers (concreto, compartilhado) ----------

    _makeButton(label, bg, onClick, opts = {}) {
        const btn = window.domManager.create('button', {
            textContent: label,
            styles: {
                padding: opts.small ? '0.5rem 1rem' : '0.85rem 1.6rem',
                fontSize: opts.small ? '0.95rem' : this._btnFont,
                // 🔴 44px é o piso de alvo do projeto e vale para o botão `small` também:
                // medido, "Repetir"/"Parar" saíam com 41px de altura.
                minHeight: '44px',
                background: bg, color: '#fff', border: 'none', borderRadius: '10px',
                cursor: 'pointer', fontWeight: 'bold', margin: '0.4rem',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }
        });
        btn.addEventListener('click', onClick);
        return btn;
    }

    _setStatus(text) { if (this.statusEl) this.statusEl.textContent = text || ''; }

    /** Tradução (fonte única window.language). */
    _t(key, params = {}) {
        return window.language ? window.language.t(key, params) : key;
    }

    /** Nome localizado da nota (PT/ES solfejo, EN letras) — bloco TOP-LEVEL `notes`. */
    _noteName(letter) {
        return this._t('notes.' + letter);
    }

    _colorForScore(pct) {
        if (pct >= 90) return '#10b981';
        if (pct >= 70) return '#f59e0b';
        if (pct >= 50) return '#f97316';
        return '#ef4444';
    }

    _clearTimers() {
        clearTimeout(this._advanceTimer);
    }

    destroy() {
        this._clearTimers();
        // Funil (Fase 3b): saiu da rota com rodada em curso = abandono.
        this._beaconEndRound('quit');
        if (this.piano) { this.piano.destroy(); this.piano = null; }
        if (this.container) this.container.innerHTML = '';
    }

    // ---------- "voltar" do aparelho (profundidade 1) ----------
    //
    // 🔴 Portado do SongReadingGame, que já pagou o preço de acertar isto. É OPT-IN: quem
    // quiser chama `_navSetup()` no `init` e `_navTeardown()` no `destroy`, e implementa
    // `_navPopBack()`. Sem isso a base segue exatamente como era (o quiz de 1 nota não tem
    // tela interna nenhuma, então empilhar degrau nele seria inventar navegação).
    //
    // 🔴 PROFUNDIDADE 1, e não um estado por tela: um estado por tela deixa entradas
    // fantasmas quando a pessoa troca de jogo pelo ⊞, e cada "voltar" seguinte vira uma
    // TECLA MORTA.

    /** Arma a navegação por gesto. `prefix` só ajuda a ler o estado no debug. */
    _navSetup(prefix = 'qz') {
        this._navId = prefix + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
        this._navToken = false;      // há um degrau NOSSO empilhado?
        this._navSkipPop = false;    // o próximo popstate é limpeza nossa, não gesto da pessoa
        this._onPopState = () => this._onNavPop();
        window.addEventListener('popstate', this._onPopState);
    }

    _navTeardown() {
        if (!this._onPopState) return;
        window.removeEventListener('popstate', this._onPopState);
        this._onPopState = null;
    }

    /**
     * Entrou numa tela. `raiz=true` na tela de onde o "voltar" deve SAIR do jogo.
     * Fora da raiz empilha um degrau (só o primeiro); de volta à raiz, CONSOME o degrau —
     * senão o "voltar" seguinte seria uma tecla morta (a pessoa já saiu daquela tela).
     */
    _navEnter(raiz) {
        if (!this._onPopState) return;               // navegação não armada
        if (!raiz) {
            if (this._navToken) return;              // já há um degrau empilhado
            // `pushState` sem URL preserva o hash: o Router só escuta `hashchange`, então
            // isto não re-roteia nada.
            try { history.pushState({ quizNav: this._navId }, ''); this._navToken = true; } catch (e) { /* file:// */ }
            return;
        }
        if (!this._navToken) return;
        this._navToken = false;
        // 🔴 Só desfaz o degrau se ELE for o topo. Com o drawer do header aberto, o estado
        // do drawer está por cima: o `back()` comeria o drawer e o nosso degrau sobraria
        // órfão. Órfão não é problema — o `_onNavPop` o reconhece e o pula.
        if (!(history.state && history.state.quizNav === this._navId)) return;
        this._navSkipPop = true;   // a tela nova já está desenhada; o pop é só limpeza
        try { history.back(); } catch (e) { this._navSkipPop = false; }
    }

    _onNavPop() {
        if (this._navSkipPop) { this._navSkipPop = false; return; }
        // Degrau ÓRFÃO, empilhado por uma instância anterior (a pessoa entrou numa rodada,
        // trocou de jogo pelo ⊞ e voltou): inerte, mas gastaria uma tecla sem mudar a tela.
        if (!this._navToken) {
            if (history.state && history.state.quizNav) { try { history.back(); } catch (e) { /* nada a fazer */ } }
            return;
        }
        // 🔴 O drawer do header empilha o estado DELE por cima do nosso e fecha pelo MESMO
        // `popstate`. Se o estado atual ainda é o nosso degrau, quem saiu foi o drawer.
        if (history.state && history.state.quizNav === this._navId) return;
        this._navToken = false;
        this._navPopBack();
    }

    /** Saída explícita por um botão da tela — o MESMO caminho do gesto do aparelho.
     *  🔴 O dedo e o gesto não podem discordar: quem tem dois caminhos tem dois
     *  comportamentos, e um deles fica sem teste. */
    _navBack() {
        if (this._navToken) { try { history.back(); return; } catch (e) { this._navToken = false; } }
        this._navPopBack();
    }

    /** O que "descer um degrau" significa neste jogo. A subclasse implementa. */
    _navPopBack() {}

    // ---------- ganchos (a subclasse implementa / sobrescreve) ----------

    /**
     * Nível 1-BASED para o beacon de rodada, ou null onde não há trilha (o quiz de 1 nota
     * não tem níveis; o modo livre tem levelIdx, mas ele não significa progressão).
     * Sobrescrito por quem tem trilha ranqueada.
     */
    _beaconLevel() { return null; }

    /**
     * Encerra a rodada no funil. Sem NENHUMA resposta dada, DESCARTA em vez de fechar: o
     * quiz apresenta a pergunta 1 sozinho ao entrar na rota, então quem só passou por
     * aqui não abandonou rodada nenhuma — contá-la inflaria o número desta fase.
     * Best-effort e idempotente (o Beacon ignora fecho sem rodada aberta).
     */
    _beaconEndRound(outcome) {
        if (!window.Beacon) return;
        if (this.history && this.history.length) window.Beacon.roundClose(outcome);
        else window.Beacon.roundCancel();
    }

    /** Sorteia a próxima pergunta e a apresenta. OBRIGATÓRIO. */
    _generateAndPresent() { throw new Error('BaseQuizGame: _generateAndPresent() não implementado'); }
    /** (Re)constrói a área de resposta do modo atual. OBRIGATÓRIO. */
    _buildAnswerArea() { throw new Error('BaseQuizGame: _buildAnswerArea() não implementado'); }
    /** Liga/desliga a entrada de resposta. OBRIGATÓRIO. */
    _setAnswersEnabled() { throw new Error('BaseQuizGame: _setAnswersEnabled() não implementado'); }
    /** HTML de uma linha do detalhamento de resultado. OBRIGATÓRIO. */
    _resultRow() { throw new Error('BaseQuizGame: _resultRow() não implementado'); }

    /** Preparação de UI antes de iniciar a rodada (ex.: mostrar o piano). Opcional. */
    _prepareRoundUI() {}
    /** Limpeza ao entrar em results (ex.: destruir piano, limpar pauta). Opcional. */
    _cleanupForResults() {}
    /** Antes de reconstruir após troca de modo (ex.: limpar timers/piano). Opcional. */
    _beforeModeRebuild() {}
    /** Depois de reconstruir após troca de modo (ex.: re-apresentar a pergunta). Opcional. */
    _afterModeRebuild() {}
    /** Após montar a tela de results (ex.: níveis: banner + botão "próximo nível"). Opcional.
     *  @param {HTMLElement} container  o #results-container já preenchido
     *  @param {HTMLElement} btnRow     a linha onde "jogar de novo"/"voltar" foram adicionados
     *  @param {number} pct             % de acerto da rodada */
    _afterResults() {}
}

// Disponibiliza globalmente
window.BaseQuizGame = BaseQuizGame;



// ============================================
// games/StaffReadingGame.js
// ============================================
/**
 * StaffReadingGame - Jogo de Leitura de Pauta (protótipo inicial).
 *
 * 2º card de treinamento. Herda o esqueleto de quiz (placar, fluxo
 * startRound→nextQuestion→showResults, toggle de modo, resultado) de
 * BaseQuizGame; aqui mora só o que é de PAUTA/ALTURA:
 *   - renderização da nota na clave de sol (MusicStaff + StaffReadingRenderer);
 *   - config responsiva da pauta (abordagem B, como no Jogo de Ritmo);
 *   - avaliação por NOME da nota (oitava-agnóstica);
 *   - modos de resposta: Botões (solfejo) ↔ Piano.
 *   - tonalidade (treino livre, 27/set): a pauta ganha ARMADURA e a nota é lida nela.
 *
 * Mecânica: mostra UMA nota → usuário responde o nome → feedback (verde/vermelho
 * + som da altura real) → após N perguntas, tela de resultado.
 *
 * 🔴 TONALIDADE: o que se lê é a letra + a armadura (a linha do Fá em Sol maior é Fá♯).
 * A resposta certa tem DUAS formas, e as duas são a mesma nota:
 *   - instrumento (piano na tela, teclado físico, mic, MIDI) → a ALTURA: classe de altura
 *     (`pc`) igual à da nota sorteada, em qualquer oitava (a tecla PRETA quando alterada);
 *   - botões → o NOME SOLETRADO (`id`: 'F#'); com armadura os botões trazem também os
 *     nomes alterados, e "Fá" para um Fá♯ escrito é ERRO — é exatamente a leitura que a
 *     armadura pede. Em Dó maior os 7 botões são os de sempre.
 * A preferência (`sr_key`) é de APARELHO como as outras e guarda um CONJUNTO ('0,1,-1'):
 * a pessoa marca quantas tonalidades quiser e a armadura é sorteada entre elas a cada
 * RODADA (não a cada nota — ler uma armadura nova a cada nota é aritmética, não leitura).
 * Uma marcada = fixa; as 15 = "todas". Nunca zero (o painel recusa desmarcar a última).
 */
class StaffReadingGame extends BaseQuizGame {
    // Ordem das notas nos botões de resposta (C..B). O rótulo exibido é localizado
    // por _noteName() (PT/ES solfejo, EN letras) — ver staffReading.notes no i18n.
    static NOTE_ORDER = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];

    /** Clave do treino: preferência de APARELHO (fora do StorageScope, como `sr_guide_mode`).
     *  'treble' (padrão) · 'bass' · 'both'. Só o treino livre tem isto — na esteira a
     *  clave é do NÍVEL (docs/LEITURA-TRILHA-RODADA2.md, mundo 4). */
    static CLEF_KEY = 'sr_clef';
    static DEFAULT_CLEF = 'treble';

    /** Oitava do piano de resposta por clave. A resposta é por LETRA (qualquer Dó vale),
     *  mas a tecla que a guia aponta e que pisca na correção é a da ALTURA sorteada —
     *  então a de fá desce uma oitava e 'both' cobre as duas (2 fileiras no celular,
     *  via `PianoKeyboard.rowsFor`: aqui o teclado é a RESPOSTA).
     *  🔴 O piano TEM de cobrir o range do sorteio da clave (`DEFAULT_BASS_RANGE` vai até
     *  pos 10 = C4, o Dó central — a nota mais importante da clave de fá): sem a tecla,
     *  guia e pisca caíam no Dó3 (achado pela outra sessão, 13/set). Guardado por asserção
     *  que percorre TODAS as posições da clave, não a sorteada. */
    static PIANO_RANGE = { treble: ['C4', 'B4'], bass: ['C3', 'C4'], both: ['C3', 'B4'] };

    /** Tonalidades do treino: preferência de APARELHO, conjunto de armaduras separado por
     *  vírgula ('0', '1,-1,2'). Só o treino livre tem isto. `'random'` (formato de 27/set,
     *  vida curta) lê como as 15. */
    static KEY_KEY = 'sr_key';
    static DEFAULT_KEYS = [0];

    /** Ordem do seletor: por nº de alterações, sustenido antes do bemol (0, 1♯, 1♭, 2♯, 2♭…).
     *  É a ordem em que se APRENDE, não a do círculo — quem conta sinais acha o seu logo. */
    static KEY_ORDER = (() => {
        const out = [0];
        for (let n = 1; n <= 7; n++) out.push(n, -n);
        return out;
    })();

    /** Modos de resposta. As duas entradas de INSTRUMENTO são condicionais ao
     *  ambiente: 'mic' (piano acústico) exige getUserMedia + secure context;
     *  'midi' exige Web MIDI (ausente no iOS). Onde não há suporte, o modo
     *  simplesmente não aparece no seletor. */
    static _answerModes() {
        const modes = [['buttons', 'staffReading.modeButtons'], ['piano', 'staffReading.modePiano']];
        if (window.MicPitchInput && window.MicPitchInput.isSupported()) {
            modes.push(['mic', 'staffReading.modeMic']);
        }
        if (window.MidiPitchInput && window.MidiPitchInput.isSupported()) {
            modes.push(['midi', 'staffReading.modeMidi']);
        }
        return modes;
    }

    constructor() {
        super({
            ns: 'staffReading',
            modeStorageKey: 'sr_answer_mode',
            defaultMode: 'buttons',
            modeLabelKey: 'staffReading.answerWith',
            modes: StaffReadingGame._answerModes(),
            resultsMaxWidth: 460,
            btnFont: '1.15rem'
        });

        // modo salvo indisponível neste ambiente ('mic' em HTTP, 'midi' no iOS)
        // → volta pros botões
        if (!this.modes.some(([m]) => m === this.answerMode)) {
            this.answerMode = 'buttons';
        }
        this.mic = null;       // MicPitchInput (criado sob demanda, no clique "ativar")
        this.micPanel = null;  // MicStatusPanel
        this.midi = null;      // MidiPitchInput (idem; irmão do mic, mesmo contrato)
        this.midiPanel = null; // MicStatusPanel (compartilhado com o mic)

        // específicos da pauta
        this.staffContainer = null;
        this.musicStaff = null;
        this.renderer = null;
        this.generator = null;
        this.currentNote = null;

        // Guia para iniciante: linha tracejada da nota até a tecla/botão correto.
        // Camada SVG própria por cima do jogo inteiro, porque pauta e área de
        // resposta são SVGs DOM separados. Três modos, escolhidos no painel de
        // opções e persistidos:
        //   'always' (padrão) — DICA índigo em toda nota; vira verde na correção;
        //   'error'           — só aparece (verde) na correção quando o usuário ERRA;
        //   'off'             — nunca aparece.
        this._guideMode = localStorage.getItem('sr_guide_mode') || 'always';
        this._clef = StaffReadingGame.readClefPref();
        this._keys = StaffReadingGame.readKeyPref();
        this._sharps = this._drawSharps();
        this._guideSvg = null;
        this._guideLine = null;
        this._guideGame = null;
        this.configPanel = null;
    }

    /** Lê a clave guardada no aparelho; valor desconhecido cai no padrão. */
    static readClefPref() {
        const v = localStorage.getItem(StaffReadingGame.CLEF_KEY);
        return window.StaffReadingGenerator.CLEFS.includes(v) ? v : StaffReadingGame.DEFAULT_CLEF;
    }

    /** Conjunto guardado no aparelho; vazio/lixo cai em Dó maior. */
    static readKeyPref() {
        return StaffReadingGame.parseKeys(localStorage.getItem(StaffReadingGame.KEY_KEY))
            || StaffReadingGame.DEFAULT_KEYS.slice();
    }

    /**
     * Texto ('1,-1,2') ou lista → conjunto válido de armaduras na ordem de `KEY_ORDER`, sem
     * repetição; `null` se NADA válido sobrou. Token é inteiro em −7..7 na forma canônica
     * ('-0', '08', ' 1', '1.5' não valem); token inválido é ignorado, não derruba os outros.
     */
    static parseKeys(v) {
        const max = window.StaffReadingGenerator.MAX_SHARPS;
        if (v === 'random') return StaffReadingGame.KEY_ORDER.slice();
        const tokens = Array.isArray(v) ? v.map(String) : String(v == null ? '' : v).split(',');
        const set = new Set();
        tokens.forEach(t => {
            if (!/^-?\d$/.test(t)) return;
            const n = Number(t);
            if (String(n) === t && Math.abs(n) <= max) set.add(n);
        });
        const keys = StaffReadingGame.KEY_ORDER.filter(n => set.has(n));
        return keys.length ? keys : null;
    }

    /** Armadura desta rodada: uma das marcadas (uma só marcada = sempre a mesma). */
    _drawSharps() {
        return this._keys[Math.floor(Math.random() * this._keys.length)];
    }

    _makeGenerator() {
        return new window.StaffReadingGenerator({ clef: this._clef, sharps: this._sharps });
    }

    /** Começo de rodada: a pauta volta (o resultado a esconde) e a armadura é sorteada entre as
     *  marcadas (o "Jogar de novo" pode trocar de tom). */
    _prepareRoundUI() {
        if (this.staffContainer) {
            this.staffContainer.style.display = '';
            // Redimensionou com a caixa escondida (o resize não remonta em `results`): a pauta
            // voltaria com a largura velha, escalada e miúda. Remonta se a caixa mudou.
            const w = this.staffContainer.clientWidth;
            if (this.musicStaff && w && w !== this.musicStaff.config.width) this._buildStaff();
        }
        if (this._keys.length < 2) return;
        this._sharps = this._drawSharps();
        this.generator = this._makeGenerator();
    }

    /**
     * Troca o conjunto de tonalidades (painel ⚙️). Mesma regra da clave: gerador novo e a
     * pergunta em aberto é RE-SORTEADA numa armadura do conjunto novo. Nos botões o CONJUNTO
     * de respostas muda com a armadura (entram os nomes alterados) — a área remonta.
     * Conjunto vazio/inválido é ignorado (o painel já recusa desmarcar a última).
     */
    _setKeys(list) {
        const keys = StaffReadingGame.parseKeys(list);
        if (!keys || keys.join() === this._keys.join()) return;
        this._keys = keys;
        localStorage.setItem(StaffReadingGame.KEY_KEY, keys.join(','));
        this._sharps = this._drawSharps();
        this.generator = this._makeGenerator();
        if (this.answerMode === 'buttons' && this.state !== 'results') {
            this._buildAnswerArea();
            this._setAnswersEnabled(this.state === 'question' && !this.answered);
        }
        if (this.state === 'question' && !this.answered) this._generateAndPresent();
        else if (this.currentNote && this.state !== 'results') this._refreshGuide();
    }

    /**
     * Troca a clave do treino (painel ⚙️). Gerador novo; se há pergunta em aberto ela
     * é RE-SORTEADA na clave nova (a nota na tela tem de ser da clave que a pessoa
     * acabou de pedir — senão o primeiro "erro" é do jogo); em feedback/resultado a
     * próxima já sai certa. O piano muda de oitava com a clave.
     */
    _setClef(clef) {
        if (!window.StaffReadingGenerator.CLEFS.includes(clef) || clef === this._clef) return;
        this._clef = clef;
        localStorage.setItem(StaffReadingGame.CLEF_KEY, clef);
        this.generator = this._makeGenerator();
        // Em `results` a área de resposta está VAZIA de propósito (showResults) e o
        // startRound a remonta com o range novo — remontar aqui punha o piano por cima
        // do resultado.
        if (this.answerMode === 'piano' && this.state !== 'results') this._buildAnswerArea();
        if (this.state === 'question' && !this.answered) this._generateAndPresent();
    }

    async init(container) {
        this.container = container;
        this.generator = this._makeGenerator();

        this.setupUI();
        this.setupComponents();
        this.startRound();

        // Tutorial: auto-abre 1x por device (flag no localStorage); depois fica
        // só no botão "?" da área de resposta. showTutorial() trata cards vazio.
        if (!localStorage.getItem('sr_tutorial_seen')) {
            this.showTutorial();
            localStorage.setItem('sr_tutorial_seen', '1');
        }
    }

    setupUI() {
        const mobile = (window.innerWidth || 1024) < 560;
        const pad = mobile ? '0.75rem' : '1.5rem';
        this.container.innerHTML = `
            <div class="staff-reading-game" style="max-width:900px;margin:0 auto;padding:${pad};overflow-x:hidden;">
                <h1 class="game-h1" style="text-align:center;margin-bottom:0.25rem;">${this._t('staffReading.title')}</h1>
                <p id="sr-progress" style="text-align:center;color:#6366f1;font-weight:600;margin:0.2rem 0;"></p>
                <div class="game-intro" style="display:flex;align-items:center;justify-content:center;gap:0.1rem;margin-bottom:0.5rem;">
                    <p id="sr-status" style="text-align:center;color:#555;min-height:1.5rem;margin:0;"></p>
                </div>
                <div id="staff-container" style="margin:1rem auto;max-width:100%;overflow:hidden;"></div>
                <div id="sr-mode" style="text-align:center;margin:0.5rem 0;font-size:0.9rem;color:#555;"></div>
                <div id="sr-answers" style="text-align:center;margin:0.75rem 0;"></div>
                <div id="sr-extra" style="text-align:center;margin-bottom:0.5rem;"></div>
                <div id="results-container" style="display:none;"></div>
            </div>`;

        this.staffContainer = this.container.querySelector('#staff-container');
        // "?" de estreia na linha do status (fora do <p>, que _setStatus reescreve).
        if (window.HelpDot) {
            window.HelpDot.attach(this.container.querySelector('.game-intro'), 'reading.howto');
        }

        this.statusEl = this.container.querySelector('#sr-status');
        this.progressEl = this.container.querySelector('#sr-progress');
        this.modeEl = this.container.querySelector('#sr-mode');
        this.answersEl = this.container.querySelector('#sr-answers');
        this.extraEl = this.container.querySelector('#sr-extra');
        this.resultsContainer = this.container.querySelector('#results-container');
    }

    setupComponents() {
        this._buildStaff();

        // Relayout em rotação/resize (só fora de feedback animado)
        this._onResize = () => {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => {
                if (this.state === 'question' || this.state === 'idle') {
                    this._buildStaff(true); // já reposiciona a guia
                } else if (this.state === 'feedback') {
                    this._refreshGuide(); // pauta não remonta: só realinha a guia
                }
            }, 150);
        };
        window.addEventListener('resize', this._onResize);
    }

    /** Config responsiva da pauta (mesma ideia do Jogo de Ritmo, abordagem B). */
    _responsiveStaffConfig() {
        const measured = this.staffContainer ? this.staffContainer.clientWidth : 0;
        const w = Math.max(280, Math.floor(measured || window.innerWidth || 800));
        const mobile = w < 560;
        return {
            staff: {
                width: w, height: 160, lineSpacing: 10,
                marginLeft: mobile ? 14 : 60,
                marginRight: mobile ? 12 : 40,
                marginTop: 60
            },
            layout: { clefSpace: mobile ? 48 : 80, leftInset: mobile ? 10 : 22 }
        };
    }

    _buildStaff(reRender = false) {
        const cfg = this._responsiveStaffConfig();
        if (this.musicStaff) this.musicStaff.destroy();
        this.musicStaff = new window.MusicStaff(this.staffContainer, cfg.staff);
        this.renderer = new window.StaffReadingRenderer(this.musicStaff);
        Object.assign(this.renderer.rr.LAYOUT, cfg.layout);
        // A Bravura chega depois do 1º quadro: a armadura é remedida e a nota muda de X →
        // a guia tem de ir atrás.
        this.renderer.onRepaint = () => this._refreshGuide();
        if (reRender && this.currentNote) {
            this._renderCurrent();
            if (this.answered) this._recolorAfterAnswer();
            this._refreshGuide(); // pauta remontada com nova largura: realinha a guia
        }
    }

    /** Desenha a pergunta em curso: posição, clave E a armadura em que ela foi sorteada. */
    _renderCurrent() {
        const n = this.currentNote;
        this.renderer.render(n.position, n.clef, n.sharps || 0);
    }

    // ---------- ganchos do BaseQuizGame ----------

    /** Sorteia e apresenta uma nota (o progresso já foi setado pela base). */
    _generateAndPresent() {
        this.currentNote = this.generator.generate();
        this._renderCurrent();
        if (this.piano) this.piano.clearFeedback();
        this._setStatus(this._t('staffReading.question'));
        this._setAnswersEnabled(true);
        // Guia: no modo 'always' já mostra a dica apontando a tecla/botão. rAF
        // garante que pauta e área de resposta já estejam medidos (1ª pergunta).
        requestAnimationFrame(() => { if (this.state === 'question') this._refreshGuide(); });
    }

    /**
     * Registra a resposta. `chosen` é o nome soletrado escolhido ('C'..'B', ou 'F#'/'Bb'
     * com armadura). `info` (opcional) é o PitchUtil.info() da tecla, quando vem de um
     * instrumento — e aí quem decide é a ALTURA (classe de altura), não o nome: a tecla
     * não sabe se se chama Fá♯ ou Sol♭ (ver 🔴 TONALIDADE no cabeçalho). Também é o que
     * pinta a própria tecla tocada no feedback.
     */
    answer(chosen, info = null) {
        if (this.state !== 'question' || this.answered) return;
        this.answered = true;
        this.state = 'feedback';
        this._setAnswersEnabled(false);

        const target = this.currentNote;
        let correct, chosenId = chosen;
        if (info && typeof info.midi === 'number') {
            correct = ((info.midi % 12) + 12) % 12 === target.pc;
            // o nome que a pessoa "disse" é a tecla lida NA armadura da pergunta
            const sp = window.Notation.spell(info.midi, target.sharps || 0);
            chosenId = sp.letter + window.StaffReadingGenerator.accSuffix(sp.alter);
        } else {
            correct = chosen === target.id;
        }
        if (correct) this.correctCount++;
        this.history.push({
            ...target,
            chosen: chosenId,
            correct
        });

        this._recolorAfterAnswer(correct);
        // Correção: a guia fica verde reforçando onde a nota deveria cair. No modo
        // 'error' isso só acontece quando o usuário ERRA (decidido em _refreshGuide).
        this._refreshGuide();

        // Feedback no piano: pisca a tecla tocada (verde/vermelho) e, se errou,
        // mostra a tecla certa em verde.
        if (this.answerMode === 'piano' && this.piano) {
            if (info) this.piano.flashKey(info.midi, correct ? '#10b981' : '#ef4444', 1200);
            if (!correct) this._flashCorrectKeys('#10b981', 1200);
        } else if (this._instrumentPanel() && info) {
            // análogo do flashKey: a nota tocada (ouvida ou MIDI) pinta de
            // verde/vermelho no painel de status
            this._instrumentPanel().flash(info, correct);
        }

        this._playPitch(this.currentNote);
        window.audioManager.play(correct ? 'correct' : 'wrong');

        const noteName = this._noteLabel(this.currentNote.id);
        if (correct) {
            this._setStatus(this._t('staffReading.correct', { note: noteName }));
        } else {
            this._setStatus(this._t('staffReading.wrong', { note: noteName }));
        }

        // avança sozinho após o feedback
        this._advanceTimer = setTimeout(() => this.nextQuestion(), this._ms(correct ? 850 : 1500));
    }

    _recolorAfterAnswer(correct) {
        // se chamado no resize, usa o último registro
        if (correct === undefined) {
            const last = this.history[this.history.length - 1];
            correct = last ? last.correct : true;
        }
        this.renderer.colorNote(correct ? '#10b981' : '#ef4444');
    }

    /** Linha de detalhamento de uma nota no resultado. */
    _resultRow(h, i) {
        const ok = h.correct;
        const chosen = this._noteLabel(h.chosen);
        const detail = ok
            ? '<span style="color:#10b981;">✔</span>'
            : `<span style="color:#ef4444;">${this._t('staffReading.youMarked', { note: chosen })}</span>`;
        return `
            <div style="display:flex;justify-content:space-between;align-items:center;padding:0.4rem 0.25rem;border-bottom:1px solid #eee;${ok ? '' : 'opacity:0.85;'}">
                <span style="font-weight:500;">${this._t('staffReading.noteN', { n: i + 1 })}: <strong>${this._noteLabel(h.id || h.letter)}</strong></span>
                <span style="font-size:0.9rem;">${detail}</span>
            </div>`;
    }

    /**
     * Rótulo localizado de um nome SOLETRADO: 'F#' → 'Fá♯' / 'F♯' / 'Fa♯'. A letra vem do
     * `notes.*` (PT/ES solfejo, EN letra); o sinal é o mesmo nos três idiomas.
     */
    _noteLabel(id) {
        const letter = String(id || '').charAt(0);
        const acc = String(id || '').slice(1);
        return this._noteName(letter) + (acc === '#' ? '♯' : acc === 'b' ? '♭' : '');
    }

    /**
     * Rótulo do que a pessoa TOCOU (mic/MIDI), soletrado NA armadura da pergunta: a tecla
     * preta chega do PitchUtil sempre como sustenido ('A#'), e em Fá maior o Si♭ certo
     * sairia escrito "Lá" no painel enquanto o status diz "Si♭" (auditoria 27/set).
     */
    _playedLabel(info) {
        if (!info || typeof info.midi !== 'number') return this._noteName(info && info.letter);
        const sharps = this.currentNote ? (this.currentNote.sharps || 0) : this._sharps;
        const sp = window.Notation.spell(info.midi, sharps);
        return this._noteLabel(sp.letter + window.StaffReadingGenerator.accSuffix(sp.alter));
    }

    /**
     * Os botões de resposta desta armadura. Dó maior = os 7 de sempre. Com armadura, os
     * 7 naturais MAIS as notas alteradas dela, em ordem de altura (Dó, Dó♯, Ré… · Mi♭, Mi…):
     * "Fá" e "Fá♯" lado a lado é a escolha que a armadura pede à pessoa.
     * @returns {Array<{letter:string, alter:number, id:string, pc:number}>}
     */
    _answerNotes() {
        const G = window.StaffReadingGenerator;
        const key = G.keyNotes(this._sharps);
        if (!this._sharps) return key;
        const out = [];
        key.forEach(k => {
            const natural = { letter: k.letter, alter: 0, id: k.letter, pc: window.Notation.NATURAL_PC[k.letter] };
            if (k.alter < 0) out.push(k);
            out.push(natural);
            if (k.alter > 0) out.push(k);
        });
        return out;
    }

    /** Ao entrar em results: solta o piano e limpa a pauta — e ESCONDE a caixa dela: vazia, o
     *  SVG deixava 160 px de branco entre o título e o placar (foto dele, 27/set). */
    _cleanupForResults() {
        this._teardownPianoInput();
        this.renderer.clear();
        this._hideGuide();
        if (this.staffContainer) this.staffContainer.style.display = 'none';
    }

    /** Painel de status ativo (mic ou MIDI); null nos modos botões/piano. */
    _instrumentPanel() { return this.micPanel || this.midiPanel; }

    /** Solta piano + teclado físico + microfone + MIDI (mic.destroy() apaga o
     *  indicador de gravação do browser e midi.destroy() solta a assinatura —
     *  crítico ao trocar de modo/jogo). */
    _teardownPianoInput() {
        if (this.keyboard) { this.keyboard.destroy(); this.keyboard = null; }
        if (this.piano) { this.piano.destroy(); this.piano = null; }
        if (this.mic) { this.mic.destroy(); this.mic = null; }
        if (this.micPanel) { this.micPanel.destroy(); this.micPanel = null; }
        if (this.midi) { this.midi.destroy(); this.midi = null; }
        if (this.midiPanel) { this.midiPanel.destroy(); this.midiPanel = null; }
    }

    /** Após trocar de modo: reabilita a resposta se ainda numa pergunta. */
    _afterModeRebuild() {
        // o alvo mudou (tecla ↔ botão): reposiciona a guia conforme estado/modo
        this._refreshGuide();
        if (this.state === 'feedback' || this.state === 'results') return;
        this._setAnswersEnabled(this.state === 'question');
    }

    // ---------- área de resposta ----------

    /** (Re)constrói a área de resposta conforme o modo atual. */
    _buildAnswerArea() {
        // limpa modo anterior
        this._teardownPianoInput();
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';

        if (this.answerMode === 'piano') {
            const [minSci, maxSci] = StaffReadingGame.PIANO_RANGE[this._clef];
            this.piano = new window.PianoKeyboard(this.answersEl, {
                minSci, maxSci,
                rows: window.PianoKeyboard.rowsFor(minSci, maxSci),
                // rótulos seguem a convenção do idioma (EN letras, PT 'Dó', ES 'Do')
                labelFn: (info) => this._noteName(info.letter),
                onKeyPress: (info) => this.answer(info.letter, info)
            });
            this.piano.render();
            this.piano.setEnabled(this.state === 'question');

            // teclado físico do PC → mesmo answer() do piano (letras do projeto principal)
            this.keyboard = new window.KeyboardInput({
                piano: this.piano,
                onKeyPress: (info) => this.answer(info.letter, info)
            });
            this.keyboard.setEnabled(this.state === 'question');
        } else if (this.answerMode === 'mic') {
            this._buildMicArea();
        } else if (this.answerMode === 'midi') {
            this._buildMidiArea();
        } else {
            const notes = this._answerNotes();
            // Com armadura entram até 14 nomes: botão mais enxuto para caberem 4 por linha
            // no celular (MEDIDO 27/set: com o padding de sempre, 7♯ dava 5 linhas de 3).
            // Alvo continua ≥ 44 px de altura (piso do _makeButton) e ≥ 56 px de largura.
            const compact = notes.length > StaffReadingGame.NOTE_ORDER.length;
            notes.forEach((n) => {
                const btn = this._makeButton(this._noteLabel(n.id), 'linear-gradient(135deg,#6366f1,#8b5cf6)', () => this.answer(n.id));
                btn.dataset.note = n.id;
                btn.dataset.letter = n.letter;
                btn.style.minWidth = compact ? '56px' : '64px';
                if (compact) { btn.style.padding = '0.85rem 0.9rem'; btn.style.margin = '0.3rem'; }
                this.answersEl.appendChild(btn);
            });
        }

        // dica comum aos dois modos: toca a altura real da nota atual
        const hint = this._makeButton(this._t('staffReading.hearNote'), '#94a3b8', () => {
            if (this.currentNote) this._playPitch(this.currentNote);
        }, { small: true });
        this.extraEl.appendChild(hint);

        // painel de opções (gaveta: modo da linha-guia)
        const cfg = this._makeButton(this._t('staffReading.config.open'), '#64748b', () => this.openConfigPanel(), { small: true });
        this.extraEl.appendChild(cfg);
        // O que mora atrás de "⚙️ Opções" é a linha-guia — e é ela que a pessoa
        // precisa entender para saber se deve baixar um degrau de ajuda.
        if (window.HelpDot) this.extraEl.appendChild(new window.HelpDot('reading.guide').el);

        // tutorial ("? Como jogar")
        const tut = this._makeButton(this._t('staffReading.tutorial.open'), '#94a3b8', () => this.showTutorial(), { small: true });
        this.extraEl.appendChild(tut);

        // link p/ o jogo irmão: "🏃 Leitura em fluxo" → #/leitura (a esteira, headline).
        const flowWrap = document.createElement('div');
        flowWrap.style.cssText = 'margin-top:1rem;text-align:center;';
        const flow = document.createElement('button');
        flow.type = 'button';
        flow.className = 'rhythm-crosslink';
        flow.textContent = this._t('staffReading.toFlow');
        flow.addEventListener('click', () => { window.location.hash = '#/leitura'; });
        flowWrap.appendChild(flow);
        if (window.HelpDot) window.HelpDot.attach(flowWrap, 'app.freeMode');
        this.extraEl.appendChild(flowWrap);
    }

    // ---------- entrada por microfone (piano acústico) ----------

    /** Painel de status + MicPitchInput. A permissão só é pedida no clique
     *  "ativar microfone" (gesto do usuário), nunca automaticamente. */
    _buildMicArea() {
        this.micPanel = new window.MicStatusPanel(this.answersEl, {
            t: (k) => this._t('micInput.' + k),
            noteLabel: (info) => this._playedLabel(info),
            onActivate: () => this._startMic(),
            onFallback: () => this._setAnswerMode('buttons')
        });
        this.micPanel.render();
    }

    _startMic() {
        if (!this.mic) {
            this.mic = new window.MicPitchInput({
                onKeyPress: (info) => this.answer(info.letter, info),
                onStateChange: (s) => { if (this.micPanel) this.micPanel.setState(s); },
                onFrame: (f) => { if (this.micPanel) this.micPanel.frame(f); }
            });
        }
        this.mic.start().then((ok) => {
            if (ok && this.mic) this.mic.setEnabled(this.state === 'question' && !this.answered);
        });
    }

    // ---------- entrada por instrumento MIDI ----------

    /** Mesmo painel do mic (textos de midiInput.*). A permissão MIDI só é pedida
     *  no clique "conectar teclado" (gesto do usuário), nunca automaticamente. */
    _buildMidiArea() {
        this.midiPanel = new window.MicStatusPanel(this.answersEl, {
            t: (k) => this._t('midiInput.' + k),
            noteLabel: (info) => this._playedLabel(info),
            meterScale: 100, // velocity já vem 0..1 (o mic manda RMS, minúsculo)
            onActivate: () => this._startMidi(),
            onFallback: () => this._setAnswerMode('buttons')
        });
        this.midiPanel.render();
    }

    _startMidi() {
        if (!this.midi) {
            this.midi = new window.MidiPitchInput({
                onKeyPress: (info) => this.answer(info.letter, info),
                onStateChange: (s) => {
                    // no 'listening' o nome do teclado plugado entra no status
                    if (this.midiPanel) this.midiPanel.setState(s, s === 'listening' ? this.midi.getDeviceName() : null);
                },
                onFrame: (f) => { if (this.midiPanel) this.midiPanel.frame(f); }
            });
        }
        this.midi.start().then((ok) => {
            if (ok && this.midi) this.midi.setEnabled(this.state === 'question' && !this.answered);
        });
    }

    // ---------- painel de opções (⚙️) ----------

    /**
     * Seções declarativas do RhythmConfigPanel — UMA LINHA por ajuste, explicação no "?".
     * 🔴 O painel vai crescer (pedido dele, 27/set): três rádios com subtítulo por ajuste
     * custavam 1.200 px para 3 ajustes. Agora: clave em fileira de botões, tonalidade e
     * linha-guia em <select>, piano real em interruptor. Ajuste novo = uma linha aqui.
     */
    _configSections() {
        const c = (k) => this._t('staffReading.config.' + k);
        const am = window.audioManager;
        const pianoOn = !!(am && am.isPianoRealistic && am.isPianoRealistic());
        const clefOpt = (id, label) => ({ id, label, checked: this._clef === id });
        const guideOpt = (id, lk) => ({ id, label: c(lk), checked: this._guideMode === id });
        return [{
            id: 'clef', title: c('clefTitle'), help: 'reading.clef', single: true, inline: true,
            items: [
                clefOpt('treble', '𝄞 ' + c('clefTreble')),
                clefOpt('bass', '𝄢 ' + c('clefBass')),
                clefOpt('both', c('clefBoth'))
            ]
        }, {
            // Fechada por padrão: 15 chips custam 5 linhas, e quem só quer Dó maior não paga por elas.
            id: 'key', title: c('keyTitle'), help: 'reading.key', inline: true, collapsible: true,
            items: this._keyOptions()
        }, {
            id: 'guide', kind: 'select', title: c('guideTitle'), help: 'reading.guide',
            items: [guideOpt('always', 'guideAlways'), guideOpt('error', 'guideError'), guideOpt('off', 'guideOff')]
        }, {
            id: 'sound', kind: 'switch', title: c('realPiano'), help: 'reading.sound',
            items: [{ id: 'realPiano', label: c('realPiano'), checked: pianoOn }]
        }];
    }

    /**
     * As 15 tonalidades como chips marcáveis (quantas quiser). Rótulo curto: tônica MAIOR
     * + nº de sinais ("Sol 1♯", "Si♭ 2♭"; Dó maior só "Dó") — é o que a pessoa conta na
     * pauta, e 15 chips têm de caber em 3-4 linhas no celular. Modo e relativa menor ficam
     * no "?". Nome da nota pelo `notes.*` (PT/ES solfejo, EN letra).
     */
    _keyOptions() {
        const K = window.Key;
        const label = (sharps) => {
            const maj = K.of(sharps, false);
            const tonic = this._noteName(maj.tonic.letter) + (maj.tonic.alter > 0 ? '♯' : maj.tonic.alter < 0 ? '♭' : '');
            return sharps ? `${tonic} ${Math.abs(sharps)}${sharps > 0 ? '♯' : '♭'}` : tonic;
        };
        return StaffReadingGame.KEY_ORDER.map(n => ({
            id: String(n), label: label(n), checked: this._keys.includes(n)
        }));
    }

    openConfigPanel() {
        if (!this.configPanel) {
            this.configPanel = new window.RhythmConfigPanel({
                title: this._t('staffReading.config.title'),
                labels: { reset: this._t('staffReading.config.reset'), close: this._t('staffReading.config.close') },
                sections: this._configSections(),
                // Tonalidade: nunca zero marcadas — sem armadura nenhuma não há o que sortear.
                canToggle: (sec, item, next, enabled) => {
                    if (sec === 'key' && !next && (enabled.key || []).length <= 1) {
                        return this._t('staffReading.config.keyAtLeastOne');
                    }
                    return true;
                },
                onChange: (enabled) => {
                    this._setClef((enabled.clef && enabled.clef[0]) || StaffReadingGame.DEFAULT_CLEF);
                    this._setKeys(enabled.key || StaffReadingGame.DEFAULT_KEYS);
                    this._guideMode = (enabled.guide && enabled.guide[0]) || 'off';
                    localStorage.setItem('sr_guide_mode', this._guideMode);
                    this._refreshGuide(); // aplica ao vivo
                    // Som: piano realista (global). Ligar baixa o banco em background.
                    const am = window.audioManager;
                    if (am && am.setPianoRealistic) {
                        const want = !!(enabled.sound && enabled.sound.includes('realPiano'));
                        if (want !== am.isPianoRealistic()) {
                            am.setPianoRealistic(want);
                            if (want && !am.isPianoBankReady()) am.loadPianoBank().catch(() => {});
                        }
                    }
                },
                onReset: () => {
                    this._setClef(StaffReadingGame.DEFAULT_CLEF);
                    this._setKeys(StaffReadingGame.DEFAULT_KEYS);
                    this._guideMode = 'always';
                    localStorage.setItem('sr_guide_mode', this._guideMode);
                    this._refreshGuide();
                    return this._configSections();
                }
            });
        } else {
            this.configPanel.setSections(this._configSections());
        }
        this.configPanel.open();
    }

    _setAnswersEnabled(enabled) {
        if (this.answerMode === 'piano') {
            if (this.piano) this.piano.setEnabled(enabled);
            if (this.keyboard) this.keyboard.setEnabled(enabled);
            return;
        }
        if (this.answerMode === 'mic' || this.answerMode === 'midi') {
            // gate de EMISSÃO: o stream/assinatura fica vivo entre perguntas
            // (sem re-pedir permissão)
            if (this.mic) this.mic.setEnabled(enabled);
            if (this.midi) this.midi.setEnabled(enabled);
            return;
        }
        this.answersEl.querySelectorAll('button').forEach(b => {
            b.disabled = !enabled;
            b.style.opacity = enabled ? '1' : '0.5';
            b.style.cursor = enabled ? 'pointer' : 'default';
        });
    }

    // ---------- áudio ----------

    /**
     * Toca a altura real da nota: piano realista (opt-in) ou tom senoidal ('tick').
     * Aceita a nota do gerador (`{midi}`) ou uma sci ('F#4'). Tudo passa por MIDI: o
     * `getFrequency` do AudioManager só entende bemol, e a nota soletrada com ♯ cairia
     * no 440 Hz de fallback — o Lá para toda nota alterada.
     */
    _playPitch(note) {
        const am = window.audioManager;
        if (!am) return;
        const PU = window.PitchUtil;
        const midi = (note && typeof note.midi === 'number') ? note.midi : PU.midiFromSci(String(note));
        am.resumeContext();
        if (am.isPianoRealistic && am.isPianoRealistic()) {
            am.playNote(PU.sciFromMidi(midi), 0.7, { volume: 0.9 });
        } else {
            am.play('tick', { frequency: PU.frequency(midi), duration: 0.7, volume: 0.9 });
        }
    }

    // ========================================================================
    // TUTORIAL ANIMADO (roteiro F — "cara do jogo + piano")
    // ------------------------------------------------------------------------
    // Espelha o tutorial do RhythmGame (overlay de cards, _tutLoop, primitivas
    // de gravura), de propósito SEM herdar dele (são jogos irmãos) e sem tocá-lo.
    // Diferença-chave: o áudio aqui tem ALTURA (playNote com playbackRate) e as
    // cenas mostram o pentagrama + piano lado a lado, com a guia tracejada
    // nota → tecla persistindo apagadinha. Toda prosa fica nos cards (i18n);
    // no SVG só entram rótulos de nota localizados (_noteName) e símbolos.
    // ========================================================================

    _tutorialCards() {
        const dict = window.language.getTranslations();
        const lang = window.language.currentLanguage;
        const node = (dict && dict[lang] && dict[lang].staffReading && dict[lang].staffReading.tutorial)
            || (dict && dict.pt && dict.pt.staffReading && dict.pt.staffReading.tutorial);
        return (node && Array.isArray(node.cards)) ? node.cards : [];
    }

    /** rótulo de nota localizado a partir de um SCI ('G4' → 'Sol'/'G'/'Sol'). */
    _tutLabel(sci) { return this._noteName(sci.replace(/-?\d+$/, '')); }

    showTutorial() {
        const cards = this._tutorialCards();
        if (!cards.length) return;

        const scenes = [
            (s) => this._sceneF1(s), (s) => this._sceneF2(s), (s) => this._sceneF3(s),
            (s) => this._sceneF4(s), (s) => this._sceneF5(s), (s) => this._sceneF6(s),
            (s) => this._sceneF7(s)
        ];
        let idx = 0;
        let sceneStop = null;
        const stopScene = () => { if (sceneStop) { sceneStop(); sceneStop = null; } };

        const overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;inset:0;z-index:1000;background:rgba(15,23,42,0.7);'
            + 'display:flex;align-items:center;justify-content:center;padding:1rem;'
            + 'opacity:0;transition:opacity 0.2s;backdrop-filter:blur(3px);';
        const modal = document.createElement('div');
        modal.style.cssText = 'background:#fff;border-radius:18px;max-width:430px;width:100%;'
            + 'padding:1.4rem;box-shadow:0 20px 60px rgba(0,0,0,0.35);text-align:center;';
        const card = document.createElement('div');
        card.style.cssText = 'border-radius:14px;padding:0.9rem 0.9rem 1.2rem;color:#fff;'
            + 'background:linear-gradient(160deg,#1a1b26,#101119);'
            + 'transition:opacity 0.18s ease, transform 0.18s ease;';
        const stage = document.createElement('div');
        stage.style.cssText = 'margin:0 0 0.7rem;';
        const cardTitle = document.createElement('h2');
        cardTitle.style.cssText = 'margin:0 0 0.3rem;font-size:1.3rem;font-weight:800;';
        const cardBody = document.createElement('p');
        cardBody.style.cssText = 'margin:0;font-size:0.98rem;line-height:1.4;color:#c7c9d6;';
        card.appendChild(stage); card.appendChild(cardTitle); card.appendChild(cardBody);

        const dots = document.createElement('div');
        dots.style.cssText = 'display:flex;gap:0.4rem;justify-content:center;margin:1rem 0 0.6rem;';
        const nav = document.createElement('div');
        nav.style.cssText = 'display:flex;justify-content:space-between;align-items:center;gap:0.5rem;';
        const prevBtn = this._makeButton(this._t('staffReading.tutorial.prev'), '#94a3b8', () => go(idx - 1), { small: true });
        const nextBtn = this._makeButton('', 'linear-gradient(135deg,#10b981,#059669)',
            () => { if (idx >= cards.length - 1) close(); else go(idx + 1); });
        prevBtn.style.margin = '0'; nextBtn.style.margin = '0';
        nav.appendChild(prevBtn); nav.appendChild(nextBtn);

        const skip = document.createElement('button');
        skip.textContent = this._t('staffReading.tutorial.skip');
        skip.style.cssText = 'background:none;border:none;color:#94a3b8;cursor:pointer;margin-top:0.7rem;font-size:0.9rem;';
        skip.addEventListener('click', close);

        const render = () => {
            const c = cards[idx];
            cardTitle.textContent = c.title;
            cardBody.innerHTML = c.body;
            prevBtn.style.visibility = idx === 0 ? 'hidden' : 'visible';
            nextBtn.textContent = (idx >= cards.length - 1)
                ? this._t('staffReading.tutorial.start') : this._t('staffReading.tutorial.next');
            dots.innerHTML = '';
            cards.forEach((_, i) => {
                const d = document.createElement('span');
                d.style.cssText = 'width:8px;height:8px;border-radius:50%;display:inline-block;'
                    + 'transition:background 0.2s;background:' + (i === idx ? '#6366f1' : '#3a3b46') + ';';
                dots.appendChild(d);
            });
            stopScene();
            stage.innerHTML = '';
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 360 150');
            svg.setAttribute('width', '100%');
            svg.style.cssText = 'display:block;border-radius:10px;background:#12131A;';
            stage.appendChild(svg);
            sceneStop = (scenes[idx] ? scenes[idx](svg) : null) || null;
        };

        function go(n) {
            if (n < 0 || n >= cards.length) return;
            stopScene();
            const dir = n > idx ? 18 : -18;
            card.style.opacity = '0';
            card.style.transform = 'translateX(' + dir + 'px)';
            setTimeout(() => {
                idx = n; render();
                card.style.opacity = '1'; card.style.transform = 'translateX(0)';
            }, 160);
        }
        function close() {
            stopScene();
            overlay.style.opacity = '0';
            setTimeout(() => overlay.remove(), 200);
        }
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

        modal.appendChild(card); modal.appendChild(dots); modal.appendChild(nav); modal.appendChild(skip);
        overlay.appendChild(modal);
        document.body.appendChild(overlay);
        render();
        requestAnimationFrame(() => { overlay.style.opacity = '1'; });
    }

    // ===== Toolkit de cena =====

    _svg(parent, tag, attrs) {
        const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
        for (const k in attrs) el.setAttribute(k, attrs[k]);
        parent.appendChild(el);
        return el;
    }
    _txt(parent, attrs, content) {
        if (!attrs['font-family']) attrs['font-family'] = 'Arial, sans-serif';
        const t = this._svg(parent, 'text', attrs);
        t.textContent = content;
        return t;
    }

    /**
     * Loop de cena com ALTURA: cada item do schedule pode ter `note` ('G4'…);
     * o áudio é o sample de piano com playbackRate. stop() mata rAF + áudio
     * agendado à frente (contrato anti-vazamento). schedule pode ser função(pass).
     */
    _tutLoop(opts) {
        const cycleSec = opts.cycleSec;
        const onFrame = opts.onFrame, onTap = opts.onTap, onPass = opts.onPass;
        let alive = true, raf = null, handles = [], t0 = 0, pass = 0, lit = [], cur = [];
        const startPass = () => {
            if (!alive) return;
            window.audioManager.resumeContext();
            cur = (typeof opts.schedule === 'function') ? opts.schedule(pass) : (opts.schedule || []);
            if (onPass) onPass(pass);
            t0 = window.audioManager.now() + 0.15;
            handles = cur.map((s) => window.audioManager.playNote(s.note || 'B4', s.dur || 0.5,
                { when: t0 + s.at, volume: s.volume != null ? s.volume : 0.55, note: s.note || 'B4' }));
            lit = cur.map(() => false);
            frame();
        };
        const frame = () => {
            if (!alive) return;
            const raw = window.audioManager.now() - t0;
            const t = Math.max(0, Math.min(cycleSec, raw));
            if (onTap) cur.forEach((s, i) => { if (!lit[i] && raw >= s.at) { lit[i] = true; onTap(i, t, pass); } });
            if (onFrame) onFrame(t, pass);
            if (raw < cycleSec) { raf = requestAnimationFrame(frame); }
            else { pass++; startPass(); }
        };
        startPass();
        return () => {
            alive = false;
            if (raf) cancelAnimationFrame(raf);
            handles.forEach((h) => { if (h && h.stop) h.stop(); });
        };
    }

    // ===== Primitivas =====

    _tutLerp(a, b, p) { return a + (b - a) * p; }
    _tutClamp01(v) { return Math.max(0, Math.min(1, v)); }

    /** pentagrama branco "cara do jogo". yOf(st): st 0 = 1ª linha (Mi). */
    _tutStaff(svg, o) {
        o = o || {};
        const top = o.top != null ? o.top : 34, ls = o.ls != null ? o.ls : 11, x0 = 16, x1 = 344;
        this._svg(svg, 'rect', { x: 0, y: 0, width: 360, height: 150, fill: '#fff' });
        const lines = [];
        for (let i = 0; i < 5; i++)
            lines.push(this._svg(svg, 'line', { x1: x0, y1: top + i * ls, x2: x1, y2: top + i * ls, stroke: '#333', 'stroke-width': 1 }));
        const yOf = (st) => top + 4 * ls - st * ls / 2;
        let clef = null;
        if (!o.noClef)
            clef = this._txt(svg, { x: o.clefX != null ? o.clefX : 20, y: yOf(2) + 0.2 * ls, 'font-size': ls * 4.4,
                'font-family': "Bravura, 'Times New Roman', serif", fill: o.clefColor || '#000' }, '𝄞');
        return { top, ls, x0, x1, lines, yOf, clef };
    }

    /** teclado de teclas brancas C4..E5; rótulos localizados via _noteName. */
    _tutPiano(svg, o) {
        o = o || {};
        const SEQ = ['C4', 'D4', 'E4', 'F4', 'G4', 'A4', 'B4', 'C5', 'D5', 'E5'];
        const n = o.keys || 8;
        const kw = o.kw != null ? o.kw : 30, kh = o.kh != null ? o.kh : 34;
        const x = o.x != null ? o.x : 180 - n * kw / 2, y = o.y != null ? o.y : 100;
        const baseFill = '#fff';
        const g = this._svg(svg, 'g', {});
        const rects = {};
        for (let i = 0; i < n; i++)
            rects[SEQ[i]] = this._svg(g, 'rect', { x: x + i * kw, y, width: kw - 1.5, height: kh, rx: 2.5,
                fill: baseFill, stroke: '#94a3b8', 'stroke-width': 1 });
        for (let i = 0; i < n - 1; i++)
            if ('CDFGA'.indexOf(SEQ[i][0]) >= 0)
                this._svg(g, 'rect', { x: x + (i + 1) * kw - kw * 0.3, y, width: kw * 0.56, height: kh * 0.58, rx: 1.5, fill: '#1f2937' });
        if (o.labels)
            for (let i = 0; i < n; i++)
                this._txt(g, { x: x + i * kw + (kw - 1.5) / 2, y: y + kh - 5, 'text-anchor': 'middle',
                    'font-size': Math.min(8.5, kw * 0.33), 'font-weight': 'bold', fill: '#475569' }, this._tutLabel(SEQ[i]));
        return {
            g, x, y, kw, kh, n,
            cx(name) { return x + SEQ.indexOf(name) * kw + (kw - 1.5) / 2; },
            light(name, color) { if (rects[name]) rects[name].setAttribute('fill', color); },
            reset() { for (const k in rects) rects[k].setAttribute('fill', baseFill); }
        };
    }

    /** acende teclas em janelas de tempo (reset → persistentes → transientes). */
    _tutKeyFlash(pn, t, items, persist) {
        pn.reset();
        if (persist) persist();
        items.forEach((it) => { const a = t - it.at; if (a >= 0 && a < (it.dur || 0.45)) pn.light(it.key, it.color); });
    }

    /** guia tracejada nota → tecla. */
    _tutGuide(svg, color) {
        const ln = this._svg(svg, 'line', { x1: 0, y1: 0, x2: 0, y2: 0, stroke: color, 'stroke-width': 1.3, 'stroke-dasharray': '3,3', opacity: 0 });
        return {
            ln,
            set(x1, y1, x2, y2, op) {
                ln.setAttribute('x1', x1); ln.setAttribute('y1', y1);
                ln.setAttribute('x2', x2); ln.setAttribute('y2', y2);
                ln.setAttribute('opacity', op != null ? op : 0.8);
            },
            hide() { ln.setAttribute('opacity', 0); }
        };
    }

    /** semínima (cabeça + haste) reposicionável. */
    _tutQnote(parent, color) {
        const g = this._svg(parent, 'g', {});
        const head = this._svg(g, 'ellipse', { cx: 0, cy: 0, rx: 6.5, ry: 4.7, fill: color, transform: 'rotate(-18 0 0)' });
        const stem = this._svg(g, 'line', { x1: 5.6, y1: -1, x2: 5.6, y2: -26, stroke: color, 'stroke-width': 1.4 });
        return {
            g, head, stem,
            at(x, y) { g.setAttribute('transform', `translate(${x},${y})`); },
            paint(c) { head.setAttribute('fill', c); stem.setAttribute('stroke', c); },
            fade(op) { g.setAttribute('opacity', op); }
        };
    }

    /** confete: burst a partir de (cx,cy); chamar update(age 0..1). */
    _tutConfetti(svg, cx, cy, colors) {
        const ps = colors.map((c) => this._svg(svg, 'circle', { cx, cy, r: 2.5, fill: c, opacity: 0 }));
        return (age) => {
            ps.forEach((p, i) => {
                if (age < 0 || age > 1) { p.setAttribute('opacity', 0); return; }
                const ang = -Math.PI / 2 + (i - (ps.length - 1) / 2) * 0.5, d = age * 46;
                p.setAttribute('cx', (cx + Math.cos(ang) * d).toFixed(1));
                p.setAttribute('cy', (cy + Math.sin(ang) * d + age * age * 30).toFixed(1));
                p.setAttribute('opacity', (1 - age).toFixed(2));
            });
        };
    }

    // ===== As 7 cenas (roteiro F) — prosa nos cards, SVG só visual + rótulos =====

    /** F1 — grave e agudo: bolinha sobe pelo teclado conforme o som sobe. */
    _sceneF1(svg) {
        this._svg(svg, 'rect', { x: 0, y: 0, width: 360, height: 150, fill: '#fff' });
        const pn = this._tutPiano(svg, { keys: 8, kw: 29, x: 64, y: 84, kh: 46, labels: true });
        this._svg(svg, 'path', { d: 'M150,28 L210,28', stroke: 'none' });
        this._txt(svg, { x: 64, y: 144, 'font-size': 13, fill: '#475569', 'font-weight': 'bold' }, '←');
        this._txt(svg, { x: 296, y: 144, 'text-anchor': 'end', 'font-size': 13, fill: '#475569', 'font-weight': 'bold' }, '→');
        const ball = this._svg(svg, 'circle', { cx: pn.cx('C4'), cy: 70, r: 7, fill: '#6366f1', opacity: 0.9 });
        const kn = ['C4', 'E4', 'G4', 'C5'], ys = [70, 56, 42, 28];
        const sched = kn.map((nm, i) => ({ at: 0.3 + i * 0.6, note: nm }));
        let px = pn.cx('C4'), py = 70, cur = 0;
        return this._tutLoop({ cycleSec: 3.2, schedule: sched,
            onPass: () => { cur = 0; },
            onTap: (i) => { cur = i; },
            onFrame: (t) => {
                this._tutKeyFlash(pn, t, kn.map((nm, i) => ({ at: sched[i].at, key: nm, color: '#c7d2fe', dur: 0.3 })));
                px += (pn.cx(kn[cur]) - px) * 0.18; py += (ys[cur] - py) * 0.18;
                ball.setAttribute('cx', px.toFixed(1)); ball.setAttribute('cy', py.toFixed(1));
            } });
    }

    /** F2 — a pauta sobre o piano; cada nota mantém sua guia persistente. */
    _sceneF2(svg) {
        const st = this._tutStaff(svg, { top: 20, ls: 9, noClef: true });
        st.lines.forEach((ln) => ln.setAttribute('x2', st.x0));
        const pn = this._tutPiano(svg, { keys: 10, kw: 26, x: 50, y: 88, kh: 40, labels: true });
        const steps = [0, 2, 4, 6], kn = ['E4', 'G4', 'B4', 'D5'];
        const NX = (i) => 120 + i * 56;
        const sched = steps.map((s, i) => ({ at: 1.3 + i * 0.55, note: kn[i] }));
        const notes = steps.map(() => { const n = this._tutQnote(svg, '#000'); n.fade(0); return n; });
        const guides = steps.map(() => this._tutGuide(svg, '#6366f1'));
        return this._tutLoop({ cycleSec: 4.4, schedule: sched,
            onPass: () => { notes.forEach((n) => n.fade(0)); guides.forEach((g) => g.hide()); },
            onTap: (i) => {
                notes.forEach((n, j) => n.fade(j === i ? 1 : (j < i ? 0.28 : 0)));
                notes[i].at(NX(i), st.yOf(steps[i]));
                guides.forEach((g, j) => {
                    if (j > i) { g.hide(); return; }
                    g.set(NX(j), st.yOf(steps[j]) + 4, pn.cx(kn[j]), 88, j === i ? 0.8 : 0.3);
                });
            },
            onFrame: (t) => {
                st.lines.forEach((ln, i) => {
                    const p = this._tutClamp01((t - 0.1 * i) / 0.4);
                    ln.setAttribute('x2', (st.x0 + p * (st.x1 - st.x0)).toFixed(1));
                });
                this._tutKeyFlash(pn, t, kn.map((nm, i) => ({ at: sched[i].at, key: nm, color: '#c7d2fe', dur: 0.55 })));
            } });
    }

    /** F3 — linhas e espaços: faixa destaca + guia persistente por nota. */
    _sceneF3(svg) {
        const st = this._tutStaff(svg, { top: 20, ls: 9, noClef: true });
        const band = this._svg(svg, 'rect', { x: 100, y: 0, width: 244, height: 5, rx: 2.5, fill: '#fbbf24', opacity: 0 });
        const pn = this._tutPiano(svg, { keys: 8, kw: 29, x: 64, y: 88, kh: 40, labels: true });
        const sts = [0, 1, 2, 3, 4], kn = ['E4', 'F4', 'G4', 'A4', 'B4'];
        const NX = (i) => 130 + i * 42;
        const sched = sts.map((s, i) => ({ at: 0.4 + i * 0.6, note: kn[i] }));
        const notes = sts.map(() => { const n = this._tutQnote(svg, '#000'); n.fade(0); return n; });
        const guides = sts.map(() => this._tutGuide(svg, '#6366f1'));
        return this._tutLoop({ cycleSec: 4.4, schedule: sched,
            onPass: () => { notes.forEach((n) => n.fade(0)); guides.forEach((g) => g.hide()); band.setAttribute('opacity', 0); },
            onTap: (i) => {
                notes.forEach((n, j) => n.fade(j === i ? 1 : (j < i ? 0.28 : 0)));
                notes[i].at(NX(i), st.yOf(sts[i]));
                guides.forEach((g, j) => {
                    if (j > i) { g.hide(); return; }
                    g.set(NX(j), st.yOf(sts[j]) + 4, pn.cx(kn[j]), 88, j === i ? 0.8 : 0.3);
                });
                const isLine = sts[i] % 2 === 0;
                if (isLine) {
                    band.setAttribute('y', (st.yOf(sts[i]) - 2.5).toFixed(1)); band.setAttribute('height', 5);
                    band.setAttribute('fill', '#fbbf24');
                } else {
                    band.setAttribute('y', (st.yOf(sts[i]) - (st.ls / 2 - 1.5)).toFixed(1)); band.setAttribute('height', st.ls - 3);
                    band.setAttribute('fill', '#a5b4fc');
                }
                band.setAttribute('opacity', 0.45);
            },
            onFrame: (t) => {
                this._tutKeyFlash(pn, t, kn.map((nm, i) => ({ at: sched[i].at, key: nm, color: '#c7d2fe', dur: 0.55 })));
            } });
    }

    /** F4 — a clave de Sol: linha do Sol + tecla do Sol, ligadas pela guia. */
    _sceneF4(svg) {
        const st = this._tutStaff(svg, { top: 20, ls: 9, noClef: true });
        const gl = st.yOf(2);
        const solLine = this._svg(svg, 'line', { x1: st.x0, y1: gl, x2: st.x1, y2: gl, stroke: '#f59e0b', 'stroke-width': 1.8, opacity: 0 });
        const clef = this._txt(svg, { x: 20, y: gl + 1.8, 'font-size': 39.6, 'font-family': "Bravura, 'Times New Roman', serif", fill: '#000', opacity: 0 }, '𝄞');
        const ring = this._svg(svg, 'circle', { cx: 34, cy: gl, r: 9, fill: 'none', stroke: '#f59e0b', 'stroke-width': 2, opacity: 0 });
        const note = this._tutQnote(svg, '#000'); note.at(210, gl); note.fade(0);
        const lab = this._txt(svg, { x: 210, y: 74, 'text-anchor': 'middle', 'font-size': 12, 'font-weight': 'bold', fill: '#f59e0b', opacity: 0 }, this._tutLabel('G4'));
        const pn = this._tutPiano(svg, { keys: 8, kw: 29, x: 64, y: 88, kh: 40, labels: true });
        const gd = this._tutGuide(svg, '#f59e0b');
        return this._tutLoop({ cycleSec: 3.6, schedule: [{ at: 1.4, note: 'G4' }, { at: 2.6, note: 'G4', volume: 0.35 }],
            onFrame: (t) => {
                clef.setAttribute('opacity', this._tutClamp01(t / 0.8).toFixed(2));
                let solOp = 0;
                [1.0, 2.4].forEach((at) => {
                    const a = t - at;
                    if (a >= 0 && a < 0.8) {
                        ring.setAttribute('opacity', (0.9 * (1 - a / 0.8)).toFixed(2));
                        ring.setAttribute('r', (9 + a / 0.8 * 12).toFixed(1));
                        solOp = Math.max(solOp, 1 - a / 0.8 * 0.4);
                    }
                });
                if (t < 1.0) ring.setAttribute('opacity', 0);
                solLine.setAttribute('opacity', Math.max(t > 1 ? 0.5 : 0, solOp).toFixed(2));
                note.fade(t >= 1.4 ? 1 : 0);
                lab.setAttribute('opacity', t >= 1.4 ? 1 : 0);
                pn.reset();
                if (t >= 1.4) { pn.light('G4', '#fbbf24'); gd.set(210, gl + 4, pn.cx('G4'), 88, 0.7); }
                else gd.hide();
            } });
    }

    /** F5 — os vizinhos do Sol: cada vizinho ligado à sua tecla. */
    _sceneF5(svg) {
        const st = this._tutStaff(svg, { top: 20, ls: 9 });
        const seq = [
            { st: 2, k: 'G4', x: 210, gold: true }, { st: 1, k: 'F4', x: 170 },
            { st: 3, k: 'A4', x: 250 }, { st: 0, k: 'E4', x: 130 }, { st: 4, k: 'B4', x: 290 }
        ];
        const sched = seq.map((s, i) => ({ at: 0.4 + i * 0.6, note: s.k }));
        const notes = seq.map(() => { const n = this._tutQnote(svg, '#000'); n.fade(0); return n; });
        const labs = seq.map((s) => this._txt(svg, { x: s.x, y: 74, 'text-anchor': 'middle', 'font-size': 11, 'font-weight': 'bold', fill: s.gold ? '#f59e0b' : '#6366f1', opacity: 0 }, this._tutLabel(s.k)));
        const pn = this._tutPiano(svg, { keys: 8, kw: 29, x: 64, y: 88, kh: 40, labels: true });
        const guides = seq.map((s) => this._tutGuide(svg, s.gold ? '#f59e0b' : '#6366f1'));
        const lit = [];
        return this._tutLoop({ cycleSec: 4.6, schedule: sched,
            onPass: () => {
                lit.length = 0;
                notes.forEach((n) => n.fade(0));
                labs.forEach((l) => l.setAttribute('opacity', 0));
                guides.forEach((g) => g.hide());
            },
            onTap: (i) => {
                notes[i].at(seq[i].x, st.yOf(seq[i].st));
                notes[i].paint(seq[i].gold ? '#f59e0b' : '#000');
                notes[i].fade(1);
                labs[i].setAttribute('opacity', 1);
                lit.forEach((j) => guides[j].set(seq[j].x, st.yOf(seq[j].st) + 4, pn.cx(seq[j].k), 88, 0.3));
                guides[i].set(seq[i].x, st.yOf(seq[i].st) + 4, pn.cx(seq[i].k), 88, seq[i].gold ? 0.85 : 0.8);
                lit.push(i);
            },
            onFrame: () => {
                pn.reset();
                lit.forEach((i) => pn.light(seq[i].k, seq[i].gold ? '#fbbf24' : '#e0e7ff'));
            } });
    }

    /** F6 — rodada no modo piano: vê a nota, toca a tecla; guia verde confirma. */
    _sceneF6(svg) {
        const st = this._tutStaff(svg, { top: 18, ls: 9 });
        const status = this._txt(svg, { x: 196, y: 12, 'text-anchor': 'middle', 'font-size': 13, 'font-weight': 'bold', fill: '#475569' }, '?');
        const note = this._tutQnote(svg, '#000');
        const pn = this._tutPiano(svg, { keys: 8, kw: 29, x: 64, y: 80, kh: 44, labels: true });
        const gd = this._tutGuide(svg, '#10b981');
        const finger = this._svg(svg, 'circle', { cx: 335, cy: 142, r: 8, fill: 'rgba(99,102,241,0.35)', stroke: '#6366f1', 'stroke-width': 1.5 });
        const Q = [{ stp: 2, k: 'G4' }, { stp: 5, k: 'C5' }];
        return this._tutLoop({ cycleSec: 3.4,
            schedule: (pass) => [{ at: 1.5, note: Q[pass % 2].k }],
            onPass: (pass) => {
                const q = Q[pass % 2];
                note.at(210, st.yOf(q.stp)); note.paint('#000'); note.fade(1);
                status.textContent = '?'; status.setAttribute('fill', '#475569');
                gd.hide();
            },
            onFrame: (t, pass) => {
                const q = Q[pass % 2];
                const tx = pn.cx(q.k), ty = pn.y + pn.kh * 0.72;
                const p = this._tutClamp01((t - 0.4) / 1.0);
                finger.setAttribute('cx', this._tutLerp(335, tx, p).toFixed(1));
                finger.setAttribute('cy', (this._tutLerp(142, ty, p) - Math.sin(p * Math.PI) * 10).toFixed(1));
                finger.setAttribute('r', (t >= 1.4 && t < 1.7) ? 6 : 8);
                pn.reset();
                if (t >= 1.5) {
                    pn.light(q.k, '#6ee7b7');
                    note.paint('#10b981');
                    status.textContent = '✓ ' + this._tutLabel(q.k);
                    status.setAttribute('fill', '#10b981');
                    gd.set(210, st.yOf(q.stp) + 4, tx, pn.y, 0.75);
                } else gd.hide();
            } });
    }

    /** F7 — bora jogar: notas saltitando + arpejo nas teclas + confete. */
    _sceneF7(svg) {
        const st = this._tutStaff(svg, { top: 16, ls: 8, clefX: 18 });
        const sts = [2, 4, 6], xs = [150, 210, 270];
        const notes = sts.map(() => this._tutQnote(svg, '#000'));
        const pn = this._tutPiano(svg, { keys: 10, kw: 24, x: 60, y: 60, kh: 26, labels: false });
        const burst = this._tutConfetti(svg, 180, 104, ['#FF5A6E', '#fbbf24', '#6366f1', '#10b981', '#c084fc', '#f59e0b']);
        const btn = this._svg(svg, 'g', {});
        this._svg(btn, 'rect', { x: 150, y: 100, width: 60, height: 22, rx: 11, fill: '#6366f1' });
        this._svg(btn, 'path', { d: 'M174,106 L186,111 L174,116 Z', fill: '#fff' });
        const sched = [{ at: 0, note: 'G4' }, { at: 0.2, note: 'B4' }, { at: 0.4, note: 'D5' },
            { at: 0.8, note: 'G4', volume: 0.35 }, { at: 0.8, note: 'B4', volume: 0.35 }, { at: 0.8, note: 'D5', volume: 0.35 }];
        return this._tutLoop({ cycleSec: 2.6, schedule: sched,
            onFrame: (t) => {
                burst(t / 1.1);
                this._tutKeyFlash(pn, t, [
                    { at: 0, key: 'G4', color: '#c7d2fe', dur: 0.3 }, { at: 0.2, key: 'B4', color: '#c7d2fe', dur: 0.3 },
                    { at: 0.4, key: 'D5', color: '#c7d2fe', dur: 0.3 },
                    { at: 0.8, key: 'G4', color: '#a5b4fc', dur: 0.4 }, { at: 0.8, key: 'B4', color: '#a5b4fc', dur: 0.4 },
                    { at: 0.8, key: 'D5', color: '#a5b4fc', dur: 0.4 }
                ]);
                notes.forEach((n, i) => n.at(xs[i], st.yOf(sts[i]) + 2 * Math.sin(t * 2 * Math.PI / 0.65 + i * 1.2)));
                btn.setAttribute('transform', `translate(0,${(-3 * Math.abs(Math.sin(t * Math.PI / 0.65))).toFixed(1)})`);
            } });
    }

    // ========================================================================
    // GUIA PARA INICIANTE — linha tracejada nota → tecla/botão correto
    // ------------------------------------------------------------------------
    // Mesma ideia da guia do tutorial (_tutGuide), mas aqui pauta e área de
    // resposta vivem em SVGs DOM separados. Por isso a linha mora numa CAMADA
    // de overlay por cima da `.staff-reading-game`, e as duas pontas são
    // calculadas em pixels de tela (getBoundingClientRect) a cada desenho.
    // ========================================================================

    /** (Lazy) cria a camada SVG de overlay e a linha; devolve o <svg> ou null. */
    _ensureGuideLayer() {
        const game = this.container && this.container.querySelector('.staff-reading-game');
        if (!game) return null;
        if (this._guideSvg) return this._guideSvg;
        if (getComputedStyle(game).position === 'static') game.style.position = 'relative';
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.style.cssText = 'position:absolute;left:0;top:0;pointer-events:none;z-index:5;overflow:visible;';
        const ln = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        ln.setAttribute('stroke-dasharray', '5,5');
        ln.setAttribute('stroke-width', '2');
        ln.setAttribute('stroke-linecap', 'round');
        ln.setAttribute('opacity', '0');
        svg.appendChild(ln);
        game.appendChild(svg);
        this._guideSvg = svg; this._guideLine = ln; this._guideGame = game;
        return svg;
    }

    /** MIDI da tecla com a ALTURA exata da nota atual, se o piano em tela a tem; senão null. */
    _exactKeyMidi() {
        if (!this.piano || !this.currentNote) return null;
        const midi = this.currentNote.midi;
        return this.piano.keys.has(midi) ? midi : null;
    }

    /**
     * Teclas do piano que respondem pela nota atual: a da altura exata quando existe;
     * senão toda tecla da mesma CLASSE DE ALTURA (a preta, se a nota é alterada; em 'both'
     * há duas oitavas). Vazio sem piano.
     */
    _keysForCurrent() {
        if (!this.piano || !this.currentNote) return [];
        const exact = this._exactKeyMidi();
        if (exact != null) return [exact];
        const pc = this.currentNote.pc;
        return [...this.piano.keys.keys()].filter(m => ((m % 12) + 12) % 12 === pc);
    }

    /** Pisca a(s) tecla(s) certa(s) na correção. */
    _flashCorrectKeys(color, ms) {
        this._keysForCurrent().forEach(m => this.piano.flashKey(m, color, ms));
    }

    /** Elemento alvo da guia: tecla certa (modo piano) ou botão da nota soletrada. */
    _guideTargetEl() {
        if (!this.currentNote) return null;
        if (this.answerMode === 'piano') {
            const keys = this._keysForCurrent();
            return keys.length ? this.piano.keys.get(keys[0]).el : null;
        }
        return this.answersEl.querySelector(`button[data-note="${this.currentNote.id}"]`);
    }

    /**
     * Decide o que a guia deve mostrar AGORA, conforme o modo e o estado:
     *  - 'off'    → escondida;
     *  - 'always' → dica índigo na pergunta; verde na correção (qualquer resposta);
     *  - 'error'  → nada na pergunta; verde na correção SÓ quando errou.
     * Ponto único chamado em apresentar/responder/resize/troca de modo/opções.
     */
    _refreshGuide() {
        // modos de instrumento (mic/MIDI): não há tecla/botão-alvo na tela pra apontar
        if (this.answerMode === 'mic' || this.answerMode === 'midi') { this._hideGuide(); return; }
        if (this._guideMode === 'off') { this._hideGuide(); return; }
        if (!this.answered) {
            if (this._guideMode === 'always') this._drawGuide('#6366f1');
            else this._hideGuide(); // 'error' não dá dica antes de responder
            return;
        }
        const last = this.history[this.history.length - 1];
        const correct = last ? last.correct : true;
        if (this._guideMode === 'error' && correct) { this._hideGuide(); return; }
        this._drawGuide('#10b981'); // correção
    }

    /** Desenha (ou reposiciona) a guia da cabeça da nota até o alvo. */
    _drawGuide(color = '#6366f1') {
        const svg = this._ensureGuideLayer();
        const noteEl = this.renderer && this.renderer.noteEls && this.renderer.noteEls[0];
        const target = this._guideTargetEl();
        if (!svg || !noteEl || !target) { this._hideGuide(); return; }

        const g = this._guideGame.getBoundingClientRect();
        svg.setAttribute('width', g.width);
        svg.setAttribute('height', g.height);

        const n = noteEl.getBoundingClientRect();  // cabeça da nota
        const t = target.getBoundingClientRect();  // tecla/botão
        const ln = this._guideLine;
        ln.setAttribute('x1', (n.left + n.width / 2 - g.left).toFixed(1));
        ln.setAttribute('y1', (n.top + n.height / 2 - g.top).toFixed(1));
        ln.setAttribute('x2', (t.left + t.width / 2 - g.left).toFixed(1));
        ln.setAttribute('y2', (t.top - g.top).toFixed(1));  // topo do alvo
        ln.setAttribute('stroke', color);
        ln.setAttribute('opacity', color === '#6366f1' ? '0.6' : '0.95');
    }

    _hideGuide() {
        if (this._guideLine) this._guideLine.setAttribute('opacity', '0');
    }

    destroy() {
        clearTimeout(this._resizeTimer);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._guideSvg) { this._guideSvg.remove(); this._guideSvg = null; }
        if (this.configPanel) { this.configPanel.destroy(); this.configPanel = null; }
        this._teardownPianoInput();   // solta piano + teclado físico ao trocar de jogo
        if (this.musicStaff) this.musicStaff.destroy();
        super.destroy();
    }
}

// Disponibiliza globalmente
window.StaffReadingGame = StaffReadingGame;



// ============================================
// games/ReadingFlowGame.js
// ============================================
/**
 * ReadingFlowGame - Leitura de Pauta em ESTEIRA (notas rolando da direita p/ a esquerda).
 *
 * É o motor do Jogo de Ritmo INVERTIDO: lá o playhead anda sobre notas paradas;
 * aqui as NOTAS andam (D→E) a velocidade constante sobre uma pauta parada. Mesmo
 * princípio "posição = tempo" (relógio único AudioContext.currentTime). Daí NÃO
 * herda BaseQuizGame (não é quiz turn-based; é loop contínuo, igual ao RhythmGame).
 *
 * Mecânica "ler antes de sumir" (velocidade de leitura):
 *   - notas entram pela direita e deslizam pra esquerda;
 *   - a próxima nota (mais à esquerda) fica DESTACADA (índigo) — você diz o nome dela;
 *   - acertou → verde + soa a altura + sequência++; errou → vermelho + zera;
 *   - cruzou a borda esquerda sem resposta → "passou" (miss), zera a sequência.
 *   - placar SEM pontos arcade: durante a rodada, bolinhas por nota (🟢 acerto /
 *     ⚪ erro / ○ ainda vem) + contador X/N mostram andamento e desempenho; no fim,
 *     PRECISÃO (%) + 1–3 ESTRELAS (STAR_ACC). Estrelas por nível salvas (STARS_KEY),
 *     exibidas no seletor. "Sequência" é só incentivo ao vivo, não vira nota.
 *
 * Resposta: no PIANO (PianoKeyboard com a extensão EXATA do range do nível) ou por BOTÕES
 * com o nome da nota. 🔴 O botão é ANDAIME DO NÍVEL 1 (`answer:'letters'`) e do modo Kids:
 * dizer a letra satura em minutos — o que transfere pro instrumento é pauta→tecla. A
 * preferência salva (rf_input_mode) NUNCA é sobrescrita; o nível só a substitui enquanto
 * vale (_effectiveInput), então quem volta ao nível 1 reencontra os botões.
 *
 * OITAVA (`octave` do nível): o range passa de uma oitava no nível 4 e a mesma LETRA passa
 * a existir em duas alturas no 5 (Mi4 e Mi5). Como o piano cobre exatamente o range, a
 * resposta certa é a TECLA certa — `octave:'exact'` (default). O nível que ESTREIA a
 * repetição num contexto novo usa `octave:'grace'`: letra certa em oitava errada conta
 * como acerto e ensina ("era o Mi de cima"), mas não soma na sequência. Ensinar antes de
 * cobrar — e a regra endurece na virada do nível, nunca no meio da rodada.
 * Trilha completa (mundos 2-5, clave de fá): docs/LEITURA-TRILHA-RODADA2.md.
 *
 * NÍVEIS: catálogo estático (ReadingFlowGame.LEVELS) que cresce aos poucos — começa
 * com 2 notas e vai abrindo o range + acelerando. Progresso (nível desbloqueado mais
 * alto) em localStorage. Camada simples e auto-contida; generalizar p/ uma
 * LevelProgression compartilhada só quando Ritmo/Intervalos também pedirem (composição).
 *
 * KIDS (skin no mesmo jogo, toggle rf_kids): notas grandes coloridas por altura
 * (padrão Boomwhacker), mais devagar, sem mexer na mecânica — só no visual/ritmo.
 * DESMAME POR NOTA (rf_kids_mastery): a muleta que sai POR MÉRITO é a cor da
 * RESPOSTA (piano/botões) — é ela que deixa "casar cor sem ler". Cada letra acumula
 * acertos (_bumpLetter) e caminha 3 estágios (_letterStage): 0 tudo colorido → 1 cor
 * fora da resposta (STAGE_ANSWER_OFF acertos) → 2 formou (STAGE_NOTE_OFF), marco do
 * álbum. 🔴 A cor da NOTA na pauta NUNCA sai: cor = IDENTIDADE da altura, e uma regra
 * que vale só até certo nível não é regra nenhuma pra criança (Mi amarelo virava
 * índigo depois de 12 acertos → "as cores mudaram de nível"). Estado
 * por usuário (StorageScope), automático — sem controle de cor pro pai. O progresso
 * é VISÍVEL no "álbum de notas" (_masteryChips: chips por letra na tela inicial e no
 * modal de resultado); a celebração do "formou" pinta a nota de DOURADO na hora e o
 * texto fica pro modal (toast mid-round tapava a resposta no mobile).
 *
 * FEEDBACK NO KIDS = ANIMAÇÃO, NUNCA COR (NoteFx). Como a cor é identidade nas DUAS
 * superfícies (cabeça da nota e tecla/botão pintados na paleta), acerto/erro não podem
 * repintar nada: ♪ voando = acertou, anel pontilhado = não foi, halo na própria cor =
 * "é este aqui". O mesmo vocabulário na pauta e no piano, de propósito. Fora do Kids
 * segue o verde/vermelho de sempre — lá a superfície não carrega identidade de nota.
 *
 * ERRO QUE ENSINA (_teachMiss): errar/deixar passar acende a resposta certa nos DOIS
 * modos (botões e piano) + "Era X!" no prompt + toca a altura. No Kids o piano recebe a
 * ♪ DESCENDO até a tecla certa (costura "a nota está ali ⇒ toca aqui"). Congela a
 * esteira FREEZE_SEC ("congela-e-ensina"): banda translúcida na linha/espaço da nota
 * + rótulo do nome, na COR da altura. O congelamento desloca o relógio LÓGICO via _pauseOffset
 * (_now/_freeze) — o tempo segue derivando do AudioContext, só muda a origem.
 *
 * Reaproveita MusicStaff (eixo de altura getY) e StaffReadingGenerator.NOTE_TABLE.
 * As cabeças de nota são <g> que TRANSLADAM SÓ NO X (Y absoluto via getY) → o eixo
 * vertical é a altura, o horizontal é o tempo, sem distorcer a notação.
 *
 * 🔴 Relógio: tempo deriva de audioManager.now() (AudioContext.currentTime). rAF só
 * desenha. NUNCA usar setInterval/performance.now p/ o tempo (mesma regra do ritmo).
 */
class ReadingFlowGame {
    static NOTE_ORDER = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];

    // Catálogo de níveis. position: 0=Mi(linha1) … 9=Sol(acima da linha5). Cada nível
    // só amplia o range (= mais notas) e acelera. Mexer AQUI p/ ajustar a curva.
    // `answer`/`octave`/`teachKey` só aparecem onde DIFEREM do DEFAULT_LEVEL.
    static LEVELS = [
        // ---------- MUNDO 1 · Na pauta (Mi4–Sol5, dentro/colado no pentagrama) ----------
        { world: 1, minPos: 0, maxPos: 1, crossSec: 6.0, spawnGap: 2.2, notesPerRound: 12, answer: 'letters' }, // 2 notas — ÚNICO nível de botão
        { world: 1, minPos: 0, maxPos: 2, crossSec: 5.6, spawnGap: 2.1, notesPerRound: 12 }, // 3 · o piano estreia aqui
        { world: 1, minPos: 0, maxPos: 3, crossSec: 5.2, spawnGap: 2.0, notesPerRound: 14 }, // 4
        // 🔴 O gate de conta (AuthGate.FREE_LEVELS=3) cai NESTE nível: de propósito ele só
        // amplia o range (entra o Dó5) — sem letra repetida, sem regra nova, sem modal.
        // O 1º nível jogado depois de criar conta tem que parecer prêmio, não prova.
        { world: 1, minPos: 0, maxPos: 5, crossSec: 4.8, spawnGap: 1.9, notesPerRound: 16 }, // 6
        // 1ª letra repetida da trilha (Mi4 e Mi5) → apresenta a oitava sem cobrá-la.
        { world: 1, minPos: 0, maxPos: 7, crossSec: 4.4, spawnGap: 1.7, notesPerRound: 18, octave: 'grace', teachKey: 'octave' }, // 8
        { world: 1, minPos: 0, maxPos: 9, crossSec: 4.0, spawnGap: 1.6, notesPerRound: 20 }, // 10 (range cheio do mundo 1) — a oitava vale nota

        // ---------- MUNDO 2 · A pauta inteira (linhas suplementares) ----------
        // A nota sai do pentagrama. 🔴 A velocidade RECUA ao entrar no mundo (6.0→5.6 do
        // nível 6 pro 7): conteúdo novo e cronômetro apertado ao mesmo tempo só ensinam
        // frustração. Ela volta a subir dentro do mundo e o mundo 3 é só velocidade.
        { world: 2, minPos: -2, maxPos: 4, crossSec: 5.6, spawnGap: 2.0, notesPerRound: 14, motion: 'step', teachKey: 'ledgerLow' },  // 7 · estreia o Dó central
        { world: 2, minPos: -2, maxPos: 6, crossSec: 5.4, spawnGap: 1.9, notesPerRound: 16, motion: 'mixed' },                        // 8
        { world: 2, minPos: 0, maxPos: 10, crossSec: 5.2, spawnGap: 1.9, notesPerRound: 16, motion: 'mixed', teachKey: 'ledgerHigh' }, // 9 · estreia o Lá agudo
        { world: 2, minPos: -2, maxPos: 10, crossSec: 5.0, spawnGap: 1.8, notesPerRound: 18, motion: 'mixed' },                       // 10 · as duas pontas juntas
        { world: 2, minPos: -2, maxPos: 10, crossSec: 4.6, spawnGap: 1.7, notesPerRound: 20 }                                          // 11 · chefe (motion livre)
    ];

    // Multiplicadores do modo Kids (mais devagar, mais espaçado).
    static KIDS = { crossMul: 1.5, gapMul: 1.35 };

    // Cores por altura (Boomwhacker-ish) — usadas só no modo Kids (associa cor↔nota).
    static KIDS_COLORS = {
        C: '#ef4444', D: '#f97316', E: '#facc15', F: '#22c55e',
        G: '#06b6d4', A: '#8b5cf6', B: '#ec4899'
    };

    static DEFAULT_LEVEL = {
        notesPerRound: 12, crossSec: 6.0, spawnGap: 2.2, firstDelay: 0.8, minPos: 0, maxPos: 1,
        world: 1,         // mundo da trilha (agrupa o seletor e nomeia o tema)
        answer: 'keys',   // superfície de resposta: 'keys' (piano/instrumento) · 'letters' (botão com o nome)
        octave: 'exact',  // 'exact' = tecla certa NA OITAVA certa · 'grace' = ensina sem punir
        motion: 'free'    // salto do sorteio: 'step' (±1 grau) · 'mixed' (±1..3) · 'free' (qualquer)
    };

    // 🔴 `idle` é PRETO, a tinta da notação do projeto: RhythmRenderer grava cabeça/haste/
    // clave em #000, e aqui a clave e as linhas suplementares já eram #000 — a cabeça em
    // ardósia azulada (#334155) fazia a MESMA nota ter duas tintas. Fora do Kids a cor é
    // reservada a ESTADO (próxima=índigo · acerto=verde · erro=vermelho, os mesmos do
    // StaffReadingGame); em repouso, notação parece notação.
    static COLOR = { idle: '#000', next: '#6366f1', hit: '#10b981', miss: '#ef4444' };
    // 🔴 No Kids as cores de COLOR colidem com a paleta de altura (miss #ef4444 É o
    // vermelho do Dó; hit #10b981 é quase o verde do Fá). Lá o estado NÃO é cor
    // NENHUMA: acerto/erro viram ANIMAÇÃO (NoteFx — ♪ voando, anel pontilhado, halo).
    // O único anel que sobra no Kids é o da PRÓXIMA nota, que não é acerto/erro: é
    // "sua vez", marcador de alvo.
    static KIDS_NEXT_RING = { stroke: '#0f172a', width: 3 };
    // Flashes de cor: SÓ fora do Kids (lá a superfície não carrega identidade de nota).
    static ANSWER_FLASH = '#10b981';
    static WRONG_FLASH = '#ef4444';
    static OCTAVE_FLASH = '#f59e0b';   // "quase": letra certa, oitava errada (nem verde nem vermelho)
    static BTN_GRADIENT = 'linear-gradient(135deg,#6366f1,#8b5cf6)'; // repouso do botão de resposta
    // No Kids, botão desmamado NÃO usa o gradiente padrão: o roxo #8b5cf6 é a cor
    // Boomwhacker do Lá — criança treinada em cor leria "tudo virou Lá".
    static KIDS_NEUTRAL_BTN = 'linear-gradient(135deg,#64748b,#475569)';
    static STOP_GRADIENT = 'linear-gradient(135deg,#94a3b8,#64748b)';
    // Inclinação da cabeça de nota (gravura). Entra também no cálculo da meia-largura da
    // linha suplementar — a elipse girada é MAIS larga que rx.
    static HEAD_ANGLE = -18;
    static FREEZE_SEC = 1.5; // congela-e-ensina (Kids): pausa da esteira no erro
    static STARS_KEY = 'reading_flow_stars_v1';        // { levelIdx: melhor nº de estrelas 0..3 }
    static BEST_KEY = 'reading_flow_best_v1';          // melhor take por nível + fila do ranking (LevelProgress)
    static STAR_ACC = [70, 85, 95];                    // % de precisão p/ 1, 2 e 3 estrelas (1★ = já libera)
    static UNLOCKED_KEY = 'reading_flow_unlocked_v1'; // índice do nível mais alto liberado
    static LEVEL_KEY = 'reading_flow_level_v1';       // último nível escolhido
    static INPUT_KEY = 'rf_input_mode';               // 'buttons' | 'piano' — PREFERÊNCIA (o nível pode substituir)
    static TEACH_SEEN_KEY = 'rf_teach_seen_v1';       // { teachKey: 1 } — momentos de ensino já vistos
    // Teclado do PC → brancas do piano em tela: o layout (2 fileiras de 7, `a`=Dó grave,
    // fileira de cima = uma oitava acima) mora em PianoKeyboard.KEYBOARD_ROWS, junto do
    // resto da receita do piano de resposta.
    static KIDS_KEY = 'rf_kids';                       // '1' | '0'
    static MASTERY_KEY = 'rf_kids_mastery';            // { letra: nº de acertos } — desmame por nota
    static UNLOCK_ACC = 70;                             // % de precisão p/ liberar o próximo
    // Desmame por nota (só Kids): a partir de N acertos a cor sai de cada superfície.
    static STAGE_ANSWER_OFF = 5;   // acertos p/ tirar a cor da RESPOSTA (piano/botões)
    static STAGE_NOTE_OFF = 12;    // acertos p/ tirar a cor da NOTA (formou)

    constructor(opts = {}) {
        this.generator = null;
        this.container = null;
        this._levelOverride = opts.level || null; // override p/ testes (nível rápido)

        // preferências / progresso
        this.levelIdx = this._clampLevel(parseInt(localStorage.getItem(window.StorageScope.key(ReadingFlowGame.LEVEL_KEY)) || '0', 10) || 0);
        this.unlocked = Math.max(0, parseInt(localStorage.getItem(window.StorageScope.key(ReadingFlowGame.UNLOCKED_KEY)) || '0', 10) || 0);
        this._reconcileUnlocked();
        if (this.levelIdx > this.unlocked) this.levelIdx = this.unlocked; // nunca bootar acima do liberado
        // Defesa do gate de conta (AuthGate, 1-based): guest não boota acima da fronteira.
        if (window.authGate) this.levelIdx = window.authGate.clampForGuest(this.levelIdx + 1) - 1;
        this._inputPref = this._storedInputPref();  // preferência do jogador (nunca sobrescrita pelo nível)
        this.kids = localStorage.getItem(ReadingFlowGame.KIDS_KEY) === '1';
        this.mastery = this._loadMastery();   // { letra: nº de acertos } — desmame por nota
        if (this.levelIdx > this.unlocked) this.levelIdx = this.unlocked;
        this.level = this._levelConfig(this.levelIdx);
        this.inputMode = this._effectiveInput(); // depende de level + kids: fica DEPOIS dos dois

        // refs de DOM
        this.staffContainer = null;
        this.musicStaff = null;
        this.notesLayer = null;
        this.hudEl = null;
        this.promptEl = null;
        this.answersEl = null;
        this.extraEl = null;
        this.resultsEl = null;
        this.piano = null;
        this.keyboard = null;   // teclado físico (só no modo piano)
        this.mic = null;        // MicPitchInput (só no modo mic; criado no start da rodada)
        this.micPanel = null;   // MicStatusPanel
        this.midi = null;       // MidiPitchInput (só no modo midi; irmão do mic)
        this.midiPanel = null;  // MicStatusPanel (compartilhado com o mic)

        this._geo = null;

        // relógio / loop
        this._raf = null;
        this._startTime = 0;
        this._running = false;
        this._ended = false;
        this._destroyed = false;
        this._removeTimers = [];
        this._cross = this.level.crossSec; // velocidade efetiva (kids multiplica)

        // congela-e-ensina: o relógio lógico desconta pausas (_pauseOffset) e, durante
        // o congelamento, devolve o instante travado (_frozenT) — rAF segue desenhando.
        this._pauseOffset = 0;
        this._frozenUntilReal = 0;
        this._frozenT = 0;
        this._teachEls = [];      // overlay didático do erro (1 por vez)
        this._stopArmed = false;  // 1º toque no Parar só "arma" (anti-misclick)

        // esteira
        this.active = [];
        this._spawnTimes = [];
        this._spawnIdx = 0;

        // placar (sem pontos arcade — ver _renderHud/_showResults)
        this.combo = 0;          // sequência de acertos (incentivo ao vivo)
        this.maxCombo = 0;
        this.hits = 0;
        this.resolved = 0;
        this._outcomes = [];     // ['hit'|'miss', …] na ordem de resolução → bolinhas de andamento
        this._reactSec = [];     // tempo de resposta dos ACERTOS (s) → desempate do ranking
        this._formedThisRound = []; // letras que "formaram" na rodada → celebradas no MODAL
        this.starsByLevel = this._loadStars();  // { levelIdx: melhor nº de estrelas }
    }

    // ---------- estrelas por nível ----------

    _loadStars() {
        try {
            const raw = localStorage.getItem(window.StorageScope.key(ReadingFlowGame.STARS_KEY));
            const obj = raw ? JSON.parse(raw) : {};
            return (obj && typeof obj === 'object') ? obj : {};
        } catch { return {}; }
    }

    /** Nº de estrelas (0..3) para uma precisão %. 1★ = mesmo limiar que libera o nível. */
    _starsFor(acc) {
        const [s1, s2, s3] = ReadingFlowGame.STAR_ACC;
        return acc >= s3 ? 3 : acc >= s2 ? 2 : acc >= s1 ? 1 : 0;
    }

    _bestStars(levelIdx) { return this.starsByLevel[levelIdx] | 0; }

    /** Guarda as estrelas do nível se superarem o recorde. Retorna true se melhorou. */
    _saveBestStars(levelIdx, stars) {
        if (stars > this._bestStars(levelIdx)) {
            this.starsByLevel[levelIdx] = stars;
            localStorage.setItem(window.StorageScope.key(ReadingFlowGame.STARS_KEY), JSON.stringify(this.starsByLevel));
            return true;
        }
        return false;
    }

    /** "★★☆" p/ n estrelas (3 posições). vazio=false → só as cheias (sem as ocas). */
    _starStr(n, filledOnly = false) {
        const full = '★'.repeat(Math.max(0, Math.min(3, n)));
        return filledOnly ? full : full + '☆'.repeat(3 - Math.max(0, Math.min(3, n)));
    }

    _clampLevel(i) { return Math.max(0, Math.min(ReadingFlowGame.LEVELS.length - 1, i)); }

    /**
     * Nível escolhido, LIDO DIRETO DO STORAGE (estático): a RankingScreen precisa saber
     * "onde o jogador está" sem instanciar o jogo. Mesma leitura do construtor.
     */
    static storedLevelIdx() {
        try {
            const raw = localStorage.getItem(window.StorageScope.key(ReadingFlowGame.LEVEL_KEY));
            const i = parseInt(raw || '0', 10) || 0;
            return Math.max(0, Math.min(ReadingFlowGame.LEVELS.length - 1, i));
        } catch (e) { return 0; }
    }

    _levelConfig(i) { return Object.assign({}, ReadingFlowGame.DEFAULT_LEVEL, ReadingFlowGame.LEVELS[this._clampLevel(i)], this._levelOverride || {}); }

    /**
     * Re-deriva `unlocked` dos MELHORES takes salvos (LevelProgress). Existe por um buraco
     * do desbloqueio: ele só é gravado no fim da rodada e com `!isLast` — quem passou o
     * ÚLTIMO nível da trilha nunca teve o próximo liberado, porque não havia próximo. Ao
     * acrescentar níveis, essa pessoa abriria o jogo com o nível seguinte trancado.
     * É a regra de sempre aplicada a um recorde que a pessoa JÁ TEM — nunca rebaixa
     * (só sobe) e não dá nível a quem não passou.
     */
    _reconcileUnlocked() {
        try {
            const prog = window.LevelProgress && window.LevelProgress.get('leitura');
            if (!prog) return;
            const bests = prog.getBests();     // { "<nível 1-based>": { acc, passed, … } }
            const last = ReadingFlowGame.LEVELS.length - 1;
            Object.keys(bests).forEach((k) => {
                const level = parseInt(k, 10);          // 1-based
                if (!Number.isFinite(level) || level < 1) return;
                const rec = bests[k] || {};
                const passed = rec.passed === true || (Number.isFinite(rec.acc) && rec.acc >= ReadingFlowGame.UNLOCK_ACC);
                if (!passed) return;
                // passou o nível 1-based N ⇒ o índice 0-based do próximo é N
                this.unlocked = Math.min(last, Math.max(this.unlocked, level));
            });
            localStorage.setItem(window.StorageScope.key(ReadingFlowGame.UNLOCKED_KEY), String(this.unlocked));
        } catch (e) { /* storage indisponível: segue com o unlocked lido */ }
    }

    // ---------- superfície de resposta ----------

    /** Preferência salva, já filtrada pelo SUPORTE do ambiente ('mic' exige getUserMedia +
     *  secure context; 'midi' exige Web MIDI, ausente no iOS). Sem suporte → botões. */
    _storedInputPref() {
        const im = localStorage.getItem(ReadingFlowGame.INPUT_KEY);
        if (im === 'piano') return 'piano';
        if (im === 'mic' && window.MicPitchInput && window.MicPitchInput.isSupported()) return 'mic';
        if (im === 'midi' && window.MidiPitchInput && window.MidiPitchInput.isSupported()) return 'midi';
        return 'buttons';
    }

    /** Botão com o NOME da nota: só onde o nível declara (`answer:'letters'`) e no Kids,
     *  onde a muleta sai por MÉRITO (desmame por nota), não por nível. */
    _buttonsAllowed(levelIdx = this.levelIdx) {
        return this.kids || this._levelConfig(levelIdx).answer === 'letters';
    }

    /** Modo EFETIVO = preferência, trocada por piano onde o botão não vale. A preferência
     *  em si nunca é reescrita: voltando ao nível 1, os botões reaparecem sozinhos. */
    _effectiveInput() {
        return (this._inputPref === 'buttons' && !this._buttonsAllowed()) ? 'piano' : this._inputPref;
    }

    // ---------- piano de resposta ----------
    //
    // 🔴 A RECEITA mora no PianoKeyboard (estáticos `responseRange` / `rowsFor` /
    // `keyMapFor`), não aqui: o jogo de música real precisa exatamente da mesma, e duas
    // cópias um dia divergiriam — a divergência apareceria como "neste jogo a tecla `a`
    // é outra nota". O que é DESTE jogo e fica aqui é só a tradução "posição na pauta →
    // altura MIDI", que só existe porque a Leitura sorteia por posição.

    /** Extensão do piano: do Dó igual/abaixo do grave do nível até o agudo dele. */
    _pianoRange() {
        const T = window.StaffReadingGenerator.NOTE_TABLE;
        const PU = window.PitchUtil;
        const lo = T[String(this.level.minPos)];
        const hi = T[String(this.level.maxPos)];
        return window.PianoKeyboard.responseRange(
            PU.midiFromSci((lo && lo.sci) || 'E4'),
            PU.midiFromSci((hi && hi.sci) || 'F4'));
    }

    _pianoRows(minSci, maxSci) {
        return window.PianoKeyboard.rowsFor(minSci, maxSci);
    }

    /**
     * Mapa tecla-do-PC → nota. Sem ele o teclado físico ficaria preso a C4–C5
     * (`KeyboardInput.DEFAULT_MAP`) e não alcançaria a oitava de cima — que é justamente o
     * que o nível 5 em diante cobra. O `reading-flow-test` mantém o invariante "toda nota
     * sorteável tem tecla" e falha se um nível novo estourar as fileiras.
     */
    _levelKeyMap() {
        const { minSci, maxSci } = this._pianoRange();
        return window.PianoKeyboard.keyMapFor(minSci, maxSci);
    }

    // ---------- momentos de ensino ----------

    _teachSeen() {
        try {
            const raw = localStorage.getItem(window.StorageScope.key(ReadingFlowGame.TEACH_SEEN_KEY));
            const o = raw ? JSON.parse(raw) : {};
            return (o && typeof o === 'object') ? o : {};
        } catch { return {}; }
    }

    _markTeachSeen(key) {
        try {
            const o = this._teachSeen();
            o[key] = 1;
            localStorage.setItem(window.StorageScope.key(ReadingFlowGame.TEACH_SEEN_KEY), JSON.stringify(o));
        } catch (e) { /* sem persistência: no pior caso o modal reaparece */ }
    }

    /**
     * Modal de UMA FRASE antes da 1ª rodada de um nível que estreia regra nova. Roda no
     * máximo uma vez por chave (StorageScope ⇒ por usuário). Sem chave, ou já visto,
     * chama `next()` na hora — o caminho normal do jogo não ganha um passo.
     */
    _maybeTeach(key, next) {
        if (!key || this._teachSeen()[key] || !window.notifications) { next(); return; }
        // 🔴 `modal()` DERRUBA o modal aberto: com o login em tela (retomada pós-OAuth do
        // AuthGate) isto engoliria o formulário. Sai sem marcar como visto — a lição volta
        // na próxima abertura, o login não volta.
        if (window.notifications.isModalOpen()) { next(); return; }
        this._markTeachSeen(key);
        // Continuação SÓ no onClose (que o botão dispara ao fechar): botão, ✕, ESC e
        // clique-fora levam ao mesmo lugar, e o guarda impede rodada dupla.
        let went = false;
        const go = () => { if (went) return; went = true; next(); };
        window.notifications.modal({
            title: this._t('readingFlow.teach.' + key + '.title'),
            html: `<p style="margin:0;font-size:1.05rem;line-height:1.5;color:#334155;text-align:center;">${this._t('readingFlow.teach.' + key + '.text')}</p>`,
            actions: [{ label: this._t('readingFlow.teach.got'), style: 'primary' }],
            onClose: go
        });
    }

    // ---------- desmame por nota (Kids) ----------

    /** Lê o mapa de mestria { letra: nº de acertos } do StorageScope. Tolerante a lixo. */
    _loadMastery() {
        try {
            const raw = localStorage.getItem(window.StorageScope.key(ReadingFlowGame.MASTERY_KEY));
            const obj = raw ? JSON.parse(raw) : {};
            return (obj && typeof obj === 'object') ? obj : {};
        } catch { return {}; }
    }

    _saveMastery() {
        localStorage.setItem(window.StorageScope.key(ReadingFlowGame.MASTERY_KEY), JSON.stringify(this.mastery));
    }

    _letterHits(letter) { return this.mastery[letter] | 0; }

    /** Estágio de desmame da letra: 0 = tudo colorido · 1 = só a nota colorida
     *  (resposta neutra) · 2 = formou (neutro). */
    _letterStage(letter) {
        const h = this._letterHits(letter);
        if (h >= ReadingFlowGame.STAGE_NOTE_OFF) return 2;
        if (h >= ReadingFlowGame.STAGE_ANSWER_OFF) return 1;
        return 0;
    }

    /** Conta um acerto na letra e persiste. Retorna o limiar recém-cruzado
     *  ('answer' | 'note') ou null — usado p/ repintar/celebrar em tempo real (Fase 2/3). */
    _bumpLetter(letter) {
        const before = this._letterStage(letter);
        this.mastery[letter] = this._letterHits(letter) + 1;
        this._saveMastery();
        const after = this._letterStage(letter);
        if (before < 1 && after === 1) return 'answer';
        if (before < 2 && after === 2) return 'note';
        return null;
    }

    /** Mapa letra→cor Boomwhacker p/ a RESPOSTA (piano/botões), só nas letras ainda
     *  no estágio 0. Letras ≥1 ficam de fora → paintByLetter as devolve ao branco.
     *  Null fora do Kids. */
    _answerColorMap() {
        if (!this.kids) return null;
        const map = {};
        for (const letter of Object.keys(ReadingFlowGame.KIDS_COLORS)) {
            if (this._letterStage(letter) === 0) map[letter] = ReadingFlowGame.KIDS_COLORS[letter];
        }
        return map;
    }

    /** Repinta a superfície de resposta de UMA letra AO VIVO (quando ela desmama a
     *  resposta no meio da rodada). Piano: repinta o mapa todo (barato). Botões:
     *  devolve o botão da letra ao gradiente índigo padrão. */
    _refreshAnswerColorFor(letter) {
        if (!this.kids) return;
        if (this.inputMode === 'piano') {
            if (this.piano) this.piano.paintByLetter(this._answerColorMap());
        } else if (this.answersEl) {
            const btn = this.answersEl.querySelector(`[data-letter="${letter}"]`);
            if (btn) btn.style.background = this._btnBaseBg(letter);
        }
    }

    /** True (só Kids) quando TODAS as notas do nível atual já formaram (estágio 2):
     *  a criança responde sem depender da cor no botão/piano. */
    _levelFullyWeaned() {
        if (!this.kids || !this.generator) return false;
        const letters = this.generator.possibleLetters();
        return letters.length > 0 && letters.every((l) => this._letterStage(l) === 2);
    }

    /** Zera o desmame por nota → todas as cores voltam. Muleta de novo do zero
     *  (troca de criança no device, demonstração…). Não toca em nível/best. */
    _resetMastery() {
        this.mastery = {};
        localStorage.removeItem(window.StorageScope.key(ReadingFlowGame.MASTERY_KEY));
    }

    /** Letra "formou" (desmame completo). O toast no meio da rodada tapava os botões
     *  de resposta no mobile e roubava a atenção da próxima nota → agora a celebração
     *  acontece NO OBJETO (a nota que acertou fica DOURADA) e a festa com texto fica
     *  pro modal de resultado (_formedThisRound), a pausa natural. */
    _celebrateLetter(letter, note) {
        this._formedThisRound.push(letter);
        if (note && note.head) {
            note.head.setAttribute('fill', '#f59e0b');
            note.head.setAttribute('stroke', '#b45309');
            note.head.setAttribute('stroke-width', '2');
            if (note.stem) note.stem.setAttribute('stroke', '#f59e0b');
        }
    }

    /** Mapa letra→cor do botão em repouso (fonte única — flashes restauram por aqui). */
    _btnBaseBg(letter) {
        if (this.kids) {
            return this._letterStage(letter) === 0
                ? ReadingFlowGame.KIDS_COLORS[letter]
                : ReadingFlowGame.KIDS_NEUTRAL_BTN;
        }
        return ReadingFlowGame.BTN_GRADIENT;
    }

    /** Pisca um botão de nota (modo botões) e devolve à cor de repouso. */
    _flashBtn(letter, color, ms) {
        if (!this.answersEl) return;
        const btn = this.answersEl.querySelector(`[data-letter="${letter}"]`);
        if (!btn) return;
        btn.style.background = color;
        const tm = setTimeout(() => { if (btn.isConnected) btn.style.background = this._btnBaseBg(letter); }, ms);
        this._removeTimers.push(tm);
    }

    /** Mensagem temporária no prompt (ex.: "Era Sol!"), volta ao prompt padrão depois. */
    _flashPrompt(msg, color, ms) {
        if (!this.promptEl) return;
        this.promptEl.textContent = msg;
        this.promptEl.style.color = color;
        const tm = setTimeout(() => {
            if (!this._running || !this.promptEl) return;
            this.promptEl.textContent = this._t('readingFlow.prompt');
            this.promptEl.style.color = '#6366f1';
        }, ms);
        this._removeTimers.push(tm);
    }

    async init(container) {
        this.container = container;
        this._applyLevelToGenerator();
        this.setupUI();
        this._buildStaff();
        this._showStartScreen();

        // Retomada pós-OAuth (AuthGate): seleciona o nível pretendido (o _selectLevel
        // já clampa ao desbloqueado re-lido da conta).
        if (window.authGate) {
            const it = window.authGate.takeIntentFor('staffReading');
            if (it) this._selectLevel(it.levelNum - 1);
        }

        this._teachVeteranOctave();

        // O progresso da conta pode chegar DEPOIS da tela montada (uma volta de rede após
        // o login). Sem isto o seletor seguiria mostrando cadeado num nível que a conta já
        // tem. Só redesenha parado: no meio da rodada, remontar tiraria notas da tela.
        this._onProgressRestored = () => {
            if (this._running || this._destroyed) return;
            this.unlocked = Math.max(0, parseInt(localStorage.getItem(window.StorageScope.key(ReadingFlowGame.UNLOCKED_KEY)) || '0', 10) || 0);
            this._showStartScreen();
        };
        document.addEventListener('progressRestored', this._onProgressRestored);

        this._onResize = () => {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => this._buildStaff(true), 150);
        };
        window.addEventListener('resize', this._onResize);
    }

    /**
     * Quem já passou do nível 5 antes da oitava passar a valer nunca cruzaria o momento de
     * ensino — a regra mudaria embaixo dele, no meio de um nível que ele já tinha vencido.
     * Aqui a lição chega uma vez no boot, a quem está acima dela. Único ponto em que um
     * `teachKey` dispara fora do seu nível; nada é revogado (estrelas/recordes/desbloqueio
     * ficam como estão) — a regra frouxa foi um erro nosso, não dele.
     */
    _teachVeteranOctave() {
        const idx = ReadingFlowGame.LEVELS.findIndex(l => l.teachKey === 'octave');
        if (idx < 0 || this.unlocked <= idx) return;   // ainda vai passar pelo nível: deixa o modal pra lá
        this._maybeTeach('octave', () => {});
    }

    _applyLevelToGenerator() {
        this.generator = new window.StaffReadingGenerator({
            minPos: this.level.minPos, maxPos: this.level.maxPos, motion: this.level.motion
        });
    }

    // ---------- UI ----------

    setupUI() {
        const mobile = (window.innerWidth || 1024) < 560;
        const pad = mobile ? '0.75rem' : '1.5rem';
        this.container.innerHTML = `
            <div class="reading-flow-game${this.kids ? ' rf-kids' : ''}" style="max-width:900px;margin:0 auto;padding:${pad};overflow-x:hidden;">
                <h1 class="game-h1" style="text-align:center;margin-bottom:0.2rem;">${this._t('readingFlow.title')}</h1>
                <div class="game-intro" style="display:flex;align-items:center;justify-content:center;gap:0.1rem;margin:0.2rem auto 0.6rem;max-width:560px;">
                    <p style="text-align:center;color:#555;margin:0;font-size:0.95rem;">${this._t('readingFlow.subtitle')}</p>
                </div>
                <div id="rf-hud" style="display:flex;justify-content:center;gap:0.6rem;flex-wrap:wrap;margin:0.4rem 0;"></div>
                <div id="rf-staff" style="margin:0.8rem auto;max-width:100%;overflow:hidden;position:relative;"></div>
                <p id="rf-prompt" style="text-align:center;color:#6366f1;font-weight:600;min-height:1.4rem;margin:0.3rem 0;"></p>
                <div id="rf-answers" style="text-align:center;margin:0.6rem 0;"></div>
                <div id="rf-extra" style="text-align:center;margin-bottom:0.5rem;"></div>
                <div id="rf-results" style="display:none;"></div>
            </div>`;

        // 🔴 O "?" de estreia vai na linha do SUBTÍTULO, NUNCA no h1: `.game-h1` é
        // `display:none` abaixo de 560px (styles.css) — some justo no CELULAR, que
        // é onde a ajuda se julga.
        if (window.HelpDot) {
            window.HelpDot.attach(this.container.querySelector('.game-intro'), 'flow.howto');
        }

        this.staffContainer = this.container.querySelector('#rf-staff');
        this.hudEl = this.container.querySelector('#rf-hud');
        this.promptEl = this.container.querySelector('#rf-prompt');
        this.answersEl = this.container.querySelector('#rf-answers');
        this.extraEl = this.container.querySelector('#rf-extra');
        this.resultsEl = this.container.querySelector('#rf-results');

        this._renderHud();
    }

    _hudCell(label, value, color) {
        return `<div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:0.35rem 0.8rem;min-width:84px;text-align:center;">
                <div style="font-size:0.7rem;color:#64748b;text-transform:uppercase;letter-spacing:0.03em;">${label}</div>
                <div style="font-size:1.15rem;font-weight:800;color:${color};">${value}</div>
            </div>`;
    }

    /** Uma bolinha por nota da rodada: 🟢 acerto · ⚪ erro/passou · ○ ainda vem.
     *  Serve de barra de andamento E de retrato de desempenho ao vivo. */
    _progressDots() {
        const total = this.level.notesPerRound;
        let s = '';
        for (let i = 0; i < total; i++) {
            const o = this._outcomes[i];
            // miss em vermelho suave: distinguível do "ainda vem" (anel cinza) a 11px
            const bg = o === 'hit' ? '#10b981' : o === 'miss' ? '#fca5a5' : 'transparent';
            const ring = o === 'hit' ? bg : o === 'miss' ? '#f87171' : '#cbd5e1';
            s += `<span style="display:inline-block;width:11px;height:11px;border-radius:50%;background:${bg};box-shadow:inset 0 0 0 1.6px ${ring};"></span>`;
        }
        return s;
    }

    /** Bloco de andamento: rótulo "ANDAMENTO X/N" + fileira de bolinhas. */
    _progressHud() {
        const total = this.level.notesPerRound;
        return `<div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:0.35rem 0.8rem;text-align:center;">
                <div style="font-size:0.7rem;color:#64748b;text-transform:uppercase;letter-spacing:0.03em;">${this._t('readingFlow.progress')} ${this.resolved}/${total}</div>
                <div style="display:flex;gap:4px;justify-content:center;flex-wrap:wrap;margin-top:0.3rem;max-width:260px;">${this._progressDots()}</div>
            </div>`;
    }

    _renderHud() {
        const hot = this.combo >= 2; // sequência só "acende" a partir de 2 (incentivo, não nota)
        this.hudEl.innerHTML =
            this._hudCell(this._t('readingFlow.level'), this.levelIdx + 1, '#0f172a') +
            this._progressHud() +
            this._hudCell(this._t('readingFlow.combo'), (hot ? '🔥 ' : '') + this.combo, hot ? '#f59e0b' : '#0f172a');
    }

    /** Tela inicial: seletor de nível + opções (entrada/kids) + botão começar. */
    _showStartScreen() {
        this.promptEl.textContent = '';
        this.promptEl.style.color = '#6366f1';
        this.hudEl.style.display = 'none'; // HUD ("0/12", "Sequência 0") só faz sentido rodando
        this.resultsEl.style.display = 'none';
        this.resultsEl.innerHTML = '';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';

        // ação principal (answersEl): só o botão Começar.
        const btn = this._makeButton(this._t('readingFlow.start'), 'linear-gradient(135deg,#10b981,#059669)', () => this.start());
        this.answersEl.appendChild(btn);

        // secundário (extraEl): seletor de nível + opções (entrada/kids).
        this.extraEl.appendChild(this._buildLevelPicker());
        this.extraEl.appendChild(this._buildOptionsRow());
        // Quem preferia os botões e subiu de nível merece saber por que eles sumiram —
        // troca silenciosa de interface parece bug.
        if (this._inputPref === 'buttons' && !this._buttonsAllowed()) {
            const note = document.createElement('p');
            note.textContent = this._t('readingFlow.buttonsLocked');
            note.style.cssText = 'text-align:center;color:#64748b;font-size:0.8rem;margin:0.5rem auto 0;max-width:420px;line-height:1.4;';
            this.extraEl.appendChild(note);
        }
        if (this.kids) {
            this.extraEl.appendChild(this._buildKidsHint());
            this.extraEl.appendChild(this._buildMasteryMap());
        }
        this.extraEl.appendChild(this._buildCrossLink());
    }

    /** Álbum de notas (só Kids): um chip por letra do nível — cheio colorido
     *  (aprendendo), contorno colorido (já responde sem a cor no botão), + ⭐ (formou).
     *  A cor da letra NUNCA sai do chip, espelhando a pauta: o que muda é o preenchimento.
     *  Torna o desmame VISÍVEL pro adulto ("o Fá ainda tem cor no botão"), sem toggle. */
    _masteryChips() {
        const letters = this.generator ? this.generator.possibleLetters() : [];
        const base = 'display:inline-flex;align-items:center;justify-content:center;min-width:42px;height:30px;padding:0 9px;border-radius:999px;font-weight:800;font-size:0.8rem;';
        return letters.map((l) => {
            const st = this._letterStage(l);
            const c = ReadingFlowGame.KIDS_COLORS[l] || '#64748b';
            const name = this._noteName(l);
            if (st === 0) return `<span style="${base}background:${c};color:#fff;">${name}</span>`;
            if (st === 1) return `<span style="${base}background:#fff;border:2px solid ${c};color:${c};">${name}</span>`;
            return `<span style="${base}background:#fff;border:2px solid ${c};color:${c};">${name} ⭐</span>`;
        }).join('');
    }

    _masteryMapHTML() {
        return `<div class="rf-mastery" style="text-align:center;margin-top:0.8rem;">
            <div style="font-size:0.7rem;color:#64748b;text-transform:uppercase;letter-spacing:0.03em;margin-bottom:0.35rem;">${this._t('readingFlow.masteryTitle')}</div>
            <div style="display:flex;gap:6px;justify-content:center;flex-wrap:wrap;">${this._masteryChips()}</div>
        </div>`;
    }

    _buildMasteryMap() {
        const tmp = document.createElement('div');
        tmp.innerHTML = this._masteryMapHTML();
        return tmp.firstElementChild;
    }

    /** Linha de reforço (só Kids): explica ONDE a cor some (nos botões/piano) e que na
     *  pauta ela fica — a regra "cor = nota" precisa valer sempre. */
    _buildKidsHint() {
        const p = document.createElement('p');
        // Nível todo aprendido → vira comemoração ("é vitória, não bug"), senão a
        // dica normal de que a cor sai da resposta conforme se aprende.
        const done = this._levelFullyWeaned();
        p.textContent = this._t(done ? 'readingFlow.kidsAllLearned' : 'readingFlow.kidsColorHint');
        p.style.cssText = `text-align:center;color:${done ? '#059669' : '#b45309'};font-size:0.82rem;margin:0.6rem auto 0;max-width:360px;font-weight:${done ? '700' : '400'};`;
        return p;
    }

    /** Link p/ o jogo irmão: "✏️ Treino livre" → #/leitura-livre (1 nota, sem pressão de tempo).
        Espelha o _buildCrossLink do Ritmo (navega pela ROTA). */
    _buildCrossLink() {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'margin-top:1rem;text-align:center;';
        const link = document.createElement('button');
        link.type = 'button';
        link.className = 'rhythm-crosslink';
        link.textContent = this._t('readingFlow.toFreeMode');
        link.addEventListener('click', () => { window.location.hash = '#/leitura-livre'; });
        wrap.appendChild(link);
        // "Trilha × livre" é a dúvida que o chip levanta: ele oferece a troca sem
        // dizer o que muda. Mesmo tópico nos jogos que têm o par.
        if (window.HelpDot) window.HelpDot.attach(wrap, 'app.freeMode');
        return wrap;
    }

    /** Botões de nível 1..N agrupados POR MUNDO (cadeado nos não liberados). Cada botão
     *  traz, embaixo, as MELHORES estrelas já tiradas naquele nível (senso de progresso).
     *
     *  🔴 O agrupamento não é enfeite: numa fila só, a trilha vira uma tira de números sem
     *  significado assim que passa de ~8 níveis — e ela vai a 22. O mundo dá o nome do que
     *  se aprende ali ("A pauta inteira") e transforma a fila em mapa. Mundo cujo primeiro
     *  nível está trancado aparece de cadeado, sem revelar o conteúdo. */
    _buildLevelPicker() {
        const outer = document.createElement('div');
        outer.style.cssText = 'display:flex;flex-direction:column;gap:0.5rem;margin-bottom:0.8rem;';

        const worlds = [];
        ReadingFlowGame.LEVELS.forEach((lv, i) => {
            const w = (lv.world || 1);
            let bucket = worlds.find(b => b.world === w);
            if (!bucket) { bucket = { world: w, items: [] }; worlds.push(bucket); }
            bucket.items.push({ lv, i });
        });

        worlds.forEach(({ world, items }) => {
            const firstIdx = items[0].i;
            const sealed = firstIdx > this.unlocked;   // mundo inteiro ainda trancado

            const head = document.createElement('div');
            head.style.cssText = `text-align:center;font-size:0.7rem;font-weight:700;letter-spacing:0.4px;
                text-transform:uppercase;color:${sealed ? '#cbd5e1' : '#94a3b8'};`;
            head.textContent = sealed
                ? `🔒 ${this._t('readingFlow.worldLabel', { n: world })}`
                : `${this._t('readingFlow.worldLabel', { n: world })} · ${this._t('readingFlow.worlds.' + world)}`;
            outer.appendChild(head);

            const wrap = this._buildLevelRow(items);
            outer.appendChild(wrap);
        });


        // 🔴 O "?" do portão vai colado a um RÓTULO, como todo "?" do sistema (§1:
        // "sempre à direita do rótulo do grupo"). Solto sob a grade ele caía em três
        // posições diferentes — e em Acordes chegava a ler como um NÍVEL a mais, do
        // mesmo tamanho e forma dos cadeados. Um "?" sem rótulo não responde "ajuda
        // sobre o quê?", e quem tem 70 anos não toca no que não tem nome.
        const gateRow = document.createElement('div');
        gateRow.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:0.1rem;margin-top:0.2rem;';
        const gateLab = document.createElement('span');
        gateLab.textContent = (window.language ? window.language.t('help.levelsLabel') : 'Níveis:');
        gateLab.style.cssText = 'color:#64748b;font-size:0.9rem;';
        gateRow.appendChild(gateLab);
        if (window.HelpDot) window.HelpDot.attach(gateRow, 'app.levelGate');
        outer.appendChild(gateRow);
        return outer;
    }

    /** Uma fileira de botões de nível (os itens de um mundo). */
    _buildLevelRow(items) {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'display:flex;justify-content:center;gap:0.4rem;flex-wrap:wrap;';
        items.forEach(({ lv, i }) => {
            const locked = i > this.unlocked;
            const active = i === this.levelIdx;

            const col = document.createElement('div');
            col.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:2px;';

            const b = document.createElement('button');
            b.type = 'button';
            b.textContent = locked ? '🔒' : String(i + 1);
            b.disabled = locked;
            const notes = lv.maxPos - lv.minPos + 1;
            b.title = locked ? this._t('readingFlow.locked') : `${this._t('readingFlow.level')} ${i + 1} · ${notes} ${this._t('readingFlow.notesWord')}`;
            b.style.cssText = `width:42px;height:42px;border-radius:10px;font-weight:800;font-size:1rem;cursor:${locked ? 'not-allowed' : 'pointer'};
                border:2px solid ${active ? '#6366f1' : '#e2e8f0'};
                background:${active ? 'linear-gradient(135deg,#6366f1,#8b5cf6)' : '#fff'};
                color:${active ? '#fff' : locked ? '#cbd5e1' : '#334155'};`;
            if (!locked) b.addEventListener('click', () => this._selectLevel(i));
            col.appendChild(b);

            // estrelas do nível (só nos liberados): cheias douradas, ocas cinza
            const stars = document.createElement('div');
            stars.style.cssText = 'font-size:0.62rem;letter-spacing:0.5px;line-height:1;height:0.7rem;';
            const n = this._bestStars(i);
            stars.innerHTML = locked ? '' :
                `<span style="color:#f59e0b;">${'★'.repeat(n)}</span><span style="color:#e2e8f0;">${'☆'.repeat(3 - n)}</span>`;
            col.appendChild(stars);

            wrap.appendChild(col);
        });
        return wrap;
    }

    /** Contexto deste jogo pro AuthGate (route = retomada pós-OAuth, que perde o hash). */
    _gateCtx() { return { gameId: 'staffReading', route: '#/leitura' }; }

    _selectLevel(i) {
        // Gate de conta (nível 4+ anônimo): este método é o choke point (chips chamam
        // direto) — bloqueado → modal abre e nada muta; o login retoma re-chamando aqui.
        if (window.authGate && !window.authGate.allow(i + 1, this._gateCtx(), () => this._selectLevel(i))) return;
        // Clampa ao desbloqueado re-lido do STORAGE (os chips confiavam só no disabled):
        // login no meio troca o escopo e a memória fica stale — a conta pode ter
        // progresso MENOR que o guest tinha; nunca selecionar nível trancado nela.
        this.unlocked = Math.max(0, parseInt(localStorage.getItem(window.StorageScope.key(ReadingFlowGame.UNLOCKED_KEY)) || '0', 10) || 0);
        this.levelIdx = Math.min(this._clampLevel(i), this.unlocked);
        localStorage.setItem(window.StorageScope.key(ReadingFlowGame.LEVEL_KEY), String(this.levelIdx));
        this.level = this._levelConfig(this.levelIdx);
        this.inputMode = this._effectiveInput(); // o nível manda na superfície de resposta
        this._applyLevelToGenerator();
        this._renderHud();
        this._showStartScreen();
    }

    /** Linha de opções: entrada (Botões/Piano) + Kids. */
    _buildOptionsRow() {
        const row = document.createElement('div');
        row.style.cssText = 'display:flex;justify-content:center;gap:1.2rem;flex-wrap:wrap;align-items:center;margin-top:0.4rem;font-size:0.9rem;';

        // entrada
        const inWrap = document.createElement('div');
        // 🔴 `flex-wrap` aqui não é enfeite: com 4 entradas (Botões/Piano/Mic/MIDI) a
        // linha já media 366 px num celular de 390, e o "?" de 44 px a levava a 422 —
        // "Responder" saía cortado à esquerda e "MIDI" à direita, dentro de um
        // `overflow-x:hidden` (some sem barra de rolagem e sem erro nenhum). Com a
        // quebra, o grupo desce em vez de vazar; abaixo do limite nada muda.
        inWrap.style.cssText = 'display:inline-flex;gap:0.3rem;align-items:center;'
            + 'flex-wrap:wrap;justify-content:center;max-width:100%;';
        const inLabel = document.createElement('span');
        inLabel.textContent = this._t('readingFlow.input') + ':';
        inLabel.style.color = '#64748b';
        inWrap.appendChild(inLabel);
        // Um "?" para a FILA inteira de entradas: a dúvida é "qual dos quatro?",
        // e essa pergunta é do grupo — quatro "?" seriam quatro vezes o mesmo texto.
        if (window.HelpDot) window.HelpDot.attach(inWrap, 'flow.input');
        // Botão-com-o-nome aparece SEMPRE na lista, mas trancado fora do nível 1: sumir
        // sem explicação faria a pessoa achar que o jogo perdeu uma opção.
        const btnLocked = !this._buttonsAllowed();
        const inputItems = [
            ['buttons', (btnLocked ? '🔒 ' : '') + this._t('readingFlow.inputButtons'), btnLocked],
            ['piano', this._t('readingFlow.inputPiano')]
        ];
        // entradas de instrumento — cada uma só onde o ambiente suporta
        if (window.MicPitchInput && window.MicPitchInput.isSupported()) {
            inputItems.push(['mic', this._t('readingFlow.inputMic')]);
        }
        if (window.MidiPitchInput && window.MidiPitchInput.isSupported()) {
            inputItems.push(['midi', this._t('readingFlow.inputMidi')]);
        }
        inWrap.appendChild(this._segToggle(inputItems, this.inputMode, (v) => {
            if (v === 'buttons' && !this._buttonsAllowed()) {
                if (window.notifications) window.notifications.toast(this._t('readingFlow.buttonsLocked'), { duration: 3200 });
                return;
            }
            this._inputPref = v;
            localStorage.setItem(ReadingFlowGame.INPUT_KEY, v);
            this.inputMode = this._effectiveInput();
            this._showStartScreen();
        }));
        row.appendChild(inWrap);

        // kids
        const kBtn = document.createElement('button');
        kBtn.type = 'button';
        kBtn.textContent = (this.kids ? '🧸 ' : '') + this._t('readingFlow.kids') + (this.kids ? ' ✓' : '');
        kBtn.style.cssText = `padding:0.45rem 0.9rem;border-radius:999px;font-weight:700;cursor:pointer;font-size:0.9rem;
            border:2px solid ${this.kids ? '#f59e0b' : '#e2e8f0'};
            background:${this.kids ? '#fef3c7' : '#fff'};color:${this.kids ? '#b45309' : '#475569'};`;
        kBtn.addEventListener('click', () => {
            this.kids = !this.kids;
            localStorage.setItem(ReadingFlowGame.KIDS_KEY, this.kids ? '1' : '0');
            this.inputMode = this._effectiveInput(); // Kids devolve os botões em qualquer nível
            this.container.querySelector('.reading-flow-game').classList.toggle('rf-kids', this.kids);
            this._showStartScreen();
        });
        // O "?" do Kids vai num invólucro junto do botão: solto na `row` o gap de
        // 1.2rem o afastaria e ele pareceria pertencer ao controle seguinte.
        const kWrap = document.createElement('div');
        kWrap.style.cssText = 'display:inline-flex;gap:0.15rem;align-items:center;';
        kWrap.appendChild(kBtn);
        if (window.HelpDot) window.HelpDot.attach(kWrap, 'flow.kids');
        row.appendChild(kWrap);

        // reset de cores (só Kids): traz a muleta de volta do zero. Útil ao trocar
        // de criança no device ou pra demonstrar. Confirma antes de apagar.
        if (this.kids) {
            const rBtn = document.createElement('button');
            rBtn.type = 'button';
            rBtn.textContent = this._t('readingFlow.kidsReset');
            rBtn.style.cssText = `padding:0.45rem 0.9rem;border-radius:999px;font-weight:700;cursor:pointer;font-size:0.9rem;
                border:2px solid #e2e8f0;background:#fff;color:#475569;`;
            rBtn.addEventListener('click', () => {
                if (!window.confirm(this._t('readingFlow.kidsResetConfirm'))) return;
                this._resetMastery();
                this._showStartScreen();
            });
            row.appendChild(rBtn);
        }

        // som: piano realista (preferência GLOBAL). Ligar baixa o banco C3–C6 sob
        // demanda (cacheado pelo Service Worker → instantâneo na volta). O progresso
        // aparece no próprio botão; sem modal. Vale pros 3 jogos melódicos.
        const am = window.audioManager;
        if (am && am.setPianoRealistic) {
            const pBtn = document.createElement('button');
            pBtn.type = 'button';
            const paint = (txt, on) => {
                pBtn.textContent = txt;
                pBtn.style.cssText = `padding:0.45rem 0.9rem;border-radius:999px;font-weight:700;cursor:pointer;font-size:0.9rem;
                    border:2px solid ${on ? '#6366f1' : '#e2e8f0'};
                    background:${on ? '#e0e7ff' : '#fff'};color:${on ? '#4338ca' : '#475569'};`;
            };
            const onLabel = () => '🎹 ' + this._t('readingFlow.realPiano') + (am.isPianoRealistic() ? ' ✓' : '');
            paint(onLabel(), am.isPianoRealistic());
            pBtn.addEventListener('click', () => {
                const next = !am.isPianoRealistic();
                am.setPianoRealistic(next);
                if (next && !am.isPianoBankReady()) {
                    pBtn.disabled = true;
                    am.loadPianoBank(({ progress }) => paint('🎹 ' + this._t('readingFlow.loadingPiano') + ' ' + progress + '%', true))
                        .then(() => { pBtn.disabled = false; paint(onLabel(), true); })
                        .catch(() => { pBtn.disabled = false; paint(onLabel(), am.isPianoRealistic()); });
                } else {
                    paint(onLabel(), next);
                }
            });
            row.appendChild(pBtn);
        }

        // (Removido o toggle Automático/Sempre/Desligado: o desmame agora é por nota,
        //  automático — ver _letterStage/_bumpLetter. Sem controle de cor pro pai.)

        return row;
    }

    /** Toggle segmentado simples (lista [valor,label], valor atual, callback). */
    _segToggle(items, current, onChange) {
        const seg = document.createElement('div');
        seg.dataset.segmented = '1';   // a régua de alvo do reading-flow-test mede por aqui (como interval/chord)
        seg.style.cssText = 'display:inline-flex;border:2px solid #e2e8f0;border-radius:999px;overflow:hidden;';
        items.forEach(([val, label, locked]) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.textContent = label;
            const on = val === current;
            // Trancado ≠ desabilitado: o clique ainda passa, pra poder EXPLICAR o porquê.
            // 🔴 `min-height:44px`: este é o MESMO widget de IntervalGame._segToggle e
            // ChordGame._segToggle, que ganharam o piso no bloco A (01/set) com a medição
            // "saía com 29px — metade do alvo, e logo ao lado de um '?' de 44px". A Leitura
            // ficou para trás e continuou em 29px até 07/set, quando a simulação em Chrome
            // real a 390px voltou a medir. Cópia de widget que recebe conserto em duas das
            // QUATRO casas (SongReadingGame era a 4ª, achada só na auditoria de deploy)
            // não é dívida — é regressão por omissão.
            // 🔴 O piso é de ALTURA, nunca de largura: a linha "Responder com:" mora num
            // `overflow-x:hidden` (`:591`) que corta em silêncio, e foi +44px de LARGURA
            // que estourou 366→422 numa reforma anterior (AJUDA-CONTEXTUAL-PLANO §10.2).
            b.style.cssText = `padding:0.4rem 0.85rem;min-height:44px;border:none;cursor:pointer;font-weight:700;font-size:0.85rem;
                background:${on ? '#6366f1' : 'transparent'};color:${on ? '#fff' : locked ? '#94a3b8' : '#475569'};`;
            b.addEventListener('click', () => onChange(val));
            seg.appendChild(b);
        });
        return seg;
    }

    /** Painel de status ativo (mic ou MIDI); null nos modos botões/piano. */
    _instrumentPanel() { return this.micPanel || this.midiPanel; }

    /** Solta piano + teclado físico + microfone + MIDI (mic.destroy() apaga o
     *  indicador de gravação do browser e midi.destroy() solta a assinatura —
     *  crítico ao parar/trocar de jogo). */
    _teardownInputDevices() {
        if (this.keyboard) { this.keyboard.destroy(); this.keyboard = null; }
        if (this.piano) { this.piano.destroy(); this.piano = null; }
        if (this.mic) { this.mic.destroy(); this.mic = null; }
        if (this.micPanel) { this.micPanel.destroy(); this.micPanel = null; }
        if (this.midi) { this.midi.destroy(); this.midi = null; }
        if (this.midiPanel) { this.midiPanel.destroy(); this.midiPanel = null; }
    }

    /** Cria (1x) e liga o MicPitchInput — chamado a partir do gesto do "Começar". */
    _startMic() {
        if (!this.mic) {
            this.mic = new window.MicPitchInput({
                onKeyPress: (info) => this.answer(info.letter, info),
                onStateChange: (s) => { if (this.micPanel) this.micPanel.setState(s); },
                onFrame: (f) => { if (this.micPanel) this.micPanel.frame(f); }
            });
        }
        this.mic.start();
    }

    /** Cria (1x) e liga o MidiPitchInput — irmão do _startMic, mesmo contrato. */
    _startMidi() {
        if (!this.midi) {
            this.midi = new window.MidiPitchInput({
                onKeyPress: (info) => this.answer(info.letter, info),
                onStateChange: (s) => {
                    // no 'listening' o nome do teclado plugado entra no status
                    if (this.midiPanel) this.midiPanel.setState(s, s === 'listening' ? this.midi.getDeviceName() : null);
                },
                onFrame: (f) => { if (this.midiPanel) this.midiPanel.frame(f); }
            });
        }
        this.midi.start();
    }

    _buildInput() {
        this.answersEl.innerHTML = '';
        this._teardownInputDevices();

        if (this.inputMode === 'piano') {
            // Extensão = range do nível: a tecla certa está em tela, e só ela (oitava).
            const { minSci, maxSci } = this._pianoRange();
            this.piano = new window.PianoKeyboard(this.answersEl, {
                minSci, maxSci,
                rows: this._pianoRows(minSci, maxSci),
                labelFn: (info) => this._noteName(info.letter),
                onKeyPress: (info) => this.answer(info.letter, info)
            });
            this.piano.render();
            this.piano.setEnabled(true);
            // Kids: pinta as teclas com a cor da altura só nas letras ainda no estágio 0
            // (não desmamadas). Letras formadas ficam brancas.
            if (this.kids) this.piano.paintByLetter(this._answerColorMap());

            // teclado físico do PC → mesmo answer() do piano. O mapa acompanha o range
            // do nível (o default do KeyboardInput para em C5 e não alcançaria a oitava
            // de cima, que é o que o nível 5 em diante cobra).
            this.keyboard = new window.KeyboardInput({
                piano: this.piano,
                keyMap: this._levelKeyMap(),
                onKeyPress: (info) => this.answer(info.letter, info)
            });
            this.keyboard.enable();
        } else if (this.inputMode === 'mic') {
            this.micPanel = new window.MicStatusPanel(this.answersEl, {
                t: (k) => this._t('micInput.' + k),
                noteLabel: (info) => this._noteName(info.letter),
                onActivate: () => this._startMic(),
                onFallback: () => {
                    // Instrumento indisponível → volta pra preferência mais simples, mas
                    // quem manda no que aparece segue sendo o nível (_effectiveInput).
                    this._inputPref = 'buttons';
                    localStorage.setItem(ReadingFlowGame.INPUT_KEY, 'buttons');
                    this.inputMode = this._effectiveInput();
                    this._buildInput();
                }
            });
            this.micPanel.render();
            this._startMic(); // o clique no "Começar" é o gesto que autoriza o pedido
        } else if (this.inputMode === 'midi') {
            this.midiPanel = new window.MicStatusPanel(this.answersEl, {
                t: (k) => this._t('midiInput.' + k),
                noteLabel: (info) => this._noteName(info.letter),
                meterScale: 100, // velocity já vem 0..1 (o mic manda RMS, minúsculo)
                onActivate: () => this._startMidi(),
                onFallback: () => {
                    // Instrumento indisponível → volta pra preferência mais simples, mas
                    // quem manda no que aparece segue sendo o nível (_effectiveInput).
                    this._inputPref = 'buttons';
                    localStorage.setItem(ReadingFlowGame.INPUT_KEY, 'buttons');
                    this.inputMode = this._effectiveInput();
                    this._buildInput();
                }
            });
            this.midiPanel.render();
            this._startMidi(); // o clique no "Começar" é o gesto que autoriza o pedido
        } else {
            ReadingFlowGame.NOTE_ORDER.forEach((letter) => {
                // cor de repouso via _btnBaseBg: cor-muleta (estágio 0), neutro Kids
                // (desmamada — cinza, NUNCA o gradiente roxo ≈ cor do Lá) ou padrão.
                const btn = this._makeButton(this._noteName(letter), this._btnBaseBg(letter), () => this.answer(letter));
                btn.dataset.letter = letter;
                btn.style.minWidth = '60px';
                if (this.kids) {
                    btn.style.fontSize = '1.3rem';
                    btn.style.padding = '1rem 1.3rem';
                }
                this.answersEl.appendChild(btn);
            });
        }

        // Botão Parar. Fica logo abaixo das respostas → margem extra + "two-tap"
        // (1º toque arma, 2º confirma) pra dedo de criança não matar a rodada sem querer.
        this.extraEl.innerHTML = '';
        this._stopArmed = false;
        const stopLabel = () => '⏹ ' + this._t('readingFlow.stop');
        const stop = this._makeButton(stopLabel(), ReadingFlowGame.STOP_GRADIENT, () => {
            if (this.resolved > 0 && !this._stopArmed) {
                this._stopArmed = true;
                stop.textContent = '⏹ ' + this._t('readingFlow.stopConfirm');
                stop.style.background = 'linear-gradient(135deg,#ef4444,#b91c1c)';
                const tm = setTimeout(() => {
                    if (this._stopArmed && this._running && stop.isConnected) {
                        this._stopArmed = false;
                        stop.textContent = stopLabel();
                        stop.style.background = ReadingFlowGame.STOP_GRADIENT;
                    }
                }, 2600);
                this._removeTimers.push(tm);
                return;
            }
            this.stop();
        }, { small: true });
        stop.style.marginTop = '1.3rem';
        this.extraEl.appendChild(stop);
    }

    // ---------- pauta + geometria ----------

    /** (Re)cria pauta, clave, linha de saída e camada de notas. Recalcula a geometria. */
    _buildStaff(reRender = false) {
        const measured = this.staffContainer ? this.staffContainer.clientWidth : 0;
        const w = Math.max(280, Math.floor(measured || window.innerWidth || 800));
        const mobile = w < 560;
        const ls = 12;
        const marginLeft = mobile ? 40 : 70;
        // A nota nasce EM cima de area.endX: a margem tem de caber a meia-largura da
        // linha suplementar (Kids ≈15px), senão a ponta do tracinho nasce cortada.
        const marginRight = 18;
        const marginTop = 56;
        const clefSpace = mobile ? 40 : 60;

        if (this.musicStaff) this.musicStaff.destroy();
        this.musicStaff = new window.MusicStaff(this.staffContainer, {
            width: w, height: 150, lineSpacing: ls, marginLeft, marginRight, marginTop
        });
        this.musicStaff.drawLines();

        const svg = this.musicStaff.svg;
        const area = this.musicStaff.getDrawArea();

        // Clave de Sol (glifo Bravura, fallback serif) — sobre a 2ª linha (Sol).
        const clef = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        clef.setAttribute('x', area.startX + ls * 0.3);
        clef.setAttribute('y', this.musicStaff.getY(2) + ls * 0.2);
        clef.setAttribute('font-size', ls * 4.4);
        clef.setAttribute('font-family', "Bravura, 'Times New Roman', serif");
        clef.setAttribute('fill', '#000');
        clef.textContent = '𝄞';
        svg.appendChild(clef);

        // Geometria da esteira: notas entram em spawnX (direita) e somem em leftLimit.
        const leftLimit = area.startX + clefSpace;
        const spawnX = area.endX;
        this._geo = { leftLimit, spawnX, travel: Math.max(60, spawnX - leftLimit), ls };

        // Linha de saída (zona de "perigo" à esquerda).
        const exit = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        exit.setAttribute('x1', leftLimit); exit.setAttribute('x2', leftLimit);
        exit.setAttribute('y1', this.musicStaff.getY(10)); exit.setAttribute('y2', this.musicStaff.getY(-2));
        exit.setAttribute('stroke', '#fca5a5'); exit.setAttribute('stroke-width', '2');
        exit.setAttribute('stroke-dasharray', '4,4'); exit.setAttribute('opacity', '0.7');
        svg.appendChild(exit);

        // Camada das notas (por cima das linhas/clave).
        this.notesLayer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        svg.appendChild(this.notesLayer);

        // Resize durante o jogo: recria os <g> das notas vivas na nova geometria.
        if (reRender && this._running) {
            this.active.forEach((n) => { if (!n.resolved) this._makeNoteEls(n); });
        }
    }

    /** Cria os elementos SVG de uma nota e os pendura na camada (transladam só no X). */
    _makeNoteEls(note) {
        const y = this.musicStaff.getY(note.pos);
        const stemUp = note.pos < 4;
        const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        const { rx, ry } = this._headSize();

        // linhas suplementares (fora da pauta) — em X absoluto dentro do grupo (≈0)
        if (note.pos < 0) {
            for (let p = -2; p >= note.pos; p -= 2) g.appendChild(this._ledger(p));
        } else if (note.pos > 9) {
            for (let p = 10; p <= note.pos; p += 2) g.appendChild(this._ledger(p));
        }

        const head = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
        head.setAttribute('cx', 0); head.setAttribute('cy', y);
        head.setAttribute('rx', rx); head.setAttribute('ry', ry);
        head.setAttribute('transform', `rotate(${ReadingFlowGame.HEAD_ANGLE} 0 ${y})`);

        const stem = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        const sx = stemUp ? rx - 0.7 : -(rx - 0.7);
        stem.setAttribute('x1', sx); stem.setAttribute('x2', sx);
        stem.setAttribute('y1', stemUp ? y - 1 : y + 1);
        stem.setAttribute('y2', stemUp ? y - 28 : y + 28);
        stem.setAttribute('stroke-width', this.kids ? '2.2' : '1.6');

        g.appendChild(head); g.appendChild(stem);
        this.notesLayer.appendChild(g);

        note.g = g; note.head = head; note.stem = stem;
        this._paintState(note, 'idle');
        return note;
    }

    /** Tamanho da cabeça de nota (Kids = maior). Fonte única: desenho E linha suplementar. */
    _headSize() {
        return this.kids ? { rx: 9.5, ry: 7.0 } : { rx: 6.7, ry: 4.8 };
    }

    _ledger(pos) {
        const y = this.musicStaff.getY(pos);
        const { rx, ry } = this._headSize();
        // Meia-largura derivada da cabeça: no Kids (cabeça gorda) o tracinho fixo de 10px
        // ficava ESCONDIDO embaixo dela e a nota boiava sem referência. Ver MusicStaff.
        const half = window.MusicStaff.ledgerHalfWidth(
            this.musicStaff.config.lineSpacing, rx, ry, ReadingFlowGame.HEAD_ANGLE);
        const ln = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        ln.setAttribute('x1', -half); ln.setAttribute('x2', half);
        ln.setAttribute('y1', y); ln.setAttribute('y2', y);
        ln.setAttribute('stroke', '#000');
        ln.setAttribute('stroke-width', this.kids ? '1.4' : '1');
        return ln;
    }

    /** Pinta a nota conforme o estado lógico (idle/next/hit/miss). 🔴 No Kids a cabeça
     *  é SEMPRE a cor da altura (Boomwhacker), em TODO estágio e TODO nível — cor é
     *  identidade da nota, não recompensa; acerto/erro NÃO pintam nada (viram animação,
     *  ver _fxHit/_fxMiss). Só 'next' marca o alvo com um anel escuro. Fora do Kids nada
     *  muda: o próprio fill é o estado. */
    _paintState(note, state) {
        note.state = state;
        const kidColor = this.kids ? ReadingFlowGame.KIDS_COLORS[note.letter] : null;
        const color = kidColor || ReadingFlowGame.COLOR[state];
        const ring = state !== 'next' ? null
            : (kidColor ? ReadingFlowGame.KIDS_NEXT_RING : { stroke: '#3730a3', width: 2 });
        if (note.head) {
            note.head.setAttribute('fill', color);
            note.head.setAttribute('stroke', ring ? ring.stroke : 'none');
            note.head.setAttribute('stroke-width', ring ? String(ring.width) : '0');
        }
        if (note.stem) note.stem.setAttribute('stroke', color);
    }

    // ---------- feedback do Kids: animação, nunca cor ----------

    /** X atual da nota na esteira (o <g> translada só em X; ver o loop). */
    _noteX(note) {
        const tr = note.g && note.g.getAttribute('transform');
        const m = tr && /translate\(([-\d.]+)/.exec(tr);
        return m ? parseFloat(m[1]) : (this._geo ? this._geo.spawnX : 0);
    }

    /** Camada de fx da PAUTA (por cima das notas, dentro do SVG da pauta). */
    _staffFx() {
        return (window.NoteFx && this.musicStaff) ? window.NoteFx.layer(this.musicStaff.svg) : null;
    }

    /** Acerto (Kids): ♪ ♫ ♬ sobem da cabeça, na cor da nota. */
    _fxHit(note) {
        if (!this.kids || !window.NoteFx) return;
        window.NoteFx.flyNotes(this._staffFx(), this._noteX(note), this.musicStaff.getY(note.pos),
            ReadingFlowGame.KIDS_COLORS[note.letter] || '#64748b', { rise: 42, ceil: 6 });
    }

    /** Erro (Kids): anel pontilhado neutro pulsa 1× + tremor SÓ em X (Y é a altura!). */
    _fxMiss(note) {
        if (!this.kids || !window.NoteFx) return;
        window.NoteFx.dottedRing(this._staffFx(), this._noteX(note), this.musicStaff.getY(note.pos), 17);
        if (note.g) window.NoteFx.shakeX(note.g, 4);
    }

    /** Feedback na superfície de RESPOSTA (piano ou botões), Kids: camada, nunca fill. */
    _fxAnswer(letter, kind, midi) {
        if (!window.NoteFx) return;
        if (this.inputMode === 'piano' && this.piano) {
            // 🔴 Com o piano de 2 oitavas a LETRA é ambígua: as variantes `*Letter` caem
            // sempre na tecla mais grave, então errar um Mi5 mandava a ♪ pousar no Mi4 —
            // ensinando exatamente a confusão que o nível veio desfazer. Com o midi em
            // mãos, aponta a tecla exata; sem ele (botões), a letra ainda serve.
            const exact = Number.isFinite(midi) && this.piano.keys && this.piano.keys.has(midi);
            if (kind === 'teach') exact ? this.piano.fxTeach(midi) : this.piano.fxTeachLetter(letter);
            else if (kind === 'hit') exact ? this.piano.fxHit(midi) : this.piano.fxHitLetter(letter);
            else exact ? this.piano.fxMiss(midi) : this.piano.fxMissLetter(letter);
            return;
        }
        const btn = this.answersEl && this.answersEl.querySelector(`[data-letter="${letter}"]`);
        if (!btn) return;
        const color = ReadingFlowGame.KIDS_COLORS[letter] || '#64748b';
        if (kind === 'miss') { window.NoteFx.dottedEl(btn); window.NoteFx.shakeX(btn, 3); }
        else window.NoteFx.haloEl(btn, color, kind === 'teach' ? 3 : 1);
    }

    // ---------- loop / relógio ----------

    /** @param {{skipTeach?:boolean}} [opts] skipTeach = a lição já foi resolvida nesta volta. */
    start(opts = {}) {
        // 🔴 `_destroyed`: o destroy() fecha o modal aberto, e o onClose do modal de ensino
        // chama de volta aqui. Sem esta guarda a instância MORTA ficava com `_running:true`
        // e abria uma rodada fantasma no funil (roundOpen seguido de roundClose('quit')).
        if (this._running || this._destroyed) return;
        // Regra nova estreando neste nível → uma frase ANTES de a esteira andar. Já vista
        // (ou nível sem estreia) não custa nem um frame: _maybeTeach chama de volta na hora.
        //
        // 🔴 `skipTeach` na continuação, NUNCA `() => this.start()` puro: quando o
        // _maybeTeach desiste de ensinar (modal de login em tela) ele chama a continuação
        // SEM marcar a chave como vista — reentrar aqui reavaliaria a mesma condição, com o
        // mesmo modal aberto, para sempre. Era recursão infinita: RangeError engolido pelo
        // try/catch do AuthGate e tela morta logo depois de um cadastro.
        if (!opts.skipTeach && this.level.teachKey && !this._teachSeen()[this.level.teachKey]) {
            this._maybeTeach(this.level.teachKey, () => this.start({ skipTeach: true }));
            return;
        }
        window.audioManager && window.audioManager.resumeContext();

        // reset placar/esteira
        this._clearActive();
        this.combo = 0; this.maxCombo = 0; this.hits = 0; this.resolved = 0; this._outcomes = [];
        this._reactSec = [];
        this._formedThisRound = [];
        this._pauseOffset = 0; this._frozenUntilReal = 0; this._frozenT = 0;
        this._stopArmed = false;
        this._ended = false;
        this._spawnIdx = 0;
        this.hudEl.style.display = 'flex'; // HUD só durante a rodada (escondido na tela inicial)

        const L = this.level;
        const crossMul = this.kids ? ReadingFlowGame.KIDS.crossMul : 1;
        const gapMul = this.kids ? ReadingFlowGame.KIDS.gapMul : 1;
        this._cross = L.crossSec * crossMul;
        const gap = L.spawnGap * gapMul;
        this._spawnTimes = [];
        for (let i = 0; i < L.notesPerRound; i++) this._spawnTimes.push(L.firstDelay + i * gap);

        this.resultsEl.style.display = 'none';
        this.resultsEl.innerHTML = '';
        this._renderHud();
        this._buildInput();
        this.promptEl.textContent = this._t('readingFlow.prompt');

        // Funil (Fase 3b): abre a rodada. Nível 1-BASED; nível sintético (teste) vai sem
        // nível, pelo mesmo motivo que fica fora do ranking. Best-effort.
        if (window.Beacon) window.Beacon.roundOpen(this._levelOverride ? null : this.levelIdx + 1);

        this._running = true;
        this._startTime = window.audioManager ? window.audioManager.now() : (performance.now() / 1000);
        this._loop();
    }

    /** Para a rodada no meio e volta à tela inicial (não conta como concluído). */
    stop() {
        if (!this._running) return;
        this._running = false;
        // Funil (Fase 3b): parou no meio = abandono (é o único jogo com botão de parar).
        if (window.Beacon) window.Beacon.roundClose('quit');
        if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
        this._clearActive();
        this._teardownInputDevices();
        this.combo = 0; this.hits = 0; this.resolved = 0; this._outcomes = []; this._reactSec = [];
        this._renderHud();
        this._showStartScreen();
    }

    _rawNow() {
        return window.audioManager ? window.audioManager.now() : (performance.now() / 1000);
    }

    _isFrozen() { return this._rawNow() < this._frozenUntilReal; }

    /** Tempo LÓGICO da rodada. Continua derivando do AudioContext (regra vermelha),
     *  mas desconta as pausas didáticas: durante o congelamento devolve o instante
     *  travado; depois, o offset acumulado faz tudo retomar sem pulo. */
    _now() {
        if (this._isFrozen()) return this._frozenT;
        return this._rawNow() - this._startTime - this._pauseOffset;
    }

    /** Congela a esteira por dur segundos (congela-e-ensina do erro no Kids).
     *  rAF segue desenhando; spawns/timeouts param junto porque o t lógico trava. */
    _freeze(dur) {
        if (this._isFrozen()) return;
        const real = this._rawNow();
        this._frozenT = real - this._startTime - this._pauseOffset;
        this._frozenUntilReal = real + dur;
        this._pauseOffset += dur;
    }

    _loop() {
        if (!this._running) return;
        const t = this._now();
        const L = this.level, geo = this._geo;

        // 1) spawn das notas no horário
        while (this._spawnIdx < L.notesPerRound && t >= this._spawnTimes[this._spawnIdx]) {
            this._spawnNote(this._spawnTimes[this._spawnIdx]);
            this._spawnIdx++;
        }

        // 2) posição (progresso no tempo → X) + timeout
        let next = null, bestProg = -1;
        for (const n of this.active) {
            if (n.resolved) continue;
            const prog = (t - n.spawnAt) / this._cross;
            const x = geo.spawnX - prog * geo.travel;
            n.g.setAttribute('transform', `translate(${x.toFixed(1)},0)`);
            if (prog >= 1) { this._resolve(n, 'timeout'); continue; }
            if (prog > bestProg) { bestProg = prog; next = n; }
        }

        // 3) destaca a próxima (a mais à esquerda)
        for (const n of this.active) {
            if (n.resolved) continue;
            this._paintState(n, n === next ? 'next' : 'idle');
        }

        this._raf = requestAnimationFrame(() => this._loop());
    }

    _spawnNote(spawnAt) {
        const data = this.generator.generate();
        const note = { pos: data.position, letter: data.letter, sci: data.sci, spawnAt, resolved: false };
        this._makeNoteEls(note);
        note.g.setAttribute('transform', `translate(${this._geo.spawnX},0)`);
        this.active.push(note);
    }

    // ---------- resposta / placar ----------

    answer(letter, info) {
        if (!this._running) return;
        if (this._isFrozen()) return; // congela-e-ensina: momento de OLHAR, não de responder
        // alvo = próxima nota (maior progresso / mais à esquerda) ainda não resolvida
        const t = this._now();
        let target = null, bestProg = -1;
        for (const n of this.active) {
            if (n.resolved) continue;
            const prog = (t - n.spawnAt) / this._cross;
            if (prog > bestProg) { bestProg = prog; target = n; }
        }
        if (!target) return;

        // Resposta certa = LETRA certa e, onde o nível cobra, na OITAVA certa. `info` só
        // existe quando a resposta veio de uma superfície com altura real (piano, teclado
        // do PC, mic, MIDI); o botão diz apenas a letra e por isso nunca é cobrado na
        // oitava — ele só existe no nível 1 e no Kids, onde a oitava ainda não entrou.
        const letterOk = letter === target.letter;
        const octaveKnown = !!(info && info.sci);
        const octaveOk = !octaveKnown || info.sci === target.sci;
        const graceMode = this.level.octave === 'grace';
        // Oitava errada com a letra certa: erro no 'exact', ACERTO que ensina no 'grace'.
        const octaveSlip = letterOk && octaveKnown && !octaveOk;
        const hit = letterOk && (octaveOk || graceMode);
        // Tempo de resposta do acerto (desde o spawn), no relógio LÓGICO — o congelamento
        // do "erro que ensina" já saiu de `t` (_now), então pausa didática não vira lentidão.
        if (hit) this._reactSec.push(Math.max(0, t - target.spawnAt));

        // Escorregão de oitava do nível 'exact': o _teachMiss precisa saber que a LETRA
        // estava certa pra dizer a coisa certa ("era o de cima", não "era Mi"). Sempre
        // reatribuído — nunca sobra estado de uma resposta anterior.
        this._octaveSlip = (octaveSlip && !graceMode) ? info : null;
        if (octaveSlip && graceMode) this._teachOctave(target, info);

        // feedback na superfície TOCADA (a resposta CERTA é acesa em _teachMiss, igual
        // nos dois modos). 🔴 No Kids a superfície CARREGA IDENTIDADE (tecla/botão pintado
        // na cor da nota) → nada de repintar: halo/pontilhado por cima (NoteFx). Fora do
        // Kids segue o verde/vermelho de sempre, onde não há colisão.
        // Tecla TOCADA: verde no acerto, vermelho no erro e ÂMBAR no "quase" (letra certa,
        // oitava errada, nível de graça) — verde nela diria "era esta", que é falso.
        const touchColor = (octaveSlip && hit) ? ReadingFlowGame.OCTAVE_FLASH
            : hit ? ReadingFlowGame.ANSWER_FLASH : ReadingFlowGame.WRONG_FLASH;
        if (this.kids && !this._instrumentPanel()) {
            // midi da tecla REALMENTE tocada (quando a resposta tem altura) — no piano de
            // 2 oitavas o efeito tem de acender onde o dedo encostou, não na outra oitava.
            this._fxAnswer(letter, hit ? 'hit' : 'miss', info && info.midi);
        } else if (this.inputMode === 'piano' && this.piano && info) {
            this.piano.flashKey(info.midi, touchColor, 1000);
        } else if (this._instrumentPanel() && info) {
            // análogo do flashKey: a nota tocada (ouvida ou MIDI) pinta de
            // verde/vermelho no painel de status
            this._instrumentPanel().flash(info, hit);
        } else if (this.inputMode === 'buttons' && !hit) {
            this._flashBtn(letter, ReadingFlowGame.WRONG_FLASH, 700);
        }

        this._resolve(target, hit ? (octaveSlip ? 'graceHit' : 'hit') : 'wrong');
    }

    /** Acende a tecla CERTA: a exata (mesma oitava) quando ela está no teclado em tela,
     *  senão a letra. 🔴 Onde a letra se repete, `flashByLetter` acenderia as DUAS —
     *  ensinaria justamente a ambiguidade que este nível veio desfazer. */
    _flashCorrectKey(note, color, ms) {
        if (!this.piano) return;
        const midi = this._midiOf(note);
        if (Number.isFinite(midi) && this.piano.keys && this.piano.keys.has(midi)) this.piano.flashKey(midi, color, ms);
        else this.piano.flashByLetter(note.letter, color, ms);
    }

    /** Midi da nota da esteira (a altura REAL, com oitava). null se o PitchUtil faltar. */
    _midiOf(note) {
        const m = (window.PitchUtil && note && note.sci) ? window.PitchUtil.midiFromSci(note.sci) : null;
        return Number.isFinite(m) ? m : null;
    }

    /** "Quase": letra certa, oitava errada, no nível que APRESENTA a oitava (`grace`).
     *  Vale o ponto, mostra a tecla certa e diz onde ela estava — sem vermelho e sem
     *  mexer na sequência. É a diferença entre ensinar e cobrar. */
    _teachOctave(note, info) {
        // 🔴 No Kids a tecla CARREGA a identidade da nota: `flashKey` repinta o fill, e o
        // verde do acerto É a cor do Fá. Lá o sinal vai pela camada de fx (♪ + halo na
        // própria cor), como manda a regra do modo. Fora do Kids segue o verde de sempre.
        if (this.kids) this._fxAnswer(note.letter, 'teach', this._midiOf(note));
        else this._flashCorrectKey(note, ReadingFlowGame.ANSWER_FLASH, 1100);
        const midi = window.PitchUtil ? window.PitchUtil.midiFromSci(note.sci) : null;
        const higher = Number.isFinite(midi) && info && midi > info.midi;
        this._flashPrompt(
            this._t(higher ? 'readingFlow.octaveUp' : 'readingFlow.octaveDown', { note: this._noteName(note.letter) }),
            '#d97706', 1500
        );
    }

    _resolve(note, outcome) {
        if (note.resolved) return;
        note.resolved = true;
        this.resolved++;

        let hold = 0; // quanto segurar a nota na pauta antes do fade (momento didático)
        if (outcome === 'hit' || outcome === 'graceHit') {
            this.hits++;
            // 'graceHit' = letra certa em oitava errada onde o nível ainda ensina: conta
            // como acerto, mas NÃO soma na sequência (e também não zera — é "quase", não
            // erro). A sequência é o incentivo à leitura completa, oitava inclusa.
            if (outcome === 'hit') {
                this.combo++;
                if (this.combo > this.maxCombo) this.maxCombo = this.combo;
            }
            this._outcomes.push('hit');
            this._paintState(note, 'hit');
            this._fxHit(note); // Kids: ♪ voando (no-op fora do Kids)
            if (this.kids) {
                // desmame por nota: conta o acerto e age no limiar recém-cruzado.
                const crossed = this._bumpLetter(note.letter);
                if (crossed === 'answer') this._refreshAnswerColorFor(note.letter); // tira a cor da resposta AO VIVO
                else if (crossed === 'note') { this._celebrateLetter(note.letter, note); hold = 650; } // formou → nota DOURADA (festa no modal)
            }
            this._playPitch(note.sci);
            window.audioManager && window.audioManager.play('correct');
        } else {
            this.combo = 0;
            this._outcomes.push('miss');
            this._paintState(note, 'miss');
            this._fxMiss(note); // Kids: anel pontilhado + tremor em X (no-op fora do Kids)
            window.audioManager && window.audioManager.play('wrong');
            this._playPitch(note.sci); // ensina a altura certa TAMBÉM no "passou" (antes era mudo)
            hold = this._teachMiss(note);
        }

        this._renderHud();
        this._animateOut(note, hold);
    }

    /** O erro é o momento mais didático do jogo — aqui ele ENSINA em vez de só punir:
     *  acende a resposta certa (paridade botões↔piano), diz "Era X!" no prompt e, no
     *  Kids, congela a esteira segurando a nota com rótulo + banda da linha/espaço
     *  ("era aqui ó"), sempre na COR da altura. Retorna o hold (ms). */
    _teachMiss(note) {
        if (this.kids) {
            // "era esta": no piano a ♪ DESCE da pauta e pousa na tecla certa, que então
            // acende — costura as duas superfícies ("a nota está ali ⇒ toca aqui").
            // A tecla certa é a da OITAVA certa: a ♪ tem de pousar no Mi5, não no Mi4.
            this._fxAnswer(note.letter, 'teach', this._midiOf(note));
        } else if (this.inputMode === 'piano') {
            this._flashCorrectKey(note, ReadingFlowGame.ANSWER_FLASH, 1100);
        } else {
            this._flashBtn(note.letter, ReadingFlowGame.ANSWER_FLASH, 1100);
        }
        // Escorregão de oitava num nível que já COBRA: a mensagem tem de reconhecer que a
        // leitura estava certa — "Era Mi!" para quem tocou um Mi é um diálogo de surdos.
        const slip = this._octaveSlip;
        this._octaveSlip = null;
        const midi = window.PitchUtil ? window.PitchUtil.midiFromSci(note.sci) : null;
        const msg = slip
            ? this._t(Number.isFinite(midi) && midi > slip.midi ? 'readingFlow.octaveUp' : 'readingFlow.octaveDown',
                { note: this._noteName(note.letter) })
            : this._t('readingFlow.wasNote', { note: this._noteName(note.letter) });
        this._flashPrompt(msg, slip ? '#d97706' : '#dc2626', this.kids ? 1700 : 1200);
        if (!this.kids) return 600; // normal: segura a nota vermelha um instante, sem pausar
        const ms = ReadingFlowGame.FREEZE_SEC * 1000;
        this._freeze(ReadingFlowGame.FREEZE_SEC);
        this._teachOverlay(note, ms);
        return ms;
    }

    /** Overlay do congela-e-ensina (Kids): banda translúcida atravessando a pauta na
     *  linha/espaço da nota + rótulo com o nome ao lado da cabeça. 1 por vez. */
    _teachOverlay(note, ms) {
        this._clearTeach();
        if (!this.musicStaff || !this.notesLayer || !this._geo) return;
        const y = this.musicStaff.getY(note.pos);
        const ls = this._geo.ls;
        // Banda na COR DA ALTURA (nunca vermelho genérico: vermelho é o Dó).
        const color = ReadingFlowGame.KIDS_COLORS[note.letter] || '#ef4444';

        const band = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        band.setAttribute('x', this._geo.leftLimit);
        band.setAttribute('y', y - ls / 2);
        band.setAttribute('width', Math.max(0, this._geo.spawnX - this._geo.leftLimit));
        band.setAttribute('height', ls);
        band.setAttribute('rx', '4');
        band.setAttribute('fill', color);
        band.setAttribute('opacity', '0.16');
        this.notesLayer.insertBefore(band, this.notesLayer.firstChild); // por baixo das notas
        this._teachEls.push(band);

        // rótulo dentro do <g> da nota (morre junto com ela no fade)
        if (note.g) {
            const label = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            label.setAttribute('x', 16);
            label.setAttribute('y', y + 5);
            label.setAttribute('font-size', '15');
            label.setAttribute('font-weight', '800');
            // tinta escura: nome é TEXTO (legibilidade), cor de altura já está na banda
            label.setAttribute('fill', '#0f172a');
            label.setAttribute('stroke', '#fff');
            label.setAttribute('stroke-width', '3');
            label.setAttribute('paint-order', 'stroke');
            label.textContent = this._noteName(note.letter);
            note.g.appendChild(label);
        }

        const tm = setTimeout(() => this._clearTeach(), ms);
        this._removeTimers.push(tm);
    }

    _clearTeach() {
        this._teachEls.forEach((el) => { if (el.parentNode) el.parentNode.removeChild(el); });
        this._teachEls = [];
    }

    /** Some com a nota resolvida. hold = ms segurando-a visível ANTES do fade
     *  (momento didático do erro / brilho dourado do "formou"). */
    _animateOut(note, hold = 0) {
        const g = note.g;
        if (g) {
            const tm0 = setTimeout(() => {
                if (!g.parentNode) return;
                g.style.transition = 'opacity 0.4s ease';
                requestAnimationFrame(() => { if (g) g.style.opacity = '0'; });
            }, hold);
            this._removeTimers.push(tm0);
        }
        const tm = setTimeout(() => {
            if (g && g.parentNode) g.parentNode.removeChild(g);
            const i = this.active.indexOf(note);
            if (i >= 0) this.active.splice(i, 1);
            if (!this._ended && this._running && this.resolved >= this.level.notesPerRound && this.active.length === 0) {
                this._end();
            }
        }, hold + 450);
        this._removeTimers.push(tm);
    }

    _end() {
        if (this._ended) return;
        this._ended = true;
        this._running = false;
        // Funil (Fase 3b): rodada CONCLUÍDA, antes de qualquer cálculo/render.
        if (window.Beacon) window.Beacon.roundClose('done');
        if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
        this._clearActive();
        this._teardownInputDevices();

        const total = this.level.notesPerRound;
        const acc = total ? Math.round((this.hits / total) * 100) : 0;
        const stars = this._starsFor(acc);
        const starRecord = this._saveBestStars(this.levelIdx, stars);

        // desbloqueio do próximo nível (1★ = mesmo limiar; ver STAR_ACC[0]/UNLOCK_ACC)
        let unlockedNew = false;
        const isLast = this.levelIdx >= ReadingFlowGame.LEVELS.length - 1;
        // Re-lê o desbloqueado do STORAGE antes de decidir: login no meio do jogo troca
        // o escopo (StorageScope) e a memória fica stale — escrever com ela poderia
        // REGREDIR o desbloqueio de uma conta que já estava à frente.
        this.unlocked = Math.max(0, parseInt(localStorage.getItem(window.StorageScope.key(ReadingFlowGame.UNLOCKED_KEY)) || '0', 10) || 0);
        if (acc >= ReadingFlowGame.UNLOCK_ACC && !isLast && this.unlocked <= this.levelIdx) {
            this.unlocked = this.levelIdx + 1;
            localStorage.setItem(window.StorageScope.key(ReadingFlowGame.UNLOCKED_KEY), String(this.unlocked));
            unlockedNew = true;
        }

        // Ranking: registra o take (local SEMPRE, servidor se logado). Depois do bloco de
        // desbloqueio de propósito — `passed` usa o MESMO limiar que libera o próximo nível.
        this._maybeSaveScore(acc, stars, acc >= ReadingFlowGame.UNLOCK_ACC);

        this.promptEl.textContent = '';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';
        this._renderHud();
        this._showResults(acc, stars, starRecord, unlockedNew, isLast);
    }

    /**
     * Grava o resultado do nível no ranking. Espelho do RhythmGame._maybeSaveScore, e
     * pelo mesmo motivo em DOIS PASSOS: (1) registra SEMPRE no mapa local (convidado
     * incluso — os níveis livres 1-3 são jogados sem conta e sumiriam do ranking por
     * nível); (2) envia agora se houver sessão. O que não subiu fica na fila e sobe no
     * login (RankingRepository.syncPending). Fire-and-forget: nunca afeta o jogo.
     *
     * 🔴 NÍVEL 1-BASED na borda (levelIdx+1): é a numeração do servidor e do AuthGate;
     * lá dentro `levelIdx` segue 0-based como sempre.
     *
     * accuracy = a MESMA precisão que a tela mostra (acertos/total) — a métrica de
     * ordenação é a do Ritmo (nível↓ depois precisão↓), então o placar e o resultado
     * do jogador nunca contam histórias diferentes. `bestMs` = tempo médio de resposta,
     * que só desempata DENTRO do nível (mesma velocidade de esteira ⇒ comparável).
     */
    _maybeSaveScore(acc, stars, passed) {
        try {
            if (this._levelOverride) return;   // nível sintético (teste) não entra no ranking
            const prog = window.LevelProgress && window.LevelProgress.get('leitura');
            if (!prog) return;

            const level = this.levelIdx + 1;
            const bestMs = this._avgReactMs();
            const L = this.level || {};
            // Bag ABERTA e versionada: o servidor grava como veio. `kids` e o crossSec REAL
            // entram porque o modo Kids desacelera a esteira — mesmo espírito do `bpm` real
            // do Ritmo: registrar o que foi de fato jogado, não o nominal do nível.
            const metrics = {
                v: 1,
                config: {
                    levelIdx: this.levelIdx,
                    minPos: L.minPos, maxPos: L.maxPos,
                    crossSec: Math.round((this._cross || L.crossSec || 0) * 100) / 100,
                    notesPerRound: L.notesPerRound,
                    kids: !!this.kids,
                    input: this.inputMode
                },
                detail: { hits: this.hits, total: L.notesPerRound, maxCombo: this.maxCombo, stars, reactMs: bestMs }
            };
            const rec = prog.recordBest(level, { accuracy: acc, bestMs, passed, metrics });

            const um = window.userManager;
            if (!um || !um.isLoggedIn() || !window.rankingRepository) return;

            window.rankingRepository
                .saveScore({ gameId: 'leitura', level, accuracy: acc, bestMs, passed, metrics })
                // `rec.seq` amarra a marcação AO TAKE QUE SUBIU: se a pessoa terminar outra
                // rodada enquanto o request está em voo, o take novo continua pendente.
                .then(res => { if (res && res.success) prog.markBestSynced(level, rec && rec.seq); })
                .catch(() => {});
        } catch (e) { /* placar é acessório: nunca propaga p/ o jogo */ }
    }

    /** Tempo médio de resposta dos acertos, em ms. null se não acertou nada. */
    _avgReactMs() {
        const r = this._reactSec || [];
        if (!r.length) return null;
        const ms = Math.round((r.reduce((a, b) => a + b, 0) / r.length) * 1000);
        return Number.isFinite(ms) && ms >= 0 ? ms : null;
    }

    /**
     * Resultado de fim de nível em MODAL centrado (window.notifications) — mais
     * legível no mobile que a antiga tela inline em resultsEl (que sofria com os
     * espaços pequenos). Fechar sem escolher ação volta à tela inicial.
     */
    _showResults(acc, stars, starRecord, unlockedNew, isLast) {
        const color = acc >= 90 ? '#10b981' : acc >= 70 ? '#f59e0b' : acc >= 50 ? '#f97316' : '#ef4444';
        // Kids: graduação quando TODAS as letras do range atual já formaram (cor 100% fora).
        const kidsGraduated = this.kids && this.generator.possibleLetters().every(l => this._letterStage(l) === 2);
        const row = (label, value) => `
            <div style="display:flex;justify-content:space-between;padding:0.45rem 0.2rem;border-bottom:1px solid #eee;">
                <span style="color:#475569;">${label}</span><strong>${value}</strong>
            </div>`;
        const starsBig = `<span style="color:#f59e0b;">${'★'.repeat(stars)}</span><span style="color:#e2e8f0;">${'☆'.repeat(3 - stars)}</span>`;

        // letras que FORMARAM nesta rodada (celebração migrou do toast mid-round pra cá)
        const formed = this._formedThisRound;
        const formedLine = formed.length
            ? this._t('readingFlow.kidsLearned', { note: formed.map((l) => this._noteName(l)).join(', ') })
            : '';
        // não liberou o próximo → diz O QUE falta (antes o critério era invisível no touch)
        const showGoal = acc < ReadingFlowGame.UNLOCK_ACC && !isLast && this.unlocked <= this.levelIdx;

        const body = document.createElement('div');
        body.innerHTML = `
            <div style="text-align:center;margin-bottom:1rem;">
                <p style="font-size:2.8rem;margin:0.1rem 0;line-height:1;letter-spacing:0.2rem;">${starsBig}</p>
                <p style="font-size:1.8rem;font-weight:900;margin:0.35rem 0 0;color:${color};line-height:1;">${acc}%</p>
                <p style="font-size:0.95rem;color:#64748b;font-weight:600;margin:0.1rem 0 0;">${this._t('readingFlow.results.scoreLine', { hits: this.hits, total: this.level.notesPerRound })}</p>
                ${starRecord ? `<p style="color:#f59e0b;font-weight:800;margin:0.5rem 0 0;">${this._t('readingFlow.results.starRecord')}</p>` : ''}
                ${unlockedNew ? `<p style="color:#10b981;font-weight:800;margin:0.5rem 0 0;">${this._t('readingFlow.results.unlocked')}</p>` : ''}
                ${showGoal ? `<p style="color:#64748b;font-weight:600;margin:0.5rem 0 0;">🔓 ${this._t('readingFlow.unlockGoal', { acc: ReadingFlowGame.UNLOCK_ACC, level: this.levelIdx + 2 })}</p>` : ''}
                ${formedLine ? `<p style="color:#b45309;font-weight:800;margin:0.5rem 0 0;">${formedLine}</p>` : ''}
                ${kidsGraduated ? `<p style="color:#b45309;font-weight:800;margin:0.5rem 0 0;">${this._t('readingFlow.kidsGraduated')}</p>` : ''}
            </div>
            <div style="background:#f8fafc;border-radius:10px;padding:0.6rem 0.9rem;">
                ${row(this._t('readingFlow.results.maxCombo'), this.maxCombo)}
                <div style="display:flex;justify-content:space-between;padding:0.45rem 0.2rem;">
                    <span style="color:#475569;">${this._t('readingFlow.results.levelStars')}</span><strong>${this._starStr(this._bestStars(this.levelIdx))}</strong>
                </div>
            </div>
            ${this.kids ? this._masteryMapHTML() : ''}`;

        // próximo nível (se acabou de liberar ou já está liberado e não é o último)
        const canNext = !isLast && this.unlocked > this.levelIdx;
        // Ação fecha o modal e age, sem disparar o onClose (que só repõe a tela inicial
        // no fechamento "passivo" via ✕/ESC/click-fora).
        const act = (fn) => () => { this._resultActionTaken = true; window.notifications.closeModal(); fn(); };
        const actions = [];
        if (canNext) {
            actions.push({ label: this._t('readingFlow.nextLevel'), style: 'primary', closeOnClick: false,
                onClick: () => {
                    // Gate de conta: bloqueado → allow() abre o modal de login, que
                    // SUBSTITUI este de resultado (NotificationManager é single-modal) e
                    // dispara o onClose passivo (_resultActionTaken=false) → a tela
                    // inicial se repõe sozinha atrás; o login retoma a sequência completa.
                    const goNext = () => { this._selectLevel(this.levelIdx + 1); this.start(); };
                    if (window.authGate && !window.authGate.allow(this.levelIdx + 2, this._gateCtx(), goNext)) return;
                    (act(goNext))();
                } });
        }
        actions.push({ label: this._t('readingFlow.playAgain'), style: 'success', closeOnClick: false,
            onClick: act(() => this.start()) });
        actions.push({ label: this._t('readingFlow.toFreeMode'), style: 'neutral', closeOnClick: false,
            onClick: act(() => { window.location.hash = '#/leitura-livre'; }) });
        actions.push({ label: this._t('readingFlow.backToMenu'), style: 'neutral', closeOnClick: false,
            onClick: act(() => window.router.navigate('/')) });

        this._resultActionTaken = false;
        window.notifications.modal({
            title: this._t('readingFlow.results.title'),
            node: body,
            actions,
            dismissible: true,
            onClose: () => { if (!this._resultActionTaken) this._showStartScreen(); }
        });
    }

    // ---------- áudio / helpers ----------

    _playPitch(sci) {
        const am = window.audioManager;
        if (!am) return;
        am.resumeContext();
        // Piano realista (opt-in) → sample real da nota; senão o tom senoidal de sempre.
        if (am.isPianoRealistic && am.isPianoRealistic()) {
            am.playNote(sci, 0.55, { volume: 0.85 });
        } else {
            am.play('tick', { frequency: am.getFrequency(sci), duration: 0.55, volume: 0.85 });
        }
    }

    _clearActive() {
        this._removeTimers.forEach(clearTimeout);
        this._removeTimers = [];
        this._clearTeach();
        // partículas/halos em voo não sobrevivem ao fim da rodada (mesma regra do áudio:
        // quem agenda à frente é responsável por cancelar).
        if (window.NoteFx && this.musicStaff) window.NoteFx.clear(this._staffFx());
        if (this.piano && this.piano.clearFx) this.piano.clearFx();
        if (this.notesLayer) {
            while (this.notesLayer.firstChild) this.notesLayer.removeChild(this.notesLayer.firstChild);
        }
        this.active = [];
    }

    _makeButton(label, bg, onClick, opts = {}) {
        const btn = window.domManager.create('button', {
            textContent: label,
            styles: {
                padding: opts.small ? '0.5rem 1rem' : '0.85rem 1.6rem',
                fontSize: opts.small ? '0.95rem' : '1.15rem',
                background: bg, color: '#fff', border: 'none', borderRadius: '10px',
                cursor: 'pointer', fontWeight: 'bold', margin: '0.35rem',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }
        });
        btn.addEventListener('click', onClick);
        return btn;
    }

    _t(key, params = {}) { return window.language ? window.language.t(key, params) : key; }
    _noteName(letter) { return this._t('notes.' + letter); }

    destroy() {
        this._destroyed = true;
        this._running = false;
        if (window.notifications) { this._resultActionTaken = true; window.notifications.closeModal(); }
        if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
        clearTimeout(this._resizeTimer);
        this._removeTimers.forEach(clearTimeout);
        this._teardownInputDevices();
        // Funil (Fase 3b): saiu da rota com a esteira rodando = abandono. No-op se já
        // fechou. DEPOIS do teardown — primeiro a esteira para, só então a medição.
        if (window.Beacon) window.Beacon.roundClose('quit');
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._onProgressRestored) document.removeEventListener('progressRestored', this._onProgressRestored);
        if (this.musicStaff) this.musicStaff.destroy();
        if (this.container) this.container.innerHTML = '';
    }
}

// Disponibiliza globalmente
window.ReadingFlowGame = ReadingFlowGame;

// Ficha da Leitura no ranking (2º jogo ranqueado). 🔴 `levels` converte o índice 0-based
// do jogo para a numeração 1-based do servidor — a conversão vive AQUI, na borda, e em
// nenhum outro lugar. Cresce sozinho quando LEVELS ganhar níveis.
if (window.LevelProgress) {
    window.LevelProgress.register({
        gameId: 'leitura',
        storageKey: ReadingFlowGame.BEST_KEY,
        nameKey: 'games.staffReading.name',
        route: '#/leitura',
        levels: () => ReadingFlowGame.LEVELS.map((_, i) => i + 1),
        currentLevel: () => ReadingFlowGame.storedLevelIdx() + 1,
        levelInfo: (n) => { const l = ReadingFlowGame.LEVELS[n - 1]; return l ? { world: l.world, pass: ReadingFlowGame.UNLOCK_ACC } : null; },
        worldName: (w) => ({ key: 'readingFlow.worldLabel', params: { n: w } }),
        // Devolução de progresso (login noutro device/browser): o LevelProgress traz os
        // takes da conta e chama isto com os níveis APROVADOS (1-based). Aqui mora a
        // conversão pro formato DESTE jogo — inteiro 0-based do nível mais alto liberado.
        // Só SOBE: nunca rebaixa quem já estava à frente localmente.
        applyUnlock: (passed) => {
            if (!Array.isArray(passed) || !passed.length) return;
            const last = ReadingFlowGame.LEVELS.length - 1;
            const key = window.StorageScope.key(ReadingFlowGame.UNLOCKED_KEY);
            const cur = Math.max(0, parseInt(localStorage.getItem(key) || '0', 10) || 0);
            // passou o nível 1-based N ⇒ índice 0-based do próximo é N
            const derived = Math.min(last, Math.max.apply(null, passed));
            if (derived > cur) localStorage.setItem(key, String(derived));
        }
    });
} else if (typeof console !== 'undefined') {
    console.warn('[ReadingFlowGame] LevelProgress ausente — Leitura fora do ranking. Conferir loadOrder.');
}



// ============================================
// games/IntervalGame.js
// ============================================
/**
 * IntervalGame - Jogo de Intervalos (treino de ouvido: distância entre alturas).
 *
 * 3º card de treinamento. Herda o esqueleto de quiz (placar %, fluxo, toggle de modo,
 * resultado) de BaseQuizGame; aqui mora só o que é de INTERVALO:
 *   - geração via Interval + IntervalGenerator + PitchUtil;
 *   - dois modos de resposta:
 *       'identify' (Ouvir e identificar): toca o intervalo e o jogador escolhe o nome;
 *       'build'    (Construir no piano): dá a raiz e o jogador toca a tecla-alvo;
 *   - reforço auditivo (toca o intervalo no feedback) e realce no piano.
 *
 * DOIS JOGOS (espelha o split do Ritmo: #/ritmo ranqueado ↔ #/ritmo-livre sandbox):
 *   - mode='ranked' (#/intervalos): TRILHA de níveis (IntervalGame.LEVELS), desbloqueio
 *     por % de acerto, progresso em localStorage via StorageScope.
 *   - mode='free'   (#/intervalos-livre): SANDBOX/treino — o jogador escolhe os intervalos,
 *     melódico/harmônico, direção (cima/baixo/ambas) e o tamanho (10/20/sem fim). Sem
 *     trilha/desbloqueio. Config salva em localStorage (device pref, sem StorageScope).
 *
 * NÍVEIS (ranked): catálogo estático IntervalGame.LEVELS (fonte única — afinar a curva é só
 * mexer ali). Camada auto-contida; generalizar p/ uma LevelProgression compartilhada só
 * quando Ritmo/Leitura/Intervalos convergirem de fato (composição, não herança).
 *
 * DICA VISUAL ("moleza"): por padrão a pergunta toca SÓ O SOM — o piano não revela as
 * teclas (treino de ouvido real). Um toggle "assist" (modo iniciante) reativa o brilho
 * durante a pergunta. O feedback (após responder) sempre revela. Gate em _playInterval(reveal).
 */
class IntervalGame extends BaseQuizGame {
    // Trilha de níveis (ranked). Cada nível liga intervalos, faixa de raízes (garante alvo
    // ≤ C6) e a forma de tocar. pass = % de acerto p/ liberar o próximo.
    static LEVELS = [
        { intervals: ['m3', 'M3'], minRootSci: 'C4', maxRootSci: 'G4', harmonic: false, pass: 70 },
        { intervals: ['m3', 'M3', 'P5'], minRootSci: 'C4', maxRootSci: 'G4', harmonic: false, pass: 70 },
        { intervals: ['m3', 'M3', 'P4', 'P5'], minRootSci: 'C4', maxRootSci: 'G4', harmonic: false, pass: 75 },
        { intervals: ['m3', 'M3', 'P4', 'P5', 'm6', 'M6'], minRootSci: 'C4', maxRootSci: 'F4', harmonic: false, pass: 75 },
        { intervals: ['m3', 'M3', 'P4', 'P5', 'm6', 'M6', 'P8'], minRootSci: 'C4', maxRootSci: 'C5', harmonic: false, pass: 78 },
        { intervals: ['m3', 'M3', 'P4', 'TT', 'P5', 'm6', 'M6', 'm7', 'M7', 'P8'], minRootSci: 'C4', maxRootSci: 'C5', harmonic: false, pass: 78 },
        { intervals: ['m3', 'M3', 'P4', 'TT', 'P5', 'm6', 'M6', 'm7', 'M7', 'P8'], minRootSci: 'C4', maxRootSci: 'C5', harmonic: true, pass: 80 }
    ];

    // Intervalos oferecidos no sandbox (sem uníssono — trivial). Ordem cromática.
    static ALL_CODES = ['m2', 'M2', 'm3', 'M3', 'P4', 'TT', 'P5', 'm6', 'M6', 'm7', 'M7', 'P8'];

    static LEVEL_KEY = 'interval_level_v1';        // último nível escolhido (StorageScope)
    static UNLOCKED_KEY = 'interval_unlocked_v1';   // índice do nível mais alto liberado
    static BEST_KEY = 'interval_best_v1';           // melhor take por nível + fila do ranking (LevelProgress)

    // Paleta do feedback, num lugar só.
    // 🔴 ERRO NÃO PINTA A NOTA CERTA. As teclas que acendem depois da resposta são sempre
    // as do intervalo QUE TOCOU — pintá-las de vermelho diria "estas notas estão erradas".
    // Quem erra vê as teclas na cor de REVELAÇÃO (a mesma do assist) e o vermelho vai para
    // o BOTÃO que a pessoa apertou, que é onde o engano de fato aconteceu.
    static COLOR_OK = '#10b981';
    static COLOR_ERR = '#ef4444';
    static COLOR_ROOT = '#6366f1';    // 1ª nota (raiz) na revelação
    static COLOR_TARGET = '#8b5cf6';  // 2ª nota (alvo) na revelação
    static ASSIST_KEY = 'interval_assist';           // '1' | '0' — pista visual na pergunta
    // sandbox (device prefs, sem StorageScope)
    static FREE_INTERVALS_KEY = 'interval_free_intervals'; // csv de codes
    static FREE_HARM_KEY = 'interval_free_harmonic';        // '1' | '0'
    static FREE_DIR_KEY = 'interval_free_dir';              // 'up' | 'down' | 'both'
    static FREE_LEN_KEY = 'interval_free_len';              // '10' | '20' | 'inf'

    constructor(opts = {}) {
        super({
            ns: 'intervals',
            modeStorageKey: 'interval_answer_mode',
            defaultMode: 'identify',
            modeLabelKey: 'intervals.mode',
            modes: [['identify', 'intervals.modeIdentify'], ['build', 'intervals.modeBuild']],
            resultsMaxWidth: 480,
            btnFont: '1.1rem'
        });

        this.mode = opts.mode === 'free' ? 'free' : 'ranked';

        // específicos de intervalo
        this.pianoContainer = null;
        this.generator = null;
        this.currentQuestion = null;
        this.harmonic = false; // setado por rodada
        this.pianoRange = { minSci: 'C4', maxSci: 'C6' };
        this._pianoRangeKey = '';

        // progresso da trilha (ranked)
        this.unlocked = this._loadInt(IntervalGame.UNLOCKED_KEY, 0);
        this._reconcileUnlocked();
        this.levelIdx = this._clampLevel(this._loadInt(IntervalGame.LEVEL_KEY, 0));
        if (this.levelIdx > this.unlocked) this.levelIdx = this.unlocked;
        // Defesa do gate de conta (AuthGate, 1-based): guest não boota acima da fronteira.
        if (window.authGate) this.levelIdx = window.authGate.clampForGuest(this.levelIdx + 1) - 1;

        // preferências compartilhadas
        this.assist = localStorage.getItem(IntervalGame.ASSIST_KEY) === '1';

        // config do sandbox (free)
        this.freeIntervals = this._loadFreeIntervals();
        this.freeHarmonic = localStorage.getItem(IntervalGame.FREE_HARM_KEY) === '1';
        const dir = localStorage.getItem(IntervalGame.FREE_DIR_KEY);
        this.freeDir = ['up', 'down', 'both'].includes(dir) ? dir : 'up';
        const len = localStorage.getItem(IntervalGame.FREE_LEN_KEY);
        this.freeLen = ['10', '20', 'inf'].includes(len) ? len : '10';

        this._timers = [];
        this._reactMs = [];   // tempo de resposta dos ACERTOS (ms) — desempate do ranking
    }

    async init(container) {
        this.container = container;
        this.generator = new window.IntervalGenerator(); // reconfigurado por rodada

        this._resizeHandler = () => {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => this._onResize(), 150);
        };
        window.addEventListener('resize', this._resizeHandler);

        this._navSetup('iv');
        this.setupUI();
        this.setupComponents();
        this._showStartScreen();

        // Retomada pós-OAuth (AuthGate): seleciona o nível pretendido e re-renderiza
        // (o _selectLevel já clampa ao desbloqueado da conta).
        if (this.mode === 'ranked' && window.authGate) {
            const it = window.authGate.takeIntentFor('intervals');
            if (it) { this._selectLevel(it.levelNum - 1); this._showStartScreen(); }
        }
    }

    setupUI() {
        const mobile = (window.innerWidth || 1024) < 560;
        const pad = mobile ? '0.75rem' : '1.5rem';
        const title = this.mode === 'free' ? 'intervals.freeTitle' : 'intervals.title';
        this.container.innerHTML = `
            <div class="interval-game" style="max-width:900px;margin:0 auto;padding:${pad};overflow-x:hidden;">
                <h1 class="game-h1" style="text-align:center;margin-bottom:0.25rem;">${this._t(title)}</h1>
                <p id="iv-progress" style="text-align:center;color:#6366f1;font-weight:600;margin:0.2rem 0;"></p>
                <div class="game-intro" style="display:flex;align-items:center;justify-content:center;gap:0.1rem;margin-bottom:0.5rem;">
                    <p id="iv-status" style="text-align:center;color:#555;min-height:1.5rem;margin:0;"></p>
                </div>
                <div id="piano-container" style="margin:1rem auto;max-width:620px;overflow:hidden;"></div>
                <div id="iv-mode" style="text-align:center;margin:0.5rem 0;font-size:0.9rem;color:#555;"></div>
                <div id="iv-answers" style="text-align:center;margin:0.75rem 0;"></div>
                <div id="iv-extra" style="text-align:center;margin-bottom:0.5rem;"></div>
                <div id="results-container" style="display:none;"></div>
            </div>`;

        // 🔴 O "?" de estreia vai na linha do SUBTÍTULO, NUNCA no h1: `.game-h1` é
        // `display:none` abaixo de 560px (styles.css) — ou seja, some justo no
        // CELULAR, que é onde a ajuda se julga. Ele fica FORA do <p> do status
        // porque _setStatus() escreve por textContent e apagaria o nó a cada
        // pergunta; o invólucro flex segura os dois lado a lado.
        if (window.HelpDot) {
            window.HelpDot.attach(this.container.querySelector('.game-intro'), 'intervals.howto');
        }

        this.statusEl = this.container.querySelector('#iv-status');
        this.progressEl = this.container.querySelector('#iv-progress');
        this.pianoContainer = this.container.querySelector('#piano-container');
        this.modeEl = this.container.querySelector('#iv-mode');
        this.answersEl = this.container.querySelector('#iv-answers');
        this.extraEl = this.container.querySelector('#iv-extra');
        this.resultsContainer = this.container.querySelector('#results-container');
    }

    setupComponents() {
        const r = this._roundPianoRange();
        this._ensurePiano(r.minSci, r.maxSci);
    }

    /**
     * Quantas FILEIRAS o teclado usa nesta rodada.
     *
     * 🔴 Só parte em duas no modo CONSTRUIR, porque só ali o piano é a superfície de
     * RESPOSTA. Medido a 390px em fileira única: branca 24,4px e preta 15,1px, contra os
     * 44px de alvo do projeto — o dedo escorrega para a vizinha e conta ERRO, ou seja, a
     * tela suja a métrica do treino (é o caso que o próprio PianoKeyboard documenta).
     * No modo IDENTIFICAR o piano é só reveladora visual: partir em duas custaria ~90px
     * de altura no celular sem tirar erro nenhum, então lá ele segue inteiro.
     */
    _pianoRows(minSci, maxSci) {
        if (this.answerMode !== 'build' || !window.PianoKeyboard.rowsFor) return 1;
        return window.PianoKeyboard.rowsFor(minSci, maxSci);
    }

    /** Piano compartilhado: (re)cria só se a faixa OU o nº de fileiras mudou. */
    _ensurePiano(minSci, maxSci, rows = null) {
        const r = rows != null ? rows : this._pianoRows(minSci, maxSci);
        const key = minSci + '-' + maxSci + '-' + r;
        if (this.piano && this._pianoRangeKey === key) return;
        if (this.piano) { this.piano.destroy(); this.piano = null; }
        this.pianoRange = { minSci, maxSci };
        this._pianoRangeKey = key;
        this.piano = new window.PianoKeyboard(this.pianoContainer, {
            minSci, maxSci, rows: r,
            labelFn: (info) => this._noteName(info.letter),
            onKeyPress: (info) => this._onPianoKey(info)
        });
        this.piano.render();
    }

    /**
     * Girar o celular (ou a barra de URL do Chrome sumindo ao rolar) muda a largura, e o
     * nº de fileiras é decidido UMA vez, no render — sem isto o teclado ficaria congelado
     * na forma da largura anterior.
     *
     * 🔴 O guard LISTA os estados em que pode remontar, nunca nega ("se não estiver
     * jogando"): em `feedback` a remontagem apagaria o realce da resposta que a pessoa
     * ainda está lendo, e em `results` o piano nem está na tela. Guard por negativa foi
     * exatamente o que o jogo de música pagou duas vezes.
     */
    _onResize() {
        if (!this.piano || !this.pianoContainer) return;
        if (this.state !== 'idle' && this.state !== 'question') return;
        const { minSci, maxSci } = this.pianoRange;
        const want = this._pianoRows(minSci, maxSci);
        const key = minSci + '-' + maxSci + '-' + want;
        if (key === this._pianoRangeKey) return;
        this._ensurePiano(minSci, maxSci, want);
        // A raiz segurada é estado do jogo, não do teclado: o piano novo não a conhece.
        if (this.state === 'question' && this.answerMode === 'build' && this.currentQuestion) {
            this.piano.hold(this.currentQuestion.rootMidi, IntervalGame.COLOR_ROOT);
        }
    }

    /**
     * Faixa do piano da rodada.
     *
     * 🔴 SÓ DESCENDENTE precisa de C3, e não precisa de C6: o alvo nunca sobe acima da raiz,
     * que fica em C4..C5. Cortar o teto ali é o que faz o teclado caber em 2 fileiras de
     * verdade — MEDIDO a 360px: C3–C6 (22 brancas) dá 24px por branca mesmo partido, C3–C5
     * (15 brancas) dá ~45px. "Ambas" continua precisando das 3 oitavas, e ali as 2 fileiras
     * aliviam sem chegar aos 44px; estreitar mais tiraria nota que a rodada usa.
     */
    _roundPianoRange() {
        if (this.mode === 'free' && this.freeDir === 'down') return { minSci: 'C3', maxSci: 'C5' };
        if (this.mode === 'free' && this.freeDir !== 'up') return { minSci: 'C3', maxSci: 'C6' };
        return { minSci: 'C4', maxSci: 'C6' };
    }

    // ---------- níveis (ranked) ----------

    _clampLevel(i) { return Math.max(0, Math.min(IntervalGame.LEVELS.length - 1, i | 0)); }
    _level(i) { return IntervalGame.LEVELS[this._clampLevel(i)]; }
    _curLevel() { return this._level(this.levelIdx); }

    /** Funil (Fase 3b): nível 1-BASED só na trilha ranqueada; no modo livre não há progressão. */
    _beaconLevel() { return this.mode === 'ranked' ? this.levelIdx + 1 : null; }

    _loadInt(key, def) {
        try {
            const raw = window.localStorage && window.localStorage.getItem(window.StorageScope.key(key));
            const n = parseInt(raw, 10);
            return Number.isFinite(n) ? n : def;
        } catch (e) { return def; }
    }

    _saveInt(key, val) {
        try { if (window.localStorage) window.localStorage.setItem(window.StorageScope.key(key), String(val)); }
        catch (e) { /* sem persistência, segue em memória */ }
    }

    /** Define o nível corrente (só até o liberado) e persiste. NÃO re-renderiza (o caller decide). */
    _selectLevel(i) {
        // Re-lê o desbloqueado do STORAGE: login no meio do jogo troca o escopo
        // (StorageScope) e a memória desta instância fica stale — a conta pode ter
        // progresso MENOR que o guest tinha. Storage é a fonte da verdade.
        this.unlocked = this._loadInt(IntervalGame.UNLOCKED_KEY, 0);
        this.levelIdx = Math.min(this._clampLevel(i), this.unlocked);
        this._saveInt(IntervalGame.LEVEL_KEY, this.levelIdx);
    }

    /**
     * Re-deriva `unlocked` dos MELHORES takes salvos (LevelProgress). Espelho do
     * `ReadingFlowGame._reconcileUnlocked`, e existe pelo mesmo buraco: o desbloqueio só é
     * gravado no fim da rodada e com `!isLast` — quem passou o ÚLTIMO nível da trilha nunca
     * teve o próximo liberado, porque não havia próximo. No dia em que a trilha crescer,
     * essa pessoa abriria o jogo com o nível seguinte TRANCADO.
     * É a regra de sempre aplicada a um recorde que a pessoa JÁ TEM: só sobe, nunca rebaixa,
     * e não dá nível a quem não passou.
     */
    _reconcileUnlocked() {
        try {
            const prog = window.LevelProgress && window.LevelProgress.get('intervalos');
            if (!prog) return;
            const bests = prog.getBests();     // { "<nível 1-based>": { acc, passed, … } }
            const last = IntervalGame.LEVELS.length - 1;
            Object.keys(bests).forEach((k) => {
                const level = parseInt(k, 10);          // 1-based
                if (!Number.isFinite(level) || level < 1 || level > IntervalGame.LEVELS.length) return;
                const rec = bests[k] || {};
                // 🔴 A meta é POR NÍVEL aqui (não há um `UNLOCK_ACC` único como na Leitura):
                // a régua de cada nível é o `pass` dele.
                const meta = IntervalGame.LEVELS[level - 1].pass;
                const passou = rec.passed === true || (Number.isFinite(rec.acc) && rec.acc >= meta);
                if (!passou) return;
                // passou o nível 1-based N ⇒ o índice 0-based do próximo é N
                this.unlocked = Math.min(last, Math.max(this.unlocked, level));
            });
            this._saveInt(IntervalGame.UNLOCKED_KEY, this.unlocked);
        } catch (e) { /* storage indisponível: segue com o unlocked lido */ }
    }

    /** Contexto deste jogo pro AuthGate (route = retomada pós-OAuth, que perde o hash). */
    _gateCtx() { return { gameId: 'intervals', route: '#/intervalos' }; }

    /** Descrição do nível = nomes dos intervalos habilitados (+ tag harmônico). */
    _levelDesc(level) {
        const names = level.intervals.map(c => this._t('intervals.names.' + c)).join(' · ');
        return level.harmonic ? `${names} — ${this._t('intervals.harmonicTag')}` : names;
    }

    // ---------- config do sandbox (free) ----------

    _loadFreeIntervals() {
        let arr = [];
        try {
            const raw = localStorage.getItem(IntervalGame.FREE_INTERVALS_KEY);
            if (raw) arr = raw.split(',').filter(c => window.Interval.CATALOG[c]);
        } catch (e) { /* ignora */ }
        return arr.length ? arr : ['m3', 'M3', 'P5'];
    }

    _saveFreeIntervals() {
        try { localStorage.setItem(IntervalGame.FREE_INTERVALS_KEY, this.freeIntervals.join(',')); }
        catch (e) { /* segue em memória */ }
    }

    _toggleFreeInterval(code) {
        const i = this.freeIntervals.indexOf(code);
        if (i >= 0) {
            if (this.freeIntervals.length <= 1) return; // mantém ≥ 1 selecionado
            this.freeIntervals.splice(i, 1);
        } else {
            this.freeIntervals.push(code);
        }
        this._saveFreeIntervals();
        this._showStartScreen();
    }

    // ---------- tela inicial ----------

    _showStartScreen() {
        this._clearTimers();
        this.state = 'idle';
        this.currentQuestion = null;
        if (this.piano) { this.piano.clearFeedback(); this.piano.releaseHolds(); }
        // 🔴 O piano fica À VISTA na tela inicial, no lugar de palco (antes das opções),
        // como a pauta fica no Ritmo e na Leitura. Antes a tela era um formulário — título,
        // botão, cadeados, três linhas de opções e 40% de vazio no celular — e a pessoa
        // entrava na rodada sem nunca ter ouvido o app. Aqui ele é brinquedo (toca ao
        // tocar; `_onPianoKey` ignora fora da pergunta) e palco do "Ouvir exemplo".
        if (this.pianoContainer) {
            this.pianoContainer.style.display = '';
            const parent = this.pianoContainer.parentNode;
            if (parent && this.modeEl) parent.insertBefore(this.pianoContainer, this.modeEl);
        }
        this.resultsContainer.style.display = 'none';
        this.resultsContainer.innerHTML = '';
        this.modeEl.innerHTML = '';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';
        this._exampleIdx = 0;
        // Som da vitrine (tecla solta, exemplo) NÃO é "começou o jogo" no funil.
        window.Beacon?.pauseGameStart(true);

        if (this.mode === 'free') this._showFreeStart();
        else this._showRankedStart();
        // Raiz do "voltar": daqui o gesto do aparelho SAI do jogo, como em qualquer tela
        // de topo. Chamado no fim porque consumir o degrau pode disparar um `popstate`.
        this._navEnter(true);
    }

    _showRankedStart() {
        const level = this._curLevel();
        // A meta vai JUNTO do nível: é o número que decide se o próximo cadeado abre, e
        // antes ele não aparecia em lugar nenhum.
        // 🔴 DUAS LINHAS, a de baixo em corpo menor. Numa linha só, MEDIDO a 360px, o nível
        // mais carregado dava 4 linhas em PT/EN e 5 em ES — um bloco roxo entre o título e o
        // botão Começar. O que a pessoa lê primeiro é "que nível, que meta"; a lista do que
        // vai cair é referência, não manchete.
        this.progressEl.innerHTML = this._escape(this._levelHeadline(level))
            + `<span style="display:block;font-size:0.8rem;font-weight:600;color:#64748b;margin-top:0.1rem;">`
            + this._escape(this._levelDesc(level)) + `</span>`;
        this._setStatus(this._t('intervals.subtitle'));

        this.answersEl.appendChild(this._makeButton(this._t('intervals.start'),
            'linear-gradient(135deg,#10b981,#059669)', () => this.startRound()));
        this.answersEl.appendChild(this._buildExampleButton());

        this.extraEl.appendChild(this._buildLevelPicker());
        this.extraEl.appendChild(this._buildOptionsRow());
        this.extraEl.appendChild(this._buildCrossLink());
    }

    _showFreeStart() {
        this.progressEl.textContent = '';
        this._setStatus(this._t('intervals.freeSubtitle'));

        this.answersEl.appendChild(this._makeButton(this._t('intervals.start'),
            'linear-gradient(135deg,#10b981,#059669)', () => this.startRound()));
        this.answersEl.appendChild(this._buildExampleButton());

        this.extraEl.appendChild(this._buildFreeConfig());
        this.extraEl.appendChild(this._buildCrossLink());
    }

    /**
     * Fileira de botões 1..N (`LevelPill`: número sempre visível, trancado = apagado,
     * melhor % embaixo). O melhor take vem do MESMO registro que alimenta o ranking
     * (`LevelProgress`), chave 1-based — não há segunda cópia do placar.
     */
    _buildLevelPicker() {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'display:flex;justify-content:center;gap:0.4rem;flex-wrap:wrap;margin:0.6rem 0;';
        const prog = window.LevelProgress && window.LevelProgress.get('intervalos');
        const bests = prog ? prog.getBests() : {};
        IntervalGame.LEVELS.forEach((lv, i) => {
            const locked = i > this.unlocked;
            const active = i === this.levelIdx;
            const b = window.LevelPill.make({
                n: i + 1, locked, active, best: bests[String(i + 1)] || null,
                title: locked ? this._t('intervals.locked') : `${this._t('intervals.level')} ${i + 1}`
            });
            if (!locked) b.addEventListener('click', () => {
                // Gate de conta (nível 4+ anônimo): bloqueado → modal abre e nada muta;
                // o login retoma a sequência completa (selecionar + re-render).
                const go = () => { this._selectLevel(i); this._showStartScreen(); };
                if (window.authGate && !window.authGate.allow(i + 1, this._gateCtx(), go)) return;
                go();
            });
            wrap.appendChild(b);
        });
        // 🔴 O "?" do portão vai colado a um RÓTULO, como todo "?" do sistema (§1:
        // "sempre à direita do rótulo do grupo"). Solto sob a grade ele caía em três
        // posições diferentes — e em Acordes chegava a ler como um NÍVEL a mais, do
        // mesmo tamanho e forma dos cadeados. Um "?" sem rótulo não responde "ajuda
        // sobre o quê?", e quem tem 70 anos não toca no que não tem nome.
        const gateRow = document.createElement('div');
        gateRow.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:0.1rem;margin-top:0.2rem;';
        const gateLab = document.createElement('span');
        gateLab.textContent = (window.language ? window.language.t('help.levelsLabel') : 'Níveis:');
        gateLab.style.cssText = 'color:#64748b;font-size:0.9rem;';
        gateRow.appendChild(gateLab);
        if (window.HelpDot) window.HelpDot.attach(gateRow, 'app.levelGate');
        wrap.appendChild(gateRow);
        return wrap;
    }

    /** "🔊 Ouvir exemplo": irmão menor do Começar, como o "▶ Ouvir" ao lado do "Avaliar" no Ritmo. */
    _buildExampleButton() {
        const b = this._makeButton(this._t('intervals.hearExample'), 'linear-gradient(135deg,#0ea5e9,#0284c7)',
            () => this._playExample(), { small: true });
        b.dataset.role = 'example';
        return b;
    }

    /**
     * Toca UM intervalo do que a rodada vai cobrar — a cada toque, o próximo da lista
     * (nível ranqueado ou chips do sandbox), sempre acendendo as teclas e escrevendo o
     * nome: "terça maior soa ASSIM". Antes a pessoa começava cega — ouvia duas notas e já
     * era cobrada. Raiz fixa em Dó (o exemplo é para ouvir a distância, não a altura);
     * no sandbox descendente a raiz sobe uma oitava e o alvo vem por baixo.
     */
    _playExample() {
        if (this.state !== 'idle') return;
        const codes = this.mode === 'free' ? this.freeIntervals : this._curLevel().intervals;
        if (!codes.length) return;
        const code = codes[this._exampleIdx % codes.length];
        this._exampleIdx++;
        const iv = window.Interval.fromCode(code);
        const down = this.mode === 'free' && this.freeDir === 'down';
        const rootMidi = down ? 72 : 60;
        const targetMidi = down ? iv.applyDown(rootMidi) : iv.applyUp(rootMidi);
        const harmonic = this.mode === 'free' ? this.freeHarmonic : !!this._curLevel().harmonic;
        this._clearTimers();
        if (this.piano) this.piano.clearFeedback();
        this._setStatus(this._t('intervals.exampleIs', { interval: this._intervalName(code) }));
        this._playInterval(true, { rootMidi, targetMidi }, harmonic);
        // Devolve o subtítulo quando o som acaba — o status é textContent, então o "?" ao
        // lado não é tocado.
        const back = this.mode === 'free' ? 'intervals.freeSubtitle' : 'intervals.subtitle';
        this._timers.push(setTimeout(() => { if (this.state === 'idle') this._setStatus(this._t(back)); }, harmonic ? 1200 : 1900));
    }

    /** Opções do ranqueado: pista visual (assist) + modo de resposta (Ouvir/Construir). */
    _buildOptionsRow() {
        const row = document.createElement('div');
        row.style.cssText = 'display:flex;justify-content:center;gap:1.2rem;flex-wrap:wrap;align-items:center;margin-top:0.5rem;font-size:0.9rem;';
        row.appendChild(this._assistSeg());
        row.appendChild(this._answerModeSeg());
        return row;
    }

    /** Painel de configuração do sandbox (chips de intervalo + toggles + tamanho). */
    _buildFreeConfig() {
        const box = document.createElement('div');
        box.style.cssText = 'max-width:560px;margin:0.4rem auto 0;';

        // chips de intervalo
        const lbl = document.createElement('p');
        lbl.textContent = this._t('intervals.pickIntervals');
        lbl.style.cssText = 'color:#64748b;font-size:0.9rem;margin:0.3rem 0;';
        box.appendChild(lbl);

        const chips = document.createElement('div');
        chips.style.cssText = 'display:flex;justify-content:center;gap:0.35rem;flex-wrap:wrap;margin-bottom:0.7rem;';
        IntervalGame.ALL_CODES.forEach(code => {
            const on = this.freeIntervals.includes(code);
            const b = document.createElement('button');
            b.type = 'button';
            b.textContent = this._intervalName(code);
            b.dataset.code = code;
            // min-height 44px: o alvo de dedo do projeto. Medido, o chip saía com 32px.
            b.style.cssText = `padding:0.4rem 0.7rem;min-height:44px;border-radius:999px;font-weight:700;font-size:0.8rem;cursor:pointer;
                border:2px solid ${on ? '#6366f1' : '#e2e8f0'};background:${on ? '#eef2ff' : '#fff'};color:${on ? '#4f46e5' : '#64748b'};`;
            b.addEventListener('click', () => this._toggleFreeInterval(code));
            chips.appendChild(b);
        });
        box.appendChild(chips);

        // toggles
        const segs = document.createElement('div');
        segs.style.cssText = 'display:flex;justify-content:center;gap:1rem;flex-wrap:wrap;align-items:center;font-size:0.9rem;';

        // melódico / harmônico
        segs.appendChild(this._labeledSeg(this._t('intervals.playLabel'), [
            ['mel', this._t('intervals.melodic')],
            ['harm', this._t('intervals.harmonicMode')]
        ], this.freeHarmonic ? 'harm' : 'mel', (v) => {
            this.freeHarmonic = v === 'harm';
            localStorage.setItem(IntervalGame.FREE_HARM_KEY, this.freeHarmonic ? '1' : '0');
            this._showStartScreen();
        }, 'intervals.play'));

        // direção
        segs.appendChild(this._labeledSeg(this._t('intervals.dir'), [
            ['up', this._t('intervals.dirUp')],
            ['down', this._t('intervals.dirDown')],
            ['both', this._t('intervals.dirBoth')]
        ], this.freeDir, (v) => {
            this.freeDir = v;
            localStorage.setItem(IntervalGame.FREE_DIR_KEY, v);
            this._showStartScreen();
        }));

        // tamanho
        segs.appendChild(this._labeledSeg(this._t('intervals.length'), [
            ['10', '10'],
            ['20', '20'],
            ['inf', this._t('intervals.endless')]
        ], this.freeLen, (v) => {
            this.freeLen = v;
            localStorage.setItem(IntervalGame.FREE_LEN_KEY, v);
            this._showStartScreen();
        }));

        segs.appendChild(this._assistSeg());
        segs.appendChild(this._answerModeSeg());
        box.appendChild(segs);
        return box;
    }

    _assistSeg() {
        return this._labeledSeg(this._t('intervals.assist'), [
            ['0', this._t('intervals.assistOff')],
            ['1', this._t('intervals.assistOn')]
        ], this.assist ? '1' : '0', (v) => {
            this.assist = v === '1';
            localStorage.setItem(IntervalGame.ASSIST_KEY, v);
            this._showStartScreen();
        }, 'intervals.assist');
    }

    _answerModeSeg() {
        const w = this._labeledSeg(this._t('intervals.mode'), [
            ['identify', this._t('intervals.modeIdentify')],
            ['build', this._t('intervals.modeBuild')]
        ], this.answerMode, (v) => {
            this.answerMode = v;
            localStorage.setItem(this.modeStorageKey, v);
            this._showStartScreen();
        }, 'intervals.mode');
        // `data-seg="mode"` dá ENDEREÇO ao seletor: é por ele que o teste prova que a
        // escolha de modo continua existindo depois de ter saído da barra da rodada.
        // Vai no invólucro dos SEGMENTOS (o último filho), não no grupo inteiro — o
        // grupo também abriga o "?" da ajuda, que é um <button> e entraria na contagem.
        if (w.lastElementChild) w.lastElementChild.dataset.seg = 'mode';
        return w;
    }

    /** Rótulo + toggle segmentado (lista [valor,label], valor atual, callback). */
    /** Rótulo + toggle segmentado. `helpTopic` pendura o "?" NO RÓTULO do grupo —
     *  um por DÚVIDA, nunca um por botão (a pergunta é "qual dos dois?"). */
    _labeledSeg(label, items, current, onChange, helpTopic = null) {
        const w = document.createElement('div');
        w.style.cssText = 'display:inline-flex;gap:0.35rem;align-items:center;';
        const lab = document.createElement('span');
        lab.textContent = label;
        lab.style.color = '#64748b';
        w.appendChild(lab);
        if (helpTopic && window.HelpDot) window.HelpDot.attach(w, helpTopic);

        const seg = document.createElement('div');
        seg.dataset.segmented = '1';   // endereço do controle (o "?" do grupo é <button> e não pode entrar na contagem)
        seg.style.cssText = 'display:inline-flex;border:2px solid #e2e8f0;border-radius:999px;overflow:hidden;';
        items.forEach(([val, text]) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.textContent = text;
            const on = val === current;
            // min-height 44px: medido, o segmento saía com 29px — metade do alvo, e logo
            // ao lado de um "?" de 44px (o ajudante maior que o controle que ele explica).
            b.style.cssText = `padding:0.4rem 0.85rem;min-height:44px;border:none;cursor:pointer;font-weight:700;font-size:0.85rem;
                background:${on ? '#6366f1' : 'transparent'};color:${on ? '#fff' : '#475569'};`;
            b.addEventListener('click', () => onChange(val));
            seg.appendChild(b);
        });
        w.appendChild(seg);
        return w;
    }

    /** Link p/ o jogo irmão (chip): ranked → "⚙️ Modo livre"; free → "🏆 Níveis". */
    _buildCrossLink() {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'margin-top:1rem;text-align:center;';
        const link = document.createElement('button');
        link.type = 'button';
        link.className = 'rhythm-crosslink';
        const toFree = this.mode === 'ranked';
        link.textContent = this._t(toFree ? 'intervals.toFreeMode' : 'intervals.toRankedMode');
        link.addEventListener('click', () => { window.location.hash = toFree ? '#/intervalos-livre' : '#/intervalos'; });
        wrap.appendChild(link);
        // "Trilha × livre" é a dúvida que o chip levanta: ele oferece a troca sem
        // dizer o que muda. Mesmo tópico nos jogos que têm o par.
        if (window.HelpDot) window.HelpDot.attach(wrap, 'app.freeMode');
        return wrap;
    }

    // ---------- ganchos do BaseQuizGame ----------

    /**
     * 🔴 Sem barra de modo DENTRO da rodada. Ela repetia, com outro visual, o mesmo
     * seletor que já está na tela inicial (`_answerModeSeg`) e custava 108px medidos no
     * topo do celular — o melhor lugar da tela. Trocar de modo continua sendo possível:
     * é a tela inicial, antes de começar. (O jogo de Acordes já fazia assim.)
     */
    _buildModeToggle() { if (this.modeEl) this.modeEl.innerHTML = ''; }

    /**
     * Ordem da área de jogo. No modo IDENTIFICAR, os botões de resposta vêm ANTES do
     * piano: ali o teclado é só reveladora e, com a pista visual desligada (o padrão),
     * ele fica 100% apagado durante a pergunta — 80px medidos de faixa branca entre o
     * enunciado e a resposta. No modo CONSTRUIR o piano É a resposta e volta para cima.
     */
    _orderPlayArea() {
        if (!this.pianoContainer || !this.answersEl) return;
        const parent = this.pianoContainer.parentNode;
        if (!parent) return;
        // No identify o piano vai para o FIM (depois do "Repetir"): as duas coisas que a
        // pessoa toca — os botões de resposta e o replay — ficam juntas no alto.
        if (this.answerMode === 'build') parent.insertBefore(this.pianoContainer, this.modeEl);
        else parent.insertBefore(this.pianoContainer, this.resultsContainer);
    }

    /** Início da rodada: aplica nível/sandbox ao gerador, ajusta piano e tamanho. */
    _prepareRoundUI() {
        if (this.mode === 'free') {
            this.harmonic = this.freeHarmonic;
            this.totalQuestions = this.freeLen === 'inf' ? Infinity : parseInt(this.freeLen, 10);
            const r = this._roundPianoRange();
            this._ensurePiano(r.minSci, r.maxSci);
            this.generator = new window.IntervalGenerator({
                intervals: this.freeIntervals, minRootSci: 'C4', maxRootSci: 'C5', direction: this.freeDir
            });
        } else {
            const level = this._curLevel();
            this.harmonic = !!level.harmonic;
            this.totalQuestions = 10;
            this._ensurePiano('C4', 'C6');
            this.generator = new window.IntervalGenerator({
                intervals: level.intervals, minRootSci: level.minRootSci, maxRootSci: level.maxRootSci
            });
        }
        if (this.pianoContainer) this.pianoContainer.style.display = '';
        this._reactMs = [];
        this._orderPlayArea();
        window.Beacon?.pauseGameStart(false);   // daqui em diante o 1º som É jogar
        // Um degrau abaixo da tela inicial. O resultado NÃO empilha outro (profundidade 1):
        // do resultado, um "voltar" devolve a tela inicial, não a rodada que já acabou.
        this._navEnter(false);
    }

    /** Sorteia e apresenta o intervalo (progresso já setado pela base). */
    _generateAndPresent() {
        this.currentQuestion = this.generator.generate();
        if (this.piano) { this.piano.clearFeedback(); this.piano.releaseHolds(); }
        // Relógio da resposta: alimenta o `best_ms` do ranking (desempate DENTRO do nível).
        this._askedAt = Date.now();
        if (this.answerMode === 'build') this._presentBuild();
        else this._presentIdentify();
    }

    _presentIdentify() {
        this._setStatus(this._t('intervals.identifyPrompt'));
        this._setAnswersEnabled(true);
        this._playInterval(this.assist); // só revela teclas se a pista visual estiver ligada
    }

    _presentBuild() {
        const q = this.currentQuestion;
        const root = this._noteName(window.PitchUtil.letterOf(q.rootMidi));
        const dirKey = q.direction === 'down' ? 'intervals.buildPromptDown' : 'intervals.buildPrompt';
        this.piano.hold(q.rootMidi, IntervalGame.COLOR_ROOT);
        this._setStatus(this._t(dirKey, { interval: this._intervalName(q.interval), root }));
        this._playNote(q.rootMidi, 0.6);
    }

    // ---------- respostas ----------

    _onPianoKey(info) {
        if (this.answerMode !== 'build' || this.state !== 'question' || this.answered) return;
        this.answerBuild(info.midi);
    }

    answerIdentify(code) {
        if (this.answerMode !== 'identify' || this.state !== 'question' || this.answered) return;
        const correct = code === this.currentQuestion.interval.code;
        this._register(code, correct);

        const q = this.currentQuestion;
        this.piano.flashKey(q.rootMidi, correct ? IntervalGame.COLOR_OK : IntervalGame.COLOR_ROOT, 1300);
        this.piano.flashKey(q.targetMidi, correct ? IntervalGame.COLOR_OK : IntervalGame.COLOR_TARGET, 1300);
        this._markAnswerButtons(code, q.interval.code);

        this._afterAnswer(correct);
    }

    answerBuild(midi) {
        const q = this.currentQuestion;
        const correct = midi === q.targetMidi;
        this._register(q.interval.code, correct, midi);

        this.piano.flashKey(midi, correct ? IntervalGame.COLOR_OK : IntervalGame.COLOR_ERR, 1300);
        if (!correct) this.piano.flashKey(q.targetMidi, IntervalGame.COLOR_OK, 1300); // mostra a certa

        this._afterAnswer(correct);
    }

    _register(chosenCode, correct, chosenMidi = null) {
        this.answered = true;
        this.state = 'feedback';
        this._setAnswersEnabled(false);
        if (correct) {
            this.correctCount++;
            if (this._askedAt) this._reactMs.push(Date.now() - this._askedAt);
        }
        this.history.push({
            interval: this.currentQuestion.interval,
            rootMidi: this.currentQuestion.rootMidi,
            targetMidi: this.currentQuestion.targetMidi,
            direction: this.currentQuestion.direction,
            chosenCode, chosenMidi, correct, mode: this.answerMode
        });
    }

    _afterAnswer(correct) {
        const name = this._intervalName(this.currentQuestion.interval);
        this._setStatus(correct
            ? this._t('intervals.correct', { interval: name })
            : this._t('intervals.wrong', { interval: name }));
        this._playInterval(true); // feedback SEMPRE revela
        window.audioManager.play(correct ? 'correct' : 'wrong');
        this._advanceTimer = setTimeout(() => this.nextQuestion(), this._ms(correct ? 950 : 1700));
    }

    // ---------- áudio ----------

    _playNote(midi, dur = 0.6, when = null) {
        const am = window.audioManager;
        if (!am) return;
        am.resumeContext();
        const t = when !== null ? when : am.now() + 0.05;
        // Piano realista (opt-in) → sample real da nota; senão o tick afinado de sempre.
        if (am.isPianoRealistic && am.isPianoRealistic()) {
            am.playNote(window.PitchUtil.sciFromMidi(midi), dur, { when: t, volume: 0.85 });
        } else {
            am.play('tick', { frequency: window.PitchUtil.frequency(midi), duration: dur, when: t, volume: 0.85 });
        }
        return t;
    }

    /**
     * Toca o intervalo e (se reveal) realça as teclas no tempo.
     * Melódico → 2 notas em sequência; harmônico → as 2 notas no MESMO instante.
     * @param {boolean} reveal  acende as teclas durante o toque (pista visual)
     * @param {object}  [q]     par {rootMidi, targetMidi}; padrão = a pergunta corrente
     * @param {boolean} [harmonic] padrão = o da rodada (o exemplo da tela inicial passa o do nível)
     */
    _playInterval(reveal = true, q = this.currentQuestion, harmonic = this.harmonic) {
        const am = window.audioManager;
        if (!am || !q) return;
        am.resumeContext();
        const dur = 0.6, gap = 0.12;
        const now = am.now();
        const t0 = now + 0.06;
        const t1 = harmonic ? t0 : t0 + dur + gap;
        this._playNote(q.rootMidi, dur, t0);
        this._playNote(q.targetMidi, dur, t1);
        if (reveal) {
            this._flashAt((t0 - now) * 1000, q.rootMidi, '#6366f1', dur * 1000);
            this._flashAt((t1 - now) * 1000, q.targetMidi, '#8b5cf6', dur * 1000);
        }
    }

    _flashAt(delayMs, midi, color, ms) {
        const id = setTimeout(() => { if (this.piano) this.piano.flashKey(midi, color, ms); }, Math.max(0, delayMs));
        this._timers.push(id);
    }

    // ---------- UI: respostas e resultado ----------

    _buildAnswerArea() {
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';

        if (this.answerMode === 'identify') {
            this.generator.enabledIntervals().forEach(iv => {
                const btn = this._makeButton(this._intervalName(iv), 'linear-gradient(135deg,#6366f1,#8b5cf6)',
                    () => this.answerIdentify(iv.code));
                btn.dataset.code = iv.code;
                btn.style.minWidth = '120px';
                this.answersEl.appendChild(btn);
            });
            const replay = this._makeButton(this._t('intervals.repeat'), '#94a3b8',
                () => { if (this.state === 'question') this._playInterval(this.assist); }, { small: true });
            this.extraEl.appendChild(replay);
        } else {
            const hint = document.createElement('span');
            hint.style.color = '#777';
            hint.style.fontSize = '0.9rem';
            hint.textContent = this._t('intervals.buildHint');
            this.answersEl.appendChild(hint);
            const replay = this._makeButton(this._t('intervals.hearBase'), '#94a3b8',
                () => { if (this.currentQuestion && this.state === 'question') this._playNote(this.currentQuestion.rootMidi, 0.6); }, { small: true });
            this.extraEl.appendChild(replay);
        }

        // Parar nos DOIS modos: no sandbox é o único fim do "sem fim"; no ranqueado é
        // como se desiste de uma rodada sem sair do jogo.
        this.extraEl.appendChild(this._buildStopButton());
    }


    /**
     * Descer um degrau — o destino do gesto do aparelho E do botão "Parar".
     *
     * 🔴 No meio da rodada o "voltar" ABANDONA a rodada e devolve a tela inicial, em vez de
     * sair do jogo. Antes o gesto de borda do iOS levava a pessoa para fora do Intervalos com o take
     * morrendo em silêncio — e o ⊞ era o único jeito de voltar.
     */
    _navPopBack() {
        if (this.state === 'question' || this.state === 'feedback') { this._abortRound(); return; }
        this._showStartScreen();
    }

    /** Desiste da rodada: fecha no funil como abandono e volta à tela inicial. Nada é
     *  gravado — rodada interrompida não é resultado comparável. */
    _abortRound() {
        this._clearTimers();
        this._beaconEndRound('quit');
        this._showStartScreen();
    }

    /**
     * Botão "Parar" — agora nos DOIS modos. No ranqueado ele não existia: só dava para
     * abandonar uma rodada saindo do jogo pelo ⊞.
     *
     * 🔴 "two-tap" (1º toque arma, 2º confirma) como na Leitura: o botão fica logo abaixo
     * das respostas e um toque torto mataria a rodada. Sem nada respondido não há o que
     * perder, então para na hora.
     */
    _buildStopButton() {
        const rotulo = () => '⏹ ' + this._t('intervals.stop');
        const stop = this._makeButton(rotulo(), 'linear-gradient(135deg,#64748b,#475569)', () => {
            if (this.history.length > 0 && !this._stopArmed) {
                this._stopArmed = true;
                stop.textContent = '⏹ ' + this._t('intervals.stopConfirm');
                stop.style.background = 'linear-gradient(135deg,#ef4444,#b91c1c)';
                this._timers.push(setTimeout(() => {
                    if (!this._stopArmed || !stop.isConnected) return;
                    this._stopArmed = false;
                    stop.textContent = rotulo();
                    stop.style.background = 'linear-gradient(135deg,#64748b,#475569)';
                }, 2600));
                return;
            }
            this._stopArmed = false;
            // 🔴 Passa pelo `_navBack`, o MESMO caminho do gesto do aparelho: o dedo e o
            // gesto não podem discordar (um deles ficaria sem teste).
            if (this.mode === 'free') this._stopFree();
            else this._navBack();
        }, { small: true });
        stop.style.marginTop = '1.1rem';
        return stop;
    }

    /** Encerra a rodada do sandbox: sem nada respondido volta à config; senão mostra o resultado. */
    _stopFree() {
        this._clearTimers();
        // Voltar à config encerra a rodada no funil também: rodada aberta sobrevive à
        // troca de tela, e deixá-la pendurada faria a PRÓXIMA abertura fechá-la como quit.
        if (this.history.length === 0) { this._beaconEndRound('quit'); this._showStartScreen(); }
        else this.showResults();
    }

    _setAnswersEnabled(enabled) {
        this.answersEl.querySelectorAll('button').forEach(b => {
            b.disabled = !enabled;
            b.style.opacity = enabled ? '1' : '0.5';
            b.style.cursor = enabled ? 'pointer' : 'default';
            // Os botões NÃO são remontados a cada pergunta (só a cada rodada), então a
            // marca da resposta anterior precisa sair na mão — senão fica na tela a
            // pergunta inteira seguinte.
            if (enabled) { b.style.outline = ''; b.style.outlineOffset = ''; }
        });
    }

    /**
     * Diz no BOTÃO o que aconteceu: verde no que era certo, vermelho no que a pessoa
     * apertou quando errou. Sem isto, o único sinal de erro era o texto do status e um
     * `opacity:0.5` aplicado a TODOS os botões — inclusive ao certo, que ficava tão
     * apagado quanto o resto.
     */
    _markAnswerButtons(chosenCode, correctCode) {
        this.answersEl.querySelectorAll('button[data-code]').forEach(b => {
            const c = b.dataset.code;
            if (c !== chosenCode && c !== correctCode) return;   // os outros seguem apagados
            const isRight = c === correctCode;
            b.style.opacity = '1';
            b.style.outline = `3px solid ${isRight ? IntervalGame.COLOR_OK : IntervalGame.COLOR_ERR}`;
            b.style.outlineOffset = '2px';
            if (!window.NoteFx) return;
            if (isRight) window.NoteFx.haloEl(b, IntervalGame.COLOR_OK);
            else window.NoteFx.shakeX(b);
        });
    }

    /** Linha de detalhamento de um intervalo no resultado. */
    _resultRow(h, i) {
        const ok = h.correct;
        const root = this._noteName(window.PitchUtil.letterOf(h.rootMidi));
        const arrow = h.direction === 'down' ? ' ↓' : '';
        const detail = ok
            ? '<span style="color:#10b981;">✔</span>'
            : (h.mode === 'build'
                ? `<span style="color:#ef4444;">${this._t('intervals.youPlayed', { note: this._noteName(window.PitchUtil.letterOf(h.chosenMidi)) })}</span>`
                : `<span style="color:#ef4444;">${this._t('intervals.youMarked', { interval: this._intervalName(h.chosenCode) })}</span>`);
        return `
            <div style="display:flex;justify-content:space-between;align-items:center;padding:0.4rem 0.25rem;border-bottom:1px solid #eee;${ok ? '' : 'opacity:0.85;'}">
                <span style="font-weight:500;">${i + 1}. ${this._intervalName(h.interval)}${arrow} <span style="color:#999;font-size:0.85rem;">${this._t('intervals.base', { root })}</span></span>
                <span style="font-size:0.9rem;">${detail}</span>
            </div>`;
    }

    /**
     * Pós-resultado. Ranked: progressão de nível (desbloqueio + "Próximo nível"). Free:
     * só "Configurar" (volta ao sandbox). Em ambos, "voltar ao menu"/"jogar de novo" vêm
     * da base. _buildCrossLink não cabe aqui (results já tem botões de ação).
     */
    _afterResults(container, btnRow, pct) {
        if (this.mode !== 'ranked') {
            btnRow.appendChild(this._makeButton(this._t('intervals.settings'),
                'linear-gradient(135deg,#0ea5e9,#0284c7)', () => this._showStartScreen()));
            return;
        }

        const levels = IntervalGame.LEVELS;
        const level = levels[this.levelIdx];
        const isLast = this.levelIdx >= levels.length - 1;

        let unlockedNew = false;
        // Re-lê o desbloqueado do STORAGE antes de decidir: login no meio do jogo troca
        // o escopo e a memória fica stale — escrever com ela poderia REGREDIR o
        // desbloqueio de uma conta que já estava à frente (storage = fonte da verdade).
        this.unlocked = this._loadInt(IntervalGame.UNLOCKED_KEY, 0);
        if (pct >= level.pass && !isLast && this.unlocked <= this.levelIdx) {
            this.unlocked = this.levelIdx + 1;
            this._saveInt(IntervalGame.UNLOCKED_KEY, this.unlocked);
            unlockedNew = true;
        }

        if (unlockedNew) {
            const banner = document.createElement('p');
            banner.textContent = this._t('intervals.unlocked');
            banner.style.cssText = 'text-align:center;color:#10b981;font-weight:800;margin:0 0 1rem;';
            container.insertBefore(banner, container.firstChild);
        }

        // Nível sempre visível no resultado — sem isso, dava pra terminar uma rodada
        // sem saber em que nível você estava (só aparecia antes de começar).
        const levelLabel = document.createElement('p');
        levelLabel.innerHTML = this._escape(this._levelHeadline(level))
            + `<span style="display:block;font-weight:600;color:#64748b;margin-top:0.1rem;">`
            + this._escape(this._levelDesc(level)) + `</span>`;
        levelLabel.style.cssText = 'text-align:center;color:#6366f1;font-weight:700;font-size:0.85rem;letter-spacing:0.02em;margin:0 0 0.6rem;';
        container.insertBefore(levelLabel, container.firstChild);

        // 🔴 Quem NÃO bate a meta precisa saber qual era. Antes, a pessoa via "60%", o
        // nível seguinte continuava com cadeado e nada na tela dizia que faltavam 10
        // pontos — o resultado só sabia comemorar.
        if (!isLast && !unlockedNew && this.unlocked <= this.levelIdx && pct < level.pass) {
            const need = document.createElement('p');
            need.textContent = this._t('intervals.needPass', { pass: level.pass });
            need.style.cssText = 'text-align:center;color:#b45309;font-weight:700;margin:0 0 1rem;';
            container.insertBefore(need, container.firstChild);
        }

        this._maybeSaveScore(pct, pct >= level.pass);

        if (!isLast && this.unlocked > this.levelIdx) {
            // Gate ANTES de mexer na UI: cancelar o modal de conta mantém o resultado
            // intacto; o login retoma a sequência completa (avançar + começar rodada).
            const goNext = () => { this._selectLevel(this.levelIdx + 1); this.startRound(); };
            const nb = this._makeButton(this._t('intervals.nextLevel'), 'linear-gradient(135deg,#6366f1,#8b5cf6)',
                () => {
                    if (window.authGate && !window.authGate.allow(this.levelIdx + 2, this._gateCtx(), goNext)) return;
                    goNext();
                });
            btnRow.insertBefore(nb, btnRow.firstChild);
        }
        btnRow.appendChild(this._makeButton(this._t('intervals.chooseLevel'),
            'linear-gradient(135deg,#0ea5e9,#0284c7)', () => this._showStartScreen()));
        // "Voltar ao menu" é o único que SAI do jogo: vai por último, nunca no meio dos
        // botões que continuam o treino (appendChild move o nó que a base já criou).
        const back = btnRow.querySelector('[data-role="back"]');
        if (back) btnRow.appendChild(back);
    }

    /**
     * Grava o resultado do nível no ranking. Espelho do ReadingFlowGame._maybeSaveScore,
     * em DOIS PASSOS: (1) registra SEMPRE no mapa local — os níveis 1-3 são livres
     * (AuthGate.FREE_LEVELS) e sumiriam do ranking por nível se dependessem de conta;
     * (2) envia agora se houver sessão. O que não subiu fica na fila e sobe no login
     * (RankingRepository.syncPending). Fire-and-forget: nunca afeta o jogo.
     *
     * 🔴 NÍVEL 1-BASED na borda (levelIdx+1) — a numeração do servidor e do AuthGate.
     * `accuracy` é a MESMA % que a tela mostra, e `bestMs` o tempo médio de resposta dos
     * acertos, que só desempata DENTRO do nível (mesmo conjunto de intervalos ⇒ comparável).
     */
    _maybeSaveScore(acc, passed) {
        try {
            if (this.mode !== 'ranked') return;
            const prog = window.LevelProgress && window.LevelProgress.get('intervalos');
            if (!prog) return;

            const level = this.levelIdx + 1;
            const bestMs = this._avgReactMs();
            const L = this._curLevel() || {};
            const metrics = {
                v: 1,
                config: {
                    levelIdx: this.levelIdx,
                    intervals: L.intervals,
                    harmonic: !!L.harmonic,
                    answerMode: this.answerMode,
                    assist: !!this.assist
                },
                detail: { correct: this.correctCount, total: this.totalQuestions, reactMs: bestMs }
            };
            const rec = prog.recordBest(level, { accuracy: acc, bestMs, passed, metrics });

            const um = window.userManager;
            if (!um || !um.isLoggedIn() || !window.rankingRepository) return;

            window.rankingRepository
                .saveScore({ gameId: 'intervalos', level, accuracy: acc, bestMs, passed, metrics })
                // `rec.seq` amarra a marcação AO TAKE QUE SUBIU: terminar outra rodada com
                // o request em voo deixa o take novo pendente, em vez de marcá-lo enviado.
                .then(res => { if (res && res.success) prog.markBestSynced(level, rec && rec.seq); })
                .catch(() => {});
        } catch (e) { /* placar é acessório: nunca propaga p/ o jogo */ }
    }

    /** Tempo médio de resposta dos acertos, em ms. null se não acertou nada. */
    _avgReactMs() {
        const r = this._reactMs || [];
        if (!r.length) return null;
        const ms = Math.round(r.reduce((a, b) => a + b, 0) / r.length);
        return Number.isFinite(ms) && ms >= 0 ? ms : null;
    }

    /** Índice 0-based do nível salvo (usado pela ficha do ranking, sem instanciar o jogo). */
    static storedLevelIdx() {
        try {
            const raw = localStorage.getItem(window.StorageScope.key(IntervalGame.LEVEL_KEY));
            const n = parseInt(raw, 10);
            return Number.isFinite(n) ? Math.max(0, Math.min(IntervalGame.LEVELS.length - 1, n)) : 0;
        } catch (e) { return 0; }
    }

    /** Ao entrar em results: solta o realce do piano e o esconde. */
    _cleanupForResults() {
        if (this.piano) { this.piano.clearFeedback(); this.piano.releaseHolds(); }
        if (this.pianoContainer) this.pianoContainer.style.display = 'none';
    }

    // 🔴 `_beforeModeRebuild`/`_afterModeRebuild` foram REMOVIDOS. Eles só rodavam pelo
    // `_setAnswerMode` da base, que por sua vez só era chamado pelo `_buildModeToggle` —
    // e este virou no-op quando a barra de modo saiu da rodada. Ficaram inalcançáveis pelo
    // jogador e vivos só para o teste, que passou a cobrir um caminho que ninguém percorre.
    // A troca de modo hoje é do `_answerModeSeg` da tela inicial, que escreve a preferência
    // e redesenha a tela — não há pergunta no ar para reapresentar.

    // ---------- helpers ----------

    /** Nome localizado do intervalo. Aceita um Interval (usa .code) ou o code (string). */
    _intervalName(intervalOrCode) {
        const code = typeof intervalOrCode === 'string' ? intervalOrCode : (intervalOrCode && intervalOrCode.code);
        return this._t('intervals.names.' + code);
    }

    /** "Nível N · Meta: X%" — a manchete da linha do nível (a lista vem embaixo, menor). */
    _levelHeadline(level) {
        return this._t('intervals.level') + ' ' + (this.levelIdx + 1)
            + ' · ' + this._t('intervals.goal', { pass: level.pass });
    }

    /** Escapa o que vai por `innerHTML`. Os nomes vêm do i18n, mas string de tradução não é
     *  lugar para confiar em conteúdo — escapa-se sempre que texto vira marcação. */
    _escape(txt) {
        return String(txt).replace(/[&<>"']/g, (c) => (
            { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
        ));
    }

    /** Estende a limpeza de timers da base com os timers de realce visual. */
    _clearTimers() {
        super._clearTimers();
        this._timers.forEach(id => clearTimeout(id));
        this._timers = [];
    }

    /** Solta os ouvintes próprios (resize e "voltar") antes da limpeza da base. */
    destroy() {
        clearTimeout(this._resizeTimer);
        if (this._resizeHandler) { window.removeEventListener('resize', this._resizeHandler); this._resizeHandler = null; }
        // 🔴 O degrau empilhado NÃO é desfeito aqui: trocar de jogo pelo ⊞ com uma rodada
        // aberta deixaria um `history.back()` competindo com a navegação de rota. Ele fica
        // órfão e o `_onNavPop` da instância seguinte o reconhece e o pula.
        this._navTeardown();
        window.Beacon?.pauseGameStart(false);
        super.destroy();
    }
}

// Disponibiliza globalmente
window.IntervalGame = IntervalGame;

// Ficha dos Intervalos no ranking (3º jogo ranqueado). 🔴 `levels` converte o índice
// 0-based do jogo para a numeração 1-based do servidor — a conversão vive AQUI, na borda,
// e em nenhum outro lugar. Cresce sozinho quando LEVELS ganhar níveis.
//
// 🔴 Por que isto não podia faltar: o gate de conta já cobrava cadastro no nível 4
// (`authGate.allow`) e o jogo não devolvia NADA em troca — nem linha no #/ranking, nem
// progresso que seguisse a conta ao logar noutro aparelho.
if (window.LevelProgress) {
    window.LevelProgress.register({
        gameId: 'intervalos',
        storageKey: IntervalGame.BEST_KEY,
        nameKey: 'games.intervals.name',
        route: '#/intervalos',
        levels: () => IntervalGame.LEVELS.map((_, i) => i + 1),
        currentLevel: () => IntervalGame.storedLevelIdx() + 1,
        // Sem mundos: a trilha é curta e cresce por um eixo só. O limiar é o do nível.
        levelInfo: (n) => { const l = IntervalGame.LEVELS[n - 1]; return l ? { world: null, pass: l.pass } : null; },
        // Devolução de progresso (login noutro device/browser): chegam os níveis APROVADOS
        // (1-based) e aqui viram o formato DESTE jogo — inteiro 0-based do mais alto
        // liberado. Só SOBE: nunca rebaixa quem já estava à frente localmente.
        applyUnlock: (passed) => {
            if (!Array.isArray(passed) || !passed.length) return;
            const last = IntervalGame.LEVELS.length - 1;
            const key = window.StorageScope.key(IntervalGame.UNLOCKED_KEY);
            const cur = Math.max(0, parseInt(localStorage.getItem(key) || '0', 10) || 0);
            // passou o nível 1-based N ⇒ índice 0-based do próximo é N
            const derived = Math.min(last, Math.max.apply(null, passed));
            if (derived > cur) localStorage.setItem(key, String(derived));
        }
    });
} else if (typeof console !== 'undefined') {
    console.warn('[IntervalGame] LevelProgress ausente — Intervalos fora do ranking. Conferir loadOrder.');
}



// ============================================
// games/ChordGame.js
// ============================================
/**
 * ChordGame - Jogo de Acordes (treino de ouvido: percepção harmônica pura).
 *
 * 4º card de treinamento. Herda o esqueleto de quiz (placar %, fluxo, resultado) de
 * BaseQuizGame; aqui mora só o que é de ACORDE:
 *   - geração via Chord + ChordGenerator + PitchUtil;
 *   - UM modo de resposta: ouvir o acorde e escolher o nome (identificação por ouvido).
 *     Não há "construir no piano" (montar 3-4 notas é outro fluxo — fica p/ o futuro);
 *   - estilo de toque bloco/arpejo = o "harmônico/melódico" do acorde (ajuda pedagógica).
 *
 * DOIS JOGOS (espelha o split do Ritmo/Intervalos: ranqueado ↔ livre):
 *   - mode='ranked' (#/acordes): TRILHA de níveis (ChordGame.LEVELS), desbloqueio por %
 *     de acerto, progresso em localStorage via StorageScope.
 *   - mode='free'   (#/acordes-livre): SANDBOX — o jogador escolhe os acordes, o estilo
 *     (bloco/arpejo), a direção do arpejo (cima/baixo/ambas) e o tamanho (10/20/sem fim).
 *     Sem trilha/desbloqueio. Config salva em localStorage (device pref, sem StorageScope).
 *
 * SEPARAÇÃO: jogo IRMÃO do de Intervalos, não o mesmo. Reusa só fundação compartilhada
 * (PianoKeyboard, AudioManager, PitchUtil, BaseQuizGame); zero acoplamento com Interval*.
 *
 * DICA VISUAL ("assist"): por padrão a pergunta toca SÓ O SOM — o piano não revela as
 * teclas (treino de ouvido real). Um toggle "assist" reativa o brilho durante a pergunta.
 * O feedback (após responder) sempre revela.
 */
class ChordGame extends BaseQuizGame {
    // Trilha de níveis (ranked). Cada nível liga acordes (codes do Chord.CATALOG) + faixa
    // de fundamentais. O gerador clampa a fundamental p/ o acorde caber no piano (C4–C6).
    static LEVELS = [
        { chords: ['maj', 'min'],                                          minRootSci: 'C4', maxRootSci: 'G4', pass: 70 },
        { chords: ['maj', 'min', 'dim'],                                   minRootSci: 'C4', maxRootSci: 'G4', pass: 70 },
        { chords: ['maj', 'min', 'dim', 'aug'],                            minRootSci: 'C4', maxRootSci: 'G4', pass: 75 },
        { chords: ['maj', 'min', 'sus2', 'sus4'],                          minRootSci: 'C4', maxRootSci: 'G4', pass: 75 },
        { chords: ['maj7', '7', 'min7'],                                   minRootSci: 'C4', maxRootSci: 'F4', pass: 75 },
        { chords: ['maj7', '7', 'min7', 'm7b5', 'dim7'],                   minRootSci: 'C4', maxRootSci: 'F4', pass: 78 },
        { chords: ['maj', 'min', 'maj7', '7', 'min7'],                     minRootSci: 'C4', maxRootSci: 'F4', pass: 78 },
        { chords: ['maj9', '9', 'min9'],                                   minRootSci: 'C4', maxRootSci: 'D4', pass: 80 },
        { chords: ['7', '9', '11', '13'],                                  minRootSci: 'C4', maxRootSci: 'D4', pass: 80 },
        { chords: ['maj', 'min', 'maj7', '7', 'min7', 'm7b5', '9', '13'],  minRootSci: 'C4', maxRootSci: 'D4', pass: 82 }
    ];

    // Acordes oferecidos no sandbox (ordem: tríades → 7ªs → extensões).
    static ALL_CODES = ['maj', 'min', 'dim', 'aug', 'sus2', 'sus4', 'maj7', '7', 'min7', 'm7b5', 'dim7', 'maj9', '9', 'min9', '11', '13'];

    static LEVEL_KEY = 'chord_level_v1';        // último nível escolhido (StorageScope)
    static UNLOCKED_KEY = 'chord_unlocked_v1';   // índice do nível mais alto liberado
    static BEST_KEY = 'chord_best_v1';           // melhor take por nível + fila do ranking (LevelProgress)

    // Paleta do feedback, num lugar só. 🔴 ERRO NÃO PINTA A NOTA CERTA: as teclas que
    // acendem depois da resposta são as do acorde QUE TOCOU — pintá-las de vermelho diria
    // "estas notas estão erradas". O vermelho vai para o BOTÃO que a pessoa apertou.
    static COLOR_OK = '#10b981';
    static COLOR_ERR = '#ef4444';
    static COLOR_REVEAL = '#8b5cf6';
    static ASSIST_KEY = 'chord_assist';           // '1' | '0' — pista visual na pergunta
    static STYLE_KEY = 'chord_play_style';         // 'block' | 'arpeggio' (compartilhado ranked/free)
    // sandbox (device prefs, sem StorageScope)
    static FREE_CHORDS_KEY = 'chord_free_chords';  // csv de codes
    static FREE_ARPDIR_KEY = 'chord_free_arpdir';  // 'up' | 'down' | 'both' (só afeta arpejo)
    static FREE_LEN_KEY = 'chord_free_len';        // '10' | '20' | 'inf'

    constructor(opts = {}) {
        super({
            ns: 'chords',
            modeStorageKey: 'chord_answer_mode',
            defaultMode: 'identify',
            modeLabelKey: 'chords.mode',
            modes: [], // modo único (identificar por ouvido) → sem toggle de modo na base
            resultsMaxWidth: 480,
            btnFont: '1.05rem'
        });

        this.mode = opts.mode === 'free' ? 'free' : 'ranked';

        this.pianoContainer = null;
        this.generator = null;
        this.currentQuestion = null;
        this._arpDir = 'up'; // direção do arpejo da pergunta atual (resolvida em _generateAndPresent)

        // piano de 2 oitavas (C4–C6) cobre fundamentais graves + extensões até a 13ª (≤ C6)
        this.pianoRange = { minSci: 'C4', maxSci: 'C6' };

        // progresso da trilha (ranked)
        this.unlocked = this._loadInt(ChordGame.UNLOCKED_KEY, 0);
        this._reconcileUnlocked();
        this.levelIdx = this._clampLevel(this._loadInt(ChordGame.LEVEL_KEY, 0));
        if (this.levelIdx > this.unlocked) this.levelIdx = this.unlocked;
        // Defesa do gate de conta (AuthGate, 1-based): guest não boota acima da fronteira.
        if (window.authGate) this.levelIdx = window.authGate.clampForGuest(this.levelIdx + 1) - 1;

        // preferências compartilhadas
        this.assist = localStorage.getItem(ChordGame.ASSIST_KEY) === '1';
        this.playStyle = localStorage.getItem(ChordGame.STYLE_KEY) || 'block';

        // config do sandbox (free)
        this.freeChords = this._loadFreeChords();
        const dir = localStorage.getItem(ChordGame.FREE_ARPDIR_KEY);
        this.freeArpDir = ['up', 'down', 'both'].includes(dir) ? dir : 'up';
        const len = localStorage.getItem(ChordGame.FREE_LEN_KEY);
        this.freeLen = ['10', '20', 'inf'].includes(len) ? len : '10';

        this._timers = [];
        this._reactMs = [];   // tempo de resposta dos ACERTOS (ms) — desempate do ranking
    }

    async init(container) {
        this.container = container;
        this.generator = new window.ChordGenerator(); // reconfigurado por rodada

        this._navSetup('ch');
        this.setupUI();
        this.setupComponents();
        this._showStartScreen();

        // Retomada pós-OAuth (AuthGate): seleciona o nível pretendido e re-renderiza
        // (o _selectLevel já clampa ao desbloqueado da conta).
        if (this.mode === 'ranked' && window.authGate) {
            const it = window.authGate.takeIntentFor('chords');
            if (it) { this._selectLevel(it.levelNum - 1); this._showStartScreen(); }
        }
    }

    setupUI() {
        const mobile = (window.innerWidth || 1024) < 560;
        const pad = mobile ? '0.75rem' : '1.5rem';
        const title = this.mode === 'free' ? 'chords.freeTitle' : 'chords.title';
        this.container.innerHTML = `
            <div class="chord-game" style="max-width:900px;margin:0 auto;padding:${pad};overflow-x:hidden;">
                <h1 class="game-h1" style="text-align:center;margin-bottom:0.25rem;">${this._t(title)}</h1>
                <p id="ch-progress" style="text-align:center;color:#6366f1;font-weight:600;margin:0.2rem 0;"></p>
                <div class="game-intro" style="display:flex;align-items:center;justify-content:center;gap:0.1rem;margin-bottom:0.5rem;">
                    <p id="ch-status" style="text-align:center;color:#555;min-height:1.5rem;margin:0;"></p>
                </div>
                <div id="piano-container" style="margin:1rem auto;max-width:620px;overflow:hidden;"></div>
                <div id="ch-mode" style="text-align:center;margin:0.5rem 0;font-size:0.9rem;color:#555;"></div>
                <div id="ch-answers" style="text-align:center;margin:0.75rem 0;"></div>
                <div id="ch-extra" style="text-align:center;margin-bottom:0.5rem;"></div>
                <div id="results-container" style="display:none;"></div>
            </div>`;

        // 🔴 O "?" de estreia vai na linha do SUBTÍTULO, NUNCA no h1: `.game-h1` é
        // `display:none` abaixo de 560px (styles.css) — ou seja, some justo no
        // CELULAR, que é onde a ajuda se julga. Ele fica FORA do <p> do status
        // porque _setStatus() escreve por textContent e apagaria o nó a cada
        // pergunta; o invólucro flex segura os dois lado a lado (mesma nota no IntervalGame).
        if (window.HelpDot) {
            window.HelpDot.attach(this.container.querySelector('.game-intro'), 'chords.howto');
        }

        this.statusEl = this.container.querySelector('#ch-status');
        this.progressEl = this.container.querySelector('#ch-progress');
        this.pianoContainer = this.container.querySelector('#piano-container');
        this.modeEl = this.container.querySelector('#ch-mode');
        this.answersEl = this.container.querySelector('#ch-answers');
        this.extraEl = this.container.querySelector('#ch-extra');
        this.resultsContainer = this.container.querySelector('#results-container');
    }

    setupComponents() {
        // Piano só p/ revelar visualmente as notas (assist + feedback). Sem input de resposta.
        this.piano = new window.PianoKeyboard(this.pianoContainer, {
            minSci: this.pianoRange.minSci, maxSci: this.pianoRange.maxSci,
            labelFn: (info) => this._noteName(info.letter)
        });
        this.piano.render();
    }

    // ---------- níveis (ranked) ----------

    _clampLevel(i) { return Math.max(0, Math.min(ChordGame.LEVELS.length - 1, i | 0)); }
    _level(i) { return ChordGame.LEVELS[this._clampLevel(i)]; }
    _curLevel() { return this._level(this.levelIdx); }

    /** Funil (Fase 3b): nível 1-BASED só na trilha ranqueada; no modo livre não há progressão. */
    _beaconLevel() { return this.mode === 'ranked' ? this.levelIdx + 1 : null; }

    _loadInt(key, def) {
        try {
            const raw = window.localStorage && window.localStorage.getItem(window.StorageScope.key(key));
            const n = parseInt(raw, 10);
            return Number.isFinite(n) ? n : def;
        } catch (e) { return def; }
    }

    _saveInt(key, val) {
        try { if (window.localStorage) window.localStorage.setItem(window.StorageScope.key(key), String(val)); }
        catch (e) { /* sem persistência, segue em memória */ }
    }

    /** Define o nível corrente (só até o liberado) e persiste. NÃO re-renderiza. */
    _selectLevel(i) {
        // Re-lê o desbloqueado do STORAGE: login no meio do jogo troca o escopo
        // (StorageScope) e a memória desta instância fica stale — a conta pode ter
        // progresso MENOR que o guest tinha. Storage é a fonte da verdade.
        this.unlocked = this._loadInt(ChordGame.UNLOCKED_KEY, 0);
        this.levelIdx = Math.min(this._clampLevel(i), this.unlocked);
        this._saveInt(ChordGame.LEVEL_KEY, this.levelIdx);
    }

    /**
     * Re-deriva `unlocked` dos MELHORES takes salvos (LevelProgress). Espelho do
     * `ReadingFlowGame._reconcileUnlocked`, e existe pelo mesmo buraco: o desbloqueio só é
     * gravado no fim da rodada e com `!isLast` — quem passou o ÚLTIMO nível da trilha nunca
     * teve o próximo liberado, porque não havia próximo. No dia em que a trilha crescer,
     * essa pessoa abriria o jogo com o nível seguinte TRANCADO.
     * É a regra de sempre aplicada a um recorde que a pessoa JÁ TEM: só sobe, nunca rebaixa,
     * e não dá nível a quem não passou.
     */
    _reconcileUnlocked() {
        try {
            const prog = window.LevelProgress && window.LevelProgress.get('acordes');
            if (!prog) return;
            const bests = prog.getBests();     // { "<nível 1-based>": { acc, passed, … } }
            const last = ChordGame.LEVELS.length - 1;
            Object.keys(bests).forEach((k) => {
                const level = parseInt(k, 10);          // 1-based
                if (!Number.isFinite(level) || level < 1 || level > ChordGame.LEVELS.length) return;
                const rec = bests[k] || {};
                // 🔴 A meta é POR NÍVEL aqui (não há um `UNLOCK_ACC` único como na Leitura):
                // a régua de cada nível é o `pass` dele.
                const meta = ChordGame.LEVELS[level - 1].pass;
                const passou = rec.passed === true || (Number.isFinite(rec.acc) && rec.acc >= meta);
                if (!passou) return;
                // passou o nível 1-based N ⇒ o índice 0-based do próximo é N
                this.unlocked = Math.min(last, Math.max(this.unlocked, level));
            });
            this._saveInt(ChordGame.UNLOCKED_KEY, this.unlocked);
        } catch (e) { /* storage indisponível: segue com o unlocked lido */ }
    }

    /** Contexto deste jogo pro AuthGate (route = retomada pós-OAuth, que perde o hash). */
    _gateCtx() { return { gameId: 'chords', route: '#/acordes' }; }

    /** Descrição do nível = nomes dos acordes habilitados. */
    _levelDesc(level) {
        return level.chords.map(c => this._chordName(c)).join(' · ');
    }

    // ---------- config do sandbox (free) ----------

    _loadFreeChords() {
        let arr = [];
        try {
            const raw = localStorage.getItem(ChordGame.FREE_CHORDS_KEY);
            if (raw) arr = raw.split(',').filter(c => window.Chord.CATALOG[c]);
        } catch (e) { /* ignora */ }
        return arr.length ? arr : ['maj', 'min', '7'];
    }

    _saveFreeChords() {
        try { localStorage.setItem(ChordGame.FREE_CHORDS_KEY, this.freeChords.join(',')); }
        catch (e) { /* segue em memória */ }
    }

    _toggleFreeChord(code) {
        const i = this.freeChords.indexOf(code);
        if (i >= 0) {
            if (this.freeChords.length <= 1) return; // mantém ≥ 1 selecionado
            this.freeChords.splice(i, 1);
        } else {
            this.freeChords.push(code);
        }
        this._saveFreeChords();
        this._showStartScreen();
    }

    // ---------- tela inicial ----------

    _showStartScreen() {
        this._clearTimers();
        this.state = 'idle';
        this.currentQuestion = null;
        if (this.piano) { this.piano.clearFeedback(); this.piano.releaseHolds(); }
        // 🔴 O piano fica À VISTA na tela inicial, no lugar de palco (antes das opções),
        // como a pauta fica no Ritmo e na Leitura — mesma nota no IntervalGame. Aqui ele
        // nunca é resposta: é brinquedo (toca ao tocar) e palco do "Ouvir exemplo".
        if (this.pianoContainer) {
            this.pianoContainer.style.display = '';
            const parent = this.pianoContainer.parentNode;
            if (parent && this.modeEl) parent.insertBefore(this.pianoContainer, this.modeEl);
        }
        this.resultsContainer.style.display = 'none';
        this.resultsContainer.innerHTML = '';
        this.modeEl.innerHTML = '';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';
        this._exampleIdx = 0;
        // Som da vitrine (tecla solta, exemplo) NÃO é "começou o jogo" no funil.
        window.Beacon?.pauseGameStart(true);

        if (this.mode === 'free') this._showFreeStart();
        else this._showRankedStart();
        // Raiz do "voltar": daqui o gesto do aparelho SAI do jogo, como em qualquer tela
        // de topo. Chamado no fim porque consumir o degrau pode disparar um `popstate`.
        this._navEnter(true);
    }

    _showRankedStart() {
        const level = this._curLevel();
        // A meta vai JUNTO do nível: é o número que decide se o próximo cadeado abre, e
        // antes ele não aparecia em lugar nenhum.
        // 🔴 DUAS LINHAS, a de baixo em corpo menor. Numa linha só, MEDIDO a 360px, o nível
        // mais carregado dava 4 linhas em PT/EN e 5 em ES — um bloco roxo entre o título e o
        // botão Começar. O que a pessoa lê primeiro é "que nível, que meta"; a lista do que
        // vai cair é referência, não manchete.
        this.progressEl.innerHTML = this._escape(this._levelHeadline(level))
            + `<span style="display:block;font-size:0.8rem;font-weight:600;color:#64748b;margin-top:0.1rem;">`
            + this._escape(this._levelDesc(level)) + `</span>`;
        this._setStatus(this._t('chords.subtitle'));

        this.answersEl.appendChild(this._makeButton(this._t('chords.start'),
            'linear-gradient(135deg,#10b981,#059669)', () => this.startRound()));
        this.answersEl.appendChild(this._buildExampleButton());

        this.extraEl.appendChild(this._buildLevelPicker());
        this.extraEl.appendChild(this._buildOptionsRow());
        this.extraEl.appendChild(this._buildCrossLink());
    }

    _showFreeStart() {
        this.progressEl.textContent = '';
        this._setStatus(this._t('chords.freeSubtitle'));

        this.answersEl.appendChild(this._makeButton(this._t('chords.start'),
            'linear-gradient(135deg,#10b981,#059669)', () => this.startRound()));
        this.answersEl.appendChild(this._buildExampleButton());

        this.extraEl.appendChild(this._buildFreeConfig());
        this.extraEl.appendChild(this._buildCrossLink());
    }

    /**
     * Fileira de botões 1..N (`LevelPill`: número sempre visível, trancado = apagado,
     * melhor % embaixo). O melhor take vem do MESMO registro que alimenta o ranking
     * (`LevelProgress`), chave 1-based — não há segunda cópia do placar.
     */
    _buildLevelPicker() {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'display:flex;justify-content:center;gap:0.4rem;flex-wrap:wrap;margin:0.6rem 0;';
        const prog = window.LevelProgress && window.LevelProgress.get('acordes');
        const bests = prog ? prog.getBests() : {};
        ChordGame.LEVELS.forEach((lv, i) => {
            const locked = i > this.unlocked;
            const active = i === this.levelIdx;
            const b = window.LevelPill.make({
                n: i + 1, locked, active, best: bests[String(i + 1)] || null,
                title: locked ? this._t('chords.locked') : `${this._t('chords.level')} ${i + 1}`
            });
            if (!locked) b.addEventListener('click', () => {
                // Gate de conta (nível 4+ anônimo): bloqueado → modal abre e nada muta;
                // o login retoma a sequência completa (selecionar + re-render).
                const go = () => { this._selectLevel(i); this._showStartScreen(); };
                if (window.authGate && !window.authGate.allow(i + 1, this._gateCtx(), go)) return;
                go();
            });
            wrap.appendChild(b);
        });
        // 🔴 O "?" do portão vai colado a um RÓTULO, como todo "?" do sistema (§1:
        // "sempre à direita do rótulo do grupo"). Solto sob a grade ele caía em três
        // posições diferentes — e em Acordes chegava a ler como um NÍVEL a mais, do
        // mesmo tamanho e forma dos cadeados. Um "?" sem rótulo não responde "ajuda
        // sobre o quê?", e quem tem 70 anos não toca no que não tem nome.
        const gateRow = document.createElement('div');
        gateRow.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:0.1rem;margin-top:0.2rem;';
        const gateLab = document.createElement('span');
        gateLab.textContent = (window.language ? window.language.t('help.levelsLabel') : 'Níveis:');
        gateLab.style.cssText = 'color:#64748b;font-size:0.9rem;';
        gateRow.appendChild(gateLab);
        if (window.HelpDot) window.HelpDot.attach(gateRow, 'app.levelGate');
        wrap.appendChild(gateRow);
        return wrap;
    }

    /** "🔊 Ouvir exemplo": irmão menor do Começar (mesma nota no IntervalGame). */
    _buildExampleButton() {
        const b = this._makeButton(this._t('chords.hearExample'), 'linear-gradient(135deg,#0ea5e9,#0284c7)',
            () => this._playExample(), { small: true });
        b.dataset.role = 'example';
        return b;
    }

    /**
     * Toca UM acorde do que a rodada vai cobrar — a cada toque, o próximo da lista (nível
     * ranqueado ou chips do sandbox), acendendo as teclas e escrevendo o nome: "menor soa
     * ASSIM". Fundamental fixa em Dó (o exemplo é para ouvir a cor, não a altura) e no
     * estilo escolhido (Junto/Arpejo), para o seletor mostrar o que faz.
     */
    _playExample() {
        if (this.state !== 'idle') return;
        const codes = this.mode === 'free' ? this.freeChords : this._curLevel().chords;
        if (!codes.length) return;
        const code = codes[this._exampleIdx % codes.length];
        this._exampleIdx++;
        const notes = window.Chord.fromCode(code).apply(60);
        this._arpDir = 'up';
        this._clearTimers();
        if (this.piano) this.piano.clearFeedback();
        this._setStatus(this._t('chords.exampleIs', { chord: this._chordName(code) }));
        this._playChord(true, notes);
        const back = this.mode === 'free' ? 'chords.freeSubtitle' : 'chords.subtitle';
        this._timers.push(setTimeout(() => { if (this.state === 'idle') this._setStatus(this._t(back)); }, 2000));
    }

    /** Opções do ranqueado: pista visual (assist) + estilo de toque (bloco/arpejo). */
    _buildOptionsRow() {
        const row = document.createElement('div');
        row.style.cssText = 'display:flex;justify-content:center;gap:1.2rem;flex-wrap:wrap;align-items:center;margin-top:0.5rem;font-size:0.9rem;';
        row.appendChild(this._assistSeg());
        row.appendChild(this._styleSeg());
        return row;
    }

    /** Painel de configuração do sandbox (chips de acorde + toggles + tamanho). */
    _buildFreeConfig() {
        const box = document.createElement('div');
        box.style.cssText = 'max-width:580px;margin:0.4rem auto 0;';

        // chips de acorde
        const lbl = document.createElement('p');
        lbl.textContent = this._t('chords.pickChords');
        lbl.style.cssText = 'color:#64748b;font-size:0.9rem;margin:0.3rem 0;';
        box.appendChild(lbl);

        const chips = document.createElement('div');
        chips.style.cssText = 'display:flex;justify-content:center;gap:0.35rem;flex-wrap:wrap;margin-bottom:0.7rem;';
        ChordGame.ALL_CODES.forEach(code => {
            const on = this.freeChords.includes(code);
            const b = document.createElement('button');
            b.type = 'button';
            b.textContent = this._chordName(code);
            b.dataset.code = code;
            // min-height 44px: o alvo de dedo do projeto. Medido, o chip saía com 32px.
            b.style.cssText = `padding:0.4rem 0.7rem;min-height:44px;border-radius:999px;font-weight:700;font-size:0.8rem;cursor:pointer;
                border:2px solid ${on ? '#6366f1' : '#e2e8f0'};background:${on ? '#eef2ff' : '#fff'};color:${on ? '#4f46e5' : '#64748b'};`;
            b.addEventListener('click', () => this._toggleFreeChord(code));
            chips.appendChild(b);
        });
        box.appendChild(chips);

        // toggles
        const segs = document.createElement('div');
        segs.style.cssText = 'display:flex;justify-content:center;gap:1rem;flex-wrap:wrap;align-items:center;font-size:0.9rem;';

        segs.appendChild(this._styleSeg());

        // direção do arpejo (só relevante no arpejo)
        segs.appendChild(this._labeledSeg(this._t('chords.arpDir'), [
            ['up', this._t('chords.dirUp')],
            ['down', this._t('chords.dirDown')],
            ['both', this._t('chords.dirBoth')]
        ], this.freeArpDir, (v) => {
            this.freeArpDir = v;
            localStorage.setItem(ChordGame.FREE_ARPDIR_KEY, v);
            this._showStartScreen();
        }));

        // tamanho
        segs.appendChild(this._labeledSeg(this._t('chords.length'), [
            ['10', '10'],
            ['20', '20'],
            ['inf', this._t('chords.endless')]
        ], this.freeLen, (v) => {
            this.freeLen = v;
            localStorage.setItem(ChordGame.FREE_LEN_KEY, v);
            this._showStartScreen();
        }));

        segs.appendChild(this._assistSeg());
        box.appendChild(segs);
        return box;
    }

    _assistSeg() {
        return this._labeledSeg(this._t('chords.assist'), [
            ['0', this._t('chords.assistOff')],
            ['1', this._t('chords.assistOn')]
        ], this.assist ? '1' : '0', (v) => {
            this.assist = v === '1';
            localStorage.setItem(ChordGame.ASSIST_KEY, v);
            this._showStartScreen();
        }, 'chords.assist');   // alias de intervals.assist: um corpo, duas âncoras
    }

    _styleSeg() {
        return this._labeledSeg(this._t('chords.style'), [
            ['block', this._t('chords.styleBlock')],
            ['arpeggio', this._t('chords.styleArpeggio')]
        ], this.playStyle, (v) => {
            this.playStyle = v;
            localStorage.setItem(ChordGame.STYLE_KEY, v);
            this._showStartScreen();
        }, 'chords.play');
    }

    /** Rótulo + toggle segmentado (lista [valor,label], valor atual, callback). */
    /** Rótulo + toggle segmentado. `helpTopic` pendura o "?" NO RÓTULO do grupo —
     *  um por DÚVIDA, nunca um por botão. */
    _labeledSeg(label, items, current, onChange, helpTopic = null) {
        const w = document.createElement('div');
        w.style.cssText = 'display:inline-flex;gap:0.35rem;align-items:center;';
        const lab = document.createElement('span');
        lab.textContent = label;
        lab.style.color = '#64748b';
        w.appendChild(lab);
        if (helpTopic && window.HelpDot) window.HelpDot.attach(w, helpTopic);

        const seg = document.createElement('div');
        seg.dataset.segmented = '1';   // endereço do controle (o "?" do grupo é <button> e não pode entrar na contagem)
        seg.style.cssText = 'display:inline-flex;border:2px solid #e2e8f0;border-radius:999px;overflow:hidden;';
        items.forEach(([val, text]) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.textContent = text;
            const on = val === current;
            // min-height 44px: medido, o segmento saía com 29px — metade do alvo, e logo
            // ao lado de um "?" de 44px (o ajudante maior que o controle que ele explica).
            b.style.cssText = `padding:0.4rem 0.85rem;min-height:44px;border:none;cursor:pointer;font-weight:700;font-size:0.85rem;
                background:${on ? '#6366f1' : 'transparent'};color:${on ? '#fff' : '#475569'};`;
            b.addEventListener('click', () => onChange(val));
            seg.appendChild(b);
        });
        w.appendChild(seg);
        return w;
    }

    /** Link p/ o jogo irmão (chip): ranked → "⚙️ Modo livre"; free → "🏆 Níveis". */
    _buildCrossLink() {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'margin-top:1rem;text-align:center;';
        const link = document.createElement('button');
        link.type = 'button';
        link.className = 'rhythm-crosslink';
        const toFree = this.mode === 'ranked';
        link.textContent = this._t(toFree ? 'chords.toFreeMode' : 'chords.toRankedMode');
        link.addEventListener('click', () => { window.location.hash = toFree ? '#/acordes-livre' : '#/acordes'; });
        wrap.appendChild(link);
        // "Trilha × livre" é a dúvida que o chip levanta: ele oferece a troca sem
        // dizer o que muda. Mesmo tópico nos jogos que têm o par.
        if (window.HelpDot) window.HelpDot.attach(wrap, 'app.freeMode');
        return wrap;
    }

    // ---------- ganchos do BaseQuizGame ----------

    /** Modo único → sem toggle de modo na barra (override do gancho da base). */
    _buildModeToggle() { if (this.modeEl) this.modeEl.innerHTML = ''; }

    /** Início da rodada: aplica nível/sandbox ao gerador e mostra o piano. */
    _prepareRoundUI() {
        const ceil = window.PitchUtil.midiFromSci(this.pianoRange.maxSci);
        if (this.mode === 'free') {
            this.totalQuestions = this.freeLen === 'inf' ? Infinity : parseInt(this.freeLen, 10);
            this.generator = new window.ChordGenerator({
                chords: this.freeChords, minRootSci: 'C4', maxRootSci: 'G4', maxTopMidi: ceil
            });
        } else {
            const level = this._curLevel();
            this.totalQuestions = 10;
            this.generator = new window.ChordGenerator({
                chords: level.chords, minRootSci: level.minRootSci, maxRootSci: level.maxRootSci, maxTopMidi: ceil
            });
        }
        if (this.pianoContainer) this.pianoContainer.style.display = '';
        this._reactMs = [];
        this._orderPlayArea();
        window.Beacon?.pauseGameStart(false);   // daqui em diante o 1º som É jogar
        // Um degrau abaixo da tela inicial. O resultado NÃO empilha outro (profundidade 1):
        // do resultado, um "voltar" devolve a tela inicial, não a rodada que já acabou.
        this._navEnter(false);
    }

    /**
     * Os botões de resposta vêm ANTES do piano. Aqui o teclado nunca recebe toque (é só
     * reveladora) e, com a pista visual desligada — o padrão —, ele fica 100% apagado
     * durante a pergunta: eram 80px medidos de faixa branca entre o enunciado e a
     * resposta, no melhor lugar do celular.
     */
    _orderPlayArea() {
        if (!this.pianoContainer || !this.resultsContainer) return;
        const parent = this.pianoContainer.parentNode;
        // Vai para o FIM (depois do "Repetir"): as duas coisas que a pessoa toca — os
        // botões de resposta e o replay — ficam juntas no alto.
        if (parent) parent.insertBefore(this.pianoContainer, this.resultsContainer);
    }

    /** Sorteia e apresenta o acorde. */
    _generateAndPresent() {
        this.currentQuestion = this.generator.generate();
        // Relógio da resposta: alimenta o `best_ms` do ranking (desempate DENTRO do nível).
        this._askedAt = Date.now();
        // direção do arpejo desta pergunta (ranked = sempre cima; free 'both' = sorteia)
        const dir = this.mode === 'free' ? this.freeArpDir : 'up';
        this._arpDir = dir === 'both' ? (Math.random() < 0.5 ? 'up' : 'down') : dir;
        if (this.piano) { this.piano.clearFeedback(); this.piano.releaseHolds(); }
        this._setStatus(this._t('chords.identifyPrompt'));
        this._setAnswersEnabled(true);
        this._playChord(this.assist); // só revela teclas se a pista visual estiver ligada
    }

    // ---------- resposta ----------

    answer(code) {
        if (this.state !== 'question' || this.answered) return;
        const q = this.currentQuestion;
        const correct = code === q.chord.code;

        this.answered = true;
        this.state = 'feedback';
        this._setAnswersEnabled(false);
        if (correct) {
            this.correctCount++;
            if (this._askedAt) this._reactMs.push(Date.now() - this._askedAt);
        }
        this.history.push({
            chord: q.chord, rootMidi: q.rootMidi, notes: q.notes, chosenCode: code, correct
        });

        // realça as notas ouvidas: verde no acerto, cor de REVELAÇÃO no erro (as notas
        // não estão erradas — quem errou foi o botão, e é lá que o vermelho aparece).
        const color = correct ? ChordGame.COLOR_OK : ChordGame.COLOR_REVEAL;
        q.notes.forEach(m => this.piano.flashKey(m, color, 1500));
        this._markAnswerButtons(code, q.chord.code);

        const name = this._chordName(q.chord);
        this._setStatus(correct
            ? this._t('chords.correct', { chord: name })
            : this._t('chords.wrong', { chord: name }));

        this._playChord(true); // reforço auditivo (feedback SEMPRE revela)
        window.audioManager.play(correct ? 'correct' : 'wrong');
        this._advanceTimer = setTimeout(() => this.nextQuestion(), this._ms(correct ? 1000 : 1800));
    }

    // ---------- áudio ----------

    _playNote(midi, dur, when) {
        const am = window.audioManager;
        if (!am) return;
        am.resumeContext();
        // Piano realista (opt-in) → sample real da nota; senão o tick afinado de sempre.
        if (am.isPianoRealistic && am.isPianoRealistic()) {
            am.playNote(window.PitchUtil.sciFromMidi(midi), dur, { when, volume: 0.7 });
        } else {
            am.play('tick', { frequency: window.PitchUtil.frequency(midi), duration: dur, when, volume: 0.7 });
        }
    }

    /**
     * Toca o acorde e (se reveal) realça as teclas no tempo.
     * block → todas as notas no MESMO instante; arpeggio → em sequência, sustentando
     * (cada nota dura até o fim → ao final soam juntas, como um acorde "rolado"). A
     * direção (this._arpDir) só afeta a ORDEM do arpejo — as notas são as mesmas.
     * @param {boolean} reveal  acende as teclas durante o toque (pista visual)
     * @param {number[]} [notes] midis a tocar; padrão = os da pergunta corrente
     */
    _playChord(reveal = true, notes = this.currentQuestion && this.currentQuestion.notes) {
        const am = window.audioManager;
        if (!am || !notes) return;
        am.resumeContext();
        const now = am.now();
        const t0 = now + 0.06;
        const arp = this.playStyle === 'arpeggio';
        const gap = arp ? 0.16 : 0;
        const order = (arp && this._arpDir === 'down') ? notes.slice().reverse() : notes;
        const total = arp ? (order.length - 1) * gap + 0.9 : 1.0;

        order.forEach((midi, i) => {
            const at = t0 + i * gap;
            const dur = arp ? (total - i * gap) : 1.0; // arpejo sustenta até o fim
            this._playNote(midi, dur, at);
            if (reveal) this._flashAt((at - now) * 1000, midi, '#8b5cf6', Math.max(600, dur * 1000));
        });
    }

    _flashAt(delayMs, midi, color, ms) {
        const id = setTimeout(() => { if (this.piano) this.piano.flashKey(midi, color, ms); }, Math.max(0, delayMs));
        this._timers.push(id);
    }

    // ---------- UI: respostas e resultado ----------

    _buildAnswerArea() {
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';

        // um botão por acorde habilitado (cresce sozinho conforme o nível/seleção)
        this.generator.enabledChords().forEach(ch => {
            const btn = this._makeButton(this._chordName(ch), 'linear-gradient(135deg,#6366f1,#8b5cf6)',
                () => this.answer(ch.code));
            btn.dataset.code = ch.code;
            btn.style.minWidth = '120px';
            this.answersEl.appendChild(btn);
        });

        const replay = this._makeButton(this._t('chords.repeat'), '#94a3b8',
            () => { if (this.state === 'question') this._playChord(this.assist); }, { small: true });
        this.extraEl.appendChild(replay);

        // Parar nos DOIS modos: no sandbox é o único fim do "sem fim"; no ranqueado é
        // como se desiste de uma rodada sem sair do jogo.
        this.extraEl.appendChild(this._buildStopButton());
    }


    /**
     * Descer um degrau — o destino do gesto do aparelho E do botão "Parar".
     *
     * 🔴 No meio da rodada o "voltar" ABANDONA a rodada e devolve a tela inicial, em vez de
     * sair do jogo. Antes o gesto de borda do iOS levava a pessoa para fora do Acordes com o take
     * morrendo em silêncio — e o ⊞ era o único jeito de voltar.
     */
    _navPopBack() {
        if (this.state === 'question' || this.state === 'feedback') { this._abortRound(); return; }
        this._showStartScreen();
    }

    /** Desiste da rodada: fecha no funil como abandono e volta à tela inicial. Nada é
     *  gravado — rodada interrompida não é resultado comparável. */
    _abortRound() {
        this._clearTimers();
        this._beaconEndRound('quit');
        this._showStartScreen();
    }

    /**
     * Botão "Parar" — agora nos DOIS modos. No ranqueado ele não existia: só dava para
     * abandonar uma rodada saindo do jogo pelo ⊞.
     *
     * 🔴 "two-tap" (1º toque arma, 2º confirma) como na Leitura: o botão fica logo abaixo
     * das respostas e um toque torto mataria a rodada. Sem nada respondido não há o que
     * perder, então para na hora.
     */
    _buildStopButton() {
        const rotulo = () => '⏹ ' + this._t('chords.stop');
        const stop = this._makeButton(rotulo(), 'linear-gradient(135deg,#64748b,#475569)', () => {
            if (this.history.length > 0 && !this._stopArmed) {
                this._stopArmed = true;
                stop.textContent = '⏹ ' + this._t('chords.stopConfirm');
                stop.style.background = 'linear-gradient(135deg,#ef4444,#b91c1c)';
                this._timers.push(setTimeout(() => {
                    if (!this._stopArmed || !stop.isConnected) return;
                    this._stopArmed = false;
                    stop.textContent = rotulo();
                    stop.style.background = 'linear-gradient(135deg,#64748b,#475569)';
                }, 2600));
                return;
            }
            this._stopArmed = false;
            // 🔴 Passa pelo `_navBack`, o MESMO caminho do gesto do aparelho: o dedo e o
            // gesto não podem discordar (um deles ficaria sem teste).
            if (this.mode === 'free') this._stopFree();
            else this._navBack();
        }, { small: true });
        stop.style.marginTop = '1.1rem';
        return stop;
    }

    /** Encerra a rodada do sandbox: sem nada respondido volta à config; senão mostra o resultado. */
    _stopFree() {
        this._clearTimers();
        // Voltar à config encerra a rodada no funil também: rodada aberta sobrevive à
        // troca de tela, e deixá-la pendurada faria a PRÓXIMA abertura fechá-la como quit.
        if (this.history.length === 0) { this._beaconEndRound('quit'); this._showStartScreen(); }
        else this.showResults();
    }

    _setAnswersEnabled(enabled) {
        this.answersEl.querySelectorAll('button').forEach(b => {
            b.disabled = !enabled;
            b.style.opacity = enabled ? '1' : '0.5';
            b.style.cursor = enabled ? 'pointer' : 'default';
            // Os botões só são remontados a cada RODADA: a marca da resposta anterior
            // precisa sair na mão, senão fica na tela a pergunta inteira seguinte.
            if (enabled) { b.style.outline = ''; b.style.outlineOffset = ''; }
        });
    }

    /**
     * Diz no BOTÃO o que aconteceu: verde no certo, vermelho no que a pessoa apertou
     * quando errou. Antes, o único sinal era o texto do status — e o `opacity:0.5`
     * apagava TODOS os botões, inclusive o certo. (Espelho do IntervalGame.)
     */
    _markAnswerButtons(chosenCode, correctCode) {
        this.answersEl.querySelectorAll('button[data-code]').forEach(b => {
            const c = b.dataset.code;
            if (c !== chosenCode && c !== correctCode) return;   // os outros seguem apagados
            const isRight = c === correctCode;
            b.style.opacity = '1';
            b.style.outline = `3px solid ${isRight ? ChordGame.COLOR_OK : ChordGame.COLOR_ERR}`;
            b.style.outlineOffset = '2px';
            if (!window.NoteFx) return;
            if (isRight) window.NoteFx.haloEl(b, ChordGame.COLOR_OK);
            else window.NoteFx.shakeX(b);
        });
    }

    /** Linha de detalhamento de um acorde no resultado. */
    _resultRow(h, i) {
        const ok = h.correct;
        const root = this._noteName(window.PitchUtil.letterOf(h.rootMidi));
        const detail = ok
            ? '<span style="color:#10b981;">✔</span>'
            : `<span style="color:#ef4444;">${this._t('chords.youMarked', { chord: this._chordName(h.chosenCode) })}</span>`;
        return `
            <div style="display:flex;justify-content:space-between;align-items:center;padding:0.4rem 0.25rem;border-bottom:1px solid #eee;${ok ? '' : 'opacity:0.85;'}">
                <span style="font-weight:500;">${i + 1}. ${this._chordName(h.chord)} <span style="color:#999;font-size:0.85rem;">${this._t('chords.base', { root })}</span></span>
                <span style="font-size:0.9rem;">${detail}</span>
            </div>`;
    }

    /**
     * Pós-resultado. Ranked: progressão de nível (desbloqueio + "Próximo nível"). Free:
     * só "Configurar" (volta ao sandbox). "voltar ao menu"/"jogar de novo" vêm da base.
     */
    _afterResults(container, btnRow, pct) {
        if (this.mode !== 'ranked') {
            btnRow.appendChild(this._makeButton(this._t('chords.settings'),
                'linear-gradient(135deg,#0ea5e9,#0284c7)', () => this._showStartScreen()));
            return;
        }

        const levels = ChordGame.LEVELS;
        const level = levels[this.levelIdx];
        const isLast = this.levelIdx >= levels.length - 1;

        let unlockedNew = false;
        // Re-lê o desbloqueado do STORAGE antes de decidir: login no meio do jogo troca
        // o escopo e a memória fica stale — escrever com ela poderia REGREDIR o
        // desbloqueio de uma conta que já estava à frente (storage = fonte da verdade).
        this.unlocked = this._loadInt(ChordGame.UNLOCKED_KEY, 0);
        if (pct >= level.pass && !isLast && this.unlocked <= this.levelIdx) {
            this.unlocked = this.levelIdx + 1;
            this._saveInt(ChordGame.UNLOCKED_KEY, this.unlocked);
            unlockedNew = true;
        }

        if (unlockedNew) {
            const banner = document.createElement('p');
            banner.textContent = this._t('chords.unlocked');
            banner.style.cssText = 'text-align:center;color:#10b981;font-weight:800;margin:0 0 1rem;';
            container.insertBefore(banner, container.firstChild);
        }

        // Nível sempre visível no resultado — sem isso, dava pra terminar uma rodada
        // sem saber em que nível você estava (só aparecia antes de começar).
        const levelLabel = document.createElement('p');
        levelLabel.innerHTML = this._escape(this._levelHeadline(level))
            + `<span style="display:block;font-weight:600;color:#64748b;margin-top:0.1rem;">`
            + this._escape(this._levelDesc(level)) + `</span>`;
        levelLabel.style.cssText = 'text-align:center;color:#6366f1;font-weight:700;font-size:0.85rem;letter-spacing:0.02em;margin:0 0 0.6rem;';
        container.insertBefore(levelLabel, container.firstChild);

        // 🔴 Quem NÃO bate a meta precisa saber qual era: antes via "60%", o cadeado
        // seguinte continuava fechado e nada dizia que faltavam 10 pontos.
        if (!isLast && !unlockedNew && this.unlocked <= this.levelIdx && pct < level.pass) {
            const need = document.createElement('p');
            need.textContent = this._t('chords.needPass', { pass: level.pass });
            need.style.cssText = 'text-align:center;color:#b45309;font-weight:700;margin:0 0 1rem;';
            container.insertBefore(need, container.firstChild);
        }

        this._maybeSaveScore(pct, pct >= level.pass);

        if (!isLast && this.unlocked > this.levelIdx) {
            // Gate ANTES de mexer na UI: cancelar o modal de conta mantém o resultado
            // intacto; o login retoma a sequência completa (avançar + começar rodada).
            const goNext = () => { this._selectLevel(this.levelIdx + 1); this.startRound(); };
            const nb = this._makeButton(this._t('chords.nextLevel'), 'linear-gradient(135deg,#6366f1,#8b5cf6)',
                () => {
                    if (window.authGate && !window.authGate.allow(this.levelIdx + 2, this._gateCtx(), goNext)) return;
                    goNext();
                });
            btnRow.insertBefore(nb, btnRow.firstChild);
        }
        btnRow.appendChild(this._makeButton(this._t('chords.chooseLevel'),
            'linear-gradient(135deg,#0ea5e9,#0284c7)', () => this._showStartScreen()));
        // "Voltar ao menu" é o único que SAI do jogo: vai por último, nunca no meio dos
        // botões que continuam o treino (appendChild move o nó que a base já criou).
        const back = btnRow.querySelector('[data-role="back"]');
        if (back) btnRow.appendChild(back);
    }

    /**
     * Grava o resultado do nível no ranking. Espelho do IntervalGame/ReadingFlowGame, em
     * DOIS PASSOS: (1) registra SEMPRE no mapa local (os níveis 1-3 são livres e sumiriam
     * do ranking por nível se dependessem de conta); (2) envia agora se houver sessão. O
     * que não subiu fica na fila e sobe no login. Fire-and-forget: nunca afeta o jogo.
     */
    _maybeSaveScore(acc, passed) {
        try {
            if (this.mode !== 'ranked') return;
            const prog = window.LevelProgress && window.LevelProgress.get('acordes');
            if (!prog) return;

            const level = this.levelIdx + 1;
            const bestMs = this._avgReactMs();
            const L = this._curLevel() || {};
            const metrics = {
                v: 1,
                config: {
                    levelIdx: this.levelIdx,
                    chords: L.chords,
                    // O estilo é preferência do jogador e muda a dificuldade (arpejo dá
                    // tempo de ouvir nota a nota): registrar o que foi DE FATO jogado,
                    // mesmo espírito do `bpm` real do Ritmo.
                    style: this.playStyle,
                    assist: !!this.assist
                },
                detail: { correct: this.correctCount, total: this.totalQuestions, reactMs: bestMs }
            };
            const rec = prog.recordBest(level, { accuracy: acc, bestMs, passed, metrics });

            const um = window.userManager;
            if (!um || !um.isLoggedIn() || !window.rankingRepository) return;

            window.rankingRepository
                .saveScore({ gameId: 'acordes', level, accuracy: acc, bestMs, passed, metrics })
                .then(res => { if (res && res.success) prog.markBestSynced(level, rec && rec.seq); })
                .catch(() => {});
        } catch (e) { /* placar é acessório: nunca propaga p/ o jogo */ }
    }

    /** Tempo médio de resposta dos acertos, em ms. null se não acertou nada. */
    _avgReactMs() {
        const r = this._reactMs || [];
        if (!r.length) return null;
        const ms = Math.round(r.reduce((a, b) => a + b, 0) / r.length);
        return Number.isFinite(ms) && ms >= 0 ? ms : null;
    }

    /** Índice 0-based do nível salvo (usado pela ficha do ranking, sem instanciar o jogo). */
    static storedLevelIdx() {
        try {
            const raw = localStorage.getItem(window.StorageScope.key(ChordGame.LEVEL_KEY));
            const n = parseInt(raw, 10);
            return Number.isFinite(n) ? Math.max(0, Math.min(ChordGame.LEVELS.length - 1, n)) : 0;
        } catch (e) { return 0; }
    }

    /** Ao entrar em results: solta o realce do piano e o esconde. */
    _cleanupForResults() {
        if (this.piano) { this.piano.clearFeedback(); this.piano.releaseHolds(); }
        if (this.pianoContainer) this.pianoContainer.style.display = 'none';
    }

    // ---------- helpers ----------

    /** Nome localizado do acorde. Aceita um Chord (usa .code) ou o code (string). */
    _chordName(chordOrCode) {
        const code = typeof chordOrCode === 'string' ? chordOrCode : (chordOrCode && chordOrCode.code);
        return this._t('chords.names.' + code);
    }

    /** "Nível N · Meta: X%" — a manchete da linha do nível (a lista vem embaixo, menor). */
    _levelHeadline(level) {
        return this._t('chords.level') + ' ' + (this.levelIdx + 1)
            + ' · ' + this._t('chords.goal', { pass: level.pass });
    }

    /** Escapa o que vai por `innerHTML`. Os nomes vêm do i18n, mas string de tradução não é
     *  lugar para confiar em conteúdo — escapa-se sempre que texto vira marcação. */
    _escape(txt) {
        return String(txt).replace(/[&<>"']/g, (c) => (
            { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
        ));
    }

    /** Estende a limpeza de timers da base com os timers de realce visual. */
    _clearTimers() {
        super._clearTimers();
        this._timers.forEach(id => clearTimeout(id));
        this._timers = [];
    }

    /** Solta o ouvinte do "voltar" antes da limpeza da base.
     *  🔴 O degrau empilhado NÃO é desfeito aqui: trocar de jogo pelo ⊞ com uma rodada
     *  aberta deixaria um `history.back()` competindo com a navegação de rota. Ele fica
     *  órfão e o `_onNavPop` da instância seguinte o reconhece e o pula. */
    destroy() {
        this._navTeardown();
        window.Beacon?.pauseGameStart(false);
        super.destroy();
    }
}

// Disponibiliza globalmente
window.ChordGame = ChordGame;

// Ficha dos Acordes no ranking (4º jogo ranqueado). 🔴 `levels` converte o índice 0-based
// do jogo para a numeração 1-based do servidor — a conversão vive AQUI, na borda.
//
// 🔴 Por que isto não podia faltar: o gate de conta já cobrava cadastro no nível 4 e o
// jogo não devolvia nada em troca — nem linha no #/ranking, nem progresso seguindo a conta.
if (window.LevelProgress) {
    window.LevelProgress.register({
        gameId: 'acordes',
        storageKey: ChordGame.BEST_KEY,
        nameKey: 'games.chords.name',
        route: '#/acordes',
        levels: () => ChordGame.LEVELS.map((_, i) => i + 1),
        currentLevel: () => ChordGame.storedLevelIdx() + 1,
        // Sem mundos: a trilha é curta e cresce por um eixo só. O limiar é o do nível.
        levelInfo: (n) => { const l = ChordGame.LEVELS[n - 1]; return l ? { world: null, pass: l.pass } : null; },
        applyUnlock: (passed) => {
            if (!Array.isArray(passed) || !passed.length) return;
            const last = ChordGame.LEVELS.length - 1;
            const key = window.StorageScope.key(ChordGame.UNLOCKED_KEY);
            const cur = Math.max(0, parseInt(localStorage.getItem(key) || '0', 10) || 0);
            const derived = Math.min(last, Math.max.apply(null, passed));
            if (derived > cur) localStorage.setItem(key, String(derived));
        }
    });
} else if (typeof console !== 'undefined') {
    console.warn('[ChordGame] LevelProgress ausente — Acordes fora do ranking. Conferir loadOrder.');
}



// ============================================
// games/SongReadingGame.js
// ============================================
/**
 * SongReadingGame - ler uma MÚSICA REAL em esteira e tocá-la no instrumento.
 *
 * O 5º jogo (Etapa 3 de docs/MUSICA-REAL-PLANO.md). A partitura rola D→E sob uma linha
 * de leitura fixa e o aluno responde no piano em tela, no teclado do PC, num teclado MIDI
 * ou tocando um piano acústico no microfone — as quatro superfícies são intercambiáveis
 * porque todas falam o mesmo CONTRATO DE ENTRADA (ver PianoKeyboard).
 *
 * ─── O que este jogo tem que a Leitura em esteira NÃO tem ────────────────────────────
 *
 * A `ReadingFlowGame` sorteia notas soltas: sem ritmo, sem compasso, sem fim. Aqui o
 * conteúdo é uma PEÇA — figura, compasso, ligadura, barra final — e por isso **o ritmo
 * conta**. Isso muda o miolo: a resposta certa não é só a altura certa, é a altura certa
 * NO INSTANTE certo, medido no mesmo relógio de áudio e com a mesma janela de ±45 ms do
 * jogo de ritmo (`RhythmScorer`).
 *
 * ─── DOIS MODOS (§7.1 do plano) ──────────────────────────────────────────────────────
 *
 *   ESTUDO — a esteira ANDA até a próxima nota e PARA nela até você tocar a certa. Não
 *            pontua nada, de propósito: é para decorar onde ficam as notas. Sem
 *            metrônomo (um pulso que continua enquanto a música espera seria mentira).
 *   TEMPO  — rola firme no BPM escolhido, com metrônomo, e é o que dá nota.
 *
 * É a diferença entre estudar e se apresentar. Quem nunca viu a peça começa no estudo.
 *
 * ─── DOIS PLACARES (§7.2) ────────────────────────────────────────────────────────────
 *
 *   NOTAS — quantas alturas certas (a leitura propriamente dita).
 *   RITMO — precisão do ataque, via `RhythmScorer.calculateTimingAccuracy`.
 *
 * 🔴 O alinhamento nota-tocada ↔ nota-escrita é feito **só pelo TEMPO**, reusando o
 * Needleman–Wunsch do `RhythmScorer`; a altura é conferida DEPOIS, par a par. Alinhar
 * exigindo altura igual puniria duas vezes o mesmo erro (a nota errada viraria "extra" E
 * "perdida") e apagaria a leitura mais útil que este jogo dá: *"você segurou o ritmo,
 * errou as notas"* — ou o contrário.
 *
 * 🔴 A DURAÇÃO (segurar a nota pelo valor escrito) fica FORA do v1. Exigiria capturar o
 * soltar da tecla em todas as fontes, o microfone não tem como dar isso, e no toque a
 * medida é suja. O ponto de extensão está previsto no contrato (`onKeyRelease`).
 *
 * 🔴 O MICROFONE NÃO PONTUA RITMO. Ele detecta a altura 50–120 ms depois do ataque (ver
 * `MicPitchInput._emit`), acima da janela perfeita. Cada nota gravada carrega `timed`, e
 * o placar de Ritmo simplesmente não aparece quando a peça foi tocada no mic. Preferimos
 * um número a menos a um número que mente.
 *
 * ─── Tripwires herdados ──────────────────────────────────────────────────────────────
 *
 * 🔴 UM RELÓGIO SÓ: tudo deriva de `audioManager.now()`. rAF só desenha.
 * 🔴 QUEM AGENDA ÁUDIO À FRENTE GUARDA O HANDLE (`_audio`) e mata no `_killAudio()` —
 *    o "Ouvir a música" agenda a peça inteira de uma vez; sem isso, apertar Parar deixa
 *    a melodia tocando sozinha no vazio (o jogo de ritmo já pagou por esta lição).
 * 🔴 NÃO herda `BaseQuizGame`: tem transporte próprio, não é quiz. Irmão do RhythmGame e
 *    da ReadingFlowGame nesse ponto.
 * 🔴 Está em `Main.GAMES` (aba no ⊞ + card), mas FORA do ranking: ranking se pede com
 *    `LevelProgress.register()`, e este jogo não chama: aqui não há trilha de níveis, e
 *    o arquivo do aluno não é comparável com o de ninguém. As duas coisas são fios
 *    separados — Etapa 6 do plano liga o segundo.
 */
class SongReadingGame {
    /**
     * Catálogo. O importador de MIDI (Etapa 4) entra como outra fonte.
     *
     * 🔴 Caminho ABSOLUTO (`/songs/…`), como `/changelog.json` e `/audio/piano/…`. Relativo
     * quebraria em produção sem dar erro visível: o app mora em `/app/` (split do Stage 3),
     * então `songs/x.json` viraria `/app/songs/x.json` — que não existe, e o catch-all do
     * SPA devolve 200 com o shell HTML, que falha no JSON.parse com uma mensagem que não
     * tem nada a ver com o problema.
     *
     * 🔴 TODA peça daqui é de DOMÍNIO PÚBLICO e entra só com a MELODIA (sem letra, que tem
     * direito próprio e prazo próprio). O `credit` do arquivo diz de onde ela vem — é o
     * campo que se confere antes de acrescentar a próxima.
     *
     * A ordem é a da TELA (a lista imprime nesta ordem): a peça de estreia primeiro, depois
     * a mais fácil de ler, e assim por diante. Não é ranking de dificuldade formal — não há
     * trilha aqui, ninguém é barrado por nível.
     */
    static SONGS = [
        // 🔴 `titleKey` repetido aqui de propósito: a LISTA (`_catalogRows`) precisa do nome
        // antes de baixar a partitura, e baixar 1 JSON por linha só para escrever o título
        // seria uma requisição por peça toda vez que a tela abre. É a mesma chave do
        // arquivo — quem acrescentar peça ao catálogo copia as duas.
        { id: 'parabens', url: '/songs/parabens.json', titleKey: 'songs.happyBirthday.title' },
        { id: 'brilha',   url: '/songs/brilha.json',   titleKey: 'songs.twinkle.title' },
        { id: 'alegria',  url: '/songs/alegria.json',  titleKey: 'songs.odeToJoy.title' },
        { id: 'jingle',   url: '/songs/jingle.json',   titleKey: 'songs.jingleBells.title' }
    ];

    static MODE_KEY = 'song_mode_v1';        // 'study' | 'tempo' | 'play'
    /** 🔴 Chave SEPARADA por rota, como o andamento já era. "Acompanhar" (que não pontua)
     *  escolhido no arquivo do aluno seguia para `#/musicas` — e lá a pessoa nunca mais
     *  ganhava estrela, sem nada na tela explicando por quê. */
    static MODE_FREE_KEY = 'song_mode_free_v1';
    static BPM_KEY = 'song_bpm_v1';
    /** 🔴 Chave SEPARADA para a peça do aluno: o andamento em que se estuda um arquivo
     *  importado não tem por que virar o andamento do catálogo (e a relação era
     *  assimétrica — o catálogo obedecia, o importado ignorava). */
    static BPM_FREE_KEY = 'song_bpm_free_v1';
    static DENSITY_KEY = 'song_density_v1';  // índice em DENSITIES
    static INPUT_KEY = 'song_input_v1';      // 'piano' | 'mic' | 'midi'
    static STARS_KEY = 'song_stars_v1';      // { songId: melhor nº de estrelas }

    /**
     * CIFRAS plantadas (Etapa 7): { "<id>": {name, updatedAt, chords:[{beat,root,code}]} }.
     *
     * 🔴 Chave GLOBAL, fora do `StorageScope`, de propósito. Lá dentro valeria a regra de
     * adoção guest→conta ("conta que já jogou neste device NUNCA herda do convidado") e o
     * trabalho manual de quem plantou 60 acordes SUMIRIA ao fazer login. Cifra não é
     * progresso comparável: é conteúdo preso a um arquivo deste aparelho, como o andamento
     * e o idioma. Por isso também não entra em `PROGRESS_BASE_KEYS`.
     *
     * `id` = hash do CONTEÚDO do .mid (o mesmo arquivo reencontra as suas cifras com
     * qualquer nome) ou `catalog:<songId>` para a peça do catálogo.
     */
    static HARMONY_KEY = 'song_harmony_v1';
    /**
     * Teto de arquivos COM CIFRA guardada. 🔴 Estourar a cota do localStorage faz os OUTROS
     * jogos pararem de gravar progresso — o despejo protege eles, não esta feature.
     *
     * 🔴 É MAIOR que `SongStore.MAX_FILES` (a estante, Etapa 8) de propósito: se fosse igual
     * ou menor, o despejo LRU apagaria as cifras de uma peça que ESTÁ guardada no aparelho —
     * a pessoa veria a música na lista, abriria, e ela estaria pelada. Cifra é ~4 KB, então
     * 64 × 4 KB = 256 KB de localStorage: folga larga. Guardado por `library-test [K]`, que
     * afirma a desigualdade E prova que uma entrada na estante sobrevive ao despejo.
     */
    static HARMONY_MAX_FILES = 64;
    static HARMONY_MAX_CHORDS = 2000;

    /** % (Notas+Ritmo) para 1, 2 e 3 estrelas — mesma régua da Leitura. */
    static STAR_ACC = [70, 85, 95];

    /** Densidade da partitura: multiplica px/semínima. O piso de legibilidade do
     *  ScoreRenderer continua valendo por cima, então "compacto" nunca colide. */
    static DENSITIES = [
        { key: 'tight', mul: 0.72 },
        { key: 'medium', mul: 1 },
        { key: 'loose', mul: 1.45 }
    ];

    static BPM_MIN = 30;
    static BPM_MAX = 160;

    /**
     * Pré-roll da captura: abre o gravador meia batida ANTES do beat 0. Quem ataca a
     * primeira nota adiantado é gravado com desvio negativo em vez de sumir num vão
     * morto. Mesmo valor e mesmo motivo do `RhythmGame.INPUT_PREROLL_BEATS`.
     */
    static PREROLL_BEATS = 0.5;

    /** Rabicho depois da última nota: sem ele, atrasar a nota final vira "não tocou".
     *  1 batida = a mesma tolerância que o alinhamento do RhythmScorer aceita. */
    static TAIL_BEATS = 1;

    /** Salto de tempo entre dois quadros acima do qual a rodada é ABANDONADA em vez de
     *  reprovada (aba escondida, device dormindo). 2 batidas é maior que qualquer
     *  engasgo de quadro e menor que o menor descuido real. Ver `_loop`. */
    static SKIP_ABORT_BEATS = 2;

    // Preto = notação em repouso (a tinta do projeto). Cor é reservada a ESTADO, os
    // mesmos três dos outros jogos: próxima=índigo · acerto=verde · erro=vermelho.
    static COLOR = { idle: '#000', next: '#6366f1', hit: '#10b981', miss: '#ef4444', pass: '#f87171' };

    constructor(opts = {}) {
        this.container = null;
        /**
         * 🔴 `mode:'free'` = #/musicas-livre: a peça vem de um ARQUIVO DO ALUNO (.mid),
         * não do catálogo. Mesmo jogo, mesma esteira, mesmos placares — muda a FONTE da
         * partitura e, por consequência, o que se pode comparar: peça importada não tem
         * recorde nem ranking (§6 do plano), porque duas pessoas nunca leram a mesma coisa.
         */
        this.routeFree = opts.mode === 'free';
        /**
         * 🔴 `freeMode` = A PEÇA ABERTA É DO ALUNO — não "a rota é a livre". Era a ROTA até
         * 28/ago, e é por isso que as duas rotas eram dois jogos: a estante não existia no
         * catálogo e o catálogo não existia na estante. Agora as duas abrem a MESMA lista
         * (`_showPickScreen`) e a bandeira segue a PEÇA: `_loadSong` a baixa, `_importBytes`
         * a levanta. Tudo o que depende dela (recorde, chave de cifra, chave de andamento e
         * de modo) já lia por método, então passou a acompanhar sozinho — o que NÃO era
         * verdade do `this.mode`, lido uma vez no construtor: ver `_reloadModePref`.
         */
        this.freeMode = this.routeFree;
        this.songId = opts.songId || (this.routeFree ? null : SongReadingGame.SONGS[0].id);
        this.score = null;
        /** Relatório da última importação ({report, fileName, midi, analysis}) — o que a
         *  tela mostra antes de tocar e o que deixa trocar de faixa sem reler o arquivo. */
        this.imported = null;
        /** ESTANTE (Etapa 8): metadados do que está guardado + os ids, para o join das
         *  cifras e para proteger essas cifras do despejo (ver `_writeHarmonyStore`).
         *  Vazio enquanto ninguém guardou nada — e enquanto o IndexedDB não responder. */
        this._shelfSongs = [];
        this._shelfIds = new Set();
        this.shelf = null;

        // 'study' (espera a nota) · 'tempo' (dá nota) · 'play' (rola e não julga — é onde
        // a cifra faz sentido; ver `start`). Lista branca: quem tem valor antigo salvo cai
        // no default sem quebrar nada.
        this.mode = SongReadingGame.readModePref(
            opts.mode === 'free' ? SongReadingGame.MODE_FREE_KEY : SongReadingGame.MODE_KEY);
        this.inputMode = this._storedInput();
        this.densityIdx = this._storedDensity();
        this.bpm = 0; // definido ao carregar a peça (default = o andamento do arquivo)

        /**
         * 🔴 QUAL TELA ESTÁ NO AR — 'start' | 'import' | 'pick' | 'harmony' | 'playing'.
         *
         * Era inferido de três negativas (`!this._running && this.score && !this.shelf`) e
         * o guard do resize não enxergava a tela de IMPORTAR: girar o celular — ou só rolar
         * a página, que no Chrome/Safari esconde a barra de URL e dispara `resize` — trocava
         * o "solte o arquivo aqui" pela partitura da peça anterior, com o título ainda
         * dizendo "carregue um arquivo MIDI". Zero erro no console. Estado nomeado mata a
         * família inteira desse defeito, em vez de acrescentar mais um `&&`.
         */
        this._screen = null;
        /** A tela em que esta rota ENTROU (a raiz do "voltar" — ver `_rootScreen`). */
        this._entryScreen = null;
        /** Há um degrau de histórico empilhado? (ver `_enterScreen`) */
        this._navToken = false;
        this._navId = 'sg' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
        this._navSkipRender = false;

        // DOM
        this.staffContainer = null;
        this.musicStaff = null;
        this.renderer = null;
        this.hudEl = null;
        this.promptEl = null;
        this.answersEl = null;
        this.extraEl = null;

        // entrada
        this.piano = null;
        this.keyboard = null;
        this.mic = null;
        this.micPanel = null;
        this.midi = null;
        this.midiPanel = null;

        this.scorer = new window.RhythmScorer();
        this.recorder = new window.NoteInputRecorder();

        // transporte (um relógio só: audioManager.now)
        this._raf = null;
        this._running = false;
        this._ended = false;
        this._destroyed = false;
        this._t0 = 0;             // tempo de áudio (s) do BEAT 0 da peça
        this._pauseOffset = 0;    // s congelados no modo estudo
        this._holdFrom = null;    // rawNow() em que a espera começou (null = rolando)
        this._holdElapsed = 0;    // s desde o beat 0, travados durante a espera
        this._captureOpen = false;// a janela de gravação já abriu? (pré-roll — ver _loop)
        this._lastLoopBeat = null;// beat do quadro anterior (detecta aba escondida)

        this._audio = [];         // handles agendados à frente (ver _killAudio)
        this._metroOwned = false; // ESTA instância ligou o metrônomo? (singleton global — ver _killAudio)
        this._timers = [];
        this._expected = [];      // notas da peça + estado ao vivo
        this._measures = [];      // grade de compassos (cache — ver _prepareExpected)
        this._cursor = 0;         // 1ª nota possivelmente pendente (ver _nextPending)
        this._nextMarked = null;
        this._studyWrong = 0;
        this.starsBySong = this._loadStars();
        /** Editor de cifras aberto? (a pauta reserva a faixa mesmo sem cifra ainda) */
        this._editingHarmony = false;
        this.harmonyEditor = null;
        this._harmonyDropped = 0;
        /** Chart que veio DENTRO do `.json` da peça (só o catálogo traz). Ver `_loadHarmony`. */
        this._defaultHarmony = [];
    }

    // ---------- preferências ----------

    /** Qual chave de andamento vale nesta rota (catálogo × peça do aluno). */
    _bpmKey() {
        return this.freeMode ? SongReadingGame.BPM_FREE_KEY : SongReadingGame.BPM_KEY;
    }

    /** Idem para o modo (ver MODE_FREE_KEY). */
    _modeKey() {
        return this.freeMode ? SongReadingGame.MODE_FREE_KEY : SongReadingGame.MODE_KEY;
    }

    /** Lista branca: valor antigo/estranho cai no default sem quebrar nada. */
    static readModePref(key) {
        const v = localStorage.getItem(key);
        return (v === 'tempo' || v === 'play') ? v : 'study';
    }

    /**
     * 🔴 O modo é preferência POR TIPO DE PEÇA (catálogo × arquivo do aluno) e agora a peça
     * aberta muda SEM trocar de rota — abrir o Parabéns pela lista, dentro de #/musicas-livre,
     * é um toque. Sem reler aqui, "Acompanhar" escolhido no arquivo do aluno seguia para a
     * peça do catálogo e a pessoa nunca mais ganhava estrela, sem nada na tela explicando
     * por quê: exatamente o defeito que fez MODE_FREE_KEY existir.
     */
    _reloadModePref() {
        this.mode = SongReadingGame.readModePref(this._modeKey());
    }

    _storedInput() {
        const v = localStorage.getItem(SongReadingGame.INPUT_KEY);
        if (v === 'mic' && window.MicPitchInput && window.MicPitchInput.isSupported()) return 'mic';
        if (v === 'midi' && window.MidiPitchInput && window.MidiPitchInput.isSupported()) return 'midi';
        return 'piano';
    }

    _storedDensity() {
        const i = parseInt(localStorage.getItem(SongReadingGame.DENSITY_KEY) || '1', 10);
        return Number.isFinite(i) && i >= 0 && i < SongReadingGame.DENSITIES.length ? i : 1;
    }

    _loadStars() {
        try {
            const raw = localStorage.getItem(window.StorageScope.key(SongReadingGame.STARS_KEY));
            const o = raw ? JSON.parse(raw) : {};
            return (o && typeof o === 'object') ? o : {};
        } catch (e) { return {}; }
    }

    _bestStars() { return this.starsBySong[this.songId] | 0; }

    /** Guarda as estrelas se superarem o recorde. true se melhorou. */
    _saveBestStars(stars) {
        // 🔴 Peça importada não tem recorde: o arquivo é de quem trouxe, ninguém mais leu
        // a mesma coisa, e a estrela é a moeda que vai valer ranking na Etapa 6. Guardar
        // "3 estrelas" ganhas num arquivo escolhido pelo próprio jogador contaminaria a
        // única medida comparável que este jogo tem.
        if (this.freeMode) return false;
        if (stars <= this._bestStars()) return false;
        this.starsBySong[this.songId] = stars;
        try {
            localStorage.setItem(window.StorageScope.key(SongReadingGame.STARS_KEY),
                                 JSON.stringify(this.starsBySong));
        } catch (e) { /* storage cheio/bloqueado: o jogo não depende disso */ }
        return true;
    }

    // ---------- cifras: guardar por ARQUIVO, neste aparelho ----------

    /**
     * Identidade do que está carregado. Para o arquivo do aluno é o hash do CONTEÚDO —
     * assim o mesmo `.mid` reencontra as suas cifras mesmo renomeado, e dois arquivos
     * diferentes nunca se misturam.
     */
    _harmonyId() {
        if (this.freeMode) return (this.imported && this.imported.hash) || null;
        return this.songId ? 'catalog:' + this.songId : null;
    }

    /** FNV-1a de 32 bits + tamanho. Barato, roda uma vez por importação. */
    static hashBytes(buffer) {
        const b = new Uint8Array(buffer);
        let h = 0x811c9dc5;
        // 🔴 `Math.imul`: `h * 0x01000193` passa de 2^53 e perde precisão silenciosamente —
        // arquivos diferentes colidiriam e um herdaria as cifras do outro.
        for (let i = 0; i < b.length; i++) { h = Math.imul(h ^ b[i], 0x01000193); }
        return (h >>> 0).toString(16) + '-' + b.length;
    }

    _harmonyStore() {
        let raw = null;
        try {
            raw = localStorage.getItem(SongReadingGame.HARMONY_KEY);
            const o = raw ? JSON.parse(raw) : {};
            if (o && typeof o === 'object') return o;
        } catch (e) { /* tratado abaixo */ }
        // 🔴 JSON corrompido devolvia `{}` e a próxima gravação SUBSTITUÍA os 20 arquivos
        // por um. Guarda o original de lado antes de seguir: perda total silenciosa a
        // partir de uma corrupção é o pior desfecho possível para trabalho manual.
        if (raw) {
            try { localStorage.setItem(SongReadingGame.HARMONY_KEY + '.bak', raw); } catch (e2) { /* sem espaço */ }
        }
        return {};
    }

    /**
     * Devolve ao `Score` as cifras guardadas para esta peça.
     * @returns {number} quantas foram DESCARTADAS por caírem fora da peça
     */
    _loadHarmony() {
        this._harmonyDropped = 0;
        // 🔴 As cifras que não cabem NESTA faixa ficam guardadas aqui e voltam ao disco no
        // `_saveHarmony`. Sem isto, quem trocasse para uma faixa curta e editasse UMA cifra
        // regravava o arquivo inteiro com o pedaço truncado: reproduzido, 8 cifras viraram
        // 2 e as outras 6 sumiram para sempre — e o aviso que a pessoa tinha acabado de ler
        // ("ficaram fora desta faixa") sugeria exatamente o contrário.
        this._harmonyOutOfRange = [];
        if (!this.score) return 0;
        // 🔴 CIFRA DE FÁBRICA: a peça do catálogo pode trazer um chart dentro do próprio
        // `.json` (é o que ensina o recurso sem a pessoa ter de plantar nada). Ela é o
        // PADRÃO, não a verdade — a primeira edição de quem usa passa a mandar, e é por
        // isso que o que está no disco vence sempre que existe. Arquivo do aluno nunca
        // chega aqui com harmonia (o `.mid` não tem cifra), então a lista sai vazia.
        this._defaultHarmony = this.score.harmony.map(h => ({
            beat: h.beat,
            root: { letter: h.root.letter, alter: h.root.alter || 0 },
            code: h.code
        }));
        this.score.harmony.length = 0;
        const id = this._harmonyId();
        const entry = id ? this._harmonyStore()[id] : null;
        // 🔴 Entrada VAZIA no disco não cai para o padrão: quem apagou todas as cifras de
        // uma peça do catálogo tem de vê-las apagadas ao voltar. É o `_saveHarmony` que
        // guarda a lista vazia (em vez de sumir com a linha) quando há chart de fábrica.
        const chords = (entry && Array.isArray(entry.chords)) ? entry.chords : this._defaultHarmony;
        if (!chords.length) return 0;

        const fim = this.score.totalBeats;
        let fora = 0;
        chords.forEach(h => {
            // 🔴 Trocar de FAIXA muda o comprimento da peça: a cifra do compasso 40 não
            // existe numa faixa de 12 compassos. Descarta, mas nunca em silêncio — o
            // cartão de importação diz quantas caíram fora.
            if (!(h.beat < fim - window.Score.EPS)) {
                fora++;
                this._harmonyOutOfRange.push({ beat: h.beat, root: h.root, code: h.code });
                return;
            }
            // 🔴 `setChord` recusa dado corrompido devolvendo null (nunca estoura). Cifra
            // que ele recusa é dado inválido, não "fora da faixa": essa NÃO se preserva.
            if (!this.score.setChord(h.beat, { root: h.root, code: h.code })) fora++;
        });
        this._harmonyDropped = fora;
        return fora;
    }

    /** Guarda o que está plantado. Silencioso em caso de falha: o jogo não depende disto. */
    _saveHarmony(opts = {}) {
        const id = this._harmonyId();
        if (!id || !this.score) return;
        const store = this._harmonyStore();
        const daFaixa = this.score.harmony
            .map(h => ({ beat: h.beat, root: { letter: h.root.letter, alter: h.root.alter }, code: h.code }));
        // 🔴 Funde com o que ficou FORA desta faixa (ver `_loadHarmony`). "Apagar todas" é a
        // única exceção: ali a pessoa pediu para limpar a música, não a faixa.
        const fora = opts.clearedAll ? [] : (this._harmonyOutOfRange || []);
        if (opts.clearedAll) this._harmonyOutOfRange = [];
        let chords = daFaixa.concat(fora).sort((a, b) => a.beat - b.beat);

        if (chords.length > SongReadingGame.HARMONY_MAX_CHORDS) {
            // Truncar em silêncio some com trabalho manual sem deixar rastro.
            chords = chords.slice(0, SongReadingGame.HARMONY_MAX_CHORDS);
            if (window.notifications) {
                window.notifications.toast(
                    this._t('song.harmony.tooMany', { max: SongReadingGame.HARMONY_MAX_CHORDS }),
                    { type: 'error', duration: 5000 });
            }
        }

        // 🔴 Peça COM chart de fábrica grava a lista vazia em vez de sumir da loja: sem a
        // linha, o `_loadHarmony` não teria como distinguir "nunca mexeu" de "apagou todas"
        // e as cifras de fábrica voltariam do nada na próxima abertura.
        if (!chords.length && !(this._defaultHarmony && this._defaultHarmony.length)) delete store[id];
        else store[id] = {
            name: this.freeMode ? ((this.imported && this.imported.fileName) || '') : this.songId,
            updatedAt: Date.now(), chords
        };

        this._writeHarmonyStore(store);
    }

    /**
     * Grava o mapa de cifras: despejo + cota, num lugar só (o backup também passa por aqui).
     *
     * 🔴 Despejo pelo mais antigo — ver `HARMONY_MAX_FILES`: é o localStorage dos OUTROS
     * jogos que está sendo protegido. 🔴 E **nunca despeja um id que está na ESTANTE**: a
     * peça guardada no aparelho não pode ficar pelada por causa de cifras de arquivos que
     * a pessoa nem tem mais. O teto (64) já é maior que o da estante (60), então na prática
     * isto só entra em jogo quando um backup traz cifras de peças que não couberam.
     */
    _writeHarmonyStore(store, keepIds) {
        const ids = Object.keys(store);
        if (ids.length > SongReadingGame.HARMONY_MAX_FILES) {
            const keep = (keepIds instanceof Set) ? keepIds : (this._shelfIds || new Set());
            const excedente = ids.length - SongReadingGame.HARMONY_MAX_FILES;
            ids.filter(k => !keep.has(k))
               .sort((a, b) => (store[a].updatedAt || 0) - (store[b].updatedAt || 0))
               .slice(0, excedente)
               .forEach(k => { delete store[k]; });
        }
        try {
            localStorage.setItem(SongReadingGame.HARMONY_KEY, JSON.stringify(store));
            return true;
        } catch (e) {
            // 🔴 Falhar calado aqui é prometer o que não se cumpre: a tela mostra "{n} cifras
            // plantadas" e, ao voltar, não há nenhuma. Avisa UMA vez por tela.
            if (!this._harmonyQuotaWarned) {
                this._harmonyQuotaWarned = true;
                // `_mergeRepertoire` pode estar em voo quando a rota troca: avisar numa
                // tela que já não existe é ruído sobre o jogo seguinte.
                if (window.notifications && !this._destroyed) {
                    window.notifications.toast(this._t('song.harmony.notSaved'),
                                               { type: 'error', duration: 6000 });
                }
            }
            return false;
        }
    }

    _starsFor(acc) {
        const [s1, s2, s3] = SongReadingGame.STAR_ACC;
        return acc >= s3 ? 3 : acc >= s2 ? 2 : acc >= s1 ? 1 : 0;
    }

    // ---------- ciclo de vida ----------

    async init(container) {
        this.container = container;
        this.setupUI();
        await this._openEntry();

        this._onResize = () => {
            clearTimeout(this._resizeTimer);
            // 🔴 Nunca remontar a pauta com a esteira rodando: o renderer seria recriado e
            // a peça saltaria de posição no meio de um compasso. O resize em pleno take é
            // raro (rotação de tela); esperar o fim é mais honesto que dar um pulo.
            this._resizeTimer = setTimeout(() => {
                // 🔴 Remonta onde a PAUTA está no ar e parada. O guard era por negativas
                // (`!this._running && this.score && !this.shelf`) e não enxergava a tela de
                // IMPORTAR: um resize ali — girar o celular, o teclado virtual abrir, ou só
                // rolar a página (o Chrome/Safari escondem a barra de URL e disparam
                // `resize`) — apagava a área de soltar o arquivo e punha no lugar a
                // partitura da peça anterior, com o título ainda pedindo um arquivo.
                //
                // 🔴 E a lista das telas é EXPLÍCITA porque a 1ª versão desta reforma pôs só
                // `'start'` e PERDEU a tela de cifras, que o guard antigo cobria: girar o
                // celular com o editor aberto deixava a pauta construída a 350 px esticada
                // para 804 px pelo `viewBox` (cabeças e cifras gigantes) até sair e voltar.
                // Era o defeito que o CIFRAS-PLANO já tinha consertado uma vez — e a
                // asserção que o guardava virou VÁCUA, porque passou a não acontecer nada.
                // `'playing'` entra só parado: é o estado do modal de resultado, com a
                // partitura atrás dele.
                const pauta = this._screen === 'start' || this._screen === 'harmony'
                    || (this._screen === 'playing' && !this._running);
                if (pauta && this.score) this._buildStaff();
            }, 150);
        };
        window.addEventListener('resize', this._onResize);
        window.addEventListener('popstate', this._onPopState = () => this._onPop());
    }

    /**
     * A PORTA do jogo — a mesma nas duas rotas.
     *
     * 🔴 Tem repertório ⇒ a entrada é a LISTA. Antes só `#/musicas-livre` a conhecia, e
     * `#/musicas` (o ladrilho do ⊞, o destino da página de SEO) abria sempre a peça do
     * catálogo: quem tinha 20 arquivos guardados voltava sempre no Parabéns e precisava
     * reconhecer um botão chamado "Importar MIDI" para chegar ao que era dele.
     *
     * Sem nada guardado, cada rota cai no que ela promete — e é só nisso que elas diferem:
     * `#/musicas` mostra o CATÁLOGO, `#/musicas-livre` abre o importador. Quem nunca
     * guardou nada não ganha uma tela a mais no caminho.
     *
     * 🔴 "Mostrar o catálogo" é a lista quando há mais de uma peça, e a peça quando há uma
     * só — pela MESMA razão do parágrafo de cima. Abrir sempre a primeira esconderia as
     * outras atrás de um botão (foi exatamente o que aconteceu com o repertório do aluno);
     * e uma lista de um item é uma tela a mais para escolher o que não tem escolha.
     */
    async _openEntry() {
        await this._refreshShelf();
        if (this._destroyed) return;
        if (this._shelfSongs.length) { this._entryScreen = 'pick'; return this._showPickScreen(); }
        if (this.routeFree) { this._entryScreen = 'import'; return this._showImportScreen(); }
        if (SongReadingGame.SONGS.length > 1) { this._entryScreen = 'pick'; return this._showPickScreen(); }
        this._entryScreen = 'start';
        await this._loadSong();
        if (this._destroyed) return;
        this._buildStaff();
        this._showStartScreen();
    }

    // =====================================================================
    // Navegação entre as telas do jogo — o "voltar" do aparelho (Tier 2)
    //
    // 🔴 As telas internas (lista, importar, cifras) eram chamadas de método, não estados
    // de histórico: o botão físico "voltar" do Android e o gesto do iOS SAÍAM DO JOGO no
    // meio das cifras, em vez de fechar as cifras. O `AppHeader` já resolveu isso para o
    // drawer com `pushState`/`popstate`; aqui é o mesmo mecanismo.
    //
    // 🔴 PROFUNDIDADE 1, de propósito. Um estado por tela deixaria entradas fantasmas no
    // histórico depois de trocar de jogo pelo ⊞ (cada "voltar" gastaria uma tecla morta
    // até esvaziar). Um degrau só: fora da raiz há UM estado empilhado, e o "voltar"
    // sempre devolve a pessoa à raiz — a peça aberta, ou a tela em que a rota entrou.
    // =====================================================================

    /**
     * A tela para a qual o "voltar" devolve: a peça aberta, ou a porta desta rota.
     *
     * 🔴 `'start'` NUNCA é raiz sem peça. `_showStartScreen` devolve para a raiz quando não
     * há peça; se a raiz devolvesse `'start'`, os dois se chamariam para sempre — **medido**:
     * `Maximum call stack size exceeded`. O caminho é curto e é de aluno novo: `#/musicas`
     * com estante vazia grava `_entryScreen = 'start'`, a pessoa vai à lista, importa um
     * arquivo que o importador RECUSA (a recusa é feature), e aperta voltar.
     */
    _rootScreen() {
        if (this.score) return 'start';
        if (this._entryScreen && this._entryScreen !== 'start') return this._entryScreen;
        return (this._shelfSongs && this._shelfSongs.length) ? 'pick' : 'import';
    }

    /** Marca a tela atual e mantém o degrau de histórico em dia. */
    /**
     * O "?" da linha do subtítulo, POR TELA. Aqui, ao contrário dos outros jogos, a
     * dúvida de estreia muda com a tela: no importador é "que arquivo serve?", na
     * lista é "de onde vêm estas músicas?", nas cifras é "por que uma grade?".
     * 🔴 Fica FORA do <p>, que cada tela reescreve por textContent — e é trocado
     * aqui, num lugar só, para nenhuma tela ficar com o "?" da anterior.
     */
    static SCREEN_HELP = {
        import:  'song.midi',
        pick:    'song.lists',
        harmony: 'song.chartGrid',
        start:   null,       // na peça aberta o "?" que importa é o de "Modo:"
        playing: null
    };

    _setIntroHelp(nome) {
        const intro = this.container && this.container.querySelector('.game-intro');
        if (!intro) return;
        intro.querySelectorAll('.help-dot').forEach(d => d.remove());
        const topico = SongReadingGame.SCREEN_HELP[nome];
        if (topico && window.HelpDot) window.HelpDot.attach(intro, topico);
    }

    _enterScreen(nome) {
        this._screen = nome;
        this._setIntroHelp(nome);
        if (nome !== this._rootScreen()) {
            if (this._navToken) return;                       // já há um degrau empilhado
            // `pushState` sem URL mantém o hash: o Router só escuta `hashchange`, então
            // isto não re-roteia nada.
            try { history.pushState({ songNav: this._navId }, ''); this._navToken = true; } catch (e) { /* file:// */ }
            return;
        }
        // Voltou à raiz por dentro (importou o arquivo, fechou as cifras, abriu uma peça da
        // lista): CONSOME o degrau. Sem isto o "voltar" do aparelho viraria uma tecla morta
        // — a pessoa já fechou a tela, mas o histórico ainda acha que ela está lá.
        if (!this._navToken) return;
        this._navToken = false;
        // 🔴 Só desfaz o degrau se ELE for o topo. Com o drawer do header aberto, o estado
        // do drawer está por cima: o `back()` comeria o drawer, o `_navSkipRender` seria
        // gasto e o nosso degrau sobraria órfão — a mesma tecla morta que a profundidade 1
        // existe para evitar. Órfão não é problema: o `_onPop` o reconhece e o pula.
        if (!(history.state && history.state.songNav === this._navId)) return;
        this._navSkipRender = true;   // a tela nova já está desenhada; o pop é só limpeza
        try { history.back(); } catch (e) { this._navSkipRender = false; }
    }

    _onPop() {
        if (this._destroyed) return;
        if (this._navSkipRender) { this._navSkipRender = false; return; }
        // 🔴 Degrau ÓRFÃO — empilhado por uma instância anterior do jogo (a pessoa entrou na
        // lista, trocou de jogo pelo ⊞ e voltou). Ele é inerte, mas cada "voltar" gastaria
        // uma tecla sem mudar nada na tela. Como ele se identifica sozinho, pula-se.
        if (!this._navToken) {
            if (history.state && history.state.songNav) { try { history.back(); } catch (e) { /* nada a fazer */ } }
            return;
        }
        // 🔴 O drawer do header empilha o estado DELE por cima do nosso. Fechá-lo dispara
        // este mesmo `popstate`, e sem esta linha o jogo voltaria uma tela junto. Se o
        // estado atual ainda é o NOSSO degrau, quem saiu foi o drawer.
        if (history.state && history.state.songNav === this._navId) return;
        this._navToken = false;
        // 🔴 No meio da rodada o "voltar" PARA a esteira, não sai do jogo. Antes o take era
        // descartado em silêncio: o gesto de borda do iOS levava a pessoa para fora com o
        // áudio agendado. Parar é o que o botão "Parar" da tela faz — o dedo e o gesto não
        // podem discordar. 🔴 `stop()` já desemboca em `_showStartScreen`; renderizar a
        // raiz aqui desenharia a tela inicial COM o áudio ainda tocando.
        if (this._running) { this.stop(); return; }
        // Fim de rodada com o modal aberto: o "voltar" fecha o modal e devolve a peça.
        if (this._screen === 'playing' && window.notifications) {
            this._resultActionTaken = true;
            window.notifications.closeModal();
        }
        this._renderScreen(this._rootScreen());
    }

    /** Saída explícita por um botão da tela — o MESMO caminho do "voltar" do aparelho. */
    _backScreen() {
        if (this._navToken) { try { history.back(); return; } catch (e) { this._navToken = false; } }
        this._renderScreen(this._rootScreen());
    }

    /** Desenha uma tela pelo nome (o `popstate` não pode chamar o `_show*` errado). */
    _renderScreen(tela) {
        if (tela === 'pick') return this._showPickScreen();
        if (tela === 'import') return this._showImportScreen();
        if (tela === 'harmony') return this._showHarmonyScreen();
        this._closeHarmonyEditor();
        this._closeShelf();
        // A lista e o importador destroem o renderer (ocupam o lugar da pauta): voltar para
        // a peça precisa remontá-la.
        if (this.score && !this.renderer) this._buildStaff();
        this._showStartScreen();
    }

    /**
     * Carrega uma peça DO CATÁLOGO. `id` opcional: a lista (`_showPickScreen`) abre
     * qualquer uma delas de dentro de qualquer uma das duas rotas.
     */
    async _loadSong(id) {
        const alvo = id || this.songId;
        const def = SongReadingGame.SONGS.find(s => s.id === alvo) || SongReadingGame.SONGS[0];
        const res = await fetch(def.url, { cache: 'no-cache' });
        // 🔴 Confere o status: o catch-all do SPA responde 200 com o shell HTML para
        // qualquer caminho inexistente, então "deu 200" não significa "achou o arquivo".
        // Sem isto, um arquivo ausente aparece como erro de JSON.parse — uma pista falsa.
        if (!res.ok) throw new Error(`não achei a partitura (${def.url}: HTTP ${res.status})`);
        const data = await res.json();
        this.score = window.Score.fromJSON(data);
        // 🔴 A peça do catálogo tem recorde e cifra própria: a bandeira e a identidade
        // descem JUNTO com ela. Sem limpar o `imported`, o cartão "📄 valsa.mid" do arquivo
        // anterior continuaria embaixo do Parabéns, com o seletor de faixa dele.
        this.freeMode = false;
        this.songId = def.id;
        this.imported = null;
        this._importError = null;
        this._reloadModePref();
        // 🔴 O mesmo portão que o importador de MIDI vai atravessar (Etapa 4). Uma peça do
        // catálogo não deveria falhar aqui nunca — se falhar, o desenho MENTE sobre o ritmo
        // (duração sem figura vira semínima em silêncio) e o placar cobra o que não está
        // escrito. Não recusamos a peça (o aluno não tem culpa nem saída), mas nunca passa calado.
        const v = this.score.validate();
        if (!v.ok) {
            console.warn('SongReadingGame: partitura inválida — o jogo pode mentir sobre o ritmo.\n  '
                + v.errors.slice(0, 8).join('\n  '));
        }
        // O andamento do ARQUIVO é só o default do slider — quem manda no tempo de estudo
        // é o aluno (§3 do plano). Preferência salva vence o arquivo.
        const saved = parseInt(localStorage.getItem(this._bpmKey()) || '0', 10);
        this.bpm = (saved >= SongReadingGame.BPM_MIN && saved <= SongReadingGame.BPM_MAX)
            ? saved : Math.round(this.score.bpmAt(0));
        this._loadHarmony();
        this._prepareExpected();
    }

    /** Notas da peça + estado ao vivo. `beat` é lido do Score e NUNCA recalculado — é a
     *  chave com que o renderer identifica a nota (ver ScoreRenderer._noteEls). */
    _prepareExpected() {
        const PU = window.PitchUtil;
        // 🔴 `measures()` aloca a grade inteira e varre TODAS as notas (via totalBeats), e
        // `measureIndexAt` chama `measures()` por dentro. Lidos por quadro, isso é a mesma
        // armadilha que o ScoreRenderer já pagou: numa peça importada de 300 compassos
        // seriam dezenas de milhares de objetos por segundo só para escrever "compasso 7".
        this._measures = this.score.measures();
        // `totalBeats` é um GETTER que varre todas as notas; o _loop e o HUD o leem 4× por
        // quadro. Mesmo alçapão que o cache de `measures()` fecha, logo acima.
        this._totalBeats = this.score.totalBeats;
        this._expected = this.score.notes()
            .filter(n => n.type === 'note')
            .map((n, i) => {
                const info = PU.info(n.midi);
                return {
                    i, beat: n.beat, duration: n.duration, midi: n.midi,
                    sci: info.sci, letter: info.letter, state: 'pending'
                };
            });
    }

    // ---------- UI ----------

    _t(key, params = {}) { return window.language ? window.language.t(key, params) : key; }
    _noteName(letter) { return this._t('notes.' + letter); }

    /** Título da peça: chave de i18n quando existe, senão o literal do arquivo. */
    _songTitle() {
        if (!this.score) return '';
        if (this.score.titleKey) {
            const v = this._t(this.score.titleKey);
            if (v && v !== this.score.titleKey) return v;
        }
        return this.score.title || '';
    }

    setupUI() {
        const mobile = (window.innerWidth || 1024) < 560;
        const pad = mobile ? '0.75rem' : '1.5rem';
        this.container.innerHTML = `
            <div class="song-game" style="max-width:900px;margin:0 auto;padding:${pad};overflow-x:hidden;">
                <!-- 🔴 NÃO usa .game-h1: aquela classe some no celular (display:none), e com
                     razão — nos outros jogos o h1 repete o nome do jogo que já está no
                     header. Aqui o h1 é o nome da MÚSICA, que o header não diz e que é o
                     conteúdo em si; sumir com ele deixaria o aluno tocando uma peça sem
                     nome. Encolhe com clamp() em vez de desaparecer. -->
                <h1 id="sg-title" style="text-align:center;margin:0 0 0.2rem;line-height:1.15;
                    font-size:clamp(1.15rem, 4.2vw, 1.9rem);">${this._t('song.title')}</h1>
                <div class="game-intro" style="display:flex;align-items:center;justify-content:center;gap:0.1rem;margin:0.2rem auto 0.6rem;max-width:600px;">
                    <p style="text-align:center;color:#555;margin:0;font-size:0.95rem;" id="sg-sub">${this._t('song.subtitle')}</p>
                </div>
                <div id="sg-hud" style="display:none;justify-content:center;gap:0.6rem;flex-wrap:wrap;margin:0.4rem 0;"></div>
                <div id="sg-staff" style="margin:0.8rem auto;max-width:100%;overflow:hidden;position:relative;"></div>
                <p id="sg-prompt" style="text-align:center;color:#6366f1;font-weight:600;min-height:1.4rem;margin:0.3rem 0;"></p>
                <div id="sg-answers" style="text-align:center;margin:0.6rem 0;"></div>
                <div id="sg-extra" style="text-align:center;margin-bottom:0.5rem;"></div>
            </div>`;

        this.staffContainer = this.container.querySelector('#sg-staff');
        this.hudEl = this.container.querySelector('#sg-hud');
        this.promptEl = this.container.querySelector('#sg-prompt');
        this.answersEl = this.container.querySelector('#sg-answers');
        this.extraEl = this.container.querySelector('#sg-extra');
    }

    /**
     * Altura da caixa da pauta, DERIVADA DA PEÇA — mesmo princípio do piso de escala
     * horizontal do ScoreRenderer (o desenho pede a medida, não recebe um número fixo).
     *
     * Com altura fixa, uma peça que cabe no pentagrama (o Parabéns cabe: nem uma linha
     * suplementar) desperdiça uma faixa branca do tamanho de meia tela de celular — e num
     * app que o Bernardo quer compacto isso empurra o piano de resposta para baixo da
     * dobra. Aqui a caixa cresce só quando a música sobe ou desce de verdade.
     *
     * A folga acima cobre haste/beam para cima e o número do compasso; a de baixo, haste
     * para baixo. As duas são medidas em espaços de pauta, então acompanham `lineSpacing`.
     */
    _staffBox() {
        const ls = 10;                          // MusicStaff.config.lineSpacing default
        const ns = this.score ? this.score.notes().filter(n => n.type === 'note') : [];
        const pos = ns.map(n => n.position).filter(p => Number.isFinite(p));
        const maxPos = pos.length ? Math.max(...pos) : 8;
        const minPos = pos.length ? Math.min(...pos) : 0;
        // Acima da 5ª linha: suplementares + haste/beam (3,5 espaços) + nº do compasso.
        // 🔴 Com cifra (ou com o editor aberto, onde a primeira ainda vai nascer) a faixa
        // das cifras entra ACIMA disso e o nº do compasso sobe. Sem cifra nada muda um
        // pixel — é o que mantém o catálogo e a foto de OG do jogo (calibrada em px)
        // exatamente como já são.
        const harmonia = this._editingHarmony || !!(this.score && this.score.harmony.length);
        // 8,0 espaços com cifra: a banda fica em (maxPos−8)/2 + 4,6 (ScoreRenderer.HARMONY_CLEAR,
        // que limpa a ponta da haste), o nº do compasso 1,8 acima dela, e sobra o ascendente.
        const above = Math.max(0, maxPos - 8) * ls * 0.5 + ls * (harmonia ? 8.0 : 4.6);
        // Abaixo da 1ª linha: suplementares + haste p/ baixo.
        const below = Math.max(0, 0 - minPos) * ls * 0.5 + ls * 4.0;
        return { marginTop: Math.round(above), height: Math.round(above + 4 * ls + below) };
    }

    /** (Re)cria pauta + renderizador na largura atual. */
    _buildStaff() {
        if (this.renderer) { this.renderer.destroy(); this.renderer = null; }
        if (this.musicStaff) { this.musicStaff.destroy(); this.musicStaff = null; }
        this.staffContainer.innerHTML = '';
        // 🔴 O que mora ACIMA da pauta sobrevive à remontagem. A saída das cifras é o único
        // caso hoje (ela não pode ficar no `answersEl`, que o `HarmonyEditor` limpa), e sem
        // isto girar a tela com o editor aberto apagava a única saída de dedo da tela —
        // conserto criando o defeito que ele veio consertar.
        if (this._staffTopNode && this._editingHarmony) {
            this.staffContainer.appendChild(this._staffTopNode);
        }

        const measured = this.staffContainer.clientWidth;
        const w = Math.max(280, Math.floor(measured || window.innerWidth || 800));
        const box = this._staffBox();

        this.musicStaff = new window.MusicStaff(this.staffContainer, {
            width: w, height: box.height,
            marginLeft: 12, marginRight: 12, marginTop: box.marginTop
        });
        this.renderer = new window.ScoreRenderer(this.musicStaff, {
            densityMul: SongReadingGame.DENSITIES[this.densityIdx].mul
        });
        if (this.score) {
            this.renderer.setScore(this.score);
            this.renderer.scrollTo(0);
        }
        // 🔴 O editor guarda o renderer da construção. Na tela de cifras `_running` é false,
        // então o resize (girar a tela, o teclado virtual abrir, o Chrome esconder a barra
        // de URL) SEMPRE remonta a pauta — e o editor ficava apontando para um renderer
        // destruído: a pauta congelava no beat 0 e nenhuma cifra nova aparecia nela, sem um
        // erro sequer no console.
        if (this.harmonyEditor) {
            this.harmonyEditor.renderer = this.renderer;
            this.harmonyEditor.render();
        }
    }

    _makeButton(label, bg, onClick, opts = {}) {
        const btn = window.domManager.create('button', {
            textContent: label,
            styles: {
                padding: opts.small ? '0.5rem 1rem' : '0.85rem 1.6rem',
                fontSize: opts.small ? '0.95rem' : '1.15rem',
                // 🔴 Alvo de dedo, como o `SongShelf.MIN_TAP` já cumpria. Sem isto a altura
                // do botão dependia do GLIFO: os de emoji davam 41 px (o emoji estica a
                // caixa de linha) e o "↩ Voltar para X" dava 34 — o mesmo rótulo tinha 44 px
                // na lista e 34 na tela de importar. Medido em 360 px nos 3 idiomas.
                minHeight: '44px',
                background: bg, color: '#fff', border: 'none', borderRadius: '10px',
                cursor: 'pointer', fontWeight: 'bold', margin: '0.35rem',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }
        });
        btn.addEventListener('click', onClick);
        return btn;
    }

    /** Toggle segmentado (mesmo vocabulário visual da Leitura). */
    _segToggle(items, current, onChange) {
        const seg = document.createElement('div');
        seg.style.cssText = 'display:inline-flex;border:2px solid #e2e8f0;border-radius:999px;overflow:hidden;';
        items.forEach(([val, label]) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.textContent = label;
            const on = val === current;
            // min-height 44px: a 4ª cópia deste widget (Interval/Chord/ReadingFlow já tinham),
            // achada pela auditoria de deploy de 07/set — só de ALTURA, nunca de largura.
            b.style.cssText = `padding:0.4rem 0.85rem;min-height:44px;border:none;cursor:pointer;font-weight:700;font-size:0.85rem;
                background:${on ? '#6366f1' : 'transparent'};color:${on ? '#fff' : '#475569'};`;
            b.addEventListener('click', () => onChange(val));
            seg.appendChild(b);
        });
        return seg;
    }

    /** Rótulo + controle. `helpTopic` pendura o "?" à direita do RÓTULO do grupo:
     *  a dúvida de "Estudo / No tempo / Acompanhar" é "qual dos três?", e essa
     *  pergunta é do grupo — três "?" seriam três vezes o mesmo texto. */
    /** Açúcar: `_labeled` com o "?" já pendurado (a ordem dos argumentos fica melhor
     *  de ler quando o tópico vem primeiro). */
    _labeledHelp(topic, labelText, node) { return this._labeled(labelText, node, topic); }

    _labeled(labelText, node, helpTopic = null) {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'display:inline-flex;gap:0.4rem;align-items:center;';
        const lab = document.createElement('span');
        lab.textContent = labelText;
        lab.style.color = '#64748b';
        wrap.appendChild(lab);
        if (helpTopic && window.HelpDot) window.HelpDot.attach(wrap, helpTopic);
        wrap.appendChild(node);
        return wrap;
    }

    _showStartScreen() {
        this._closeShelf();
        // Sem peça não há tela de peça: cai na RAIZ (que nunca é 'start' sem peça — ver
        // `_rootScreen`, onde mora a guarda contra a recursão).
        if (!this.score) return this._renderScreen(this._rootScreen());
        this._enterScreen('start');
        this.promptEl.style.display = '';
        this.promptEl.textContent = '';
        this.promptEl.style.color = '#6366f1';
        this.hudEl.style.display = 'none';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';
        this._teardownInputDevices();
        if (this.renderer) { this.renderer.clearMarks(); this.renderer.scrollTo(0); }

        const t = this.container.querySelector('#sg-title');
        if (t) t.textContent = this._songTitle() || this._t('song.title');
        const sub = this.container.querySelector('#sg-sub');
        if (sub) sub.textContent = this._t('song.subtitle');

        this.answersEl.appendChild(this._makeButton(
            '▶ ' + this._t('song.start'), 'linear-gradient(135deg,#10b981,#059669)', () => this.start()));
        this.answersEl.appendChild(this._makeButton(
            '🎧 ' + this._t('song.listen'), 'linear-gradient(135deg,#6366f1,#8b5cf6)', () => this.listen(),
            { small: true }));

        // Porta das CIFRAS (Etapa 7). MIDI não traz acorde nenhum: quem sabe onde eles
        // entram é quem está tocando.
        const btnCifra = this._makeButton(
            '🎸 ' + this._t('song.harmony.open'), 'linear-gradient(135deg,#0f766e,#0d9488)',
            () => this._showHarmonyScreen(), { small: true });
        this.answersEl.appendChild(btnCifra);
        // O botão diz "Cifras" e não diz o que é uma cifra nem que o app não as toca.
        if (window.HelpDot) this.answersEl.appendChild(new window.HelpDot('song.chart').el);
        if (this.score && this.score.harmony.length) {
            const n = document.createElement('p');
            const q = this.score.harmony.length;
            n.textContent = this._t(q === 1 ? 'song.harmony.summary_one' : 'song.harmony.summary', { n: q });
            n.style.cssText = 'color:#0d9488;font-size:0.8rem;margin:0.25rem 0 0;font-weight:600;';
            this.answersEl.appendChild(n);
        }

        const stars = this._bestStars();
        if (stars > 0 && !this.freeMode) {
            const p = document.createElement('p');
            p.innerHTML = `<span style="color:#f59e0b;">${'★'.repeat(stars)}</span><span style="color:#e2e8f0;">${'☆'.repeat(3 - stars)}</span>`;
            p.style.cssText = 'font-size:1.5rem;margin:0.3rem 0 0;letter-spacing:0.15rem;';
            this.answersEl.appendChild(p);
        }

        // UMA porta para trocar de peça, igual nas duas rotas: a lista.
        //
        // 🔴 Eram TRÊS botões diferentes no mesmo lugar ("Importar MIDI" no catálogo, "Outro
        // arquivo" no livre sem estante, "Minhas músicas" no livre com estante) — e o do
        // catálogo ainda trocava de rota. Quem tinha repertório precisava reconhecer
        // "Importar MIDI" como "onde estão as minhas músicas". Agora o destino é sempre o
        // mesmo e a lista traz o catálogo, os arquivos do aluno e o importador dentro dela.
        //
        // 🔴 NÃO zera a peça aqui: quem trocava de tela e depois apertava Cancelar no
        // seletor do sistema ficava sem música nenhuma — e o `change` do <input> não dispara
        // em cancelamento, então não havia como reverter. A peça só sai quando outra entra.
        this.answersEl.appendChild(this._makeButton(
            '📚 ' + this._t('song.pick.open'), 'linear-gradient(135deg,#64748b,#475569)',
            () => this._showPickScreen(), { small: true }));

        if (this.imported) this.extraEl.appendChild(this._importSummaryCard());
        this.extraEl.appendChild(this._buildControls());
        const hint = document.createElement('p');
        hint.textContent = this._t(this.mode === 'study' ? 'song.modeStudyHint'
            : this.mode === 'play' ? 'song.modePlayHint' : 'song.modeTempoHint');
        hint.style.cssText = 'color:#64748b;font-size:0.82rem;margin:0.7rem auto 0;max-width:460px;line-height:1.45;';
        this.extraEl.appendChild(hint);

        if (this.score) {
            const credit = document.createElement('p');
            credit.textContent = this.score.credit || '';
            credit.style.cssText = 'color:#94a3b8;font-size:0.72rem;margin:0.9rem auto 0;max-width:520px;line-height:1.4;';
            this.extraEl.appendChild(credit);
        }
    }

    // =====================================================================
    // Cifras (Etapa 7) — docs/CIFRAS-PLANO.md
    //
    // 🔴 A cifra é FAIXA DO SCORE, nunca overlay: sobrevive ao redesenho da janela, à
    // troca de andamento e ao replay. O editor é DOM puro e não escreve no SVG.
    // =====================================================================

    _showHarmonyScreen() {
        if (!this.score) return;
        this._enterScreen('harmony');
        this._teardownInputDevices();
        this.hudEl.style.display = 'none';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';
        this.promptEl.textContent = '';
        // 🔴 O prompt vazio reserva 41 px (altura mínima + margens) entre a pauta e a grade,
        // medidos no celular. Aqui não há frase para dizer — a tela inteira é a instrução.
        this.promptEl.style.display = 'none';

        // 🔴 A pauta é remontada com a faixa das cifras reservada mesmo que a peça ainda
        // não tenha nenhuma — senão a PRIMEIRA cifra plantada nasceria fora do viewBox.
        this._editingHarmony = true;
        this._buildStaff();

        const t = this.container.querySelector('#sg-title');
        // 🔴 O nome da PEÇA fica no título. Ele virava só "Cifras" e a tela não dizia mais
        // em que música os acordes estavam sendo plantados — e quem chega aqui pela lista
        // acabou de escolher entre várias.
        const nome = this._openLabel();
        if (t) t.textContent = nome ? this._t('song.harmony.title') + ' · ' + nome
                                    : this._t('song.harmony.title');
        const sub = this.container.querySelector('#sg-sub');
        if (sub) sub.textContent = this._t('song.harmony.lead');

        // 🔴 A saída fica no TOPO. A única era o "✓ Pronto", que num celular de 360×640 cai
        // em y=884 — abaixo da dobra, depois da pauta, da grade de compassos e de cinco
        // fileiras de acordes. Aqui em cima ela espelha o que a lista já faz.
        // 🔴 No `staffContainer` e não no `answersEl`: o `HarmonyEditor` limpa o host dele.
        const volta = this._makeButton('↩ ' + this._openLabel(),
            'linear-gradient(135deg,#10b981,#059669)', () => this._backScreen(), { small: true });
        volta.dataset.harmonyBack = '1';
        volta.style.margin = '0 0 0.5rem';
        this._staffTopNode = volta;
        this.staffContainer.insertBefore(volta, this.staffContainer.firstChild);

        this.harmonyEditor = new window.HarmonyEditor({
            score: this.score,
            renderer: this.renderer,
            host: this.answersEl,
            t: (k, params) => this._t(k, params),
            onChange: (info) => this._saveHarmony(info || {}),
            onDone: () => { this._closeHarmonyEditor(); this._showStartScreen(); }
        });
        this.harmonyEditor.render();
    }

    _closeHarmonyEditor() {
        if (this.harmonyEditor) { this.harmonyEditor.destroy(); this.harmonyEditor = null; }
        this._staffTopNode = null;
        this.promptEl.style.display = '';
        if (!this._editingHarmony) return;
        this._editingHarmony = false;
        // A caixa da pauta muda de altura conforme a peça FICOU com cifra ou não.
        this._buildStaff();
    }

    // =====================================================================
    // ESTANTE (Etapa 8) — docs/ESTANTE-PLANO.md
    //
    // As CIFRAS já voltavam (chave pelo hash do conteúdo do arquivo); o ARQUIVO não. Aqui
    // ele passa a ficar no aparelho (`SongStore`/IndexedDB) e a peça abre cifrada em um
    // toque. 🔴 O arquivo continua NÃO SAINDO do aparelho — guardar localmente é o que a
    // Etapa 8 acrescenta; subir para servidor segue fora, e é o que a tela promete em
    // três idiomas.
    // =====================================================================

    /** Lê a estante e junta a contagem de cifras (localStorage, síncrono). Nunca estoura. */
    async _refreshShelf() {
        this._shelfSongs = [];
        this._shelfIds = new Set();
        if (!window.songStore) return this._shelfSongs;
        const metas = await window.songStore.list();
        // 🔴 O join é por `id` e o `id` é o mesmo hash que as cifras já usam em produção —
        // é por isso que a Etapa 8 não tem passo de migração: a estante se pendura na
        // identidade que o `song_harmony_v1` sempre teve.
        const cifras = this._harmonyStore();
        this._shelfIds = new Set(metas.map(m => m.id));
        this._shelfSongs = metas.map(m => Object.assign({}, m, {
            chords: ((cifras[m.id] && cifras[m.id].chords) || []).length
        }));
        return this._shelfSongs;
    }

    /**
     * Guarda a peça recém-importada. Fire-and-forget: a partitura JÁ está na tela quando
     * isto roda.
     *
     * 🔴 Falha da estante nunca impede tocar. Cheia avisa (dá para apagar uma e tentar de
     * novo); indisponível cala a boca — não há nada que a pessoa possa fazer a respeito, e
     * um alarme por arquivo importado seria ruído puro.
     */
    _shelfStore(buffer, fileName, trackIndex) {
        if (!window.songStore || !buffer) return Promise.resolve();
        return window.songStore.put({
            id: SongReadingGame.hashBytes(buffer), name: fileName, bytes: buffer, trackIndex
        }).then(async (res) => {
            if (this._destroyed) return;
            if (!res.ok && window.notifications
                && (res.reason === 'full' || res.reason === 'fullBytes')) {
                // Dois tetos, duas frases: por arquivos o número é o limite; por espaço
                // não há número que faça sentido para quem lê.
                window.notifications.toast(
                    res.reason === 'fullBytes'
                        ? this._t('song.shelf.fullBytes')
                        : this._t('song.shelf.full', { max: window.SongStore.MAX_FILES }),
                    { type: 'error', duration: 6000 });
            }
            const tinhaEstante = (this._shelfSongs || []).length > 0;
            await this._refreshShelf();
            // 🔴 De novo depois do `await`: a rota pode ter trocado enquanto a estante era
            // relida, e `_showStartScreen` numa instância morta mexeria no histórico do
            // jogo seguinte (o `_enterScreen` pode chamar `history.back()`).
            if (this._destroyed) return;
            // 🔴 A PRIMEIRA peça guardada da sessão nasce depois de a tela inicial já estar
            // desenhada (guardar é async, desenhar não é) — e a tela ficava sem a porta
            // "Minhas músicas" até a pessoa navegar por outro caminho. Redesenha uma vez, e
            // só quando a estante ACABOU de passar a existir. Achado pelo controle positivo
            // do `library-test [E]`: a asserção de que a porta some sem IndexedDB passava
            // sozinha, porque ela também não aparecia COM.
            if (!tinhaEstante && this._shelfSongs.length && this.score && this._screen === 'start') {
                this._showStartScreen();
            }
        }).catch(() => {});
    }

    /**
     * A tela "Escolher música" — a LISTA ÚNICA das duas rotas.
     *
     * 🔴 Ela lista o repertório do aluno E o catálogo. Antes eram dois lugares: o catálogo
     * (uma peça) morava numa rota e a estante na outra, e a hierarquia estava de cabeça
     * para baixo — o ladrilho do ⊞ levava sempre à peça de demonstração, e o repertório da
     * pessoa ficava atrás de um botão chamado "Importar MIDI".
     *
     * `notice` = recado de uma operação (relatório do backup, sincronia, peça sumida).
     */
    _showPickScreen(notice) {
        this._enterScreen('pick');
        this._closeHarmonyEditor();
        this._closeShelf();
        this._teardownInputDevices();
        this.hudEl.style.display = 'none';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';
        this.promptEl.textContent = '';
        this.promptEl.style.display = 'none';
        // A lista ocupa o lugar da pauta, como a área de soltar arquivo já faz: não há peça
        // escolhida enquanto se escolhe a peça.
        if (this.renderer) { this.renderer.destroy(); this.renderer = null; }
        if (this.musicStaff) { this.musicStaff.destroy(); this.musicStaff = null; }
        this.staffContainer.innerHTML = '';

        const t = this.container.querySelector('#sg-title');
        if (t) t.textContent = this._t('song.pick.title');
        const sub = this.container.querySelector('#sg-sub');
        if (sub) sub.textContent = this._t('song.pick.lead');

        this.shelf = new window.SongShelf({
            host: this.staffContainer,
            t: (k, params) => this._t(k, params),
            songs: this._shelfSongs || [],
            catalog: this._catalogRows(),
            // Qual linha é a peça que está aberta atrás desta tela. Sem isto, entrar na
            // lista no meio do estudo não dizia de onde a pessoa veio.
            // 🔴 `this.score &&`: o catch de uma importação RECUSADA zera `score` e `imported`
            // mas não `songId`/`freeMode`, então `_harmonyId()` ainda devolvia `catalog:…` e
            // a lista marcava "▶ aberta agora" numa peça que a tela anterior descartou.
            currentId: this.score ? this._harmonyId() : null,
            // 🔴 A saída para a peça aberta fica NO TOPO, dentro do nó da lista. Ela era o
            // último elemento da tela — depois de 60 linhas, do bloco de backup e da linha
            // de privacidade —, e é a ação mais provável de quem entrou aqui sem querer.
            // 🔴 SÓ existe se LEVAR a algum lugar. A 1ª versão desta reforma mostrava o
            // botão sempre — e quando a lista é a PRÓPRIA raiz (quem já tem música guardada
            // entra direto nela), ele "voltava" para a tela em que a pessoa já estava:
            // botão morto, rotulado "↩ Música de Verdade". Relatado do tablet, em produção.
            //
            // 🔴 E o teste que o guardava afirmava que ele EXISTE, não que ele FUNCIONA —
            // asserção cega de manual. Agora a asserção clica e exige a TROCA de tela.
            //
            // Não é beco: quando a lista é a raiz, a saída dela é escolher uma música (o
            // catálogo está sempre na lista) e o header persistente cobre o resto.
            back: (this.score || this._navToken)
                ? { label: (this.score && this._openLabel()) || this._t(
                        this._rootScreen() === 'import' ? 'song.import.title' : 'song.title'),
                    onBack: () => this._backScreen() }
                : null,
            notice: notice || null,
            onOpen: (id) => this._openFromPick(id),
            onRemove: (song) => this._askRemoveFromShelf(song),
            onImportFile: () => this._pickFile(),
            onExport: () => this._exportRepertoire(),
            onImportBackup: () => this._pickBackup(),
            // O rótulo tem de PROMETER o que vai acontecer: "Enviar cópia" onde a folha de
            // compartilhamento abre, "Baixar cópia" onde o arquivo cai no disco.
            canShare: window.SongStore ? window.SongStore.canShareFiles() : false,
            account: this._accountState(),
            onSync: () => this._syncWithAccount(),
            // 🔴 `AuthGate` só tem `allow(nivel)` — é o gate da TRILHA, e aqui não há nível
            // nenhum. Quem abre a caixa de login é o `AuthModal`, a mesma porta que o
            // avatar do header usa. Chamar `authGate.open()` compilava e não fazia NADA.
            // 🔴 Os modos são 'signin' | 'signup' | 'forgot' | 'reset'. Um modo inventado
            // ('login') não estoura: o modal abre SEM os botões sociais e sem os campos de
            // cadastro, porque o render só testa igualdade. Falha silenciosa das boas.
            onLogin: () => { if (window.authModal) window.authModal.open('signin'); },
            onForget: (id, nome) => this._askForget(id, nome)
        });
        this.shelf.render();
        this.extraEl.appendChild(this._privacyLine());
    }

    /**
     * Nome curto da peça aberta — o arquivo do aluno, ou o título do catálogo.
     *
     * 🔴 SEM a extensão: o `h1` já mostrava "valsa" (`ScoreBuilder` recebe o nome sem
     * `.mid`) enquanto os botões diziam "valsa.mid". Uma peça, dois nomes na mesma tela.
     * A LISTA continua mostrando o nome do arquivo com extensão — lá é o arquivo mesmo.
     */
    _openLabel() {
        if (this.imported && this.imported.fileName) {
            return this.imported.fileName.replace(/\.(mid|midi)$/i, '');
        }
        return this._songTitle() || '';
    }

    /**
     * As linhas do CATÁLOGO na lista. O id leva o prefixo `catalog:` — a mesma identidade
     * que as cifras e a sincronia já usam — para não colidir nunca com o hash de um arquivo.
     */
    _catalogRows() {
        const estrelas = this._loadStars();
        return SongReadingGame.SONGS.map(def => ({
            id: 'catalog:' + def.id,
            name: this._catalogTitle(def),
            stars: estrelas[def.id] | 0,
            chords: ((this._harmonyStore()['catalog:' + def.id] || {}).chords || []).length
        }));
    }

    /** Título de uma peça do catálogo, com o literal do arquivo como rede. */
    _catalogTitle(def) {
        const v = def.titleKey ? this._t(def.titleKey) : '';
        if (v && v !== def.titleKey) return v;
        return (this.songId === def.id && this._songTitle()) || def.id;
    }

    /** Um toque numa linha da lista: catálogo ou arquivo do aluno, sem trocar de rota. */
    async _openFromPick(id) {
        if (/^catalog:/.test(id)) return this._openCatalog(id.replace(/^catalog:/, ''));
        return this._openFromShelf(id);
    }

    /**
     * Abre uma peça do catálogo NA MESMA ROTA. É `freeMode` seguir a peça (e não a rota)
     * que torna isto possível — em `#/musicas-livre` a peça do catálogo continua sendo do
     * catálogo, com o recorde e as cifras dela.
     */
    async _openCatalog(id) {
        this._closeShelf();
        try {
            await this._loadSong(id);
        } catch (err) {
            if (this._destroyed) return;
            console.warn('SongReadingGame: falha ao carregar a peça do catálogo', err);
            return this._showPickScreen({ text: this._t('song.import.err.demoFailed'), tone: 'error' });
        }
        if (this._destroyed) return;
        this._buildStaff();
        this._showStartScreen();
    }

    _closeShelf() {
        if (this.shelf) { this.shelf.destroy(); this.shelf = null; }
        if (this.promptEl) this.promptEl.style.display = '';
    }

    /** Um toque na linha: bytes da estante → o MESMO caminho de importação de sempre. */
    async _openFromShelf(id) {
        const rec = window.songStore ? await window.songStore.get(id) : null;
        if (this._destroyed) return;
        if (!rec || !rec.bytes) {
            // Estante e tela discordando: aconteceu algo entre listar e abrir (outra aba,
            // limpeza do browser). Relista em vez de mentir.
            await this._refreshShelf();
            if (!this._destroyed) this._showPickScreen({ text: this._t('song.shelf.gone'), tone: 'error' });
            return;
        }
        this._closeShelf();
        // 🔴 A FAIXA guardada volta junto: sem ela, reabrir um arquivo de banda reaplicaria
        // a heurística, poderia cair noutra faixa, e as cifras plantadas na faixa longa
        // apareceriam como "ficaram fora desta faixa". Guardar a faixa é o que faz "abre
        // como você deixou" ser verdade.
        this._importBytes(rec.bytes, rec.name, rec.trackIndex == null ? undefined : rec.trackIndex);
    }

    _askRemoveFromShelf(song) {
        const n = song.chords || 0;
        const body = document.createElement('div');
        // 🔴 Apagar o ARQUIVO não apaga as CIFRAS: elas são indexadas pelo conteúdo dele, e
        // reimportar o mesmo .mid as traz de volta. Dizer isso na hora da confirmação é o
        // que separa "apaguei um arquivo" de "perdi uma tarde de trabalho".
        body.textContent = n
            ? this._t(n === 1 ? 'song.shelf.removeAskChords_one' : 'song.shelf.removeAskChords',
                      { name: song.name, n })
            : this._t('song.shelf.removeAsk', { name: song.name });
        body.style.cssText = 'text-align:center;color:#475569;line-height:1.5;';
        window.notifications.modal({
            title: this._t('song.shelf.remove'),
            node: body,
            actions: [
                { label: this._t('song.shelf.remove'), style: 'primary', onClick: () => this._removeFromShelf(song.id) },
                { label: this._t('common.cancel'), style: 'neutral' }
            ],
            dismissible: true
        });
    }

    async _removeFromShelf(id) {
        if (window.songStore) await window.songStore.remove(id);
        await this._refreshShelf();
        if (this._destroyed) return;
        // 🔴 Volta SEMPRE para a lista. O `else _showImportScreen()` era resto da
        // arquitetura anterior, quando a lista podia ficar vazia — agora o catálogo mora
        // nela e ela existe sempre. Quem apagava a última música era ejetado para o
        // importador, que ainda oferecia "↩ Voltar para <o arquivo recém-apagado>".
        this._showPickScreen();
    }

    /**
     * A linha de privacidade da tela de importação — e ela MUDA com o estado da conta.
     *
     * 🔴 Convidado continua lendo a frase inteira ("o arquivo não é enviado para nenhum
     * servidor"), que segue LITERALMENTE verdadeira: sem conta nada sobe. Para quem está
     * logado ela deixou de ser verdadeira no dia em que o .mid passou a viajar, e uma
     * promessa de privacidade que o app não cumpre mais é pior que promessa nenhuma.
     * A frase de logado não recua — termina: o arquivo fica guardado NA CONTA, e é por
     * isso que ele aparece no outro aparelho.
     */
    _privacyLine() {
        const p = document.createElement('p');
        const logado = !!(window.songSync && window.songSync.available());
        p.textContent = this._t(logado ? 'song.import.privacyAccount' : 'song.import.privacy');
        p.style.cssText = 'color:#94a3b8;font-size:0.78rem;margin:1rem auto 0;max-width:460px;line-height:1.45;';
        // A linha promete que o arquivo fica no aparelho; o "?" diz o que isso
        // custa (não segue a conta) e como levar as músicas junto (o backup).
        const wrap = document.createElement('div');
        wrap.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:0.1rem;max-width:520px;margin:0 auto;';
        wrap.appendChild(p);
        if (window.HelpDot) window.HelpDot.attach(wrap, 'song.account');
        return wrap;
    }

    // ---------- a conta: o repertório segue a PESSOA (Etapa 9) ----------

    /** Estado que a barra da conta desenha. `null` some com a barra inteira. */
    _accountState() {
        if (!window.songSync) return null;
        return {
            loggedIn: window.songSync.available(),
            // 🔴 `synced` existe porque ANTES da primeira conversa com o servidor não há
            // número nenhum para mostrar: o teto vem de lá. Sem isto a barra abria dizendo
            // "1 de 0 músicas na sua conta" — número local contra teto inexistente.
            synced: this._cloudMax != null,
            count: this._cloudCount || 0,
            max: this._cloudMax || 0,
            busy: !!this._syncBusy,
            songs: this._cloudSongs || []
        };
    }

    /**
     * Sincroniza o repertório com a conta. BAIXA → FUNDE → SOBE, nessa ordem.
     *
     * 🔴 Baixar ANTES de subir é a mesma lei do login do ranking: subir primeiro faria a
     * cifra deste aparelho vencer por ser a última a escrever, e a tarde de trabalho feita
     * no outro aparelho evaporava sem ninguém ver.
     *
     * 🔴 Quem funde é `SongStore.mergeChords` — a função do backup `.json`, já testada.
     * Nada de fusão mora aqui nem no PHP.
     */
    async _syncWithAccount() {
        if (this._syncBusy || !window.songSync || !window.songSync.available()) return;
        this._syncBusy = true;
        this._showPickScreen();

        const S = window.SongStore;
        const r = { sent: 0, got: 0, full: 0, tooNew: 0, gotFiles: 0, noRoom: 0, fileErr: 0 };
        // 🔴 Preenchido DEPOIS do `list()`: "enviadas" tem de medir quantas linhas ENTRARAM
        // na conta nesta passada. Lido antes, ele confundia "aprendi que a conta tem 1" com
        // "acabei de pôr 1 lá" — e a tela dizia "1 música enviada" numa passada em que nada
        // subiu (era o que o bloco [U] mostrava).
        let contaAntes = 0;
        try {
            // ── 1. BAIXAR ────────────────────────────────────────────────────────
            const remoto = await window.songSync.list();
            if (!remoto.success) {
                this._syncBusy = false;
                if (this._destroyed) return;
                this._finishSync({ text: this._t('song.cloud.err'), tone: 'error' });
                return;
            }
            this._cloudMax = remoto.max;
            this._cloudCount = remoto.rows.length;
            contaAntes = remoto.rows.length;
            this._cloudSongs = remoto.rows.map(x => ({ id: x.id, name: x.name || '' }));

            // ── 2. FUNDIR no que está aqui ───────────────────────────────────────
            const store = this._harmonyStore();
            // 🔴 Ids que este app NÃO SABE LER ficam INTOCADOS nas duas direções: não entram
            // na fusão e não sobem. Ver `SongSync.itemsOf` — misturar "linha vazia" com
            // "linha que não sei ler" fazia o app velho re-subir a cifra pobre dele por cima
            // da nova, com o carimbo da nova.
            const intocados = new Set();
            for (const row of remoto.rows) {
                const vindas = window.SongSync.itemsOf(row);
                if (vindas === null) { intocados.add(row.id); r.tooNew++; continue; }
                const local = store[row.id];
                const remotoMaisNovo = (row.updated_at || 0) > ((local && local.updatedAt) || 0);
                const m = S.mergeChords(local && local.chords, vindas, remotoMaisNovo, window.Score.isValidChord);
                // `replaced` conta tanto quanto `added`: uma cifra TROCADA muda o que a
                // pessoa vê na pauta. Sem ela o relatório dizia "nada de novo" enquanto o
                // acorde mudava debaixo dela.
                r.got += m.added + (m.replaced || 0);
                if (m.chords.length) {
                    store[row.id] = {
                        name: (local && local.name) || row.name || '',
                        updatedAt: Math.max(row.updated_at || 0, (local && local.updatedAt) || 0) || Date.now(),
                        chords: m.chords
                    };
                }
            }
            await this._refreshShelf();
            this._writeHarmonyStore(store, this._shelfIds);
            // 🔴 O SEGUNDO refresh (o `_mergeRepertoire` tem os dois, e é por isto): a
            // contagem de cifras da lista é lida do localStorage, então sem ele a tela
            // mostrava "12 cifras novas" no recado e "sem cifras" na linha da música.
            await this._refreshShelf();

            // ── 2b. BAIXAR os ARQUIVOS que a conta tem e este aparelho não ────────
            // 🔴 É este passo que faz a sincronia significar o que a tela promete. Sem ele
            // o outro aparelho recebia NOME e CIFRA de uma peça que não existe nele: a
            // música aparecia na lista da conta e não abria, e a pessoa concluía (com
            // razão) que a sincronia não funcionou.
            for (const row of remoto.rows) {
                if (!row.has_file || this._shelfIds.has(row.id)) continue;
                const bx = await window.songSync.file(row.id);
                if (this._destroyed) return;
                if (!bx.success) { r.fileErr++; continue; }
                // 🔴 CONFERE O HASH DO QUE CHEGOU. O servidor já provou na subida, mas o id
                // é a chave em que as CIFRAS estão penduradas: guardar bytes errados sob um
                // id válido planta uma peça que abre com a cifragem de outra, e o id certo
                // fica ocupado — a peça boa não volta nem reimportando o arquivo original.
                if (SongReadingGame.hashBytes(bx.bytes.buffer) !== row.id) { r.fileErr++; continue; }
                const res = await window.songStore.put({
                    id: row.id, name: row.name || '', bytes: bx.bytes,
                    trackIndex: row.track_index
                });
                if (this._destroyed) return;
                // Estante cheia NÃO despeja (lei da Etapa 8): a conta tem a música, este
                // aparelho é que não tem espaço. Contado e dito, nunca resolvido à força.
                if (res && res.ok) r.gotFiles++; else r.noRoom++;
            }
            if (r.gotFiles) await this._refreshShelf();

            // ── 3. SUBIR o resultado ─────────────────────────────────────────────
            // 🔴 A fila é a ESTANTE, não o mapa de cifras: `song_harmony_v1` guarda até 64
            // arquivos, muitos deles já apagados do aparelho. Subir por ele encheria a
            // conta (teto 3) com peças que a pessoa não tem mais, e a música que ela está
            // estudando agora receberia `songs_full`.
            // 🔴 A peça ABERTA pode não estar na estante (estante cheia no import, IndexedDB
            // bloqueado, ou o arquivo apagado mantendo as cifras — os três são caminhos
            // normais). Sem ela na fila, a hora de trabalho que está na tela AGORA nunca
            // chegava à conta, e o relatório nem sabia que ela existia.
            const fila = (this._shelfSongs || []).slice();
            const aberta = this._harmonyId();
            if (aberta && !/^catalog:/.test(aberta) && !fila.some(p => p.id === aberta)) {
                fila.push({ id: aberta,
                            name: (this.imported && this.imported.fileName) || '',
                            trackIndex: (this.imported && this.imported.trackIndex) });
            }
            // Quem a conta já tem COM arquivo não precisa dos bytes de novo: os .mid são a
            // parte pesada e o id é o hash do conteúdo, então "já está lá" implica idêntico.
            const comArquivo = new Set(remoto.rows.filter(x => x.has_file).map(x => x.id));
            for (const peca of fila) {
                if (intocados.has(peca.id)) continue;
                const h = store[peca.id] || {};
                // 🔴 Os BYTES sobem junto do metadado, na mesma chamada. Só são lidos do
                // disco quando a conta ainda não os tem — e a peça ABERTA que nunca foi
                // guardada na estante simplesmente não tem bytes para mandar: sobe só a
                // cifra, que é a carga cara, e o arquivo vai no dia em que couber.
                let midi = null;
                if (!comArquivo.has(peca.id) && window.songStore) {
                    const guardada = await window.songStore.get(peca.id);
                    if (this._destroyed) return;
                    if (guardada && guardada.bytes) midi = window.SongStore.toBase64(guardada.bytes);
                }
                const res = await window.songSync.put({
                    id: peca.id,
                    name: peca.name || '',
                    trackIndex: peca.trackIndex,
                    chords: h.chords || [],
                    updatedAt: h.updatedAt || 0,
                    midi
                });
                if (res.success) { r.sent++; this._cloudCount = res.count; this._cloudMax = res.max; }
                else if (res.code === 'songs_full') { r.full++; if (res.max) this._cloudMax = res.max; }
                else {
                    // Rede/sessão: para a passada inteira. Insistir agora sai mais caro que
                    // tentar de novo no próximo toque — mesma regra do backfill do ranking.
                    this._syncBusy = false;
                    if (this._destroyed) return;
                    // 🔴 O erro NÃO apaga o que já aconteceu: a fusão já foi para o disco e
                    // os `put` anteriores já subiram. Dizer só "falhou" ensina a pessoa a
                    // desconfiar de uma operação que funcionou pela metade.
                    r.sentNew = Math.max(0, (this._cloudCount || 0) - contaAntes);
                    const feito = this._syncReport(r, true);
                    this._finishSync({ text: feito ? feito + ' · ' + this._t('song.cloud.err')
                                                   : this._t('song.cloud.err'), tone: 'error' });
                    return;
                }
            }
        } catch (e) {
            this._syncBusy = false;
            if (this._destroyed) return;
            // 🔴 Erro de CÓDIGO cai aqui e virava "não deu para falar com a sua conta" —
            // a frase de rede, com o servidor tendo respondido 200. Foi assim que um
            // `TypeError` de exportação de classe se disfarçou de problema de internet.
            if (window.console && console.error) console.error('[sync]', e);
            this._finishSync({ text: this._t('song.cloud.err'), tone: 'error' });
            return;
        }

        this._syncBusy = false;
        if (this._destroyed) return;
        r.sentNew = Math.max(0, (this._cloudCount || 0) - contaAntes);
        // A peça aberta pode ter recebido cifra da conta: recarrega do disco.
        if (this.score) { this._loadHarmony(); if (this.renderer) this.renderer.refresh(); }
        this._finishSync({ text: this._syncReport(r), tone: 'info' });
    }

    /**
     * Tirar UMA música da conta. 🔴 Confirmação obrigatória e a frase diz o que NÃO
     * acontece: o arquivo e as cifras continuam neste aparelho. Sem essa frase, "tirar da
     * conta" e "apagar" viram a mesma coisa na cabeça de quem lê — e uma delas destrói
     * trabalho manual.
     */
    _askForget(id, nome) {
        const seguir = async () => {
            const res = await window.songSync.forget(id);
            if (!res.success) { this._finishSync({ text: this._t('song.cloud.err'), tone: 'error' }); return; }
            this._cloudCount = res.count;
            this._cloudSongs = (this._cloudSongs || []).filter(x => x.id !== id);
            if (!this._destroyed) this._finishSync(null);
        };
        // Mesmo molde do `_askRemoveFromShelf` — `notifications.confirm` não existe neste
        // projeto; a primitiva é `modal({actions})`.
        const body = document.createElement('div');
        body.textContent = this._t('song.cloud.forgetAsk', { name: nome || this._t('song.shelf.untitled') });
        body.style.cssText = 'text-align:center;color:#475569;line-height:1.5;';
        window.notifications.modal({
            title: this._t('song.cloud.forget'),
            node: body,
            actions: [
                { label: this._t('song.cloud.forget'), style: 'primary', onClick: seguir },
                { label: this._t('common.cancel'), style: 'neutral' }
            ],
            dismissible: true
        });
    }

    /**
     * Fecha a sincronia SEM puxar o tapete.
     *
     * 🔴 Os `put` são sequenciais e a tela continua navegável enquanto rodam: a pessoa pode
     * ter aberto uma música no meio. Redesenhar a estante por cima dela destruía o renderer
     * de uma peça que já estava tocando — e como o `destroy()` não passa por `stop()`, o
     * `_loop` seguinte batia em `renderer.scrollTo` de um `null`, matava a cadeia de
     * `requestAnimationFrame` com o metrônomo agendado ainda soando, e o ⏹ tinha sido
     * apagado junto. Se a estante não está mais na tela, o recado vira toast.
     */
    _finishSync(notice) {
        const naTela = !!(this.shelf && this.shelf.el && this.shelf.el.isConnected);
        if (naTela) { this._showPickScreen(notice); return; }
        if (notice && notice.text && window.notifications) {
            window.notifications.toast(notice.text,
                { type: notice.tone === 'error' ? 'error' : 'info', duration: 7000 });
        }
    }

    /**
     * Relatório em UMA linha. Mesma regra do backup: zero não vira frase, e cada número tem
     * singular — "1 cifras novas" nos três idiomas já foi achado por duas auditorias.
     *
     * 🔴 "Enviadas" conta o que ENTROU NA CONTA (delta da contagem do servidor), não quantos
     * `put` saíram daqui. Contando os `put`, toda passada dizia "3 músicas enviadas" mesmo
     * sem nada ter mudado, e `song.cloud.nothing` era inalcançável — um relatório que nunca
     * diz "nada mudou" não informa nada.
     * @param {boolean} parcial não devolve a frase de "nada" (o chamador vai emendar o erro)
     */
    _syncReport(r, parcial) {
        const partes = [];
        const p = (n, chave, extra) => { if (n > 0) partes.push(this._t(
            'song.cloud.' + chave + (n === 1 ? '_one' : ''), Object.assign({ n }, extra || {}))); };
        // 🔴 As músicas BAIXADAS vêm primeiro: num aparelho novo é o único número que
        // importa, e é a resposta à pergunta que a pessoa fez ao apertar o botão.
        p(r.gotFiles || 0, 'gotFiles');
        p(r.got, 'got');
        p(r.sentNew || 0, 'sent');
        p(r.full, 'full', { max: this._cloudMax || 0 });
        p(r.noRoom || 0, 'noRoom');
        p(r.fileErr || 0, 'fileErr');
        p(r.tooNew, 'tooNew');
        if (partes.length) return partes.join(' · ');
        return parcial ? '' : this._t('song.cloud.nothing');
    }

    // ---------- backup: um .json que atravessa aparelhos ----------

    /**
     * Repertório inteiro (arquivos + cifras) num `.json` que a PESSOA leva no dedo.
     * 🔴 Nada aqui fala com a rede: é `Blob` + `<a download>`, do aparelho para o aparelho.
     */
    async _exportRepertoire() {
        const metas = window.songStore ? await window.songStore.list() : [];
        if (!metas.length) {
            if (window.notifications) window.notifications.toast(this._t('song.backup.empty'), { type: 'error' });
            return;
        }
        const songs = [];
        for (const m of metas) {
            const rec = await window.songStore.get(m.id);
            if (rec) songs.push(rec);
        }
        if (this._destroyed) return;
        const pack = window.SongStore.packRepertoire(songs, this._harmonyStore());
        const blob = new Blob([JSON.stringify(pack)], { type: 'application/json' });
        // Nome NEUTRO de idioma, como a cifra: é um nome de arquivo, e ele vai viajar entre
        // aparelhos cujo idioma pode ser outro.
        const nome = 'aulademusica-repertorio-' + new Date().toISOString().slice(0, 10) + '.json';

        // 🔴 No CELULAR, entregar > baixar. Baixar deixa o `.json` na pasta de downloads do
        // MESMO aparelho de onde ele saiu — e o objetivo era justamente sair dele. A folha
        // de compartilhamento do sistema (AirDrop, WhatsApp, Arquivos) faz o trabalho todo
        // em um toque. No computador `canShareFiles()` diz não e o download segue valendo,
        // que lá é o certo: o arquivo vai para uma pasta que a pessoa sabe abrir.
        if (window.SongStore.canShareFiles()) {
            try {
                const f = new File([blob], nome, { type: 'application/json' });
                await navigator.share({ files: [f], title: nome });
                return;
            } catch (e) {
                // Cancelar a folha é uma DECISÃO da pessoa, não uma falha: não cair no
                // download por trás dela (ela veria um arquivo aparecer depois de desistir).
                if (e && (e.name === 'AbortError' || e.name === 'NotAllowedError')) return;
                // Qualquer outra falha (share indisponível na hora, arquivo grande demais
                // para o alvo) cai no download abaixo — nunca sair sem entregar nada.
            }
        }

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        a.remove();
        // Revogar na hora corta o download em alguns browsers; um quadro depois basta.
        setTimeout(() => URL.revokeObjectURL(url), 2000);
    }

    /** Seletor do sistema para o `.json` de repertório. */
    _pickBackup() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.json,application/json';
        input.style.display = 'none';
        input.addEventListener('change', () => {
            const f = input.files && input.files[0];
            if (f) {
                const reader = new FileReader();
                reader.onload = () => this._mergeRepertoire(String(reader.result || ''));
                reader.onerror = () => this._showPickScreen(
                    { text: this._t('song.import.err.readFailed'), tone: 'error' });
                reader.readAsText(f);
            }
            input.remove();
        });
        input.addEventListener('cancel', () => input.remove());
        document.body.appendChild(input);
        input.click();
    }

    /**
     * Funde um backup no que já existe neste aparelho.
     *
     * 🔴 ADITIVO, NUNCA DESTRUTIVO — a mesma regra do `deploy.sh` e pelo mesmo motivo.
     * Cifra funde por UNIÃO DE BEAT: beat de um lado só entra, beat nos dois fica com o do
     * registro mais NOVO. Apagar não se propaga. O erro possível é ficar com uma cifra a
     * mais; o outro seria perder uma tarde de trabalho manual, que foi exatamente o defeito
     * nº 1 da auditoria das cifras.
     */
    async _mergeRepertoire(text) {
        const S = window.SongStore;
        const { songs, errors, fixedIds } =
            S.unpackRepertoire(text, SongReadingGame.hashBytes, window.MidiFile.MAX_BYTES);
        if (!songs.length) {
            const e = errors[0] || { code: 'badSong' };
            await this._refreshShelf();
            if (!this._destroyed) {
                this._backToShelfOrImport({ text: this._t('song.backup.err.' + e.code, e.params || {}), tone: 'error' });
            }
            return { added: 0, updated: 0, chords: 0, noRoom: 0, noShelf: 0, fixed: 0, skipped: errors.length };
        }

        const store = this._harmonyStore();
        const r = { added: 0, updated: 0, chords: 0, rejected: 0, noRoom: 0, noShelf: 0,
                    fixed: fixedIds, skipped: errors.length };
        for (const sg of songs) {
            const local = store[sg.id];
            const maisNovo = (sg.updatedAt || 0) > ((local && local.updatedAt) || 0);
            // 🔴 A lei da cifra vai junto (`Score.isValidChord`): sem ela, uma cifra
            // corrompida que chegasse mais nova DESLOCAVA a cifra boa que estava aqui — e
            // sumia de vez no save seguinte, com a tela dizendo "1 atualizadas".
            const m = S.mergeChords(local && local.chords, sg.chords, maisNovo, window.Score.isValidChord);
            r.chords += m.added;
            r.rejected += m.rejected;
            if (m.chords.length) {
                store[sg.id] = {
                    name: (local && local.name) || sg.name || '',
                    updatedAt: Math.max(sg.updatedAt || 0, (local && local.updatedAt) || 0) || Date.now(),
                    chords: m.chords
                };
            }
            const jaTinha = this._shelfIds && this._shelfIds.has(sg.id);
            const res = window.songStore
                ? await window.songStore.put({ id: sg.id, name: sg.name, bytes: sg.bytes, trackIndex: sg.trackIndex })
                : { ok: false, reason: 'unavailable' };
            // 🔴 Estante cheia recusa o ARQUIVO mas as cifras já foram fundidas acima: são
            // 4 KB e ficam esperando o .mid. Perder o trabalho manual por falta de espaço
            // para um arquivo seria a troca errada.
            if (res.ok) { if (jaTinha) r.updated++; else r.added++; }
            // 🔴 "Não coube" e "este aparelho não TEM estante" não são a mesma frase: a
            // primeira manda apagar uma da lista, e não há lista nenhuma para apagar.
            else if (res.reason === 'unavailable') r.noShelf++;
            else r.noRoom++;
        }
        // As peças da estante são protegidas do despejo do localStorage (ver
        // `_writeHarmonyStore`): um backup grande não pode desnudar o que está guardado.
        await this._refreshShelf();
        this._writeHarmonyStore(store, this._shelfIds);
        await this._refreshShelf();
        if (this._destroyed) return r;

        this._backToShelfOrImport({ text: this._backupReport(r), tone: 'info' });
        // A peça aberta pode ter recebido cifras do backup: recarrega do disco.
        if (this.score) { this._loadHarmony(); if (this.renderer) this.renderer.refresh(); }
        return r;
    }

    /**
     * Relatório do backup em UMA linha. 🔴 Só o que aconteceu entra (zero não vira frase) e
     * cada número tem singular — "1 cifras novas" nos três idiomas foi o achado que esta
     * auditoria repetiu da anterior.
     */
    _backupReport(r) {
        const partes = [];
        const p = (n, chave) => { if (n > 0) partes.push(this._t(
            'song.backup.' + chave + (n === 1 ? '_one' : ''), { n })); };
        p(r.added, 'added');
        p(r.updated, 'updated');
        p(r.chords, 'chords');
        p(r.noShelf, 'noShelf');
        p(r.noRoom, 'noRoom');
        p(r.fixed, 'fixed');
        p(r.rejected, 'rejected');
        p(r.skipped, 'skipped');
        return partes.length ? partes.join(' · ') : this._t('song.backup.nothing');
    }

    /**
     * Volta para a estante — ou para a tela de importar quando não HÁ estante.
     * 🔴 Sem isto, importar um backup num aparelho sem IndexedDB abria uma tela "Minhas
     * músicas" com zero linhas e `#sg-answers` vazio: a tela que o §0 do plano promete que
     * não existe quando o IndexedDB está fora.
     */
    /** Fim de uma operação de repertório (backup, sincronia): volta para a lista com o recado. */
    _backToShelfOrImport(notice) {
        // 🔴 Sem condição: a lista existe sempre desde que o catálogo entrou nela. O ramo
        // do importador levava o recado num toast — e sumia com a lista de onde a pessoa
        // tinha acabado de mandar restaurar um backup.
        return this._showPickScreen(notice);
    }

    // =====================================================================
    // Importar MIDI (#/musicas-livre) — Etapa 4 de docs/MUSICA-REAL-PLANO.md
    //
    // 🔴 O ARQUIVO NUNCA SAI DO APARELHO: `FileReader` + `MidiFile` + `ScoreBuilder`
    // rodam no browser. Nada de upload, nada de servidor — resolve privacidade e
    // direito autoral de uma vez só, e é o que a tela promete em letras miúdas.
    //
    // 🔴 A recusa é parte do produto, não um erro a esconder: um `.mid` de gravação ao
    // vivo não é partitura, e o importador diz isso com todas as letras em vez de
    // desenhar um ritmo que ninguém escreveu.
    // =====================================================================

    /** Tela de importar: escolher o arquivo do aluno (ou o exemplo). */
    _showImportScreen(errText) {
        this._enterScreen('import');
        this._closeShelf();
        this._teardownInputDevices();
        this.promptEl.style.display = '';
        this.hudEl.style.display = 'none';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';
        this.promptEl.textContent = '';
        if (this.renderer) { this.renderer.destroy(); this.renderer = null; }
        if (this.musicStaff) { this.musicStaff.destroy(); this.musicStaff = null; }

        const t = this.container.querySelector('#sg-title');
        if (t) t.textContent = this._t('song.import.title');
        const sub = this.container.querySelector('#sg-sub');
        if (sub) sub.textContent = this._t('song.import.lead');

        // Área de soltar o arquivo ocupa o lugar da pauta (é onde a partitura vai nascer).
        this.staffContainer.innerHTML = '';
        const drop = document.createElement('div');
        drop.style.cssText = `border:2px dashed #cbd5e1;border-radius:14px;padding:1.6rem 1rem;
            text-align:center;color:#64748b;background:#f8fafc;`;
        const mobile = (window.innerWidth || 1024) < 700;
        // 🔴 No celular — onde esta feature mais vale — não existe arrastar arquivo. O
        // retângulo tracejado é o maior alvo de toque da tela e não fazia nada; agora ele
        // é o próprio botão, e o texto pede o gesto que o aparelho tem.
        drop.textContent = this._t(mobile ? 'song.import.tap' : 'song.import.drop');
        drop.style.cursor = 'pointer';
        drop.addEventListener('click', () => this._pickFile());
        ['dragenter', 'dragover'].forEach(ev => drop.addEventListener(ev, (e) => {
            e.preventDefault(); drop.style.borderColor = '#6366f1'; drop.style.background = '#eef2ff';
        }));
        ['dragleave', 'drop'].forEach(ev => drop.addEventListener(ev, (e) => {
            e.preventDefault(); drop.style.borderColor = '#cbd5e1'; drop.style.background = '#f8fafc';
        }));
        drop.addEventListener('drop', (e) => {
            const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
            if (f) this._handleFile(f);
        });
        this.staffContainer.appendChild(drop);

        if (errText) {
            const box = document.createElement('div');
            box.style.cssText = `margin:0.9rem auto 0;max-width:520px;padding:0.8rem 1rem;border-radius:12px;
                background:#fef2f2;border:1px solid #fecaca;color:#b91c1c;font-size:0.9rem;line-height:1.45;text-align:left;`;
            box.innerHTML = `<strong>${this._t('song.import.errTitle')}</strong><br>${errText}`;
            this.staffContainer.appendChild(box);
        }

        this.answersEl.appendChild(this._makeButton(
            '📂 ' + this._t('song.import.choose'), 'linear-gradient(135deg,#6366f1,#8b5cf6)',
            () => this._pickFile()));
        this.answersEl.appendChild(this._makeButton(
            '🎵 ' + this._t('song.import.demo'), 'linear-gradient(135deg,#64748b,#475569)',
            () => this._loadDemo(), { small: true }));

        // Saída de volta para a peça que já estava carregada — sem ela, abrir esta tela
        // por engano era um caminho só de ida. Passa pelo `_backScreen` para que o botão da
        // tela e o "voltar" do aparelho façam a MESMA coisa.
        if (this.score) {
            this.answersEl.appendChild(this._makeButton(
                '↩ ' + this._t('song.import.back', { file: this._openLabel() }),
                'linear-gradient(135deg,#10b981,#059669)',
                () => this._backScreen(), { small: true }));
        }

        this.answersEl.appendChild(this._makeButton(
            '📚 ' + this._t('song.pick.open'), 'linear-gradient(135deg,#0f766e,#0d9488)',
            () => this._showPickScreen(), { small: true }));
        // 🔴 Restaurar um backup também se faz DAQUI, não só da estante: num celular novo a
        // estante está vazia — e a tela da estante só aparece quando há estante. Se esta
        // fosse a única porta que existe, ela teria de servir para entrar.
        this.answersEl.appendChild(this._makeButton(
            '⬆ ' + this._t('song.backup.import'), 'linear-gradient(135deg,#64748b,#475569)',
            () => this._pickBackup(), { small: true }));

        this.extraEl.appendChild(this._privacyLine());
    }

    /** Abre o seletor de arquivo do sistema (no iOS isto funciona; Web MIDI é que não). */
    _pickFile() {
        const input = document.createElement('input');
        input.type = 'file';
        // `.mid`/`.midi` por extensão E por tipo: o macOS manda `audio/midi`, o Windows
        // `audio/mid`, e o Android costuma mandar vazio. Filtrar só por MIME esconderia
        // do aluno o arquivo que ele veio abrir.
        input.accept = '.mid,.midi,audio/midi,audio/x-midi,audio/mid';
        input.style.display = 'none';
        input.addEventListener('change', () => {
            const f = input.files && input.files[0];
            if (f) this._handleFile(f);
            input.remove();
        });
        // 🔴 `change` NÃO dispara em cancelamento: sem isto, cada vez que a pessoa abre o
        // seletor e desiste, um <input> fica pendurado no body para sempre.
        input.addEventListener('cancel', () => input.remove());
        document.body.appendChild(input);
        input.click();
    }

    /** Arquivo escolhido/solto → bytes. */
    _handleFile(file) {
        if (this._importing) return;   // dois arquivos em voo: o último a chegar ganhava
        if (file.size > window.MidiFile.MAX_BYTES) {
            return this._showImportScreen(this._errText({
                code: 'tooBig',
                params: { kb: Math.round(file.size / 1024), max: window.MidiFile.MAX_BYTES / 1024 }
            }));
        }
        this._importing = true;
        this.promptEl.textContent = this._t('song.import.reading');
        const reader = new FileReader();
        reader.onload = () => { this._importing = false; this._importBytes(reader.result, file.name); };
        reader.onerror = () => {
            this._importing = false;
            this._showImportScreen(this._t('song.import.err.readFailed'));
        };
        reader.readAsArrayBuffer(file);
    }

    /** O exemplo passa pelo MESMO caminho do arquivo do aluno — inclusive o parser. */
    async _loadDemo() {
        if (this._importing) return;
        this._importing = true;
        this.promptEl.textContent = this._t('song.import.reading');
        try {
            const res = await fetch('/songs/parabens.mid', { cache: 'no-cache' });
            if (!res.ok) throw new Error('HTTP ' + res.status);
            this._importBytes(await res.arrayBuffer(), 'parabens.mid');
        } catch (e) {
            // A falha aqui é NOSSA (rede/arquivo do site), não do aluno: ele não escolheu
            // arquivo nenhum. Fora do ar, o exemplo também cai aqui num PWA instalado.
            this._showImportScreen(this._t('song.import.err.demoFailed'));
        } finally {
            this._importing = false;
        }
    }

    /**
     * Bytes → partitura na tela. Toda recusa vira mensagem legível (o código do erro é
     * chave de i18n: a classe pura não escreve frase, quem tem tela é que sabe o idioma).
     * @param {ArrayBuffer} buffer
     * @param {string} fileName
     * @param {number} [trackIndex] - trocar de faixa relê o MIDI já parseado, sem novo arquivo
     */
    _importBytes(buffer, fileName, trackIndex) {
        if (this._destroyed) return;   // troca de rota enquanto o arquivo era lido
        const hash = SongReadingGame.hashBytes(buffer);
        // 🔴 Reaproveitar o MIDI já parseado só vale para o MESMO ARQUIVO. A estante (Etapa
        // 8) abre uma peça JÁ com a faixa guardada — e `trackIndex != null` sozinho fazia
        // isso reusar o `midi` da peça ANTERIOR: tocaria a música errada, com o nome certo.
        const mesmoArquivo = !!(this.imported && this.imported.hash === hash);
        try {
            const midi = (mesmoArquivo && this.imported.midi && trackIndex != null)
                ? this.imported.midi : window.MidiFile.parse(buffer);
            const analysis = window.ScoreBuilder.analyze(midi);
            const title = fileName.replace(/\.(mid|midi)$/i, '');
            const { score, report } = window.ScoreBuilder.build(midi, { trackIndex, title });

            this.imported = { midi, analysis, report, fileName, buffer, hash };
            this.score = score;
            this.songId = null;
            // 🔴 A peça aberta passou a ser DO ALUNO — e isso pode acontecer sem trocar de
            // rota (a lista abre catálogo e arquivo lado a lado). Sem levantar a bandeira
            // aqui, um arquivo aberto DEPOIS do Parabéns gravaria recorde no nome dele e
            // procuraria as cifras na chave do catálogo. Pego pelo controle positivo do
            // `song-nav-test [G]`: a asserção só falhou na SEGUNDA troca de peça.
            this.freeMode = true;
            this._reloadModePref();
            // O andamento do arquivo é só o DEFAULT do slider (§3 do plano): quem manda no
            // tempo de estudo é o aluno. Aqui ele vale mais que a preferência salva porque
            // é o único palpite honesto para uma peça que o app nunca viu.
            const salvo = parseInt(localStorage.getItem(this._bpmKey()) || '0', 10);
            this.bpm = (salvo >= SongReadingGame.BPM_MIN && salvo <= SongReadingGame.BPM_MAX)
                ? salvo
                : Math.min(SongReadingGame.BPM_MAX,
                    Math.max(SongReadingGame.BPM_MIN, Math.round(score.bpmAt(0))));
            // As cifras deste arquivo voltam ANTES de montar a pauta: a caixa da pauta
            // reserva a faixa das cifras conforme a peça as tenha (ver `_staffBox`).
            this._loadHarmony();
            this._prepareExpected();
            this._buildStaff();
            this._showStartScreen();
            // A estante guarda DEPOIS de a partitura estar na tela: guardar é um bônus, e
            // um bônus nunca pode atrasar (nem impedir) o que a pessoa veio fazer.
            this._shelfStore(buffer, fileName, report.trackIndex);
        } catch (err) {
            if (!err || !err.code) console.warn('SongReadingGame: falha ao importar MIDI', err);
            // 🔴 Se JÁ HAVIA uma peça tocável e a falha foi só nesta faixa, ela FICA. Zerar
            // tudo aqui era o pior beco da tela: escolher a faixa do baixo (gravada solta)
            // jogava fora o arquivo inteiro, já lido, e mandava o aluno buscá-lo de novo —
            // e a mensagem "tente outra faixa" aparecia numa tela sem seletor de faixa.
            if (trackIndex != null && mesmoArquivo && this.score) {
                this._importError = this._errText(err);
                this._showStartScreen();
                return;
            }
            this.imported = null;
            this.score = null;
            this._showImportScreen(this._errText(err));
        }
    }

    /**
     * Cartão do arquivo importado, mostrado acima dos controles: o que o app ENTENDEU do
     * arquivo. Sem isto a conversão seria silenciosa — e a conversão tem perdas (§3).
     */
    _importSummaryCard() {
        const r = this.imported.report;
        const card = document.createElement('div');
        card.style.cssText = `margin:0.2rem auto 0.6rem;max-width:520px;padding:0.7rem 0.9rem;border-radius:12px;
            background:#f8fafc;border:1px solid #e2e8f0;color:#475569;font-size:0.85rem;line-height:1.5;text-align:left;`;

        const head = document.createElement('div');
        head.style.cssText = 'font-weight:700;color:#334155;word-break:break-word;';
        head.textContent = '📄 ' + this.imported.fileName;
        card.appendChild(head);

        // Faixa recusada: o aviso mora AQUI, ao lado do seletor que permite tentar outra —
        // e a peça que estava tocando continua no ar, atrás dele.
        if (this._importError) {
            const box = document.createElement('div');
            box.style.cssText = `margin:0.4rem 0;padding:0.5rem 0.7rem;border-radius:8px;
                background:#fef2f2;border:1px solid #fecaca;color:#b91c1c;font-size:0.82rem;line-height:1.4;`;
            box.textContent = '⚠️ ' + this._importError;
            card.appendChild(box);
            this._importError = null;
        }

        // Cifras que não couberam na faixa escolhida (ver `_loadHarmony`).
        if (this._harmonyDropped) {
            const p = document.createElement('div');
            p.style.cssText = 'margin:0.4rem 0;color:#b45309;font-size:0.8rem;';
            p.textContent = '⚠️ ' + this._t(this._harmonyDropped === 1
                ? 'song.harmony.dropped_one' : 'song.harmony.dropped', { n: this._harmonyDropped });
            card.appendChild(p);
            this._harmonyDropped = 0;
        }

        const line = document.createElement('div');
        line.textContent = this._t('song.import.summary', {
            notes: r.notes, measures: r.measures,
            ts: r.timeSignature.beats + '/' + r.timeSignature.noteValue,
            key: this._keyLabel(r.keySignature),
            clef: this._t('song.import.clef.' + r.clef)
        });
        card.appendChild(line);

        // Trocar de faixa: um arquivo de banda tem uma trilha por instrumento e a nossa
        // escolha é heurística. Reler é instantâneo — o MIDI já está parseado.
        const withNotes = this.imported.analysis.tracks.filter(t => t.noteCount > 0);
        if (withNotes.length > 1) {
            const row = document.createElement('div');
            row.style.cssText = 'margin-top:0.5rem;display:flex;gap:0.4rem;align-items:center;flex-wrap:wrap;';
            const lab = document.createElement('span');
            lab.textContent = this._t('song.import.track') + ':';
            const sel = document.createElement('select');
            sel.style.cssText = 'padding:0.3rem 0.5rem;border:1px solid #cbd5e1;border-radius:8px;max-width:100%;';
            withNotes.forEach(t => {
                const o = document.createElement('option');
                o.value = String(t.index);
                o.textContent = (t.name || this._t('song.import.trackN', { n: t.index + 1 }))
                    + ` · ${t.noteCount} ${this._t('song.import.notesWord')}`
                    + (t.drums ? ' · ' + this._t('song.import.drums') : '');
                o.selected = (t.index === r.trackIndex);
                sel.appendChild(o);
            });
            sel.addEventListener('change', () => {
                this._importBytes(this.imported.buffer, this.imported.fileName, parseInt(sel.value, 10));
            });
            row.appendChild(lab); row.appendChild(sel);
            card.appendChild(row);
        }

        (r.warnings || []).forEach(w => {
            const txt = this._warnText(w);
            if (!txt) return;
            const p = document.createElement('div');
            p.style.cssText = 'margin-top:0.4rem;color:#b45309;font-size:0.8rem;';
            p.textContent = '⚠️ ' + txt;
            card.appendChild(p);
        });
        return card;
    }

    /** "Mi♭ maior" — a tônica vem do catálogo de tonalidades, o modo vem do idioma. */
    _keyLabel(key) {
        const K = window.Key && window.Key.of(key.sharps, key.minor);
        if (!K) return '';
        const useSolfege = (window.language && window.language.currentLanguage) !== 'en';
        return window.Key.tonicLabel(K, useSolfege) + ' '
            + this._t(key.minor ? 'music.minor' : 'music.major');
    }

    /** Recusa (código + params) → frase no idioma da pessoa. */
    _errText(err) {
        const code = (err && err.code) || 'unknown';
        const txt = this._t('song.import.err.' + code, (err && err.params) || {});
        return (txt && txt !== 'song.import.err.' + code)
            ? txt : this._t('song.import.err.unknown');
    }

    /** Ressalva (a conversão teve perdas, e elas são ditas). */
    _warnText(w) {
        const key = 'song.import.warn.' + w.code;
        const txt = this._t(key, w.params || {});
        return (txt && txt !== key) ? txt : '';
    }

    _buildControls() {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'display:flex;flex-direction:column;gap:0.7rem;align-items:center;margin-top:0.6rem;font-size:0.9rem;';

        // modo
        wrap.appendChild(this._labeled(this._t('song.mode') + ':', this._segToggle([
            ['study', this._t('song.modeStudy')],
            ['tempo', this._t('song.modeTempo')],
            ['play', this._t('song.modePlay')]
        ], this.mode, (v) => {
            this.mode = v;
            localStorage.setItem(this._modeKey(), v);
            this._showStartScreen();
        }), 'song.mode'));

        // andamento — slider, como no Ritmo. Só faz diferença audível no modo tempo,
        // mas vale nos dois: no estudo ele governa o quanto a esteira anda entre notas.
        const bpmRow = document.createElement('div');
        bpmRow.style.cssText = 'display:flex;gap:0.6rem;align-items:center;flex-wrap:wrap;justify-content:center;max-width:100%;';
        const bpmLab = document.createElement('span');
        bpmLab.style.color = '#64748b';
        bpmLab.textContent = this._t('song.tempoLabel') + ':';
        const bpmVal = document.createElement('strong');
        bpmVal.textContent = this.bpm + ' bpm';
        bpmVal.style.cssText = 'min-width:5.5rem;text-align:left;font-variant-numeric:tabular-nums;';
        const range = document.createElement('input');
        range.type = 'range';
        range.min = String(SongReadingGame.BPM_MIN);
        range.max = String(SongReadingGame.BPM_MAX);
        range.step = '1';
        range.value = String(this.bpm);
        range.style.cssText = 'flex:1;min-width:150px;max-width:260px;';
        range.addEventListener('input', () => {
            this.bpm = parseInt(range.value, 10);
            bpmVal.textContent = this.bpm + ' bpm';
            localStorage.setItem(this._bpmKey(), String(this.bpm));
        });
        bpmRow.appendChild(bpmLab);
        if (window.HelpDot) bpmRow.appendChild(new window.HelpDot('song.tempo').el);
        bpmRow.appendChild(range); bpmRow.appendChild(bpmVal);
        wrap.appendChild(bpmRow);

        // densidade da partitura (o slider px/semínima da página de aferição, virado
        // preferência: três degraus em vez de um número solto)
        wrap.appendChild(this._labeled(this._t('song.densityLabel') + ':', this._segToggle(
            SongReadingGame.DENSITIES.map((d, i) => [String(i), this._t('song.density.' + d.key)]),
            String(this.densityIdx),
            (v) => {
                this.densityIdx = parseInt(v, 10);
                localStorage.setItem(SongReadingGame.DENSITY_KEY, v);
                this._buildStaff();
                this._showStartScreen();
            })));

        // entrada — só as superfícies que este ambiente suporta
        const inputItems = [['piano', this._t('song.inputPiano')]];
        if (window.MicPitchInput && window.MicPitchInput.isSupported()) {
            inputItems.push(['mic', this._t('song.inputMic')]);
        }
        if (window.MidiPitchInput && window.MidiPitchInput.isSupported()) {
            inputItems.push(['midi', this._t('song.inputMidi')]);
        }
        if (inputItems.length > 1) {
            wrap.appendChild(this._labeledHelp('song.input', this._t('song.input') + ':', this._segToggle(
                inputItems, this.inputMode, (v) => {
                    this.inputMode = v;
                    localStorage.setItem(SongReadingGame.INPUT_KEY, v);
                    this._showStartScreen();
                })));
        }

        // aviso honesto: no microfone o placar de Ritmo não existe
        if (this.inputMode === 'mic' && this.mode === 'tempo') {
            const w = document.createElement('p');
            w.textContent = this._t('song.micNoRhythm');
            w.style.cssText = 'color:#b45309;font-size:0.8rem;margin:0.2rem auto 0;max-width:440px;line-height:1.4;';
            wrap.appendChild(w);
        }

        return wrap;
    }

    // ---------- entrada ----------

    _teardownInputDevices() {
        if (this.keyboard) { this.keyboard.destroy(); this.keyboard = null; }
        if (this.piano) { this.piano.destroy(); this.piano = null; }
        if (this.mic) { this.mic.destroy(); this.mic = null; }
        if (this.micPanel) { this.micPanel.destroy(); this.micPanel = null; }
        if (this.midi) { this.midi.destroy(); this.midi = null; }
        if (this.midiPanel) { this.midiPanel.destroy(); this.midiPanel = null; }
    }

    _instrumentPanel() { return this.micPanel || this.midiPanel; }

    /** Extensão do piano de resposta = o âmbito da PEÇA, pela receita do PianoKeyboard. */
    _pianoRange() {
        const r = (this.score && this.score.midiRange()) || { min: 60, max: 72 };
        return window.PianoKeyboard.responseRange(r.min, r.max);
    }

    _buildInput() {
        this.answersEl.innerHTML = '';
        this._teardownInputDevices();

        if (this.inputMode === 'mic' || this.inputMode === 'midi') {
            const isMic = this.inputMode === 'mic';
            const panel = new window.MicStatusPanel(this.answersEl, {
                t: (k) => this._t((isMic ? 'micInput.' : 'midiInput.') + k),
                noteLabel: (info) => this._noteName(info.letter),
                meterScale: isMic ? undefined : 100,
                onActivate: () => (isMic ? this._startMic() : this._startMidi()),
                onFallback: () => {
                    this.inputMode = 'piano';
                    localStorage.setItem(SongReadingGame.INPUT_KEY, 'piano');
                    this._buildInput();
                }
            });
            panel.render();
            if (isMic) { this.micPanel = panel; this._startMic(); }
            else { this.midiPanel = panel; this._startMidi(); }
            return;
        }

        const { minSci, maxSci } = this._pianoRange();
        this.piano = new window.PianoKeyboard(this.answersEl, {
            minSci, maxSci,
            rows: window.PianoKeyboard.rowsFor(minSci, maxSci),
            labelFn: (info) => this._noteName(info.letter),
            // 🔴 O som da tecla é NOSSO (_playPitch), não o 'tick' do componente: aqui o
            // que o aluno toca É a música, então tem de soar como piano — e o banco
            // realista, quando ligado, precisa passar pelo playNote.
            playSound: false,
            onKeyPress: (info, ev) => this.onNote(info, ev)
        });
        this.piano.render();
        this.piano.setEnabled(true);

        // teclado do PC → mesma entrada, mesmo contrato
        this.keyboard = new window.KeyboardInput({
            piano: this.piano,
            keyMap: window.PianoKeyboard.keyMapFor(minSci, maxSci),
            playSound: false,
            onKeyPress: (info, ev) => this.onNote(info, ev)
        });
        this.keyboard.enable();
    }

    _startMic() {
        if (!this.mic) {
            this.mic = new window.MicPitchInput({
                onKeyPress: (info, ev) => this.onNote(info, ev),
                onStateChange: (s) => { if (this.micPanel) this.micPanel.setState(s); },
                onFrame: (f) => { if (this.micPanel) this.micPanel.frame(f); }
            });
        }
        this.mic.start();
    }

    _startMidi() {
        if (!this.midi) {
            this.midi = new window.MidiPitchInput({
                onKeyPress: (info, ev) => this.onNote(info, ev),
                onStateChange: (s) => {
                    if (this.midiPanel) this.midiPanel.setState(s, s === 'listening' ? this.midi.getDeviceName() : null);
                },
                onFrame: (f) => { if (this.midiPanel) this.midiPanel.frame(f); }
            });
        }
        this.midi.start();
    }

    // ---------- relógio ----------

    _rawNow() {
        return window.audioManager ? window.audioManager.now() : (performance.now() / 1000);
    }

    _beatDurSec() { return 60 / this.bpm; }

    /** Segundos desde o beat 0 (negativo durante a contagem), descontadas as esperas. */
    _elapsedSec() {
        if (this._holdFrom !== null) return this._holdElapsed;
        return this._rawNow() - this._t0 - this._pauseOffset;
    }

    /** Posição da esteira em semínimas. Fonte única de "onde a música está". */
    _beat() { return this._elapsedSec() / this._beatDurSec(); }

    /** Congela a esteira EXATAMENTE num beat (modo estudo). Idempotente. */
    _holdAt(beat) {
        if (this._holdFrom !== null) return;
        this._holdElapsed = beat * this._beatDurSec();
        this._holdFrom = this._rawNow();
    }

    /**
     * Retoma. O tempo parado vira `_pauseOffset` — o relógio segue sendo o do áudio, só a
     * origem se desloca (mesma solução do congela-e-ensina da Leitura).
     *
     * 🔴 Absorve TAMBÉM o excesso: quando o quadro percebe que a nota chegou, o relógio já
     * passou dela um pouco (até um quadro), e `_holdAt` trava o DESENHO no beat exato. Se o
     * offset contasse só o tempo de parede parado, ao destravar a esteira saltaria de volta
     * para esse excesso — um pulinho para a frente bem na hora em que o aluno acabou de
     * acertar. Descontando `atual − travado`, a música recomeça exatamente de onde parou.
     */
    _release() {
        if (this._holdFrom === null) return;
        const atual = this._rawNow() - this._t0 - this._pauseOffset;
        this._pauseOffset += (atual - this._holdElapsed);
        this._holdFrom = null;
    }

    // ---------- áudio ----------

    /**
     * Mata tudo que foi agendado à frente. 🔴 Chamado em TODA saída (parar, fim, destroy):
     * sem isso a peça agendada continua tocando depois da tela sumir.
     *
     * 🔴 O metrônomo só é parado por quem o LIGOU. Ele é singleton global: uma instância
     * deste jogo que morre sem nunca ter tocado — a tela órfã de uma troca de rota no meio
     * do carregamento — chamaria `stop()` e calaria o metrônomo do jogo que está tocando
     * de verdade. A auditoria mediu exatamente isso. A trava de reentrância do Router
     * fechou a porta principal; esta guarda fecha a de serviço.
     */
    _killAudio() {
        this._audio.forEach(h => { try { h.stop(); } catch (e) { /* já tocou */ } });
        this._audio = [];
        if (this._metroOwned && window.metronomeManager) {
            window.metronomeManager.stop();
            this._metroOwned = false;
        }
    }

    _playPitch(sci, duration = 0.5) {
        const am = window.audioManager;
        if (!am) return;
        // 🔴 No microfone NÃO tocamos nada: o mic ouve o alto-falante e o AudioManager
        // cala a detecção por ~250 ms depois de cada som (isOutputBusy). Sonorizar aqui
        // faria o jogo surdo justamente enquanto o aluno toca. E é desnecessário — no
        // mic o som já existe, é o piano de verdade dele.
        if (this.inputMode === 'mic') return;
        am.resumeContext();
        // 🔴 O handle vai para `_audio` mesmo sendo som de AGORA. A letra da tripwire fala
        // de áudio agendado à frente, mas a última tecla tocada seguia soando ~0,55 s
        // depois de a tela voltar ao menu — barulho órfão de uma rodada que já acabou.
        // Guardar é de graça; `_killAudio` já esvazia a lista em toda saída.
        const h = (am.isPianoRealistic && am.isPianoRealistic())
            ? am.playNote(sci, duration, { volume: 0.85 })
            : am.play('tick', { frequency: am.getFrequency(sci), duration, volume: 0.85 });
        if (h && typeof h.stop === 'function') this._audio.push(h);
    }

    /**
     * Contagem de entrada, em semínimas antes do beat 0.
     *
     * 🔴 Sai da ANACRUSE, não de um número redondo. O Parabéns começa em levada de 1
     * semínima: o primeiro tempo forte cai no beat 1, não no 0. Uma contagem de "um
     * compasso" ancorada no beat 0 poria os acentos do metrônomo em 0, 3, 6 — uma
     * batida fora da barra, a peça inteira. Aqui a conta é: recuar até o início nocional
     * do compasso da anacruse e dar mais um compasso inteiro antes dele. Assim os acentos
     * caem em 1, 4, 7… que é onde as barras estão.
     */
    _countInBeats() {
        const q = window.Notation.quartersPerMeasure(this.score.timeSignatureAt(0));
        const pickup = this.score.pickupBeats || 0;
        const measureStart = pickup > 0 ? (pickup - q) : 0;  // em beats, relativo ao beat 0
        return q - measureStart;
    }

    /** "Ouvir a música": toca a peça inteira e roda a esteira junto, sem avaliar nada. */
    listen() {
        if (this._running) return;
        window.audioManager && window.audioManager.resumeContext();
        this._killAudio();
        this.renderer.clearMarks();

        const beatDur = this._beatDurSec();
        const t0 = this._rawNow() + 0.35;
        this._t0 = t0;
        this._pauseOffset = 0;
        this._holdFrom = null;
        this._listening = true;
        this._running = true;
        // 🔴 'playing' é o que impede o resize de remontar a pauta no meio da esteira: o
        // renderer seria recriado e a peça saltaria de posição dentro do compasso. E vai
        // pelo `_enterScreen` para EMPILHAR o degrau: sem ele, o "voltar" no meio da rodada
        // saía do jogo e o take ia junto, calado.
        this._enterScreen('playing');
        this._ended = false;
        this._lastLoopBeat = null;

        // 🔴 A peça inteira é agendada de uma vez e CADA handle é guardado. Para o
        // catálogo curado (dezenas de compassos) isso é trivial; um arquivo importado de
        // 300 compassos (Etapa 4) vai precisar de agendamento por janela, como o
        // MetronomeManager faz — o limite abaixo é o aviso de que essa hora chegou.
        const LIMITE = 600;
        // O exemplo sonoro agenda a peça INTEIRA de uma vez; acima deste teto o navegador
        // não dá conta. Uma peça importada pode ter 3.000 notas — e emudecer na 601 sem
        // dizer nada parece bug de áudio do celular. Agendamento por janela (como o
        // MetronomeManager faz) é o conserto de verdade; até lá, a verdade dita.
        if (this._expected.length > LIMITE) {
            const m = this._measures.findIndex(x => x.startBeat > this._expected[LIMITE - 1].beat);
            this._flashPrompt(this._t('song.listenPartial', { measure: m > 0 ? m : '?' }), '#b45309', 3500);
        }
        this._expected.slice(0, LIMITE).forEach(e => {
            const when = t0 + e.beat * beatDur;
            const dur = Math.max(0.18, e.duration * beatDur * 0.92);
            this._audio.push(window.audioManager.playNote(e.sci, dur, { when, volume: 0.8 }));
        });

        this.hudEl.style.display = 'flex';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';
        this.promptEl.textContent = this._t('song.listening');
        this.promptEl.style.color = '#6366f1';
        const stop = this._makeButton('⏹ ' + this._t('song.stop'),
            'linear-gradient(135deg,#94a3b8,#64748b)', () => this.stop(), { small: true });
        this.extraEl.appendChild(stop);

        this._loop();
    }

    // ---------- rodada ----------

    start() {
        if (this._running || this._destroyed) return;
        window.audioManager && window.audioManager.resumeContext();
        this._killAudio();

        this._expected.forEach(e => { e.state = 'pending'; });
        this._cursor = 0;
        this._nextMarked = null;
        this._studyWrong = 0;
        this._ended = false;
        this._listening = false;
        this._pauseOffset = 0;
        this._holdFrom = null;
        this._captureOpen = false;
        this._lastLoopBeat = null;
        this.recorder.clear();
        this.renderer.clearMarks();

        const beatDur = this._beatDurSec();
        // Estudo não tem contagem (a esteira espera). Tempo e Acompanhar têm: os dois
        // rolam firme, e entrar sem contagem é entrar perdido.
        const countIn = this.mode === 'study' ? 0 : this._countInBeats();
        this._t0 = this._rawNow() + 0.35 + countIn * beatDur;

        // 🔴 `_running` ANTES de qualquer coisa que possa lançar. Ele era a ÚLTIMA linha do
        // método, depois de ligar o metrônomo e de montar a entrada — e `_buildInput()`
        // pode lançar de verdade (construir MicStatusPanel num navegador que não coopera).
        // Quando lançava, sobrava metrônomo tocando que o `stop()` se RECUSAVA a matar
        // (`if (!this._running) return`), sem nem botão de Parar na tela: só trocar de rota
        // calava. Agora quem falha no meio deixa um estado que o `stop()` alcança.
        this._running = true;
        this._enterScreen('playing');   // ver `listen()`: degrau + o resize não remonta rodando
        try {
            if (this.mode !== 'study') {
                const q = window.Notation.quartersPerMeasure(this.score.timeSignatureAt(0));
                // Metrônomo só no modo TEMPO: no estudo a esteira PARA, e um pulso que segue
                // andando enquanto a música espera contaria uma mentira sobre o tempo.
                window.metronomeManager.start(this.bpm, q, this._t0 - countIn * beatDur,
                                              countIn + this._totalBeats + 1);
                this._metroOwned = true;
            }

            this.hudEl.style.display = 'flex';
            this.promptEl.textContent = this._t(this._promptKey());
            this.promptEl.style.color = '#6366f1';
            // 🔴 Acompanhar não monta entrada NENHUMA: não há piano na tela, não há
            // gravador, não há placar. Quem toca, toca no instrumento de verdade — e o
            // app não tem o que medir, porque quem lê a cifra toca notas que não estão
            // escritas na pauta. Montar o piano aqui prometeria uma avaliação que não vem.
            if (this.mode !== 'play') this._buildInput();
            this._buildRoundControls();
        } catch (e) {
            console.error('SongReadingGame: falha ao montar a rodada —', e);
            this.stop();
            return;
        }

        // 🔴 Acompanhar NÃO abre rodada: nada é medido ali, e um `p=round o=done` vindo
        // dele é indistinguível de um take avaliado — contamina a série que o funil existe
        // para medir. Sem `roundOpen`, o `roundClose` de saída é inócuo (é idempotente).
        if (window.Beacon && this.mode !== 'play') window.Beacon.roundOpen(null);
        this._loop();
    }

    /** Botões que ficam na tela durante a rodada: Parar e, no estudo, pular a nota. */
    _buildRoundControls() {
        this.extraEl.innerHTML = '';
        if (this.mode === 'study') {
            // 🔴 Saída para quem travou. No estudo a esteira espera INDEFINIDAMENTE pela
            // nota certa — é a alma do modo —, mas a única saída era matar a rodada. Um
            // iniciante preso numa nota precisa poder seguir sem perder a peça inteira.
            // A nota pulada é marcada como "passou", igual a uma que a linha ultrapassou.
            this.extraEl.appendChild(this._makeButton('⏭ ' + this._t('song.skipNote'),
                'linear-gradient(135deg,#6366f1,#8b5cf6)', () => this._skipNote(), { small: true }));
        }
        this.extraEl.appendChild(this._makeButton('⏹ ' + this._t('song.stop'),
            'linear-gradient(135deg,#94a3b8,#64748b)', () => this.stop(), { small: true }));
    }

    /** Desiste da nota em que a esteira está parada (modo estudo) e segue a peça. */
    _skipNote() {
        if (!this._running || this.mode !== 'study') return;
        const alvo = this._nextPending();
        if (!alvo) return;
        alvo.state = 'missed';
        this.renderer.markNote(alvo.beat, SongReadingGame.COLOR.pass);
        this._flashPrompt(this._t('song.wasNote', { note: this._noteName(alvo.letter) }), '#b45309', 1200);
        this._release();
    }

    /** Para no meio e volta à tela inicial (não conta como concluída). */
    stop() {
        if (!this._running) return;
        const wasRound = !this._listening;
        this._running = false;
        this._listening = false;
        if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
        this._killAudio();
        this.recorder.stop();
        this._teardownInputDevices();
        if (wasRound && window.Beacon) window.Beacon.roundClose('quit');
        this._showStartScreen();
    }

    _loop() {
        if (!this._running) return;
        let beat = this._beat();

        // 🔴 PRÉ-ROLL DE VERDADE. Antes, `recorder.start()` era chamado lá em `start()` e a
        // captura ficava aberta a contagem de entrada INTEIRA — 5 batidas no Parabéns, onze
        // vezes mais do que a constante promete. Quem se conta na tecla junto com o
        // metrônomo (hábito que o próprio Jogo de Ritmo ensina) via cada toque virar "nota
        // a mais", −5% de Ritmo cada: ★★★ virava ★★ com 5 toques. Agora a janela abre meia
        // batida antes do beat 0, como no `RhythmGame.INPUT_PREROLL_BEATS`, e pelo mesmo
        // motivo: capturar quem ataca a primeira nota adiantado, sem capturar a contagem.
        if (!this._listening && this.mode === 'tempo' && !this._captureOpen
                && beat >= -SongReadingGame.PREROLL_BEATS) {
            this._captureOpen = true;
            const latency = window.audioManager ? window.audioManager.getOutputLatency() : 0;
            this.recorder.start(this._t0, latency);
        }

        if (!this._listening && this.mode === 'study') beat = this._studyGate(beat);

        this.renderer.scrollTo(beat);
        // 🔴 A aba escondida para o rAF mas NÃO para o relógio de áudio: ao voltar, a
        // esteira saltou e o varredor condenaria de uma vez tudo o que passou no escuro.
        // Medido pela auditoria: 6 s fora da aba = 6 notas "perdidas" que o aluno nunca
        // viu; a peça inteira escondida terminava com 25/25 perdidas e um modal de 0%. Um
        // salto maior que o rabicho não é execução, é ausência — a rodada é abandonada em
        // vez de reprovada. Nunca inventamos um número para o que não foi tocado.
        // No modo acompanhar nada é pontuado, então não há resultado a proteger: sair da
        // aba e voltar continua a música em vez de encerrar a sessão.
        if (!this._listening && this.mode !== 'play' && this._lastLoopBeat != null
                && beat - this._lastLoopBeat > SongReadingGame.SKIP_ABORT_BEATS) {
            this._abortByGap(beat - this._lastLoopBeat);
            return;
        }
        this._lastLoopBeat = beat;

        if (!this._listening && this.mode === 'tempo') this._sweepMissed(beat);
        // Destacar "a próxima nota" seria mentira no modo acompanhar: não há nota esperada.
        if (this.mode !== 'play') this._markNext();
        this._renderHud(beat);

        const tail = this._listening ? 0.5 : SongReadingGame.TAIL_BEATS;
        if (beat >= this._totalBeats + tail) {
            if (this._listening) { this.stop(); return; }
            this._end();
            return;
        }
        this._raf = requestAnimationFrame(() => this._loop());
    }

    /**
     * A rodada rodou no escuro (aba escondida, tela apagada) e voltou muito à frente.
     * Abandona em vez de pontuar: o aluno não tocou porque não estava vendo, e reprová-lo
     * por isso seria inventar um resultado. Volta à tela inicial com um aviso.
     */
    _abortByGap(gap) {
        this._running = false;
        if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
        this._killAudio();
        this.recorder.stop();
        this._teardownInputDevices();
        if (window.Beacon) window.Beacon.roundClose('quit');
        this._showStartScreen();
        if (window.notifications) {
            window.notifications.toast(this._t('song.interrupted'), { duration: 4200 });
        }
    }

    /**
     * Próxima nota pendente.
     *
     * 🔴 Cursor em vez de `.find()` a cada quadro. As notas já resolvidas ficam TODAS antes
     * da pendente, então um `.find` do zero varre a peça inteira quando ela está no fim —
     * e este método é chamado 3× por quadro. Com 25 notas é irrelevante; com as 2.700 de um
     * arquivo importado (Etapa 4) são ~500 mil comparações por segundo. O cursor só ANDA
     * para a frente, e por isso continua correto mesmo quando o casamento ao vivo resolve
     * uma nota fora de ordem: ele para na primeira que ainda estiver pendente.
     */
    _nextPending() {
        while (this._cursor < this._expected.length && this._expected[this._cursor].state !== 'pending') {
            this._cursor++;
        }
        return this._expected[this._cursor] || null;
    }

    /**
     * Modo estudo: anda até a próxima nota pendente e PARA nela.
     * @returns {number} o beat a desenhar (travado na nota enquanto espera)
     */
    _studyGate(beat) {
        const next = this._nextPending();
        if (!next) { this._release(); return beat; }
        if (beat >= next.beat - 1e-6) { this._holdAt(next.beat); return next.beat; }
        return beat;
    }

    /** Notas que a linha de leitura ultrapassou sem resposta viram "passou". A folga de
     *  1 batida é a MESMA tolerância que o alinhamento final aceita — assim o que a tela
     *  chama de perdida é o que o placar também vai chamar. Varre a partir do cursor:
     *  o que ficou para trás já está resolvido. */
    _sweepMissed(beat) {
        for (let i = this._cursor; i < this._expected.length; i++) {
            const e = this._expected[i];
            if (e.beat + SongReadingGame.TAIL_BEATS >= beat) break; // daqui pra frente é futuro
            if (e.state !== 'pending') continue;
            e.state = 'missed';
            this.renderer.markNote(e.beat, SongReadingGame.COLOR.pass);
        }
    }

    /** Destaca a próxima nota pendente (índigo). Só mexe no DOM quando ela MUDA — este
     *  método roda 60×/s. */
    _markNext() {
        const next = this._nextPending();
        if (next === this._nextMarked) return;
        if (this._nextMarked && this._nextMarked.state === 'pending') {
            this.renderer.markNote(this._nextMarked.beat, null);
        }
        if (next) this.renderer.markNote(next.beat, SongReadingGame.COLOR.next);
        this._nextMarked = next;
    }

    _renderHud(beat) {
        const ms = this._measures;
        const total = ms.length;
        const b = Math.max(0, Math.min(beat, this._totalBeats - 1e-6));
        // Busca na grade JÁ calculada (ver _prepareExpected) em vez de `measureIndexAt`,
        // que reconstrói a peça inteira a cada chamada — e isto roda 60×/s.
        let idx = 0;
        for (let i = 0; i < ms.length; i++) { if (b >= ms[i].startBeat - 1e-6) idx = ms[i].index; else break; }
        const num = this.score.pickupBeats > window.Score.EPS ? idx : idx + 1;
        const cell = (label, value) => `
            <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:0.35rem 0.8rem;min-width:84px;text-align:center;">
                <div style="font-size:0.7rem;color:#64748b;text-transform:uppercase;letter-spacing:0.03em;">${label}</div>
                <div style="font-size:1.15rem;font-weight:800;color:#0f172a;">${value}</div>
            </div>`;
        let done = 0;
        for (let i = 0; i < this._expected.length; i++) if (this._expected[i].state === 'hit') done++;

        // 🔴 Só reescreve o HUD quando algo MUDA. Ele roda 60×/s e reconstruía três células
        // idênticas a cada quadro — 180 mutações de DOM em 3 segundos parado no modo estudo,
        // trabalho de layout e coleta de lixo que nunca termina. É exatamente o cuidado que
        // o `_markNext`, dez linhas acima, já toma. Medido pela auditoria: 8,7 ms/s à toa.
        const chave = num + '|' + done + '|' + this.bpm + '|' + this.mode;
        if (chave === this._hudKey) return;
        this._hudKey = chave;

        // No modo acompanhar não existe "acertos" — não mostrar um contador parado em 0/25.
        this.hudEl.innerHTML =
            cell(this._t('song.measure'), `${Math.max(1, num)}/${Math.max(1, this.score.pickupBeats > 0 ? total - 1 : total)}`) +
            (this.mode === 'play' ? '' : cell(this._t('song.hits'), `${done}/${this._expected.length}`)) +
            cell(this._t('song.tempoLabel'), this.bpm);
    }

    // ---------- resposta ----------

    onNote(info, ev) {
        if (!this._running || this._listening || this.mode === 'play' || !info) return;
        this._playPitch(info.sci, 0.45);

        if (this.mode === 'study') { this._studyAnswer(info); return; }

        const entry = this.recorder.record(info, ev);
        if (entry) this._liveMatch(info, entry);
    }

    /**
     * Modo estudo: só julga quando a esteira JÁ PAROU na nota. Tocar antes disso não
     * resolve a nota que ainda vem chegando — a lição é "toque quando ela alcançar a
     * linha", e aceitar o adiantamento apagaria justamente essa lição.
     */
    _studyAnswer(info) {
        const next = this._nextPending();
        if (!next || this._holdFrom === null) return;

        if (info.midi === next.midi) {
            next.state = 'hit';
            this.renderer.markNote(next.beat, SongReadingGame.COLOR.hit);
            if (this.piano) this.piano.flashKey(info.midi, SongReadingGame.COLOR.hit, 380);
            this._release();
            return;
        }

        // errou: mostra a tecla certa e diz o nome dela. A esteira continua parada — o
        // erro aqui não custa nota nenhuma, custa uma segunda tentativa.
        this._studyWrong++;
        if (this.piano) {
            this.piano.flashKey(info.midi, SongReadingGame.COLOR.miss, 500);
            if (this.piano.keys.has(next.midi)) {
                this.piano.flashKey(next.midi, SongReadingGame.COLOR.hit, 900);
            }
        }
        this._flashPrompt(this._t('song.wasNote', { note: this._noteName(next.letter) }), '#dc2626', 1100);
    }

    /**
     * Feedback AO VIVO no modo tempo: o toque responde a PRÓXIMA nota não resolvida, em
     * ORDEM. Nunca uma nota do futuro, por mais perto que ela esteja no tempo.
     *
     * 🔴 A versão anterior escolhia a nota pendente MAIS PRÓXIMA no tempo, e isso não era
     * uma aproximação inofensiva — era uma cascata. Medido a 96 bpm, tocando as 25 alturas
     * CERTAS com 163 ms de atraso (o arrastar mais banal de iniciante): assim que o atraso
     * passa de metade do vão até a nota seguinte, a seguinte fica "mais perto" do que a que
     * o aluno quis tocar; o toque é entregue a ela, a nota certa fica órfã e morre como
     * "passou", e o erro se propaga pela frase inteira. Resultado na tela: **18 cabeças
     * vermelhas de 25**, enquanto o modal informava "25 de 25 alturas certas". E era
     * assimétrico: quem ADIANTAVA o mesmo tanto via as 25 verdes.
     *
     * 🔴 A regra certa não é mais esperta, é mais simples — e é a mesma dos outros dois
     * lugares que já decidem isto: quem lê uma partitura toca as notas NA ORDEM. É o que o
     * modo estudo faz (`_studyAnswer`) e, sobretudo, é o que o placar final faz — o
     * alinhamento do `RhythmScorer` é um Needleman–Wunsch que **preserva a ordem**. Era
     * justamente por não preservá-la que a tela e o placar contavam histórias diferentes.
     *
     * Nota pulada se resolve sozinha: o próprio toque seguinte prova que ela ficou para
     * trás, e ela é marcada ali (o laço abaixo), sem esperar a linha de leitura passar.
     */
    _liveMatch(info, entry) {
        const beatDurMs = 60000 / this.bpm;
        const tol = beatDurMs * SongReadingGame.TAIL_BEATS;

        // Notas que este toque já deixou para trás além da tolerância não têm mais como ser
        // respondidas: o toque é a prova de que foram puladas.
        let alvo = this._nextPending();
        while (alvo && entry.startRelative - alvo.beat * beatDurMs > tol) {
            alvo.state = 'missed';
            this.renderer.markNote(alvo.beat, SongReadingGame.COLOR.pass);
            alvo = this._nextPending();
        }
        if (!alvo) return;
        // Adiantado demais para ser esta nota: é nota a mais (o placar final também a
        // tratará como extra — as duas pontas usam a MESMA tolerância de 1 batida).
        if (alvo.beat * beatDurMs - entry.startRelative > tol) return;

        const ok = info.midi === alvo.midi;
        alvo.state = ok ? 'hit' : 'wrong';
        this.renderer.markNote(alvo.beat, ok ? SongReadingGame.COLOR.hit : SongReadingGame.COLOR.miss);
        if (this.piano) {
            this.piano.flashKey(info.midi, ok ? SongReadingGame.COLOR.hit : SongReadingGame.COLOR.miss, 320);
        } else if (this._instrumentPanel()) {
            this._instrumentPanel().flash(info, ok);
        }
    }

    /** A frase de repouso do modo corrente. 🔴 Três modos, três frases: com o ternário de
     *  duas pontas, um flash em "Acompanhar" restaurava a instrução do modo que MEDE. */
    _promptKey() {
        return this.mode === 'study' ? 'song.promptStudy'
             : this.mode === 'play' ? 'song.playing' : 'song.prompt';
    }

    _flashPrompt(msg, color, ms) {
        this.promptEl.textContent = msg;
        this.promptEl.style.color = color;
        const id = setTimeout(() => {
            if (!this._running) return;
            this.promptEl.textContent = this._t(this._promptKey());
            this.promptEl.style.color = '#6366f1';
        }, ms);
        this._timers.push(id);
    }

    // ---------- avaliação ----------

    /**
     * Os dois placares. Reusa do `RhythmScorer` exatamente as duas partes difíceis — o
     * alinhamento ótimo que preserva a ordem e a curva de precisão calibrada — e nada
     * mais. Não chama `evaluate()`: aquele método calcula também duração e violação de
     * pausa, que este jogo não mede; deixá-lo produzir números que ninguém olha é como
     * ter uma resposta errada guardada esperando alguém exibi-la.
     */
    /**
     * Janela "perfeita" (ms) para o andamento em que a peça está sendo tocada.
     *
     * 🔴 O ±45 ms fixo veio do Jogo de Ritmo, onde funciona porque **lá o bpm é do NÍVEL**.
     * Aqui o bpm é um slider livre de 30 a 160, e a mesma imprecisão MUSICAL passou a valer
     * coisas opostas: ±10% da batida dava Ritmo 61 a 30 bpm e Ritmo 100 a 160. Ou seja, o
     * caminho mais curto para três estrelas era arrastar o slider para a direita, e quem
     * estudava devagar — que é o certo — era punido por isso.
     *
     * A janela passa a ser o MAIOR entre o piso absoluto e uma fração da batida. A
     * propriedade que faz esta escolha ser conservadora: **a 96 bpm (o andamento escrito no
     * Parabéns) o resultado é praticamente o de hoje**, e a 160 bpm o piso continua
     * mandando — não fica mais fácil em lugar nenhum. Só o extremo lento é corrigido, onde
     * exigir ±45 ms de uma batida de dois segundos nunca fez sentido musical.
     *
     * O decaimento acompanha pelo mesmo motivo: chegar a 0% a uma distância FIXA em ms
     * significaria, a 30 bpm, zerar dentro de 22% da batida. Ancorado em fração de batida,
     * a curva inteira fica com o mesmo formato em qualquer andamento.
     */
    static WINDOW_FLOOR_MS = 45;      // piso absoluto (o valor herdado do Jogo de Ritmo)
    static WINDOW_BEAT_FRAC = 0.10;   // ...ou 10% da batida, o que for maior
    static DECAY_BEAT_FRAC = 0.60;    // 0% de precisão a esta distância além da janela

    _scorerFor(beatDurMs) {
        const perfect = Math.max(SongReadingGame.WINDOW_FLOOR_MS,
                                 beatDurMs * SongReadingGame.WINDOW_BEAT_FRAC);
        return new window.RhythmScorer({
            perfectWindowMs: perfect,
            timingDecayPerMs: 100 / (beatDurMs * SongReadingGame.DECAY_BEAT_FRAC)
        });
    }

    _evaluate() {
        const beatDurMs = 60000 / this.bpm;
        const expected = this._expected.map(e => ({
            beat: e.beat, midi: e.midi,
            startTime: e.beat * beatDurMs,
            duration: e.duration * beatDurMs
        }));
        const inputs = this.recorder.stop();
        // Scorer calibrado PARA ESTE ANDAMENTO (ver _scorerFor). `this.scorer` segue
        // existindo para o alinhamento, que não depende da janela.
        const scorer = this._scorerFor(beatDurMs);
        const { aligned, extras } = scorer.alignInputsToNotes(expected, inputs, beatDurMs);

        let pitchOk = 0, timingSum = 0, played = 0, signedSum = 0;
        aligned.forEach(({ expected: e, actual }) => {
            if (!actual) return;                       // perdida: 0 nos dois placares
            played++;
            if (actual.midi === e.midi) pitchOk++;
            const signed = actual.startRelative - e.startTime;
            signedSum += signed;
            timingSum += scorer.calculateTimingAccuracy(Math.abs(signed));
        });

        const total = expected.length;
        // 🔴 Denominador = TODAS as notas escritas nos dois placares (a perdida entra como
        // zero), como no jogo de ritmo. É o que os torna comparáveis entre si: "100% de
        // ritmo" é impossível para quem tocou metade da peça.
        const notes = total ? Math.round((pitchOk / total) * 100) : 0;
        const rhythmBase = total ? (timingSum / total) : 0;
        // Nota extra é erro de COLOCAÇÃO no tempo → desconta só do Ritmo, nunca de Notas.
        const rhythm = Math.max(0, Math.round(rhythmBase - extras.length * scorer.EXTRA_NOTE_PENALTY));
        const timed = this.recorder.allTimed();
        // 🔴 `overall` é NULL quando o ritmo não foi medido — não vira "só Notas". Antes
        // virava, e com isso a MESMA execução (25 alturas certas, ritmo destruído) valia
        // ☆☆☆ no piano e ★★★ no microfone, com "Novo recorde!" junto. Pior: bastava UMA
        // nota vinda do mic no meio de 24 do piano para o ritmo ser descartado e a medalha
        // sair de graça. A estrela é o único registro que sobra desta peça e vai virar a
        // moeda do ranking (Etapa 6) — ela não pode significar coisas diferentes conforme
        // a superfície, sem dizer isso em lugar nenhum. Sem medida, não há medalha; o
        // placar de Notas continua aparecendo, que é o que o aluno veio treinar.
        const overall = timed ? Math.round((notes + rhythm) / 2) : null;

        return {
            notes, rhythm, overall, timed, total, played, pitchOk,
            perfectMs: Math.round(scorer.PERFECT_WINDOW_MS),
            extras: extras.length,
            missed: total - played,
            avgSignedMs: played ? Math.round(signedSum / played) : 0
        };
    }

    _end() {
        if (this._ended) return;
        this._ended = true;
        this._running = false;
        if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
        this._killAudio();
        this._teardownInputDevices();
        // DIÁRIO (user_events): a ÚNICA linha de diário dentro de um jogo — este é o único
        // fora do LevelProgress, e a identidade da peça (catálogo × arquivo do aluno) só
        // existe aqui. ANTES do roundClose: é ele que zera a duração aberta no tracker.
        // No-op para convidado. Ver docs/EVENTOS-PLANO.md §3.
        try {
            window.eventTracker?.track('song_played', {
                song_id: this._harmonyId(), mode: this.mode,
                duration_s: window.eventTracker.roundElapsed(), own: this.freeMode ? 1 : 0
            });
        } catch (e) { /* diário nunca quebra o jogo */ }
        if (window.Beacon) window.Beacon.roundClose('done');

        this.promptEl.textContent = '';
        this.answersEl.innerHTML = '';
        this.extraEl.innerHTML = '';

        if (this.mode === 'play') {
            // Nada a julgar: a peça acabou, e é só isso que há para dizer.
            this._showStartScreen();
            if (window.notifications) window.notifications.toast(this._t('song.playDone'));
            return;
        }
        if (this.mode === 'study') this._showStudyResults();
        else this._showResults(this._evaluate());
    }

    /** O modo estudo não dá nota — ele conta o que aconteceu e sugere o próximo passo. */
    _showStudyResults() {
        const body = document.createElement('div');
        body.innerHTML = `
            <div style="text-align:center;">
                <p style="font-size:2.2rem;margin:0.2rem 0;">🎼</p>
                <p style="font-size:1.05rem;font-weight:700;margin:0.3rem 0;">${this._t('song.results.studyDone')}</p>
                <p style="color:#64748b;font-size:0.92rem;margin:0.4rem 0 0;">
                    ${this._t('song.results.studyLine', { notes: this._expected.length, wrong: this._studyWrong })}
                </p>
                <p style="color:#475569;font-size:0.88rem;margin:0.9rem auto 0;max-width:380px;line-height:1.5;">
                    ${this._t('song.results.studyNext')}
                </p>
            </div>`;

        // 🔴 A classe da âncora vai NO TEMPLATE, nunca por `body.children[1]`:
        // seleção por POSIÇÃO é o defeito que o §11.2 registrou ter aprendido do
        // jeito difícil — um bloco novo no topo e o "?" migra de quadro em silêncio.
        const act = (fn) => () => { this._resultActionTaken = true; window.notifications.closeModal(); fn(); };
        this._resultActionTaken = false;
        window.notifications.modal({
            title: this._songTitle(),
            node: body,
            actions: [
                { label: this._t('song.results.toTempo'), style: 'primary', closeOnClick: false,
                  onClick: act(() => { this.mode = 'tempo'; localStorage.setItem(this._modeKey(), 'tempo'); this.start(); }) },
                { label: this._t('song.results.again'), style: 'success', closeOnClick: false,
                  onClick: act(() => this.start()) },
                // 🔴 Este botão era "Voltar" e ia para a HOME DO APP: acabar de tocar a sua
                // música te ejetava do jogo inteiro. E o ✕ do mesmo modal fazia outra coisa
                // (voltava para a peça) — duas saídas, dois destinos. Agora ele nomeia o
                // destino, como manda a convenção do BaseGameScreen, e o destino é útil.
                { label: this._t('song.results.pick'), style: 'neutral', closeOnClick: false,
                  onClick: act(() => this._showPickScreen()) }
            ],
            dismissible: true,
            onClose: () => { if (!this._resultActionTaken) this._showStartScreen(); }
        });
    }

    _showResults(r) {
        const medido = r.overall != null;
        const stars = medido ? this._starsFor(r.overall) : 0;
        const record = medido ? this._saveBestStars(stars) : false;
        const color = (v) => v >= 90 ? '#10b981' : v >= 70 ? '#f59e0b' : v >= 50 ? '#f97316' : '#ef4444';
        // Sem ritmo medido não há estrela NENHUMA na tela — nem vazia, que ainda sugeriria
        // que faltou pouco. Em lugar dela, a frase que explica o que falta para valer.
        const starsBig = medido
            ? `<span style="color:#f59e0b;">${'★'.repeat(stars)}</span><span style="color:#e2e8f0;">${'☆'.repeat(3 - stars)}</span>`
            : `<span style="font-size:1.6rem;">🎧</span>`;

        const card = (label, value, hint) => `
            <div style="flex:1;min-width:120px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:0.7rem 0.5rem;text-align:center;">
                <div style="font-size:0.72rem;color:#64748b;text-transform:uppercase;letter-spacing:0.04em;">${label}</div>
                <div style="font-size:1.7rem;font-weight:900;color:${color(value)};line-height:1.1;">${value}%</div>
                ${hint ? `<div style="font-size:0.72rem;color:#94a3b8;margin-top:0.2rem;">${hint}</div>` : ''}
            </div>`;

        // Tendência: adiantando × atrasando. É a dica de estudo nº1 e o número sozinho
        // não a entrega — 64% de ritmo não diz se você corre ou arrasta.
        const trend = !r.timed ? '' : (Math.abs(r.avgSignedMs) < 25 ? this._t('song.results.onTime')
            : r.avgSignedMs < 0 ? this._t('song.results.rushing', { ms: Math.abs(r.avgSignedMs) })
            : this._t('song.results.dragging', { ms: r.avgSignedMs }));

        const body = document.createElement('div');
        body.innerHTML = `
            <div style="text-align:center;margin-bottom:0.9rem;">
                <p style="font-size:2.6rem;margin:0.1rem 0;line-height:1;letter-spacing:0.2rem;">${starsBig}</p>
                ${record ? `<p style="color:#f59e0b;font-weight:800;margin:0.4rem 0 0;">${this._t('song.results.starRecord')}</p>` : ''}
                ${(medido && this.freeMode) ? `<p style="color:#94a3b8;margin:0.4rem auto 0;max-width:400px;font-size:0.8rem;line-height:1.4;">${this._t('song.results.freeNoRecord')}</p>` : ''}
                ${medido ? '' : `<p style="color:#b45309;font-weight:700;margin:0.4rem auto 0;max-width:400px;font-size:0.85rem;line-height:1.45;">${this._t('song.results.noStar')}</p>`}
            </div>
            <div class="song-modal-score" style="display:flex;gap:0.6rem;flex-wrap:wrap;">
                ${card(this._t('song.results.notes'), r.notes, this._t('song.results.notesHint', { hits: r.pitchOk, total: r.total }))}
                ${r.timed
                    ? card(this._t('song.results.rhythm'), r.rhythm, trend)
                    : `<div style="flex:1;min-width:120px;background:#fffbeb;border:1px solid #fde68a;border-radius:10px;padding:0.7rem 0.5rem;text-align:center;">
                         <div style="font-size:0.72rem;color:#b45309;text-transform:uppercase;letter-spacing:0.04em;">${this._t('song.results.rhythm')}</div>
                         <div style="font-size:1.1rem;font-weight:800;color:#b45309;line-height:1.3;margin-top:0.3rem;">—</div>
                         <div style="font-size:0.72rem;color:#b45309;margin-top:0.2rem;">${this._t('song.results.rhythmNotMeasured')}</div>
                       </div>`}
            </div>
            <div style="margin-top:0.8rem;background:#f8fafc;border-radius:10px;padding:0.5rem 0.9rem;font-size:0.85rem;color:#475569;">
                <div style="display:flex;justify-content:space-between;padding:0.3rem 0;">
                    <span>${this._t('song.results.missed')}</span><strong>${r.missed}</strong>
                </div>
                <div style="display:flex;justify-content:space-between;padding:0.3rem 0;">
                    <span>${this._t('song.results.extras')}</span><strong>${r.extras}</strong>
                </div>
            </div>`;

        // 🔴 A classe da âncora vai NO TEMPLATE, nunca por `body.children[1]`:
        // seleção por POSIÇÃO é o defeito que o §11.2 registrou ter aprendido do
        // jeito difícil — um bloco novo no topo e o "?" migra de quadro em silêncio.
        const act = (fn) => () => { this._resultActionTaken = true; window.notifications.closeModal(); fn(); };
        this._resultActionTaken = false;
        window.notifications.modal({
            title: this._songTitle(),
            node: body,
            actions: [
                { label: this._t('song.results.again'), style: 'success', closeOnClick: false, onClick: act(() => this.start()) },
                { label: this._t('song.results.toStudy'), style: 'neutral', closeOnClick: false,
                  onClick: act(() => { this.mode = 'study'; localStorage.setItem(this._modeKey(), 'study'); this.start(); }) },
                // 🔴 Este botão era "Voltar" e ia para a HOME DO APP: acabar de tocar a sua
                // música te ejetava do jogo inteiro. E o ✕ do mesmo modal fazia outra coisa
                // (voltava para a peça) — duas saídas, dois destinos. Agora ele nomeia o
                // destino, como manda a convenção do BaseGameScreen, e o destino é útil.
                { label: this._t('song.results.pick'), style: 'neutral', closeOnClick: false,
                  onClick: act(() => this._showPickScreen()) }
            ],
            dismissible: true,
            onClose: () => { if (!this._resultActionTaken) this._showStartScreen(); }
        });
        // 🔴 "?" DENTRO do modal: troca a página do MESMO card. Um segundo overlay
        // apagaria o resultado (o NotificationManager só tem um modal), e aqui isso
        // custaria caro — o resultado só existe depois de tocar a música inteira.
        const linha = document.querySelector('[data-notification-modal] .song-modal-score');
        if (linha && window.HelpSheet) {
            window.HelpSheet.dotInCard('song.results', linha, linha.closest('[data-notification-modal]'));
        }
    }

    // ---------- fim ----------

    destroy() {
        this._destroyed = true;
        this._running = false;
        if (this._onPopState) { window.removeEventListener('popstate', this._onPopState); this._onPopState = null; }
        if (this.harmonyEditor) { this.harmonyEditor.destroy(); this.harmonyEditor = null; }
        if (this.shelf) { this.shelf.destroy(); this.shelf = null; }
        if (this.promptEl) this.promptEl.style.display = '';
        if (window.notifications) { this._resultActionTaken = true; window.notifications.closeModal(); }
        if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
        clearTimeout(this._resizeTimer);
        this._timers.forEach(clearTimeout);
        this._timers = [];
        this._killAudio();
        this._teardownInputDevices();
        if (window.Beacon) window.Beacon.roundClose('quit');
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this.renderer) { this.renderer.destroy(); this.renderer = null; }
        if (this.musicStaff) { this.musicStaff.destroy(); this.musicStaff = null; }
        if (this.container) this.container.innerHTML = '';
    }
}

// Disponibiliza globalmente
window.SongReadingGame = SongReadingGame;



// ============================================
// screens/BaseScreen.js
// ============================================
/**
 * BaseScreen — base de TODA tela do app (Router → tela). PAI do BaseGameScreen.
 *
 * Existe porque as telas que NÃO são jogo (Novidades, Ajuda, Ranking) herdavam
 * BaseGameScreen "pelo encanamento" e cada uma reescrevia o mesmo init() à mão
 * (esconder landing → container → título → render). Três cópias hoje; com dez telas
 * de plataforma (perfil, turma, painel) seriam dez decisões. Aqui o encanamento
 * mora uma vez e a subclasse só diz o que é DELA:
 *
 *   class FooScreen extends BaseScreen {
 *     static TITLE_KEY = 'foo.title';       // título da aba (i18n) — ou getTitle()
 *     async load(params) { … }              // OPCIONAL: busca o dado (rede, storage)
 *     render() { this.container.innerHTML = …; }   // OBRIGATÓRIO: desenha
 *     renderError(e) { … }                  // OPCIONAL: default = frase + "← Início"
 *   }
 *
 * Ciclo (Template Method): init(params) → hideLandingPage → createContainer →
 * document.title → renderLoading → load → render; se load/render lançar, renderError
 * — a exceção NUNCA sobe pro Router (tela de erro no lugar, nunca tela em branco).
 * Faltar o render() é erro de PROGRAMAÇÃO e lança na hora, com o nome da classe
 * (igual ao createGame() do BaseGameScreen), para aparecer no primeiro teste e não
 * em prod.
 *
 * 🔴 TELA ÓRFÃ (auditoria de 06/set): o Router só a destrói DEPOIS que o `load` resolve,
 * e nesse meio-tempo a tela seguinte já montou por cima (createContainer remove o wrap
 * anterior). Então, ao voltar do `load`, a tela confere se AINDA é ela que está no DOM
 * (`_isMounted`): se não, não renderiza (escreveria num container solto e, na Novidades,
 * carimbaria `news_last_seen` de uma lista que ninguém viu). E `destroy()` só reexibe a
 * landing se o wrap removido era o que estava na página — a órfã morrendo não pode
 * trazer hero/cards de volta por baixo do jogo que já está no ar.
 *
 * 🔴 `params` recebe path-params E query já fundidos pelo Router (`/turma/:id` +
 * `?aba=x` chegam juntos; a query vence no conflito).
 * 🔴 `.header` fica FORA de LANDING_SELECTORS de propósito: a navegação (AppHeader)
 * é persistente — sumir com ela ao entrar numa tela era a "navegação horrível".
 */
class BaseScreen {
    // Seções da landing estática a esconder enquanto uma tela está ativa.
    static LANDING_SELECTORS = ['.hero', '.games-section', '.about-section', '.footer'];

    constructor() {
        this.container = null;
        this.wrap = null;
        this.contextBar = null;
        this.params = {};
        this._destroyed = false;
    }

    _t(key, params = {}) {
        return window.language ? window.language.t(key, params) : key;
    }

    _esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, c => (
            { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    // ----- contrato da subclasse ------------------------------------------------

    /** Título da aba. Default: `static TITLE_KEY` traduzida; '' = só o nome do app. */
    getTitle() {
        const k = this.constructor.TITLE_KEY;
        return k ? this._t(k) : '';
    }

    /** Busca o dado de que o render precisa. Default: nada a buscar. */
    async load(params) { /* opcional */ }

    /**
     * O que a pessoa vê ENQUANTO o load espera (rede lenta, PWA offline com fetch
     * pendurado). Default: "Carregando…" centrado. A subclasse que tenha um shell
     * próprio (a Novidades pinta h1 + subtítulo) sobrescreve — a landing já sumiu,
     * então um container vazio aqui é tela em branco.
     */
    renderLoading() {
        if (!this.container) return;
        this.container.innerHTML =
            `<div class="screen-loading" style="padding:2rem;text-align:center;color:#64748b;">`
            + `${this._esc(this._t('app.loading'))}</div>`;
    }

    /** OBRIGATÓRIO: desenha em this.container. */
    render() {
        throw new Error(`${this.constructor.name}: render() deve ser implementado pela subclasse`);
    }

    /**
     * Tela de erro: o load/render lançou. Default enxuto e trilíngue — a subclasse
     * que tenha um estado de erro próprio (a lista de Novidades tem) trata no load
     * e nem chega aqui.
     */
    renderError(error) {
        if (!this.container) return;
        const back = this._t('nav.home');
        this.container.innerHTML = `
            <div class="screen-error" style="padding:2rem;text-align:center;">
                <p style="color:#475569;margin:0 0 1rem;">${this._esc(this._t('app.loadError'))}</p>
                <button type="button" class="screen-error-back" style="padding:0.5rem 1rem;">← ${this._esc(back)}</button>
            </div>`;
        this.container.querySelector('.screen-error-back')
            .addEventListener('click', () => { window.location.hash = '#/'; });
    }

    // ----- ciclo de vida ----------------------------------------------------------

    async init(params = {}) {
        // Erro de programação, não de runtime: lança ANTES de mexer no DOM.
        if (this.render === BaseScreen.prototype.render) this.render();

        this.params = params || {};
        this.hideLandingPage();
        this.createContainer();
        this._syncDocumentTitle();
        this.renderLoading();
        try {
            await this.load(this.params);
            if (!this._isMounted()) return;   // órfã: outra tela já está no lugar
            this.render();
        } catch (error) {
            if (!this._isMounted()) return;
            console.error(`${this.constructor.name}: erro ao carregar a tela:`, error);
            this.renderError(error);
        }
    }

    /** Ainda sou eu que estou na página? (false = destruída, ou outra tela montou por cima) */
    _isMounted() {
        return !this._destroyed && !!this.wrap && this.wrap.isConnected;
    }

    _syncDocumentTitle() {
        const title = this.getTitle();
        const app = this._t('app.name');
        document.title = title ? `${title} | ${app}` : app;
    }

    /**
     * Destino do "← voltar" da barra de contexto. Default = home (#/), o hub de
     * jogos. Subclasses sobrescrevem para um pai mais específico (ex.: o Ritmo
     * Livre volta para os Níveis do ranqueado, não para a home). O rótulo é o
     * NOME DO DESTINO (padrão iOS: "← Início" / "← Níveis"), não "voltar" — a tela
     * atual já é identificada pelo gatilho ⊞ do header.
     */
    getBackTarget() {
        const t = (k, fb) => { const v = window.language?.t(k); return (v && v !== k) ? v : fb; };
        return { hash: '#/', label: t('nav.home', 'Início') };
    }

    hideLandingPage() {
        BaseScreen.LANDING_SELECTORS.forEach(sel => {
            const el = document.querySelector(sel);
            if (el) el.style.display = 'none';
        });
    }

    showLandingPage() {
        BaseScreen.LANDING_SELECTORS.forEach(sel => {
            const el = document.querySelector(sel);
            if (el) el.style.display = '';
        });
    }

    createContainer() {
        // Wrapper irmão: a barra de contexto NÃO pode morar dentro de #game-container
        // porque os jogos fazem `container.innerHTML = ...` (a apagariam). Ela fica
        // ACIMA do container, no wrapper, e sobrevive ao re-render.
        const existing = document.getElementById('game-screen-wrap');
        if (existing) existing.remove();

        const wrap = document.createElement('div');
        wrap.id = 'game-screen-wrap';
        wrap.className = 'game-screen-wrap';
        const contextBar = this._buildContextBar();
        if (contextBar) wrap.appendChild(contextBar);

        this.container = document.createElement('div');
        this.container.id = 'game-container';
        this.container.className = 'game-container';
        wrap.appendChild(this.container);

        document.body.appendChild(wrap);
        this.wrap = wrap;
    }

    /**
     * Barra fina "← <destino>" — saída consistente de QUALQUER tela.
     * Quando o destino é a home, a barra é OMITIDA de propósito: o AppHeader
     * (sticky, sempre visível) já cobre "voltar pra home" com a logo + o drawer
     * ⊞, então a barra só duplicava esse caminho e empilhava chrome no topo das
     * rotas ranqueadas. Ela continua aparecendo nas sub-rotas (ex.: Ritmo Livre
     * → "← Níveis"), onde é o único atalho de 1 toque pro pai específico.
     */
    _buildContextBar() {
        const back = this.getBackTarget();
        if (back.hash === '#/') return null;
        const bar = document.createElement('div');
        bar.className = 'game-context-bar';
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'game-back';
        chip.innerHTML =
            `<span class="game-back-arrow" aria-hidden="true">←</span>` +
            `<span class="game-back-label">${back.label}</span>`;
        // Do TEXTO impresso, não de `back.label`: o rótulo pode chegar escapado (nome de trilha,
        // texto de terceiro) e atributo não decodifica entidade — o leitor de tela lia `&amp;lt;`.
        chip.setAttribute('aria-label', chip.textContent.trim());
        chip.addEventListener('click', () => { window.location.hash = back.hash; });
        bar.appendChild(chip);
        this.contextBar = bar;
        return bar;
    }

    destroy() {
        this._destroyed = true;
        if (this.wrap) {
            // Só reexibe a landing se o wrap que sai era o que estava na página. Se outra
            // tela já montou por cima (esta é uma órfã), a landing é DELA — fica escondida.
            const mine = document.getElementById('game-screen-wrap') === this.wrap;
            this.wrap.remove();
            this.wrap = null;
            this.container = null;
            if (mine) this.showLandingPage();
        }
    }
}

// Disponibiliza globalmente
window.BaseScreen = BaseScreen;



// ============================================
// screens/BaseGameScreen.js
// ============================================
/**
 * BaseGameScreen - Base das telas-wrapper dos jogos (Router → tela → jogo).
 *
 * Herda de BaseScreen (esconder landing, container, barra de contexto, destroy)
 * e acrescenta o ciclo de vida do JOGO: a subclasse só diz QUAL jogo criar
 * (createGame()). Espelha o papel do BaseScreen do projeto principal.
 *
 * Adicionar um jogo novo passa a ser ~5 linhas:
 *   class FooGameScreen extends BaseGameScreen {
 *     createGame() { return new window.FooGame(); }
 *   }
 *
 * 🔴 Tela que NÃO é jogo estende BaseScreen (load/render/renderError), não esta.
 */
class BaseGameScreen extends BaseScreen {
    constructor() {
        super();
        this.game = null;
    }

    /** OBRIGATÓRIO: a subclasse retorna a instância do jogo a rodar. Recebe os params da rota (query fundida). */
    createGame(params = {}) {
        throw new Error('BaseGameScreen: createGame() deve ser implementado pela subclasse');
    }

    /**
     * OPCIONAL, assíncrono, ANTES do jogo nascer: buscar o que o jogo precisa para ser construído
     * (a trilha do professor vem do servidor por `?lista=`). Devolver `false` ABORTA a tela sem
     * criar jogo (a subclasse já redirecionou — ex.: convidado com `?lista=` vai para a capa).
     */
    async prepare(params = {}) { return true; }

    async init(params = {}) {
        try {
            this.hideLandingPage();
            this.createContainer();
            this.renderLoading();
            if ((await this.prepare(params)) === false) return;
            if (!this._isMounted()) return;   // outra tela montou por cima enquanto o prepare esperava

            this.game = this.createGame(params);

            // nível inicial opcional (passado por parâmetro de rota)
            if (params.level) {
                this.game.currentLevel = parseInt(params.level) || 1;
            }

            await this.game.init(this.container);
        } catch (error) {
            console.error('Erro ao inicializar jogo:', error);
            if (this.container) {
                this.container.innerHTML = `
                    <div style="padding: 2rem; text-align: center;">
                        <h2>Erro ao carregar jogo</h2>
                        <p>${error.message}</p>
                        <button onclick="window.location.hash='/'" style="margin-top: 1rem; padding: 0.5rem 1rem;">Voltar</button>
                    </div>`;
            }
        }
    }

    destroy() {
        if (this.game) {
            this.game.destroy();
            this.game = null;
        }
        super.destroy();
    }
}

// Disponibiliza globalmente
window.BaseGameScreen = BaseGameScreen;



// ============================================
// screens/RhythmGameScreen.js
// ============================================
/**
 * RhythmGameScreen - Tela do jogo de ritmo RANQUEADO (#/ritmo, headline).
 * Toda a mecânica de wrapper (esconder landing, container, ciclo de vida) vem do
 * BaseGameScreen; aqui só dizemos qual jogo instanciar e em que MODO.
 * O personalizado (sandbox) é a RhythmFreeScreen (#/ritmo-livre).
 */
class RhythmGameScreen extends BaseGameScreen {
    createGame() {
        return new window.RhythmGame({ mode: 'ranked' });
    }
}

// Disponibiliza globalmente
window.RhythmGameScreen = RhythmGameScreen;



// ============================================
// screens/RhythmFreeScreen.js
// ============================================
/**
 * RhythmFreeScreen - Tela do jogo de ritmo PERSONALIZADO / sandbox (#/ritmo-livre).
 * Rota AVULSA (fora de Main.GAMES → não vira tab no header): descoberta pelo link
 * "⚙️ Modo livre" dentro do ranqueado. Espelha a RhythmGameScreen, só muda o MODO.
 *
 * Desde 17/set a MESMA rota abre a TRILHA DO PROFESSOR (docs/LISTAS-PLANO.md):
 *   #/ritmo-livre?lista=CÓDIGO            → RhythmGame em modo `list` (a lista vem do servidor no
 *                                            `prepare`; convidado é mandado para a capa #/trilha/CÓDIGO,
 *                                            que pede conta — trilha é de cadastrado)
 *   #/ritmo-livre?lista=CÓDIGO&nivel=LID&testar=1 → o DONO testando um nível da oficina (18/set):
 *                                            modo `list` com `list.test` — sem cadeado e sem gravar
 *                                            nada; "← trilha" volta para a oficina, no nível.
 * 🔴 `?lista=` SEM lista válida (404, pausada, rede) cai na capa, que sabe dizer o que houve.
 * 🔴 O antigo `?edit=CÓDIGO&lid=` (editar um nível DENTRO do jogo) saiu com a oficina: o nível se
 *    edita na própria trilha, com o mesmo painel ⚙️; o jogo é só para jogar e testar.
 */
class RhythmFreeScreen extends BaseGameScreen {
    constructor() {
        super();
        this._list = null;   // a lista normalizada (modo list); `list.test` = o dono testando
    }

    async prepare(params = {}) {
        const um = window.userManager;
        const T = window.RhythmTrails;
        const code = String(params.lista || '').trim();
        if (code) {
            if (!um || !um.isLoggedIn()) { window.location.hash = '#/trilha/' + encodeURIComponent(code); return false; }
            const r = um.fetchList ? await um.fetchList(code) : { success: false };
            const list = r && r.success && T ? T.normalizeList(r.list) : null;
            if (!list) { window.location.hash = '#/trilha/' + encodeURIComponent(code); return false; }
            // TESTE do dono (`&testar=1`): só com `can_edit` — para os outros a bandeira é ignorada.
            if (String(params.testar || '') === '1' && r.can_edit) list.test = true;
            this._list = list;
            // A capa (ou a oficina) pode ter deixado o nível escolhido; a régua de liberação é a do RhythmTrails.
            if (params.nivel) T.setCurrent(list, String(params.nivel));
            return true;
        }
        return true;
    }

    createGame(params = {}) {
        if (this._list) return new window.RhythmGame({ mode: 'list', list: this._list });
        return new window.RhythmGame({ mode: 'free' });
    }

    /**
     * O modo livre é filho do ranqueado: "← Níveis" volta p/ #/ritmo (não a home).
     * Na trilha do professor, "← ⟨nome da trilha⟩" volta para a CAPA dela (não para #/ritmo):
     * é de lá que se escolhe nível e se vê o progresso. Testando (dono): volta à OFICINA, no nível.
     */
    getBackTarget() {
        const t = (k, fb) => { const v = window.language?.t(k); return (v && v !== k) ? v : fb; };
        // 🔴 O nome da trilha é texto do AUTOR e a barra o imprime por innerHTML: ESCAPADO aqui.
        if (this._list && this._list.test) {
            const lid = window.RhythmTrails.currentLid(this._list);
            return { hash: '#/trilha/' + encodeURIComponent(this._list.code) + '?edit=1&lid=' + encodeURIComponent(lid), label: this._esc(this._list.name) || t('rhythm.trails.title', 'Trilha') };
        }
        if (this._list) return { hash: '#/trilha/' + encodeURIComponent(this._list.code), label: this._esc(this._list.name) || t('rhythm.trails.title', 'Trilha') };
        return { hash: '#/ritmo', label: t('nav.levels', 'Níveis') };
    }

    // O `prepare` decide o destino do "voltar" — e a barra nasce no createContainer, ANTES dele.
    // Refaz a barra depois do prepare, com o destino certo.
    async init(params = {}) {
        await super.init(params);
        if (this.wrap && this._isMounted() && this._list) {
            if (this.contextBar) this.contextBar.remove();
            const bar = this._buildContextBar();
            if (bar) this.wrap.insertBefore(bar, this.container);
        }
    }
}

// Disponibiliza globalmente
window.RhythmFreeScreen = RhythmFreeScreen;



// ============================================
// screens/StaffReadingScreen.js
// ============================================
/**
 * StaffReadingScreen - Tela do jogo de leitura de 1 nota (turn-based). É o "treino livre"
 * IRMÃO da esteira (#/leitura-livre), espelhando RhythmFreeScreen: rota avulsa fora de
 * Main.GAMES, achada pelo link dentro da esteira. "← Leitura" volta p/ o headline #/leitura.
 */
class StaffReadingScreen extends BaseGameScreen {
    createGame() {
        return new window.StaffReadingGame();
    }

    /** Filho da esteira: "← Leitura" volta p/ #/leitura (não a home). */
    getBackTarget() {
        const t = (k, fb) => { const v = window.language?.t(k); return (v && v !== k) ? v : fb; };
        return { hash: '#/leitura', label: t('nav.staffReading', 'Leitura') };
    }
}

// Disponibiliza globalmente
window.StaffReadingScreen = StaffReadingScreen;



// ============================================
// screens/ReadingFlowScreen.js
// ============================================
/**
 * ReadingFlowScreen - Tela da Leitura em Fluxo / esteira. É o HEADLINE de #/leitura
 * (Main.GAMES), espelhando o split do Ritmo: a esteira é o jogo principal e o turn-based
 * de 1 nota virou o "treino livre" (#/leitura-livre). Back default (home) herdado da base.
 */
class ReadingFlowScreen extends BaseGameScreen {
    /** Porta Kids: #/leitura?kids=1 (CTA da página p/ pais) liga o modo ANTES do jogo
     *  nascer — o construtor do game lê rf_kids do localStorage. Sem o param, quem
     *  vinha da página infantil caía no jogo adulto com o pill Kids abaixo da dobra. */
    async init(params = {}) {
        if (params.kids === '1' || params.kids === '0') {
            localStorage.setItem(window.ReadingFlowGame.KIDS_KEY, params.kids);
        }
        return super.init(params);
    }

    createGame() {
        return new window.ReadingFlowGame();
    }
}

// Disponibiliza globalmente
window.ReadingFlowScreen = ReadingFlowScreen;



// ============================================
// screens/SongFreeScreen.js
// ============================================
/**
 * SongFreeScreen - Música de Verdade com a peça DO ALUNO (#/musicas-livre).
 *
 * Rota AVULSA (fora de Main.GAMES → não vira ladrilho no ⊞). É o ATALHO para importar:
 * o destino da página de SEO do importador, e a porta que abre direto no seletor de
 * arquivo quando não há nada guardado.
 *
 * 🔴 Desde 28/ago as duas rotas rodam o MESMO jogo com a MESMA lista de músicas — a
 * diferença é só onde cada uma entra com a estante vazia (aqui, o importador; em
 * `#/musicas`, a peça do catálogo). Ver `SongReadingGame._openEntry`.
 *
 * 🔴 O que continua valendo do §6 do MUSICA-REAL-PLANO: peça do aluno não tem recorde
 * nem ranking. Isso agora é da PEÇA (`freeMode`), não da rota.
 */
class SongFreeScreen extends BaseGameScreen {
    createGame() {
        return new window.SongReadingGame({ mode: 'free' });
    }

    /**
     * 🔴 SEM barra "← Música". Ela existia porque esta rota era um jogo à parte; agora as
     * duas abrem a MESMA lista de músicas (o catálogo entrou nela), então o chip dizia
     * "voltar de Música para Música" e levava a pessoa para a peça de demonstração. A
     * saída de dentro do jogo é a lista; a saída do jogo é o header, que é persistente.
     */
}

// Disponibiliza globalmente
window.SongFreeScreen = SongFreeScreen;



// ============================================
// screens/SongScreen.js
// ============================================
/**
 * SongScreen - tela do jogo de MÚSICA REAL (#/musicas).
 *
 * Está em `Main.GAMES` como os outros 4 jogos: card na landing/home + ladrilho no
 * switcher ⊞. Ficou fora enquanto era "rota avulsa", e o preço foi ser anunciado como
 * jogo por fora e arquivado como tela auxiliar por dentro.
 *
 * 🔴 Estar em `Main.GAMES` NÃO o coloca no ranking: isso vem de
 * `LevelProgress.register()`, que este jogo não chama enquanto o catálogo tiver uma
 * peça só. Ranking e página SEO seguem na Etapa 6 de docs/MUSICA-REAL-PLANO.md.
 */
class SongScreen extends BaseGameScreen {
    createGame() {
        return new window.SongReadingGame();
    }
}

// Disponibiliza globalmente
window.SongScreen = SongScreen;



// ============================================
// screens/IntervalGameScreen.js
// ============================================
/**
 * IntervalGameScreen - Tela do jogo de Intervalos RANQUEADO (#/intervalos, headline).
 * Wrapper mínimo sobre BaseGameScreen (ver RhythmGameScreen). O sandbox/treino é a
 * IntervalFreeScreen (#/intervalos-livre).
 */
class IntervalGameScreen extends BaseGameScreen {
    createGame() {
        return new window.IntervalGame({ mode: 'ranked' });
    }
}

// Disponibiliza globalmente
window.IntervalGameScreen = IntervalGameScreen;



// ============================================
// screens/IntervalFreeScreen.js
// ============================================
/**
 * IntervalFreeScreen - Tela do jogo de Intervalos PERSONALIZADO / sandbox (#/intervalos-livre).
 * Rota AVULSA (fora de Main.GAMES → não vira tab no header): descoberta pelo link
 * "⚙️ Modo livre" dentro do ranqueado. Espelha a IntervalGameScreen, só muda o MODO.
 */
class IntervalFreeScreen extends BaseGameScreen {
    createGame() {
        return new window.IntervalGame({ mode: 'free' });
    }

    /** O sandbox é filho do ranqueado: "← Níveis" volta p/ #/intervalos (não a home). */
    getBackTarget() {
        const t = (k, fb) => { const v = window.language?.t(k); return (v && v !== k) ? v : fb; };
        return { hash: '#/intervalos', label: t('nav.levels', 'Níveis') };
    }
}

// Disponibiliza globalmente
window.IntervalFreeScreen = IntervalFreeScreen;



// ============================================
// screens/ChordGameScreen.js
// ============================================
/**
 * ChordGameScreen - Tela do jogo de acordes.
 * Wrapper mínimo sobre BaseGameScreen (ver IntervalGameScreen).
 */
class ChordGameScreen extends BaseGameScreen {
    createGame() {
        return new window.ChordGame();
    }
}

// Disponibiliza globalmente
window.ChordGameScreen = ChordGameScreen;



// ============================================
// screens/ChordFreeScreen.js
// ============================================
/**
 * ChordFreeScreen - Tela do jogo de Acordes PERSONALIZADO / sandbox (#/acordes-livre).
 * Rota AVULSA (fora de Main.GAMES → não vira tab no header): descoberta pelo link
 * "⚙️ Modo livre" dentro do ranqueado. Espelha a ChordGameScreen, só muda o MODO.
 */
class ChordFreeScreen extends BaseGameScreen {
    createGame() {
        return new window.ChordGame({ mode: 'free' });
    }

    /** O sandbox é filho do ranqueado: "← Níveis" volta p/ #/acordes (não a home). */
    getBackTarget() {
        const t = (k, fb) => { const v = window.language?.t(k); return (v && v !== k) ? v : fb; };
        return { hash: '#/acordes', label: t('nav.levels', 'Níveis') };
    }
}

// Disponibiliza globalmente
window.ChordFreeScreen = ChordFreeScreen;



// ============================================
// screens/HelpScreen.js
// ============================================
/**
 * HelpScreen — a Central de Ajuda (`#/ajuda`), fase 2 do plano de ajuda.
 *
 * Cópia estrutural do NewsScreen: NÃO é jogo — estende BaseScreen (o template
 * load → render das telas não-jogo). Entra no ☰ e no Router por UMA linha em
 * `Main.MENU`, ao lado de `/novidades` e `/ranking`.
 *
 * 🔴 `#/ajuda` NÃO entra em `Main.GAMES` (ajuda não é jogo, e o ⊞ é o switcher de
 * JOGO) e, por coerência, também não entra em `Beacon.GAME_ROUTES`. O help-test
 * guarda os dois lados, para ninguém "consertar" isso depois por analogia.
 *
 * Os "?" espalhados resolvem a dúvida de quem JÁ ESTÁ na tela certa. Esta tela
 * resolve a de quem NÃO SABE ONDE PROCURAR — e é o único lugar onde cabem os
 * assuntos que não pertencem a jogo nenhum (o portão do nível 4, o modo livre).
 *
 * Quatro seções, nesta ordem, e a ordem é a resposta a "de onde a pessoa vem":
 *   1. Ajuda desta tela  — os tópicos da rota anterior (HelpRegistry.ROUTE_TOPICS).
 *      Quem abre a ajuda no meio do jogo quase sempre quer o assunto DAQUELA tela.
 *   2. Primeiros passos  — HelpRegistry.FIRST_STEPS.
 *   3. Ajuda por jogo    — todos os tópicos, agrupados, na ordem do GROUP_ORDER.
 *   4. (a busca fica ACIMA de tudo: é a saída de quem não reconhece nome nenhum)
 *
 * 🔴 Zero literal de tópico aqui: tudo vem do HelpRegistry. Espelho de tabela não
 * é redundância — é uma segunda verdade esperando divergir.
 */
class HelpScreen extends BaseScreen {
    static TITLE_KEY = 'help.title';

    /** Rótulo de um grupo: os de JOGO reusam `nav.*` (fonte única do header);
     *  só `app`, que não é jogo e não tem entrada no nav, ganha chave própria. */
    static GROUP_LABEL_KEY = {
        rhythm: 'nav.rhythm',
        staffReading: 'nav.staffReading',
        intervals: 'nav.intervals',
        chords: 'nav.chords',
        songs: 'nav.songs',
        app: 'help.groups.app'
    };

    static GROUP_ICON = {
        rhythm: '🥁', staffReading: '🎼', intervals: '🎧',
        chords: '🎸', songs: '🎵', app: '📱'
    };

    /** 🔴 A rota anterior é lida ANTES de qualquer render (load roda antes do render
     *  no template do BaseScreen): assim que o Router troca de tela, `previousPath`
     *  já aponta para cá. */
    async load() {
        this._from = HelpScreen._cameFrom();
    }

    render() {
        this._render();
    }

    /**
     * De onde a pessoa veio. Preferimos o que o Router guarda; se não houver
     * (entrou direto pelo link), não inventamos uma tela de origem.
     */
    static _cameFrom() {
        const prev = (window.router && window.router.previousPath) || null;
        if (prev && window.HelpRegistry.forRoute(prev).length) return prev;
        return null;   // entrou direto pelo link: não inventamos uma tela de origem
    }

    _render() {
        const mobile = (window.innerWidth || 1024) < 560;
        this.container.innerHTML = `
            <div class="help-screen" style="max-width:680px;margin:0 auto;padding:${mobile ? '1rem' : '2rem 1.5rem'};">
                <h1 style="text-align:center;margin-bottom:0.2rem;">${this._esc(this._t('help.title'))}</h1>
                <p style="text-align:center;color:#64748b;margin:0 0 1.1rem;">${this._esc(this._t('help.subtitle'))}</p>
                <div id="help-search-wrap"></div>
                <div id="help-sections"></div>
            </div>`;
        this.sectionsEl = this.container.querySelector('#help-sections');
        this.container.querySelector('#help-search-wrap').appendChild(this._searchBox());
        this._renderSections();
        this._injectStyle();
    }

    /** Busca: a única saída para quem não reconhece o nome de nenhum jogo. */
    _searchBox() {
        const wrap = document.createElement('div');
        wrap.className = 'help-search';
        const inp = document.createElement('input');
        inp.type = 'search';
        inp.className = 'help-search-input';
        inp.setAttribute('aria-label', this._t('help.searchPlaceholder'));
        inp.placeholder = this._t('help.searchPlaceholder');
        inp.addEventListener('input', () => {
            this._query = inp.value.trim();
            this._renderSections();
        });
        wrap.appendChild(inp);
        this._searchEl = inp;
        return wrap;
    }

    /**
     * Filtro da busca: casa no TÍTULO e no CORPO do tópico, sem acento e sem
     * caixa. Buscar por "bluetooth" tem de achar o "Como jogar" do Ritmo, que é uma
     * palavra que só aparece na resposta — procurar só no título devolveria nada e a
     * pessoa concluiria que o app não fala do assunto.
     */
    _matches(id) {
        if (!this._query) return true;
        const q = HelpScreen._fold(this._query);
        const texto = window.HelpRegistry.i18nKeys(id)
            .map(k => this._t(k)).join(' ');
        return HelpScreen._fold(texto).includes(q);
    }

    static _fold(s) {
        return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    }

    _renderSections() {
        const R = window.HelpRegistry;
        this.sectionsEl.innerHTML = '';
        const buscando = !!this._query;

        if (buscando) {
            // 🔴 Colapsa alias por `sourceId`: no índice por jogo as duas âncoras são
            // PROPOSITAIS (a mesma dúvida mora em Intervalos e em Acordes), mas numa
            // lista plana viram duas linhas com o MESMO título e a mesma folha — o
            // usuário lê como bug. Fica a primeira, na ordem da tabela.
            const fontes = new Set();
            const achou = R.ids().filter((id) => {
                if (!this._matches(id)) return false;
                const src = R.get(id).sourceId;
                if (fontes.has(src)) return false;
                fontes.add(src);
                return true;
            });
            if (!achou.length) {
                const p = document.createElement('p');
                p.className = 'help-empty';
                p.dataset.helpEmpty = '1';
                p.textContent = this._t('help.searchEmpty', { q: this._query });
                this.sectionsEl.appendChild(p);
                return;
            }
            this.sectionsEl.appendChild(this._section(null, null, achou, 'search'));
            return;
        }

        // 1. Ajuda desta tela — só existe quando há uma tela de origem.
        if (this._from) {
            const ids = R.forRoute(this._from);
            if (ids.length) {
                const sec = this._section(this._t('help.hereTitle'),
                    this._t('help.hereFrom', { game: this._routeName(this._from) }), ids, 'here');
                sec.classList.add('help-section--here');
                this.sectionsEl.appendChild(sec);
            }
        }

        // 2. Primeiros passos
        const first = R.FIRST_STEPS.filter(id => R.get(id));
        if (first.length) {
            this.sectionsEl.appendChild(
                this._section(this._t('help.firstTitle'), this._t('help.firstSub'), first, 'first'));
        }

        // 3. Ajuda por jogo — TODOS os tópicos, agrupados. É o índice completo.
        const head = document.createElement('div');
        head.className = 'help-section-head';
        head.innerHTML = `<h2 class="help-section-title">${this._esc(this._t('help.byGameTitle'))}</h2>`
            + `<p class="help-section-sub">${this._esc(this._t('help.byGameSub'))}</p>`;
        this.sectionsEl.appendChild(head);

        R.GROUP_ORDER.forEach((g) => {
            const ids = R.byGroup(g);
            if (!ids.length) return;
            const card = document.createElement('div');
            card.className = 'help-group';
            card.dataset.helpGroup = g;

            const h = document.createElement('div');
            h.className = 'help-group-head';
            const n = ids.length;
            h.innerHTML =
                `<span class="help-group-ico" aria-hidden="true">${HelpScreen.GROUP_ICON[g] || '❓'}</span>`
                + `<strong class="help-group-name">${this._esc(this._t(HelpScreen.GROUP_LABEL_KEY[g] || g))}</strong>`
                + `<span class="help-group-count">${this._esc(n === 1 ? this._t('help.topicsOne') : this._t('help.topicsN', { n }))}</span>`;
            card.appendChild(h);
            ids.forEach(id => card.appendChild(this._row(id)));
            this.sectionsEl.appendChild(card);
        });

        // 4. Guias interativos — as páginas SATÉLITE, fora do app.
        this.sectionsEl.appendChild(this._guidesSection());
    }

    /**
     * As duas páginas satélite (`HelpRegistry.GUIDES`), no PÉ da Central.
     *
     * 🔴 É o ÚNICO link para fora do app em todo o produto, e é decisão do
     * Bernardo que seja aqui: na tela dos jogos a pessoa está *fazendo*, e link
     * para fora é vazamento. Quem chegou à Central está confusa com um conceito —
     * uma página que explica o conceito ajuda em vez de atrapalhar.
     *
     * 🔴 `target="_blank"`: dentro do PWA instalado (display standalone) navegar
     * para fora de `/app/` sai do escopo e a pessoa fica sem barra de endereço
     * para voltar. Abrir ao lado deixa o app vivo atrás.
     *
     * 🔴 Some da busca de propósito: a busca é sobre os TÓPICOS de ajuda, e uma
     * linha que não abre folha nenhuma no meio dos resultados lê como resultado
     * quebrado. `_renderSections()` só chega aqui no ramo sem busca.
     */
    _guidesSection() {
        const sec = document.createElement('div');
        sec.className = 'help-section help-section--guides';
        sec.dataset.helpSection = 'guides';

        const h = document.createElement('h2');
        h.className = 'help-section-title';
        h.textContent = this._t('help.guidesTitle');
        sec.appendChild(h);

        const p = document.createElement('p');
        p.className = 'help-section-sub';
        p.textContent = this._t('help.guidesSub');
        sec.appendChild(p);

        const prefixo = HelpScreen._langPrefix();
        const lang = (window.language && window.language.currentLanguage) || 'pt';
        window.HelpRegistry.GUIDES.forEach((g) => {
            const slug = window.HelpRegistry.guideSlug(g.key, lang);
            if (!slug) return;
            const rotulo = this._t('pages.' + g.key + '.linkLabel');
            const a = document.createElement('a');
            a.className = 'help-row help-guide-row';
            a.dataset.helpGuide = g.key;
            a.href = `${prefixo}/${slug}/`;
            a.target = '_blank';
            a.rel = 'noopener';
            a.innerHTML =
                `<span class="help-row-ico" aria-hidden="true">${this._esc(g.icon)}</span>`
                + `<span class="help-row-title">${this._esc(rotulo)}</span>`
                + `<span class="help-row-caret" aria-hidden="true">↗</span>`;
            sec.appendChild(a);
        });
        return sec;
    }

    /**
     * Prefixo de idioma do caminho, e ele existe por AMBIENTE, não por gosto.
     * Em produção (e no lab) cada idioma tem o seu DOMÍNIO, e as satélites moram
     * na raiz dele: prefixo vazio. No `ritmo.local`, os 3 idiomas dividem um
     * docroot só e as versões EN/ES estão em `/en/` e `/es/` — sem o prefixo o
     * link cairia no catch-all da SPA, que responde 200 com a landing PT.
     * Mesma armadilha do seletor de idioma no dev (CLAUDE.md, I18N.md).
     */
    static _langPrefix() {
        const L = window.language;
        const lang = (L && L.currentLanguage) || 'pt';
        if (lang === 'pt') return '';   // PT mora na raiz em qualquer ambiente
        const host = (typeof location !== 'undefined' && location.hostname) || '';
        const porHost = (L && L.languageFromHost) ? L.languageFromHost(host) : null;
        return porHost === lang ? '' : '/' + lang;
    }

    _section(title, sub, ids, marca) {
        const sec = document.createElement('div');
        sec.className = 'help-section';
        sec.dataset.helpSection = marca;
        if (title) {
            const h = document.createElement('h2');
            h.className = 'help-section-title';
            h.textContent = title;
            sec.appendChild(h);
        }
        if (sub) {
            const p = document.createElement('p');
            p.className = 'help-section-sub';
            p.textContent = sub;
            sec.appendChild(p);
        }
        ids.forEach(id => sec.appendChild(this._row(id)));
        return sec;
    }

    /** Uma linha de assunto. Botão (não link): abre a folha, não navega. */
    _row(id) {
        const def = window.HelpRegistry.get(id);
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'help-row';
        b.dataset.helpRow = id;
        b.innerHTML =
            `<span class="help-row-ico" aria-hidden="true">${this._esc(def.icon || '❓')}</span>`
            + `<span class="help-row-title">${this._esc(this._t('help.' + def.sourceId + '.title'))}</span>`
            + `<span class="help-row-caret" aria-hidden="true">›</span>`;
        b.addEventListener('click', () => {
            if (window.HelpSheet) window.HelpSheet.open(id);
        });
        return b;
    }

    /** Nome legível da rota de origem ("Intervalos"), via Main.GAMES. */
    _routeName(path) {
        const G = window.main && window.main.constructor.GAMES;
        const def = G && (G[path] || G[String(path).replace(/-livre$/, '')]);
        return def ? this._t('nav.' + def.name) : String(path).replace(/^\//, '');
    }

    /** A Central sai de cena com a folha fechada — o `route:changed` do HelpSheet
     *  já cobre, mas quem abre um overlay é quem tem de garantir que ele morre. */
    destroy() {
        if (window.HelpSheet) window.HelpSheet.close();
        if (super.destroy) super.destroy();
    }

    _esc(s) {
        return String(s).replace(/[&<>"']/g, c => (
            { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    _injectStyle() {
        if (document.getElementById('help-screen-style')) return;
        const s = document.createElement('style');
        s.id = 'help-screen-style';
        s.textContent = `
.help-search{margin:0 0 1.2rem;}
.help-search-input{width:100%;min-height:44px;padding:0.7rem 0.95rem;font:inherit;font-size:1rem;
    border:2px solid #e2e8f0;border-radius:12px;background:#fff;color:#0f172a;}
.help-search-input:focus{outline:none;border-color:#6366f1;}
.help-section{margin-bottom:1.4rem;}
.help-section--here{background:#eef2ff;border:1px solid #c7d2fe;border-radius:14px;padding:0.9rem 0.8rem 0.6rem;}
.help-section-head{margin:1.6rem 0 0.7rem;}
.help-section-title{margin:0 0 0.15rem;font-size:1.08rem;color:#0f172a;}
.help-section-sub{margin:0 0 0.7rem;font-size:0.9rem;color:#64748b;}
.help-group{background:#fff;border:1px solid #eef0f5;border-radius:14px;margin-bottom:0.8rem;
    box-shadow:0 2px 10px rgba(0,0,0,0.05);overflow:hidden;}
.help-group-head{display:flex;align-items:center;gap:0.55rem;padding:0.75rem 0.9rem;
    border-bottom:1px solid #f1f5f9;background:#fbfcfe;}
.help-group-ico{font-size:1.15rem;line-height:1;}
.help-group-name{flex:1;font-size:1rem;color:#0f172a;}
.help-group-count{font-size:0.78rem;color:#94a3b8;}
.help-row{display:flex;align-items:center;gap:0.6rem;width:100%;min-height:52px;
    padding:0.6rem 0.9rem;border:none;border-top:1px solid #f6f8fb;background:none;cursor:pointer;
    font:inherit;font-size:0.98rem;color:#0f172a;text-align:left;}
.help-section .help-row,.help-section--here .help-row{background:#fff;border:1px solid #e2e8f0;
    border-radius:12px;margin-bottom:0.45rem;}
.help-group .help-row:first-of-type{border-top:none;}
.help-row:hover{background:#f8faff;}
.help-row-ico{flex:0 0 auto;font-size:1.1rem;line-height:1;}
.help-row-title{flex:1;}
.help-row-caret{color:#c7d2fe;font-size:1.2rem;line-height:1;}
.help-empty{text-align:center;color:#94a3b8;padding:2rem 0.5rem;line-height:1.5;}
/* Guias interativos (páginas satélite): mesma linha, mas é <a> — âncora herda
   sublinhado e a cor de link do documento, e sem isto a lista fica com duas
   aparências. A seta ↗ (em vez do › das linhas que abrem folha) é o aviso de que
   este item sai do app. */
.help-section--guides{margin-top:1.7rem;}
.help-guide-row{text-decoration:none;}
.help-guide-row:hover{background:#f8faff;}
.help-guide-row .help-row-caret{color:#94a3b8;font-size:1rem;}`;
        document.head.appendChild(s);
    }
}

window.HelpScreen = HelpScreen;



// ============================================
// screens/NewsScreen.js
// ============================================
/**
 * NewsScreen - Tela de Novidades / What's New / Novedades.
 *
 * Espelha a ChangelogScreen do projeto principal: lê o `changelog.json` (MESMO
 * formato — `entries[]` com `title`/`description` em {pt,en,es}) e lista as
 * novidades, mais recentes primeiro. NÃO é um jogo: estende BaseScreen (o
 * template load → render das telas não-jogo). Entra no ☰ e no Router por UMA
 * linha em `Main.MENU` — fora de `Main.GAMES` (não vira ladrilho de jogo).
 *
 * Fase 1 (simples): cabeçalho + lista de cards, trilíngue, sem filtros/paginação.
 * O badge "•novo" no header e o JSON-LD (SEO) ficam para fases seguintes.
 *
 * 🔴 CHAMADA PARA AÇÃO (campo `link`, opcional, por entrada do changelog.json):
 *
 *     "link": { "route": "#/musicas", "label": { "pt": …, "en": …, "es": … } }
 *
 * Anunciar uma novidade sem dar como chegar nela é a metade do trabalho — foi o
 * que aconteceu com o jogo de música real (rota avulsa `#/musicas`, sem aba e sem
 * card, então a Novidades era a única superfície que falava dele e nem ela
 * linkava). O campo é GENÉRICO: toda entrada futura ganha o botão de graça.
 * `label` é opcional (cai em `news.cta`). 🔴 Só ROTA INTERNA (`#/…`): o JSON é
 * buscado por fetch e vira href, então um `javascript:` ali seria XSS — a rota é
 * validada contra `ROUTE_RE` e a entrada é ignorada (card sem botão) se não bater.
 */
class NewsScreen extends BaseScreen {
    static TITLE_KEY = 'news.title';
    // idioma do app → locale do Intl (formatação de data).
    static LOCALE = { pt: 'pt-BR', en: 'en-US', es: 'es-ES' };

    // Rota interna do SPA e nada mais — sem esquema, sem host, sem caminho absoluto.
    static ROUTE_RE = /^#\/[A-Za-z0-9\-\/_]*$/;

    /**
     * Busca o changelog. Falha de rede NÃO lança: vira `_entries = null` e a lista
     * mostra `news.error` — a tela inteira continua de pé (só a lista avisa).
     */
    async load() {
        this._entries = null;
        try {
            // no-cache: novidades novas aparecem assim que online (igual ao principal).
            const res = await fetch('/changelog.json', { cache: 'no-cache' });
            if (!res.ok) throw new Error('HTTP ' + res.status);
            const data = await res.json();
            this._entries = Array.isArray(data.entries) ? data.entries : [];
        } catch (e) {
            console.warn('NewsScreen: falha ao carregar changelog.json', e);
        }
    }

    /** Enquanto o changelog não chega: h1 + subtítulo já no lugar (era assim antes do BaseScreen). */
    renderLoading() {
        this._renderShell();
    }

    render() {
        // O shell já foi pintado pelo renderLoading; só recria se sumiu (idempotente, mesmos ids).
        if (!this.listEl || !this.listEl.isConnected) this._renderShell();
        this._renderList();
    }

    _renderShell() {
        const mobile = (window.innerWidth || 1024) < 560;
        const center = `
            <div class="news-screen" style="max-width:680px;margin:0 auto;padding:${mobile ? '1rem' : '2rem 1.5rem'};">
                <h1 style="text-align:center;margin-bottom:0.25rem;">${this._t('news.title')}</h1>
                <p id="news-updated" style="text-align:center;color:#6366f1;font-weight:600;margin:0.2rem 0 1.2rem;"></p>
                <div id="news-list"></div>
            </div>`;
        // 🌿 Vitrine em tela larga (PromoRail, 15/set): a placement `news` é a ÚNICA ligada
        //    por enquanto. Desligada/oculta, o wrap devolve o centro intocado — a tela não
        //    sabe que a rail existe. O shell é pintado no renderLoading e reaproveitado pelo
        //    render (mesmos ids), então a rail nasce UMA vez por abertura da tela.
        this.container.innerHTML = (window.PromoRail && typeof window.PromoRail.wrap === 'function')
            ? window.PromoRail.wrap(center, 'news') : center;
        this.listEl = this.container.querySelector('#news-list');
        this.updatedEl = this.container.querySelector('#news-updated');
    }

    _renderList() {
        let entries = this._entries;
        if (entries === null) {
            this.listEl.innerHTML = this._stateMsg(this._t('news.error'));
            return;
        }
        if (!entries.length) {
            this.listEl.innerHTML = this._stateMsg(this._t('news.empty'));
            return;
        }
        // mais recente primeiro (o JSON já vem assim; reforça por data ISO).
        entries = entries.slice().sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')));
        this.updatedEl.textContent = this._t('news.updated', { date: this._formatDate(entries[0].date) });
        this.listEl.innerHTML = entries.map(e => this._card(e)).join('');

        // Marca tudo como visto (data da mais recente) e avisa o header p/ apagar o "•novo".
        const newest = entries[0].date;
        if (newest) {
            localStorage.setItem('news_last_seen', newest);
            window.eventBus?.emit('news:seen');
        }
    }

    _card(entry) {
        const lang = window.language?.currentLanguage || 'pt';
        const pick = (o) => (o && (o[lang] || o.en || Object.values(o)[0])) || '';
        const title = this._escape(pick(entry.title));
        const desc = this._escape(pick(entry.description));
        const icon = this._escape(entry.icon || '🎵');
        const improvement = entry.category === 'improvement';
        const tagText = this._t(improvement ? 'news.tagImprovement' : 'news.tagFeature');
        const tagBg = improvement ? '#dbeafe' : '#dcfce7';
        const tagColor = improvement ? '#1d4ed8' : '#15803d';
        const date = this._escape(this._formatDate(entry.date));
        return `
            <div class="news-card" style="background:#fff;border:1px solid #eef0f5;border-radius:14px;padding:1rem 1.1rem;margin-bottom:0.9rem;box-shadow:0 2px 10px rgba(0,0,0,0.05);">
                <div style="display:flex;align-items:center;gap:0.6rem;margin-bottom:0.4rem;">
                    <span style="font-size:1.5rem;line-height:1;" aria-hidden="true">${icon}</span>
                    <strong style="font-size:1.05rem;flex:1;">${title}</strong>
                </div>
                <p style="margin:0 0 0.7rem;color:#475569;line-height:1.45;">${desc}</p>
                ${this._cta(entry, pick)}
                <div style="display:flex;align-items:center;justify-content:space-between;gap:0.5rem;">
                    <span style="font-size:0.72rem;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;padding:0.18rem 0.55rem;border-radius:999px;background:${tagBg};color:${tagColor};">${tagText}</span>
                    <span style="font-size:0.82rem;color:#94a3b8;">${date}</span>
                </div>
            </div>`;
    }

    /**
     * Botão "ir para a novidade" — só sai se a entrada trouxer `link.route` VÁLIDA
     * (rota interna do SPA). Rota estranha ⇒ string vazia: o card perde o botão,
     * nunca a tela. `pick` é o seletor de idioma do card (mesmo fallback).
     */
    _cta(entry, pick) {
        const route = entry.link?.route;
        if (typeof route !== 'string' || !NewsScreen.ROUTE_RE.test(route)) return '';
        const label = this._escape(pick(entry.link.label) || this._t('news.cta'));
        return `<p style="margin:0 0 0.85rem;">
                    <a class="news-cta" href="${this._escape(route)}">${label}</a>
                </p>`;
    }

    _stateMsg(text) {
        return `<p style="text-align:center;color:#94a3b8;padding:2rem 0;">${this._escape(text)}</p>`;
    }

    /** Data ISO (YYYY-MM-DD) → texto localizado ("23 de junho de 2026" etc.). */
    _formatDate(iso) {
        if (!iso) return '';
        const lang = window.language?.currentLanguage || 'pt';
        const d = new Date(iso + 'T00:00:00');
        if (isNaN(d.getTime())) return iso;
        try {
            return new Intl.DateTimeFormat(NewsScreen.LOCALE[lang] || 'pt-BR',
                { day: 'numeric', month: 'long', year: 'numeric' }).format(d);
        } catch (_) { return iso; }
    }

    _escape(s) {
        return String(s).replace(/[&<>"']/g, c => (
            { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }
}

// Disponibiliza globalmente
window.NewsScreen = NewsScreen;



// ============================================
// components/RankPager.js
// ============================================
/**
 * RankPager — a paginação NUMERADA dos rankings (18/set), no modelo do projeto principal:
 *   ‹ 1 … 4 [5] 6 … 12 ›   (pulo direto + reticências, estilo Google)
 * Usado pela RankingScreen (#/ranking) e pelo GroupRanking (página do grupo): UMA régua de
 * desenho e de alvo para os dois. Puro: devolve HTML; quem hospeda liga o clique por
 * delegação em `[data-page]` e troca a PÁGINA inteira (não há junção de páginas — a classe
 * de defeitos do "Ver mais", duplicata e foco numa lista que cresce, não existe aqui).
 */
class RankPager {
    /** Páginas a mostrar: 1, as vizinhas da atual e a última; `null` = reticências. */
    static pages(current, total) {
        if (total <= 1) return [];
        const set = new Set([1, total, current - 1, current, current + 1].filter(n => n >= 1 && n <= total));
        const nums = [...set].sort((a, b) => a - b);
        const out = [];
        nums.forEach((n, i) => {
            if (i > 0 && n - nums[i - 1] > 1) out.push(n - nums[i - 1] === 2 ? n - 1 : null);
            out.push(n);
        });
        return out;
    }

    /**
     * @param {number} current  página atual (1-based)
     * @param {number} total    total de páginas
     * @param {(k:string, v?:object)=>string} t  tradutor
     * @param {(s:string)=>string} esc
     * @param {string} cls      prefixo de classe do anfitrião ('rk' | 'gr')
     */
    static html(current, total, t, esc, cls = 'rk') {
        if (total <= 1) return '';
        // `near` = vizinha da atual: some em tela estreitíssima (ver css()), onde ela não cabe.
        const btn = (label, page, { cur = false, disabled = false, near = false, aria = '' } = {}) =>
            `<button type="button" class="${cls}-page${cur ? ' is-cur' : ''}${near ? ` ${cls}-page--near` : ''}"`
            + (page != null && !disabled && !cur ? ` data-page="${page}"` : '')
            + (cur ? ' aria-current="page"' : '')
            + (disabled ? ' disabled' : '')
            + (aria ? ` aria-label="${esc(aria)}"` : '')
            + `>${esc(String(label))}</button>`;
        const parts = [btn('‹', current - 1, { disabled: current <= 1, aria: t('ranking.prev') })];
        RankPager.pages(current, total).forEach(n => {
            parts.push(n == null
                ? `<span class="${cls}-ellipsis" aria-hidden="true">…</span>`
                : btn(n, n, { cur: n === current, near: Math.abs(n - current) === 1, aria: t('ranking.pageN', { n }) }));
        });
        parts.push(btn('›', current + 1, { disabled: current >= total, aria: t('ranking.next') }));
        return `<nav class="${cls}-pager" aria-label="${esc(t('ranking.pageNav'))}">${parts.join('')}</nav>`;
    }

    /** CSS do paginador (o anfitrião injeta junto com o seu). Alvos de 44 px; quebra linha no celular. */
    static css(cls = 'rk') {
        return `
        .${cls}-pager{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:.3rem;margin:.9rem 0 0;}
        .${cls}-page{min-width:44px;min-height:44px;padding:0 .5rem;border-radius:10px;border:1.5px solid #e2e8f0;background:#fff;
            color:#374151;font-weight:600;font-size:.95rem;cursor:pointer;font-family:inherit;}
        .${cls}-page.is-cur{background:#eef2ff;border-color:#6366f1;color:#3730a3;cursor:default;}
        .${cls}-page[disabled]{opacity:.35;cursor:default;}
        .${cls}-ellipsis{min-width:1.2rem;text-align:center;color:#9ca3af;}
        /* Celular: 7 números + 2 setas + 2 reticências não cabem em 390 px e o paginador virava DUAS
           linhas (medido em 18/set). O alvo de 44 px NÃO cede — cede o espaço entre eles e, abaixo de
           400, as vizinhas da atual (o ‹ › continua andando de uma em uma). */
        @media (max-width:480px){
            .${cls}-pager{gap:.2rem;}
            .${cls}-page{padding:0 .3rem;}
            .${cls}-ellipsis{min-width:.9rem;}
        }
        /* 379 px e abaixo (as vizinhas não cabem nem com o espaço apertado — medido). */
        @media (max-width:379px){ .${cls}-page--near{display:none;} }`;
    }
}

window.RankPager = RankPager;



// ============================================
// screens/RankingScreen.js
// ============================================
/**
 * RankingScreen — Ranking / Leaderboard (Fase 5). Tela auxiliar (NÃO é jogo): estende
 * BaseScreen (o template load → render das telas não-jogo). Entra no ☰ e no Router por
 * UMA linha em `Main.MENU` — fora de Main.GAMES (não vira ladrilho de jogo).
 *
 * Espelha a RankingScreen do capsula, mas SEM a camada social (seguir/comentar/avatar
 * upload). Consome o `leaderboard` via RankingRepository (público — convidado vê, mas só
 * entra ao logar). Duas visões:
 *   - GERAL ('overall'): nível alcançado↓, depois precisão média↓ (dos níveis vencidos).
 *   - POR NÍVEL ('level'): precisão↓ de um nível específico.
 *
 * MULTI-JOGO: UMA tela pros N jogos ranqueados, com seletor de jogo. 🔴 A lista de jogos,
 * os níveis de cada um, o nome (i18n) e a rota do CTA vêm TODOS do registro do
 * LevelProgress — jogo novo aparece aqui só por se registrar, e a trilha de cada um
 * cresce de 6 a 100 níveis sem tocar nesta tela. NUNCA hardcodar jogo nem nº de níveis.
 * A métrica de ordenação é a MESMA pra todo jogo (é o `leaderboard` do backend que
 * ordena) — mudar isso por jogo seria mexer no PHP, não aqui.
 *
 * Trilíngue (todas as strings via _t) e responsivo (tabela em wrapper com scroll próprio;
 * colunas acessórias somem no mobile). Ver docs/RANKING-PLANO.md.
 */
class RankingScreen extends BaseScreen {
    static TITLE_KEY = 'ranking.title';
    // Linhas por PÁGINA (o `limit` pedido ao servidor). 20, como o projeto principal (18/set):
    // 50 eram uma rolagem enorme no celular, e a linha "você" fixa + "Ir para a minha página"
    // já levam cada um ao próprio lugar. A nota "cadê eu?" usa isto para saber se a página veio CHEIA.
    static LIMIT = 20;

    // Último jogo visto. Preferência de DEVICE (como rf_input_mode), não progresso:
    // fica fora do StorageScope de propósito — não é dado de dono, é onde a tela abre.
    static GAME_KEY = 'ranking_game_v1';

    constructor() {
        super();
        this.gameId = this._initialGame();
        this.scope = 'overall';        // 'overall' | 'level'
        this.who = 'all';              // 'all' | 'group' — o 2º eixo: todo mundo × o meu grupo
        this.level = null;             // nível selecionado no modo 'level'
        this._onUserChange = null;
        this._reqId = 0;               // token de sequência: só a resposta mais recente pinta
    }

    /** Jogos ranqueados, na ordem de registro. Vazio só se o bundle não carregou. */
    _games() {
        return (window.LevelProgress && window.LevelProgress.all()) || [];
    }

    /** Ficha do jogo selecionado (níveis, nome, rota). null se o registro sumiu. */
    _prog() {
        return (window.LevelProgress && window.LevelProgress.get(this.gameId)) || null;
    }

    _gameName(prog) {
        return prog ? this._t(prog.nameKey) : this.gameId;
    }

    /**
     * O grupo (escola/turma) que a conta pode ver, ou null — vem do payload do user:
     * o grupo em que ela ESTÁ (`getGroup`) ou, não estando em nenhum, o grupo que ela
     * ORGANIZA e está liberado (`getOwnedGroup().live`; autonomia, 15/set). O dono vê o
     * ranking da turma sem aparecer nela — o servidor já permitia (hoje o ranking do grupo é público),
     * faltava a tela saber. `owner: true` marca o 2º caso (nota em vez de "cadê eu?").
     */
    _group() {
        const um = window.userManager;
        if (!(um && um.isLoggedIn())) return null;
        const mine = um.getGroup ? um.getGroup() : null;
        if (mine) return mine;
        const owned = um.getOwnedGroup ? um.getOwnedGroup() : null;
        return (owned && owned.live) ? { id: owned.id, name: owned.name, owner: true } : null;
    }

    /**
     * Em qual jogo a tela abre. Ordem: escolha explícita anterior → jogo em que a pessoa
     * JOGOU por último → primeiro registrado.
     *
     * 🔴 O 2º critério existe por causa do 1º cadastro orgânico (27/jul): a pessoa
     * chegou pela Leitura, criou conta no portão e, ao abrir o ranking, cairia no Ritmo
     * — uma lista onde ela não está, do jogo que ela não jogou. O sinal já existia de
     * graça: cada take grava `at` no LevelProgress, inclusive de convidado.
     */
    _initialGame() {
        const games = this._games();
        if (!games.length) return 'ritmo';

        let saved = null;
        try { saved = window.localStorage && window.localStorage.getItem(RankingScreen.GAME_KEY); } catch (e) { /* sem storage */ }
        if (saved && games.some(g => g.gameId === saved)) return saved;

        let best = null, bestAt = -1;
        games.forEach(g => {
            const bests = g.getBests();
            Object.keys(bests).forEach(k => {
                const at = bests[k] && bests[k].at;
                if (Number.isFinite(at) && at > bestAt) { bestAt = at; best = g.gameId; }
            });
        });
        return best || games[0].gameId;
    }

    /**
     * @param {Object} params query da rota — `#/ranking?game=leitura` abre direto no jogo
     *   (permite um link "ver ranking" no fim de nível de cada jogo, sem tela nova).
     * Não busca rede aqui (ver render): só resolve jogo e nível a partir dos params.
     */
    async load(params = {}) {
        if (params && params.game && this._games().some(g => g.gameId === params.game)) {
            this.gameId = params.game;
        }
        // `#/ranking?who=group` abre direto no meu grupo (link direto; a porta do #/perfil hoje é a página do grupo).
        // Sem grupo o parâmetro é ignorado: a lista de "todos" é a única que existe.
        if (params && params.who === 'group' && this._group()) this.who = 'group';
        // Nível default = onde o jogador ESTÁ na trilha DAQUELE jogo (não o nº 1, que ele
        // já deixou pra trás). Fonte única = a ficha do jogo; nunca hardcodar.
        if (this.level == null) this.level = this._prog() ? this._prog().currentLevel() : null;

        // Ao logar/deslogar (inclusive retomada pós-OAuth): tira o convite de login e
        // recarrega p/ destacar "você". Assinado AQUI (uma vez por instância), nunca no
        // render(): um 2º render duplicaria o ouvinte e perderia a referência do 1º.
        if (!this._onUserChange) {
            this._onUserChange = () => {
                // Deslogou (ou saiu do grupo noutra tela): "Meu grupo" deixa de existir.
                if (!this._group()) this.who = 'all';
                this._syncWhoBar(); this._syncLoginBar(); this._load();
            };
            document.addEventListener('userStateChanged', this._onUserChange);
        }
        // 🔴 NÃO há ouvinte de `userPrefChanged` aqui, e isso é conclusão de auditoria, não
        //    esquecimento: o interruptor "Aparecer no ranking" só existe em `#/perfil`, e o
        //    Router destrói aquela tela antes de montar esta — o caminho "desligar com o
        //    ranking aberto" é INALCANÇÁVEL. Um ouvinte para ele seria código morto com um
        //    teste que o exercita à mão (o projeto já pagou por isso no `requireRole`).
        //    Quem garante que a lista chega certa depois de desligar é o `no-store` do
        //    `leaderboard` (handler.php): era o cache de 30 s do navegador — e não a falta
        //    de ouvinte — que fazia a pessoa continuar se vendo na lista de onde saiu.
        //    Se um dia o interruptor aparecer na gaveta ☰ (que abre por cima desta rota),
        //    o ouvinte volta JUNTO com ele.
    }

    /** Título da aba acompanha o jogo selecionado ("Ranking · Ritmo"). É a TELA que manda
     *  no título (o afterEach do Main cede quando getTitle() devolve algo). */
    getTitle() {
        const name = this._gameName(this._prog());
        const g = this.who === 'group' ? this._group() : null;
        return this._t('ranking.title') + (name ? ' · ' + name : '') + (g ? ' · ' + g.name : '');
    }

    render() {
        this._syncTitle();   // o jogo pode ter mudado desde o init
        this._renderShell();
        this._bind();

        // 🔴 SEM await: o Router só registra `currentScreen` DEPOIS que o handler resolve.
        // Esperar a rede aqui faria uma navegação durante o fetch sobrescrever o screen
        // ativo por esta tela já morta — o listener acima nunca seria removido (vazamento)
        // e o jogo seguinte não receberia destroy(). O shell já mostra "Carregando…".
        this._load();
    }

    /** O convite de login some assim que a pessoa loga (inclusive pelo botão daqui). */
    _syncLoginBar() {
        if (!this.container) return;
        if (window.userManager && window.userManager.isLoggedIn()) {
            this.container.querySelector('.rk-loginbar')?.remove();
        }
    }

    _renderShell() {
        const loggedIn = !!(window.userManager && window.userManager.isLoggedIn());
        this.container.innerHTML = `
            <div class="rk-screen">
                <style>${RankingScreen._css()}</style>
                <header class="rk-head">
                    <h1 class="rk-title">${this._esc(this._t('ranking.title'))}</h1>
                    <p class="rk-sub">${this._esc(this._t('ranking.subtitle'))}</p>
                </header>

                ${this._gameBar()}
                ${this._whoBar()}

                <div class="rk-tabs" role="group" aria-label="${this._esc(this._t('ranking.scopeLabel'))}">
                    <button type="button" class="rk-tab" data-scope="overall">${this._esc(this._t('ranking.tabOverall'))}</button>
                    <button type="button" class="rk-tab" data-scope="level">${this._esc(this._t('ranking.tabLevel'))}</button>
                </div>

                <div class="rk-levelbar" id="rk-levelbar" hidden>
                    <label for="rk-level" class="rk-levellabel">${this._esc(this._t('ranking.levelLabel'))}</label>
                    <select id="rk-level" class="rk-select">${this._levelOptions()}</select>
                </div>

                ${loggedIn ? '' : `
                <div class="rk-loginbar">
                    <span>${this._esc(this._t('ranking.loginPrompt'))}</span>
                    <button type="button" class="rk-loginbtn" id="rk-login">${this._esc(this._t('ranking.loginCta'))}</button>
                </div>`}

                <div class="rk-body" id="rk-body" aria-live="polite"></div>
            </div>`;
        this.bodyEl = this.container.querySelector('#rk-body');
        this.levelBar = this.container.querySelector('#rk-levelbar');
        this._syncTabs();
        this._syncWhoBar();
    }

    /**
     * "Todos × Meu grupo" — o 2º eixo, e só quando a conta ESTÁ num grupo (para os outros
     * o seletor não existe: um botão de "meu grupo" para quem não tem grupo é convite para
     * uma tela vazia). O rótulo é o NOME do grupo. Sempre no DOM (escondido) para a troca
     * de conta com a tela aberta não precisar remontar o shell.
     */
    _whoBar() {
        return `<div class="rk-whobar" id="rk-whobar" role="group" aria-label="${this._esc(this._t('ranking.whoLabel'))}" hidden>
                    <button type="button" class="rk-who" data-who="all">${this._esc(this._t('ranking.whoAll'))}</button>
                    <button type="button" class="rk-who" data-who="group" id="rk-who-group"></button>
                </div>`;
    }

    _syncWhoBar() {
        const bar = this.container && this.container.querySelector('#rk-whobar');
        if (!bar) return;
        const g = this._group();
        bar.hidden = !g;
        const lbl = bar.querySelector('#rk-who-group');
        if (lbl) lbl.textContent = g ? g.name : '';
        bar.querySelectorAll('.rk-who').forEach(btn => {
            const on = btn.dataset.who === this.who;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-pressed', String(on));
        });
    }

    /**
     * Seletor de jogo. Some com 1 jogo só (um <select> de uma opção é ruído) e volta
     * sozinho quando o 2º se registrar — a tela nunca precisa saber quantos existem.
     */
    _gameBar() {
        const games = this._games();
        if (games.length < 2) return '';
        const opts = games.map(g =>
            `<option value="${this._esc(g.gameId)}"${g.gameId === this.gameId ? ' selected' : ''}>${this._esc(this._gameName(g))}</option>`
        ).join('');
        return `<div class="rk-gamebar">
                    <label for="rk-game" class="rk-levellabel">${this._esc(this._t('ranking.gameLabel'))}</label>
                    <select id="rk-game" class="rk-select rk-gameselect">${opts}</select>
                </div>`;
    }

    _levelOptions() {
        const levels = this._prog() ? this._prog().levels() : [];
        return levels.map(n =>
            `<option value="${n}"${n === this.level ? ' selected' : ''}>${this._esc(this._t('ranking.levelOption', { n }))}</option>`
        ).join('');
    }

    /** Um caminho só para o título: getTitle() → BaseScreen._syncDocumentTitle(). */
    _syncTitle() { this._syncDocumentTitle(); }

    /**
     * Troca de jogo: o nível selecionado é DAQUELE jogo (trilhas de tamanhos diferentes),
     * então nunca é reaproveitado — volta pro "você está aqui" do jogo novo.
     */
    _setGame(gameId) {
        if (gameId === this.gameId || !this._games().some(g => g.gameId === gameId)) return;
        this.gameId = gameId;
        try { window.localStorage && window.localStorage.setItem(RankingScreen.GAME_KEY, gameId); } catch (e) { /* sem storage: só não lembra */ }
        this.level = this._prog() ? this._prog().currentLevel() : null;
        const sel = this.container.querySelector('#rk-level');
        if (sel) sel.innerHTML = this._levelOptions();
        this._syncTitle();
        this._load();
    }

    _bind() {
        const game = this.container.querySelector('#rk-game');
        if (game) game.addEventListener('change', (e) => this._setGame(e.target.value));

        this.container.querySelectorAll('.rk-who').forEach(btn => {
            btn.addEventListener('click', () => {
                const who = btn.dataset.who === 'group' && this._group() ? 'group' : 'all';
                if (who === this.who) return;
                this.who = who;
                this._syncWhoBar();
                this._syncTitle();
                this._load();
            });
        });
        this.container.querySelectorAll('.rk-tab').forEach(btn => {
            btn.addEventListener('click', () => {
                const scope = btn.dataset.scope === 'level' ? 'level' : 'overall';
                if (scope === this.scope) return;
                this.scope = scope;
                this._syncTabs();
                this._load();
            });
        });
        const sel = this.container.querySelector('#rk-level');
        if (sel) sel.addEventListener('change', (e) => {
            const v = parseInt(e.target.value, 10);
            if (!Number.isNaN(v)) { this.level = v; this._load(); }
        });
        const login = this.container.querySelector('#rk-login');
        if (login) login.addEventListener('click', () => window.authModal && window.authModal.open('signin'));
    }

    _syncTabs() {
        // aria-pressed (não role=tab/aria-selected): não há tabpanel de verdade — a tabela
        // é recarregada. Padrão ARIA pela metade confunde mais o leitor de tela que ajuda.
        this.container.querySelectorAll('.rk-tab').forEach(btn => {
            const on = btn.dataset.scope === this.scope;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-pressed', String(on));
        });
        if (this.levelBar) this.levelBar.hidden = this.scope !== 'level';
    }

    /** Estado do corpo: loading | ready | empty | error (marcador p/ CSS e testes). */
    _setBody(state, html) {
        this.bodyEl.dataset.state = state;
        this.bodyEl.innerHTML = html;
    }

    /**
     * Carrega UMA página (1-based). Trocar de jogo/aba/nível/grupo volta à 1ª (todo `_load()` sem
     * argumento); o paginador pede `{ page: n }`. Troca de PÁGINA mantém a tabela atual na tela
     * até a nova chegar (sem piscar "carregando" nem pular a rolagem) — `aria-busy` diz que está vindo.
     * 🔴 `troca` é EXPLÍCITO (só o paginador o passa): deduzir de "estava na página 2" tratava a troca
     *    de jogo/aba/nível como troca de página e roubava o foco do `<select>` (auditoria 18/set).
     * `foco: 'me'` = veio do "Ir para a minha página": o foco vai à linha "você", não ao topo.
     */
    async _load({ page = 1, troca = false, foco = '' } = {}) {
        if (!this.bodyEl) return;
        const temTabela = !!this.bodyEl.querySelector('.rk-table');
        troca = !!troca && temTabela;
        this._page = null;
        if (troca && temTabela) this.bodyEl.setAttribute('aria-busy', 'true');
        else this._setBody('loading', this._state(this._t('ranking.loading')));
        if (!window.rankingRepository) { this._setBody('error', this._state(this._t('ranking.error'))); return; }

        // Token de sequência: cobre troca de aba/nível E dois pedidos IGUAIS em voo (ex.:
        // login durante o fetch inicial) — só a resposta mais recente pinta a tela.
        const id = ++this._reqId;
        const reqScope = this.scope;
        const reqWho = this.who;
        const args = { gameId: this.gameId, scope: reqScope, level: this.level, limit: RankingScreen.LIMIT,
                       offset: (Math.max(1, page) - 1) * RankingScreen.LIMIT };
        // O id do grupo vai SEMPRE que há grupo: para o membro é o mesmo que o servidor
        // deduziria; para o DONO (não-membro) é a única forma de pedir (`group_id`).
        const gsel = reqWho === 'group' ? this._group() : null;
        if (gsel) args.groupId = gsel.id;
        const res = reqWho === 'group' && window.rankingRepository.groupLeaderboard
            ? await window.rankingRepository.groupLeaderboard(args)
            : await window.rankingRepository.leaderboard(args);
        if (id !== this._reqId) return;
        this.bodyEl.removeAttribute('aria-busy');

        // A conta saiu do grupo noutro aparelho: o servidor diz `no_group`; volta a "Todos"
        // em vez de mostrar erro (e tira o botão, porque o payload local ainda o tinha).
        if (!res.success && res.code === 'no_group' && reqWho === 'group') {
            this.who = 'all';
            // Membro: o payload local ainda tinha o grupo → apaga. Dono: o grupo foi pausado/
            // desativado → o `owns_group` local deixa de valer como "live".
            try {
                if (gsel && gsel.owner) window.userManager?._applyOwnedGroup?.(Object.assign({}, window.userManager.getOwnedGroup() || {}, { live: false, is_active: 0 }));
                else window.userManager?._applyGroup?.(null);
            } catch (e) {}
            this._syncWhoBar();
            this._load();
            return;
        }
        if (!res.success) { this._setBody('error', this._state(this._t('ranking.error'))); return; }
        // 🔴 A nota de ESCONDIDO tem precedência sobre o "cadê eu?": quando a razão da
        //    ausência é conhecida, não se oferece um palpite ("talvez você não tenha jogado
        //    logado"). As duas juntas seriam duas explicações para o mesmo buraco.
        // Dono não-membro: ele não está na lista porque não é dela — a nota diz isso, em vez
        // do "cadê eu?" (que sugeriria jogar logado para entrar num ranking que não é o dele).
        // O DONO vem antes do `meHidden` (auditoria M5): `me_hidden` é a preferência de quem
        // pede, e o dono não está na lista por não ser membro — dizer "você pediu para sair"
        // seria falso.
        const nota = (gsel && gsel.owner) ? `<p class="rk-note rk-note--owner">${this._esc(this._t('ranking.ownerNote'))}</p>`
            : res.meHidden ? this._hiddenNote()
            : this._selfNote(res.rows, reqScope, res.me || res.meRank);
        // Página que ESVAZIOU entre dois cliques (alguém se escondeu ou saiu): vai à última que
        // existe — "ninguém no ranking ainda" seria falso e sem paginador não haveria como voltar.
        const ultima = Math.max(1, Math.ceil((res.total || 0) / RankingScreen.LIMIT));
        if (!res.rows.length && page > 1 && res.total > 0 && ultima < page) return this._load({ page: ultima, troca, foco });
        if (!res.rows.length) { this._setBody('empty', this._empty(reqWho === 'group' ? res.group : null) + nota); return; }
        this._page = { n: Math.max(1, page), rows: res.rows, total: res.total, me: res.me, meRank: res.meRank,
                       scope: reqScope, nota };
        this._paintPage(troca, foco);
    }

    /** Número de páginas da lista atual. */
    _pages() { return this._page ? Math.max(1, Math.ceil((this._page.total || 0) / RankingScreen.LIMIT)) : 1; }

    /**
     * Desenha a página: a tabela, a linha "você" fixa (se ela está em OUTRA página), a contagem
     * "51–100 de 129", o paginador e o "Ir para a minha página".
     * `troca` = mudou de página: o `aria-live` do corpo fica mudo (senão o leitor de tela leria as
     * 50 linhas), a tela sobe até o começo da tabela e o foco vai para ela — o rótulo da região diz
     * a página ("Ranking · Ritmo · página 2 de 3").
     */
    _paintPage(troca = false, foco = '') {
        const p = this._page;
        if (!p) return;
        const live = this.bodyEl.getAttribute('aria-live');
        if (troca && live) this.bodyEl.setAttribute('aria-live', 'off');
        const me = (p.me && !p.rows.some(r => r.is_me)) ? p.me : null;
        const pages = this._pages();
        const de = (p.n - 1) * RankingScreen.LIMIT + 1, ate = de + p.rows.length - 1;
        const conta = pages > 1
            ? `<p class="rk-count">${this._esc(this._t('ranking.showing', { from: de, to: ate, total: p.total }))}</p>` : '';
        const minha = (me && p.meRank) ? Math.ceil(p.meRank / RankingScreen.LIMIT) : null;
        const irMinha = (minha && minha !== p.n)
            ? `<div class="rk-minewrap"><button type="button" class="rk-mine" data-page="${minha}">${this._esc(this._t('ranking.goToMine'))}</button></div>` : '';
        const pager = window.RankPager ? window.RankPager.html(p.n, pages, (k, v) => this._t(k, v), (x) => this._esc(x), 'rk') : '';
        this._setBody('ready', this._table(p.rows, p.scope, me) + irMinha + conta + pager + p.nota);
        // `pages` da página DESENHADA: com outra em voo `this._page` é null, e ler `_pages()` na
        // hora do clique engolia o 2º clique em silêncio (o token de pedido já cuida da ordem).
        this.bodyEl.querySelectorAll('[data-page]').forEach(b => b.addEventListener('click', () => {
            const n = parseInt(b.dataset.page, 10);
            if (Number.isFinite(n) && n >= 1 && n <= pages && n !== p.n) {
                this._load({ page: n, troca: true, foco: b.classList.contains('rk-mine') ? 'me' : '' });
            }
        }));
        if (troca) {
            const wrap = this.bodyEl.querySelector('.rk-tablewrap');
            const meRow = foco === 'me' ? this.bodyEl.querySelector('tr.rk-me') : null;
            if (meRow) { meRow.setAttribute('tabindex', '-1'); meRow.focus(); }
            else if (wrap) {
                const top = wrap.getBoundingClientRect().top;
                if (top < 0 && typeof window.scrollBy === 'function') window.scrollBy(0, top - 12);
                wrap.focus({ preventScroll: true });
            }
            if (live) setTimeout(() => { if (this.bodyEl) this.bodyEl.setAttribute('aria-live', live); }, 0);
        }
    }

    /**
     * "Cadê eu?" — logado e ausente da lista POR NÍVEL não é bug: o servidor só conhece
     * partidas jogadas com a conta conectada (e a lista é cortada no topo). Sem esta
     * nota, aparecer no Geral e sumir no nível 1 parece contradição — foi exatamente a
     * leitura do primeiro teste real. Só no escopo 'level': no Geral, uma linha basta
     * pra aparecer, então a ausência ali já significa "não jogou logado".
     */
    /**
     * "Você não está aqui, e é porque VOCÊ pediu." Sai só para quem desligou (o servidor
     * responde `me_hidden` para a própria sessão) e leva o caminho de volta — um
     * interruptor de privacidade sem o caminho de volta é uma armadilha educada.
     */
    _hiddenNote() {
        return `<p class="rk-note rk-note--hidden">${this._esc(this._t('ranking.youAreHidden'))}`
            + ` <a href="#/perfil" class="rk-notelink">${this._esc(this._t('ranking.youAreHiddenCta'))}</a></p>`;
    }

    _selfNote(rows, scope, me = null) {
        if (scope !== 'level') return '';
        if (!(window.userManager && window.userManager.isLoggedIn())) return '';
        if (me || rows.some(r => r.is_me)) return '';
        // Desde a paginação (18/set) o servidor devolve a linha de quem pediu mesmo fora da
        // página (`me`): se ela não veio, a pessoa NÃO tem registro neste nível — não há mais
        // o caso "talvez esteja abaixo do corte".
        return `<p class="rk-note">${this._esc(this._t('ranking.notInLevel', { n: this.level }))}</p>`;
    }

    _table(rows, scope, me = null) {
        const overall = scope === 'overall';
        const head = `
            <tr>
                <th scope="col" class="rk-c-pos"><span class="rk-sr">${this._esc(this._t('ranking.colPosition'))}</span><span aria-hidden="true">#</span></th>
                <th scope="col" class="rk-c-player">${this._esc(this._t('ranking.colPlayer'))}</th>
                ${overall ? `<th scope="col" class="rk-c-level">${this._esc(this._t('ranking.colLevel'))}</th>` : ''}
                <th scope="col" class="rk-c-acc">${this._esc(this._t('ranking.colAccuracy'))}</th>
                <th scope="col" class="rk-c-plays rk-hide-sm">${this._esc(this._t('ranking.colPlays'))}</th>
            </tr>`;
        const body = rows.map(r => this._row(r, overall)).join('');
        // A linha "você", FIXA embaixo quando a posição está além do que foi carregado, com a
        // posição REAL. A separação é uma BORDA tracejada na própria linha, nunca uma linha "⋯"
        // com colspan: no celular a coluna de partidas some, e um colspan contado a mais criou
        // uma coluna fantasma que espremeu os nomes de 83 px para 13 px (medido, 18/set).
        const pinned = me ? `<tbody class="rk-pinned">${this._row(me, overall)}</tbody>` : '';
        // Wrapper rolável precisa ser focável e anunciável (tabela pode passar da viewport).
        // A região rolável nomeia O JOGO: numa tela multi-jogo, "Ranking" sozinho não
        // diz ao leitor de tela de qual placar se trata.
        const g = this.who === 'group' ? this._group() : null;
        const pg = (this._page && this._pages() > 1) ? ' · ' + this._t('ranking.pageOf', { n: this._page.n, total: this._pages() }) : '';
        const label = this._t('ranking.title') + ' · ' + this._gameName(this._prog()) + (g ? ' · ' + g.name : '') + pg;
        return `<div class="rk-tablewrap" tabindex="0" role="region" aria-label="${this._esc(label)}">
                    <table class="rk-table"><thead>${head}</thead><tbody>${body}</tbody>${pinned}</table>
                </div>`;
    }

    _row(r, overall) {
        const medal = r.rank <= 3 ? ['🥇', '🥈', '🥉'][r.rank - 1] : '';
        const name = (r.name && String(r.name).trim()) || this._t('ranking.guestPlayer');
        const meTag = r.is_me ? `<span class="rk-you">${this._esc(this._t('ranking.you'))}</span>` : '';
        // A ESCOLA (17/set): só o 🏫, que leva à página pública do grupo — o nome vai no aria-label
        // e no title. Só na lista de TODOS: no "Meu grupo" todo mundo é da mesma escola. O servidor
        // só manda `group` de grupo LIBERADO. Nome embaixo fica para quando houver mais escolas.
        const g = (this.who !== 'group' && r.group && r.group.id) ? r.group : null;
        const school = g
            ? `<a class="rk-school" href="#/grupo/${this._esc(g.id)}" title="${this._esc(g.name)}" aria-label="${this._esc(this._t('ranking.schoolLink', { group: g.name }))}"><span aria-hidden="true">🏫</span></a>`
            : '';
        const acc = (r.accuracy == null) ? '—' : `${Math.round(r.accuracy)}%`;
        // "Nível 30": no celular a PALAVRA some (o cabeçalho já diz "Nível") e a coluna estreita —
        // é a largura que o 🏫 da escola precisa para não cortar os nomes. O texto inteiro segue no DOM.
        const [lvlA, lvlB] = overall ? this._t('ranking.reached', { n: '\u0000' }).split('\u0000') : ['', ''];
        const lvl = overall
            ? `${lvlA ? `<span class="rk-lvlword">${this._esc(lvlA)}</span>` : ''}${this._esc(String(r.reached))}${lvlB ? `<span class="rk-lvlword">${this._esc(lvlB)}</span>` : ''}`
            : '';
        // A medalha é DECORATIVA: sozinha, o leitor de tela diria "medalha de prata" e a
        // posição se perderia. O número vai sempre junto, visível ou só p/ leitor.
        const pos = medal
            ? `<span aria-hidden="true">${medal}</span><span class="rk-sr">${r.rank}</span>`
            : `${r.rank}`;
        return `
            <tr class="${r.is_me ? 'rk-me' : ''}">
                <td class="rk-c-pos"><span class="rk-rank">${pos}</span></td>
                <td class="rk-c-player">
                    <span class="rk-cellflex">
                        <span class="rk-avatar" aria-hidden="true">${this._avatar(r)}</span>
                        <span class="rk-name">${this._esc(name)}</span>${school}${meTag}
                    </span>
                </td>
                ${overall ? `<td class="rk-c-level">${lvl}</td>` : ''}
                <td class="rk-c-acc">${this._esc(acc)}</td>
                <td class="rk-c-plays rk-hide-sm">${this._esc(String(r.plays ?? 0))}</td>
            </tr>`;
    }

    _avatar(r) { return RankingScreen.avatar(r, (x) => this._esc(x), 'rk'); }

    /** Foto (ou inicial) de uma linha de ranking — régua ÚNICA, usada também pelo GroupRanking. */
    static avatar(r, esc, cls = 'rk') {
        const name = (r.name && String(r.name).trim()) || '?';
        const initial = esc(name.charAt(0).toUpperCase());
        // Só https: hoje o avatar_url vem do provider social, mas se um dia virar upload/
        // edição de perfil, um esquema exótico aqui não deve nem chegar ao atributo.
        if (r.avatar && /^https:\/\//i.test(String(r.avatar))) {
            return `<img class="${cls}-avatar-img" src="${esc(r.avatar)}" alt="" loading="lazy">`;
        }
        return `<span class="${cls}-avatar-ini">${initial}</span>`;
    }

    _state(text) {
        return `<p class="rk-state">${this._esc(text)}</p>`;
    }

    /** Vazio com a ação óbvia: é o único momento em que a tela pode puxar pro jogo.
     *  Rota e nome vêm da ficha do jogo SELECIONADO — mandar pro Ritmo quem olha a
     *  Leitura seria trocar o jogo da pessoa por outro sem ela pedir. */
    _empty(group = null) {
        const prog = this._prog();
        const route = (prog && prog.route) || '#/ritmo';
        const cta = this._t('ranking.emptyCta', { game: this._gameName(prog) });
        // Vazio DO GRUPO diz de quem é o vazio ("ninguém da Escola X ainda"), não "ninguém
        // no ranking" — que seria falso: a lista de todos pode estar cheia.
        const g = group || this._group();
        const msg = group ? this._t('ranking.groupEmpty', { group: (g && g.name) || '', game: this._gameName(prog) })
                          : this._t('ranking.empty');
        return `<div class="rk-empty">
                    <p class="rk-state">${this._esc(msg)}</p>
                    <a class="rk-emptycta" href="${this._esc(route)}">${this._esc(cta)}</a>
                </div>`;
    }

    _esc(s) {
        return String(s).replace(/[&<>"']/g, c => (
            { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    destroy() {
        if (this._onUserChange) {
            document.removeEventListener('userStateChanged', this._onUserChange);
            this._onUserChange = null;
        }
        super.destroy();
    }

    static _css() {
        // Paleta = accent do APP (indigo #6366f1, o mesmo do design system e da NewsScreen),
        // não um verde próprio: Sálvia é a paleta do SÍMBOLO (docs/DIAPASAO.md), e uma tela
        // com cor exclusiva fazia Novidades→Ranking parecerem dois produtos.
        // Contrastes conferidos: cinzas de texto em #64748b (4.5:1+), nunca #94a3b8 (2.4:1).
        return `
        .rk-screen{max-width:640px;margin:0 auto;padding:1rem 1rem 3rem;}
        .rk-sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;
            clip:rect(0 0 0 0);white-space:nowrap;border:0;}
        .rk-head{text-align:center;margin-bottom:.8rem;}
        .rk-title{margin:0 0 .2rem;font-size:1.6rem;}
        .rk-sub{margin:0;color:#64748b;font-size:.95rem;}
        .rk-tabs{display:flex;gap:.4rem;justify-content:center;margin-bottom:.9rem;}
        /* .rk-who (Todos × Meu grupo) veste a MESMA pílula das abas, mas é outra classe:
           .rk-tab é "as abas de ESCOPO" para quem conta abas (ranking-screen-test). */
        .rk-tab,.rk-who{flex:0 0 auto;padding:.5rem 1.1rem;border:1px solid #d9dbe6;background:#fff;color:#4b5563;
            border-radius:999px;font-weight:600;font-size:.92rem;cursor:pointer;transition:all .15s;font-family:inherit;}
        .rk-tab:hover,.rk-who:hover{border-color:#a5b4fc;}
        .rk-tab.is-active,.rk-who.is-active{background:#4f46e5;border-color:#4f46e5;color:#fff;}
        /* "Todos × Meu grupo": 2º eixo, acima das abas de escopo; alvo de 44px (é dedo). */
        .rk-whobar{display:flex;gap:.4rem;justify-content:center;margin-bottom:.9rem;flex-wrap:wrap;}
        .rk-whobar[hidden]{display:none;}
        .rk-who{min-height:44px;max-width:min(70vw,20rem);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
        /* Seletor de JOGO: eixo primário, acima das abas de escopo. Mesma linguagem do
           seletor de nível (label + select) — a tela não ganha um 3º vocabulário. */
        .rk-gamebar{display:flex;align-items:center;gap:.5rem;justify-content:center;margin-bottom:.9rem;}
        .rk-gameselect{font-weight:600;max-width:min(60vw,16rem);}
        .rk-levelbar{display:flex;align-items:center;gap:.5rem;justify-content:center;margin-bottom:.9rem;}
        .rk-levelbar[hidden]{display:none;}
        .rk-levellabel{font-size:.9rem;color:#4b5563;font-weight:600;}
        .rk-select{padding:.4rem .7rem;border:1px solid #d9dbe6;border-radius:8px;background:#fff;font-size:.92rem;color:#374151;}
        .rk-loginbar{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:.6rem;
            background:#eef2ff;border:1px solid #e0e7ff;border-radius:12px;padding:.7rem 1rem;margin-bottom:1rem;
            font-size:.9rem;color:#4b5563;text-align:center;}
        .rk-loginbtn{padding:.4rem 1rem;border:none;border-radius:999px;background:#4f46e5;color:#fff;
            font-weight:600;font-size:.88rem;cursor:pointer;}
        .rk-loginbtn:hover{background:#4338ca;}
        .rk-tablewrap{overflow-x:auto;-webkit-overflow-scrolling:touch;}
        /* table-layout:fixed = o fix do nome longo. Sem ele o <td> do jogador cresce ate o
           max-content, o ellipsis nunca dispara e as colunas de DADO saem da tela. */
        .rk-table{width:100%;border-collapse:collapse;font-size:.95rem;table-layout:fixed;}
        .rk-table th{text-align:left;font-size:.72rem;text-transform:uppercase;letter-spacing:.04em;
            color:#64748b;font-weight:700;padding:.4rem .5rem;border-bottom:2px solid #eef0f5;white-space:nowrap;}
        .rk-table td{padding:.55rem .5rem;border-bottom:1px solid #f1f3f6;vertical-align:middle;}
        .rk-c-pos{width:2.6rem;text-align:center;}
        /* overflow:hidden é o par obrigatório do max-width:0 — sem ele o badge "VOCÊ"
           (flex:0 0 auto) transborda por cima da coluna Nível a 320px e ainda espreme
           o nome do próprio jogador logado até 0px. */
        .rk-c-player{max-width:0;overflow:hidden;}   /* segue table-cell; o flex vive no .rk-cellflex */
        .rk-c-level{width:5.6rem;white-space:nowrap;}
        .rk-c-acc{width:5.7rem;text-align:right;white-space:nowrap;}
        .rk-c-plays{width:5.7rem;text-align:right;white-space:nowrap;}
        .rk-rank{font-weight:700;color:#64748b;font-size:1.05rem;}
        .rk-cellflex{display:flex;align-items:center;gap:.55rem;min-width:0;}
        .rk-avatar{flex:0 0 auto;}
        .rk-avatar-ini{display:inline-flex;align-items:center;justify-content:center;width:1.9rem;height:1.9rem;
            border-radius:50%;background:#6366f1;color:#fff;font-weight:700;font-size:.85rem;}
        .rk-avatar-img{width:1.9rem;height:1.9rem;border-radius:50%;object-fit:cover;display:block;}
        .rk-name{font-weight:600;color:#1f2937;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;}
        .rk-you{flex:0 0 auto;margin-left:.45rem;font-size:.68rem;font-weight:700;text-transform:uppercase;
            letter-spacing:.03em;color:#3730a3;background:#e0e7ff;border-radius:999px;padding:.1rem .45rem;}
        .rk-me{background:#f5f7ff;}
        .rk-pinned .rk-me td{border-top:2px dashed #a5b4fc;}
        .rk-count{text-align:center;color:#6b7280;font-size:.85rem;margin:.7rem 0 0;}
        .rk-minewrap{text-align:center;margin:.7rem 0 0;}
        .rk-mine{min-height:44px;padding:0 1.1rem;border-radius:10px;border:1.5px solid #c7d2fe;background:#fff;
            color:#3730a3;font-weight:600;font-size:.92rem;cursor:pointer;font-family:inherit;}
        .rk-table[aria-busy="true"], .rk-body[aria-busy="true"] .rk-table{opacity:.55;}
        ${window.RankPager ? window.RankPager.css('rk') : ''}
        /* 🏫 da escola: pequeno no desenho, 44px no dedo (o ::after centralizado) sem roubar largura do nome. */
        .rk-school{position:relative;flex:0 0 auto;display:inline-flex;align-items:center;margin-left:-.3rem;font-size:.9rem;line-height:1;text-decoration:none;}
        /* A area de toque cresce para a ESQUERDA (sobre o proprio nome), nunca para fora da celula:
           a direita fica a coluna Nivel, e o overflow:hidden do .rk-c-player recortaria o que passasse. */
        .rk-school::after{content:'';position:absolute;right:-2px;top:50%;width:44px;height:44px;transform:translateY(-50%);}
        .rk-state{text-align:center;color:#64748b;padding:2.5rem 1rem 1rem;}
        .rk-note{margin:.9rem 0 0;text-align:center;color:#4b5563;font-size:.86rem;line-height:1.45;
            background:#f8fafc;border:1px solid #eef0f5;border-radius:10px;padding:.6rem .8rem;}
        .rk-empty{text-align:center;padding-bottom:2rem;}
        .rk-emptycta{display:inline-block;padding:.5rem 1.2rem;border-radius:999px;background:#4f46e5;
            color:#fff;font-weight:600;font-size:.9rem;text-decoration:none;}
        .rk-emptycta:hover{background:#4338ca;}
        @media (max-width:480px){
            .rk-hide-sm{display:none;}
            .rk-title{font-size:1.35rem;}
            .rk-sub{display:none;}          /* o titulo ja diz tudo; ganha dobra no mobile */
            .rk-screen{padding:.8rem .7rem 2.5rem;}
            .rk-c-level{width:3.4rem;}
            .rk-lvlword{display:none;}
        }
        /* Telas estreitíssimas (320px): o badge sai do VISUAL, não da semântica — a
           linha já é destacada pelo fundo .rk-me, e o texto continua no leitor de tela. */
        @media (max-width:360px){
            .rk-you{position:absolute;width:1px;height:1px;padding:0;margin:-1px;
                overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}
        }`;
    }
}

// Disponibiliza globalmente
window.RankingScreen = RankingScreen;



// ============================================
// screens/StatsScreen.js
// ============================================
/**
 * StatsScreen — "Meu progresso" (#/progresso). A PRIMEIRA coisa que a conta devolve para
 * a pessoa VER: dias de treino, sequência, tempo, a evolução da precisão num gráfico e o
 * resumo por jogo. Item 5 do §4 de docs/PLATAFORMA-MAPA-2026-09-06.md.
 *
 * NÃO é jogo: estende BaseScreen (load → render) e entra no ☰ e no Router por UMA linha
 * em `Main.MENU`. Lê UMA action (`my_stats`, GET com sessão) que devolve os agregados já
 * prontos — a tela não soma evento nenhum; ela desenha o que o servidor contou.
 *
 * 🔴 BASE DE TEMPO: o servidor agrupa por `client_ts` no fuso que ESTA tela manda
 *    (`tz=+HH:MM`, o offset do navegador). O porquê está no cabeçalho de
 *    auth-backend/php/stats.php. Aqui só uma consequência importa: "hoje" é o `today`
 *    que VOLTA na resposta, nunca `new Date()` local — os dois quase sempre coincidem,
 *    mas a régua da faixa e do streak tem de ser a mesma que contou.
 *
 * 🔴 ZERO NÃO É AUSÊNCIA. Três estados que parecem "sem dado" e são coisas diferentes:
 *    - diário DESLIGADO (`analytics_enabled: 0`): a tela DIZ que está desligado e oferece
 *      ligar; os números do diário viram "—", nunca 0 (0 seria mentira: ela não gravou);
 *    - conta que nunca jogou conectada: estado vazio honesto, com a porta para um jogo;
 *    - conta com níveis mas sem diário (jogou antes de o diário existir, 06/set): os
 *      níveis aparecem e uma nota explica por que os dias/tempo não.
 *
 * O gráfico é SVG inline (o projeto é Vanilla + SVG; nada de biblioteca): precisão média
 * por dia, do jogo escolhido, nos últimos 30 ou 90 dias. Só dias com rodada viram ponto;
 * a linha liga os pontos na escala do tempo (um buraco de uma semana aparece como um
 * segmento longo, que é o que aconteceu). A `<title>` de cada ponto é o tooltip nativo.
 *
 * 🔴 CONVIDADO VÊ A MESMA TELA, EM MODO EXEMPLO (07/set). Antes esta rota devolvia um
 *    convite seco ("entre na sua conta") — a pessoa lia uma frase e não fazia ideia do que
 *    estava perdendo. Agora ela vê os cartões, o gráfico e a faixa desenhados com uma
 *    AMOSTRA, e a tabela "por jogo" com o progresso REAL que este aparelho guardou.
 *
 *    Três regras que sustentam isso:
 *    - **A amostra é CONTEXTUAL**: a curva é do jogo de onde a pessoa acabou de vir
 *      (`router.previousPath` → o registro do `LevelProgress`), não de um jogo fixo. Não há
 *      tabela nova para manter: nome, rota e nº de níveis saem do MESMO registro que já põe
 *      o jogo no ranking. Jogo novo entra na amostra pela linha que já o registra.
 *    - **A amostra é CARIMBADA e DETERMINÍSTICA**: cada bloco de exemplo leva o rótulo
 *      "Exemplo", o gráfico leva marca d'água por cima, e o `aria-label` diz "Exemplo:"
 *      antes de qualquer número. Nada de `Math.random`: uma curva que muda a cada F5 é
 *      exatamente o que ela não pode parecer.
 *    - **O que é REAL não é carimbado**: a tabela do aparelho traz o nível mais alto e a
 *      melhor precisão que este navegador guardou (`LevelProgress.getBests()`), com nota
 *      própria dizendo o que é e o que se perde sem conta. Misturar os dois sem marca seria
 *      a tela mentindo — e as colunas do diário ali são "—", nunca 0.
 *
 * 🔴 O EXEMPLO NUNCA APARECE LOGADO. A trava estrutural é o ramo `isLoggedIn()` no render;
 *    a segunda camada é o próprio render, que ZERA `_data` ao sair do modo exemplo — assim
 *    uma resposta real que chegue depois nunca encontra número inventado no lugar.
 *
 * Trilíngue (toda string por _t) e responsivo (viewBox; a tabela por jogo rola no
 * próprio wrapper; nada estoura os 390px — guardado por `stats-screen-test`).
 */
class StatsScreen extends BaseScreen {
    static TITLE_KEY = 'stats.title';
    static WINDOWS = [30, 90];          // dias no gráfico (o servidor manda 90)
    static STRIP_DAYS = 28;             // a faixa "últimas 4 semanas"
    static LOCALE = { pt: 'pt-BR', en: 'en-US', es: 'es-ES' };
    // Último jogo/janela vistos. Preferência de DEVICE (como o ranking_game_v1): fora do
    // StorageScope de propósito — não é progresso, é onde a tela abre.
    static PREF_KEY = 'stats_view_v1';

    // ── modo exemplo (convidado) ──
    static SAMPLE_DAYS = 30;      // a janela desenhada na prévia (sem as pills 30/90)
    static SAMPLE_FROM = 70;      // onde a curva começa
    static SAMPLE_TO = 92;        // onde ela chega
    static SAMPLE_LEVEL_FRAC = 0.4;   // nível de exemplo = 40% da trilha do jogo
    static SAMPLE_FALLBACK_LEVEL = 8; // …quando o jogo não declara trilha

    constructor() {
        super();
        this._data = null;        // resposta do my_stats
        this._error = false;
        this.gameId = null;       // jogo do gráfico
        this.window = 30;         // 30 | 90
        this._onUserChange = null;
        this._reqId = 0;
        this._loading = false;    // há pedido em voo (o render pinta "carregando", nunca "erro", enquanto isso)
        // 🔴 Modo exemplo. `_sampleGame` fica FORA de `this.gameId` de propósito: gameId é a
        //    preferência PERSISTIDA da pessoa, e o jogo que a prévia escolheu por contexto não
        //    pode reescrevê-la — quem entrasse pela Leitura veria o gráfico dela abrir em
        //    Leitura depois de logar, sem nunca ter pedido isso.
        this._preview = false;
        this._sampleGame = null;
        this._restorePref();
    }

    /** Offset do navegador no formato do servidor (+HH:MM). Testável com uma data fixa. */
    static tzOffset(d = new Date()) {
        const m = -d.getTimezoneOffset();
        const a = Math.abs(m);
        return (m < 0 ? '-' : '+') + String(Math.floor(a / 60)).padStart(2, '0') + ':' + String(a % 60).padStart(2, '0');
    }

    _restorePref() {
        try {
            const raw = window.localStorage && window.localStorage.getItem(StatsScreen.PREF_KEY);
            const p = raw ? JSON.parse(raw) : null;
            if (p && typeof p.game === 'string') this.gameId = p.game;
            if (p && StatsScreen.WINDOWS.includes(p.window)) this.window = p.window;
        } catch (e) { /* sem storage: abre no padrão */ }
    }

    _savePref() {
        try { window.localStorage && window.localStorage.setItem(StatsScreen.PREF_KEY, JSON.stringify({ game: this.gameId, window: this.window })); }
        catch (e) { /* só não lembra */ }
    }

    // ----- ciclo ------------------------------------------------------------------

    async load() {
        // Login/logout (inclusive a retomada pós-OAuth): recarrega. Assinado UMA vez por
        // instância, nunca no render (um 2º render duplicaria o ouvinte).
        if (!this._onUserChange) {
            this._onUserChange = () => this._refresh();
            document.addEventListener('userStateChanged', this._onUserChange);
        }
        await this._fetch();
    }

    async _fetch() {
        this._data = null;
        this._error = false;
        // 🔴 A AMOSTRA MORRE AQUI, não no render (auditoria de 07/set). Ela morria depois do
        //    pedido, e a ordem era fatal: `_fetch` gravava a resposta REAL em `_data`, o
        //    `render` via `_preview` ainda ligado e apagava esse dado — então quem clicava em
        //    "Criar conta para guardar isto" e criava a conta era recebido por "Não foi
        //    possível carregar o seu progresso", com `success:true` na mão. Valia para os dois
        //    caminhos de cadastro, e o do Google é pior: ele VOLTA em #/progresso.
        this._preview = false;
        this._sampleGame = null;
        // `_loading` também: o ramo de convidado devolve antes de zerá-lo, e um logout com
        // pedido em voo deixava a bandeira presa em true para sempre.
        this._loading = false;
        const um = window.userManager;
        // O token sobe ANTES do ramo de convidado: uma resposta da conta anterior ainda em voo
        // no logout não pode povoar `_data` (auditoria 07/set).
        const id = ++this._reqId;
        if (!um || !um.isLoggedIn()) return;          // convidado: o render mostra o convite
        this._loading = true;
        const res = await um.apiGet('my_stats', { tz: StatsScreen.tzOffset() });
        if (id !== this._reqId) return;                // resposta velha: outra já está em voo
        this._loading = false;
        if (!res || !res.success) { this._error = true; return; }
        this._data = res;
        this._pickGame();
    }

    /** Jogo do gráfico: o lembrado, se tem rodada na janela; senão o com MAIS rodadas. */
    _pickGame() {
        const withRounds = this._gamesWithRounds();
        if (!withRounds.length) { this.gameId = null; return; }
        if (this.gameId && withRounds.some(g => g.game_id === this.gameId)) return;
        this.gameId = withRounds.slice().sort((a, b) => b.rounds - a.rounds)[0].game_id;
    }

    async _refresh() {
        if (!this._isMounted()) return;
        this.renderLoading();
        await this._fetch();
        if (this._isMounted()) this.render();
    }

    destroy() {
        if (this._onUserChange) {
            document.removeEventListener('userStateChanged', this._onUserChange);
            this._onUserChange = null;
        }
        super.destroy();
    }

    renderLoading() {
        if (!this.container) return;
        this.container.innerHTML = this._shell('loading', `<p class="st-state">${this._esc(this._t('app.loading'))}</p>`);
    }

    render() {
        const um = window.userManager;
        // 🔴 Convidado vê a MESMA tela em modo exemplo. Este ramo é a trava do "o exemplo
        //    nunca aparece logado" — não há outro caminho para `_renderPreview`.
        if (!um || !um.isLoggedIn()) { this._renderPreview(); return; }
        // 🔴 Segunda camada, e ela só apaga o que É AMOSTRA. A 1ª versão apagava `_data`
        //    sempre que `_preview` estivesse ligado, e como o `_fetch` já tinha gravado a
        //    resposta real, ela apagava justamente o dado de quem acabou de criar a conta.
        //    Quem zera a bandeira é o `_fetch` (acima); aqui só sobra a rede de segurança
        //    para um caminho que chegue ao render sem passar por lá.
        if (this._data && this._data.sample) { this._preview = false; this._sampleGame = null; this._data = null; }
        // Outro pedido em voo (userStateChanged chegou com o load inicial no ar): o que se
        // mostra é "carregando", não o cartão de erro — medido pela auditoria de 07/set.
        if (!this._data && !this._error && this._loading) { this.renderLoading(); return; }
        if (this._error || !this._data) {
            this.container.innerHTML = this._shell('error', `
                <div class="st-card st-invite">
                    <p>${this._esc(this._t('stats.error'))}</p>
                    <button type="button" class="st-btn" id="st-retry">${this._esc(this._t('stats.retry'))}</button>
                </div>`);
            this.container.querySelector('#st-retry').addEventListener('click', () => this._refresh());
            return;
        }
        const d = this._data;
        const diaryOff = !d.analytics_enabled;
        const hasAnything = d.active_days > 0 || (d.games && d.games.length > 0);
        if (!hasAnything) {
            const first = (window.LevelProgress && window.LevelProgress.all()[0]) || null;
            const route = first ? first.route : '#/ritmo';
            const name = first ? this._t(first.nameKey) : this._t('games.rhythm.name');
            // 🔴 Vazio COM o diário desligado: o aviso vem junto e a promessa muda — "os dias e a
            //    evolução aparecem aqui" seria mentira, porque nada vai ser registrado.
            this.container.innerHTML = this._shell('empty', (diaryOff ? this._notice() : '') + `
                <div class="st-card st-invite">
                    <p class="st-emptytitle">${this._esc(this._t('stats.emptyTitle'))}</p>
                    <p>${this._esc(this._t(diaryOff ? 'stats.emptyBodyOff' : 'stats.emptyBody'))}</p>
                    <a class="st-btn" href="${this._esc(route)}">${this._esc(this._t('stats.emptyCta', { game: name }))}</a>
                </div>`, diaryOff ? 'off' : 'on');
            this._bind();
            return;
        }
        this.container.innerHTML = this._shell('ready',
            (diaryOff ? this._notice() : '')
            + this._tiles()
            // A nota "antes do diário" só quando o diário NÃO tem nada (nem abandono): conta que
            // só abandonou hoje está sendo registrada, e a nota mentiria (auditoria 07/set).
            + (!diaryOff && d.active_days === 0 && d.games.some(g => g.top_level != null) ? `<p class="st-note">${this._esc(this._t('stats.beforeDiary'))}</p>` : '')
            // Gráfico e faixa são leituras do DIÁRIO: desligado, não há o que desenhar — e
            // "nenhuma rodada nos últimos 30 dias" seria mentira (houve; não foi registrada).
            + (diaryOff ? '' : this._chartCard() + this._stripCard())
            + this._tableCard(),
            diaryOff ? 'off' : 'on');
        this._bind();
    }

    _shell(state, body, diary = '') {
        return `
            <div class="st-screen" data-state="${state}"${diary ? ` data-diary="${diary}"` : ''}>
                <style>${StatsScreen._css()}</style>
                <header class="st-head">
                    <h1 class="st-title">${this._esc(this._t('stats.title'))}</h1>
                    <p class="st-sub">${this._esc(this._t('stats.subtitle'))}</p>
                </header>
                ${body}
            </div>`;
    }

    _bind() {
        const on = this.container.querySelector('#st-diary-on');
        if (on) on.addEventListener('click', async () => {
            on.disabled = true;
            const um = window.userManager;
            const r = um && um.savePref ? await um.savePref('analytics_enabled', 1) : null;
            if (r && r.success) { this._refresh(); return; }
            on.disabled = false;
            // sessão morta já foi avisada; troca de conta com o pedido em voo não é erro desta conta
            if (r && ['session_expired', 'not_logged', 'account_changed'].includes(r.error_code)) return;
            window.notifications?.toast(this._t('auth.prefs.saveError'), { type: 'error' });
        });
        const sel = this.container.querySelector('#st-game');
        if (sel) sel.addEventListener('change', (e) => {
            if (!this._gamesWithRounds().some(g => g.game_id === e.target.value)) return;
            this.gameId = e.target.value;
            this._savePref();
            this._redrawChart();
        });
        this.container.querySelectorAll('.st-win').forEach(btn => btn.addEventListener('click', () => {
            const w = parseInt(btn.dataset.window, 10);
            if (!StatsScreen.WINDOWS.includes(w) || w === this.window) return;
            this.window = w;
            this._savePref();
            this._syncWindowButtons();
            this._redrawChart();
        }));
    }

    _syncWindowButtons() {
        this.container.querySelectorAll('.st-win').forEach(b => {
            const on = parseInt(b.dataset.window, 10) === this.window;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', String(on));
        });
    }

    _redrawChart() {
        // Fora do try do init(): um erro aqui seria exceção solta no clique.
        try {
            const host = this.container.querySelector('#st-chart');
            if (host) host.innerHTML = this._chart();
            const cap = this.container.querySelector('#st-chart-caption');
            if (cap) cap.textContent = this._chartCaption();
        } catch (e) { console.error('StatsScreen: falha ao redesenhar o gráfico', e); }
    }

    // ----- dados derivados ------------------------------------------------------

    _gamesWithRounds() {
        const d = this._data;
        if (!d) return [];
        const acc = {};
        (d.series || []).forEach(r => { if (r.rounds > 0) acc[r.game_id] = (acc[r.game_id] || 0) + r.rounds; });
        return Object.keys(acc).map(g => ({ game_id: g, rounds: acc[g] }));
    }

    /** Nome do jogo: registro do ranking (nameKey) → música → o id cru. */
    _gameName(gameId) {
        const prog = window.LevelProgress && window.LevelProgress.get(gameId);
        if (prog) return this._t(prog.nameKey);
        if (gameId === 'musicas') return this._t('games.songs.name');
        return gameId;
    }

    /** Lista de 'YYYY-MM-DD' terminando em `today`, com `n` dias. Aritmética em UTC (dia civil). */
    static dayRange(today, n) {
        const out = [];
        let base = new Date(String(today || '') + 'T00:00:00Z');
        // `today` inválido (resposta velha, campo ausente): cai no dia local em vez de derrubar
        // a tela inteira com RangeError — tiles e tabela não dependem dele.
        if (isNaN(base.getTime())) { const l = new Date(); base = new Date(Date.UTC(l.getFullYear(), l.getMonth(), l.getDate())); }
        for (let i = n - 1; i >= 0; i--) {
            const d = new Date(base.getTime() - i * 86400000);
            out.push(d.toISOString().slice(0, 10));
        }
        return out;
    }

    /** Série do jogo escolhido indexada por dia. */
    _seriesByDay(gameId) {
        const map = {};
        (this._data.series || []).forEach(r => { if (r.game_id === gameId && r.rounds > 0) map[r.d] = r; });
        return map;
    }

    /** Atividade (todos os jogos) por dia — a faixa. Abandono CONTA: é um dia de treino para
     *  os cartões, e a faixa não pode dizer "sem rodadas" num dia que eles contam. */
    _roundsByDay() {
        const map = {};
        (this._data.series || []).forEach(r => { map[r.d] = (map[r.d] || 0) + (Number(r.rounds) || 0) + (Number(r.songs) || 0) + (Number(r.abandons) || 0); });
        return map;
    }

    _fmtDate(ymd, opts) {
        const lang = window.language?.currentLanguage || 'pt';
        const d = new Date(ymd + 'T00:00:00');
        if (isNaN(d.getTime())) return ymd;
        try { return new Intl.DateTimeFormat(StatsScreen.LOCALE[lang] || 'pt-BR', opts).format(d); }
        catch (_) { return ymd; }
    }
    _fmtShort(ymd) { return this._fmtDate(ymd, { day: 'numeric', month: 'short' }); }
    _fmtLong(ymd) { return this._fmtDate(ymd, { day: 'numeric', month: 'long', year: 'numeric' }); }

    /** Segundos → "2h 14min" / "12 min" / "—" (0 = nada registrado). */
    _fmtTime(s) {
        if (!s || s <= 0) return this._t('stats.timeMinutes', { m: 0 });   // "0 min": o "—" é só do diário DESLIGADO
        const h = Math.floor(s / 3600), m = Math.round((s % 3600) / 60);
        if (h > 0) return this._t('stats.timeHours', { h, m });
        return this._t('stats.timeMinutes', { m: Math.max(1, m) });
    }

    _pct(v) { return (v == null || !Number.isFinite(Number(v))) ? '—' : `${Math.round(Number(v))}%`; }

    // ----- modo exemplo (convidado) ---------------------------------------------

    /**
     * Dia de hoje no relógio LOCAL, 'YYYY-MM-DD'.
     *
     * 🔴 A regra do arquivo é "hoje é o `today` que VOLTA na resposta, nunca `new Date()`".
     *    Ela vale para dado do servidor, e continua valendo: aqui NÃO há resposta — a prévia
     *    não pede nada ao backend. O dia local é a única régua que existe, e usá-la é o que
     *    faz a faixa de 4 semanas terminar no quadradinho de hoje.
     */
    static todayLocal(d = new Date()) {
        return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }

    /**
     * O que ESTE aparelho guardou, por jogo: o nível mais alto alcançado e a MELHOR
     * precisão registrada. Sai do mesmo bag que alimenta o ranking (`LevelProgress`), no
     * escopo `::guest` — é o progresso de quem ainda não tem conta.
     *
     * 🔴 "melhor precisão", não "média": o bag guarda UM registro por nível (o melhor take),
     *    então a média daqui seria a média dos RECORDES, que não é a média de nada que a
     *    pessoa jogou. A tela logada mostra média (do diário) na mesma coluna, e é por isso
     *    que a tabela do aparelho vem com título e nota próprios dizendo qual das duas é.
     * 🔴 Nível fora do catálogo do jogo (bag de uma trilha que encolheu) é IGNORADO: ele
     *    imprimiria um número que a trilha de hoje não tem.
     */
    static deviceBests() {
        const out = [];
        const all = (window.LevelProgress && window.LevelProgress.all()) || [];
        all.forEach((prog) => {
            let bests, levels;
            try { bests = prog.getBests() || {}; levels = prog.levels() || []; } catch (e) { return; }
            let top = null, acc = null;
            Object.keys(bests).forEach((k) => {
                const rec = bests[k];
                const lvl = parseInt(k, 10);
                const a = rec ? Number(rec.acc) : NaN;
                if (!Number.isFinite(lvl) || !Number.isFinite(a)) return;
                if (levels.length && levels.indexOf(lvl) === -1) return;
                if (top == null || lvl > top) top = lvl;
                if (acc == null || a > acc) acc = a;
            });
            if (top != null) out.push({ game_id: prog.gameId, nameKey: prog.nameKey, top_level: top, avg_accuracy: acc });
        });
        return out;
    }

    /**
     * O jogo da amostra. É a decisão que torna a prévia CONTEXTUAL, e ela não custa
     * tabela nenhuma: tudo sai do registro que o jogo já faz para entrar no ranking.
     *
     *   1. de onde a pessoa VEIO (`router.previousPath`) — quem chega da Leitura vê Leitura;
     *   2. senão, o jogo em que ESTE aparelho foi mais longe;
     *   3. senão, o primeiro registrado.
     *
     * 🔴 A rota avulsa `-livre` é o MESMO jogo: ela não tem registro próprio (o ranking é do
     *    ranqueado), então sem o corte do sufixo quem viesse de `#/ritmo-livre` caía no passo 2.
     * @param {string|null} prevPath rota anterior; só o teste passa (produção lê do Router).
     */
    static previewGame(prevPath = undefined) {
        const all = (window.LevelProgress && window.LevelProgress.all()) || [];
        const shape = (p) => ({ gameId: p.gameId, nameKey: p.nameKey, levels: (p.levels() || []).length });
        const prev = prevPath !== undefined ? prevPath : ((window.router && window.router.previousPath) || null);
        if (prev) {
            const base = String(prev).replace(/^#/, '').split('?')[0].replace(/-livre$/, '');
            const hit = all.find((p) => String(p.route || '').replace(/^#/, '') === base);
            if (hit) return shape(hit);
        }
        const dev = StatsScreen.deviceBests().slice().sort((a, b) => b.top_level - a.top_level)[0];
        if (dev) {
            const hit = all.find((p) => p.gameId === dev.game_id);
            if (hit) return shape(hit);
        }
        if (all.length) return shape(all[0]);
        // Nenhum jogo registrado (só acontece fora do app real): a prévia ainda desenha.
        return { gameId: 'ritmo', nameKey: 'games.rhythm.name', levels: 0 };
    }

    /**
     * A amostra, no formato EXATO que o `my_stats` devolve — assim os blocos da tela
     * (cartões, gráfico, faixa, tabela) desenham sem saber que é exemplo.
     *
     * 🔴 DETERMINÍSTICA. Nada de `Math.random`: uma curva que muda a cada F5 se lê como
     *    "gráfico aleatório", que é justamente o que ela não pode parecer — e o teste não
     *    teria número nenhum sobre o que afirmar.
     * 🔴 A serrilha existe porque a reta perfeita não se lê como treino de gente; ela é
     *    somada e depois CLAMPADA, e quem diz de onde a onde a curva foi é o primeiro e o
     *    último ponto REAIS (`from`/`to` na resposta), nunca as constantes — senão o
     *    `aria-label` prometeria um número que o desenho não tem.
     */
    static sample(game, today) {
        const N = StatsScreen.SAMPLE_DAYS;
        const days = StatsScreen.dayRange(today, N);
        const A = StatsScreen.SAMPLE_FROM, B = StatsScreen.SAMPLE_TO;
        const series = [];
        let rounds = 0, seconds = 0, accSum = 0;
        days.forEach((d, i) => {
            // 3 dias de treino a cada 5: 18 dias em 30. O ÚLTIMO dia da janela tem rodada,
            // então a sequência da amostra termina HOJE — como a de quem está treinando.
            if (i % 5 === 0 || i % 5 === 1) return;
            const t = N === 1 ? 1 : i / (N - 1);
            // A serrilha some nas PONTAS (janela seno): sem isso a curva prometida de 70 a
            // 92 chegava em 74 → 91, e o `aria-label` teria de citar números que não são os
            // do desenho. Com a janela, o último ponto é exatamente SAMPLE_TO.
            const wave = (2.2 * Math.sin(i * 1.07) + 1.1 * Math.sin(i * 0.41)) * Math.sin(Math.PI * t);
            const acc = Math.max(0, Math.min(100, Math.round((A + (B - A) * t + wave) * 10) / 10));
            const n = 2 + (i % 3 === 0 ? 1 : 0);
            const secs = n * 105;
            series.push({ d, game_id: game.gameId, rounds: n, passed: n, avg_accuracy: acc, abandons: 0, seconds: secs, songs: 0 });
            rounds += n; seconds += secs; accSum += acc;
        });
        const avg = series.length ? Math.round(accSum / series.length * 10) / 10 : null;
        const top = game.levels
            ? Math.max(1, Math.round(game.levels * StatsScreen.SAMPLE_LEVEL_FRAC))
            : StatsScreen.SAMPLE_FALLBACK_LEVEL;
        // Sequência da amostra: os dias corridos que terminam no último (3, pelo padrão acima).
        let streak = 0;
        for (let i = days.length - 1; i >= 0 && series.some((r) => r.d === days[i]); i--) streak++;
        return {
            success: true, sample: true, basis: 'sample', today, window_days: N, analytics_enabled: 1,
            active_days: series.length, first_day: series.length ? series[0].d : null,
            streak, best_streak: streak,
            totals: { rounds, passed: rounds, abandons: 0, seconds, songs: 0 },
            games: [{
                game_id: game.gameId, rounds, passed: rounds, avg_accuracy: avg, abandons: 0,
                seconds, songs: 0, top_level: top, levels_passed: top, plays: rounds
            }],
            series,
            // O que o `aria-label` promete: os pontos REAIS das pontas, não as constantes.
            from: series.length ? series[0].avg_accuracy : null,
            to: series.length ? series[series.length - 1].avg_accuracy : null
        };
    }

    /** Nome do jogo da amostra (o `nameKey` do registro; `_gameName` cobre o resto). */
    _sampleName() {
        return this._sampleGame ? this._t(this._sampleGame.nameKey) : '';
    }

    /** Rótulo "Exemplo" — o carimbo de cada bloco que NÃO é dado da pessoa. */
    _stamp() {
        return `<span class="st-stamp">${this._esc(this._t('stats.previewStamp'))}</span>`;
    }

    /** O cartão de chamada. Aparece DUAS vezes (topo e fim) e é o mesmo botão. */
    _previewCta(where) {
        const body = where === 'top'
            ? this._t('stats.previewIntro', { game: this._sampleName() })
            : this._t('stats.previewOutro');
        return `
            <div class="st-card st-invite st-cta st-cta--${where}">
                <p>${this._esc(body)}</p>
                <button type="button" class="st-btn" data-preview-cta="${where}">${this._esc(this._t('stats.previewCta'))}</button>
            </div>`;
    }

    /**
     * A tela do convidado: a MESMA tela, com a amostra carimbada e a tabela do aparelho.
     * Só é chamada do ramo `!isLoggedIn()` do render — a trava do "nunca logado" é ele.
     */
    _renderPreview() {
        this._sampleGame = StatsScreen.previewGame();
        this._preview = true;
        this._data = StatsScreen.sample(this._sampleGame, StatsScreen.todayLocal());
        const dev = StatsScreen.deviceBests();
        this.container.innerHTML = this._shell('preview',
            this._previewCta('top')
            + `<div class="st-stampline">${this._stamp()}</div>`
            + this._tiles(true)
            + this._chartCard(true)
            + this._stripCard(true)
            + (dev.length ? this._deviceTable(dev) : this._tableCard(null, { stamp: true }))
            + this._previewCta('end'));
        this._bindPreview();
        // 🔴 O beacon sai DEPOIS de a tela existir: "viu a prévia" é sobre o que foi
        //    desenhado, e `g=`/`dev=` só são verdade aqui embaixo.
        try { window.Beacon?.action?.('stats_preview', { g: this._sampleGame.gameId, dev: dev.length ? 1 : 0 }); } catch (e) { /* best-effort */ }
    }

    /** A tabela do APARELHO: dado real, sem carimbo, com título e nota próprios. */
    _deviceTable(rows) {
        return this._tableCard(rows.map((r) => ({
            game_id: r.game_id, top_level: r.top_level, avg_accuracy: r.avg_accuracy,
            rounds: 0, songs: 0, abandons: 0, seconds: 0
        })), { title: this._t('stats.previewDeviceTitle'), note: this._t('stats.previewDeviceNote'), dashDiary: true });
    }

    _bindPreview() {
        this.container.querySelectorAll('[data-preview-cta]').forEach((btn) => {
            btn.addEventListener('click', () => {
                try { window.Beacon?.action?.('stats_cta', { g: this._sampleGame ? this._sampleGame.gameId : null }); } catch (e) { /* best-effort */ }
                // 🔴 'signup', não 'signin': a promessa do botão é GUARDAR isto, e quem já tem
                //    conta não está nesta tela. O modal abre na ESCOLHA (Google × e-mail).
                if (window.authModal) window.authModal.open('signup');
            });
        });
    }

    // ----- blocos ---------------------------------------------------------------

    _notice() {
        return `
            <div class="st-notice" role="status">
                <p>${this._esc(this._t('stats.diaryOff'))}</p>
                <button type="button" class="st-btn" id="st-diary-on">${this._esc(this._t('stats.diaryOffCta'))}</button>
            </div>`;
    }

    _tiles(preview = false) {
        const d = this._data;
        const off = !d.analytics_enabled;
        // Com o diário desligado os números do diário são "—": zero seria "você não treinou",
        // e o que houve foi "não registrei". O que vem de `scores` (níveis) segue na tabela.
        const v = (x) => off ? '—' : String(x);
        const streakSub = off ? '' : this._t('stats.tileStreakSub', { n: d.best_streak });
        // O grupo se anuncia como exemplo: os cartões são só número + rótulo, sem aria
        // próprio, e o `.st-stampline` acima é um <span> solto que o rotor não associa a eles.
        return `
            <div class="st-tiles"${preview ? ` role="group" aria-label="${this._esc(this._t('stats.previewStamp'))}"` : ''}>
                ${this._tile(v(d.active_days), this._t('stats.tileDays'), d.first_day && !off ? this._t('stats.since', { date: this._fmtDate(d.first_day, { day: 'numeric', month: 'short', year: 'numeric' }) }) : '')}
                ${this._tile(v(d.streak), this._t('stats.tileStreak'), streakSub)}
                ${this._tile(off ? '—' : this._fmtTime(d.totals.seconds), this._t('stats.tileTime'), '')}
                ${this._tile(v(d.totals.rounds + d.totals.songs), this._t('stats.tileRounds'), off || !d.totals.abandons ? '' : this._t('stats.tileRoundsSub', { n: d.totals.abandons }))}
            </div>`;
    }

    _tile(value, label, sub) {
        return `<div class="st-tile"><div class="st-tilevalue">${this._esc(value)}</div><div class="st-tilelabel">${this._esc(label)}</div>${sub ? `<div class="st-tilesub">${this._esc(sub)}</div>` : ''}</div>`;
    }

    /** Jogo do gráfico. Na prévia é o da AMOSTRA, nunca `gameId` (que é a preferência da pessoa). */
    _chartGame() { return this._preview ? (this._sampleGame ? this._sampleGame.gameId : null) : this.gameId; }
    _chartGameName() { return this._preview ? this._sampleName() : this._gameName(this.gameId); }

    _chartCaption() {
        return this._chartGame() ? this._t('stats.chartCaption', { game: this._chartGameName() }) : '';
    }

    /** @param {boolean} preview modo exemplo: carimbo no lugar dos controles. */
    _chartCard(preview = false) {
        const games = preview ? [] : this._gamesWithRounds();
        const sel = games.length > 1 ? `
            <label class="st-sel"><span class="st-sr">${this._esc(this._t('stats.gameLabel'))}</span>
                <select id="st-game" class="st-select">${games.map(g =>
                    `<option value="${this._esc(g.game_id)}"${g.game_id === this.gameId ? ' selected' : ''}>${this._esc(this._gameName(g.game_id))}</option>`).join('')}</select>
            </label>` : '';
        // 🔴 Na prévia não há pills 30/90 nem seletor de jogo: são controles sobre DADO, e
        //    o dado é de mentira. Mexer neles ali só ensinaria a pessoa a não confiar na tela.
        const wins = preview ? this._stamp()
            : `<div class="st-wins" role="group" aria-label="${this._esc(this._t('stats.windowGroup'))}">${StatsScreen.WINDOWS.map(w =>
            `<button type="button" class="st-win${w === this.window ? ' is-active' : ''}" data-window="${w}" aria-pressed="${w === this.window}">${this._esc(this._t('stats.windowLabel', { n: w }))}</button>`).join('')}</div>`;
        return `
            <section class="st-card st-chartcard" aria-labelledby="st-chart-h">
                <div class="st-cardhead">
                    <h2 class="st-h2" id="st-chart-h">${this._esc(this._t('stats.chartTitle'))}</h2>
                    <div class="st-controls">${sel}${wins}</div>
                </div>
                <div id="st-chart" class="st-chart">${this._chart()}</div>
                <p class="st-caption" id="st-chart-caption">${this._esc(this._chartCaption())}</p>
            </section>`;
    }

    /**
     * O gráfico: precisão média por dia do jogo escolhido, nos últimos `window` dias.
     * Geometria em viewBox fixo (600×230): escala uniforme, texto não distorce.
     */
    _chart() {
        const d = this._data;
        const W = 600, H = 230, L = 40, R = 16, T = 22, B = 30;
        const iw = W - L - R, ih = H - T - B;
        // 🔴 Na prévia a janela é a da AMOSTRA, nunca `this.window`. `window` vem de
        //    `stats_view_v1`, preferência de APARELHO que a tela LOGADA escreve pelas pills
        //    30/90 e que ninguém limpa no logout: com 90 lá, os 18 dias da amostra ficavam
        //    espremidos no terço final, com dois meses de linha vazia à esquerda — e o
        //    `aria` continuava prometendo 30 dias, que é o defeito que a janela da serrilha
        //    existe para evitar. A prévia não tem as pills; ela não pode obedecê-las.
        const janela = this._preview ? StatsScreen.SAMPLE_DAYS : this.window;
        const days = StatsScreen.dayRange(d.today, janela);
        const by = this._chartGame() ? this._seriesByDay(this._chartGame()) : {};
        // Dia sem precisão numérica não vira ponto (defesa: hoje o servidor sempre manda número
        // quando há rodada; sem o guarda, null virava 0% e ausente virava NaN no path).
        const pts = days.map((day, i) => by[day] ? { i, day, acc: Number(by[day].avg_accuracy), rounds: by[day].rounds } : null)
            .filter(p => p && Number.isFinite(p.acc));
        if (!pts.length) {
            return `<p class="st-state st-chartempty">${this._esc(this._t('stats.chartEmpty', { n: janela }))}</p>`;
        }
        const x = i => L + (days.length === 1 ? iw / 2 : i * iw / (days.length - 1));
        const y = v => T + (100 - Math.max(0, Math.min(100, v))) / 100 * ih;
        const avg = pts.reduce((s, p) => s + p.acc, 0) / pts.length;

        const grid = [0, 25, 50, 75, 100].map(v =>
            `<line class="st-grid" x1="${L}" x2="${W - R}" y1="${y(v).toFixed(1)}" y2="${y(v).toFixed(1)}"/>`
            + `<text class="st-ylab" x="${L - 8}" y="${(y(v) + 4).toFixed(1)}" text-anchor="end">${v}%</text>`).join('');
        // Rótulos do eixo X: primeiro, meio e último dia da janela (nunca um por dia).
        const ticks = [0, Math.floor((days.length - 1) / 2), days.length - 1];
        const xlab = ticks.map((i, k) =>
            `<text class="st-xlab" x="${x(i).toFixed(1)}" y="${H - 8}" text-anchor="${k === 0 ? 'start' : k === 2 ? 'end' : 'middle'}">${this._esc(this._fmtShort(days[i]))}</text>`).join('');
        const line = pts.map((p, k) => `${k ? 'L' : 'M'}${x(p.i).toFixed(1)},${y(p.acc).toFixed(1)}`).join(' ');
        const area = pts.length > 1
            ? `${line} L${x(pts[pts.length - 1].i).toFixed(1)},${y(0).toFixed(1)} L${x(pts[0].i).toFixed(1)},${y(0).toFixed(1)} Z`
            : '';
        const dots = pts.map((p, k) => {
            const last = k === pts.length - 1;
            const title = `${this._fmtLong(p.day)} · ${Math.round(p.acc)}% · ${this._t(p.rounds === 1 ? 'stats.roundsOne' : 'stats.roundsMany', { n: p.rounds })}`;
            return `<circle class="st-dot${last ? ' st-dot--last' : ''}" cx="${x(p.i).toFixed(1)}" cy="${y(p.acc).toFixed(1)}" r="${last ? 5 : 3.5}"><title>${this._esc(title)}</title></circle>`;
        }).join('');
        const lastP = pts[pts.length - 1];
        const lastLabel = `<text class="st-lastlab" x="${(x(lastP.i) + (lastP.i > days.length * 0.85 ? -10 : 10)).toFixed(1)}" y="${(y(lastP.acc) - 10).toFixed(1)}" text-anchor="${lastP.i > days.length * 0.85 ? 'end' : 'start'}">${Math.round(lastP.acc)}%</text>`;
        // Com UM ponto a média é o próprio ponto: a linha e o rótulo colidiam com o rótulo do
        // último ponto (medido a 390px) e não diziam nada. Só a partir de 2.
        const avgLine = pts.length < 2 ? '' : `<line class="st-avg" x1="${L}" x2="${W - R}" y1="${y(avg).toFixed(1)}" y2="${y(avg).toFixed(1)}"/>`
            + `<text class="st-avglab" x="${W - R}" y="${(y(avg) - 5).toFixed(1)}" text-anchor="end">${this._esc(this._t('stats.chartAvg', { p: Math.round(avg) }))}</text>`;
        // 🔴 O `aria` da prévia diz "Exemplo:" ANTES de qualquer número — quem ouve a tela
        //    não vê o carimbo, e sem isto a amostra chegaria a essa pessoa como dado dela.
        //    De/para saem dos pontos REAIS das pontas (`from`/`to` da amostra).
        const aria = this._preview
            ? this._t('stats.previewAria', { game: this._sampleName(), from: Math.round(d.from), to: Math.round(d.to), n: StatsScreen.SAMPLE_DAYS })
            : this._t('stats.chartAria', { game: this._gameName(this.gameId), days: pts.length, n: this.window, p: Math.round(avg) });
        // Marca d'água POR CIMA (a faixa translúcida). `aria-hidden`: o `aria-label` do
        // <svg> já diz que é exemplo, e repetir seria ler "Exemplo" duas vezes.
        const wm = !this._preview ? '' : `
                <g class="st-wm" aria-hidden="true" transform="rotate(-7 ${W / 2} ${H / 2})">
                    <rect x="-60" y="${H / 2 - 22}" width="${W + 120}" height="44"/>
                    <text x="${W / 2}" y="${H / 2 + 9}" text-anchor="middle">${this._esc(this._t('stats.previewStamp'))}</text>
                </g>`;
        return `
            <svg class="st-svg" viewBox="0 0 ${W} ${H}" role="img" aria-label="${this._esc(aria)}" data-points="${pts.length}">
                <defs><linearGradient id="st-fill" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stop-color="#6366f1" stop-opacity=".28"/><stop offset="1" stop-color="#6366f1" stop-opacity="0"/>
                </linearGradient></defs>
                ${grid}
                ${area ? `<path class="st-area" d="${area}"/>` : ''}
                ${avgLine}
                <path class="st-line" d="${line}"/>
                ${dots}${lastLabel}${xlab}${wm}
            </svg>`;
    }

    _stripCard(preview = false) {
        const d = this._data;
        const days = StatsScreen.dayRange(d.today, StatsScreen.STRIP_DAYS);
        const by = this._roundsByDay();
        const cells = days.map(day => {
            const n = by[day] || 0;
            const lvl = n === 0 ? 0 : n <= 2 ? 1 : n <= 5 ? 2 : 3;
            // 🔴 O carimbo tem de PREFIXAR cada célula anunciada, não só existir no cabeçalho:
            //    quem navega por rotor percorre os 28 `role="img"` um a um e nunca passa pelo
            //    `.st-stamp` do topo do cartão. Sem isto, a amostra chega como dado da pessoa.
            const marca = preview ? this._t('stats.previewStamp') + ': ' : '';
            const label = `${marca}${this._fmtLong(day)} · ${n === 0 ? this._t('stats.stripNone') : this._t(n === 1 ? 'stats.roundsOne' : 'stats.roundsMany', { n })}`;
            // Só dia COM atividade se anuncia (28 "sem rodadas" num leitor de tela é ruído); o
            // vazio é decorativo. `n` é sempre número aqui (a soma coage), nunca texto da rede.
            const a11y = n > 0 ? `aria-label="${this._esc(label)}" role="img"` : 'aria-hidden="true"';
            return `<span class="st-cell st-cell--${lvl}${day === d.today ? ' st-cell--today' : ''}" data-day="${day}" data-rounds="${Number(n) || 0}" title="${this._esc(label)}" ${a11y}></span>`;
        }).join('');
        return `
            <section class="st-card" aria-labelledby="st-strip-h">
                <div class="st-cardhead"><h2 class="st-h2" id="st-strip-h">${this._esc(this._t('stats.stripTitle'))}</h2>${preview ? this._stamp() : ''}</div>
                <div class="st-strip">${cells}</div>
                <div class="st-stripaxis"><span>${this._esc(this._fmtShort(days[0]))}</span><span>${this._esc(this._t('stats.stripToday'))}</span></div>
            </section>`;
    }

    /**
     * A tabela "por jogo". Serve DOIS donos: a conta (linhas do `my_stats`) e, na prévia,
     * o que este APARELHO guardou — que tem as mesmas duas primeiras colunas e nada do
     * diário. Daí os parâmetros, em vez de uma segunda tabela que divergiria na 1ª coluna nova.
     * @param {Array|null} list linhas; null = as da resposta
     * @param {{title?:string, note?:string, dashDiary?:boolean, stamp?:boolean}} opts
     */
    _tableCard(list = null, opts = {}) {
        const d = this._data;
        // `dashDiary` força "—" nas colunas do DIÁRIO mesmo com ele ligado: na tabela do
        // aparelho não existe diário nenhum, e 0 ali seria "você não treinou".
        // 🔴 PRECISÃO NÃO É COLUNA DE DIÁRIO AQUI: na tabela do aparelho ela sai do bag do
        //    `LevelProgress` (o melhor take), que existe sem diário nenhum. Apagá-la junto
        //    esvaziava a única coluna com número real da prévia — medido na 1ª montagem.
        const off = !d.analytics_enabled || !!opts.dashDiary;
        const offAcc = !d.analytics_enabled;
        const dash = '—';
        const rows = (list || d.games).map(g => {
            const rounds = (Number(g.rounds) || 0) + (Number(g.songs) || 0);
            return `
                <tr>
                    <th scope="row" class="st-c-game">${this._esc(this._gameName(g.game_id))}</th>
                    <td class="st-c-num">${g.top_level != null ? g.top_level : dash}</td>
                    <td class="st-c-num">${offAcc ? dash : this._pct(g.avg_accuracy)}</td>
                    <td class="st-c-num">${off ? dash : rounds}</td>
                    <td class="st-c-num">${off ? dash : g.abandons}</td>
                    <td class="st-c-num st-hide-sm">${off ? dash : this._fmtTime(g.seconds)}</td>
                </tr>`;
        }).join('');
        return `
            <section class="st-card" aria-labelledby="st-table-h">
                <div class="st-cardhead"><h2 class="st-h2" id="st-table-h">${this._esc(opts.title || this._t('stats.tableTitle'))}</h2>${opts.stamp ? this._stamp() : ''}</div>
                ${opts.note ? `<p class="st-devnote">${this._esc(opts.note)}</p>` : ''}
                <div class="st-tablewrap" tabindex="0" role="region" aria-label="${this._esc(opts.title || this._t('stats.tableTitle'))}">
                    <table class="st-table">
                        <thead><tr>
                            <th scope="col" class="st-c-game">${this._esc(this._t('stats.colGame'))}</th>
                            <th scope="col" class="st-c-num">${this._esc(this._t('stats.colLevel'))}</th>
                            <th scope="col" class="st-c-num">${this._esc(this._t('stats.colAccuracy'))}</th>
                            <th scope="col" class="st-c-num">${this._esc(this._t('stats.colRounds'))}</th>
                            <th scope="col" class="st-c-num">${this._esc(this._t('stats.colAbandons'))}</th>
                            <th scope="col" class="st-c-num st-hide-sm">${this._esc(this._t('stats.colTime'))}</th>
                        </tr></thead>
                        <tbody>${rows}</tbody>
                    </table>
                </div>
            </section>`;
    }

    static _css() {
        // Paleta = a do app (indigo #6366f1/#4f46e5), a mesma da Novidades e do Ranking.
        // Cinzas de texto em #64748b ou mais escuro (4.5:1+).
        return `
        .st-screen{max-width:640px;margin:0 auto;padding:1rem 1rem 3rem;}
        .st-sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}
        .st-head{text-align:center;margin-bottom:1rem;}
        .st-title{margin:0 0 .2rem;font-size:1.6rem;}
        .st-sub{margin:0;color:#64748b;font-size:.95rem;}
        .st-state{text-align:center;color:#64748b;padding:2rem 1rem;}
        .st-card{background:#fff;border:1px solid #eef0f5;border-radius:14px;padding:1rem 1.1rem;margin-bottom:.9rem;box-shadow:0 2px 10px rgba(0,0,0,.05);}
        .st-invite{text-align:center;padding:1.6rem 1.1rem;color:#475569;line-height:1.5;}
        .st-invite p{margin:0 0 .9rem;}
        .st-emptytitle{font-weight:700;color:#1f2937;font-size:1.05rem;}
        .st-btn{display:inline-block;min-height:44px;padding:.6rem 1.2rem;border:none;border-radius:999px;background:#4f46e5;color:#fff;
            font-weight:600;font-size:.92rem;cursor:pointer;text-decoration:none;line-height:1.2;}
        .st-btn:hover{background:#4338ca;}
        .st-btn[disabled]{opacity:.6;cursor:default;}
        .st-notice{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:.7rem;background:#fff7ed;border:1px solid #fed7aa;
            border-radius:12px;padding:.8rem 1rem;margin-bottom:.9rem;color:#7c2d12;font-size:.9rem;line-height:1.45;}
        .st-notice p{margin:0;flex:1 1 220px;}
        .st-note{margin:0 0 .9rem;text-align:center;color:#4b5563;font-size:.86rem;line-height:1.45;background:#f8fafc;border:1px solid #eef0f5;border-radius:10px;padding:.6rem .8rem;}
        /* ── modo exemplo (convidado) ──
           O carimbo é AMARELO de propósito: a paleta da tela é indigo, então "Exemplo" é a
           única coisa fora dela e o olho a acha antes de ler número nenhum. Contraste
           #78350f sobre #fef3c7 passa folgado em AA. */
        .st-stamp{display:inline-block;padding:.2rem .55rem;border-radius:999px;background:#fef3c7;border:1px solid #fcd34d;
            color:#78350f;font-size:.7rem;font-weight:800;text-transform:uppercase;letter-spacing:.06em;line-height:1.4;white-space:nowrap;}
        .st-stampline{display:flex;justify-content:flex-end;margin-bottom:.4rem;}
        /* A faixa translúcida sobre o gráfico. Opacidade baixa no fundo e média no texto:
           tem de ser impossível de ignorar e ainda deixar a curva legível. */
        .st-wm rect{fill:#0f172a;opacity:.05;}
        .st-wm text{fill:#334155;opacity:.22;font-size:44px;font-weight:800;letter-spacing:.18em;text-transform:uppercase;}
        .st-devnote{margin:0 0 .7rem;color:#475569;font-size:.84rem;line-height:1.45;}
        .st-cta{border-color:#c7d2fe;background:linear-gradient(180deg,#f5f3ff,#fff);}
        .st-cta p{color:#3730a3;}
        .st-tiles{display:grid;grid-template-columns:repeat(4,1fr);gap:.6rem;margin-bottom:.9rem;}
        .st-tile{background:#fff;border:1px solid #eef0f5;border-radius:14px;padding:.8rem .6rem;text-align:center;box-shadow:0 2px 10px rgba(0,0,0,.05);min-width:0;}
        .st-tilevalue{font-size:1.5rem;font-weight:800;color:#312e81;line-height:1.1;letter-spacing:-.01em;overflow-wrap:anywhere;}
        .st-tilelabel{margin-top:.25rem;font-size:.72rem;text-transform:uppercase;letter-spacing:.04em;color:#64748b;font-weight:700;}
        .st-tilesub{margin-top:.2rem;font-size:.75rem;color:#64748b;}
        .st-cardhead{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:.5rem;margin-bottom:.6rem;}
        .st-h2{margin:0;font-size:1.05rem;color:#1f2937;}
        .st-controls{display:flex;align-items:center;gap:.5rem;flex-wrap:wrap;}
        .st-select{min-height:44px;padding:.3rem .6rem;border:1px solid #d9dbe6;border-radius:8px;background:#fff;font-size:.88rem;color:#374151;font-weight:600;max-width:11rem;}
        .st-wins{display:inline-flex;border:1px solid #d9dbe6;border-radius:999px;overflow:hidden;}
        .st-win{min-height:44px;padding:.3rem .8rem;border:none;background:#fff;color:#4b5563;font-weight:600;font-size:.85rem;cursor:pointer;}
        .st-win.is-active{background:#4f46e5;color:#fff;}
        .st-chart{width:100%;}
        .st-svg{display:block;width:100%;height:auto;font-family:inherit;}
        .st-grid{stroke:#eef0f5;stroke-width:1;}
        .st-ylab,.st-xlab{fill:#64748b;font-size:11px;}
        .st-area{fill:url(#st-fill);}
        .st-line{fill:none;stroke:#4f46e5;stroke-width:2.5;stroke-linejoin:round;stroke-linecap:round;}
        .st-dot{fill:#fff;stroke:#4f46e5;stroke-width:2;}
        .st-dot--last{fill:#4f46e5;}
        .st-lastlab{fill:#312e81;font-size:12px;font-weight:700;}
        .st-avg{stroke:#a5b4fc;stroke-width:1;stroke-dasharray:4 4;}
        .st-avglab{fill:#6366f1;font-size:11px;font-weight:600;}
        .st-caption{margin:.4rem 0 0;text-align:center;color:#64748b;font-size:.82rem;}
        .st-chartempty{padding:2.2rem 1rem;}
        .st-strip{display:grid;grid-template-columns:repeat(${StatsScreen.STRIP_DAYS},1fr);gap:3px;}
        .st-cell{display:block;aspect-ratio:1/1;border-radius:3px;background:#eef0f5;min-width:0;}
        .st-cell--1{background:#c7d2fe;}
        .st-cell--2{background:#818cf8;}
        .st-cell--3{background:#4338ca;}
        .st-cell--today{box-shadow:0 0 0 2px #fff,0 0 0 3px #4f46e5;}
        .st-stripaxis{display:flex;justify-content:space-between;margin-top:.35rem;font-size:.75rem;color:#64748b;}
        .st-tablewrap{overflow-x:auto;-webkit-overflow-scrolling:touch;}
        .st-table{width:100%;border-collapse:collapse;font-size:.9rem;}
        .st-table th{text-align:left;font-size:.7rem;text-transform:uppercase;letter-spacing:.04em;color:#64748b;font-weight:700;padding:.4rem .4rem;border-bottom:2px solid #eef0f5;white-space:nowrap;}
        .st-table td{padding:.55rem .4rem;border-bottom:1px solid #f1f3f6;vertical-align:middle;white-space:nowrap;}
        .st-table tbody th{font-size:.9rem;text-transform:none;letter-spacing:0;color:#1f2937;font-weight:600;border-bottom:1px solid #f1f3f6;padding:.55rem .4rem;white-space:normal;}
        .st-c-num{text-align:right;}
        @media (max-width:480px){
            .st-screen{padding:.8rem .7rem 2.5rem;}
            .st-title{font-size:1.35rem;}
            .st-sub{display:none;}
            .st-tiles{grid-template-columns:repeat(2,1fr);}
            .st-tilevalue{font-size:1.35rem;}
            .st-card{padding:.85rem .8rem;}
            .st-table{font-size:.84rem;}
            .st-table th,.st-table td,.st-table tbody th{padding:.45rem .25rem;}
            .st-table th{letter-spacing:0;font-size:.66rem;}
            /* 44px de largura a mais no cabeçalho estouram a linha num visor de 390 —
               a mesma medida do "?" da ajuda. O carimbo vai para a linha de baixo. */
            .st-cardhead{flex-wrap:wrap;}
            .st-wm text{font-size:52px;}
            /* Tempo por jogo sai do VISUAL no celular (o total está no cartão de cima):
               medido a 390px, com ela a tabela pedia 397px num wrapper de 340 e rolava. */
            .st-hide-sm{display:none;}
        }`;
    }
}

window.StatsScreen = StatsScreen;



// ============================================
// screens/LegalScreen.js
// ============================================
/**
 * LegalScreen — as três telas institucionais DENTRO do app: privacidade
 * (`#/privacidade`), termos (`#/termos`) e contato (`#/contato`).
 *
 * Não são jogo: estendem BaseScreen (o template load → render das telas
 * não-jogo, como NewsScreen e HelpScreen). Entram no ☰ e no Router por UMA linha
 * em `Main.MENU` cada — fora de `Main.GAMES` (o ⊞ é o switcher de JOGO) e, por
 * coerência, fora de `Beacon.GAME_ROUTES`.
 *
 * 🔴 UMA classe para as três porque a diferença entre elas é DADO, não código:
 * muda a chave do bloco (`static PAGE`), o título e o slug da página estática
 * irmã. Três arquivos quase iguais seriam três lugares para corrigir a mesma
 * escapada de HTML.
 *
 * 🔴 A PROSA NÃO MORA AQUI nem no `translations.json`: vem de `/legal.json`, o
 * mesmo padrão do `changelog.json` que a Novidades busca. Texto legal muda por
 * fora do ciclo de deploy do bundle (mudou o e-mail, mudou a política), e no
 * `translations.json` cada revisão custaria um rebuild do `js/app.js` — que o app
 * inteiro baixa. Só as 5 chaves de MOLDURA (título, "atualizado em", erro, link
 * para o site) são i18n de bundle; o corpo é conteúdo publicado.
 *
 * 🔴 TODA string do JSON passa por `_esc()`. O arquivo é buscado por fetch e vira
 * `innerHTML`; `p`/`ul` são arrays de string PURA, sem HTML — quem quiser negrito
 * pede uma seção nova, não uma tag no dado. Mesma postura do `ROUTE_RE` da
 * Novidades: dado externo é dado, nunca marcação.
 *
 * 🔴 FALHA DE REDE NÃO PASSA PELO `renderError` do BaseScreen (escolha, não
 * esquecimento): o `renderError` troca a tela inteira por "não deu, ← Início", e
 * aqui isso apagaria justamente a saída que resolve o problema da pessoa — o link
 * para a página estática equivalente (`/privacidade/` e irmãs), que é HTML servido
 * pelo servidor e não depende de JSON nenhum. Então a falha é tratada no `load`
 * (que não lança, como na Novidades): o casco fica de pé com o h1 e o rodapé, e só
 * o corpo vira o aviso `legal.error` + os dois caminhos de saída (a página do site
 * e a home). No CONTATO o formulário não depende do JSON: ele aparece também no
 * estado de erro (a prosa falhou, o canal não).
 */
class LegalScreen extends BaseScreen {
    /** Chave do bloco em legal.json ('privacy' | 'terms' | 'contact'). A subclasse define. */
    static PAGE = null;

    static JSON_URL = '/legal.json';

    /**
     * Slug da página ESTÁTICA equivalente, por idioma (sem barras — o caminho é
     * montado em `_pageHref`, que é quem conhece o ambiente).
     *
     * 🔴 Esta é a MESMA tabela que o `scripts/build-landing.js` tem em
     * `LEGAL_PAGES[<chave>].slugs`: o build roda em Node e o bundle roda no
     * browser, não há objeto para compartilhar, então o espelho é inevitável — e
     * por isso ele é ESCRITO UMA VEZ SÓ (aqui, na base; as subclasses só dizem
     * `PAGE`) e guardado por teste, que importa os dois lados e exige igualdade
     * nos dois sentidos. Espelho sem guarda é uma segunda verdade esperando
     * divergir — foi assim que 3 páginas inteiras sumiram do gate de OG.
     */
    static SLUGS = {
        privacy: { pt: 'privacidade', en: 'privacy', es: 'privacidad' },
        terms:   { pt: 'termos',      en: 'terms',   es: 'terminos'   },
        contact: { pt: 'contato',     en: 'contact', es: 'contacto'   }
    };

    /** Um fetch por sessão serve as três telas (são vizinhas no ☰; texto legal não muda no meio da visita). */
    static _cache = null;

    /** Slug puro, sem ambiente. `null` se a chave não existe. */
    static slugFor(page, lang) {
        const s = LegalScreen.SLUGS[page];
        if (!s) return null;
        return s[lang] || s.pt;
    }

    // ----- ciclo ------------------------------------------------------------------

    /**
     * Busca a prosa. Falha (rede, 404, JSON quebrado, bloco ausente) NÃO lança:
     * vira `_block = null` e o render mostra o estado de erro — ver o cabeçalho.
     */
    async load() {
        this._block = null;
        try {
            let data = LegalScreen._cache;
            if (!data) {
                // no-cache: revisão de política aparece assim que a pessoa está online
                // (mesma escolha do changelog.json).
                const res = await fetch(LegalScreen.JSON_URL, { cache: 'no-cache' });
                if (!res.ok) throw new Error('HTTP ' + res.status);
                data = await res.json();
                if (!data || typeof data !== 'object') throw new Error('legal.json vazio');
                LegalScreen._cache = data;   // só sucesso entra no cache
            }
            this._updated = typeof data.updated === 'string' ? data.updated : '';
            this._block = LegalScreen._pick(data, this.constructor.PAGE);
        } catch (e) {
            console.warn('LegalScreen: falha ao carregar legal.json', e);
        }
    }

    /**
     * Bloco do idioma corrente, com queda para PT quando o idioma ainda não foi
     * traduzido no arquivo — página institucional em português é ruim, mas página
     * VAZIA é pior (e, sem termos na tela, o app fica sem o que a loja exige).
     */
    static _pick(data, page) {
        const lang = (window.language && window.language.currentLanguage) || 'pt';
        const bloco = (data[lang] && data[lang][page]) || (data.pt && data.pt[page]);
        return (bloco && typeof bloco === 'object') ? bloco : null;
    }

    /** A landing já sumiu quando isto roda: container vazio seria tela BRANCA. Pinta o h1. */
    renderLoading() {
        this._renderShell();
        if (this.bodyEl) {
            this.bodyEl.innerHTML =
                `<p class="legal-state">${this._esc(this._t('app.loading'))}</p>`;
        }
    }

    render() {
        // O casco já veio do renderLoading; só recria se sumiu (idempotente, mesmos ids).
        if (!this.bodyEl || !this.bodyEl.isConnected) this._renderShell();
        // 🔴 O h1 TEM de ser reescrito aqui. O casco nasce no `renderLoading`, quando
        // `_block` ainda é null, então ele sai com o título do i18n — e sem esta linha o
        // `h1` do legal.json nunca chegava à tela: era campo morto. Passou despercebido
        // porque hoje os dois textos coincidem nas 3 páginas (o teste que pegou usa um
        // h1 diferente de propósito; asserção que compara dois valores iguais não prova
        // de onde o valor veio).
        const h1 = this.container && this.container.querySelector('.legal-h1');
        if (h1 && this._block && typeof this._block.h1 === 'string' && this._block.h1) {
            h1.textContent = this._block.h1;
        }
        this.bodyEl.innerHTML = this._block ? this._body(this._block) : this._errorBody();
    }

    // ----- desenho ----------------------------------------------------------------

    /**
     * h1 + corpo. O h1 sai do JSON quando ele já chegou (é a redação publicada) e
     * do `TITLE_KEY` enquanto não chegou — o mesmo nome que a aba e o ☰ mostram.
     */
    _renderShell() {
        const titulo = (this._block && typeof this._block.h1 === 'string' && this._block.h1)
            || this.getTitle();
        this.container.innerHTML = `
            <div class="legal-screen">
                <h1 class="legal-h1">${this._esc(titulo)}</h1>
                <div class="legal-body"></div>
            </div>`;
        this.bodyEl = this.container.querySelector('.legal-body');
        // Aqui, e não no render(): quem precisa do CSS é o CASCO (medida da coluna,
        // padding), e ele já está no ar durante o `load` — injetar só no fim deixaria
        // a tela de carregando desalinhada e piscando ao trocar de estilo.
        this._injectStyle();
    }

    _body(b) {
        const secoes = Array.isArray(b.sections) ? b.sections : [];
        return [
            this._updatedLine(),
            (typeof b.lead === 'string' && b.lead)
                ? `<p class="legal-lead">${this._esc(b.lead)}</p>` : '',
            this._afterLead(),
            secoes.map(s => this._section(s)).join(''),
            this._siteLink()
        ].join('');
    }

    _updatedLine() {
        if (!this._updated) return '';
        return `<p class="legal-updated">`
            + `${this._esc(this._t('legal.updated', { date: this._formatDate(this._updated) }))}</p>`;
    }

    /** Uma seção: título + parágrafos + lista opcional. Tudo string pura, tudo escapado. */
    _section(sec) {
        if (!sec || typeof sec !== 'object') return '';
        const texto = (v) => (typeof v === 'string' && v.trim()) ? v : null;
        const h = texto(sec.h) ? `<h2 class="legal-h2">${this._esc(sec.h)}</h2>` : '';
        const ps = (Array.isArray(sec.p) ? sec.p : [])
            .filter(texto)
            .map(p => `<p class="legal-p">${this._esc(p)}</p>`).join('');
        const itens = (Array.isArray(sec.ul) ? sec.ul : [])
            .filter(texto)
            .map(li => `<li>${this._esc(li)}</li>`).join('');
        const ul = itens ? `<ul class="legal-ul">${itens}</ul>` : '';
        return (h || ps || ul) ? `<section class="legal-section">${h}${ps}${ul}</section>` : '';
    }

    /**
     * Gancho logo depois do lead: a AÇÃO da página, antes da prosa. Vazio em
     * privacidade e termos; o contato põe o formulário aqui (ver ContactScreen).
     * 🔴 Não recebe o bloco do JSON de propósito: o que mora aqui NÃO pode depender
     * dele — o estado de erro (JSON que não chegou) chama o mesmo gancho.
     */
    _afterLead() { return ''; }

    /**
     * Link para a página estática equivalente do site.
     *
     * 🔴 `target="_blank"`: dentro do PWA instalado (display standalone) sair de
     * `/app/` deixa a pessoa sem barra de endereço para voltar. Mesma razão dos
     * guias no pé da Central de Ajuda.
     */
    _siteLink() {
        const href = this._pageHref();
        if (!href) return '';
        return `<p class="legal-site-link">`
            + `<a href="${this._esc(href)}" target="_blank" rel="noopener">`
            + `${this._esc(this._t('legal.readOnSite'))} <span aria-hidden="true">↗</span></a></p>`;
    }

    /**
     * Caminho da página estática NO AMBIENTE certo. Em produção (e no lab) cada
     * idioma tem o seu DOMÍNIO e as páginas moram na raiz dele: prefixo vazio. No
     * `ritmo.local` os 3 idiomas dividem um docroot só e EN/ES vivem em `/en/` e
     * `/es/` — sem o prefixo o link cai no catch-all da SPA, que responde 200 com
     * a landing PT (nada quebra, e por isso o defeito é silencioso).
     */
    _pageHref() {
        const L = window.language;
        const lang = (L && L.currentLanguage) || 'pt';
        const slug = LegalScreen.slugFor(this.constructor.PAGE, lang);
        if (!slug) return '';
        const host = (typeof location !== 'undefined' && location.hostname) || '';
        const porHost = (L && L.languageFromHost) ? L.languageFromHost(host) : null;
        // 🔴 SÓ `porHost === lang`. Havia um `lang === 'pt' ||` aqui, tratando PT como
        // sempre-raiz — inalcançável hoje (nada no app chama `setLanguage`), mas uma bomba
        // para o dia em que houver troca de idioma dentro do app: quem lesse em PT no
        // domínio EN geraria `/privacidade/`, que o .htaccess 301-eia para `/privacy/` — a
        // página EM INGLÊS. Sem host conhecido (ritmo.local) o prefixo é `/pt` para PT?
        // Não: PT é a raiz do docroot, então `porHost` null cai no prefixo do idioma e o
        // caso PT é resolvido pela linha abaixo.
        const prefixo = (porHost === lang || (porHost === null && lang === 'pt')) ? '' : '/' + lang;
        return `${prefixo}/${slug}/`;
    }

    /** Sem JSON: o aviso + as DUAS saídas (a página do site, que não depende dele, e a home). */
    _errorBody() {
        return `
            <p class="legal-state legal-error">${this._esc(this._t('legal.error'))}</p>
            ${this._afterLead()}
            ${this._siteLink()}
            <p class="legal-site-link"><a href="#/">← ${this._esc(this._t('nav.home'))}</a></p>`;
    }

    /** Data ISO (YYYY-MM-DD) → texto localizado. Data estranha volta como veio. */
    _formatDate(iso) {
        const lang = (window.language && window.language.currentLanguage) || 'pt';
        const d = new Date(iso + 'T00:00:00');
        if (isNaN(d.getTime())) return iso;
        try {
            return new Intl.DateTimeFormat(LegalScreen.LOCALE[lang] || 'pt-BR',
                { day: 'numeric', month: 'long', year: 'numeric' }).format(d);
        } catch (_) { return iso; }
    }

    static LOCALE = { pt: 'pt-BR', en: 'en-US', es: 'es-ES' };

    /**
     * 🔴 Medida de coluna e quebra de palavra são o requisito RESPONSIVO desta
     * tela: texto corrido longo em 390px estoura na horizontal por um e-mail ou
     * uma URL sem espaço, e o `overflow-x:hidden` do styles.css corta em SILÊNCIO
     * (não aparece barra, some conteúdo). Daí `overflow-wrap:anywhere` no corpo e
     * `padding-left` na lista, para o marcador não sair da caixa.
     */
    _injectStyle() {
        if (document.getElementById('legal-screen-style')) return;
        const s = document.createElement('style');
        s.id = 'legal-screen-style';
        s.textContent = `
.legal-screen{max-width:680px;margin:0 auto;padding:1rem;overflow-wrap:anywhere;}
@media (min-width:560px){.legal-screen{padding:2rem 1.5rem;}}
.legal-h1{text-align:center;margin:0 0 0.3rem;}
.legal-updated{text-align:center;color:#6366f1;font-weight:600;margin:0 0 1.2rem;font-size:0.9rem;}
.legal-lead{color:#334155;line-height:1.6;margin:0 0 1.4rem;}
.legal-section{margin:0 0 1.4rem;}
.legal-h2{font-size:1.05rem;color:#0f172a;margin:0 0 0.45rem;}
.legal-p{color:#475569;line-height:1.6;margin:0 0 0.7rem;}
.legal-ul{margin:0 0 0.7rem;padding-left:1.35rem;color:#475569;line-height:1.6;}
.legal-ul li{margin-bottom:0.35rem;}
.legal-contact{position:relative;overflow:hidden;background:#fff;border:1px solid #e0e7ff;
    border-radius:18px;padding:1.5rem 1.25rem 1.3rem;margin:0 0 1.8rem;
    box-shadow:0 8px 28px rgba(79,70,229,0.09);overflow-wrap:normal;}
.legal-contact::before{content:"";position:absolute;left:0;right:0;top:0;height:4px;
    background:linear-gradient(90deg,#6366f1,#8b5cf6 55%,#a78bfa);}
.legal-contact[data-state="guest"],.legal-contact[data-state="sent"]{text-align:center;}
.legal-contact-badge{width:54px;height:54px;border-radius:50%;margin:0 auto 0.75rem;
    display:flex;align-items:center;justify-content:center;background:#eef2ff;color:#4f46e5;}
.legal-contact-badge svg{width:26px;height:26px;}
.legal-contact-badge--ok{background:#dcfce7;color:#15803d;animation:legalPop .35s ease-out;}
@keyframes legalPop{from{transform:scale(.6);opacity:0;}to{transform:scale(1);opacity:1;}}
.legal-contact-h{margin:0 0 0.3rem;font-size:1.2rem;color:#1e1b4b;line-height:1.3;}
.legal-contact-text{margin:0 0 1.1rem;color:#475569;line-height:1.55;}
.legal-contact-from{margin:0 0 1rem;color:#64748b;font-size:0.9rem;overflow-wrap:anywhere;}
.legal-contact-from strong{color:#334155;font-weight:600;}
.legal-contact-label{display:block;margin:0 0 0.4rem;font-size:0.76rem;font-weight:700;color:#64748b;
    text-transform:uppercase;letter-spacing:0.05em;}
.legal-contact-input{display:block;width:100%;box-sizing:border-box;min-height:10rem;resize:vertical;
    padding:0.8rem 0.9rem;border:1px solid #d9dbe6;border-radius:12px;background:#fafbff;color:#1f2937;
    font:inherit;font-size:1rem;line-height:1.55;transition:border-color .15s,box-shadow .15s,background .15s;}
.legal-contact-input::placeholder{color:#6b7280;}
.legal-sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}
.legal-contact-input:focus{outline:none;border-color:#6366f1;background:#fff;box-shadow:0 0 0 3px rgba(99,102,241,0.22);}
.legal-contact-input[readonly]{opacity:0.7;}
.legal-contact-foot{display:flex;align-items:center;justify-content:space-between;gap:0.75rem;
    flex-wrap:wrap;margin-top:0.7rem;}
.legal-contact-count{font-size:0.8rem;color:#64748b;font-variant-numeric:tabular-nums;}
.legal-contact-count--near{color:#b45309;font-weight:600;}
.legal-contact-error{margin:0.6rem 0 0;padding:0.55rem 0.75rem;border-radius:10px;background:#fef2f2;
    color:#b91c1c;font-size:0.9rem;line-height:1.45;}
.legal-contact-btns{display:flex;gap:0.6rem;justify-content:center;flex-wrap:wrap;}
.legal-btn{display:inline-flex;align-items:center;justify-content:center;gap:0.45rem;min-height:44px;
    padding:0.6rem 1.35rem;border:none;border-radius:999px;background:#4f46e5;color:#fff;cursor:pointer;
    font-family:inherit;font-size:0.95rem;font-weight:700;line-height:1.2;text-decoration:none;
    box-shadow:0 4px 14px rgba(79,70,229,0.25);transition:background .15s,transform .1s;}
.legal-btn:hover{background:#4338ca;}
.legal-btn:active{transform:translateY(1px);}
.legal-btn:focus-visible{outline:3px solid rgba(99,102,241,0.45);outline-offset:2px;}
.legal-btn[disabled]{opacity:0.5;cursor:default;box-shadow:none;transform:none;}
.legal-btn--ghost{background:#eef2ff;color:#3730a3;box-shadow:none;}
.legal-btn--ghost:hover{background:#e0e7ff;}
.legal-contact-done{outline:none;}
@media (max-width:480px){
    .legal-contact{padding:1.3rem 1rem 1.1rem;border-radius:16px;}
    .legal-contact-foot{flex-direction:column;align-items:stretch;gap:0.5rem;margin-top:0.35rem;}
    .legal-contact-send{width:100%;}
    .legal-contact-count{text-align:right;}
}
@media (prefers-reduced-motion:reduce){.legal-contact-badge--ok{animation:none;}.legal-btn{transition:none;}}
.legal-site-link{margin:1.6rem 0 0;text-align:center;}
.legal-site-link a{display:inline-flex;align-items:center;gap:0.35rem;min-height:44px;
    color:#4f46e5;font-weight:600;}
.legal-state{text-align:center;color:#94a3b8;padding:2rem 0 0.5rem;line-height:1.5;}
.legal-error{color:#b45309;}`;
        document.head.appendChild(s);
    }
}

/** Privacidade — o que o app guarda, onde, e o que a conta leva junto. */
class PrivacyScreen extends LegalScreen {
    static PAGE = 'privacy';
    static TITLE_KEY = 'legal.privacy.title';
}

/** Termos de uso. */
class TermsScreen extends LegalScreen {
    static PAGE = 'terms';
    static TITLE_KEY = 'legal.terms.title';
}

/**
 * Contato — FORMULÁRIO de quem tem conta (14/set/2026; era um `mailto`).
 *
 * 🔴 NENHUM ENDEREÇO DE E-MAIL NO CLIENTE. O `mailto` exigia o endereço no /legal.json e
 *    nas 9 páginas estáticas, onde coletor de e-mail o lê. A mensagem vai pela action
 *    `contact_send` (sessão + CSRF + 5/h por conta); o servidor grava e encaminha para a
 *    caixa do `config.php`, com Reply-To = e-mail da conta.
 * 🔴 SÓ LOGADO (decisão do dono). Convidado vê o convite com as duas portas do AuthModal;
 *    o `userStateChanged` troca o cartão sozinho quando a pessoa entra — e o RASCUNHO
 *    sobrevive (inclusive a sessão morrendo no meio do envio: ela reloga e o texto está lá).
 * 🔴 O cliente NÃO recusa por tamanho: `too_short`/`too_long` vêm do servidor (recusa antes
 *    de postar não deixa linha em log). O botão só fica apagado com o campo VAZIO, e o
 *    `maxlength` é o teto do dedo.
 * 🔴 Três estados NOMEADOS no `data-state` do cartão (`guest` · `form` · `sent`): o teste e
 *    o CSS leem o estado, nunca o inferem de "tem textarea?".
 * O cartão repinta SOZINHO (`_paintForm`), sem refazer a tela: a prosa do JSON não muda
 * quando a pessoa digita, entra ou envia.
 */
class ContactScreen extends LegalScreen {
    static PAGE = 'contact';
    static TITLE_KEY = 'legal.contact.title';
    /** Códigos de recusa que são DESTE formulário (os outros caem em `auth.errors.*`). */
    // `rate_limited` e `csrf` têm frase PRÓPRIA aqui: a genérica diz "aguarde um instante"
    // (o balde é de 5/HORA) e "recarregue a página" (o rascunho só existe na memória).
    static MSG_ERRORS = ['too_short', 'too_long', 'bad_message', 'rate_limited', 'csrf'];

    constructor() {
        super();
        this._draft = '';        // o texto digitado — sobrevive a repintura, login e sessão morta
        this._sending = false;
        this._sent = false;
        this._error = '';        // código da última recusa
        this._draftUid = null;   // DE QUEM é o rascunho (id da conta que digitou)
        this._lastUid = null;    // a conta que o cartão está mostrando agora (null = convidado)
        this._sendSeq = 0;       // número do envio em voo — resposta de envio velho é descartada
        this._sendUid = null;    // DE QUEM é o envio em voo
        this._onUserChange = null;
    }

    /** Id da conta logada, em string; `null` = convidado. */
    _uid() {
        const um = window.userManager;
        if (!um || !um.isLoggedIn()) return null;
        const u = um.getUser() || {};
        // Sem id, o e-mail (como o `getUserId` do UserManager): duas contas sem id não podem
        // cair na mesma identidade e dividir o rascunho.
        if (u.id != null) return String(u.id);
        return u.email ? 'e:' + String(u.email).toLowerCase() : 'logged';
    }

    async load(params) {
        // Assinado UMA vez por instância (um 2º render não duplica o ouvinte).
        if (!this._onUserChange) {
            this._lastUid = this._uid();
            this._onUserChange = () => {
                if (!this._isMounted()) return;
                const uid = this._uid();
                // O `setUser` do boot e da volta do OAuth dispara o evento com a MESMA conta:
                // nada mudou para este cartão, e repintar apagaria "Mensagem enviada" e a recusa.
                if (uid === this._lastUid) return;
                this._lastUid = uid;
                // 🔴 ENVIO EM VOO DE OUTRA CONTA (auditoria 14/set): a Ana envia, sai, o Bruno
                //    entra — o cartão dele nascia travado em "Enviando…" e depois pintava o
                //    resultado DELA ("responde em bruno@…"). Outra conta = o envio velho é
                //    abandonado (a resposta dele é descartada pelo número). Ir a convidado NÃO
                //    abandona: é a sessão morrendo, e o convite tem de dizer por quê.
                if (this._sending && uid !== null && uid !== this._sendUid) {
                    this._sendSeq++;
                    this._sending = false;
                }
                // 🔴 O RASCUNHO É DA CONTA QUE O ESCREVEU (auditoria 14/set). Num tablet de escola,
                //    a sessão da Ana cai, o Bruno entra pelo convite — e via o relato dela, pronto
                //    para sair "em nome dele". Relogar a MESMA conta devolve o texto; outra conta,
                //    não. Convidado não apaga (o texto nem aparece: o convite não tem campo).
                if (uid !== null && this._draftUid !== null && uid !== this._draftUid) {
                    this._draft = '';
                    this._draftUid = null;
                }
                this._sent = false;
                this._error = '';
                this._paintForm();
            };
            document.addEventListener('userStateChanged', this._onUserChange);
        }
        return super.load(params);
    }

    destroy() {
        if (this._onUserChange) {
            document.removeEventListener('userStateChanged', this._onUserChange);
            this._onUserChange = null;
        }
        super.destroy();
    }

    render() {
        super.render();
        this._bindForm();
    }

    // ----- desenho ----------------------------------------------------------------

    _state() {
        const um = window.userManager;
        if (!um || !um.isLoggedIn()) return 'guest';
        return this._sent ? 'sent' : 'form';
    }

    _afterLead() {
        const st = this._state();
        return `<section class="legal-contact" data-contact data-state="${st}" aria-labelledby="legal-contact-h">`
            + this._cardInner(st) + `</section>`;
    }

    /** Repinta só o cartão (entrar, sair, enviar, errar). */
    _paintForm() {
        const host = this.container && this.container.querySelector('[data-contact]');
        if (!host) return;
        const st = this._state();
        host.dataset.state = st;
        host.innerHTML = this._cardInner(st);
        this._bindForm();
    }

    static ICON_MAIL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="m4 7 8 6 8-6"/></svg>';
    static ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

    _cardInner(st) {
        const esc = (s) => this._esc(s);
        const t = (k, p) => this._t(k, p);
        if (st === 'guest') {
            // Sem `role="alert"`: o AppHeader já anuncia a sessão expirada num toast — dois
            // anúncios seguidos para a mesma coisa. Aqui a frase só explica o convite de volta.
            const aviso = this._error === 'session_expired'
                ? `<p class="legal-contact-error">${esc(t('auth.errors.session_expired'))}</p>` : '';
            return `
                <div class="legal-contact-badge" aria-hidden="true">${ContactScreen.ICON_MAIL}</div>
                <h2 class="legal-contact-h" id="legal-contact-h">${esc(t('legal.contact.formTitle'))}</h2>
                <p class="legal-contact-text">${esc(t('legal.contact.guestBody'))}</p>
                ${aviso}
                <div class="legal-contact-btns">
                    <button type="button" class="legal-btn" data-act="signup">${esc(t('profile.guestSignUp'))}</button>
                    <button type="button" class="legal-btn legal-btn--ghost" data-act="signin">${esc(t('profile.guestSignIn'))}</button>
                </div>`;
        }
        const email = ((window.userManager && window.userManager.getUser()) || {}).email || '';
        if (st === 'sent') {
            return `
                <div class="legal-contact-done" data-done tabindex="-1" role="status">
                    <div class="legal-contact-badge legal-contact-badge--ok" aria-hidden="true">${ContactScreen.ICON_OK}</div>
                    <h2 class="legal-contact-h" id="legal-contact-h">${esc(t('legal.contact.sentTitle'))}</h2>
                    <p class="legal-contact-text">${esc(t('legal.contact.sentBody', { email }))}</p>
                </div>
                <button type="button" class="legal-btn legal-btn--ghost" data-act="another">${esc(t('legal.contact.another'))}</button>`;
        }
        const max = (window.UserManager && window.UserManager.CONTACT_MAX) || 4000;
        const erro = this._error
            ? `<p class="legal-contact-error" id="legal-contact-err" role="alert">${esc(this._errorText(this._error))}</p>` : '';
        // O e-mail vai num <strong> SEPARADO da frase: a frase CRUA é partida no {email} e as
        // duas metades são escapadas; o endereço (dado da conta) entra escapado entre elas.
        const [antes, depois] = String(t('legal.contact.from')).split('{email}');
        return `
            <h2 class="legal-contact-h" id="legal-contact-h">${esc(t('legal.contact.formTitle'))}</h2>
            <p class="legal-contact-from">${esc(antes || '')}<strong>${esc(email)}</strong>${esc(depois || '')}</p>
            <form class="legal-contact-form" data-form="contact" novalidate>
                <label class="legal-contact-label" for="legal-contact-msg">${esc(t('legal.contact.label'))}</label>
                <textarea id="legal-contact-msg" class="legal-contact-input" name="message" rows="6"
                    maxlength="${max}" placeholder="${esc(t('legal.contact.placeholder'))}"
                    aria-describedby="legal-contact-count${this._error ? ' legal-contact-err' : ''}"${this._sending ? ' readonly' : ''}>${esc(this._draft)}</textarea>
                ${erro}
                <span class="legal-sr" data-live aria-live="polite"></span>
                <div class="legal-contact-foot">
                    <span class="legal-contact-count${this._nearMax() ? ' legal-contact-count--near' : ''}" id="legal-contact-count">${esc(this._counterText())}</span>
                    <button type="submit" class="legal-btn legal-contact-send" data-act="send"${(this._sending || !this._draft.trim()) ? ' disabled' : ''}>${esc(t(this._sending ? 'legal.contact.sending' : 'legal.contact.send'))}</button>
                </div>
            </form>`;
    }

    _counterText() {
        const max = (window.UserManager && window.UserManager.CONTACT_MAX) || 4000;
        return this._t('legal.contact.counter', { n: this._draft.length, max });
    }

    /** Perto do teto (90%): o contador muda de cor — no desenho E na digitação. */
    _nearMax() {
        const max = (window.UserManager && window.UserManager.CONTACT_MAX) || 4000;
        return this._draft.length >= max * 0.9;
    }

    _errorText(code) {
        const UM = window.UserManager || {};
        if (ContactScreen.MSG_ERRORS.includes(code)) {
            return this._t('legal.contact.errors.' + code, { min: UM.CONTACT_MIN || 10, max: UM.CONTACT_MAX || 4000 });
        }
        const k = 'auth.errors.' + code;
        const v = this._t(k);
        return (v && v !== k) ? v : this._t('auth.errors.generic');
    }

    _bindForm() {
        const host = this.container && this.container.querySelector('[data-contact]');
        if (!host) return;
        host.querySelectorAll('[data-act=signup],[data-act=signin]').forEach(b => b.addEventListener('click', () => {
            if (window.authModal) window.authModal.open(b.dataset.act === 'signup' ? 'signup' : 'signin');
        }));
        const outra = host.querySelector('[data-act=another]');
        if (outra) outra.addEventListener('click', () => {
            this._sent = false;
            this._draft = '';
            this._paintForm();
            const ta = this.container && this.container.querySelector('#legal-contact-msg');
            if (ta) ta.focus();
        });
        const form = host.querySelector('[data-form=contact]');
        if (!form) return;
        const ta = form.querySelector('textarea');
        const btn = form.querySelector('[data-act=send]');
        const count = form.querySelector('.legal-contact-count');
        ta.addEventListener('input', () => {
            this._draft = ta.value;
            this._draftUid = this._uid();
            if (count) {
                count.textContent = this._counterText();
                count.classList.toggle('legal-contact-count--near', this._nearMax());
            }
            if (btn && !this._sending) btn.disabled = !this._draft.trim();
        });
        // Ctrl/⌘+Enter envia (quem escreve um relato longo no computador espera isso).
        ta.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); this._send(); }
        });
        form.addEventListener('submit', (e) => { e.preventDefault(); this._send(); });
    }

    async _send() {
        const um = window.userManager;
        if (this._sending || !um || !this._draft.trim()) return;
        this._sending = true;
        this._error = '';
        const seq = ++this._sendSeq;
        this._sendUid = this._uid();
        // 🔴 NÃO repinta ao começar (auditoria 14/set): trocar o <textarea> tira o foco — o
        //    teclado do celular fecha e o leitor de tela cai no <body> sem ouvir "Enviando…".
        //    Mexe só nos nós que já estão na tela.
        const form = this.container && this.container.querySelector('[data-contact] [data-form=contact]');
        if (form) {
            form.setAttribute('aria-busy', 'true');
            const ta = form.querySelector('textarea');
            if (ta) ta.readOnly = true;
            const btn = form.querySelector('[data-act=send]');
            if (btn) { btn.disabled = true; btn.textContent = this._t('legal.contact.sending'); }
            const live = form.querySelector('[data-live]');
            if (live) live.textContent = this._t('legal.contact.sending');
            const velho = form.querySelector('.legal-contact-error');
            if (velho) velho.remove();
        }
        let r;
        try { r = await um.sendContact(this._draft); } catch (e) { r = { success: false, code: 'network' }; }
        // Outra conta entrou no meio: este resultado não é de quem está na tela (nem o
        // `_sending`, que o ouvinte já soltou para o envio novo).
        if (seq !== this._sendSeq) return;
        this._sending = false;
        if (!this._isMounted()) return;
        if (r && r.success) {
            this._sent = true;
            this._draft = '';
        } else {
            // Sessão morta: o UserManager já deslogou e o ouvinte repintou o convite; o
            // código entra DEPOIS, para o convite dizer por que voltou (e o rascunho fica).
            this._error = (r && r.code) || 'generic';
        }
        this._paintForm();
        // Sessão morta virou convite: sem campo, o foco vai para "Entrar" (senão cai no <body>).
        const alvo = this._sent ? '[data-done]' : (this._state() === 'guest' ? '[data-act=signin]' : '#legal-contact-msg');
        const foco = this.container && this.container.querySelector(alvo);
        if (foco) foco.focus();
    }
}

// 🔴 Disponibiliza globalmente. Sem isto a classe some do bundle SEM ERRO NENHUM:
// `class Foo` no topo do arquivo não cria `window.Foo`, e o Main procura a tela
// pelo NOME (Main.MENU → `screen: 'PrivacyScreen'`). As quatro vão, inclusive a
// base — o teste importa `LegalScreen.SLUGS` para conferir contra o build.
window.LegalScreen = LegalScreen;
window.PrivacyScreen = PrivacyScreen;
window.TermsScreen = TermsScreen;
window.ContactScreen = ContactScreen;



// ============================================
// screens/ProfileScreen.js
// ============================================
/**
 * ProfileScreen — "Minha conta" (#/perfil). O cadastro que a pessoa vê e edita, e os
 * ajustes da conta num lugar só. Itens 2 e 3 do §4 de docs/PLATAFORMA-MAPA-2026-09-06.md;
 * a porta de entrada da frente é docs/HANDOFF-2026-09-07-CONTA-E-PERFIL.md.
 *
 * NÃO é jogo: estende BaseScreen (load → render) e entra no ☰ e no Router por UMA linha
 * em `Main.MENU`. Lê UMA action (`my_profile`, GET com sessão) que já devolve tudo o que
 * a tela desenha — o molde é o `my_stats`.
 *
 * 🔴 É A PRIMEIRA TELA DO APP QUE ESCREVE CADASTRO. `my_stats`, `my_scores` e
 *    `#/ranking` só liam. Daí três posturas que valem aqui e não valiam antes:
 *    - a verdade que fica na tela é a que o SERVIDOR devolveu (o nome pintado é o
 *      `name` da resposta, não o que foi digitado: ele pode ter sido cortado em
 *      MAX_NAME_LEN, e o header/ranking mostram o do banco);
 *    - recusa de negócio (nome vazio) é do servidor, não do cliente — validação que
 *      recusa ANTES de postar não deixa linha em log nenhum (a lição de 13/ago);
 *    - o que é destrutivo pergunta antes, e a pergunta DIZ o que fica de pé.
 *
 * 🔴 O AVATAR NÃO SE EDITA AQUI, E ISSO É DECISÃO (handoff §4). Quem entra pelo Google
 *    traz a foto (`users.avatar_url`, já em prod); quem entra por e-mail fica nas
 *    iniciais coloridas do `UserAvatar`. Upload custaria endpoint, armazenamento e
 *    moderação de imagem — o mesmo critério "o mais barato" que decidiu o contato por
 *    `mailto`. A tela DIZ isso, em vez de deixar a pessoa procurando o botão.
 *    🔴 Quem um dia construir a troca precisa saber: o vínculo social grava o avatar com
 *    `COALESCE(avatar_url, ?)` (SocialLogin), que NUNCA sobrescreve o que já existe.
 *    Trocar esse COALESCE por atribuição direta reintroduz "o Google desfaz a escolha da
 *    pessoa a cada login".
 *
 * 🔴 OS CONTROLES SÃO OS MESMOS DA GAVETA ☰ (`AccountActions`), não cópias: o interruptor
 *    do diário e o "Apagar conta" já existiam lá, e duas implementações divergem na
 *    primeira correção — justo num controle que promete "não estou gravando".
 *
 * 🔴 O IDIOMA NÃO É PREFERÊNCIA DE CONTA: ele vem do DOMÍNIO (aulademusica.com.br = PT,
 *    absolutepitchclass.com = EN, oidoabsolutoclass.com = ES; ver I18N.md). Então esta
 *    tela não grava idioma nenhum — ela mostra o vigente e reaproveita o SELETOR REAL do
 *    shell (`.lang-switch`, clonado), que já carrega os hrefs por domínio e o conserto do
 *    lab. Reescrever os três endereços aqui criaria uma segunda verdade que quebra no lab
 *    em silêncio. (`users.preferred_language` continua sendo só o registro de ONDE a
 *    conta nasceu.)
 *
 * Trilíngue (toda string por `_t`) e responsivo (nada estoura 390px) — guardado por
 * `profile-screen-test`; o servidor, por `profile-test`.
 */
class ProfileScreen extends BaseScreen {
    static TITLE_KEY = 'profile.title';
    static LOCALE = { pt: 'pt-BR', en: 'en-US', es: 'es-ES' };

    constructor() {
        super();
        this._profile = null;     // bloco `profile` do my_profile
        this._error = false;
        this._editing = false;    // o cartão do nome está em modo de edição?
        this._formError = '';     // código de erro da última gravação (auth.errors.<code>)
        this._saving = false;
        this._selfUpdate = false; // gravação própria em voo (ver o ouvinte em `load`)
        this._onUserChange = null;
        this._reqId = 0;
        // Grupo (escola/turma): a lista do `list_groups` (só quando a conta NÃO está em
        // grupo — é a tela dizendo "a sua escola está aqui"), o erro do código e o estado.
        this._groups = null;       // array | null (não pedido / rede caída)
        this._groupError = '';     // auth.errors.<code> do último join
        this._joining = false;
        this._adminError = '';
        this._creating = false;
        this._lists = null;        // "Minhas trilhas" (my_lists): array | null (rede caída)
    }

    // ----- ciclo ------------------------------------------------------------------

    async load() {
        // Login/logout (inclusive a retomada pós-OAuth e a morte de sessão): recarrega.
        // Assinado UMA vez por instância, nunca no render (um 2º render duplicaria o ouvinte).
        if (!this._onUserChange) {
            this._onUserChange = () => {
                // 🔴 O evento que ESTA TELA acabou de causar não pede uma 2ª ida ao servidor:
                //    gravar o nome chama `setUser`, que dispara `userStateChanged` — e o
                //    `_refresh` buscaria de novo o cadastro que a resposta da gravação já
                //    trouxe (e apagaria o modo de edição de quem tivesse reaberto). O
                //    dispatch é SÍNCRONO (UserManager.notifyStateChange), então a marca é
                //    consumida ainda dentro do `await` do `_saveName` — ela nunca sobra para
                //    engolir um login/logout de verdade.
                if (this._selfUpdate) { this._selfUpdate = false; return; }
                this._refresh();
            };
            document.addEventListener('userStateChanged', this._onUserChange);
        }
        await this._fetch();
    }

    destroy() {
        if (this._onUserChange) {
            document.removeEventListener('userStateChanged', this._onUserChange);
            this._onUserChange = null;
        }
        super.destroy();
    }

    /** Busca o cadastro. Convidado nem chega à rede. */
    async _fetch() {
        const um = window.userManager;
        this._error = false;
        if (!um || !um.isLoggedIn()) { this._profile = null; return; }
        const id = ++this._reqId;
        const p = await um.fetchProfile();
        // Resposta velha (troca de conta com pedido em voo) não pinta por cima da nova.
        if (id !== this._reqId) return;
        // 🔴 Sessão morta chega aqui como `null` DEPOIS de o UserManager já ter deslogado
        //    (apiGet trata o 401): nesse caso não é erro de rede, é convidado — e o
        //    `userStateChanged` vai remontar a tela. Distinguir pelo estado atual.
        if (!p && um.isLoggedIn()) this._error = true;
        this._profile = p;
        // A lista de grupos só interessa a quem pode entrar num (sem grupo) e ao admin
        // (que vê os códigos). Segunda ida, e só nesses dois casos; falha = sem lista.
        this._groups = null;
        if (p && (!p.group || p.role === 'admin') && um.listGroups) {
            const lista = await um.listGroups();
            if (id !== this._reqId) return;
            this._groups = Array.isArray(lista) ? lista : null;
        }
        // As trilhas DA CONTA (docs/LISTAS-PLANO.md): criar é de qualquer conta, então o cartão
        // aparece para todo mundo — com a lista, ou com a porta para montar a primeira.
        this._lists = null;
        if (p && um.myLists && window.RhythmTrails && window.RhythmTrails.ENABLED) {
            const ls = await um.myLists();
            if (id !== this._reqId) return;
            this._lists = Array.isArray(ls) ? ls : null;
        }
    }

    async _refresh() {
        await this._fetch();
        if (!this._isMounted()) return;
        this._editing = false;
        this._formError = '';
        this._groupError = '';   // a recusa do código era da conta ANTERIOR (auditoria 17/set)
        this.render();
    }

    // ----- render -----------------------------------------------------------------

    render() {
        const um = window.userManager;
        if (!um || !um.isLoggedIn()) { this._renderGuest(); return; }
        if (this._error || !this._profile) { this._renderFail(); return; }
        const p = this._profile;
        this.container.innerHTML = this._shell('ready',
            this._identityCard(p) + this._nameCard(p) + this._accessCard(p)
            // Tudo de GRUPO junto (17/set): o cartão único e, para o admin, a fila e a lista logo abaixo.
            + this._groupCard(p) + (p.role === 'admin' ? this._adminQueueCard() + this._adminGroupsCard() : '')
            + this._trailsCard()
            + this._langCard() + this._prefsCard() + this._dangerCard());
        this._bind(p);
    }

    _shell(state, body) {
        return `
            <div class="pf-screen" data-state="${state}">
                <style>${ProfileScreen._css()}</style>
                <header class="pf-head">
                    <h1 class="pf-title">${this._esc(this._t('profile.title'))}</h1>
                    <p class="pf-sub">${this._esc(this._t('profile.subtitle'))}</p>
                </header>
                ${body}
            </div>`;
    }

    /** O que a pessoa vê enquanto o `my_profile` não volta (a landing já sumiu). */
    renderLoading() {
        if (!this.container) return;
        this.container.innerHTML = this._shell('loading',
            `<p class="pf-state">${this._esc(this._t('app.loading'))}</p>`);
    }

    /** Sem conta: convite honesto, com as duas portas. Não há prévia — não há o que prever. */
    _renderGuest() {
        this.container.innerHTML = this._shell('guest', `
            <div class="pf-card pf-invite">
                <p class="pf-invitetitle">${this._esc(this._t('profile.guestTitle'))}</p>
                <p>${this._esc(this._t('profile.guestBody'))}</p>
                <div class="pf-invitebtns">
                    <button type="button" class="pf-btn" data-act="signup">${this._esc(this._t('profile.guestSignUp'))}</button>
                    <button type="button" class="pf-btn pf-btn--ghost" data-act="signin">${this._esc(this._t('profile.guestSignIn'))}</button>
                </div>
            </div>`);
        this.container.querySelectorAll('[data-act]').forEach(b => b.addEventListener('click', () => {
            window.authModal?.open(b.dataset.act === 'signup' ? 'signup' : 'signin');
        }));
    }

    /** Logado, mas o cadastro não veio (rede caída / backend fora). Nunca tela em branco. */
    _renderFail() {
        this.container.innerHTML = this._shell('error', `
            <div class="pf-card pf-invite">
                <p>${this._esc(this._t('profile.loadError'))}</p>
                <button type="button" class="pf-btn" data-act="retry">${this._esc(this._t('profile.retry'))}</button>
            </div>`);
        this.container.querySelector('[data-act=retry]')?.addEventListener('click', () => this._refresh());
    }

    _identityCard(p) {
        const selos = []
            .concat(p.role === 'admin' ? [`<span class="pf-badge pf-badge--admin">${this._esc(this._t('profile.roleAdmin'))}</span>`] : [])
            .concat(p.email_verified
                ? [`<span class="pf-badge pf-badge--ok">${this._esc(this._t('profile.verified'))}</span>`]
                : [`<span class="pf-badge pf-badge--warn">${this._esc(this._t('profile.unverified'))}</span>`])
            .join('');
        return `
            <section class="pf-card pf-id">
                <div class="pf-idhead">
                    <span class="pf-avatar" data-avatar></span>
                    <div class="pf-idinfo">
                        <p class="pf-name">${this._esc(p.name || this._t('profile.noName'))}</p>
                        <p class="pf-email">${this._esc(p.email || '')}</p>
                        <div class="pf-badges">${selos}</div>
                    </div>
                </div>
                <p class="pf-since">${this._esc(this._t('profile.memberSince', { date: this._fmtDate(p.created_at) }))}</p>
                <p class="pf-note">${this._esc(this._t('profile.avatarNote'))}</p>
            </section>`;
    }

    /**
     * O nome — o único campo editável hoje. Dois estados no MESMO cartão (ler × editar),
     * nunca um modal: é um campo só, e o modal esconderia a frase que diz que ele é público.
     */
    _nameCard(p) {
        const max = (window.UserManager && window.UserManager.MAX_NAME) || 60;
        const erro = this._formError
            ? `<p class="pf-error" role="alert">${this._esc(this._t('auth.errors.' + this._formError))}</p>` : '';
        const corpo = this._editing
            ? `<form class="pf-form" data-form="name" novalidate>
                   <label class="pf-label" for="pf-name">${this._esc(this._t('profile.nameLabel'))}</label>
                   <input id="pf-name" class="pf-input" name="name" type="text" maxlength="${max}"
                          autocomplete="name" value="${this._esc(p.name || '')}">
                   ${erro}
                   <div class="pf-formbtns">
                       <button type="submit" class="pf-btn" data-act="save"${this._saving ? ' disabled' : ''}>${this._esc(this._t('profile.save'))}</button>
                       <button type="button" class="pf-btn pf-btn--ghost" data-act="cancel">${this._esc(this._t('common.cancel'))}</button>
                   </div>
               </form>`
            : `<div class="pf-rowline">
                   <span class="pf-value">${this._esc(p.name || this._t('profile.noName'))}</span>
                   <button type="button" class="pf-btn pf-btn--small pf-btn--link" data-act="edit">${this._esc(this._t('profile.edit'))}</button>
               </div>`;
        return `
            <section class="pf-card" aria-labelledby="pf-name-h">
                <h2 class="pf-h2" id="pf-name-h">${this._esc(this._t('profile.nameLabel'))}</h2>
                ${corpo}
                <p class="pf-note">${this._esc(this._t('profile.namePublic'))}</p>
            </section>`;
    }

    /**
     * "Como você entra" — a informação que só o servidor tem, e a que explica a conta sem
     * senha (o vínculo Google apaga a senha de conta com e-mail não confirmado; ver o
     * tripwire de auth no CLAUDE.md). Sem esta linha, a pessoa só descobre no dia em que
     * tenta entrar por e-mail e não consegue.
     */
    _accessCard(p) {
        const vias = [];
        if (p.has_password) vias.push(this._t('profile.accessPassword'));
        (p.providers || []).forEach(prov => vias.push(prov === 'google' ? this._t('profile.accessGoogle') : prov));
        const lista = vias.length
            ? `<ul class="pf-list">${vias.map(v => `<li>${this._esc(v)}</li>`).join('')}</ul>`
            : `<p class="pf-value">${this._esc(this._t('profile.accessNone'))}</p>`;
        const semSenha = !p.has_password
            ? `<p class="pf-note">${this._esc(this._t('profile.noPasswordNote'))}</p>`
              + `<button type="button" class="pf-btn pf-btn--small pf-btn--ghost" data-act="setpw">${this._esc(this._t('profile.setPassword'))}</button>`
            : '';
        // O reenvio da confirmação: o app só o oferecia na gaveta ☰; aqui ele fica ao lado
        // do selo "Não confirmado", que é onde a pergunta nasce.
        const verificar = !p.email_verified && p.email
            ? `<div class="pf-actions" data-slot="verify"></div>` : '';
        return `
            <section class="pf-card" aria-labelledby="pf-access-h">
                <h2 class="pf-h2" id="pf-access-h">${this._esc(this._t('profile.accessTitle'))}</h2>
                ${lista}
                ${semSenha}
                ${verificar}
            </section>`;
    }

    /**
     * O GRUPO (escola/turma) — docs/GRUPOS-PLANO.md. Dois estados no mesmo cartão:
     *  - COM grupo: nome, quantos estão nele, a porta para a PÁGINA do grupo (onde mora o ranking) e "Sair".
     *  - SEM grupo: o convite para digitar o CÓDIGO (é a escola quem decide quem entra —
     *    não há busca-e-clique), e a lista do que existe, para a pessoa saber que a escola
     *    dela ESTÁ aqui antes de pedir o código.
     * 🔴 A recusa (`bad_code`, `already_in_group`) é do SERVIDOR e vira frase; nada é
     *    validado antes de postar (a lição de 13/ago: recusa client-side é buraco no log).
     */
    _groupCard(p) {
        const g = p.group;
        // Quem ORGANIZA um grupo vê o grupo DELE aqui, no mesmo cartão (17/set): eram dois
        // cartões, e o primeiro convidava o professor a "digitar o código para entrar".
        if (p.owned_group) {
            const also = g
                ? `<div class="pf-subgroup" data-also>
                       <p class="pf-note">${this._esc(this._t('profile.group.alsoMember', { name: g.name }))}</p>
                       <a class="pf-btn pf-btn--ghost pf-groupcta" href="#/grupo/${this._esc(g.id)}" data-act="grouppage">${this._esc(this._t('profile.group.viewPage'))}</a>
                       <div class="pf-actions" data-slot="group"></div>
                       <p class="pf-note">${this._esc(this._t('profile.group.note'))}</p>
                   </div>`
                : `<details class="pf-joinother"${(this._groupError || this._joining) ? ' open' : ''}>
                       <summary>${this._esc(this._t('profile.group.joinOther'))}</summary>
                       ${this._joinForm()}
                   </details>`;
            return `
            <section class="pf-card" aria-labelledby="pf-group-h" data-group="${g ? 'in' : 'owner'}">
                <h2 class="pf-h2" id="pf-group-h">${this._esc(this._t('profile.group.title'))}</h2>
                ${this._ownerBlock(p.owned_group)}
                ${also}
            </section>`;
        }
        if (g) {
            const n = Number(g.members) || 0;
            const quantos = this._t(n === 1 ? 'profile.group.membersOne' : 'profile.group.members', { n });
            return `
            <section class="pf-card" aria-labelledby="pf-group-h" data-group="in">
                <h2 class="pf-h2" id="pf-group-h">${this._esc(this._t('profile.group.title'))}</h2>
                <div class="pf-rowline">
                    <span class="pf-value pf-groupname">${this._esc(g.name)}</span>
                    <span class="pf-groupcount">${this._esc(quantos)}</span>
                </div>
                <a class="pf-btn pf-groupcta" href="#/grupo/${this._esc(g.id)}" data-act="grouppage">${this._esc(this._t('profile.group.viewPage'))}</a>
                <div class="pf-actions" data-slot="group"></div>
                <p class="pf-note">${this._esc(this._t('profile.group.note'))}</p>
            </section>`;
        }
        const lista = (this._groups && this._groups.length)
            ? `<p class="pf-note pf-grouplist">${this._esc(this._t('profile.group.existing'))} `
              + this._groups.map(x => `<span class="pf-groupitem">${this._esc(x.name)} (${Number(x.members) || 0})</span>`).join(', ') + `</p>`
            : '';
        // Quem não organiza grupo nenhum vê a porta para PEDIR (autonomia, 15/set): é a linha
        // que faltou ao professor da MICA — ele chutou código 5 vezes sem ter como pedir.
        return `
            <section class="pf-card" aria-labelledby="pf-group-h" data-group="out">
                <h2 class="pf-h2" id="pf-group-h">${this._esc(this._t('profile.group.title'))}</h2>
                <p class="pf-groupintro">${this._esc(this._t('profile.group.intro'))}</p>
                ${this._joinForm()}
                ${lista}
                <div class="pf-request" data-request>
                    <p class="pf-note">${this._esc(this._t('profile.group.requestIntro'))}</p>
                    <div class="pf-ctarow" data-help-anchor="app.groups"><a class="pf-btn pf-btn--ghost" href="#/grupo/novo" data-act="requestgroup">${this._esc(this._t('profile.group.requestCta'))}</a></div>
                </div>
            </section>`;
    }

    /** O formulário do CÓDIGO de convite (sem grupo; ou, recolhido, para quem organiza). */
    _joinForm() {
        const erro = this._groupError
            ? `<p class="pf-error" role="alert">${this._esc(this._t('auth.errors.' + this._groupError))}</p>` : '';
        return `
                <form class="pf-form pf-groupform" data-form="group" novalidate>
                    <label class="pf-label" for="pf-code">${this._esc(this._t('profile.group.codeLabel'))}</label>
                    <input id="pf-code" class="pf-input pf-codeinput" name="code" type="text" maxlength="16"
                           autocomplete="off" autocapitalize="characters" spellcheck="false"
                           placeholder="${this._esc(this._t('profile.group.codePlaceholder'))}">
                    ${erro}
                    <p class="pf-note pf-joinnote">${this._esc(this._t('profile.group.note'))}</p>
                    <div class="pf-formbtns">
                        <button type="submit" class="pf-btn" data-act="joingroup"${this._joining ? ' disabled' : ''}>${this._esc(this._t('profile.group.join'))}</button>
                    </div>
                </form>`;
    }

    /**
     * O GRUPO QUE A PESSOA ORGANIZA (pediu) — autonomia, 15/set. Um BLOCO do cartão "Grupo", quatro estados
     * do ciclo: em análise · liberado (com o CÓDIGO e o LINK de convite: é o dono quem
     * distribui) · recusado (com a nota, e a porta para pedir de novo) · pausado.
     * 🔴 O código só vem do servidor quando o grupo está liberado E visível — a tela não
     *    deduz nada; se `g.code` não veio, não há convite a mostrar.
     */
    _ownerBlock(g) {
        const st = g.status === 'active' ? (Number(g.is_active) === 1 ? 'live' : 'paused') : g.status; // 'pending' | 'rejected' | 'live' | 'paused'
        // TABELA de chaves inteiras (não `'x.' + st`): o profile-screen-test extrai do fonte
        // todo literal com cara de chave e trata os terminados em ponto como "família
        // dinâmica" a conferir à parte — com a tabela, cada chave é conferida como as outras.
        const stKey = { live: 'profile.group.owner.live', pending: 'profile.group.owner.pending',
                        rejected: 'profile.group.owner.rejected', paused: 'profile.group.owner.paused' }[st] || 'profile.group.owner.pending';
        const badgeCls = { live: 'ok', pending: 'warn', rejected: 'off', paused: 'off' }[st] || 'warn';
        const n = Number(g.members) || 0;
        const quantos = this._t(n === 1 ? 'profile.group.membersOne' : 'profile.group.members', { n });
        const nota = g.decision_note
            ? `<p class="pf-note pf-decision"><strong>${this._esc(this._t('profile.group.owner.decisionNote'))}</strong> ${this._esc(g.decision_note)}</p>` : '';
        let corpo = '';
        if (st === 'live' && g.code) {
            const link = this._inviteLink(g);
            corpo = `
                <p class="pf-note">${this._esc(this._t('profile.group.owner.share'))}</p>
                <div class="pf-invite">
                    <span class="pf-label">${this._esc(this._t('profile.group.owner.code'))}</span>
                    <div class="pf-rowline">
                        <code class="pf-code pf-code--big" data-code>${this._esc(g.code)}</code>
                        <button type="button" class="pf-btn pf-btn--small pf-btn--ghost" data-act="copycode" data-copy="${this._esc(g.code)}">${this._esc(this._t('profile.group.owner.copy'))}</button>
                    </div>
                    <span class="pf-label">${this._esc(this._t('profile.group.owner.link'))}</span>
                    <div class="pf-rowline">
                        <a class="pf-link" href="${this._esc(link)}" data-link>${this._esc(link)}</a>
                        <button type="button" class="pf-btn pf-btn--small pf-btn--ghost" data-act="copylink" data-copy="${this._esc(link)}">${this._esc(this._t('profile.group.owner.copy'))}</button>
                    </div>
                </div>
                <div class="pf-formbtns">
                    <a class="pf-btn" href="#/grupo/${this._esc(g.id)}" data-act="ownerpage">${this._esc(this._t('profile.group.viewPage'))}</a>
                </div>
                ${g.translation_status === 'failed' && g.description_raw ? `<p class="pf-note">${this._esc(this._t('profile.group.owner.noTranslation'))}</p>` : ''}
                ${g.translation_status === 'pending' && g.description_raw ? `<p class="pf-note">${this._esc(this._t('profile.group.owner.translating'))}</p>` : ''}`;
        } else if (st === 'pending') {
            corpo = `
                <p class="pf-note">${this._esc(this._t('profile.group.owner.pendingBody'))}</p>
                <div class="pf-formbtns">
                    <a class="pf-btn" href="#/grupo/${this._esc(g.id)}" data-act="ownerpage">${this._esc(this._t('profile.group.viewPage'))}</a>
                </div>`;
        } else if (st === 'rejected') {
            corpo = `
                <p class="pf-note">${this._esc(this._t('profile.group.owner.rejectedBody'))}</p>
                ${nota}
                <div class="pf-formbtns">
                    <a class="pf-btn pf-btn--ghost" href="#/grupo/novo" data-act="requestgroup">${this._esc(this._t('profile.group.requestCta'))}</a>
                </div>`;
        } else {
            corpo = `<p class="pf-note">${this._esc(this._t('profile.group.owner.pausedBody'))}</p>${nota}`;
        }
        return `
            <div class="pf-ownerblock" data-owner="${this._esc(st)}">
                <div class="pf-rowline">
                    <span class="pf-value pf-groupname">${this._esc(g.name)}</span>
                    <span class="pf-badge pf-badge--${badgeCls}">${this._esc(this._t(stKey))}</span>
                </div>
                ${st === 'live' ? `<p class="pf-groupcount">${this._esc(quantos)}</p>` : ''}
                ${corpo}
            </div>`;
    }

    /** O link de convite: a página do grupo com `?join=CÓDIGO`, na origem atual (lab/prod). */
    _inviteLink(g) {
        const origin = (typeof location !== 'undefined' && location.origin) ? location.origin : '';
        return `${origin}/app/#/grupo/${g.id}?join=${g.code}`;
    }

    /**
     * A FILA de pedidos (admin): liberar/recusar sem sair do app. Cada pedido mostra o que a
     * pessoa escreveu (nome, descrição, observação, logo), quem pediu, e uma nota opcional
     * que vai no e-mail da decisão. `list_groups` entrega a fila em `requests` só ao admin.
     */
    _adminQueueCard() {
        const fila = (this._groups && Array.isArray(this._groups.requests)) ? this._groups.requests : [];
        const pend = fila.filter(x => x.status === 'pending');
        const outros = fila.filter(x => x.status !== 'pending');
        const item = (x) => {
            const stKeyFull = x.status === 'pending' ? 'profile.group.adminQueue.statusPending'
                : (x.status === 'rejected' ? 'profile.group.adminQueue.statusRejected' : 'profile.group.adminQueue.statusPaused');
            const logo = x.has_logo && window.UserManager && window.UserManager.groupLogoUrl
                ? `<img class="pf-qlogo" src="${this._esc(window.UserManager.groupLogoUrl(x.id, x.logo_v))}" alt="" width="48" height="48">` : '';
            const gid = Number(x.id) || 0;
            const noteMax = (window.GroupScreen && window.GroupScreen.NOTE_MAX) || 500;
            const notaAntes = (this._qnotes && this._qnotes[gid]) || '';
            const previa = `<a class="pf-btn pf-btn--ghost" href="#/grupo/${gid}">${this._esc(this._t('profile.group.adminQueue.viewPreview'))}</a>`;
            // Pendente: liberar/recusar (recusar CONFIRMA — é irreversível; auditoria A3).
            // Liberado e pausado: retomar. Liberado e visível não entra na fila.
            const acoes = x.status === 'pending'
                ? `${x.decision_note ? `<p class="pf-note"><strong>${this._esc(this._t('profile.group.adminQueue.previous'))}</strong> ${this._esc(x.decision_note)}</p>` : ''}
                   <label class="pf-label" for="pf-qnote-${gid}">${this._esc(this._t('profile.group.adminQueue.noteLabel'))}</label>
                   <input id="pf-qnote-${gid}" class="pf-input" type="text" maxlength="${noteMax}" data-qnote="${gid}" value="${this._esc(notaAntes)}">
                   <div class="pf-formbtns">
                       <button type="button" class="pf-btn" data-act="approve" data-gid="${gid}">${this._esc(this._t('profile.group.adminQueue.approve'))}</button>
                       <button type="button" class="pf-btn pf-btn--ghost" data-act="reject" data-gid="${gid}">${this._esc(this._t('profile.group.adminQueue.reject'))}</button>
                       ${previa}
                   </div>`
                : (x.status === 'active' && Number(x.is_active) === 0
                    ? `<div class="pf-formbtns"><button type="button" class="pf-btn" data-act="resume" data-gid="${gid}">${this._esc(this._t('profile.group.adminQueue.resume'))}</button>${previa}</div>`
                    : '');
            return `
                <li class="pf-qitem" data-request-id="${gid}" data-status="${this._esc(x.status)}">
                    <div class="pf-qhead">${logo}<div>
                        <span class="pf-groupname">${this._esc(x.name)}</span>
                        <span class="pf-badge pf-badge--${x.status === 'pending' ? 'warn' : 'off'}">${this._esc(this._t(stKeyFull))}</span>
                        <p class="pf-note pf-qby">${this._esc(this._t('profile.group.adminQueue.by', { email: x.owner_email || '—' }))} · ${this._esc(String(x.lang || '').toUpperCase())}</p>
                    </div></div>
                    <p class="pf-qdesc">${this._esc(x.description || this._t('profile.group.adminQueue.noDescription'))}</p>
                    ${x.request_note ? `<p class="pf-note"><strong>${this._esc(this._t('profile.group.adminQueue.note'))}</strong> ${this._esc(x.request_note)}</p>` : ''}
                    ${acoes}
                </li>`;
        };
        const erro = this._queueError ? `<p class="pf-error" role="alert">${this._esc(this._t('auth.errors.' + this._queueError))}</p>` : '';
        return `
            <section class="pf-card" aria-labelledby="pf-queue-h" data-admin-queue>
                <h2 class="pf-h2" id="pf-queue-h">${this._esc(this._t('profile.group.adminQueue.title'))}</h2>
                ${pend.length ? `<ul class="pf-qlist">${pend.map(item).join('')}</ul>` : `<p class="pf-value">${this._esc(this._t('profile.group.adminQueue.none'))}</p>`}
                ${outros.length ? `<ul class="pf-qlist pf-qlist--past">${outros.slice(0, 5).map(item).join('')}</ul>` : ''}
                ${erro}
            </section>`;
    }

    /**
     * ADMINISTRAÇÃO de grupos — só para `role === 'admin'` (o portão recusa os outros com
     * 403 de qualquer jeito; o cartão só não aparece para quem não pode). É onde o grupo é
     * criado PELA AÇÃO (nunca por INSERT à mão) e onde o código de convite fica visível
     * para ser passado à escola. O `list_groups` devolve `code` só para admin.
     */
    _adminGroupsCard() {
        const erro = this._adminError
            ? `<p class="pf-error" role="alert">${this._esc(this._t('auth.errors.' + this._adminError))}</p>` : '';
        const linhas = (this._groups && this._groups.length)
            ? `<ul class="pf-list pf-adminlist">` + this._groups.map(x =>
                `<li><span class="pf-groupname">${this._esc(x.name)}</span> · ${this._esc(this._t(Number(x.members) === 1 ? 'profile.group.membersOne' : 'profile.group.members', { n: Number(x.members) || 0 }))}`
                + (x.code ? ` · ${this._esc(this._t('profile.group.admin.code'))} <code class="pf-code">${this._esc(x.code)}</code>` : '')
                // A porta é a PÁGINA do grupo, como para todo mundo: lá o admin vê o ranking e o
                // cartão da visão da turma (passa no `requireCanManageGroup` como o dono).
                + `<div class="pf-formbtns"><a class="pf-btn pf-btn--ghost" href="#/grupo/${this._esc(x.id)}" data-act="adminpage">${this._esc(this._t('profile.group.viewPage'))}</a></div></li>`).join('') + `</ul>`
            : `<p class="pf-value">${this._esc(this._t('profile.group.admin.none'))}</p>`;
        return `
            <section class="pf-card" aria-labelledby="pf-admin-h" data-admin-groups>
                <h2 class="pf-h2" id="pf-admin-h">${this._esc(this._t('profile.group.admin.title'))}</h2>
                <p class="pf-groupintro">${this._esc(this._t('profile.group.admin.intro'))}</p>
                ${linhas}
                <form class="pf-form" data-form="creategroup" novalidate>
                    <label class="pf-label" for="pf-groupname">${this._esc(this._t('profile.group.admin.nameLabel'))}</label>
                    <input id="pf-groupname" class="pf-input" name="name" type="text" maxlength="${(window.GroupScreen && window.GroupScreen.NAME_MAX) || 60}" autocomplete="off">
                    ${erro}
                    <div class="pf-formbtns">
                        <button type="submit" class="pf-btn" data-act="creategroup"${this._creating ? ' disabled' : ''}>${this._esc(this._t('profile.group.admin.create'))}</button>
                    </div>
                </form>
            </section>`;
    }

    /**
     * "Minhas trilhas" (docs/LISTAS-PLANO.md, 17/set): nome, nº de níveis, o retorno ("N começaram ·
     * M concluíram", lido do diário) e três portas — editar, abrir a capa, copiar o link. E a porta
     * PRINCIPAL da oficina (18/set): "＋ Nova trilha" cria a trilha com 1 nível (o preset padrão do
     * Ritmo Livre) e nome padrão, e abre a oficina — sem modal de nome, sem passar pelo jogo.
     */
    _trailsCard() {
        if (!(window.RhythmTrails && window.RhythmTrails.ENABLED)) return '';   // a cortina (RhythmTrails.ENABLED)
        const lists = Array.isArray(this._lists) ? this._lists : [];
        const sample = window.RhythmTrails.sampleRoute ? window.RhythmTrails.sampleRoute() : null;   // a trilha exemplo (22/set)
        const origin = (typeof location !== 'undefined' && location.origin) ? location.origin : '';
        const rows = lists.map(l => {
            const s = l.stats || {};
            const n = Number(l.n_levels) || 0;
            const stats = (Number(s.started) || 0) === 0 ? this._t('trail.statsNone') : this._t('trail.stats', { started: Number(s.started) || 0, finished: Number(s.finished) || 0 });
            const link = origin + '/app/#/trilha/' + String(l.code);
            return `
                <li class="pf-trail" data-code="${this._esc(l.code)}">
                    <div class="pf-trailhead">
                        <span class="pf-trailname">${this._esc(l.name)}</span>
                        <span class="pf-trailmeta">${this._esc(this._t(n === 1 ? 'trail.levelsOne' : 'trail.levels', { n }))} · ${this._esc(stats)}</span>
                    </div>
                    <div class="pf-trailbtns">
                        <a class="pf-btn pf-btn--ghost pf-btn--sm" href="#/trilha/${this._esc(l.code)}?edit=1" data-act="trailedit">${this._esc(this._t('profile.trails.edit'))}</a>
                        <a class="pf-btn pf-btn--ghost pf-btn--sm" href="#/trilha/${this._esc(l.code)}" data-act="trailopen">${this._esc(this._t('profile.trails.open'))}</a>
                        <button type="button" class="pf-btn pf-btn--ghost pf-btn--sm" data-act="copylink" data-copy="${this._esc(link)}">${this._esc(this._t('profile.trails.copyLink'))}</button>
                    </div>
                </li>`;
        }).join('');
        return `
            <section class="pf-card" aria-labelledby="pf-trails-h" data-trails="${lists.length}">
                <h2 class="pf-h2" id="pf-trails-h">${this._esc(this._t('profile.trails.title'))}</h2>
                <p class="pf-note">${this._esc(this._t('profile.trails.intro'))}</p>
                ${lists.length ? `<ul class="pf-traillist">${rows}</ul>` : `<p class="pf-note pf-trailnone">${this._esc(this._t('profile.trails.none'))}${sample ? ` <a href="${this._esc(sample)}" data-act="trailsample">${this._esc(this._t('rhythm.trails.sample'))}</a>` : ''}</p>`}
                <div class="pf-ctarow"><button type="button" class="pf-btn" data-act="trailcreate"${lists.length >= ((this._lists && this._lists.max) || 20) ? ' disabled' : ''}>${this._esc(this._t('profile.trails.create'))}</button></div>
            </section>`;
    }

    /** "＋ Nova trilha": 1 nível com o preset padrão, nome padrão; a recusa é do servidor e vira frase. */
    async _createTrail() {
        const um = window.userManager, T = window.RhythmTrails;
        if (!um || !um.saveList || !T || this._creatingTrail) return;
        this._creatingTrail = true;
        // Nasce "só semínimas" (auditoria 22/set) — a receita mora em RhythmTrails.createBlank, a mesma do Ritmo Livre.
        const r = await T.createBlank(um, (k, v) => this._t(k, v));
        this._creatingTrail = false;
        if (r && r.success && r.list) { window.location.hash = '#/trilha/' + encodeURIComponent(r.list.code) + '?edit=1'; return; }
        window.notifications?.toast(this._t('auth.errors.' + ((r && r.code) || 'generic')), { type: 'error', duration: 3000 });
    }

    _langCard() {
        const lang = (window.language && window.language.currentLanguage) || 'pt';
        return `
            <section class="pf-card" aria-labelledby="pf-lang-h">
                <h2 class="pf-h2" id="pf-lang-h">${this._esc(this._t('profile.languageLabel'))}</h2>
                <div class="pf-rowline">
                    <span class="pf-value pf-langvalue">${this._esc(this._t('profile.language.' + lang))}</span>
                    <span class="pf-langslot" data-slot="lang"></span>
                </div>
                <p class="pf-note">${this._esc(this._t('profile.languageNote'))}</p>
            </section>`;
    }

    _prefsCard() {
        return `
            <section class="pf-card" aria-labelledby="pf-prefs-h">
                <h2 class="pf-h2" id="pf-prefs-h">${this._esc(this._t('profile.prefsTitle'))}</h2>
                <div class="pf-actions" data-slot="prefs"></div>
            </section>`;
    }

    _dangerCard() {
        return `
            <section class="pf-card" aria-labelledby="pf-danger-h">
                <h2 class="pf-h2" id="pf-danger-h">${this._esc(this._t('profile.accountTitle'))}</h2>
                <div class="pf-actions" data-slot="account"></div>
            </section>`;
    }

    // ----- eventos ----------------------------------------------------------------

    _bind(p) {
        const c = this.container;
        // Avatar: o componente do header, no tamanho do painel (nó, não HTML — a foto tem
        // fallback para iniciais quando o link do Google morre).
        const av = c.querySelector('[data-avatar]');
        if (av && window.UserAvatar) av.appendChild(window.UserAvatar.el({ name: p.name, email: p.email, avatar_url: p.avatar_url }, 64));

        c.querySelector('[data-act=edit]')?.addEventListener('click', () => {
            this._editing = true; this._formError = ''; this.render();
            this.container.querySelector('#pf-name')?.focus();
        });
        c.querySelector('[data-act=cancel]')?.addEventListener('click', () => {
            this._editing = false; this._formError = ''; this.render();
        });
        c.querySelector('[data-form=name]')?.addEventListener('submit', (e) => { e.preventDefault(); this._saveName(); });
        c.querySelector('[data-act=setpw]')?.addEventListener('click', () => {
            // O caminho DOCUMENTADO para uma conta só-social ganhar senha é o "esqueci a
            // senha" (o backend manda o token mesmo sem `password_hash`). Com o e-mail já
            // preenchido: ele está na tela ao lado, pedir para digitar seria teatro.
            window.authModal?.open('forgot', { email: p.email || '' });
        });

        // Grupo: entrar pelo código · sair (linha do AccountActions, com confirmação).
        c.querySelector('[data-form=group]')?.addEventListener('submit', (e) => { e.preventDefault(); this._joinGroup(); });
        // O "?" do pedido de grupo ao lado do botão "Pedir um grupo" (o mesmo tópico de #/grupo/novo):
        // é aqui que a pessoa encontra a porta pela 1ª vez (pedido dele, 15/set).
        if (window.HelpDot) c.querySelectorAll('[data-help-anchor]').forEach(n => { if (!n.querySelector('.help-dot')) window.HelpDot.attach(n, n.dataset.helpAnchor); });
        // Dono: copiar código/link de convite. Sem clipboard (http, permissão) o texto continua
        // visível e selecionável na tela — o botão só é o atalho.
        c.querySelector('[data-act=trailcreate]')?.addEventListener('click', () => this._createTrail());
        c.querySelectorAll('[data-act=copycode],[data-act=copylink]').forEach(b => b.addEventListener('click', async () => {
            const txt = b.dataset.copy || '';
            let okc = false;
            try { if (navigator.clipboard && navigator.clipboard.writeText) { await navigator.clipboard.writeText(txt); okc = true; } } catch (e) {}
            // Origem insegura (http no lab) não tem `navigator.clipboard`: o caminho antigo
            // (textarea + execCommand) e, se nem ele, SELECIONAR o texto e dizer (auditoria M4).
            if (!okc) {
                try {
                    const ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', '');
                    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;'; document.body.appendChild(ta); ta.select();
                    okc = document.execCommand && document.execCommand('copy'); document.body.removeChild(ta);
                } catch (e) { okc = false; }
            }
            if (okc) { window.notifications?.toast(this._t('profile.group.owner.copied'), { type: 'success', duration: 1600 }); return; }
            const alvo = b.dataset.act === 'copycode' ? c.querySelector('[data-code]') : c.querySelector('[data-link]');
            try { const r = document.createRange(); r.selectNodeContents(alvo); const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r); } catch (e) {}
            window.notifications?.toast(this._t('profile.group.owner.copyFailed'), { type: 'info', duration: 2600 });
        }));
        // Admin: liberar / recusar um pedido da fila.
        c.querySelectorAll('[data-act=approve],[data-act=reject],[data-act=resume]').forEach(b => b.addEventListener('click', () => {
            const gid = Number(b.dataset.gid); const dec = b.dataset.act;
            if (dec !== 'reject') { this._decide(gid, dec); return; }
            // Recusar é um toque a 44 px do "Liberar", e não tem volta (o servidor responde
            // bad_status a uma 2ª decisão): pergunta antes, com o nome e a nota que vai no e-mail.
            const item = c.querySelector(`[data-request-id="${gid}"]`);
            const nome = item ? (item.querySelector('.pf-groupname')?.textContent || '') : '';
            const nota = (c.querySelector(`[data-qnote="${gid}"]`)?.value || '').trim();
            if (!window.notifications || !window.notifications.modal) { this._decide(gid, dec); return; }
            window.notifications.modal({
                title: this._t('profile.group.adminQueue.rejectTitle'),
                html: `<p style="text-align:center;color:#475569;margin:0;line-height:1.5;">${this._esc(this._t('profile.group.adminQueue.rejectBody', { name: nome }))}</p>`
                    + (nota ? `<p style="text-align:center;color:#1f2937;margin:.7rem 0 0;font-size:.92rem;white-space:pre-wrap;">${this._esc(nota)}</p>` : ''),
                actions: [
                    { label: this._t('profile.group.adminQueue.reject'), style: 'linear-gradient(135deg,#ef4444,#dc2626)', onClick: () => this._decide(gid, dec) },
                    { label: this._t('common.cancel'), style: 'neutral' }
                ]
            });
        }));
        c.querySelector('[data-form=creategroup]')?.addEventListener('submit', (e) => { e.preventDefault(); this._createGroup(); });
        const slotGroup = c.querySelector('[data-slot=group]');
        if (slotGroup && p.group && window.AccountActions) {
            slotGroup.appendChild(window.AccountActions.row({
                ico: '🚪', act: 'leavegroup', label: this._t('profile.group.leave'),
                sub: this._t('profile.group.leaveSub'),
                // O `userStateChanged` do leaveGroup já recarrega a tela (traz a lista de
                // grupos de volta); o onDone fica para quem não tem o ouvinte (teste isolado).
                onClick: () => window.AccountActions.confirmLeaveGroup({ name: p.group.name })
            }));
        }

        // Reenviar confirmação — a MESMA linha da gaveta.
        const slotVerify = c.querySelector('[data-slot=verify]');
        if (slotVerify) slotVerify.appendChild(window.AccountActions.row({
            ico: '✉️', act: 'verify', label: this._t('auth.resendVerification'),
            onClick: () => this._resend()
        }));

        // Ajustes: o interruptor do diário (gate de LGPD), o mesmo objeto da gaveta.
        const slotPrefs = c.querySelector('[data-slot=prefs]');
        if (slotPrefs && window.AccountActions) {
            // 🔴 O do RANKING vem primeiro: é o único que publica alguma coisa para outras
            //    pessoas, e é o que a pessoa nunca escolheu (a conta do Google leva nome
            //    completo e foto para uma página pública). O do diário é sobre o histórico
            //    dela mesma.
            slotPrefs.appendChild(window.AccountActions.rankingToggle());
            slotPrefs.appendChild(window.AccountActions.diaryToggle());
        }

        // Conta: sair · zerar progresso · apagar conta (as duas últimas, destrutivas, por último).
        const slotAcc = c.querySelector('[data-slot=account]');
        if (slotAcc && window.AccountActions) {
            slotAcc.appendChild(window.AccountActions.row({
                ico: '🚪', act: 'signout', label: this._t('auth.signOut'),
                onClick: () => window.AccountActions.signOut()
            }));
            slotAcc.appendChild(window.AccountActions.row({
                ico: '♻️', act: 'reset', danger: true, label: this._t('profile.reset.title'),
                sub: this._t(p.scores > 0 ? 'profile.reset.sub' : 'profile.reset.subEmpty', { n: p.scores }),
                onClick: () => window.AccountActions.confirmReset({ scores: p.scores, onDone: () => this._refresh() })
            }));
            slotAcc.appendChild(window.AccountActions.row({
                ico: '🗑️', act: 'delete', danger: true, label: this._t('auth.deleteAccount'),
                onClick: () => window.AccountActions.confirmDelete()
            }));
        }

        // Idioma: o seletor REAL do shell, clonado (hrefs por domínio + conserto do lab).
        // Sem header montado (teste isolado, página sem shell) o cartão fica só com o nome
        // do idioma — nunca com três links inventados aqui.
        const slotLang = c.querySelector('[data-slot=lang]');
        const fonte = window.appHeader && window.appHeader.langEl;
        if (slotLang && fonte) slotLang.appendChild(fonte.cloneNode(true));
    }

    async _saveName() {
        if (this._saving) return;
        const input = this.container.querySelector('#pf-name');
        if (!input) return;
        const valor = input.value;
        this._saving = true;
        const btn = this.container.querySelector('[data-act=save]');
        if (btn) btn.disabled = true;
        this._selfUpdate = true;
        const r = await window.userManager?.updateProfile({ name: valor });
        this._selfUpdate = false;   // já foi consumida no dispatch síncrono do setUser
        this._saving = false;
        if (!this._isMounted()) return;
        if (!r || !r.success) {
            // Sessão morta já derrubou o login e o `userStateChanged` vai remontar a tela:
            // pintar erro no formulário seria falar por cima do que já foi dito.
            if (r && r.code === 'session_expired') return;
            this._formError = (r && r.code) || 'generic';
            this.render();
            return;
        }
        // 🔴 O que fica na tela é o nome que VOLTOU (cortado/limpo pelo servidor).
        if (this._profile) this._profile.name = r.name;
        this._editing = false;
        this._formError = '';
        this.render();
        window.notifications?.toast(this._t('profile.nameSaved'), { type: 'success' });
    }

    /** Entrar no grupo pelo código digitado. A recusa é do servidor e fica no formulário. */
    async _joinGroup() {
        if (this._joining) return;
        const input = this.container.querySelector('#pf-code');
        if (!input) return;
        const code = input.value;
        this._joining = true;
        const btn = this.container.querySelector('[data-act=joingroup]');
        if (btn) btn.disabled = true;
        // Sucesso dispara `userStateChanged` (setUser com o grupo) → o ouvinte de `load`
        // recarrega o cadastro, e o cartão já nasce no estado "com grupo".
        const r = await window.userManager?.joinGroup(code);
        this._joining = false;
        if (!this._isMounted()) return;
        if (!r || !r.success) {
            if (r && r.code === 'session_expired') return;
            this._groupError = (r && r.code) || 'generic';
            this.render();
            const again = this.container.querySelector('#pf-code');
            if (again) { again.value = code; again.focus(); }
            return;
        }
        this._groupError = '';
        window.notifications?.toast(this._t('profile.group.joined', { name: r.group.name }), { type: 'success' });
    }

    /** Admin: criar grupo pela AÇÃO. O código volta na resposta e a lista é relida. */
    async _createGroup() {
        if (this._creating) return;
        const input = this.container.querySelector('#pf-groupname');
        if (!input) return;
        this._creating = true;
        const r = await window.userManager?.createGroup(input.value);
        this._creating = false;
        if (!this._isMounted()) return;
        if (!r || !r.success) {
            if (r && r.code === 'session_expired') return;
            this._adminError = (r && r.code) || 'generic';
            this.render();
            return;
        }
        this._adminError = '';
        window.notifications?.toast(this._t('profile.group.admin.created', { name: r.group.name, code: r.group.code }), { type: 'success' });
        await this._refresh();
    }

    /** Admin: decide um pedido (`decide_group`); a nota vai no e-mail. Relê a fila depois. */
    async _decide(gid, decision) {
        if (this._deciding) return;
        const input = this.container.querySelector(`[data-qnote="${gid}"]`);
        const note = input ? input.value : '';
        // A nota sobrevive a uma falha de rede (o render recria o campo; auditoria M8).
        this._qnotes = this._qnotes || {}; this._qnotes[gid] = note;
        this._deciding = true;
        this.container.querySelectorAll(`[data-gid="${gid}"]`).forEach(b => { b.disabled = true; });
        const r = await window.userManager?.decideGroup(gid, decision, note);
        this._deciding = false;
        if (!this._isMounted()) return;
        if (!r || !r.success) {
            if (r && r.code === 'session_expired') return;
            this._queueError = (r && r.code) || 'generic';
            this.render();
            return;
        }
        this._queueError = '';
        if (this._qnotes) delete this._qnotes[gid];
        const decKey = decision === 'reject' ? 'profile.group.adminQueue.statusRejected' : 'profile.group.adminQueue.statusLive';
        window.notifications?.toast(this._t('profile.group.adminQueue.decided', { name: r.group.name, status: this._t(decKey) }), { type: 'success' });
        await this._refresh();
    }

    async _resend() {
        const um = window.userManager;
        const r = um && um.resendVerification ? await um.resendVerification(um.getUserEmail()) : null;
        const okk = !!(r && r.success);
        window.notifications?.toast(
            this._t(okk ? 'auth.toasts.verifySent' : 'auth.errors.' + ((r && r.code) || 'generic')),
            { type: okk ? 'success' : 'error' });
    }

    // ----- utilidades -------------------------------------------------------------

    /** 'YYYY-MM-DD HH:MM:SS' (MySQL) → data por extenso no idioma da tela. */
    _fmtDate(ts) {
        const s = String(ts || '').trim();
        if (!s) return '';
        const d = new Date(s.replace(' ', 'T'));
        if (isNaN(d.getTime())) return s.slice(0, 10);
        const lang = (window.language && window.language.currentLanguage) || 'pt';
        try {
            return new Intl.DateTimeFormat(ProfileScreen.LOCALE[lang] || 'pt-BR',
                { year: 'numeric', month: 'long', day: 'numeric' }).format(d);
        } catch (e) { return s.slice(0, 10); }
    }

    static _css() {
        // Paleta = a do app (indigo #6366f1/#4f46e5), a mesma do Ranking e do "Meu progresso".
        return `
        .pf-screen{max-width:640px;margin:0 auto;padding:1rem 1rem 3rem;}
        .pf-head{text-align:center;margin-bottom:1rem;}
        .pf-title{margin:0 0 .2rem;font-size:1.6rem;}
        .pf-sub{margin:0;color:#64748b;font-size:.95rem;}
        .pf-state{text-align:center;color:#64748b;padding:2rem 1rem;}
        .pf-card{background:#fff;border:1px solid #eef0f5;border-radius:14px;padding:1rem 1.1rem;margin-bottom:.9rem;box-shadow:0 2px 10px rgba(0,0,0,.05);}
        .pf-h2{margin:0 0 .6rem;font-size:1.05rem;color:#1f2937;}
        .pf-invite{text-align:center;padding:1.6rem 1.1rem;color:#475569;line-height:1.5;}
        .pf-invite p{margin:0 0 .9rem;}
        .pf-invitetitle{font-weight:700;color:#1f2937;font-size:1.05rem;}
        .pf-invitebtns{display:flex;gap:.6rem;justify-content:center;flex-wrap:wrap;}
        /* Botões: 44px de alvo no celular (medido pelos testes a 390px); em tela larga o alvo é
           de mouse e o botão fica mais baixo — era o que os deixava "grandes demais" no desktop.
           Hierarquia: cheio = a ação da seção; ghost = secundária; link = editar em linha. */
        .pf-btn{display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;min-height:44px;padding:.5rem 1.1rem;border:none;border-radius:999px;
            background:#4f46e5;color:#fff;font-weight:600;font-size:.9rem;font-family:inherit;cursor:pointer;text-decoration:none;line-height:1.2;}
        .pf-btn:hover{background:#4338ca;}
        .pf-btn[disabled]{opacity:.6;cursor:default;}
        .pf-btn--ghost{background:#eef2ff;color:#3730a3;}
        .pf-btn--ghost:hover{background:#e0e7ff;}
        .pf-btn--small{padding:.35rem .9rem;font-size:.85rem;}
        .pf-btn--link{background:transparent;color:#4f46e5;padding-left:.7rem;padding-right:.7rem;}
        .pf-btn--link:hover{background:#eef2ff;}
        @media (min-width:700px){
            .pf-btn{min-height:38px;}
            .pf-btn--small{min-height:34px;}
        }
        .pf-idhead{display:flex;align-items:center;gap:.9rem;}
        .pf-avatar{flex:0 0 auto;display:inline-flex;}
        .pf-idinfo{min-width:0;}
        .pf-name{margin:0;font-weight:800;color:#1f2937;font-size:1.1rem;overflow-wrap:anywhere;}
        .pf-email{margin:.15rem 0 0;color:#64748b;font-size:.9rem;overflow-wrap:anywhere;}
        .pf-badges{display:flex;flex-wrap:wrap;gap:.35rem;margin-top:.4rem;}
        .pf-badge{display:inline-block;padding:.15rem .5rem;border-radius:999px;font-size:.7rem;font-weight:800;text-transform:uppercase;letter-spacing:.04em;}
        .pf-badge--ok{background:#dcfce7;color:#166534;}
        .pf-badge--warn{background:#fef3c7;color:#78350f;}
        .pf-badge--admin{background:#e0e7ff;color:#3730a3;}
        .pf-since{margin:.8rem 0 0;color:#64748b;font-size:.85rem;}
        .pf-note{margin:.6rem 0 0;color:#64748b;font-size:.82rem;line-height:1.45;}
        .pf-rowline{display:flex;align-items:center;justify-content:space-between;gap:.7rem;flex-wrap:wrap;}
        .pf-value{color:#1f2937;font-weight:600;overflow-wrap:anywhere;}
        .pf-list{margin:0;padding-left:1.1rem;color:#1f2937;}
        .pf-list li{margin:.15rem 0;}
        .pf-label{display:block;font-size:.8rem;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.04em;margin-bottom:.3rem;}
        .pf-input{width:100%;min-height:44px;padding:.5rem .7rem;border:1px solid #d9dbe6;border-radius:10px;font-size:1rem;font-family:inherit;color:#1f2937;background:#fff;}
        .pf-input:focus{outline:2px solid #6366f1;outline-offset:1px;}
        .pf-formbtns{display:flex;gap:.6rem;margin-top:.7rem;flex-wrap:wrap;}
        .pf-error{margin:.5rem 0 0;color:#b91c1c;font-size:.88rem;}
        .pf-actions{display:flex;flex-direction:column;gap:.15rem;}
        /* As linhas de ação vêm do AccountActions (as MESMAS da gaveta ☰): dentro do cartão
           elas ganham a borda entre irmãs, e mais nada — alvo, estado e rótulo são de lá. */
        .pf-actions .nav-menu-item + .nav-menu-item{border-top:1px solid #f1f3f6;}
        .pf-groupname{font-weight:700;}
        .pf-groupcount{color:#64748b;font-size:.88rem;white-space:nowrap;}
        .pf-groupcta{margin-top:.7rem;}
        .pf-subgroup{margin-top:1rem;padding-top:.9rem;border-top:1px solid #eef0f5;}
        .pf-joinother{margin-top:1rem;padding-top:.4rem;border-top:1px solid #eef0f5;}
        .pf-joinother>summary{min-height:44px;display:flex;align-items:center;cursor:pointer;color:#3730a3;font-weight:600;font-size:.92rem;list-style:none;}
        .pf-joinother>summary::-webkit-details-marker{display:none;}
        .pf-joinother>summary::before{content:'▸';margin-right:.45rem;transition:transform .15s;}
        .pf-joinother[open]>summary::before{transform:rotate(90deg);}
        .pf-groupintro{margin:0 0 .7rem;color:#475569;font-size:.92rem;line-height:1.5;}
        .pf-groupform{margin-top:.2rem;}
        .pf-codeinput{text-transform:uppercase;letter-spacing:.14em;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;}
        .pf-grouplist{margin-top:.8rem;}
        .pf-groupitem{white-space:nowrap;color:#1f2937;font-weight:600;}
        .pf-adminlist{margin-bottom:.8rem;}
        .pf-code{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;background:#eef2ff;color:#3730a3;padding:.1rem .45rem;border-radius:6px;letter-spacing:.08em;font-weight:700;}
        .pf-code--big{font-size:1.25rem;padding:.35rem .7rem;letter-spacing:.16em;}
        .pf-badge--off{background:#f1f5f9;color:#475569;}
        .pf-request{margin-top:1rem;padding-top:.9rem;border-top:1px solid #f1f3f6;}
        .pf-ctarow{display:flex;align-items:center;gap:.35rem;flex-wrap:wrap;}
        .pf-request .pf-note{margin:0 0 .6rem;}
        .pf-invite{margin:.6rem 0 .4rem;display:flex;flex-direction:column;gap:.25rem;}
        .pf-invite .pf-label{margin-top:.5rem;}
        .pf-link{color:#3730a3;font-size:.88rem;overflow-wrap:anywhere;min-height:44px;display:inline-flex;align-items:center;}
        .pf-decision{margin-top:.4rem;}
        .pf-qlist{list-style:none;margin:0;padding:0;}
        .pf-qlist--past{margin-top:.8rem;opacity:.85;}
        .pf-qitem{border:1px solid #eef0f5;border-radius:12px;padding:.8rem .9rem;margin-bottom:.7rem;}
        .pf-qhead{display:flex;gap:.7rem;align-items:flex-start;}
        .pf-qhead .pf-badge{margin-left:.4rem;vertical-align:middle;}
        .pf-qlogo{width:48px;height:48px;border-radius:10px;object-fit:contain;background:#f8fafc;border:1px solid #e5e7eb;flex:0 0 auto;}
        .pf-qby{margin:.2rem 0 0;}
        .pf-qdesc{margin:.6rem 0 0;color:#1f2937;font-size:.92rem;line-height:1.5;white-space:pre-wrap;overflow-wrap:anywhere;}
        .pf-langslot .lang-switch{display:inline-flex;gap:.4rem;}
        .pf-langslot .lang-link{min-height:44px;display:inline-flex;align-items:center;padding:.3rem .7rem;border-radius:8px;
            border:1px solid #d9dbe6;color:#4b5563;font-weight:700;font-size:.85rem;text-decoration:none;}
        .pf-langslot .lang-link-active{background:#4f46e5;border-color:#4f46e5;color:#fff;}
        @media (max-width:480px){
            .pf-screen{padding:.8rem .7rem 2.5rem;}
            .pf-title{font-size:1.35rem;}
            .pf-sub{display:none;}
            .pf-card{padding:.85rem .8rem;}
        }
.pf-traillist{list-style:none;margin:0 0 0.6rem;padding:0;display:flex;flex-direction:column;gap:0.5rem;}
.pf-trail{border:1.5px solid #e2e8f0;border-radius:12px;padding:0.55rem 0.7rem;}
.pf-trailhead{display:flex;flex-direction:column;gap:0.15rem;margin-bottom:0.45rem;}
.pf-trailname{font-weight:700;color:#0f172a;overflow-wrap:anywhere;}
.pf-trailmeta{font-size:0.8rem;color:#64748b;}
.pf-trailbtns{display:flex;flex-wrap:wrap;gap:0.4rem;}
.pf-btn--sm{min-height:44px;padding:0.4rem 0.8rem;font-size:0.88rem;}`;
    }
}

window.ProfileScreen = ProfileScreen;



// ============================================
// screens/TrailScreen.js
// ============================================
/**
 * TrailScreen — a TRILHA DO PROFESSOR: a CAPA (`#/trilha/:code`) e o EDITOR (`#/trilha/:code?edit=1`).
 * docs/LISTAS-PLANO.md, fase 1a, 17/set/2026.
 *
 * NÃO é jogo: estende BaseScreen (load → render). Rota AVULSA no Main (fora de GAMES/GAME_ROUTES
 * e de MENU). Chega-se por três portas: o LINK que o professor manda (Classroom, WhatsApp), o
 * cartão "Minhas trilhas" em #/perfil, e o "← ⟨trilha⟩" de dentro do jogo.
 *
 * Em português comum: o link abre esta página. Quem NÃO tem conta vê o nome da trilha, quem a
 * fez, a escola e quantos níveis — e as duas portas (entrar / criar conta). Quem tem conta vê
 * os níveis, onde está, e o botão de jogar. Quem a FEZ vê o link para copiar, "N começaram ·
 * M concluíram" e o editor.
 *
 * 🔴 A CAPA É PÚBLICA, OS NÍVEIS NÃO (decisão dele, 17/set): o servidor só manda `levels` com
 *    sessão; sem conta a tela nem tem o que mostrar além da capa. Jogar = `#/ritmo-livre?lista=`.
 * 🔴 NOME, RÓTULO, AUTOR E ESCOLA SÃO TEXTO DO AUTOR: tudo passa por `_esc` (a tela monta por
 *    innerHTML). Um `<img onerror>` no nome tem asserção.
 * 🔴 A recusa é do SERVIDOR e vira frase (`auth.errors.<code>`): nada é validado antes de
 *    postar (a lição de 13/ago). `maxlength` é só o teto do dedo.
 * 🔴 A OFICINA (o editor, refeita em 18/set — docs/TRILHAS-USABILIDADE-PROPOSTA.md): UMA tela
 *    para montar. O nível se edita AQUI: o mesmo painel ⚙️ do Ritmo Livre (`RhythmConfigPanel`
 *    com as seções de `RhythmSandbox.sections`) abre por cima e grava no NÍVEL — NUNCA no preset
 *    da pessoa (`applyPreset`/`setBpm` não existem aqui; guardado por mutante no `trails-test`).
 *    Cada nível aberto mostra um EXEMPLO desenhado do que a turma verá (gerador + renderer do
 *    jogo, com `RhythmSandbox.writeLevel` em memória e `apply()` logo depois, para o
 *    `EXERCISE_CONFIG` voltar ao da pessoa) e a linha do nível diz O QUE MUDOU em relação ao
 *    anterior. O jogo entra só para TESTAR (`?testar=1`: sem cadeado, sem gravar nada).
 * 🔴 Grava por OPERAÇÃO (autosave): campo de texto no `change`, chips/passos/⚙️/estrutura na
 *    hora (debounce). Cada gravação é um `list_put` com a lista INTEIRA — e é o servidor quem
 *    decide se o `rev` sobe (só quando o conteúdo muda).
 * 🔴 IDENTIDADE DO NÍVEL É O `lid`: duplicar gera lid novo; apagar tira o lid; a posição é só
 *    o número impresso. Reordenar, duplicar a LISTA e importar/exportar são da 1b.
 * 🔴 Só reage a `userStateChanged` quando o UID MUDA (a régua da GroupScreen): o check_session
 *    do boot reidrata a mesma sessão e dispararia um redesenho do editor em digitação.
 */
class TrailScreen extends BaseScreen {
    static TITLE_KEY = 'trail.title';
    static SAVE_DEBOUNCE_MS = 1000;          // era 400: cada toque virava um PUT (o balde é por conta)
    static SAVE_RETRY_MS = [3000, 10000, 30000, 60000];   // recusa do servidor: tenta de novo, com folga crescente
    /** O PUT que a instância anterior deixou em voo ao morrer: a próxima espera por ele antes de ler. */
    static _inflight = null;

    constructor() {
        super();
        this._code = '';
        this._edit = false;
        this._raw = null;        // o bloco do servidor (capa, e níveis se logado)
        this._data = null;       // a lista normalizada (RhythmTrails) — só com níveis
        this._logged = false;
        this._canEdit = false;
        this._stats = null;
        this._error = '';        // '' | 'notfound' | 'network'
        this._uid = null;
        this._onUserChange = null;
        this._reqId = 0;
        this._saveTimer = null;
        this._saving = false;
        this._saveState = '';    // '' | 'saving' | 'saved' | 'error:<code>'
        this._busy = false;
        this._asStudent = false; // `?aluno=1`: o dono vê a capa SEM o cartão de dono ("Ver como aluno")
        this._focusLid = '';     // `&lid=`: o nível a abrir e rolar até (voltando do teste, ou o recém-acrescentado)
        this._openLid = '';      // a oficina abre UM nível por vez
        this._newLid = '';       // o nível recém-adicionado leva a faixa "Nasceu igual ao nível N"
        this._examples = {};     // lid → padrão desenhado (cache: o exemplo só muda quando o preset muda ou a pedido)
        this._staff = null;      // o pentagrama do exemplo aberto (MusicStaff), destruído a cada troca
        this._panel = null;      // o RhythmConfigPanel da oficina (um só, religado ao nível aberto)
        this._panelLevel = null;
    }

    getTitle() {
        const name = this._raw && this._raw.name ? String(this._raw.name) : '';
        if (this._editing()) return this._t('trail.editTitle') + (name ? ' · ' + name : '');
        return name || this._t('trail.title');
    }

    // ----- ciclo ------------------------------------------------------------------

    async load(params = {}) {
        this._code = String(params.code || '').trim();
        this._edit = String(params.edit || '') === '1';          // `?edit=0` não é editor
        this._asStudent = String(params.aluno || '') === '1';
        this._focusLid = String(params.lid || '').trim();
        this._uid = this._currentUid();
        if (!this._onUserChange) {
            this._onUserChange = () => { this._afterUserChange(); };
            document.addEventListener('userStateChanged', this._onUserChange);
        }
        if (!this._onVis) {
            // 🔴 "Última aba vence": a oficina manda a lista INTEIRA a cada gravação; um nível acrescentado
            //    noutra aba (ou pelo Ritmo Livre, "vira o nível N+1") sumiria no chip seguinte. Ao voltar
            //    à aba, sem gravação pendente, relê — e redesenha só se o `rev` mudou.
            this._onVis = () => { if (document.visibilityState === 'visible') this._refetchIfChanged(); };
            document.addEventListener('visibilitychange', this._onVis);
        }
        // 🔴 O PUT fire-and-forget da instância anterior (destroy) pode chegar DEPOIS do GET desta:
        //    a oficina renasceria sem a última edição e o próximo PUT a apagaria (auditoria 18/set).
        if (TrailScreen._inflight) { try { await TrailScreen._inflight; } catch (e) {} }
        await this._fetch();
    }

    async _refetchIfChanged() {
        if (!this._editing() || this._saveTimer || this._saving || this._busy || this._unsaved) return;
        const um = window.userManager, T = window.RhythmTrails;
        if (!um || !um.fetchList) return;
        // Ficha PRÓPRIA (não o `_reqId` do `_fetch`: invalidá-lo deixava o `_afterUserChange` em voo
        // pintar a tela do usuário anterior). Toda gravação a invalida (`_saveNow`).
        const vis = (this._visId = (this._visId || 0) + 1), uid = this._uid;
        const r = await um.fetchList(this._code);
        if (vis !== this._visId || uid !== this._uid || !this._isMounted() || this._saveTimer || this._saving) return;
        if (!r.success || !r.logged) return;
        const fresh = T.normalizeList(r.list);
        // 🔴 Só um `rev` MAIOR conta: um GET lento respondendo depois de uma gravação daqui traria a
        //    lista VELHA por cima da nova (auditoria 18/set).
        if (!fresh || !(fresh.rev > this._data.rev)) return;
        this._raw = r.list; this._data = fresh; this._stats = r.stats || this._stats; this._examples = {};
        this._canEdit = !!r.can_edit; this._logged = !!r.logged;
        if (this._openLid && !T.byLid(fresh, this._openLid)) this._openLid = fresh.levels[0].lid;
        // o painel aberto apontava para o objeto de nível ANTIGO: toggles gravariam no vazio
        if (this._panel) this._panel.close();
        this._panelLevel = null;
        if (!this._editing()) { this.render(); return; }
        this._renderEditor();
    }

    destroy() {
        if (this._onUserChange) { document.removeEventListener('userStateChanged', this._onUserChange); this._onUserChange = null; }
        // 🔴 Edição pendente NÃO morre com a tela (auditoria 17/set: digitar e tocar em "voltar" em
        //    menos de 400 ms perdia o rótulo em silêncio). O flush é fire-and-forget; `_saveNow`
        //    lê `_data` antes do `await` e só não pinta depois (`_isMounted`).
        //    E o que uma recusa do servidor deixou por gravar (`_unsaved`) ganha uma última tentativa.
        if (this._saveTimer || this._unsaved) { clearTimeout(this._saveTimer); this._saveTimer = null; this._saveNow(); }
        if (this._onVis) { document.removeEventListener('visibilitychange', this._onVis); this._onVis = null; }
        if (this._panel) { this._panel.destroy(); this._panel = null; }
        if (this._staff) { try { this._staff.destroy(); } catch (e) {} this._staff = null; }
        super.destroy();
    }

    _currentUid() {
        const um = window.userManager;
        return (um && um.isLoggedIn() && um.getUserId) ? String(um.getUserId()) : null;
    }

    async _afterUserChange() {
        if (!this._isMounted()) return;
        const uid = this._currentUid();
        if (uid === this._uid) return;
        // 🔴 Sessão morta no meio da edição (401 no autosave, logout noutra aba): a tela vira capa de
        //    convidado e o que não subiu morreria. Guarda a lista com o uid de quem editava; se a MESMA
        //    pessoa entrar de novo, devolve e grava (auditoria 18/set).
        if (!uid && this._data && (this._unsaved || this._saveTimer || this._saving || this._dirty)) {
            clearTimeout(this._saveTimer); this._saveTimer = null;
            this._stash = { uid: this._uid, code: this._code, name: this._data.name, levels: JSON.parse(JSON.stringify(this._data.levels)) };
        }
        this._uid = uid;
        await this._fetch();
        if (!this._isMounted()) return;
        const st = this._stash;
        if (st && uid && st.uid === uid && st.code === this._code && this._editing()) {
            this._stash = null;
            const T = window.RhythmTrails;
            this._data.name = st.name;
            this._data.levels = st.levels.map(l => T.normalizeLevel(l, []));
            this._examples = {};
            this._unsaved = false;
            this._scheduleSave(0);
        }
        this.render();
    }

    async _fetch() {
        const um = window.userManager;
        const T = window.RhythmTrails;
        const id = ++this._reqId;
        this._error = '';
        const r = (um && um.fetchList) ? await um.fetchList(this._code) : { success: false, code: 'network' };
        if (id !== this._reqId) return;
        if (r.success) {
            this._raw = r.list;
            this._logged = !!r.logged;
            this._canEdit = !!r.can_edit;
            this._stats = r.stats || null;
            this._data = (r.logged && T) ? T.normalizeList(r.list) : null;
        } else {
            this._raw = null; this._data = null; this._canEdit = false; this._stats = null;
            this._error = (r.code === 'no_list' || r.code === 'bad_list') ? 'notfound' : 'network';
        }
    }

    _editing() { return this._edit && !this._asStudent && this._canEdit && !!this._data; }

    // ----- render -----------------------------------------------------------------

    renderLoading() {
        if (!this.container) return;
        this.container.innerHTML = this._shell(`<p class="tr-state">${this._esc(this._t('app.loading'))}</p>`, 'loading');
    }

    render() {
        this._syncDocumentTitle();
        if (this._error) { this._renderMissing(); return; }
        if (this._editing()) {
            const T = window.RhythmTrails;
            if (this._focusLid && T.byLid(this._data, this._focusLid)) this._openLid = this._focusLid;
            else if (!this._openLid || !T.byLid(this._data, this._openLid)) this._openLid = this._data.levels[0].lid;
            this._renderEditor(); this._scrollToFocus(); return;
        }
        this._renderCover();
    }

    /** Voltando do teste ou chegando com `&lid=`: rola até o nível (com 30+ níveis era uma caçada). */
    _scrollToFocus() {
        if (!this._focusLid) return;
        const row = this.container.querySelector(`[data-lid="${this._focusLid.replace(/"/g, '')}"]`);
        this._focusLid = '';
        try { if (row && row.scrollIntoView) row.scrollIntoView({ block: 'center' }); } catch (e) {}
    }

    /** Trilha PAUSADA pela administração: só dono/admin a veem, e têm de saber (os alunos recebem 404). */
    _pausedBanner() {
        if (!this._raw || this._raw.active !== false) return '';
        return `<p class="tr-paused" role="status">${this._esc(this._t('trail.paused'))}</p>`;
    }

    _shell(body, state) {
        return `
            <div class="tr-screen" data-state="${state}">
                <style>${TrailScreen._css()}</style>
                ${body}
            </div>`;
    }

    _renderMissing() {
        const key = this._error === 'notfound' ? 'trail.notFound' : 'app.loadError';
        this.container.innerHTML = this._shell(`
            <div class="tr-card tr-missing">
                <p class="tr-lead">${this._esc(this._t(key))}</p>
                ${this._error === 'network' ? `<button type="button" class="tr-btn" data-act="retry">${this._esc(this._t('profile.retry'))}</button>` : ''}
                <a class="tr-btn tr-btn--ghost" href="#/">${this._esc(this._t('nav.home'))}</a>
            </div>`, this._error);
        this.container.querySelector('[data-act=retry]')?.addEventListener('click', async () => {
            await this._fetch(); if (this._isMounted()) this.render();
        });
    }

    /** Autor e escola, ESCAPADOS (são texto de terceiros). */
    _byline(raw) {
        const a = raw.author && raw.author.name ? String(raw.author.name) : '';
        const g = raw.group && raw.group.name ? String(raw.group.name) : '';
        if (!a) return '';
        return this._esc(g ? this._t('trail.bySchool', { name: a, school: g }) : this._t('trail.by', { name: a }));
    }

    _levelsCount(n) {
        return this._esc(this._t(n === 1 ? 'trail.levelsOne' : 'trail.levels', { n }));
    }

    _link() {
        const origin = (typeof location !== 'undefined' && location.origin) ? location.origin : '';
        return `${origin}/app/#/trilha/${this._code}`;
    }

    _linkBox() {
        const link = this._link();
        return `
            <div class="tr-linkbox">
                <span class="tr-linklabel">${this._esc(this._t('trail.link'))}</span>
                <code class="tr-link" data-link>${this._esc(link)}</code>
                <button type="button" class="tr-btn tr-btn--ghost tr-btn--small" data-act="copylink" data-copy="${this._esc(link)}">${this._esc(this._t('profile.group.owner.copy'))}</button>
            </div>`;
    }

    _statsLine() {
        const s = this._stats;
        if (!s) return '';
        const txt = (s.started || 0) === 0 ? this._t('trail.statsNone') : this._t('trail.stats', { started: s.started || 0, finished: s.finished || 0 });
        return `<p class="tr-stats" data-stats>${this._esc(txt)}</p>`;
    }

    _renderCover() {
        const raw = this._raw;
        const T = window.RhythmTrails;
        const head = `
            <header class="tr-head">
                <p class="tr-kicker">${this._esc(this._t('trail.title'))}</p>
                <h1 class="tr-name">${this._esc(raw.name)}</h1>
                <p class="tr-by">${this._byline(raw)}${this._byline(raw) ? ' · ' : ''}${this._levelsCount(Number(raw.n_levels) || (this._data ? this._data.levels.length : 0))}</p>
            </header>`;
        let body;
        if (this._logged && !this._data) {
            // Logado e sem níveis = a lista veio corrompida/vazia: é ERRO, não "crie uma conta".
            this._error = 'network'; this._renderMissing(); return;
        }
        if (!this._logged) {
            // Convidado: o que é isto, o ESBOÇO dos níveis (nome e meta, sem link — o servidor manda só isso,
            // nunca o preset; auditoria 22/set: "ver uma trilha de exemplo" sem ver nível nenhum não mostrava o
            // formato) e as duas portas.
            const outline = Array.isArray(raw.outline) ? raw.outline : [];
            const sketch = outline.length ? `<div class="tr-card tr-outline" data-outline="${outline.length}">${outline.map((o, i) => {
                const meta = (o.pass != null ? this._t('rhythm.level.goal', { pass: o.pass }) : this._t('trail.training'))
                    + (o.takes > 1 ? ' · ' + this._t('rhythm.trails.takes', { done: 0, takes: o.takes }) : '')
                    + (o.seed ? ' · ' + this._t('trail.sameRhythm') : '');
                return `<div class="tr-level" data-state="outline" aria-disabled="true">
                    <span class="tr-num">${i + 1}</span>
                    <span class="tr-lvtxt"><span class="tr-lvname">${this._esc(o.label || this._t('rhythm.level.n', { n: i + 1 }))}</span><span class="tr-lvmeta">${this._esc(meta)}</span></span>
                    <span class="tr-lvstate" data-state="locked">🔒</span></div>`;
            }).join('')}</div>` : '';
            body = sketch + `
                <div class="tr-card tr-invite" data-guest>
                    <p>${this._esc(this._t('trail.guestWhat'))}</p>
                    <p>${this._esc(this._t('trail.guestIntro'))}</p>
                    <div class="tr-btns">
                        <button type="button" class="tr-btn" data-act="signup">${this._esc(this._t('profile.guestSignUp'))}</button>
                        <button type="button" class="tr-btn tr-btn--ghost" data-act="signin">${this._esc(this._t('profile.guestSignIn'))}</button>
                    </div>
                </div>`;
        } else {
            const list = this._data;
            const cur = T.currentLid(list);
            const curPos = T.indexOf(list, cur) + 1;
            const done = list.levels.filter(l => T.isCleared(list, l.lid)).length;
            // "você está aqui" = o 1º nível aberto e NÃO concluído (o `current` guardado pode ser um já
            // concluído, e a capa ficava sem marcador entre um ✓ e um 🔒 — auditoria 22/set).
            const firstOpen = list.levels.find(l => T.isUnlocked(list, l.lid) && !T.isCleared(list, l.lid));
            const hereLid = firstOpen ? firstOpen.lid : cur;
            const rows = list.levels.map((l, i) => {
                const unlocked = T.isUnlocked(list, l.lid), cleared = T.isCleared(list, l.lid), isCur = l.lid === hereLid;
                const meta = (l.pass != null ? this._t('rhythm.level.goal', { pass: l.pass }) : this._t('trail.training'))
                    + (l.takes > 1 ? ' · ' + this._t('rhythm.trails.takes', { done: Math.min(T.doneCount(list, l.lid), l.takes), takes: l.takes }) : '')
                    + (l.seed != null ? ' · ' + this._t('trail.sameRhythm') : '');
                // 🔴 O cadeado ganha do ✓: um nível inserido no meio re-tranca os seguintes, e "✓ concluído"
                //    num nível sem link era uma linha morta (auditoria 17/set).
                const state = !unlocked ? 'locked' : (cleared ? 'cleared' : (isCur ? 'current' : 'open'));
                const stateTxt = !unlocked ? this._t('trail.locked') : (cleared ? this._t('trail.cleared') : (isCur ? this._t('trail.current') : ''));
                const inner = `
                    <span class="tr-num">${i + 1}</span>
                    <span class="tr-lvtxt">
                        <span class="tr-lvname">${this._esc(l.label || this._t('rhythm.level.n', { n: i + 1 }))}</span>
                        <span class="tr-lvmeta">${this._esc(meta)}</span>
                    </span>
                    <span class="tr-lvstate" data-state="${state}">${!unlocked ? '🔒 ' : (cleared ? '✓ ' : '')}${this._esc(stateTxt)}</span>`;
                return unlocked
                    ? `<a class="tr-level" data-lid="${this._esc(l.lid)}" data-state="${state}" href="#/ritmo-livre?lista=${this._esc(this._code)}&nivel=${this._esc(l.lid)}">${inner}</a>`
                    : `<div class="tr-level" data-lid="${this._esc(l.lid)}" data-state="${state}" aria-disabled="true">${inner}</div>`;
            }).join('');
            const allDone = done >= list.levels.length;
            body = '';
            // "Ver como aluno" era um beco: sem o cartão do dono não havia como voltar (auditoria 18/set).
            if (this._canEdit && this._asStudent) {
                body += `<p class="tr-asstudent" data-asstudent>${this._esc(this._t('trail.asStudent'))} · <a href="#/trilha/${this._esc(this._code)}?edit=1" data-act="backworkshop">${this._esc(this._t('trail.backToWorkshop'))}</a></p>`;
            }
            // O cartão do DONO vem ANTES dos níveis (com 120 níveis o link ficava a 8.000 px do topo):
            // retorno, link e editar — o que o professor veio buscar. "Ver como aluno" o esconde.
            if (this._canEdit && !this._asStudent) {
                body += `
                <div class="tr-card tr-owner" data-owner>
                    ${this._pausedBanner()}
                    ${this._statsLine()}
                    ${this._linkBox()}
                    <div class="tr-btns">
                        <a class="tr-btn" data-act="edit" href="#/trilha/${this._esc(this._code)}?edit=1">${this._esc(this._t('trail.edit'))}</a>
                    </div>
                </div>`;
            }
            body += `
                <div class="tr-card" data-player>
                    <div class="tr-playrow">
                        <div>
                            <p class="tr-progress" data-progress>${this._esc(this._t('trail.progress', { done, total: list.levels.length }))}</p>
                            <p class="tr-devnote" data-devnote>${this._esc(this._t('trail.deviceNote'))}</p>
                        </div>
                        <a class="tr-btn tr-play" data-act="play" href="#/ritmo-livre?lista=${this._esc(this._code)}">${this._esc(allDone ? this._t('trail.playAgain') : (curPos > 1 ? this._t('trail.continueAt', { n: curPos }) : this._t('trail.play')))}</a>
                    </div>
                    <div class="tr-levels" data-levels>${rows}</div>
                </div>`;
        }
        this.container.innerHTML = this._shell(head + body, this._logged ? 'ready' : 'guest');
        this._bindCommon();
        this.container.querySelectorAll('[data-act=signup],[data-act=signin]').forEach(b => b.addEventListener('click', () => {
            window.authModal?.open(b.dataset.act === 'signup' ? 'signup' : 'signin');
        }));
    }

    // ----- a oficina (editor) -------------------------------------------------------

    /** Resumo de um nível: fórmula · compassos · BPM · figuras (nomes do catálogo, traduzidos). */
    _levelSummary(l) {
        const p = l.preset || {};
        const beats = p.timeSig ? p.timeSig.beats : 4;
        const m = p.measures || 1;
        // A figura que o jogo LIGOU para fechar o compasso (não escolhida) vem marcada — §3 do plano.
        const auto = Array.isArray(p.autoFigures) ? p.autoFigures : [];
        const figs = (p.figures || []).map(id => this._figName(id) + (auto.includes(id) ? ' (' + this._t('trail.editor.auto') + ')' : '')).join(', ');
        // Tabela de LITERAIS (nunca 'rhythm.config.click' + x): o teste de i18n acha a chave no fonte.
        const CLICK_LABEL = { all: 'rhythm.config.clickAll', one: 'rhythm.config.clickOne', '24': 'rhythm.config.click24', none: 'rhythm.config.clickNone' };
        const parts = [`${beats}/4`, `${m} ${this._t(m === 1 ? 'trail.editor.measureOne' : 'trail.editor.measures')}`, `${p.bpm || 60} BPM`];
        if (p.ties) parts.push(this._t('trail.editor.ties'));
        if (p.click && p.click !== 'all' && CLICK_LABEL[p.click]) parts.push(this._t(CLICK_LABEL[p.click]).toLocaleLowerCase());
        return parts.join(' · ') + (figs ? ' · ' + figs : '');
    }

    _figName(id) {
        return (id === 'whole-rest' ? this._t('rhythm.config.measureRest') : this._t('rhythm.figures.' + id)).toLocaleLowerCase();
    }

    /**
     * O QUE MUDOU em relação ao nível anterior ("novo: colcheia · andamento 60 → 70") — é o que
     * faz uma sequência de 30 níveis ser legível numa olhada. Texto puro (quem imprime escapa).
     */
    _levelDiff(l, prev) {
        if (!prev) return '';
        const a = prev.preset || {}, b = l.preset || {};
        const fa = a.figures || [], fb = b.figures || [];
        const parts = [];
        const added = fb.filter(x => !fa.includes(x)), gone = fa.filter(x => !fb.includes(x));
        if (added.length) parts.push(this._t('trail.editor.diffNew', { x: added.map(id => this._figName(id)).join(', ') }));
        if (gone.length) parts.push(this._t('trail.editor.diffOut', { x: gone.map(id => this._figName(id)).join(', ') }));
        if (a.bpm !== b.bpm) parts.push(this._t('trail.editor.diffTempo', { a: a.bpm, b: b.bpm }));
        const ba = a.timeSig ? a.timeSig.beats : 4, bb = b.timeSig ? b.timeSig.beats : 4;
        if (ba !== bb) parts.push(this._t('trail.editor.diffSig', { a: ba + '/4', b: bb + '/4' }));
        if (a.measures !== b.measures) parts.push(this._t('trail.editor.diffBars', { n: b.measures }));
        if (!!a.ties !== !!b.ties) parts.push(this._t(b.ties ? 'trail.editor.diffTiesOn' : 'trail.editor.diffTiesOff'));
        return parts.length ? parts.join(' · ') : this._t('trail.editor.diffSame');
    }

    /** As opções de "Para passar" (chips): treino · 70 · 80 · 90, mais o valor gravado se for outro. */
    _passOptions(l) {
        const base = [70, 80, 90];
        if (l.pass != null && !base.includes(l.pass)) base.push(l.pass);
        return [null, ...base.sort((x, y) => x - y)];
    }

    _takesOptions(l) {
        const base = [1, 2, 3, 5];
        if (!base.includes(l.takes)) base.push(l.takes);
        return base.sort((x, y) => x - y);
    }

    _chip(label, on, attrs) {
        return `<button type="button" class="tr-chip" aria-pressed="${on ? 'true' : 'false'}" ${attrs}>${this._esc(label)}</button>`;
    }

    _renderLevelRow(l, i, list) {
        const T = window.RhythmTrails;
        const open = l.lid === this._openLid;
        const prev = list.levels[i - 1] || null;
        const diff = this._levelDiff(l, prev);
        const head = `
            <button type="button" class="tr-ehead" data-act="toggle" data-lid="${this._esc(l.lid)}" aria-expanded="${open ? 'true' : 'false'}">
                <span class="tr-num">${i + 1}</span>
                <span class="tr-etxt">
                    <span class="tr-ename">${this._esc(l.label || this._t('rhythm.level.n', { n: i + 1 }))}</span>
                    <span class="tr-esummary">${this._esc(this._levelSummary(l))}</span>
                    ${diff ? `<span class="tr-ediff${diff === this._t('trail.editor.diffSame') ? ' tr-ediff--same' : ''}" data-diff>${this._esc(diff)}</span>` : ''}
                </span>
                <span class="tr-chev" aria-hidden="true">▾</span>
            </button>`;
        if (!open) return `<li class="tr-erow" data-lid="${this._esc(l.lid)}" data-open="false">${head}</li>`;
        const passChips = this._passOptions(l).map(v => this._chip(v == null ? this._t('trail.editor.passTraining') : v + '%', l.pass === v || (v == null && l.pass == null), `data-act="pass" data-v="${v == null ? '' : v}"`)).join('');
        const takesChips = this._takesOptions(l).map(v => this._chip(String(v), l.takes === v, `data-act="takes" data-v="${v}"`)).join('');
        const body = `
            <div class="tr-ebody">
                ${this._newLid === l.lid ? `<p class="tr-newhint" data-newhint>${this._esc(this._t('trail.editor.newHint', { n: i }))}</p>` : ''}
                <p class="tr-extitle">${this._esc(this._t('trail.editor.exTitle'))}</p>
                <div class="tr-example" data-example></div>
                <div class="tr-ebtns">
                    <button type="button" class="tr-btn tr-btn--ghost tr-btn--small" data-act="regen">${this._esc(this._t(l.seed != null ? 'trail.editor.otherSeed' : 'trail.editor.otherEx'))}</button>
                    <button type="button" class="tr-btn tr-btn--small" data-act="panel">${this._esc(this._t('trail.editor.figs'))}</button>
                </div>
                <div class="tr-set">
                    <p class="tr-settitle">${this._esc(this._t('trail.editor.tempo'))}</p>
                    <div class="tr-stepper">
                        <button type="button" data-act="bpm" data-d="-5" aria-label="−5 BPM">−</button>
                        <b data-bpm>${Number(l.preset.bpm) || 60} BPM</b>
                        <button type="button" data-act="bpm" data-d="5" aria-label="+5 BPM">+</button>
                    </div>
                </div>
                <div class="tr-set">
                    <p class="tr-settitle">${this._esc(this._t('trail.editor.pass'))}</p>
                    <div class="tr-chips" data-pass>${passChips}</div>
                    ${l.pass == null ? `<p class="tr-setnote">${this._esc(this._t('trail.editor.passNote'))}</p>` : ''}
                </div>
                ${l.pass == null ? '' : `<div class="tr-set">
                    <p class="tr-settitle">${this._esc(this._t('trail.editor.takes'))}</p>
                    <div class="tr-chips" data-takes>${takesChips}</div>
                </div>`}
                <div class="tr-set">
                    <label class="tr-check tr-check--seed"><input type="checkbox" data-field="seed"${l.seed != null ? ' checked' : ''}>
                        <span>${this._esc(this._t('trail.editor.seed'))}<small>${this._esc(this._t('trail.editor.seedNote'))}</small></span></label>
                </div>
                <div class="tr-set">
                    <label class="tr-field tr-field--label"><span>${this._esc(this._t('trail.editor.label'))}</span>
                        <input type="text" maxlength="${T.LABEL_MAX}" data-field="label" value="${this._esc(l.label)}" placeholder="${this._esc(this._t('trail.editor.labelPh'))}"></label>
                </div>
                <p class="tr-savestate tr-savestate--row" data-savestate aria-hidden="true">${this._esc(this._saveStateText())}</p>
                <div class="tr-ebtns tr-ebtns--end">
                    <a class="tr-btn tr-btn--test" data-act="test" data-lid="${this._esc(l.lid)}" href="#/ritmo-livre?lista=${this._esc(this._code)}&nivel=${this._esc(l.lid)}&testar=1">${this._esc(this._t('trail.editor.test'))}</a>
                    <button type="button" class="tr-btn tr-btn--ghost tr-btn--small" data-act="dup" data-lid="${this._esc(l.lid)}">${this._esc(this._t('trail.editor.dup'))}</button>
                    <button type="button" class="tr-btn tr-btn--ghost tr-btn--small tr-btn--danger" data-act="del" data-lid="${this._esc(l.lid)}"${list.levels.length <= 1 ? ' disabled' : ''}>${this._esc(this._t('trail.editor.del'))}</button>
                </div>
            </div>`;
        return `<li class="tr-erow" data-lid="${this._esc(l.lid)}" data-open="true">${head}${body}</li>`;
    }

    _renderEditor() {
        const list = this._data;
        const T = window.RhythmTrails;
        if (this._staff) { try { this._staff.destroy(); } catch (e) {} this._staff = null; }
        const rows = list.levels.map((l, i) => this._renderLevelRow(l, i, list)).join('');
        // Tabela de LITERAIS inteiros (nunca prefixo + x montado em runtime): o teste de i18n acha a chave no fonte.
        const STEPS = {
            s1: ['trail.editor.s1', 'trail.editor.s1Lead'],
            s2: ['trail.editor.s2', 'trail.editor.s2Lead'],
            s3: ['trail.editor.s3', 'trail.editor.s3Lead']
        };
        const step = (n, key) => `
            <div class="tr-step"><b>${n}</b><h2 class="tr-h2">${this._esc(this._t(STEPS[key][0]))}</h2></div>
            <p class="tr-lead-left">${this._esc(this._t(STEPS[key][1]))}</p>`;
        const body = `
            <header class="tr-head tr-head--edit">
                <p class="tr-backline"><a href="#/perfil" data-act="back">← ${this._esc(this._t('profile.trails.title'))}</a></p>
                <p class="tr-kicker">${this._esc(this._t('trail.editor.kicker'))}</p>
                <label class="tr-field tr-field--name"><span>${this._esc(this._t('trail.editor.name'))}</span>
                    <input type="text" id="tr-name" maxlength="${T.NAME_MAX}" data-field="name" value="${this._esc(list.name)}" placeholder="${this._esc(this._t('trail.editor.namePh'))}"></label>
                <p class="tr-setnote">${this._esc(this._t('trail.editor.nameHint'))}</p>
                <p class="tr-savestate" data-savestate aria-live="polite">${this._esc(this._saveStateText())}</p>
                ${this._pausedBanner()}
            </header>
            <div class="tr-card">
                ${step(1, 's1')}
                <ol class="tr-elist" data-elist>${rows}</ol>
                <div class="tr-addrow">
                    <button type="button" class="tr-btn tr-btn--full" data-act="add"${list.levels.length >= T.MAX_LEVELS ? ' disabled' : ''}>${this._esc(this._t('trail.editor.add'))}</button>
                    <p class="tr-setnote tr-center">${this._esc(this._t('trail.editor.addNote'))}</p>
                </div>
            </div>
            <div class="tr-card tr-owner">
                ${step(2, 's2')}
                ${this._linkBox()}
                <div class="tr-btns">
                    <a class="tr-btn tr-btn--ghost" data-act="view" href="#/trilha/${this._esc(this._code)}?aluno=1">${this._esc(this._t('trail.viewAsStudent'))}</a>
                </div>
            </div>
            <div class="tr-card tr-owner">
                ${step(3, 's3')}
                ${this._statsLine() || `<p class="tr-stats" data-stats>${this._esc(this._t('trail.statsNone'))}</p>`}
            </div>
            <p class="tr-footer"><button type="button" class="tr-linkbtn" data-act="deltrail">${this._esc(this._t('trail.editor.delTrail'))}</button></p>`;
        // rótulo em digitação sem `change` (iOS não emite blur ao trocar de app): entra no nível antes de redesenhar
        const typing = this.container && this.container.querySelector('[data-field=label]');
        if (typing && document.activeElement === typing) {
            const lt = T.byLid(list, typing.closest('[data-lid]')?.dataset.lid);
            if (lt) { const v = String(typing.value || '').trim().slice(0, T.LABEL_MAX); if (v !== lt.label) { lt.label = v; this._scheduleSave(); } }
        }
        // redesenho inteiro a cada chip: o scroll não pode pular (página de 4.500 px com 30 níveis)
        const y = (typeof window !== 'undefined') ? window.scrollY : 0;
        this.container.innerHTML = this._shell(body, 'edit');
        this._bindCommon();
        this._bindEditor();
        this._renderExample();
        try { if (y) window.scrollTo(0, y); } catch (e) {}
    }

    _saveStateText() {
        const s = this._saveState;
        if (s === 'saving') return this._t('trail.editor.saving');
        if (s === 'saved') return this._t('trail.editor.saved');
        if (s.startsWith('error:')) return this._t('auth.errors.' + s.slice(6));
        return '';
    }

    _paintSaveState() {
        if (!this.container) return;
        // no cabeçalho E junto ao nível aberto (com 10+ níveis o do topo fica a 3.000 px do que se mexeu)
        this.container.querySelectorAll('[data-savestate]').forEach(el => {
            el.textContent = this._saveStateText();
            el.dataset.state = this._saveState.startsWith('error:') ? 'error' : this._saveState;
        });
    }

    /**
     * O EXEMPLO do nível aberto: o gerador e o renderer DO JOGO, sobre o preset do nível escrito
     * em memória (`writeLevel`) — e `apply()` logo depois, para o `EXERCISE_CONFIG` voltar ao da
     * pessoa. Cache por lid: o desenho só muda quando o preset muda ou a pedido ("Outro exemplo"),
     * senão cada toque num chip sortearia outro ritmo e a tela pareceria aleatória.
     * Com semente, é o ritmo EXATO que a turma vai tocar.
     */
    _renderExample(force = false) {
        const list = this._data;
        const T = window.RhythmTrails, S = window.RhythmSandbox;
        const l = list && T.byLid(list, this._openLid);
        const host = this.container && this.container.querySelector('[data-example]');
        if (!l || !host || !S || !window.RhythmPatternGenerator || !window.MusicStaff || !window.RhythmRenderer) return;
        if (this._staff) { try { this._staff.destroy(); } catch (e) {} this._staff = null; }
        host.innerHTML = '';
        let pattern = force ? null : this._examples[l.lid];
        if (!pattern) {
            try {
                S.writeLevel(l.preset);
                const gen = new window.RhythmPatternGenerator(window.EXERCISE_CONFIG, T.rngFor(l));
                pattern = gen.generate();
                pattern.config = { ...pattern.config, bpm: l.preset.bpm };
            } catch (e) { pattern = null; }
            // 🔴 devolve o EXERCISE_CONFIG ao preset da PESSOA (o jogo re-sincroniza a cada rodada de
            //    qualquer jeito; isto é a oficina não deixando rastro).
            try { S.apply(); } catch (e) {}
            if (!pattern) return;
            this._examples[l.lid] = pattern;
        }
        const w = host.clientWidth || 340;
        const mobile = w < 560;
        try {
            this._staff = new window.MusicStaff(host, { width: w, height: 150, lineSpacing: 10, marginLeft: mobile ? 14 : 60, marginRight: mobile ? 12 : 40, marginTop: 40 });
            const r = new window.RhythmRenderer(this._staff);
            Object.assign(r.LAYOUT, { clefSpace: mobile ? 48 : 80, leftInset: mobile ? 10 : 22 });
            r.reserveResponseBand = false;
            r.render(pattern);
            const svg = host.querySelector('svg');
            if (svg) { svg.setAttribute('role', 'img'); svg.setAttribute('aria-label', this._t('trail.editor.exTitle')); }
        } catch (e) { /* sem desenho não há exemplo; a oficina continua */ }
    }

    /** O painel ⚙️ da oficina: o MESMO `RhythmConfigPanel`, religado ao nível aberto. */
    _openLevelPanel(level) {
        const S = window.RhythmSandbox;
        const t = (k, v) => this._t(k, v);
        if (!window.RhythmConfigPanel || !S) return;
        this._panelLevel = level;
        const pos = window.RhythmTrails.indexOf(this._data, level.lid) + 1;
        const title = this._t('trail.editor.panelTitle', { n: pos });
        if (!this._panel) {
            this._panel = new window.RhythmConfigPanel({
                title,
                labels: { reset: t('trail.editor.resetLevel'), close: t('rhythm.config.close') },
                sections: S.sections(level.preset, { t }),
                canToggle: (sid, iid, next, en) => S.canToggle(this._panelLevel.preset, sid, iid, next, en, t),
                onChange: (en, meta) => this._applyLevelSelection(en, meta),
                onReset: () => {
                    this._panelLevel.preset = S.normalize(S.defaultPreset(), { level: true });
                    this._afterLevelChange(this._panelLevel, { preset: true });
                    return S.sections(this._panelLevel.preset, { t });
                }
            });
        } else {
            this._panel.title = title;
            this._panel.setSections(S.sections(level.preset, { t }));
        }
        this._panel.open();
        const h = this._panel.drawer && this._panel.drawer.querySelector('h2');
        if (h) h.textContent = title;
    }

    /**
     * Painel → preset DO NÍVEL (`normalize`, régua de nível: BPM inteiro, `tieProb`). 🔴 NUNCA
     * `applyPreset`/`setBpm`: a oficina não grava no aparelho da pessoa (mutante no trails-test).
     */
    _applyLevelSelection(enabledBySection, meta = null) {
        const S = window.RhythmSandbox;
        const level = this._panelLevel;
        if (!level) return;
        const cur = level.preset;
        const n = S.normalize(S.presetFromSelection(cur, enabledBySection, meta), { level: true });
        level.preset = n;
        // Fórmula e nº de compassos mudam o que cabe, o que precisa ser ligado e o que se pode
        // escolher: o painel se redesenha e DIZ o que ligou por conta própria.
        const novos = n.autoFigures.filter(id => !cur.autoFigures.includes(id));
        if (this._panel && (n.timeSig.beats !== cur.timeSig.beats || n.measures !== cur.measures || n.autoFigures.join() !== cur.autoFigures.join())) {
            this._panel.setSections(S.sections(n, { t: (k, v) => this._t(k, v) }));
            if (novos.length) this._panel.warn(this._t('rhythm.config.autoAdded', { sig: `${n.timeSig.beats}/4`, fig: novos.map(id => this._figName(id)).join(', ') }));
        }
        this._afterLevelChange(level, { preset: true });
    }

    /** Depois de mexer num nível: cache do exemplo (se o preset mudou), redesenho e gravação. */
    _afterLevelChange(level, { preset = false } = {}) {
        if (preset) delete this._examples[level.lid];
        this._renderEditor();
        this._scheduleSave();
    }

    _bindCommon() {
        const c = this.container;
        // Copiar o link (o molde do #/perfil): sem clipboard o texto fica selecionado.
        c.querySelectorAll('[data-act=copylink]').forEach(b => b.addEventListener('click', async () => {
            const txt = b.dataset.copy || '';
            let okc = false;
            try { if (navigator.clipboard && navigator.clipboard.writeText) { await navigator.clipboard.writeText(txt); okc = true; } } catch (e) {}
            if (!okc) {
                try {
                    const ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', '');
                    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;'; document.body.appendChild(ta); ta.select();
                    okc = document.execCommand && document.execCommand('copy'); document.body.removeChild(ta);
                } catch (e) { okc = false; }
            }
            if (okc) { window.notifications?.toast(this._t('profile.group.owner.copied'), { type: 'success', duration: 1600 }); return; }
            const alvo = c.querySelector('[data-link]');
            try { const r = document.createRange(); r.selectNodeContents(alvo); const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r); } catch (e) {}
            window.notifications?.toast(this._t('profile.group.owner.copyFailed'), { type: 'info', duration: 2600 });
        }));
    }

    _bindEditor() {
        const c = this.container;
        const T = window.RhythmTrails;
        const list = this._data;
        const byRow = (el) => { const row = el.closest('[data-lid]'); return row ? T.byLid(list, row.dataset.lid) : null; };
        const flush = () => this._flush();

        c.querySelector('[data-field=name]')?.addEventListener('change', (e) => {
            list.name = String(e.target.value || '').trim().slice(0, T.NAME_MAX);
            this._scheduleSave();
        });
        // abrir/fechar um nível (um por vez)
        c.querySelectorAll('[data-act=toggle]').forEach(b => b.addEventListener('click', () => {
            const lid = b.dataset.lid;
            if (this._newLid && this._newLid !== lid) this._newLid = '';
            this._openLid = this._openLid === lid ? '' : lid;
            this._renderEditor();
        }));
        c.querySelector('[data-act=regen]')?.addEventListener('click', () => {
            const l = T.byLid(list, this._openLid); if (!l) return;
            if (l.seed != null) {
                // "Sortear outro ritmo": a semente é o ritmo da turma — muda e GRAVA
                l.seed = T.newSeed(); l.gen = window.RhythmPatternGenerator ? window.RhythmPatternGenerator.GEN : 1;
                this._afterLevelChange(l, { preset: true });
            } else {
                this._renderExample(true);
            }
        });
        c.querySelector('[data-act=panel]')?.addEventListener('click', () => {
            const l = T.byLid(list, this._openLid); if (l) this._openLevelPanel(l);
        });
        c.querySelectorAll('[data-act=bpm]').forEach(b => b.addEventListener('click', () => {
            const l = T.byLid(list, this._openLid); if (!l) return;
            const S = window.RhythmSandbox;
            const bpm = Math.max(S.BPM_MIN, Math.min(S.BPM_MAX, (Number(l.preset.bpm) || 60) + Number(b.dataset.d)));
            if (bpm === l.preset.bpm) return;
            l.preset = S.normalize({ ...l.preset, figures: S.storedFigures(l.preset), bpm }, { level: true });
            this._afterLevelChange(l, { preset: true });
        }));
        c.querySelectorAll('[data-act=pass]').forEach(b => b.addEventListener('click', () => {
            const l = T.byLid(list, this._openLid); if (!l) return;
            const v = b.dataset.v;
            l.pass = v === '' ? null : Math.max(0, Math.min(100, Math.round(Number(v))));
            // Treino não tem "vezes": um `takes` escondido trancava o próximo nível com a faixa
            // dizendo "liberado" (auditoria 18/set).
            if (l.pass == null) l.takes = 1;
            this._afterLevelChange(l);
        }));
        c.querySelectorAll('[data-act=takes]').forEach(b => b.addEventListener('click', () => {
            const l = T.byLid(list, this._openLid); if (!l) return;
            const n = Number(b.dataset.v);
            l.takes = Number.isFinite(n) && n >= 1 ? Math.min(T.TAKES_MAX, Math.round(n)) : 1;
            this._afterLevelChange(l);
        }));
        c.querySelectorAll('[data-field=label]').forEach(inp => inp.addEventListener('change', (e) => {
            const l = byRow(e.target); if (!l) return;
            l.label = String(e.target.value || '').trim().slice(0, T.LABEL_MAX);
            const row = e.target.closest('[data-lid]');
            const nm = row && row.querySelector('.tr-ename');
            if (nm) nm.textContent = l.label || this._t('rhythm.level.n', { n: T.indexOf(list, l.lid) + 1 });
            this._scheduleSave();
        }));
        c.querySelectorAll('[data-field=seed]').forEach(inp => inp.addEventListener('change', (e) => {
            const l = byRow(e.target); if (!l) return;
            if (e.target.checked) { l.seed = T.newSeed(); l.gen = window.RhythmPatternGenerator ? window.RhythmPatternGenerator.GEN : 1; }
            else { l.seed = null; l.gen = null; }
            this._afterLevelChange(l, { preset: true });
        }));
        // Testar: grava o pendente ANTES de sair (o jogo busca a lista do servidor)
        c.querySelectorAll('[data-act=test]').forEach(a => a.addEventListener('click', async (e) => {
            e.preventDefault();
            const r = await flush();
            // recusado = o jogo testaria o nível VELHO; a pessoa fica, com a frase do erro à vista
            if (r && !r.success) { window.notifications?.toast(this._t('auth.errors.' + (r.code || 'generic')), { type: 'error', duration: 3000 }); return; }
            if (!this._isMounted()) return;   // desistiu e saiu enquanto o PUT lento corria
            window.location.hash = a.getAttribute('href');
        }));
        c.querySelectorAll('[data-act=dup]').forEach(b => b.addEventListener('click', () => {
            const i = T.indexOf(list, b.dataset.lid);
            if (i < 0 || list.levels.length >= T.MAX_LEVELS) return;
            const src = list.levels[i];
            const S = window.RhythmSandbox;
            // sem as figuras ligadas só para fechar o compasso: a cópia as religa como `auto`, não como escolha
            const copy = T.normalizeLevel({ ...src, lid: T.newLid(list.levels.map(x => x.lid)), preset: { ...src.preset, figures: S.storedFigures(src.preset) }, seed: null, gen: null }, list.levels.map(x => x.lid));
            list.levels.splice(i + 1, 0, copy);
            this._openLid = copy.lid; this._newLid = '';
            this._renderEditor();
            this._scheduleSave(0);
        }));
        c.querySelectorAll('[data-act=del]').forEach(b => b.addEventListener('click', () => {
            const i = T.indexOf(list, b.dataset.lid);
            if (i < 0 || list.levels.length <= 1 || !window.notifications) return;
            window.notifications.modal({
                title: this._t('trail.editor.del'),
                html: `<p style="text-align:center;margin:0;color:#475569;">${this._esc(this._t('trail.editor.delLevelConfirm', { n: i + 1 }))}</p>`,
                actions: [
                    { label: this._t('trail.editor.del'), style: 'linear-gradient(135deg,#ef4444,#dc2626)', onClick: () => {
                        const k = T.indexOf(list, b.dataset.lid);
                        if (k < 0 || list.levels.length <= 1) return;
                        list.levels.splice(k, 1);
                        delete this._examples[b.dataset.lid];
                        this._openLid = list.levels[Math.max(0, k - 1)].lid; this._newLid = '';
                        this._renderEditor();
                        this._scheduleSave(0);
                    } },
                    { label: this._t('trail.cancel'), style: 'neutral' }
                ]
            });
        }));
        c.querySelector('[data-act=add]')?.addEventListener('click', () => {
            if (list.levels.length >= T.MAX_LEVELS) return;
            // Nasce igual ao ANTERIOR (o último): "mude uma coisa" é a instrução — na hora certa.
            const src = list.levels[list.levels.length - 1];
            const S = window.RhythmSandbox;
            const novo = T.normalizeLevel({ preset: { ...src.preset, figures: S.storedFigures(src.preset) }, pass: src.pass, takes: src.takes, label: '' }, list.levels.map(x => x.lid));
            list.levels.push(novo);
            this._openLid = novo.lid; this._newLid = novo.lid;
            this._renderEditor();
            this._scheduleSave(0);
            const row = this.container.querySelector(`[data-lid="${novo.lid}"]`);
            try { if (row && row.scrollIntoView) row.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
        });
        c.querySelector('[data-act=deltrail]')?.addEventListener('click', () => {
            if (!window.notifications) return;
            window.notifications.modal({
                title: this._t('trail.editor.delTrail'),
                html: `<p style="text-align:center;margin:0;color:#475569;">${this._esc(this._t('trail.editor.delConfirm', { name: list.name }))}</p>`,
                actions: [
                    { label: this._t('trail.editor.delTrail'), style: 'linear-gradient(135deg,#ef4444,#dc2626)', onClick: () => this._deleteTrail() },
                    { label: this._t('trail.cancel'), style: 'neutral' }
                ]
            });
        });
    }

    _scheduleSave(ms = TrailScreen.SAVE_DEBOUNCE_MS) {
        clearTimeout(this._saveTimer);
        this._saveTimer = setTimeout(() => { this._saveTimer = null; this._saveNow(); }, ms);
    }

    /**
     * Manda a lista INTEIRA (`list_put`). O servidor devolve a versão limpa: `rev` e `levels`
     * voltam de lá, mas a tela NÃO se redesenha no sucesso (a pessoa pode estar digitando) — só
     * o estado. Recusa vira frase e o que está na tela fica (nada se perde).
     */
    async _saveNow() {
        const um = window.userManager;
        const T = window.RhythmTrails;
        if (!um || !um.saveList || !this._data) return null;
        // 🔴 Gravação EM VOO: marca "sujo" e devolve a promessa em voo, que ao terminar grava de novo.
        //    Antes, só reagendava (+400 ms) e devolvia null — "Testar" saía com a edição para trás e o
        //    jogo testava o nível velho em Wi-Fi lento (auditoria 18/set).
        if (this._saving) { this._dirty = true; return this._savePromise; }
        this._saving = true;
        this._visId = (this._visId || 0) + 1;   // toda gravação invalida uma releitura em voo
        this._saveState = 'saving'; this._paintSaveState();
        this._savePromise = (async () => {
            let r = null;
            try {
                r = await um.saveList({ code: this._code, name: this._data.name, levels: T.serializeLevels(this._data.levels) });
            } catch (e) { r = { success: false, code: 'generic' }; }
            finally { this._saving = false; }
            const dead = !!(r && r.code === 'session_expired');
            if (r && r.success) {
                this._unsaved = false; this._retry = 0;
                this._raw = r.list;
                this._data.rev = Math.max(1, Number(r.list.rev) || this._data.rev);
                this._saveState = 'saved';
            } else {
                // 🔴 Recusa (balde, tamanho, CSRF, rede) NÃO é o fim: o que está na tela continua por gravar
                //    (`_unsaved`), tenta de novo com folga crescente, e o destroy dá a última tentativa.
                //    Antes, a recusa só pintava a frase e sair da tela perdia tudo desde o último PUT bom.
                this._saveState = 'error:' + ((r && r.code) || 'generic');
                if (!dead) {
                    this._unsaved = true;
                    const ms = TrailScreen.SAVE_RETRY_MS[Math.min(this._retry || 0, TrailScreen.SAVE_RETRY_MS.length - 1)];
                    this._retry = (this._retry || 0) + 1;
                    if (this._isMounted() && !this._dirty) this._scheduleSave(ms);
                }
            }
            if (this._isMounted()) this._paintSaveState();
            if (this._dirty && !dead) { this._dirty = false; return this._saveNow(); }
            this._dirty = false;
            return r;
        })();
        TrailScreen._inflight = this._savePromise;
        return this._savePromise;
    }

    /** Grava o pendente E espera o que está em voo (é o que "Testar" e o destroy precisam). */
    _flush() {
        if (this._saveTimer) { clearTimeout(this._saveTimer); this._saveTimer = null; return this._saveNow(); }
        return this._saving ? this._savePromise : Promise.resolve(null);
    }

    async _deleteTrail() {
        const um = window.userManager;
        if (!um || !um.deleteList || this._busy) return;
        this._busy = true;
        clearTimeout(this._saveTimer); this._saveTimer = null;
        const r = await um.deleteList(this._code);
        this._busy = false;
        if (r && r.success) {
            window.notifications?.toast(this._t('trail.editor.deleted'), { type: 'success', duration: 2000 });
            window.location.hash = '#/perfil';
            return;
        }
        window.notifications?.toast(this._t('auth.errors.' + ((r && r.code) || 'generic')), { type: 'error', duration: 3000 });
    }

    static _css() {
        return `
.tr-screen{max-width:720px;margin:0 auto;padding:1rem 16px 2rem;}
.tr-head{text-align:center;margin-bottom:1rem;}
.tr-kicker{font-size:0.72rem;letter-spacing:0.06em;text-transform:uppercase;color:#94a3b8;font-weight:700;margin:0 0 0.2rem;}
.tr-name{font-size:1.6rem;margin:0 0 0.25rem;color:#0f172a;line-height:1.2;overflow-wrap:anywhere;}
.tr-by{margin:0;color:#64748b;font-size:0.92rem;overflow-wrap:anywhere;}
.tr-card{background:#fff;border-radius:14px;padding:1rem;box-shadow:0 2px 10px rgba(0,0,0,0.06);margin-bottom:1rem;}
.tr-invite p{margin:0 0 0.8rem;color:#334155;}
.tr-btns{display:flex;flex-wrap:wrap;gap:0.5rem;justify-content:center;}
.tr-btn{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0.55rem 1.1rem;border-radius:10px;border:none;background:linear-gradient(135deg,#6366f1,#4f46e5);color:#fff;font-weight:700;font-size:0.95rem;text-decoration:none;cursor:pointer;font-family:inherit;box-sizing:border-box;}
.tr-btn--ghost{background:#f1f5f9;color:#334155;border:1px solid #e2e8f0;}
.tr-btn--small{min-height:44px;padding:0.4rem 0.8rem;font-size:0.88rem;}
.tr-btn--danger{color:#b91c1c;}
.tr-btn[disabled]{opacity:0.45;cursor:default;}
.tr-playrow{display:flex;align-items:center;justify-content:space-between;gap:0.8rem;flex-wrap:wrap;margin-bottom:0.8rem;}
.tr-progress{margin:0;color:#475569;font-weight:600;}
.tr-devnote{margin:0.15rem 0 0;font-size:0.8rem;color:#64748b;}
.tr-outline .tr-level{cursor:default;}
.tr-levels{display:flex;flex-direction:column;gap:0.35rem;}
.tr-level{display:flex;align-items:center;gap:0.6rem;min-height:44px;padding:0.4rem 0.6rem;border-radius:10px;border:1.5px solid #e2e8f0;text-decoration:none;color:#334155;background:#fff;}
.tr-level[data-state=current]{border-color:#6366f1;background:#eef2ff;}
.tr-level[data-state=cleared]{border-color:#bbf7d0;background:#f0fdf4;}
.tr-level[data-state=locked]{opacity:0.5;}
.tr-num{font-weight:800;color:#4f46e5;min-width:2rem;text-align:center;}
.tr-lvtxt{flex:1;display:flex;flex-direction:column;line-height:1.25;min-width:0;}
.tr-lvname{font-weight:600;overflow-wrap:anywhere;}
.tr-lvmeta{font-size:0.78rem;color:#94a3b8;}
.tr-lvstate{font-size:0.78rem;color:#64748b;white-space:nowrap;}
.tr-owner .tr-btns{margin-top:0.8rem;}
.tr-stats{margin:0 0 0.6rem;color:#475569;font-weight:600;text-align:center;}
.tr-linkbox{display:flex;flex-wrap:wrap;align-items:center;gap:0.5rem;background:#f8fafc;border:1px solid #eef2ff;border-radius:10px;padding:0.6rem 0.7rem;}
.tr-linklabel{font-size:0.75rem;text-transform:uppercase;letter-spacing:0.05em;color:#94a3b8;font-weight:700;width:100%;}
.tr-link{flex:1;min-width:0;overflow-wrap:anywhere;font-size:0.85rem;color:#334155;}
.tr-h2{font-size:1.05rem;margin:0;color:#0f172a;}
.tr-step{display:flex;align-items:center;gap:0.6rem;margin:0 0 0.3rem;}
.tr-step b{display:grid;place-items:center;width:26px;height:26px;border-radius:50%;background:#6366f1;color:#fff;font-size:0.85rem;flex:0 0 auto;}
.tr-lead-left{color:#64748b;font-size:0.88rem;margin:0 0 0.8rem;}
.tr-head--edit .tr-field--name{margin:0 auto;}
.tr-elist{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:0.5rem;}
.tr-erow{border:1.5px solid #e2e8f0;border-radius:12px;background:#fff;}
.tr-erow[data-open=true]{border-color:#6366f1;}
.tr-ehead{display:grid;grid-template-columns:2rem 1fr 1.4rem;gap:0.5rem;align-items:center;width:100%;min-height:52px;padding:0.4rem 0.5rem;background:none;border:none;text-align:left;font:inherit;color:inherit;cursor:pointer;border-radius:12px;}
.tr-etxt{display:flex;flex-direction:column;line-height:1.25;min-width:0;}
.tr-ename{font-weight:600;color:#0f172a;overflow-wrap:anywhere;}
.tr-esummary{font-size:0.78rem;color:#475569;line-height:1.3;overflow-wrap:anywhere;}
.tr-ediff{font-size:0.76rem;color:#0f766e;font-weight:600;overflow-wrap:anywhere;}
.tr-chev{color:#94a3b8;text-align:center;transition:transform 0.15s;}
.tr-erow[data-open=true] .tr-chev{transform:rotate(180deg);}
.tr-ebody{padding:0.2rem 0.7rem 0.8rem;border-top:1px dashed #e2e8f0;}
.tr-newhint{margin:0.5rem 0;padding:0.5rem 0.7rem;border-radius:10px;background:#ccfbf1;color:#0f766e;font-size:0.85rem;font-weight:500;}
.tr-extitle{font-size:0.72rem;letter-spacing:0.05em;text-transform:uppercase;color:#94a3b8;font-weight:700;margin:0.6rem 0 0.2rem;}
.tr-example{background:#f8fafc;border-radius:8px;min-height:60px;overflow:hidden;}
.tr-example svg{display:block;width:100%;height:auto;}
.tr-ebtns{display:flex;flex-wrap:wrap;gap:0.4rem;margin:0.5rem 0 0;}
.tr-ebtns--end{margin-top:0.9rem;}
.tr-btn--test{background:linear-gradient(135deg,#0f766e,#0d9488);}
.tr-btn--full{width:100%;}
.tr-set{margin:0.7rem 0 0;}
.tr-settitle{font-size:0.8rem;color:#64748b;font-weight:600;margin:0 0 0.25rem;}
.tr-setnote{font-size:0.76rem;color:#94a3b8;margin:0.2rem 0 0;}
.tr-center{text-align:center;}
.tr-chips{display:flex;flex-wrap:wrap;gap:0.4rem;}
.tr-chip{min-height:44px;padding:0.4rem 0.8rem;border-radius:999px;border:1.5px solid #e2e8f0;background:#fff;color:#0f172a;font:500 0.88rem inherit;font-family:inherit;cursor:pointer;}
.tr-chip[aria-pressed=true]{background:#eef2ff;border-color:#6366f1;color:#4f46e5;font-weight:700;}
.tr-stepper{display:inline-flex;align-items:center;gap:0.4rem;}
.tr-stepper button{width:44px;height:44px;border-radius:10px;border:1.5px solid #e2e8f0;background:#fff;color:#0f172a;font:700 1.1rem inherit;font-family:inherit;cursor:pointer;}
.tr-stepper b{min-width:5rem;text-align:center;font-size:1rem;}
.tr-addrow{margin-top:0.6rem;}
.tr-field{display:flex;flex-direction:column;gap:0.2rem;font-size:0.78rem;color:#64748b;}
.tr-field input{min-height:44px;padding:0.4rem 0.6rem;border:1.5px solid #cbd5e1;border-radius:10px;font:inherit;font-size:0.95rem;color:#0f172a;box-sizing:border-box;width:100%;}
.tr-field--name{max-width:480px;text-align:left;}
.tr-field--name input{font-size:1.1rem;font-weight:700;}
.tr-check{display:flex;align-items:flex-start;gap:0.5rem;min-height:44px;font-size:0.88rem;color:#334155;cursor:pointer;}
.tr-check input{width:20px;height:20px;accent-color:#6366f1;margin-top:2px;flex:0 0 auto;}
.tr-check small{display:block;color:#94a3b8;font-size:0.76rem;line-height:1.3;font-weight:400;}
.tr-check--seed span{font-weight:600;}
.tr-savestate{min-height:1.2rem;margin:0.3rem 0 0;font-size:0.82rem;color:#64748b;}
.tr-savestate--row{margin:0.6rem 0 -0.4rem;text-align:right;}
.tr-ediff--same{color:#b45309;}
.tr-backline{margin:0 0 0.4rem;font-size:0.9rem;text-align:left;}
.tr-backline a{color:#4f46e5;text-decoration:none;font-weight:600;display:inline-flex;align-items:center;min-height:44px;}
.tr-footer{text-align:center;margin:1.2rem 0 0;}
.tr-linkbtn{background:none;border:none;color:#b91c1c;font:inherit;font-size:0.9rem;text-decoration:underline;cursor:pointer;min-height:44px;padding:0 0.6rem;}
.tr-asstudent{margin:0 0 0.8rem;padding:0.5rem 0.7rem;border-radius:10px;background:#ecfeff;color:#0e7490;font-size:0.88rem;text-align:center;}
.tr-asstudent a{color:#0e7490;font-weight:700;display:inline-flex;align-items:center;min-height:44px;}
.tr-savestate[data-state=error]{color:#dc2626;}
.tr-savestate[data-state=saved]{color:#059669;}
.tr-state,.tr-lead{text-align:center;color:#475569;}
.tr-missing{text-align:center;}
.tr-missing .tr-btn{margin:0.3rem;}
.tr-paused{margin:0 0 0.6rem;padding:0.5rem 0.7rem;border-radius:10px;background:#fef3c7;color:#92400e;font-weight:600;font-size:0.9rem;text-align:center;}
@media (max-width:480px){ .tr-lvstate{font-size:0.72rem;} }`;
    }
}

window.TrailScreen = TrailScreen;



// ============================================
// components/GroupRanking.js
// ============================================
/**
 * GroupRanking — o RANKING DO GRUPO dentro da página `#/grupo/:id` (17/set/2026). Antes a
 * página só tinha um botão para o `#/ranking`, e o `#/perfil` precisava de dois (ranking e
 * página): a página do grupo é o lugar do grupo, e o ranking é dado DELE.
 *
 * Componente, não tela: nó próprio dentro da GroupScreen (nunca `host.innerHTML = ''` no host
 * emprestado). Lê UMA action (`group_leaderboard`, via `rankingRepository.groupLeaderboard`)
 * com o `group_id` SEMPRE explícito — admin e dono não são membros, e o grupo da página não é
 * necessariamente o da conta.
 *
 * 🔴 PÚBLICO (decisão dele, 17/set): qualquer pessoa, com ou sem conta, vê o ranking de um grupo
 *    LIBERADO. A trava de privacidade é a do `leaderboard` geral, no SQL (`rankLeaderboardRows`
 *    esconde quem desligou "Aparecer no ranking"); os nomes já eram públicos lá.
 * 🔴 A tela `#/ranking` segue com o seletor "Todos × Meu grupo" (decisão dele): este cartão é
 *    o MESMO dado visto da página, sem regra própria. Jogo e níveis vêm do registro do
 *    `LevelProgress`, como lá; a escolha de jogo é a mesma preferência de aparelho
 *    (`ranking_game_v1`).
 */
class GroupRanking {
    static LIMIT = 20;   // linhas por página — a MESMA régua do RankingScreen.LIMIT
    static GAME_KEY = 'ranking_game_v1';   // a MESMA do RankingScreen (preferência de aparelho)

    /**
     * @param {HTMLElement} host
     * @param {{id:number|string, name:string}} group
     * @param {'member'|'owner'|'admin'|'visitor'} viewer  quem olha — só muda a NOTA ("você organiza…")
     *   e o "jogue para estrear" (só para quem é do grupo)
     */
    constructor(host, group, viewer = 'member') {
        this.host = host;
        this.groupId = group.id;
        this.groupName = group.name || '';
        this.viewer = viewer;
        this.gameId = this._initialGame();
        this.scope = 'overall';
        this.level = this._prog() ? this._prog().currentLevel() : null;
        this.state = 'loading';     // loading | ready | empty | error
        this.rows = [];
        this.page = 1;         // página do ranking (RankPager)
        this.meHidden = false;
        this._req = 0;
        this._focusId = '';   // controle que a pessoa usou: o foco volta a ele depois do redesenho (clicar não foca no Safari)
        this.el = document.createElement('section');
        this.el.className = 'gr';
        this.el.setAttribute('aria-labelledby', 'gr-h');
        this.el.dataset.groupRanking = '';
        host.appendChild(this.el);
        this._onClick = (e) => this._click(e);
        this._onChange = (e) => this._change(e);
        this.el.addEventListener('click', this._onClick);
        this.el.addEventListener('change', this._onChange);
    }

    destroy() {
        this._req++;
        if (this.el) {
            this.el.removeEventListener('click', this._onClick);
            this.el.removeEventListener('change', this._onChange);
            this.el.remove();
        }
        this.el = null;
    }

    _t(key, params = {}) { return window.language ? window.language.t(key, params) : key; }
    _esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, c => (
            { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }
    _games() { return (window.LevelProgress && window.LevelProgress.all()) || []; }
    _prog() { return (window.LevelProgress && window.LevelProgress.get(this.gameId)) || null; }
    _gameName(prog) { return prog ? this._t(prog.nameKey) : this.gameId; }

    /** Escolha anterior do aparelho → jogo jogado por último → 1º registrado (a régua do RankingScreen). */
    _initialGame() {
        const games = this._games();
        if (!games.length) return 'ritmo';
        let saved = null;
        try { saved = window.localStorage && window.localStorage.getItem(GroupRanking.GAME_KEY); } catch (e) { /* sem storage */ }
        if (saved && games.some(g => g.gameId === saved)) return saved;
        let best = null, bestAt = -1;
        games.forEach(g => {
            const bests = g.getBests();
            Object.keys(bests).forEach(k => {
                const at = bests[k] && bests[k].at;
                if (Number.isFinite(at) && at > bestAt) { bestAt = at; best = g.gameId; }
            });
        });
        return best || games[0].gameId;
    }

    // ----- dado ---------------------------------------------------------------------

    /**
     * Carrega UMA página (1-based) — a paginação numerada da RankingScreen (RankPager). Trocar de
     * jogo/aba/nível volta à 1ª (todo `load()` sem argumento). Troca de PÁGINA mantém a tabela na
     * tela até a nova chegar, e depois leva o foco a ela.
     * 🔴 `troca` é EXPLÍCITO (só o paginador o passa): deduzir de "estava na página 2" tratava a
     *    troca de jogo/aba/nível como troca de página e roubava o foco do `<select>` (auditoria 18/set).
     * `foco: 'me'` = veio do "Ir para a minha página": o foco vai à linha "você", não ao topo.
     */
    async load({ page = 1, troca = false, foco = '' } = {}) {
        const id = ++this._req;
        troca = !!troca && this.state === 'ready';
        if (!troca) { this.state = 'loading'; this.render(); }
        else { const b = this.el && this.el.querySelector('.gr-body'); if (b) b.setAttribute('aria-busy', 'true'); }
        const repo = window.rankingRepository;
        const pg = Math.max(1, page);
        const res = repo && repo.groupLeaderboard
            ? await repo.groupLeaderboard({ gameId: this.gameId, scope: this.scope, level: this.level, offset: (pg - 1) * GroupRanking.LIMIT, limit: GroupRanking.LIMIT, groupId: this.groupId })
            : { success: false, rows: [] };
        if (id !== this._req || !this.el) return;
        const body0 = this.el.querySelector('.gr-body'); if (body0) body0.removeAttribute('aria-busy');
        if (!res.success) {
            if (res.code === 'session_expired') return;
            this.state = 'error'; this.rows = [];
        } else {
            this.rows = res.rows || [];
            this.meHidden = !!res.meHidden;
            // Página (18/set): a turma da MICA tem 80 — a lista parava nos 50 primeiros.
            this.page = pg;
            this.total = Number.isFinite(res.total) ? res.total : this.rows.length;
            this.me = res.me || null;
            this.meRank = res.meRank || null;
            this.state = this.rows.length ? 'ready' : 'empty';
            // Página que ESVAZIOU entre dois cliques (alguém se escondeu ou saiu): vai à última que
            // existe — "ninguém jogou ainda" seria falso e sem paginador não haveria como voltar.
            const ultima = Math.max(1, Math.ceil((this.total || 0) / GroupRanking.LIMIT));
            if (!this.rows.length && pg > 1 && this.total > 0 && ultima < pg) {
                this.state = 'ready';
                return this.load({ page: ultima, troca, foco });
            }
        }
        if (!troca) { this.render(); this._focusId = ''; return; }
        // Troca de página: o `aria-live` fica mudo (senão leria as 50 linhas), a tela sobe até a
        // tabela e o foco vai para ela (o rótulo da região diz a página).
        const body = this.el.querySelector('.gr-body');
        const live = body && body.getAttribute('aria-live');
        if (live) body.setAttribute('aria-live', 'off');
        this._focusId = '';
        this.render();
        const wrap = this.el.querySelector('.gr-wrap');
        const meRow = foco === 'me' ? this.el.querySelector('tr.gr-me') : null;
        if (meRow) { meRow.setAttribute('tabindex', '-1'); meRow.focus(); }
        else if (wrap) {
            const top = wrap.getBoundingClientRect().top;
            if (top < 0 && typeof window.scrollBy === 'function') window.scrollBy(0, top - 12);
            wrap.focus({ preventScroll: true });
        }
        const b2 = this.el.querySelector('.gr-body');
        if (live && b2) setTimeout(() => b2.setAttribute('aria-live', live), 0);
    }

    _pages() { return Math.max(1, Math.ceil((this.total || 0) / GroupRanking.LIMIT)); }

    // ----- render -------------------------------------------------------------------

    render() {
        if (!this.el) return;
        const focusId = this._focusId || (this.el.contains(document.activeElement) ? document.activeElement.id : '');
        const games = this._games();
        const gameBar = games.length >= 2
            ? `<div class="gr-field">
                   <label for="gr-game" class="gr-label">${this._esc(this._t('ranking.gameLabel'))}</label>
                   <select id="gr-game" class="gr-select">${games.map(g =>
                       `<option value="${this._esc(g.gameId)}"${g.gameId === this.gameId ? ' selected' : ''}>${this._esc(this._gameName(g))}</option>`).join('')}</select>
               </div>` : '';
        const levels = this._prog() ? this._prog().levels() : [];
        const levelBar = this.scope === 'level'
            ? `<div class="gr-field">
                   <label for="gr-level" class="gr-label">${this._esc(this._t('ranking.levelLabel'))}</label>
                   <select id="gr-level" class="gr-select">${levels.map(n =>
                       `<option value="${n}"${n === this.level ? ' selected' : ''}>${this._esc(this._t('ranking.levelOption', { n }))}</option>`).join('')}</select>
               </div>` : '';
        const tab = (scope, key) => `<button type="button" class="gr-tab" id="gr-tab-${scope}" data-scope="${scope}" aria-pressed="${this.scope === scope}">${this._esc(this._t(key))}</button>`;

        this.el.dataset.state = this.state;
        const casca = `<style>${GroupRanking._css()}</style>
            <h2 class="gr-h2" id="gr-h" tabindex="-1">${this._esc(this._t('group.ranking.title'))}</h2>
            <div class="gr-controls">
                ${gameBar}
                <div class="gr-tabs" role="group" aria-label="${this._esc(this._t('ranking.scopeLabel'))}">
                    ${tab('overall', 'ranking.tabOverall')}${tab('level', 'ranking.tabLevel')}
                </div>
                ${levelBar}
            </div>
            <div class="gr-body" aria-live="polite"></div>`;
        // 🔴 O `aria-live` só fala quando o MESMO nó muda de conteúdo (auditoria 17/set): reescrever
        //    o cartão inteiro trocava o nó e o leitor de tela não anunciava nada ao trocar de jogo.
        //    A casca é refeita só quando muda de forma (seletor de nível entrando/saindo, idioma).
        // A FORMA (idioma, jogos, aba) decide se a casca é refeita; o VALOR dos seletores é ajustado
        // no DOM. Refazer a casca a cada carga trocava o nó do aria-live e o leitor de tela calava.
        const forma = [(window.language && window.language.currentLanguage) || 'pt', this.scope, games.map(x => x.gameId).join(',')].join('|');
        if (this._forma !== forma) { this.el.innerHTML = casca; this._forma = forma; }
        const selJogo = this.el.querySelector('#gr-game'); if (selJogo && selJogo.value !== this.gameId) selJogo.value = this.gameId;
        // A lista de níveis é DAQUELE jogo (trilhas de tamanhos diferentes): troca aqui, sem refazer a casca.
        const selNivel = this.el.querySelector('#gr-level');
        if (selNivel && selNivel.options.length !== levels.length) selNivel.innerHTML = levels.map(n => `<option value="${n}">${this._esc(this._t('ranking.levelOption', { n }))}</option>`).join('');
        if (selNivel && this.level != null && selNivel.value !== String(this.level)) selNivel.value = String(this.level);
        this.el.querySelectorAll('.gr-tab').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.scope === this.scope)));
        const body = this.el.querySelector('.gr-body');
        if (body) body.innerHTML = this._body();
        if (focusId) { const f = this.el.querySelector('#' + focusId); if (f) f.focus(); }
    }

    _body() {
        if (this.state === 'loading') return `<p class="gr-state">${this._esc(this._t('ranking.loading'))}</p>`;
        if (this.state === 'error') {
            return `<p class="gr-state">${this._esc(this._t('ranking.error'))}</p>
                    <div class="gr-center"><button type="button" class="gr-btn" data-gr="retry">${this._esc(this._t('app.retry'))}</button></div>`;
        }
        const game = this._gameName(this._prog());
        const nota = this._note();
        if (this.state === 'empty') {
            // Só quem é do grupo é chamado a "jogar para estrear": para os outros o vazio é dos alunos.
            const msg = this.viewer === 'member'
                ? this._t('ranking.groupEmpty', { group: this.groupName, game })
                : this._t('group.ranking.emptyViewer', { group: this.groupName, game });
            const prog = this._prog();
            const cta = this.viewer === 'member' && prog && prog.route
                ? `<div class="gr-center"><a class="gr-btn" href="${this._esc(prog.route)}">${this._esc(this._t('ranking.emptyCta', { game }))}</a></div>` : '';
            return `<p class="gr-state">${this._esc(msg)}</p>${cta}${nota}`;
        }
        return this._table() + this._pagerBar() + nota;
    }

    /** "51–100 de 129", o paginador e o "Ir para a minha página" (a régua da RankingScreen). */
    _pagerBar() {
        const pages = this._pages(), n = this.page || 1;
        const me = (this.me && !this.rows.some(r => r.is_me)) ? this.me : null;
        const minha = (me && this.meRank) ? Math.ceil(this.meRank / GroupRanking.LIMIT) : null;
        const ir = (minha && minha !== n)
            ? `<div class="gr-center gr-minewrap"><button type="button" class="gr-btn gr-mine" data-page="${minha}">${this._esc(this._t('ranking.goToMine'))}</button></div>` : '';
        if (pages <= 1) return ir;
        const de = (n - 1) * GroupRanking.LIMIT + 1, ate = de + this.rows.length - 1;
        return ir + `<p class="gr-count">${this._esc(this._t('ranking.showing', { from: de, to: ate, total: this.total }))}</p>`
            + (window.RankPager ? window.RankPager.html(n, pages, (k, v) => this._t(k, v), (x) => this._esc(x), 'gr') : '');
    }

    /** Organizador e admin não estão na lista por não serem dela; o membro escondido, porque pediu. */
    _note() {
        if (this.viewer === 'owner') return `<p class="gr-note" data-gr-note="owner">${this._esc(this._t('ranking.ownerNote'))}</p>`;
        if (this.viewer === 'admin') return `<p class="gr-note" data-gr-note="admin">${this._esc(this._t('group.ranking.adminNote'))}</p>`;
        // 🔴 Só para MEMBRO: quem não é do grupo não está na lista por não ser dela — dizer "você
        //    desligou" seria falso e ainda empurraria a religar uma decisão de privacidade (auditoria).
        if (this.meHidden && this.viewer === 'member') {
            return `<p class="gr-note" data-gr-note="hidden">${this._esc(this._t('ranking.youAreHidden'))}`
                + ` <a href="#/perfil" class="gr-link">${this._esc(this._t('ranking.youAreHiddenCta'))}</a></p>`;
        }
        return '';
    }

    _table() {
        const overall = this.scope === 'overall';
        const label = this._t('group.ranking.title') + ' · ' + this._gameName(this._prog()) + (overall ? '' : ' · ' + this._t('ranking.levelOption', { n: this.level }))
            + (this._pages() > 1 ? ' · ' + this._t('ranking.pageOf', { n: this.page || 1, total: this._pages() }) : '');
        // "Nível 30": no celular a PALAVRA some (o cabeçalho já diz "Nível") — a régua do ranking geral,
        // que dá à foto a largura que ela toma do nome. O texto inteiro segue no DOM.
        const [lvlA, lvlB] = overall ? this._t('ranking.reached', { n: '\u0000' }).split('\u0000') : ['', ''];
        const lvl = (r) => `${lvlA ? `<span class="gr-lvlword">${this._esc(lvlA)}</span>` : ''}${this._esc(String(r.reached))}${lvlB ? `<span class="gr-lvlword">${this._esc(lvlB)}</span>` : ''}`;
        const linha = (r) => {
            const medal = r.rank <= 3 ? ['🥇', '🥈', '🥉'][r.rank - 1] : '';
            const pos = medal ? `<span aria-hidden="true">${medal}</span><span class="gr-sr">${r.rank}</span>` : `${this._esc(r.rank)}`;
            const name = (r.name && String(r.name).trim()) || this._t('ranking.guestPlayer');
            const me = r.is_me ? `<span class="gr-you">${this._esc(this._t('ranking.you'))}</span>` : '';
            const acc = r.accuracy == null ? '—' : `${Math.round(r.accuracy)}%`;
            return `<tr class="${r.is_me ? 'gr-me' : ''}">
                <td class="gr-c-pos">${pos}</td>
                <td class="gr-c-player"><span class="gr-cell">${window.RankingScreen ? `<span class="gr-avatar" aria-hidden="true">${window.RankingScreen.avatar(r, (x) => this._esc(x), 'gr')}</span>` : ''}<span class="gr-name">${this._esc(name)}</span>${me}</span></td>
                ${overall ? `<td class="gr-c-level">${lvl(r)}</td>` : ''}
                <td class="gr-c-acc">${this._esc(acc)}</td>
            </tr>`;
        };
        const rows = this.rows.map(linha).join('');
        // "você" FIXO embaixo quando a posição está além do que foi carregado (posição real).
        const me = (this.me && !this.rows.some(r => r.is_me)) ? this.me : null;
        const pinned = me
            ? `<tbody class="gr-pinned">${linha(me)}</tbody>`   // separação = borda tracejada (sem colspan: ver RankingScreen)
            : '';
        return `<div class="gr-wrap" tabindex="0" role="region" aria-label="${this._esc(label)}">
            <table class="gr-table"><thead><tr>
                <th scope="col" class="gr-c-pos"><span class="gr-sr">${this._esc(this._t('ranking.colPosition'))}</span><span aria-hidden="true">#</span></th>
                <th scope="col" class="gr-c-player">${this._esc(this._t('ranking.colPlayer'))}</th>
                ${overall ? `<th scope="col" class="gr-c-level">${this._esc(this._t('ranking.colLevel'))}</th>` : ''}
                <th scope="col" class="gr-c-acc">${this._esc(this._t('ranking.colAccuracy'))}</th>
            </tr></thead><tbody>${rows}</tbody>${pinned}</table></div>`;
    }

    // ----- eventos ------------------------------------------------------------------

    _click(e) {
        const tab = e.target.closest('[data-scope]');
        if (tab) {
            const scope = tab.dataset.scope === 'level' ? 'level' : 'overall';
            if (scope === this.scope) return;
            this.scope = scope;
            this._focusId = tab.id;
            if (scope === 'level' && this.level == null) this.level = 1;
            this.load();
            return;
        }
        if (e.target.closest('[data-gr="retry"]')) { this._focusId = 'gr-h'; this.load(); return; }
        const pg = e.target.closest('[data-page]');
        if (pg) {
            const n = parseInt(pg.dataset.page, 10);
            if (Number.isFinite(n) && n >= 1 && n <= this._pages() && n !== this.page) {
                this.load({ page: n, troca: true, foco: pg.classList.contains('gr-mine') ? 'me' : '' });
            }
        }
    }

    _change(e) {
        if (e.target.id === 'gr-game') {
            const gameId = e.target.value;
            if (gameId === this.gameId || !this._games().some(g => g.gameId === gameId)) return;
            this.gameId = gameId;
            this._focusId = 'gr-game';
            try { window.localStorage && window.localStorage.setItem(GroupRanking.GAME_KEY, gameId); } catch (err) { /* só não lembra */ }
            // O nível é DAQUELE jogo (trilhas de tamanhos diferentes): volta ao "você está aqui" do novo.
            this.level = this._prog() ? this._prog().currentLevel() : 1;
            this.load();
        } else if (e.target.id === 'gr-level') {
            const v = parseInt(e.target.value, 10);
            if (!Number.isNaN(v) && v !== this.level) { this.level = v; this._focusId = 'gr-level'; this.load(); }
        }
    }

    static _css() {
        // Mesma paleta e mesmo cartão da página do grupo (.gp-card) e da ClassView.
        return `
        .gr{background:#fff;border:1px solid #eef0f5;border-radius:14px;padding:1rem 1.1rem;margin-bottom:.9rem;box-shadow:0 2px 10px rgba(0,0,0,.05);min-width:0;}
        .gr-h2{margin:0 0 .7rem;font-size:1.2rem;color:#1f2937;}
        .gr-pinned .gr-me td{border-top:2px dashed #a5b4fc;}
        .gr-avatar{flex:0 0 auto;}
        .gr-avatar-ini{display:inline-flex;align-items:center;justify-content:center;width:1.9rem;height:1.9rem;border-radius:50%;
            background:#6366f1;color:#fff;font-weight:700;font-size:.85rem;}
        .gr-avatar-img{width:1.9rem;height:1.9rem;border-radius:50%;object-fit:cover;display:block;}
        .gr-count{text-align:center;color:#6b7280;font-size:.85rem;margin:.7rem 0 0;}
        .gr-minewrap{margin-top:.7rem;}
        .gr-body[aria-busy="true"] .gr-table{opacity:.55;}
        ${window.RankPager ? window.RankPager.css('gr') : ''}
        .gr-sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}
        .gr-controls{display:flex;flex-wrap:wrap;gap:.5rem .8rem;align-items:center;margin-bottom:.7rem;}
        .gr-field{display:flex;align-items:center;gap:.45rem;min-width:0;}
        .gr-label{font-size:.88rem;color:#4b5563;font-weight:600;}
        .gr-select{min-height:44px;padding:.35rem .6rem;border:1px solid #d9dbe6;border-radius:8px;background:#fff;font-size:.92rem;color:#374151;font-family:inherit;max-width:min(60vw,15rem);}
        .gr-tabs{display:flex;gap:.4rem;}
        .gr-tab{min-height:44px;padding:.4rem 1rem;border:1px solid #d9dbe6;background:#fff;color:#4b5563;border-radius:999px;font-weight:600;font-size:.9rem;cursor:pointer;font-family:inherit;}
        .gr-tab[aria-pressed="true"]{background:#4f46e5;border-color:#4f46e5;color:#fff;}
        .gr-wrap{overflow-x:auto;-webkit-overflow-scrolling:touch;}
        .gr-table{width:100%;border-collapse:collapse;font-size:.95rem;table-layout:fixed;}
        .gr-table th{text-align:left;font-size:.72rem;text-transform:uppercase;letter-spacing:.04em;color:#64748b;font-weight:700;padding:.4rem .45rem;border-bottom:2px solid #eef0f5;white-space:nowrap;}
        .gr-table td{padding:.55rem .45rem;border-bottom:1px solid #f1f3f6;vertical-align:middle;}
        .gr-c-pos{width:2.4rem;text-align:center;font-weight:700;color:#64748b;}
        .gr-c-player{max-width:0;overflow:hidden;}
        .gr-c-level{width:5.4rem;white-space:nowrap;}
        .gr-c-acc{width:5.2rem;text-align:right;white-space:nowrap;}
        .gr-cell{display:flex;align-items:center;gap:.45rem;min-width:0;}
        .gr-name{font-weight:600;color:#1f2937;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;}
        .gr-you{flex:0 0 auto;font-size:.68rem;font-weight:700;text-transform:uppercase;color:#3730a3;background:#e0e7ff;border-radius:999px;padding:.1rem .45rem;}
        .gr-me{background:#f5f7ff;}
        .gr-state{text-align:center;color:#64748b;margin:1rem 0 .6rem;}
        .gr-center{text-align:center;margin-bottom:.4rem;}
        .gr-btn{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:.4rem 1.1rem;border:none;border-radius:999px;background:#4f46e5;color:#fff;font-weight:600;font-size:.9rem;text-decoration:none;cursor:pointer;font-family:inherit;}
        .gr-note{margin:.8rem 0 0;color:#4b5563;font-size:.86rem;line-height:1.45;background:#f8fafc;border:1px solid #eef0f5;border-radius:10px;padding:.55rem .75rem;}
        .gr-link{color:#3730a3;font-weight:600;}
        @media (max-width:480px){ .gr{padding:.85rem .8rem;} .gr-c-level{width:3.4rem;} .gr-lvlword{display:none;} .gr-table{font-size:.9rem;} }
        /* 360px: o selo "Você" sai do VISUAL (a linha já tem o fundo), não do leitor de tela — como no geral. */
        @media (max-width:360px){ .gr-you{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;} }`;
    }
}

window.GroupRanking = GroupRanking;



// ============================================
// components/ClassView.js
// ============================================
/**
 * ClassView — a VISÃO DA TURMA (degrau 2 do professor, 17/set/2026): o cartão que o DONO do
 * grupo e o ADMIN veem em `#/grupo/:id`. Decisões e o que ficou aberto:
 * docs/VISAO-DA-TURMA-PLANO.md.
 *
 * Componente, não tela: mora DENTRO da GroupScreen, num nó próprio que ele cria (nunca faz
 * `host.innerHTML = ''` no host emprestado — a lição da SongShelf). Lê UMA action
 * (`group_class_view`) e desenha o que o servidor contou; a única conta daqui é a que só o
 * cliente pode fazer: o TAMANHO DA TRILHA, o MUNDO e o LIMIAR de cada nível, lidos do
 * registro do `LevelProgress` (a mesma linha que põe o jogo no ranking). Jogo novo entra
 * aqui pela linha que já o registra.
 *
 * 🔴 QUEM VÊ é decidido pelo SERVIDOR (`requireCanManageGroup`: dono ou admin; membro 403).
 *    A GroupScreen só não monta o cartão para quem ia levar 403 — é economia, não trava.
 * 🔴 ZERO NÃO É AUSÊNCIA: aluno com o diário desligado chega com `null` em tentativas/tempo e
 *    a tela escreve "—"; ele NUNCA entra em "precisa de uma mão" (não há como saber).
 * 🔴 O DIAGNÓSTICO é a régua do `RhythmGame._failVerdict`, nos dois sentidos: início bate o
 *    limiar e a duração não → "falta segurar"; duração bate e o início não → "entrar no
 *    tempo"; os dois baixos (ou jogo sem os dois placares) → genérico. Compara o que a TELA
 *    DO JOGO IMPRIME (`Math.round`), como lá. Fonte única: `ClassView.diagnose`.
 * 🔴 ALVO DE DEDO: as bolinhas do histograma são DESENHO (12 px, aria-hidden); o que se toca
 *    são os nomes (botões de 44 px). O mock tinha bolinhas-botão de 24 px.
 */
class ClassView {
    /** Tentativas no nível atual, sem passar, a partir das quais o aluno "precisa de uma mão". */
    static STUCK_TRIES = 10;
    /** Bolinhas empilhadas por nível antes do "+N". */
    static DOTS_MAX = 6;
    /** Quantos empacados ficam à vista; o resto entra no "Ver os outros N" (turma de 55 virava parede). */
    static STUCK_SHOWN = 2;
    /** Alunos medidos para um nível virar a manchete de "onde a turma trava". */
    static WALL_MIN_N = 2;
    static LOCALE = { pt: 'pt-BR', en: 'en-US', es: 'es-ES' };
    /** Chaves do diagnóstico — TABELA de literais inteiros, nunca `'x.' + diag` (o teste de i18n lê o fonte). */
    static DIAG_BADGE = { hold: 'group.class.badge.hold', timing: 'group.class.badge.timing', generic: 'group.class.badge.generic' };
    static DIAG_TEXT = { hold: 'group.class.diag.hold', timing: 'group.class.diag.timing', generic: 'group.class.diag.generic', genericSplit: 'group.class.diag.genericSplit' };

    /**
     * @param {HTMLElement} host  onde o cartão entra (o nó é do ClassView; o host, de quem emprestou)
     * @param {number|string} groupId
     */
    constructor(host, groupId) {
        this.host = host;
        this.groupId = groupId;
        this.game = '';
        this.data = null;
        this.state = 'loading';     // loading | ready | error
        this.error = '';
        this.selected = null;       // key do aluno aberto no detalhe
        this._req = 0;
        this._dead = false;
        this.el = document.createElement('section');
        this.el.className = 'cv';
        this.el.setAttribute('aria-labelledby', 'cv-h');
        this.el.dataset.classView = '';
        host.appendChild(this.el);
        this._onClick = (e) => this._click(e);
        this._onChange = (e) => this._change(e);
        this.el.addEventListener('click', this._onClick);
        this.el.addEventListener('change', this._onChange);
    }

    destroy() {
        this._dead = true;
        if (this.el) { this.el.removeEventListener('click', this._onClick); this.el.removeEventListener('change', this._onChange); this.el.remove(); }
        this.el = null;
    }

    _t(key, params = {}) { return window.language ? window.language.t(key, params) : key; }
    _esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, c => (
            { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }
    _lang() { return (window.language && window.language.currentLanguage) || 'pt'; }
    _num(n) { return Number(n).toLocaleString(ClassView.LOCALE[this._lang()] || 'pt-BR'); }

    /** Offset do navegador no formato do servidor (+HH:MM) — a mesma régua do StatsScreen. */
    static tzOffset(d = new Date()) {
        const m = -d.getTimezoneOffset();
        const a = Math.abs(m);
        return (m < 0 ? '-' : '+') + String(Math.floor(a / 60)).padStart(2, '0') + ':' + String(a % 60).padStart(2, '0');
    }

    // ----- dado ---------------------------------------------------------------------

    async load(game = this._want != null ? this._want : this.game, focus = null) {
        // 🔴 O jogo PEDIDO fica guardado (auditoria 17/set): trocar para Leitura, a rede cair e
        //    tocar "Tentar de novo" pedia o Ritmo de novo — e no erro as pílulas somem.
        this._want = game;
        this._focus = focus;
        const id = ++this._req;
        this.state = 'loading'; this.error = '';
        this.render();
        const um = window.userManager;
        const r = um && um.fetchClassView
            ? await um.fetchClassView(this.groupId, { game, tz: ClassView.tzOffset() })
            : { success: false, code: 'network' };
        if (this._dead || id !== this._req) return;
        if (r.success) {
            this.data = r.data; this.game = r.data.game_id; this._want = null; this.state = 'ready';
            if (this.selected && !r.data.students.some(s => s.key === this.selected)) this.selected = null;
        } else {
            if (r.code === 'session_expired') return;   // o app inteiro já reagiu
            this.state = 'error'; this.error = r.code || 'network';
        }
        this.render();
        // O redesenho inteiro jogava o foco no <body> (auditoria 17/set): ele volta para a pílula
        // do jogo aberto (troca de jogo) ou para o título (tentar de novo / erro).
        if (this._focus && this.el) {
            const alvo = (this._focus === 'game' && this.el.querySelector('[data-cv="game"][aria-pressed="true"]'))
                || this.el.querySelector('[data-cv="retry"]') || this.el.querySelector('#cv-h');
            try { if (alvo) alvo.focus(); } catch (e) {}
        }
        this._focus = null;
    }

    /**
     * O veredito de quem não passa, com a régua do `_failVerdict` do Ritmo, nos DOIS sentidos.
     * @returns {'hold'|'timing'|'generic'|null} null quando não há o que diagnosticar
     */
    static diagnose(best, pass) {
        if (!best || !Number.isFinite(pass)) return null;
        const o = best.onset, d = best.duration;
        if (Number.isFinite(o) && Number.isFinite(d)) {
            const ro = Math.round(o), rd = Math.round(d);
            if (ro >= pass && rd < pass) return 'hold';
            if (rd >= pass && ro < pass) return 'timing';
        }
        return 'generic';
    }

    /**
     * O MODELO que a tela desenha: resposta do servidor + o que só o registro do jogo sabe.
     * Pura (sem DOM), estática, para o teste chamar com dados conhecidos.
     */
    static model(data, prog) {
        const levels = (prog && prog.levels().length) ? prog.levels().slice() : [];
        if (!levels.length) {
            const top = Math.max(1, ...data.students.map(s => s.current || 0), ...(data.levels || []).map(l => l.level));
            for (let l = 1; l <= top; l++) levels.push(l);
        }
        const trailLen = levels[levels.length - 1];
        const info = (l) => prog ? prog.levelInfo(l) : { world: null, pass: null };
        const students = data.students.map(s => {
            const out = Object.assign({}, s);
            if (!s.started) return Object.assign(out, { level: null, done: false, world: null, pass: null, stuck: false, diag: null });
            const done = s.passed_max != null && s.passed_max >= trailLen;
            const level = done ? trailLen : Math.min(s.current, trailLen);
            const li = info(level);
            const passedHere = !!(s.best && s.best.passed);
            // 🔴 Diário desligado (tries null) NUNCA é empacado: não há como saber.
            const stuck = !done && !passedHere && Number.isFinite(s.tries) && s.tries >= ClassView.STUCK_TRIES;
            return Object.assign(out, { level, done, world: li.world, pass: li.pass, stuck,
                diag: done || passedHere ? null : ClassView.diagnose(s.best, li.pass) });
        });
        const started = students.filter(s => s.started);
        const withDiary = students.filter(s => s.diary === 1);
        const sum = (k) => withDiary.reduce((a, s) => a + (Number.isFinite(s[k]) ? s[k] : 0), 0);
        const lv = started.map(s => s.level).sort((a, b) => a - b);
        const mid = lv.length ? (lv.length % 2 ? lv[(lv.length - 1) / 2] : Math.round((lv[lv.length / 2 - 1] + lv[lv.length / 2]) / 2)) : null;

        // Mundos na ordem da trilha; jogo sem mundos = um grupo só (world null).
        const worlds = [];
        levels.forEach(l => {
            const w = info(l).world;
            let g = worlds[worlds.length - 1];
            if (!g || g.world !== w) { g = { world: w, levels: [] }; worlds.push(g); }
            g.levels.push(l);
        });
        return {
            trailLen, levels, worlds, students, started,
            stuck: students.filter(s => s.stuck).sort((a, b) => b.tries - a.tries),
            summary: {
                members: students.length, started: started.length,
                diaryOff: students.filter(s => s.diary !== 1).length,
                // Com ninguém de diário ligado, a soma é "—", nunca 0.
                rounds: withDiary.length ? sum('rounds') : null,
                seconds: withDiary.length ? sum('seconds') : null,
                midLevel: mid
            }
        };
    }

    // ----- render -------------------------------------------------------------------

    render() {
        if (!this.el) return;
        const head = `<div class="cv-head">
                <h2 class="cv-h2" id="cv-h" tabindex="-1">${this._esc(this._t('group.class.title'))}</h2>
                <p class="cv-private">${this._esc(this._t('group.class.private'))}</p>
                ${this.state === 'ready' ? this._gamePills() : ''}
            </div>`;
        let body;
        if (this.state === 'loading') body = `<p class="cv-state" role="status">${this._esc(this._t('app.loading'))}</p>`;
        else if (this.state === 'error') {
            body = `<div class="cv-card cv-center"><p class="cv-state">${this._esc(this._t(this.error === 'forbidden' ? 'group.class.forbidden' : 'app.loadError'))}</p>
                    <button type="button" class="cv-btn" data-cv="retry">${this._esc(this._t('app.retry'))}</button></div>`;
        } else body = this._readyBody();
        this.el.dataset.state = this.state === 'ready' ? this._readyState() : this.state;
        this.el.innerHTML = `<style>${ClassView._css()}</style>${head}${body}`;
    }

    _prog() { return window.LevelProgress ? window.LevelProgress.get(this.data.game_id) : null; }
    _gameName(gameId) {
        const p = window.LevelProgress ? window.LevelProgress.get(gameId) : null;
        return p ? this._t(p.nameKey) : gameId;
    }

    _readyState() {
        const d = this.data;
        if (!d.students.length) return 'empty';
        if (!d.students.some(s => s.started)) return 'nogame';
        return 'ready';
    }

    /** Pílulas de jogo: os REGISTRADOS no LevelProgress, com atividade no grupo (+ o aberto). */
    _gamePills() {
        const d = this.data;
        const reg = window.LevelProgress ? window.LevelProgress.all().map(p => p.gameId) : [];
        const act = {};
        (d.games || []).forEach(g => { act[g.game_id] = g.plays; });
        const list = reg.filter(g => g === d.game_id || act[g] > 0);
        if (list.length < 2) {
            return `<p class="cv-gameone">${this._esc(this._t('group.class.inGame', { game: this._gameName(d.game_id) }))}</p>`;
        }
        return `<div class="cv-games" role="group" aria-label="${this._esc(this._t('group.class.gameLabel'))}">
            ${list.map(g => `<button type="button" class="cv-pill" data-cv="game" data-game="${this._esc(g)}" aria-pressed="${g === d.game_id}">${this._esc(this._gameName(g))}</button>`).join('')}
        </div>`;
    }

    _readyBody() {
        const st = this._readyState();
        const d = this.data;
        if (st === 'empty') {
            return `<div class="cv-card cv-center"><p class="cv-state">${this._esc(this._t('group.class.empty'))}</p></div>`;
        }
        if (st === 'nogame') {
            return `<div class="cv-card cv-center"><p class="cv-state">${this._esc(this._t('group.class.noneStarted', { game: this._gameName(d.game_id) }))}</p></div>`;
        }
        const m = ClassView.model(d, this._prog());
        this._model = m;
        return this._summaryCard(m) + this._whereCard(m) + this._stuckCard(m) + this._seriesCard(m) + this._wallsCard(m) + this._tableCard(m);
    }

    _time(sec) {
        if (!Number.isFinite(sec)) return '—';
        const total = Math.round(sec / 60);
        if (total < 60) return this._t('group.class.min', { m: total });
        return this._t('group.class.hm', { h: Math.floor(total / 60), m: String(total % 60).padStart(2, '0') });
    }

    _day(ymd) {
        if (!ymd) return '—';
        const today = this.data.today;
        if (ymd === today) return this._t('group.class.today');
        const y = new Date(today + 'T00:00:00Z'); y.setUTCDate(y.getUTCDate() - 1);
        if (ymd === y.toISOString().slice(0, 10)) return this._t('group.class.yesterday');
        const dt = new Date(ymd + 'T12:00:00Z');
        return dt.toLocaleDateString(ClassView.LOCALE[this._lang()] || 'pt-BR', { day: 'numeric', month: 'short', timeZone: 'UTC' });
    }

    _name(s) { return s.name && s.name.trim() ? s.name : this._t('group.class.noName'); }
    _levelLabel(l) { return this._t('group.class.level', { n: l }); }
    _worldLabel(w) {
        const p = this._prog();
        const n = p && w != null ? p.worldName(w) : null;
        const txt = n ? this._t(n.key, n.params) : '';
        // Chave ausente volta CRUA do Language: aí vale "Nível"/"Mundo" genérico, nunca a chave.
        return txt && txt !== n.key ? txt : (w != null ? this._t('group.class.world', { n: w }) : this._t('group.class.levels'));
    }

    _summaryCard(m) {
        const s = m.summary;
        const tile = (val, label, key) => `<div class="cv-stat" data-stat="${key}"><b>${this._esc(val)}</b><span>${this._esc(label)}</span></div>`;
        const off = s.diaryOff
            ? `<p class="cv-note" data-note="diary-off">${this._esc(this._t(s.diaryOff === 1 ? 'group.class.diaryOffOne' : 'group.class.diaryOff', { n: s.diaryOff }))}</p>` : '';
        const playing = s.started < s.members ? `<p class="cv-note">${this._esc(this._t('group.class.playing', { n: s.started, total: s.members }))}</p>` : '';
        return `<div class="cv-card">
            <div class="cv-stats">
                ${tile(this._num(s.members), this._t(s.members === 1 ? 'group.class.statStudentOne' : 'group.class.statStudents'), 'members')}
                ${tile(s.rounds == null ? '—' : this._num(s.rounds), this._t('group.class.statRounds'), 'rounds')}
                ${tile(s.seconds == null ? '—' : this._time(s.seconds), this._t('group.class.statTime'), 'time')}
                ${tile(s.midLevel == null ? '—' : s.midLevel, this._t('group.class.statMid'), 'mid')}
            </div>
            ${playing}${off}
        </div>`;
    }

    _whereCard(m) {
        const by = {};
        m.started.forEach(s => { (by[s.level] = by[s.level] || []).push(s); });
        const parts = m.levels.filter(l => by[l]).map(l => {
            const n = by[l].length, st = by[l].filter(s => s.stuck).length, dn = by[l].filter(s => s.done).length;
            let t = this._t(n === 1 ? 'group.class.histPartOne' : 'group.class.histPart', { level: l, n });
            if (st) t += ' (' + this._t('group.class.histStuck', { n: st }) + ')';
            if (dn) t += ' (' + this._t('group.class.done') + ')';
            return t;
        });
        const aria = this._t('group.class.histAria', { parts: parts.join('; ') });
        const tallest = Math.min(ClassView.DOTS_MAX, Math.max(1, ...Object.values(by).map(x => x.length)));
        const stackPx = tallest * 14 + (Object.values(by).some(x => x.length > ClassView.DOTS_MAX) ? 12 : 0);
        const worlds = m.worlds.map(w => {
            const cols = w.levels.map(l => {
                const here = by[l] || [];
                const shown = here.slice(0, ClassView.DOTS_MAX);
                const dots = shown.map(s => `<i class="cv-dot${s.stuck ? ' cv-dot--stuck' : ''}${s.done ? ' cv-dot--done' : ''}"></i>`).join('');
                const more = here.length > shown.length ? `<em class="cv-more">+${here.length - shown.length}</em>` : '';
                return `<div class="cv-col" data-level="${l}" data-n="${here.length}"><div class="cv-stack">${more}${dots}</div><span class="cv-lv">${l}</span></div>`;
            }).join('');
            const wide = w.levels.length > 6 ? ' cv-world--wide' : '';
            return `<div class="cv-world${wide}"${w.world != null ? ` data-world="${w.world}"` : ''}>
                <h4 class="cv-wname">${this._esc(this._worldLabel(w.world))}</h4>
                <div class="cv-cols" style="grid-template-columns:repeat(${w.levels.length},minmax(0,1fr))">${cols}</div>
            </div>`;
        }).join('');
        const chips = m.started.map(s => {
            const sel = this.selected === s.key;
            const mark = s.done ? '✓ ' : (s.stuck ? '! ' : '');
            return `<li><button type="button" class="cv-chip${s.stuck ? ' cv-chip--stuck' : ''}${s.done ? ' cv-chip--done' : ''}" data-cv="pick" data-key="${this._esc(s.key)}" aria-pressed="${sel}"
                aria-label="${this._esc(this._name(s) + ', ' + (s.done ? this._t('group.class.done') : this._levelLabel(s.level)) + (s.stuck ? ', ' + this._t('group.class.stuckTitle') : ''))}"><span class="cv-chipname">${this._esc(this._name(s))}</span><span class="cv-chiplv" aria-hidden="true">${mark}${s.level}</span></button></li>`;
        }).join('');
        const notStarted = m.students.filter(s => !s.started);
        const ns = notStarted.length
            ? `<p class="cv-note" data-note="not-started">${this._esc(this._t('group.class.notStarted', { names: notStarted.map(s => this._name(s)).join(', ') }))}</p>` : '';
        const sel = this.selected ? m.students.find(s => s.key === this.selected && s.started) : null;
        // SELETOR de aluno: numa turma grande, achar alguém na lista é rolagem; aqui é um toque, e o
        // detalhe fica SEMPRE no mesmo lugar, logo abaixo (17/set, pedido dele).
        const opcoes = `<option value="">${this._esc(this._t('group.class.pickNone'))}</option>`
            + m.started.map(s => `<option value="${this._esc(s.key)}"${s.key === this.selected ? ' selected' : ''}>${this._esc(
                this._name(s) + ' · ' + (s.done ? this._t('group.class.done') : this._levelLabel(s.level)) + (s.stuck ? ' · ' + this._t('group.class.stuckTitle') : ''))}</option>`).join('');
        return `<div class="cv-card" data-card="where">
            <h3 class="cv-h3">${this._esc(this._t('group.class.whereTitle'))}</h3>
            <p class="cv-hint">${this._esc(this._t('group.class.whereHint'))}</p>
            <div class="cv-worlds" role="img" aria-label="${this._esc(aria)}" style="--cv-stack:${stackPx}px">${worlds}</div>
            <div class="cv-legend" aria-hidden="true">
                <span><i class="cv-dot"></i>${this._esc(this._t('group.class.legendAdvancing'))}</span>
                <span><i class="cv-dot cv-dot--stuck"></i>${this._esc(this._t('group.class.legendStuck', { n: ClassView.STUCK_TRIES }))}</span>
                <span><i class="cv-dot cv-dot--done"></i>${this._esc(this._t('group.class.legendDone'))}</span>
            </div>
            <div class="cv-pickrow">
                <label class="cv-picklabel" for="cv-pick">${this._esc(this._t('group.class.pickLabel'))}</label>
                <select id="cv-pick" class="cv-select" data-cv-select>${opcoes}</select>
            </div>
            <div class="cv-detail" aria-live="polite" data-detail>${sel ? this._detail(sel) : ''}</div>
            <p class="cv-hint cv-taphint">${this._esc(this._t('group.class.tapHint'))}</p>
            <ul class="cv-chips">${chips}</ul>
            ${ns}
        </div>`;
    }

    _detail(s) {
        const lines = [];
        const w = s.world != null ? ` · ${this._worldLabel(s.world)}` : '';
        lines.push(`<b>${this._esc(this._name(s))}</b> · ${this._esc(s.done ? this._t('group.class.done') : this._levelLabel(s.level))}${this._esc(w)}`);
        if (!s.done) {
            if (s.best && s.pass != null && Number.isFinite(s.best.onset) && Number.isFinite(s.best.duration)) {
                lines.push(this._esc(this._t('group.class.bestSplit', { onset: Math.round(s.best.onset), duration: Math.round(s.best.duration), pass: s.pass })));
            } else if (s.best && Number.isFinite(s.best.accuracy)) {
                lines.push(this._esc(this._t(s.pass != null ? 'group.class.best' : 'group.class.bestNoPass', { acc: Math.round(s.best.accuracy), pass: s.pass })));
            } else {
                lines.push(this._esc(this._t('group.class.noBest')));
            }
            if (s.diag && s.diag !== 'generic') lines.push(`<span class="cv-diag cv-diag--${s.diag}">${this._esc(this._t(ClassView.DIAG_BADGE[s.diag]))}</span> ${this._esc(this._t(ClassView.DIAG_TEXT[s.diag]))}`);
        }
        if (s.diary !== 1) {
            lines.push(`<span class="cv-muted">${this._esc(this._t('group.class.diaryOffStudent'))}</span>`);
        } else if (s.tries == null) {
            // Diário ligado e nenhuma linha neste jogo (jogou antes de o diário existir): ausência, não zero.
            lines.push(`<span class="cv-muted">${this._esc(this._t('group.class.noRecords'))}</span>`);
        } else {
            if (!s.done) lines.push(this._esc(this._t(s.tries === 1 ? 'group.class.triesOne' : 'group.class.tries', { n: s.tries, level: s.level })));
            lines.push(this._esc(this._t('group.class.totals', { rounds: this._num(s.rounds || 0), time: this._time(s.seconds), game: this._gameName(this.data.game_id) })));
        }
        return lines.map(l => `<p>${l}</p>`).join('');
    }

    _seriesPart(day, r) {
        return this._t(r.players === 1 ? 'group.class.seriesPartOne' : 'group.class.seriesPart',
            { day: this._day(day), n: this._num(r.rounds), players: r.players });
    }

    _wallPart(level, l, hereN) {
        let t = this._t(l.median_n === 1 ? 'group.class.wallsPartOne' : 'group.class.wallsPart', { level, median: this._num(l.median_tries), n: l.median_n });
        if (hereN) t += ' · ' + this._t('group.class.wallsNow', { n: hereN });
        return t;
    }

    _meter(label, value, pass) {
        const v = Math.max(0, Math.min(100, Math.round(value)));
        const low = pass != null && v < pass;
        return `<div class="cv-meterrow"><span class="cv-meterlbl">${this._esc(label)}</span>
            <span class="cv-meter" aria-hidden="true"><b class="${low ? 'cv-low' : ''}" style="width:${v}%"></b>${pass != null ? `<em style="left:${pass}%"></em>` : ''}</span>
            <span class="cv-meterval${low ? ' cv-low-t' : ''}">${v}%</span></div>`;
    }

    _stuckCard(m) {
        const linha = (s) => {
            const b = s.best;
            const split = b && Number.isFinite(b.onset) && Number.isFinite(b.duration);
            const semNumero = !b || (!split && !Number.isFinite(b.accuracy));
            const meters = semNumero ? `<p class="cv-muted">${this._esc(this._t('group.class.noBest'))}</p>`
                : (split ? this._meter(this._t('rhythm.onsetTitle'), b.onset, s.pass) + this._meter(this._t('rhythm.durationTitle'), b.duration, s.pass)
                         : this._meter(this._t('group.class.accuracy'), b.accuracy, s.pass));
            // "Início e duração abaixo" só quando um dos dois ESTÁ abaixo — senão o texto contradiz as barras.
            const algumAbaixo = split && s.pass != null && (Math.round(b.onset) < s.pass || Math.round(b.duration) < s.pass);
            const diagKey = s.diag === 'generic' ? (algumAbaixo ? 'genericSplit' : 'generic') : s.diag;
            const diag = s.diag ? `<p class="cv-diagtext"><span class="cv-diag cv-diag--${s.diag}">${this._esc(this._t(ClassView.DIAG_BADGE[s.diag]))}</span> ${this._esc(this._t(ClassView.DIAG_TEXT[diagKey], { pass: s.pass }))}</p>` : '';
            const passTxt = s.pass != null ? ` · ${this._t('group.class.needs', { pass: s.pass })}` : '';
            return `<li class="cv-stuck" data-key="${this._esc(s.key)}" data-diag="${this._esc(s.diag || '')}">
                <div class="cv-stuckmain">
                    <p class="cv-stuckname"><b>${this._esc(this._name(s))}</b> <span class="cv-muted">· ${this._esc(this._levelLabel(s.level) + passTxt)}</span></p>
                    ${diag}${meters}
                </div>
                <p class="cv-tries"><b>${this._num(s.tries)}</b><span>${this._esc(this._t('group.class.triesShort'))}</span></p>
            </li>`;
        };
        // Os PRIMEIROS (mais tentativas) à vista; o resto recolhido — a lista inteira ocupava três telas
        // para um assunto só (17/set, ele mesmo em prod). <details> nativo, como a tabela.
        const vista = m.stuck.slice(0, ClassView.STUCK_SHOWN).map(linha).join('');
        const resto = m.stuck.slice(ClassView.STUCK_SHOWN);
        const maisKey = resto.length === 1 ? 'group.class.stuckMoreOne' : 'group.class.stuckMore';
        const mais = resto.length
            ? `<details class="cv-details cv-stuckmore" data-more="stuck">
                   <summary>${this._esc(this._t(maisKey, { n: resto.length }))}</summary>
                   <ul class="cv-stucklist">${resto.map(linha).join('')}</ul>
               </details>` : '';
        return `<div class="cv-card" data-card="stuck">
            <h3 class="cv-h3">${this._esc(this._t('group.class.stuckTitle'))}</h3>
            <p class="cv-hint">${this._esc(this._t('group.class.stuckHint', { n: ClassView.STUCK_TRIES }))}</p>
            ${vista ? `<ul class="cv-stucklist">${vista}</ul>${mais}` : `<p class="cv-state" data-note="none-stuck">${this._esc(this._t('group.class.stuckNone'))}</p>`}
        </div>`;
    }

    _seriesCard(m) {
        const d = this.data;
        const n = d.series_days || 30;
        const end = new Date(d.today + 'T00:00:00Z');
        const days = [];
        for (let i = n - 1; i >= 0; i--) { const x = new Date(end); x.setUTCDate(x.getUTCDate() - i); days.push(x.toISOString().slice(0, 10)); }
        const by = {}; (d.series || []).forEach(r => { by[r.d] = r; });
        const withData = days.filter(x => by[x] && by[x].rounds > 0);
        let chart;
        if (!withData.length) {
            chart = `<p class="cv-state" data-note="no-series">${this._esc(this._t(m.summary.rounds == null ? 'group.class.seriesOff' : 'group.class.seriesEmpty', { n }))}</p>`;
        } else {
            const W = 300, H = 94, top = 2, base = 93;
            const max = Math.max(...withData.map(x => by[x].rounds));
            const bw = W / n;
            const bars = days.map((x, i) => {
                const r = by[x] ? by[x].rounds : 0;
                if (!r) return '';
                const h = Math.max(2, Math.round((base - top) * r / max));
                return `<rect x="${(i * bw + 1).toFixed(1)}" y="${base - h}" width="${(bw - 2).toFixed(1)}" height="${h}" rx="1.5" class="cv-bar"><title>${this._esc(this._seriesPart(x, by[x]))}</title></rect>`;
            }).join('');
            const parts = withData.map(x => this._seriesPart(x, by[x]));
            chart = `<p class="cv-ticks cv-ticks--top" aria-hidden="true"><span>${this._esc(this._num(max))}</span></p>
                <svg class="cv-svg" viewBox="0 0 ${W} ${H}" role="img" aria-label="${this._esc(this._t('group.class.seriesAria', { parts: parts.join('; ') }))}" preserveAspectRatio="none">
                <line x1="0" y1="${base + 0.5}" x2="${W}" y2="${base + 0.5}" class="cv-axis" vector-effect="non-scaling-stroke"/>
                ${bars}
            </svg>
            <p class="cv-ticks" aria-hidden="true"><span>${this._esc(this._day(days[0]))}</span><span>${this._esc(this._day(days[days.length - 1]))}</span></p>`;
        }
        return `<div class="cv-card" data-card="series">
            <h3 class="cv-h3">${this._esc(this._t('group.class.seriesTitle'))}</h3>
            <p class="cv-hint">${this._esc(this._t('group.class.seriesHint', { n }))}</p>
            ${chart}
        </div>`;
    }

    _wallsCard(m) {
        const by = {}; (this.data.levels || []).forEach(l => { by[l.level] = l; });
        const measured = m.levels.filter(l => by[l] && by[l].median_n > 0);
        let chart;
        if (!measured.length) {
            chart = `<p class="cv-state" data-note="no-walls">${this._esc(this._t('group.class.wallsEmpty'))}</p>`;
        } else {
            // 🔴 A manchete só com 2+ alunos medidos (auditoria 17/set): um aluno só não é "a turma".
            const firmes = measured.filter(l => by[l].median_n >= ClassView.WALL_MIN_N);
            const top = firmes.length ? firmes.reduce((a, l) => (by[l].median_tries > by[a].median_tries ? l : a), firmes[0]) : null;
            const max = Math.max(...measured.map(l => by[l].median_tries));
            const W = 300, H = 110, t0 = 2, base = 100;
            const bw = W / m.levels.length;
            const here = {}; m.started.forEach(s => { if (!s.done) here[s.level] = (here[s.level] || 0) + 1; });
            const bars = m.levels.map((l, i) => {
                const x = (i * bw + 1).toFixed(1), w = Math.max(1, bw - 2).toFixed(1);
                const mark = here[l] ? `<rect x="${(i * bw + bw * 0.2).toFixed(1)}" y="${base + 4}" width="${(bw * 0.6).toFixed(1)}" height="4" rx="1" class="cv-here"/>` : '';
                if (!by[l] || !by[l].median_n) return mark;
                const h = Math.max(2, Math.round((base - t0) * by[l].median_tries / max));
                return `<rect x="${x}" y="${base - h}" width="${w}" height="${h}" rx="1.5" class="cv-bar${l === top ? ' cv-bar--top' : ''}"><title>${this._esc(this._wallPart(l, by[l], here[l]))}</title></rect>${mark}`;
            }).join('');
            // A mediana só mede quem PASSOU: quem está parado no nível agora entra na frase, senão
            // um nível com 4 empacados e 1 aprovado de primeira pareceria fácil (auditoria 17/set).
            const parts = measured.map(l => this._wallPart(l, by[l], here[l]));
            const stuckNow = m.levels.filter(l => !(by[l] && by[l].median_n) && here[l]).map(l => this._t('group.class.wallsOnlyHere', { level: l, n: here[l] }));
            chart = `${top != null ? `<p class="cv-walltop">${this._esc(this._t('group.class.wallsTop', { level: top, median: this._num(by[top].median_tries) }))}</p>` : ''}
                <p class="cv-ticks cv-ticks--top" aria-hidden="true"><span>${this._esc(this._num(max))}</span></p>
                <svg class="cv-svg" viewBox="0 0 ${W} ${H}" role="img" aria-label="${this._esc(this._t('group.class.wallsAria', { parts: parts.concat(stuckNow).join('; ') }))}" preserveAspectRatio="none">
                    <line x1="0" y1="${base + 0.5}" x2="${W}" y2="${base + 0.5}" class="cv-axis" vector-effect="non-scaling-stroke"/>
                    ${bars}
                </svg>
                <p class="cv-ticks" aria-hidden="true"><span>${this._esc(this._levelLabel(m.levels[0]))}</span><span>${this._esc(this._levelLabel(m.levels[m.levels.length - 1]))}</span></p>
                <p class="cv-legend" aria-hidden="true"><span><i class="cv-dot cv-dot--here"></i>${this._esc(this._t('group.class.wallsHere'))}</span></p>`;
        }
        return `<div class="cv-card" data-card="walls">
            <h3 class="cv-h3">${this._esc(this._t('group.class.wallsTitle'))}</h3>
            <p class="cv-hint">${this._esc(this._t('group.class.wallsHint'))}</p>
            ${chart}
        </div>`;
    }

    _tableCard(m) {
        const dash = (v) => (v == null ? '—' : v);
        const rows = m.students.map(s => `<tr data-key="${this._esc(s.key)}">
                <th scope="row">${this._esc(this._name(s))}</th>
                <td>${s.started ? (s.done ? '✓ ' + s.level : s.level) : '—'}</td>
                <td>${s.started && !s.done ? this._esc(dash(s.tries)) : '—'}</td>
                <td class="cv-hide-m">${this._esc(s.rounds == null ? '—' : this._num(s.rounds))}</td>
                <td>${this._esc(s.seconds == null ? '—' : this._time(s.seconds))}</td>
            </tr>`).join('');
        return `<div class="cv-card" data-card="table">
            <details class="cv-details">
                <summary>${this._esc(this._t('group.class.tableSummary', { n: m.students.length }))}</summary>
                <div class="cv-tablewrap"><table class="cv-table">
                    <thead><tr>
                        <th scope="col">${this._esc(this._t('group.class.colName'))}</th>
                        <th scope="col">${this._esc(this._t('group.class.colLevel'))}</th>
                        <th scope="col">${this._esc(this._t('group.class.colTries'))}</th>
                        <th scope="col" class="cv-hide-m">${this._esc(this._t('group.class.colRounds'))}</th>
                        <th scope="col">${this._esc(this._t('group.class.colTime'))}</th>
                    </tr></thead>
                    <tbody>${rows}</tbody>
                </table></div>
            </details>
        </div>`;
    }

    // ----- interação ------------------------------------------------------------------

    _click(e) {
        const b = e.target.closest('[data-cv]');
        if (!b || !this.el || !this.el.contains(b)) return;
        const act = b.dataset.cv;
        if (act === 'retry') { this.load(undefined, 'retry'); return; }
        if (act === 'game') { if (b.dataset.game !== this.game) { this.selected = null; this.load(b.dataset.game, 'game'); } return; }
        if (act === 'pick') {
            const key = b.dataset.key;
            this.selected = this.selected === key ? null : key;
            // Só o detalhe e o estado dos botões mudam: redesenhar tudo tiraria o foco do dedo/teclado.
            this.el.querySelectorAll('[data-cv="pick"]').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.key === this.selected)));
            const det = this.el.querySelector('[data-detail]');
            const s = this.selected && this._model ? this._model.students.find(x => x.key === this.selected) : null;
            if (det) det.innerHTML = s ? this._detail(s) : '';
            // 🔴 O detalhe abre DEPOIS da lista de nomes, e numa turma grande (55 alunos na MICA) ela é
            //    mais alta que a tela: o nome destacava e parecia que nada acontecia (17/set, ele mesmo
            //    achou em prod). Rola o MÍNIMO para o detalhe entrar na tela; ao fechar, não rola nada.
            const selEl = this.el.querySelector('#cv-pick');
            if (selEl) selEl.value = this.selected || '';
            if (det && s && det.scrollIntoView) { try { det.scrollIntoView({ block: 'nearest' }); } catch (e) { det.scrollIntoView(false); } }
        }
    }

    /** O seletor de aluno: mesmo efeito do toque no nome, sem rolagem (o detalhe está logo abaixo). */
    _change(e) {
        if (!this.el || e.target.id !== 'cv-pick') return;
        this.selected = e.target.value || null;
        const det = this.el.querySelector('[data-detail]');
        const s = this.selected && this._model ? this._model.students.find(x => x.key === this.selected) : null;
        if (det) det.innerHTML = s ? this._detail(s) : '';
        this.el.querySelectorAll('[data-cv="pick"]').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.key === this.selected)));
    }

    static _css() {
        // Paleta do app (indigo #4f46e5, como GroupScreen/StatsScreen). O app é CLARO: não há
        // tema escuro em styles.css (medido 17/set) e um cartão escuro numa página clara seria ruído.
        return `
        .cv{margin-top:1.2rem;scroll-margin-top:72px;}
        .cv-head{margin:0 0 .7rem;}
        .cv-h2{margin:0;font-size:1.25rem;color:#1f2937;}
        .cv-private{margin:.25rem 0 .6rem;color:#64748b;font-size:.85rem;line-height:1.4;}
        .cv-gameone{margin:0;color:#475569;font-size:.9rem;}
        .cv-games{display:flex;flex-wrap:wrap;gap:.4rem;}
        .cv-pill{min-height:44px;padding:.4rem .95rem;border-radius:999px;border:1px solid #c7d2fe;background:#fff;color:#3730a3;font-weight:600;font-size:.9rem;font-family:inherit;cursor:pointer;}
        .cv-pill[aria-pressed="true"]{background:#4f46e5;border-color:#4f46e5;color:#fff;}
        .cv-card{background:#fff;border:1px solid #eef0f5;border-radius:14px;padding:1rem 1.1rem;margin-bottom:.8rem;box-shadow:0 2px 10px rgba(0,0,0,.05);min-width:0;}
        .cv-center{text-align:center;}
        .cv-state{margin:.4rem 0;color:#64748b;font-size:.95rem;line-height:1.45;}
        .cv-btn{min-height:44px;padding:.5rem 1.1rem;border:none;border-radius:999px;background:#4f46e5;color:#fff;font-weight:600;font-family:inherit;cursor:pointer;}
        .cv-h3{margin:0 0 .2rem;font-size:1.05rem;color:#1f2937;}
        .cv-hint{margin:0 0 .7rem;color:#64748b;font-size:.84rem;line-height:1.4;}
        .cv-note{margin:.6rem 0 0;color:#64748b;font-size:.84rem;line-height:1.4;overflow-wrap:anywhere;}
        .cv-muted{color:#64748b;}
        .cv-stats{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:.5rem;}
        @media (max-width:520px){.cv-stats{grid-template-columns:repeat(2,minmax(0,1fr));}}
        .cv-stat{background:#f5f6fb;border-radius:10px;padding:.6rem .4rem;text-align:center;min-width:0;}
        .cv-stat b{display:block;font-size:1.3rem;line-height:1.15;color:#1f2937;overflow-wrap:anywhere;}
        .cv-stat span{display:block;font-size:.74rem;color:#475569;line-height:1.25;margin-top:.15rem;}
        .cv-worlds{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:.45rem;}
        .cv-world{background:#f5f6fb;border-radius:10px;padding:.4rem .3rem .3rem;min-width:0;}
        .cv-world--wide{grid-column:1/-1;}
        .cv-wname{margin:0 0 .3rem;font-size:.7rem;font-weight:700;color:#475569;text-align:center;line-height:1.2;overflow-wrap:anywhere;}
        .cv-cols{display:grid;gap:1px;align-items:end;}
        .cv-col{display:flex;flex-direction:column;align-items:center;min-width:0;}
        .cv-stack{display:flex;flex-direction:column-reverse;align-items:center;gap:2px;min-height:var(--cv-stack,40px);justify-content:flex-start;}
        .cv-dot{display:inline-block;width:12px;height:12px;border-radius:50%;background:#6366f1;flex:0 0 auto;}
        .cv-dot--stuck{background:#fff;box-shadow:inset 0 0 0 2.5px #d97706;}
        .cv-dot--done{background:#059669;}
        .cv-dot--here{background:#d97706;width:8px;height:8px;}
        .cv-more{font-style:normal;font-size:.62rem;color:#475569;line-height:1;}
        .cv-lv{font-size:.62rem;color:#64748b;margin-top:2px;}
        .cv-legend{display:flex;flex-wrap:wrap;gap:.3rem .9rem;margin:.55rem 0 0;font-size:.76rem;color:#64748b;}
        .cv-legend i{margin-right:.3rem;vertical-align:-1px;}
        .cv-taphint{margin:.8rem 0 .4rem;}
        .cv-pickrow{display:flex;align-items:center;gap:.5rem;flex-wrap:wrap;margin:.7rem 0 0;}
        .cv-picklabel{font-size:.9rem;font-weight:600;color:#4b5563;}
        .cv-select{min-height:44px;flex:1 1 12rem;min-width:0;max-width:100%;padding:.35rem .6rem;border:1px solid #c7d2fe;border-radius:10px;background:#fff;color:#1f2937;font-size:.95rem;font-family:inherit;}
        .cv-chips{list-style:none;margin:0;padding:0;display:flex;flex-wrap:wrap;gap:.35rem;}
        .cv-chip{display:inline-flex;align-items:center;gap:.4rem;min-height:44px;max-width:100%;padding:.3rem .45rem .3rem .75rem;border-radius:999px;border:1px solid #e0e7ff;background:#fff;color:#1f2937;font-weight:500;font-size:.88rem;font-family:inherit;cursor:pointer;}
        .cv-chip[aria-pressed="true"]{border-color:#4f46e5;box-shadow:0 0 0 2px #4f46e5 inset;}
        .cv-chip--stuck{border-color:#f59e0b;}
        .cv-chipname{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:10rem;}
        .cv-chiplv{display:inline-flex;align-items:center;justify-content:center;min-width:1.9rem;height:1.6rem;padding:0 .35rem;border-radius:999px;background:#eef2ff;color:#3730a3;font-weight:700;font-size:.8rem;}
        .cv-chip--stuck .cv-chiplv{background:#fef3c7;color:#92400e;}
        .cv-chip--done .cv-chiplv{background:#d1fae5;color:#065f46;}
        .cv-detail{scroll-margin:84px 0 16px;}
        .cv-detail:not(:empty){margin-top:.6rem;background:#f5f6fb;border-radius:10px;padding:.6rem .8rem;font-size:.9rem;line-height:1.45;color:#1f2937;}
        .cv-detail p{margin:.15rem 0;overflow-wrap:anywhere;}
        .cv-diag{display:inline-block;padding:.05rem .5rem;border-radius:999px;font-size:.76rem;font-weight:700;}
        .cv-diag--hold{background:#fef3c7;color:#92400e;}
        .cv-diag--timing{background:#e0f2fe;color:#075985;}
        .cv-diag--generic{background:#f1f5f9;color:#334155;}
        .cv-stucklist{list-style:none;margin:0;padding:0;}
        .cv-stuck{display:flex;gap:.7rem;align-items:flex-start;padding:.7rem 0;border-top:1px solid #eef0f5;}
        .cv-stuck:first-child{border-top:0;padding-top:.2rem;}
        .cv-stuckmore{margin-top:.5rem;border-top:1px solid #eef0f5;padding-top:.3rem;}
        .cv-stuckmore .cv-stuck:first-child{border-top:0;}
        .cv-stuckmain{flex:1;min-width:0;}
        .cv-stuckname{margin:0 0 .25rem;overflow-wrap:anywhere;}
        .cv-diagtext{margin:0 0 .35rem;font-size:.85rem;color:#334155;line-height:1.4;}
        .cv-meterrow{display:grid;grid-template-columns:4.6rem minmax(0,1fr) 2.6rem;align-items:center;gap:.4rem;font-size:.8rem;margin:.2rem 0;}
        .cv-meterlbl{color:#64748b;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
        .cv-meter{position:relative;height:8px;border-radius:4px;background:#e5e7eb;}
        .cv-meter b{position:absolute;left:0;top:0;bottom:0;border-radius:4px;background:#6366f1;}
        .cv-meter b.cv-low{background:#d97706;}
        .cv-meter em{position:absolute;top:-4px;bottom:-4px;width:2px;background:#1f2937;}
        .cv-meterval{text-align:right;font-variant-numeric:tabular-nums;color:#1f2937;}
        .cv-low-t{color:#b45309;font-weight:700;}
        .cv-tries{margin:0;text-align:right;line-height:1.1;flex:0 0 auto;}
        .cv-tries b{display:block;font-size:1.25rem;color:#1f2937;}
        .cv-tries span{font-size:.72rem;color:#64748b;}
        .cv-svg{display:block;width:100%;height:110px;}
        .cv-ticks{display:flex;justify-content:space-between;margin:.2rem 0 0;font-size:.72rem;color:#64748b;}
        .cv-ticks--top{margin:0 0 .15rem;}
        .cv-bar{fill:#6366f1;}
        .cv-bar--top{fill:#d97706;}
        .cv-here{fill:#d97706;}
        .cv-axis{stroke:#cbd5e1;stroke-width:1;}
                .cv-walltop{margin:0 0 .4rem;font-size:.88rem;color:#334155;}
        .cv-details summary{min-height:44px;display:flex;align-items:center;gap:.45rem;font-weight:700;color:#1f2937;cursor:pointer;list-style:none;}
        .cv-details summary::-webkit-details-marker{display:none;}
        .cv-details summary::before{content:'▸';color:#4f46e5;transition:transform .15s;}
        .cv-details[open] summary::before{transform:rotate(90deg);}
        .cv-tablewrap{overflow-x:auto;}
        .cv-table{width:100%;border-collapse:collapse;font-size:.85rem;}
        .cv-table th,.cv-table td{padding:.45rem .3rem;text-align:right;border-top:1px solid #eef0f5;white-space:nowrap;}
        .cv-table thead th{font-size:.72rem;color:#64748b;border-top:0;}
        .cv-table th:first-child{text-align:left;white-space:normal;overflow-wrap:anywhere;font-weight:500;}
        @media (max-width:520px){.cv-hide-m{display:none;} .cv-card{padding:.85rem .8rem;}}`;
    }
}

window.ClassView = ClassView;



// ============================================
// screens/GroupScreen.js
// ============================================
/**
 * GroupScreen — a PÁGINA de um grupo (`#/grupo/:id`) e o PEDIDO de criação (`#/grupo/novo`).
 * Autonomia de grupos, 15/set/2026: docs/GRUPOS-AUTONOMIA-PLANO.md.
 *
 * NÃO é jogo: estende BaseScreen (load → render). Rota AVULSA no Main (fora de `Main.MENU`,
 * porque não é item do ☰; fora de `Main.GAMES` e de `Beacon.GAME_ROUTES`, porque não é
 * jogo). Chega-se por três portas: o cartão "Grupo" em #/perfil (pedir / ver a página), o
 * LINK DE CONVITE `#/grupo/7?join=ABCD2345` que o organizador cola onde a turma está, e o
 * e-mail de liberação.
 *
 * 🔴 A página é PÚBLICA (decisão 2 de 15/set): convidado vê nome, descrição no idioma do
 *    domínio, quantos e a logo — nunca o código, nunca nomes. O botão "Entrar neste grupo"
 *    só existe quando a URL traz `?join=CÓDIGO`: o código É o convite, a página não o
 *    substitui. Deslogado com convite: entra/cria conta e o pedido de entrada continua
 *    sozinho (`userStateChanged`; no Google a rota inteira, com a query, volta pelo
 *    `saveReturnRoute`). Depois de entrar o `?join=` sai da URL (replaceState): recarregar
 *    não repete o pedido, e a URL "limpa" é a que se compartilha.
 * 🔴 A recusa é do SERVIDOR e vira frase (`auth.errors.<code>`): nada é validado antes de
 *    postar (a lição de 13/ago). O `maxlength` dos campos é só o teto do dedo.
 * 🔴 A logo entra DEPOIS do pedido (precisa do id): o arquivo escolhido fica em memória e
 *    sobe logo após o `request_group` responder — se falhar, o pedido já existe e a pessoa
 *    manda a logo de novo pelo "Editar". Nunca um pedido perdido por causa de uma imagem.
 * 🔴 `#/grupo/novo` é o MESMO padrão de rota (`:id` = 'novo'): um único registro no Router.
 */
class GroupScreen extends BaseScreen {
    static TITLE_KEY = 'group.title';
    static NEW_ID = 'novo';
    static DESC_MAX = 600;   // espelho de GROUP_DESC_MAX (groups.php) — o servidor corta de qualquer jeito
    static NOTE_MAX = 500;   // espelho de GROUP_NOTE_MAX
    static NAME_MAX = 60;    // espelho de GROUP_NAME_MAX
    static LOGO_MAX_BYTES = 2 * 1024 * 1024;   // espelho de GROUP_LOGO_IN_MAX_BYTES
    static LOGO_CLIENT_MAX_SIDE = 1024;        // lado máximo que SAI do aparelho (o servidor grava 256)
    /** PAÍS opcional (17/set): ISO 3166-1 alfa-2 — espelho de GROUP_COUNTRIES (groups.php), conferido pelo teste. */
    static COUNTRIES = 'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(' ');
    static LOCALE = { pt: 'pt-BR', en: 'en', es: 'es' };
    /**
     * SELOS "✨ Novo" para quem organiza (17/set): o aviso mora ONDE a novidade está. Cada um some quando
     * a pessoa o usa/fecha (marca no APARELHO, fora do StorageScope — é preferência de tela, como a
     * ajuda) ou depois de `until` (inclusive). Selo que não expira vira enfeite eterno.
     */
    static NEWS = { country: { until: '2026-10-17' }, classview: { until: '2026-10-17' } };
    static NEWS_KEY = 'group_news_seen_v1';
    /** Data LOCAL de hoje (AAAA-MM-DD). Método para o teste poder mover o relógio. */
    static today() { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
    static newsOn(id) {
        const n = GroupScreen.NEWS[id];
        if (!n || GroupScreen.today() > n.until) return false;
        try { return !JSON.parse(localStorage.getItem(GroupScreen.NEWS_KEY) || '{}')[id]; } catch (e) { return true; }
    }
    static newsSeen(id) {
        try { const o = JSON.parse(localStorage.getItem(GroupScreen.NEWS_KEY) || '{}'); o[id] = 1; localStorage.setItem(GroupScreen.NEWS_KEY, JSON.stringify(o)); } catch (e) { /* sem storage: volta a aparecer, e só */ }
    }

    /** 'KR' → 🇰🇷 (dois indicadores regionais; sem imagem — no Windows sai "KR", e o nome vai junto). */
    static flag(code) {
        return /^[A-Z]{2}$/.test(code || '') ? String.fromCodePoint(...[...code].map(ch => 0x1F1E6 + ch.charCodeAt(0) - 65)) : '';
    }

    /**
     * Encolhe a imagem NO APARELHO antes de subir. Foto de celular tem 4032×3024 (12 Mpx) e
     * o servidor recusa acima de 6 Mpx (`logo_too_large_dims`) — foi a 1ª logo real, 15/set.
     * Redesenha em canvas até LOGO_CLIENT_MAX_SIDE e devolve PNG (mantém transparência).
     * 🔴 Falha em qualquer passo (imagem inválida, canvas indisponível) devolve o arquivo
     * ORIGINAL: a decisão final é do servidor, isto é só economia de rede e de recusa.
     */
    static async shrinkLogo(file) {
        try {
            if (!file || !/^image\//.test(file.type || '') || typeof createImageBitmap !== 'function') return file;
            const bmp = await createImageBitmap(file);
            const max = GroupScreen.LOGO_CLIENT_MAX_SIDE;
            const w = bmp.width, h = bmp.height;
            if (w <= max && h <= max && file.size <= GroupScreen.LOGO_MAX_BYTES) { if (bmp.close) bmp.close(); return file; }
            const k = Math.min(1, max / Math.max(w, h));
            const cw = Math.max(1, Math.round(w * k)), ch = Math.max(1, Math.round(h * k));
            const cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
            cv.getContext('2d').drawImage(bmp, 0, 0, cw, ch);
            if (bmp.close) bmp.close();
            const blob = await new Promise(r => cv.toBlob(r, 'image/png'));
            if (!blob) return file;
            return new File([blob], String(file.name || 'logo').replace(/\.[^.]+$/, '') + '.png', { type: 'image/png' });
        } catch (e) { return file; }
    }

    constructor() {
        super();
        this._mode = 'page';       // 'page' | 'new' | 'edit'
        this._id = null;
        this._data = null;         // bloco do grupo (page ou owner)
        this._preview = false;
        this._error = '';          // 'notfound' | 'network' | ''
        this._formError = '';
        this._busy = false;
        this._joinCode = '';
        this._joinError = '';
        this._joined = false;
        this._pendingLogo = null;  // File escolhido antes de existir o grupo
        this._logoPrep = null;     // Promise do encolhimento em curso (o submit espera)
        this._draft = null;        // o que foi digitado, preservado quando a recusa redesenha o formulário
        this._uid = null;          // quem estava logado quando a tela montou (auto-entrada só para uid NOVO)
        this._joinTried = false;   // recusa já vista: o join automático não reposta (só o clique)
        this._from = '';           // 'page' quando o editor foi aberto de #/grupo/:id (para voltar para lá)
        this._logoV = '';
        this._reqId = 0;
    }

    getTitle() {
        if (this._mode === 'new') return this._t('group.newTitle');
        if (this._data && this._data.name && this._classMode()) return this._t('group.class.title') + ' · ' + this._data.name;
        if (this._data && this._data.name) return this._data.name;
        return this._t('group.title');
    }

    // ----- ciclo ------------------------------------------------------------------

    async load(params = {}) {
        this._id = String(params.id || '');
        this._joinCode = String(params.join || '').trim();
        this._mode = this._id === GroupScreen.NEW_ID ? 'new' : (params.edit ? 'edit' : 'page');
        this._from = String(params.from || '');
        this._turma = !!params.turma;   // `?turma=1`: a VISÃO DA TURMA sozinha (só dono/admin; os outros veem a página)
        this._uid = this._currentUid();
        if (!this._onUserChange) {
            this._onUserChange = () => { this._afterUserChange(); };
            document.addEventListener('userStateChanged', this._onUserChange);
        }
        await this._fetch();
    }

    destroy() {
        if (this._onUserChange) { document.removeEventListener('userStateChanged', this._onUserChange); this._onUserChange = null; }
        if (this._cv) { this._cv.destroy(); this._cv = null; }
        if (this._gr) { this._gr.destroy(); this._gr = null; }
        super.destroy();
    }

    _currentUid() {
        const um = window.userManager;
        return (um && um.isLoggedIn() && um.getUserId) ? String(um.getUserId()) : null;
    }

    /**
     * Login/logout com a tela aberta. 🔴 Só reage quando a PESSOA mudou (uid diferente):
     * o `check_session` do boot reidrata a MESMA sessão e dispara `userStateChanged` — sem
     * esta régua, quem já estava logado entrava no grupo sem tocar em nada, e o formulário
     * em digitação era redesenhado vazio (auditoria 15/set, A1/A2). O `setUser` do próprio
     * `joinGroup`/`uploadGroupLogo` também cai aqui, com o mesmo uid: ignorado.
     */
    async _afterUserChange() {
        if (!this._isMounted()) return;
        const uid = this._currentUid();
        if (uid === this._uid) return;
        const veioDeConvidado = this._uid === null && uid !== null;
        this._uid = uid;
        // Outra pessoa (ou ninguém): o que era desta conta não vale mais.
        this._joined = false; this._joinError = ''; this._joinTried = false;
        if (this._mode !== 'page') this._draft = this._formValues();
        await this._fetch();
        if (!this._isMounted()) return;
        this.render();
        // Auto-entrada SÓ para quem acabou de entrar na conta A PARTIR desta tela (era convidado).
        if (this._mode === 'page' && this._joinCode && veioDeConvidado && !this._joinTried) this._join();
    }

    async _fetch() {
        const um = window.userManager;
        const id = ++this._reqId;
        this._error = '';
        if (this._mode === 'new') {
            // Pedido recusado: o formulário nasce preenchido com o que a pessoa escreveu.
            this._data = null;
            const mine = um && um.getOwnedGroup ? um.getOwnedGroup() : null;
            if (mine && um.fetchProfile) {
                const p = await um.fetchProfile();
                if (id !== this._reqId) return;
                if (p && p.owned_group) this._data = p.owned_group;
            }
            return;
        }
        if (this._mode === 'edit') {
            this._data = null;
            const p = um && um.isLoggedIn() && um.fetchProfile ? await um.fetchProfile() : null;
            if (id !== this._reqId) return;
            if (p && p.owned_group && String(p.owned_group.id) === this._id) { this._data = p.owned_group; return; }
            // Admin editando o grupo de outra pessoa: cai na página com a prévia (edição de
            // admin é pelo cartão de administração, não por aqui).
            this._mode = 'page';
        }
        const lang = (window.language && window.language.currentLanguage) || '';
        const r = um && um.fetchGroupPage ? await um.fetchGroupPage(this._id, lang) : { success: false, code: 'network' };
        if (id !== this._reqId) return;
        if (r.success) { this._data = r.group; this._preview = !!r.preview; this._logoV = r.group.logo_v || ''; }
        else { this._data = null; this._error = r.code === 'no_group' || r.code === 'bad_group' ? 'notfound' : 'network'; }
    }

    // ----- render -----------------------------------------------------------------

    renderLoading() {
        if (!this.container) return;
        this.container.innerHTML = this._shell(`<p class="gp-state">${this._esc(this._t('app.loading'))}</p>`, 'loading');
    }

    render() {
        // O BaseScreen sincroniza o título ANTES do load (quando o nome ainda não chegou):
        // refazer aqui é o que põe o nome do grupo na aba.
        this._syncDocumentTitle();
        if (this._mode === 'new' || this._mode === 'edit') { this._renderForm(); return; }
        if (!this._data) { this._renderMissing(); return; }
        if (this._classMode()) { this._renderClass(); return; }
        this._renderPage();
    }

    /** Quem organiza ESTE grupo (dono) ou o admin — os únicos que o servidor deixa ver a turma. */
    _canManage() {
        const um = window.userManager;
        if (!(um && um.isLoggedIn()) || !this._data) return false;
        const owned = um.getOwnedGroup ? um.getOwnedGroup() : null;
        return !!(owned && owned.id === Number(this._data.id)) || !!(um.isAdmin && um.isAdmin());
    }

    /** `?turma=1` vale só para quem pode: os outros (e quem deslogou com a tela aberta) veem a página. */
    _classMode() { return this._mode === 'page' && this._turma && this._canManage(); }

    /**
     * A VISÃO DA TURMA numa tela só dela (`#/grupo/:id?turma=1`, 17/set): a página do grupo fica
     * leve para todo mundo, e a análise carrega quando quem organiza PEDE. Cabeçalho mínimo
     * (logo pequena, nome, volta para a página) + o componente.
     */
    _renderClass() {
        const g = this._data;
        if (this._gr) { this._gr.destroy(); this._gr = null; }
        this.container.innerHTML = this._shell(`
            <div class="gp-classbar">
                <a class="gp-btn gp-btn--ghost" href="#/grupo/${this._esc(g.id)}" data-act="backpage"><span aria-hidden="true">←</span> ${this._esc(this._t('group.class.backPage'))}</a>
                <div class="gp-classname">${this._logoHtml(g, false)}<span>${this._esc(g.name)}</span></div>
            </div>`, 'ready');
        this._mountClassView(g, true);
    }

    _shell(body, state) {
        return `<div class="gp-screen" data-state="${state}" data-mode="${this._mode}"><style>${GroupScreen._css()}</style>${body}</div>`;
    }

    _renderMissing() {
        const key = this._error === 'network' ? 'app.loadError' : 'group.page.notFound';
        this.container.innerHTML = this._shell(`
            <div class="gp-card gp-center">
                <p class="gp-lead">${this._esc(this._t(key))}</p>
                <a class="gp-btn" href="#/">${this._esc(this._t('nav.home'))}</a>
            </div>`, this._error || 'missing');
    }

    /** Nome do país no idioma da tela — quem traduz é o navegador (Intl), não uma tabela nossa. */
    _countryName(code) {
        const lg = (window.language && window.language.currentLanguage) || 'pt';
        // UMA instância por idioma: uma por país custava 21 ms por desenho do formulário (auditoria).
        if (!GroupScreen._names || GroupScreen._namesLang !== lg) {
            GroupScreen._namesLang = lg;
            try { GroupScreen._names = new Intl.DisplayNames([GroupScreen.LOCALE[lg] || lg], { type: 'region' }); } catch (e) { GroupScreen._names = null; }
        }
        try { return (GroupScreen._names && GroupScreen._names.of(code)) || code; } catch (e) { return code; }
    }

    _logoHtml(g, big = true) {
        if (!g || !g.has_logo) return `<div class="gp-logo gp-logo--fallback${big ? '' : ' gp-logo--small'}" aria-hidden="true">🏫</div>`;
        const src = window.UserManager && window.UserManager.groupLogoUrl ? window.UserManager.groupLogoUrl(g.id, g.logo_v || this._logoV) : '';
        return `<img class="gp-logo${big ? '' : ' gp-logo--small'}" src="${this._esc(src)}" alt="${this._esc(this._t('group.page.logoAlt', { name: g.name }))}" width="128" height="128">`;
    }

    _renderPage() {
        const g = this._data;
        const um = window.userManager;
        const logged = !!(um && um.isLoggedIn());
        const mine = logged && um.getGroup ? um.getGroup() : null;           // grupo em que estou
        const owned = logged && um.getOwnedGroup ? um.getOwnedGroup() : null; // grupo que organizo
        const isMember = !!(mine && mine.id === Number(g.id));
        const isOwner = !!(owned && owned.id === Number(g.id));
        const n = Number(g.members) || 0;
        const quantos = this._t(n === 1 ? 'profile.group.membersOne' : 'profile.group.members', { n });
        const desc = (g.description || '').trim();

        let acao = '';
        if (isOwner) {
            const novoPais = GroupScreen.newsOn('country');
            acao = `<p class="gp-you" data-you="owner">${this._esc(this._t('group.page.owner'))}</p>
                    <div class="gp-btns">
                        <a class="gp-btn gp-btn--ghost" href="#/grupo/${this._esc(g.id)}?edit=1&from=page" data-act="edit">${this._esc(this._t(g.live === false ? 'profile.group.owner.edit' : 'profile.group.owner.editLive'))}</a>
                        ${novoPais ? `<button type="button" class="gp-new" data-news="country" aria-expanded="false" aria-controls="gp-newtip-country"><span aria-hidden="true">✨</span> ${this._esc(this._t('group.news.badge'))}</button>` : ''}
                    </div>
                    ${novoPais ? `<div class="gp-newtip" id="gp-newtip-country" data-newstip="country" hidden>
                        <p>${this._esc(this._t('group.news.country'))}</p>
                        <button type="button" class="gp-btn gp-btn--ghost" data-newsok="country">${this._esc(this._t('group.news.ok'))}</button>
                    </div>` : ''}`;
        } else if (isMember || (this._joined && logged)) {
            acao = `<p class="gp-you" data-you="member">${this._esc(this._t('group.page.joined'))}</p>`;
        } else if (this._joinCode && g.live !== false) {
            const inOther = `<p class="gp-error" role="alert">${this._esc(this._t('group.page.inOther'))} <a href="#/perfil" class="gp-link">${this._esc(this._t('profile.title'))}</a></p>`;
            const erro = this._joinError
                ? (this._joinError === 'already_in_group' ? inOther : `<p class="gp-error" role="alert">${this._esc(this._t('auth.errors.' + this._joinError))}</p>`)
                // Já está em OUTRO grupo: a tela sabe antes do clique (auditoria M3) — o botão fica
                // (quem decide é o servidor), a nota diz o caminho.
                : (mine ? inOther : '');
            const joinLbl = this._t(this._busy ? 'group.page.joining' : 'group.page.join');
            acao = logged
                ? `<div class="gp-btns"><button type="button" class="gp-btn" data-act="join"${this._busy ? ' disabled' : ''}>${this._esc(joinLbl)}</button></div>${erro}
                   <p class="gp-note">${this._esc(this._t('group.page.joinNote'))}</p>`
                : `<div class="gp-btns"><button type="button" class="gp-btn" data-act="login">${this._esc(this._t('group.page.joinLogin'))}</button></div>
                   <p class="gp-note">${this._esc(this._t('group.page.joinNote'))}</p>`;
        } else if (!logged || !mine) {
            acao = `<p class="gp-note">${this._esc(this._t('group.page.askCode'))}</p>`;
        }
        const preview = this._preview ? `<p class="gp-preview" role="status">${this._esc(this._t('group.page.preview'))}</p>` : '';
        this.container.innerHTML = this._shell(`
            ${preview}
            <div class="gp-card">
                <div class="gp-head">
                    ${this._logoHtml(g)}
                    <div class="gp-headinfo">
                        <h1 class="gp-name">${this._esc(g.name)}</h1>
                        ${g.country && GroupScreen.flag(g.country) ? `<p class="gp-country" data-country="${this._esc(g.country)}"><span class="gp-flag" aria-hidden="true">${GroupScreen.flag(g.country)}</span> ${this._esc(this._countryName(g.country))}</p>` : ''}
                        <p class="gp-count">${this._esc(quantos)}</p>
                    </div>
                </div>
                <p class="gp-desc${desc ? '' : ' gp-desc--empty'}">${this._esc(desc || this._t('group.page.noDescription'))}</p>
                ${acao}
            </div>`, 'ready');
        this.container.querySelector('[data-act=join]')?.addEventListener('click', () => { this._joinTried = false; this._join(); });
        this.container.querySelector('[data-act=login]')?.addEventListener('click', () => window.authModal?.open('signup'));
        // Selo do país: tocar abre o aviso; "Entendi" ou abrir o editor (onde o campo está) o apaga.
        const chip = this.container.querySelector('[data-news=country]');
        const tip = this.container.querySelector('[data-newstip=country]');
        if (chip && tip) {
            chip.addEventListener('click', () => { tip.hidden = !tip.hidden; chip.setAttribute('aria-expanded', String(!tip.hidden)); });
            tip.querySelector('[data-newsok]').addEventListener('click', () => {
                GroupScreen.newsSeen('country'); chip.remove(); tip.remove();
                this.container.querySelector('[data-act=edit]')?.focus();
            });
        }
        this.container.querySelector('[data-act=edit]')?.addEventListener('click', () => GroupScreen.newsSeen('country'));
        const isAdmin = !!(logged && um.isAdmin && um.isAdmin());
        // O RANKING DO GRUPO mora na página e é PÚBLICO (17/set, decisão dele): qualquer pessoa,
        // com ou sem conta. Só não existe com o grupo fora do ar (pendente/pausado: sem lista).
        // `viewer` só escolhe a NOTA de quem não está na lista (dono/admin) e o "jogue para estrear".
        const viewer = isOwner ? 'owner' : ((isMember || (this._joined && logged)) ? 'member' : (isAdmin ? 'admin' : 'visitor'));
        this._mountRanking(g, g.live !== false ? viewer : '');
        // A VISÃO DA TURMA não carrega aqui: um cartão explica e leva à tela dela.
        if (this._cv) { this._cv.destroy(); this._cv = null; }
        if (isOwner || isAdmin) {
            const card = document.createElement('div');
            card.innerHTML = `
                <section class="gp-card gp-classcard" aria-labelledby="gp-class-h" data-class-card>
                    <h2 class="gp-h2" id="gp-class-h">${this._esc(this._t('group.class.title'))}${GroupScreen.newsOn('classview') ? ` <span class="gp-newbadge" data-news="classview"><span aria-hidden="true">✨</span> ${this._esc(this._t('group.news.badge'))}</span>` : ''}</h2>
                    <p class="gp-classintro">${this._esc(this._t('group.class.cardIntro', { n: window.ClassView ? window.ClassView.STUCK_TRIES : 10 }))}</p>
                    <p class="gp-note">${this._esc(this._t('group.class.private'))}</p>
                    <div class="gp-btns"><a class="gp-btn" href="#/grupo/${this._esc(g.id)}?turma=1" data-act="openclass">${this._esc(this._t('group.class.cardCta'))}</a></div>
                </section>`;
            const screen = this.container.querySelector('.gp-screen');
            // Logo abaixo do cartão do grupo, antes do ranking: é a razão de quem organiza estar aqui.
            const rank = screen && screen.querySelector('.gp-rankhost');
            if (screen) screen.insertBefore(card.firstElementChild, rank || null);
            this.container.querySelector('[data-act=openclass]')?.addEventListener('click', () => GroupScreen.newsSeen('classview'));
        }
    }

    /**
     * O RANKING DO GRUPO abaixo do cartão (components/GroupRanking.js). Como a ClassView, o
     * componente é MANTIDO entre redesenhos da página (mesmo grupo e mesmo papel: sem novo pedido).
     */
    _mountRanking(g, viewer) {
        if (!viewer || !window.GroupRanking) { if (this._gr) { this._gr.destroy(); this._gr = null; } return; }
        const host = document.createElement('div');
        host.className = 'gp-rankhost';
        this.container.querySelector('.gp-screen')?.appendChild(host);
        // Mesmo grupo, mesmo papel E MESMA PESSOA: trocar de conta sem logout mantinha o "VOCÊ" da
        // anterior e a nota dela (auditoria 17/set).
        const uid = this._currentUid();
        if (this._gr && String(this._gr.groupId) === String(g.id) && this._gr.viewer === viewer && this._gr.uid === uid && this._gr.el) {
            host.appendChild(this._gr.el);
            return;
        }
        if (this._gr) this._gr.destroy();
        this._gr = new window.GroupRanking(host, g, viewer);
        this._gr.uid = uid;
        this._gr.load();
    }

    /**
     * A VISÃO DA TURMA (docs/VISAO-DA-TURMA-PLANO.md) na tela `?turma=1` — só para quem organiza
     * este grupo ou é admin. 🔴 A trava é o servidor (`requireCanManageGroup`); aqui é só não
     * pedir o que viria 403. O componente é MANTIDO entre redesenhos da página (o `innerHTML`
     * acima destrói o nó): o mesmo grupo reaproveita o que já carregou, sem novo pedido.
     */
    _mountClassView(g, can) {
        if (!can || !window.ClassView) { if (this._cv) { this._cv.destroy(); this._cv = null; } return; }
        const host = document.createElement('div');
        host.className = 'gp-classhost';
        this.container.querySelector('.gp-screen')?.appendChild(host);
        if (this._cv && String(this._cv.groupId) === String(g.id) && this._cv.el) {
            host.appendChild(this._cv.el);
            return;
        }
        if (this._cv) this._cv.destroy();
        this._cv = new window.ClassView(host, g.id);
        this._cv.load();
    }

    async _join() {
        if (this._busy || !this._joinCode || this._joinTried) return;
        const um = window.userManager;
        if (!um || !um.isLoggedIn() || !um.joinGroup) return;
        this._busy = true; this._joinError = '';
        // Só o botão muda (não a página inteira): o foco fica onde estava.
        const btn = this.container.querySelector('[data-act=join]');
        if (btn) { btn.disabled = true; btn.textContent = this._t('group.page.joining'); }
        const r = await um.joinGroup(this._joinCode);
        this._busy = false;
        if (!this._isMounted()) return;
        if (!r || !r.success) {
            if (r && r.code === 'session_expired') return;
            this._joinError = (r && r.code) || 'generic';
            // Recusa vista: o automático não reposta (auditoria M2); o clique da pessoa sim.
            if (this._joinError !== 'network') this._joinTried = true;
            this.render();
            this.container.querySelector('[data-act=join]')?.focus();
            return;
        }
        this._joined = true;
        // O convite já foi usado: a URL fica limpa (recarregar não repete; compartilhar não vaza o código).
        try { history.replaceState(null, '', location.pathname + location.search + '#/grupo/' + encodeURIComponent(String(this._data.id))); } catch (e) {}
        this._joinCode = '';
        // A contagem nova vem do servidor na releitura (somar aqui piscava N+2; auditoria B1).
        const id = ++this._reqId;
        const lang = (window.language && window.language.currentLanguage) || '';
        const again = um.fetchGroupPage ? await um.fetchGroupPage(this._data.id, lang) : null;
        if (!this._isMounted() || id !== this._reqId) return;
        if (again && again.success) this._data = again.group;
        this.render();
        window.notifications?.toast(this._t('profile.group.joined', { name: r.group.name }), { type: 'success' });
    }

    // ----- formulário (pedir / editar) ---------------------------------------------

    _renderForm() {
        const um = window.userManager;
        if (!um || !um.isLoggedIn()) {
            this.container.innerHTML = this._shell(`
                <div class="gp-card gp-center">
                    <p class="gp-lead">${this._esc(this._t('group.guest.title'))}</p>
                    <p class="gp-note">${this._esc(this._t('group.guest.body'))}</p>
                    <div class="gp-btns gp-btns--center">
                        <button type="button" class="gp-btn" data-act="signup">${this._esc(this._t('profile.guestSignUp'))}</button>
                        <button type="button" class="gp-btn gp-btn--ghost" data-act="signin">${this._esc(this._t('profile.guestSignIn'))}</button>
                    </div>
                </div>`, 'guest');
            this.container.querySelectorAll('[data-act]').forEach(b => b.addEventListener('click', () => window.authModal?.open(b.dataset.act === 'signup' ? 'signup' : 'signin')));
            this._helpDot();
            return;
        }
        const owned = um.getOwnedGroup ? um.getOwnedGroup() : null;
        // Já organiza um grupo (pendente ou liberado): não há 2º pedido — a porta é o #/perfil.
        if (this._mode === 'new' && owned && owned.status !== 'rejected') {
            this.container.innerHTML = this._shell(`
                <div class="gp-card gp-center">
                    <p class="gp-lead">${this._esc(this._t('auth.errors.' + (owned.status === 'pending' ? 'pending_exists' : 'owner_exists')))}</p>
                    <a class="gp-btn" href="#/perfil">${this._esc(this._t('profile.title'))}</a>
                </div>`, 'has-group');
            return;
        }
        // O que a pessoa DIGITOU vence o que veio do servidor quando a tela é redesenhada por
        // uma recusa (`_draft`): ela corrige, não redigita.
        const g = Object.assign({}, this._data || {}, this._draft ? { name: this._draft.name, description_raw: this._draft.description, request_note: this._draft.note, country: this._draft.country } : {});
        // Países em ordem ALFABÉTICA do idioma da tela (o código não diz nada a quem escolhe).
        const paises = GroupScreen.COUNTRIES.map(c => ({ c, n: this._countryName(c) })).sort((a, b) => a.n.localeCompare(b.n, (window.language && window.language.currentLanguage) || 'pt'));
        const countryOpts = `<option value="">${this._esc(this._t('group.form.countryNone'))}</option>`
            + paises.map(p => `<option value="${p.c}"${p.c === (g.country || '') ? ' selected' : ''}>${this._esc(GroupScreen.flag(p.c) + ' ' + p.n)}</option>`).join('');
        const edit = this._mode === 'edit';
        const erro = this._formError ? `<p class="gp-error" role="alert">${this._esc(this._t('auth.errors.' + this._formError))}</p>` : '';
        const nameLocked = edit && g.status === 'active';
        const logoBlock = edit
            ? `<div class="gp-logorow">
                   ${this._logoHtml(g, false)}
                   <div class="gp-logobtns">
                       <label class="gp-btn gp-btn--ghost gp-file"><input type="file" id="gp-logo" name="logo" accept="image/png,image/jpeg,image/gif,image/webp" data-act="logofile">${this._esc(this._t('group.form.logoChoose'))}</label>
                       ${g.has_logo ? `<button type="button" class="gp-btn gp-btn--ghost" data-act="logoremove">${this._esc(this._t('group.form.logoRemove'))}</button>` : ''}
                   </div>
               </div>`
            : `<label class="gp-btn gp-btn--ghost gp-file"><input type="file" id="gp-logo" name="logo" accept="image/png,image/jpeg,image/gif,image/webp" data-act="logofile">${this._esc(this._t('group.form.logoChoose'))}</label>
               <span class="gp-filename" data-filename>${this._esc(this._pendingLogo ? this._pendingLogo.name : '')}</span>`;
        this.container.innerHTML = this._shell(`
            <header class="gp-formhead">
                <h1 class="gp-title">${this._esc(this._t(edit ? (nameLocked ? 'profile.group.owner.editLive' : 'profile.group.owner.edit') : 'group.newTitle'))}</h1>
                <p class="gp-lead">${this._esc(this._t('group.form.intro'))}</p>
            </header>
            <form class="gp-card gp-form" data-form="group" novalidate>
                <label class="gp-label" for="gp-name">${this._esc(this._t('group.form.nameLabel'))}</label>
                <input id="gp-name" class="gp-input" name="name" type="text" maxlength="${GroupScreen.NAME_MAX}" autocomplete="organization"
                       value="${this._esc(g.name || '')}"${nameLocked ? ' readonly aria-readonly="true"' : ''}>
                ${nameLocked ? `<p class="gp-hint">${this._esc(this._t('auth.errors.name_locked'))}</p>` : ''}

                <label class="gp-label" for="gp-desc">${this._esc(this._t('group.form.descLabel'))}</label>
                <textarea id="gp-desc" class="gp-input gp-textarea" name="description" rows="5" maxlength="${GroupScreen.DESC_MAX}">${this._esc(g.description_raw != null ? g.description_raw : (g.description || ''))}</textarea>
                <p class="gp-hint"><span data-count>${this._esc(this._t('group.form.descHint', { max: GroupScreen.DESC_MAX }))}</span></p>

                <label class="gp-label" for="gp-logo">${this._esc(this._t('group.form.logoLabel'))}</label>
                ${logoBlock}
                <p class="gp-hint">${this._esc(this._t('group.form.logoHint'))}${edit ? '' : ' ' + this._esc(this._t('group.form.logoAfter'))}</p>

                <label class="gp-label" for="gp-country">${this._esc(this._t('group.form.countryLabel'))}</label>
                <select id="gp-country" class="gp-input gp-select" name="country">${countryOpts}</select>
                <p class="gp-hint">${this._esc(this._t('group.form.countryHint'))}</p>

                <label class="gp-label" for="gp-note">${this._esc(this._t('group.form.noteLabel'))}</label>
                <textarea id="gp-note" class="gp-input gp-textarea" name="note" rows="3" maxlength="${GroupScreen.NOTE_MAX}">${this._esc(g.request_note || '')}</textarea>
                <p class="gp-hint">${this._esc(this._t('group.form.noteHint'))}</p>
                ${erro}
                <div class="gp-btns">
                    <button type="submit" class="gp-btn" data-act="submit"${this._busy ? ' disabled' : ''}>${this._esc(this._t(edit ? 'group.form.save' : 'group.form.submit'))}</button>
                    <a class="gp-btn gp-btn--ghost" href="${this._esc(this._backHash())}" data-act="cancel">${this._esc(this._t('common.cancel'))}</a>
                </div>
            </form>`, edit ? 'edit' : 'new');
        const c = this.container;
        if (!edit) this._helpDot();
        c.querySelector('[data-form=group]')?.addEventListener('submit', (e) => { e.preventDefault(); edit ? this._save() : this._submit(); });
        c.querySelector('[data-act=logofile]')?.addEventListener('change', async (e) => {
            const f0 = e.target.files && e.target.files[0];
            if (!f0) return;
            // Foto de celular encolhe AQUI (canvas ≤ 1024 px) — senão 12 Mpx sobem para ouvir "grande demais".
            // 🔴 O envio do formulário ESPERA este encolhimento (`_logoPrep`): escolher a foto e
            //    tocar "Enviar" no mesmo segundo perdia a logo em silêncio (pego pelo teste).
            this._logoPrep = GroupScreen.shrinkLogo(f0);
            const f = await this._logoPrep;
            this._logoPrep = null;
            if (!this._isMounted() || c.querySelector('[data-act=logofile]') !== e.target) return;
            // Teto do arquivo conferido ANTES de subir 5 MB para ouvir "grande demais" (auditoria M5):
            // não é validação de negócio (o servidor confere de novo), é economia de rede e de balde.
            if (f.size > GroupScreen.LOGO_MAX_BYTES) {
                e.target.value = '';
                this._formError = 'logo_too_big';
                this._draft = this._formValues();
                this.render();
                this.container.querySelector('#gp-logo')?.focus();
                return;
            }
            if (edit) this._uploadLogo(f); else { this._pendingLogo = f; const s = c.querySelector('[data-filename]'); if (s) s.textContent = f.name; }
        });
        c.querySelector('[data-act=logoremove]')?.addEventListener('click', () => this._uploadLogo(null, true));
    }

    /** O "?" do pedido de grupo (tópico `app.groups`), ao lado do texto de abertura — convidado e logado. */
    _helpDot() {
        const lead = this.container && this.container.querySelector('.gp-lead');
        if (lead && window.HelpDot && !lead.querySelector('.help-dot')) window.HelpDot.attach(lead, 'app.groups');
    }

    _formValues() {
        const c = this.container;
        return {
            name: c.querySelector('#gp-name')?.value || '',
            description: c.querySelector('#gp-desc')?.value || '',
            note: c.querySelector('#gp-note')?.value || '',
            country: c.querySelector('#gp-country')?.value || ''
        };
    }

    /** Pedir: `request_group` → (logo pendente → `group_logo_put`) → modal → #/perfil. */
    async _submit() {
        if (this._busy) return;
        const um = window.userManager;
        const v = this._formValues();
        this._busy = true; this._formError = '';
        const btn = this.container.querySelector('[data-act=submit]'); if (btn) btn.disabled = true;
        if (this._logoPrep) { try { await this._logoPrep; } catch (e) { /* o original fica */ } }
        if (!this._isMounted()) return;
        const r = await um?.requestGroup(v);
        if (!this._isMounted()) return;
        if (!r || !r.success) {
            this._busy = false;
            if (r && r.code === 'session_expired') return;
            this._formError = (r && r.code) || 'generic';
            this._draft = v;
            this.render();
            this.container.querySelector('#gp-name')?.focus();
            return;
        }
        this._draft = null;
        let logoWarn = '';
        if (this._pendingLogo && um.uploadGroupLogo) {
            const lr = await um.uploadGroupLogo(r.group.id, this._pendingLogo);
            if (!lr || !lr.success) logoWarn = this._t('auth.errors.' + ((lr && lr.code) || 'generic'));
            this._pendingLogo = null;
        }
        this._busy = false;
        if (!this._isMounted()) return;
        const go = () => { window.location.hash = '#/perfil'; };
        if (window.notifications && window.notifications.modal) {
            window.notifications.modal({
                title: this._t('group.sent.title'),
                html: `<p style="text-align:center;color:#475569;margin:0;line-height:1.5;">${this._esc(this._t('group.sent.body'))}</p>`
                    + (logoWarn ? `<p style="text-align:center;color:#b45309;margin:.8rem 0 0;font-size:.9rem;">${this._esc(logoWarn)}</p>` : ''),
                actions: [{ label: this._t('group.sent.ok'), onClick: go }],
                onClose: go, queue: true
            });
        } else { go(); }
    }

    /** Editar: `update_group` (PATCH) e volta ao perfil. */
    async _save() {
        if (this._busy || !this._data) return;
        const um = window.userManager;
        const v = this._formValues();
        const fields = { description: v.description, note: v.note, country: v.country };
        if (this._data.status !== 'active') fields.name = v.name;
        this._busy = true; this._formError = '';
        const btn = this.container.querySelector('[data-act=submit]'); if (btn) btn.disabled = true;
        const r = await um?.updateGroup(this._data.id, fields);
        this._busy = false;
        if (!this._isMounted()) return;
        if (!r || !r.success) {
            if (r && r.code === 'session_expired') return;
            this._formError = (r && r.code) || 'generic';
            this._draft = v;
            this.render();
            this.container.querySelector('#gp-name')?.focus();
            return;
        }
        this._draft = null;
        this._data = r.group;
        window.notifications?.toast(this._t('group.form.saved'), { type: 'success' });
        // Voltar para onde a pessoa VEIO: a página do grupo (`?from=page`) ou o perfil (auditoria M10).
        window.location.hash = this._backHash();
    }

    _backHash() {
        return (this._from === 'page' && this._data && this._data.id) ? '#/grupo/' + encodeURIComponent(String(this._data.id)) : '#/perfil';
    }

    async _uploadLogo(file, remove = false) {
        if (this._busy || !this._data) return;
        const um = window.userManager;
        // O redesenho depois da logo NÃO pode apagar a descrição em digitação (auditoria A2).
        this._draft = this._formValues();
        this._busy = true; this._formError = '';
        window.notifications?.toast(this._t('group.form.logoSending'), { type: 'info', duration: 1500 });
        const r = await um?.uploadGroupLogo(this._data.id, file, { remove });
        this._busy = false;
        if (!this._isMounted()) return;
        if (!r || !r.success) {
            if (r && r.code === 'session_expired') return;
            this._formError = (r && r.code) || 'generic';
            this.render();
            return;
        }
        this._data = r.group; this._logoV = r.group.logo_v || '';
        this.render();
        window.notifications?.toast(this._t('group.form.logoSaved'), { type: 'success' });
    }

    static _css() {
        // A mesma paleta do #/perfil e do ranking (indigo #4f46e5), classes próprias (gp-).
        return `
        .gp-screen{max-width:640px;margin:0 auto;padding:1rem 1rem 3rem;}
        .gp-card{background:#fff;border:1px solid #eef0f5;border-radius:14px;padding:1.1rem 1.2rem;margin-bottom:.9rem;box-shadow:0 2px 10px rgba(0,0,0,.05);}
        .gp-center{text-align:center;padding:1.6rem 1.1rem;}
        .gp-state{text-align:center;color:#64748b;padding:2rem 1rem;}
        .gp-lead{margin:0 0 .8rem;color:#475569;font-size:.98rem;line-height:1.5;}
        .gp-formhead{text-align:center;margin-bottom:1rem;}
        .gp-title{margin:0 0 .3rem;font-size:1.5rem;color:#1f2937;}
        .gp-head{display:flex;align-items:center;gap:1rem;margin-bottom:.9rem;}
        .gp-logo{width:96px;height:96px;flex:0 0 auto;border-radius:18px;object-fit:contain;background:#f8fafc;border:1px solid #e5e7eb;}
        .gp-logo--fallback{display:flex;align-items:center;justify-content:center;font-size:2.6rem;}
        .gp-logo--small{width:64px;height:64px;font-size:1.8rem;border-radius:12px;}
        .gp-headinfo{min-width:0;}
        .gp-name{margin:0;font-size:1.35rem;color:#1f2937;overflow-wrap:anywhere;}
        .gp-count{margin:.2rem 0 0;color:#64748b;font-size:.9rem;}
        .gp-country{margin:.25rem 0 0;color:#374151;font-size:.95rem;display:flex;align-items:center;gap:.35rem;}
        .gp-flag{font-size:1.25rem;line-height:1;}
        .gp-select{min-height:44px;background:#fff;}
        .gp-desc{margin:0 0 1rem;color:#1f2937;line-height:1.55;white-space:pre-wrap;overflow-wrap:anywhere;}
        .gp-desc--empty{color:#94a3b8;font-style:italic;}
        .gp-you{margin:0 0 .6rem;font-weight:700;color:#3730a3;}
        .gp-preview{margin:0 0 .9rem;padding:.6rem .9rem;border-radius:10px;background:#fef3c7;color:#78350f;font-size:.9rem;line-height:1.45;}
        .gp-btns{display:flex;gap:.6rem;flex-wrap:wrap;margin-top:.4rem;}
        .gp-btns--center{justify-content:center;}
        .gp-btn{display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;min-height:44px;padding:.5rem 1.1rem;border:none;border-radius:999px;
            background:#4f46e5;color:#fff;font-weight:600;font-size:.92rem;font-family:inherit;cursor:pointer;text-decoration:none;line-height:1.2;}
        @media (min-width:700px){ .gp-btn{min-height:38px;} }
        .gp-btn:hover{background:#4338ca;}
        .gp-btn[disabled]{opacity:.6;cursor:default;}
        .gp-btn--ghost{background:#eef2ff;color:#3730a3;}
        .gp-btn--ghost:hover{background:#e0e7ff;}
        .gp-file{position:relative;overflow:hidden;}
        .gp-file input{position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%;}
        .gp-file:focus-within{outline:2px solid #6366f1;outline-offset:2px;}
        .gp-link{color:#3730a3;font-weight:600;}
        .gp-filename{color:#64748b;font-size:.88rem;margin-left:.6rem;overflow-wrap:anywhere;}
        .gp-note{margin:.8rem 0 0;color:#64748b;font-size:.85rem;line-height:1.45;}
        .gp-h2{margin:0 0 .5rem;font-size:1.2rem;color:#1f2937;}
        .gp-new{display:inline-flex;align-items:center;min-height:44px;padding:.4rem .9rem;border:1px solid #fcd34d;border-radius:999px;background:#fffbeb;color:#92400e;font-weight:700;font-size:.85rem;cursor:pointer;font-family:inherit;}
        .gp-new[aria-expanded="true"]{background:#fef3c7;}
        .gp-newtip{margin:.6rem 0 0;padding:.7rem .85rem;border:1px solid #fde68a;border-radius:12px;background:#fffbeb;color:#78350f;font-size:.92rem;line-height:1.45;}
        .gp-newtip p{margin:0 0 .5rem;}
        .gp-newtip[hidden]{display:none;}
        .gp-newbadge{display:inline-block;vertical-align:middle;margin-left:.35rem;padding:.1rem .5rem;border-radius:999px;background:#fffbeb;border:1px solid #fcd34d;color:#92400e;font-size:.72rem;font-weight:700;}
        .gp-classintro{margin:0;color:#374151;line-height:1.5;}
        .gp-classcard .gp-note{margin:.5rem 0 .6rem;}
        .gp-classbar{display:flex;align-items:center;gap:.8rem;flex-wrap:wrap;margin-bottom:.9rem;}
        .gp-classname{display:flex;align-items:center;gap:.6rem;min-width:0;font-weight:700;color:#1f2937;overflow-wrap:anywhere;}
        .gp-classname .gp-logo--small{width:40px;height:40px;font-size:1.2rem;border-radius:10px;flex:0 0 auto;}
        .gp-error{margin:.6rem 0 0;color:#b91c1c;font-size:.9rem;}
        .gp-label{display:block;font-size:.8rem;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.04em;margin:1rem 0 .3rem;}
        .gp-form .gp-label:first-child{margin-top:0;}
        .gp-input{width:100%;min-height:44px;padding:.55rem .7rem;border:1px solid #d9dbe6;border-radius:10px;font-size:1rem;font-family:inherit;color:#1f2937;background:#fff;box-sizing:border-box;}
        .gp-input:focus{outline:2px solid #6366f1;outline-offset:1px;}
        .gp-input[readonly]{background:#f8fafc;color:#64748b;}
        .gp-textarea{resize:vertical;line-height:1.45;}
        .gp-hint{margin:.3rem 0 0;color:#94a3b8;font-size:.8rem;line-height:1.4;}
        .gp-logorow{display:flex;align-items:center;gap:.8rem;flex-wrap:wrap;}
        .gp-logobtns{display:flex;gap:.5rem;flex-wrap:wrap;}
        @media (max-width:480px){
            .gp-screen{padding:.8rem .7rem 2.5rem;}
            .gp-card{padding:.9rem .85rem;}
            .gp-logo{width:72px;height:72px;font-size:2rem;}
            .gp-name{font-size:1.15rem;}
        }`;
    }
}

window.GroupScreen = GroupScreen;



// ============================================
// components/NotificationManager.js
// ============================================
/**
 * NotificationManager — primitivo de UI de notificação (modal + toast).
 *
 * "Nasceu" inspirado no NotificationManager do projeto principal (capsula), MAS é
 * propositalmente ENXUTO: aqui é SÓ o primitivo de UI reutilizável. NÃO há nada de
 * fórum (sino, não-lidas, persistência, NotificationRepository) — isso é exclusivo
 * do capsula (referência read-only). Genérico p/ qualquer jogo plugar o "fim de
 * rodada" (Leitura/Ritmo/Intervalos) sem duplicar overlay.
 *
 * Estilo espelha o overlay do RhythmLevelMap: position:fixed inset:0, z-index alto,
 * fundo escuro com blur, fade-in, fecha por ✕ / ESC / click-fora (se dismissible).
 * Diferença: este é CENTRADO (não gaveta lateral) — ideal p/ resultado de nível.
 *
 * API:
 *   const h = window.notifications.modal({ title, html|node, actions, dismissible });
 *     actions: [{ label, style:'primary'|'success'|'neutral', onClick, closeOnClick }]
 *     retorna { close() }.
 *   window.notifications.toast(msg, { type:'info'|'success'|'error', duration, action });
 *     action: { label, onClick } → botão dentro do toast (executa e fecha).
 *     duration: 0 → fica até clicar no botão ou no ✕ (usado pelo aviso de versão nova).
 *
 * Singleton global: window.notifications.
 */
class NotificationManager {
    constructor() {
        this._queue = [];   // modais esperando a vez (ver modal(): queue/sticky)
        this._modal = null;          // { overlay, card, onKey } do modal aberto (1 por vez)
        this._toastWrap = null;      // container fixo dos toasts
        this.Z = 2000;               // acima do header e do RhythmLevelMap (1000)
    }

    // ---------- MODAL ----------

    /**
     * Abre um modal centrado. Fecha o anterior (1 por vez). Retorna { close() }.
     * @param {object} o
     * @param {string} [o.title]
     * @param {string} [o.html]     conteúdo como HTML string
     * @param {Node}   [o.node]     OU conteúdo como nó pronto (tem precedência sobre html)
     * @param {Array}  [o.actions]  botões de ação no rodapé
     * @param {boolean}[o.dismissible=true] permite fechar por ESC / click-fora / ✕
     * @param {Function}[o.onClose]
     * @param {number} [o.width=440]  largura máxima do card, em px. Aditivo: nenhuma
     *        chamada existente passa `width`, então todas continuam em 440 byte a byte.
     *        A folha de ajuda (HelpSheet) pede 560 — texto corrido de 17px em 440
     *        fica estreito demais para 4 frases.
     */
    modal({ title = '', html = '', node = null, actions = [], dismissible = true, onClose = null, width = 440, queue = false, sticky = false } = {}) {
        // 🔴 Dois modais no boot se MATAM (o último a chegar derruba o anterior sem
        // callback): o tutorial do ritmo era consumido sem aparecer pelo aviso de conta,
        // e o aviso era engolido por qualquer modal que abrisse depois. Duas bandeiras,
        // opt-in, para quem não pode perder a vez:
        //   queue  — se há modal aberto, ESPERA ele fechar em vez de derrubá-lo;
        //   sticky — enquanto ESTE está aberto, quem chegar espera (fica na fila).
        // Chamada sem bandeira continua igual: substitui na hora.
        if (this._modal && (queue || this._modal.sticky)) {
            this._queue.push({ title, html, node, actions, dismissible, onClose, width, queue, sticky });
            return { close: () => { const i = this._queue.findIndex(q => q.node === node && q.title === title); if (i !== -1) this._queue.splice(i, 1); } };
        }
        // Substituir um modal aberto: remove o anterior NA HORA (sem fade) p/ nunca
        // empilhar 2 overlays no DOM. O fade fica só no fechamento normal (closeModal).
        this._tearDownModal(false);

        const overlay = document.createElement('div');
        overlay.style.cssText = `position:fixed;inset:0;z-index:${this.Z};display:flex;`
            + 'align-items:center;justify-content:center;padding:1rem;'
            + 'background:rgba(15,23,42,0.5);opacity:0;transition:opacity 0.22s;'
            + 'backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);';

        const card = document.createElement('div');
        card.setAttribute('role', 'dialog');
        card.setAttribute('aria-modal', 'true');
        // 🔴 IDENTIDADE do card. `[role="dialog"]` NÃO é único no app: o drawer do
        // AppHeader também é um, e vive no DOM mesmo fechado — então
        // `document.querySelector('[role="dialog"]')` pode devolver o drawer em vez
        // deste modal. Quem precisa achar "o modal" procura por este atributo.
        card.dataset.notificationModal = '1';
        card.style.cssText = `background:#fff;border-radius:16px;width:min(${width}px,100%);`
            + 'max-height:90vh;overflow-y:auto;-webkit-overflow-scrolling:touch;'
            + 'box-shadow:0 20px 50px rgba(0,0,0,0.3);transform:scale(0.94);'
            + 'transition:transform 0.22s ease;padding:1.4rem 1.3rem 1.2rem;';

        if (dismissible) {
            const x = document.createElement('button');
            x.textContent = '✕';
            x.setAttribute('aria-label', this._t('common.close', 'Close'));
            // Identidade do ✕: quem substitui o conteúdo do card por outra página
            // (HelpSheet.openInCard) precisa PRESERVAR a saída — esconder o ✕ junto
            // com o resto deixava a pessoa sem como fechar.
            x.dataset.modalClose = '1';
            x.style.cssText = 'position:absolute;top:0.6rem;right:0.7rem;background:none;border:none;'
                + 'font-size:1.2rem;color:#94a3b8;cursor:pointer;padding:0.3rem 0.5rem;line-height:1;';
            x.addEventListener('click', () => this.closeModal());
            card.style.position = 'relative';
            card.appendChild(x);
        }

        if (title) {
            const h = document.createElement('h2');
            h.textContent = title;
            h.style.cssText = 'margin:0 1.5rem 0.8rem 0;font-size:1.25rem;color:#0f172a;text-align:center;';
            card.appendChild(h);
        }

        const body = document.createElement('div');
        if (node) body.appendChild(node);
        else body.innerHTML = html;
        card.appendChild(body);

        if (actions.length) {
            const footer = document.createElement('div');
            footer.style.cssText = 'display:flex;flex-direction:column;gap:0.55rem;margin-top:1.2rem;';
            actions.forEach((a) => footer.appendChild(this._actionButton(a)));
            card.appendChild(footer);
        }

        overlay.appendChild(card);
        if (dismissible) {
            overlay.addEventListener('click', (e) => { if (e.target === overlay) this.closeModal(); });
        }

        const onKey = (e) => { if (dismissible && e.key === 'Escape') this.closeModal(); };
        document.addEventListener('keydown', onKey);

        document.body.appendChild(overlay);
        this._modal = { overlay, card, onKey, onClose, sticky: !!sticky };

        requestAnimationFrame(() => requestAnimationFrame(() => {
            overlay.style.opacity = '1';
            card.style.transform = 'scale(1)';
        }));

        return { close: () => this.closeModal() };
    }

    closeModal() { this._tearDownModal(true); }

    /** Fecha o modal atual. animate=true → fade-out (fechamento normal); false →
     *  remove imediatamente (ao substituir por outro modal / teardown). */
    _tearDownModal(animate) {
        const m = this._modal;
        if (!m) return;
        this._modal = null;
        document.removeEventListener('keydown', m.onKey);
        if (animate) {
            m.overlay.style.opacity = '0';
            m.card.style.transform = 'scale(0.94)';
            setTimeout(() => { if (m.overlay.parentNode) m.overlay.remove(); }, 230);
        } else if (m.overlay.parentNode) {
            m.overlay.remove();
        }
        if (m.onClose) { try { m.onClose(); } catch (_) {} }
        // Próximo da fila só depois do fade (senão dois overlays no DOM).
        if (this._queue.length && !this._modal) {
            const next = this._queue.shift();
            setTimeout(() => { if (!this._modal) this.modal(next); }, animate ? 240 : 0);
        }
    }

    isModalOpen() { return !!this._modal; }
    /** Quantos modais esperam a vez (fila do `queue`/`sticky`). */
    queuedModals() { return this._queue.length; }

    _actionButton({ label, style = 'neutral', onClick = null, closeOnClick = true }) {
        const bg = {
            primary: 'linear-gradient(135deg,#6366f1,#8b5cf6)',
            success: 'linear-gradient(135deg,#10b981,#059669)',
            neutral: 'linear-gradient(135deg,#64748b,#475569)'
        }[style] || style; // permite passar um gradiente custom direto

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = label;
        btn.style.cssText = 'width:100%;padding:0.8rem 1rem;border:none;border-radius:10px;'
            + `background:${bg};color:#fff;font-weight:700;font-size:1.05rem;cursor:pointer;`
            + 'box-shadow:0 4px 12px rgba(0,0,0,0.15);';
        btn.addEventListener('click', () => {
            if (closeOnClick) this.closeModal();
            if (onClick) onClick();
        });
        return btn;
    }

    // ---------- TOAST ----------

    /**
     * Notificação transitória (canto inferior). type: info|success|error.
     * Aditivo (06/set/2026): `action` = { label, onClick } põe um botão no toast, e
     * `duration: 0` o deixa fixo até clicar (botão ou ✕). Sem `action` e sem `duration`
     * nada muda: mesmo nó, mesmo estilo, some sozinho em 2,6 s.
     * 🔴 O wrap é `pointer-events:none` (toast não pode roubar clique do jogo); só o toast
     * COM ação religa `pointer-events` em si mesmo — os outros continuam intocáveis.
     */
    toast(msg, { type = 'info', duration = 2600, action = null } = {}) {
        if (!this._toastWrap) {
            this._toastWrap = document.createElement('div');
            this._toastWrap.style.cssText = `position:fixed;left:50%;bottom:1.4rem;transform:translateX(-50%);`
                + `z-index:${this.Z + 1};display:flex;flex-direction:column;gap:0.5rem;`
                + 'align-items:center;pointer-events:none;width:max-content;max-width:92vw;';
            // Leitor de tela anuncia o toast sem roubar o foco (polite: espera a fala atual).
            this._toastWrap.setAttribute('aria-live', 'polite');
            document.body.appendChild(this._toastWrap);
        }

        const colors = {
            info: { bg: '#1e293b', fg: '#fff' },
            success: { bg: '#059669', fg: '#fff' },
            error: { bg: '#dc2626', fg: '#fff' }
        }[type] || { bg: '#1e293b', fg: '#fff' };

        const sticky = !(duration > 0);
        const interactive = !!(action && action.label) || sticky;

        const el = document.createElement('div');
        el.style.cssText = `background:${colors.bg};color:${colors.fg};padding:0.7rem 1.1rem;`
            + 'border-radius:10px;font-weight:600;font-size:0.95rem;box-shadow:0 6px 20px rgba(0,0,0,0.25);'
            + 'opacity:0;transform:translateY(10px);transition:opacity 0.2s,transform 0.2s;text-align:center;';
        if (sticky) el.setAttribute('role', 'status'); // fixo = aviso que fica; anunciado como status
        if (interactive) {
            el.className = 'toast-with-action';
            el.style.pointerEvents = 'auto';
            el.style.display = 'flex';
            el.style.alignItems = 'center';
            el.style.gap = '0.7rem';
            const txt = document.createElement('span');
            txt.textContent = msg;
            el.appendChild(txt);
        } else {
            el.textContent = msg;
        }
        this._toastWrap.appendChild(el);

        const dismiss = () => {
            el.style.opacity = '0'; el.style.transform = 'translateY(10px)';
            setTimeout(() => { if (el.parentNode) el.remove(); }, 220);
        };

        if (action && action.label) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'toast-action';
            btn.textContent = action.label;
            btn.style.cssText = `background:${colors.fg};color:${colors.bg};border:0;border-radius:8px;`
                + 'padding:0.4rem 0.8rem;font-weight:700;font-size:0.9rem;cursor:pointer;min-height:36px;';
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                dismiss();
                try { if (typeof action.onClick === 'function') action.onClick(); } catch (err) { console.warn('toast action:', err); }
            });
            el.appendChild(btn);
        }
        if (sticky) {
            const x = document.createElement('button');
            x.type = 'button';
            x.className = 'toast-close';
            x.setAttribute('aria-label', this._t('common.close', 'Fechar'));
            x.textContent = '✕';
            x.style.cssText = `background:transparent;color:${colors.fg};border:0;opacity:0.7;cursor:pointer;`
                + 'font-size:1rem;padding:0.2rem 0.3rem;min-width:32px;min-height:32px;';
            x.addEventListener('click', (e) => { e.stopPropagation(); dismiss(); });
            el.appendChild(x);
        }

        requestAnimationFrame(() => requestAnimationFrame(() => {
            el.style.opacity = '1'; el.style.transform = 'translateY(0)';
        }));

        if (!sticky) {
            const tm = setTimeout(dismiss, duration);
            el.addEventListener('click', () => clearTimeout(tm));
        }
        return el;
    }

    // ---------- helpers ----------

    _t(key, fallback) {
        const v = window.language ? window.language.t(key) : null;
        return (v && v !== key) ? v : fallback;
    }

    /** Limpa tudo (usado em testes / teardown global). */
    destroy() {
        this.closeModal();
        if (this._toastWrap) { this._toastWrap.remove(); this._toastWrap = null; }
    }
}

// Classe + singleton global (mesmo padrão de domManager/audioManager)
window.NotificationManager = NotificationManager;
window.notifications = new NotificationManager();



// ============================================
// components/help/HelpDot.js
// ============================================
/**
 * HelpDot — o "?" contextual (Camada 1 do plano de ajuda).
 *
 * Fica ao lado de um controle OU de uma FILA de controles: um "?" por DÚVIDA,
 * nunca por botão. A dúvida real de "Estudo / No tempo / Acompanhar" é "qual dos
 * três?", e essa pergunta é do grupo — três "?" ali seriam três vezes o mesmo texto.
 *
 * Cotas (mock F, palco 1) — a diferença entre alvo confortável e ícone que polui:
 *   glifo 22px · disco 26px · ALVO 44×44px de padding invisível.
 *   #6366f1 sobre #eef2ff, borda #c7d2fe → contraste 4,3:1 (piso gráfico é 3:1).
 *
 * 🔴 NUNCA depende de hover: no toque não existe hover. O "?" está sempre no ar.
 * Pulse só na 1ª visita (2 ciclos), morre para sempre no primeiro toque, e respeita
 * prefers-reduced-motion.
 */
class HelpDot {

    static SIZE = 44;          // alvo de toque (WCAG 2.5.5)
    static DISC = 26;          // disco visível
    static GLYPH = 22;         // "?" — o desenho continua pequeno; quem tem 44 é a ÁREA
    static STYLE_ID = 'help-dot-style';

    /**
     * @param {string} topicId  id em HelpRegistry.HELP
     * @param {object} [opts]
     * @param {string} [opts.subject]  assunto p/ o aria-label; default = título do tópico
     * @param {number} [opts.size]     override do alvo (raro; o default é o piso)
     */
    constructor(topicId, { subject = '', size = HelpDot.SIZE } = {}) {
        this.topicId = topicId;
        this.def = window.HelpRegistry ? window.HelpRegistry.get(topicId) : null;
        this._injectStyle();

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'help-dot';
        btn.dataset.helpTopic = topicId;
        // O glifo é um <span> POSICIONADO de propósito: o disco é um ::before
        // absoluto, e conteúdo em fluxo pinta ANTES de elemento posicionado —
        // com o "?" como nó de texto puro, o disco o cobriria.
        const glyph = document.createElement('span');
        glyph.className = 'help-dot-glyph';
        glyph.textContent = '?';
        glyph.setAttribute('aria-hidden', 'true');
        btn.appendChild(glyph);
        btn.setAttribute('aria-label', this._aria(subject));
        if (size !== HelpDot.SIZE) {
            btn.style.width = size + 'px';
            btn.style.height = size + 'px';
        }

        // Pulse de estreia: 2 ciclos, só enquanto o tópico nunca foi aberto neste
        // aparelho. Do 2º encontro em diante o "?" fica quieto — para sempre.
        if (window.HelpRegistry && !window.HelpRegistry.seen(topicId)) {
            btn.classList.add('help-dot--new');
        }

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            btn.classList.remove('help-dot--new');
            if (window.HelpRegistry) window.HelpRegistry.markSeen(topicId);
            if (window.HelpSheet) window.HelpSheet.open(topicId);
        });

        this._el = btn;
    }

    get el() { return this._el; }

    /** Atalho: cria o "?" e o pendura no nó do rótulo. Devolve a instância. */
    static attach(labelNode, topicId, opts = {}) {
        const dot = new HelpDot(topicId, opts);
        if (labelNode) labelNode.appendChild(dot.el);
        return dot;
    }

    destroy() {
        if (this._el && this._el.parentNode) this._el.remove();
        this._el = null;
    }

    // ---------- privado ----------

    /** "Ajuda: {subject}" — o assunto é o TÍTULO do tópico, não o id. */
    _aria(subject) {
        const t = (k, p) => (window.language ? window.language.t(k, p) : k);
        const src = this.def ? this.def.sourceId : this.topicId;
        let subj = subject;
        if (!subj) {
            const key = 'help.' + src + '.title';
            const v = t(key);
            subj = (v && v !== key) ? v : src;
        }
        const aria = t('help.dotAria', { subject: subj });
        return (aria && aria !== 'help.dotAria') ? aria : ('Ajuda: ' + subj);
    }

    _injectStyle() {
        if (document.getElementById(HelpDot.STYLE_ID)) return;
        const s = document.createElement('style');
        s.id = HelpDot.STYLE_ID;
        s.textContent = `
.help-dot{
    display:inline-flex;align-items:center;justify-content:center;
    width:${HelpDot.SIZE}px;height:${HelpDot.SIZE}px;   /* alvo — padding invisível */
    padding:0;margin:0;border:none;background:none;cursor:pointer;
    vertical-align:middle;flex:0 0 auto;-webkit-tap-highlight-color:transparent;
    position:relative;font-family:inherit;color:#6366f1;
}
.help-dot-glyph{
    position:relative;                                  /* pinta DEPOIS do disco */
    font-size:${HelpDot.GLYPH}px;font-weight:800;line-height:1;
}
.help-dot::before{                                      /* o disco de 26px */
    content:'';position:absolute;width:${HelpDot.DISC}px;height:${HelpDot.DISC}px;
    border-radius:50%;background:#eef2ff;border:1px solid #c7d2fe;
    transition:transform .12s ease,background .12s ease;
}
.help-dot:hover::before{background:#e0e7ff;}
.help-dot:focus-visible{outline:none;}
.help-dot:focus-visible::before{box-shadow:0 0 0 3px #fff,0 0 0 6px #6366f1;}
.help-dot:active::before{transform:scale(.92);background:#6366f1;}
.help-dot:active{color:#fff;}
.help-dot--new::before{animation:help-dot-pulse 1.4s ease-out 2;}
@keyframes help-dot-pulse{
    0%{box-shadow:0 0 0 0 rgba(99,102,241,.45);}
    70%{box-shadow:0 0 0 10px rgba(99,102,241,0);}
    100%{box-shadow:0 0 0 0 rgba(99,102,241,0);}
}
@media (prefers-reduced-motion: reduce){
    .help-dot--new::before{animation:none;}
    .help-dot::before{transition:none;}
}`;
        document.head.appendChild(s);
    }
}

window.HelpDot = HelpDot;



// ============================================
// components/help/HelpSheet.js
// ============================================
/**
 * HelpSheet — a folha de ajuda (Camada 2 do plano).
 *
 * 🔴 Hospeda-se no NotificationManager.modal({ node, width }) — NADA de overlay
 * novo. O ✕, o ESC, o clique-fora e o fade já são do primitivo; reimplementar
 * seria uma segunda verdade sobre o que é um modal neste app.
 *
 * FASE 2: Explicação + Perguntas. `tabsFor()` conhece as três abas e devolve só
 * as que têm conteúdo; com uma só, NENHUMA barra é desenhada (tópico simples abre
 * direto). A aba Vídeo fica para a fase 4 — a regra que a esconde já é a mesma.
 *
 * Explicação = 1 a N páginas (o N mora no HelpRegistry), cada uma com título +
 * corpo. Navegação por bolinhas, ◀ ▶ e setas do teclado. Corpo 17px/1.6 e termo
 * técnico só DEPOIS da frase em português comum — isso é regra da REDAÇÃO, e por
 * isso mora no translations.json, não aqui.
 *
 * 🟡 O bottom sheet do celular (alça, colado embaixo) NÃO entra na fase 1: ele
 * exige mexer no ALINHAMENTO do overlay do NotificationManager, que é mudança
 * global — afeta o modal de resultado de todos os jogos. Vai declarada e sozinha,
 * como o ✕ de 44px, e não de contrabando junto da ajuda. Aqui a folha usa o modal
 * centrado de sempre, que já tem max-height:90vh e rolagem interna.
 */
class HelpSheet {

    static WIDTH = 560;             // o modal padrão é 440; a folha pede mais
    static STYLE_ID = 'help-sheet-style';
    static _open = null;            // { topicId, handle, onKey, sheet } — folha em modal próprio
    static _inline = null;          // { back, cardEl } — folha trocando a página de um card alheio
    static _routeBound = false;     // assinatura única do route:changed

    /**
     * Abas COM CONTEÚDO, na ordem fixa Explicação · Vídeo · Perguntas.
     * Função PURA (recebe a definição, não lê o mundo) para o teste poder
     * exercitar os dois lados da regra: `faq:0` → 1 aba; `faq:2` → 2 abas.
     *
     * 🔴 A REGRA, escrita direito: uma ABA existe com 1+ item; a BARRA aparece com
     * 2+ abas. O comentário antigo dizia "aba com menos de 2 itens não aparece" e
     * contradizia este código — pelo texto, os 7 tópicos de `faq:1` não deveriam ter
     * aba nenhuma, e a pergunta deles ficaria inalcançável. Quem estava errado era o
     * comentário: esconder conteúdo que existe é pior que desenhar uma barra.
     */
    static tabsFor(def) {
        if (!def) return [];
        const tabs = [];
        if ((def.pages || 0) >= 1) tabs.push('explain');
        if (def.video) tabs.push('video');
        if ((def.faq || 0) >= 1) tabs.push('faq');
        return tabs;
    }

    static isOpen() { return !!HelpSheet._open; }

    static openTopicId() { return HelpSheet._open ? HelpSheet._open.topicId : null; }

    /** Abre a folha de um tópico. Sem tópico (ou sem NotificationManager) não faz nada. */
    static open(topicId) {
        const def = window.HelpRegistry ? window.HelpRegistry.get(topicId) : null;
        if (!def || !window.notifications) return null;

        HelpSheet._injectStyle();
        HelpSheet._watchRoute();
        if (window.HelpRegistry) window.HelpRegistry.markSeen(topicId);

        const sheet = new HelpSheet(def);
        const handle = window.notifications.modal({
            node: sheet.el,
            width: HelpSheet.WIDTH,
            dismissible: true,
            onClose: () => { HelpSheet._teardown(); }
        });

        // Setas do teclado viram a página. 🔴 O ouvinte sai no fechar (o onClose do
        // modal chama _teardown) — sem isso, abrir/fechar 20× empilha 20 ouvintes.
        const onKey = (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); sheet.go(sheet.page + 1); }
            else if (e.key === 'ArrowLeft') { e.preventDefault(); sheet.go(sheet.page - 1); }
        };
        document.addEventListener('keydown', onKey);

        HelpSheet._open = { topicId, handle, onKey, sheet };
        return handle;
    }

    /**
     * 🔴 O "?" DENTRO de um modal já aberto (o de fim de nível, por exemplo).
     *
     * O NotificationManager só tem UM modal: `modal()` derruba o aberto na primeira
     * linha. Abrir a folha por cima APAGARIA o resultado que a pessoa acabou de
     * conquistar — e ela voltaria para a tela sem nunca mais ver a nota. Por isso
     * aqui não há segundo overlay: a folha TROCA DE PÁGINA dentro do mesmo card e
     * o "◀ Voltar ao resultado" devolve os nós ORIGINAIS.
     *
     * 🔴 Os nós do resultado são GUARDADOS, não recriados: quem chamou não tem como
     * remontar o resultado (ele depende do take que já passou), e um "voltar" que
     * reconstrói uma versão parecida é a mesma perda com outra cara.
     *
     * @returns {{back:Function}|null}
     */
    static openInCard(topicId, cardEl) {
        const def = window.HelpRegistry ? window.HelpRegistry.get(topicId) : null;
        if (!def || !cardEl) return null;
        if (cardEl.dataset.helpSwapped === '1') return null;   // já trocado: não empilha

        HelpSheet._injectStyle();
        if (window.HelpRegistry) window.HelpRegistry.markSeen(topicId);

        /**
         * Guarda os nós ORIGINAIS (identidade preservada) e os tira do fluxo.
         *
         * 🔴 NÃO se usa `hidden` aqui. `[hidden]{display:none}` mora na folha do
         * NAVEGADOR e perde para qualquer `display` INLINE — e o rodapé de ações do
         * NotificationManager tem `style="display:flex"`. Com `hidden`, o resultado
         * ficava invertido: "Ir pro Nível 4" continuava CLICÁVEL por cima da ajuda
         * (e avançar dali fechava o modal por um caminho sem limpeza), enquanto o ✕,
         * que não tem display inline, era o único que sumia. Guardamos o `display`
         * inline de cada nó e devolvemos o valor original no `back()`.
         *
         * 🔴 O ✕ FICA: ele é a saída, e a folha é um degrau de cima, não uma prisão.
         */
        const guardados = Array.from(cardEl.children)
            .filter(n => !n.dataset || n.dataset.modalClose !== '1');
        const escondidos = guardados.map(n => ({ n, display: n.style.display }));
        escondidos.forEach(({ n }) => { n.style.display = 'none'; });
        cardEl.dataset.helpSwapped = '1';

        const sheet = new HelpSheet(def);
        const painel = document.createElement('div');
        painel.className = 'help-sheet-inline';
        painel.dataset.helpInline = topicId;

        const voltar = document.createElement('button');
        voltar.type = 'button';
        voltar.className = 'help-sheet-back';
        voltar.dataset.helpBack = '1';
        voltar.textContent = sheet._t('help.backToResult') || '◀';
        const back = () => {
            if (cardEl.dataset.helpSwapped !== '1') return;
            painel.remove();
            escondidos.forEach(({ n, display }) => { n.style.display = display; });
            delete cardEl.dataset.helpSwapped;
            // 🔴 O MESMO terceiro argumento do addEventListener. `capture` faz parte
            // da IDENTIDADE do ouvinte: remover sem ele não remove nada, e o ouvinte
            // órfão — que roda na captura do document, o primeiro nó do caminho —
            // engolia o Escape do app INTEIRO (modal e drawer do header) pelo resto
            // da sessão, empilhando mais um a cada visita ao "?".
            document.removeEventListener('keydown', onKey, true);
            HelpSheet._inline = null;
        };
        voltar.addEventListener('click', back);

        // ESC volta ao resultado em vez de fechar o modal — a folha é o degrau de
        // cima, e fechar tudo perderia o resultado do mesmo jeito. `capture` para
        // chegar ANTES do ouvinte do NotificationManager, que fecharia o modal.
        const onKey = (e) => {
            if (e.key === 'Escape') { e.stopPropagation(); back(); }
            else if (e.key === 'ArrowRight') { e.preventDefault(); sheet.go(sheet.page + 1); }
            else if (e.key === 'ArrowLeft') { e.preventDefault(); sheet.go(sheet.page - 1); }
        };
        document.addEventListener('keydown', onKey, true);
        // 🔴 Registro global da folha inline: o modal pode ser fechado POR FORA (✕,
        // clique-fora, outro modal() derrubando este, destroy() do jogo) e nenhum
        // desses caminhos passa pelo "◀ Voltar". Sem este registro o ouvinte ficava
        // para trás. `HelpSheet.close()` e o `route:changed` desmontam por aqui.
        // 🔴 O modal pode sumir sem passar pelo "◀ Voltar": ✕, clique-fora, outro
        // `modal()` derrubando este, ou o `destroy()` do jogo. Nenhum desses caminhos
        // é nosso, e nenhum nos avisa — então observamos o DOM. Quando o card sai,
        // desmontamos (o `back()` é idempotente: o guard do `helpSwapped` protege).
        const obs = new MutationObserver(() => {
            if (!cardEl.isConnected) { obs.disconnect(); back(); }
        });
        try { obs.observe(document.body, { childList: true, subtree: true }); } catch (_) {}
        HelpSheet._inline = { back: () => { obs.disconnect(); back(); }, cardEl };

        painel.appendChild(voltar);
        painel.appendChild(sheet.el);
        // O "Entendi" da folha, aqui dentro, também volta ao resultado (fechar o
        // modal inteiro seria a mesma perda).
        const done = sheet.el.querySelector('.help-sheet-done');
        if (done) { done.textContent = voltar.textContent; done.addEventListener('click', back); }
        cardEl.appendChild(painel);
        return { back };
    }

    /** Pendura um "?" que TROCA A PÁGINA do card em que ele está (não abre modal). */
    static dotInCard(topicId, hostEl, cardEl) {
        if (!window.HelpDot || !hostEl) return null;
        const dot = new window.HelpDot(topicId);
        dot.el.addEventListener('click', (e) => {
            e.stopImmediatePropagation();   // impede o clique padrão (que abriria a folha por cima)
            HelpSheet.openInCard(topicId, cardEl || hostEl.closest('[data-notification-modal]'));
        }, true);
        hostEl.appendChild(dot.el);
        return dot;
    }

    /**
     * 🔴 A folha NÃO sobrevive à troca de tela. Ela é um overlay de z-index 2000,
     * acima do header: deixada para trás, fica colada por cima do jogo seguinte e a
     * pessoa não alcança nem o ⊞ nem o ☰. Acontecia com o gesto mais natural do
     * celular — o "voltar" do aparelho, que é o reflexo de quem quer fechar a folha.
     * `ReadingFlowGame` e `SongReadingGame` já fecham o modal no `destroy()`; a
     * convenção da casa existe, a ajuda é que precisava segui-la. Assinado UMA vez.
     */
    static _watchRoute() {
        if (HelpSheet._routeBound || !window.eventBus) return;
        HelpSheet._routeBound = true;
        window.eventBus.on('route:changed', () => HelpSheet.close());
    }

    static close() {
        // A folha inline não tem modal próprio: fechar significa devolver a página.
        if (HelpSheet._inline) { HelpSheet._inline.back(); return; }
        if (!HelpSheet._open) return;
        // closeModal dispara onClose → _teardown. Não desmontar aqui para não
        // desmontar duas vezes (e para o ESC/✕ seguirem o MESMO caminho).
        window.notifications.closeModal();
    }

    static _teardown() {
        const o = HelpSheet._open;
        if (!o) return;
        HelpSheet._open = null;
        document.removeEventListener('keydown', o.onKey);
    }

    // ---------- instância ----------

    constructor(def) {
        this.def = def;
        this.pages = Math.max(1, def.pages || 1);
        this.faq = Math.max(0, def.faq || 0);
        this.page = 0;
        this.tabs = HelpSheet.tabsFor(def);
        this.tab = this.tabs[0] || 'explain';
        this._build();
    }

    get el() { return this._root; }

    /** Vai para a página n (fora do intervalo = ignora, não dá a volta). */
    go(n) {
        if (this.tab !== 'explain') return;          // as setas são da Explicação
        if (n < 0 || n >= this.pages || n === this.page) return;
        this.page = n;
        this._renderPage();
    }

    /** Troca de aba. O rodapé de páginas é da Explicação e some nas outras. */
    goTab(tab) {
        if (!this.tabs.includes(tab) || tab === this.tab) return;
        this.tab = tab;
        if (this._barEl) {
            Array.from(this._barEl.children).forEach((b) => {
                const on = b.dataset.helpTab === tab;
                b.classList.toggle('is-active', on);
                b.setAttribute('aria-selected', String(on));
            });
        }
        if (this._footEl) this._footEl.hidden = (tab !== 'explain');
        this._renderPage();
    }

    // ---------- construção ----------

    _t(key, params) {
        const v = window.language ? window.language.t(key, params || {}) : key;
        return (v && v !== key) ? v : '';
    }

    _base() { return 'help.' + this.def.sourceId; }

    _build() {
        const root = document.createElement('div');
        root.className = 'help-sheet';
        root.dataset.helpTopic = this.def.id;

        // cabeçalho: ícone + título (o ✕ é do NotificationManager)
        const head = document.createElement('div');
        head.className = 'help-sheet-head';
        const ico = document.createElement('span');
        ico.className = 'help-sheet-icon';
        ico.setAttribute('aria-hidden', 'true');
        ico.textContent = this.def.icon || '❓';
        const h = document.createElement('h2');
        h.className = 'help-sheet-title';
        h.textContent = this._t(this._base() + '.title') || this.def.sourceId;
        head.appendChild(ico);
        head.appendChild(h);
        root.appendChild(head);

        // 🔴 Barra de abas SÓ com 2+ abas com conteúdo. Na fase 1 nunca aparece:
        // não há vídeo nem perguntas, então tabsFor() devolve ['explain'].
        if (this.tabs.length >= 2) {
            const bar = document.createElement('div');
            bar.className = 'help-sheet-tabs';
            bar.setAttribute('role', 'tablist');
            this.tabs.forEach((t) => {
                const b = document.createElement('button');
                b.type = 'button';
                b.className = 'help-sheet-tab' + (t === this.tab ? ' is-active' : '');
                b.dataset.helpTab = t;
                b.setAttribute('role', 'tab');
                b.setAttribute('aria-selected', String(t === this.tab));
                b.textContent = this._t('help.tabs.' + t) || t;
                b.addEventListener('click', () => this.goTab(t));
                bar.appendChild(b);
            });
            this._barEl = bar;
            root.appendChild(bar);
        }

        this._bodyEl = document.createElement('div');
        this._bodyEl.className = 'help-sheet-body';
        root.appendChild(this._bodyEl);

        // rodapé: bolinhas + ◀ ▶ (some inteiro em tópico de 1 página)
        if (this.pages > 1) {
            const foot = this._footEl = document.createElement('div');
            foot.className = 'help-sheet-foot';

            const posicao = document.createElement('div');
            posicao.className = 'help-sheet-pos';

            this._dotsEl = document.createElement('div');
            this._dotsEl.className = 'help-sheet-dots';
            for (let i = 0; i < this.pages; i++) {
                const d = document.createElement('button');
                d.type = 'button';
                d.className = 'help-sheet-pagedot';
                d.setAttribute('aria-label', String(i + 1));
                d.addEventListener('click', () => this.go(i));
                this._dotsEl.appendChild(d);
            }
            posicao.appendChild(this._dotsEl);

            // 🔴 "Página 1 de 3" EM PALAVRAS. As bolinhas têm 8 px de desenho: para
            // 60+ elas não são indicador de posição, são enfeite — e sem saber que há
            // uma página 2, a pessoa fecha na 1 e perde o resto.
            this._contaEl = document.createElement('span');
            this._contaEl.className = 'help-sheet-count';
            posicao.appendChild(this._contaEl);
            foot.appendChild(posicao);

            const nav = document.createElement('div');
            nav.className = 'help-sheet-nav';
            this._prevEl = this._navButton('◀ ' + (this._t('help.prev') || ''), () => this.go(this.page - 1), false);
            this._nextEl = this._navButton((this._t('help.next') || '') + ' ▶', () => this.go(this.page + 1), true);
            nav.appendChild(this._prevEl);
            nav.appendChild(this._nextEl);
            foot.appendChild(nav);
            root.appendChild(foot);
        }

        // "Entendi" fecha a folha — a saída explícita de quem terminou de ler.
        const done = document.createElement('button');
        done.type = 'button';
        done.className = 'help-sheet-done';
        done.textContent = this._t('help.gotIt') || 'OK';
        done.addEventListener('click', () => HelpSheet.close());
        this._doneEl = done;
        root.appendChild(done);

        this._root = root;
        this._renderPage();
    }

    /** A rota da ação de um tópico: string, ou função que devolve string; null quando não há. */
    static actionRoute(def) {
        const act = def && def.action;
        if (!act) return null;
        const r = (typeof act.route === 'function') ? act.route() : act.route;
        return (typeof r === 'string' && r.startsWith('#/')) ? r : null;
    }

    _navButton(label, onClick, primary) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'help-sheet-navbtn' + (primary ? ' is-primary' : '');
        b.textContent = label;
        b.addEventListener('click', onClick);
        return b;
    }

    _renderPage() {
        this._bodyEl.innerHTML = '';
        if (this.tab === 'faq') return this._renderFaq();

        const base = this._base() + '.p' + (this.page + 1);

        const t = document.createElement('h3');
        t.className = 'help-sheet-ptitle';
        t.textContent = this._t(base + '.title');
        const p = document.createElement('p');
        p.className = 'help-sheet-pbody';
        p.textContent = this._t(base + '.body');
        this._bodyEl.appendChild(t);
        this._bodyEl.appendChild(p);

        // A AÇÃO do tópico (`action: { route }`, rótulo em help.<id>.action) — só na ÚLTIMA página,
        // como link de rota: mudar o hash dispara `route:changed` e a folha fecha sozinha. `route`
        // pode ser FUNÇÃO (dado por ambiente, como a trilha exemplo); vazio ⇒ nada nasce.
        if (this.page === this.pages - 1) {
            const rota = HelpSheet.actionRoute(this.def);
            if (rota) {
                const a = document.createElement('a');
                a.className = 'help-sheet-action';
                a.href = rota;
                a.setAttribute('data-help-action', this.def.id);
                a.textContent = this._t(this._base() + '.action');
                this._bodyEl.appendChild(a);
            }
        }

        if (this._dotsEl) {
            Array.from(this._dotsEl.children).forEach((d, i) => {
                d.classList.toggle('is-active', i === this.page);
                d.setAttribute('aria-current', i === this.page ? 'true' : 'false');
            });
        }
        if (this._contaEl) {
            this._contaEl.textContent = this._t('help.pageOf', { n: this.page + 1, total: this.pages });
        }
        // 🔴 OCULTAR, não desabilitar. Um "Próximo" desabilitado continua sendo um
        // bloco roxo cheio: o olho vai nele e ele não faz nada. E na ÚLTIMA página o
        // slot primário passa a ser o "Entendi" — uma ação principal por vez, sempre
        // no mesmo lugar. Antes, o "Entendi" de largura total (a posição de CTA do
        // app inteiro) aparecia já na página 1 e convidava a fechar sem ler o resto.
        const ultima = this.page === this.pages - 1;
        if (this._prevEl) this._prevEl.hidden = (this.page === 0);
        if (this._nextEl) this._nextEl.hidden = ultima;
        if (this._doneEl) this._doneEl.classList.toggle('is-quiet', !ultima && this.pages > 1);
    }

    /**
     * Aba Perguntas — acordeão <details>/<summary>, que é o que o navegador já sabe
     * fazer: abre/fecha sem JS, é acessível por teclado e o leitor de tela anuncia o
     * estado. A 1ª pergunta nasce ABERTA para a aba não parecer uma lista morta.
     */
    _renderFaq() {
        const base = this._base();
        for (let i = 1; i <= this.faq; i++) {
            const q = this._t(base + '.q' + i + '.q');
            const a = this._t(base + '.q' + i + '.a');
            if (!q) continue;
            const d = document.createElement('details');
            d.className = 'help-sheet-faq';
            d.dataset.helpFaq = String(i);
            if (i === 1) d.open = true;
            const sum = document.createElement('summary');
            sum.className = 'help-sheet-faq-q';
            sum.textContent = q;
            const p = document.createElement('p');
            p.className = 'help-sheet-faq-a';
            p.textContent = a;
            d.appendChild(sum);
            d.appendChild(p);
            this._bodyEl.appendChild(d);
        }
    }

    // ---------- estilo ----------

    static _injectStyle() {
        if (document.getElementById(HelpSheet.STYLE_ID)) return;
        const s = document.createElement('style');
        s.id = HelpSheet.STYLE_ID;
        s.textContent = `
.help-sheet{text-align:left;color:#0f172a;}
.help-sheet-head{display:flex;align-items:center;gap:0.6rem;margin:0 1.6rem 0.9rem 0;}
.help-sheet-icon{font-size:1.4rem;line-height:1;flex:0 0 auto;
    width:38px;height:38px;border-radius:10px;background:#eef2ff;
    display:inline-flex;align-items:center;justify-content:center;}
.help-sheet-title{margin:0;font-size:1.15rem;line-height:1.3;color:#0f172a;text-align:left;}
.help-sheet-tabs{display:flex;gap:0.3rem;border-bottom:1px solid #e2e8f0;margin-bottom:0.9rem;}
.help-sheet-tab{background:none;border:none;cursor:pointer;font:inherit;font-weight:700;
    font-size:0.95rem;color:#64748b;padding:0.55rem 0.7rem;min-height:44px;
    border-bottom:2px solid transparent;margin-bottom:-1px;}
.help-sheet-tab.is-active{color:#6366f1;border-bottom-color:#6366f1;}
.help-sheet-body{min-height:5.5rem;}
.help-sheet-ptitle{margin:0 0 0.45rem;font-size:1.02rem;line-height:1.35;color:#0f172a;}
.help-sheet-pbody{margin:0;font-size:17px;line-height:1.6;color:#334155;}
.help-sheet-foot{display:flex;align-items:center;justify-content:space-between;
    gap:0.6rem;margin-top:1.1rem;flex-wrap:wrap;}
.help-sheet-pos{display:flex;flex-direction:column;gap:0.15rem;}
.help-sheet-count{font-size:0.78rem;color:#94a3b8;}
.help-sheet-dots{display:flex;gap:0.45rem;align-items:center;}
.help-sheet-pagedot{width:32px;height:44px;padding:0;border:none;background:none;cursor:pointer;
    display:inline-flex;align-items:center;justify-content:center;}
.help-sheet-pagedot::before{content:'';width:8px;height:8px;border-radius:999px;background:#cbd5e1;
    transition:width .16s ease,background .16s ease;}
.help-sheet-pagedot.is-active::before{width:20px;background:#6366f1;}
.help-sheet-nav{display:flex;gap:0.45rem;}
.help-sheet-navbtn{min-height:44px;padding:0.5rem 0.95rem;border-radius:10px;cursor:pointer;
    font:inherit;font-weight:700;font-size:0.95rem;border:1px solid #e2e8f0;background:#fff;color:#475569;}
.help-sheet-navbtn.is-primary{border-color:transparent;background:#6366f1;color:#fff;}
.help-sheet-navbtn{white-space:nowrap;}
.help-sheet-faq{border:1px solid #e2e8f0;border-radius:10px;margin-bottom:0.5rem;background:#fff;}
.help-sheet-faq[open]{border-color:#c7d2fe;background:#f8faff;}
.help-sheet-faq-q{cursor:pointer;list-style:none;padding:0.7rem 0.9rem;min-height:44px;
    display:flex;align-items:center;gap:0.5rem;font-weight:700;font-size:0.98rem;color:#0f172a;}
.help-sheet-faq-q::-webkit-details-marker{display:none;}
.help-sheet-faq-q::before{content:'+';color:#6366f1;font-weight:800;font-size:1.1rem;flex:0 0 auto;width:1ch;}
.help-sheet-faq[open] .help-sheet-faq-q::before{content:'–';}
.help-sheet-faq-a{margin:0;padding:0 0.9rem 0.85rem 2.1rem;font-size:17px;line-height:1.6;color:#334155;}
.help-sheet-inline{text-align:left;}
.help-sheet-back{display:inline-flex;align-items:center;min-height:44px;padding:0.4rem 0.7rem;
    margin:0 0 0.6rem -0.3rem;border:none;background:none;cursor:pointer;font:inherit;
    font-weight:700;font-size:0.95rem;color:#6366f1;}
.help-sheet-action{display:inline-flex;align-items:center;min-height:44px;margin-top:0.6rem;padding:0.5rem 0.9rem;border-radius:10px;
  background:rgba(99,102,241,0.12);color:#4f46e5;font-weight:700;text-decoration:none;font-size:0.95rem}
.help-sheet-action:hover{background:rgba(99,102,241,0.2)}
.help-sheet-done{width:100%;margin-top:1rem;min-height:44px;padding:0.7rem 1rem;border:none;
    border-radius:10px;cursor:pointer;font:inherit;font-weight:700;font-size:1rem;
    background:#6366f1;color:#fff;}
/* Páginas intermediárias: "Entendi" recua a link discreto — ali a ação principal é
   seguir lendo, não fechar. Na última página ele volta a ser o botão cheio. */
.help-sheet-done.is-quiet{background:none;color:#6366f1;font-weight:600;font-size:0.92rem;
    text-decoration:underline;text-underline-offset:3px;margin-top:0.5rem;}
@media (prefers-reduced-motion: reduce){.help-sheet-pagedot::before{transition:none;}}
@media (max-width:560px){
    .help-sheet-title{font-size:1.05rem;}
    .help-sheet-head{gap:0.5rem;}
    .help-sheet-navbtn{padding:0.5rem 0.8rem;}
}`;
        document.head.appendChild(s);
    }
}

window.HelpSheet = HelpSheet;



// ============================================
// components/AuthModal.js
// ============================================
/**
 * AuthModal — UI de login / cadastro / recuperação de senha.
 *
 * 🔴 NÃO reimplementa overlay/backdrop/foco: HOSPEDA seu formulário no
 * NotificationManager (window.notifications.modal), o primitivo de modal/toast que
 * cresce robusto (espelhando o capsula). Aqui vive só o form + a lógica de auth,
 * conversando com o UserManager (Etapa A): loginWithPassword / registerAccount /
 * requestPasswordReset / startOAuth. Erros chegam como `code` estável e são
 * localizados via auth.errors.<code>.
 *
 * Botão do Google fica atrás de AuthModal.SOCIAL (vazio até o OAuth Client existir —
 * Etapa E): acende adicionando 'google' na lista, sem tocar no layout.
 *
 * 🔴 O CADASTRO tem DOIS ESTADOS (`_signupStep`), não dois modos: 'choice' mostra Google
 * e e-mail como botões irmãos (o padrão do projeto principal) e 'form' mostra os campos.
 * Só existe escolha quando há social aceso — sem provedor o formulário abre direto.
 * Ver docs/AUTH-ESCOLHA-PLANO.md.
 *
 * Abrir: window.authModal.open('signin'|'signup'|'forgot') ou disparando o evento
 * 'open-auth-modal' (o header dispara na Etapa C).
 */
class AuthModal {
    constructor() {
        if (AuthModal.instance) return AuthModal.instance;
        this.mode = 'signin';       // signin | signup | forgot | reset
        // 🔴 ESTADO do cadastro, NÃO um 5º modo: 'choice' (Google × e-mail, o padrão do
        // projeto principal) e 'form' (os campos). Modo novo tornaria a matriz com
        // forgot/reset quadrática — ver docs/AUTH-ESCOLHA-PLANO.md §7.
        this._signupStep = 'choice';
        this.root = null;           // nó injetado no modal do NotificationManager
        this.handle = null;         // { close } devolvido pelo NotificationManager
        this.busy = false;
        this._prefillEmail = '';
        this._resetToken = '';      // token do link de reset (modo 'reset')
        this._gate = null;          // contexto do gate de nível ({ gameId, levelNum }) ou null
        // 🔴 SELO do submit em voo. `open()` zera o `busy` e devolve o cadastro à
        // escolha — e nesse estado o `.auth-error` NÃO EXISTE, então a resposta atrasada
        // de um cadastro anterior escrevia a recusa (`email_taken`) num nó ausente e
        // sumia em silêncio, além de reabilitar o botão do card novo (duplo-submit).
        // Quem volta do `await` confere o selo antes de tocar na tela.
        this._submitSeal = 0;
        if (typeof document !== 'undefined') {
            document.addEventListener('open-auth-modal', (e) =>
                this.open((e.detail && e.detail.mode) || 'signin', e.detail || {}));
        }
        AuthModal.instance = this;
    }

    /** Tradução com fallback explícito (nunca devolve a chave crua). */
    _t(key, fallback, params) {
        const v = window.language ? window.language.t(key, params || {}) : null;
        return (v && v !== key) ? v : (fallback != null ? fallback : key);
    }

    _um() { return window.userManager; }

    /** Piso de senha vigente (fonte única: UserManager.MIN_PASSWORD). Só o texto vem daqui. */
    _minPassword() { return (window.UserManager && window.UserManager.MIN_PASSWORD) || 6; }

    // ---------- abrir / fechar ----------

    open(mode = 'signin', opts = {}) {
        this.mode = mode;
        this.busy = false;
        if (mode === 'reset') this._resetToken = opts.token || this._resetToken || '';
        // Contexto de GATE de nível (AuthGate): header de recompensa acima do social.
        // Cada open() decide (aberturas normais — header — zeram); switchMode preserva.
        this._gate = opts.gate || null;
        this._reason = opts.reason || '';   // por que a conta está sendo pedida (ex.: montar uma trilha) — 22/set
        // Toda abertura de cadastro começa na ESCOLHA: se ficasse no 'form' da vez
        // anterior, a segunda pessoa a usar o mesmo aparelho nunca veria o Google.
        this._signupStep = 'choice';
        // E-mail já conhecido pelo chamador (o painel "Minha conta" abre 'forgot' para a
        // conta só-social CRIAR uma senha, e ali o endereço está na tela ao lado). Nunca
        // apaga o que já havia: `open()` sem `email` preserva o prefill anterior.
        if (typeof opts.email === 'string' && opts.email) this._prefillEmail = opts.email;
        this._submitSeal++;         // invalida resposta de submit anterior ainda em voo
        if (!this.root) this.root = document.createElement('div');
        this.root.className = 'auth-root';
        this._render();
        if (!this.handle && window.notifications) {
            this.handle = window.notifications.modal({
                node: this.root,
                dismissible: true,
                onClose: () => {
                    this.handle = null; this._prefillEmail = ''; this._gate = null; this._reason = '';
                    // AuthGate ouve pra descartar a retomada pendente se fechou sem logar.
                    document.dispatchEvent(new CustomEvent('auth-modal-closed'));
                }
            });
        }
        this._syncDialogLabel();
        this._focusFirst();
    }

    close() { this._submitSeal++; if (this.handle) { const h = this.handle; this.handle = null; h.close(); } }

    switchMode(mode) {
        if (this.busy) return;                 // não troca de modo com submit em voo
        this._captureEmail();                  // preserva o email digitado ao trocar
        // Entrar no cadastro (inclusive pela bifurcação `no_account`) cai na ESCOLHA —
        // é justamente ali que oferecer o Google paga, com o e-mail já em mãos.
        if (mode === 'signup') this._signupStep = 'choice';
        this.mode = mode;
        this._render();
        this._focusFirst();
    }

    /** Guarda o email atual em _prefillEmail (pra sobreviver ao re-render). */
    _captureEmail() {
        const el = this.root && this.root.querySelector('[name=email]');
        if (el && el.value) this._prefillEmail = el.value;
    }

    /** Liga o dialog do NotificationManager ao título (nome acessível). */
    _syncDialogLabel() {
        const dlg = this.root && this.root.closest && this.root.closest('[role="dialog"]');
        if (dlg) dlg.setAttribute('aria-labelledby', 'auth-modal-title');
    }

    /**
     * 🔴 Qual é "o primeiro" MUDA com o estado: no cadastro em 'choice' não existe
     * `<input>` nenhum. Focar nó ausente não dá erro — dá tela sem foco (e teclado de
     * celular que não abre onde deveria), que é falha MUDA. Por isso a ordem é
     * declarada, com o botão do social como segunda opção.
     */
    _focusFirst() {
        setTimeout(() => {
            if (!this.root) return;
            const input = this.root.querySelector('input:not([type=hidden])');
            if (input) { input.focus(); return; }
            // 🔴 Sem campo (cadastro em 'choice'), o foco vai para o TÍTULO, não para o
            // botão do Google. Antes o foco de abertura sempre caía num campo de texto,
            // onde Enter/Espaço são inofensivos; o botão do social é o único controle
            // desta tela cujo acionamento SAI DO SITE (redirect de OAuth), e o modal
            // abre logo depois de um clique/tecla no mapa de níveis — que também trata
            // Enter e Espaço. Título com tabindex=-1 põe o foco dentro do diálogo (o
            // leitor de tela anuncia o cabeçalho) sem armar um gatilho de navegação.
            const h = this.root.querySelector('#auth-modal-title');
            if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
        }, 60);
    }

    /**
     * Troca entre os dois estados do CADASTRO (escolha ⇄ formulário) sem mexer no modo.
     * `_captureEmail` primeiro: o e-mail digitado sobrevive à ida e à volta — quem
     * chegou por "esse e-mail não tem conta" não pode ter que redigitar.
     */
    _setSignupStep(step) {
        if (this.busy) return;
        this._captureEmail();
        this._signupStep = step;
        this._render();
        this._focusFirst();
    }

    // ---------- render ----------

    _render() {
        const providers = AuthModal._providers();
        const social = providers.length > 0 && (this.mode === 'signin' || this.mode === 'signup');
        // 🔴 A ESCOLHA só existe onde há de fato DOIS caminhos: no cadastro E com social
        // aceso. Sem provedor, uma tela de escolha com uma opção só é um clique morto —
        // o formulário abre direto, como sempre foi.
        const chooser = social && this.mode === 'signup';
        const atChoice = chooser && this._signupStep === 'choice';
        const titleKey = { signin: 'signInTitle', signup: 'signUpTitle', forgot: 'forgotTitle', reset: 'resetTitle' }[this.mode];
        const title = this._t('auth.' + titleKey, 'Entrar');

        // Header do GATE de nível (recompensa, espelho enxuto do gate v2 do capsula):
        // pips dos níveis livres feitos + 🔒, título de recompensa (vira o nome acessível
        // do dialog no lugar do h2 comum) + subtítulo. Só nos modos com social em cima.
        let headHtml = `<h2 class="auth-title" id="auth-modal-title">${title}</h2>`;
        if (this._reason && !this._gate && (this.mode === 'signin' || this.mode === 'signup')) {
            headHtml += `<p class="auth-gate-sub" data-auth-reason>${this._esc ? this._esc(this._reason) : String(this._reason).replace(/[<>&]/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]))}</p>`;
        }
        if (this._gate && (this.mode === 'signin' || this.mode === 'signup')) {
            const free = (window.AuthGate && window.AuthGate.FREE_LEVELS) || 3;
            const pips = Array.from({ length: free }, () =>
                '<span class="auth-gate-pip auth-gate-done">✓</span>').join('')
                + '<span class="auth-gate-pip auth-gate-lock">🔒</span>';
            headHtml = `
                <div class="auth-gate-head">
                    <div class="auth-gate-pips" aria-hidden="true">${pips}</div>
                    <h2 class="auth-title" id="auth-modal-title">${this._t('auth.gate.rewardTitle', 'Você está indo bem! 🎉')}</h2>
                    <p class="auth-gate-sub">${this._t('auth.gate.rewardSubtitle', 'Crie sua conta pra continuar e salvar seu progresso.')}</p>
                    <p class="auth-gate-context">${this._t('auth.gate.contextLine', '', { free, level: this._gate.levelNum })}</p>
                </div>`;
        }

        let socialHtml = '';
        if (social) {
            const g = (providers.indexOf('google') !== -1)
                ? `<button type="button" class="auth-social auth-social-google" data-provider="google">
                     ${AuthModal.GOOGLE_SVG}
                     <span>${this._t('auth.google', 'Continuar com Google')}</span>
                   </button>` : '';
            socialHtml = `<div class="auth-social-list">${g}</div>
                          <div class="auth-divider"><span>${this._t('auth.or', 'ou')}</span></div>`;
        }

        // O e-mail vira BOTÃO IRMÃO do Google (padrão do projeto principal): os dois
        // caminhos com o mesmo peso, e o formulário só abre em quem escolher e-mail.
        const mailHtml = atChoice
            ? `<button type="button" class="auth-mail" data-step="form">
                   <span class="auth-mail-ico" aria-hidden="true">✉️</span>
                   <span>${this._t('auth.emailButton', 'Criar conta com e-mail')}</span>
               </button>`
            : '';

        const nameField = this.mode === 'signup' ? `
            <label class="auth-field">
                <span class="auth-label">${this._t('auth.nameLabel', 'Nome')}</span>
                <input class="auth-input" name="name" type="text" autocomplete="name"
                       placeholder="${this._t('auth.namePlaceholder', '')}">
            </label>` : '';

        // No modo reset o e-mail não é pedido (a autorização é o token do link).
        const emailField = this.mode !== 'reset' ? `
            <label class="auth-field">
                <span class="auth-label">${this._t('auth.emailLabel', 'Email')}</span>
                <input class="auth-input" name="email" type="email" autocomplete="email" required
                       inputmode="email" placeholder="${this._t('auth.emailPlaceholder', '')}"
                       value="${this._escAttr(this._prefillEmail)}">
            </label>` : '';

        // forgot = só e-mail (sem senha); reset = só a NOVA senha; demais = senha normal.
        let passwordField = '';
        if (this.mode === 'reset') {
            passwordField = `
            <label class="auth-field">
                <span class="auth-label">${this._t('auth.newPasswordLabel', 'Nova senha')}</span>
                <input class="auth-input" name="password" type="password" required
                       autocomplete="new-password" placeholder="${this._t('auth.newPasswordPlaceholder', '', { min: this._minPassword() })}">
            </label>`;
        } else if (this.mode !== 'forgot') {
            // No CADASTRO a exigência é dita enquanto se digita (ver _bindPasswordHint);
            // no login não há exigência a mostrar — repetir "mínimo N" ali só faz a tela de
            // entrar parecer a de criar conta, que é a confusão que estamos desfazendo.
            const isSignup = this.mode === 'signup';
            passwordField = `
            <label class="auth-field">
                <span class="auth-label">${this._t('auth.passwordLabel', 'Senha')}</span>
                <input class="auth-input" name="password" type="password" required
                       autocomplete="${isSignup ? 'new-password' : 'current-password'}"
                       ${isSignup ? 'aria-describedby="auth-pw-hint"' : ''}>
            </label>
            ${isSignup ? `<span class="auth-hint" id="auth-pw-hint">${
                this._t('auth.passwordPlaceholder', '', { min: this._minPassword() })}</span>` : ''}`;
        }

        let intro = '';
        if (this.mode === 'forgot') intro = `<p class="auth-intro">${this._t('auth.forgotIntro', '')}</p>`;
        else if (this.mode === 'reset') intro = `<p class="auth-intro">${this._t('auth.resetIntro', '')}</p>`;

        const submitKey = { signin: 'signInSubmit', signup: 'signUpSubmit', forgot: 'forgotSubmit', reset: 'resetSubmit' }[this.mode];
        const submitLabel = this._t('auth.' + submitKey, 'Entrar');

        let altHtml = '';
        if (this.mode === 'signin') {
            altHtml = `
                <button type="button" class="auth-link" data-go="forgot">${this._t('auth.toForgot', 'Esqueci a senha')}</button>
                <button type="button" class="auth-link" data-go="signup">${this._t('auth.toSignUp', 'Criar conta')}</button>`;
        } else if (this.mode === 'signup') {
            // "◀ Voltar" só existe quando há escolha ATRÁS: com social apagado o
            // formulário é a primeira tela, e voltar levaria a lugar nenhum.
            const back = (chooser && !atChoice)
                ? `<button type="button" class="auth-link auth-back" data-step="choice"><span aria-hidden="true">◀ </span>${this._t('auth.backToChoice', 'Voltar')}</button>`
                : '';
            altHtml = back + `<button type="button" class="auth-link" data-go="signin">${this._t('auth.toSignIn', 'Já tem conta? Entrar')}</button>`;
        } else {
            altHtml = `<button type="button" class="auth-link" data-go="signin">${this._t('auth.backToSignIn', 'Voltar ao login')}</button>`;
        }

        const formHtml = atChoice ? '' : `
            <form class="auth-form" novalidate>
                ${nameField}
                ${emailField}
                ${passwordField}
                ${intro}
                <div class="auth-error" role="alert" hidden></div>
                <button type="submit" class="auth-submit">${submitLabel}</button>
            </form>`;

        this.root.innerHTML = `
            ${headHtml}
            ${socialHtml}
            ${mailHtml}
            ${formHtml}
            <div class="auth-alt${atChoice ? ' auth-alt--center' : ''}">${altHtml}</div>`;

        // ---- listeners (todos inertes enquanto um submit está em voo) ----
        // 🔴 O form NÃO existe no estado 'choice' — procurar sem checar dava TypeError
        // dentro do próprio render, e o card ficava pela metade.
        const form = this.root.querySelector('.auth-form');
        if (form) form.addEventListener('submit', (e) => { e.preventDefault(); this._submit(); });
        this.root.querySelectorAll('.auth-link[data-go]').forEach(b =>
            b.addEventListener('click', () => { if (!this.busy) this.switchMode(b.dataset.go); }));
        this.root.querySelectorAll('[data-step]').forEach(b =>
            b.addEventListener('click', () => this._setSignupStep(b.dataset.step)));
        const g = this.root.querySelector('.auth-social[data-provider]');
        if (g) g.addEventListener('click', () => { if (!this.busy) this._um()?.startOAuth(g.dataset.provider); });

        this._bindPasswordHint();
        this._syncDialogLabel();
    }

    /**
     * A exigência de senha do CADASTRO se cumpre à vista: a dica vira "atendida" assim que
     * o tamanho basta, em vez de virar erro vermelho depois do clique. É o conserto do
     * defeito de origem — a recusa por senha curta acontecia no navegador, sem virar
     * requisição, então nem o usuário entendia nem o servidor registrava.
     * Só marca o SUFICIENTE; nunca pinta de erro enquanto se digita (ninguém começa
     * uma senha já completa, e acusar erro na 1ª letra é hostil).
     */
    _bindPasswordHint() {
        const input = this.root.querySelector('[name=password]');
        const hint  = this.root.querySelector('#auth-pw-hint');
        if (!input || !hint) return;
        const min = this._minPassword();
        const sync = () => hint.classList.toggle('is-met', input.value.length >= min);
        // 'change' junto: gerenciador de senha preenche por script e NÃO dispara 'input' —
        // a dica ficaria "não cumprida" com uma senha válida no campo, o oposto do objetivo.
        ['input', 'change'].forEach(ev => input.addEventListener(ev, sync));
        sync();
    }

    // 🔴 O `&` vai PRIMEIRO: sem ele, `joao&amp;silva@x.com` volta do re-render como
    // `joao&silva@x.com` — o e-mail muda sozinho. Não era teórico: o botão "Criar conta"
    // da bifurcação força exatamente esse re-render. Escapa `'` também para o dia em que
    // este retorno for parar num atributo de aspas simples.
    _escAttr(s) {
        return String(s || '')
            .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;').replace(/</g, '&lt;');
    }

    // ---------- submit ----------

    async _submit() {
        if (this.busy) return;
        const um = this._um();
        if (!um) { this._showError(this._t('auth.errors.network', '')); return; }

        const val = (n) => { const el = this.root.querySelector(`[name=${n}]`); return el ? el.value : ''; };
        const email = val('email'), password = val('password'), name = val('name');

        const mode = this.mode;
        const seal = ++this._submitSeal;
        this.busy = true; this._setLoading(true); this._showError('');

        let res;
        if (mode === 'signin') res = await um.loginWithPassword({ email, password });
        else if (mode === 'signup') res = await um.registerAccount({ name, email, password });
        else if (mode === 'reset') res = await um.resetPassword(this._resetToken, password);
        else res = await um.requestPasswordReset(email);

        // 🔴 A tela pode ter virado outra durante o `await` (fechar + reabrir pelo
        // portão devolve o cadastro à escolha, onde não existe `.auth-error` nem
        // `.auth-submit`). Escrever aqui seria pintar um card que já não está no ar.
        if (seal !== this._submitSeal) return;

        if (!res || !res.success) {
            // UM ponto para TODA recusa deste formulário — inclusive a que o próprio
            // cliente decidiu (senha curta) e que, por não virar requisição, é invisível
            // no log do servidor. Só o código do erro viaja, nunca o e-mail.
            const code = (res && res.code) || 'generic';
            if (window.Beacon) window.Beacon.authFail(mode, code);
            this._endBusy();
            this._showError(this._errorMsg(res), this._errorActions(res));
            return;
        }

        if (mode === 'forgot') {
            this._toast(this._t('auth.toasts.resetSent', ''), 'success');
            this._prefillEmail = email; this._endBusy(); this.switchMode('signin');
            return;
        }

        if (mode === 'reset') {
            // Senha trocada (backend não abre sessão). Se já havia sessão local (raro:
            // redefiniu estando logado), só fecha — não faz sentido mostrar "Entrar".
            // Deslogado → manda pro login pra entrar com a nova senha.
            this._resetToken = '';
            this._toast(this._t('auth.toasts.passwordReset', ''), 'success');
            this._endBusy();
            if (um.isLoggedIn && um.isLoggedIn()) this.close();
            else this.switchMode('signin');
            return;
        }

        if (mode === 'signup') {
            // Cadastro não abre sessão no backend → auto-login p/ já entrar (a conta é
            // is_active mesmo sem verificar email; a verificação é um lembrete, não gate).
            // MANTÉM o loading até o auto-login resolver (sem janela de duplo-submit).
            const login = await um.loginWithPassword({ email, password });
            if (login && login.success) { this._welcome(login.user); this.close(); }
            else {
                this._toast(this._t('auth.toasts.accountCreated', ''), 'success');
                this._prefillEmail = email; this._endBusy(); this.switchMode('signin');
            }
            return;
        }

        // signin
        this._welcome(res.user);
        this.close();
    }

    _endBusy() { this.busy = false; this._setLoading(false); }

    _welcome(user) {
        const name = (user && user.name) || this._t('auth.guest', '');
        this._toast(this._t('auth.toasts.welcome', 'Bem-vindo!', { name }), 'success');
    }

    _errorMsg(res) {
        let code = (res && res.code) || 'generic';
        // A frase de `social_account` cita "o botão do Google"; sem provedor aceso o botão
        // não existe na tela, e prometer saída que não se desenha é beco com outro nome.
        if (code === 'social_account' && AuthModal._providers().indexOf((res && res.provider) || 'google') === -1) {
            code = 'social_account_noprov';
        }
        // `min` só é consumido por short_password; passar sempre evita um caso especial.
        return this._t('auth.errors.' + code, this._t('auth.errors.generic', 'Algo deu errado.'),
                       { min: this._minPassword() });
    }

    /**
     * Alguns erros não são "você errou" — são uma BIFURCAÇÃO: a pessoa está no formulário
     * errado. Esses ganham um botão que leva ao outro lado (o e-mail digitado sobrevive,
     * via _captureEmail no switchMode). Sem isso, "não encontramos conta" é um beco: foi
     * exatamente o que aconteceu com quem tentou entrar sem ter cadastro.
     */
    _errorActions(res) {
        const code = (res && res.code) || 'generic';
        if (code === 'no_account')  return [{ go: 'signup', label: this._t('auth.errors.actions.createAccount', 'Criar conta') }];
        if (code === 'email_taken') return [{ go: 'signin', label: this._t('auth.errors.actions.signIn', 'Entrar') }];
        // Conta sem senha (só-Google, ou senha APAGADA pelo vínculo — SocialLogin.php).
        // Era um beco com duas instruções em texto; vira dois botões: o do provedor (só
        // se ele está aceso neste build) e "definir nova senha" (= esqueci a senha, que
        // devolve a conta a híbrida). O e-mail digitado sobrevive à troca de modo.
        if (code === 'social_account') {
            const out = [];
            const provider = (res && res.provider) || 'google';
            if (AuthModal._providers().indexOf(provider) !== -1) {
                out.push({ run: () => this._um()?.startOAuth(provider),
                           label: this._t('auth.errors.actions.googleSignIn', 'Entrar com Google') });
            }
            out.push({ go: 'forgot', label: this._t('auth.errors.actions.setPassword', 'Definir nova senha') });
            return out;
        }
        return null;
    }

    /**
     * @param {string} msg
     * @param {Array<{go?:string,run?:Function,label:string}>|null} actions  botões de saída
     *        (bifurcação, não erro). `go` troca de modo; `run` executa (ex.: OAuth).
     */
    _showError(msg, actions) {
        const box = this.root && this.root.querySelector('.auth-error');
        if (!box) return;
        const list = Array.isArray(actions) ? actions : (actions ? [actions] : []);
        box.textContent = '';
        box.hidden = !msg;
        box.classList.toggle('auth-error--fork', !!(msg && list.length));
        if (!msg) return;

        const p = document.createElement('p');
        p.className = 'auth-error-msg';
        p.textContent = msg;
        box.appendChild(p);

        if (!list.length) return;
        const row = document.createElement('div');
        row.className = 'auth-error-actions';
        list.forEach((action) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'auth-error-action';
            btn.textContent = action.label;
            btn.addEventListener('click', () => {
                if (this.busy) return;
                if (typeof action.run === 'function') action.run();
                else this.switchMode(action.go);
            });
            row.appendChild(btn);
        });
        box.appendChild(row);
    }

    _setLoading(on) {
        const btn = this.root && this.root.querySelector('.auth-submit');
        if (!btn) return;
        btn.disabled = on;
        this.root.classList.toggle('is-loading', on);
        if (on) {
            btn.dataset.label = btn.textContent;
            btn.textContent = this._t('auth.loading', 'Aguarde…');
        } else if (btn.dataset.label) {
            btn.textContent = btn.dataset.label;
        }
    }

    _toast(msg, type) {
        if (window.notifications && msg) window.notifications.toast(msg, { type: type || 'info' });
    }

    /**
     * Provedores a mostrar. PROD é controlada pelo flag AuthModal.SOCIAL (vazio até o
     * OAuth Client de prod estar 100%). No LAB (lab.<domínio>, HTTPS + URIs já
     * registradas) o Google aparece SEMPRE p/ teste — sem tocar em prod nem arriscar
     * botão quebrado. ritmo.local (http) fica fora: o Google rejeita http.
     */
    static _providers() {
        const list = (AuthModal.SOCIAL || []).slice();
        try {
            const host = (typeof location !== 'undefined' && location.hostname) || '';
            if (host.startsWith('lab.') && list.indexOf('google') === -1) list.push('google');
        } catch (e) {}
        return list;
    }
}

// Provedores sociais ATIVOS EM PROD. Vazio = só e-mail/senha. Google acendido em 11/jul/2026
// (OAuth Client 100%: 3 redirect URIs de prod + consent publicado; gate de auditoria 3-agentes
// passou). O LAB já revelava o Google sozinho (ver _providers).
AuthModal.SOCIAL = ['google'];

// 🔴 "G" OFICIAL do Google — COPIADO do projeto vizinho (capsula/NotificationManager.js),
// nunca redesenhado: marca alheia com o traço errado é pior que a letra `G` de CSS que
// estava aqui. 4 paths, 4 cores da marca (#EA4335 #4285F4 #FBBC05 #34A853).
AuthModal.GOOGLE_SVG = '<svg class="auth-social-ico" viewBox="0 0 48 48" aria-hidden="true" focusable="false">'
    + '<path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6.1C12.3 13.2 17.6 9.5 24 9.5z"/>'
    + '<path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.5 3-2.2 5.5-4.7 7.2l7.3 5.7c4.3-4 6.8-9.9 6.8-17.4z"/>'
    + '<path fill="#FBBC05" d="M10.4 28.3c-.5-1.5-.8-3-.8-4.8s.3-3.3.8-4.8l-7.8-6.1C.9 16 0 19.9 0 23.5s.9 7.5 2.6 10.9l7.8-6.1z"/>'
    + '<path fill="#34A853" d="M24 47c6.2 0 11.4-2 15.2-5.5l-7.3-5.7c-2 1.4-4.7 2.3-7.9 2.3-6.4 0-11.7-3.7-13.6-9.8l-7.8 6.1C6.5 42.6 14.6 47 24 47z"/>'
    + '</svg>';

// Classe + singleton global (mesmo padrão de notifications/appHeader).
window.AuthModal = AuthModal;
window.authModal = new AuthModal();



// ============================================
// components/promo/PromoCatalog.js
// ============================================
/**
 * PromoCatalog — a TABELA das peças de vitrine ("propaganda") que o app mostra no espaço
 * que sobra em tela larga. Dado PURO, sem DOM: quem desenha é o PromoCard, quem decide
 * ONDE e QUANDO é o PromoRail. Ver docs/PROMO-PLANO.md.
 *
 * FILOSOFIA (espelho do SidebarRail/SidebarWidget do projeto principal): o código é
 * escrito UMA vez; o CONTEÚDO cresce como DADO — uma entrada nova aqui (uma dica, um
 * jogo em destaque, uma campanha) não pede classe nova. Só o TIPO de peça (kind) que
 * exija desenho próprio ganha um renderer no PromoCard.
 *
 * 🔴 A COPY MORA NO `translations.json` (`promo.<id>.*`), nunca aqui: é a regra da casa
 *    (fonte única, paridade pt/en/es cobrada pelo i18n-test). Aqui fica só o que NÃO é
 *    texto: o destino por idioma, o tipo e o prazo do "Ocultar".
 * 🔴 O destino é o irmão do MESMO idioma (regra dos 3 domínios). O link leva `utm_*` de
 *    propósito: o site do irmão é estático e o HTML sai do cache — com a query o pedido
 *    CHEGA ao servidor e o Referer (aulademusica) fica no log de lá. Por isso o `rel` do
 *    link é `noopener` SEM `noreferrer` (noreferrer apagaria justamente a origem).
 *
 * Contrato de uma entrada:
 *   id       → chave do beacon (`pr=`) e do `promo.<id>` no i18n. Faixa: ^[a-z][a-z0-9]{0,15}$
 *   kind     → 'sister' (cartão com o diapasão do irmão) | 'card' (genérico: icon/title/body/cta)
 *   hosts    → {pt,en,es} host de destino (kind 'sister')
 *   hideDays → quantos dias o "Ocultar" vale (aparelho, localStorage)
 */
class PromoCatalog {
    static PROMOS = {
        // 🌿 O projeto principal (ouvido absoluto). Brand por idioma = o nome que o domínio
        // de lá usa (Ouvido Absoluto · Absolute Pitch Piano · Oído Absoluto Piano).
        sister: {
            kind: 'sister',
            hosts: { pt: 'ouvidoabsoluto.com.br', en: 'absolutepitchpiano.com', es: 'oidoabsolutopiano.com' },
            hideDays: 14
        }
    };

    /** Faixa do id — a mesma que o ETL aplica ao `pr=` (analytics/funnel.php). */
    static ID_RE = /^[a-z][a-z0-9]{0,15}$/;

    static get(id) {
        const p = PromoCatalog.PROMOS[id];
        return (p && PromoCatalog.ID_RE.test(id)) ? p : null;
    }

    static lang() {
        const l = (typeof window !== 'undefined' && window.language && window.language.currentLanguage) || 'pt';
        return ({ pt: 'pt', en: 'en', es: 'es' })[l] || 'pt';
    }

    static _t(key) {
        return (typeof window !== 'undefined' && window.language) ? window.language.t(key) : key;
    }

    /** Destino do cartão irmão para o idioma corrente (ou o pedido). */
    static href(id, lang, placement) {
        const p = PromoCatalog.get(id);
        if (!p || !p.hosts) return '';
        const L = lang || PromoCatalog.lang();
        const host = p.hosts[L] || p.hosts.en;
        const q = new URLSearchParams({
            utm_source: 'aulademusica', utm_medium: 'rail', utm_campaign: 'irmao',
            utm_content: String(placement || '')
        });
        return `https://${host}/?${q.toString()}`;
    }

    /**
     * O objeto de DADO que o PromoCard renderiza, para uma peça numa placement.
     * null = id desconhecido (o rail simplesmente não a desenha).
     */
    static data(id, placement) {
        const p = PromoCatalog.get(id);
        if (!p) return null;
        const lang = PromoCatalog.lang();
        const k = 'promo.' + id + '.';
        if (p.kind === 'sister') {
            return {
                type: 'sister', id, placement,
                eyebrow: PromoCatalog._t(k + 'eyebrow'),
                brand: PromoCatalog._t(k + 'brand'),
                body: PromoCatalog._t(k + 'body'),
                domain: p.hosts[lang] || p.hosts.en,
                hideLabel: PromoCatalog._t(k + 'hide'),
                cta: { label: PromoCatalog._t(k + 'cta'), href: PromoCatalog.href(id, lang, placement) }
            };
        }
        return {
            type: 'card', id, placement,
            icon: p.icon || '', title: PromoCatalog._t(k + 'title'), body: PromoCatalog._t(k + 'body'),
            hideLabel: PromoCatalog._t(k + 'hide'),
            cta: p.route ? { label: PromoCatalog._t(k + 'cta'), href: p.route } : null
        };
    }
}

if (typeof window !== 'undefined') window.PromoCatalog = PromoCatalog;



// ============================================
// components/promo/PromoCard.js
// ============================================
/**
 * PromoCard — o cartão de vitrine, data-driven. Render PURO (objeto → string HTML), sem
 * estado e sem DOM próprio: quem injeta é o PromoRail. Todo texto passa por escape; todo
 * href passa por uma faixa (rota interna `#/…`, caminho `/…` ou http(s) absoluto — nunca
 * `javascript:`, nunca `//host`). Ver docs/PROMO-PLANO.md.
 *
 * Tipos:
 *   'sister' → cartão do projeto irmão: diapasão do IRMÃO (paleta metálica do capsula, não
 *              a Sálvia daqui — é a marca DELE que se anuncia), eyebrow + brand, corpo,
 *              link de texto (nunca botão preenchido: a vitrine não compete com a tela),
 *              rodapé com "Ocultar" e o domínio visível.
 *   'card'   → genérico (icon/title/body/cta) para dicas e destaques futuros.
 *
 * Quem trata clique/ocultar é o listener delegado do PromoRail (data-promo-*).
 */
class PromoCard {
    static renderHtml(d) {
        if (!d || typeof d !== 'object') return '';
        if (d.type === 'sister') return PromoCard._sister(d);
        return PromoCard._card(d);
    }

    static _sister(d) {
        const e = PromoCard._escape;
        const id = e(d.id || '');
        const pl = e(d.placement || '');
        const cta = (d.cta && d.cta.label && PromoCard._safeUrl(d.cta.href))
            // 🔴 `noopener` sem `noreferrer`: o Referer é como o funil do irmão sabe que a
            //    pessoa veio daqui. Apagá-lo deixaria o clique invisível do outro lado.
            ? `<a class="promo-link" href="${e(d.cta.href)}" target="_blank" rel="noopener" data-promo-cta="${id}">${e(d.cta.label)} <span class="promo-arr" aria-hidden="true">→</span></a>`
            : '';
        const hide = d.hideLabel
            ? `<button type="button" class="promo-dismiss" data-promo-dismiss="${id}">${e(d.hideLabel)}</button>`
            : '';
        const domain = d.domain ? `<span class="promo-domain">${e(d.domain)}</span>` : '';
        return `
            <article class="promo-card promo-card--sister" data-promo="${id}" data-promo-pl="${pl}">
                <div class="promo-head">
                    ${PromoCard.logoSvg(30)}
                    <div>
                        <span class="promo-eyebrow">${e(d.eyebrow)}</span>
                        <span class="promo-brand">${e(d.brand)}</span>
                    </div>
                </div>
                ${d.body ? `<p class="promo-text">${e(d.body)}</p>` : ''}
                ${cta}
                <div class="promo-foot">${hide}${domain}</div>
            </article>`;
    }

    static _card(d) {
        const e = PromoCard._escape;
        const id = e(d.id || '');
        const pl = e(d.placement || '');
        const icon = d.icon ? `<span class="promo-icon" aria-hidden="true">${e(d.icon)}</span>` : '';
        const title = d.title ? `<span class="promo-title">${e(d.title)}</span>` : '';
        const head = (icon || title) ? `<div class="promo-head promo-head--card">${icon}${title}</div>` : '';
        const cta = (d.cta && d.cta.label && PromoCard._safeHref(d.cta.href))
            ? `<a class="promo-link" href="${e(d.cta.href)}" data-promo-cta="${id}">${e(d.cta.label)} <span class="promo-arr" aria-hidden="true">→</span></a>`
            : '';
        const hide = d.hideLabel
            ? `<button type="button" class="promo-dismiss" data-promo-dismiss="${id}">${e(d.hideLabel)}</button>`
            : '';
        if (!head && !d.body && !cta) return '';   // cartão sem conteúdo não existe
        return `
            <article class="promo-card" data-promo="${id}" data-promo-pl="${pl}">
                ${head}
                ${d.body ? `<p class="promo-text">${e(d.body)}</p>` : ''}
                ${cta}
                ${hide ? `<div class="promo-foot">${hide}</div>` : ''}
            </article>`;
    }

    /**
     * Diapasão do PROJETO IRMÃO — a geometria canônica (viewBox 316 270 168 240, a mesma
     * do `img/logo.svg`) na paleta METÁLICA do capsula (`capsula/DIAPASAO.md`): hastes
     * `#e8e8e8→#d0d0d0→#b8b8b8`, cabo `#4a4a4a→#2c2c2c→#1a1a1a`, boca `#3498db`.
     * ids prefixados (pmlg-) para não colidir com o logo Sálvia do header.
     */
    static logoSvg(width) {
        const w = Math.max(12, parseInt(width, 10) || 30);
        const h = Math.round(w * 240 / 168);
        return `<svg class="promo-logo" width="${w}" height="${h}" viewBox="316 270 168 240" aria-hidden="true" focusable="false">
            <defs>
              <linearGradient id="pmlg-la" x1="336" y1="280" x2="397" y2="480" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#e8e8e8"/><stop offset=".5" stop-color="#d0d0d0"/><stop offset="1" stop-color="#b8b8b8"/></linearGradient>
              <linearGradient id="pmlg-ra" x1="464" y1="280" x2="403" y2="480" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#e8e8e8"/><stop offset=".5" stop-color="#d0d0d0"/><stop offset="1" stop-color="#b8b8b8"/></linearGradient>
              <linearGradient id="pmlg-h" x1="370" y1="460" x2="430" y2="500" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#4a4a4a"/><stop offset=".5" stop-color="#2c2c2c"/><stop offset="1" stop-color="#1a1a1a"/></linearGradient>
            </defs>
            <rect x="370" y="460" width="60" height="40" fill="url(#pmlg-h)" stroke="#808080" stroke-width="3"/>
            <polygon points="326,280 346,280 407,480 387,480" fill="url(#pmlg-la)" stroke="#808080" stroke-width="3" stroke-linejoin="round"/>
            <polygon points="454,280 474,280 413,480 393,480" fill="url(#pmlg-ra)" stroke="#808080" stroke-width="3" stroke-linejoin="round"/>
            <ellipse cx="400" cy="465" rx="14" ry="14" fill="#3498db" stroke="#2c3e50" stroke-width="2.5"/>
            <ellipse cx="348" cy="330" rx="18" ry="22" fill="#fff" stroke="#333" stroke-width="2.5"/><circle cx="348" cy="330" r="10" fill="#1a1a1a"/><circle cx="344" cy="326" r="4" fill="#fff" fill-opacity=".6"/>
            <ellipse cx="452" cy="330" rx="18" ry="22" fill="#fff" stroke="#333" stroke-width="2.5"/><circle cx="452" cy="330" r="10" fill="#1a1a1a"/><circle cx="448" cy="326" r="4" fill="#fff" fill-opacity=".6"/>
        </svg>`;
    }

    static _escape(value) {
        if (value === null || value === undefined) return '';
        return String(value)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    /** Só http(s) absoluto (o cartão irmão SAI do site — nada de javascript:/data:). */
    static _safeUrl(url) {
        return typeof url === 'string' && /^https?:\/\//i.test(url);
    }

    /** CTA genérico: rota interna (#/…), caminho (/…) ou http(s). `//host` e `/\host` são os
     *  dois caminhos para fora do site disfarçados de caminho — rejeitados. */
    static _safeHref(href) {
        if (typeof href !== 'string') return false;
        if (/^\/[\\/]/.test(href)) return false;
        return /^\//.test(href) || /^#\//.test(href) || /^https?:\/\//i.test(href);
    }
}

if (typeof window !== 'undefined') window.PromoCard = PromoCard;



// ============================================
// components/promo/PromoRail.js
// ============================================
/**
 * PromoRail — a coluna lateral de vitrine ("propaganda") que ocupa o espaço que sobra em
 * tela larga, reutilizável em VÁRIAS telas. Espelho do SidebarRail do projeto principal,
 * no idioma desta casa (BaseScreen, Beacon.action, i18n no translations.json).
 * Ver docs/PROMO-PLANO.md.
 *
 * MODELO DE PLACEMENT: cada tela é uma "placement" com config própria em PLACEMENTS —
 * ligar/desligar, quais peças (ids do PromoCatalog) e o breakpoint abaixo do qual a rail
 * some. Ligar uma tela = UMA linha aqui + `PromoRail.wrap(html, '<placement>')` no render
 * da tela. Tela desligada nem sabe que a rail existe: wrap() devolve o HTML intocado.
 *
 * ESTADO (15/set/2026, 1ª onda): só `news` ligada, com UM cartão (o do projeto irmão),
 * rail à direita, não-sticky (rola com a página). Decisão do Bernardo: começar pela tela
 * menos invasiva; quem abre Novidades é quem mais se interessa (professor, aficionados).
 *
 * VISIBILIDADE = dupla trava: (1) `enabled` mata na origem; (2) o CSS esconde a rail abaixo
 * do breakpoint (`@media` em css/styles.css — o número TEM de ser o mesmo daqui, o
 * promo-test cobra). 🔴 O HTML da rail é emitido SEMPRE; quem a esconde no celular é o CSS.
 * Por isso o beacon de VISTA só sai quando `isVisible()` (largura ≥ breakpoint): sem esse
 * guard todo celular contaria uma "vista" de algo que ninguém viu, e a taxa de clique viria
 * diluída — lição paga no principal (SidebarRail.wrap, 09/set).
 *
 * FUNIL: `promo_view` / `promo_click` / `promo_hide` via `Beacon.action()` (mesmo portão
 * humano do app, mesma faixa `provavel` no ETL) com `pl=<placement>` e `pr=<id>`. O
 * contrato de 3 vias (emissor ↔ funnel.php ↔ funnel-live.php) é cobrado pelo
 * funnel-etl-test, que varre esta pasta.
 *
 * "OCULTAR" é preferência de APARELHO (`promo_hidden_v1`, fora do StorageScope como o
 * `help_seen_v1`): vale HIDE_DAYS por peça, não por placement — quem ocultou o cartão
 * irmão nas Novidades não o quer noutra tela no dia seguinte.
 */
class PromoRail {
    /** ⚠️ CHAVE = nome da placement que a tela passa ao wrap(). `breakpoint` é a largura
     *  mínima (px) em que a rail é visível — ESPELHADO em css/styles.css. */
    static PLACEMENTS = {
        news: { enabled: true, promos: ['sister'], breakpoint: 1280, side: 'right' }
        // Candidatas futuras (desligadas, sem custo): ranking, progress, help, perfil…
        // Ligar = uma linha aqui + wrap() no render da tela + a regra CSS `.promo-shell--<x>`.
    };

    /** Chave de "ocultar" no aparelho: { [id]: untilMs }. */
    static HIDE_KEY = 'promo_hidden_v1';

    static isEnabled(placement) {
        const cfg = PromoRail.PLACEMENTS[placement];
        return !!(cfg && cfg.enabled);
    }

    /** A rail está VISÍVEL nesta largura? (a mesma régua do @media do CSS) */
    static isVisible(placement) {
        const cfg = PromoRail.PLACEMENTS[placement];
        if (!cfg) return false;
        const w = (typeof window !== 'undefined' && window.innerWidth) || 0;
        return w >= (cfg.breakpoint || 0);
    }

    // ───────────────────────── "Ocultar" (aparelho) ─────────────────────────

    static _hiddenMap() {
        try {
            const raw = window.localStorage.getItem(PromoRail.HIDE_KEY);
            const m = raw ? JSON.parse(raw) : null;
            return (m && typeof m === 'object' && !Array.isArray(m)) ? m : {};
        } catch (e) { return {}; }
    }

    static isHidden(id) {
        const until = Number(PromoRail._hiddenMap()[id] || 0);
        return Number.isFinite(until) && until > Date.now();
    }

    static hide(id, days) {
        const p = (typeof PromoCatalog !== 'undefined') ? PromoCatalog.get(id) : null;
        const d = Number.isFinite(days) ? days : ((p && p.hideDays) || 14);
        try {
            const m = PromoRail._hiddenMap();
            m[id] = Date.now() + d * 86400000;
            window.localStorage.setItem(PromoRail.HIDE_KEY, JSON.stringify(m));
        } catch (e) { /* aparelho sem storage: o cartão some só nesta tela */ }
    }

    // ───────────────────────── conteúdo ─────────────────────────

    /** As peças desta placement que NÃO estão ocultas, já como dado do PromoCard. */
    static widgets(placement) {
        const cfg = PromoRail.PLACEMENTS[placement];
        if (!cfg || !cfg.enabled || typeof PromoCatalog === 'undefined') return [];
        const out = [];
        (cfg.promos || []).forEach(id => {
            if (PromoRail.isHidden(id)) return;
            const d = PromoCatalog.data(id, placement);
            if (d) out.push(d);
        });
        return out;
    }

    /**
     * Envolve o HTML central da tela na grade com a rail. Placement desligada, sem peça ou
     * tudo oculto ⇒ devolve `centerHtml` INTOCADO (nem a grade nasce: coluna vazia é
     * impossível por construção). Seguro em qualquer tela: é só chamar.
     */
    static wrap(centerHtml, placement) {
        const cfg = PromoRail.PLACEMENTS[placement];
        if (!cfg || !cfg.enabled) return centerHtml;
        const list = PromoRail.widgets(placement);
        if (!list.length) return centerHtml;

        // 🔴 A guarda de "coluna vazia" olha o HTML, não a lista: o PromoCard devolve '' para
        //    peça sem conteúdo, e a vista só sai de peça que foi DESENHADA (auditoria 15/set).
        const drawn = list.map(d => ({ d, html: PromoCard.renderHtml(d) })).filter(x => x.html);
        if (!drawn.length) return centerHtml;

        PromoRail._ensureListeners();
        if (PromoRail.isVisible(placement)) {
            drawn.forEach(({ d }) => {
                try { window.Beacon?.action?.('promo_view', { pl: placement, pr: d.id }); } catch (e) { /* best-effort */ }
            });
        }
        const label = PromoRail._t('promo.railLabel');
        const side = cfg.side === 'left' ? 'left' : 'right';
        const cards = drawn.map(x => x.html).join('');
        return `
            <div class="promo-shell promo-shell--${PromoCard._escape(placement)}">
                <div class="promo-center">${centerHtml}</div>
                <aside class="promo-rail promo-rail--${side}" aria-label="${PromoCard._escape(label)}">${cards}</aside>
            </div>`;
    }

    /** Colapsa a rail (e a grade) quando não sobrou cartão nenhum. */
    static collapseIfEmpty(railEl) {
        if (!railEl) return;
        if (railEl.querySelector('.promo-card')) return;
        const shell = railEl.closest('.promo-shell');
        railEl.remove();
        if (shell && !shell.querySelector('.promo-rail')) shell.classList.add('promo-shell--collapsed');
    }

    /** Listener delegado ÚNICO (CTA e Ocultar), no document: sobrevive a re-render. */
    static _ensureListeners() {
        if (PromoRail._listening || typeof document === 'undefined') return;
        PromoRail._listening = true;
        const onClick = (ev) => {
            const t = ev.target;
            if (!t || !t.closest) return;
            const cta = t.closest('[data-promo-cta]');
            // Botão do MEIO ("abrir em nova aba", hábito de desktop — o único lugar onde a rail
            // existe) chega como `auxclick`, não `click`: sem isto o irmão veria o utm e o
            // funil daqui não veria o clique (auditoria 15/set). O dedup do Beacon segura o resto.
            if (ev.type === 'auxclick') {
                if (cta && ev.button === 1) {
                    const card = cta.closest('[data-promo]');
                    try { window.Beacon?.action?.('promo_click', { pl: card ? card.getAttribute('data-promo-pl') : '', pr: cta.getAttribute('data-promo-cta') }); } catch (e) { /* best-effort */ }
                }
                return;
            }
            if (cta) {
                const card = cta.closest('[data-promo]');
                const pl = card ? card.getAttribute('data-promo-pl') : '';
                try { window.Beacon?.action?.('promo_click', { pl, pr: cta.getAttribute('data-promo-cta') }); } catch (e) { /* best-effort */ }
                return;   // a navegação segue (target=_blank / rota interna)
            }
            const btn = t.closest('[data-promo-dismiss]');
            if (btn) {
                ev.preventDefault();
                const id = btn.getAttribute('data-promo-dismiss');
                const card = btn.closest('[data-promo]');
                const pl = card ? card.getAttribute('data-promo-pl') : '';
                const rail = btn.closest('.promo-rail');
                PromoRail.hide(id);
                try { window.Beacon?.action?.('promo_hide', { pl, pr: id }); } catch (e) { /* best-effort */ }
                if (card) card.remove();   // some AGORA, sem esperar re-render
                PromoRail.collapseIfEmpty(rail);
            }
        };
        document.addEventListener('click', onClick, true);
        document.addEventListener('auxclick', onClick, true);
    }

    static _t(key) {
        return (typeof window !== 'undefined' && window.language) ? window.language.t(key) : key;
    }
}

if (typeof window !== 'undefined') window.PromoRail = PromoRail;



// ============================================
// components/UserAvatar.js
// ============================================
/**
 * UserAvatar — avatar reusável do usuário. Produz um nó (sem estado): foto
 * (avatar_url, ex.: Google) OU iniciais em cor determinística pelo nome/email.
 * Usado no header (Etapa C) e reaproveitável em perfil / prompts de fim de nível.
 */
class UserAvatar {
    /** Elemento de avatar p/ o usuário dado. `size` em px. */
    static el(user, size = 32) {
        const span = document.createElement('span');
        span.className = 'user-avatar';
        span.style.width = span.style.height = size + 'px';
        span.style.fontSize = Math.round(size * 0.42) + 'px';
        const name = (user && (user.name || user.email)) || '';

        if (user && user.avatar_url) {
            const img = document.createElement('img');
            img.src = user.avatar_url;
            img.alt = name;
            img.referrerPolicy = 'no-referrer';
            // Foto falhou (link morto / offline) → cai pras iniciais, nunca quebra.
            img.addEventListener('error', () => {
                img.remove();
                span.textContent = UserAvatar.initials(name);
                span.style.background = UserAvatar.color(name);
            });
            span.appendChild(img);
        } else {
            span.textContent = UserAvatar.initials(name);
            span.style.background = UserAvatar.color(name);
        }
        return span;
    }

    static initials(name) {
        const s = String(name || '').trim();
        if (!s) return '?';
        const parts = s.split(/\s+/);
        const a = parts[0][0] || '';
        const b = parts.length > 1 ? (parts[parts.length - 1][0] || '') : '';
        return (a + b).toUpperCase() || '?';
    }

    /** Cor de fundo determinística (hue do hash do nome). */
    static color(name) {
        let h = 0;
        const s = String(name || '');
        for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
        return `hsl(${h}, 52%, 52%)`;
    }
}

window.UserAvatar = UserAvatar;



// ============================================
// components/AccountActions.js
// ============================================
/**
 * AccountActions — os CONTROLES DE CONTA que existem em DOIS lugares: a gaveta ☰ do
 * `AppHeader` (acesso rápido, de dentro de qualquer jogo) e o painel "Minha conta"
 * (`#/perfil`, `ProfileScreen`).
 *
 * 🔴 POR QUE ESTA CLASSE EXISTE. O interruptor do diário e o "Apagar conta" nasceram
 * dentro do `AppHeader` (07/set), e a tela de perfil precisava dos mesmos. Duplicar o
 * código era a saída barata e a pior: as regras que valem ali não são óbvias — o
 * interruptor NÃO é otimista (só pinta o que o servidor devolveu), o clique apaga a fila
 * do diário NA HORA (é o que a política promete em 3 idiomas), e a morte de sessão não
 * pode virar um 2º toast. Duas cópias divergem na primeira correção, e a que diverge é a
 * que promete "não estou gravando".
 *
 * 🔴 E POR QUE O MESMO NÓ, e não só o mesmo comportamento: as duas superfícies produzem
 * a MESMA linha (`.nav-menu-item .nav-account-action`), com os mesmos 48px de alvo. Se o
 * painel tivesse marcação própria, o alvo de dedo, o `aria-pressed` e o estado visual
 * teriam de ser consertados duas vezes — e o painel é justamente a superfície nova, a
 * que ninguém lembra de testar.
 *
 * 🔴 `data-act` em toda linha (`profile|diary|signout|delete|reset|verify`): quem procura
 * uma ação a acha pela INTENÇÃO. O teste antigo pegava "Sair" pelo índice `[0]` da lista
 * e passou a clicar no interruptor quando ele entrou na frente — índice em lista que
 * cresce é bomba de relógio, e o teste continua "passando" clicando no botão errado.
 *
 * Não é singleton e não guarda estado: só fábricas estáticas (o molde do `UserAvatar`).
 */
class AccountActions {
    static _t(key, fallback = '', params = undefined) {
        const v = window.language ? window.language.t(key, params) : key;
        return (v && v !== key) ? v : (fallback || key);
    }

    static _esc(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    /**
     * Uma linha de ação da conta. `act` é a intenção (vira `data-act`), não a aparência.
     * @param {{ico:string, label:string, act:string, onClick:Function, danger?:boolean, sub?:string, cls?:string}} o
     */
    static row({ ico, label, act, onClick, danger = false, sub = '', cls = '' }) {
        const b = document.createElement('button');
        b.type = 'button';
        // 🔴 `--stack` quando há subtítulo: sem ele o `.nav-menu-label` é uma linha só e o
        //    sub cola no rótulo ("Zerar progresso12 resultados guardados" — medido a 390px).
        //    A regra mora no styles.css, com o resto da gaveta, para valer nas DUAS superfícies.
        b.className = 'nav-menu-item nav-account-action' + (sub ? ' nav-account-action--stack' : '')
            + (danger ? ' is-danger' : '') + (cls ? ' ' + cls : '');
        if (act) b.dataset.act = act;
        b.innerHTML = `<span class="nav-menu-ico" aria-hidden="true">${AccountActions._esc(ico)}</span>`
            + `<span class="nav-menu-label">${AccountActions._esc(label)}`
            + (sub ? `<span class="nav-menu-sub">${AccountActions._esc(sub)}</span>` : '')
            + `</span>`;
        if (onClick) b.addEventListener('click', onClick);
        return b;
    }

    /**
     * Interruptor de UMA preferência da conta (`users.data`). Nasceu como o do diário e
     * virou genérico quando o do ranking chegou (07/set): as regras difíceis são as
     * MESMAS nos dois, e é para não tê-las escritas duas vezes que esta função existe.
     *
     * `aria-pressed` (e não um checkbox) porque a linha é um botão como as vizinhas: o
     * leitor de tela anuncia o estado e o alvo continua sendo a linha inteira, com os 48px.
     *
     * 🔴 NÃO É OTIMISTA: o estado só muda com o que o SERVIDOR devolveu. Uma tela dizendo
     *    "desligado" com o servidor gravando é pior que meio segundo de espera — e estes
     *    interruptores são justamente o que promete que não se está gravando/publicando.
     * 🔴 UMA PREFERÊNCIA POR SUPERFÍCIE, nunca um interruptor "genérico de privacidade":
     *    ver a tabela USER_PREFS no auth-helpers.php (consentimento não se herda).
     *
     * @param {{pref:string, ico:string, act:string, labelKey:string, onKey:string,
     *          offKey:string, helpKeys?:string[], afterOff?:Function}} o
     *   `helpKeys` = as frases do toast explicativo (sempre TODAS juntas: dizer o que o
     *   interruptor faz sem dizer o que ele NÃO faz deixa a pessoa achando que resolveu
     *   uma coisa que não resolveu). `afterOff` roda só quando o servidor confirma o
     *   desligamento (é onde o diário apaga a fila local).
     */
    static prefToggle({ pref, ico, act, labelKey, onKey, offKey, fallbacks = {}, helpKeys = [], afterOff = null }) {
        const um = window.userManager;
        const b = AccountActions.row({ ico, label: '', act, onClick: null, cls: 'nav-account-toggle' });
        const pinta = () => {
            const on = !!(um && um.getPref && um.getPref(pref));
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            b.classList.toggle('is-on', on);
            b.innerHTML = `<span class="nav-menu-ico" aria-hidden="true">${AccountActions._esc(ico)}</span>`
                // 🔴 Com fallback vazio o `_t` devolve a CHAVE CRUA ("auth.prefs.diary" na
                //    tela). O genérico tinha perdido os fallbacks que o interruptor do
                //    diário trazia — auditoria de 07/set.
                + `<span class="nav-menu-label">${AccountActions._esc(AccountActions._t(labelKey, fallbacks.label))}`
                + `<span class="nav-menu-sub">${AccountActions._esc(AccountActions._t(on ? onKey : offKey, on ? fallbacks.on : fallbacks.off))}</span></span>`
                + `<span class="nav-toggle" aria-hidden="true"><span class="nav-toggle-knob"></span></span>`;
        };
        pinta();
        // 🔴 A MESMA PREFERÊNCIA APARECE EM DUAS TELAS AO MESMO TEMPO: a gaveta ☰ abre POR
        //    CIMA do painel "Minha conta", e as duas montam o interruptor do diário. Quem
        //    clicava num deixava o outro pintado com o estado velho — e clicar no
        //    mentiroso mandava o valor invertido do que a pessoa via, sem a linha mudar de
        //    aparência (parecia botão morto, com o servidor já gravado). Auditoria de
        //    07/set. O ouvinte se LIMPA sozinho quando o nó sai do DOM: estes nós são
        //    descartados a cada abertura da gaveta, e um `addEventListener` no `document`
        //    por nó descartado empilharia ouvintes para sempre.
        const sincroniza = (e) => {
            if (!b.isConnected) { document.removeEventListener('userPrefChanged', sincroniza); return; }
            if (e && e.detail && e.detail.pref === pref) pinta();
        };
        document.addEventListener('userPrefChanged', sincroniza);
        b.addEventListener('click', async () => {
            if (b.disabled) return;
            b.disabled = true;
            const alvo = um && um.getPref(pref) ? 0 : 1;
            let r = null;
            // `finally`: reabilita o botão em qualquer desfecho que ASSENTE (sucesso, recusa,
            // rejeição de rede). 🔴 Não cobre fetch PENDURADO (TCP morto não rejeita nem
            // resolve; `finally` só roda depois do `await` assentar). Sem timeout no
            // UserManager, o botão fica preso até o SO desistir do TCP; sair da tela (ou
            // fechar e reabrir a gaveta) o reconstrói. Dívida anotada, não resolvida.
            try {
                r = um && um.savePref ? await um.savePref(pref, alvo) : null;
            } finally {
                b.disabled = false;
            }
            // O efeito local do DESLIGAR (ex.: o diário apaga a fila que não subiu) — só
            // depois de o SERVIDOR confirmar.
            if (r && r.success && !alvo && afterOff) { try { afterOff(); } catch (e) {} }
            if (!r || !r.success) {
                // Sessão morta: o `handleSessionExpired` já avisou "Sessão expirada" — um 2º
                // toast mandando "recarregar" seria conselho errado.
                // `account_changed`: outra conta entrou com o pedido em voo — o controle já foi
                // redesenhado para ela; avisar a nova conta de um erro da anterior seria ruído.
                if (r && (r.error_code === 'session_expired' || r.error_code === 'not_logged' || r.error_code === 'account_changed')) return;
                window.notifications?.toast(AccountActions._t('auth.prefs.saveError',
                    'Não deu para confirmar se salvou. Recarregue o app para ver como está.'), { type: 'error' });
                return;   // não pinta: o estado da tela continua sendo o do servidor
            }
            pinta();
            // A explicação vai no toast, e não numa terceira linha da gaveta: ela é longa e
            // só interessa no instante da decisão.
            const frases = helpKeys.map(k => AccountActions._t(k, '')).filter(Boolean).join(' ');
            if (frases) window.notifications?.toast(frases, { type: 'info' });
            // 🔴 O evento publica o valor CONFIRMADO (o cache já absorveu a resposta), não o
            //    `alvo` pedido: o servidor pode devolver `success` com a preferência
            //    INALTERADA (patch descartado), e quem ouvir tem de ver o que vale, não o
            //    que se quis. Auditoria de 07/set.
            document.dispatchEvent(new CustomEvent('userPrefChanged',
                { detail: { pref, value: um && um.getPref ? um.getPref(pref) : alvo } }));
        });
        return b;
    }

    /** Diário de jogo — o GATE DE LGPD do `user_events` (a fila local morre no clique). */
    static diaryToggle() {
        return AccountActions.prefToggle({
            pref: 'analytics_enabled', ico: '📓', act: 'diary',
            labelKey: 'auth.prefs.diary', onKey: 'auth.prefs.on', offKey: 'auth.prefs.off',
            fallbacks: { label: 'Diário de jogo', on: 'Registrando', off: 'Desligado' },
            // 🔴 As DUAS frases sempre juntas: dizer o que o interruptor faz sem dizer que o
            //    funil anônimo NÃO depende dele deixa a pessoa achando que desligou uma coisa
            //    que não desligou.
            helpKeys: ['auth.prefs.help', 'auth.prefs.anon'],
            // 🔴 A FILA SE APAGA NO CLIQUE — não no próximo evento. A política promete, em 3
            //    idiomas, que ela some "na hora"; o `dropQueue` só roda dentro de
            //    `track`/`flush`, então quem desligava e fechava a aba deixava a fila no
            //    aparelho, e o boot seguinte podia POSTÁ-LA antes do `check_session`.
            afterOff: () => window.eventTracker?.dropQueue()
        });
    }

    /**
     * Aparecer no `#/ranking` (nome + foto numa página pública). Opt-out: é o que já estava
     * no ar e o que a política descreve — o que muda é existir a saída, e a tela DIZER que
     * ela existe. 🔴 O interruptor não é a trava: quem filtra é o SQL do `leaderboard`.
     */
    static rankingToggle() {
        return AccountActions.prefToggle({
            pref: 'ranking_visible', ico: '🏆', act: 'ranking',
            labelKey: 'profile.ranking.label', onKey: 'profile.ranking.on', offKey: 'profile.ranking.off',
            fallbacks: { label: 'Aparecer no ranking', on: 'Nome e foto visíveis', off: 'Fora da lista pública' },
            // A 2ª frase delimita o escopo, como a do diário: sair do ranking não apaga
            // placar nenhum, e o progresso continua sendo seu.
            helpKeys: ['profile.ranking.help', 'profile.ranking.scope']
        });
    }

    /** Sair: encerra a sessão no servidor e avisa. */
    static signOut() {
        window.userManager?.logoutServer();
        window.notifications?.toast(AccountActions._t('auth.toasts.signedOut', 'Você saiu.'), { type: 'info' });
    }

    /** Confirma a exclusão num modal do NotificationManager antes de apagar. */
    static confirmDelete() {
        const t = AccountActions._t;
        const um = window.userManager;
        if (!window.notifications) { um?.deleteAccount(); return; }
        window.notifications.modal({
            title: t('auth.deleteAccount', 'Apagar conta'),
            html: `<p style="text-align:center;color:var(--color-text-secondary,#475569);margin:0;">`
                + `${AccountActions._esc(t('auth.deleteConfirm', 'Apagar sua conta?'))}</p>`,
            actions: [
                {
                    label: t('auth.deleteAccount', 'Apagar conta'),
                    style: 'linear-gradient(135deg,#ef4444,#dc2626)',
                    onClick: async () => {
                        const r = await um?.deleteAccount();
                        const okDel = r && r.success;
                        window.notifications.toast(
                            okDel ? t('auth.toasts.accountDeleted', 'Conta apagada.') : t('auth.errors.generic', 'Erro.'),
                            { type: okDel ? 'success' : 'error' });
                    }
                },
                { label: t('common.close', 'Fechar'), style: 'neutral' }
            ]
        });
    }

    /**
     * Confirma o "Sair do grupo" (escola/turma) e executa. 🔴 O texto DIZ o que fica:
     * sair tira a linha do ranking do grupo e não apaga nada — e diz que dá para voltar
     * com o código. Vive aqui (não na tela) pela mesma razão do resto: se um dia a gaveta
     * ☰ ganhar a linha do grupo, ela reaproveita esta confirmação.
     * @param {{name?:string, onDone?:Function}} o
     */
    static confirmLeaveGroup({ name = '', onDone = null } = {}) {
        const t = AccountActions._t;
        const um = window.userManager;
        const executa = async () => {
            const r = await um?.leaveGroup();
            const okL = r && r.success;
            if (!okL && r && (r.code === 'session_expired' || r.code === 'not_logged')) return;
            window.notifications?.toast(
                okL ? t('profile.group.left', 'Você saiu do grupo.') : t('auth.errors.generic', 'Erro.'),
                { type: okL ? 'success' : 'error' });
            if (okL && typeof onDone === 'function') onDone(r);
        };
        if (!window.notifications) { executa(); return; }
        window.notifications.modal({
            title: t('profile.group.leaveTitle', 'Sair do grupo'),
            html: `<p style="text-align:center;color:var(--color-text-secondary,#475569);margin:0;line-height:1.5;">`
                + `${AccountActions._esc(t('profile.group.leaveBody', 'Sair do grupo?', { name }))}</p>`,
            actions: [
                { label: t('profile.group.leaveConfirm', 'Sair do grupo'), style: 'linear-gradient(135deg,#ef4444,#dc2626)', onClick: executa },
                { label: t('common.cancel', 'Cancelar'), style: 'neutral' }
            ]
        });
    }

    /**
     * Confirma o "Zerar progresso" e executa.
     *
     * 🔴 O TEXTO DIZ O QUE FICA, não só o que sai. Zerar apaga os placares (a trilha volta
     *    ao começo e a linha some do ranking) e NÃO apaga o diário de treino nem as músicas
     *    sincronizadas — é o que a política publicada promete, e é o que o `reset_progress`
     *    faz. Uma confirmação que só diz "não tem volta" faz a pessoa imaginar o resto.
     * @param {{scores?:number, onDone?:Function}} o `scores` = quantos placares existem hoje.
     */
    static confirmReset({ scores = null, onDone = null } = {}) {
        const t = AccountActions._t;
        const um = window.userManager;
        const executa = async () => {
            const r = await um?.resetProgress();
            const okR = r && r.success;
            window.notifications?.toast(
                okR ? t('profile.reset.done', 'Progresso zerado.') : t('auth.errors.generic', 'Erro.'),
                { type: okR ? 'success' : 'error' });
            if (okR && typeof onDone === 'function') onDone(r);
        };
        if (!window.notifications) { executa(); return; }
        const quantos = Number.isFinite(scores) && scores > 0
            ? `<p style="text-align:center;color:var(--color-text-secondary,#475569);margin:.6rem 0 0;font-size:.9rem;">`
              + AccountActions._esc(t('profile.reset.count', '', { n: scores })) + `</p>`
            : '';
        window.notifications.modal({
            title: t('profile.reset.title', 'Zerar progresso'),
            html: `<p style="text-align:center;color:var(--color-text-secondary,#475569);margin:0;line-height:1.5;">`
                + `${AccountActions._esc(t('profile.reset.body', 'Apaga os seus resultados.'))}</p>${quantos}`,
            actions: [
                { label: t('profile.reset.confirm', 'Zerar progresso'), style: 'linear-gradient(135deg,#ef4444,#dc2626)', onClick: executa },
                { label: t('common.cancel', 'Cancelar'), style: 'neutral' }
            ]
        });
    }
}

window.AccountActions = AccountActions;



// ============================================
// components/AppHeader.js
// ============================================
/**
 * AppHeader - Shell de navegação persistente do app (escalável p/ N jogos).
 *
 * DECISÃO DE ARQUITETURA (jun/2026): o header NÃO lista mais um <tab> por jogo.
 * Com 6-7 jogos no horizonte (+ login, configs, etc.), abas inline estouravam a
 * largura no celular (era o bug do "ES" vazando) e não escalavam. Agora o header
 * tem SEMPRE 2 controles fixos, independam de quantos jogos existam:
 *
 *   [ ⊞ Jogos ▾ ]   → switcher: abre um drawer com a grade de TODOS os jogos.
 *                      Quando dentro de um jogo, vira o CONTEXTO (ícone + nome do
 *                      jogo atual) — serve de "onde estou" + "trocar de jogo".
 *   [ ☰ ]           → menu: drawer com o secundário (Novidades, Idioma e, no
 *                      futuro, Entrar/Configurações). Tira o idioma da disputa de
 *                      espaço no header → conserta o overflow do "ES".
 *
 * Trocar de jogo fica a UM toque de QUALQUER tela (inclusive de dentro de um jogo),
 * porque o switcher é global. A grade vem de `Main.GAMES` (fonte única) → adicionar
 * um jogo continua sendo 1 linha lá, e ele aparece no switcher sem tocar em markup.
 *
 * O drawer integra com o histórico (pushState): o botão físico "voltar" do Android
 * e o Esc fecham o drawer em vez de sair do app — comportamento esperado de PWA.
 *
 * 🔴 O header é PERSISTENTE: BaseGameScreen NÃO o esconde ao entrar num jogo
 * (fora de LANDING_SELECTORS), então a navegação fica disponível o tempo todo.
 */
class AppHeader {
    constructor() {
        if (AppHeader.instance) return AppHeader.instance;
        this.isOpen = false;
        this.openKind = null;     // 'games' | 'menu'
        this._pushed = false;     // empilhamos um estado no history?
        this._activePath = null;  // rota atual (destaca o card do jogo no switcher)
        this._newsUnseen = false; // há novidade não vista? (ponto vermelho)
        this.langEl = null;       // <span.lang-switch> movido p/ dentro do menu
        AppHeader.instance = this;
    }

    /** Tradução com fallback explícito (nunca devolve a chave crua). */
    _t(key, fallback) {
        const v = window.language?.t(key);
        return (v && v !== key) ? v : fallback;
    }

    /** Rótulo do jogo: nav.<name> (curto) → games.<name>.name (longo) → name. */
    _label(name) {
        const short = this._t(`nav.${name}`, null);
        if (short) return short;
        return this._t(`games.${name}.name`, name);
    }

    // `Main` é binding lexical do bundle (mesmo script): lido em runtime, depois do parse,
    // sempre existe. Sem fallback — o antigo `window.main?.constructor` era inalcançável.
    _games() {
        return (typeof Main !== 'undefined' ? Main.GAMES : null) || {};
    }

    /** Telas do ☰ (Ajuda, Novidades, Ranking…): fonte única = Main.MENU, na ordem de lá. */
    _menu() {
        return (typeof Main !== 'undefined' ? Main.MENU : null) || {};
    }

    mount() {
        const header = document.querySelector('.header');
        const navEl = header?.querySelector('.nav');
        if (!navEl) return;                              // shell sem header (não deveria no /app/)
        if (header.dataset.appHeader === 'ready') return; // idempotente

        // Logo → home do app (SPA), não sai pro marketing.
        const logo = header.querySelector('.logo');
        if (logo) logo.setAttribute('href', '#/');

        // Gatilho "Jogos" (switcher + contexto do jogo atual).
        const games = document.createElement('button');
        games.type = 'button';
        games.className = 'nav-trigger nav-trigger-games';
        games.setAttribute('aria-haspopup', 'dialog');
        games.setAttribute('aria-expanded', 'false');
        games.innerHTML =
            `<span class="nav-trigger-icon" aria-hidden="true">⊞</span>` +
            `<span class="nav-trigger-label"></span>` +
            `<span class="nav-trigger-caret" aria-hidden="true">▾</span>`;
        games.addEventListener('click', () => this.toggle('games'));

        // Gatilho "Menu" (☰) — secundário. Ponto vermelho = novidade não vista.
        const menu = document.createElement('button');
        menu.type = 'button';
        menu.className = 'nav-trigger nav-trigger-menu';
        menu.setAttribute('aria-haspopup', 'dialog');
        menu.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-label', this._t('nav.menu', 'Menu'));
        // 🔴 A palavra "Menu" É IMPRESSA. O ☰ sozinho é o ícone menos reconhecível
        // do header para o público 60+, e a chave `nav.menu` já existia nos 3
        // idiomas — só nunca tinha sido escrita na tela.
        menu.innerHTML =
            `<span class="nav-hamburger" aria-hidden="true"><i></i><i></i><i></i></span>` +
            `<span class="nav-trigger-label nav-trigger-menu-label"></span>` +
            `<span class="nav-trigger-dot nav-news-badge" aria-hidden="true" style="display:none;"></span>`;
        menu.querySelector('.nav-trigger-menu-label').textContent = this._t('nav.menu', 'Menu');
        menu.addEventListener('click', () => this.toggle('menu'));

        // Gatilho "Conta" — deslogado abre o AuthModal ("Entrar"); logado vira avatar
        // + drawer de conta. Como o header é persistente, o login aparece em TODO jogo.
        const account = document.createElement('button');
        account.type = 'button';
        account.className = 'nav-trigger nav-trigger-account';
        account.setAttribute('aria-haspopup', 'dialog');
        account.setAttribute('aria-expanded', 'false');
        account.addEventListener('click', () => this._onAccountClick());

        this.gamesTrigger = games;
        this.menuTrigger = menu;
        this.accountTrigger = account;
        this.menuDot = menu.querySelector('.nav-trigger-dot');

        // Move o seletor de idioma existente (preserva os hrefs por domínio + o fix
        // do lab, que já rodou no parse) p/ dentro do drawer de menu.
        this.langEl = navEl.querySelector('.lang-switch');
        if (this.langEl) this.langEl.remove();

        navEl.appendChild(games);
        navEl.appendChild(menu);
        navEl.appendChild(account);

        this._buildOverlay();
        header.dataset.appHeader = 'ready';

        // Sincronização com o app.
        window.eventBus?.on('route:changed', ({ to }) => this._onRoute(to?.path));
        window.eventBus?.on('language:changed', () => {
            this._relabel();
            if (this.isOpen) this._render(this.openKind);
        });
        window.eventBus?.on('news:seen', () => this._setNewsBadge(false));
        window.addEventListener('popstate', () => this._onPop());
        window.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.isOpen) this.dismiss(); });

        // Estado de conta: o UserManager dispara 'userStateChanged' (login/logout) e
        // 'sessionExpired'. O header reflete no gatilho (avatar ↔ "Entrar") e, se o
        // drawer de conta estiver aberto, re-renderiza.
        document.addEventListener('userStateChanged', () => {
            this._refreshAccount();
            if (this.isOpen && this.openKind === 'account') {
                if (window.userManager?.isLoggedIn()) this._renderAccount();
                else this.dismiss();   // deslogou com o drawer aberto → fecha
            }
        });
        document.addEventListener('sessionExpired', () => {
            this._refreshAccount();
            window.notifications?.toast(this._t('auth.toasts.sessionExpired', 'Sessão expirada.'), { type: 'info' });
        });
        // Progresso da conta devolvido pelo servidor (RankingRepository.restoreMine) —
        // avisado AQUI, num ponto só, porque vale pra qualquer jogo ranqueado: o header
        // está sempre montado e jogo novo não precisa reimplementar o aviso. Cada jogo só
        // cuida de se redesenhar (o mesmo evento).
        document.addEventListener('progressRestored', () => {
            window.notifications?.toast(
                this._t('auth.toasts.progressRestored', 'Progresso da sua conta recuperado.'),
                { type: 'success', duration: 3600 }
            );
        });

        this._onRoute(window.router?.getCurrentPath?.());
        this._refreshNewsBadge();
        this._refreshAccount();
    }

    /** Drawer reutilizado pelos dois gatilhos (conteúdo trocado por _render). */
    _buildOverlay() {
        const ov = document.createElement('div');
        ov.className = 'nav-overlay';
        ov.innerHTML =
            `<div class="nav-drawer" role="dialog" aria-modal="true" tabindex="-1">` +
            `<div class="nav-drawer-head">` +
            `<h2 class="nav-drawer-title"></h2>` +
            `<button type="button" class="nav-drawer-close" aria-label="${this._t('menu.close', 'Fechar')}">✕</button>` +
            `</div>` +
            `<div class="nav-drawer-body"></div>` +
            `</div>`;
        ov.addEventListener('click', (e) => { if (e.target === ov) this.dismiss(); });
        ov.querySelector('.nav-drawer-close').addEventListener('click', () => this.dismiss());

        document.body.appendChild(ov);
        this.overlay = ov;
        this.drawer = ov.querySelector('.nav-drawer');
        this.drawerTitle = ov.querySelector('.nav-drawer-title');
        this.drawerBody = ov.querySelector('.nav-drawer-body');
    }

    // ----- conteúdo dos drawers -------------------------------------------------

    _render(kind) {
        this.openKind = kind;
        if (kind === 'games') {
            this.drawerTitle.textContent = this._t('menu.switchTitle', 'Trocar de jogo');
            this._renderGames();
        } else if (kind === 'account') {
            this.drawerTitle.textContent = this._t('auth.accountTitle', 'Conta');
            this._renderAccount();
        } else {
            this.drawerTitle.textContent = this._t('nav.menu', 'Menu');
            this._renderMenu();
        }
    }

    _renderGames() {
        const body = this.drawerBody;
        body.innerHTML = '';
        const grid = document.createElement('div');
        grid.className = 'nav-switch-grid';
        Object.entries(this._games()).forEach(([path, def]) => {
            const a = document.createElement('a');
            a.className = 'nav-switch-card' + (path === this._activePath ? ' is-active' : '');
            a.href = '#' + path;
            a.dataset.route = path;
            a.innerHTML =
                `<span class="nav-switch-icon" aria-hidden="true">${def.icon || '🎮'}</span>` +
                `<span class="nav-switch-name">${this._label(def.name)}</span>`;
            a.addEventListener('click', () => this._hideForNav());
            grid.appendChild(a);
        });
        body.appendChild(grid);
    }

    _renderMenu() {
        const body = this.drawerBody;
        body.innerHTML = '';

        const list = document.createElement('div');
        list.className = 'nav-menu-list';

        // Um item por linha de Main.MENU, na ordem de lá (Ajuda PRIMEIRO: quem abre o ☰
        // perdido não deve passar por Novidades e Ranking antes de achar a ajuda).
        // 🔴 Música de Verdade NÃO entra aqui: é JOGO, e jogo mora no switcher ⊞
        // (Main.GAMES). Ele morou neste menu enquanto era rota avulsa, e o resultado foi
        // um jogo arquivado junto de Novidades/Ranking — as telas que não são jogo.
        // Este drawer é só para o que NÃO é jogo.
        Object.entries(this._menu()).forEach(([path, def]) => {
            const a = document.createElement('a');
            a.className = 'nav-menu-item' + (def.cls ? ' ' + def.cls : '');
            a.href = '#' + path;
            a.dataset.route = path;
            const sub = def.subKey ? `<span class="nav-menu-sub">${this._t(def.subKey, '')}</span>` : '';
            // Ponto de "não visto" (só Novidades hoje): o estado vive em _newsUnseen.
            const dot = def.badge === 'news'
                ? `<span class="nav-menu-dot" aria-hidden="true" style="display:${this._newsUnseen ? 'inline-block' : 'none'};"></span>`
                : '';
            a.innerHTML =
                `<span class="nav-menu-ico" aria-hidden="true">${def.icon || '•'}</span>` +
                `<span class="nav-menu-label">${this._label(def.name)}${sub}</span>` +
                dot;
            a.addEventListener('click', () => this._hideForNav());
            list.appendChild(a);
        });

        body.appendChild(list);

        // Idioma — reaproveita o <span.lang-switch> movido (hrefs por domínio intactos).
        if (this.langEl) {
            const sec = document.createElement('div');
            sec.className = 'nav-menu-section';
            const label = document.createElement('div');
            label.className = 'nav-menu-section-label';
            label.textContent = this._t('langSwitch.label', 'Idioma');
            sec.appendChild(label);
            sec.appendChild(this.langEl);
            body.appendChild(sec);
        }

        // 🔮 Futuro: novas seções (Entrar / Configurações da conta) entram AQUI,
        // sem mexer no header — é só append de mais um bloco neste drawer.
    }

    // ----- abrir / fechar (com integração ao histórico) -------------------------

    toggle(kind) {
        if (this.isOpen && this.openKind === kind) this.dismiss();
        else this.open(kind);
    }

    open(kind) {
        this._render(kind);
        this.gamesTrigger.setAttribute('aria-expanded', String(kind === 'games'));
        this.menuTrigger.setAttribute('aria-expanded', String(kind === 'menu'));
        this.accountTrigger?.setAttribute('aria-expanded', String(kind === 'account'));
        if (this.isOpen) return; // já aberto: só trocou o conteúdo, não re-empilha
        this.isOpen = true;
        this.overlay.classList.add('is-open');
        document.body.classList.add('nav-drawer-open');
        // Empilha um estado p/ o "voltar" do Android / gesto fechar o drawer.
        try { history.pushState({ navDrawer: true }, ''); this._pushed = true; } catch (_) { }
        this.drawer.focus?.();
    }

    /** Fechar por ✕ / backdrop / Esc: desfaz o estado empilhado (history.back). */
    dismiss() {
        if (!this.isOpen) return;
        if (this._pushed) { this._pushed = false; history.back(); } // popstate → _onPop fecha de fato
        else this._close();
    }

    /** Fechar ao navegar (clique num card/link): deixa o hashchange criar a entrada nova. */
    _hideForNav() {
        if (!this.isOpen) return;
        this._pushed = false;
        this._close();
    }

    _onPop() {
        if (this.isOpen) { this._pushed = false; this._close(); }
    }

    _close() {
        this.isOpen = false;
        this.overlay.classList.remove('is-open');
        document.body.classList.remove('nav-drawer-open');
        this.gamesTrigger.setAttribute('aria-expanded', 'false');
        this.menuTrigger.setAttribute('aria-expanded', 'false');
        this.accountTrigger?.setAttribute('aria-expanded', 'false');
    }

    // ----- estado (rota ativa / idioma / badge) ---------------------------------

    /**
     * Atualiza o gatilho "Jogos": dentro de um jogo vira CONTEXTO (ícone + nome).
     * Sub-rotas avulsas (fora de Main.GAMES) herdam o jogo-PAI via SUBROUTE_PARENT
     * — ex.: #/ritmo-livre mostra o contexto "Ritmo" e destaca o card Ritmo no
     * switcher (a barra "← Níveis" já dá a saída específica do modo livre).
     */
    _onRoute(path) {
        if (!this.gamesTrigger) { this._activePath = path; return; }
        const G = this._games();
        let def = G[path];
        let highlight = path;
        if (!def) {
            const parent = AppHeader.SUBROUTE_PARENT[path];
            if (parent && G[parent]) { def = G[parent]; highlight = parent; }
        }
        this._activePath = highlight; // o switcher destaca o jogo (ou o jogo-pai)
        const icon = this.gamesTrigger.querySelector('.nav-trigger-icon');
        const label = this.gamesTrigger.querySelector('.nav-trigger-label');
        if (def) {
            icon.textContent = def.icon || '🎮';
            label.textContent = this._label(def.name);
            this.gamesTrigger.classList.add('is-context');
        } else {
            icon.textContent = '⊞';
            label.textContent = this._t('nav.games', 'Jogos');
            this.gamesTrigger.classList.remove('is-context');
        }
        if (this.isOpen && this.openKind === 'games') this._renderGames(); // re-destaca o card ativo
    }

    /** Re-rotula tudo após troca de idioma in-app (futuro toggle). */
    _relabel() {
        this._onRoute(this._activePath);
        // A palavra do ☰ também é traduzida — o drawer inteiro troca de idioma,
        // e o gatilho ficaria em PT no meio de uma tela em ES.
        const menuLabel = this.menuTrigger?.querySelector('.nav-trigger-menu-label');
        if (menuLabel) {
            menuLabel.textContent = this._t('nav.menu', 'Menu');
            this.menuTrigger.setAttribute('aria-label', this._t('nav.menu', 'Menu'));
        }
    }

    /** Mostra o "•novo" se há entrada do changelog mais recente que a última vista. */
    async _refreshNewsBadge() {
        try {
            const res = await fetch('/changelog.json', { cache: 'no-cache' });
            if (!res.ok) return;
            const data = await res.json();
            const newest = data && data.entries && data.entries[0] && data.entries[0].date;
            if (!newest) return;
            const seen = localStorage.getItem('news_last_seen');
            this._setNewsBadge(!seen || seen < newest); // datas ISO comparam lexicograficamente
        } catch (_) { /* badge é enfeite: nunca pode quebrar o header */ }
    }

    _setNewsBadge(on) {
        this._newsUnseen = !!on;
        if (this.menuDot) this.menuDot.style.display = on ? 'inline-block' : 'none';
        const item = this.drawerBody?.querySelector('.nav-menu-dot');
        if (item) item.style.display = on ? 'inline-block' : 'none';
    }

    // ----- conta (login / avatar / drawer) --------------------------------------

    _esc(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    /** Clique no gatilho: deslogado → AuthModal; logado → drawer de conta. */
    _onAccountClick() {
        if (window.userManager?.isLoggedIn()) this.toggle('account');
        else window.authModal?.open('signin');
    }

    /** Atualiza a aparência do gatilho: avatar (logado) ↔ "Entrar" (deslogado). */
    _refreshAccount() {
        const t = this.accountTrigger;
        if (!t) return;
        const um = window.userManager;
        const loggedIn = !!(um && um.isLoggedIn());
        t.innerHTML = '';
        if (loggedIn) {
            t.classList.add('is-logged');
            t.setAttribute('aria-label', this._t('auth.accountTitle', 'Conta'));
            if (window.UserAvatar) t.appendChild(window.UserAvatar.el(um.getUser(), 30));
        } else {
            t.classList.remove('is-logged');
            const label = this._t('auth.signInCta', 'Entrar');
            t.setAttribute('aria-label', label);
            t.innerHTML = `<span class="nav-trigger-icon" aria-hidden="true">👤</span>`
                + `<span class="nav-trigger-label nav-account-label">${this._esc(label)}</span>`;
        }
    }

    _renderAccount() {
        const body = this.drawerBody;
        body.innerHTML = '';
        const um = window.userManager;
        if (!um || !um.isLoggedIn()) { this.dismiss(); return; }

        const head = document.createElement('div');
        head.className = 'nav-account-head';
        if (window.UserAvatar) head.appendChild(window.UserAvatar.el(um.getUser(), 46));
        const info = document.createElement('div');
        info.className = 'nav-account-info';
        info.innerHTML = `<div class="nav-account-name">${this._esc(um.getUserName())}</div>`
            + `<div class="nav-account-email">${this._esc(um.getUserEmail() || '')}</div>`;
        head.appendChild(info);
        body.appendChild(head);

        const list = document.createElement('div');
        list.className = 'nav-menu-list';
        // E-mail NÃO confirmado (só conta local; a social já nasce confirmada): o único
        // lugar do app que oferece o reenvio — o endpoint `resend_verification` existia
        // sem nenhum botão. Só com `0` explícito do check_session: `undefined` (login
        // local, que não devolve o campo) NÃO mostra — não se acusa o que não se sabe.
        const u = um.getUser() || {};
        if (String(u.email_verified) === '0' && um.getUserEmail()) {
            const rv = window.AccountActions.row({
                ico: '✉️', act: 'verify',
                label: this._t('auth.resendVerification', 'Confirmar e-mail (reenviar link)'),
                onClick: () => this._resendVerification()
            });
            rv.classList.add('nav-account-verify');
            list.appendChild(rv);
        }
        // 👤 A PORTA do painel "Minha conta" (#/perfil). A gaveta é acesso rápido de dentro
        // do jogo; o painel é onde se OLHA e se EDITA o cadastro. Vem primeiro porque é a
        // única linha daqui que leva a algum lugar — as outras agem na hora.
        list.appendChild(window.AccountActions.row({
            ico: '👤', act: 'profile',
            label: this._t('nav.profile', 'Minha conta'),
            onClick: () => { this._hideForNav(); window.location.hash = '#/perfil'; }
        }));
        // 📓 Diário de jogo — o GATE DE LGPD (users.data → analytics_enabled). Fica ANTES de
        // "Sair"/"Apagar conta" porque é ajuste, não saída. 🔴 A MESMA linha (mesmo código,
        // mesmo nó) que o painel usa: ver o cabeçalho de AccountActions.
        list.appendChild(window.AccountActions.diaryToggle());
        list.appendChild(window.AccountActions.row({
            ico: '🚪', act: 'signout', label: this._t('auth.signOut', 'Sair'),
            onClick: () => { this.dismiss(); window.AccountActions.signOut(); }
        }));
        list.appendChild(window.AccountActions.row({
            ico: '🗑️', act: 'delete', danger: true, label: this._t('auth.deleteAccount', 'Apagar conta'),
            onClick: () => { this.dismiss(); window.AccountActions.confirmDelete(); }
        }));
        body.appendChild(list);
    }

    // 🔴 O interruptor do diário, a linha de ação e o modal de "Apagar conta" MUDARAM DE
    // CASA (07/set) para `components/AccountActions.js`: eles existem também no painel
    // "Minha conta" (#/perfil) e duas cópias divergiriam na primeira correção — justo num
    // controle que promete "não estou gravando". Aqui ficou só quem é do HEADER.

    async _resendVerification() {
        const um = window.userManager;
        this.dismiss();
        const r = um && um.resendVerification ? await um.resendVerification(um.getUserEmail()) : null;
        const okk = !!(r && r.success);
        window.notifications?.toast(
            this._t(okk ? 'auth.toasts.verifySent' : 'auth.errors.' + ((r && r.code) || 'generic'), ''),
            { type: okk ? 'success' : 'error' });
    }

}

// Rotas avulsas (fora de Main.GAMES) que pertencem a um jogo-pai, p/ o contexto do
// header. Adicionar um modo/variante futura (ex.: outro jogo livre) é 1 linha aqui.
AppHeader.SUBROUTE_PARENT = {
    '/ritmo-livre': '/ritmo',
    '/leitura-livre': '/leitura',
    '/intervalos-livre': '/intervalos',
    '/acordes-livre': '/acordes',
    '/musicas-livre': '/musicas'
    // 🔴 Sandbox novo entra aqui: sem a linha, o `-livre` perde o contexto no gatilho ⊞ e
    // o card do jogo-pai não acende.
};

// Singleton global (mount() é chamado por Main.init()).
window.AppHeader = AppHeader;
window.appHeader = new AppHeader();



// ============================================
// core/Main.js
// ============================================
/**
 * Main - Orquestrador principal da aplicação
 * Inicializa todos os sistemas e gerencia o ciclo de vida
 */
class Main {
    constructor() {
        if (Main.instance) {
            return Main.instance;
        }

        this.initialized = false;
        this.version = '1.0.0';

        Main.instance = this;
    }

    /**
     * Inicializa a aplicação
     */
    async init() {
        if (this.initialized) {
            console.warn('Main: Aplicação já inicializada');
            return;
        }

        console.log('🎵 Aula de Música - Iniciando...');

        try {
            // 1. Inicializa singletons globais (já criados nos arquivos)
            // window.eventBus, window.domManager, window.language, window.router

            // 2. Registra rotas
            this.setupRoutes();

            // 3. Configura eventos globais
            this.setupGlobalEvents();

            // 4. Monta o header de navegação persistente (tabs de jogo a partir de GAMES)
            window.appHeader?.mount();

            // 5. Inicializa o router
            window.router.init();

            // 6. Marcadores de e-mail no link (?verified= / ?reset_token=): toast de
            //    verificação e abertura do AuthModal no modo reset. Depois do header/
            //    router pra que notifications/authModal já existam.
            this._handleEmailNotices();

            this.initialized = true;
            console.log('✅ Aplicação inicializada com sucesso!');

            // Emite evento de inicialização
            window.eventBus.emit('app:initialized');

        } catch (error) {
            console.error('❌ Erro ao inicializar aplicação:', error);
            throw error;
        } finally {
            // 7. Remove o preloader do shell (diapasão first-paint em app/index.html).
            //    No finally de propósito: se um passo do init lançar, revela o shell na
            //    hora em vez de deixar o usuário 6s atrás do overlay. O timeout inline
            //    do shell segue como seguro pro caso "app.js nem carregou".
            this._dismissPreloader();
        }
    }

    /**
     * O ÚNICO reload do app: é a pessoa, no botão do toast de versão nova.
     * Despacha `appUpdateApply` (cancelável): o shell (app.template.html) o captura, promove o
     * SW em espera com `SKIP_WAITING` e recarrega quando ele assume — desde 16/set o
     * `app/sw.js` não se promove sozinho no install (o iOS matava o SW velho com o app.js
     * em voo). Sem shell ouvindo (harness de teste, página avulsa), recarrega direto.
     */
    _reloadApp() {
        const ev = new CustomEvent('appUpdateApply', { cancelable: true });
        const handled = !document.dispatchEvent(ev); // false = alguém fez preventDefault
        if (!handled) window.location.reload();
    }

    /**
     * Esmaece e remove o preloader do shell (#app-preloader em app.template.html).
     * Idempotente: nada acontece se já removido (ex.: timeout de segurança passou antes).
     */
    _dismissPreloader() {
        const el = document.getElementById('app-preloader');
        if (!el) return;
        el.classList.add('app-preloader-done');
        setTimeout(() => el.remove(), 400);
    }

    /**
     * Consome ?verified= / ?reset_token= do link do e-mail (via UserManager.takeAuthNotice,
     * que limpa a URL) e reage na UI: toast de verificação; abre o AuthModal no modo reset.
     */
    _handleEmailNotices() {
        try {
            const um = window.userManager;
            if (!um || typeof um.takeAuthNotice !== 'function') return;
            const notice = um.takeAuthNotice();
            const t = (k, fb) => (window.language ? window.language.t(k) : fb) || fb;

            if (notice.verified === '1') {
                window.notifications?.toast(t('auth.toasts.emailVerified', 'E-mail verificado!'), { type: 'success' });
            } else if (notice.verified === 'rate') {
                window.notifications?.toast(t('auth.toasts.verifyRate', 'Muitas tentativas. Abra o link de novo em alguns minutos.'), { type: 'info' });
            } else if (notice.verified === '0') {
                window.notifications?.toast(t('auth.toasts.verifyFailed', 'Link inválido ou expirado.'), { type: 'error' });
            }

            // INT-1: retorno de OAuth com falha (?auth_error=) → toast localizado. Sem isto o
            // erro era silencioso (evento sem ouvinte). Códigos vêm do handler.php (oauth_callback).
            if (notice.authError) {
                // hasOwnProperty: notice.authError vem cru da URL — evita resolver p/ membro
                // herdado do Object.prototype (ex.: ?auth_error=constructor) e toast feio.
                const key = Object.prototype.hasOwnProperty.call(Main.OAUTH_ERROR_KEYS, notice.authError)
                    ? Main.OAUTH_ERROR_KEYS[notice.authError] : 'oauth_failed';
                window.notifications?.toast(
                    t('auth.errors.' + key, t('auth.errors.generic', 'Algo deu errado. Tente de novo.')),
                    { type: 'error' }
                );
            }

            if (notice.resetToken) {
                if (window.authModal) window.authModal.open('reset', { token: notice.resetToken });
                else document.dispatchEvent(new CustomEvent('open-auth-modal', { detail: { mode: 'reset', token: notice.resetToken } }));
            }
        } catch (e) { /* boot nunca quebra por causa de notice */ }
    }

    /**
     * O vínculo Google APAGOU a senha da conta local (e-mail nunca confirmado → anti
     * pre-hijacking no SocialLogin.php). A regra é certa; o defeito era o silêncio: sem
     * isto a próxima tentativa de senha virava um "esta conta usa login social" sem
     * explicação. É MODAL, não toast — é uma frase que a pessoa tem de LER, e o toast
     * some em 2,6 s. O e-mail `password_removed` é o registro durável; isto é o aviso.
     * "Definir nova senha" reaproveita o "esqueci a senha" (que devolve a conta a
     * híbrida). Chega pelo evento 'authNotice' (UserManager._fetchCheckSession), DEPOIS
     * do setUser com o mesmo payload — o e-mail é o da conta certa, não o de uma sessão
     * velha do localStorage. `queue`+`sticky`: espera o modal que estiver aberto (tutorial)
     * e não é derrubado por quem chegar depois.
     */
    _noticePasswordCleared() {
        const t = (k, fb) => (window.language ? window.language.t(k) : fb) || fb;
        const nm = window.notifications;
        if (!nm || typeof nm.modal !== 'function') return;
        const setPassword = async () => {
            const um = window.userManager;
            const email = um && um.getUserEmail && um.getUserEmail();
            if (email && um.requestPasswordReset) {
                const r = await um.requestPasswordReset(email);
                // Não o "se o e-mail existir" do fluxo anônimo: aqui o app SABE que a conta
                // existe (a pessoa acabou de entrar nela).
                nm.toast(t(r && r.success ? 'auth.linked.resetSent' : 'auth.errors.generic', ''),
                         { type: r && r.success ? 'success' : 'error', duration: 4200 });
            } else if (window.authModal) {
                window.authModal.open('forgot');
            }
        };
        nm.modal({
            title: t('auth.linked.title', 'Sua conta agora entra pelo Google'),
            html: `<p>${t('auth.linked.body', '')}</p>`,
            actions: [
                { label: t('auth.linked.ok', 'Entendi'), style: 'primary' },
                { label: t('auth.linked.setPassword', 'Definir nova senha'), style: 'neutral', onClick: setPassword },
            ],
            queue: true, sticky: true,
        });
    }

    // INT-1: códigos de erro OAuth (handler.php oauth_callback) → chave em auth.errors.
    // Desconhecido cai em 'oauth_failed'; server_error reusa o 'generic' existente.
    static OAUTH_ERROR_KEYS = {
        oauth_cancelled:      'oauth_cancelled',
        invalid_state:        'oauth_invalid_state',
        local_account_exists: 'oauth_account_exists',
        oauth_error:          'oauth_failed',
        rate_limited:         'rate_limited',   // oauth_start estourou o limite (string já existe)
        server_error:         'generic',
    };

    /**
     * Tabela de jogos. Adicionar um jogo novo é UMA linha aqui (+ criar a
     * <Nome>Screen que estende BaseGameScreen). A rota, o título e o wrapper
     * de instanciação saem daqui automaticamente.
     */
    static GAMES = {
        '/ritmo':      { name: 'rhythm',       title: 'Jogo de Ritmo',    screen: 'RhythmGameScreen',  icon: '🥁' },
        '/leitura':    { name: 'staffReading', title: 'Leitura de Pauta', screen: 'ReadingFlowScreen', icon: '🎼' },
        '/intervalos': { name: 'intervals',    title: 'Intervalos',       screen: 'IntervalGameScreen', icon: '🎹' },
        '/acordes':    { name: 'chords',       title: 'Acordes',          screen: 'ChordGameScreen',   icon: '🎸' },
        // Música de Verdade — 5º jogo. Estava FORA daqui (rota avulsa) enquanto o catálogo
        // tinha uma peça só, e o preço foi alto: ele aparecia como card de jogo na landing e
        // na home do /app/, mas dentro do app morava no ☰ junto de Novidades/Ranking — as
        // telas que NÃO são jogo. Como o ⊞ é o único jeito de trocar de jogo no meio da
        // sessão, era o único jogo do qual não se voltava. Estar aqui dá rota + ladrilho no
        // ⊞ e MAIS NADA: ranking vem de `LevelProgress.register()`, que este jogo não chama.
        '/musicas':    { name: 'songs',        title: 'Música de Verdade', screen: 'SongScreen',       icon: '🎵' }
        // 🔴 O 6º jogo (Escalas) foi RETIRADO em 09/set — decisão do Bernardo: amadurecer a
        // ideia antes de publicar. Nada foi deployado. Código e strings em
        // docs/escalas-arquivo/, plano em docs/ESCALAS-PLANO.md. Jogo novo entra AQUI e em
        // Beacon.GAME_ROUTES — as duas linhas, sempre.
    };

    /**
     * Tabela das telas do ☰ — irmã de GAMES, para o que NÃO é jogo. Uma linha aqui
     * = rota registrada (mesmo wrapper das GAMES) + item no drawer do AppHeader, na
     * ORDEM de inserção. A tela estende BaseScreen (load/render), nunca BaseGameScreen.
     *   titleKey → título da rota/aba · subKey → sub-rótulo no item · badge:'news' →
     *   ponto vermelho de "não visto" · cls → classe extra no item.
     * 🔴 Ajuda vem PRIMEIRO: quem abre o ☰ perdido não deve passar por Novidades e
     *    Ranking antes de achar a ajuda.
     * 🔴 Nada daqui entra em Beacon.GAME_ROUTES (o ⊞ é o switcher de JOGO; help-test,
     *    news-test e beacon-test guardam os dois lados).
     */
    static MENU = {
        '/ajuda':     { name: 'help',    screen: 'HelpScreen',    icon: '❓', titleKey: 'help.title', subKey: 'help.sub', cls: 'nav-menu-item--help' },
        // 📈 Meu progresso (item 5 do §4 do mapa de plataforma): a primeira coisa que a
        // conta devolve para a pessoa VER. Lê `my_stats`; sem conta, convida a entrar.
        '/progresso': { name: 'progress', screen: 'StatsScreen',   icon: '📈', titleKey: 'stats.title' },
        // 👤 "Minha conta" (itens 2 e 3 do §4 do mapa): o cadastro que a pessoa vê e edita,
        // e os ajustes num lugar só. Fica ao lado de "Meu progresso" — as duas são "minhas".
        // A gaveta de conta (avatar → ☰ de conta) também aponta para cá, e isso não é item
        // escrito à mão: lá é a gaveta DE CONTA, não o menu do Main.MENU.
        '/perfil':    { name: 'profile',  screen: 'ProfileScreen', icon: '👤', titleKey: 'profile.title' },
        '/novidades': { name: 'news',    screen: 'NewsScreen',    icon: '📰', titleKey: 'news.title', badge: 'news' },
        '/ranking':   { name: 'ranking', screen: 'RankingScreen', icon: '🏆', titleKey: 'ranking.title' },
        // 📄 Institucionais (pacote B, item 14). Vêm por ÚLTIMO e levam `--legal`, que o
        // CSS usa para separá-las visualmente do resto: são o rodapé do menu, não opções
        // de uso. A prosa NÃO mora no bundle — as três telas buscam `/legal.json`
        // (mesmo padrão do changelog.json), e cada uma tem página estática irmã na raiz
        // (build-landing.js → LEGAL_PAGES), que é o endereço que o consent do Google pede.
        '/privacidade': { name: 'privacy', screen: 'PrivacyScreen', icon: '🔒', titleKey: 'legal.privacy.title', cls: 'nav-menu-item--legal' },
        '/termos':      { name: 'terms',   screen: 'TermsScreen',   icon: '📄', titleKey: 'legal.terms.title',   cls: 'nav-menu-item--legal' },
        '/contato':     { name: 'contact', screen: 'ContactScreen', icon: '✉️', titleKey: 'legal.contact.title', cls: 'nav-menu-item--legal' }
    };

    /**
     * Configura as rotas da aplicação
     */
    setupRoutes() {
        const routes = {
            '/': {
                name: 'home',
                title: 'Aula de Música',
                handler: () => {
                    // Landing page já está renderizada estaticamente
                    // Apenas atualiza título
                    document.title = window.language.t('app.name') + ' - ' + window.language.t('app.tagline');
                    return null;
                }
            },
            // Ritmo Livre — sandbox personalizado. Rota AVULSA (fora de Main.GAMES →
            // não vira tab no header); só acessível pelo link "⚙️ Modo livre" dentro
            // do ranqueado. Mesmo wrapper das telas de jogo (BaseGameScreen).
            '/ritmo-livre': {
                name: 'rhythmFree',
                title: window.language.t('rhythm.freeTitle'),
                handler: async (params) => {
                    const screen = new window.RhythmFreeScreen();
                    await screen.init(params);
                    return screen;
                }
            },
            // Intervalos "treino livre" — sandbox personalizado. Rota AVULSA (fora de
            // Main.GAMES → não vira tab); achada pelo link "⚙️ Modo livre" no ranqueado.
            // Espelha o split do Ritmo (#/intervalos ranqueado ↔ #/intervalos-livre sandbox).
            '/intervalos-livre': {
                name: 'intervalsFree',
                title: window.language.t('intervals.freeTitle'),
                handler: async (params) => {
                    const screen = new window.IntervalFreeScreen();
                    await screen.init(params);
                    return screen;
                }
            },
            // Acordes "modo livre" — sandbox personalizado. Rota AVULSA (fora de Main.GAMES
            // → não vira tab); achada pelo link "⚙️ Modo livre" no ranqueado. Espelha o split
            // do Ritmo/Intervalos (#/acordes ranqueado ↔ #/acordes-livre sandbox).
            '/acordes-livre': {
                name: 'chordsFree',
                title: window.language.t('chords.freeTitle'),
                handler: async (params) => {
                    const screen = new window.ChordFreeScreen();
                    await screen.init(params);
                    return screen;
                }
            },
            // Leitura "treino livre" — o jogo de 1 nota (turn-based) virou o IRMÃO da esteira,
            // espelhando o split do Ritmo (#/ritmo ranqueado ↔ #/ritmo-livre sandbox). A esteira
            // é o headline de #/leitura (Main.GAMES); este é a rota AVULSA, achada pelo link
            // "✏️ Treino livre" dentro da esteira (fora de Main.GAMES → não vira tab).
            '/leitura-livre': {
                name: 'staffReadingFree',
                title: window.language.t('staffReading.title'),
                handler: async (params) => {
                    const screen = new window.StaffReadingScreen();
                    await screen.init(params);
                    return screen;
                }
            },
            // Música de Verdade com o arquivo DO ALUNO (importar .mid). Rota AVULSA (fora
            // de Main.GAMES → não vira ladrilho no ⊞); achada pelo botão "🎼 Importar MIDI"
            // dentro de #/musicas. Espelha o split ranqueado ↔ livre dos outros jogos.
            '/musicas-livre': {
                name: 'songsFree',
                title: window.language.t('song.import.title'),
                handler: async (params) => {
                    const screen = new window.SongFreeScreen();
                    await screen.init(params);
                    return screen;
                }
            },
            // A PÁGINA de um grupo (escola/turma) e o PEDIDO de criação (`:id` = 'novo').
            // Rota AVULSA (autonomia de grupos, 15/set; docs/GRUPOS-AUTONOMIA-PLANO.md): não
            // é item do ☰ (fora de Main.MENU) nem jogo (fora de GAMES/GAME_ROUTES). Chega-se
            // pelo cartão "Grupo" em #/perfil e pelo LINK DE CONVITE `#/grupo/7?join=CÓDIGO`.
            // TRILHA DO PROFESSOR — a CAPA (#/trilha/CÓDIGO) e o EDITOR (#/trilha/CÓDIGO?edit=1).
            // Rota AVULSA (docs/LISTAS-PLANO.md, 17/set): não é jogo (fora de GAMES/GAME_ROUTES) nem
            // item do ☰ (fora de MENU). Chega-se pelo LINK que o professor manda, pelo cartão "Minhas
            // trilhas" em #/perfil e pelo "← ⟨trilha⟩" de dentro do jogo. Jogar = #/ritmo-livre?lista=.
            '/trilha/:code': {
                name: 'trail',
                title: window.language.t('trail.title'),
                handler: async (params) => {
                    const screen = new window.TrailScreen();
                    await screen.init(params);
                    return screen;
                }
            },
            '/grupo/:id': {
                name: 'group',
                title: window.language.t('group.title'),
                handler: async (params) => {
                    const screen = new window.GroupScreen();
                    await screen.init(params);
                    return screen;
                }
            },
            // Alias legado: a esteira morava aqui durante o beta. Redireciona p/ o novo headline.
            '/leitura-fluxo': {
                name: 'readingFlowLegacy',
                title: window.language.t('readingFlow.title'),
                handler: () => { window.location.hash = '#/leitura'; return null; }
            },
        };

        // Wrapper único de instanciação: jogo (GAMES) e tela do ☰ (MENU) nascem iguais —
        // `new window[screen]().init(params)`; o que muda é só a tabela de origem.
        const screenHandler = (def) => async (params) => {
            const ScreenClass = window[def.screen];
            if (!ScreenClass) {
                console.warn(`${def.screen} não encontrada`);
                return null;
            }
            const screen = new ScreenClass();
            await screen.init(params);
            return screen;
        };

        // Gera as rotas de jogo a partir da tabela GAMES.
        Object.entries(Main.GAMES).forEach(([path, def]) => {
            routes[path] = { name: def.name, title: def.title, handler: screenHandler(def) };
        });
        // Gera as rotas do ☰ (Ajuda, Novidades, Ranking) a partir da tabela MENU — telas
        // que NÃO são jogo, por isso fora de GAMES (e de Beacon.GAME_ROUTES).
        Object.entries(Main.MENU).forEach(([path, def]) => {
            routes[path] = { name: def.name, title: window.language.t(def.titleKey), handler: screenHandler(def) };
        });

        window.router.registerAll(routes);

        // Hook para atualizar título. 🔴 A TELA manda quando sabe o próprio título
        // (BaseScreen.getTitle() não-vazio, ex.: "Ranking · Ritmo"): este hook roda DEPOIS
        // do handler e sobrescrevia o refinamento dela — três escritores de document.title
        // e o da tela era o que perdia. Jogos (sem TITLE_KEY → getTitle() = '') e rotas sem
        // tela continuam recebendo `to.title` daqui.
        window.router.afterEach((from, to) => {
            const scr = window.router.currentScreen;
            const own = (scr && typeof scr.getTitle === 'function') ? scr.getTitle() : '';
            if (own) return;
            if (to?.title) {
                document.title = to.title + ' | ' + window.language.t('app.name');
            }
        });
        // 🔴 O Beacon.setRoute NÃO mora aqui: o afterEach roda DEPOIS do handler montar a
        //    tela, e jogo que abre rodada no init() já teria capturado o jogo errado.
        //    Fonte única: Router.handleRoute, entre o destroy() e o handler.
    }

    /**
     * Configura eventos globais
     */
    setupGlobalEvents() {
        // Aviso de conta vindo do check_session (UserManager). Só 'password_cleared' hoje;
        // código desconhecido é ignorado de propósito (o servidor pode estrear um antes do app).
        document.addEventListener('authNotice', (e) => {
            const code = e && e.detail && e.detail.code;
            if (code === 'password_cleared') this._noticePasswordCleared();
        });
        // 🔴 VERSÃO NOVA CHEGOU (o registro do SW em app.template.html despacha quando um SW
        // novo terminou de instalar POR CIMA de um que já controlava a página). Shell, bundle e
        // CSS vêm da rede com no-store, então o PRÓXIMO reload já pega o build novo — o que
        // faltava era a pessoa SABER: aba aberta há dias ficava no bundle velho sem aviso nenhum.
        // O SW novo fica em waiting até o clique (ver _reloadApp).
        // Toast fixo com botão "Atualizar" → reload. NUNCA recarregar sozinho: no meio de
        // uma rodada de ritmo seria pior que o problema (o capsula provou: pwaupdate.md §17,
        // e o "Depois" de lá que não adiava nada — aqui o ✕ é honesto, o reload é da pessoa).
        // Uma vez por page-load: o statechange pode disparar mais de uma vez.
        // Ouvinte NOMEADO (não uma arrow inline): o app-update-test o remove e recoloca
        // para provar que é ELE que produz o toast; e o reload passa por _reloadApp(),
        // que o teste substitui por um espião — `location.reload` não é substituível.
        this._updateToastShown = false;
        this._onUpdateAvailable = () => {
            if (this._updateToastShown) return;
            this._updateToastShown = true;
            const t = (k, fb) => { const v = window.language?.t(k); return (v && v !== k) ? v : fb; };
            window.notifications?.toast(t('app.updateAvailable', 'Nova versão disponível'), {
                duration: 0,
                action: { label: t('app.updateNow', 'Atualizar'), onClick: () => this._reloadApp() }
            });
        };
        document.addEventListener('appUpdateAvailable', this._onUpdateAvailable);
        // Escuta mudança de idioma
        window.eventBus.on('language:changed', (lang) => {
            console.log('Idioma alterado para:', lang);
            // Aqui poderia re-renderizar elementos
        });

        // Escuta erros não tratados
        window.addEventListener('unhandledrejection', (event) => {
            console.error('Erro não tratado:', event.reason);
        });

        // Escuta mudança de visibilidade (tab focus)
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                window.eventBus.emit('app:focus');
            } else {
                window.eventBus.emit('app:blur');
            }
        });

        // Escuta redimensionamento
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                window.eventBus.emit('app:resize', {
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            }, 250);
        });
    }

    /**
     * Obtém a versão da aplicação
     * @returns {string}
     */
    getVersion() {
        return this.version;
    }
}

// Singleton global
window.main = new Main();

// Inicializa quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
    window.main.init();
});


